/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 551);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_core__ = __webpack_require__(369);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "assertPlatform", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "destroyPlatform", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "getPlatform", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "createPlatform", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ApplicationRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "enableProdMode", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "isDevMode", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "createPlatformFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PlatformRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "APP_ID", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PACKAGE_ROOT_URL", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "APP_BOOTSTRAP_LISTENER", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PLATFORM_INITIALIZER", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ApplicationInitStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "APP_INITIALIZER", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DebugElement", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DebugNode", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "asNativeElements", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "getDebugNode", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Testability", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TestabilityRegistry", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "setTestabilityGetter", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TRANSLATIONS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TRANSLATIONS_FORMAT", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "LOCALE_ID", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ApplicationModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "wtfCreateScope", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "wtfLeave", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "wtfStartTimeRange", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "wtfEndTimeRange", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Type", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "EventEmitter", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ErrorHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationTransitionEvent", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationPlayer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Sanitizer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SecurityContext", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Attribute", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ContentChild", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ContentChildren", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Query", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ViewChild", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ViewChildren", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ANALYZE_FOR_ENTRY_COMPONENTS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Component", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Directive", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HostBinding", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HostListener", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Input", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Output", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Pipe", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "OnDestroy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AfterContentInit", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AfterViewChecked", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AfterViewInit", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DoCheck", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "OnChanges", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AfterContentChecked", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "OnInit", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CUSTOM_ELEMENTS_SCHEMA", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NO_ERRORS_SCHEMA", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ViewEncapsulation", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Class", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "forwardRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "resolveForwardRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Injector", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ReflectiveInjector", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ResolvedReflectiveFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ReflectiveKey", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "OpaqueToken", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgZone", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RenderComponentType", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_20"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Renderer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_21"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RootRenderer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_22"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "COMPILER_OPTIONS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_23"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CompilerFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_24"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ModuleWithComponentFactories", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_25"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Compiler", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_26"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ComponentFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_27"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ComponentRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_28"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ComponentFactoryResolver", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_29"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ElementRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_30"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModuleFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_31"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModuleRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_32"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModuleFactoryLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_33"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "getModuleFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_34"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "QueryList", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_35"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SystemJsNgModuleLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_36"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SystemJsNgModuleLoaderConfig", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_37"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "TemplateRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_38"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ViewContainerRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_39"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "EmbeddedViewRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_40"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ViewRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_41"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ChangeDetectionStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_42"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ChangeDetectorRef", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_43"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CollectionChangeRecord", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_44"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DefaultIterableDiffer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_45"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "IterableDiffers", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_46"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "KeyValueChangeRecord", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_47"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "KeyValueDiffers", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_48"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SimpleChange", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_49"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "WrappedValue", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_50"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "platformCore", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_51"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "__core_private__", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_52"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AUTO_STYLE", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_53"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationEntryMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_54"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationStateMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_55"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationStateDeclarationMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_56"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationStateTransitionMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_57"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_58"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationKeyframesSequenceMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_59"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationStyleMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_60"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationAnimateMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_61"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationWithStepsMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_62"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationSequenceMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_63"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationGroupMetadata", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_64"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "animate", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_65"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "group", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_66"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "sequence", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_67"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "style", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_68"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "state", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_69"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "keyframes", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_70"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "transition", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_71"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "trigger", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_72"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Inject", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_73"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Optional", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_74"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Injectable", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_75"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Self", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_76"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SkipSelf", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_77"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Host", function() { return __WEBPACK_IMPORTED_MODULE_0__src_core__["_78"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the core package.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ exports["l"] = scheduleMicroTask;
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return _global; });
/* harmony export (immutable) */ exports["j"] = getTypeNameForDebugging;
/* harmony export (immutable) */ exports["d"] = isPresent;
/* harmony export (immutable) */ exports["c"] = isBlank;
/* unused harmony export isStrictStringMap */
/* harmony export (immutable) */ exports["n"] = isDate;
/* harmony export (immutable) */ exports["b"] = stringify;
/* harmony export (binding) */ __webpack_require__.d(exports, "m", function() { return NumberWrapper; });
/* harmony export (immutable) */ exports["i"] = looseIdentical;
/* harmony export (immutable) */ exports["e"] = isJsObject;
/* harmony export (immutable) */ exports["g"] = print;
/* harmony export (immutable) */ exports["h"] = warn;
/* harmony export (immutable) */ exports["o"] = setValueOnPath;
/* harmony export (immutable) */ exports["f"] = getSymbolIterator;
/* harmony export (immutable) */ exports["k"] = isPrimitive;
/* unused harmony export escapeRegExp */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var globalScope;
if (typeof window === 'undefined') {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
        // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
        globalScope = self;
    }
    else {
        globalScope = global;
    }
}
else {
    globalScope = window;
}
function scheduleMicroTask(fn) {
    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
// Need to declare a new variable for global here since TypeScript
// exports the original value of the symbol.
var _global = globalScope;

function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
// TODO: remove calls to assert in production environment
// Note: Can't just export this and import in in other files
// as `assert` is a reserved keyword in Dart
_global.assert = function assert(condition) {
    // TODO: to be fixed properly via #2830, noop for now
};
function isPresent(obj) {
    return obj != null;
}
function isBlank(obj) {
    return obj == null;
}
var STRING_MAP_PROTO = Object.getPrototypeOf({});
function isStrictStringMap(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
}
function isDate(obj) {
    return obj instanceof Date && !isNaN(obj.valueOf());
}
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token === undefined || token === null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return token.overriddenName;
    }
    if (token.name) {
        return token.name;
    }
    var res = token.toString();
    var newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
var NumberWrapper = (function () {
    function NumberWrapper() {
    }
    NumberWrapper.parseIntAutoRadix = function (text) {
        var result = parseInt(text);
        if (isNaN(result)) {
            throw new Error('Invalid integer literal when parsing ' + text);
        }
        return result;
    };
    NumberWrapper.parseInt = function (text, radix) {
        if (radix == 10) {
            if (/^(\-|\+)?[0-9]+$/.test(text)) {
                return parseInt(text, radix);
            }
        }
        else if (radix == 16) {
            if (/^(\-|\+)?[0-9ABCDEFabcdef]+$/.test(text)) {
                return parseInt(text, radix);
            }
        }
        else {
            var result = parseInt(text, radix);
            if (!isNaN(result)) {
                return result;
            }
        }
        throw new Error('Invalid integer literal when parsing ' + text + ' in base ' + radix);
    };
    NumberWrapper.isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
    return NumberWrapper;
}());
// JS has NaN !== NaN
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
function print(obj) {
    console.log(obj);
}
function warn(obj) {
    console.warn(obj);
}
function setValueOnPath(global, path, value) {
    var parts = path.split('.');
    var obj = global;
    while (parts.length > 1) {
        var name = parts.shift();
        if (obj.hasOwnProperty(name) && isPresent(obj[name])) {
            obj = obj[name];
        }
        else {
            obj = obj[name] = {};
        }
    }
    if (obj === undefined || obj === null) {
        obj = {};
    }
    obj[parts.shift()] = value;
}
var _symbolIterator = null;
function getSymbolIterator() {
    if (!_symbolIterator) {
        if (globalScope.Symbol && Symbol.iterator) {
            _symbolIterator = Symbol.iterator;
        }
        else {
            // es6-shim specific logic
            var keys = Object.getOwnPropertyNames(Map.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    Map.prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
function isPrimitive(obj) {
    return !isJsObject(obj);
}
function escapeRegExp(s) {
    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
//# sourceMappingURL=lang.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var config_service_1 = __webpack_require__(5);
var angular2_universal_1 = __webpack_require__(27);
var UtilsService = (function () {
    function UtilsService(config, router) {
        this.config = config;
        this.router = router;
    }
    UtilsService.prototype.currentYear = function () {
        return new Date().getFullYear();
    };
    UtilsService.prototype.dateNowPlusDays = function (days) {
        return new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * days);
    };
    UtilsService.prototype.isMobile = function () {
        if (angular2_universal_1.isBrowser) {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
                return true;
            return false;
        }
    };
    UtilsService.prototype.toLocale = function (language) {
        var countryLangs = {
            fr: 'FR',
            en: 'US'
        };
        return language + '_' + countryLangs[language];
    };
    UtilsService.prototype.getElementPosition = function (element, plus, plus_xs) {
        if ($(window).width() <= 576)
            plus = plus_xs;
        return $(element).offset().top + plus;
    };
    UtilsService.prototype.loadScripts = function (scripts, targetElement) {
        for (var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++) {
            var scr = scripts_1[_i];
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = scr;
            targetElement.appendChild(s);
        }
    };
    UtilsService.prototype.scroll = function (target, plus) {
        var scrollTo = target.getBoundingClientRect().top + plus;
        $('html, body').animate({
            scrollTop: scrollTo
        }, 1200);
    };
    UtilsService.prototype.scrollToClass = function (className, plus) {
        this.scroll($("." + className)[0], plus);
    };
    UtilsService.prototype.lLink = function (target, currentLanguage) {
        if (!this.isSquashed(currentLanguage)) {
            if (target != '')
                target = currentLanguage + '/' + target;
            else
                target = currentLanguage;
        }
        this.router.navigateByUrl(target);
    };
    UtilsService.prototype.lNavigate = function (target, language, route, queryParams) {
        var params = {};
        if (queryParams)
            params = queryParams;
        if (route != null)
            params['relativeTo'] = route;
        if (!this.isSquashed(language)) {
            if (target.startsWith('/')) {
                target = target.replace(/^\//, "");
                language = '/' + language;
            }
            if (target != '') {
                var tree = [language];
                tree = tree.concat(target.split('/'));
                this.router.navigate(tree, params);
            }
            else
                this.router.navigate([language], params);
        }
        else {
            var tree = [language];
            tree = tree.concat(target.split('/'));
            this.router.navigate(tree, params);
        }
    };
    UtilsService.prototype.queryParamsParser = function (params, paramName) {
        var res = [];
        if (params[paramName]) {
            var filterObjects = params[paramName].split('>');
            filterObjects.forEach(function (fObj) {
                var typeValue = fObj.split('~');
                if (typeValue.length == 2) {
                    var type = typeValue[0];
                    var value = typeValue[1];
                    res.push(JSON.parse('{"' + type + '": "' + value + '"}'));
                }
            });
        }
        return res;
    };
    UtilsService.prototype.filtersToEsFilters = function (filters, fieldSuffix) {
        var esFilters = [];
        filters.forEach(function (f) {
            var esFilter = '{"term": {"' + Object.keys(f)[0] + fieldSuffix + '": "' + f[Object.keys(f)[0]] + '"}}';
            esFilters.push(JSON.parse(esFilter));
        });
        return esFilters;
    };
    UtilsService.prototype.isInFilters = function (esFilters, type, value) {
        var res = false;
        esFilters.forEach(function (esf) {
            if (esf.term[type + '.raw'] == value) {
                //console.log('+',esf.term[type], value);
                res = true;
            }
        });
        return res;
    };
    UtilsService.prototype.formatInHtml = function (str, tag) {
        // if no markup around content
        if (str.indexOf(/[^<].+[^>]/) == -1)
            str = '<' + tag + '>' + str + '</' + tag + '>';
        return str;
    };
    UtilsService.prototype.removeQueryParam = function (queryParamString, type, value) {
        type = type.replace(/\.raw/, "");
        var re = new RegExp('>?' + type + '~' + value, "gi");
        queryParamString = queryParamString.replace(re, "");
        queryParamString = queryParamString.replace(/^>/, "");
        return queryParamString;
    };
    UtilsService.prototype.appendQueryParam = function (queryParamString, type, value) {
        if (!queryParamString)
            queryParamString = type + '~' + value;
        else
            queryParamString += '>' + type + '~' + value;
        return queryParamString;
    };
    UtilsService.prototype.isSquashed = function (currentLanguage) {
        //console.log(this.config.PREFERRED_LANGUAGE_SQUASH, currentLanguage, this.config.PREFERRED_LANGUAGE)
        if (this.config.data.APP.LANGUAGES.SQUASH && currentLanguage == this.config.data.APP.LANGUAGES.PREFERRED) {
            return true;
        }
        return false;
    };
    UtilsService.prototype.clearLgParamFromUrl = function (url) {
        var cleared = url.replace(/lg=[a-z][a-z]/, "");
        cleared = cleared.replace(/\?$/, "");
        return cleared;
    };
    UtilsService.prototype.getUrlByRoute = function (router) {
        if (router.routerState.root.children[0]) {
            return router.routerState.root.children[0].snapshot.url;
        }
        return null;
    };
    UtilsService.prototype.getLanguageByUrl = function (url) {
        var match = url.match(/^\/([a-z][a-z])\//);
        if (match)
            return match[1];
        match = url.match(/^\/([a-z][a-z])$/);
        if (match)
            return match[1];
        return null;
    };
    // getLanguageByRoute(router: Router){
    //     if(router.routerState.root.children[0]){
    //         return router.routerState.root.children[0].snapshot.params['lg'];
    //     }
    //     return null;
    // }
    UtilsService.prototype.getLanguageAgnosticUrl = function (currentUrl) {
        // 1. /en (root)
        var re = /^\/[a-z][a-z]\/?$/;
        if (currentUrl.match(re))
            return currentUrl.replace(re, "");
        // 2. /en/page
        re = /^\/[a-z][a-z]\//;
        if (currentUrl.match(re))
            return currentUrl.replace(re, "/");
        // No language initially
        return currentUrl.replace(/\/$/, "");
    };
    UtilsService.prototype.cleanImageName = function (str) {
        str = this.removeAccents(str);
        str = str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        // restore extension
        str = str.replace(/-(.{3})$/g, ".$1");
        return str;
    };
    UtilsService.prototype.removeAccents = function (str) {
        var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        var strLen = str.length;
        var i, x;
        for (i = 0; i < strLen; i++) {
            if ((x = accents.indexOf(str[i])) != -1) {
                str[i] = accentsOut[x];
            }
        }
        return str.join('');
    };
    UtilsService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], UtilsService);
    return UtilsService;
    var _a, _b;
}());
exports.UtilsService = UtilsService;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_tokens__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__change_detection_change_detection__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__render_api__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__security__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__element__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors__ = __webpack_require__(268);
/* harmony export (binding) */ __webpack_require__.d(exports, "ViewUtils", function() { return ViewUtils; });
/* harmony export (immutable) */ exports["flattenNestedViewRenderNodes"] = flattenNestedViewRenderNodes;
/* harmony export (immutable) */ exports["ensureSlotCount"] = ensureSlotCount;
/* harmony export (binding) */ __webpack_require__.d(exports, "MAX_INTERPOLATION_VALUES", function() { return MAX_INTERPOLATION_VALUES; });
/* harmony export (immutable) */ exports["interpolate"] = interpolate;
/* harmony export (immutable) */ exports["checkBinding"] = checkBinding;
/* harmony export (immutable) */ exports["castByValue"] = castByValue;
/* harmony export (binding) */ __webpack_require__.d(exports, "EMPTY_ARRAY", function() { return EMPTY_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(exports, "EMPTY_MAP", function() { return EMPTY_MAP; });
/* harmony export (immutable) */ exports["pureProxy1"] = pureProxy1;
/* harmony export (immutable) */ exports["pureProxy2"] = pureProxy2;
/* harmony export (immutable) */ exports["pureProxy3"] = pureProxy3;
/* harmony export (immutable) */ exports["pureProxy4"] = pureProxy4;
/* harmony export (immutable) */ exports["pureProxy5"] = pureProxy5;
/* harmony export (immutable) */ exports["pureProxy6"] = pureProxy6;
/* harmony export (immutable) */ exports["pureProxy7"] = pureProxy7;
/* harmony export (immutable) */ exports["pureProxy8"] = pureProxy8;
/* harmony export (immutable) */ exports["pureProxy9"] = pureProxy9;
/* harmony export (immutable) */ exports["pureProxy10"] = pureProxy10;
/* harmony export (immutable) */ exports["setBindingDebugInfoForChanges"] = setBindingDebugInfoForChanges;
/* harmony export (immutable) */ exports["setBindingDebugInfo"] = setBindingDebugInfo;
/* harmony export (immutable) */ exports["createRenderElement"] = createRenderElement;
/* harmony export (immutable) */ exports["selectOrCreateRenderHostElement"] = selectOrCreateRenderHostElement;
/* harmony export (binding) */ __webpack_require__.d(exports, "InlineArray2", function() { return InlineArray2; });
/* harmony export (binding) */ __webpack_require__.d(exports, "InlineArray4", function() { return InlineArray4; });
/* harmony export (binding) */ __webpack_require__.d(exports, "InlineArray8", function() { return InlineArray8; });
/* harmony export (binding) */ __webpack_require__.d(exports, "InlineArray16", function() { return InlineArray16; });
/* harmony export (binding) */ __webpack_require__.d(exports, "InlineArrayDynamic", function() { return InlineArrayDynamic; });
/* harmony export (binding) */ __webpack_require__.d(exports, "EMPTY_INLINE_ARRAY", function() { return EMPTY_INLINE_ARRAY; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









var ViewUtils = (function () {
    function ViewUtils(_renderer, _appId, sanitizer) {
        this._renderer = _renderer;
        this._appId = _appId;
        this._nextCompTypeId = 0;
        this.sanitizer = sanitizer;
    }
    /**
     * Used by the generated code
     */
    // TODO (matsko): add typing for the animation function
    ViewUtils.prototype.createRenderComponentType = function (templateUrl, slotCount, encapsulation, styles, animations) {
        return new __WEBPACK_IMPORTED_MODULE_5__render_api__["RenderComponentType"](this._appId + "-" + this._nextCompTypeId++, templateUrl, slotCount, encapsulation, styles, animations);
    };
    /** @internal */
    ViewUtils.prototype.renderComponent = function (renderComponentType) {
        return this._renderer.renderComponent(renderComponentType);
    };
    ViewUtils.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_3__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    ViewUtils.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_5__render_api__["RootRenderer"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_3__di__["c" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_0__application_tokens__["APP_ID"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_6__security__["Sanitizer"], },
    ];
    return ViewUtils;
}());
function flattenNestedViewRenderNodes(nodes) {
    return _flattenNestedViewRenderNodes(nodes, []);
}
function _flattenNestedViewRenderNodes(nodes, renderNodes) {
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node instanceof __WEBPACK_IMPORTED_MODULE_7__element__["AppElement"]) {
            var appEl = node;
            renderNodes.push(appEl.nativeElement);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(appEl.nestedViews)) {
                for (var k = 0; k < appEl.nestedViews.length; k++) {
                    _flattenNestedViewRenderNodes(appEl.nestedViews[k].rootNodesOrAppElements, renderNodes);
                }
            }
        }
        else {
            renderNodes.push(node);
        }
    }
    return renderNodes;
}
var EMPTY_ARR = [];
function ensureSlotCount(projectableNodes, expectedSlotCount) {
    var res;
    if (!projectableNodes) {
        res = EMPTY_ARR;
    }
    else if (projectableNodes.length < expectedSlotCount) {
        var givenSlotCount = projectableNodes.length;
        res = new Array(expectedSlotCount);
        for (var i = 0; i < expectedSlotCount; i++) {
            res[i] = (i < givenSlotCount) ? projectableNodes[i] : EMPTY_ARR;
        }
    }
    else {
        res = projectableNodes;
    }
    return res;
}
var MAX_INTERPOLATION_VALUES = 9;
function interpolate(valueCount, c0, a1, c1, a2, c2, a3, c3, a4, c4, a5, c5, a6, c6, a7, c7, a8, c8, a9, c9) {
    switch (valueCount) {
        case 1:
            return c0 + _toStringWithNull(a1) + c1;
        case 2:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2;
        case 3:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3;
        case 4:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4;
        case 5:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5;
        case 6:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) + c6;
        case 7:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7;
        case 8:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8;
        case 9:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8 + _toStringWithNull(a9) + c9;
        default:
            throw new Error("Does not support more than 9 expressions");
    }
}
function _toStringWithNull(v) {
    return v != null ? v.toString() : '';
}
function checkBinding(throwOnChange, oldValue, newValue) {
    if (throwOnChange) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__change_detection_change_detection__["devModeEqual"])(oldValue, newValue)) {
            throw new __WEBPACK_IMPORTED_MODULE_8__errors__["a" /* ExpressionChangedAfterItHasBeenCheckedError */](oldValue, newValue);
        }
        return false;
    }
    else {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(oldValue, newValue);
    }
}
function castByValue(input, value) {
    return input;
}
var EMPTY_ARRAY = [];
var EMPTY_MAP = {};
function pureProxy1(fn) {
    var result;
    var v0 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0)) {
            v0 = p0;
            result = fn(p0);
        }
        return result;
    };
}
function pureProxy2(fn) {
    var result;
    var v0 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    var v1 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1)) {
            v0 = p0;
            v1 = p1;
            result = fn(p0, p1);
        }
        return result;
    };
}
function pureProxy3(fn) {
    var result;
    var v0 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    var v1 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    var v2 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            result = fn(p0, p1, p2);
        }
        return result;
    };
}
function pureProxy4(fn) {
    var result;
    var v0, v1, v2, v3;
    v0 = v1 = v2 = v3 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            result = fn(p0, p1, p2, p3);
        }
        return result;
    };
}
function pureProxy5(fn) {
    var result;
    var v0, v1, v2, v3, v4;
    v0 = v1 = v2 = v3 = v4 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            result = fn(p0, p1, p2, p3, p4);
        }
        return result;
    };
}
function pureProxy6(fn) {
    var result;
    var v0, v1, v2, v3, v4, v5;
    v0 = v1 = v2 = v3 = v4 = v5 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4, p5) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v5, p5)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            v5 = p5;
            result = fn(p0, p1, p2, p3, p4, p5);
        }
        return result;
    };
}
function pureProxy7(fn) {
    var result;
    var v0, v1, v2, v3, v4, v5, v6;
    v0 = v1 = v2 = v3 = v4 = v5 = v6 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4, p5, p6) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v5, p5) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v6, p6)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            v5 = p5;
            v6 = p6;
            result = fn(p0, p1, p2, p3, p4, p5, p6);
        }
        return result;
    };
}
function pureProxy8(fn) {
    var result;
    var v0, v1, v2, v3, v4, v5, v6, v7;
    v0 = v1 = v2 = v3 = v4 = v5 = v6 = v7 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4, p5, p6, p7) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v5, p5) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v6, p6) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v7, p7)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            v5 = p5;
            v6 = p6;
            v7 = p7;
            result = fn(p0, p1, p2, p3, p4, p5, p6, p7);
        }
        return result;
    };
}
function pureProxy9(fn) {
    var result;
    var v0, v1, v2, v3, v4, v5, v6, v7, v8;
    v0 = v1 = v2 = v3 = v4 = v5 = v6 = v7 = v8 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4, p5, p6, p7, p8) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v5, p5) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v6, p6) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v7, p7) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v8, p8)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            v5 = p5;
            v6 = p6;
            v7 = p7;
            v8 = p8;
            result = fn(p0, p1, p2, p3, p4, p5, p6, p7, p8);
        }
        return result;
    };
}
function pureProxy10(fn) {
    var result;
    var v0, v1, v2, v3, v4, v5, v6, v7, v8, v9;
    v0 = v1 = v2 = v3 = v4 = v5 = v6 = v7 = v8 = v9 = __WEBPACK_IMPORTED_MODULE_2__change_detection_change_detection_util__["a" /* UNINITIALIZED */];
    return function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v0, p0) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v1, p1) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v2, p2) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v3, p3) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v4, p4) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v5, p5) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v6, p6) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v7, p7) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v8, p8) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["i" /* looseIdentical */])(v9, p9)) {
            v0 = p0;
            v1 = p1;
            v2 = p2;
            v3 = p3;
            v4 = p4;
            v5 = p5;
            v6 = p6;
            v7 = p7;
            v8 = p8;
            v9 = p9;
            result = fn(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
        }
        return result;
    };
}
function setBindingDebugInfoForChanges(renderer, el, changes) {
    Object.keys(changes).forEach(function (propName) {
        setBindingDebugInfo(renderer, el, propName, changes[propName].currentValue);
    });
}
function setBindingDebugInfo(renderer, el, propName, value) {
    try {
        renderer.setBindingDebugInfo(el, "ng-reflect-" + camelCaseToDashCase(propName), value ? value.toString() : null);
    }
    catch (e) {
        renderer.setBindingDebugInfo(el, "ng-reflect-" + camelCaseToDashCase(propName), '[ERROR] Exception while trying to serialize the value');
    }
}
var CAMEL_CASE_REGEXP = /([A-Z])/g;
function camelCaseToDashCase(input) {
    return input.replace(CAMEL_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i - 0] = arguments[_i];
        }
        return '-' + m[1].toLowerCase();
    });
}
function createRenderElement(renderer, parentElement, name, attrs, debugInfo) {
    var el = renderer.createElement(parentElement, name, debugInfo);
    for (var i = 0; i < attrs.length; i += 2) {
        renderer.setElementAttribute(el, attrs.get(i), attrs.get(i + 1));
    }
    return el;
}
function selectOrCreateRenderHostElement(renderer, elementName, attrs, rootSelectorOrNode, debugInfo) {
    var hostElement;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(rootSelectorOrNode)) {
        hostElement = renderer.selectRootElement(rootSelectorOrNode, debugInfo);
    }
    else {
        hostElement = createRenderElement(renderer, null, elementName, attrs, debugInfo);
    }
    return hostElement;
}
var InlineArray0 = (function () {
    function InlineArray0() {
        this.length = 0;
    }
    InlineArray0.prototype.get = function (index) { return undefined; };
    return InlineArray0;
}());
var InlineArray2 = (function () {
    function InlineArray2(length, _v0, _v1) {
        this.length = length;
        this._v0 = _v0;
        this._v1 = _v1;
    }
    InlineArray2.prototype.get = function (index) {
        switch (index) {
            case 0:
                return this._v0;
            case 1:
                return this._v1;
            default:
                return undefined;
        }
    };
    return InlineArray2;
}());
var InlineArray4 = (function () {
    function InlineArray4(length, _v0, _v1, _v2, _v3) {
        this.length = length;
        this._v0 = _v0;
        this._v1 = _v1;
        this._v2 = _v2;
        this._v3 = _v3;
    }
    InlineArray4.prototype.get = function (index) {
        switch (index) {
            case 0:
                return this._v0;
            case 1:
                return this._v1;
            case 2:
                return this._v2;
            case 3:
                return this._v3;
            default:
                return undefined;
        }
    };
    return InlineArray4;
}());
var InlineArray8 = (function () {
    function InlineArray8(length, _v0, _v1, _v2, _v3, _v4, _v5, _v6, _v7) {
        this.length = length;
        this._v0 = _v0;
        this._v1 = _v1;
        this._v2 = _v2;
        this._v3 = _v3;
        this._v4 = _v4;
        this._v5 = _v5;
        this._v6 = _v6;
        this._v7 = _v7;
    }
    InlineArray8.prototype.get = function (index) {
        switch (index) {
            case 0:
                return this._v0;
            case 1:
                return this._v1;
            case 2:
                return this._v2;
            case 3:
                return this._v3;
            case 4:
                return this._v4;
            case 5:
                return this._v5;
            case 6:
                return this._v6;
            case 7:
                return this._v7;
            default:
                return undefined;
        }
    };
    return InlineArray8;
}());
var InlineArray16 = (function () {
    function InlineArray16(length, _v0, _v1, _v2, _v3, _v4, _v5, _v6, _v7, _v8, _v9, _v10, _v11, _v12, _v13, _v14, _v15) {
        this.length = length;
        this._v0 = _v0;
        this._v1 = _v1;
        this._v2 = _v2;
        this._v3 = _v3;
        this._v4 = _v4;
        this._v5 = _v5;
        this._v6 = _v6;
        this._v7 = _v7;
        this._v8 = _v8;
        this._v9 = _v9;
        this._v10 = _v10;
        this._v11 = _v11;
        this._v12 = _v12;
        this._v13 = _v13;
        this._v14 = _v14;
        this._v15 = _v15;
    }
    InlineArray16.prototype.get = function (index) {
        switch (index) {
            case 0:
                return this._v0;
            case 1:
                return this._v1;
            case 2:
                return this._v2;
            case 3:
                return this._v3;
            case 4:
                return this._v4;
            case 5:
                return this._v5;
            case 6:
                return this._v6;
            case 7:
                return this._v7;
            case 8:
                return this._v8;
            case 9:
                return this._v9;
            case 10:
                return this._v10;
            case 11:
                return this._v11;
            case 12:
                return this._v12;
            case 13:
                return this._v13;
            case 14:
                return this._v14;
            case 15:
                return this._v15;
            default:
                return undefined;
        }
    };
    return InlineArray16;
}());
var InlineArrayDynamic = (function () {
    // Note: We still take the length argument so this class can be created
    // in the same ways as the other classes!
    function InlineArrayDynamic(length) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        this.length = length;
        this._values = values;
    }
    InlineArrayDynamic.prototype.get = function (index) { return this._values[index]; };
    return InlineArrayDynamic;
}());
var EMPTY_INLINE_ARRAY = new InlineArray0();
//# sourceMappingURL=view_utils.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differs_default_iterable_differ__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differs_default_keyvalue_differ__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differs_iterable_differs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differs_keyvalue_differs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__change_detection_util__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__change_detector_ref__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(131);
/* harmony export (binding) */ __webpack_require__.d(exports, "keyValDiff", function() { return keyValDiff; });
/* harmony export (binding) */ __webpack_require__.d(exports, "iterableDiff", function() { return iterableDiff; });
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultIterableDiffers", function() { return defaultIterableDiffers; });
/* harmony export (binding) */ __webpack_require__.d(exports, "defaultKeyValueDiffers", function() { return defaultKeyValueDiffers; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SimpleChange", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UNINITIALIZED", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ValueUnwrapper", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "WrappedValue", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "devModeEqual", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "looseIdentical", function() { return __WEBPACK_IMPORTED_MODULE_4__change_detection_util__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ChangeDetectorRef", function() { return __WEBPACK_IMPORTED_MODULE_5__change_detector_ref__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ChangeDetectionStrategy", function() { return __WEBPACK_IMPORTED_MODULE_6__constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ChangeDetectorStatus", function() { return __WEBPACK_IMPORTED_MODULE_6__constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "isDefaultChangeDetectionStrategy", function() { return __WEBPACK_IMPORTED_MODULE_6__constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CollectionChangeRecord", function() { return __WEBPACK_IMPORTED_MODULE_0__differs_default_iterable_differ__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultIterableDifferFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__differs_default_iterable_differ__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultIterableDiffer", function() { return __WEBPACK_IMPORTED_MODULE_0__differs_default_iterable_differ__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "KeyValueChangeRecord", function() { return __WEBPACK_IMPORTED_MODULE_1__differs_default_keyvalue_differ__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultKeyValueDifferFactory", function() { return __WEBPACK_IMPORTED_MODULE_1__differs_default_keyvalue_differ__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "IterableDiffers", function() { return __WEBPACK_IMPORTED_MODULE_2__differs_iterable_differs__["IterableDiffers"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "KeyValueDiffers", function() { return __WEBPACK_IMPORTED_MODULE_3__differs_keyvalue_differs__["KeyValueDiffers"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */












/**
 * Structural diffing for `Object`s and `Map`s.
 */
var keyValDiff = [new __WEBPACK_IMPORTED_MODULE_1__differs_default_keyvalue_differ__["a" /* DefaultKeyValueDifferFactory */]()];
/**
 * Structural diffing for `Iterable` types such as `Array`s.
 */
var iterableDiff = [new __WEBPACK_IMPORTED_MODULE_0__differs_default_iterable_differ__["a" /* DefaultIterableDifferFactory */]()];
var defaultIterableDiffers = new __WEBPACK_IMPORTED_MODULE_2__differs_iterable_differs__["IterableDiffers"](iterableDiff);
var defaultKeyValueDiffers = new __WEBPACK_IMPORTED_MODULE_3__differs_keyvalue_differs__["KeyValueDiffers"](keyValDiff);
//# sourceMappingURL=change_detection.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var config = __webpack_require__(462);
var ConfigService = (function () {
    function ConfigService() {
        this.data = config;
    }
    ConfigService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], ConfigService);
    return ConfigService;
}());
exports.ConfigService = ConfigService;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "ViewType", function() { return ViewType; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ViewType;
(function (ViewType) {
    // A view that contains the host element with bound component directive.
    // Contains a COMPONENT view
    ViewType[ViewType["HOST"] = 0] = "HOST";
    // The view of the component
    // Can contain 0 to n EMBEDDED views
    ViewType[ViewType["COMPONENT"] = 1] = "COMPONENT";
    // A view that is embedded into another View via a <template> element
    // inside of a COMPONENT view
    ViewType[ViewType["EMBEDDED"] = 2] = "EMBEDDED";
})(ViewType || (ViewType = {}));
//# sourceMappingURL=view_type.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element_ref__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_container_ref__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_type__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(exports, "AppElement", function() { return AppElement; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * An AppElement is created for elements that have a ViewContainerRef,
 * a nested component or a <template> element to keep data around
 * that is needed for later instantiations.
 */
var AppElement = (function () {
    function AppElement(index, parentIndex, parentView, nativeElement) {
        this.index = index;
        this.parentIndex = parentIndex;
        this.parentView = parentView;
        this.nativeElement = nativeElement;
        this.nestedViews = null;
        this.componentView = null;
    }
    Object.defineProperty(AppElement.prototype, "elementRef", {
        get: function () { return new __WEBPACK_IMPORTED_MODULE_1__element_ref__["ElementRef"](this.nativeElement); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppElement.prototype, "vcRef", {
        get: function () { return new __WEBPACK_IMPORTED_MODULE_2__view_container_ref__["a" /* ViewContainerRef_ */](this); },
        enumerable: true,
        configurable: true
    });
    AppElement.prototype.initComponent = function (component, componentConstructorViewQueries, view) {
        this.component = component;
        this.componentConstructorViewQueries = componentConstructorViewQueries;
        this.componentView = view;
    };
    Object.defineProperty(AppElement.prototype, "parentInjector", {
        get: function () { return this.parentView.injector(this.parentIndex); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppElement.prototype, "injector", {
        get: function () { return this.parentView.injector(this.index); },
        enumerable: true,
        configurable: true
    });
    AppElement.prototype.mapNestedViews = function (nestedViewClass, callback) {
        var result = [];
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.nestedViews)) {
            this.nestedViews.forEach(function (nestedView) {
                if (nestedView.clazz === nestedViewClass) {
                    result.push(callback(nestedView));
                }
            });
        }
        return result;
    };
    AppElement.prototype.moveView = function (view, currentIndex) {
        var previousIndex = this.nestedViews.indexOf(view);
        if (view.type === __WEBPACK_IMPORTED_MODULE_3__view_type__["ViewType"].COMPONENT) {
            throw new Error("Component views can't be moved!");
        }
        var nestedViews = this.nestedViews;
        if (nestedViews == null) {
            nestedViews = [];
            this.nestedViews = nestedViews;
        }
        nestedViews.splice(previousIndex, 1);
        nestedViews.splice(currentIndex, 0, view);
        var refRenderNode;
        if (currentIndex > 0) {
            var prevView = nestedViews[currentIndex - 1];
            refRenderNode = prevView.lastRootNode;
        }
        else {
            refRenderNode = this.nativeElement;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(refRenderNode)) {
            view.renderer.attachViewAfter(refRenderNode, view.flatRootNodes);
        }
        view.markContentChildAsMoved(this);
    };
    AppElement.prototype.attachView = function (view, viewIndex) {
        if (view.type === __WEBPACK_IMPORTED_MODULE_3__view_type__["ViewType"].COMPONENT) {
            throw new Error("Component views can't be moved!");
        }
        var nestedViews = this.nestedViews;
        if (nestedViews == null) {
            nestedViews = [];
            this.nestedViews = nestedViews;
        }
        nestedViews.splice(viewIndex, 0, view);
        var refRenderNode;
        if (viewIndex > 0) {
            var prevView = nestedViews[viewIndex - 1];
            refRenderNode = prevView.lastRootNode;
        }
        else {
            refRenderNode = this.nativeElement;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(refRenderNode)) {
            view.renderer.attachViewAfter(refRenderNode, view.flatRootNodes);
        }
        view.addToContentChildren(this);
    };
    AppElement.prototype.detachView = function (viewIndex) {
        var view = this.nestedViews.splice(viewIndex, 1)[0];
        if (view.type === __WEBPACK_IMPORTED_MODULE_3__view_type__["ViewType"].COMPONENT) {
            throw new Error("Component views can't be moved!");
        }
        view.detach();
        view.removeFromContentChildren(this);
        return view;
    };
    return AppElement;
}());
//# sourceMappingURL=element.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(406);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterLink", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterLinkWithHref", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterLinkActive", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterOutlet", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NavigationCancel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NavigationEnd", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NavigationError", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RoutesRecognized", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NavigationStart", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "provideRoutes", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterOutletMap", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PreloadAllModules", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PreloadingStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NoPreloading", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ActivatedRoute", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ActivatedRouteSnapshot", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterState", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RouterStateSnapshot", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PRIMARY_OUTLET", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DefaultUrlSerializer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "UrlSegment", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "UrlSerializer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "UrlTree", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "__router_private__", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["z"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the router package.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var http_1 = __webpack_require__(62);
__webpack_require__(122);
var ContentService = (function () {
    function ContentService(http, router) {
        this.http = http;
        this.router = router;
        this.baseUrl = '/api/content/';
        this.notFoundRedirect = 'page-not-found';
        this.header = new http_1.RequestOptions({ headers: new http_1.Headers() });
        this.jsonHeader = new http_1.RequestOptions({ headers: new http_1.Headers({ 'Content-Type': 'application/json' }) });
        this.noCacheHeader = new http_1.RequestOptions({ headers: new http_1.Headers({ 'Cache-control': 'private, no-cache, no-store, max-age=0, must-revalidate' }) });
    }
    ContentService.prototype.cacheControl = function (noCache) {
        if (noCache) {
            return this.noCacheHeader;
        }
        return this.header;
    };
    ContentService.prototype.findContents = function (type, elements, noCache) {
        return this.http.get('/api/contents/' + type + '/' + elements, this.cacheControl(noCache))
            .toPromise()
            .then(function (response) {
            //console.log(response.json());
            return response.json();
        })
            .catch(this.handleError);
    };
    // /api/contents/record/tag/featured
    ContentService.prototype.getContentsByField = function (type, field, value, noCache) {
        return this.http.get('/api/contents/' + type + '/' + field + '/' + value, this.cacheControl(noCache))
            .toPromise()
            .then(function (response) {
            //console.log(response.json());
            return response.json();
        })
            .catch(this.handleError);
    };
    // /api/contents/page
    ContentService.prototype.getContents = function (type, noCache) {
        return this.http.get('/api/contents/' + type, this.cacheControl(noCache))
            .toPromise()
            .then(function (response) {
            //console.log(response.json());
            return response.json();
        })
            .catch(this.handleError);
    };
    ContentService.prototype.getContent = function (type, fieldObj, noCache) {
        var _this = this;
        var fieldType = Object.keys(fieldObj)[0];
        var fieldValue = fieldObj[fieldType];
        var queryUrl = this.baseUrl + type + '/' + fieldType + '/' + fieldValue;
        // "this" can't be used in error callback
        var redirect = function () { _this.router.navigateByUrl(_this.notFoundRedirect); };
        var handleError = function (e) { _this.handleError(e); };
        return this.http.get(queryUrl, this.cacheControl(noCache))
            .toPromise()
            .then(function (response) {
            return response.json();
        })
            .catch(function (e) {
            //if(e.status==404) redirect();
            if (e.status == 404)
                return { error: 404 };
            else
                handleError(e);
        });
    };
    ContentService.prototype.deleteContent = function (type, id) {
        var queryUrl = this.baseUrl + type + '/delete/' + id;
        return this.http.get(queryUrl)
            .toPromise()
            .then(function (response) {
            return response;
        })
            .catch(this.handleError);
    };
    ContentService.prototype.saveContent = function (type, action, data) {
        var $newId;
        // action: add OR update
        return this.http.post('/api/content/' + type + '/' + action, data, this.jsonHeader)
            .toPromise()
            .then(function (response) {
            //console.log(response.json()); 
            return response;
        })
            .catch(this.handleError);
    };
    ContentService.prototype.handleError = function (error) {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    };
    ContentService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], ContentService);
    return ContentService;
    var _a, _b;
}());
exports.ContentService = ContentService;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_utils__ = __webpack_require__(3);
/* harmony export (binding) */ __webpack_require__.d(exports, "ComponentRef", function() { return ComponentRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ComponentRef_", function() { return ComponentRef_; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ComponentFactory", function() { return ComponentFactory; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * Represents an instance of a Component created via a {@link ComponentFactory}.
 *
 * `ComponentRef` provides access to the Component Instance as well other objects related to this
 * Component Instance and allows you to destroy the Component Instance via the {@link #destroy}
 * method.
 * @stable
 */
var ComponentRef = (function () {
    function ComponentRef() {
    }
    Object.defineProperty(ComponentRef.prototype, "location", {
        /**
         * Location of the Host Element of this Component Instance.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef.prototype, "injector", {
        /**
         * The injector on which the component instance exists.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef.prototype, "instance", {
        /**
         * The instance of the Component.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef.prototype, "hostView", {
        /**
         * The {@link ViewRef} of the Host View of this Component instance.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef.prototype, "changeDetectorRef", {
        /**
         * The {@link ChangeDetectorRef} of the Component instance.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef.prototype, "componentType", {
        /**
         * The component type.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    return ComponentRef;
}());
var ComponentRef_ = (function (_super) {
    __extends(ComponentRef_, _super);
    function ComponentRef_(_hostElement, _componentType) {
        _super.call(this);
        this._hostElement = _hostElement;
        this._componentType = _componentType;
    }
    Object.defineProperty(ComponentRef_.prototype, "location", {
        get: function () { return this._hostElement.elementRef; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "injector", {
        get: function () { return this._hostElement.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "instance", {
        get: function () { return this._hostElement.component; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "hostView", {
        get: function () { return this._hostElement.parentView.ref; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "changeDetectorRef", {
        get: function () { return this._hostElement.parentView.ref; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "componentType", {
        get: function () { return this._componentType; },
        enumerable: true,
        configurable: true
    });
    ComponentRef_.prototype.destroy = function () { this._hostElement.parentView.destroy(); };
    ComponentRef_.prototype.onDestroy = function (callback) { this.hostView.onDestroy(callback); };
    return ComponentRef_;
}(ComponentRef));
/**
 * @experimental
 */
var EMPTY_CONTEXT = new Object();
/**
 * @stable
 */
var ComponentFactory = (function () {
    function ComponentFactory(selector, _viewFactory, _componentType) {
        this.selector = selector;
        this._viewFactory = _viewFactory;
        this._componentType = _componentType;
    }
    Object.defineProperty(ComponentFactory.prototype, "componentType", {
        get: function () { return this._componentType; },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new component.
     */
    ComponentFactory.prototype.create = function (injector, projectableNodes, rootSelectorOrNode) {
        if (projectableNodes === void 0) { projectableNodes = null; }
        if (rootSelectorOrNode === void 0) { rootSelectorOrNode = null; }
        var vu = injector.get(__WEBPACK_IMPORTED_MODULE_1__view_utils__["ViewUtils"]);
        if (!projectableNodes) {
            projectableNodes = [];
        }
        // Note: Host views don't need a declarationAppElement!
        var hostView = this._viewFactory(vu, injector, null);
        var hostElement = hostView.create(EMPTY_CONTEXT, projectableNodes, rootSelectorOrNode);
        return new ComponentRef_(hostElement, this._componentType);
    };
    return ComponentFactory;
}());
//# sourceMappingURL=component_factory.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "ViewEncapsulation", function() { return ViewEncapsulation; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ViewMetadata", function() { return ViewMetadata; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Defines template and style encapsulation options available for Component's {@link Component}.
 *
 * See {@link ViewMetadata#encapsulation}.
 * @stable
 */
var ViewEncapsulation;
(function (ViewEncapsulation) {
    /**
     * Emulate `Native` scoping of styles by adding an attribute containing surrogate id to the Host
     * Element and pre-processing the style rules provided via
     * {@link ViewMetadata#styles} or {@link ViewMetadata#stylesUrls}, and adding the new Host Element
     * attribute to all selectors.
     *
     * This is the default option.
     */
    ViewEncapsulation[ViewEncapsulation["Emulated"] = 0] = "Emulated";
    /**
     * Use the native encapsulation mechanism of the renderer.
     *
     * For the DOM this means using [Shadow DOM](https://w3c.github.io/webcomponents/spec/shadow/) and
     * creating a ShadowRoot for Component's Host Element.
     */
    ViewEncapsulation[ViewEncapsulation["Native"] = 1] = "Native";
    /**
     * Don't provide any template or style encapsulation.
     */
    ViewEncapsulation[ViewEncapsulation["None"] = 2] = "None";
})(ViewEncapsulation || (ViewEncapsulation = {}));
/**
 * Metadata properties available for configuring Views.
 *
 * For details on the `@Component` annotation, see {@link Component}.
 *
 * ### Example
 *
 * ```
 * @Component({
 *   selector: 'greet',
 *   template: 'Hello {{name}}!',
 * })
 * class Greet {
 *   name: string;
 *
 *   constructor() {
 *     this.name = 'World';
 *   }
 * }
 * ```
 *
 * @deprecated Use Component instead.
 *
 * {@link Component}
 */
var ViewMetadata = (function () {
    function ViewMetadata(_a) {
        var _b = _a === void 0 ? {} : _a, templateUrl = _b.templateUrl, template = _b.template, encapsulation = _b.encapsulation, styles = _b.styles, styleUrls = _b.styleUrls, animations = _b.animations, interpolation = _b.interpolation;
        this.templateUrl = templateUrl;
        this.template = template;
        this.styleUrls = styleUrls;
        this.styles = styles;
        this.encapsulation = encapsulation;
        this.animations = animations;
        this.interpolation = interpolation;
    }
    return ViewMetadata;
}());
//# sourceMappingURL=view.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_profile__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation_view_context__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__debug_context__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__element__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__element_injector__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_ref__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_type__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_utils__ = __webpack_require__(3);
/* harmony export (binding) */ __webpack_require__.d(exports, "AppView", function() { return AppView; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DebugAppView", function() { return DebugAppView; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};












var _scope_check = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__profile_profile__["a" /* wtfCreateScope */])("AppView#check(ascii id)");
/**
 * Cost of making objects: http://jsperf.com/instantiate-size-of-object
 *
 */
var AppView = (function () {
    function AppView(clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode) {
        this.clazz = clazz;
        this.componentType = componentType;
        this.type = type;
        this.viewUtils = viewUtils;
        this.parentInjector = parentInjector;
        this.declarationAppElement = declarationAppElement;
        this.cdMode = cdMode;
        this.contentChildren = [];
        this.viewChildren = [];
        this.viewContainerElement = null;
        this.numberOfChecks = 0;
        this.ref = new __WEBPACK_IMPORTED_MODULE_9__view_ref__["a" /* ViewRef_ */](this);
        if (type === __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].COMPONENT || type === __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].HOST) {
            this.renderer = viewUtils.renderComponent(componentType);
        }
        else {
            this.renderer = declarationAppElement.parentView.renderer;
        }
    }
    Object.defineProperty(AppView.prototype, "animationContext", {
        get: function () {
            if (!this._animationContext) {
                this._animationContext = new __WEBPACK_IMPORTED_MODULE_4__animation_view_context__["a" /* AnimationViewContext */]();
            }
            return this._animationContext;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppView.prototype, "destroyed", {
        get: function () { return this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Destroyed; },
        enumerable: true,
        configurable: true
    });
    AppView.prototype.create = function (context, givenProjectableNodes, rootSelectorOrNode) {
        this.context = context;
        var projectableNodes;
        switch (this.type) {
            case __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].COMPONENT:
                projectableNodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__view_utils__["ensureSlotCount"])(givenProjectableNodes, this.componentType.slotCount);
                break;
            case __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].EMBEDDED:
                projectableNodes = this.declarationAppElement.parentView.projectableNodes;
                break;
            case __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].HOST:
                // Note: Don't ensure the slot count for the projectableNodes as we store
                // them only for the contained component view (which will later check the slot count...)
                projectableNodes = givenProjectableNodes;
                break;
        }
        this._hasExternalHostElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(rootSelectorOrNode);
        this.projectableNodes = projectableNodes;
        return this.createInternal(rootSelectorOrNode);
    };
    /**
     * Overwritten by implementations.
     * Returns the AppElement for the host element for ViewType.HOST.
     */
    AppView.prototype.createInternal = function (rootSelectorOrNode) { return null; };
    AppView.prototype.init = function (rootNodesOrAppElements, allNodes, disposables, subscriptions) {
        this.rootNodesOrAppElements = rootNodesOrAppElements;
        this.allNodes = allNodes;
        this.disposables = disposables;
        this.subscriptions = subscriptions;
        if (this.type === __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].COMPONENT) {
            // Note: the render nodes have been attached to their host element
            // in the ViewFactory already.
            this.declarationAppElement.parentView.viewChildren.push(this);
            this.dirtyParentQueriesInternal();
        }
    };
    AppView.prototype.injectorGet = function (token, nodeIndex, notFoundResult) {
        return this.injectorGetInternal(token, nodeIndex, notFoundResult);
    };
    /**
     * Overwritten by implementations
     */
    AppView.prototype.injectorGetInternal = function (token, nodeIndex, notFoundResult) {
        return notFoundResult;
    };
    AppView.prototype.injector = function (nodeIndex) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(nodeIndex)) {
            return new __WEBPACK_IMPORTED_MODULE_7__element_injector__["a" /* ElementInjector */](this, nodeIndex);
        }
        else {
            return this.parentInjector;
        }
    };
    AppView.prototype.destroy = function () {
        if (this._hasExternalHostElement) {
            this.renderer.detachView(this.flatRootNodes);
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this.viewContainerElement)) {
            this.viewContainerElement.detachView(this.viewContainerElement.nestedViews.indexOf(this));
        }
        this._destroyRecurse();
    };
    AppView.prototype._destroyRecurse = function () {
        if (this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Destroyed) {
            return;
        }
        var children = this.contentChildren;
        for (var i = 0; i < children.length; i++) {
            children[i]._destroyRecurse();
        }
        children = this.viewChildren;
        for (var i = 0; i < children.length; i++) {
            children[i]._destroyRecurse();
        }
        this.destroyLocal();
        this.cdMode = __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Destroyed;
    };
    AppView.prototype.destroyLocal = function () {
        var _this = this;
        var hostElement = this.type === __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].COMPONENT ? this.declarationAppElement.nativeElement : null;
        for (var i = 0; i < this.disposables.length; i++) {
            this.disposables[i]();
        }
        for (var i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }
        this.destroyInternal();
        this.dirtyParentQueriesInternal();
        if (this._animationContext) {
            this._animationContext.onAllActiveAnimationsDone(function () { return _this.renderer.destroyView(hostElement, _this.allNodes); });
        }
        else {
            this.renderer.destroyView(hostElement, this.allNodes);
        }
    };
    /**
     * Overwritten by implementations
     */
    AppView.prototype.destroyInternal = function () { };
    /**
     * Overwritten by implementations
     */
    AppView.prototype.detachInternal = function () { };
    AppView.prototype.detach = function () {
        var _this = this;
        this.detachInternal();
        if (this._animationContext) {
            this._animationContext.onAllActiveAnimationsDone(function () { return _this.renderer.detachView(_this.flatRootNodes); });
        }
        else {
            this.renderer.detachView(this.flatRootNodes);
        }
    };
    Object.defineProperty(AppView.prototype, "changeDetectorRef", {
        get: function () { return this.ref; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppView.prototype, "parent", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this.declarationAppElement) ? this.declarationAppElement.parentView : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppView.prototype, "flatRootNodes", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__view_utils__["flattenNestedViewRenderNodes"])(this.rootNodesOrAppElements); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppView.prototype, "lastRootNode", {
        get: function () {
            var lastNode = this.rootNodesOrAppElements.length > 0 ?
                this.rootNodesOrAppElements[this.rootNodesOrAppElements.length - 1] :
                null;
            return _findLastRenderNode(lastNode);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Overwritten by implementations
     */
    AppView.prototype.dirtyParentQueriesInternal = function () { };
    AppView.prototype.detectChanges = function (throwOnChange) {
        var s = _scope_check(this.clazz);
        if (this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Checked ||
            this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Errored)
            return;
        if (this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Destroyed) {
            this.throwDestroyedError('detectChanges');
        }
        this.detectChangesInternal(throwOnChange);
        if (this.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].CheckOnce)
            this.cdMode = __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Checked;
        this.numberOfChecks++;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__profile_profile__["b" /* wtfLeave */])(s);
    };
    /**
     * Overwritten by implementations
     */
    AppView.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    AppView.prototype.detectContentChildrenChanges = function (throwOnChange) {
        for (var i = 0; i < this.contentChildren.length; ++i) {
            var child = this.contentChildren[i];
            if (child.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Detached)
                continue;
            child.detectChanges(throwOnChange);
        }
    };
    AppView.prototype.detectViewChildrenChanges = function (throwOnChange) {
        for (var i = 0; i < this.viewChildren.length; ++i) {
            var child = this.viewChildren[i];
            if (child.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Detached)
                continue;
            child.detectChanges(throwOnChange);
        }
    };
    AppView.prototype.markContentChildAsMoved = function (renderAppElement) { this.dirtyParentQueriesInternal(); };
    AppView.prototype.addToContentChildren = function (renderAppElement) {
        renderAppElement.parentView.contentChildren.push(this);
        this.viewContainerElement = renderAppElement;
        this.dirtyParentQueriesInternal();
    };
    AppView.prototype.removeFromContentChildren = function (renderAppElement) {
        __WEBPACK_IMPORTED_MODULE_1__facade_collection__["e" /* ListWrapper */].remove(renderAppElement.parentView.contentChildren, this);
        this.dirtyParentQueriesInternal();
        this.viewContainerElement = null;
    };
    AppView.prototype.markAsCheckOnce = function () { this.cdMode = __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].CheckOnce; };
    AppView.prototype.markPathToRootAsCheckOnce = function () {
        var c = this;
        while (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(c) && c.cdMode !== __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Detached) {
            if (c.cdMode === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Checked) {
                c.cdMode = __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].CheckOnce;
            }
            var parentEl = c.type === __WEBPACK_IMPORTED_MODULE_10__view_type__["ViewType"].COMPONENT ? c.declarationAppElement : c.viewContainerElement;
            c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(parentEl) ? parentEl.parentView : null;
        }
    };
    AppView.prototype.eventHandler = function (cb) { return cb; };
    AppView.prototype.throwDestroyedError = function (details) { throw new __WEBPACK_IMPORTED_MODULE_8__errors__["b" /* ViewDestroyedError */](details); };
    return AppView;
}());
var DebugAppView = (function (_super) {
    __extends(DebugAppView, _super);
    function DebugAppView(clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode, staticNodeDebugInfos) {
        _super.call(this, clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode);
        this.staticNodeDebugInfos = staticNodeDebugInfos;
        this._currentDebugContext = null;
    }
    DebugAppView.prototype.create = function (context, givenProjectableNodes, rootSelectorOrNode) {
        this._resetDebug();
        try {
            return _super.prototype.create.call(this, context, givenProjectableNodes, rootSelectorOrNode);
        }
        catch (e) {
            this._rethrowWithContext(e);
            throw e;
        }
    };
    DebugAppView.prototype.injectorGet = function (token, nodeIndex, notFoundResult) {
        this._resetDebug();
        try {
            return _super.prototype.injectorGet.call(this, token, nodeIndex, notFoundResult);
        }
        catch (e) {
            this._rethrowWithContext(e);
            throw e;
        }
    };
    DebugAppView.prototype.detach = function () {
        this._resetDebug();
        try {
            _super.prototype.detach.call(this);
        }
        catch (e) {
            this._rethrowWithContext(e);
            throw e;
        }
    };
    DebugAppView.prototype.destroyLocal = function () {
        this._resetDebug();
        try {
            _super.prototype.destroyLocal.call(this);
        }
        catch (e) {
            this._rethrowWithContext(e);
            throw e;
        }
    };
    DebugAppView.prototype.detectChanges = function (throwOnChange) {
        this._resetDebug();
        try {
            _super.prototype.detectChanges.call(this, throwOnChange);
        }
        catch (e) {
            this._rethrowWithContext(e);
            throw e;
        }
    };
    DebugAppView.prototype._resetDebug = function () { this._currentDebugContext = null; };
    DebugAppView.prototype.debug = function (nodeIndex, rowNum, colNum) {
        return this._currentDebugContext = new __WEBPACK_IMPORTED_MODULE_5__debug_context__["a" /* DebugContext */](this, nodeIndex, rowNum, colNum);
    };
    DebugAppView.prototype._rethrowWithContext = function (e) {
        if (!(e instanceof __WEBPACK_IMPORTED_MODULE_8__errors__["c" /* ViewWrappedError */])) {
            if (!(e instanceof __WEBPACK_IMPORTED_MODULE_8__errors__["a" /* ExpressionChangedAfterItHasBeenCheckedError */])) {
                this.cdMode = __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorStatus"].Errored;
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._currentDebugContext)) {
                throw new __WEBPACK_IMPORTED_MODULE_8__errors__["c" /* ViewWrappedError */](e, this._currentDebugContext);
            }
        }
    };
    DebugAppView.prototype.eventHandler = function (cb) {
        var _this = this;
        var superHandler = _super.prototype.eventHandler.call(this, cb);
        return function (event) {
            _this._resetDebug();
            try {
                return superHandler(event);
            }
            catch (e) {
                _this._rethrowWithContext(e);
                throw e;
            }
        };
    };
    return DebugAppView;
}(AppView));
function _findLastRenderNode(node) {
    var lastNode;
    if (node instanceof __WEBPACK_IMPORTED_MODULE_6__element__["AppElement"]) {
        var appEl = node;
        lastNode = appEl.nativeElement;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(appEl.nestedViews)) {
            // Note: Views might have no root nodes at all!
            for (var i = appEl.nestedViews.length - 1; i >= 0; i--) {
                var nestedView = appEl.nestedViews[i];
                if (nestedView.rootNodesOrAppElements.length > 0) {
                    lastNode = _findLastRenderNode(nestedView.rootNodesOrAppElements[nestedView.rootNodesOrAppElements.length - 1]);
                }
            }
        }
    }
    else {
        lastNode = node;
    }
    return lastNode;
}
//# sourceMappingURL=view.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
var toSubscriber_1 = __webpack_require__(546);
var observable_1 = __webpack_require__(247);
/**
 * A representation of any set of values over any amount of time. This the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is  called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this._subscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.$$observable] = function () {
        return this;
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "TemplateRef", function() { return TemplateRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "TemplateRef_", function() { return TemplateRef_; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * Represents an Embedded Template that can be used to instantiate Embedded Views.
 *
 * You can access a `TemplateRef`, in two ways. Via a directive placed on a `<template>` element (or
 * directive prefixed with `*`) and have the `TemplateRef` for this Embedded View injected into the
 * constructor of the directive using the `TemplateRef` Token. Alternatively you can query for the
 * `TemplateRef` from a Component or a Directive via {@link Query}.
 *
 * To instantiate Embedded Views based on a Template, use
 * {@link ViewContainerRef#createEmbeddedView}, which will create the View and attach it to the
 * View Container.
 * @stable
 */
var TemplateRef = (function () {
    function TemplateRef() {
    }
    Object.defineProperty(TemplateRef.prototype, "elementRef", {
        /**
         * The location in the View where the Embedded View logically belongs to.
         *
         * The data-binding and injection contexts of Embedded Views created from this `TemplateRef`
         * inherit from the contexts of this location.
         *
         * Typically new Embedded Views are attached to the View Container of this location, but in
         * advanced use-cases, the View can be attached to a different container while keeping the
         * data-binding and injection context from the original location.
         *
         */
        // TODO(i): rename to anchor or location
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return TemplateRef;
}());
var TemplateRef_ = (function (_super) {
    __extends(TemplateRef_, _super);
    function TemplateRef_(_appElement, _viewFactory) {
        _super.call(this);
        this._appElement = _appElement;
        this._viewFactory = _viewFactory;
    }
    TemplateRef_.prototype.createEmbeddedView = function (context) {
        var view = this._viewFactory(this._appElement.parentView.viewUtils, this._appElement.parentInjector, this._appElement);
        view.create(context || {}, null, null);
        return view.ref;
    };
    Object.defineProperty(TemplateRef_.prototype, "elementRef", {
        get: function () { return this._appElement.elementRef; },
        enumerable: true,
        configurable: true
    });
    return TemplateRef_;
}(TemplateRef));
//# sourceMappingURL=template_ref.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_every__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_reduce__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_operator_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__apply_redirects__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__create_router_state__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__create_url_tree__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__recognize__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_config_loader__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_outlet_map__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_state__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_collection__ = __webpack_require__(63);
/* harmony export (binding) */ __webpack_require__.d(exports, "NavigationStart", function() { return NavigationStart; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NavigationEnd", function() { return NavigationEnd; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NavigationCancel", function() { return NavigationCancel; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NavigationError", function() { return NavigationError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RoutesRecognized", function() { return RoutesRecognized; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PreActivation", function() { return PreActivation; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





















/**
 * @whatItDoes Represents an event triggered when a navigation starts.
 *
 * @stable
 */
var NavigationStart = (function () {
    // TODO: vsavkin: make internal
    function NavigationStart(
        /** @docsNotRequired */
        id, 
        /** @docsNotRequired */
        url) {
        this.id = id;
        this.url = url;
    }
    /** @docsNotRequired */
    NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationStart;
}());
/**
 * @whatItDoes Represents an event triggered when a navigation ends successfully.
 *
 * @stable
 */
var NavigationEnd = (function () {
    // TODO: vsavkin: make internal
    function NavigationEnd(
        /** @docsNotRequired */
        id, 
        /** @docsNotRequired */
        url, 
        /** @docsNotRequired */
        urlAfterRedirects) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
    }
    /** @docsNotRequired */
    NavigationEnd.prototype.toString = function () {
        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
    };
    return NavigationEnd;
}());
/**
 * @whatItDoes Represents an event triggered when a navigation is canceled.
 *
 * @stable
 */
var NavigationCancel = (function () {
    // TODO: vsavkin: make internal
    function NavigationCancel(
        /** @docsNotRequired */
        id, 
        /** @docsNotRequired */
        url, 
        /** @docsNotRequired */
        reason) {
        this.id = id;
        this.url = url;
        this.reason = reason;
    }
    /** @docsNotRequired */
    NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationCancel;
}());
/**
 * @whatItDoes Represents an event triggered when a navigation fails due to an unexpected error.
 *
 * @stable
 */
var NavigationError = (function () {
    // TODO: vsavkin: make internal
    function NavigationError(
        /** @docsNotRequired */
        id, 
        /** @docsNotRequired */
        url, 
        /** @docsNotRequired */
        error) {
        this.id = id;
        this.url = url;
        this.error = error;
    }
    /** @docsNotRequired */
    NavigationError.prototype.toString = function () {
        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
    };
    return NavigationError;
}());
/**
 * @whatItDoes Represents an event triggered when routes are recognized.
 *
 * @stable
 */
var RoutesRecognized = (function () {
    // TODO: vsavkin: make internal
    function RoutesRecognized(
        /** @docsNotRequired */
        id, 
        /** @docsNotRequired */
        url, 
        /** @docsNotRequired */
        urlAfterRedirects, 
        /** @docsNotRequired */
        state) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
        this.state = state;
    }
    /** @docsNotRequired */
    RoutesRecognized.prototype.toString = function () {
        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return RoutesRecognized;
}());
function defaultErrorHandler(error) {
    throw error;
}
/**
 * @whatItDoes Provides the navigation and url manipulation capabilities.
 *
 * See {@link Routes} for more details and examples.
 *
 * @ngModule RouterModule
 *
 * @stable
 */
var Router = (function () {
    /**
     * Creates the router service.
     */
    // TODO: vsavkin make internal after the final is out.
    function Router(rootComponentType, urlSerializer, outletMap, location, injector, loader, compiler, config) {
        this.rootComponentType = rootComponentType;
        this.urlSerializer = urlSerializer;
        this.outletMap = outletMap;
        this.location = location;
        this.injector = injector;
        this.config = config;
        this.navigationId = 0;
        /**
         * Error handler that is invoked when a navigation errors.
         *
         * See {@link ErrorHandler} for more information.
         */
        this.errorHandler = defaultErrorHandler;
        /**
         * Indicates if at least one navigation happened.
         */
        this.navigated = false;
        this.resetConfig(config);
        this.routerEvents = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
        this.currentUrlTree = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__url_tree__["createEmptyUrlTree"])();
        this.configLoader = new __WEBPACK_IMPORTED_MODULE_15__router_config_loader__["RouterConfigLoader"](loader, compiler);
        this.currentRouterState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["createEmptyState"])(this.currentUrlTree, this.rootComponentType);
    }
    /**
     * @internal
     * TODO: this should be removed once the constructor of the router made internal
     */
    Router.prototype.resetRootComponentType = function (rootComponentType) {
        this.rootComponentType = rootComponentType;
        // TODO: vsavkin router 4.0 should make the root component set to null
        // this will simplify the lifecycle of the router.
        this.currentRouterState.root.component = this.rootComponentType;
    };
    /**
     * Sets up the location change listener and performs the initial navigation.
     */
    Router.prototype.initialNavigation = function () {
        this.setUpLocationChangeListener();
        this.navigateByUrl(this.location.path(true), { replaceUrl: true });
    };
    /**
     * Sets up the location change listener.
     */
    Router.prototype.setUpLocationChangeListener = function () {
        var _this = this;
        // Zone.current.wrap is needed because of the issue with RxJS scheduler,
        // which does not work properly with zone.js in IE and Safari
        this.locationSubscription = this.location.subscribe(Zone.current.wrap(function (change) {
            var tree = _this.urlSerializer.parse(change['url']);
            // we fire multiple events for a single URL change
            // we should navigate only once
            return _this.currentUrlTree.toString() !== tree.toString() ?
                _this.scheduleNavigation(tree, { skipLocationChange: change['pop'], replaceUrl: true }) :
                null;
        }));
    };
    Object.defineProperty(Router.prototype, "routerState", {
        /**
         * Returns the current route state.
         */
        get: function () { return this.currentRouterState; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "url", {
        /**
         * Returns the current url.
         */
        get: function () { return this.serializeUrl(this.currentUrlTree); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "events", {
        /**
         * Returns an observable of route events
         */
        get: function () { return this.routerEvents; },
        enumerable: true,
        configurable: true
    });
    /**
     * Resets the configuration used for navigation and generating links.
     *
     * ### Usage
     *
     * ```
     * router.resetConfig([
     *  { path: 'team/:id', component: TeamCmp, children: [
     *    { path: 'simple', component: SimpleCmp },
     *    { path: 'user/:name', component: UserCmp }
     *  ] }
     * ]);
     * ```
     */
    Router.prototype.resetConfig = function (config) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* validateConfig */])(config);
        this.config = config;
    };
    /**
     * @docsNotRequired
     */
    Router.prototype.ngOnDestroy = function () { this.dispose(); };
    /**
     * Disposes of the router.
     */
    Router.prototype.dispose = function () { this.locationSubscription.unsubscribe(); };
    /**
     * Applies an array of commands to the current url tree and creates a new url tree.
     *
     * When given an activate route, applies the given commands starting from the route.
     * When not given a route, applies the given command starting from the root.
     *
     * ### Usage
     *
     * ```
     * // create /team/33/user/11
     * router.createUrlTree(['/team', 33, 'user', 11]);
     *
     * // create /team/33;expand=true/user/11
     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
     *
     * // you can collapse static segments like this (this works only with the first passed-in value):
     * router.createUrlTree(['/team/33/user', userId]);
     *
     * // If the first segment can contain slashes, and you do not want the router to split it, you
     * // can do the following:
     *
     * router.createUrlTree([{segmentPath: '/one/two'}]);
     *
     * // create /team/33/(user/11//right:chat)
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
     *
     * // remove the right secondary node
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
     *
     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
     *
     * // navigate to /team/33/user/11/details
     * router.createUrlTree(['details'], {relativeTo: route});
     *
     * // navigate to /team/33/user/22
     * router.createUrlTree(['../22'], {relativeTo: route});
     *
     * // navigate to /team/44/user/22
     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
     * ```
     */
    Router.prototype.createUrlTree = function (commands, _a) {
        var _b = _a === void 0 ? {} : _a, relativeTo = _b.relativeTo, queryParams = _b.queryParams, fragment = _b.fragment, preserveQueryParams = _b.preserveQueryParams, preserveFragment = _b.preserveFragment;
        var a = relativeTo ? relativeTo : this.routerState.root;
        var q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams;
        var f = preserveFragment ? this.currentUrlTree.fragment : fragment;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__create_url_tree__["a" /* createUrlTree */])(a, this.currentUrlTree, commands, q, f);
    };
    /**
     * Navigate based on the provided url. This navigation is always absolute.
     *
     * Returns a promise that:
     * - is resolved with 'true' when navigation succeeds
     * - is resolved with 'false' when navigation fails
     * - is rejected when an error happens
     *
     * ### Usage
     *
     * ```
     * router.navigateByUrl("/team/33/user/11");
     *
     * // Navigate without updating the URL
     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
     * ```
     *
     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
     * and does not apply any delta to the current one.
     */
    Router.prototype.navigateByUrl = function (url, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        if (url instanceof __WEBPACK_IMPORTED_MODULE_19__url_tree__["UrlTree"]) {
            return this.scheduleNavigation(url, extras);
        }
        else {
            var urlTree = this.urlSerializer.parse(url);
            return this.scheduleNavigation(urlTree, extras);
        }
    };
    /**
     * Navigate based on the provided array of commands and a starting point.
     * If no starting route is provided, the navigation is absolute.
     *
     * Returns a promise that:
     * - is resolved with 'true' when navigation succeeds
     * - is resolved with 'false' when navigation fails
     * - is rejected when an error happens
     *
     * ### Usage
     *
     * ```
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
     *
     * // Navigate without updating the URL
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true });
     * ```
     *
     * In opposite to `navigateByUrl`, `navigate` always takes a delta
     * that is applied to the current URL.
     */
    Router.prototype.navigate = function (commands, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        return this.scheduleNavigation(this.createUrlTree(commands, extras), extras);
    };
    /**
     * Serializes a {@link UrlTree} into a string.
     */
    Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
    /**
     * Parses a string into a {@link UrlTree}.
     */
    Router.prototype.parseUrl = function (url) { return this.urlSerializer.parse(url); };
    /**
     * Returns if the url is activated or not.
     */
    Router.prototype.isActive = function (url, exact) {
        if (url instanceof __WEBPACK_IMPORTED_MODULE_19__url_tree__["UrlTree"]) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__url_tree__["containsTree"])(this.currentUrlTree, url, exact);
        }
        else {
            var urlTree = this.urlSerializer.parse(url);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__url_tree__["containsTree"])(this.currentUrlTree, urlTree, exact);
        }
    };
    Router.prototype.scheduleNavigation = function (url, extras) {
        var _this = this;
        var id = ++this.navigationId;
        this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
        return Promise.resolve().then(function (_) { return _this.runNavigate(url, extras.skipLocationChange, extras.replaceUrl, id); });
    };
    Router.prototype.runNavigate = function (url, shouldPreventPushState, shouldReplaceUrl, id) {
        var _this = this;
        if (id !== this.navigationId) {
            this.location.go(this.urlSerializer.serialize(this.currentUrlTree));
            this.routerEvents.next(new NavigationCancel(id, this.serializeUrl(url), "Navigation ID " + id + " is not equal to the current navigation id " + this.navigationId));
            return Promise.resolve(false);
        }
        return new Promise(function (resolvePromise, rejectPromise) {
            var state;
            var navigationIsSuccessful;
            var preActivation;
            var appliedUrl;
            var storedState = _this.currentRouterState;
            var storedUrl = _this.currentUrlTree;
            var redirectsApplied$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__apply_redirects__["a" /* applyRedirects */])(_this.injector, _this.configLoader, url, _this.config);
            var snapshot$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap__["mergeMap"].call(redirectsApplied$, function (u) {
                appliedUrl = u;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__recognize__["a" /* recognize */])(_this.rootComponentType, _this.config, appliedUrl, _this.serializeUrl(appliedUrl));
            });
            var emitRecognzied$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(snapshot$, function (newRouterStateSnapshot) {
                _this.routerEvents.next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), newRouterStateSnapshot));
                return newRouterStateSnapshot;
            });
            var routerState$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(emitRecognzied$, function (routerStateSnapshot) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__create_router_state__["a" /* createRouterState */])(routerStateSnapshot, _this.currentRouterState);
            });
            var preactivation$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(routerState$, function (newState) {
                state = newState;
                preActivation =
                    new PreActivation(state.snapshot, _this.currentRouterState.snapshot, _this.injector);
                preActivation.traverse(_this.outletMap);
            });
            var preactivation2$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap__["mergeMap"].call(preactivation$, function () { return preActivation.checkGuards(); });
            var resolveData$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_mergeMap__["mergeMap"].call(preactivation2$, function (shouldActivate) {
                if (shouldActivate) {
                    return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(preActivation.resolveData(), function () { return shouldActivate; });
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(shouldActivate);
                }
            });
            resolveData$
                .forEach(function (shouldActivate) {
                if (!shouldActivate || id !== _this.navigationId) {
                    navigationIsSuccessful = false;
                    return;
                }
                _this.currentUrlTree = appliedUrl;
                _this.currentRouterState = state;
                if (!shouldPreventPushState) {
                    var path = _this.urlSerializer.serialize(appliedUrl);
                    if (_this.location.isCurrentPathEqualTo(path) || shouldReplaceUrl) {
                        _this.location.replaceState(path);
                    }
                    else {
                        _this.location.go(path);
                    }
                }
                new ActivateRoutes(state, storedState).activate(_this.outletMap);
                navigationIsSuccessful = true;
            })
                .then(function () {
                _this.navigated = true;
                if (navigationIsSuccessful) {
                    _this.routerEvents.next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl)));
                    resolvePromise(true);
                }
                else {
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), ''));
                    resolvePromise(false);
                }
            }, function (e) {
                if (e instanceof __WEBPACK_IMPORTED_MODULE_18__shared__["b" /* NavigationCancelingError */]) {
                    _this.navigated = true;
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), e.message));
                    resolvePromise(false);
                }
                else {
                    _this.routerEvents.next(new NavigationError(id, _this.serializeUrl(url), e));
                    try {
                        resolvePromise(_this.errorHandler(e));
                    }
                    catch (ee) {
                        rejectPromise(ee);
                    }
                }
                if (id === _this.navigationId) {
                    _this.currentRouterState = storedState;
                    _this.currentUrlTree = storedUrl;
                    _this.location.replaceState(_this.serializeUrl(storedUrl));
                }
            });
        });
    };
    return Router;
}());
var CanActivate = (function () {
    function CanActivate(path) {
        this.path = path;
    }
    Object.defineProperty(CanActivate.prototype, "route", {
        get: function () { return this.path[this.path.length - 1]; },
        enumerable: true,
        configurable: true
    });
    return CanActivate;
}());
var CanDeactivate = (function () {
    function CanDeactivate(component, route) {
        this.component = component;
        this.route = route;
    }
    return CanDeactivate;
}());
var PreActivation = (function () {
    function PreActivation(future, curr, injector) {
        this.future = future;
        this.curr = curr;
        this.injector = injector;
        this.checks = [];
    }
    PreActivation.prototype.traverse = function (parentOutletMap) {
        var futureRoot = this.future._root;
        var currRoot = this.curr ? this.curr._root : null;
        this.traverseChildRoutes(futureRoot, currRoot, parentOutletMap, [futureRoot.value]);
    };
    PreActivation.prototype.checkGuards = function () {
        var _this = this;
        if (this.checks.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(true);
        var checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(this.checks);
        var runningChecks$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(checks$, function (s) {
            if (s instanceof CanActivate) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["f" /* andObservables */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])([_this.runCanActivateChild(s.path), _this.runCanActivate(s.route)]));
            }
            else if (s instanceof CanDeactivate) {
                // workaround https://github.com/Microsoft/TypeScript/issues/7271
                var s2 = s;
                return _this.runCanDeactivate(s2.component, s2.route);
            }
            else {
                throw new Error('Cannot be reached');
            }
        });
        var mergedChecks$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__["mergeAll"].call(runningChecks$);
        return __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_every__["every"].call(mergedChecks$, function (result) { return result === true; });
    };
    PreActivation.prototype.resolveData = function () {
        var _this = this;
        if (this.checks.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(null);
        var checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(this.checks);
        var runningChecks$ = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__["concatMap"].call(checks$, function (s) {
            if (s instanceof CanActivate) {
                return _this.runResolve(s.route);
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(null);
            }
        });
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_reduce__["reduce"].call(runningChecks$, function (_, __) { return _; });
    };
    PreActivation.prototype.traverseChildRoutes = function (futureNode, currNode, outletMap, futurePath) {
        var _this = this;
        var prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.traverseRoutes(c, prevChildren[c.value.outlet], outletMap, futurePath.concat([c.value]));
            delete prevChildren[c.value.outlet];
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["c" /* forEach */])(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, outletMap._outlets[k]); });
    };
    PreActivation.prototype.traverseRoutes = function (futureNode, currNode, parentOutletMap, futurePath) {
        var future = futureNode.value;
        var curr = currNode ? currNode.value : null;
        var outlet = parentOutletMap ? parentOutletMap._outlets[futureNode.value.outlet] : null;
        // reusing the node
        if (curr && future._routeConfig === curr._routeConfig) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["d" /* shallowEqual */])(future.params, curr.params)) {
                this.checks.push(new CanDeactivate(outlet.component, curr), new CanActivate(futurePath));
            }
            else {
                // we need to set the data
                future.data = curr.data;
                future._resolvedData = curr._resolvedData;
            }
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, currNode, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, currNode, parentOutletMap, futurePath);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, outlet);
            }
            this.checks.push(new CanActivate(futurePath));
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, null, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, null, parentOutletMap, futurePath);
            }
        }
    };
    PreActivation.prototype.deactiveRouteAndItsChildren = function (route, outlet) {
        var _this = this;
        var prevChildren = nodeChildrenAsMap(route);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["c" /* forEach */])(prevChildren, function (v, k) {
            var childOutlet = outlet ? outlet.outletMap._outlets[k] : null;
            _this.deactiveRouteAndItsChildren(v, childOutlet);
        });
        var component = outlet && outlet.isActivated ? outlet.component : null;
        this.checks.push(new CanDeactivate(component, route.value));
    };
    PreActivation.prototype.runCanActivate = function (future) {
        var _this = this;
        var canActivate = future._routeConfig ? future._routeConfig.canActivate : null;
        if (!canActivate || canActivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(true);
        var obs = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(canActivate), function (c) {
            var guard = _this.getToken(c, future);
            if (guard.canActivate) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard.canActivate(future, _this.future));
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard(future, _this.future));
            }
        });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["f" /* andObservables */])(obs);
    };
    PreActivation.prototype.runCanActivateChild = function (path) {
        var _this = this;
        var future = path[path.length - 1];
        var canActivateChildGuards = path.slice(0, path.length - 1)
            .reverse()
            .map(function (p) { return _this.extractCanActivateChild(p); })
            .filter(function (_) { return _ !== null; });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["f" /* andObservables */])(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(canActivateChildGuards), function (d) {
            var obs = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(d.guards), function (c) {
                var guard = _this.getToken(c, c.node);
                if (guard.canActivateChild) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard.canActivateChild(future, _this.future));
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard(future, _this.future));
                }
            });
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["f" /* andObservables */])(obs);
        }));
    };
    PreActivation.prototype.extractCanActivateChild = function (p) {
        var canActivateChild = p._routeConfig ? p._routeConfig.canActivateChild : null;
        if (!canActivateChild || canActivateChild.length === 0)
            return null;
        return { node: p, guards: canActivateChild };
    };
    PreActivation.prototype.runCanDeactivate = function (component, curr) {
        var _this = this;
        var canDeactivate = curr && curr._routeConfig ? curr._routeConfig.canDeactivate : null;
        if (!canDeactivate || canDeactivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(true);
        var canDeactivate$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_from__["from"])(canDeactivate), function (c) {
            var guard = _this.getToken(c, curr);
            if (guard.canDeactivate) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard.canDeactivate(component, curr, _this.curr));
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(guard(component, curr, _this.curr));
            }
        });
        var merged$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__["mergeAll"].call(canDeactivate$);
        return __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_every__["every"].call(merged$, function (result) { return result === true; });
    };
    PreActivation.prototype.runResolve = function (future) {
        var resolve = future._resolve;
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(this.resolveNode(resolve, future), function (resolvedData) {
            future._resolvedData = resolvedData;
            future.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["g" /* merge */])(future.data, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["inheritedParamsDataResolve"])(future).resolve);
            return null;
        });
    };
    PreActivation.prototype.resolveNode = function (resolve, future) {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["e" /* waitForMap */])(resolve, function (k, v) {
            var resolver = _this.getToken(v, future);
            return resolver.resolve ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(resolver.resolve(future, _this.future)) :
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["b" /* wrapIntoObservable */])(resolver(future, _this.future));
        });
    };
    PreActivation.prototype.getToken = function (token, snapshot) {
        var config = closestLoadedConfig(snapshot);
        var injector = config ? config.injector : this.injector;
        return injector.get(token);
    };
    return PreActivation;
}());
var ActivateRoutes = (function () {
    function ActivateRoutes(futureState, currState) {
        this.futureState = futureState;
        this.currState = currState;
    }
    ActivateRoutes.prototype.activate = function (parentOutletMap) {
        var futureRoot = this.futureState._root;
        var currRoot = this.currState ? this.currState._root : null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["advanceActivatedRoute"])(this.futureState.root);
        this.activateChildRoutes(futureRoot, currRoot, parentOutletMap);
    };
    ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, outletMap) {
        var _this = this;
        var prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.activateRoutes(c, prevChildren[c.value.outlet], outletMap);
            delete prevChildren[c.value.outlet];
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["c" /* forEach */])(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, outletMap); });
    };
    ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentOutletMap) {
        var future = futureNode.value;
        var curr = currNode ? currNode.value : null;
        // reusing the node
        if (future === curr) {
            // advance the route to push the parameters
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["advanceActivatedRoute"])(future);
            // If we have a normal route, we need to go through an outlet.
            if (future.component) {
                var outlet = getOutlet(parentOutletMap, future);
                this.activateChildRoutes(futureNode, currNode, outlet.outletMap);
            }
            else {
                this.activateChildRoutes(futureNode, currNode, parentOutletMap);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, parentOutletMap);
            }
            // if we have a normal route, we need to advance the route
            // and place the component into the outlet. After that recurse.
            if (future.component) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["advanceActivatedRoute"])(future);
                var outlet = getOutlet(parentOutletMap, futureNode.value);
                var outletMap = new __WEBPACK_IMPORTED_MODULE_16__router_outlet_map__["RouterOutletMap"]();
                this.placeComponentIntoOutlet(outletMap, future, outlet);
                this.activateChildRoutes(futureNode, null, outletMap);
            }
            else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__router_state__["advanceActivatedRoute"])(future);
                this.activateChildRoutes(futureNode, null, parentOutletMap);
            }
        }
    };
    ActivateRoutes.prototype.placeComponentIntoOutlet = function (outletMap, future, outlet) {
        var resolved = [{ provide: __WEBPACK_IMPORTED_MODULE_17__router_state__["ActivatedRoute"], useValue: future }, {
                provide: __WEBPACK_IMPORTED_MODULE_16__router_outlet_map__["RouterOutletMap"],
                useValue: outletMap
            }];
        var config = parentLoadedConfig(future.snapshot);
        var loadedFactoryResolver = null;
        var loadedInjector = null;
        if (config) {
            loadedFactoryResolver = config.factoryResolver;
            loadedInjector = config.injector;
            resolved.push({ provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], useValue: loadedFactoryResolver });
        }
        outlet.activate(future, loadedFactoryResolver, loadedInjector, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolve(resolved), outletMap);
    };
    ActivateRoutes.prototype.deactiveRouteAndItsChildren = function (route, parentOutletMap) {
        var _this = this;
        var prevChildren = nodeChildrenAsMap(route);
        var outlet = null;
        // getOutlet throws when cannot find the right outlet,
        // which can happen if an outlet was in an NgIf and was removed
        try {
            outlet = getOutlet(parentOutletMap, route.value);
        }
        catch (e) {
            return;
        }
        var childOutletMap = outlet.outletMap;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_collection__["c" /* forEach */])(prevChildren, function (v, k) {
            if (route.value.component) {
                _this.deactiveRouteAndItsChildren(v, childOutletMap);
            }
            else {
                _this.deactiveRouteAndItsChildren(v, parentOutletMap);
            }
        });
        if (outlet && outlet.isActivated) {
            outlet.deactivate();
        }
    };
    return ActivateRoutes;
}());
function parentLoadedConfig(snapshot) {
    var s = snapshot.parent;
    while (s) {
        var c = s._routeConfig;
        if (c && c._loadedConfig)
            return c._loadedConfig;
        if (c && c.component)
            return null;
        s = s.parent;
    }
    return null;
}
function closestLoadedConfig(snapshot) {
    if (!snapshot)
        return null;
    var s = snapshot.parent;
    while (s) {
        var c = s._routeConfig;
        if (c && c._loadedConfig)
            return c._loadedConfig;
        s = s.parent;
    }
    return null;
}
function nodeChildrenAsMap(node) {
    return node ? node.children.reduce(function (m, c) {
        m[c.value.outlet] = c;
        return m;
    }, {}) : {};
}
function getOutlet(outletMap, route) {
    var outlet = outletMap._outlets[route.outlet];
    if (!outlet) {
        var componentName = route.component.name;
        if (route.outlet === __WEBPACK_IMPORTED_MODULE_18__shared__["a" /* PRIMARY_OUTLET */]) {
            throw new Error("Cannot find primary outlet to load '" + componentName + "'");
        }
        else {
            throw new Error("Cannot find the outlet " + route.outlet + " to load '" + componentName + "'");
        }
    }
    return outlet;
}
//# sourceMappingURL=router.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_collection__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tree__ = __webpack_require__(215);
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterState", function() { return RouterState; });
/* harmony export (immutable) */ exports["createEmptyState"] = createEmptyState;
/* harmony export (immutable) */ exports["createEmptyStateSnapshot"] = createEmptyStateSnapshot;
/* harmony export (binding) */ __webpack_require__.d(exports, "ActivatedRoute", function() { return ActivatedRoute; });
/* harmony export (immutable) */ exports["inheritedParamsDataResolve"] = inheritedParamsDataResolve;
/* harmony export (binding) */ __webpack_require__.d(exports, "ActivatedRouteSnapshot", function() { return ActivatedRouteSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterStateSnapshot", function() { return RouterStateSnapshot; });
/* harmony export (immutable) */ exports["advanceActivatedRoute"] = advanceActivatedRoute;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





/**
 * @whatItDoes Represents the state of the router.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const root: ActivatedRoute = state.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * @description
 * RouterState is a tree of activated routes. Every node in this tree knows about the "consumed" URL
 * segments,
 * the extracted parameters, and the resolved data.
 *
 * See {@link ActivatedRoute} for more information.
 *
 * @stable
 */
var RouterState = (function (_super) {
    __extends(RouterState, _super);
    /**
     * @internal
     */
    function RouterState(root, 
        /**
         * The current snapshot of the router state.
         */
        snapshot) {
        _super.call(this, root);
        this.snapshot = snapshot;
        setRouterStateSnapshot(this, root);
    }
    RouterState.prototype.toString = function () { return this.snapshot.toString(); };
    return RouterState;
}(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["a" /* Tree */]));
function createEmptyState(urlTree, rootComponent) {
    var snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
    var emptyUrl = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]([new __WEBPACK_IMPORTED_MODULE_2__url_tree__["UrlSegment"]('', {})]);
    var emptyParams = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var emptyData = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var emptyQueryParams = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var fragment = new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]('');
    var activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, __WEBPACK_IMPORTED_MODULE_1__shared__["a" /* PRIMARY_OUTLET */], rootComponent, snapshot.root);
    activated.snapshot = snapshot.root;
    return new RouterState(new __WEBPACK_IMPORTED_MODULE_4__utils_tree__["b" /* TreeNode */](activated, []), snapshot);
}
function createEmptyStateSnapshot(urlTree, rootComponent) {
    var emptyParams = {};
    var emptyData = {};
    var emptyQueryParams = {};
    var fragment = '';
    var activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, __WEBPACK_IMPORTED_MODULE_1__shared__["a" /* PRIMARY_OUTLET */], rootComponent, null, urlTree.root, -1, {});
    return new RouterStateSnapshot('', new __WEBPACK_IMPORTED_MODULE_4__utils_tree__["b" /* TreeNode */](activated, []));
}
/**
 * @whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet.
 * ActivatedRoute can also be used to traverse the router state tree.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'./my-component.html'})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: Observable<string> = route.params.map(p => p.id);
 *     const url: Observable<string> = route.url.map(s => s.join(''));
 *     const user = route.data.map(d => d.user); //includes `data` and `resolve`
 *   }
 * }
 * ```
 *
 * @stable
 */
var ActivatedRoute = (function () {
    /**
     * @internal
     */
    function ActivatedRoute(
        /**
         *  The URL segments matched by this route. The observable will emit a new value when
         *  the array of segments changes.
         */
        url, 
        /**
         * The matrix parameters scoped to this route. The observable will emit a new value when
         * the set of the parameters changes.
         */
        params, 
        /**
         * The query parameters shared by all the routes. The observable will emit a new value when
         * the set of the parameters changes.
         */
        queryParams, 
        /**
         * The URL fragment shared by all the routes. The observable will emit a new value when
         * the URL fragment changes.
         */
        fragment, 
        /**
         * The static and resolved data of this route. The observable will emit a new value when
         * any of the resolvers returns a new object.
         */
        data, 
        /**
         * The outlet name of the route. It's a constant.
         */
        outlet, 
        /**
         * The component of the route. It's a constant.
         */
        component, // TODO: vsavkin: remove |string
        futureSnapshot) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._futureSnapshot = futureSnapshot;
    }
    Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
        /**
         * The configuration used to match this route.
         */
        get: function () { return this._futureSnapshot.routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "root", {
        /**
         * The root of the router state.
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "parent", {
        /**
         * The parent of this route in the router state tree.
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree.
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "children", {
        /**
         * The children of this route in the router state tree.
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route.
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    /**
     * @docsNotRequired
     */
    ActivatedRoute.prototype.toString = function () {
        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
    };
    return ActivatedRoute;
}());
/**
 * @internal
 */
function inheritedParamsDataResolve(route) {
    var pathToRoot = route.pathFromRoot;
    var inhertingStartingFrom = pathToRoot.length - 1;
    while (inhertingStartingFrom >= 1) {
        var current = pathToRoot[inhertingStartingFrom];
        var parent_1 = pathToRoot[inhertingStartingFrom - 1];
        // current route is an empty path => inherits its parent's params and data
        if (current.routeConfig && current.routeConfig.path === '') {
            inhertingStartingFrom--;
        }
        else if (!parent_1.component) {
            inhertingStartingFrom--;
        }
        else {
            break;
        }
    }
    return pathToRoot.slice(inhertingStartingFrom).reduce(function (res, curr) {
        var params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.params, curr.params);
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.data, curr.data);
        var resolve = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["g" /* merge */])(res.resolve, curr._resolvedData);
        return { params: params, data: data, resolve: resolve };
    }, { params: {}, data: {}, resolve: {} });
}
/**
 * @whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet
 * at a particular moment in time. ActivatedRouteSnapshot can also be used to traverse the router
 * state tree.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'./my-component.html'})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: string = route.snapshot.params.id;
 *     const url: string = route.snapshot.url.join('');
 *     const user = route.snapshot.data.user;
 *   }
 * }
 * ```
 *
 * @stable
 */
var ActivatedRouteSnapshot = (function () {
    /**
     * @internal
     */
    function ActivatedRouteSnapshot(
        /**
         *  The URL segments matched by this route.
         */
        url, 
        /**
         * The matrix parameters scoped to this route.
         */
        params, 
        /**
         * The query parameters shared by all the routes.
         */
        queryParams, 
        /**
         * The URL fragment shared by all the routes.
         */
        fragment, 
        /**
         * The static and resolved data of this route.
         */
        data, 
        /**
         * The outlet name of the route.
         */
        outlet, 
        /**
         * The component of the route.
         */
        component, routeConfig, urlSegment, lastPathIndex, resolve) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._routeConfig = routeConfig;
        this._urlSegment = urlSegment;
        this._lastPathIndex = lastPathIndex;
        this._resolve = resolve;
    }
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "routeConfig", {
        /**
         * The configuration used to match this route.
         */
        get: function () { return this._routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
        /**
         * The root of the router state.
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
        /**
         * The parent of this route in the router state tree.
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree.
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
        /**
         * The children of this route in the router state tree.
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route.
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    /**
     * @docsNotRequired
     */
    ActivatedRouteSnapshot.prototype.toString = function () {
        var url = this.url.map(function (s) { return s.toString(); }).join('/');
        var matched = this._routeConfig ? this._routeConfig.path : '';
        return "Route(url:'" + url + "', path:'" + matched + "')";
    };
    return ActivatedRouteSnapshot;
}());
/**
 * @whatItDoes Represents the state of the router at a moment in time.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const snapshot: RouterStateSnapshot = state.snapshot;
 *     const root: ActivatedRouteSnapshot = snapshot.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * @description
 * RouterStateSnapshot is a tree of activated route snapshots. Every node in this tree knows about
 * the "consumed" URL segments, the extracted parameters, and the resolved data.
 *
 * @stable
 */
var RouterStateSnapshot = (function (_super) {
    __extends(RouterStateSnapshot, _super);
    /**
     * @internal
     */
    function RouterStateSnapshot(
        /** The url from which this snapshot was created */
        url, root) {
        _super.call(this, root);
        this.url = url;
        setRouterStateSnapshot(this, root);
    }
    RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
    return RouterStateSnapshot;
}(__WEBPACK_IMPORTED_MODULE_4__utils_tree__["a" /* Tree */]));
function setRouterStateSnapshot(state, node) {
    node.value._routerState = state;
    node.children.forEach(function (c) { return setRouterStateSnapshot(state, c); });
}
function serializeNode(node) {
    var c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(", ") + " } " : '';
    return "" + node.value + c;
}
/**
 * The expectation is that the activate route is created with the right set of parameters.
 * So we push new values into the observables only when they are not the initial values.
 * And we detect that by checking if the snapshot field is set.
 */
function advanceActivatedRoute(route) {
    if (route.snapshot) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["d" /* shallowEqual */])(route.snapshot.queryParams, route._futureSnapshot.queryParams)) {
            route.queryParams.next(route._futureSnapshot.queryParams);
        }
        if (route.snapshot.fragment !== route._futureSnapshot.fragment) {
            route.fragment.next(route._futureSnapshot.fragment);
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["d" /* shallowEqual */])(route.snapshot.params, route._futureSnapshot.params)) {
            route.params.next(route._futureSnapshot.params);
            route.data.next(route._futureSnapshot.data);
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_collection__["h" /* shallowEqualArrays */])(route.snapshot.url, route._futureSnapshot.url)) {
            route.url.next(route._futureSnapshot.url);
        }
        route.snapshot = route._futureSnapshot;
    }
    else {
        route.snapshot = route._futureSnapshot;
        // this is for resolved data
        route.data.next(route._futureSnapshot.data);
    }
}
//# sourceMappingURL=router_state.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
var intl = __webpack_require__(463);
var IntlService = (function () {
    function IntlService(http) {
        this.http = http;
        this.data = intl;
    }
    IntlService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], IntlService);
    return IntlService;
    var _a;
}());
exports.IntlService = IntlService;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "ElementRef", function() { return ElementRef; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A wrapper around a native element inside of a View.
 *
 * An `ElementRef` is backed by a render-specific element. In the browser, this is usually a DOM
 * element.
 *
 * @security Permitting direct access to the DOM can make your application more vulnerable to
 * XSS attacks. Carefully review any use of `ElementRef` in your code. For more detail, see the
 * [Security Guide](http://g.co/ng/security).
 *
 * @stable
 */
// Note: We don't expose things like `Injector`, `ViewContainer`, ... here,
// i.e. users have to ask for what they need. With that, we can build better analysis tools
// and could do better codegen in the future.
var ElementRef = (function () {
    function ElementRef(nativeElement) {
        this.nativeElement = nativeElement;
    }
    return ElementRef;
}());
//# sourceMappingURL=element_ref.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgIf", function() { return NgIf; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Removes or recreates a portion of the DOM tree based on an {expression}.
 *
 * If the expression assigned to `ngIf` evaluates to a falsy value then the element
 * is removed from the DOM, otherwise a clone of the element is reinserted into the DOM.
 *
 * ### Example ([live demo](http://plnkr.co/edit/fe0kgemFBtmQOY31b4tw?p=preview)):
 *
 * ```
 * <div *ngIf="errorCount > 0" class="error">
 *   <!-- Error message displayed when the errorCount property in the current context is greater
 * than 0. -->
 *   {{errorCount}} errors detected
 * </div>
 * ```
 *
 * ### Syntax
 *
 * - `<div *ngIf="condition">...</div>`
 * - `<div template="ngIf condition">...</div>`
 * - `<template [ngIf]="condition"><div>...</div></template>`
 *
 * @stable
 */
var NgIf = (function () {
    function NgIf(_viewContainer, _template) {
        this._viewContainer = _viewContainer;
        this._template = _template;
        this._hasView = false;
    }
    Object.defineProperty(NgIf.prototype, "ngIf", {
        set: function (condition) {
            if (condition && !this._hasView) {
                this._hasView = true;
                this._viewContainer.createEmbeddedView(this._template);
            }
            else if (!condition && this._hasView) {
                this._hasView = false;
                this._viewContainer.clear();
            }
        },
        enumerable: true,
        configurable: true
    });
    NgIf.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngIf]' },] },
    ];
    /** @nocollapse */
    NgIf.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    ];
    NgIf.propDecorators = {
        'ngIf': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgIf;
}());
//# sourceMappingURL=ng_if.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "IterableDiffers", function() { return IterableDiffers; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
 * @stable
 */
var IterableDiffers = (function () {
    function IterableDiffers(factories) {
        this.factories = factories;
    }
    IterableDiffers.create = function (factories, parent) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parent)) {
            var copied = parent.factories.slice();
            factories = factories.concat(copied);
            return new IterableDiffers(factories);
        }
        else {
            return new IterableDiffers(factories);
        }
    };
    /**
     * Takes an array of {@link IterableDifferFactory} and returns a provider used to extend the
     * inherited {@link IterableDiffers} instance with the provided factories and return a new
     * {@link IterableDiffers} instance.
     *
     * The following example shows how to extend an existing list of factories,
           * which will only be applied to the injector for this component and its children.
           * This step is all that's required to make a new {@link IterableDiffer} available.
     *
     * ### Example
     *
     * ```
     * @Component({
     *   viewProviders: [
     *     IterableDiffers.extend([new ImmutableListDiffer()])
     *   ]
     * })
     * ```
     */
    IterableDiffers.extend = function (factories) {
        return {
            provide: IterableDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
                    // to
                    // bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend IterableDiffers without a parent injector');
                }
                return IterableDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[IterableDiffers, new __WEBPACK_IMPORTED_MODULE_0__di__["e" /* SkipSelf */](), new __WEBPACK_IMPORTED_MODULE_0__di__["d" /* Optional */]()]]
        };
    };
    IterableDiffers.prototype.find = function (iterable) {
        var factory = this.factories.find(function (f) { return f.supports(iterable); });
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(factory)) {
            return factory;
        }
        else {
            throw new Error("Cannot find a differ supporting object '" + iterable + "' of type '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["j" /* getTypeNameForDebugging */])(iterable) + "'");
        }
    };
    return IterableDiffers;
}());
//# sourceMappingURL=iterable_differs.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgForRow", function() { return NgForRow; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgFor", function() { return NgFor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var NgForRow = (function () {
    function NgForRow($implicit, index, count) {
        this.$implicit = $implicit;
        this.index = index;
        this.count = count;
    }
    Object.defineProperty(NgForRow.prototype, "first", {
        get: function () { return this.index === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForRow.prototype, "last", {
        get: function () { return this.index === this.count - 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForRow.prototype, "even", {
        get: function () { return this.index % 2 === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForRow.prototype, "odd", {
        get: function () { return !this.even; },
        enumerable: true,
        configurable: true
    });
    return NgForRow;
}());
/**
 * The `NgFor` directive instantiates a template once per item from an iterable. The context for
 * each instantiated template inherits from the outer context with the given loop variable set
 * to the current item from the iterable.
 *
 * ### Local Variables
 *
 * `NgFor` provides several exported values that can be aliased to local variables:
 *
 * * `index` will be set to the current loop iteration for each template context.
 * * `first` will be set to a boolean value indicating whether the item is the first one in the
 *   iteration.
 * * `last` will be set to a boolean value indicating whether the item is the last one in the
 *   iteration.
 * * `even` will be set to a boolean value indicating whether this item has an even index.
 * * `odd` will be set to a boolean value indicating whether this item has an odd index.
 *
 * ### Change Propagation
 *
 * When the contents of the iterator changes, `NgFor` makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 * * Otherwise, the DOM element for that item will remain the same.
 *
 * Angular uses object identity to track insertions and deletions within the iterator and reproduce
 * those changes in the DOM. This has important implications for animations and any stateful
 * controls
 * (such as `<input>` elements which accept user input) that are present. Inserted rows can be
 * animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state such
 * as user input.
 *
 * It is possible for the identities of elements in the iterator to change while the data does not.
 * This can happen, for example, if the iterator produced from an RPC to the server, and that
 * RPC is re-run. Even if the data hasn't changed, the second response will produce objects with
 * different identities, and Angular will tear down the entire DOM and rebuild it (as if all old
 * elements were deleted and all new elements inserted). This is an expensive operation and should
 * be avoided if possible.
 *
 * To customize the default tracking algorithm, `NgFor` supports `trackBy` option.
 * `trackBy` takes a function which has two arguments: `index` and `item`.
 * If `trackBy` is given, Angular tracks changes by the return value of the function.
 *
 * ### Syntax
 *
 * - `<li *ngFor="let item of items; let i = index; trackBy: trackByFn">...</li>`
 * - `<li template="ngFor let item of items; let i = index; trackBy: trackByFn">...</li>`
 *
 * With `<template>` element:
 *
 * ```
 * <template ngFor let-item [ngForOf]="items" let-i="index" [ngForTrackBy]="trackByFn">
 *   <li>...</li>
 * </template>
 * ```
 *
 * ### Example
 *
 * See a [live demo](http://plnkr.co/edit/KVuXxDp0qinGDyo307QW?p=preview) for a more detailed
 * example.
 *
 * @stable
 */
var NgFor = (function () {
    function NgFor(_viewContainer, _template, _differs, _cdr) {
        this._viewContainer = _viewContainer;
        this._template = _template;
        this._differs = _differs;
        this._cdr = _cdr;
        this._differ = null;
    }
    Object.defineProperty(NgFor.prototype, "ngForTemplate", {
        set: function (value) {
            if (value) {
                this._template = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    NgFor.prototype.ngOnChanges = function (changes) {
        if ('ngForOf' in changes) {
            // React on ngForOf changes only once all inputs have been initialized
            var value = changes['ngForOf'].currentValue;
            if (!this._differ && value) {
                try {
                    this._differ = this._differs.find(value).create(this._cdr, this.ngForTrackBy);
                }
                catch (e) {
                    throw new Error("Cannot find a differ supporting object '" + value + "' of type '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["j" /* getTypeNameForDebugging */])(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
                }
            }
        }
    };
    NgFor.prototype.ngDoCheck = function () {
        if (this._differ) {
            var changes = this._differ.diff(this.ngForOf);
            if (changes)
                this._applyChanges(changes);
        }
    };
    NgFor.prototype._applyChanges = function (changes) {
        var _this = this;
        var insertTuples = [];
        changes.forEachOperation(function (item, adjustedPreviousIndex, currentIndex) {
            if (item.previousIndex == null) {
                var view = _this._viewContainer.createEmbeddedView(_this._template, new NgForRow(null, null, null), currentIndex);
                var tuple = new RecordViewTuple(item, view);
                insertTuples.push(tuple);
            }
            else if (currentIndex == null) {
                _this._viewContainer.remove(adjustedPreviousIndex);
            }
            else {
                var view = _this._viewContainer.get(adjustedPreviousIndex);
                _this._viewContainer.move(view, currentIndex);
                var tuple = new RecordViewTuple(item, view);
                insertTuples.push(tuple);
            }
        });
        for (var i = 0; i < insertTuples.length; i++) {
            this._perViewChange(insertTuples[i].view, insertTuples[i].record);
        }
        for (var i = 0, ilen = this._viewContainer.length; i < ilen; i++) {
            var viewRef = this._viewContainer.get(i);
            viewRef.context.index = i;
            viewRef.context.count = ilen;
        }
        changes.forEachIdentityChange(function (record) {
            var viewRef = _this._viewContainer.get(record.currentIndex);
            viewRef.context.$implicit = record.item;
        });
    };
    NgFor.prototype._perViewChange = function (view, record) {
        view.context.$implicit = record.item;
    };
    NgFor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngFor][ngForOf]' },] },
    ];
    /** @nocollapse */
    NgFor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ];
    NgFor.propDecorators = {
        'ngForOf': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ngForTrackBy': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ngForTemplate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgFor;
}());
var RecordViewTuple = (function () {
    function RecordViewTuple(record, view) {
        this.record = record;
        this.view = view;
    }
    return RecordViewTuple;
}());
//# sourceMappingURL=ng_for.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(19);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgIf = (function () {
    function Wrapper_NgIf(p0, p1) {
        this.changed = false;
        this.context = new import0.NgIf(p0, p1);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_NgIf.prototype.check_ngIf = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngIf = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgIf.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgIf.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgIf;
}());
exports.Wrapper_NgIf = Wrapper_NgIf;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_location__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_localization__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_common_module__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_directives_index__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__ = __webpack_require__(257);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PlatformLocation", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "LocationStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "APP_BASE_HREF", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Location", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HashLocationStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PathLocationStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_location__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgLocalization", function() { return __WEBPACK_IMPORTED_MODULE_1__src_localization__["NgLocalization"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CommonModule", function() { return __WEBPACK_IMPORTED_MODULE_2__src_common_module__["CommonModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgClass", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgFor", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgIf", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgPlural", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgPluralCase", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgStyle", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSwitch", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSwitchCase", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSwitchDefault", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgTemplateOutlet", function() { return __WEBPACK_IMPORTED_MODULE_3__src_directives_index__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "LowerCasePipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DatePipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "I18nPluralPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "I18nSelectPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "JsonPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AsyncPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CurrencyPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DecimalPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PercentPipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SlicePipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "UpperCasePipe", function() { return __WEBPACK_IMPORTED_MODULE_4__src_pipes_index__["l"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(21);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgFor = (function () {
    function Wrapper_NgFor(p0, p1, p2, p3) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.NgFor(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
    }
    Wrapper_NgFor.prototype.check_ngForOf = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngForOf = currValue;
            this.changes['ngForOf'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgFor.prototype.check_ngForTrackBy = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.ngForTrackBy = currValue;
            this.changes['ngForTrackBy'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_NgFor.prototype.check_ngForTemplate = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.ngForTemplate = currValue;
            this.changes['ngForTemplate'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_NgFor.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
            this.context.ngDoCheck();
        }
        return changed;
    };
    Wrapper_NgFor.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgFor;
}());
exports.Wrapper_NgFor = Wrapper_NgFor;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var angular2_meta_1 = __webpack_require__(149);
var MetaService = (function () {
    function MetaService(meta) {
        this.meta = meta;
    }
    MetaService.prototype.setMeta = function (title, description, keywords) {
        this.meta.setTitle(title);
        this.meta.updateMeta('description', description);
        this.meta.updateMeta('keywords', keywords);
    };
    MetaService.prototype.setLanguage = function (lang) {
        this.meta.setLanguage(lang);
    };
    MetaService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof angular2_meta_1.Meta !== 'undefined' && angular2_meta_1.Meta) === 'function' && _a) || Object])
    ], MetaService);
    return MetaService;
    var _a;
}());
exports.MetaService = MetaService;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "NG_VALUE_ACCESSOR", function() { return NG_VALUE_ACCESSOR; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var browserUniversal = __webpack_require__(292);
__export(__webpack_require__(292));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = browserUniversal;
//# sourceMappingURL=index.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(199);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgControl", function() { return NgControl; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * @stable
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        _super.apply(this, arguments);
        /** @internal */
        this._parent = null;
        this.name = null;
        this.valueAccessor = null;
        /** @internal */
        this._rawValidators = [];
        /** @internal */
        this._rawAsyncValidators = [];
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    return NgControl;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
//# sourceMappingURL=ng_control.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
__webpack_require__(241);
__webpack_require__(122);
var ElasticSearchService = (function () {
    function ElasticSearchService(http) {
        this.http = http;
        this.clearSearchBox = false;
        this.query_search_all = {
            _source: false,
            sort: ["_score", { date: { order: "desc" } }],
            query: { bool: {
                    must: { match_all: {} },
                    filter: []
                } }
        };
        this.query_search_all_nosort = {
            _source: false,
            query: { bool: {
                    must: { match_all: {} },
                    filter: []
                } }
        };
        // Initial default query
        this.queryInit();
    }
    ElasticSearchService.prototype.queryInit = function () {
        this.searchQuery = this.query_search_all;
    };
    ElasticSearchService.prototype.addFilterActive = function (filters, val) {
        filters.push({
            term: { active: val }
        });
    };
    ElasticSearchService.prototype.setAggregationQueryString = function (fields) {
        this.queryPart_agg = this.buildQuery_agg(fields, 10);
        this.searchQuery['aggregations'] = this.queryPart_agg;
    };
    ElasticSearchService.prototype.buildQuery_agg = function (fields, limit) {
        var query = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var f = fields_1[_i];
            query[f] = { terms: {} };
            query[f]['terms'] = { field: f + '.raw', size: limit };
        }
        return query;
    };
    ElasticSearchService.prototype.handleError = function (error) {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    };
    ElasticSearchService.prototype.setFilterQueryString = function (esFilters) {
        this.searchQuery.query.bool.filter = esFilters;
    };
    ElasticSearchService.prototype.setPaginationQueryString = function (from, size) {
        if (from == null)
            delete this.searchQuery.from;
        else
            this.searchQuery.from = from;
        if (size == null)
            delete this.searchQuery.size;
        else
            this.searchQuery.size = size;
    };
    ElasticSearchService.prototype.clearSearchQueryString = function () {
        this.searchQuery.query.bool.must = { match_all: {} };
    };
    ElasticSearchService.prototype.setSearchQueryString = function (fields, queryString) {
        this.queryInit();
        // operator: "and",
        this.searchQuery.query.bool.must = {
            multi_match: {
                query: queryString,
                fields: fields,
                fuzziness: 0
            }
        };
        this.searchQuery['aggregations'] = this.queryPart_agg;
    };
    // target format: {type1: [{name: name1, freq: 2}]} 
    ElasticSearchService.prototype.formatSuggestions = function (suggestions) {
        // Compute freq
        var formated = {};
        for (var type in suggestions) {
            formated[type] = {};
            for (var _i = 0, _a = suggestions[type][0].options; _i < _a.length; _i++) {
                var s = _a[_i];
                if (!formated[type][s.text])
                    formated[type][s.text] = 1;
                else
                    formated[type][s.text] = formated[type][s.text] + 1;
            }
        }
        // Format in an ordered array of objects
        var sorted = {};
        for (var type in formated) {
            sorted[type] = [];
            for (var e in formated[type]) {
                sorted[type].push({ name: e, freq: formated[type][e] });
            }
            sorted[type].sort(function (obj1, obj2) {
                return obj2.freq - obj1.freq;
            });
        }
        return sorted;
    };
    ElasticSearchService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ElasticSearchService);
    return ElasticSearchService;
    var _a;
}());
exports.ElasticSearchService = ElasticSearchService;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
__webpack_require__(122);
var search_elasticsearch_service_1 = __webpack_require__(29);
var SearchService = (function () {
    function SearchService(http, es) {
        this.http = http;
        this.es = es;
        this.baseUrl = '/api/content/';
        this.headers = new http_1.Headers({ 'Content-Type': 'application/json' });
        this.options = new http_1.RequestOptions({ headers: this.headers });
    }
    SearchService.prototype.search = function (type, query) {
        return this.http.post('/api/index/' + type + '/search', query, this.options)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    SearchService.prototype.suggest = function (type, term) {
        // /api/index/record/suggest/fr/moza
        return this.http.get('/api/index/' + type + '/suggest/' + term)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    SearchService.prototype.mlt = function (type, id) {
        // /api/index/record/mlt/595805ba0de2df2fd87fdf24
        return this.http.get('/api/index/' + type + '/mlt/' + id)
            .toPromise()
            .then(function (response) {
            return response.json();
        });
    };
    SearchService.prototype.autocomplete = function (type, field, input) {
        var _this = this;
        // /api/index/record/suggest/fr/moza
        return this.http.get('/api/index/' + type + '/autocomplete/' + field + '/' + input)
            .toPromise()
            .then(function (response) {
            return _this.es.formatSuggestions(response.json().suggest);
        });
    };
    SearchService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _b) || Object])
    ], SearchService);
    return SearchService;
    var _a, _b;
}());
exports.SearchService = SearchService;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "SecurityContext", function() { return SecurityContext; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Sanitizer", function() { return Sanitizer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A SecurityContext marks a location that has dangerous security implications, e.g. a DOM property
 * like `innerHTML` that could cause Cross Site Scripting (XSS) security bugs when improperly
 * handled.
 *
 * See DomSanitizer for more details on security in Angular applications.
 *
 * @stable
 */
var SecurityContext;
(function (SecurityContext) {
    SecurityContext[SecurityContext["NONE"] = 0] = "NONE";
    SecurityContext[SecurityContext["HTML"] = 1] = "HTML";
    SecurityContext[SecurityContext["STYLE"] = 2] = "STYLE";
    SecurityContext[SecurityContext["SCRIPT"] = 3] = "SCRIPT";
    SecurityContext[SecurityContext["URL"] = 4] = "URL";
    SecurityContext[SecurityContext["RESOURCE_URL"] = 5] = "RESOURCE_URL";
})(SecurityContext || (SecurityContext = {}));
/**
 * Sanitizer is used by the views to sanitize potentially dangerous values.
 *
 * @stable
 */
var Sanitizer = (function () {
    function Sanitizer() {
    }
    return Sanitizer;
}());
//# sourceMappingURL=security.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_strategy__ = __webpack_require__(88);
/* harmony export (binding) */ __webpack_require__.d(exports, "Location", function() { return Location; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * `Location` is a service that applications can use to interact with a browser's URL.
 * Depending on which {@link LocationStrategy} is used, `Location` will either persist
 * to the URL's path or the URL's hash segment.
 *
 * Note: it's better to use {@link Router#navigate} service to trigger route changes. Use
 * `Location` only if you need to interact with or create normalized URLs outside of
 * routing.
 *
 * `Location` is responsible for normalizing the URL against the application's base href.
 * A normalized URL is absolute from the URL host, includes the application's base href, and has no
 * trailing slash:
 * - `/my/app/user/123` is normalized
 * - `my/app/user/123` **is not** normalized
 * - `/my/app/user/123/` **is not** normalized
 *
 * ### Example
 *
 * ```
 * import {Component} from '@angular/core';
 * import {Location} from '@angular/common';
 *
 * @Component({selector: 'app-component'})
 * class AppCmp {
 *   constructor(location: Location) {
 *     location.go('/foo');
 *   }
 * }
 * ```
 *
 * @stable
 */
var Location = (function () {
    function Location(platformStrategy) {
        var _this = this;
        /** @internal */
        this._subject = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._platformStrategy = platformStrategy;
        var browserBaseHref = this._platformStrategy.getBaseHref();
        this._baseHref = Location.stripTrailingSlash(_stripIndexHtml(browserBaseHref));
        this._platformStrategy.onPopState(function (ev) {
            _this._subject.emit({
                'url': _this.path(true),
                'pop': true,
                'type': ev.type,
            });
        });
    }
    /**
     * Returns the normalized URL path.
     */
    // TODO: vsavkin. Remove the boolean flag and always include hash once the deprecated router is
    // removed.
    Location.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        return this.normalize(this._platformStrategy.path(includeHash));
    };
    /**
     * Normalizes the given path and compares to the current normalized path.
     */
    Location.prototype.isCurrentPathEqualTo = function (path, query) {
        if (query === void 0) { query = ''; }
        return this.path() == this.normalize(path + Location.normalizeQueryParams(query));
    };
    /**
     * Given a string representing a URL, returns the normalized URL path without leading or
     * trailing slashes.
     */
    Location.prototype.normalize = function (url) {
        return Location.stripTrailingSlash(_stripBaseHref(this._baseHref, _stripIndexHtml(url)));
    };
    /**
     * Given a string representing a URL, returns the platform-specific external URL path.
     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
     */
    Location.prototype.prepareExternalUrl = function (url) {
        if (url.length > 0 && !url.startsWith('/')) {
            url = '/' + url;
        }
        return this._platformStrategy.prepareExternalUrl(url);
    };
    // TODO: rename this method to pushState
    /**
     * Changes the browsers URL to the normalized version of the given URL, and pushes a
     * new item onto the platform's history.
     */
    Location.prototype.go = function (path, query) {
        if (query === void 0) { query = ''; }
        this._platformStrategy.pushState(null, '', path, query);
    };
    /**
     * Changes the browsers URL to the normalized version of the given URL, and replaces
     * the top item on the platform's history stack.
     */
    Location.prototype.replaceState = function (path, query) {
        if (query === void 0) { query = ''; }
        this._platformStrategy.replaceState(null, '', path, query);
    };
    /**
     * Navigates forward in the platform's history.
     */
    Location.prototype.forward = function () { this._platformStrategy.forward(); };
    /**
     * Navigates back in the platform's history.
     */
    Location.prototype.back = function () { this._platformStrategy.back(); };
    /**
     * Subscribe to the platform's `popState` events.
     */
    Location.prototype.subscribe = function (onNext, onThrow, onReturn) {
        if (onThrow === void 0) { onThrow = null; }
        if (onReturn === void 0) { onReturn = null; }
        return this._subject.subscribe({ next: onNext, error: onThrow, complete: onReturn });
    };
    /**
     * Given a string of url parameters, prepend with '?' if needed, otherwise return parameters as
     * is.
     */
    Location.normalizeQueryParams = function (params) {
        return (params.length > 0 && params.substring(0, 1) != '?') ? ('?' + params) : params;
    };
    /**
     * Given 2 parts of a url, join them with a slash if needed.
     */
    Location.joinWithSlash = function (start, end) {
        if (start.length == 0) {
            return end;
        }
        if (end.length == 0) {
            return start;
        }
        var slashes = 0;
        if (start.endsWith('/')) {
            slashes++;
        }
        if (end.startsWith('/')) {
            slashes++;
        }
        if (slashes == 2) {
            return start + end.substring(1);
        }
        if (slashes == 1) {
            return start + end;
        }
        return start + '/' + end;
    };
    /**
     * If url has a trailing slash, remove it, otherwise return url as is.
     */
    Location.stripTrailingSlash = function (url) {
        if (/\/$/g.test(url)) {
            url = url.substring(0, url.length - 1);
        }
        return url;
    };
    Location.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Location.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__location_strategy__["LocationStrategy"], },
    ];
    return Location;
}());
function _stripBaseHref(baseHref, url) {
    if (baseHref.length > 0 && url.startsWith(baseHref)) {
        return url.substring(baseHref.length);
    }
    return url;
}
function _stripIndexHtml(url) {
    if (/\/index.html$/g.test(url)) {
        // '/index.html'.length == 11
        return url.substring(0, url.length - 11);
    }
    return url;
}
//# sourceMappingURL=location.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng_control__ = __webpack_require__(28);
/* harmony export (binding) */ __webpack_require__.d(exports, "AbstractControlStatus", function() { return AbstractControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ngControlStatusHost", function() { return ngControlStatusHost; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgControlStatus", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return NgControlStatusGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




var AbstractControlStatus = (function () {
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.untouched : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.touched : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.pristine : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.dirty : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.valid : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._cd.control) ? this._cd.control.invalid : false;
        },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid'
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * @stable
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    function NgControlStatus(cd) {
        _super.call(this, cd);
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__ng_control__["NgControl"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ];
    return NgControlStatus;
}(AbstractControlStatus));
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * @stable
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    function NgControlStatusGroup(cd) {
        _super.call(this, cd);
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ];
    return NgControlStatusGroup;
}(AbstractControlStatus));
//# sourceMappingURL=ng_control_status.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["getDOM"] = getDOM;
/* harmony export (immutable) */ exports["setDOM"] = setDOM;
/* harmony export (immutable) */ exports["setRootDomAdapter"] = setRootDomAdapter;
/* harmony export (binding) */ __webpack_require__.d(exports, "DomAdapter", function() { return DomAdapter; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _DOM = null;
function getDOM() {
    return _DOM;
}
function setDOM(adapter) {
    _DOM = adapter;
}
function setRootDomAdapter(adapter) {
    if (!_DOM) {
        _DOM = adapter;
    }
}
/* tslint:disable:requireParameterType */
/**
 * Provides DOM operations in an environment-agnostic way.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
var DomAdapter = (function () {
    function DomAdapter() {
        this.resourceLoaderType = null;
    }
    Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
        /**
         * Maps attribute names to their corresponding property names for cases
         * where attribute name doesn't match property name.
         */
        get: function () { return this._attrToPropMap; },
        set: function (value) { this._attrToPropMap = value; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    return DomAdapter;
}());
//# sourceMappingURL=dom_adapter.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(336);
var Subscription_1 = __webpack_require__(99);
var Observer_1 = __webpack_require__(322);
var rxSubscriber_1 = __webpack_require__(248);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.$$rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parent, observerOrNext, error, complete) {
        _super.call(this);
        this._parent = _parent;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            context = observerOrNext;
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (isFunction_1.isFunction(context.unsubscribe)) {
                this.add(context.unsubscribe.bind(context));
            }
            context.unsubscribe = this.unsubscribe.bind(this);
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parent = this._parent;
            if (!_parent.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parent, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parent = this._parent;
            if (this._error) {
                if (!_parent.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parent, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parent.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parent.syncErrorValue = err;
                _parent.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _parent = this._parent;
            if (this._complete) {
                if (!_parent.syncErrorThrowable) {
                    this.__tryOrUnsub(this._complete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parent, this._complete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parent = this._parent;
        this._context = null;
        this._parent = null;
        _parent.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return MapWrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return StringMapWrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return ListWrapper; });
/* harmony export (immutable) */ exports["b"] = isListLikeIterable;
/* harmony export (immutable) */ exports["d"] = areIterablesEqual;
/* harmony export (immutable) */ exports["c"] = iterateListLike;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// Safari doesn't implement MapIterator.next(), which is used is Traceur's polyfill of Array.from
// TODO(mlaval): remove the work around once we have a working polyfill of Array.from
var _arrayFromMap = (function () {
    try {
        if ((new Map()).values().next) {
            return function createArrayFromMap(m, getValues) {
                return getValues ? Array.from(m.values()) : Array.from(m.keys());
            };
        }
    }
    catch (e) {
    }
    return function createArrayFromMapWithForeach(m, getValues) {
        var res = new Array(m.size), i = 0;
        m.forEach(function (v, k) {
            res[i] = getValues ? v : k;
            i++;
        });
        return res;
    };
})();
var MapWrapper = (function () {
    function MapWrapper() {
    }
    MapWrapper.createFromStringMap = function (stringMap) {
        var result = new Map();
        for (var prop in stringMap) {
            result.set(prop, stringMap[prop]);
        }
        return result;
    };
    MapWrapper.keys = function (m) { return _arrayFromMap(m, false); };
    MapWrapper.values = function (m) { return _arrayFromMap(m, true); };
    return MapWrapper;
}());
/**
 * Wraps Javascript Objects
 */
var StringMapWrapper = (function () {
    function StringMapWrapper() {
    }
    StringMapWrapper.merge = function (m1, m2) {
        var m = {};
        for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
            var k = _a[_i];
            m[k] = m1[k];
        }
        for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
            var k = _c[_b];
            m[k] = m2[k];
        }
        return m;
    };
    StringMapWrapper.equals = function (m1, m2) {
        var k1 = Object.keys(m1);
        var k2 = Object.keys(m2);
        if (k1.length != k2.length) {
            return false;
        }
        for (var i = 0; i < k1.length; i++) {
            var key = k1[i];
            if (m1[key] !== m2[key]) {
                return false;
            }
        }
        return true;
    };
    return StringMapWrapper;
}());
var ListWrapper = (function () {
    function ListWrapper() {
    }
    ListWrapper.removeAll = function (list, items) {
        for (var i = 0; i < items.length; ++i) {
            var index = list.indexOf(items[i]);
            list.splice(index, 1);
        }
    };
    ListWrapper.remove = function (list, el) {
        var index = list.indexOf(el);
        if (index > -1) {
            list.splice(index, 1);
            return true;
        }
        return false;
    };
    ListWrapper.equals = function (a, b) {
        if (a.length != b.length)
            return false;
        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    };
    ListWrapper.maximum = function (list, predicate) {
        if (list.length == 0) {
            return null;
        }
        var solution = null;
        var maxValue = -Infinity;
        for (var index = 0; index < list.length; index++) {
            var candidate = list[index];
            if (candidate == null) {
                continue;
            }
            var candidateValue = predicate(candidate);
            if (candidateValue > maxValue) {
                solution = candidate;
                maxValue = candidateValue;
            }
        }
        return solution;
    };
    ListWrapper.flatten = function (list) {
        var target = [];
        _flattenArray(list, target);
        return target;
    };
    return ListWrapper;
}());
function _flattenArray(source, target) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["d" /* isPresent */])(source)) {
        for (var i = 0; i < source.length; i++) {
            var item = source[i];
            if (Array.isArray(item)) {
                _flattenArray(item, target);
            }
            else {
                target.push(item);
            }
        }
    }
    return target;
}
function isListLikeIterable(obj) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["e" /* isJsObject */])(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) &&
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["f" /* getSymbolIterator */])() in obj); // JS Iterable have a Symbol.iterator prop
}
function areIterablesEqual(a, b, comparator) {
    var iterator1 = a[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["f" /* getSymbolIterator */])()]();
    var iterator2 = b[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["f" /* getSymbolIterator */])()]();
    while (true) {
        var item1 = iterator1.next();
        var item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var iterator = obj[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["f" /* getSymbolIterator */])()]();
        var item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
//# sourceMappingURL=collection.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(199);
/* harmony export (binding) */ __webpack_require__.d(exports, "ControlContainer", function() { return ControlContainer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * A directive that contains multiple {@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * @stable
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        _super.apply(this, arguments);
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
//# sourceMappingURL=control_container.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__ = __webpack_require__(189);
/* harmony export (binding) */ __webpack_require__.d(exports, "LOCALE_ID", function() { return LOCALE_ID; });
/* harmony export (binding) */ __webpack_require__.d(exports, "TRANSLATIONS", function() { return TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "TRANSLATIONS_FORMAT", function() { return TRANSLATIONS_FORMAT; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @experimental i18n support is experimental.
 */
var LOCALE_ID = new __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__["a" /* OpaqueToken */]('LocaleId');
/**
 * @experimental i18n support is experimental.
 */
var TRANSLATIONS = new __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__["a" /* OpaqueToken */]('Translations');
/**
 * @experimental i18n support is experimental.
 */
var TRANSLATIONS_FORMAT = new __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__["a" /* OpaqueToken */]('TranslationsFormat');
//# sourceMappingURL=tokens.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony export (binding) */ __webpack_require__.d(exports, "SwitchView", function() { return SwitchView; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgSwitch", function() { return NgSwitch; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgSwitchCase", function() { return NgSwitchCase; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgSwitchDefault", function() { return NgSwitchDefault; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var _CASE_DEFAULT = {};
var SwitchView = (function () {
    function SwitchView(_viewContainerRef, _templateRef) {
        this._viewContainerRef = _viewContainerRef;
        this._templateRef = _templateRef;
    }
    SwitchView.prototype.create = function () { this._viewContainerRef.createEmbeddedView(this._templateRef); };
    SwitchView.prototype.destroy = function () { this._viewContainerRef.clear(); };
    return SwitchView;
}());
/**
 * @ngModule CommonModule
 *
 * @whatItDoes Adds / removes DOM sub-trees when the nest match expressions matches the switch
 *             expression.
 *
 * @howToUse
 * ```
 *     <container-element [ngSwitch]="switch_expression">
 *       <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *       <some-element *ngSwitchCase="match_expression_2">...</some-element>
 *       <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
 *       <ng-container *ngSwitchCase="match_expression_3">
 *         <!-- use a ng-container to group multiple root nodes -->
 *         <inner-element></inner-element>
 *         <inner-other-element></inner-other-element>
 *       </ng-container>
 *       <some-element *ngSwitchDefault>...</some-element>
 *     </container-element>
 * ```
 * @description
 *
 * `NgSwitch` stamps out nested views when their match expression value matches the value of the
 * switch expression.
 *
 * In other words:
 * - you define a container element (where you place the directive with a switch expression on the
 * `[ngSwitch]="..."` attribute)
 * - you define inner views inside the `NgSwitch` and place a `*ngSwitchCase` attribute on the view
 * root elements.
 *
 * Elements within `NgSwitch` but outside of a `NgSwitchCase` or `NgSwitchDefault` directives will
 * be preserved at the location.
 *
 * The `ngSwitchCase` directive informs the parent `NgSwitch` of which view to display when the
 * expression is evaluated.
 * When no matching expression is found on a `ngSwitchCase` view, the `ngSwitchDefault` view is
 * stamped out.
 *
 * @stable
 */
var NgSwitch = (function () {
    function NgSwitch() {
        this._useDefault = false;
        this._valueViews = new Map();
        this._activeViews = [];
    }
    Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
        set: function (value) {
            // Set of views to display for this value
            var views = this._valueViews.get(value);
            if (views) {
                this._useDefault = false;
            }
            else {
                // No view to display for the current value -> default case
                // Nothing to do if the default case was already active
                if (this._useDefault) {
                    return;
                }
                this._useDefault = true;
                views = this._valueViews.get(_CASE_DEFAULT);
            }
            this._emptyAllActiveViews();
            this._activateViews(views);
            this._switchValue = value;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSwitch.prototype._onCaseValueChanged = function (oldCase, newCase, view) {
        this._deregisterView(oldCase, view);
        this._registerView(newCase, view);
        if (oldCase === this._switchValue) {
            view.destroy();
            __WEBPACK_IMPORTED_MODULE_1__facade_collection__["e" /* ListWrapper */].remove(this._activeViews, view);
        }
        else if (newCase === this._switchValue) {
            if (this._useDefault) {
                this._useDefault = false;
                this._emptyAllActiveViews();
            }
            view.create();
            this._activeViews.push(view);
        }
        // Switch to default when there is no more active ViewContainers
        if (this._activeViews.length === 0 && !this._useDefault) {
            this._useDefault = true;
            this._activateViews(this._valueViews.get(_CASE_DEFAULT));
        }
    };
    NgSwitch.prototype._emptyAllActiveViews = function () {
        var activeContainers = this._activeViews;
        for (var i = 0; i < activeContainers.length; i++) {
            activeContainers[i].destroy();
        }
        this._activeViews = [];
    };
    NgSwitch.prototype._activateViews = function (views) {
        if (views) {
            for (var i = 0; i < views.length; i++) {
                views[i].create();
            }
            this._activeViews = views;
        }
    };
    /** @internal */
    NgSwitch.prototype._registerView = function (value, view) {
        var views = this._valueViews.get(value);
        if (!views) {
            views = [];
            this._valueViews.set(value, views);
        }
        views.push(view);
    };
    NgSwitch.prototype._deregisterView = function (value, view) {
        // `_CASE_DEFAULT` is used a marker for non-registered cases
        if (value === _CASE_DEFAULT)
            return;
        var views = this._valueViews.get(value);
        if (views.length == 1) {
            this._valueViews.delete(value);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1__facade_collection__["e" /* ListWrapper */].remove(views, view);
        }
    };
    NgSwitch.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitch]' },] },
    ];
    /** @nocollapse */
    NgSwitch.ctorParameters = [];
    NgSwitch.propDecorators = {
        'ngSwitch': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgSwitch;
}());
/**
 * @ngModule CommonModule
 *
 * @whatItDoes Creates a view that will be added/removed from the parent {@link NgSwitch} when the
 *             given expression evaluate to respectively the same/different value as the switch
 *             expression.
 *
 * @howToUse
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 * </container-element>
 *```
 * @description
 *
 * Insert the sub-tree when the expression evaluates to the same value as the enclosing switch
 * expression.
 *
 * If multiple match expressions match the switch expression value, all of them are displayed.
 *
 * See {@link NgSwitch} for more details and example.
 *
 * @stable
 */
var NgSwitchCase = (function () {
    function NgSwitchCase(viewContainer, templateRef, ngSwitch) {
        // `_CASE_DEFAULT` is used as a marker for a not yet initialized value
        this._value = _CASE_DEFAULT;
        this._switch = ngSwitch;
        this._view = new SwitchView(viewContainer, templateRef);
    }
    Object.defineProperty(NgSwitchCase.prototype, "ngSwitchCase", {
        set: function (value) {
            this._switch._onCaseValueChanged(this._value, value, this._view);
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    NgSwitchCase.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitchCase]' },] },
    ];
    /** @nocollapse */
    NgSwitchCase.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
        { type: NgSwitch, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    NgSwitchCase.propDecorators = {
        'ngSwitchCase': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgSwitchCase;
}());
/**
 * @ngModule CommonModule
 * @whatItDoes Creates a view that is added to the parent {@link NgSwitch} when no case expressions
 * match the
 *             switch expression.
 *
 * @howToUse
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *   <some-other-element *ngSwitchDefault>...</some-other-element>
 * </container-element>
 * ```
 *
 * @description
 *
 * Insert the sub-tree when no case expressions evaluate to the same value as the enclosing switch
 * expression.
 *
 * See {@link NgSwitch} for more details and example.
 *
 * @stable
 */
var NgSwitchDefault = (function () {
    function NgSwitchDefault(viewContainer, templateRef, sswitch) {
        sswitch._registerView(_CASE_DEFAULT, new SwitchView(viewContainer, templateRef));
    }
    NgSwitchDefault.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitchDefault]' },] },
    ];
    /** @nocollapse */
    NgSwitchDefault.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
        { type: NgSwitch, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    return NgSwitchDefault;
}());
//# sourceMappingURL=ng_switch.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "KeyValueDiffers", function() { return KeyValueDiffers; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
 * @stable
 */
var KeyValueDiffers = (function () {
    function KeyValueDiffers(factories) {
        this.factories = factories;
    }
    KeyValueDiffers.create = function (factories, parent) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parent)) {
            var copied = parent.factories.slice();
            factories = factories.concat(copied);
            return new KeyValueDiffers(factories);
        }
        else {
            return new KeyValueDiffers(factories);
        }
    };
    /**
     * Takes an array of {@link KeyValueDifferFactory} and returns a provider used to extend the
     * inherited {@link KeyValueDiffers} instance with the provided factories and return a new
     * {@link KeyValueDiffers} instance.
     *
     * The following example shows how to extend an existing list of factories,
           * which will only be applied to the injector for this component and its children.
           * This step is all that's required to make a new {@link KeyValueDiffer} available.
     *
     * ### Example
     *
     * ```
     * @Component({
     *   viewProviders: [
     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
     *   ]
     * })
     * ```
     */
    KeyValueDiffers.extend = function (factories) {
        return {
            provide: KeyValueDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
                    // to
                    // bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend KeyValueDiffers without a parent injector');
                }
                return KeyValueDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[KeyValueDiffers, new __WEBPACK_IMPORTED_MODULE_0__di__["e" /* SkipSelf */](), new __WEBPACK_IMPORTED_MODULE_0__di__["d" /* Optional */]()]]
        };
    };
    KeyValueDiffers.prototype.find = function (kv) {
        var factory = this.factories.find(function (f) { return f.supports(kv); });
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(factory)) {
            return factory;
        }
        else {
            throw new Error("Cannot find a differ supporting object '" + kv + "'");
        }
    };
    return KeyValueDiffers;
}());
//# sourceMappingURL=keyvalue_differs.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(exports, "CHECKBOX_VALUE_ACCESSOR", function() { return CHECKBOX_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return CheckboxControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var CHECKBOX_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  @stable
 */
var CheckboxControlValueAccessor = (function () {
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return CheckboxControlValueAccessor;
}());
//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = unimplemented;
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return BaseError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return WrappedError; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * @stable
 */
var BaseError = (function (_super) {
    __extends(BaseError, _super);
    function BaseError(message) {
        // Errors don't use current this, instead they create a new instance.
        // We have to do forward all of our api to the nativeInstance.
        var nativeError = _super.call(this, message);
        this._nativeError = nativeError;
    }
    Object.defineProperty(BaseError.prototype, "message", {
        get: function () { return this._nativeError.message; },
        set: function (message) { this._nativeError.message = message; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseError.prototype, "name", {
        get: function () { return this._nativeError.name; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseError.prototype, "stack", {
        get: function () { return this._nativeError.stack; },
        set: function (value) { this._nativeError.stack = value; },
        enumerable: true,
        configurable: true
    });
    BaseError.prototype.toString = function () { return this._nativeError.toString(); };
    return BaseError;
}(Error));
/**
 * @stable
 */
var WrappedError = (function (_super) {
    __extends(WrappedError, _super);
    function WrappedError(message, error) {
        _super.call(this, message + " caused by: " + (error instanceof Error ? error.message : error));
        this.originalError = error;
    }
    Object.defineProperty(WrappedError.prototype, "stack", {
        get: function () {
            return (this.originalError instanceof Error ? this.originalError : this._nativeError)
                .stack;
        },
        enumerable: true,
        configurable: true
    });
    return WrappedError;
}(BaseError));
//# sourceMappingURL=errors.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(33);
var import1 = __webpack_require__(4);
var import3 = __webpack_require__(3);
var Wrapper_NgControlStatus = (function () {
    function Wrapper_NgControlStatus(p0) {
        this.changed = false;
        this.context = new import0.NgControlStatus(p0);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_NgControlStatus.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgControlStatus.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_0 = this.context.ngClassUntouched;
        if (import3.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'ng-untouched', currVal_0);
            this._expr_0 = currVal_0;
        }
        var currVal_1 = this.context.ngClassTouched;
        if (import3.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementClass(el, 'ng-touched', currVal_1);
            this._expr_1 = currVal_1;
        }
        var currVal_2 = this.context.ngClassPristine;
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            view.renderer.setElementClass(el, 'ng-pristine', currVal_2);
            this._expr_2 = currVal_2;
        }
        var currVal_3 = this.context.ngClassDirty;
        if (import3.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementClass(el, 'ng-dirty', currVal_3);
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context.ngClassValid;
        if (import3.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementClass(el, 'ng-valid', currVal_4);
            this._expr_4 = currVal_4;
        }
        var currVal_5 = this.context.ngClassInvalid;
        if (import3.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementClass(el, 'ng-invalid', currVal_5);
            this._expr_5 = currVal_5;
        }
    };
    return Wrapper_NgControlStatus;
}());
exports.Wrapper_NgControlStatus = Wrapper_NgControlStatus;
var Wrapper_NgControlStatusGroup = (function () {
    function Wrapper_NgControlStatusGroup(p0) {
        this.changed = false;
        this.context = new import0.NgControlStatusGroup(p0);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_NgControlStatusGroup.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgControlStatusGroup.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_0 = this.context.ngClassUntouched;
        if (import3.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'ng-untouched', currVal_0);
            this._expr_0 = currVal_0;
        }
        var currVal_1 = this.context.ngClassTouched;
        if (import3.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementClass(el, 'ng-touched', currVal_1);
            this._expr_1 = currVal_1;
        }
        var currVal_2 = this.context.ngClassPristine;
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            view.renderer.setElementClass(el, 'ng-pristine', currVal_2);
            this._expr_2 = currVal_2;
        }
        var currVal_3 = this.context.ngClassDirty;
        if (import3.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementClass(el, 'ng-dirty', currVal_3);
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context.ngClassValid;
        if (import3.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementClass(el, 'ng-valid', currVal_4);
            this._expr_4 = currVal_4;
        }
        var currVal_5 = this.context.ngClassInvalid;
        if (import3.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementClass(el, 'ng-invalid', currVal_5);
            this._expr_5 = currVal_5;
        }
    };
    return Wrapper_NgControlStatusGroup;
}());
exports.Wrapper_NgControlStatusGroup = Wrapper_NgControlStatusGroup;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
/**
 * Created by colinjlacy on 4/14/16.
 */
var core_1 = __webpack_require__(0);
var angular2_universal_1 = __webpack_require__(27);
var LoadingIndicator = (function () {
    function LoadingIndicator() {
        this.type = 'spinner';
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], LoadingIndicator.prototype, "color", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], LoadingIndicator.prototype, "type", void 0);
    LoadingIndicator = __decorate([
        core_1.Component({
            selector: 'loading-indicator',
            template: "\n        <div [ngSwitch]=\"type\">\n            <div *ngSwitchCase=\"'spinner'\" class=\"spinner\">\n                <div [ngStyle]=\"{'background-color': color}\" class=\"rect1\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"rect2\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"rect3\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"rect4\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"rect5\"></div>\n            </div>\n            <div *ngSwitchCase=\"'cube'\" class=\"sk-cube-grid\">\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube1\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube2\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube3\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube4\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube5\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube6\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube7\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube8\"></div>\n                <div [ngStyle]=\"{'background-color': color}\" class=\"sk-cube sk-cube9\"></div>\n            </div>\n        </div>\n        ",
            styles: [__webpack_require__(503)]
        }), 
        __metadata('design:paramtypes', [])
    ], LoadingIndicator);
    return LoadingIndicator;
}());
exports.LoadingIndicator = LoadingIndicator;
var LoadingPage = (function () {
    function LoadingPage(val) {
        this.loading = val;
    }
    LoadingPage.prototype.standby = function () {
        this.loading = true;
    };
    LoadingPage.prototype.ready = function () {
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
        this.loading = false;
    };
    return LoadingPage;
}());
exports.LoadingPage = LoadingPage;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var NotificationService = (function () {
    function NotificationService(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.isDelayed = true;
        this.delay = 3000;
    }
    NotificationService.prototype.notify = function (text) {
        var _this = this;
        var e = this.el.nativeElement.querySelector('#snackbar');
        this.renderer.setElementClass(e, 'show', true);
        this.renderer.setText(e, text);
        if (this.isDelayed) {
            setTimeout(function () {
                _this.renderer.setElementClass(e, 'show', false);
            }, this.delay);
        }
    };
    NotificationService.prototype.setNoDelay = function () {
        this.isDelayed = false;
    };
    NotificationService.prototype.setDelay = function (val) {
        this.isDelayed = true;
        if (val)
            this.delay = val;
    };
    NotificationService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object, (typeof (_b = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _b) || Object])
    ], NotificationService);
    return NotificationService;
    var _a, _b;
}());
exports.NotificationService = NotificationService;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_intl__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "DatePipe", function() { return DatePipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * @ngModule CommonModule
 * @whatItDoes Formats a date according to locale rules.
 * @howToUse `date_expression | date[:format]`
 * @description
 *
 * Where:
 * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
 * (https://www.w3.org/TR/NOTE-datetime).
 * - `format` indicates which date/time components to include. The format can be predifined as
 *   shown below or custom as shown in the table.
 *   - `'medium'`: equivalent to `'yMMMdjms'` (e.g. `Sep 3, 2010, 12:05:08 PM` for `en-US`)
 *   - `'short'`: equivalent to `'yMdjm'` (e.g. `9/3/2010, 12:05 PM` for `en-US`)
 *   - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. `Friday, September 3, 2010` for `en-US`)
 *   - `'longDate'`: equivalent to `'yMMMMd'` (e.g. `September 3, 2010` for `en-US`)
 *   - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. `Sep 3, 2010` for `en-US`)
 *   - `'shortDate'`: equivalent to `'yMd'` (e.g. `9/3/2010` for `en-US`)
 *   - `'mediumTime'`: equivalent to `'jms'` (e.g. `12:05:08 PM` for `en-US`)
 *   - `'shortTime'`: equivalent to `'jm'` (e.g. `12:05 PM` for `en-US`)
 *
 *
 *  | Component | Symbol | Short Form   | Long Form         | Numeric   | 2-digit   |
 *  |-----------|:------:|--------------|-------------------|-----------|-----------|
 *  | era       |   G    | G (AD)       | GGGG (Anno Domini)| -         | -         |
 *  | year      |   y    | -            | -                 | y (2015)  | yy (15)   |
 *  | month     |   M    | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
 *  | day       |   d    | -            | -                 | d (3)     | dd (03)   |
 *  | weekday   |   E    | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
 *  | hour      |   j    | -            | -                 | j (13)    | jj (13)   |
 *  | hour12    |   h    | -            | -                 | h (1 PM)  | hh (01 PM)|
 *  | hour24    |   H    | -            | -                 | H (13)    | HH (13)   |
 *  | minute    |   m    | -            | -                 | m (5)     | mm (05)   |
 *  | second    |   s    | -            | -                 | s (9)     | ss (09)   |
 *  | timezone  |   z    | -            | z (Pacific Standard Time)| -  | -         |
 *  | timezone  |   Z    | Z (GMT-8:00) | -                 | -         | -         |
 *  | timezone  |   a    | a (PM)       | -                 | -         | -         |
 *
 * In javascript, only the components specified will be respected (not the ordering,
 * punctuations, ...) and details of the formatting will be dependent on the locale.
 *
 * Timezone of the formatted text will be the local system timezone of the end-user's machine.
 *
 * WARNINGS:
 * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
 *   Instead users should treat the date as an immutable object and change the reference when the
 *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
 *   which would be an expensive operation).
 * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
 *   browsers.
 *
 * ### Examples
 *
 * Assuming `dateObj` is (year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11)
 * in the _local_ time and locale is 'en-US':
 *
 * ```
 *     {{ dateObj | date }}               // output is 'Jun 15, 2015'
 *     {{ dateObj | date:'medium' }}      // output is 'Jun 15, 2015, 9:43:11 PM'
 *     {{ dateObj | date:'shortTime' }}   // output is '9:43 PM'
 *     {{ dateObj | date:'mmss' }}        // output is '43:11'
 * ```
 *
 * {@example common/pipes/ts/date_pipe.ts region='DatePipe'}
 *
 * @stable
 */
var DatePipe = (function () {
    function DatePipe(_locale) {
        this._locale = _locale;
    }
    DatePipe.prototype.transform = function (value, pattern) {
        if (pattern === void 0) { pattern = 'mediumDate'; }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["c" /* isBlank */])(value))
            return null;
        if (!this.supports(value)) {
            throw new __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](DatePipe, value);
        }
        if (__WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].isNumeric(value)) {
            value = parseFloat(value);
        }
        return __WEBPACK_IMPORTED_MODULE_1__facade_intl__["a" /* DateFormatter */].format(new Date(value), this._locale, DatePipe._ALIASES[pattern] || pattern);
    };
    DatePipe.prototype.supports = function (obj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["n" /* isDate */])(obj) || __WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].isNumeric(obj) ||
            (typeof obj === 'string' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["n" /* isDate */])(new Date(obj)));
    };
    /** @internal */
    DatePipe._ALIASES = {
        'medium': 'yMMMdjms',
        'short': 'yMdjm',
        'fullDate': 'yMMMMEEEEd',
        'longDate': 'yMMMMd',
        'mediumDate': 'yMMMd',
        'shortDate': 'yMd',
        'mediumTime': 'jms',
        'shortTime': 'jm'
    };
    DatePipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'date', pure: true },] },
    ];
    /** @nocollapse */
    DatePipe.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
    ];
    return DatePipe;
}());
//# sourceMappingURL=date_pipe.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(exports, "DEFAULT_VALUE_ACCESSOR", function() { return DEFAULT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return DefaultValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var DEFAULT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  @stable
 */
var DefaultValueAccessor = (function () {
    function DefaultValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var normalizedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value) ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngControl],[ngModel],[ngFormControl]',
                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return DefaultValueAccessor;
}());
//# sourceMappingURL=default_value_accessor.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__control_value_accessor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ng_control__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ng_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ng_model_group__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__ = __webpack_require__(278);
/* harmony export (binding) */ __webpack_require__.d(exports, "formControlBinding", function() { return formControlBinding; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgModel", function() { return NgModel; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};












var formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_7__ng_control__["NgControl"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * @whatItDoes Creates a {@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * @howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {@link RadioControlValueAccessor}
 * * Selects: {@link SelectControlValueAccessor}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  @stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        /** @internal */
        this._control = new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */]();
        /** @internal */
        this._registered = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        get: function () {
            return this._parent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* controlPath */])(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    NgModel.prototype._isStandalone = function () {
        return !this._parent || (this.options && this.options.standalone);
    };
    NgModel.prototype._setUpStandalone = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["d" /* setUpControl */])(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].formGroupNameException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_8__ng_form__["NgForm"])) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].modelParentException();
        }
    };
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].missingNameException();
        }
    };
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var disabledValue = changes['isDisabled'].currentValue;
        var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_5__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["NG_ASYNC_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__control_value_accessor__["NG_VALUE_ACCESSOR"],] },] },
    ];
    NgModel.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(__WEBPACK_IMPORTED_MODULE_7__ng_control__["NgControl"]));
//# sourceMappingURL=ng_model.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var http_1 = __webpack_require__(62);
var angular2_universal_1 = __webpack_require__(27);
var core_2 = __webpack_require__(112);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var content_service_1 = __webpack_require__(9);
var CartService = (function () {
    function CartService(config, utils, router, contentService, cookieService, http) {
        this.config = config;
        this.utils = utils;
        this.router = router;
        this.contentService = contentService;
        this.cookieService = cookieService;
        this.http = http;
        this.headers = new http_1.Headers({ 'Content-Type': 'application/json' });
        this.options = new http_1.RequestOptions({ headers: this.headers });
        // Items: [{content: recordObj, qty: 2}]
        this.items = [];
        // Cookie: {id: 12345, qty: 2}
        this.cookieData = {};
        this.cookieOptions = {};
        this.ready = false;
        // Display limit 
        this.limit = 3;
        // Id when payment has been processed
        this.paymentData = null;
        // Retrieve unfinished purchase with cart in cookie
        if (angular2_universal_1.isBrowser) {
            this.getCookieItems();
        }
    }
    CartService.prototype.setCookieExpiresInDays = function (days) {
        this.cookieOptions['expires'] = this.utils.dateNowPlusDays(days);
    };
    CartService.prototype.getCookieItems = function () {
        var _this = this;
        var cookie = this.cookieService.getObject('cart');
        if (cookie && Object.keys(cookie).length > 0) {
            this.cookieData = this.cookieService.getObject('cart');
            var idsString = Object.keys(this.cookieData).join(',');
            this.contentService.findContents('record', idsString).then(function (contents) {
                for (var _i = 0, contents_1 = contents; _i < contents_1.length; _i++) {
                    var content = contents_1[_i];
                    if (content != null) {
                        _this.items.push({
                            content: content,
                            qty: _this.cookieData[content._id]
                        });
                    }
                }
            });
        }
    };
    CartService.prototype.isInCart = function (id) {
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var added = _a[_i];
            if (id == added['content']._id) {
                return true;
            }
        }
        return false;
    };
    CartService.prototype.update = function (content, qty) {
        // see if record is already in cart
        var exists = false;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var added = _a[_i];
            if (content['_id'] == added['content']._id) {
                added['qty'] = qty; // update quantity
                exists = true;
                // cookie
                this.cookieData[added['content']._id] = added['qty'];
                this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
            }
        }
        // new item in cart
        if (!exists) {
            this.items.push({
                content: content,
                qty: qty
            });
            // cookie
            this.cookieData[content['_id']] = qty;
            this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
        }
    };
    CartService.prototype.remove = function (id) {
        var newItems = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var added = _a[_i];
            if (id != added.content._id)
                newItems.push(added);
        }
        // cookie
        delete this.cookieData[id];
        this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
        this.items = newItems;
    };
    CartService.prototype.clear = function () {
        var _this = this;
        this.items = [];
        this.cookieService.remove('cart');
        // Clear payment data when navigating away from cart
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.paymentData = null;
            }
        });
    };
    CartService.prototype.shipping = function () {
        var nb = this.countAll();
        var cost = 0;
        if (nb > 0)
            cost = this.config.data.CART.SHIPPING_FIRST;
        if (nb > 1)
            cost += this.config.data.CART.SHIPPING_OTHER * (nb - 1);
        return Number.parseFloat(cost.toFixed(2));
    };
    CartService.prototype.subtotal = function () {
        var total = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var added = _a[_i];
            total += added.qty * added.content.price;
        }
        return Number.parseFloat(total.toFixed(2));
    };
    CartService.prototype.total = function () {
        // Issue with decimals
        var total = this.subtotal() + this.shipping();
        //console.log(Number.parseFloat(total.toFixed(2)));
        //return Number.parseFloat(total.toFixed(2));
        return Number.parseFloat(total.toFixed(2));
    };
    CartService.prototype.count = function () {
        return this.items.length;
    };
    CartService.prototype.countAll = function () {
        var count = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var added = _a[_i];
            count += +added.qty;
        }
        return count;
    };
    CartService.prototype.itemsLimited = function () {
        var limited = [];
        for (var i = this.items.length - 1; i >= 0; i--) {
            limited.push(this.items[i]);
            if (limited.length >= this.limit)
                break;
        }
        return limited;
    };
    CartService.prototype.checkout = function (data) {
        return this.http.post('/api/payment/checkout', data, this.options)
            .toPromise()
            .then(function (response) {
            //console.log(response.json()); 
            return response;
        })
            .catch(this.handleError);
    };
    CartService.prototype.getClientToken = function () {
        return this.http.get('/api/payment/token')
            .toPromise()
            .then(function (response) {
            return response;
        })
            .catch(this.handleError);
    };
    CartService.prototype.handleError = function (error) {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    };
    CartService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _d) || Object, (typeof (_e = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _e) || Object, (typeof (_f = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _f) || Object])
    ], CartService);
    return CartService;
    var _a, _b, _c, _d, _e, _f;
}());
exports.CartService = CartService;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var IntlPipe = (function () {
    function IntlPipe() {
    }
    IntlPipe.prototype.transform = function (value, lg) {
        if (value)
            return value[lg];
    };
    IntlPipe = __decorate([
        core_1.Pipe({
            name: 'intl'
        }), 
        __metadata('design:paramtypes', [])
    ], IntlPipe);
    return IntlPipe;
}());
exports.IntlPipe = IntlPipe;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di_metadata__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__di_forward_ref__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__di_injector__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__di_reflective_injector__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__di_reflective_provider__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__di_reflective_key__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__di_opaque_token__ = __webpack_require__(189);
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__di_metadata__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__di_forward_ref__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__di_forward_ref__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__di_injector__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__di_reflective_injector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__di_reflective_provider__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__di_reflective_key__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__di_opaque_token__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * The `di` module provides dependency injection container services.
 */







//# sourceMappingURL=di.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_forms__ = __webpack_require__(387);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractFormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ControlContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_VALUE_ACCESSOR", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControlStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgForm", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgModelGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControlName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormArrayName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroupName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "PatternValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormBuilder", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AbstractControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormArray", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_ASYNC_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NG_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Validators", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "FormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ReactiveFormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["I"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(72);
/* harmony export (binding) */ __webpack_require__.d(exports, "formDirectiveProvider", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return FormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["ControlContainer"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * @whatItDoes Binds an existing {@link FormGroup} to a DOM element.
 *
 * @howToUse
 *
 * This directive accepts an existing {@link FormGroup} instance. It will then use this
 * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
 * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
 * and {@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
 * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
 * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
 * re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: {@link ReactiveFormsModule}
 *
 *  @stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    function FormGroupDirective(_validators, _asyncValidators) {
        _super.call(this);
        this._validators = _validators;
        this._asyncValidators = _asyncValidators;
        this._submitted = false;
        this.directives = [];
        this.form = null;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
    }
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    FormGroupDirective.prototype.addControl = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.removeControl = function (dir) { __WEBPACK_IMPORTED_MODULE_2__facade_collection__["e" /* ListWrapper */].remove(this.directives, dir); };
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var ctrl = this.form.get(dir.path);
        ctrl.setValue(value);
    };
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /** @internal */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["h" /* cleanUpControl */])(dir._control, dir);
                if (newCtrl)
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    FormGroupDirective.prototype._updateValidators = function () {
        var sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._validators);
        this.form.validator = __WEBPACK_IMPORTED_MODULE_3__validators__["Validators"].compose([this.form.validator, sync]);
        var async = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._asyncValidators);
        this.form.asyncValidator = __WEBPACK_IMPORTED_MODULE_3__validators__["Validators"].composeAsync([this.form.asyncValidator, async]);
    };
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["NG_ASYNC_VALIDATORS"],] },] },
    ];
    FormGroupDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
        'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["ControlContainer"]));
//# sourceMappingURL=form_group_directive.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reactive_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_group_directive__ = __webpack_require__(53);
/* harmony export (binding) */ __webpack_require__.d(exports, "formGroupNameProvider", function() { return formGroupNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(exports, "FormGroupName", function() { return FormGroupName; });
/* harmony export (binding) */ __webpack_require__.d(exports, "formArrayNameProvider", function() { return formArrayNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(exports, "FormArrayName", function() { return FormArrayName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formGroupNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * @whatItDoes Syncs a nested {@link FormGroup} to a DOM element.
 *
 * @howToUse
 *
 * This directive can only be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {@link FormGroup} you want to link, and
 * will look for a {@link FormGroup} registered with that name in the parent
 * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {@link FormGroup} using the
 * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {@link FormGroup}, or you can set it programmatically later using
 * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * @stable
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    function FormGroupName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /** @internal */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_ASYNC_VALIDATORS"],] },] },
    ];
    FormGroupName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
var formArrayNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * @whatItDoes Syncs a nested {@link FormArray} to a DOM element.
 *
 * @howToUse
 *
 * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {@link FormArray} you want to link, and
 * will look for a {@link FormArray} registered with that name in the parent
 * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {@link FormArray} using the
 * {@link AbstractControl.get} method on the parent {@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {@link FormArray}, or you can set the value programmatically later using the
 * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
 * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
 * calling its {@link FormArray.push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * @stable
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    function FormArrayName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        get: function () {
            return this._parent ? this._parent.formDirective : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_ASYNC_VALIDATORS"],] },] },
    ];
    FormArrayName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(__WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"]));
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof __WEBPACK_IMPORTED_MODULE_6__form_group_directive__["FormGroupDirective"]) &&
        !(parent instanceof FormArrayName);
}
//# sourceMappingURL=form_group_name.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_import_core__ = __webpack_require__(280);
/* harmony export (binding) */ __webpack_require__.d(exports, "NG_VALIDATORS", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NG_ASYNC_VALIDATORS", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Validators", function() { return Validators; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





function isEmptyInputValue(value) {
    return value == null || typeof value === 'string' && value.length === 0;
}
/**
 * Providers for validators to be used for {@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * @stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {@link NG_VALIDATORS} for more details.
 *
 * @stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgAsyncValidators');
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * @stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a non-empty value.
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var length = typeof control.value === 'string' ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var length = typeof control.value === 'string' ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     */
    Validators.pattern = function (pattern) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var regex = new RegExp("^" + pattern + "$");
            var value = control.value;
            return regex.test(value) ?
                null :
                { 'pattern': { 'requiredPattern': "^" + pattern + "$", 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * Compose multiple validators into a single function that returns the union
     * of the individual error maps.
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["d" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["d" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
            return Promise.all(promises).then(_mergeErrors);
        };
    };
    return Validators;
}());
function _convertToPromise(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__private_import_core__["a" /* isPromise */])(obj) ? obj : __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__["toPromise"].call(obj);
}
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _mergeErrors(arrayOfErrors) {
    var res = arrayOfErrors.reduce(function (res, errors) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["d" /* isPresent */])(errors) ? __WEBPACK_IMPORTED_MODULE_2__facade_collection__["f" /* StringMapWrapper */].merge(res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
//# sourceMappingURL=validators.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(39);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgSwitch = (function () {
    function Wrapper_NgSwitch() {
        this.changed = false;
        this.context = new import0.NgSwitch();
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_NgSwitch.prototype.check_ngSwitch = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngSwitch = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgSwitch.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgSwitch.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgSwitch;
}());
exports.Wrapper_NgSwitch = Wrapper_NgSwitch;
var Wrapper_NgSwitchCase = (function () {
    function Wrapper_NgSwitchCase(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.NgSwitchCase(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_NgSwitchCase.prototype.check_ngSwitchCase = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngSwitchCase = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgSwitchCase.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgSwitchCase.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgSwitchCase;
}());
exports.Wrapper_NgSwitchCase = Wrapper_NgSwitchCase;
var Wrapper_NgSwitchDefault = (function () {
    function Wrapper_NgSwitchDefault(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.NgSwitchDefault(p0, p1, p2);
    }
    Wrapper_NgSwitchDefault.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgSwitchDefault.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgSwitchDefault;
}());
exports.Wrapper_NgSwitchDefault = Wrapper_NgSwitchDefault;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgClass", function() { return NgClass; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 *
 * @whatItDoes Adds and removes CSS classes on an HTML element.
 *
 * @howToUse
 * ```
 *     <some-element [ngClass]="'first second'">...</some-element>
 *
 *     <some-element [ngClass]="['first', 'second']">...</some-element>
 *
 *     <some-element [ngClass]="{'first': true, 'second': true, 'third': false}">...</some-element>
 *
 *     <some-element [ngClass]="stringExp|arrayExp|objExp">...</some-element>
 * ```
 *
 * @description
 *
 * The CSS classes are updated as follows, depending on the type of the expression evaluation:
 * - `string` - the CSS classes listed in the string (space delimited) are added,
 * - `Array` - the CSS classes declared as Array elements are added,
 * - `Object` - keys are CSS classes that get added when the expression given in the value
 *              evaluates to a truthy value, otherwise they are removed.
 *
 * @stable
 */
var NgClass = (function () {
    function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
        this._iterableDiffers = _iterableDiffers;
        this._keyValueDiffers = _keyValueDiffers;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
        this._initialClasses = [];
    }
    Object.defineProperty(NgClass.prototype, "klass", {
        set: function (v) {
            this._applyInitialClasses(true);
            this._initialClasses = typeof v === 'string' ? v.split(/\s+/) : [];
            this._applyInitialClasses(false);
            this._applyClasses(this._rawClass, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgClass.prototype, "ngClass", {
        set: function (v) {
            this._cleanupClasses(this._rawClass);
            this._iterableDiffer = null;
            this._keyValueDiffer = null;
            this._rawClass = typeof v === 'string' ? v.split(/\s+/) : v;
            if (this._rawClass) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_collection__["b" /* isListLikeIterable */])(this._rawClass)) {
                    this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create(null);
                }
                else {
                    this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create(null);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    NgClass.prototype.ngDoCheck = function () {
        if (this._iterableDiffer) {
            var changes = this._iterableDiffer.diff(this._rawClass);
            if (changes) {
                this._applyIterableChanges(changes);
            }
        }
        else if (this._keyValueDiffer) {
            var changes = this._keyValueDiffer.diff(this._rawClass);
            if (changes) {
                this._applyKeyValueChanges(changes);
            }
        }
    };
    NgClass.prototype._cleanupClasses = function (rawClassVal) {
        this._applyClasses(rawClassVal, true);
        this._applyInitialClasses(false);
    };
    NgClass.prototype._applyKeyValueChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachRemovedItem(function (record) {
            if (record.previousValue) {
                _this._toggleClass(record.key, false);
            }
        });
    };
    NgClass.prototype._applyIterableChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) { return _this._toggleClass(record.item, true); });
        changes.forEachRemovedItem(function (record) { return _this._toggleClass(record.item, false); });
    };
    NgClass.prototype._applyInitialClasses = function (isCleanup) {
        var _this = this;
        this._initialClasses.forEach(function (klass) { return _this._toggleClass(klass, !isCleanup); });
    };
    NgClass.prototype._applyClasses = function (rawClassVal, isCleanup) {
        var _this = this;
        if (rawClassVal) {
            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                rawClassVal.forEach(function (klass) { return _this._toggleClass(klass, !isCleanup); });
            }
            else {
                Object.keys(rawClassVal).forEach(function (klass) {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(rawClassVal[klass]))
                        _this._toggleClass(klass, !isCleanup);
                });
            }
        }
    };
    NgClass.prototype._toggleClass = function (klass, enabled) {
        var _this = this;
        klass = klass.trim();
        if (klass) {
            klass.split(/\s+/g).forEach(function (klass) { _this._renderer.setElementClass(_this._ngEl.nativeElement, klass, enabled); });
        }
    };
    NgClass.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngClass]' },] },
    ];
    /** @nocollapse */
    NgClass.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ];
    NgClass.propDecorators = {
        'klass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class',] },],
        'ngClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgClass;
}());
//# sourceMappingURL=ng_class.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PRIMARY_OUTLET; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NavigationCancelingError; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @whatItDoes Name of the primary outlet.
 *
 * @stable
 */
var PRIMARY_OUTLET = 'primary';
var NavigationCancelingError = (function (_super) {
    __extends(NavigationCancelingError, _super);
    function NavigationCancelingError(message) {
        _super.call(this, message);
        this.message = message;
        this.stack = (new Error(message)).stack;
    }
    NavigationCancelingError.prototype.toString = function () { return this.message; };
    return NavigationCancelingError;
}(Error));
//# sourceMappingURL=shared.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() { return this; })();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return EventEmitter; });
/* unused harmony reexport Observable */
/* unused harmony reexport Subject */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * Use by directives and components to emit custom Events.
 *
 * ### Examples
 *
 * In the following example, `Zippy` alternatively emits `open` and `close` events when its
 * title gets clicked:
 *
 * ```
 * @Component({
 *   selector: 'zippy',
 *   template: `
 *   <div class="zippy">
 *     <div (click)="toggle()">Toggle</div>
 *     <div [hidden]="!visible">
 *       <ng-content></ng-content>
 *     </div>
 *  </div>`})
 * export class Zippy {
 *   visible: boolean = true;
 *   @Output() open: EventEmitter<any> = new EventEmitter();
 *   @Output() close: EventEmitter<any> = new EventEmitter();
 *
 *   toggle() {
 *     this.visible = !this.visible;
 *     if (this.visible) {
 *       this.open.emit(null);
 *     } else {
 *       this.close.emit(null);
 *     }
 *   }
 * }
 * ```
 *
 * The events payload can be accessed by the parameter `$event` on the components output event
 * handler:
 *
 * ```
 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
 * ```
 *
 * Uses Rx.Observable but provides an adapter to make it work as specified here:
 * https://github.com/jhusain/observable-spec
 *
 * Once a reference implementation of the spec is available, switch to it.
 * @stable
 */
var EventEmitter = (function (_super) {
    __extends(EventEmitter, _super);
    /**
     * Creates an instance of [EventEmitter], which depending on [isAsync],
     * delivers events synchronously or asynchronously.
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) { isAsync = false; }
        _super.call(this);
        this.__isAsync = isAsync;
    }
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var schedulerFn;
        var errorFn = function (err) { return null; };
        var completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]));
//# sourceMappingURL=async.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_value_accessor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng_control__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reactive_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_group_directive__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_group_name__ = __webpack_require__(54);
/* harmony export (binding) */ __webpack_require__.d(exports, "controlNameBinding", function() { return controlNameBinding; });
/* harmony export (binding) */ __webpack_require__.d(exports, "FormControlName", function() { return FormControlName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};











var controlNameBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_6__ng_control__["NgControl"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * @whatItDoes  Syncs a {@link FormControl} in an existing {@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {@link FormControl} instance (view -> model).
 *
 * @howToUse
 *
 * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {@link FormControl} instance you want to
 * link, and will look for a {@link FormControl} registered with that name in the
 * closest {@link FormGroup} or {@link FormArray} above it.
 *
 * **Access the control**: You can access the {@link FormControl} associated with
 * this directive by using the {@link AbstractControl.get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
 * See a full list of available properties in {@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {@link FormControl}, or you can set it programmatically later using
 *  {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {@link RadioControlValueAccessor}
 * * Selects: {@link SelectControlValueAccessor}
 *
 * **npm package**: `@angular/forms`
 *
 * **NgModule**: {@link ReactiveFormsModule}
 *
 *  @stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this._added = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["FormGroupName"]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].ngModelGroupException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["FormGroupName"]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__form_group_directive__["FormGroupDirective"]) &&
            !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["FormArrayName"])) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].controlParentException();
        }
    };
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["NG_ASYNC_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_5__control_value_accessor__["NG_VALUE_ACCESSOR"],] },] },
    ];
    FormControlName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(__WEBPACK_IMPORTED_MODULE_6__ng_control__["NgControl"]));
//# sourceMappingURL=form_control_name.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__(388);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "BrowserXhr", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "JSONPBackend", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "JSONPConnection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "CookieXSRFStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "XHRBackend", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "XHRConnection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "BaseRequestOptions", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RequestOptions", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "BaseResponseOptions", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ResponseOptions", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ReadyState", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "RequestMethod", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ResponseContentType", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ResponseType", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Headers", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Http", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Jsonp", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HttpModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "JsonpModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Connection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "ConnectionBackend", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "XSRFStrategy", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Request", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Response", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "QueryEncoder", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "URLSearchParams", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index__["z"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the http package.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_concatAll__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_concatAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_every__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_last__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(58);
/* harmony export (immutable) */ exports["h"] = shallowEqualArrays;
/* harmony export (immutable) */ exports["d"] = shallowEqual;
/* harmony export (immutable) */ exports["a"] = flatten;
/* unused harmony export first */
/* harmony export (immutable) */ exports["i"] = last;
/* unused harmony export and */
/* harmony export (immutable) */ exports["g"] = merge;
/* harmony export (immutable) */ exports["c"] = forEach;
/* harmony export (immutable) */ exports["e"] = waitForMap;
/* harmony export (immutable) */ exports["f"] = andObservables;
/* harmony export (immutable) */ exports["b"] = wrapIntoObservable;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









function shallowEqualArrays(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (!shallowEqual(a[i], b[i]))
            return false;
    }
    return true;
}
function shallowEqual(a, b) {
    var k1 = Object.keys(a);
    var k2 = Object.keys(b);
    if (k1.length != k2.length) {
        return false;
    }
    var key;
    for (var i = 0; i < k1.length; i++) {
        key = k1[i];
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
function flatten(a) {
    var target = [];
    for (var i = 0; i < a.length; ++i) {
        for (var j = 0; j < a[i].length; ++j) {
            target.push(a[i][j]);
        }
    }
    return target;
}
function first(a) {
    return a.length > 0 ? a[0] : null;
}
function last(a) {
    return a.length > 0 ? a[a.length - 1] : null;
}
function and(bools) {
    return bools.reduce(function (a, b) { return a && b; }, true);
}
function merge(m1, m2) {
    var m = {};
    for (var attr in m1) {
        if (m1.hasOwnProperty(attr)) {
            m[attr] = m1[attr];
        }
    }
    for (var attr in m2) {
        if (m2.hasOwnProperty(attr)) {
            m[attr] = m2[attr];
        }
    }
    return m;
}
function forEach(map, callback) {
    for (var prop in map) {
        if (map.hasOwnProperty(prop)) {
            callback(map[prop], prop);
        }
    }
}
function waitForMap(obj, fn) {
    var waitFor = [];
    var res = {};
    forEach(obj, function (a, k) {
        if (k === __WEBPACK_IMPORTED_MODULE_8__shared__["a" /* PRIMARY_OUTLET */]) {
            waitFor.push(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(fn(k, a), function (_) {
                res[k] = _;
                return _;
            }));
        }
    });
    forEach(obj, function (a, k) {
        if (k !== __WEBPACK_IMPORTED_MODULE_8__shared__["a" /* PRIMARY_OUTLET */]) {
            waitFor.push(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(fn(k, a), function (_) {
                res[k] = _;
                return _;
            }));
        }
    });
    if (waitFor.length > 0) {
        var concatted$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_concatAll__["concatAll"].call(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"].apply(void 0, waitFor));
        var last$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_last__["last"].call(concatted$);
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(last$, function () { return res; });
    }
    else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(res);
    }
}
function andObservables(observables) {
    var merged$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeAll__["mergeAll"].call(observables);
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_every__["every"].call(merged$, function (result) { return result === true; });
}
function wrapIntoObservable(value) {
    if (value instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]) {
        return value;
    }
    else if (value instanceof Promise) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__["fromPromise"])(value);
    }
    else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(value);
    }
}
//# sourceMappingURL=collection.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(41);
var Wrapper_CheckboxControlValueAccessor = (function () {
    function Wrapper_CheckboxControlValueAccessor(p0, p1) {
        this.changed = false;
        this.context = new import0.CheckboxControlValueAccessor(p0, p1);
    }
    Wrapper_CheckboxControlValueAccessor.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_CheckboxControlValueAccessor.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_CheckboxControlValueAccessor;
}());
exports.Wrapper_CheckboxControlValueAccessor = Wrapper_CheckboxControlValueAccessor;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(44);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(11);
var import9 = __webpack_require__(10);
var import10 = __webpack_require__(453);
var import11 = __webpack_require__(56);
var import12 = __webpack_require__(14);
var import13 = __webpack_require__(39);
var import14 = __webpack_require__(216);
var import15 = __webpack_require__(40);
var import16 = __webpack_require__(18);
var import17 = __webpack_require__(102);
var Wrapper_LoadingIndicator = (function () {
    function Wrapper_LoadingIndicator() {
        this.changed = false;
        this.context = new import0.LoadingIndicator();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_LoadingIndicator.prototype.check_color = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.color = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_LoadingIndicator.prototype.check_type = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.type = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_LoadingIndicator.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_LoadingIndicator.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_LoadingIndicator;
}());
exports.Wrapper_LoadingIndicator = Wrapper_LoadingIndicator;
var renderType_LoadingIndicator_Host = null;
var _View_LoadingIndicator_Host0 = (function (_super) {
    __extends(_View_LoadingIndicator_Host0, _super);
    function _View_LoadingIndicator_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LoadingIndicator_Host0, renderType_LoadingIndicator_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_LoadingIndicator_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'loading-indicator', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_LoadingIndicator_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_LoadingIndicator_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LoadingIndicator_Host0;
}(import3.AppView));
function viewFactory_LoadingIndicator_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_LoadingIndicator_Host === null)) {
        (renderType_LoadingIndicator_Host = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {}));
    }
    return new _View_LoadingIndicator_Host0(viewUtils, parentInjector, declarationEl);
}
exports.LoadingIndicatorNgFactory = new import9.ComponentFactory('loading-indicator', viewFactory_LoadingIndicator_Host0, import0.LoadingIndicator);
var styles_LoadingIndicator = [import10.styles];
var renderType_LoadingIndicator = null;
var _View_LoadingIndicator0 = (function (_super) {
    __extends(_View_LoadingIndicator0, _super);
    function _View_LoadingIndicator0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LoadingIndicator0, renderType_LoadingIndicator, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_LoadingIndicator0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this._el_1 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_1_3 = new import11.Wrapper_NgSwitch();
        this._text_2 = this.renderer.createText(this._el_1, '\n            ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_3 = new import5.AppElement(3, 1, this, this._anchor_3);
        this._TemplateRef_3_5 = new import12.TemplateRef_(this._appEl_3, viewFactory_LoadingIndicator1);
        this._NgSwitchCase_3_6 = new import11.Wrapper_NgSwitchCase(this._appEl_3.vcRef, this._TemplateRef_3_5, this._NgSwitch_1_3.context);
        this._text_4 = this.renderer.createText(this._el_1, '\n            ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_5 = new import5.AppElement(5, 1, this, this._anchor_5);
        this._TemplateRef_5_5 = new import12.TemplateRef_(this._appEl_5, viewFactory_LoadingIndicator2);
        this._NgSwitchCase_5_6 = new import11.Wrapper_NgSwitchCase(this._appEl_5.vcRef, this._TemplateRef_5_5, this._NgSwitch_1_3.context);
        this._text_6 = this.renderer.createText(this._el_1, '\n        ', null);
        this._text_7 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._anchor_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._text_7
        ], [], []);
        return null;
    };
    _View_LoadingIndicator0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import12.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import13.NgSwitchCase) && (3 === requestNodeIndex))) {
            return this._NgSwitchCase_3_6.context;
        }
        if (((token === import12.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import13.NgSwitchCase) && (5 === requestNodeIndex))) {
            return this._NgSwitchCase_5_6.context;
        }
        if (((token === import13.NgSwitch) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._NgSwitch_1_3.context;
        }
        return notFoundResult;
    };
    _View_LoadingIndicator0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = this.context.type;
        this._NgSwitch_1_3.check_ngSwitch(currVal_1_0_0, throwOnChange, false);
        this._NgSwitch_1_3.detectChangesInInputProps(this, this._el_1, throwOnChange);
        var currVal_3_0_0 = 'spinner';
        this._NgSwitchCase_3_6.check_ngSwitchCase(currVal_3_0_0, throwOnChange, false);
        this._NgSwitchCase_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        var currVal_5_0_0 = 'cube';
        this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0, throwOnChange, false);
        this._NgSwitchCase_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_1_3.detectChangesInHostProps(this, this._el_1, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LoadingIndicator0;
}(import3.AppView));
function viewFactory_LoadingIndicator0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_LoadingIndicator === null)) {
        (renderType_LoadingIndicator = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.Emulated, styles_LoadingIndicator, {}));
    }
    return new _View_LoadingIndicator0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_LoadingIndicator0 = viewFactory_LoadingIndicator0;
var _View_LoadingIndicator1 = (function (_super) {
    __extends(_View_LoadingIndicator1, _super);
    function _View_LoadingIndicator1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LoadingIndicator1, renderType_LoadingIndicator, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_17 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_18 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_19 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_20 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_21 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
    }
    _View_LoadingIndicator1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'spinner'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'rect1'), null);
        this._NgStyle_2_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_2), this.renderer);
        this._text_3 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'rect2'), null);
        this._NgStyle_4_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_4), this.renderer);
        this._text_5 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'rect3'), null);
        this._NgStyle_6_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_6), this.renderer);
        this._text_7 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'rect4'), null);
        this._NgStyle_8_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_8), this.renderer);
        this._text_9 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_10 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'rect5'), null);
        this._NgStyle_10_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_10), this.renderer);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11
        ], [], []);
        return null;
    };
    _View_LoadingIndicator1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.NgStyle) && (2 === requestNodeIndex))) {
            return this._NgStyle_2_3.context;
        }
        if (((token === import17.NgStyle) && (4 === requestNodeIndex))) {
            return this._NgStyle_4_3.context;
        }
        if (((token === import17.NgStyle) && (6 === requestNodeIndex))) {
            return this._NgStyle_6_3.context;
        }
        if (((token === import17.NgStyle) && (8 === requestNodeIndex))) {
            return this._NgStyle_8_3.context;
        }
        if (((token === import17.NgStyle) && (10 === requestNodeIndex))) {
            return this._NgStyle_10_3.context;
        }
        return notFoundResult;
    };
    _View_LoadingIndicator1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this._map_17(this.parent.context.color);
        this._NgStyle_2_3.check_ngStyle(currVal_2_0_0, throwOnChange, false);
        this._NgStyle_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_4_0_0 = this._map_18(this.parent.context.color);
        this._NgStyle_4_3.check_ngStyle(currVal_4_0_0, throwOnChange, false);
        this._NgStyle_4_3.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_6_0_0 = this._map_19(this.parent.context.color);
        this._NgStyle_6_3.check_ngStyle(currVal_6_0_0, throwOnChange, false);
        this._NgStyle_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_8_0_0 = this._map_20(this.parent.context.color);
        this._NgStyle_8_3.check_ngStyle(currVal_8_0_0, throwOnChange, false);
        this._NgStyle_8_3.detectChangesInInputProps(this, this._el_8, throwOnChange);
        var currVal_10_0_0 = this._map_21(this.parent.context.color);
        this._NgStyle_10_3.check_ngStyle(currVal_10_0_0, throwOnChange, false);
        this._NgStyle_10_3.detectChangesInInputProps(this, this._el_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgStyle_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgStyle_4_3.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._NgStyle_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgStyle_8_3.detectChangesInHostProps(this, this._el_8, throwOnChange);
        this._NgStyle_10_3.detectChangesInHostProps(this, this._el_10, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LoadingIndicator1;
}(import3.AppView));
function viewFactory_LoadingIndicator1(viewUtils, parentInjector, declarationEl) {
    return new _View_LoadingIndicator1(viewUtils, parentInjector, declarationEl);
}
var _View_LoadingIndicator2 = (function (_super) {
    __extends(_View_LoadingIndicator2, _super);
    function _View_LoadingIndicator2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LoadingIndicator2, renderType_LoadingIndicator, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_29 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_30 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_31 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_32 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_33 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_34 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_35 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_36 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
        this._map_37 = import2.pureProxy1(function (p0) {
            return { 'background-color': p0 };
        });
    }
    _View_LoadingIndicator2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'sk-cube-grid'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube1'), null);
        this._NgStyle_2_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_2), this.renderer);
        this._text_3 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube2'), null);
        this._NgStyle_4_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_4), this.renderer);
        this._text_5 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube3'), null);
        this._NgStyle_6_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_6), this.renderer);
        this._text_7 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube4'), null);
        this._NgStyle_8_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_8), this.renderer);
        this._text_9 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_10 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube5'), null);
        this._NgStyle_10_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_10), this.renderer);
        this._text_11 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_12 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube6'), null);
        this._NgStyle_12_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_12), this.renderer);
        this._text_13 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_14 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube7'), null);
        this._NgStyle_14_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_14), this.renderer);
        this._text_15 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_16 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube8'), null);
        this._NgStyle_16_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_16), this.renderer);
        this._text_17 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_18 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'sk-cube sk-cube9'), null);
        this._NgStyle_18_3 = new import14.Wrapper_NgStyle(this.parent.parentInjector.get(import15.KeyValueDiffers), new import16.ElementRef(this._el_18), this.renderer);
        this._text_19 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19
        ], [], []);
        return null;
    };
    _View_LoadingIndicator2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.NgStyle) && (2 === requestNodeIndex))) {
            return this._NgStyle_2_3.context;
        }
        if (((token === import17.NgStyle) && (4 === requestNodeIndex))) {
            return this._NgStyle_4_3.context;
        }
        if (((token === import17.NgStyle) && (6 === requestNodeIndex))) {
            return this._NgStyle_6_3.context;
        }
        if (((token === import17.NgStyle) && (8 === requestNodeIndex))) {
            return this._NgStyle_8_3.context;
        }
        if (((token === import17.NgStyle) && (10 === requestNodeIndex))) {
            return this._NgStyle_10_3.context;
        }
        if (((token === import17.NgStyle) && (12 === requestNodeIndex))) {
            return this._NgStyle_12_3.context;
        }
        if (((token === import17.NgStyle) && (14 === requestNodeIndex))) {
            return this._NgStyle_14_3.context;
        }
        if (((token === import17.NgStyle) && (16 === requestNodeIndex))) {
            return this._NgStyle_16_3.context;
        }
        if (((token === import17.NgStyle) && (18 === requestNodeIndex))) {
            return this._NgStyle_18_3.context;
        }
        return notFoundResult;
    };
    _View_LoadingIndicator2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this._map_29(this.parent.context.color);
        this._NgStyle_2_3.check_ngStyle(currVal_2_0_0, throwOnChange, false);
        this._NgStyle_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_4_0_0 = this._map_30(this.parent.context.color);
        this._NgStyle_4_3.check_ngStyle(currVal_4_0_0, throwOnChange, false);
        this._NgStyle_4_3.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_6_0_0 = this._map_31(this.parent.context.color);
        this._NgStyle_6_3.check_ngStyle(currVal_6_0_0, throwOnChange, false);
        this._NgStyle_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_8_0_0 = this._map_32(this.parent.context.color);
        this._NgStyle_8_3.check_ngStyle(currVal_8_0_0, throwOnChange, false);
        this._NgStyle_8_3.detectChangesInInputProps(this, this._el_8, throwOnChange);
        var currVal_10_0_0 = this._map_33(this.parent.context.color);
        this._NgStyle_10_3.check_ngStyle(currVal_10_0_0, throwOnChange, false);
        this._NgStyle_10_3.detectChangesInInputProps(this, this._el_10, throwOnChange);
        var currVal_12_0_0 = this._map_34(this.parent.context.color);
        this._NgStyle_12_3.check_ngStyle(currVal_12_0_0, throwOnChange, false);
        this._NgStyle_12_3.detectChangesInInputProps(this, this._el_12, throwOnChange);
        var currVal_14_0_0 = this._map_35(this.parent.context.color);
        this._NgStyle_14_3.check_ngStyle(currVal_14_0_0, throwOnChange, false);
        this._NgStyle_14_3.detectChangesInInputProps(this, this._el_14, throwOnChange);
        var currVal_16_0_0 = this._map_36(this.parent.context.color);
        this._NgStyle_16_3.check_ngStyle(currVal_16_0_0, throwOnChange, false);
        this._NgStyle_16_3.detectChangesInInputProps(this, this._el_16, throwOnChange);
        var currVal_18_0_0 = this._map_37(this.parent.context.color);
        this._NgStyle_18_3.check_ngStyle(currVal_18_0_0, throwOnChange, false);
        this._NgStyle_18_3.detectChangesInInputProps(this, this._el_18, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgStyle_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgStyle_4_3.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._NgStyle_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgStyle_8_3.detectChangesInHostProps(this, this._el_8, throwOnChange);
        this._NgStyle_10_3.detectChangesInHostProps(this, this._el_10, throwOnChange);
        this._NgStyle_12_3.detectChangesInHostProps(this, this._el_12, throwOnChange);
        this._NgStyle_14_3.detectChangesInHostProps(this, this._el_14, throwOnChange);
        this._NgStyle_16_3.detectChangesInHostProps(this, this._el_16, throwOnChange);
        this._NgStyle_18_3.detectChangesInHostProps(this, this._el_18, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LoadingIndicator2;
}(import3.AppView));
function viewFactory_LoadingIndicator2(viewUtils, parentInjector, declarationEl) {
    return new _View_LoadingIndicator2(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
var Subscriber_1 = __webpack_require__(35);
var Subscription_1 = __webpack_require__(99);
var ObjectUnsubscribedError_1 = __webpack_require__(250);
var SubjectSubscription_1 = __webpack_require__(323);
var rxSubscriber_1 = __webpack_require__(248);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.$$rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {"use strict";
/**
 * window: browser in DOM main thread
 * self: browser in WebWorker
 * global: Node.js/other
 */
exports.root = (typeof window == 'object' && window.window === window && window
    || typeof self == 'object' && self.self === self && self
    || typeof global == 'object' && global.global === global && global);
if (!exports.root) {
    throw new Error('RxJS could not find any global context (window, self, global)');
}
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return InvalidPipeArgumentError; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var InvalidPipeArgumentError = (function (_super) {
    __extends(InvalidPipeArgumentError, _super);
    function InvalidPipeArgumentError(type, value) {
        _super.call(this, "Invalid argument '" + value + "' for pipe '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(type) + "'");
    }
    return InvalidPipeArgumentError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
//# sourceMappingURL=invalid_pipe_argument_error.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(72);
/* harmony export (binding) */ __webpack_require__.d(exports, "formDirectiveProvider", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgForm", function() { return NgForm; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_5__control_container__["ControlContainer"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * @whatItDoes Creates a top-level {@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * @howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {@link NgModel} with a
 * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  @stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    function NgForm(validators, asyncValidators) {
        _super.call(this);
        this._submitted = false;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this.form =
            new __WEBPACK_IMPORTED_MODULE_3__model__["a" /* FormGroup */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(validators), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(asyncValidators));
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            dir._control = container.registerControl(dir.name, dir.control);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(container)) {
                container.removeControl(dir.name);
            }
        });
    };
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            var group = new __WEBPACK_IMPORTED_MODULE_3__model__["a" /* FormGroup */]({});
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(container)) {
                container.removeControl(dir.name);
            }
        });
    };
    NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var ctrl = _this.form.get(dir.path);
            ctrl.setValue(value);
        });
    };
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    NgForm.prototype.onReset = function () { this.resetForm(); };
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /** @internal */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? this.form.get(path) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_4__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_4__validators__["NG_ASYNC_VALIDATORS"],] },] },
    ];
    return NgForm;
}(__WEBPACK_IMPORTED_MODULE_5__control_container__["ControlContainer"]));
//# sourceMappingURL=ng_form.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(exports, "SELECT_VALUE_ACCESSOR", function() { return SELECT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgSelectOption", function() { return NgSelectOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var SELECT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
function _buildValueString(id, value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["c" /* isBlank */])(id))
        return "" + value;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["k" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * @whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
 * to keep the view synced with the {@link FormControl} model.
 *
 * @howToUse
 *
 * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var SelectControlValueAccessor = (function () {
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var valueString = _buildValueString(this._getOptionId(value), value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_1__facade_collection__["a" /* MapWrapper */].keys(this._optionMap); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["i" /* looseIdentical */])(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var value = this._optionMap.get(_extractId(valueString));
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(value) ? value : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return SelectControlValueAccessor;
}());
/**
 * @whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * @howToUse
 *
 * See docs for {@link SelectControlValueAccessor} for usage examples.
 *
 * @stable
 */
var NgSelectOption = (function () {
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select))
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        set: function (value) {
            this._setElementValue(value);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select))
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select)) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    NgSelectOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());
//# sourceMappingURL=select_control_value_accessor.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(26);
/* harmony export (binding) */ __webpack_require__.d(exports, "SELECT_MULTIPLE_VALUE_ACCESSOR", function() { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgSelectMultipleOption", function() { return NgSelectMultipleOption; });
/* harmony export (binding) */ __webpack_require__.d(exports, "SELECT_DIRECTIVES", function() { return SELECT_DIRECTIVES; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
function _buildValueString(id, value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["c" /* isBlank */])(id))
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["k" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/** Mock interface for HTMLCollection */
var HTMLCollection = (function () {
    function HTMLCollection() {
    }
    return HTMLCollection;
}());
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 * @stable
 */
var SelectMultipleControlValueAccessor = (function () {
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        if (value == null)
            return;
        var values = value;
        // convert values to ids
        var ids = values.map(function (v) { return _this._getOptionId(v); });
        this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
    };
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var options = _.selectedOptions;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    var val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var options = _.options;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    if (opt.selected) {
                        var val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            fn(selected);
        };
    };
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = __WEBPACK_IMPORTED_MODULE_1__facade_collection__["a" /* MapWrapper */].keys(this._optionMap); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["i" /* looseIdentical */])(this._optionMap.get(id)._value, value))
                return id;
        }
        return null;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var opt = this._optionMap.get(_extractId(valueString));
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(opt) ? opt._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return SelectMultipleControlValueAccessor;
}());
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select)) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        set: function (value) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select)) {
                this._value = value;
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /** @internal */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(this._select)) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    NgSelectMultipleOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());
var SELECT_DIRECTIVES = [SelectMultipleControlValueAccessor, NgSelectMultipleOption];
//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__normalize_validator__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__select_control_value_accessor__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select_multiple_control_value_accessor__ = __webpack_require__(71);
/* harmony export (immutable) */ exports["a"] = controlPath;
/* harmony export (immutable) */ exports["d"] = setUpControl;
/* harmony export (immutable) */ exports["h"] = cleanUpControl;
/* harmony export (immutable) */ exports["e"] = setUpFormContainer;
/* harmony export (immutable) */ exports["b"] = composeValidators;
/* harmony export (immutable) */ exports["c"] = composeAsyncValidators;
/* harmony export (immutable) */ exports["g"] = isPropertyUpdated;
/* unused harmony export isBuiltInAccessor */
/* harmony export (immutable) */ exports["f"] = selectValueAccessor;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









function controlPath(name, parent) {
    return parent.path.concat([name]);
}
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    // view -> model
    dir.valueAccessor.registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    });
    // touched
    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) { return validator.registerOnValidatorChange(null); });
    dir._rawAsyncValidators.forEach(function (validator) { return validator.registerOnValidatorChange(null); });
    if (control)
        control._clearChangeFns();
}
function setUpFormContainer(control, dir) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isBlank */])(control))
        _throwError(dir, 'Cannot find control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].composeAsync([control.asyncValidator, dir.asyncValidator]);
}
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
function _throwError(dir, message) {
    var messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
function composeValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].compose(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["a" /* normalizeValidator */])) : null;
}
function composeAsyncValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["Validators"].composeAsync(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["b" /* normalizeAsyncValidator */])) :
        null;
}
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["i" /* looseIdentical */])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__["CheckboxControlValueAccessor"],
    __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__select_control_value_accessor__["SelectControlValueAccessor"],
    __WEBPACK_IMPORTED_MODULE_8__select_multiple_control_value_accessor__["SelectMultipleControlValueAccessor"],
    __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__["RadioControlValueAccessor"],
];
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var defaultAccessor;
    var builtinAccessor;
    var customAccessor;
    valueAccessors.forEach(function (v) {
        if (v.constructor === __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__["DefaultValueAccessor"]) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
//# sourceMappingURL=shared.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(140);
/* harmony export (binding) */ __webpack_require__.d(exports, "FormBuilder", function() { return FormBuilder; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @whatItDoes Creates an {@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * @howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `@angular/forms`
 *
 *  * **NgModule**: {@link ReactiveFormsModule}
 *
 * @stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {@link FormGroup} constructor for more details.
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var controls = this._reduceControls(controlsConfig);
        var validator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(extra) ? extra['validator'] : null;
        var asyncValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(extra) ? extra['asyncValidator'] : null;
        return new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */](controls, validator, asyncValidator);
    };
    /**
     * Construct a new {@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        return new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */](formState, validator, asyncValidator);
    };
    /**
     * Construct a {@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */](controls, validator, asyncValidator);
    };
    /** @internal */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /** @internal */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */] || controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */] ||
            controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */]) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var value = controlConfig[0];
            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = [];
    return FormBuilder;
}());
//# sourceMappingURL=form_builder.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RequestMethod; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ReadyState; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ResponseType; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return ContentType; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return ResponseContentType; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Supported http methods.
 * @experimental
 */
var RequestMethod;
(function (RequestMethod) {
    RequestMethod[RequestMethod["Get"] = 0] = "Get";
    RequestMethod[RequestMethod["Post"] = 1] = "Post";
    RequestMethod[RequestMethod["Put"] = 2] = "Put";
    RequestMethod[RequestMethod["Delete"] = 3] = "Delete";
    RequestMethod[RequestMethod["Options"] = 4] = "Options";
    RequestMethod[RequestMethod["Head"] = 5] = "Head";
    RequestMethod[RequestMethod["Patch"] = 6] = "Patch";
})(RequestMethod || (RequestMethod = {}));
/**
 * All possible states in which a connection can be, based on
 * [States](http://www.w3.org/TR/XMLHttpRequest/#states) from the `XMLHttpRequest` spec, but with an
 * additional "CANCELLED" state.
 * @experimental
 */
var ReadyState;
(function (ReadyState) {
    ReadyState[ReadyState["Unsent"] = 0] = "Unsent";
    ReadyState[ReadyState["Open"] = 1] = "Open";
    ReadyState[ReadyState["HeadersReceived"] = 2] = "HeadersReceived";
    ReadyState[ReadyState["Loading"] = 3] = "Loading";
    ReadyState[ReadyState["Done"] = 4] = "Done";
    ReadyState[ReadyState["Cancelled"] = 5] = "Cancelled";
})(ReadyState || (ReadyState = {}));
/**
 * Acceptable response types to be associated with a {@link Response}, based on
 * [ResponseType](https://fetch.spec.whatwg.org/#responsetype) from the Fetch spec.
 * @experimental
 */
var ResponseType;
(function (ResponseType) {
    ResponseType[ResponseType["Basic"] = 0] = "Basic";
    ResponseType[ResponseType["Cors"] = 1] = "Cors";
    ResponseType[ResponseType["Default"] = 2] = "Default";
    ResponseType[ResponseType["Error"] = 3] = "Error";
    ResponseType[ResponseType["Opaque"] = 4] = "Opaque";
})(ResponseType || (ResponseType = {}));
/**
 * Supported content type to be automatically associated with a {@link Request}.
 * @experimental
 */
var ContentType;
(function (ContentType) {
    ContentType[ContentType["NONE"] = 0] = "NONE";
    ContentType[ContentType["JSON"] = 1] = "JSON";
    ContentType[ContentType["FORM"] = 2] = "FORM";
    ContentType[ContentType["FORM_DATA"] = 3] = "FORM_DATA";
    ContentType[ContentType["TEXT"] = 4] = "TEXT";
    ContentType[ContentType["BLOB"] = 5] = "BLOB";
    ContentType[ContentType["ARRAY_BUFFER"] = 6] = "ARRAY_BUFFER";
})(ContentType || (ContentType = {}));
/**
 * Define which buffer to use to store the response
 * @experimental
 */
var ResponseContentType;
(function (ResponseContentType) {
    ResponseContentType[ResponseContentType["Text"] = 0] = "Text";
    ResponseContentType[ResponseContentType["Json"] = 1] = "Json";
    ResponseContentType[ResponseContentType["ArrayBuffer"] = 2] = "ArrayBuffer";
    ResponseContentType[ResponseContentType["Blob"] = 3] = "Blob";
})(ResponseContentType || (ResponseContentType = {}));
//# sourceMappingURL=enums.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterOutletMap", function() { return RouterOutletMap; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes Contains all the router outlets created in a component.
 *
 * @stable
 */
var RouterOutletMap = (function () {
    function RouterOutletMap() {
        /** @internal */
        this._outlets = {};
    }
    /**
     * Adds an outlet to this map.
     */
    RouterOutletMap.prototype.registerOutlet = function (name, outlet) { this._outlets[name] = outlet; };
    /**
     * Removes an outlet from this map.
     */
    RouterOutletMap.prototype.removeOutlet = function (name) { this._outlets[name] = undefined; };
    return RouterOutletMap;
}());
//# sourceMappingURL=router_outlet_map.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_collection__ = __webpack_require__(63);
/* harmony export (immutable) */ exports["createEmptyUrlTree"] = createEmptyUrlTree;
/* harmony export (immutable) */ exports["containsTree"] = containsTree;
/* harmony export (binding) */ __webpack_require__.d(exports, "UrlTree", function() { return UrlTree; });
/* harmony export (binding) */ __webpack_require__.d(exports, "UrlSegmentGroup", function() { return UrlSegmentGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "UrlSegment", function() { return UrlSegment; });
/* harmony export (immutable) */ exports["equalSegments"] = equalSegments;
/* harmony export (immutable) */ exports["equalPath"] = equalPath;
/* harmony export (immutable) */ exports["mapChildrenIntoArray"] = mapChildrenIntoArray;
/* harmony export (binding) */ __webpack_require__.d(exports, "UrlSerializer", function() { return UrlSerializer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DefaultUrlSerializer", function() { return DefaultUrlSerializer; });
/* harmony export (immutable) */ exports["serializePaths"] = serializePaths;
/* harmony export (immutable) */ exports["encode"] = encode;
/* harmony export (immutable) */ exports["decode"] = decode;
/* harmony export (immutable) */ exports["serializePath"] = serializePath;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


function createEmptyUrlTree() {
    return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
}
function containsTree(container, containee, exact) {
    if (exact) {
        return equalSegmentGroups(container.root, containee.root);
    }
    else {
        return containsSegmentGroup(container.root, containee.root);
    }
}
function equalSegmentGroups(container, containee) {
    if (!equalPath(container.segments, containee.segments))
        return false;
    if (container.numberOfChildren !== containee.numberOfChildren)
        return false;
    for (var c in containee.children) {
        if (!container.children[c])
            return false;
        if (!equalSegmentGroups(container.children[c], containee.children[c]))
            return false;
    }
    return true;
}
function containsSegmentGroup(container, containee) {
    return containsSegmentGroupHelper(container, containee, containee.segments);
}
function containsSegmentGroupHelper(container, containee, containeePaths) {
    if (container.segments.length > containeePaths.length) {
        var current = container.segments.slice(0, containeePaths.length);
        if (!equalPath(current, containeePaths))
            return false;
        if (containee.hasChildren())
            return false;
        return true;
    }
    else if (container.segments.length === containeePaths.length) {
        if (!equalPath(container.segments, containeePaths))
            return false;
        for (var c in containee.children) {
            if (!container.children[c])
                return false;
            if (!containsSegmentGroup(container.children[c], containee.children[c]))
                return false;
        }
        return true;
    }
    else {
        var current = containeePaths.slice(0, container.segments.length);
        var next = containeePaths.slice(container.segments.length);
        if (!equalPath(container.segments, current))
            return false;
        if (!container.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]])
            return false;
        return containsSegmentGroupHelper(container.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], containee, next);
    }
}
/**
 * @whatItDoes Represents the parsed URL.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree =
 * router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
 *     const f = tree.fragment; // return 'fragment'
 *     const q = tree.queryParams; // returns {debug: 'true'}
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
 *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
 *     g.children['support'].segments; // return 1 segment 'help'
 *   }
 * }
 * ```
 *
 * @description
 *
 * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
 * serialized tree.
 * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
 *
 * @stable
 */
var UrlTree = (function () {
    /**
     * @internal
     */
    function UrlTree(
        /**
        * The root segment group of the URL tree.
         */
        root, 
        /**
         * The query params of the URL.
         */
        queryParams, 
        /**
         * The fragment of the URL.
         */
        fragment) {
        this.root = root;
        this.queryParams = queryParams;
        this.fragment = fragment;
    }
    /**
     * @docsNotRequired
     */
    UrlTree.prototype.toString = function () { return new DefaultUrlSerializer().serialize(this); };
    return UrlTree;
}());
/**
 * @whatItDoes Represents the parsed URL segment.
 *
 * See {@link UrlTree} for more information.
 *
 * @stable
 */
var UrlSegmentGroup = (function () {
    function UrlSegmentGroup(
        /**
         * The URL segments of this group. See {@link UrlSegment} for more information.
         */
        segments, 
        /**
         * The list of children of this group.
         */
        children) {
        var _this = this;
        this.segments = segments;
        this.children = children;
        /**
         * The parent node in the url tree.
         */
        this.parent = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* forEach */])(children, function (v, k) { return v.parent = _this; });
    }
    /**
     * Return true if the segment has child segments
     */
    UrlSegmentGroup.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
    Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
        /**
         * Returns the number of child sements.
         */
        get: function () { return Object.keys(this.children).length; },
        enumerable: true,
        configurable: true
    });
    /**
     * @docsNotRequired
     */
    UrlSegmentGroup.prototype.toString = function () { return serializePaths(this); };
    return UrlSegmentGroup;
}());
/**
 * @whatItDoes Represents a single URL segment.
 *
 * @howToUse
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree = router.parseUrl('/team;id=33');
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments;
 *     s[0].path; // returns 'team'
 *     s[0].parameters; // returns {id: 33}
 *   }
 * }
 * ```
 *
 * @description
 *
 * A UrlSegment is a part of a URL between the two slashes. It contains a path and
 * the matrix parameters associated with the segment.
 *
 * @stable
 */
var UrlSegment = (function () {
    function UrlSegment(
        /**
         * The part part of a URL segment.
         */
        path, 
        /**
         * The matrix parameters associated with a segment.
         */
        parameters) {
        this.path = path;
        this.parameters = parameters;
    }
    /**
     * @docsNotRequired
     */
    UrlSegment.prototype.toString = function () { return serializePath(this); };
    return UrlSegment;
}());
function equalSegments(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (a[i].path !== b[i].path)
            return false;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["d" /* shallowEqual */])(a[i].parameters, b[i].parameters))
            return false;
    }
    return true;
}
function equalPath(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (a[i].path !== b[i].path)
            return false;
    }
    return true;
}
function mapChildrenIntoArray(segment, fn) {
    var res = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* forEach */])(segment.children, function (child, childOutlet) {
        if (childOutlet === __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* forEach */])(segment.children, function (child, childOutlet) {
        if (childOutlet !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    return res;
}
/**
 * @whatItDoes Serializes and deserializes a URL string into a URL tree.
 *
 * @description The url serialization strategy is customizable. You can
 * make all URLs case insensitive by providing a custom UrlSerializer.
 *
 * See {@link DefaultUrlSerializer} for an example of a URL serializer.
 *
 * @stable
 */
var UrlSerializer = (function () {
    function UrlSerializer() {
    }
    return UrlSerializer;
}());
/**
 * @whatItDoes A default implementation of the {@link UrlSerializer}.
 *
 * @description
 *
 * Example URLs:
 *
 * ```
 * /inbox/33(popup:compose)
 * /inbox/33;open=true/messages/44
 * ```
 *
 * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
 * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
 * specify route specific parameters.
 *
 * @stable
 */
var DefaultUrlSerializer = (function () {
    function DefaultUrlSerializer() {
    }
    /**
     * Parse a url into a {@link UrlTree}.
     */
    DefaultUrlSerializer.prototype.parse = function (url) {
        var p = new UrlParser(url);
        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
    };
    /**
     * Converts a {@link UrlTree} into a url.
     */
    DefaultUrlSerializer.prototype.serialize = function (tree) {
        var segment = "/" + serializeSegment(tree.root, true);
        var query = serializeQueryParams(tree.queryParams);
        var fragment = tree.fragment !== null && tree.fragment !== undefined ? "#" + encodeURI(tree.fragment) : '';
        return "" + segment + query + fragment;
    };
    return DefaultUrlSerializer;
}());
function serializePaths(segment) {
    return segment.segments.map(function (p) { return serializePath(p); }).join('/');
}
function serializeSegment(segment, root) {
    if (segment.hasChildren() && root) {
        var primary = segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] ?
            serializeSegment(segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], false) :
            '';
        var children_1 = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_collection__["c" /* forEach */])(segment.children, function (v, k) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
                children_1.push(k + ":" + serializeSegment(v, false));
            }
        });
        if (children_1.length > 0) {
            return primary + "(" + children_1.join('//') + ")";
        }
        else {
            return "" + primary;
        }
    }
    else if (segment.hasChildren() && !root) {
        var children = mapChildrenIntoArray(segment, function (v, k) {
            if (k === __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]) {
                return [serializeSegment(segment.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]], false)];
            }
            else {
                return [(k + ":" + serializeSegment(v, false))];
            }
        });
        return serializePaths(segment) + "/(" + children.join('//') + ")";
    }
    else {
        return serializePaths(segment);
    }
}
function encode(s) {
    return encodeURIComponent(s);
}
function decode(s) {
    return decodeURIComponent(s);
}
function serializePath(path) {
    return "" + encode(path.path) + serializeParams(path.parameters);
}
function serializeParams(params) {
    return pairs(params).map(function (p) { return (";" + encode(p.first) + "=" + encode(p.second)); }).join('');
}
function serializeQueryParams(params) {
    var strs = pairs(params).map(function (p) { return (encode(p.first) + "=" + encode(p.second)); });
    return strs.length > 0 ? "?" + strs.join("&") : '';
}
var Pair = (function () {
    function Pair(first, second) {
        this.first = first;
        this.second = second;
    }
    return Pair;
}());
function pairs(obj) {
    var res = [];
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            res.push(new Pair(prop, obj[prop]));
        }
    }
    return res;
}
var SEGMENT_RE = /^[^\/\(\)\?;=&#]+/;
function matchSegments(str) {
    SEGMENT_RE.lastIndex = 0;
    var match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_RE = /^[^=\?&#]+/;
function matchQueryParams(str) {
    QUERY_PARAM_RE.lastIndex = 0;
    var match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_VALUE_RE = /^[^\?&#]+/;
function matchUrlQueryParamValue(str) {
    QUERY_PARAM_VALUE_RE.lastIndex = 0;
    var match = str.match(QUERY_PARAM_VALUE_RE);
    return match ? match[0] : '';
}
var UrlParser = (function () {
    function UrlParser(url) {
        this.url = url;
        this.remaining = url;
    }
    UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
    UrlParser.prototype.capture = function (str) {
        if (!this.remaining.startsWith(str)) {
            throw new Error("Expected \"" + str + "\".");
        }
        this.remaining = this.remaining.substring(str.length);
    };
    UrlParser.prototype.parseRootSegment = function () {
        if (this.remaining.startsWith('/')) {
            this.capture('/');
        }
        if (this.remaining === '' || this.remaining.startsWith('?') || this.remaining.startsWith('#')) {
            return new UrlSegmentGroup([], {});
        }
        else {
            return new UrlSegmentGroup([], this.parseChildren());
        }
    };
    UrlParser.prototype.parseChildren = function () {
        if (this.remaining.length == 0) {
            return {};
        }
        if (this.peekStartsWith('/')) {
            this.capture('/');
        }
        var paths = [];
        if (!this.peekStartsWith('(')) {
            paths.push(this.parseSegments());
        }
        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
            this.capture('/');
            paths.push(this.parseSegments());
        }
        var children = {};
        if (this.peekStartsWith('/(')) {
            this.capture('/');
            children = this.parseParens(true);
        }
        var res = {};
        if (this.peekStartsWith('(')) {
            res = this.parseParens(false);
        }
        if (paths.length > 0 || Object.keys(children).length > 0) {
            res[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = new UrlSegmentGroup(paths, children);
        }
        return res;
    };
    UrlParser.prototype.parseSegments = function () {
        var path = matchSegments(this.remaining);
        if (path === '' && this.peekStartsWith(';')) {
            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
        }
        this.capture(path);
        var matrixParams = {};
        if (this.peekStartsWith(';')) {
            matrixParams = this.parseMatrixParams();
        }
        return new UrlSegment(decode(path), matrixParams);
    };
    UrlParser.prototype.parseQueryParams = function () {
        var params = {};
        if (this.peekStartsWith('?')) {
            this.capture('?');
            this.parseQueryParam(params);
            while (this.remaining.length > 0 && this.peekStartsWith('&')) {
                this.capture('&');
                this.parseQueryParam(params);
            }
        }
        return params;
    };
    UrlParser.prototype.parseFragment = function () {
        if (this.peekStartsWith('#')) {
            return decodeURI(this.remaining.substring(1));
        }
        else {
            return null;
        }
    };
    UrlParser.prototype.parseMatrixParams = function () {
        var params = {};
        while (this.remaining.length > 0 && this.peekStartsWith(';')) {
            this.capture(';');
            this.parseParam(params);
        }
        return params;
    };
    UrlParser.prototype.parseParam = function (params) {
        var key = matchSegments(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var value = '';
        if (this.peekStartsWith('=')) {
            this.capture('=');
            var valueMatch = matchSegments(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        params[decode(key)] = decode(value);
    };
    UrlParser.prototype.parseQueryParam = function (params) {
        var key = matchQueryParams(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var value = '';
        if (this.peekStartsWith('=')) {
            this.capture('=');
            var valueMatch = matchUrlQueryParamValue(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        params[decode(key)] = decode(value);
    };
    UrlParser.prototype.parseParens = function (allowPrimary) {
        var segments = {};
        this.capture('(');
        while (!this.peekStartsWith(')') && this.remaining.length > 0) {
            var path = matchSegments(this.remaining);
            var next = this.remaining[path.length];
            // if is is not one of these characters, then the segment was unescaped
            // or the group was not closed
            if (next !== '/' && next !== ')' && next !== ';') {
                throw new Error("Cannot parse url '" + this.url + "'");
            }
            var outletName = void 0;
            if (path.indexOf(':') > -1) {
                outletName = path.substr(0, path.indexOf(':'));
                this.capture(outletName);
                this.capture(':');
            }
            else if (allowPrimary) {
                outletName = __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */];
            }
            var children = this.parseChildren();
            segments[outletName] = Object.keys(children).length === 1 ? children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] :
                new UrlSegmentGroup([], children);
            if (this.peekStartsWith('//')) {
                this.capture('//');
            }
        }
        this.capture(')');
        return segments;
    };
    return UrlParser;
}());
//# sourceMappingURL=url_tree.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var base_cookie_options_1 = __webpack_require__(291);
var CookieService = (function () {
    function CookieService(_defaultOptions) {
        this._defaultOptions = _defaultOptions;
    }
    Object.defineProperty(CookieService.prototype, "cookieString", {
        get: function () {
            return document.cookie || '';
        },
        set: function (val) {
            document.cookie = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @name CookieService#get
     *
     * @description
     * Returns the value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {string} Raw cookie value.
     */
    CookieService.prototype.get = function (key) {
        return this._cookieReader()[key];
    };
    /**
     * @name CookieService#getObject
     *
     * @description
     * Returns the deserialized value of given cookie key.
     *
     * @param {string} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    CookieService.prototype.getObject = function (key) {
        var value = this.get(key);
        return value ? JSON.parse(value) : value;
    };
    /**
     * @name CookieService#getAll
     *
     * @description
     * Returns a key value object with all the cookies.
     *
     * @returns {Object} All cookies
     */
    CookieService.prototype.getAll = function () {
        return this._cookieReader();
    };
    /**
     * @name CookieService#put
     *
     * @description
     * Sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {string} value Raw value to be stored.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.put = function (key, value, options) {
        this._cookieWriter()(key, value, options);
    };
    /**
     * @name CookieService#putObject
     *
     * @description
     * Serializes and sets a value for given cookie key.
     *
     * @param {string} key Id for the `value`.
     * @param {Object} value Value to be stored.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.putObject = function (key, value, options) {
        this.put(key, JSON.stringify(value), options);
    };
    /**
     * @name CookieService#remove
     *
     * @description
     * Remove given cookie.
     *
     * @param {string} key Id of the key-value pair to delete.
     * @param {CookieOptionsArgs} options (Optional) Options object.
     */
    CookieService.prototype.remove = function (key, options) {
        this._cookieWriter()(key, undefined, options);
    };
    /**
     * @name CookieService#removeAll
     *
     * @description
     * Remove all cookies.
     */
    CookieService.prototype.removeAll = function () {
        var _this = this;
        var cookies = this.getAll();
        Object.keys(cookies).forEach(function (key) {
            _this.remove(key);
        });
    };
    CookieService.prototype._cookieReader = function () {
        var lastCookies = {};
        var lastCookieString = '';
        var that = this;
        var cookieArray, cookie, i, index, name;
        var currentCookieString = this.cookieString;
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookieArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookieArray.length; i++) {
                cookie = cookieArray[i];
                index = cookie.indexOf('=');
                if (index > 0) {
                    name = that._safeDecodeURIComponent(cookie.substring(0, index));
                    // the first value that is seen for a cookie is the most
                    // specific one.  values for the same cookie name that
                    // follow are for less specific paths.
                    if (this.isBlank(lastCookies[name])) {
                        lastCookies[name] = that._safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
        }
        return lastCookies;
    };
    CookieService.prototype._cookieWriter = function () {
        var that = this;
        return function (name, value, options) {
            that.cookieString = that._buildCookieString(name, value, options);
        };
    };
    CookieService.prototype._safeDecodeURIComponent = function (str) {
        try {
            return decodeURIComponent(str);
        }
        catch (e) {
            return str;
        }
    };
    CookieService.prototype._buildCookieString = function (name, value, options) {
        var cookiePath = '/';
        var path, expires;
        var defaultOpts = this._defaultOptions || new base_cookie_options_1.CookieOptions({ path: cookiePath });
        var opts = this._mergeOptions(defaultOpts, options);
        expires = opts.expires;
        if (this.isBlank(value)) {
            expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            value = '';
        }
        if (this.isString(expires)) {
            expires = new Date(expires);
        }
        var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? ';path=' + opts.path : '';
        str += opts.domain ? ';domain=' + opts.domain : '';
        str += expires ? ';expires=' + expires.toUTCString() : '';
        str += opts.secure ? ';secure' : '';
        // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
        // - 300 cookies
        // - 20 cookies per unique domain
        // - 4096 bytes per cookie
        var cookieLength = str.length + 1;
        if (cookieLength > 4096) {
            console.log("Cookie '" + name + "' possibly not set or overflowed because it was too \n      large (" + cookieLength + " > 4096 bytes)!");
        }
        return str;
    };
    CookieService.prototype._mergeOptions = function (defaultOpts, providedOpts) {
        var newOpts = defaultOpts;
        if (this.isPresent(providedOpts)) {
            return newOpts.merge(new base_cookie_options_1.CookieOptions(providedOpts));
        }
        return newOpts;
    };
    CookieService.prototype.isBlank = function (obj) {
        return obj === undefined || obj === null;
    };
    CookieService.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    CookieService.prototype.isString = function (obj) {
        return typeof obj === 'string';
    };
    CookieService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()), 
        __metadata('design:paramtypes', [base_cookie_options_1.CookieOptions])
    ], CookieService);
    return CookieService;
}());
exports.CookieService = CookieService;

//# sourceMappingURL=cookies.service.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(57);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgClass = (function () {
    function Wrapper_NgClass(p0, p1, p2, p3) {
        this.changed = false;
        this.context = new import0.NgClass(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_NgClass.prototype.check_klass = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.klass = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgClass.prototype.check_ngClass = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.ngClass = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_NgClass.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            this.context.ngDoCheck();
        }
        return changed;
    };
    Wrapper_NgClass.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgClass;
}());
exports.Wrapper_NgClass = Wrapper_NgClass;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(48);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgModel = (function () {
    function Wrapper_NgModel(p0, p1, p2, p3) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.NgModel(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
    }
    Wrapper_NgModel.prototype.check_name = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.name = currValue;
            this.changes['name'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgModel.prototype.check_isDisabled = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.isDisabled = currValue;
            this.changes['isDisabled'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_NgModel.prototype.check_model = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.model = currValue;
            this.changes['model'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_NgModel.prototype.check_options = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.options = currValue;
            this.changes['options'] = new import1.SimpleChange(this._expr_3, currValue);
            this._expr_3 = currValue;
        }
    };
    Wrapper_NgModel.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_NgModel.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgModel;
}());
exports.Wrapper_NgModel = Wrapper_NgModel;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
__webpack_require__(121);
var loading_indicator_1 = __webpack_require__(44);
var angular2_universal_1 = __webpack_require__(27);
var Content = (function (_super) {
    __extends(Content, _super);
    function Content(config, intl, metaService, contentService, route) {
        _super.call(this, true); // sets loading to true
        this.config = config;
        this.intl = intl;
        this.metaService = metaService;
        this.contentService = contentService;
        this.route = route;
    }
    Content.prototype.setMeta = function () {
        var title = this.content.title;
        if (this.content.title[this.currentLanguage] != null)
            title = this.content.title[this.currentLanguage];
        this.metaService.setMeta('Forgotten Records | ' + title, title, 'xxx');
    };
    Content.prototype.ngOnInit = function () {
        this.setContent();
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
    };
    Content.prototype.setContent = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.contentService.getContent(_this.type, { url: params['url'] }); })
            .subscribe(function (response) {
            _this.content = response;
            // Retrieve language from parent route
            _this.route.parent.params.subscribe(function (params) {
                _this.currentLanguage = params['lg'];
                _this.setMeta();
            });
        });
    };
    Content.prototype.getIntlInitObject = function () {
        var obj = {};
        for (var _i = 0, _a = this.config.data.APP.LANGUAGES.SUPPORTED; _i < _a.length; _i++) {
            var lg = _a[_i];
            obj[lg] = '';
        }
        return obj;
    };
    Content.prototype.setType = function (type) {
        this.type = type;
    };
    Content.prototype.setContentAsync = function () {
        var _this = this;
        this.contentAsync = this.route.params.switchMap(function (params) {
            return _this.contentService.getContent(_this.type, { url: params['url'] });
        });
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
    };
    Content.prototype.setContentByIdAsync = function () {
        var _this = this;
        this.contentAsync = this.route.params.switchMap(function (params) {
            return _this.contentService.getContent(_this.type, { _id: params['id'] });
        });
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
    };
    // Also set the current language
    Content.prototype.setCurrentLanguage = function () {
        var _this = this;
        // Language is made available by the root parent route
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
            _this.metaService.setLanguage(_this.currentLanguage);
        });
    };
    Content.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }
    };
    return Content;
}(loading_indicator_1.LoadingPage));
exports.Content = Content;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "UpperCasePipe", function() { return UpperCasePipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 * @whatItDoes Transforms string to uppercase.
 * @howToUse `expression | uppercase`
 * @description
 *
 * Converts value into lowercase string using `String.prototype.toUpperCase()`.
 *
 * ### Example
 *
 * {@example common/pipes/ts/lowerupper_pipe.ts region='LowerUpperPipe'}
 *
 * @stable
 */
var UpperCasePipe = (function () {
    function UpperCasePipe() {
    }
    UpperCasePipe.prototype.transform = function (value) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value))
            return value;
        if (typeof value !== 'string') {
            throw new __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](UpperCasePipe, value);
        }
        return value.toUpperCase();
    };
    UpperCasePipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'uppercase' },] },
    ];
    /** @nocollapse */
    UpperCasePipe.ctorParameters = [];
    return UpperCasePipe;
}());
//# sourceMappingURL=uppercase_pipe.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "NoComponentFactoryError", function() { return NoComponentFactoryError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ComponentFactoryResolver", function() { return ComponentFactoryResolver; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CodegenComponentFactoryResolver", function() { return CodegenComponentFactoryResolver; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * @stable
 */
var NoComponentFactoryError = (function (_super) {
    __extends(NoComponentFactoryError, _super);
    function NoComponentFactoryError(component) {
        _super.call(this, "No component factory found for " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(component));
        this.component = component;
    }
    return NoComponentFactoryError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
var _NullComponentFactoryResolver = (function () {
    function _NullComponentFactoryResolver() {
    }
    _NullComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        throw new NoComponentFactoryError(component);
    };
    return _NullComponentFactoryResolver;
}());
/**
 * @stable
 */
var ComponentFactoryResolver = (function () {
    function ComponentFactoryResolver() {
    }
    ComponentFactoryResolver.NULL = new _NullComponentFactoryResolver();
    return ComponentFactoryResolver;
}());
var CodegenComponentFactoryResolver = (function () {
    function CodegenComponentFactoryResolver(factories, _parent) {
        this._parent = _parent;
        this._factories = new Map();
        for (var i = 0; i < factories.length; i++) {
            var factory = factories[i];
            this._factories.set(factory.componentType, factory);
        }
    }
    CodegenComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        var result = this._factories.get(component);
        if (!result) {
            result = this._parent.resolveComponentFactory(component);
        }
        return result;
    };
    return CodegenComponentFactoryResolver;
}());
//# sourceMappingURL=component_factory_resolver.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "EVENT_MANAGER_PLUGINS", function() { return EVENT_MANAGER_PLUGINS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "EventManager", function() { return EventManager; });
/* harmony export (binding) */ __webpack_require__.d(exports, "EventManagerPlugin", function() { return EventManagerPlugin; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @stable
 */
var EVENT_MANAGER_PLUGINS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('EventManagerPlugins');
/**
 * @stable
 */
var EventManager = (function () {
    function EventManager(plugins, _zone) {
        var _this = this;
        this._zone = _zone;
        plugins.forEach(function (p) { return p.manager = _this; });
        this._plugins = plugins.slice().reverse();
    }
    EventManager.prototype.addEventListener = function (element, eventName, handler) {
        var plugin = this._findPluginFor(eventName);
        return plugin.addEventListener(element, eventName, handler);
    };
    EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
        var plugin = this._findPluginFor(eventName);
        return plugin.addGlobalEventListener(target, eventName, handler);
    };
    EventManager.prototype.getZone = function () { return this._zone; };
    /** @internal */
    EventManager.prototype._findPluginFor = function (eventName) {
        var plugins = this._plugins;
        for (var i = 0; i < plugins.length; i++) {
            var plugin = plugins[i];
            if (plugin.supports(eventName)) {
                return plugin;
            }
        }
        throw new Error("No event manager plugin found for event " + eventName);
    };
    EventManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    EventManager.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [EVENT_MANAGER_PLUGINS,] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ];
    return EventManager;
}());
var EventManagerPlugin = (function () {
    function EventManagerPlugin() {
    }
    // That is equivalent to having supporting $event.target
    EventManagerPlugin.prototype.supports = function (eventName) { return false; };
    EventManagerPlugin.prototype.addEventListener = function (element, eventName, handler) {
        throw 'not implemented';
    };
    EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
        throw 'not implemented';
    };
    return EventManagerPlugin;
}());
//# sourceMappingURL=event_manager.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(47);
var Wrapper_DefaultValueAccessor = (function () {
    function Wrapper_DefaultValueAccessor(p0, p1) {
        this.changed = false;
        this.context = new import0.DefaultValueAccessor(p0, p1);
    }
    Wrapper_DefaultValueAccessor.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_DefaultValueAccessor.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_DefaultValueAccessor;
}());
exports.Wrapper_DefaultValueAccessor = Wrapper_DefaultValueAccessor;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
//import { CookieService } from 'angular2-cookie/core';
var http_1 = __webpack_require__(62);
__webpack_require__(122);
var AuthService = (function () {
    function AuthService(http) {
        this.http = http;
        this.adminDefaultUser = 'admin';
        this.in = '/api/login';
        this.out = '/api/logout';
        this.check = '/api/isLoggedIn/' + this.adminDefaultUser;
    }
    AuthService.prototype.login = function (credentials) {
        var _this = this;
        return this.http.post(this.in, credentials)
            .toPromise()
            .then(function (response) {
            _this.isLoggedIn = true;
            _this.loggedInUser = response.text();
        }) // returns the user (string)
            .catch(this.handleError);
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        return this.http.get(this.out)
            .toPromise()
            .then(function (response) {
            _this.isLoggedIn = false;
            _this.loggedInUser = null;
        })
            .catch(this.handleError);
    };
    AuthService.prototype.handleError = function (error) {
        console.error('Auth API error', error);
        return Promise.reject(error.message || error);
    };
    AuthService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], AuthService);
    return AuthService;
    var _a;
}());
exports.AuthService = AuthService;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var ArrayObservable_1 = __webpack_require__(184);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "LocationStrategy", function() { return LocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "APP_BASE_HREF", function() { return APP_BASE_HREF; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * `LocationStrategy` is responsible for representing and reading route state
 * from the browser's URL. Angular provides two strategies:
 * {@link HashLocationStrategy} and {@link PathLocationStrategy} (default).
 *
 * This is used under the hood of the {@link Location} service.
 *
 * Applications should use the {@link Router} or {@link Location} services to
 * interact with application route state.
 *
 * For instance, {@link HashLocationStrategy} produces URLs like
 * `http://example.com#/foo`, and {@link PathLocationStrategy} produces
 * `http://example.com/foo` as an equivalent URL.
 *
 * See these two classes for more.
 *
 * @stable
 */
var LocationStrategy = (function () {
    function LocationStrategy() {
    }
    return LocationStrategy;
}());
/**
 * The `APP_BASE_HREF` token represents the base href to be used with the
 * {@link PathLocationStrategy}.
 *
 * If you're using {@link PathLocationStrategy}, you must provide a provider to a string
 * representing the URL prefix that should be preserved when generating and recognizing
 * URLs.
 *
 * ### Example
 *
 * ```typescript
 * import {Component, NgModule} from '@angular/core';
 * import {APP_BASE_HREF} from '@angular/common';
 *
 * @NgModule({
 *   providers: [{provide: APP_BASE_HREF, useValue: '/my/app'}]
 * })
 * class AppModule {}
 * ```
 *
 * @stable
 */
var APP_BASE_HREF = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('appBaseHref');
//# sourceMappingURL=location_strategy.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "ComponentStillLoadingError", function() { return ComponentStillLoadingError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ModuleWithComponentFactories", function() { return ModuleWithComponentFactories; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Compiler", function() { return Compiler; });
/* harmony export (binding) */ __webpack_require__.d(exports, "COMPILER_OPTIONS", function() { return COMPILER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CompilerFactory", function() { return CompilerFactory; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * Indicates that a component is still being loaded in a synchronous compile.
 *
 * @stable
 */
var ComponentStillLoadingError = (function (_super) {
    __extends(ComponentStillLoadingError, _super);
    function ComponentStillLoadingError(compType) {
        _super.call(this, "Can't compile synchronously as " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["b" /* stringify */])(compType) + " is still being loaded!");
        this.compType = compType;
    }
    return ComponentStillLoadingError;
}(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["b" /* BaseError */]));
/**
 * Combination of NgModuleFactory and ComponentFactorys.
 *
 * @experimental
 */
var ModuleWithComponentFactories = (function () {
    function ModuleWithComponentFactories(ngModuleFactory, componentFactories) {
        this.ngModuleFactory = ngModuleFactory;
        this.componentFactories = componentFactories;
    }
    return ModuleWithComponentFactories;
}());
function _throwError() {
    throw new Error("Runtime compiler is not loaded");
}
/**
 * Low-level service for running the angular compiler during runtime
 * to create {@link ComponentFactory}s, which
 * can later be used to create and render a Component instance.
 *
 * Each `@NgModule` provides an own `Compiler` to its injector,
 * that will use the directives/pipes of the ng module for compilation
 * of components.
 * @stable
 */
var Compiler = (function () {
    function Compiler() {
    }
    /**
     * Compiles the given NgModule and all of its components. All templates of the components listed
     * in `entryComponents`
     * have to be inlined. Otherwise throws a {@link ComponentStillLoadingError}.
     */
    Compiler.prototype.compileModuleSync = function (moduleType) { throw _throwError(); };
    /**
     * Compiles the given NgModule and all of its components
     */
    Compiler.prototype.compileModuleAsync = function (moduleType) { throw _throwError(); };
    /**
     * Same as {@link compileModuleSync} but also creates ComponentFactories for all components.
     */
    Compiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Same as {@link compileModuleAsync} but also creates ComponentFactories for all components.
     */
    Compiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Clears all caches.
     */
    Compiler.prototype.clearCache = function () { };
    /**
     * Clears the cache for the given component/ngModule.
     */
    Compiler.prototype.clearCacheFor = function (type) { };
    return Compiler;
}());
/**
 * Token to provide CompilerOptions in the platform injector.
 *
 * @experimental
 */
var COMPILER_OPTIONS = new __WEBPACK_IMPORTED_MODULE_0__di__["a" /* OpaqueToken */]('compilerOptions');
/**
 * A factory for creating a Compiler
 *
 * @experimental
 */
var CompilerFactory = (function () {
    function CompilerFactory() {
    }
    return CompilerFactory;
}());
//# sourceMappingURL=compiler.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (immutable) */ exports["d"] = Class;
/* harmony export (immutable) */ exports["c"] = makeDecorator;
/* harmony export (immutable) */ exports["a"] = makeParamDecorator;
/* harmony export (immutable) */ exports["b"] = makePropDecorator;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var _nextClassId = 0;
var Reflect = __WEBPACK_IMPORTED_MODULE_0__facade_lang__["a" /* global */].Reflect;
function extractAnnotation(annotation) {
    if (typeof annotation === 'function' && annotation.hasOwnProperty('annotation')) {
        // it is a decorator, extract annotation
        annotation = annotation.annotation;
    }
    return annotation;
}
function applyParams(fnOrArray, key) {
    if (fnOrArray === Object || fnOrArray === String || fnOrArray === Function ||
        fnOrArray === Number || fnOrArray === Array) {
        throw new Error("Can not use native " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(fnOrArray) + " as constructor");
    }
    if (typeof fnOrArray === 'function') {
        return fnOrArray;
    }
    if (Array.isArray(fnOrArray)) {
        var annotations = fnOrArray;
        var annoLength = annotations.length - 1;
        var fn = fnOrArray[annoLength];
        if (typeof fn !== 'function') {
            throw new Error("Last position of Class method array must be Function in key " + key + " was '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(fn) + "'");
        }
        if (annoLength != fn.length) {
            throw new Error("Number of annotations (" + annoLength + ") does not match number of arguments (" + fn.length + ") in the function: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(fn));
        }
        var paramsAnnotations = [];
        for (var i = 0, ii = annotations.length - 1; i < ii; i++) {
            var paramAnnotations = [];
            paramsAnnotations.push(paramAnnotations);
            var annotation = annotations[i];
            if (Array.isArray(annotation)) {
                for (var j = 0; j < annotation.length; j++) {
                    paramAnnotations.push(extractAnnotation(annotation[j]));
                }
            }
            else if (typeof annotation === 'function') {
                paramAnnotations.push(extractAnnotation(annotation));
            }
            else {
                paramAnnotations.push(annotation);
            }
        }
        Reflect.defineMetadata('parameters', paramsAnnotations, fn);
        return fn;
    }
    throw new Error("Only Function or Array is supported in Class definition for key '" + key + "' is '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(fnOrArray) + "'");
}
/**
 * Provides a way for expressing ES6 classes with parameter annotations in ES5.
 *
 * ## Basic Example
 *
 * ```
 * var Greeter = ng.Class({
 *   constructor: function(name) {
 *     this.name = name;
 *   },
 *
 *   greet: function() {
 *     alert('Hello ' + this.name + '!');
 *   }
 * });
 * ```
 *
 * is equivalent to ES6:
 *
 * ```
 * class Greeter {
 *   constructor(name) {
 *     this.name = name;
 *   }
 *
 *   greet() {
 *     alert('Hello ' + this.name + '!');
 *   }
 * }
 * ```
 *
 * or equivalent to ES5:
 *
 * ```
 * var Greeter = function (name) {
 *   this.name = name;
 * }
 *
 * Greeter.prototype.greet = function () {
 *   alert('Hello ' + this.name + '!');
 * }
 * ```
 *
 * ### Example with parameter annotations
 *
 * ```
 * var MyService = ng.Class({
 *   constructor: [String, [new Optional(), Service], function(name, myService) {
 *     ...
 *   }]
 * });
 * ```
 *
 * is equivalent to ES6:
 *
 * ```
 * class MyService {
 *   constructor(name: string, @Optional() myService: Service) {
 *     ...
 *   }
 * }
 * ```
 *
 * ### Example with inheritance
 *
 * ```
 * var Shape = ng.Class({
 *   constructor: (color) {
 *     this.color = color;
 *   }
 * });
 *
 * var Square = ng.Class({
 *   extends: Shape,
 *   constructor: function(color, size) {
 *     Shape.call(this, color);
 *     this.size = size;
 *   }
 * });
 * ```
 * @stable
 */
function Class(clsDef) {
    var constructor = applyParams(clsDef.hasOwnProperty('constructor') ? clsDef.constructor : undefined, 'constructor');
    var proto = constructor.prototype;
    if (clsDef.hasOwnProperty('extends')) {
        if (typeof clsDef.extends === 'function') {
            constructor.prototype = proto =
                Object.create(clsDef.extends.prototype);
        }
        else {
            throw new Error("Class definition 'extends' property must be a constructor function was: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(clsDef.extends));
        }
    }
    for (var key in clsDef) {
        if (key !== 'extends' && key !== 'prototype' && clsDef.hasOwnProperty(key)) {
            proto[key] = applyParams(clsDef[key], key);
        }
    }
    if (this && this.annotations instanceof Array) {
        Reflect.defineMetadata('annotations', this.annotations, constructor);
    }
    var constructorName = constructor['name'];
    if (!constructorName || constructorName === 'constructor') {
        constructor['overriddenName'] = "class" + _nextClassId++;
    }
    return constructor;
}
function makeDecorator(name, props, parentClass, chainFn) {
    if (chainFn === void 0) { chainFn = null; }
    var metaCtor = makeMetadataCtor([props]);
    function DecoratorFactory(objOrType) {
        if (!(Reflect && Reflect.getMetadata)) {
            throw 'reflect-metadata shim is required when using class decorators';
        }
        if (this instanceof DecoratorFactory) {
            metaCtor.call(this, objOrType);
            return this;
        }
        var annotationInstance = new DecoratorFactory(objOrType);
        var chainAnnotation = typeof this === 'function' && Array.isArray(this.annotations) ? this.annotations : [];
        chainAnnotation.push(annotationInstance);
        var TypeDecorator = function TypeDecorator(cls) {
            var annotations = Reflect.getOwnMetadata('annotations', cls) || [];
            annotations.push(annotationInstance);
            Reflect.defineMetadata('annotations', annotations, cls);
            return cls;
        };
        TypeDecorator.annotations = chainAnnotation;
        TypeDecorator.Class = Class;
        if (chainFn)
            chainFn(TypeDecorator);
        return TypeDecorator;
    }
    if (parentClass) {
        DecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    DecoratorFactory.prototype.toString = function () { return ("@" + name); };
    DecoratorFactory.annotationCls = DecoratorFactory;
    return DecoratorFactory;
}
function makeMetadataCtor(props) {
    return function ctor() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        props.forEach(function (prop, i) {
            var argVal = args[i];
            if (Array.isArray(prop)) {
                // plain parameter
                _this[prop[0]] = argVal === undefined ? prop[1] : argVal;
            }
            else {
                for (var propName in prop) {
                    _this[propName] =
                        argVal && argVal.hasOwnProperty(propName) ? argVal[propName] : prop[propName];
                }
            }
        });
    };
}
function makeParamDecorator(name, props, parentClass) {
    var metaCtor = makeMetadataCtor(props);
    function ParamDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        if (this instanceof ParamDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var annotationInstance = new ((_a = ParamDecoratorFactory).bind.apply(_a, [void 0].concat(args)))();
        ParamDecorator.annotation = annotationInstance;
        return ParamDecorator;
        function ParamDecorator(cls, unusedKey, index) {
            var parameters = Reflect.getMetadata('parameters', cls) || [];
            // there might be gaps if some in between parameters do not have annotations.
            // we pad with nulls.
            while (parameters.length <= index) {
                parameters.push(null);
            }
            parameters[index] = parameters[index] || [];
            parameters[index].push(annotationInstance);
            Reflect.defineMetadata('parameters', parameters, cls);
            return cls;
        }
        var _a;
    }
    if (parentClass) {
        ParamDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    ParamDecoratorFactory.prototype.toString = function () { return ("@" + name); };
    ParamDecoratorFactory.annotationCls = ParamDecoratorFactory;
    return ParamDecoratorFactory;
}
function makePropDecorator(name, props, parentClass) {
    var metaCtor = makeMetadataCtor(props);
    function PropDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        if (this instanceof PropDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var decoratorInstance = new ((_a = PropDecoratorFactory).bind.apply(_a, [void 0].concat(args)))();
        return function PropDecorator(target, name) {
            var meta = Reflect.getOwnMetadata('propMetadata', target.constructor) || {};
            meta[name] = meta.hasOwnProperty(name) && meta[name] || [];
            meta[name].unshift(decoratorInstance);
            Reflect.defineMetadata('propMetadata', meta, target.constructor);
        };
        var _a;
    }
    if (parentClass) {
        PropDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    PropDecoratorFactory.prototype.toString = function () { return ("@" + name); };
    PropDecoratorFactory.annotationCls = PropDecoratorFactory;
    return PropDecoratorFactory;
}
//# sourceMappingURL=decorators.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(28);
/* harmony export (binding) */ __webpack_require__.d(exports, "RADIO_VALUE_ACCESSOR", function() { return RADIO_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RadioControlRegistry", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return RadioControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var RADIO_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    RadioControlRegistry.prototype.remove = function (accessor) {
        var indexToRemove = -1;
        for (var i = 0; i < this._accessors.length; ++i) {
            if (this._accessors[i][1] === accessor) {
                indexToRemove = i;
            }
        }
        this._accessors.splice(indexToRemove, 1);
    };
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = [];
    return RadioControlRegistry;
}());
/**
 * @whatItDoes  Writes radio control values and listens to radio control changes.
 *
 * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
 * to keep the view synced with the {@link FormControl} model.
 *
 * @howToUse
 *
 * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `@angular/forms`
 *
 *  @stable
 */
var RadioControlValueAccessor = (function () {
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(__WEBPACK_IMPORTED_MODULE_2__ng_control__["NgControl"]);
        this._checkName();
        this._registry.add(this._control, this);
    };
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ];
    RadioControlValueAccessor.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());
//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "ConnectionBackend", function() { return ConnectionBackend; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Connection", function() { return Connection; });
/* harmony export (binding) */ __webpack_require__.d(exports, "XSRFStrategy", function() { return XSRFStrategy; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Abstract class from which real backends are derived.
 *
 * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
 * {@link Request}.
 *
 * @experimental
 */
var ConnectionBackend = (function () {
    function ConnectionBackend() {
    }
    return ConnectionBackend;
}());
/**
 * Abstract class from which real connections are derived.
 *
 * @experimental
 */
var Connection = (function () {
    function Connection() {
    }
    return Connection;
}());
/**
 * An XSRFStrategy configures XSRF protection (e.g. via headers) on an HTTP request.
 *
 * @experimental
 */
var XSRFStrategy = (function () {
    function XSRFStrategy() {
    }
    return XSRFStrategy;
}());
//# sourceMappingURL=interfaces.js.map

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_outlet_map__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared__ = __webpack_require__(58);
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterOutlet", function() { return RouterOutlet; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @whatItDoes Acts as a placeholder that Angular dynamically fills based on the current router
 * state.
 *
 * @howToUse
 *
 * ```
 * <router-outlet></router-outlet>
 * <router-outlet name='left'></router-outlet>
 * <router-outlet name='right'></router-outlet>
 * ```
 *
 * A router outlet will emit an activate event any time a new component is being instantiated,
 * and a deactivate event when it is being destroyed.
 *
 * ```
 * <router-outlet
 *   (activate)='onActivate($event)'
 *   (deactivate)='onDeactivate($event)'></router-outlet>
 * ```
 * @selector 'a[routerLink]'
 * @ngModule RouterModule
 *
 * @stable
 */
var RouterOutlet = (function () {
    function RouterOutlet(parentOutletMap, location, resolver, name) {
        this.parentOutletMap = parentOutletMap;
        this.location = location;
        this.resolver = resolver;
        this.name = name;
        this.activateEvents = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.deactivateEvents = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        parentOutletMap.registerOutlet(name ? name : __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* PRIMARY_OUTLET */], this);
    }
    RouterOutlet.prototype.ngOnDestroy = function () { this.parentOutletMap.removeOutlet(this.name ? this.name : __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* PRIMARY_OUTLET */]); };
    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
        get: function () { return !!this.activated; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "component", {
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this.activated.instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this._activatedRoute;
        },
        enumerable: true,
        configurable: true
    });
    RouterOutlet.prototype.deactivate = function () {
        if (this.activated) {
            var c = this.component;
            this.activated.destroy();
            this.activated = null;
            this.deactivateEvents.emit(c);
        }
    };
    RouterOutlet.prototype.activate = function (activatedRoute, loadedResolver, loadedInjector, providers, outletMap) {
        if (this.isActivated) {
            throw new Error('Cannot activate an already activated outlet');
        }
        this.outletMap = outletMap;
        this._activatedRoute = activatedRoute;
        var snapshot = activatedRoute._futureSnapshot;
        var component = snapshot._routeConfig.component;
        var factory;
        if (loadedResolver) {
            factory = loadedResolver.resolveComponentFactory(component);
        }
        else {
            factory = this.resolver.resolveComponentFactory(component);
        }
        var injector = loadedInjector ? loadedInjector : this.location.parentInjector;
        var inj = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].fromResolvedProviders(providers, injector);
        this.activated = this.location.createComponent(factory, this.location.length, inj, []);
        this.activated.changeDetectorRef.detectChanges();
        this.activateEvents.emit(this.activated.instance);
    };
    RouterOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'router-outlet' },] },
    ];
    /** @nocollapse */
    RouterOutlet.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__router_outlet_map__["RouterOutletMap"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['name',] },] },
    ];
    RouterOutlet.propDecorators = {
        'activateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['activate',] },],
        'deactivateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['deactivate',] },],
    };
    return RouterOutlet;
}());
//# sourceMappingURL=router_outlet.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_collection__ = __webpack_require__(63);
/* harmony export (binding) */ __webpack_require__.d(exports, "ROUTES", function() { return ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "LoadedRouterConfig", function() { return LoadedRouterConfig; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterConfigLoader", function() { return RouterConfigLoader; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * @experimental
 */
var ROUTES = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('ROUTES');
var LoadedRouterConfig = (function () {
    function LoadedRouterConfig(routes, injector, factoryResolver) {
        this.routes = routes;
        this.injector = injector;
        this.factoryResolver = factoryResolver;
    }
    return LoadedRouterConfig;
}());
var RouterConfigLoader = (function () {
    function RouterConfigLoader(loader, compiler) {
        this.loader = loader;
        this.compiler = compiler;
    }
    RouterConfigLoader.prototype.load = function (parentInjector, loadChildren) {
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(this.loadModuleFactory(loadChildren), function (r) {
            var ref = r.create(parentInjector);
            return new LoadedRouterConfig(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["a" /* flatten */])(ref.injector.get(ROUTES)), ref.injector, ref.componentFactoryResolver);
        });
    };
    RouterConfigLoader.prototype.loadModuleFactory = function (loadChildren) {
        var _this = this;
        if (typeof loadChildren === 'string') {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__["fromPromise"])(this.loader.load(loadChildren));
        }
        else {
            var offlineMode_1 = this.compiler instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"];
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_mergeMap__["mergeMap"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["b" /* wrapIntoObservable */])(loadChildren()), function (t) { return offlineMode_1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(t) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_fromPromise__["fromPromise"])(_this.compiler.compileModuleAsync(t)); });
        }
    };
    return RouterConfigLoader;
}());
//# sourceMappingURL=router_config_loader.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var PaginationComponent = (function () {
    function PaginationComponent() {
        this.offset = 3;
        this.pageChange = new core_1.EventEmitter();
        this.pageList = [];
    }
    /**
     * On changes
     * @param changes
     */
    PaginationComponent.prototype.ngOnChanges = function (changes) {
        this.selectedPageNo = this.currentPage;
        this.doPaging();
    };
    /**
     * Do paging
     */
    PaginationComponent.prototype.doPaging = function () {
        this.pageList = [];
        this.selectedPageNo = this.selectedPageNo || 1;
        var i = 1, count = 0;
        var remaining = this.totalItems % this.pageSize;
        this.totalSize = Math.round(((this.totalItems - remaining) / this.pageSize) + (remaining === 0 ? 0 : 1));
        if (this.selectedPageNo > this.totalSize - this.offset) {
            i = this.totalSize - this.offset * 2;
            i = i <= 0 ? 1 : i;
        }
        else if (this.selectedPageNo > this.offset) {
            i = this.selectedPageNo - this.offset;
        }
        for (count = 0; i <= this.totalSize && count < 7; i++, count++) {
            this.pageList.push(i);
        }
        //next validation
        if (i - 1 < this.totalSize) {
            this.nextItemValid = true;
        }
        else {
            this.nextItemValid = false;
        }
        //previous validation
        if ((this.selectedPageNo) > 1) {
            this.previousItemValid = true;
        }
        else {
            this.previousItemValid = false;
        }
    };
    /**
     * Set current page
     * @param pageNo
     */
    PaginationComponent.prototype.setCurrentPage = function (pageNo) {
        this.selectedPageNo = pageNo;
        this.pageChageListner();
        this.doPaging();
    };
    /**
     * Go to first page
     */
    PaginationComponent.prototype.firstPage = function () {
        this.selectedPageNo = 1;
        this.pageChageListner();
        this.doPaging();
    };
    /**
     * Go to last page
     */
    PaginationComponent.prototype.lastPage = function () {
        var totalPages = (this.totalItems / this.pageSize);
        var lastPage = (totalPages) - (totalPages % this.pageSize === 0 ? this.pageSize : totalPages % this.pageSize) + 1;
        this.selectedPageNo = this.totalSize;
        this.pageChageListner();
        this.doPaging();
    };
    /**
     * Go to next page
     */
    PaginationComponent.prototype.nextPage = function () {
        this.selectedPageNo = this.selectedPageNo + 1; //pageNo;
        this.pageChageListner();
        this.doPaging();
    };
    /**
     * Go to previous page
     */
    PaginationComponent.prototype.previousPage = function () {
        this.selectedPageNo = this.selectedPageNo - 1; //page > 0 ? page : 1;
        this.pageChageListner();
        this.doPaging();
    };
    // writeValue(value: string): void {
    //     if (!value && value != '0') return;
    //     this.setValue(value);
    // }
    //
    // setValue(currentValue: any) {
    //     this.selectedPageNo = currentValue;
    //     this.doPaging();
    // }
    /**
     * Page listener
     */
    PaginationComponent.prototype.pageChageListner = function () {
        this.pageChange.emit({
            currentPage: this.selectedPageNo
        });
    };
    __decorate([
        core_1.Input("previous-text"), 
        __metadata('design:type', String)
    ], PaginationComponent.prototype, "previousText", void 0);
    __decorate([
        core_1.Input("next-text"), 
        __metadata('design:type', String)
    ], PaginationComponent.prototype, "nextText", void 0);
    __decorate([
        core_1.Input("first-text"), 
        __metadata('design:type', String)
    ], PaginationComponent.prototype, "firstText", void 0);
    __decorate([
        core_1.Input("last-text"), 
        __metadata('design:type', String)
    ], PaginationComponent.prototype, "lastText", void 0);
    __decorate([
        core_1.Input("totalItems"), 
        __metadata('design:type', Number)
    ], PaginationComponent.prototype, "totalItems", void 0);
    __decorate([
        core_1.Input("currentPage"), 
        __metadata('design:type', Number)
    ], PaginationComponent.prototype, "currentPage", void 0);
    __decorate([
        core_1.Input("pageSize"), 
        __metadata('design:type', Number)
    ], PaginationComponent.prototype, "pageSize", void 0);
    __decorate([
        core_1.Input("offset"), 
        __metadata('design:type', Number)
    ], PaginationComponent.prototype, "offset", void 0);
    __decorate([
        core_1.Output("pageChange"), 
        __metadata('design:type', Object)
    ], PaginationComponent.prototype, "pageChange", void 0);
    PaginationComponent = __decorate([
        core_1.Component({
            //moduleId: module.id,
            selector: 'ng-pagination',
            template: __webpack_require__(470)
        }), 
        __metadata('design:paramtypes', [])
    ], PaginationComponent);
    return PaginationComponent;
}());
exports.PaginationComponent = PaginationComponent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var HtmlEditorComponent = (function () {
    function HtmlEditorComponent() {
        this.onEditorKeyup = new core_1.EventEmitter();
    }
    HtmlEditorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        //console.log('A',this.model);
        tinymce.init({
            selector: '#' + this.elementId,
            //selector: "[editorId='"+this.editorId+"']",
            plugins: ['image', 'link', 'paste', 'table', 'code'],
            menubar: false,
            toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright | link image | table | code',
            skin_url: '/resources_admin/css/skins/light',
            content_css: ['/resources_front/assets/css/bootstrap.css',
                '/resources_front/assets/css/et-line-icons.css',
                '/resources_front/assets/css/font-awesome.min.css',
                '/resources_front/assets/css/settings.css',
                '/resources_shared/assets/fonts/montserrat-v10-latin.css',
                '/resources_front/assets/css/style.css',
                '/resources_front/assets/custom/front.css',
                '/resources_front/assets/css/responsive.css',
                '/resources_shared/assets/css/footnotes.css'],
            content_style: "img {max-width: 500px}",
            relative_urls: false,
            extended_valid_elements: "sup[text]",
            setup: function (editor) {
                // Data binding
                _this.editor = editor;
                editor.on('MouseLeave', function () {
                    var content = editor.getContent();
                    _this.onEditorKeyup.emit(content);
                });
            },
        });
    };
    HtmlEditorComponent.prototype.ngOnDestroy = function () {
        tinymce.remove(this.editor);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], HtmlEditorComponent.prototype, "elementId", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], HtmlEditorComponent.prototype, "initText", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], HtmlEditorComponent.prototype, "height", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], HtmlEditorComponent.prototype, "onEditorKeyup", void 0);
    HtmlEditorComponent = __decorate([
        core_1.Component({
            selector: 'html-editor',
            template: "<textarea [ngStyle]=\"{'height.em': height}\" id=\"{{elementId}}\">{{initText}}</textarea>"
        }), 
        __metadata('design:paramtypes', [])
    ], HtmlEditorComponent);
    return HtmlEditorComponent;
}());
exports.HtmlEditorComponent = HtmlEditorComponent;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var content_service_1 = __webpack_require__(9);
var search_service_1 = __webpack_require__(30);
var utils_service_1 = __webpack_require__(2);
var loading_indicator_1 = __webpack_require__(44);
var SearchableContentsComponent = (function (_super) {
    __extends(SearchableContentsComponent, _super);
    function SearchableContentsComponent(contentService, searchService, utils, route, router, es) {
        _super.call(this, true); // sets loading to true
        this.contentService = contentService;
        this.searchService = searchService;
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.noCache = false;
        this.esFilters = [];
        this.aggFields = {
            record: ['type', 'soloist', 'composer', 'conductor', 'instrument'],
            writing: ['language', 'tag', 'author'],
        };
    }
    SearchableContentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // FRONT: Initial entry into a catalogue type with nice urls
        this.route.params.subscribe(function (params) {
            // Entry 
            if (params['type'] != null || params['field'] != null) {
                // Entry field (e.g composer/mozart)
                if (params['field'] != null && params['value'] != null) {
                    _this.entryField = params['field'];
                    var filter = JSON.parse('{"' + _this.entryField + '": "' + params['value'] + '"}');
                    _this.esFilters = _this.utils.filtersToEsFilters([filter], '.raw');
                }
                else 
                // Entry type
                if (params['type'] != null) {
                    _this.entryType = params['type'];
                    _this.esFilters = _this.utils.filtersToEsFilters([{ type: _this.entryType }], '.raw');
                }
                if (_this.active)
                    _this.es.addFilterActive(_this.esFilters, _this.active);
                _this.es.setFilterQueryString(_this.esFilters);
                _this.es.setAggregationQueryString(_this.aggFields[_this.context]);
                _this.esQuery = _this.es.searchQuery;
                _this.search();
            }
            else 
            // ADMIN: Active/non-active items
            if (params['active'] != null) {
                _this.hasActiveParam = true;
                var activeSelect = JSON.parse(params['active']);
                _this.esFilters = [];
                _this.es.addFilterActive(_this.esFilters, activeSelect);
                _this.es.setFilterQueryString(_this.esFilters);
                _this.esQuery = _this.es.searchQuery;
                _this.search();
            }
        });
        // Further filtering with query params
        this.route.queryParams.subscribe(function (params) {
            if (!_this.entryType && !_this.hasActiveParam) {
                // Aggregations
                _this.es.setAggregationQueryString(_this.aggFields[_this.context]);
                if (!_this.entryField) {
                    // Search
                    if (params['s'] != null) {
                        var searchFields = {
                            record: ['title', 'music_piece_title', 'instrument', 'orchestra', 'composer', 'conductor', 'soloist'],
                            writing: ['title', 'content', 'author'],
                        };
                        _this.es.setSearchQueryString(searchFields[_this.context], params['s']);
                    }
                    // Filters
                    var filters = _this.utils.queryParamsParser(params, 'f');
                    _this.esFilters = _this.utils.filtersToEsFilters(filters, '.raw');
                    _this.es.setFilterQueryString(_this.esFilters);
                }
            }
            // Clear search
            if (params['s'] == null)
                _this.es.clearSearchQueryString();
            // Pagination
            if (params['from'] != null)
                _this.es.setPaginationQueryString(params['from'], _this.pageSize);
            else
                _this.es.setPaginationQueryString(null, _this.pageSize);
            // Active
            if (_this.active)
                _this.es.addFilterActive(_this.esFilters, _this.active);
            // Run search
            _this.esQuery = _this.es.searchQuery;
            _this.standby(); // loading
            _this.search();
        });
    };
    SearchableContentsComponent.prototype.search = function () {
        var _this = this;
        // Retrieve IDs from index
        //console.log(this.es.searchQuery);
        this.searchService.search(this.context, this.es.searchQuery)
            .then(function (response) {
            var indexData = JSON.parse(response.body);
            _this.esContents = indexData.hits;
            _this.esAggregations = indexData.aggregations;
            // Retrieve info from db based on index ids
            _this.dbContents = [];
            var ids = [];
            for (var _i = 0, _a = _this.esContents['hits']; _i < _a.length; _i++) {
                var hit = _a[_i];
                ids.push(hit._id);
            }
            if (ids.length > 0) {
                var idsString = ids.join(',');
                _this.contentService.findContents(_this.context, idsString, _this.noCache)
                    .then(function (res) {
                    _this.dbContents = res;
                    _this.ready(); // sets loading to false and preboot complete
                });
            }
            else
                _this.ready();
        });
    };
    SearchableContentsComponent.prototype.dbContentsLimited = function (limit) {
        var limited = [];
        for (var i = 0; i < this.dbContents.length; i++) {
            limited.push(this.dbContents[i]);
            if (i == limit - 1)
                break;
        }
        return limited;
    };
    SearchableContentsComponent.prototype.searchCallBack = function (info) {
        //console.log('[search]', info);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchableContentsComponent.prototype, "context", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchableContentsComponent.prototype, "pageSize", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchableContentsComponent.prototype, "active", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], SearchableContentsComponent.prototype, "noCache", void 0);
    SearchableContentsComponent = __decorate([
        core_1.Directive({
            selector: '[searchable-contents]',
            exportAs: 'sc',
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _a) || Object, (typeof (_b = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _b) || Object, (typeof (_c = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _f) || Object])
    ], SearchableContentsComponent);
    return SearchableContentsComponent;
    var _a, _b, _c, _d, _e, _f;
}(loading_indicator_1.LoadingPage));
exports.SearchableContentsComponent = SearchableContentsComponent;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var TruncatePipe = (function () {
    function TruncatePipe() {
    }
    TruncatePipe.prototype.transform = function (value, limitStr) {
        if (!value)
            return value;
        var limit = parseInt(limitStr);
        var trail = '...';
        return value.length > limit ? value.substring(0, limit) + trail : value;
    };
    TruncatePipe = __decorate([
        core_1.Pipe({
            name: 'truncate'
        }), 
        __metadata('design:paramtypes', [])
    ], TruncatePipe);
    return TruncatePipe;
}());
exports.TruncatePipe = TruncatePipe;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var isArray_1 = __webpack_require__(252);
var isObject_1 = __webpack_require__(337);
var isFunction_1 = __webpack_require__(336);
var tryCatch_1 = __webpack_require__(339);
var errorObject_1 = __webpack_require__(251);
var UnsubscriptionError_1 = __webpack_require__(545);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        this.closed = true;
        var _a = this, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this._subscriptions = null;
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                (errors = errors || []).push(errorObject_1.errorObject.e);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(err.errors);
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var sub = teardown;
        switch (typeof teardown) {
            case 'function':
                sub = new Subscription(teardown);
            case 'object':
                if (sub.closed || typeof sub.unsubscribe !== 'function') {
                    break;
                }
                else if (this.closed) {
                    sub.unsubscribe();
                }
                else {
                    (this._subscriptions || (this._subscriptions = [])).push(sub);
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        return sub;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        // HACK: This might be redundant because of the logic in `add()`
        if (subscription == null || (subscription === this) || (subscription === Subscription.EMPTY)) {
            return;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var of_1 = __webpack_require__(87);
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(185);
var OuterSubscriber_1 = __webpack_require__(182);
/* tslint:disable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): Observable} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return this.lift(new MergeMapOperator(project, resultSelector, concurrent));
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgStyle", function() { return NgStyle; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @ngModule CommonModule
 *
 * @whatItDoes Update an HTML element styles.
 *
 * @howToUse
 * ```
 * <some-element [ngStyle]="{'font-style': styleExp}">...</some-element>
 *
 * <some-element [ngStyle]="{'max-width.px': widthExp}">...</some-element>
 *
 * <some-element [ngStyle]="objExp">...</some-element>
 * ```
 *
 * @description
 *
 * The styles are updated according to the value of the expression evaluation:
 * - keys are style names with an option `.<unit>` suffix (ie 'top.px', 'font-style.em'),
 * - values are the values assigned to those properties (expressed in the given unit).
 *
 * @stable
 */
var NgStyle = (function () {
    function NgStyle(_differs, _ngEl, _renderer) {
        this._differs = _differs;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
    }
    Object.defineProperty(NgStyle.prototype, "ngStyle", {
        set: function (v) {
            this._ngStyle = v;
            if (!this._differ && v) {
                this._differ = this._differs.find(v).create(null);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgStyle.prototype.ngDoCheck = function () {
        if (this._differ) {
            var changes = this._differ.diff(this._ngStyle);
            if (changes) {
                this._applyChanges(changes);
            }
        }
    };
    NgStyle.prototype._applyChanges = function (changes) {
        var _this = this;
        changes.forEachRemovedItem(function (record) { return _this._setStyle(record.key, null); });
        changes.forEachAddedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
    };
    NgStyle.prototype._setStyle = function (nameAndUnit, value) {
        var _a = nameAndUnit.split('.'), name = _a[0], unit = _a[1];
        value = value && unit ? "" + value + unit : value;
        this._renderer.setElementStyle(this._ngEl.nativeElement, name, value);
    };
    NgStyle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngStyle]' },] },
    ];
    /** @nocollapse */
    NgStyle.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ];
    NgStyle.propDecorators = {
        'ngStyle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgStyle;
}());
//# sourceMappingURL=ng_style.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgLocalization", function() { return NgLocalization; });
/* harmony export (immutable) */ exports["getPluralCategory"] = getPluralCategory;
/* harmony export (binding) */ __webpack_require__.d(exports, "NgLocaleLocalization", function() { return NgLocaleLocalization; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Plural", function() { return Plural; });
/* harmony export (immutable) */ exports["getPluralCase"] = getPluralCase;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * @experimental
 */
var NgLocalization = (function () {
    function NgLocalization() {
    }
    return NgLocalization;
}());
/**
 * Returns the plural category for a given value.
 * - "=value" when the case exists,
 * - the plural category otherwise
 *
 * @internal
 */
function getPluralCategory(value, cases, ngLocalization) {
    var nbCase = "=" + value;
    return cases.indexOf(nbCase) > -1 ? nbCase : ngLocalization.getPluralCategory(value);
}
/**
 * Returns the plural case based on the locale
 *
 * @experimental
 */
var NgLocaleLocalization = (function (_super) {
    __extends(NgLocaleLocalization, _super);
    function NgLocaleLocalization(_locale) {
        _super.call(this);
        this._locale = _locale;
    }
    NgLocaleLocalization.prototype.getPluralCategory = function (value) {
        var plural = getPluralCase(this._locale, value);
        switch (plural) {
            case Plural.Zero:
                return 'zero';
            case Plural.One:
                return 'one';
            case Plural.Two:
                return 'two';
            case Plural.Few:
                return 'few';
            case Plural.Many:
                return 'many';
            default:
                return 'other';
        }
    };
    NgLocaleLocalization.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NgLocaleLocalization.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
    ];
    return NgLocaleLocalization;
}(NgLocalization));
// This is generated code DO NOT MODIFY
// see angular2/script/cldr/gen_plural_rules.js
/** @experimental */
var Plural;
(function (Plural) {
    Plural[Plural["Zero"] = 0] = "Zero";
    Plural[Plural["One"] = 1] = "One";
    Plural[Plural["Two"] = 2] = "Two";
    Plural[Plural["Few"] = 3] = "Few";
    Plural[Plural["Many"] = 4] = "Many";
    Plural[Plural["Other"] = 5] = "Other";
})(Plural || (Plural = {}));
/**
 * Returns the plural case based on the locale
 *
 * @experimental
 */
function getPluralCase(locale, nLike) {
    // TODO(vicb): lazy compute
    if (typeof nLike === 'string') {
        nLike = parseInt(nLike, 10);
    }
    var n = nLike;
    var nDecimal = n.toString().replace(/^[^.]*\.?/, '');
    var i = Math.floor(Math.abs(n));
    var v = nDecimal.length;
    var f = parseInt(nDecimal, 10);
    var t = parseInt(n.toString().replace(/^[^.]*\.?|0+$/g, ''), 10) || 0;
    var lang = locale.split('-')[0].toLowerCase();
    switch (lang) {
        case 'af':
        case 'asa':
        case 'az':
        case 'bem':
        case 'bez':
        case 'bg':
        case 'brx':
        case 'ce':
        case 'cgg':
        case 'chr':
        case 'ckb':
        case 'ee':
        case 'el':
        case 'eo':
        case 'es':
        case 'eu':
        case 'fo':
        case 'fur':
        case 'gsw':
        case 'ha':
        case 'haw':
        case 'hu':
        case 'jgo':
        case 'jmc':
        case 'ka':
        case 'kk':
        case 'kkj':
        case 'kl':
        case 'ks':
        case 'ksb':
        case 'ky':
        case 'lb':
        case 'lg':
        case 'mas':
        case 'mgo':
        case 'ml':
        case 'mn':
        case 'nb':
        case 'nd':
        case 'ne':
        case 'nn':
        case 'nnh':
        case 'nyn':
        case 'om':
        case 'or':
        case 'os':
        case 'ps':
        case 'rm':
        case 'rof':
        case 'rwk':
        case 'saq':
        case 'seh':
        case 'sn':
        case 'so':
        case 'sq':
        case 'ta':
        case 'te':
        case 'teo':
        case 'tk':
        case 'tr':
        case 'ug':
        case 'uz':
        case 'vo':
        case 'vun':
        case 'wae':
        case 'xog':
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'agq':
        case 'bas':
        case 'cu':
        case 'dav':
        case 'dje':
        case 'dua':
        case 'dyo':
        case 'ebu':
        case 'ewo':
        case 'guz':
        case 'kam':
        case 'khq':
        case 'ki':
        case 'kln':
        case 'kok':
        case 'ksf':
        case 'lrc':
        case 'lu':
        case 'luo':
        case 'luy':
        case 'mer':
        case 'mfe':
        case 'mgh':
        case 'mua':
        case 'mzn':
        case 'nmg':
        case 'nus':
        case 'qu':
        case 'rn':
        case 'rw':
        case 'sbp':
        case 'twq':
        case 'vai':
        case 'yav':
        case 'yue':
        case 'zgh':
        case 'ak':
        case 'ln':
        case 'mg':
        case 'pa':
        case 'ti':
            if (n === Math.floor(n) && n >= 0 && n <= 1)
                return Plural.One;
            return Plural.Other;
        case 'am':
        case 'as':
        case 'bn':
        case 'fa':
        case 'gu':
        case 'hi':
        case 'kn':
        case 'mr':
        case 'zu':
            if (i === 0 || n === 1)
                return Plural.One;
            return Plural.Other;
        case 'ar':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 3 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 99)
                return Plural.Many;
            return Plural.Other;
        case 'ast':
        case 'ca':
        case 'de':
        case 'en':
        case 'et':
        case 'fi':
        case 'fy':
        case 'gl':
        case 'it':
        case 'nl':
        case 'sv':
        case 'sw':
        case 'ur':
        case 'yi':
            if (i === 1 && v === 0)
                return Plural.One;
            return Plural.Other;
        case 'be':
            if (n % 10 === 1 && !(n % 100 === 11))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 4 &&
                !(n % 100 >= 12 && n % 100 <= 14))
                return Plural.Few;
            if (n % 10 === 0 || n % 10 === Math.floor(n % 10) && n % 10 >= 5 && n % 10 <= 9 ||
                n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'br':
            if (n % 10 === 1 && !(n % 100 === 11 || n % 100 === 71 || n % 100 === 91))
                return Plural.One;
            if (n % 10 === 2 && !(n % 100 === 12 || n % 100 === 72 || n % 100 === 92))
                return Plural.Two;
            if (n % 10 === Math.floor(n % 10) && (n % 10 >= 3 && n % 10 <= 4 || n % 10 === 9) &&
                !(n % 100 >= 10 && n % 100 <= 19 || n % 100 >= 70 && n % 100 <= 79 ||
                    n % 100 >= 90 && n % 100 <= 99))
                return Plural.Few;
            if (!(n === 0) && n % 1e6 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'bs':
        case 'hr':
        case 'sr':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11) || f % 10 === 1 && !(f % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14) ||
                f % 10 === Math.floor(f % 10) && f % 10 >= 2 && f % 10 <= 4 &&
                    !(f % 100 >= 12 && f % 100 <= 14))
                return Plural.Few;
            return Plural.Other;
        case 'cs':
        case 'sk':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === Math.floor(i) && i >= 2 && i <= 4 && v === 0)
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'cy':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === 3)
                return Plural.Few;
            if (n === 6)
                return Plural.Many;
            return Plural.Other;
        case 'da':
            if (n === 1 || !(t === 0) && (i === 0 || i === 1))
                return Plural.One;
            return Plural.Other;
        case 'dsb':
        case 'hsb':
            if (v === 0 && i % 100 === 1 || f % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2 || f % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 ||
                f % 100 === Math.floor(f % 100) && f % 100 >= 3 && f % 100 <= 4)
                return Plural.Few;
            return Plural.Other;
        case 'ff':
        case 'fr':
        case 'hy':
        case 'kab':
            if (i === 0 || i === 1)
                return Plural.One;
            return Plural.Other;
        case 'fil':
            if (v === 0 && (i === 1 || i === 2 || i === 3) ||
                v === 0 && !(i % 10 === 4 || i % 10 === 6 || i % 10 === 9) ||
                !(v === 0) && !(f % 10 === 4 || f % 10 === 6 || f % 10 === 9))
                return Plural.One;
            return Plural.Other;
        case 'ga':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === Math.floor(n) && n >= 3 && n <= 6)
                return Plural.Few;
            if (n === Math.floor(n) && n >= 7 && n <= 10)
                return Plural.Many;
            return Plural.Other;
        case 'gd':
            if (n === 1 || n === 11)
                return Plural.One;
            if (n === 2 || n === 12)
                return Plural.Two;
            if (n === Math.floor(n) && (n >= 3 && n <= 10 || n >= 13 && n <= 19))
                return Plural.Few;
            return Plural.Other;
        case 'gv':
            if (v === 0 && i % 10 === 1)
                return Plural.One;
            if (v === 0 && i % 10 === 2)
                return Plural.Two;
            if (v === 0 &&
                (i % 100 === 0 || i % 100 === 20 || i % 100 === 40 || i % 100 === 60 || i % 100 === 80))
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'he':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === 2 && v === 0)
                return Plural.Two;
            if (v === 0 && !(n >= 0 && n <= 10) && n % 10 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'is':
            if (t === 0 && i % 10 === 1 && !(i % 100 === 11) || !(t === 0))
                return Plural.One;
            return Plural.Other;
        case 'ksh':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'kw':
        case 'naq':
        case 'se':
        case 'smn':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            return Plural.Other;
        case 'lag':
            if (n === 0)
                return Plural.Zero;
            if ((i === 0 || i === 1) && !(n === 0))
                return Plural.One;
            return Plural.Other;
        case 'lt':
            if (n % 10 === 1 && !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 9 &&
                !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.Few;
            if (!(f === 0))
                return Plural.Many;
            return Plural.Other;
        case 'lv':
        case 'prg':
            if (n % 10 === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19 ||
                v === 2 && f % 100 === Math.floor(f % 100) && f % 100 >= 11 && f % 100 <= 19)
                return Plural.Zero;
            if (n % 10 === 1 && !(n % 100 === 11) || v === 2 && f % 10 === 1 && !(f % 100 === 11) ||
                !(v === 2) && f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mk':
            if (v === 0 && i % 10 === 1 || f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mt':
            if (n === 1)
                return Plural.One;
            if (n === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19)
                return Plural.Many;
            return Plural.Other;
        case 'pl':
            if (i === 1 && v === 0)
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && !(i === 1) && i % 10 === Math.floor(i % 10) && i % 10 >= 0 && i % 10 <= 1 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 12 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'pt':
            if (n === Math.floor(n) && n >= 0 && n <= 2 && !(n === 2))
                return Plural.One;
            return Plural.Other;
        case 'ro':
            if (i === 1 && v === 0)
                return Plural.One;
            if (!(v === 0) || n === 0 ||
                !(n === 1) && n % 100 === Math.floor(n % 100) && n % 100 >= 1 && n % 100 <= 19)
                return Plural.Few;
            return Plural.Other;
        case 'ru':
        case 'uk':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && i % 10 === 0 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 11 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'shi':
            if (i === 0 || n === 1)
                return Plural.One;
            if (n === Math.floor(n) && n >= 2 && n <= 10)
                return Plural.Few;
            return Plural.Other;
        case 'si':
            if (n === 0 || n === 1 || i === 0 && f === 1)
                return Plural.One;
            return Plural.Other;
        case 'sl':
            if (v === 0 && i % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 || !(v === 0))
                return Plural.Few;
            return Plural.Other;
        case 'tzm':
            if (n === Math.floor(n) && n >= 0 && n <= 1 || n === Math.floor(n) && n >= 11 && n <= 99)
                return Plural.One;
            return Plural.Other;
        default:
            return Plural.Other;
    }
}
//# sourceMappingURL=localization.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony export (binding) */ __webpack_require__.d(exports, "APP_ID", function() { return APP_ID; });
/* harmony export (immutable) */ exports["_appIdRandomProviderFactory"] = _appIdRandomProviderFactory;
/* harmony export (binding) */ __webpack_require__.d(exports, "APP_ID_RANDOM_PROVIDER", function() { return APP_ID_RANDOM_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PLATFORM_INITIALIZER", function() { return PLATFORM_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "APP_BOOTSTRAP_LISTENER", function() { return APP_BOOTSTRAP_LISTENER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PACKAGE_ROOT_URL", function() { return PACKAGE_ROOT_URL; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A DI Token representing a unique string id assigned to the application by Angular and used
 * primarily for prefixing application attributes and CSS styles when
 * {@link ViewEncapsulation#Emulated} is being used.
 *
 * If you need to avoid randomly generated value to be used as an application id, you can provide
 * a custom value via a DI provider <!-- TODO: provider --> configuring the root {@link Injector}
 * using this token.
 * @experimental
 */
var APP_ID = new __WEBPACK_IMPORTED_MODULE_0__di__["a" /* OpaqueToken */]('AppId');
function _appIdRandomProviderFactory() {
    return "" + _randomChar() + _randomChar() + _randomChar();
}
/**
 * Providers that will generate a random APP_ID_TOKEN.
 * @experimental
 */
var APP_ID_RANDOM_PROVIDER = {
    provide: APP_ID,
    useFactory: _appIdRandomProviderFactory,
    deps: [],
};
function _randomChar() {
    return String.fromCharCode(97 + Math.floor(Math.random() * 25));
}
/**
 * A function that will be executed when a platform is initialized.
 * @experimental
 */
var PLATFORM_INITIALIZER = new __WEBPACK_IMPORTED_MODULE_0__di__["a" /* OpaqueToken */]('Platform Initializer');
/**
 * All callbacks provided via this token will be called for every component that is bootstrapped.
 * Signature of the callback:
 *
 * `(componentRef: ComponentRef) => void`.
 *
 * @experimental
 */
var APP_BOOTSTRAP_LISTENER = new __WEBPACK_IMPORTED_MODULE_0__di__["a" /* OpaqueToken */]('appBootstrapListener');
/**
 * A token which indicates the root directory of the application
 * @experimental
 */
var PACKAGE_ROOT_URL = new __WEBPACK_IMPORTED_MODULE_0__di__["a" /* OpaqueToken */]('Application Packages Root URL');
//# sourceMappingURL=application_tokens.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_async__ = __webpack_require__(60);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgZone", function() { return NgZone; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * An injectable service for executing work inside or outside of the Angular zone.
 *
 * The most common use of this service is to optimize performance when starting a work consisting of
 * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
 * Angular. Such tasks can be kicked off via {@link runOutsideAngular} and if needed, these tasks
 * can reenter the Angular zone via {@link run}.
 *
 * <!-- TODO: add/fix links to:
 *   - docs explaining zones and the use of zones in Angular and change-detection
 *   - link to runOutsideAngular/run (throughout this file!)
 *   -->
 *
 * ### Example
 * ```
 * import {Component, NgZone} from '@angular/core';
 * import {NgIf} from '@angular/common';
 *
 * @Component({
 *   selector: 'ng-zone-demo'.
 *   template: `
 *     <h2>Demo: NgZone</h2>
 *
 *     <p>Progress: {{progress}}%</p>
 *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
 *
 *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
 *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
 *   `,
 * })
 * export class NgZoneDemo {
 *   progress: number = 0;
 *   label: string;
 *
 *   constructor(private _ngZone: NgZone) {}
 *
 *   // Loop inside the Angular zone
 *   // so the UI DOES refresh after each setTimeout cycle
 *   processWithinAngularZone() {
 *     this.label = 'inside';
 *     this.progress = 0;
 *     this._increaseProgress(() => console.log('Inside Done!'));
 *   }
 *
 *   // Loop outside of the Angular zone
 *   // so the UI DOES NOT refresh after each setTimeout cycle
 *   processOutsideOfAngularZone() {
 *     this.label = 'outside';
 *     this.progress = 0;
 *     this._ngZone.runOutsideAngular(() => {
 *       this._increaseProgress(() => {
 *       // reenter the Angular zone and display done
 *       this._ngZone.run(() => {console.log('Outside Done!') });
 *     }}));
 *   }
 *
 *   _increaseProgress(doneCallback: () => void) {
 *     this.progress += 1;
 *     console.log(`Current progress: ${this.progress}%`);
 *
 *     if (this.progress < 100) {
 *       window.setTimeout(() => this._increaseProgress(doneCallback)), 10)
 *     } else {
 *       doneCallback();
 *     }
 *   }
 * }
 * ```
 * @experimental
 */
var NgZone = (function () {
    function NgZone(_a) {
        var _b = _a.enableLongStackTrace, enableLongStackTrace = _b === void 0 ? false : _b;
        this._hasPendingMicrotasks = false;
        this._hasPendingMacrotasks = false;
        this._isStable = true;
        this._nesting = 0;
        this._onUnstable = new __WEBPACK_IMPORTED_MODULE_0__facade_async__["a" /* EventEmitter */](false);
        this._onMicrotaskEmpty = new __WEBPACK_IMPORTED_MODULE_0__facade_async__["a" /* EventEmitter */](false);
        this._onStable = new __WEBPACK_IMPORTED_MODULE_0__facade_async__["a" /* EventEmitter */](false);
        this._onErrorEvents = new __WEBPACK_IMPORTED_MODULE_0__facade_async__["a" /* EventEmitter */](false);
        if (typeof Zone == 'undefined') {
            throw new Error('Angular requires Zone.js prolyfill.');
        }
        Zone.assertZonePatched();
        this.outer = this.inner = Zone.current;
        if (Zone['wtfZoneSpec']) {
            this.inner = this.inner.fork(Zone['wtfZoneSpec']);
        }
        if (enableLongStackTrace && Zone['longStackTraceZoneSpec']) {
            this.inner = this.inner.fork(Zone['longStackTraceZoneSpec']);
        }
        this.forkInnerZoneWithAngularBehavior();
    }
    NgZone.isInAngularZone = function () { return Zone.current.get('isAngularZone') === true; };
    NgZone.assertInAngularZone = function () {
        if (!NgZone.isInAngularZone()) {
            throw new Error('Expected to be in Angular Zone, but it is not!');
        }
    };
    NgZone.assertNotInAngularZone = function () {
        if (NgZone.isInAngularZone()) {
            throw new Error('Expected to not be in Angular Zone, but it is!');
        }
    };
    /**
     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
     * the function.
     *
     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
     * outside of the Angular zone (typically started via {@link runOutsideAngular}).
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * within the Angular zone.
     *
     * If a synchronous error happens it will be rethrown and not reported via `onError`.
     */
    NgZone.prototype.run = function (fn) { return this.inner.run(fn); };
    /**
     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
     * rethrown.
     */
    NgZone.prototype.runGuarded = function (fn) { return this.inner.runGuarded(fn); };
    /**
     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
     * the function.
     *
     * Running functions via `runOutsideAngular` allows you to escape Angular's zone and do work that
     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * outside of the Angular zone.
     *
     * Use {@link run} to reenter the Angular zone and do work that updates the application model.
     */
    NgZone.prototype.runOutsideAngular = function (fn) { return this.outer.run(fn); };
    Object.defineProperty(NgZone.prototype, "onUnstable", {
        /**
         * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
         */
        get: function () { return this._onUnstable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onMicrotaskEmpty", {
        /**
         * Notifies when there is no more microtasks enqueue in the current VM Turn.
         * This is a hint for Angular to do change detection, which may enqueue more microtasks.
         * For this reason this event can fire multiple times per VM Turn.
         */
        get: function () { return this._onMicrotaskEmpty; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onStable", {
        /**
         * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
         * implies we are about to relinquish VM turn.
         * This event gets called just once.
         */
        get: function () { return this._onStable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onError", {
        /**
         * Notify that an error has been delivered.
         */
        get: function () { return this._onErrorEvents; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "isStable", {
        /**
         * Whether there are no outstanding microtasks or macrotasks.
         */
        get: function () { return this._isStable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "hasPendingMicrotasks", {
        get: function () { return this._hasPendingMicrotasks; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "hasPendingMacrotasks", {
        get: function () { return this._hasPendingMacrotasks; },
        enumerable: true,
        configurable: true
    });
    NgZone.prototype.checkStable = function () {
        var _this = this;
        if (this._nesting == 0 && !this._hasPendingMicrotasks && !this._isStable) {
            try {
                this._nesting++;
                this._onMicrotaskEmpty.emit(null);
            }
            finally {
                this._nesting--;
                if (!this._hasPendingMicrotasks) {
                    try {
                        this.runOutsideAngular(function () { return _this._onStable.emit(null); });
                    }
                    finally {
                        this._isStable = true;
                    }
                }
            }
        }
    };
    NgZone.prototype.forkInnerZoneWithAngularBehavior = function () {
        var _this = this;
        this.inner = this.inner.fork({
            name: 'angular',
            properties: { 'isAngularZone': true },
            onInvokeTask: function (delegate, current, target, task, applyThis, applyArgs) {
                try {
                    _this.onEnter();
                    return delegate.invokeTask(target, task, applyThis, applyArgs);
                }
                finally {
                    _this.onLeave();
                }
            },
            onInvoke: function (delegate, current, target, callback, applyThis, applyArgs, source) {
                try {
                    _this.onEnter();
                    return delegate.invoke(target, callback, applyThis, applyArgs, source);
                }
                finally {
                    _this.onLeave();
                }
            },
            onHasTask: function (delegate, current, target, hasTaskState) {
                delegate.hasTask(target, hasTaskState);
                if (current === target) {
                    // We are only interested in hasTask events which originate from our zone
                    // (A child hasTask event is not interesting to us)
                    if (hasTaskState.change == 'microTask') {
                        _this.setHasMicrotask(hasTaskState.microTask);
                    }
                    else if (hasTaskState.change == 'macroTask') {
                        _this.setHasMacrotask(hasTaskState.macroTask);
                    }
                }
            },
            onHandleError: function (delegate, current, target, error) {
                delegate.handleError(target, error);
                _this.triggerError(error);
                return false;
            }
        });
    };
    NgZone.prototype.onEnter = function () {
        this._nesting++;
        if (this._isStable) {
            this._isStable = false;
            this._onUnstable.emit(null);
        }
    };
    NgZone.prototype.onLeave = function () {
        this._nesting--;
        this.checkStable();
    };
    NgZone.prototype.setHasMicrotask = function (hasMicrotasks) {
        this._hasPendingMicrotasks = hasMicrotasks;
        this.checkStable();
    };
    NgZone.prototype.setHasMacrotask = function (hasMacrotasks) { this._hasPendingMacrotasks = hasMacrotasks; };
    NgZone.prototype.triggerError = function (error) { this._onErrorEvents.emit(error); };
    return NgZone;
}());
//# sourceMappingURL=ng_zone.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(72);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractFormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
 *
 * @stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        _super.apply(this, arguments);
    }
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {@link FormGroup} backing this binding.
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {@link Form} to which this group belongs.
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_0__control_container__["ControlContainer"]));
//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(55);
/* harmony export (binding) */ __webpack_require__.d(exports, "REQUIRED_VALIDATOR", function() { return REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RequiredValidator", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(exports, "MIN_LENGTH_VALIDATOR", function() { return MIN_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(exports, "MAX_LENGTH_VALIDATOR", function() { return MAX_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PATTERN_VALIDATOR", function() { return PATTERN_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PatternValidator", function() { return PatternValidator; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * @stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            this._required = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(value) && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_2__validators__["Validators"].required(c) : null;
    };
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[required][formControlName],[required][formControl],[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = [];
    RequiredValidator.propDecorators = {
        'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * @stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_2__validators__["Validators"].minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if (changes['minlength']) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MinLengthValidator.prototype.validate = function (c) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.minlength) ? this._validator(c) : null;
    };
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = [];
    MinLengthValidator.propDecorators = {
        'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * @stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_2__validators__["Validators"].maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if (changes['maxlength']) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MaxLengthValidator.prototype.validate = function (c) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.maxlength) ? this._validator(c) : null;
    };
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = [];
    MaxLengthValidator.propDecorators = {
        'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
var PATTERN_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * @stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    PatternValidator.prototype._createValidator = function () { this._validator = __WEBPACK_IMPORTED_MODULE_2__validators__["Validators"].pattern(this.pattern); };
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if (changes['pattern']) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    PatternValidator.prototype.validate = function (c) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.pattern) ? this._validator(c) : null;
    };
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = [];
    PatternValidator.propDecorators = {
        'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return PatternValidator;
}());
//# sourceMappingURL=validators.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headers__ = __webpack_require__(109);
/* harmony export (binding) */ __webpack_require__.d(exports, "ResponseOptions", function() { return ResponseOptions; });
/* harmony export (binding) */ __webpack_require__.d(exports, "BaseResponseOptions", function() { return BaseResponseOptions; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Creates a response options object to be optionally provided when instantiating a
 * {@link Response}.
 *
 * This class is based on the `ResponseInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#responseinit).
 *
 * All values are null by default. Typical defaults can be found in the
 * {@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
 *
 * This class may be used in tests to build {@link Response Responses} for
 * mock responses (see {@link MockBackend}).
 *
 * ### Example ([live demo](http://plnkr.co/edit/P9Jkk8e8cz6NVzbcxEsD?p=preview))
 *
 * ```typescript
 * import {ResponseOptions, Response} from '@angular/http';
 *
 * var options = new ResponseOptions({
 *   body: '{"name":"Jeff"}'
 * });
 * var res = new Response(options);
 *
 * console.log('res.json():', res.json()); // Object {name: "Jeff"}
 * ```
 *
 * @experimental
 */
var ResponseOptions = (function () {
    function ResponseOptions(_a) {
        var _b = _a === void 0 ? {} : _a, body = _b.body, status = _b.status, headers = _b.headers, statusText = _b.statusText, type = _b.type, url = _b.url;
        this.body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(body) ? body : null;
        this.status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(status) ? status : null;
        this.headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(headers) ? headers : null;
        this.statusText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(statusText) ? statusText : null;
        this.type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(type) ? type : null;
        this.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(url) ? url : null;
    }
    /**
     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
     * override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * This may be useful when sharing a base `ResponseOptions` object inside tests,
     * where certain properties may change from test to test.
     *
     * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
     *
     * ```typescript
     * import {ResponseOptions, Response} from '@angular/http';
     *
     * var options = new ResponseOptions({
     *   body: {name: 'Jeff'}
     * });
     * var res = new Response(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('options.url:', options.url); // null
     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
     * console.log('res.url:', res.url); // https://google.com
     * ```
     */
    ResponseOptions.prototype.merge = function (options) {
        return new ResponseOptions({
            body: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.body) ? options.body : this.body,
            status: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.status) ? options.status : this.status,
            headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.headers) ? options.headers : this.headers,
            statusText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.statusText) ? options.statusText :
                this.statusText,
            type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.type) ? options.type : this.type,
            url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.url) ? options.url : this.url,
        });
    };
    return ResponseOptions;
}());
/**
 * Subclass of {@link ResponseOptions}, with default values.
 *
 * Default values:
 *  * status: 200
 *  * headers: empty {@link Headers} object
 *
 * This class could be extended and bound to the {@link ResponseOptions} class
 * when configuring an {@link Injector}, in order to override the default options
 * used by {@link Http} to create {@link Response Responses}.
 *
 * ### Example ([live demo](http://plnkr.co/edit/qv8DLT?p=preview))
 *
 * ```typescript
 * import {provide} from '@angular/core';
 * import {bootstrap} from '@angular/platform-browser/browser';
 * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
 * '@angular/http';
 * import {App} from './myapp';
 *
 * class MyOptions extends BaseResponseOptions {
 *   headers:Headers = new Headers({network: 'github'});
 * }
 *
 * bootstrap(App, [HTTP_PROVIDERS, {provide: ResponseOptions, useClass: MyOptions}]);
 * ```
 *
 * The options could also be extended when manually creating a {@link Response}
 * object.
 *
 * ### Example ([live demo](http://plnkr.co/edit/VngosOWiaExEtbstDoix?p=preview))
 *
 * ```
 * import {BaseResponseOptions, Response} from '@angular/http';
 *
 * var options = new BaseResponseOptions();
 * var res = new Response(options.merge({
 *   body: 'Angular',
 *   headers: new Headers({framework: 'angular'})
 * }));
 * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
 * console.log('res.text():', res.text()); // Angular;
 * ```
 *
 * @experimental
 */
var BaseResponseOptions = (function (_super) {
    __extends(BaseResponseOptions, _super);
    function BaseResponseOptions() {
        _super.call(this, { status: 200, statusText: 'Ok', type: __WEBPACK_IMPORTED_MODULE_2__enums__["a" /* ResponseType */].Default, headers: new __WEBPACK_IMPORTED_MODULE_3__headers__["a" /* Headers */]() });
    }
    BaseResponseOptions.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BaseResponseOptions.ctorParameters = [];
    return BaseResponseOptions;
}(ResponseOptions));
//# sourceMappingURL=base_response_options.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_facade_collection__ = __webpack_require__(36);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Headers; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
 * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
 *
 * The only known difference between this `Headers` implementation and the spec is the
 * lack of an `entries` method.
 *
 * ### Example
 *
 * ```
 * import {Headers} from '@angular/http';
 *
 * var firstHeaders = new Headers();
 * firstHeaders.append('Content-Type', 'image/jpeg');
 * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
 *
 * // Create headers from Plain Old JavaScript Object
 * var secondHeaders = new Headers({
 *   'X-My-Custom-Header': 'Angular'
 * });
 * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
 *
 * var thirdHeaders = new Headers(secondHeaders);
 * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
 * ```
 *
 * @experimental
 */
var Headers = (function () {
    // TODO(vicb): any -> string|string[]
    function Headers(headers) {
        var _this = this;
        /** @internal header names are lower case */
        this._headers = new Map();
        /** @internal map lower case names to actual names */
        this._normalizedNames = new Map();
        if (!headers) {
            return;
        }
        if (headers instanceof Headers) {
            headers._headers.forEach(function (values, name) {
                values.forEach(function (value) { return _this.append(name, value); });
            });
            return;
        }
        Object.keys(headers).forEach(function (name) {
            var values = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
            _this.delete(name);
            values.forEach(function (value) { return _this.append(name, value); });
        });
    }
    /**
     * Returns a new Headers instance from the given DOMString of Response Headers
     */
    Headers.fromResponseHeaderString = function (headersString) {
        var headers = new Headers();
        headersString.split('\n').forEach(function (line) {
            var index = line.indexOf(':');
            if (index > 0) {
                var name_1 = line.slice(0, index);
                var value = line.slice(index + 1).trim();
                headers.set(name_1, value);
            }
        });
        return headers;
    };
    /**
     * Appends a header to existing list of header values for a given header name.
     */
    Headers.prototype.append = function (name, value) {
        var values = this.getAll(name);
        if (values === null) {
            this.set(name, value);
        }
        else {
            values.push(value);
        }
    };
    /**
     * Deletes all header values for the given name.
     */
    Headers.prototype.delete = function (name) {
        var lcName = name.toLowerCase();
        this._normalizedNames.delete(lcName);
        this._headers.delete(lcName);
    };
    Headers.prototype.forEach = function (fn) {
        var _this = this;
        this._headers.forEach(function (values, lcName) { return fn(values, _this._normalizedNames.get(lcName), _this._headers); });
    };
    /**
     * Returns first header that matches given name.
     */
    Headers.prototype.get = function (name) {
        var values = this.getAll(name);
        if (values === null) {
            return null;
        }
        return values.length > 0 ? values[0] : null;
    };
    /**
     * Checks for existence of header by given name.
     */
    Headers.prototype.has = function (name) { return this._headers.has(name.toLowerCase()); };
    /**
     * Returns the names of the headers
     */
    Headers.prototype.keys = function () { return __WEBPACK_IMPORTED_MODULE_0__src_facade_collection__["a" /* MapWrapper */].values(this._normalizedNames); };
    /**
     * Sets or overrides header value for given name.
     */
    Headers.prototype.set = function (name, value) {
        if (Array.isArray(value)) {
            if (value.length) {
                this._headers.set(name.toLowerCase(), [value.join(',')]);
            }
        }
        else {
            this._headers.set(name.toLowerCase(), [value]);
        }
        this.mayBeSetNormalizedName(name);
    };
    /**
     * Returns values of all headers.
     */
    Headers.prototype.values = function () { return __WEBPACK_IMPORTED_MODULE_0__src_facade_collection__["a" /* MapWrapper */].values(this._headers); };
    /**
     * Returns string of all headers.
     */
    // TODO(vicb): returns {[name: string]: string[]}
    Headers.prototype.toJSON = function () {
        var _this = this;
        var serialized = {};
        this._headers.forEach(function (values, name) {
            var split = [];
            values.forEach(function (v) { return split.push.apply(split, v.split(',')); });
            serialized[_this._normalizedNames.get(name)] = split;
        });
        return serialized;
    };
    /**
     * Returns list of header values for a given name.
     */
    Headers.prototype.getAll = function (name) {
        return this.has(name) ? this._headers.get(name.toLowerCase()) : null;
    };
    /**
     * This method is not implemented.
     */
    Headers.prototype.entries = function () { throw new Error('"entries" method is not implemented on Headers class'); };
    Headers.prototype.mayBeSetNormalizedName = function (name) {
        var lcName = name.toLowerCase();
        if (!this._normalizedNames.has(lcName)) {
            this._normalizedNames.set(lcName, name);
        }
    };
    return Headers;
}());
//# sourceMappingURL=headers.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "DOCUMENT", function() { return DOCUMENT; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 * @stable
 */
var DOCUMENT = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('DocumentToken');
//# sourceMappingURL=dom_tokens.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_state__ = __webpack_require__(16);
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterLink", function() { return RouterLink; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterLinkWithHref", function() { return RouterLinkWithHref; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * @whatItDoes Lets you link to specific parts of your app.
 *
 * @howToUse
 *
 * Consider the following route configuration:

 * ```
 * [{ path: 'user/:name', component: UserCmp }]
 * ```
 *
 * When linking to this `user/:name` route, you can write:
 *
 * ```
 * <a routerLink='/user/bob'>link to user component</a>
 * ```
 *
 * @description
 *
 * The RouterLink directives let you link to specific parts of your app.
 *
 * Whe the link is static, you can use the directive as follows:
 *
 * ```
 * <a routerLink="/user/bob">link to user component</a>
 * ```
 *
 * If you use dynamic values to generate the link, you can pass an array of path
 * segments, followed by the params for each segment.
 *
 * For instance `['/team', teamId, 'user', userName, {details: true}]`
 * means that we want to generate a link to `/team/11/user/bob;details=true`.
 *
 * Multiple static segments can be merged into one (e.g., `['/team/11/user', userName, {details:
 true}]`).
 *
 * The first segment name can be prepended with `/`, `./`, or `../`:
 * * If the first segment begins with `/`, the router will look up the route from the root of the
 app.
 * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
 * instead look in the children of the current activated route.
 * * And if the first segment begins with `../`, the router will go up one level.
 *
 * You can set query params and fragment as follows:
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">link to user
 component</a>
 * ```
 * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
 *
 * You can also tell the directive to preserve the current query params and fragment:
 *
 * ```
 * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>link to user
 component</a>
 * ```
 *
 * The router link directive always treats the provided input as a delta to the current url.
 *
 * For instance, if the current url is `/user/(box//aux:team)`.
 *
 * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
 * `/user/(jim//aux:team)`.
 *
 * @selector ':not(a)[routerLink]'
 * @ngModule RouterModule
 *
 * See {@link Router.createUrlTree} for more information.
 *
 * @stable
 */
var RouterLink = (function () {
    function RouterLink(router, route, locationStrategy) {
        this.router = router;
        this.route = route;
        this.locationStrategy = locationStrategy;
        this.commands = [];
    }
    Object.defineProperty(RouterLink.prototype, "routerLink", {
        set: function (data) {
            if (Array.isArray(data)) {
                this.commands = data;
            }
            else {
                this.commands = [data];
            }
        },
        enumerable: true,
        configurable: true
    });
    RouterLink.prototype.onClick = function (button, ctrlKey, metaKey) {
        if (button !== 0 || ctrlKey || metaKey) {
            return true;
        }
        this.router.navigateByUrl(this.urlTree);
        return false;
    };
    Object.defineProperty(RouterLink.prototype, "urlTree", {
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: toBool(this.preserveQueryParams),
                preserveFragment: toBool(this.preserveFragment)
            });
        },
        enumerable: true,
        configurable: true
    });
    RouterLink.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: ':not(a)[routerLink]' },] },
    ];
    /** @nocollapse */
    RouterLink.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__router__["Router"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__router_state__["ActivatedRoute"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"], },
    ];
    RouterLink.propDecorators = {
        'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
    };
    return RouterLink;
}());
/**
 * @whatItDoes Lets you link to specific parts of your app.
 *
 * See {@link RouterLink} for more information.
 *
 * @selector 'a[routerLink]'
 * @ngModule RouterModule
 *
 * @stable
 */
var RouterLinkWithHref = (function () {
    function RouterLinkWithHref(router, route, locationStrategy) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.locationStrategy = locationStrategy;
        this.commands = [];
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof __WEBPACK_IMPORTED_MODULE_2__router__["NavigationEnd"]) {
                _this.updateTargetUrlAndHref();
            }
        });
    }
    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
        set: function (data) {
            if (Array.isArray(data)) {
                this.commands = data;
            }
            else {
                this.commands = [data];
            }
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
    RouterLinkWithHref.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey) {
        if (button !== 0 || ctrlKey || metaKey) {
            return true;
        }
        if (typeof this.target === 'string' && this.target != '_self') {
            return true;
        }
        this.router.navigateByUrl(this.urlTree);
        return false;
    };
    RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
    };
    Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: toBool(this.preserveQueryParams),
                preserveFragment: toBool(this.preserveFragment)
            });
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkWithHref.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'a[routerLink]' },] },
    ];
    /** @nocollapse */
    RouterLinkWithHref.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__router__["Router"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__router_state__["ActivatedRoute"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"], },
    ];
    RouterLinkWithHref.propDecorators = {
        'target': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'routerLinkOptions': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'href': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"] },],
        'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
    };
    return RouterLinkWithHref;
}());
function toBool(s) {
    if (s === '')
        return true;
    return !!s;
}
//# sourceMappingURL=router_link.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var services_1 = __webpack_require__(290);
__export(__webpack_require__(290));
exports.ANGULAR2_COOKIE_PROVIDERS = [
    { provide: services_1.CookieOptions, useClass: services_1.BaseCookieOptions },
    { provide: services_1.CookieService, useFactory: cookieServiceFactory, deps: [services_1.CookieOptions] }
];
function cookieServiceFactory(options) {
    return new services_1.CookieService(options);
}
exports.cookieServiceFactory = cookieServiceFactory;

//# sourceMappingURL=core.js.map


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(61);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_FormControlName = (function () {
    function Wrapper_FormControlName(p0, p1, p2, p3) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.FormControlName(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
    }
    Wrapper_FormControlName.prototype.check_name = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.name = currValue;
            this.changes['name'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_FormControlName.prototype.check_model = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.model = currValue;
            this.changes['model'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_FormControlName.prototype.check_isDisabled = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.isDisabled = currValue;
            this.changes['isDisabled'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_FormControlName.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_FormControlName.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FormControlName;
}());
exports.Wrapper_FormControlName = Wrapper_FormControlName;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(53);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_FormGroupDirective = (function () {
    function Wrapper_FormGroupDirective(p0, p1) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.FormGroupDirective(p0, p1);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_FormGroupDirective.prototype.check_form = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.form = currValue;
            this.changes['form'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_FormGroupDirective.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_FormGroupDirective.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FormGroupDirective;
}());
exports.Wrapper_FormGroupDirective = Wrapper_FormGroupDirective;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(54);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_FormGroupName = (function () {
    function Wrapper_FormGroupName(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.FormGroupName(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_FormGroupName.prototype.check_name = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.name = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_FormGroupName.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_FormGroupName.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FormGroupName;
}());
exports.Wrapper_FormGroupName = Wrapper_FormGroupName;
var Wrapper_FormArrayName = (function () {
    function Wrapper_FormArrayName(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.FormArrayName(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_FormArrayName.prototype.check_name = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.name = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_FormArrayName.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_FormArrayName.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FormArrayName;
}());
exports.Wrapper_FormArrayName = Wrapper_FormArrayName;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
__webpack_require__(122);
var DataService = (function () {
    function DataService(http) {
        this.http = http;
        this.baseUrl = '/api/data/';
    }
    DataService.prototype.delete = function (type, filePath) {
        return this.http.get(this.baseUrl + type + '/delete/' + filePath)
            .toPromise()
            .then(function (response) { return response; })
            .catch(this.handleError);
    };
    DataService.prototype.handleError = function (error) {
        console.error('Data API error', error);
        return Promise.reject(error.message || error);
    };
    DataService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], DataService);
    return DataService;
    var _a;
}());
exports.DataService = DataService;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var angular2_universal_1 = __webpack_require__(27);
var common_1 = __webpack_require__(23);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var core_2 = __webpack_require__(112);
//import { isBrowser } from 'angular2-universal';
var LanguageRoutingComponent = (function () {
    function LanguageRoutingComponent(config, location, router, utils, cookieService) {
        this.config = config;
        this.location = location;
        this.router = router;
        this.utils = utils;
        this.cookieService = cookieService;
    }
    LanguageRoutingComponent.prototype.onSelect = function (langSelect) {
        this.currentLanguage = langSelect;
        //console.log('[lang]', this.currentLanguage, '(select)');
    };
    LanguageRoutingComponent.prototype.isRootUrl = function () {
        if (this.location.path() == '/' || this.location.path() == '')
            return true;
        return false;
    };
    // Set some properties based on the current URL
    // Navigate based on existing cookie if no current current language is available in the URL
    LanguageRoutingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isRoot = this.isRootUrl();
        // Need to wait until router has finished so as to get the current path
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                // Get resource URL without language
                _this.resourcePath = _this.utils.getLanguageAgnosticUrl(_this.location.path()); // without the base href
                if (!_this.currentLanguage) {
                    // Current language retrieved from URL by default
                    _this.currentLanguage = _this.utils.getLanguageByUrl(_this.location.path());
                    if (_this.currentLanguage) {
                    }
                    else {
                        // Language cookie not working with SSR
                        // But handled when the browser kicks in: picks up the cookie and navigate with the language in the uRL
                        // This is when SSR is able to render the page in the right language although the server side did not pick up the language
                        var langCookie = null;
                        if (angular2_universal_1.isBrowser) {
                            langCookie = _this.cookieService.get('lang');
                            if (langCookie) {
                                _this.currentLanguage = langCookie;
                                var target = _this.resourcePath;
                                if (!_this.config.data.APP.LANGUAGES.SQUASH || langCookie != _this.config.data.APP.LANGUAGES.PREFERRED) {
                                    target = langCookie + target;
                                    _this.router.navigateByUrl(target);
                                }
                            }
                        }
                        if (!langCookie) {
                            _this.currentLanguage = _this.config.data.APP.LANGUAGES.PREFERRED;
                            var target = _this.resourcePath;
                            if (!_this.config.data.APP.LANGUAGES.SQUASH) {
                                target = _this.config.data.APP.LANGUAGES.PREFERRED + target;
                                _this.router.navigateByUrl(target);
                            }
                        }
                    }
                }
            }
        });
    };
    LanguageRoutingComponent = __decorate([
        core_1.Directive({
            selector: '[lg-routing]',
            exportAs: 'lgRouting',
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _e) || Object])
    ], LanguageRoutingComponent);
    return LanguageRoutingComponent;
    var _a, _b, _c, _d, _e;
}());
exports.LanguageRoutingComponent = LanguageRoutingComponent;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var NameResolverPipe = (function () {
    function NameResolverPipe() {
    }
    NameResolverPipe.prototype.transform = function (value) {
        var sep = ', ';
        if (!value || value.indexOf(sep) == -1)
            return value;
        var first = value.substring(value.indexOf(sep) + sep.length);
        var last = value.substring(0, value.indexOf(sep));
        return first + ' ' + last;
    };
    NameResolverPipe = __decorate([
        core_1.Pipe({
            name: 'nameResolver'
        }), 
        __metadata('design:paramtypes', [])
    ], NameResolverPipe);
    return NameResolverPipe;
}());
exports.NameResolverPipe = NameResolverPipe;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var utils_service_1 = __webpack_require__(2);
var SearchFilterComponent = (function () {
    function SearchFilterComponent(utils, router, route, es) {
        this.utils = utils;
        this.router = router;
        this.route = route;
        this.es = es;
    }
    SearchFilterComponent.prototype.hasActive = function () {
        this.esFilters.forEach(function (f) {
            if (f['term']['active']) {
                console.log(f['term']['active']);
                return true;
            }
            return false;
        });
    };
    SearchFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.searchQueryParams = params['s'];
            _this.filterQueryParams = params['f'];
        });
    };
    SearchFilterComponent.prototype.onRemoveSearch = function () {
        this.es.clearSearchBox = true;
        this.es.searchQuery = this.es.query_search_all;
        // Nav
        var newQueryParams = { queryParams: {} };
        if (this.filterQueryParams)
            newQueryParams.queryParams['f'] = this.filterQueryParams;
        newQueryParams['relativeTo'] = this.route;
        this.router.navigate(['.'], newQueryParams);
    };
    SearchFilterComponent.prototype.onRemoveFilter = function (type, value) {
        var newQueryParams = { queryParams: {} };
        // existing search
        if (this.searchQueryParams)
            newQueryParams.queryParams['s'] = this.searchQueryParams;
        // update filter params
        if (this.filterQueryParams) {
            var newFilterQueryParams = this.utils.removeQueryParam(this.filterQueryParams, type, value);
            if (newFilterQueryParams)
                newQueryParams.queryParams['f'] = newFilterQueryParams;
        }
        // go
        if (this.target)
            this.router.navigate([this.language + '/' + this.target], newQueryParams);
        else {
            newQueryParams['relativeTo'] = this.route;
            this.router.navigate(['.'], newQueryParams);
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchFilterComponent.prototype, "esQuery", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchFilterComponent.prototype, "esFilters", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchFilterComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchFilterComponent.prototype, "target", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchFilterComponent.prototype, "labels", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchFilterComponent.prototype, "language", void 0);
    SearchFilterComponent = __decorate([
        core_1.Component({
            selector: 'search-filters',
            template: "\n    <p class=\"font-alt text-uppercase\">\n      <span class=\"search-filters-intro letter-spacing-4 font-weight-600\"\n        *ngIf=\"esFilters.length>1 || searchQueryParams!=null\">\n          {{title}}: </span>\n          <span *ngIf=\"searchQueryParams!=null\" title=\"search\"> \n            <a (click)=\"onRemoveSearch()\" title=\"search\" class=\"pointer letter-spacing-3 search-filter\">\n              \"{{esQuery.query.bool.must.multi_match.query}}\" <small>x</small>\n            </a>\n      </span>\n      <span *ngFor=\"let filter of esFilters\" title=\"filter\">\n        <a *ngFor=\"let f of filter.term | mapToIterable\" (click)=\"onRemoveFilter(f.key, f.value)\" class=\"pointer letter-spacing-3 search-filter\">\n          <span *ngIf=\"f.key!='active'\">\n            {{labels && labels[f.key.replace('.raw','')].VALUES ? labels[f.key.replace('.raw','')].VALUES[f.value][language] : f.value | nameResolver}} &times;</span>\n        </a>\n      </span>\n    </p>"
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _d) || Object])
    ], SearchFilterComponent);
    return SearchFilterComponent;
    var _a, _b, _c, _d;
}());
exports.SearchFilterComponent = SearchFilterComponent;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var catch_1 = __webpack_require__(245);
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;
//# sourceMappingURL=catch.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var switchMap_1 = __webpack_require__(538);
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var toPromise_1 = __webpack_require__(332);
Observable_1.Observable.prototype.toPromise = toPromise_1.toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    if (typeof project !== 'function') {
        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }
    return this.lift(new MapOperator(project, thisArg));
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(182);
var subscribeToResult_1 = __webpack_require__(185);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return this.lift(new MergeAllOperator(concurrent));
}
exports.mergeAll = mergeAll;
var MergeAllOperator = (function () {
    function MergeAllOperator(concurrent) {
        this.concurrent = concurrent;
    }
    MergeAllOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeAllSubscriber(observer, this.concurrent));
    };
    return MergeAllOperator;
}());
exports.MergeAllOperator = MergeAllOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeAllSubscriber = (function (_super) {
    __extends(MergeAllSubscriber, _super);
    function MergeAllSubscriber(destination, concurrent) {
        _super.call(this, destination);
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
    }
    MergeAllSubscriber.prototype._next = function (observable) {
        if (this.active < this.concurrent) {
            this.active++;
            this.add(subscribeToResult_1.subscribeToResult(this, observable));
        }
        else {
            this.buffer.push(observable);
        }
    };
    MergeAllSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeAllSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeAllSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeAllSubscriber = MergeAllSubscriber;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__ = __webpack_require__(397);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "BrowserModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "platformBrowser", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "Title", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "disableDebugTools", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "enableDebugTools", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "AnimationDriver", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "By", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "NgProbeToken", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DOCUMENT", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "EVENT_MANAGER_PLUGINS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "EventManager", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HAMMER_GESTURE_CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "HammerGestureConfig", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "DomSanitizer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(exports, "__platform_browser_private__", function() { return __WEBPACK_IMPORTED_MODULE_0__src_platform_browser__["o"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-browser package.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "PlatformLocation", function() { return PlatformLocation; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This class should not be used directly by an application developer. Instead, use
 * {@link Location}.
 *
 * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
 * agnostic.
 * This means that we can have different implementation of `PlatformLocation` for the different
 * platforms
 * that angular supports. For example, the default `PlatformLocation` is {@link
 * BrowserPlatformLocation},
 * however when you run your app in a WebWorker you use {@link WebWorkerPlatformLocation}.
 *
 * The `PlatformLocation` class is used directly by all implementations of {@link LocationStrategy}
 * when
 * they need to interact with the DOM apis like pushState, popState, etc...
 *
 * {@link LocationStrategy} in turn is used by the {@link Location} service which is used directly
 * by
 * the {@link Router} in order to navigate between routes. Since all interactions between {@link
 * Router} /
 * {@link Location} / {@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
 * class
 * they are all platform independent.
 *
 * @stable
 */
var PlatformLocation = (function () {
    function PlatformLocation() {
    }
    Object.defineProperty(PlatformLocation.prototype, "pathname", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformLocation.prototype, "search", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformLocation.prototype, "hash", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return PlatformLocation;
}());
//# sourceMappingURL=platform_location.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_util_lang__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__di__ = __webpack_require__(51);
/* harmony export (binding) */ __webpack_require__.d(exports, "APP_INITIALIZER", function() { return APP_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ApplicationInitStatus", function() { return ApplicationInitStatus; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * A function that will be executed when an application is initialized.
 * @experimental
 */
var APP_INITIALIZER = new __WEBPACK_IMPORTED_MODULE_1__di__["a" /* OpaqueToken */]('Application Initializer');
/**
 * A class that reflects the state of running {@link APP_INITIALIZER}s.
 *
 * @experimental
 */
var ApplicationInitStatus = (function () {
    function ApplicationInitStatus(appInits) {
        var _this = this;
        this._done = false;
        var asyncInitPromises = [];
        if (appInits) {
            for (var i = 0; i < appInits.length; i++) {
                var initResult = appInits[i]();
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__src_util_lang__["a" /* isPromise */])(initResult)) {
                    asyncInitPromises.push(initResult);
                }
            }
        }
        this._donePromise = Promise.all(asyncInitPromises).then(function () { _this._done = true; });
        if (asyncInitPromises.length === 0) {
            this._done = true;
        }
    }
    Object.defineProperty(ApplicationInitStatus.prototype, "done", {
        get: function () { return this._done; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationInitStatus.prototype, "donePromise", {
        get: function () { return this._donePromise; },
        enumerable: true,
        configurable: true
    });
    ApplicationInitStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    ApplicationInitStatus.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__di__["c" /* Inject */], args: [APP_INITIALIZER,] }, { type: __WEBPACK_IMPORTED_MODULE_1__di__["d" /* Optional */] },] },
    ];
    return ApplicationInitStatus;
}());
//# sourceMappingURL=application_init.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_error_handler__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_util_lang__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__application_init__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__application_tokens__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__console__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__linker_compiler__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__linker_component_factory__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__linker_component_factory_resolver__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__profile_profile__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__testability_testability__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zone_ng_zone__ = __webpack_require__(105);
/* harmony export (immutable) */ exports["enableProdMode"] = enableProdMode;
/* harmony export (immutable) */ exports["isDevMode"] = isDevMode;
/* harmony export (immutable) */ exports["createPlatform"] = createPlatform;
/* harmony export (immutable) */ exports["createPlatformFactory"] = createPlatformFactory;
/* harmony export (immutable) */ exports["assertPlatform"] = assertPlatform;
/* harmony export (immutable) */ exports["destroyPlatform"] = destroyPlatform;
/* harmony export (immutable) */ exports["getPlatform"] = getPlatform;
/* harmony export (binding) */ __webpack_require__.d(exports, "PlatformRef", function() { return PlatformRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PlatformRef_", function() { return PlatformRef_; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ApplicationRef", function() { return ApplicationRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ApplicationRef_", function() { return ApplicationRef_; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};















var _devMode = true;
var _runModeLocked = false;
var _platform;
/**
 * Disable Angular's development mode, which turns off assertions and other
 * checks within the framework.
 *
 * One important assertion this disables verifies that a change detection pass
 * does not result in additional changes to any bindings (also known as
 * unidirectional data flow).
 *
 * @stable
 */
function enableProdMode() {
    if (_runModeLocked) {
        throw new Error('Cannot enable prod mode after platform setup.');
    }
    _devMode = false;
}
/**
 * Returns whether Angular is in development mode. After called once,
 * the value is locked and won't change any more.
 *
 * By default, this is true, unless a user calls `enableProdMode` before calling this.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function isDevMode() {
    _runModeLocked = true;
    return _devMode;
}
/**
 * Creates a platform.
 * Platforms have to be eagerly created via this function.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function createPlatform(injector) {
    if (_platform && !_platform.destroyed) {
        throw new Error('There can be only one platform. Destroy the previous one to create a new one.');
    }
    _platform = injector.get(PlatformRef);
    var inits = injector.get(__WEBPACK_IMPORTED_MODULE_6__application_tokens__["PLATFORM_INITIALIZER"], null);
    if (inits)
        inits.forEach(function (init) { return init(); });
    return _platform;
}
/**
 * Creates a factory for a platform
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function createPlatformFactory(parentPlaformFactory, name, providers) {
    if (providers === void 0) { providers = []; }
    var marker = new __WEBPACK_IMPORTED_MODULE_8__di__["a" /* OpaqueToken */]("Platform: " + name);
    return function (extraProviders) {
        if (extraProviders === void 0) { extraProviders = []; }
        if (!getPlatform()) {
            if (parentPlaformFactory) {
                parentPlaformFactory(providers.concat(extraProviders).concat({ provide: marker, useValue: true }));
            }
            else {
                createPlatform(__WEBPACK_IMPORTED_MODULE_8__di__["f" /* ReflectiveInjector */].resolveAndCreate(providers.concat(extraProviders).concat({ provide: marker, useValue: true })));
            }
        }
        return assertPlatform(marker);
    };
}
/**
 * Checks that there currently is a platform
 * which contains the given token as a provider.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function assertPlatform(requiredToken) {
    var platform = getPlatform();
    if (!platform) {
        throw new Error('No platform exists!');
    }
    if (!platform.injector.get(requiredToken, null)) {
        throw new Error('A platform with a different configuration has been created. Please destroy it first.');
    }
    return platform;
}
/**
 * Destroy the existing platform.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function destroyPlatform() {
    if (_platform && !_platform.destroyed) {
        _platform.destroy();
    }
}
/**
 * Returns the current platform.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function getPlatform() {
    return _platform && !_platform.destroyed ? _platform : null;
}
/**
 * The Angular platform is the entry point for Angular on a web page. Each page
 * has exactly one platform, and services (such as reflection) which are common
 * to every Angular application running on the page are bound in its scope.
 *
 * A page's platform is initialized implicitly when {@link bootstrap}() is called, or
 * explicitly by calling {@link createPlatform}().
 *
 * @stable
 */
var PlatformRef = (function () {
    function PlatformRef() {
    }
    /**
     * Creates an instance of an `@NgModule` for the given platform
     * for offline compilation.
     *
     * ## Simple Example
     *
     * ```typescript
     * my_module.ts:
     *
     * @NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * main.ts:
     * import {MyModuleNgFactory} from './my_module.ngfactory';
     * import {platformBrowser} from '@angular/platform-browser';
     *
     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
     * ```
     *
     * @experimental APIs related to application bootstrap are currently under review.
     */
    PlatformRef.prototype.bootstrapModuleFactory = function (moduleFactory) {
        throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])();
    };
    /**
     * Creates an instance of an `@NgModule` for a given platform using the given runtime compiler.
     *
     * ## Simple Example
     *
     * ```typescript
     * @NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
     * ```
     * @stable
     */
    PlatformRef.prototype.bootstrapModule = function (moduleType, compilerOptions) {
        if (compilerOptions === void 0) { compilerOptions = []; }
        throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])();
    };
    Object.defineProperty(PlatformRef.prototype, "injector", {
        /**
         * Retrieve the platform {@link Injector}, which is the parent injector for
         * every Angular application on the page and provides singleton providers.
         */
        get: function () { throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(PlatformRef.prototype, "destroyed", {
        get: function () { throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    return PlatformRef;
}());
function _callAndReportToErrorHandler(errorHandler, callback) {
    try {
        var result = callback();
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__src_util_lang__["a" /* isPromise */])(result)) {
            return result.catch(function (e) {
                errorHandler.handleError(e);
                // rethrow as the exception handler might not do it
                throw e;
            });
        }
        return result;
    }
    catch (e) {
        errorHandler.handleError(e);
        // rethrow as the exception handler might not do it
        throw e;
    }
}
var PlatformRef_ = (function (_super) {
    __extends(PlatformRef_, _super);
    function PlatformRef_(_injector) {
        _super.call(this);
        this._injector = _injector;
        this._modules = [];
        this._destroyListeners = [];
        this._destroyed = false;
    }
    PlatformRef_.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    Object.defineProperty(PlatformRef_.prototype, "injector", {
        get: function () { return this._injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformRef_.prototype, "destroyed", {
        get: function () { return this._destroyed; },
        enumerable: true,
        configurable: true
    });
    PlatformRef_.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error('The platform has already been destroyed!');
        }
        this._modules.slice().forEach(function (module) { return module.destroy(); });
        this._destroyListeners.forEach(function (listener) { return listener(); });
        this._destroyed = true;
    };
    PlatformRef_.prototype.bootstrapModuleFactory = function (moduleFactory) {
        return this._bootstrapModuleFactoryWithZone(moduleFactory, null);
    };
    PlatformRef_.prototype._bootstrapModuleFactoryWithZone = function (moduleFactory, ngZone) {
        var _this = this;
        // Note: We need to create the NgZone _before_ we instantiate the module,
        // as instantiating the module creates some providers eagerly.
        // So we create a mini parent injector that just contains the new NgZone and
        // pass that as parent to the NgModuleFactory.
        if (!ngZone)
            ngZone = new __WEBPACK_IMPORTED_MODULE_14__zone_ng_zone__["NgZone"]({ enableLongStackTrace: isDevMode() });
        // Attention: Don't use ApplicationRef.run here,
        // as we want to be sure that all possible constructor calls are inside `ngZone.run`!
        return ngZone.run(function () {
            var ngZoneInjector = __WEBPACK_IMPORTED_MODULE_8__di__["f" /* ReflectiveInjector */].resolveAndCreate([{ provide: __WEBPACK_IMPORTED_MODULE_14__zone_ng_zone__["NgZone"], useValue: ngZone }], _this.injector);
            var moduleRef = moduleFactory.create(ngZoneInjector);
            var exceptionHandler = moduleRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__src_error_handler__["ErrorHandler"], null);
            if (!exceptionHandler) {
                throw new Error('No ErrorHandler. Is platform module (BrowserModule) included?');
            }
            moduleRef.onDestroy(function () { return __WEBPACK_IMPORTED_MODULE_1__src_facade_collection__["e" /* ListWrapper */].remove(_this._modules, moduleRef); });
            ngZone.onError.subscribe({ next: function (error) { exceptionHandler.handleError(error); } });
            return _callAndReportToErrorHandler(exceptionHandler, function () {
                var initStatus = moduleRef.injector.get(__WEBPACK_IMPORTED_MODULE_5__application_init__["ApplicationInitStatus"]);
                return initStatus.donePromise.then(function () {
                    _this._moduleDoBootstrap(moduleRef);
                    return moduleRef;
                });
            });
        });
    };
    PlatformRef_.prototype.bootstrapModule = function (moduleType, compilerOptions) {
        if (compilerOptions === void 0) { compilerOptions = []; }
        return this._bootstrapModuleWithZone(moduleType, compilerOptions, null);
    };
    PlatformRef_.prototype._bootstrapModuleWithZone = function (moduleType, compilerOptions, ngZone, componentFactoryCallback) {
        var _this = this;
        if (compilerOptions === void 0) { compilerOptions = []; }
        var compilerFactory = this.injector.get(__WEBPACK_IMPORTED_MODULE_9__linker_compiler__["CompilerFactory"]);
        var compiler = compilerFactory.createCompiler(Array.isArray(compilerOptions) ? compilerOptions : [compilerOptions]);
        // ugly internal api hack: generate host component factories for all declared components and
        // pass the factories into the callback - this is used by UpdateAdapter to get hold of all
        // factories.
        if (componentFactoryCallback) {
            return compiler.compileModuleAndAllComponentsAsync(moduleType)
                .then(function (_a) {
                var ngModuleFactory = _a.ngModuleFactory, componentFactories = _a.componentFactories;
                componentFactoryCallback(componentFactories);
                return _this._bootstrapModuleFactoryWithZone(ngModuleFactory, ngZone);
            });
        }
        return compiler.compileModuleAsync(moduleType)
            .then(function (moduleFactory) { return _this._bootstrapModuleFactoryWithZone(moduleFactory, ngZone); });
    };
    PlatformRef_.prototype._moduleDoBootstrap = function (moduleRef) {
        var appRef = moduleRef.injector.get(ApplicationRef);
        if (moduleRef.bootstrapFactories.length > 0) {
            moduleRef.bootstrapFactories.forEach(function (compFactory) { return appRef.bootstrap(compFactory); });
        }
        else if (moduleRef.instance.ngDoBootstrap) {
            moduleRef.instance.ngDoBootstrap(appRef);
        }
        else {
            throw new Error(("The module " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__src_facade_lang__["b" /* stringify */])(moduleRef.instance.constructor) + " was bootstrapped, but it does not declare \"@NgModule.bootstrap\" components nor a \"ngDoBootstrap\" method. ") +
                "Please define one of these.");
        }
    };
    PlatformRef_.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_8__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    PlatformRef_.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_8__di__["g" /* Injector */], },
    ];
    return PlatformRef_;
}(PlatformRef));
/**
 * A reference to an Angular application running on a page.
 *
 * For more about Angular applications, see the documentation for {@link bootstrap}.
 *
 * @stable
 */
var ApplicationRef = (function () {
    function ApplicationRef() {
    }
    Object.defineProperty(ApplicationRef.prototype, "componentTypes", {
        /**
         * Get a list of component types registered to this application.
         * This list is populated even before the component is created.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ApplicationRef.prototype, "components", {
        /**
         * Get a list of components registered to this application.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__src_facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    return ApplicationRef;
}());
var ApplicationRef_ = (function (_super) {
    __extends(ApplicationRef_, _super);
    function ApplicationRef_(_zone, _console, _injector, _exceptionHandler, _componentFactoryResolver, _initStatus, _testabilityRegistry, _testability) {
        var _this = this;
        _super.call(this);
        this._zone = _zone;
        this._console = _console;
        this._injector = _injector;
        this._exceptionHandler = _exceptionHandler;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._initStatus = _initStatus;
        this._testabilityRegistry = _testabilityRegistry;
        this._testability = _testability;
        this._bootstrapListeners = [];
        this._rootComponents = [];
        this._rootComponentTypes = [];
        this._changeDetectorRefs = [];
        this._runningTick = false;
        this._enforceNoNewChanges = false;
        this._enforceNoNewChanges = isDevMode();
        this._zone.onMicrotaskEmpty.subscribe({ next: function () { _this._zone.run(function () { _this.tick(); }); } });
    }
    ApplicationRef_.prototype.registerChangeDetector = function (changeDetector) {
        this._changeDetectorRefs.push(changeDetector);
    };
    ApplicationRef_.prototype.unregisterChangeDetector = function (changeDetector) {
        __WEBPACK_IMPORTED_MODULE_1__src_facade_collection__["e" /* ListWrapper */].remove(this._changeDetectorRefs, changeDetector);
    };
    ApplicationRef_.prototype.bootstrap = function (componentOrFactory) {
        var _this = this;
        if (!this._initStatus.done) {
            throw new Error('Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.');
        }
        var componentFactory;
        if (componentOrFactory instanceof __WEBPACK_IMPORTED_MODULE_10__linker_component_factory__["ComponentFactory"]) {
            componentFactory = componentOrFactory;
        }
        else {
            componentFactory = this._componentFactoryResolver.resolveComponentFactory(componentOrFactory);
        }
        this._rootComponentTypes.push(componentFactory.componentType);
        var compRef = componentFactory.create(this._injector, [], componentFactory.selector);
        compRef.onDestroy(function () { _this._unloadComponent(compRef); });
        var testability = compRef.injector.get(__WEBPACK_IMPORTED_MODULE_13__testability_testability__["Testability"], null);
        if (testability) {
            compRef.injector.get(__WEBPACK_IMPORTED_MODULE_13__testability_testability__["TestabilityRegistry"])
                .registerApplication(compRef.location.nativeElement, testability);
        }
        this._loadComponent(compRef);
        if (isDevMode()) {
            this._console.log("Angular 2 is running in the development mode. Call enableProdMode() to enable the production mode.");
        }
        return compRef;
    };
    /** @internal */
    ApplicationRef_.prototype._loadComponent = function (componentRef) {
        this._changeDetectorRefs.push(componentRef.changeDetectorRef);
        this.tick();
        this._rootComponents.push(componentRef);
        // Get the listeners lazily to prevent DI cycles.
        var listeners = this._injector.get(__WEBPACK_IMPORTED_MODULE_6__application_tokens__["APP_BOOTSTRAP_LISTENER"], [])
            .concat(this._bootstrapListeners);
        listeners.forEach(function (listener) { return listener(componentRef); });
    };
    /** @internal */
    ApplicationRef_.prototype._unloadComponent = function (componentRef) {
        if (this._rootComponents.indexOf(componentRef) == -1) {
            return;
        }
        this.unregisterChangeDetector(componentRef.changeDetectorRef);
        __WEBPACK_IMPORTED_MODULE_1__src_facade_collection__["e" /* ListWrapper */].remove(this._rootComponents, componentRef);
    };
    ApplicationRef_.prototype.tick = function () {
        if (this._runningTick) {
            throw new Error('ApplicationRef.tick is called recursively');
        }
        var scope = ApplicationRef_._tickScope();
        try {
            this._runningTick = true;
            this._changeDetectorRefs.forEach(function (detector) { return detector.detectChanges(); });
            if (this._enforceNoNewChanges) {
                this._changeDetectorRefs.forEach(function (detector) { return detector.checkNoChanges(); });
            }
        }
        finally {
            this._runningTick = false;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profile_profile__["b" /* wtfLeave */])(scope);
        }
    };
    ApplicationRef_.prototype.ngOnDestroy = function () {
        // TODO(alxhub): Dispose of the NgZone.
        this._rootComponents.slice().forEach(function (component) { return component.destroy(); });
    };
    Object.defineProperty(ApplicationRef_.prototype, "componentTypes", {
        get: function () { return this._rootComponentTypes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationRef_.prototype, "components", {
        get: function () { return this._rootComponents; },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    ApplicationRef_._tickScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__profile_profile__["a" /* wtfCreateScope */])('ApplicationRef#tick()');
    ApplicationRef_.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_8__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    ApplicationRef_.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_14__zone_ng_zone__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_7__console__["Console"], },
        { type: __WEBPACK_IMPORTED_MODULE_8__di__["g" /* Injector */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__src_error_handler__["ErrorHandler"], },
        { type: __WEBPACK_IMPORTED_MODULE_11__linker_component_factory_resolver__["ComponentFactoryResolver"], },
        { type: __WEBPACK_IMPORTED_MODULE_5__application_init__["ApplicationInitStatus"], },
        { type: __WEBPACK_IMPORTED_MODULE_13__testability_testability__["TestabilityRegistry"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_8__di__["d" /* Optional */] },] },
        { type: __WEBPACK_IMPORTED_MODULE_13__testability_testability__["Testability"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_8__di__["d" /* Optional */] },] },
    ];
    return ApplicationRef_;
}(ApplicationRef));
//# sourceMappingURL=application_ref.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return UNINITIALIZED; });
/* harmony export (immutable) */ exports["b"] = devModeEqual;
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return WrappedValue; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ValueUnwrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return SimpleChange; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__facade_lang__["i"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var UNINITIALIZED = {
    toString: function () { return 'CD_INIT_VALUE'; }
};
function devModeEqual(a, b) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(a) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(b)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["d" /* areIterablesEqual */])(a, b, devModeEqual);
    }
    else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(a) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["k" /* isPrimitive */])(a) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(b) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["k" /* isPrimitive */])(b)) {
        return true;
    }
    else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(a, b);
    }
}
/**
 * Indicates that the result of a {@link Pipe} transformation has changed even though the
 * reference
 * has not changed.
 *
 * The wrapped value will be unwrapped by change detection, and the unwrapped value will be stored.
 *
 * Example:
 *
 * ```
 * if (this._latestValue === this._latestReturnedValue) {
 *    return this._latestReturnedValue;
 *  } else {
 *    this._latestReturnedValue = this._latestValue;
 *    return WrappedValue.wrap(this._latestValue); // this will force update
 *  }
 * ```
 * @stable
 */
var WrappedValue = (function () {
    function WrappedValue(wrapped) {
        this.wrapped = wrapped;
    }
    WrappedValue.wrap = function (value) { return new WrappedValue(value); };
    return WrappedValue;
}());
/**
 * Helper class for unwrapping WrappedValue s
 */
var ValueUnwrapper = (function () {
    function ValueUnwrapper() {
        this.hasWrappedValue = false;
    }
    ValueUnwrapper.prototype.unwrap = function (value) {
        if (value instanceof WrappedValue) {
            this.hasWrappedValue = true;
            return value.wrapped;
        }
        return value;
    };
    ValueUnwrapper.prototype.reset = function () { this.hasWrappedValue = false; };
    return ValueUnwrapper;
}());
/**
 * Represents a basic change from a previous to a new value.
 * @stable
 */
var SimpleChange = (function () {
    function SimpleChange(previousValue, currentValue) {
        this.previousValue = previousValue;
        this.currentValue = currentValue;
    }
    /**
     * Check whether the new value is the first value assigned.
     */
    SimpleChange.prototype.isFirstChange = function () { return this.previousValue === UNINITIALIZED; };
    return SimpleChange;
}());
//# sourceMappingURL=change_detection_util.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ChangeDetectionStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ChangeDetectorStatus; });
/* harmony export (immutable) */ exports["c"] = isDefaultChangeDetectionStrategy;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Describes within the change detector which strategy will be used the next time change
 * detection is triggered.
 * @stable
 */
var ChangeDetectionStrategy;
(function (ChangeDetectionStrategy) {
    /**
     * `OnPush` means that the change detector's mode will be set to `CheckOnce` during hydration.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["OnPush"] = 0] = "OnPush";
    /**
     * `Default` means that the change detector's mode will be set to `CheckAlways` during hydration.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["Default"] = 1] = "Default";
})(ChangeDetectionStrategy || (ChangeDetectionStrategy = {}));
/**
 * Describes the status of the detector.
 */
var ChangeDetectorStatus;
(function (ChangeDetectorStatus) {
    /**
     * `CheckedOnce` means that after calling detectChanges the mode of the change detector
     * will become `Checked`.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["CheckOnce"] = 0] = "CheckOnce";
    /**
     * `Checked` means that the change detector should be skipped until its mode changes to
     * `CheckOnce`.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Checked"] = 1] = "Checked";
    /**
     * `CheckAlways` means that after calling detectChanges the mode of the change detector
     * will remain `CheckAlways`.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["CheckAlways"] = 2] = "CheckAlways";
    /**
     * `Detached` means that the change detector sub tree is not a part of the main tree and
     * should be skipped.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Detached"] = 3] = "Detached";
    /**
     * `Errored` means that the change detector encountered an error checking a binding
     * or calling a directive lifecycle method and is now in an inconsistent state. Change
     * detectors in this state will no longer detect changes.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Errored"] = 4] = "Errored";
    /**
     * `Destroyed` means that the change detector is destroyed.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Destroyed"] = 5] = "Destroyed";
})(ChangeDetectorStatus || (ChangeDetectorStatus = {}));
function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isBlank */])(changeDetectionStrategy) ||
        changeDetectionStrategy === ChangeDetectionStrategy.Default;
}
//# sourceMappingURL=constants.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "Console", function() { return Console; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var Console = (function () {
    function Console() {
    }
    Console.prototype.log = function (message) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["g" /* print */])(message); };
    // Note: for reporting errors use `DOM.logError()` as it is platform specific
    Console.prototype.warn = function (message) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["h" /* warn */])(message); };
    Console.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    Console.ctorParameters = [];
    return Console;
}());
//# sourceMappingURL=console.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return THROW_IF_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return Injector; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var _THROW_IF_NOT_FOUND = new Object();
var THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
var _NullInjector = (function () {
    function _NullInjector() {
    }
    _NullInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = _THROW_IF_NOT_FOUND; }
        if (notFoundValue === _THROW_IF_NOT_FOUND) {
            throw new Error("No provider for " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(token) + "!");
        }
        return notFoundValue;
    };
    return _NullInjector;
}());
/**
 * @whatItDoes Injector interface
 * @howToUse
 * ```
 * const injector: Injector = ...;
 * injector.get(...);
 * ```
 *
 * @description
 * For more details, see the {@linkDocs guide/dependency-injection "Dependency Injection Guide"}.
 *
 * ### Example
 *
 * {@example core/di/ts/injector_spec.ts region='Injector'}
 *
 * `Injector` returns itself when given `Injector` as a token:
 * {@example core/di/ts/injector_spec.ts region='injectInjector'}
 *
 * @stable
 */
var Injector = (function () {
    function Injector() {
    }
    /**
     * Retrieves an instance from the injector based on the provided token.
     * If not found:
     * - Throws {@link NoProviderError} if no `notFoundValue` that is not equal to
     * Injector.THROW_IF_NOT_FOUND is given
     * - Returns the `notFoundValue` otherwise
     */
    Injector.prototype.get = function (token, notFoundValue) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); };
    Injector.THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
    Injector.NULL = new _NullInjector();
    return Injector;
}());
//# sourceMappingURL=injector.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_decorators__ = __webpack_require__(90);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return Inject; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return Optional; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Injectable; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return Self; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return SkipSelf; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return Host; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Inject decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Inject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('Inject', [['token', undefined]]);
/**
 * Optional decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Optional = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('Optional', []);
/**
 * Injectable decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Injectable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('Injectable', []);
/**
 * Self decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Self = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('Self', []);
/**
 * SkipSelf decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var SkipSelf = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('SkipSelf', []);
/**
 * Host decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Host = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["a" /* makeParamDecorator */])('Host', []);
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wtf_impl__ = __webpack_require__(382);
/* unused harmony export wtfEnabled */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return wtfCreateScope; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return wtfLeave; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return wtfStartTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return wtfEndTimeRange; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * True if WTF is enabled.
 */
var wtfEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wtf_impl__["a" /* detectWTF */])();
function noopScope(arg0, arg1) {
    return null;
}
/**
 * Create trace scope.
 *
 * Scopes must be strictly nested and are analogous to stack frames, but
 * do not have to follow the stack frames. Instead it is recommended that they follow logical
 * nesting. You may want to use
 * [Event
 * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
 * as they are defined in WTF.
 *
 * Used to mark scope entry. The return value is used to leave the scope.
 *
 *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
 *
 *     someMethod() {
 *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
 *        // DO SOME WORK HERE
 *        return wtfLeave(s, 123); // Return value 123
 *     }
 *
 * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
 * negatively impact the performance of your application. For this reason we recommend that
 * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
 * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
 * exception, will produce incorrect trace, but presence of exception signifies logic error which
 * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
 * an exception is expected during normal execution while profiling.
 *
 * @experimental
 */
var wtfCreateScope = wtfEnabled ? __WEBPACK_IMPORTED_MODULE_0__wtf_impl__["b" /* createScope */] : function (signature, flags) { return noopScope; };
/**
 * Used to mark end of Scope.
 *
 * - `scope` to end.
 * - `returnValue` (optional) to be passed to the WTF.
 *
 * Returns the `returnValue for easy chaining.
 * @experimental
 */
var wtfLeave = wtfEnabled ? __WEBPACK_IMPORTED_MODULE_0__wtf_impl__["c" /* leave */] : function (s, r) { return r; };
/**
 * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
 * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
 * enabled.
 *
 *     someMethod() {
 *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
 *        var future = new Future.delay(5).then((_) {
 *          wtfEndTimeRange(s);
 *        });
 *     }
 * @experimental
 */
var wtfStartTimeRange = wtfEnabled ? __WEBPACK_IMPORTED_MODULE_0__wtf_impl__["d" /* startTimeRange */] : function (rangeType, action) { return null; };
/**
 * Ends a async time range operation.
 * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
 * enabled.
 * @experimental
 */
var wtfEndTimeRange = wtfEnabled ? __WEBPACK_IMPORTED_MODULE_0__wtf_impl__["e" /* endTimeRange */] : function (r) { return null; };
//# sourceMappingURL=profile.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony export (binding) */ __webpack_require__.d(exports, "RenderComponentType", function() { return RenderComponentType; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RenderDebugInfo", function() { return RenderDebugInfo; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Renderer", function() { return Renderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RootRenderer", function() { return RootRenderer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @experimental
 */
// TODO (matsko): add typing for the animation function
var RenderComponentType = (function () {
    function RenderComponentType(id, templateUrl, slotCount, encapsulation, styles, animations) {
        this.id = id;
        this.templateUrl = templateUrl;
        this.slotCount = slotCount;
        this.encapsulation = encapsulation;
        this.styles = styles;
        this.animations = animations;
    }
    return RenderComponentType;
}());
var RenderDebugInfo = (function () {
    function RenderDebugInfo() {
    }
    Object.defineProperty(RenderDebugInfo.prototype, "injector", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderDebugInfo.prototype, "component", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderDebugInfo.prototype, "providerTokens", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderDebugInfo.prototype, "references", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderDebugInfo.prototype, "context", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderDebugInfo.prototype, "source", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    return RenderDebugInfo;
}());
/**
 * @experimental
 */
var Renderer = (function () {
    function Renderer() {
    }
    return Renderer;
}());
/**
 * Injectable service that provides a low-level interface for modifying the UI.
 *
 * Use this service to bypass Angular's templating and make custom UI changes that can't be
 * expressed declaratively. For example if you need to set a property or an attribute whose name is
 * not statically known, use {@link #setElementProperty} or {@link #setElementAttribute}
 * respectively.
 *
 * If you are implementing a custom renderer, you must implement this interface.
 *
 * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
 * @experimental
 */
var RootRenderer = (function () {
    function RootRenderer() {
    }
    return RootRenderer;
}());
//# sourceMappingURL=api.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zone_ng_zone__ = __webpack_require__(105);
/* harmony export (binding) */ __webpack_require__.d(exports, "Testability", function() { return Testability; });
/* harmony export (binding) */ __webpack_require__.d(exports, "TestabilityRegistry", function() { return TestabilityRegistry; });
/* harmony export (immutable) */ exports["setTestabilityGetter"] = setTestabilityGetter;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * The Testability service provides testing hooks that can be accessed from
 * the browser and by services such as Protractor. Each bootstrapped Angular
 * application on the page will have an instance of Testability.
 * @experimental
 */
var Testability = (function () {
    function Testability(_ngZone) {
        this._ngZone = _ngZone;
        /** @internal */
        this._pendingCount = 0;
        /** @internal */
        this._isZoneStable = true;
        /**
         * Whether any work was done since the last 'whenStable' callback. This is
         * useful to detect if this could have potentially destabilized another
         * component while it is stabilizing.
         * @internal
         */
        this._didWork = false;
        /** @internal */
        this._callbacks = [];
        this._watchAngularEvents();
    }
    /** @internal */
    Testability.prototype._watchAngularEvents = function () {
        var _this = this;
        this._ngZone.onUnstable.subscribe({
            next: function () {
                _this._didWork = true;
                _this._isZoneStable = false;
            }
        });
        this._ngZone.runOutsideAngular(function () {
            _this._ngZone.onStable.subscribe({
                next: function () {
                    __WEBPACK_IMPORTED_MODULE_3__zone_ng_zone__["NgZone"].assertNotInAngularZone();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["l" /* scheduleMicroTask */])(function () {
                        _this._isZoneStable = true;
                        _this._runCallbacksIfReady();
                    });
                }
            });
        });
    };
    Testability.prototype.increasePendingRequestCount = function () {
        this._pendingCount += 1;
        this._didWork = true;
        return this._pendingCount;
    };
    Testability.prototype.decreasePendingRequestCount = function () {
        this._pendingCount -= 1;
        if (this._pendingCount < 0) {
            throw new Error('pending async requests below zero');
        }
        this._runCallbacksIfReady();
        return this._pendingCount;
    };
    Testability.prototype.isStable = function () {
        return this._isZoneStable && this._pendingCount == 0 && !this._ngZone.hasPendingMacrotasks;
    };
    /** @internal */
    Testability.prototype._runCallbacksIfReady = function () {
        var _this = this;
        if (this.isStable()) {
            // Schedules the call backs in a new frame so that it is always async.
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["l" /* scheduleMicroTask */])(function () {
                while (_this._callbacks.length !== 0) {
                    (_this._callbacks.pop())(_this._didWork);
                }
                _this._didWork = false;
            });
        }
        else {
            // Not Ready
            this._didWork = true;
        }
    };
    Testability.prototype.whenStable = function (callback) {
        this._callbacks.push(callback);
        this._runCallbacksIfReady();
    };
    Testability.prototype.getPendingRequestCount = function () { return this._pendingCount; };
    /** @deprecated use findProviders */
    Testability.prototype.findBindings = function (using, provider, exactMatch) {
        // TODO(juliemr): implement.
        return [];
    };
    Testability.prototype.findProviders = function (using, provider, exactMatch) {
        // TODO(juliemr): implement.
        return [];
    };
    Testability.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    Testability.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__zone_ng_zone__["NgZone"], },
    ];
    return Testability;
}());
/**
 * A global registry of {@link Testability} instances for specific elements.
 * @experimental
 */
var TestabilityRegistry = (function () {
    function TestabilityRegistry() {
        /** @internal */
        this._applications = new Map();
        _testabilityGetter.addToWindow(this);
    }
    TestabilityRegistry.prototype.registerApplication = function (token, testability) {
        this._applications.set(token, testability);
    };
    TestabilityRegistry.prototype.getTestability = function (elem) { return this._applications.get(elem); };
    TestabilityRegistry.prototype.getAllTestabilities = function () { return __WEBPACK_IMPORTED_MODULE_1__facade_collection__["a" /* MapWrapper */].values(this._applications); };
    TestabilityRegistry.prototype.getAllRootElements = function () { return __WEBPACK_IMPORTED_MODULE_1__facade_collection__["a" /* MapWrapper */].keys(this._applications); };
    TestabilityRegistry.prototype.findTestabilityInTree = function (elem, findInAncestors) {
        if (findInAncestors === void 0) { findInAncestors = true; }
        return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
    };
    TestabilityRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    TestabilityRegistry.ctorParameters = [];
    return TestabilityRegistry;
}());
var _NoopGetTestability = (function () {
    function _NoopGetTestability() {
    }
    _NoopGetTestability.prototype.addToWindow = function (registry) { };
    _NoopGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        return null;
    };
    return _NoopGetTestability;
}());
/**
 * Set the {@link GetTestability} implementation used by the Angular testing framework.
 * @experimental
 */
function setTestabilityGetter(getter) {
    _testabilityGetter = getter;
}
var _testabilityGetter = new _NoopGetTestability();
//# sourceMappingURL=testability.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__ = __webpack_require__(278);
/* unused harmony export modelGroupProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModelGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var modelGroupProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * @whatItDoes Creates and binds a {@link FormGroup} instance to a DOM element.
 *
 * @howToUse
 *
 * This directive can only be used as a child of {@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * @stable
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    function NgModelGroup(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /** @internal */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__ng_form__["NgForm"])) {
            __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__["a" /* TemplateDrivenErrors */].modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["ControlContainer"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["NG_ASYNC_VALIDATORS"],] },] },
    ];
    NgModelGroup.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
//# sourceMappingURL=ng_model_group.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(277);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReactiveErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName);
    };
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formArrayName);
    };
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
//# sourceMappingURL=reactive_errors.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_shared__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_import_core__ = __webpack_require__(280);
/* unused harmony export VALID */
/* unused harmony export INVALID */
/* unused harmony export PENDING */
/* unused harmony export DISABLED */
/* unused harmony export isControl */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return FormArray; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
function isControl(control) {
    return control instanceof AbstractControl;
}
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = path.split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return path.reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(name) || null;
        }
        return null;
    }, control);
}
function toObservable(r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__private_import_core__["a" /* isPromise */])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
}
function coerceToValidator(validator) {
    return Array.isArray(validator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["b" /* composeValidators */])(validator) : validator;
}
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["c" /* composeAsyncValidators */])(asyncValidator) : asyncValidator;
}
/**
 * @whatItDoes This is the base class for {@link FormControl}, {@link FormGroup}, and
 * {@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * @stable
 */
var AbstractControl = (function () {
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /** @internal */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /** @internal */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
        * A control is marked `touched` once the user has triggered
        * a `blur` event on it.
        */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pending`.
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            this._cancelExistingSubscription();
            var obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
        }
    };
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        var control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    AbstractControl.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return !!this.getError(errorCode, path);
    };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         */
        get: function () {
            var x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /** @internal */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
    };
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /** @internal */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /** @internal */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /** @internal */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /** @internal */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
/**
 * @whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {@link FormGroup} and {@link FormArray}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 *```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
        /** @internal */
        this._onChange = [];
        this._applyFormState(formState);
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this._initObservables();
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {@link FormControl.setValue} at this level.
     * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf });
    };
    /**
     * @internal
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * @internal
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * @internal
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * @internal
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @internal
     */
    FormControl.prototype._forEachChild = function (cb) { };
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * @whatItDoes Tracks the value and validity state of a group of {@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {@link FormControl} and {@link FormArray}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {@link FormGroup.addControl} instead.
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {@link AbstractControl.get} instead.
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
    };
    /**
     *  Patches the value of the {@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
    };
    /**
     * Resets the {@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the {@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control.value;
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /** @internal */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /** @internal */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /** @internal */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /** @internal */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /** @internal */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /** @internal */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /** @internal */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * @whatItDoes Tracks the value and validity state of an array of {@link FormControl}
 * instances.
 *
 * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {@link FormControl} and {@link FormGroup}.
 *
 * @howToUse
 *
 * When instantiating a {@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `@angular/forms`
 *
 * @stable
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    function FormArray(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     * Get the {@link AbstractControl} at the given `index` in the array.
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {@link AbstractControl} at the end of the array.
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {@link AbstractControl} at the given `index` in the array.
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
    };
    /**
     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
    };
    /**
     * Resets the {@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     */
    FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
    /** @internal */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /** @internal */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /** @internal */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /** @internal */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /** @internal */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /** @internal */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /** @internal */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
//# sourceMappingURL=model.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "BrowserXhr", function() { return BrowserXhr; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A backend for http that uses the `XMLHttpRequest` browser API.
 *
 * Take care not to evaluate this in non-browser contexts.
 *
 * @experimental
 */
var BrowserXhr = (function () {
    function BrowserXhr() {
    }
    BrowserXhr.prototype.build = function () { return (new XMLHttpRequest()); };
    BrowserXhr.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BrowserXhr.ctorParameters = [];
    return BrowserXhr;
}());
//# sourceMappingURL=browser_xhr.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http_utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__url_search_params__ = __webpack_require__(145);
/* harmony export (binding) */ __webpack_require__.d(exports, "RequestOptions", function() { return RequestOptions; });
/* harmony export (binding) */ __webpack_require__.d(exports, "BaseRequestOptions", function() { return BaseRequestOptions; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






/**
 * Creates a request options object to be optionally provided when instantiating a
 * {@link Request}.
 *
 * This class is based on the `RequestInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#requestinit).
 *
 * All values are null by default. Typical defaults can be found in the {@link BaseRequestOptions}
 * class, which sub-classes `RequestOptions`.
 *
 * ### Example ([live demo](http://plnkr.co/edit/7Wvi3lfLq41aQPKlxB4O?p=preview))
 *
 * ```typescript
 * import {RequestOptions, Request, RequestMethod} from '@angular/http';
 *
 * var options = new RequestOptions({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * });
 * var req = new Request(options);
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // https://google.com
 * ```
 *
 * @experimental
 */
var RequestOptions = (function () {
    function RequestOptions(_a) {
        var _b = _a === void 0 ? {} : _a, method = _b.method, headers = _b.headers, body = _b.body, url = _b.url, search = _b.search, withCredentials = _b.withCredentials, responseType = _b.responseType;
        this.method = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(method) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__http_utils__["e" /* normalizeMethodName */])(method) : null;
        this.headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(headers) ? headers : null;
        this.body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(body) ? body : null;
        this.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(url) ? url : null;
        this.search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(search) ?
            (typeof search === 'string' ? new __WEBPACK_IMPORTED_MODULE_5__url_search_params__["a" /* URLSearchParams */]((search)) :
                (search)) :
            null;
        this.withCredentials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(withCredentials) ? withCredentials : null;
        this.responseType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(responseType) ? responseType : null;
    }
    /**
     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * Note that `headers` and `search` will override existing values completely if present in
     * the `options` object. If these values should be merged, it should be done prior to calling
     * `merge` on the `RequestOptions` instance.
     *
     * ### Example ([live demo](http://plnkr.co/edit/6w8XA8YTkDRcPYpdB9dk?p=preview))
     *
     * ```typescript
     * import {RequestOptions, Request, RequestMethod} from '@angular/http';
     *
     * var options = new RequestOptions({
     *   method: RequestMethod.Post
     * });
     * var req = new Request(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('req.method:', RequestMethod[req.method]); // Post
     * console.log('options.url:', options.url); // null
     * console.log('req.url:', req.url); // https://google.com
     * ```
     */
    RequestOptions.prototype.merge = function (options) {
        return new RequestOptions({
            method: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.method) ? options.method : this.method,
            headers: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.headers) ? options.headers : this.headers,
            body: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.body) ? options.body : this.body,
            url: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.url) ? options.url : this.url,
            search: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.search) ?
                (typeof options.search === 'string' ? new __WEBPACK_IMPORTED_MODULE_5__url_search_params__["a" /* URLSearchParams */](options.search) :
                    (options.search).clone()) :
                this.search,
            withCredentials: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.withCredentials) ? options.withCredentials :
                this.withCredentials,
            responseType: options && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(options.responseType) ? options.responseType :
                this.responseType
        });
    };
    return RequestOptions;
}());
/**
 * Subclass of {@link RequestOptions}, with default values.
 *
 * Default values:
 *  * method: {@link RequestMethod RequestMethod.Get}
 *  * headers: empty {@link Headers} object
 *
 * This class could be extended and bound to the {@link RequestOptions} class
 * when configuring an {@link Injector}, in order to override the default options
 * used by {@link Http} to create and send {@link Request Requests}.
 *
 * ### Example ([live demo](http://plnkr.co/edit/LEKVSx?p=preview))
 *
 * ```typescript
 * import {provide} from '@angular/core';
 * import {bootstrap} from '@angular/platform-browser/browser';
 * import {HTTP_PROVIDERS, Http, BaseRequestOptions, RequestOptions} from '@angular/http';
 * import {App} from './myapp';
 *
 * class MyOptions extends BaseRequestOptions {
 *   search: string = 'coreTeam=true';
 * }
 *
 * bootstrap(App, [HTTP_PROVIDERS, {provide: RequestOptions, useClass: MyOptions}]);
 * ```
 *
 * The options could also be extended when manually creating a {@link Request}
 * object.
 *
 * ### Example ([live demo](http://plnkr.co/edit/oyBoEvNtDhOSfi9YxaVb?p=preview))
 *
 * ```
 * import {BaseRequestOptions, Request, RequestMethod} from '@angular/http';
 *
 * var options = new BaseRequestOptions();
 * var req = new Request(options.merge({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * }));
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // null
 * console.log('req.url:', req.url); // https://google.com
 * ```
 *
 * @experimental
 */
var BaseRequestOptions = (function (_super) {
    __extends(BaseRequestOptions, _super);
    function BaseRequestOptions() {
        _super.call(this, { method: __WEBPACK_IMPORTED_MODULE_2__enums__["b" /* RequestMethod */].Get, headers: new __WEBPACK_IMPORTED_MODULE_3__headers__["a" /* Headers */]() });
    }
    BaseRequestOptions.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BaseRequestOptions.ctorParameters = [];
    return BaseRequestOptions;
}(RequestOptions));
//# sourceMappingURL=base_request_options.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_request_options__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interfaces__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_request__ = __webpack_require__(283);
/* harmony export (binding) */ __webpack_require__.d(exports, "Http", function() { return Http; });
/* harmony export (binding) */ __webpack_require__.d(exports, "Jsonp", function() { return Jsonp; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






function httpRequest(backend, request) {
    return backend.createConnection(request).response;
}
function mergeOptions(defaultOpts, providedOpts, method, url) {
    var newOptions = defaultOpts;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(providedOpts)) {
        // Hack so Dart can used named parameters
        return newOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({
            method: providedOpts.method || method,
            url: providedOpts.url || url,
            search: providedOpts.search,
            headers: providedOpts.headers,
            body: providedOpts.body,
            withCredentials: providedOpts.withCredentials,
            responseType: providedOpts.responseType
        }));
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["d" /* isPresent */])(method)) {
        return newOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({ method: method, url: url }));
    }
    else {
        return newOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({ url: url }));
    }
}
/**
 * Performs http requests using `XMLHttpRequest` as the default backend.
 *
 * `Http` is available as an injectable class, with methods to perform http requests. Calling
 * `request` returns an `Observable` which will emit a single {@link Response} when a
 * response is received.
 *
 * ### Example
 *
 * ```typescript
 * import {Http, HTTP_PROVIDERS} from '@angular/http';
 * import 'rxjs/add/operator/map'
 * @Component({
 *   selector: 'http-app',
 *   viewProviders: [HTTP_PROVIDERS],
 *   templateUrl: 'people.html'
 * })
 * class PeopleComponent {
 *   constructor(http: Http) {
 *     http.get('people.json')
 *       // Call map on the response observable to get the parsed people object
 *       .map(res => res.json())
 *       // Subscribe to the observable to get the parsed people object and attach it to the
 *       // component
 *       .subscribe(people => this.people = people);
 *   }
 * }
 * ```
 *
 *
 * ### Example
 *
 * ```
 * http.get('people.json').subscribe((res:Response) => this.people = res.json());
 * ```
 *
 * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
 * {@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
 * the {@link XHRBackend} provider, as in the following example:
 *
 * ### Example
 *
 * ```typescript
 * import {BaseRequestOptions, Http} from '@angular/http';
 * import {MockBackend} from '@angular/http/testing';
 * var injector = Injector.resolveAndCreate([
 *   BaseRequestOptions,
 *   MockBackend,
 *   {provide: Http, useFactory:
 *       function(backend, defaultOptions) {
 *         return new Http(backend, defaultOptions);
 *       },
 *       deps: [MockBackend, BaseRequestOptions]}
 * ]);
 * var http = injector.get(Http);
 * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
 * ```
 *
 * @experimental
 */
var Http = (function () {
    function Http(_backend, _defaultOptions) {
        this._backend = _backend;
        this._defaultOptions = _defaultOptions;
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {@link BaseRequestOptions} before performing the request.
     */
    Http.prototype.request = function (url, options) {
        var responseObservable;
        if (typeof url === 'string') {
            responseObservable = httpRequest(this._backend, new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Get, url)));
        }
        else if (url instanceof __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */]) {
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    /**
     * Performs a request with `get` http method.
     */
    Http.prototype.get = function (url, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Get, url)));
    };
    /**
     * Performs a request with `post` http method.
     */
    Http.prototype.post = function (url, body, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({ body: body })), options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Post, url)));
    };
    /**
     * Performs a request with `put` http method.
     */
    Http.prototype.put = function (url, body, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({ body: body })), options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Put, url)));
    };
    /**
     * Performs a request with `delete` http method.
     */
    Http.prototype.delete = function (url, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Delete, url)));
    };
    /**
     * Performs a request with `patch` http method.
     */
    Http.prototype.patch = function (url, body, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions.merge(new __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"]({ body: body })), options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Patch, url)));
    };
    /**
     * Performs a request with `head` http method.
     */
    Http.prototype.head = function (url, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Head, url)));
    };
    /**
     * Performs a request with `options` http method.
     */
    Http.prototype.options = function (url, options) {
        return this.request(new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Options, url)));
    };
    Http.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Http.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__interfaces__["ConnectionBackend"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"], },
    ];
    return Http;
}());
/**
 * @experimental
 */
var Jsonp = (function (_super) {
    __extends(Jsonp, _super);
    function Jsonp(backend, defaultOptions) {
        _super.call(this, backend, defaultOptions);
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {@link BaseRequestOptions} before performing the request.
     *
     * @security Regular XHR is the safest alternative to JSONP for most applications, and is
     * supported by all current browsers. Because JSONP creates a `<script>` element with
     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
     * source could expose your application to XSS risks. Data exposed by JSONP may also be
     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
     * future security issues (e.g. content sniffing).  For more detail, see the
     * [Security Guide](http://g.co/ng/security).
     */
    Jsonp.prototype.request = function (url, options) {
        var responseObservable;
        if (typeof url === 'string') {
            url =
                new __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */](mergeOptions(this._defaultOptions, options, __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Get, url));
        }
        if (url instanceof __WEBPACK_IMPORTED_MODULE_5__static_request__["a" /* Request */]) {
            if (url.method !== __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Get) {
                throw new Error('JSONP requests must use GET request method.');
            }
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    Jsonp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    Jsonp.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__interfaces__["ConnectionBackend"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__base_request_options__["RequestOptions"], },
    ];
    return Jsonp;
}(Http));
//# sourceMappingURL=http.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_facade_lang__ = __webpack_require__(1);
/* harmony export (immutable) */ exports["e"] = normalizeMethodName;
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return isSuccess; });
/* harmony export (immutable) */ exports["c"] = getResponseURL;
/* harmony export (immutable) */ exports["b"] = stringToArrayBuffer;
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_facade_lang__["e"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

function normalizeMethodName(method) {
    if (typeof method !== 'string')
        return method;
    switch (method.toUpperCase()) {
        case 'GET':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Get;
        case 'POST':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Post;
        case 'PUT':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Put;
        case 'DELETE':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Delete;
        case 'OPTIONS':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Options;
        case 'HEAD':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Head;
        case 'PATCH':
            return __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* RequestMethod */].Patch;
    }
    throw new Error("Invalid request method. The method \"" + method + "\" is not supported.");
}
var isSuccess = function (status) { return (status >= 200 && status < 300); };
function getResponseURL(xhr) {
    if ('responseURL' in xhr) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return;
}
function stringToArrayBuffer(input) {
    var view = new Uint16Array(input.length);
    for (var i = 0, strLen = input.length; i < strLen; i++) {
        view[i] = input.charCodeAt(i);
    }
    return view.buffer;
}

//# sourceMappingURL=http_utils.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return QueryEncoder; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return URLSearchParams; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function paramParser(rawParams) {
    if (rawParams === void 0) { rawParams = ''; }
    var map = new Map();
    if (rawParams.length > 0) {
        var params = rawParams.split('&');
        params.forEach(function (param) {
            var eqIdx = param.indexOf('=');
            var _a = eqIdx == -1 ? [param, ''] : [param.slice(0, eqIdx), param.slice(eqIdx + 1)], key = _a[0], val = _a[1];
            var list = map.get(key) || [];
            list.push(val);
            map.set(key, list);
        });
    }
    return map;
}
/**
 * @experimental
 **/
var QueryEncoder = (function () {
    function QueryEncoder() {
    }
    QueryEncoder.prototype.encodeKey = function (k) { return standardEncoding(k); };
    QueryEncoder.prototype.encodeValue = function (v) { return standardEncoding(v); };
    return QueryEncoder;
}());
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * Map-like representation of url search parameters, based on
 * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
 * with several extensions for merging URLSearchParams objects:
 *   - setAll()
 *   - appendAll()
 *   - replaceAll()
 *
 * This class accepts an optional second parameter of ${@link QueryEncoder},
 * which is used to serialize parameters before making a request. By default,
 * `QueryEncoder` encodes keys and values of parameters using `encodeURIComponent`,
 * and then un-encodes certain characters that are allowed to be part of the query
 * according to IETF RFC 3986: https://tools.ietf.org/html/rfc3986.
 *
 * These are the characters that are not encoded: `! $ \' ( ) * + , ; A 9 - . _ ~ ? /`
 *
 * If the set of allowed query characters is not acceptable for a particular backend,
 * `QueryEncoder` can be subclassed and provided as the 2nd argument to URLSearchParams.
 *
 * ```
 * import {URLSearchParams, QueryEncoder} from '@angular/http';
 * class MyQueryEncoder extends QueryEncoder {
 *   encodeKey(k: string): string {
 *     return myEncodingFunction(k);
 *   }
 *
 *   encodeValue(v: string): string {
 *     return myEncodingFunction(v);
 *   }
 * }
 *
 * let params = new URLSearchParams('', new MyQueryEncoder());
 * ```
 * @experimental
 */
var URLSearchParams = (function () {
    function URLSearchParams(rawParams, queryEncoder) {
        if (rawParams === void 0) { rawParams = ''; }
        if (queryEncoder === void 0) { queryEncoder = new QueryEncoder(); }
        this.rawParams = rawParams;
        this.queryEncoder = queryEncoder;
        this.paramsMap = paramParser(rawParams);
    }
    URLSearchParams.prototype.clone = function () {
        var clone = new URLSearchParams('', this.queryEncoder);
        clone.appendAll(this);
        return clone;
    };
    URLSearchParams.prototype.has = function (param) { return this.paramsMap.has(param); };
    URLSearchParams.prototype.get = function (param) {
        var storedParam = this.paramsMap.get(param);
        return Array.isArray(storedParam) ? storedParam[0] : null;
    };
    URLSearchParams.prototype.getAll = function (param) { return this.paramsMap.get(param) || []; };
    URLSearchParams.prototype.set = function (param, val) {
        if (val === void 0 || val === null) {
            this.delete(param);
            return;
        }
        var list = this.paramsMap.get(param) || [];
        list.length = 0;
        list.push(val);
        this.paramsMap.set(param, list);
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `set(name, values[0])`
    //
    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.setAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            list.length = 0;
            list.push(value[0]);
            _this.paramsMap.set(param, list);
        });
    };
    URLSearchParams.prototype.append = function (param, val) {
        if (val === void 0 || val === null)
            return;
        var list = this.paramsMap.get(param) || [];
        list.push(val);
        this.paramsMap.set(param, list);
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `append(name, value)`
    // for each value in `values`.
    //
    // E.g: "a=[1,2], c=[8]" + "a=[3,4], b=[7]" = "a=[1,2,3,4], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.appendAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            for (var i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `delete(name)`,
    // followed by `set(name, values)`
    //
    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4,5,6], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.replaceAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            list.length = 0;
            for (var i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    URLSearchParams.prototype.toString = function () {
        var _this = this;
        var paramsList = [];
        this.paramsMap.forEach(function (values, k) {
            values.forEach(function (v) { return paramsList.push(_this.queryEncoder.encodeKey(k) + '=' + _this.queryEncoder.encodeValue(v)); });
        });
        return paramsList.join('&');
    };
    URLSearchParams.prototype.delete = function (param) { this.paramsMap.delete(param); };
    return URLSearchParams;
}());
//# sourceMappingURL=url_search_params.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__private_import_core__ = __webpack_require__(399);
/* harmony export (binding) */ __webpack_require__.d(exports, "AnimationDriver", function() { return AnimationDriver; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var _NoOpAnimationDriver = (function () {
    function _NoOpAnimationDriver() {
    }
    _NoOpAnimationDriver.prototype.animate = function (element, startingStyles, keyframes, duration, delay, easing) {
        return new __WEBPACK_IMPORTED_MODULE_0__private_import_core__["a" /* NoOpAnimationPlayer */]();
    };
    return _NoOpAnimationDriver;
}());
/**
 * @experimental
 */
var AnimationDriver = (function () {
    function AnimationDriver() {
    }
    AnimationDriver.NOOP = new _NoOpAnimationDriver();
    return AnimationDriver;
}());
//# sourceMappingURL=animation_driver.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hammer_common__ = __webpack_require__(393);
/* harmony export (binding) */ __webpack_require__.d(exports, "HAMMER_GESTURE_CONFIG", function() { return HAMMER_GESTURE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(exports, "HammerGestureConfig", function() { return HammerGestureConfig; });
/* harmony export (binding) */ __webpack_require__.d(exports, "HammerGesturesPlugin", function() { return HammerGesturesPlugin; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * A DI token that you can use to provide{@link HammerGestureConfig} to Angular. Use it to configure
 * Hammer gestures.
 *
 * @experimental
 */
var HAMMER_GESTURE_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('HammerGestureConfig');
/**
 * @experimental
 */
var HammerGestureConfig = (function () {
    function HammerGestureConfig() {
        this.events = [];
        this.overrides = {};
    }
    HammerGestureConfig.prototype.buildHammer = function (element) {
        var mc = new Hammer(element);
        mc.get('pinch').set({ enable: true });
        mc.get('rotate').set({ enable: true });
        for (var eventName in this.overrides) {
            mc.get(eventName).set(this.overrides[eventName]);
        }
        return mc;
    };
    HammerGestureConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HammerGestureConfig.ctorParameters = [];
    return HammerGestureConfig;
}());
var HammerGesturesPlugin = (function (_super) {
    __extends(HammerGesturesPlugin, _super);
    function HammerGesturesPlugin(_config) {
        _super.call(this);
        this._config = _config;
    }
    HammerGesturesPlugin.prototype.supports = function (eventName) {
        if (!_super.prototype.supports.call(this, eventName) && !this.isCustomEvent(eventName))
            return false;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(window['Hammer'])) {
            throw new Error("Hammer.js is not loaded, can not bind " + eventName + " event");
        }
        return true;
    };
    HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var _this = this;
        var zone = this.manager.getZone();
        eventName = eventName.toLowerCase();
        return zone.runOutsideAngular(function () {
            // Creating the manager bind events, must be done outside of angular
            var mc = _this._config.buildHammer(element);
            var callback = function (eventObj /** TODO #???? */) {
                zone.runGuarded(function () { handler(eventObj); });
            };
            mc.on(eventName, callback);
            return function () { mc.off(eventName, callback); };
        });
    };
    HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) { return this._config.events.indexOf(eventName) > -1; };
    HammerGesturesPlugin.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HammerGesturesPlugin.ctorParameters = [
        { type: HammerGestureConfig, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [HAMMER_GESTURE_CONFIG,] },] },
    ];
    return HammerGesturesPlugin;
}(__WEBPACK_IMPORTED_MODULE_2__hammer_common__["a" /* HammerGesturesPluginCommon */]));
//# sourceMappingURL=hammer_gestures.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_tokens__ = __webpack_require__(110);
/* harmony export (binding) */ __webpack_require__.d(exports, "SharedStylesHost", function() { return SharedStylesHost; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DomSharedStylesHost", function() { return DomSharedStylesHost; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var SharedStylesHost = (function () {
    function SharedStylesHost() {
        /** @internal */
        this._styles = [];
        /** @internal */
        this._stylesSet = new Set();
    }
    SharedStylesHost.prototype.addStyles = function (styles) {
        var _this = this;
        var additions = [];
        styles.forEach(function (style) {
            if (!_this._stylesSet.has(style)) {
                _this._stylesSet.add(style);
                _this._styles.push(style);
                additions.push(style);
            }
        });
        this.onStylesAdded(additions);
    };
    SharedStylesHost.prototype.onStylesAdded = function (additions) { };
    SharedStylesHost.prototype.getAllStyles = function () { return this._styles; };
    SharedStylesHost.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    SharedStylesHost.ctorParameters = [];
    return SharedStylesHost;
}());
var DomSharedStylesHost = (function (_super) {
    __extends(DomSharedStylesHost, _super);
    function DomSharedStylesHost(doc) {
        _super.call(this);
        this._hostNodes = new Set();
        this._hostNodes.add(doc.head);
    }
    /** @internal */
    DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
        for (var i = 0; i < styles.length; i++) {
            var style = styles[i];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_adapter__["getDOM"])().appendChild(host, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_adapter__["getDOM"])().createStyleElement(style));
        }
    };
    DomSharedStylesHost.prototype.addHost = function (hostNode) {
        this._addStylesToHost(this._styles, hostNode);
        this._hostNodes.add(hostNode);
    };
    DomSharedStylesHost.prototype.removeHost = function (hostNode) { this._hostNodes.delete(hostNode); };
    DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
        var _this = this;
        this._hostNodes.forEach(function (hostNode) { _this._addStylesToHost(additions, hostNode); });
    };
    DomSharedStylesHost.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DomSharedStylesHost.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__dom_tokens__["DOCUMENT"],] },] },
    ];
    return DomSharedStylesHost;
}(SharedStylesHost));
//# sourceMappingURL=shared_styles_host.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
// CUSTOM
// https://github.com/angular/universal-starter/issues/287
var core_1 = __webpack_require__(0);
// es6-modules are used here
var dom_adapter_1 = __webpack_require__(34);
// CUSTOM
var platform_browser_1 = __webpack_require__(126);
var angular2_universal_1 = __webpack_require__(27);
/**
 * A service that can be used to get and add meta tags.
 *
 * @experimental
 */
var Meta = (function () {
    // CUSTOM
    function Meta(_document) {
        this._document = _document;
        this._dom = dom_adapter_1.getDOM();
    }
    /**
     * Adds a new meta tag to the dom.
     *
     *  ### Example
     *
     * ```ts
     * const name: MetaDefinition = {name: 'application-name', content: 'Name of my application'};
     * const desc: MetaDefinition = {name: 'description', content: 'A description of the page'};
     * const tags: HTMLMetaElement[] = this.meta.addTags([name, desc]);
     * ```
     *
     * @param tags
     * @returns {HTMLMetaElement[]}
     */
    Meta.prototype.addTags = function () {
        var _this = this;
        var tags = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tags[_i - 0] = arguments[_i];
        }
        var presentTags = this._flattenArray(tags);
        if (presentTags.length === 0)
            return [];
        return presentTags.map(function (tag) { return _this._addInternal(tag); });
    };
    /**
     * Gets the meta tag by the given selector. Returns element or null
     * if there's no such meta element.
     *
     *  ### Example
     *
     * ```ts
     * const meta: HTMLMetaElement = this.meta.getTag('name=description');
     * const twitterMeta: HTMLMetaElement = this.meta.getTag('name="twitter:title"');
     * const fbMeta: HTMLMetaElement = this.meta.getTag('property="fb:app_id"');
     * ```
     *
     * @param selector
     * @returns {HTMLMetaElement}
     */
    Meta.prototype.getTag = function (selector) {
        if (!selector)
            return null;
        return this._dom.query("meta[" + selector + "]");
    };
    // CUSTOM
    Meta.prototype.updateMeta = function (name, content) {
        var head = this._document.head;
        var childNodesAsList = this._dom.childNodesAsList(head);
        var metaEl = childNodesAsList.find(function (el) { return el['attribs'] ? el['attribs'].name == name : false; });
        if (metaEl)
            metaEl['attribs'].content = content;
    };
    Meta.prototype.setTitle = function (title) {
        this._document.title = title;
    };
    Meta.prototype.setLanguage = function (lang) {
        if (angular2_universal_1.isBrowser)
            this._document.documentElement.setAttribute('lang', lang);
        if (angular2_universal_1.isNode)
            this._dom.setAttribute(this._document.head.parent, 'lang', lang);
    };
    /**
     * Updates the meta tag with the given selector.
     *
     * *  ### Example
     *
     * ```ts
     * const meta: HTMLMetaElement = this.meta.updateTag('name=description', {name: 'description',
     * content: 'New description'});
     * console.log(meta.content); // 'New description'
     * ```
     *
     * @param selector
     * @param tag updated tag definition
     * @returns {HTMLMetaElement}
     */
    Meta.prototype.updateTag = function (selector, tag) {
        var meta = this.getTag(selector);
        if (!meta) {
            // create element if it doesn't exist
            return this._addInternal(tag);
        }
        return this._prepareMetaElement(tag, meta);
    };
    /**
     * Removes meta tag with the given selector from the dom.
     *
     *  ### Example
     *
     * ```ts
     * this.meta.removeTagBySelector('name=description');
     * ```
     *
     * @param selector
     */
    Meta.prototype.removeTagBySelector = function (selector) {
        var meta = this.getTag(selector);
        this.removeTagElement(meta);
    };
    /**
     * Removes given meta element from the dom.
     *
     *  ### Example
     *  ```ts
     * const elem: HTMLMetaElement = this.meta.getTag('name=description');
     * this.meta.removeTagElement(elem);
     * ```
     *
     * @param meta meta element
     */
    Meta.prototype.removeTagElement = function (meta) {
        if (meta) {
            this._removeMetaElement(meta);
        }
    };
    Meta.prototype._addInternal = function (tag) {
        var meta = this._createMetaElement();
        this._prepareMetaElement(tag, meta);
        this._appendMetaElement(meta);
        return meta;
    };
    Meta.prototype._createMetaElement = function () {
        return this._dom.createElement('meta');
    };
    Meta.prototype._prepareMetaElement = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    // private _appendMetaElement(meta: HTMLMetaElement): void {
    //   const head = this._dom.getElementsByTagName(this._dom.defaultDoc(), 'head')[0];
    //   this._dom.appendChild(head, meta);
    // }
    // CUSTOM
    Meta.prototype._appendMetaElement = function (meta) {
        var head = this._document.head;
        this._dom.appendChild(head, meta);
    };
    Meta.prototype._removeMetaElement = function (meta) {
        var head = this._dom.parentElement(meta);
        this._dom.removeChild(head, meta);
    };
    Meta.prototype._flattenArray = function (input, out) {
        if (out === void 0) { out = []; }
        if (input) {
            for (var i = 0; i < input.length; i++) {
                var item = input[i];
                if (Array.isArray(item)) {
                    this._flattenArray(item, out);
                }
                else if (item) {
                    out.push(item);
                }
            }
        }
        return out;
    };
    Meta = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Object])
    ], Meta);
    return Meta;
}());
exports.Meta = Meta;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(23);
var auth_service_1 = __webpack_require__(86);
var router_1 = __webpack_require__(8);
var AdminLoginComponent = (function () {
    function AdminLoginComponent(location, router, authService) {
        this.location = location;
        this.router = router;
        this.authService = authService;
        this.credentials = {
            username: null,
            password: null
        };
    }
    AdminLoginComponent.prototype.ngOnInit = function () {
        this.authService.logout();
    };
    AdminLoginComponent.prototype.login = function (credentials) {
        var _this = this;
        this.authService.login(credentials)
            .then(function (response) {
            _this.router.navigate(['admin']);
        });
    };
    AdminLoginComponent = __decorate([
        core_1.Component({
            selector: 'admin-logged-out',
            template: __webpack_require__(473),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
    ], AdminLoginComponent);
    return AdminLoginComponent;
    var _a, _b, _c;
}());
exports.AdminLoginComponent = AdminLoginComponent;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var auth_service_1 = __webpack_require__(86);
var router_1 = __webpack_require__(8);
var notification_service_1 = __webpack_require__(45);
// import {ToastyService, ToastyConfig} from 'ng2-toasty';
var AdminRootComponent = (function () {
    function AdminRootComponent(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AdminRootComponent.prototype.logout = function () {
        var _this = this;
        this.authService.logout()
            .then(function (response) {
            _this.router.navigate(['/login']);
        });
    };
    AdminRootComponent.prototype.ngOnInit = function () {
        this.loggedInUser = this.authService.loggedInUser;
        this.loggedIn = this.authService.loggedInUser != null;
        console.log('[auth]', this.loggedInUser);
    };
    AdminRootComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(475),
            styles: [__webpack_require__(469)],
            // providers: [ToastyService,ToastyConfig]
            providers: [notification_service_1.NotificationService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
    ], AdminRootComponent);
    return AdminRootComponent;
    var _a, _b;
}());
exports.AdminRootComponent = AdminRootComponent;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var search_service_1 = __webpack_require__(30);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var config_service_1 = __webpack_require__(5);
var ContentMessageEditComponent = (function (_super) {
    __extends(ContentMessageEditComponent, _super);
    function ContentMessageEditComponent(messageConfig, messageIntlService, messageMetaService, el, searchService, datePipe, utils, formBuilder, router, messageService, messageRoute) {
        _super.call(this, messageConfig, messageIntlService, messageMetaService, messageService, messageRoute);
        this.messageConfig = messageConfig;
        this.messageIntlService = messageIntlService;
        this.messageMetaService = messageMetaService;
        this.el = el;
        this.searchService = searchService;
        this.datePipe = datePipe;
        this.utils = utils;
        this.formBuilder = formBuilder;
        this.router = router;
        this.messageService = messageService;
        this.messageRoute = messageRoute;
        this.action = 'add';
        this.setType('message');
    }
    ContentMessageEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.messageRoute.params.subscribe(function (params) {
            // Need to init the form for the view, for some reason
            var group = _this.buildGroupForm(true, {});
            _this.messageForm = _this.formBuilder.group(group);
            if (params['id'] != 0) {
                _this.action = 'update';
                _this.messageService.getContent(_this.type, { _id: params['id'] }, true).then(function (response) {
                    _this.content = response;
                    var group = _this.buildGroupForm(false, _this.content);
                    _this.messageForm = _this.formBuilder.group(group);
                });
            }
        });
        this.messageRoute.parent.params.subscribe(function (params) {
            // Current language
            _this.currentLanguage = params['lg'];
        });
    };
    ContentMessageEditComponent.prototype.buildGroupForm = function (isNew, content) {
        var group = {};
        if (!isNew)
            group['_id'] = content._id;
        group['cid'] = [content.cid, []]; // null for new entry
        group['label'] = [content.label, []];
        group['url'] = [content.url, []];
        group['active'] = [isNew ? false : content.active, []]; // not active when new
        group['title'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.title);
        group['subtitle'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.subtitle);
        group['content'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.content);
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'), []];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'), []];
        return group;
    };
    ContentMessageEditComponent.prototype.onSubmit = function () {
        var _this = this;
        // update date
        this.messageForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // save
        this.messageService.saveContent('message', this.action, this.messageForm.value).then(function (res) {
            //console.log('form', this.messageForm.value);
            // this.router.navigate(['messages'], {relativeTo: this.route.parent});
            _this.router.navigate(['messages/reload'], { relativeTo: _this.route.parent });
            setTimeout(function () {
                _this.router.navigate(['messages'], { relativeTo: _this.route.parent });
            }, 500);
        });
    };
    ContentMessageEditComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.messageService.deleteContent(type, id);
        this.router.navigate(['messages/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['messages'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentMessageEditComponent.prototype.keyupEditorHandlerFunction = function (fieldPath, text) {
        this.messageForm.get(fieldPath).patchValue(text);
        //console.log(text);
    };
    ContentMessageEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(476),
            providers: [common_1.DatePipe]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _d) || Object, (typeof (_e = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.DatePipe !== 'undefined' && common_1.DatePipe) === 'function' && _f) || Object, (typeof (_g = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _l) || Object])
    ], ContentMessageEditComponent);
    return ContentMessageEditComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}(content_1.Content));
exports.ContentMessageEditComponent = ContentMessageEditComponent;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var type = 'message';
var ContentMessagesComponent = (function () {
    function ContentMessagesComponent(config, utils, contentService, route, location, router) {
        this.config = config;
        this.utils = utils;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
    }
    ContentMessagesComponent.prototype.onStatusChange = function (status, item) {
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(function (res) {
            console.log("Content " + type + " set to " + status);
        });
    };
    ContentMessagesComponent.prototype.setContents = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.contentService.getContents(type, true); }) // no cache
            .subscribe(function (response) {
            _this.contents = response;
        });
    };
    ContentMessagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setContents();
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentMessagesComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    };
    ContentMessagesComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(477)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
    ], ContentMessagesComponent);
    return ContentMessagesComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ContentMessagesComponent = ContentMessagesComponent;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var utils_service_1 = __webpack_require__(2);
var intl_service_1 = __webpack_require__(17);
var meta_service_1 = __webpack_require__(25);
var config_service_1 = __webpack_require__(5);
var ContentPageEditComponent = (function (_super) {
    __extends(ContentPageEditComponent, _super);
    function ContentPageEditComponent(pageConfig, pageIntlService, pageMetaService, utils, formBuilder, router, pageService, pageRoute) {
        _super.call(this, pageConfig, pageIntlService, pageMetaService, pageService, pageRoute);
        this.pageConfig = pageConfig;
        this.pageIntlService = pageIntlService;
        this.pageMetaService = pageMetaService;
        this.utils = utils;
        this.formBuilder = formBuilder;
        this.router = router;
        this.pageService = pageService;
        this.pageRoute = pageRoute;
        this.action = 'add';
        this.setType('page');
    }
    ContentPageEditComponent.prototype.onAddTag = function () {
        var tags = this.pageForm.controls['tags'];
        tags.push(this.formBuilder.control(null));
    };
    ContentPageEditComponent.prototype.onRemoveTag = function (index) {
        var tags = this.pageForm.controls['tags'];
        tags.removeAt(index);
    };
    ContentPageEditComponent.prototype.keyupEditorHandlerFunction = function (fieldPath, text) {
        this.pageForm.get(fieldPath).patchValue(text);
        //console.log(text);
    };
    ContentPageEditComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.pageService.deleteContent(type, id);
        this.router.navigate(['pages/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['pages'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentPageEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.pageRoute.params.subscribe(function (params) {
            // add
            _this.pageForm = _this.formBuilder.group({
                title: _this.formBuilder.group(_this.getIntlInitObject()),
                content: _this.formBuilder.group(_this.getIntlInitObject()),
                summary: _this.formBuilder.group(_this.getIntlInitObject()),
                _id: [null, []],
                active: [false, []],
                url: [null, []],
                date: [null, []],
                update_date: [null, []],
                tags: _this.formBuilder.array(['']),
            });
            // update
            if (params['id'] != 0) {
                _this.action = 'update';
                _this.pageService.getContent(_this.type, { _id: params['id'] }, true).then(function (response) {
                    _this.content = response;
                    _this.pageForm = _this.formBuilder.group({
                        title: _this.formBuilder.group(_this.content.title),
                        content: _this.formBuilder.group(_this.content.content),
                        summary: _this.formBuilder.group(_this.content.summary),
                        _id: [_this.content._id, []],
                        active: [_this.content.active, []],
                        url: [_this.content.url, []],
                        date: [_this.content.date, []],
                        update_date: [_this.content.update_date, []],
                        tags: _this.formBuilder.array(_this.content.tags),
                    });
                });
            }
        });
        this.pageRoute.parent.params.subscribe(function (params) {
            // Current language
            _this.currentLanguage = params['lg'];
        });
    };
    ContentPageEditComponent.prototype.onSubmit = function () {
        var _this = this;
        // update date
        this.pageForm.controls['update_date'].setValue(Date.now());
        // save
        this.pageService.saveContent('page', this.action, this.pageForm.value).then(function (res) {
            // nav
            _this.router.navigate(['pages'], { relativeTo: _this.route.parent });
        });
    };
    ContentPageEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(478),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _h) || Object])
    ], ContentPageEditComponent);
    return ContentPageEditComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}(content_1.Content));
exports.ContentPageEditComponent = ContentPageEditComponent;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var type = 'page';
var ContentPagesComponent = (function () {
    function ContentPagesComponent(utils, config, contentService, route, location, router) {
        this.utils = utils;
        this.config = config;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
    }
    ContentPagesComponent.prototype.onStatusChange = function (status, item) {
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(function (res) {
            console.log("Content " + type + " set to " + status);
        });
    };
    ContentPagesComponent.prototype.setContents = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.contentService.getContents(type, true); }) // no cache
            .subscribe(function (response) {
            _this.contents = response;
        });
    };
    ContentPagesComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.contentService.deleteContent(type, id);
        this.router.navigate(['pages/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['pages'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentPagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setContents();
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentPagesComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    };
    ContentPagesComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(479),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _a) || Object, (typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
    ], ContentPagesComponent);
    return ContentPagesComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ContentPagesComponent = ContentPagesComponent;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
__webpack_require__(100);
__webpack_require__(121);
__webpack_require__(120);
__webpack_require__(183);
__webpack_require__(240);
var search_service_1 = __webpack_require__(30);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var ContentRecordEditComponent = (function (_super) {
    __extends(ContentRecordEditComponent, _super);
    function ContentRecordEditComponent(recordConfig, recordIntlService, recordMetaService, el, searchService, datePipe, utils, formBuilder, router, recordService, recordRoute) {
        _super.call(this, recordConfig, recordIntlService, recordMetaService, recordService, recordRoute);
        this.recordConfig = recordConfig;
        this.recordIntlService = recordIntlService;
        this.recordMetaService = recordMetaService;
        this.el = el;
        this.searchService = searchService;
        this.datePipe = datePipe;
        this.utils = utils;
        this.formBuilder = formBuilder;
        this.router = router;
        this.recordService = recordService;
        this.recordRoute = recordRoute;
        this.action = 'add';
        this.urlSoloistLimit = 4;
        this.inputFocus = {
            element: null,
            type: null
        };
        this.setType('record');
    }
    ContentRecordEditComponent.prototype.buildGroupForm = function (isNew, content) {
        var group = {};
        if (!isNew)
            group['_id'] = content._id;
        group['cid'] = [content.cid, []]; // null for new entry
        group['active'] = [isNew ? false : content.active, []]; // not active when new
        group['type'] = [isNew ? 'reissue' : content.type, []];
        group['reference'] = [isNew ? 'fr ' : content.reference, [
                forms_1.Validators.required,
                forms_1.Validators.minLength(4)
            ]];
        group['url'] = [content.url, [
                forms_1.Validators.required
            ]];
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'), []];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'), []];
        group['original_references'] = isNew ?
            this.formBuilder.array([null]) :
            this.formBuilder.array(content.original_references);
        group['length'] = [content.length, []]; // null for new entry
        group['price'] = [content.price, [
                forms_1.Validators.required
            ]]; // null for new entry
        group['title'] = [content.title, [
                forms_1.Validators.required
            ]];
        group['music_pieces'] = isNew ?
            this.formBuilder.array([this.getNewMusicPiece()]) :
            this.formBuilder.array(this.getMusicPieceFormModel(this.content.music_pieces));
        group['cover'] = this.formBuilder.group({
            front: [isNew ? null : content.cover.front, [
                    forms_1.Validators.required
                ]],
            back: [isNew ? null : content.cover.back, [
                    forms_1.Validators.required
                ]]
        });
        group['description'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.description);
        group['tags'] = isNew ?
            this.formBuilder.array([null]) :
            this.formBuilder.array(this.content.tags);
        return group;
    };
    ContentRecordEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.recordRoute.params.subscribe(function (params) {
            // Need to init the form for the view, for some reason
            var group = _this.buildGroupForm(true, {});
            _this.recordForm = _this.formBuilder.group(group);
            if (params['id'] != 0) {
                _this.action = 'update';
                _this.recordService.getContent(_this.type, { _id: params['id'] }, true).then(function (response) {
                    _this.content = response;
                    var group = _this.buildGroupForm(false, _this.content);
                    _this.recordForm = _this.formBuilder.group(group);
                    _this.url = _this.content.url;
                    // Is special
                    _this.recordService.getContent('special', { url: _this.url }, true).then(function (special) {
                        if (!special.error)
                            _this.special = special;
                    });
                });
            }
            else {
                _this.recordForm.valueChanges.subscribe(function (e) {
                    _this.buildUrl();
                });
            }
        });
        this.recordRoute.parent.params.subscribe(function (params) {
            // Current language
            _this.currentLanguage = params['lg'];
        });
    };
    ContentRecordEditComponent.prototype.onInputChange = function (type, $event) {
        this.inputFocus = {
            element: $event.target,
            type: type,
        };
    };
    ContentRecordEditComponent.prototype.buildUrl = function () {
        if (this.recordForm.get('title').value) {
            var title = this.recordForm.get('title').value;
            title = this.utils.removeAccents(title);
            title = title.toLowerCase().replace(/[^a-z0-9]+/g, "-");
            var ref = this.recordForm.get('reference').value;
            ref = ref.toLowerCase().replace(/[^a-z0-9]+/g, "");
            var url = title + '-' + ref;
            url = url.replace(/--+/, "-");
            this.url = url;
        }
    };
    ContentRecordEditComponent.prototype.getMusicPieceFormModel = function (mps) {
        var _this = this;
        var mpsForm = [];
        mps.forEach(function (mp) {
            var mpForm = _this.formBuilder.group({});
            var _loop_1 = function(key) {
                if (key == 'soloists') {
                    var soloistsForm_1 = [];
                    mp[key].forEach(function (sol) {
                        soloistsForm_1.push(_this.formBuilder.group(sol));
                    });
                    mpForm.addControl(key, _this.formBuilder.array(soloistsForm_1));
                }
                else if (typeof mp[key] === 'string' || mp[key] == null) {
                    mpForm.addControl(key, _this.formBuilder.control(mp[key]));
                }
            };
            for (var key in mp) {
                _loop_1(key);
            }
            mpsForm.push(mpForm);
        });
        return mpsForm;
    };
    ContentRecordEditComponent.prototype.getNewMusicPiece = function () {
        return this.formBuilder.group({
            title: [null, [
                    forms_1.Validators.required
                ]],
            composer: [null, []],
            conductor: [null, []],
            orchestra: [null, []],
            date: ['1900-01-01', []],
            soloists: this.formBuilder.array([this.getNewSoloist()]),
        });
    };
    ContentRecordEditComponent.prototype.getNewSoloist = function () {
        return this.formBuilder.group({
            name: [null, []],
            instrument: [null, []]
        });
    };
    ContentRecordEditComponent.prototype.onSubmit = function () {
        var _this = this;
        // update date
        this.recordForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // save
        this.recordService.saveContent('record', this.action, this.recordForm.value).then(function (res) {
            // console.log('form', this.recordForm.value);
            // this.router.navigate(['records'], {relativeTo: this.route.parent});
            _this.router.navigate(['records/reload'], { relativeTo: _this.route.parent });
            setTimeout(function () {
                _this.router.navigate(['records'], { relativeTo: _this.route.parent });
            }, 500);
        });
    };
    ContentRecordEditComponent.prototype.onAddTag = function () {
        var tags = this.recordForm.controls['tags'];
        tags.push(this.formBuilder.control(null));
    };
    ContentRecordEditComponent.prototype.onRemoveTag = function (index) {
        var tags = this.recordForm.controls['tags'];
        tags.removeAt(index);
    };
    ContentRecordEditComponent.prototype.onAddOriginalReference = function () {
        var original_references = this.recordForm.controls['original_references'];
        original_references.push(this.formBuilder.control(null));
    };
    ContentRecordEditComponent.prototype.onRemoveOriginalReference = function (index) {
        var original_references = this.recordForm.controls['original_references'];
        original_references.removeAt(index);
    };
    ContentRecordEditComponent.prototype.onAddMusicPiece = function () {
        var mps = this.recordForm.controls['music_pieces'];
        mps.push(this.getNewMusicPiece());
    };
    ContentRecordEditComponent.prototype.onRemoveMusicPiece = function (index) {
        var mps = this.recordForm.controls['music_pieces'];
        mps.removeAt(index);
    };
    ContentRecordEditComponent.prototype.onAddSoloist = function (mpIndex) {
        var sols = this.recordForm
            .get('music_pieces').at(mpIndex)
            .get('soloists');
        sols.push(this.getNewSoloist());
    };
    ContentRecordEditComponent.prototype.onRemoveSoloist = function (mpIndex, solIndex) {
        var sols = this.recordForm
            .get('music_pieces').at(mpIndex)
            .get('soloists');
        sols.removeAt(solIndex);
    };
    ContentRecordEditComponent.prototype.keyupEditorHandlerFunction = function (fieldPath, text) {
        this.recordForm.get(fieldPath).patchValue(text);
        //console.log(text);
    };
    ContentRecordEditComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.recordService.deleteContent(type, id);
        this.router.navigate(['records/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['records'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentRecordEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(480),
            providers: [common_1.DatePipe]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _d) || Object, (typeof (_e = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.DatePipe !== 'undefined' && common_1.DatePipe) === 'function' && _f) || Object, (typeof (_g = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _l) || Object])
    ], ContentRecordEditComponent);
    return ContentRecordEditComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}(content_1.Content));
exports.ContentRecordEditComponent = ContentRecordEditComponent;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var type = 'record';
var ContentRecordsComponent = (function () {
    function ContentRecordsComponent(config, utils, contentService, route, location, router) {
        this.config = config;
        this.utils = utils;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
        this.pageSize = 12;
    }
    ContentRecordsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentRecordsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }
    };
    ContentRecordsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(481),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
    ], ContentRecordsComponent);
    return ContentRecordsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ContentRecordsComponent = ContentRecordsComponent;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var notification_service_1 = __webpack_require__(45);
var intl_service_1 = __webpack_require__(17);
var ContentSpecialEditComponent = (function (_super) {
    __extends(ContentSpecialEditComponent, _super);
    function ContentSpecialEditComponent(specialConfig, specialIntlService, datePipe, notification, metaSpecialService, utils, formBuilder, router, specialService, specialRoute) {
        _super.call(this, specialConfig, specialIntlService, metaSpecialService, specialService, specialRoute);
        this.specialConfig = specialConfig;
        this.specialIntlService = specialIntlService;
        this.datePipe = datePipe;
        this.notification = notification;
        this.metaSpecialService = metaSpecialService;
        this.utils = utils;
        this.formBuilder = formBuilder;
        this.router = router;
        this.specialService = specialService;
        this.specialRoute = specialRoute;
        this.action = 'add';
        this.setType('special');
    }
    ContentSpecialEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.specialRoute.params.subscribe(function (params) {
            // Get record url
            _this.specialRoute.queryParams.subscribe(function (queryParams) {
                _this.recordUrl = queryParams['recordUrl'];
                // Need to init the form for the view, for some reason
                var group = _this.buildGroupForm(true, {});
                _this.specialForm = _this.formBuilder.group(group);
                if (params['id'] != 0) {
                    _this.action = 'update';
                    _this.specialService.getContent(_this.type, { _id: params['id'] }, true).then(function (response) {
                        _this.content = response;
                        var group = _this.buildGroupForm(false, _this.content);
                        _this.specialForm = _this.formBuilder.group(group);
                        _this.image = _this.content.image;
                    });
                }
                else {
                    // Get record info (no cache)
                    _this.specialService.getContent('record', { url: _this.recordUrl }, true).then(function (record) {
                        _this.specialForm.controls['url'].setValue(record.url);
                        _this.image = '/' + _this.specialConfig.data.DATA.covers + '/thumbs/' + record.cover.front;
                        _this.specialForm.controls['image'].setValue(_this.image);
                    });
                }
            });
        });
        this.specialRoute.parent.params.subscribe(function (params) {
            // Current language
            _this.currentLanguage = params['lg'];
        });
    };
    ContentSpecialEditComponent.prototype.buildGroupForm = function (isNew, content) {
        var group = {};
        if (!isNew)
            group['_id'] = content._id;
        group['active'] = [isNew ? false : content.active, []]; // not active when new
        group['image'] = [content.image, []];
        group['url'] = [content.url, [
                forms_1.Validators.required
            ]];
        group['date'] = [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'), []];
        group['update_date'] = [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'), []];
        group['title'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.title);
        group['subtitle'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.subtitle);
        group['content'] = isNew ?
            this.formBuilder.group(this.getIntlInitObject()) :
            this.formBuilder.group(this.content.content);
        return group;
    };
    ContentSpecialEditComponent.prototype.onSubmit = function () {
        var _this = this;
        // update date
        this.specialForm.controls['update_date'].setValue(Date.now());
        // save
        this.specialService.saveContent('special', this.action, this.specialForm.value).then(function (res) {
            // this.notification.notify(res);
            _this.router.navigate(['specials'], { relativeTo: _this.route.parent });
        });
    };
    ContentSpecialEditComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.specialService.deleteContent(type, id);
        this.router.navigate(['specials/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['specials'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentSpecialEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(482),
            providers: [common_1.DatePipe]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof common_1.DatePipe !== 'undefined' && common_1.DatePipe) === 'function' && _c) || Object, (typeof (_d = typeof notification_service_1.NotificationService !== 'undefined' && notification_service_1.NotificationService) === 'function' && _d) || Object, (typeof (_e = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _e) || Object, (typeof (_f = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _j) || Object, (typeof (_k = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _k) || Object])
    ], ContentSpecialEditComponent);
    return ContentSpecialEditComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}(content_1.Content));
exports.ContentSpecialEditComponent = ContentSpecialEditComponent;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var notification_service_1 = __webpack_require__(45);
// import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
var type = 'special';
var ContentSpecialsComponent = (function () {
    //private toastyService:ToastyService, private toastyConfig: ToastyConfig,
    function ContentSpecialsComponent(config, notification, utils, contentService, route, location, router) {
        this.config = config;
        this.notification = notification;
        this.utils = utils;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
        // this.toastyConfig.theme = 'material';
    }
    ContentSpecialsComponent.prototype.onStatusChange = function (status, item) {
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(function (res) {
            console.log("Content " + type + " set to " + status);
        });
    };
    ContentSpecialsComponent.prototype.setContents = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.contentService.getContents(type, true); }) // no cache
            .subscribe(function (response) {
            _this.contents = response;
        });
    };
    ContentSpecialsComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.contentService.deleteContent(type, id);
        this.router.navigate(['specials/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['specials'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentSpecialsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setContents();
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentSpecialsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    };
    ContentSpecialsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(483)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof notification_service_1.NotificationService !== 'undefined' && notification_service_1.NotificationService) === 'function' && _b) || Object, (typeof (_c = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _c) || Object, (typeof (_d = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
    ], ContentSpecialsComponent);
    return ContentSpecialsComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.ContentSpecialsComponent = ContentSpecialsComponent;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var ContentWritingEditComponent = (function (_super) {
    __extends(ContentWritingEditComponent, _super);
    function ContentWritingEditComponent(writingConfig, writingIntlService, writingMetaService, utils, datePipe, formBuilder, router, writingService, writingRoute) {
        _super.call(this, writingConfig, writingIntlService, writingMetaService, writingService, writingRoute);
        this.writingConfig = writingConfig;
        this.writingIntlService = writingIntlService;
        this.writingMetaService = writingMetaService;
        this.utils = utils;
        this.datePipe = datePipe;
        this.formBuilder = formBuilder;
        this.router = router;
        this.writingService = writingService;
        this.writingRoute = writingRoute;
        this.action = 'add';
        this.url = "";
        this.isNew = true;
        this.setType('writing');
    }
    ContentWritingEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.writingRoute.params.subscribe(function (params) {
            // NEW
            // Need to init the form for the view, for some reason
            _this.buildForm(_this.isNew, null);
            // UPDATE
            if (params['id'] != 0) {
                _this.action = 'update';
                _this.isNew = false;
                _this.writingService.getContent(_this.type, { _id: params['id'] }, true).then(function (response) {
                    _this.content = response;
                    _this.buildForm(_this.isNew, _this.content);
                    _this.url = _this.content.url;
                });
            }
            // Clean url - only works for new content
            _this.writingForm.valueChanges.subscribe(function (e) {
                setTimeout(function () {
                    _this.url = _this.cleanUrl(_this.url);
                }, 300);
            });
        });
        // Current language
        this.writingRoute.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentWritingEditComponent.prototype.buildForm = function (isNew, content) {
        this.writingForm = this.formBuilder.group({
            cid: isNew ? null : content.cid,
            active: isNew ? false : content.active,
            author: [isNew ? null : content.author, [
                    forms_1.Validators.required
                ]],
            // languages: isNew ? this.formBuilder.array([]) : this.formBuilder.array(this.content.languages),
            title: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.title),
            summary: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.summary),
            content: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.content),
            url: [isNew ? null : content.url, [
                    forms_1.Validators.required
                ]],
            date: [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'), []],
            update_date: [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'), []],
            tags: isNew ? this.formBuilder.array([null]) : this.formBuilder.array(this.content.tags)
        });
        if (!isNew)
            this.writingForm.addControl('_id', new forms_1.FormControl(content._id));
    };
    ContentWritingEditComponent.prototype.onSubmit = function () {
        var _this = this;
        // update date
        this.writingForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // supported languages
        var supportedLanguages = this.getSupportedLanguages();
        this.writingForm.addControl('languages', this.formBuilder.array(supportedLanguages));
        // save
        this.writingService.saveContent('writing', this.action, this.writingForm.value).then(function (res) {
            // nav
            _this.router.navigate(['writings'], { relativeTo: _this.route.parent });
        });
    };
    ContentWritingEditComponent.prototype.getSupportedLanguages = function () {
        var supportedLanguages = [];
        for (var _i = 0, _a = this.config.data.APP.LANGUAGES.SUPPORTED; _i < _a.length; _i++) {
            var lg = _a[_i];
            if (this.writingForm.get(['content', lg]).value != "")
                supportedLanguages.push(lg);
        }
        return supportedLanguages;
    };
    // buildUrl() {
    //     let url = this.url;
    //     if (this.writingForm.get('author').value) {
    //         url = this.writingForm.get('author').value + '-' + url;
    //     }
    //     this.url = this.cleanUrl(url);
    // }
    ContentWritingEditComponent.prototype.cleanUrl = function (str) {
        str = this.utils.removeAccents(str);
        str = str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        str = str.replace(/--+/, "-");
        return str;
    };
    ContentWritingEditComponent.prototype.onAddTag = function () {
        var tags = this.writingForm.controls['tags'];
        tags.push(this.formBuilder.control(null));
    };
    ContentWritingEditComponent.prototype.onRemoveTag = function (index) {
        var tags = this.writingForm.controls['tags'];
        tags.removeAt(index);
    };
    ContentWritingEditComponent.prototype.keyupEditorHandlerFunction = function (fieldPath, text) {
        this.writingForm.get(fieldPath).patchValue(text);
        //console.log(text);
    };
    ContentWritingEditComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.writingService.deleteContent(type, id);
        this.router.navigate(['writings/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['writings'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentWritingEditComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(484),
            providers: [common_1.DatePipe]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.DatePipe !== 'undefined' && common_1.DatePipe) === 'function' && _e) || Object, (typeof (_f = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _j) || Object])
    ], ContentWritingEditComponent);
    return ContentWritingEditComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}(content_1.Content));
exports.ContentWritingEditComponent = ContentWritingEditComponent;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var type = 'writing';
var ContentWritingsComponent = (function () {
    function ContentWritingsComponent(config, utils, contentService, route, location, router) {
        this.config = config;
        this.utils = utils;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
    }
    ContentWritingsComponent.prototype.onStatusChange = function (status, item) {
        item.active = status;
        this.contentService.saveContent(type, 'update', item).then(function (res) {
            console.log("Content " + type + " set to " + status);
        });
    };
    ContentWritingsComponent.prototype.setContents = function () {
        var _this = this;
        this.route.params
            .switchMap(function (params) { return _this.contentService.getContents(type, true); }) // no cache
            .subscribe(function (response) {
            _this.contents = response;
        });
    };
    ContentWritingsComponent.prototype.deleteContent = function (type, id) {
        var _this = this;
        this.contentService.deleteContent(type, id);
        this.router.navigate(['writings/reload'], { relativeTo: this.route.parent });
        setTimeout(function () {
            _this.router.navigate(['writings'], { relativeTo: _this.route.parent });
        }, 500);
    };
    ContentWritingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setContents();
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    ContentWritingsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    };
    ContentWritingsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(485),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
    ], ContentWritingsComponent);
    return ContentWritingsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ContentWritingsComponent = ContentWritingsComponent;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(96);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(11);
var import9 = __webpack_require__(10);
var import10 = __webpack_require__(216);
var import11 = __webpack_require__(40);
var import12 = __webpack_require__(18);
var import13 = __webpack_require__(102);
var Wrapper_HtmlEditorComponent = (function () {
    function Wrapper_HtmlEditorComponent() {
        this.changed = false;
        this.context = new import0.HtmlEditorComponent();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
    }
    Wrapper_HtmlEditorComponent.prototype.check_elementId = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.elementId = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_HtmlEditorComponent.prototype.check_initText = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.initText = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_HtmlEditorComponent.prototype.check_height = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.height = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_HtmlEditorComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_HtmlEditorComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_HtmlEditorComponent;
}());
exports.Wrapper_HtmlEditorComponent = Wrapper_HtmlEditorComponent;
var renderType_HtmlEditorComponent_Host = null;
var _View_HtmlEditorComponent_Host0 = (function (_super) {
    __extends(_View_HtmlEditorComponent_Host0, _super);
    function _View_HtmlEditorComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HtmlEditorComponent_Host0, renderType_HtmlEditorComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_HtmlEditorComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'html-editor', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._HtmlEditorComponent_0_4 = new Wrapper_HtmlEditorComponent();
        this._appEl_0.initComponent(this._HtmlEditorComponent_0_4.context, [], compView_0);
        compView_0.create(this._HtmlEditorComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_HtmlEditorComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.HtmlEditorComponent) && (0 === requestNodeIndex))) {
            return this._HtmlEditorComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_HtmlEditorComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._HtmlEditorComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._HtmlEditorComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_0_4.context.ngAfterViewInit();
            }
        }
    };
    _View_HtmlEditorComponent_Host0.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_0_4.context.ngOnDestroy();
    };
    return _View_HtmlEditorComponent_Host0;
}(import3.AppView));
function viewFactory_HtmlEditorComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_HtmlEditorComponent_Host === null)) {
        (renderType_HtmlEditorComponent_Host = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {}));
    }
    return new _View_HtmlEditorComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.HtmlEditorComponentNgFactory = new import9.ComponentFactory('html-editor', viewFactory_HtmlEditorComponent_Host0, import0.HtmlEditorComponent);
var styles_HtmlEditorComponent = [];
var renderType_HtmlEditorComponent = null;
var _View_HtmlEditorComponent0 = (function (_super) {
    __extends(_View_HtmlEditorComponent0, _super);
    function _View_HtmlEditorComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HtmlEditorComponent0, renderType_HtmlEditorComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_3 = import1.UNINITIALIZED;
        this._map_4 = import2.pureProxy1(function (p0) {
            return { 'height.em': p0 };
        });
        this._expr_5 = import1.UNINITIALIZED;
    }
    _View_HtmlEditorComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import2.createRenderElement(this.renderer, parentRenderNode, 'textarea', import2.EMPTY_INLINE_ARRAY, null);
        this._NgStyle_0_3 = new import10.Wrapper_NgStyle(this.parentInjector.get(import11.KeyValueDiffers), new import12.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([], [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_HtmlEditorComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import13.NgStyle) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgStyle_0_3.context;
        }
        return notFoundResult;
    };
    _View_HtmlEditorComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._map_4(this.context.height);
        this._NgStyle_0_3.check_ngStyle(currVal_0_0_0, throwOnChange, false);
        this._NgStyle_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_3 = import2.interpolate(1, '', this.context.elementId, '');
        if (import2.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            this.renderer.setElementProperty(this._el_0, 'id', currVal_3);
            this._expr_3 = currVal_3;
        }
        this._NgStyle_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_5 = import2.interpolate(1, '', this.context.initText, '');
        if (import2.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            this.renderer.setText(this._text_1, currVal_5);
            this._expr_5 = currVal_5;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_HtmlEditorComponent0;
}(import3.AppView));
function viewFactory_HtmlEditorComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_HtmlEditorComponent === null)) {
        (renderType_HtmlEditorComponent = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, styles_HtmlEditorComponent, {}));
    }
    return new _View_HtmlEditorComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_HtmlEditorComponent0 = viewFactory_HtmlEditorComponent0;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var angular2_universal_1 = __webpack_require__(27);
var cart_service_1 = __webpack_require__(49);
var content_service_1 = __webpack_require__(9);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var intl_service_1 = __webpack_require__(17);
// declare let braintree:any;
var CartComponent = (function () {
    function CartComponent(intl, config, contentService, elementRef, utils, cartService, route, router) {
        this.intl = intl;
        this.config = config;
        this.contentService = contentService;
        this.elementRef = elementRef;
        this.utils = utils;
        this.cartService = cartService;
        this.route = route;
        this.router = router;
    }
    CartComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Current language
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
        this.contentService.getContent('message', { label: 'away' }, true) // true = no cache
            .then(function (res) {
            _this.awayMessage = res;
        });
    };
    CartComponent.prototype.ngAfterContentInit = function () {
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
    };
    CartComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }
    };
    CartComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(490),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _a) || Object, (typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _d) || Object, (typeof (_e = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _e) || Object, (typeof (_f = typeof cart_service_1.CartService !== 'undefined' && cart_service_1.CartService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object])
    ], CartComponent);
    return CartComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.CartComponent = CartComponent;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var intl_service_1 = __webpack_require__(17);
var meta_service_1 = __webpack_require__(25);
var ContentPageComponent = (function (_super) {
    __extends(ContentPageComponent, _super);
    function ContentPageComponent(pageConfig, pageIntlService, utils, pageMetaService, pageService, pageRoute) {
        _super.call(this, pageConfig, pageIntlService, pageMetaService, pageService, pageRoute);
        this.pageConfig = pageConfig;
        this.pageIntlService = pageIntlService;
        this.utils = utils;
        this.pageMetaService = pageMetaService;
        this.pageService = pageService;
        this.pageRoute = pageRoute;
        this.setType('page');
    }
    // Overrides super class init
    ContentPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(function (page) {
            if (page != null) {
                _this.content = page;
                _this.ready();
                _this.setMeta();
            }
            else
                console.error('Content not set');
        });
    };
    ContentPageComponent.prototype.ngAfterContentChecked = function () {
        _super.prototype.ngAfterContentChecked.call(this);
    };
    ContentPageComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(491),
            providers: [content_service_1.ContentService, meta_service_1.MetaService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _c) || Object, (typeof (_d = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _d) || Object, (typeof (_e = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object])
    ], ContentPageComponent);
    return ContentPageComponent;
    var _a, _b, _c, _d, _e, _f;
}(content_1.Content));
exports.ContentPageComponent = ContentPageComponent;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(23);
var router_1 = __webpack_require__(8);
var content_service_1 = __webpack_require__(9);
var search_service_1 = __webpack_require__(30);
var meta_service_1 = __webpack_require__(25);
var content_1 = __webpack_require__(80);
var cart_service_1 = __webpack_require__(49);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var intl_service_1 = __webpack_require__(17);
var notification_service_1 = __webpack_require__(45);
var angular2_universal_1 = __webpack_require__(27);
var ContentRecordComponent = (function (_super) {
    __extends(ContentRecordComponent, _super);
    function ContentRecordComponent(recordConfig, location, recordIntlService, notification, cartService, searchService, elementRef, utils, recordMetaService, recordService, recordRoute, router) {
        _super.call(this, recordConfig, recordIntlService, recordMetaService, recordService, recordRoute);
        this.recordConfig = recordConfig;
        this.location = location;
        this.recordIntlService = recordIntlService;
        this.notification = notification;
        this.cartService = cartService;
        this.searchService = searchService;
        this.elementRef = elementRef;
        this.utils = utils;
        this.recordMetaService = recordMetaService;
        this.recordService = recordService;
        this.recordRoute = recordRoute;
        this.router = router;
        this.mltContents = [];
        this.qty = 1;
        this.setType('record');
        this.cartService.setCookieExpiresInDays(this.config.data.CART.COOKIE_DAY_AGE);
    }
    ContentRecordComponent.prototype.addToCart = function () {
        this.cartService.update(this.content, this.qty);
        this.notification.notify('Le panier a été mis à jour');
    };
    ContentRecordComponent.prototype.removeFromCart = function (id) {
        this.cartService.remove(id);
        this.notification.notify('Le panier a été mis à jour');
    };
    // Overrides super class init
    ContentRecordComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(function (record) {
            if (!record) {
                console.error('Content not set');
            }
            else if (record.error && record.error == 404) {
                // Page not found
                _this.router.navigate(['page-not-found'], { relativeTo: _this.recordRoute.parent });
            }
            else {
                _this.content = record;
                // meta
                _this.setMeta();
                // MLT
                _this.ready();
                _this.searchService.mlt('record', _this.content._id).then(function (response) {
                    var indexData = response.hits;
                    // Retrieve info from db based on index ids
                    var ids = [];
                    for (var _i = 0, _a = indexData['hits']; _i < _a.length; _i++) {
                        var hit = _a[_i];
                        ids.push(hit._id);
                    }
                    if (ids.length > 0) {
                        var idsString = ids.join(',');
                        _this.recordService.findContents('record', idsString)
                            .then(function (res) {
                            _this.mltContents = res;
                        });
                    }
                });
            }
        });
    };
    ContentRecordComponent.prototype.ngAfterContentChecked = function () {
        _super.prototype.ngAfterContentChecked.call(this);
        // JS file path must be configurable
        if (angular2_universal_1.isBrowser) {
            this.utils.loadScripts(["/resources_front/assets/custom/popup-gallery-bundle.js"], this.elementRef.nativeElement);
        }
    };
    ContentRecordComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(492),
            providers: [notification_service_1.NotificationService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _c) || Object, (typeof (_d = typeof notification_service_1.NotificationService !== 'undefined' && notification_service_1.NotificationService) === 'function' && _d) || Object, (typeof (_e = typeof cart_service_1.CartService !== 'undefined' && cart_service_1.CartService) === 'function' && _e) || Object, (typeof (_f = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _g) || Object, (typeof (_h = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _h) || Object, (typeof (_j = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _j) || Object, (typeof (_k = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _l) || Object, (typeof (_m = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _m) || Object])
    ], ContentRecordComponent);
    return ContentRecordComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
}(content_1.Content));
exports.ContentRecordComponent = ContentRecordComponent;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var utils_service_1 = __webpack_require__(2);
var content_service_1 = __webpack_require__(9);
var angular2_universal_1 = __webpack_require__(27);
var ContentRecordsFeaturedComponent = (function () {
    function ContentRecordsFeaturedComponent(contentService, utils, route, router, es) {
        this.contentService = contentService;
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.dbContents = [];
    }
    ContentRecordsFeaturedComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.contentService.getContentsByField('record', 'tags', 'featured')
            .then(function (res) {
            _this.dbContents = res;
            // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
            // we wait till the asyn data is available to do the replacement
            if (typeof angular2_universal_1.prebootComplete != 'undefined') {
                angular2_universal_1.prebootComplete();
            }
        });
    };
    ContentRecordsFeaturedComponent.prototype.dbContentsLimited = function (limit) {
        var limited = [];
        for (var i = 0; i < this.dbContents.length; i++) {
            limited.push(this.dbContents[i]);
            if (i == limit - 1)
                break;
        }
        return limited;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ContentRecordsFeaturedComponent.prototype, "currentLanguage", void 0);
    ContentRecordsFeaturedComponent = __decorate([
        core_1.Directive({
            selector: '[content-records-featured]',
            exportAs: 'featured',
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _e) || Object])
    ], ContentRecordsFeaturedComponent);
    return ContentRecordsFeaturedComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ContentRecordsFeaturedComponent = ContentRecordsFeaturedComponent;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var config_service_1 = __webpack_require__(5);
var angular2_universal_1 = __webpack_require__(27);
var name_resolver_pipe_1 = __webpack_require__(118);
var type = 'record';
var ContentRecordsComponent = (function () {
    function ContentRecordsComponent(nameResolver, elementRef, config, utils, intl, metaService, contentService, route, location, router) {
        this.nameResolver = nameResolver;
        this.elementRef = elementRef;
        this.config = config;
        this.utils = utils;
        this.intl = intl;
        this.metaService = metaService;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
        this.isServer = true;
        this.hasFilter = false;
        this.currentPage = 1;
        this.pageSize = 12;
        this.isFirstPage = false;
        this.entryType = null;
        this.onSearch = new core_1.EventEmitter();
    }
    ContentRecordsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isServer = !angular2_universal_1.isBrowser;
        // Update hasFilter and entryType for display purposes
        this.router.events.subscribe(function (evt) {
            if (evt instanceof router_1.NavigationEnd) {
                // Has filter or not
                _this.hasFilter = false;
                if (_this.route.snapshot.queryParams['s'] || _this.route.snapshot.queryParams['f'] || _this.route.snapshot.params['field']) {
                    _this.hasFilter = true;
                }
                // Entry type
                _this.entryType = _this.route.snapshot.params['type'];
                // Entry field = 
                _this.entryField = _this.route.snapshot.params['field'];
                // Language (parent route)
                if (_this.route.parent.snapshot.params['lg']) {
                    _this.currentLanguage = _this.route.parent.snapshot.params['lg'];
                    // Meta
                    var metaTitle = _this.intl.data.COMMON.MENU.CATALOGUE[_this.currentLanguage];
                    if (_this.entryType)
                        metaTitle += ' | ' + _this.intl.data.COMMON.TAXONOMY.type.VALUES[_this.entryType][_this.currentLanguage];
                    else if (_this.entryField)
                        metaTitle += ' | ' + _this.nameResolver.transform(_this.route.snapshot.params['value']);
                    _this.metaService.setLanguage(_this.currentLanguage);
                    _this.metaService.setMeta(_this.config.data.APP.FRONT.TITLE + ' | ' + metaTitle, _this.intl.data.COMMON.SUMMARY[_this.currentLanguage], _this.intl.data.COMMON.KEYWORDS[_this.currentLanguage]);
                }
            }
        });
        // Parent route properties
        // this.route.parent.params.subscribe((params: Params) => {
        //     // Current language
        //     this.currentLanguage = params['lg'];
        //     // Meta language
        //     this.metaService.setLanguage(this.currentLanguage);
        // });
        this.route.params.subscribe(function (params) {
            if (params['field'] != null) {
                // Set page size to max so as to expose as much content as possible for SEO
                _this.pageSize = 1000;
            }
        });
        this.route.queryParams.subscribe(function (params) {
            // Current search
            _this.currentSearch = params['s'];
            // Is first page
            if (params['from'] != null)
                _this.isFirstPage = false;
            else {
                _this.isFirstPage = true;
                _this.currentPage = 1;
            }
        });
    };
    ContentRecordsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }
    };
    ContentRecordsComponent.prototype.onPageChange = function (event, target) {
        this.currentPage = event.currentPage;
        var from = (this.currentPage - 1) * this.pageSize;
        // Callback log
        this.onSearch.emit('page ' + this.currentPage);
        // Nav
        var params = {};
        for (var qp in this.route.snapshot.queryParams) {
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from;
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    };
    ;
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], ContentRecordsComponent.prototype, "onSearch", void 0);
    ContentRecordsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(493),
            providers: [name_resolver_pipe_1.NameResolverPipe]
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof name_resolver_pipe_1.NameResolverPipe !== 'undefined' && name_resolver_pipe_1.NameResolverPipe) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object, (typeof (_d = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _d) || Object, (typeof (_e = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _e) || Object, (typeof (_f = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _f) || Object, (typeof (_g = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _g) || Object, (typeof (_h = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _j) || Object, (typeof (_k = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _k) || Object, (typeof (_l = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _l) || Object])
    ], ContentRecordsComponent);
    return ContentRecordsComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
}());
exports.ContentRecordsComponent = ContentRecordsComponent;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var utils_service_1 = __webpack_require__(2);
var content_service_1 = __webpack_require__(9);
var angular2_universal_1 = __webpack_require__(27);
var ContentSpecialsComponent = (function () {
    function ContentSpecialsComponent(contentService, utils, route, router, es) {
        this.contentService = contentService;
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.dbContents = [];
    }
    ContentSpecialsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.contentService.getContents('special')
            .then(function (res) {
            _this.dbContents = res;
            _this.filterNonActive();
            // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
            // we wait till the asyn data is available to do the replacement
            if (typeof angular2_universal_1.prebootComplete != 'undefined') {
                angular2_universal_1.prebootComplete();
            }
        });
    };
    ContentSpecialsComponent.prototype.filterNonActive = function () {
        var filtered = [];
        for (var _i = 0, _a = this.dbContents; _i < _a.length; _i++) {
            var content = _a[_i];
            if (content.active)
                filtered.push(content);
        }
        this.dbContents = filtered;
    };
    ContentSpecialsComponent.prototype.dbContentsLimited = function (limit) {
        var limited = [];
        for (var i = 0; i < this.dbContents.length; i++) {
            limited.push(this.dbContents[i]);
            if (i == limit - 1)
                break;
        }
        return limited;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ContentSpecialsComponent.prototype, "currentLanguage", void 0);
    ContentSpecialsComponent = __decorate([
        core_1.Directive({
            selector: '[content-specials]',
            exportAs: 'specials',
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _e) || Object])
    ], ContentSpecialsComponent);
    return ContentSpecialsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ContentSpecialsComponent = ContentSpecialsComponent;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var content_service_1 = __webpack_require__(9);
var content_1 = __webpack_require__(80);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var intl_service_1 = __webpack_require__(17);
var meta_service_1 = __webpack_require__(25);
var angular2_universal_1 = __webpack_require__(27);
var ContentWritingComponent = (function (_super) {
    __extends(ContentWritingComponent, _super);
    function ContentWritingComponent(writingConfig, writingIntlService, elementRef, utils, writingMetaService, writingService, writingRoute) {
        _super.call(this, writingConfig, writingIntlService, writingMetaService, writingService, writingRoute);
        this.writingConfig = writingConfig;
        this.writingIntlService = writingIntlService;
        this.elementRef = elementRef;
        this.utils = utils;
        this.writingMetaService = writingMetaService;
        this.writingService = writingService;
        this.writingRoute = writingRoute;
        this.setType('writing');
    }
    // Overrides super class init
    ContentWritingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(function (writing) {
            if (writing != null) {
                _this.content = writing;
                _this.ready();
                _this.setMeta();
                // footnotes
                if (angular2_universal_1.isBrowser) {
                    _this.utils.loadScripts(["/resources_shared/assets/js/shared.js"], _this.elementRef.nativeElement);
                }
            }
            else
                console.error('Content not set');
        });
    };
    ContentWritingComponent.prototype.ngAfterContentChecked = function () {
        _super.prototype.ngAfterContentChecked.call(this);
    };
    ContentWritingComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(494),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _e) || Object, (typeof (_f = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object])
    ], ContentWritingComponent);
    return ContentWritingComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}(content_1.Content));
exports.ContentWritingComponent = ContentWritingComponent;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var content_service_1 = __webpack_require__(9);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var config_service_1 = __webpack_require__(5);
var type = 'writing';
var ContentWritingsComponent = (function () {
    function ContentWritingsComponent(config, intl, metaService, utils, contentService, route, location, router) {
        this.config = config;
        this.intl = intl;
        this.metaService = metaService;
        this.utils = utils;
        this.contentService = contentService;
        this.route = route;
        this.location = location;
        this.router = router;
        this.hasFilter = false;
        this.currentPage = 1;
        this.pageSize = 6;
        this.isFirstPage = false;
        this.onSearch = new core_1.EventEmitter();
    }
    ContentWritingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.parent.params.subscribe(function (params) {
            // Current language
            _this.currentLanguage = params['lg'];
            // Meta language
            _this.metaService.setLanguage(_this.currentLanguage);
        });
        this.route.params.subscribe(function (params) {
            // Meta (except language)
            var metaTitle = _this.intl.data.COMMON.MENU.CATALOGUE[_this.currentLanguage];
            _this.metaService.setMeta(_this.config.data.APP.FRONT.TITLE + ' | ' + _this.intl.data.COMMON.MENU.WRITINGS.LONG[_this.currentLanguage], '', '');
        });
        this.route.queryParams.subscribe(function (params) {
            // Has filters or not
            if (params['s'] != null || params['f'] != null)
                _this.hasFilter = true;
            else
                _this.hasFilter = false;
            // Is first page
            if (params['from'] != null)
                _this.isFirstPage = false;
            else {
                _this.isFirstPage = true;
                _this.currentPage = 1;
            }
        });
    };
    ContentWritingsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }
    };
    ContentWritingsComponent.prototype.onPageChange = function (event, target) {
        this.currentPage = event.currentPage;
        var from = (this.currentPage - 1) * this.pageSize;
        // Callback log
        this.onSearch.emit('page ' + this.currentPage);
        // Nav
        var params = {};
        for (var qp in this.route.snapshot.queryParams) {
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from;
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    };
    ;
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], ContentWritingsComponent.prototype, "onSearch", void 0);
    ContentWritingsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(495)
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _c) || Object, (typeof (_d = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _d) || Object, (typeof (_e = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _e) || Object, (typeof (_f = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object])
    ], ContentWritingsComponent);
    return ContentWritingsComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.ContentWritingsComponent = ContentWritingsComponent;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var angular2_universal_1 = __webpack_require__(27);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var content_service_1 = __webpack_require__(9);
var meta_service_1 = __webpack_require__(25);
var intl_service_1 = __webpack_require__(17);
var HomeComponent = (function () {
    function HomeComponent(config, intl, metaService, contentService, utils, rootNode, route, router) {
        this.config = config;
        this.intl = intl;
        this.metaService = metaService;
        this.contentService = contentService;
        this.utils = utils;
        this.rootNode = rootNode;
        this.route = route;
        this.router = router;
    }
    HomeComponent.prototype.setCurrentLanguage = function () {
        // Language is made available by the root parent route
        // this.route.parent.params.subscribe(
        //     (params: Params) => {
        //         this.currentLanguage = params['lg'];
        //     }
        // );
        // Above does not work for path like '', 'en'. See routing config
        if (this.route.snapshot.url[0]) {
            this.currentLanguage = this.route.snapshot.url[0].path;
        }
    };
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setCurrentLanguage();
        // meta
        this.metaService.setMeta('Forgotten Records | ' + this.intl.data.COMMON.HEADLINE[this.currentLanguage], this.intl.data.COMMON.SUMMARY[this.currentLanguage], this.intl.data.COMMON.KEYWORDS[this.currentLanguage]);
        this.metaService.setLanguage(this.currentLanguage);
        this.contentService.getContent('page', { url: 'about' }).then(function (response) {
            _this.about = response;
        });
    };
    // Hack full-screen image
    HomeComponent.prototype.ngAfterViewInit = function () {
        if (angular2_universal_1.isBrowser) {
            $(document).ready(function () {
                $("#full-screen-home").addClass("full-screen");
                $(window).trigger('resize');
            });
        }
    };
    HomeComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }
    };
    HomeComponent = __decorate([
        //
        core_1.Component({
            template: __webpack_require__(497),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof meta_service_1.MetaService !== 'undefined' && meta_service_1.MetaService) === 'function' && _c) || Object, (typeof (_d = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _d) || Object, (typeof (_e = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object])
    ], HomeComponent);
    return HomeComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.HomeComponent = HomeComponent;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var angular2_universal_1 = __webpack_require__(27);
var config_service_1 = __webpack_require__(5);
var intl_service_1 = __webpack_require__(17);
var utils_service_1 = __webpack_require__(2);
var PageNotFoundComponent = (function () {
    function PageNotFoundComponent(utils, intl, config, router, route) {
        this.utils = utils;
        this.intl = intl;
        this.config = config;
        this.router = router;
        this.route = route;
    }
    PageNotFoundComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Current language
        this.route.parent.params.subscribe(function (params) { _this.currentLanguage = params['lg']; });
    };
    PageNotFoundComponent.prototype.ngAfterContentInit = function () {
        if (typeof angular2_universal_1.prebootComplete != 'undefined') {
            angular2_universal_1.prebootComplete();
        }
    };
    PageNotFoundComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage) {
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
        }
    };
    PageNotFoundComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(498),
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object])
    ], PageNotFoundComponent);
    return PageNotFoundComponent;
    var _a, _b, _c, _d, _e;
}());
exports.PageNotFoundComponent = PageNotFoundComponent;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(112);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var angular2_universal_1 = __webpack_require__(27);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var intl_service_1 = __webpack_require__(17);
var cart_service_1 = __webpack_require__(49);
var FrontRootComponent = (function () {
    function FrontRootComponent(config, intl, cookieService, cartService, location, route, router, elementRef, renderer, utils) {
        this.config = config;
        this.intl = intl;
        this.cookieService = cookieService;
        this.cartService = cartService;
        this.location = location;
        this.route = route;
        this.router = router;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.utils = utils;
        this.nodeLoading = true;
        this.gaActive = true; // for dev
        this.agreesOnCookiePolicy = false;
        this.currentYear = utils.currentYear();
    }
    FrontRootComponent.prototype.isCurrent = function (link) {
        return this.location.path().indexOf(link) > -1;
    };
    FrontRootComponent.prototype.getCookieConsent = function () {
        var cookie = this.cookieService.getObject('cookie-consent');
        if (cookie != undefined && cookie)
            return true;
        return false;
    };
    FrontRootComponent.prototype.onActivate = function (e) {
        var _this = this;
        // language check
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                var lang = _this.utils.getLanguageByUrl(_this.location.path());
                if (lang && lang.length == 2 && _this.config.data.APP.LANGUAGES.SUPPORTED.indexOf(lang) == -1)
                    _this.router.navigate([_this.config.data.APP.LANGUAGES.PREFERRED, 'page-not-found']);
            }
        });
        if (angular2_universal_1.isBrowser) {
            // Google Analytics
            if (this.gaActive && this.agreesOnCookiePolicy) {
                ga('set', 'page', this.location.path());
                ga('send', 'pageview');
            }
            // UI adjustments
            this.router.events.subscribe(function (evt) {
                if (evt instanceof router_1.NavigationEnd) {
                    window.scrollTo(0, 0);
                }
            });
        }
    };
    FrontRootComponent.prototype.ngOnInit = function () {
        if (angular2_universal_1.isBrowser) {
            this.agreesOnCookiePolicy = this.getCookieConsent();
            this.nodeLoading = false;
            // dropdown-menu to be restored to normal
            this.dropDownMenuElement = this.elementRef.nativeElement.querySelector('.dropdown-menu');
            // need to reload for mouseover menu like the cart
            this.utils.loadScripts(["/resources_front/assets/custom/main-bundle.js"], this.elementRef.nativeElement);
        }
    };
    FrontRootComponent.prototype.ngAfterViewInit = function () {
        if (angular2_universal_1.isBrowser) {
            //Click event to scroll to top
            $('.scrollToTop').click(function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 1000);
                return false;
            });
        }
    };
    FrontRootComponent.prototype.onSearchClick = function (target, language) {
        var _this = this;
        this.utils.lNavigate(target, language, this.route.parent);
        if (angular2_universal_1.isBrowser) {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: _this.utils.getElementPosition('#content-start', 20, -20)
                }, 1000);
                $('#search-box').focus();
            }, 300);
        }
    };
    FrontRootComponent.prototype.onMenuClick = function (target, language) {
        var _this = this;
        if (angular2_universal_1.isBrowser) {
            if (this.utils.isMobile())
                $('.navbar-collapse').collapse("hide");
            // dropdown-menu to be hidden
            if (this.dropDownMenuElement != null) {
                this.renderer.setElementClass(this.dropDownMenuElement, 'hidden', true);
                setTimeout(function () {
                    _this.renderer.setElementClass(_this.dropDownMenuElement, 'hidden', false);
                }, 1000);
            }
        }
        // nav
        //this.router.navigate([target], {relativeTo: this.route.parent});
        this.utils.lNavigate(target, language, this.route.parent);
    };
    FrontRootComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(499)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof cart_service_1.CartService !== 'undefined' && cart_service_1.CartService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _h) || Object, (typeof (_j = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _j) || Object, (typeof (_k = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _k) || Object])
    ], FrontRootComponent);
    return FrontRootComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
}());
exports.FrontRootComponent = FrontRootComponent;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var utils_service_1 = __webpack_require__(2);
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
var SearchFacetsComponent = (function () {
    //types = ['type','composer','soloist','conductor','instrument'];
    function SearchFacetsComponent(utils, route, router, es) {
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.onFilter = new core_1.EventEmitter();
    }
    SearchFacetsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.searchQueryParams = params['s'];
            _this.filterQueryParams = params['f'];
        });
        this.route.params.subscribe(function (params) {
            // Entry fields
            if (params['field'] && params['value'])
                _this.filterQueryParams = _this.utils.appendQueryParam(_this.filterQueryParams, params['field'], params['value']);
        });
    };
    SearchFacetsComponent.prototype.onSelect = function (type, value) {
        // Callback 
        this.onFilter.emit({ type: type, value: value });
        // Nav
        var newQueryParams = { queryParams: {} };
        // Current filters/search
        if (this.searchQueryParams)
            newQueryParams.queryParams['s'] = this.searchQueryParams;
        newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
        // go
        if (this.target)
            this.router.navigate([this.language + '/' + this.target], newQueryParams);
        else {
            newQueryParams['relativeTo'] = this.route;
            this.router.navigate(['.'], this.newQueryParams);
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchFacetsComponent.prototype, "esAggregations", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchFacetsComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchFacetsComponent.prototype, "esFilters", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchFacetsComponent.prototype, "labels", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchFacetsComponent.prototype, "language", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], SearchFacetsComponent.prototype, "onFilter", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchFacetsComponent.prototype, "target", void 0);
    SearchFacetsComponent = __decorate([
        core_1.Component({
            selector: 'search-facets',
            template: __webpack_require__(501)
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _e) || Object])
    ], SearchFacetsComponent);
    return SearchFacetsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SearchFacetsComponent = SearchFacetsComponent;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var common_1 = __webpack_require__(23);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var core_2 = __webpack_require__(112);
var LanguageSelectorComponent = (function () {
    function LanguageSelectorComponent(config, location, router, utils, cookieService) {
        this.config = config;
        this.location = location;
        this.router = router;
        this.utils = utils;
        this.cookieService = cookieService;
        this.onLanguageSelect = new core_1.EventEmitter();
    }
    LanguageSelectorComponent.prototype.select = function () {
        // Callback for parent component
        this.onLanguageSelect.emit(this.language);
        // Navigate
        var target = this.resourcePath;
        if (!this.config.data.APP.LANGUAGES.SQUASH || this.language != this.config.data.APP.LANGUAGES.PREFERRED)
            target = this.language + target;
        this.router.navigateByUrl(target);
        // Update cookie
        this.cookieService.put('lang', this.language, { expires: this.utils.dateNowPlusDays(this.config.data.APP.LANGUAGES.COOKIE_DAY_AGE) });
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], LanguageSelectorComponent.prototype, "resourcePath", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], LanguageSelectorComponent.prototype, "currentLanguage", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], LanguageSelectorComponent.prototype, "displayCurrent", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], LanguageSelectorComponent.prototype, "language", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], LanguageSelectorComponent.prototype, "labels", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], LanguageSelectorComponent.prototype, "onLanguageSelect", void 0);
    LanguageSelectorComponent = __decorate([
        core_1.Component({
            selector: '[language-selector]',
            template: "\n        <a  *ngIf=\"language != currentLanguage || displayCurrent\"\n                (click)=\"select()\" \n                [ngClass]=\"{active : language === currentLanguage || !displayCurrent}\" class=\"lgSelect lLink\">\n                    {{(labels ? labels[language] : language) | uppercase}}\n        </a>\n        "
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _e) || Object, (typeof (_f = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _f) || Object])
    ], LanguageSelectorComponent);
    return LanguageSelectorComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.LanguageSelectorComponent = LanguageSelectorComponent;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var NumberFormat = (function () {
    function NumberFormat() {
    }
    NumberFormat.prototype.transform = function (n, dec) {
        return n.toFixed(dec);
    };
    NumberFormat = __decorate([
        core_1.Pipe({
            name: 'numberFormat'
        }), 
        __metadata('design:paramtypes', [])
    ], NumberFormat);
    return NumberFormat;
}());
exports.NumberFormat = NumberFormat;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var Subject_1 = __webpack_require__(66);
var angular2_universal_1 = __webpack_require__(27);
// Observable class extensions
__webpack_require__(100);
// Observable operators
__webpack_require__(121);
__webpack_require__(120);
__webpack_require__(183);
__webpack_require__(240);
var search_service_1 = __webpack_require__(30);
var utils_service_1 = __webpack_require__(2);
var search_elasticsearch_service_1 = __webpack_require__(29);
var SearchComponent = (function () {
    function SearchComponent(utils, search, es, route, router) {
        this.utils = utils;
        this.search = search;
        this.es = es;
        this.route = route;
        this.router = router;
        this.type = 'local'; // local | glogal
        this.expand = false;
        // @Output() onSearch: EventEmitter<Object> = new EventEmitter<Object>();
        this.suggestionTriggerThreshold = 2;
        this.keepSuggestions = false;
        this.suggestionEventEmitter = new Subject_1.Subject();
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Suggestion stream management
        this.suggestionEventEmitter
            .debounceTime(300)
            .switchMap(function (term) {
            return _this.search.suggest('record', term);
            //return this.es.suggest(term);
        }).subscribe(function (res) {
            _this.suggestions = _this.es.formatSuggestions(res.suggest);
        }, function (error) {
            console.log(error);
        });
        // Clear box when search removed by user
        this.route.queryParams.subscribe(function (params) {
            _this.searchQueryParams = params['s'];
            _this.filterQueryParams = params['f'];
            // if(this.es.clearSearchBox){
            //     this.formQuery = "";
            //     this.es.clearSearchBox = false;
            // }
        });
    };
    SearchComponent.prototype.onInputClick = function (input, event) {
        if (angular2_universal_1.isBrowser && this.scrollOnClick != null) {
            $('html, body').animate({
                scrollTop: this.utils.getElementPosition(this.scrollOnClick, 20, -20)
            }, 1000);
        }
    };
    SearchComponent.prototype.onInputChange = function (input, event) {
        if (event.key == 'Enter')
            this.suggestions = null;
        else if (input.length >= this.suggestionTriggerThreshold)
            this.suggestionEventEmitter.next(input);
        else
            this.suggestions = null;
    };
    SearchComponent.prototype.onSuggestSelect = function (type, value) {
        // Nav
        var newQueryParams = { queryParams: {} };
        //newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
        newQueryParams.queryParams['f'] = this.utils.appendQueryParam('', type, value);
        //newQueryParams['relativeTo'] = this.route.parent;
        // this.router.navigate([this.target], newQueryParams);
        this.utils.lNavigate(this.target, this.language, this.route.parent, newQueryParams);
        // Clear
        this.formQuery = "";
        this.suggestions = null;
    };
    SearchComponent.prototype.onSearchLeave = function () {
        var _this = this;
        this.keepSuggestions = false;
        setTimeout(function () {
            // In the mean time, move may have come back over
            if (!_this.keepSuggestions)
                _this.suggestions = null;
        }, 1500);
    };
    SearchComponent.prototype.onSearchOver = function () {
        this.keepSuggestions = true;
    };
    SearchComponent.prototype.onSubmit = function () {
        // Callback 
        //this.onSearch.emit(this.formQuery);
        // Nav
        if (this.formQuery != "" && this.formQuery != null)
            this.utils.lNavigate(this.target, this.language, this.route.parent, { queryParams: { s: this.formQuery } });
        else
            this.utils.lNavigate(this.target, this.language, this.route.parent);
        // Clear suggestions
        this.suggestions = null;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchComponent.prototype, "type", void 0);
    __decorate([
        // local | glogal
        core_1.Input(), 
        __metadata('design:type', Array)
    ], SearchComponent.prototype, "order", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchComponent.prototype, "scrollOnClick", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchComponent.prototype, "target", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchComponent.prototype, "language", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchComponent.prototype, "labels", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], SearchComponent.prototype, "expand", void 0);
    SearchComponent = __decorate([
        core_1.Component({
            selector: 'search',
            template: __webpack_require__(504),
            styles: [__webpack_require__(502)]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _a) || Object, (typeof (_b = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _b) || Object, (typeof (_c = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
    ], SearchComponent);
    return SearchComponent;
    var _a, _b, _c, _d, _e;
}());
exports.SearchComponent = SearchComponent;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(97);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_SearchableContentsComponent = (function () {
    function Wrapper_SearchableContentsComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.SearchableContentsComponent(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
    }
    Wrapper_SearchableContentsComponent.prototype.check_context = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.context = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchableContentsComponent.prototype.check_pageSize = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.pageSize = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchableContentsComponent.prototype.check_active = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.active = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchableContentsComponent.prototype.check_noCache = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.noCache = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchableContentsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchableContentsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchableContentsComponent;
}());
exports.Wrapper_SearchableContentsComponent = Wrapper_SearchableContentsComponent;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(23);
var router_1 = __webpack_require__(8);
var forms_1 = __webpack_require__(52);
var api_service_1 = __webpack_require__(232);
var model_service_1 = __webpack_require__(311);
var cookies_service_1 = __webpack_require__(77);
var ng2_bs_pagination_1 = __webpack_require__(315);
// import { ToastyModule } from 'ng2-toasty'; // version 2.1.0
// // SHARED
var auth_service_1 = __webpack_require__(86);
var auth_gard_service_1 = __webpack_require__(233);
var utils_service_1 = __webpack_require__(2);
var meta_service_1 = __webpack_require__(25);
var content_service_1 = __webpack_require__(9);
var data_service_1 = __webpack_require__(116);
var language_selector_component_1 = __webpack_require__(175);
var language_routing_component_1 = __webpack_require__(117);
var loading_indicator_1 = __webpack_require__(44);
var search_elasticsearch_service_1 = __webpack_require__(29);
var search_filter_component_1 = __webpack_require__(119);
var searchable_contents_component_1 = __webpack_require__(97);
var search_component_1 = __webpack_require__(177);
var search_service_1 = __webpack_require__(30);
var notification_service_1 = __webpack_require__(45);
var search_autocomplete_component_1 = __webpack_require__(236);
var map_to_iterable_pipe_1 = __webpack_require__(235);
var replace_pipe_1 = __webpack_require__(312);
var truncate_pipe_1 = __webpack_require__(98);
var date2year_pipe_1 = __webpack_require__(307);
var intl_pipe_1 = __webpack_require__(50);
var name_resolver_pipe_1 = __webpack_require__(118);
var join_pipe_1 = __webpack_require__(308);
var number_format_pipe_1 = __webpack_require__(176);
var intl_service_1 = __webpack_require__(17);
var config_service_1 = __webpack_require__(5);
// TEST
var test_component_1 = __webpack_require__(456);
var MODULES = [
    // Do NOT include UniversalModule, HttpModule, or JsonpModule here!
    common_1.CommonModule,
    router_1.RouterModule,
    forms_1.FormsModule,
    forms_1.ReactiveFormsModule,
    ng2_bs_pagination_1.PaginationModule,
];
var PIPES = [
    // put pipes here
    map_to_iterable_pipe_1.MapToIterable, replace_pipe_1.ReplacePipe, truncate_pipe_1.TruncatePipe, date2year_pipe_1.Date2YearPipe, intl_pipe_1.IntlPipe, name_resolver_pipe_1.NameResolverPipe, join_pipe_1.JoinPipe, number_format_pipe_1.NumberFormat
];
var COMPONENTS = [
    // put shared components here
    language_routing_component_1.LanguageRoutingComponent, language_selector_component_1.LanguageSelectorComponent,
    search_filter_component_1.SearchFilterComponent, searchable_contents_component_1.SearchableContentsComponent, search_component_1.SearchComponent, search_autocomplete_component_1.SearchAutocompleteComponent,
    loading_indicator_1.LoadingIndicator,
    // test 
    test_component_1.TestComponent
];
var PROVIDERS = [
    model_service_1.ModelService,
    api_service_1.ApiService,
    cookies_service_1.CookieService,
    auth_service_1.AuthService,
    auth_gard_service_1.AuthGuard,
    content_service_1.ContentService,
    data_service_1.DataService,
    utils_service_1.UtilsService,
    search_service_1.SearchService,
    search_elasticsearch_service_1.ElasticSearchService,
    meta_service_1.MetaService,
    notification_service_1.NotificationService,
    intl_service_1.IntlService,
    config_service_1.ConfigService
];
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule,
            providers: PROVIDERS.slice()
        };
    };
    SharedModule = __decorate([
        core_1.NgModule({
            imports: MODULES.slice(),
            declarations: PIPES.concat(COMPONENTS),
            exports: MODULES.concat(PIPES, COMPONENTS)
        }), 
        __metadata('design:paramtypes', [])
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(514);
__webpack_require__(121);
__webpack_require__(183);
var ReplaySubject_1 = __webpack_require__(509);
var core_1 = __webpack_require__(0);
var scroll_listener_1 = __webpack_require__(466);
var lazyload_image_1 = __webpack_require__(465);
var target = typeof window !== 'undefined' ? window : undefined;
var LazyLoadImageDirective = (function () {
    function LazyLoadImageDirective(el, ngZone) {
        this.scrollTarget = target;
        this.onLoad = new core_1.EventEmitter();
        this.elementRef = el;
        this.ngZone = ngZone;
        this.propertyChanges$ = new ReplaySubject_1.ReplaySubject();
    }
    LazyLoadImageDirective.prototype.ngOnChanges = function (changes) {
        this.propertyChanges$.next({
            lazyImage: this.lazyImage,
            defaultImage: this.defaultImage,
            errorImage: this.errorImage,
            scrollTarget: this.scrollTarget,
            scrollObservable: this.scrollObservable,
            offset: this.offset,
        });
    };
    LazyLoadImageDirective.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (typeof window === 'undefined') {
            return null;
        }
        this.ngZone.runOutsideAngular(function () {
            var scrollObservable;
            if (_this.scrollObservable) {
                scrollObservable = _this.scrollObservable.startWith('');
            }
            else {
                scrollObservable = scroll_listener_1.getScrollListener(_this.scrollTarget);
            }
            _this.scrollSubscription = _this.propertyChanges$
                .debounceTime(10)
                .switchMap(function (props) { return scrollObservable.let(lazyload_image_1.lazyLoadImage(_this.elementRef.nativeElement, props.lazyImage, props.defaultImage, props.errorImage, props.offset)); })
                .subscribe(function (success) { return _this.onLoad.emit(success); });
        });
    };
    LazyLoadImageDirective.prototype.ngOnDestroy = function () {
        [this.scrollSubscription]
            .filter(function (subscription) { return subscription && !subscription.isUnsubscribed; })
            .forEach(function (subscription) { return subscription.unsubscribe(); });
    };
    __decorate([
        core_1.Input('lazyLoad'),
        __metadata("design:type", Object)
    ], LazyLoadImageDirective.prototype, "lazyImage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], LazyLoadImageDirective.prototype, "defaultImage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], LazyLoadImageDirective.prototype, "errorImage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], LazyLoadImageDirective.prototype, "scrollTarget", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], LazyLoadImageDirective.prototype, "scrollObservable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], LazyLoadImageDirective.prototype, "offset", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], LazyLoadImageDirective.prototype, "onLoad", void 0);
    LazyLoadImageDirective = __decorate([
        core_1.Directive({
            selector: '[lazyLoad]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.NgZone])
    ], LazyLoadImageDirective);
    return LazyLoadImageDirective;
}());
exports.LazyLoadImageDirective = LazyLoadImageDirective;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var file_uploader_class_1 = __webpack_require__(239);
// todo: filters
var FileSelectDirective = (function () {
    function FileSelectDirective(element) {
        this.element = element;
    }
    FileSelectDirective.prototype.getOptions = function () {
        return this.uploader.options;
    };
    FileSelectDirective.prototype.getFilters = function () {
        return void 0;
    };
    FileSelectDirective.prototype.isEmptyAfterSelection = function () {
        return !!this.element.nativeElement.attributes.multiple;
    };
    FileSelectDirective.prototype.onChange = function () {
        // let files = this.uploader.isHTML5 ? this.element.nativeElement[0].files : this.element.nativeElement[0];
        var files = this.element.nativeElement.files;
        var options = this.getOptions();
        var filters = this.getFilters();
        // if(!this.uploader.isHTML5) this.destroy();
        this.uploader.addToQueue(files, options, filters);
        if (this.isEmptyAfterSelection()) {
            // todo
            this.element.nativeElement.value = '';
        }
    };
    return FileSelectDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", file_uploader_class_1.FileUploader)
], FileSelectDirective.prototype, "uploader", void 0);
__decorate([
    core_1.HostListener('change'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], FileSelectDirective.prototype, "onChange", null);
FileSelectDirective = __decorate([
    core_1.Directive({ selector: '[ng2FileSelect]' }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], FileSelectDirective);
exports.FileSelectDirective = FileSelectDirective;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var debounceTime_1 = __webpack_require__(527);
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
var ScalarObservable_1 = __webpack_require__(242);
var EmptyObservable_1 = __webpack_require__(123);
var isScheduler_1 = __webpack_require__(253);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` Scheduler, which means the `next`
     * notifications are sent synchronously, although with a different Scheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
var isArray_1 = __webpack_require__(252);
var isPromise_1 = __webpack_require__(338);
var isObject_1 = __webpack_require__(337);
var Observable_1 = __webpack_require__(13);
var iterator_1 = __webpack_require__(246);
var InnerSubscriber_1 = __webpack_require__(507);
var observable_1 = __webpack_require__(247);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            return result.subscribe(destination);
        }
    }
    else if (isArray_1.isArray(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.$$iterator] === 'function') {
        var iterator = result[iterator_1.$$iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.$$observable] === 'function') {
        var obs = result[observable_1.$$observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return AnimationPlayer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NoOpAnimationPlayer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @experimental Animation support is experimental.
 */
var AnimationPlayer = (function () {
    function AnimationPlayer() {
    }
    Object.defineProperty(AnimationPlayer.prototype, "parentPlayer", {
        get: function () { throw new Error('NOT IMPLEMENTED: Base Class'); },
        set: function (player) { throw new Error('NOT IMPLEMENTED: Base Class'); },
        enumerable: true,
        configurable: true
    });
    return AnimationPlayer;
}());
var NoOpAnimationPlayer = (function () {
    function NoOpAnimationPlayer() {
        var _this = this;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._started = false;
        this.parentPlayer = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["l" /* scheduleMicroTask */])(function () { return _this._onFinish(); });
    }
    /** @internal */
    NoOpAnimationPlayer.prototype._onFinish = function () {
        this._onDoneFns.forEach(function (fn) { return fn(); });
        this._onDoneFns = [];
    };
    NoOpAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    NoOpAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    NoOpAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    NoOpAnimationPlayer.prototype.init = function () { };
    NoOpAnimationPlayer.prototype.play = function () {
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
        }
        this._started = true;
    };
    NoOpAnimationPlayer.prototype.pause = function () { };
    NoOpAnimationPlayer.prototype.restart = function () { };
    NoOpAnimationPlayer.prototype.finish = function () { this._onFinish(); };
    NoOpAnimationPlayer.prototype.destroy = function () { };
    NoOpAnimationPlayer.prototype.reset = function () { };
    NoOpAnimationPlayer.prototype.setPosition = function (p /** TODO #9100 */) { };
    NoOpAnimationPlayer.prototype.getPosition = function () { return 0; };
    return NoOpAnimationPlayer;
}());
//# sourceMappingURL=animation_player.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultIterableDifferFactory; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return DefaultIterableDiffer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return CollectionChangeRecord; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var DefaultIterableDifferFactory = (function () {
    function DefaultIterableDifferFactory() {
    }
    DefaultIterableDifferFactory.prototype.supports = function (obj) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(obj); };
    DefaultIterableDifferFactory.prototype.create = function (cdRef, trackByFn) {
        return new DefaultIterableDiffer(trackByFn);
    };
    return DefaultIterableDifferFactory;
}());
var trackByIdentity = function (index, item) { return item; };
/**
 * @stable
 */
var DefaultIterableDiffer = (function () {
    function DefaultIterableDiffer(_trackByFn) {
        this._trackByFn = _trackByFn;
        this._length = null;
        this._collection = null;
        // Keeps track of the used records at any point in time (during & across `_check()` calls)
        this._linkedRecords = null;
        // Keeps track of the removed records at any point in time during `_check()` calls.
        this._unlinkedRecords = null;
        this._previousItHead = null;
        this._itHead = null;
        this._itTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._movesHead = null;
        this._movesTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
        // Keeps track of records where custom track by is the same, but item identity has changed
        this._identityChangesHead = null;
        this._identityChangesTail = null;
        this._trackByFn = this._trackByFn || trackByIdentity;
    }
    Object.defineProperty(DefaultIterableDiffer.prototype, "collection", {
        get: function () { return this._collection; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultIterableDiffer.prototype, "length", {
        get: function () { return this._length; },
        enumerable: true,
        configurable: true
    });
    DefaultIterableDiffer.prototype.forEachItem = function (fn) {
        var record;
        for (record = this._itHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachOperation = function (fn) {
        var nextIt = this._itHead;
        var nextRemove = this._removalsHead;
        var addRemoveOffset = 0;
        var moveOffsets = null;
        while (nextIt || nextRemove) {
            // Figure out which is the next record to process
            // Order: remove, add, move
            var record = !nextRemove ||
                nextIt &&
                    nextIt.currentIndex < getPreviousIndex(nextRemove, addRemoveOffset, moveOffsets) ?
                nextIt :
                nextRemove;
            var adjPreviousIndex = getPreviousIndex(record, addRemoveOffset, moveOffsets);
            var currentIndex = record.currentIndex;
            // consume the item, and adjust the addRemoveOffset and update moveDistance if necessary
            if (record === nextRemove) {
                addRemoveOffset--;
                nextRemove = nextRemove._nextRemoved;
            }
            else {
                nextIt = nextIt._next;
                if (record.previousIndex == null) {
                    addRemoveOffset++;
                }
                else {
                    // INVARIANT:  currentIndex < previousIndex
                    if (!moveOffsets)
                        moveOffsets = [];
                    var localMovePreviousIndex = adjPreviousIndex - addRemoveOffset;
                    var localCurrentIndex = currentIndex - addRemoveOffset;
                    if (localMovePreviousIndex != localCurrentIndex) {
                        for (var i = 0; i < localMovePreviousIndex; i++) {
                            var offset = i < moveOffsets.length ? moveOffsets[i] : (moveOffsets[i] = 0);
                            var index = offset + i;
                            if (localCurrentIndex <= index && index < localMovePreviousIndex) {
                                moveOffsets[i] = offset + 1;
                            }
                        }
                        var previousIndex = record.previousIndex;
                        moveOffsets[previousIndex] = localCurrentIndex - localMovePreviousIndex;
                    }
                }
            }
            if (adjPreviousIndex !== currentIndex) {
                fn(record, adjPreviousIndex, currentIndex);
            }
        }
    };
    DefaultIterableDiffer.prototype.forEachPreviousItem = function (fn) {
        var record;
        for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachAddedItem = function (fn) {
        var record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachMovedItem = function (fn) {
        var record;
        for (record = this._movesHead; record !== null; record = record._nextMoved) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachRemovedItem = function (fn) {
        var record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachIdentityChange = function (fn) {
        var record;
        for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.diff = function (collection) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(collection))
            collection = [];
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["b" /* isListLikeIterable */])(collection)) {
            throw new Error("Error trying to diff '" + collection + "'");
        }
        if (this.check(collection)) {
            return this;
        }
        else {
            return null;
        }
    };
    DefaultIterableDiffer.prototype.onDestroy = function () { };
    // todo(vicb): optim for UnmodifiableListView (frozen arrays)
    DefaultIterableDiffer.prototype.check = function (collection) {
        var _this = this;
        this._reset();
        var record = this._itHead;
        var mayBeDirty = false;
        var index;
        var item;
        var itemTrackBy;
        if (Array.isArray(collection)) {
            var list = collection;
            this._length = collection.length;
            for (var index_1 = 0; index_1 < this._length; index_1++) {
                item = list[index_1];
                itemTrackBy = this._trackByFn(index_1, item);
                if (record === null || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.trackById, itemTrackBy)) {
                    record = this._mismatch(record, item, itemTrackBy, index_1);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = this._verifyReinsertion(record, item, itemTrackBy, index_1);
                    }
                    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.item, item))
                        this._addIdentityChange(record, item);
                }
                record = record._next;
            }
        }
        else {
            index = 0;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_collection__["c" /* iterateListLike */])(collection, function (item /** TODO #9100 */) {
                itemTrackBy = _this._trackByFn(index, item);
                if (record === null || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.trackById, itemTrackBy)) {
                    record = _this._mismatch(record, item, itemTrackBy, index);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = _this._verifyReinsertion(record, item, itemTrackBy, index);
                    }
                    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.item, item))
                        _this._addIdentityChange(record, item);
                }
                record = record._next;
                index++;
            });
            this._length = index;
        }
        this._truncate(record);
        this._collection = collection;
        return this.isDirty;
    };
    Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
        /* CollectionChanges is considered dirty if it has any additions, moves, removals, or identity
         * changes.
         */
        get: function () {
            return this._additionsHead !== null || this._movesHead !== null ||
                this._removalsHead !== null || this._identityChangesHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reset the state of the change objects to show no changes. This means set previousKey to
     * currentKey, and clear all of the queues (additions, moves, removals).
     * Set the previousIndexes of moved and added items to their currentIndexes
     * Reset the list of additions, moves and removals
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var record;
            var nextRecord;
            for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                record.previousIndex = record.currentIndex;
            }
            this._additionsHead = this._additionsTail = null;
            for (record = this._movesHead; record !== null; record = nextRecord) {
                record.previousIndex = record.currentIndex;
                nextRecord = record._nextMoved;
            }
            this._movesHead = this._movesTail = null;
            this._removalsHead = this._removalsTail = null;
            this._identityChangesHead = this._identityChangesTail = null;
        }
    };
    /**
     * This is the core function which handles differences between collections.
     *
     * - `record` is the record which we saw at this position last time. If null then it is a new
     *   item.
     * - `item` is the current item in the collection
     * - `index` is the position of the item in the collection
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._mismatch = function (record, item, itemTrackBy, index) {
        // The previous record after which we will append the current one.
        var previousRecord;
        if (record === null) {
            previousRecord = this._itTail;
        }
        else {
            previousRecord = record._prev;
            // Remove the record from the collection since we know it does not match the item.
            this._remove(record);
        }
        // Attempt to see if we have seen the item before.
        record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
        if (record !== null) {
            // We have seen this before, we need to move it forward in the collection.
            // But first we need to check if identity changed, so we can update in view if necessary
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.item, item))
                this._addIdentityChange(record, item);
            this._moveAfter(record, previousRecord, index);
        }
        else {
            // Never seen it, check evicted list.
            record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy);
            if (record !== null) {
                // It is an item which we have evicted earlier: reinsert it back into the list.
                // But first we need to check if identity changed, so we can update in view if necessary
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.item, item))
                    this._addIdentityChange(record, item);
                this._reinsertAfter(record, previousRecord, index);
            }
            else {
                // It is a new item: add it.
                record =
                    this._addAfter(new CollectionChangeRecord(item, itemTrackBy), previousRecord, index);
            }
        }
        return record;
    };
    /**
     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
     *
     * Use case: `[a, a]` => `[b, a, a]`
     *
     * If we did not have this check then the insertion of `b` would:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) leave `a` at index `1` as is. <-- this is wrong!
     *   3) reinsert `a` at index 2. <-- this is wrong!
     *
     * The correct behavior is:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) reinsert `a` at index 1.
     *   3) move `a` at from `1` to `2`.
     *
     *
     * Double check that we have not evicted a duplicate item. We need to check if the item type may
     * have already been removed:
     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
     * at the end.
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._verifyReinsertion = function (record, item, itemTrackBy, index) {
        var reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy);
        if (reinsertRecord !== null) {
            record = this._reinsertAfter(reinsertRecord, record._prev, index);
        }
        else if (record.currentIndex != index) {
            record.currentIndex = index;
            this._addToMoves(record, index);
        }
        return record;
    };
    /**
     * Get rid of any excess {@link CollectionChangeRecord}s from the previous collection
     *
     * - `record` The first excess {@link CollectionChangeRecord}.
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._truncate = function (record) {
        // Anything after that needs to be removed;
        while (record !== null) {
            var nextRecord = record._next;
            this._addToRemovals(this._unlink(record));
            record = nextRecord;
        }
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.clear();
        }
        if (this._additionsTail !== null) {
            this._additionsTail._nextAdded = null;
        }
        if (this._movesTail !== null) {
            this._movesTail._nextMoved = null;
        }
        if (this._itTail !== null) {
            this._itTail._next = null;
        }
        if (this._removalsTail !== null) {
            this._removalsTail._nextRemoved = null;
        }
        if (this._identityChangesTail !== null) {
            this._identityChangesTail._nextIdentityChange = null;
        }
    };
    /** @internal */
    DefaultIterableDiffer.prototype._reinsertAfter = function (record, prevRecord, index) {
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.remove(record);
        }
        var prev = record._prevRemoved;
        var next = record._nextRemoved;
        if (prev === null) {
            this._removalsHead = next;
        }
        else {
            prev._nextRemoved = next;
        }
        if (next === null) {
            this._removalsTail = prev;
        }
        else {
            next._prevRemoved = prev;
        }
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._moveAfter = function (record, prevRecord, index) {
        this._unlink(record);
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addAfter = function (record, prevRecord, index) {
        this._insertAfter(record, prevRecord, index);
        if (this._additionsTail === null) {
            // todo(vicb)
            // assert(this._additionsHead === null);
            this._additionsTail = this._additionsHead = record;
        }
        else {
            // todo(vicb)
            // assert(_additionsTail._nextAdded === null);
            // assert(record._nextAdded === null);
            this._additionsTail = this._additionsTail._nextAdded = record;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._insertAfter = function (record, prevRecord, index) {
        // todo(vicb)
        // assert(record != prevRecord);
        // assert(record._next === null);
        // assert(record._prev === null);
        var next = prevRecord === null ? this._itHead : prevRecord._next;
        // todo(vicb)
        // assert(next != record);
        // assert(prevRecord != record);
        record._next = next;
        record._prev = prevRecord;
        if (next === null) {
            this._itTail = record;
        }
        else {
            next._prev = record;
        }
        if (prevRecord === null) {
            this._itHead = record;
        }
        else {
            prevRecord._next = record;
        }
        if (this._linkedRecords === null) {
            this._linkedRecords = new _DuplicateMap();
        }
        this._linkedRecords.put(record);
        record.currentIndex = index;
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._remove = function (record) {
        return this._addToRemovals(this._unlink(record));
    };
    /** @internal */
    DefaultIterableDiffer.prototype._unlink = function (record) {
        if (this._linkedRecords !== null) {
            this._linkedRecords.remove(record);
        }
        var prev = record._prev;
        var next = record._next;
        // todo(vicb)
        // assert((record._prev = null) === null);
        // assert((record._next = null) === null);
        if (prev === null) {
            this._itHead = next;
        }
        else {
            prev._next = next;
        }
        if (next === null) {
            this._itTail = prev;
        }
        else {
            next._prev = prev;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addToMoves = function (record, toIndex) {
        // todo(vicb)
        // assert(record._nextMoved === null);
        if (record.previousIndex === toIndex) {
            return record;
        }
        if (this._movesTail === null) {
            // todo(vicb)
            // assert(_movesHead === null);
            this._movesTail = this._movesHead = record;
        }
        else {
            // todo(vicb)
            // assert(_movesTail._nextMoved === null);
            this._movesTail = this._movesTail._nextMoved = record;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addToRemovals = function (record) {
        if (this._unlinkedRecords === null) {
            this._unlinkedRecords = new _DuplicateMap();
        }
        this._unlinkedRecords.put(record);
        record.currentIndex = null;
        record._nextRemoved = null;
        if (this._removalsTail === null) {
            // todo(vicb)
            // assert(_removalsHead === null);
            this._removalsTail = this._removalsHead = record;
            record._prevRemoved = null;
        }
        else {
            // todo(vicb)
            // assert(_removalsTail._nextRemoved === null);
            // assert(record._nextRemoved === null);
            record._prevRemoved = this._removalsTail;
            this._removalsTail = this._removalsTail._nextRemoved = record;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addIdentityChange = function (record, item) {
        record.item = item;
        if (this._identityChangesTail === null) {
            this._identityChangesTail = this._identityChangesHead = record;
        }
        else {
            this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
        }
        return record;
    };
    DefaultIterableDiffer.prototype.toString = function () {
        var list = [];
        this.forEachItem(function (record /** TODO #9100 */) { return list.push(record); });
        var previous = [];
        this.forEachPreviousItem(function (record /** TODO #9100 */) { return previous.push(record); });
        var additions = [];
        this.forEachAddedItem(function (record /** TODO #9100 */) { return additions.push(record); });
        var moves = [];
        this.forEachMovedItem(function (record /** TODO #9100 */) { return moves.push(record); });
        var removals = [];
        this.forEachRemovedItem(function (record /** TODO #9100 */) { return removals.push(record); });
        var identityChanges = [];
        this.forEachIdentityChange(function (record /** TODO #9100 */) { return identityChanges.push(record); });
        return 'collection: ' + list.join(', ') + '\n' +
            'previous: ' + previous.join(', ') + '\n' +
            'additions: ' + additions.join(', ') + '\n' +
            'moves: ' + moves.join(', ') + '\n' +
            'removals: ' + removals.join(', ') + '\n' +
            'identityChanges: ' + identityChanges.join(', ') + '\n';
    };
    return DefaultIterableDiffer;
}());
/**
 * @stable
 */
var CollectionChangeRecord = (function () {
    function CollectionChangeRecord(item, trackById) {
        this.item = item;
        this.trackById = trackById;
        this.currentIndex = null;
        this.previousIndex = null;
        /** @internal */
        this._nextPrevious = null;
        /** @internal */
        this._prev = null;
        /** @internal */
        this._next = null;
        /** @internal */
        this._prevDup = null;
        /** @internal */
        this._nextDup = null;
        /** @internal */
        this._prevRemoved = null;
        /** @internal */
        this._nextRemoved = null;
        /** @internal */
        this._nextAdded = null;
        /** @internal */
        this._nextMoved = null;
        /** @internal */
        this._nextIdentityChange = null;
    }
    CollectionChangeRecord.prototype.toString = function () {
        return this.previousIndex === this.currentIndex ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.item) :
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.item) + '[' +
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.previousIndex) + '->' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.currentIndex) + ']';
    };
    return CollectionChangeRecord;
}());
// A linked list of CollectionChangeRecords with the same CollectionChangeRecord.item
var _DuplicateItemRecordList = (function () {
    function _DuplicateItemRecordList() {
        /** @internal */
        this._head = null;
        /** @internal */
        this._tail = null;
    }
    /**
     * Append the record to the list of duplicates.
     *
     * Note: by design all records in the list of duplicates hold the same value in record.item.
     */
    _DuplicateItemRecordList.prototype.add = function (record) {
        if (this._head === null) {
            this._head = this._tail = record;
            record._nextDup = null;
            record._prevDup = null;
        }
        else {
            // todo(vicb)
            // assert(record.item ==  _head.item ||
            //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
            this._tail._nextDup = record;
            record._prevDup = this._tail;
            record._nextDup = null;
            this._tail = record;
        }
    };
    // Returns a CollectionChangeRecord having CollectionChangeRecord.trackById == trackById and
    // CollectionChangeRecord.currentIndex >= afterIndex
    _DuplicateItemRecordList.prototype.get = function (trackById, afterIndex) {
        var record;
        for (record = this._head; record !== null; record = record._nextDup) {
            if ((afterIndex === null || afterIndex < record.currentIndex) &&
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["i" /* looseIdentical */])(record.trackById, trackById)) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove one {@link CollectionChangeRecord} from the list of duplicates.
     *
     * Returns whether the list of duplicates is empty.
     */
    _DuplicateItemRecordList.prototype.remove = function (record) {
        // todo(vicb)
        // assert(() {
        //  // verify that the record being removed is in the list.
        //  for (CollectionChangeRecord cursor = _head; cursor != null; cursor = cursor._nextDup) {
        //    if (identical(cursor, record)) return true;
        //  }
        //  return false;
        //});
        var prev = record._prevDup;
        var next = record._nextDup;
        if (prev === null) {
            this._head = next;
        }
        else {
            prev._nextDup = next;
        }
        if (next === null) {
            this._tail = prev;
        }
        else {
            next._prevDup = prev;
        }
        return this._head === null;
    };
    return _DuplicateItemRecordList;
}());
var _DuplicateMap = (function () {
    function _DuplicateMap() {
        this.map = new Map();
    }
    _DuplicateMap.prototype.put = function (record) {
        var key = record.trackById;
        var duplicates = this.map.get(key);
        if (!duplicates) {
            duplicates = new _DuplicateItemRecordList();
            this.map.set(key, duplicates);
        }
        duplicates.add(record);
    };
    /**
     * Retrieve the `value` using key. Because the CollectionChangeRecord value may be one which we
     * have already iterated over, we use the afterIndex to pretend it is not there.
     *
     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
     * have any more `a`s needs to return the last `a` not the first or second.
     */
    _DuplicateMap.prototype.get = function (trackById, afterIndex) {
        if (afterIndex === void 0) { afterIndex = null; }
        var key = trackById;
        var recordList = this.map.get(key);
        return recordList ? recordList.get(trackById, afterIndex) : null;
    };
    /**
     * Removes a {@link CollectionChangeRecord} from the list of duplicates.
     *
     * The list of duplicates also is removed from the map if it gets empty.
     */
    _DuplicateMap.prototype.remove = function (record) {
        var key = record.trackById;
        var recordList = this.map.get(key);
        // Remove the list of duplicates when it gets empty
        if (recordList.remove(record)) {
            this.map.delete(key);
        }
        return record;
    };
    Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
        get: function () { return this.map.size === 0; },
        enumerable: true,
        configurable: true
    });
    _DuplicateMap.prototype.clear = function () { this.map.clear(); };
    _DuplicateMap.prototype.toString = function () { return '_DuplicateMap(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.map) + ')'; };
    return _DuplicateMap;
}());
function getPreviousIndex(item, addRemoveOffset, moveOffsets) {
    var previousIndex = item.previousIndex;
    if (previousIndex === null)
        return previousIndex;
    var moveOffset = 0;
    if (moveOffsets && previousIndex < moveOffsets.length) {
        moveOffset = moveOffsets[previousIndex];
    }
    return previousIndex + addRemoveOffset + moveOffset;
}
//# sourceMappingURL=default_iterable_differ.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (immutable) */ exports["b"] = forwardRef;
/* harmony export (immutable) */ exports["a"] = resolveForwardRef;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Allows to refer to references which are not yet defined.
 *
 * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
 * DI is declared,
 * but not yet defined. It is also used when the `token` which we use when creating a query is not
 * yet defined.
 *
 * ### Example
 * {@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
 * @experimental
 */
function forwardRef(forwardRefFn) {
    forwardRefFn.__forward_ref__ = forwardRef;
    forwardRefFn.toString = function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this()); };
    return forwardRefFn;
}
/**
 * Lazily retrieves the reference value from a forwardRef.
 *
 * Acts as the identity function when given a non-forward-ref value.
 *
 * ### Example ([live demo](http://plnkr.co/edit/GU72mJrk1fiodChcmiDR?p=preview))
 *
 * {@example core/di/ts/forward_ref/forward_ref_spec.ts region='resolve_forward_ref'}
 *
 * See: {@link forwardRef}
 * @experimental
 */
function resolveForwardRef(type) {
    if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__') &&
        type.__forward_ref__ === forwardRef) {
        return type();
    }
    else {
        return type;
    }
}
//# sourceMappingURL=forward_ref.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(134);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return OpaqueToken; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Creates a token that can be used in a DI Provider.
 *
 * ### Example ([live demo](http://plnkr.co/edit/Ys9ezXpj2Mnoy3Uc8KBp?p=preview))
 *
 * ```typescript
 * var t = new OpaqueToken("value");
 *
 * var injector = Injector.resolveAndCreate([
 *   {provide: t, useValue: "bindingValue"}
 * ]);
 *
 * expect(injector.get(t)).toEqual("bindingValue");
 * ```
 *
 * Using an `OpaqueToken` is preferable to using strings as tokens because of possible collisions
 * caused by multiple providers using the same string as two different tokens.
 *
 * Using an `OpaqueToken` is preferable to using an `Object` as tokens because it provides better
 * error messages.
 * @stable
 */
// so that metadata is gathered for this class
var OpaqueToken = (function () {
    function OpaqueToken(_desc) {
        this._desc = _desc;
    }
    OpaqueToken.prototype.toString = function () { return "Token " + this._desc; };
    OpaqueToken.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* Injectable */] },
    ];
    /** @nocollapse */
    OpaqueToken.ctorParameters = [
        null,
    ];
    return OpaqueToken;
}());
//# sourceMappingURL=opaque_token.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forward_ref__ = __webpack_require__(188);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReflectiveKey; });
/* unused harmony export KeyRegistry */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * A unique object used for retrieving items from the {@link ReflectiveInjector}.
 *
 * Keys have:
 * - a system-wide unique `id`.
 * - a `token`.
 *
 * `Key` is used internally by {@link ReflectiveInjector} because its system-wide unique `id` allows
 * the
 * injector to store created objects in a more efficient way.
 *
 * `Key` should not be created directly. {@link ReflectiveInjector} creates keys automatically when
 * resolving
 * providers.
 * @experimental
 */
var ReflectiveKey = (function () {
    /**
     * Private
     */
    function ReflectiveKey(token, id) {
        this.token = token;
        this.id = id;
        if (!token) {
            throw new Error('Token must be defined!');
        }
    }
    Object.defineProperty(ReflectiveKey.prototype, "displayName", {
        /**
         * Returns a stringified token.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this.token); },
        enumerable: true,
        configurable: true
    });
    /**
     * Retrieves a `Key` for a token.
     */
    ReflectiveKey.get = function (token) {
        return _globalKeyRegistry.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__forward_ref__["a" /* resolveForwardRef */])(token));
    };
    Object.defineProperty(ReflectiveKey, "numberOfKeys", {
        /**
         * @returns the number of keys registered in the system.
         */
        get: function () { return _globalKeyRegistry.numberOfKeys; },
        enumerable: true,
        configurable: true
    });
    return ReflectiveKey;
}());
/**
 * @internal
 */
var KeyRegistry = (function () {
    function KeyRegistry() {
        this._allKeys = new Map();
    }
    KeyRegistry.prototype.get = function (token) {
        if (token instanceof ReflectiveKey)
            return token;
        if (this._allKeys.has(token)) {
            return this._allKeys.get(token);
        }
        var newKey = new ReflectiveKey(token, ReflectiveKey.numberOfKeys);
        this._allKeys.set(token, newKey);
        return newKey;
    };
    Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
        get: function () { return this._allKeys.size; },
        enumerable: true,
        configurable: true
    });
    return KeyRegistry;
}());
var _globalKeyRegistry = new KeyRegistry();
//# sourceMappingURL=reflective_key.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forward_ref__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metadata__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reflective_errors__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reflective_key__ = __webpack_require__(190);
/* unused harmony export ReflectiveDependency */
/* unused harmony export ResolvedReflectiveProvider_ */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ResolvedReflectiveFactory; });
/* harmony export (immutable) */ exports["a"] = resolveReflectiveProviders;
/* unused harmony export mergeResolvedReflectiveProviders */
/* harmony export (immutable) */ exports["b"] = constructDependencies;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */








/**
 * `Dependency` is used by the framework to extend DI.
 * This is internal to Angular and should not be used directly.
 */
var ReflectiveDependency = (function () {
    function ReflectiveDependency(key, optional, lowerBoundVisibility, upperBoundVisibility, properties) {
        this.key = key;
        this.optional = optional;
        this.lowerBoundVisibility = lowerBoundVisibility;
        this.upperBoundVisibility = upperBoundVisibility;
        this.properties = properties;
    }
    ReflectiveDependency.fromKey = function (key) {
        return new ReflectiveDependency(key, false, null, null, []);
    };
    return ReflectiveDependency;
}());
var _EMPTY_LIST = [];
var ResolvedReflectiveProvider_ = (function () {
    function ResolvedReflectiveProvider_(key, resolvedFactories, multiProvider) {
        this.key = key;
        this.resolvedFactories = resolvedFactories;
        this.multiProvider = multiProvider;
    }
    Object.defineProperty(ResolvedReflectiveProvider_.prototype, "resolvedFactory", {
        get: function () { return this.resolvedFactories[0]; },
        enumerable: true,
        configurable: true
    });
    return ResolvedReflectiveProvider_;
}());
/**
 * An internal resolved representation of a factory function created by resolving {@link
 * Provider}.
 * @experimental
 */
var ResolvedReflectiveFactory = (function () {
    function ResolvedReflectiveFactory(
        /**
         * Factory function which can return an instance of an object represented by a key.
         */
        factory, 
        /**
         * Arguments (dependencies) to the `factory` function.
         */
        dependencies) {
        this.factory = factory;
        this.dependencies = dependencies;
    }
    return ResolvedReflectiveFactory;
}());
/**
 * Resolve a single provider.
 */
function resolveReflectiveFactory(provider) {
    var factoryFn;
    var resolvedDeps;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(provider.useClass)) {
        var useClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__forward_ref__["a" /* resolveForwardRef */])(provider.useClass);
        factoryFn = __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__["a" /* reflector */].factory(useClass);
        resolvedDeps = _dependenciesFor(useClass);
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(provider.useExisting)) {
        factoryFn = function (aliasInstance) { return aliasInstance; };
        resolvedDeps = [ReflectiveDependency.fromKey(__WEBPACK_IMPORTED_MODULE_7__reflective_key__["a" /* ReflectiveKey */].get(provider.useExisting))];
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(provider.useFactory)) {
        factoryFn = provider.useFactory;
        resolvedDeps = constructDependencies(provider.useFactory, provider.deps);
    }
    else {
        factoryFn = function () { return provider.useValue; };
        resolvedDeps = _EMPTY_LIST;
    }
    return new ResolvedReflectiveFactory(factoryFn, resolvedDeps);
}
/**
 * Converts the {@link Provider} into {@link ResolvedProvider}.
 *
 * {@link Injector} internally only uses {@link ResolvedProvider}, {@link Provider} contains
 * convenience provider syntax.
 */
function resolveReflectiveProvider(provider) {
    return new ResolvedReflectiveProvider_(__WEBPACK_IMPORTED_MODULE_7__reflective_key__["a" /* ReflectiveKey */].get(provider.provide), [resolveReflectiveFactory(provider)], provider.multi);
}
/**
 * Resolve a list of Providers.
 */
function resolveReflectiveProviders(providers) {
    var normalized = _normalizeProviders(providers, []);
    var resolved = normalized.map(resolveReflectiveProvider);
    return __WEBPACK_IMPORTED_MODULE_0__facade_collection__["a" /* MapWrapper */].values(mergeResolvedReflectiveProviders(resolved, new Map()));
}
/**
 * Merges a list of ResolvedProviders into a list where
 * each key is contained exactly once and multi providers
 * have been merged.
 */
function mergeResolvedReflectiveProviders(providers, normalizedProvidersMap) {
    for (var i = 0; i < providers.length; i++) {
        var provider = providers[i];
        var existing = normalizedProvidersMap.get(provider.key.id);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(existing)) {
            if (provider.multiProvider !== existing.multiProvider) {
                throw new __WEBPACK_IMPORTED_MODULE_6__reflective_errors__["a" /* MixingMultiProvidersWithRegularProvidersError */](existing, provider);
            }
            if (provider.multiProvider) {
                for (var j = 0; j < provider.resolvedFactories.length; j++) {
                    existing.resolvedFactories.push(provider.resolvedFactories[j]);
                }
            }
            else {
                normalizedProvidersMap.set(provider.key.id, provider);
            }
        }
        else {
            var resolvedProvider;
            if (provider.multiProvider) {
                resolvedProvider = new ResolvedReflectiveProvider_(provider.key, provider.resolvedFactories.slice(), provider.multiProvider);
            }
            else {
                resolvedProvider = provider;
            }
            normalizedProvidersMap.set(provider.key.id, resolvedProvider);
        }
    }
    return normalizedProvidersMap;
}
function _normalizeProviders(providers, res) {
    providers.forEach(function (b) {
        if (b instanceof __WEBPACK_IMPORTED_MODULE_3__type__["a" /* Type */]) {
            res.push({ provide: b, useClass: b });
        }
        else if (b && typeof b == 'object' && b.provide !== undefined) {
            res.push(b);
        }
        else if (b instanceof Array) {
            _normalizeProviders(b, res);
        }
        else {
            throw new __WEBPACK_IMPORTED_MODULE_6__reflective_errors__["b" /* InvalidProviderError */](b);
        }
    });
    return res;
}
function constructDependencies(typeOrFunc, dependencies) {
    if (!dependencies) {
        return _dependenciesFor(typeOrFunc);
    }
    else {
        var params = dependencies.map(function (t) { return [t]; });
        return dependencies.map(function (t) { return _extractToken(typeOrFunc, t, params); });
    }
}
function _dependenciesFor(typeOrFunc) {
    var params = __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__["a" /* reflector */].parameters(typeOrFunc);
    if (!params)
        return [];
    if (params.some(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])) {
        throw new __WEBPACK_IMPORTED_MODULE_6__reflective_errors__["c" /* NoAnnotationError */](typeOrFunc, params);
    }
    return params.map(function (p) { return _extractToken(typeOrFunc, p, params); });
}
function _extractToken(typeOrFunc /** TODO #9100 */, metadata /** TODO #9100 */ /*any[] | any*/, params) {
    var depProps = [];
    var token = null;
    var optional = false;
    if (!Array.isArray(metadata)) {
        if (metadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["b" /* Inject */]) {
            return _createDependency(metadata.token, optional, null, null, depProps);
        }
        else {
            return _createDependency(metadata, optional, null, null, depProps);
        }
    }
    var lowerBoundVisibility = null;
    var upperBoundVisibility = null;
    for (var i = 0; i < metadata.length; ++i) {
        var paramMetadata = metadata[i];
        if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_3__type__["a" /* Type */]) {
            token = paramMetadata;
        }
        else if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["b" /* Inject */]) {
            token = paramMetadata.token;
        }
        else if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["c" /* Optional */]) {
            optional = true;
        }
        else if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["d" /* Self */]) {
            upperBoundVisibility = paramMetadata;
        }
        else if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["e" /* Host */]) {
            upperBoundVisibility = paramMetadata;
        }
        else if (paramMetadata instanceof __WEBPACK_IMPORTED_MODULE_5__metadata__["f" /* SkipSelf */]) {
            lowerBoundVisibility = paramMetadata;
        }
    }
    token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__forward_ref__["a" /* resolveForwardRef */])(token);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(token)) {
        return _createDependency(token, optional, lowerBoundVisibility, upperBoundVisibility, depProps);
    }
    else {
        throw new __WEBPACK_IMPORTED_MODULE_6__reflective_errors__["c" /* NoAnnotationError */](typeOrFunc, params);
    }
}
function _createDependency(token /** TODO #9100 */, optional /** TODO #9100 */, lowerBoundVisibility /** TODO #9100 */, upperBoundVisibility /** TODO #9100 */, depProps /** TODO #9100 */) {
    return new ReflectiveDependency(__WEBPACK_IMPORTED_MODULE_7__reflective_key__["a" /* ReflectiveKey */].get(token), optional, lowerBoundVisibility, upperBoundVisibility, depProps);
}
//# sourceMappingURL=reflective_provider.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "ErrorHandler", function() { return ErrorHandler; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes Provides a hook for centralized exception handling.
 *
 * @description
 *
 * The default implementation of `ErrorHandler` prints error messages to the `console`. To
 * intercept error handling, write a custom exception handler that replaces this default as
 * appropriate for your app.
 *
 * ### Example
 *
 * ```
 * class MyErrorHandler implements ErrorHandler {
 *   handleError(error) {
 *     // do something with the exception
 *   }
 * }
 *
 * @NgModule({
 *   providers: [{provide: ErrorHandler, useClass: MyErrorHandler}]
 * })
 * class MyModule {}
 * ```
 *
 * @stable
 */
var ErrorHandler = (function () {
    function ErrorHandler(rethrowError) {
        if (rethrowError === void 0) { rethrowError = true; }
        /**
         * @internal
         */
        this._console = console;
        this.rethrowError = rethrowError;
    }
    ErrorHandler.prototype.handleError = function (error) {
        var originalError = this._findOriginalError(error);
        var originalStack = this._findOriginalStack(error);
        var context = this._findContext(error);
        this._console.error("EXCEPTION: " + this._extractMessage(error));
        if (originalError) {
            this._console.error("ORIGINAL EXCEPTION: " + this._extractMessage(originalError));
        }
        if (originalStack) {
            this._console.error('ORIGINAL STACKTRACE:');
            this._console.error(originalStack);
        }
        if (context) {
            this._console.error('ERROR CONTEXT:');
            this._console.error(context);
        }
        // We rethrow exceptions, so operations like 'bootstrap' will result in an error
        // when an error happens. If we do not rethrow, bootstrap will always succeed.
        if (this.rethrowError)
            throw error;
    };
    /** @internal */
    ErrorHandler.prototype._extractMessage = function (error) {
        return error instanceof Error ? error.message : error.toString();
    };
    /** @internal */
    ErrorHandler.prototype._findContext = function (error) {
        if (error) {
            return error.context ? error.context :
                this._findContext(error.originalError);
        }
        return null;
    };
    /** @internal */
    ErrorHandler.prototype._findOriginalError = function (error) {
        var e = error.originalError;
        while (e && e.originalError) {
            e = e.originalError;
        }
        return e;
    };
    /** @internal */
    ErrorHandler.prototype._findOriginalStack = function (error) {
        if (!(error instanceof Error))
            return null;
        var e = error;
        var stack = e.stack;
        while (e instanceof Error && e.originalError) {
            e = e.originalError;
            if (e instanceof Error && e.stack) {
                stack = e.stack;
            }
        }
        return stack;
    };
    return ErrorHandler;
}());
//# sourceMappingURL=error_handler.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di_injector__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_factory_resolver__ = __webpack_require__(83);
/* harmony export (binding) */ __webpack_require__.d(exports, "NgModuleRef", function() { return NgModuleRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgModuleFactory", function() { return NgModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NgModuleInjector", function() { return NgModuleInjector; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Represents an instance of an NgModule created via a {@link NgModuleFactory}.
 *
 * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
 * NgModule Instance.
 *
 * @stable
 */
var NgModuleRef = (function () {
    function NgModuleRef() {
    }
    Object.defineProperty(NgModuleRef.prototype, "injector", {
        /**
         * The injector that contains all of the providers of the NgModule.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModuleRef.prototype, "componentFactoryResolver", {
        /**
         * The ComponentFactoryResolver to get hold of the ComponentFactories
         * declared in the `entryComponents` property of the module.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModuleRef.prototype, "instance", {
        /**
         * The NgModule instance.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    return NgModuleRef;
}());
/**
 * @experimental
 */
var NgModuleFactory = (function () {
    function NgModuleFactory(_injectorClass, _moduleType) {
        this._injectorClass = _injectorClass;
        this._moduleType = _moduleType;
    }
    Object.defineProperty(NgModuleFactory.prototype, "moduleType", {
        get: function () { return this._moduleType; },
        enumerable: true,
        configurable: true
    });
    NgModuleFactory.prototype.create = function (parentInjector) {
        if (!parentInjector) {
            parentInjector = __WEBPACK_IMPORTED_MODULE_0__di_injector__["b" /* Injector */].NULL;
        }
        var instance = new this._injectorClass(parentInjector);
        instance.create();
        return instance;
    };
    return NgModuleFactory;
}());
var _UNDEFINED = new Object();
var NgModuleInjector = (function (_super) {
    __extends(NgModuleInjector, _super);
    function NgModuleInjector(parent, factories, bootstrapFactories) {
        _super.call(this, factories, parent.get(__WEBPACK_IMPORTED_MODULE_3__component_factory_resolver__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_3__component_factory_resolver__["ComponentFactoryResolver"].NULL));
        this.parent = parent;
        this.bootstrapFactories = bootstrapFactories;
        this._destroyListeners = [];
        this._destroyed = false;
    }
    NgModuleInjector.prototype.create = function () { this.instance = this.createInternal(); };
    NgModuleInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = __WEBPACK_IMPORTED_MODULE_0__di_injector__["a" /* THROW_IF_NOT_FOUND */]; }
        if (token === __WEBPACK_IMPORTED_MODULE_0__di_injector__["b" /* Injector */] || token === __WEBPACK_IMPORTED_MODULE_3__component_factory_resolver__["ComponentFactoryResolver"]) {
            return this;
        }
        var result = this.getInternal(token, _UNDEFINED);
        return result === _UNDEFINED ? this.parent.get(token, notFoundValue) : result;
    };
    Object.defineProperty(NgModuleInjector.prototype, "injector", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModuleInjector.prototype, "componentFactoryResolver", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    NgModuleInjector.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error("The ng module " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["b" /* stringify */])(this.instance.constructor) + " has already been destroyed.");
        }
        this._destroyed = true;
        this.destroyInternal();
        this._destroyListeners.forEach(function (listener) { return listener(); });
    };
    NgModuleInjector.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    return NgModuleInjector;
}(__WEBPACK_IMPORTED_MODULE_3__component_factory_resolver__["CodegenComponentFactoryResolver"]));
//# sourceMappingURL=ng_module_factory.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "NgModuleFactoryLoader", function() { return NgModuleFactoryLoader; });
/* harmony export (immutable) */ exports["registerModuleFactory"] = registerModuleFactory;
/* harmony export (immutable) */ exports["clearModulesForTest"] = clearModulesForTest;
/* harmony export (immutable) */ exports["getModuleFactory"] = getModuleFactory;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to load ng module factories.
 * @stable
 */
var NgModuleFactoryLoader = (function () {
    function NgModuleFactoryLoader() {
    }
    return NgModuleFactoryLoader;
}());
var moduleFactories = new Map();
/**
 * Registers a loaded module. Should only be called from generated NgModuleFactory code.
 * @experimental
 */
function registerModuleFactory(id, factory) {
    var existing = moduleFactories.get(id);
    if (existing) {
        throw new Error("Duplicate module registered for " + id + " - " + existing.moduleType.name + " vs " + factory.moduleType.name);
    }
    moduleFactories.set(id, factory);
}
function clearModulesForTest() {
    moduleFactories = new Map();
}
/**
 * Returns the NgModuleFactory with the given id, if it exists and has been loaded.
 * Factories for modules that do not specify an `id` cannot be retrieved. Throws if the module
 * cannot be found.
 * @experimental
 */
function getModuleFactory(id) {
    var factory = moduleFactories.get(id);
    if (!factory)
        throw new Error("No module with ID " + id + " loaded");
    return factory;
}
//# sourceMappingURL=ng_module_factory_loader.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reflection_capabilities__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reflector__ = __webpack_require__(275);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return reflector; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reflector__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * The {@link Reflector} used internally in Angular to access metadata
 * about symbols.
 */
var reflector = new __WEBPACK_IMPORTED_MODULE_1__reflector__["a" /* Reflector */](new __WEBPACK_IMPORTED_MODULE_0__reflection_capabilities__["a" /* ReflectionCapabilities */]());
//# sourceMappingURL=reflection.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReflectorReader; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides read-only access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
var ReflectorReader = (function () {
    function ReflectorReader() {
    }
    return ReflectorReader;
}());
//# sourceMappingURL=reflector_reader.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Type; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @whatItDoes Represents a type that a Component or other object is instances of.
 *
 * @description
 *
 * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
 * the `MyCustomComponent` constructor function.
 *
 * @stable
 */
var Type = Function;
//# sourceMappingURL=type.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = isPromise;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function isPromise(obj) {
    // allow any Promise/A+ compliant thenable.
    // It's up to the caller to ensure that obj.then conforms to the spec
    return !!obj && typeof obj.then === 'function';
}
//# sourceMappingURL=lang.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * @stable
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "control", {
        get: function () { throw new Error('unimplemented'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.errors : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control) ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.control))
            this.control.reset(value);
    };
    return AbstractControlDirective;
}());
//# sourceMappingURL=abstract_control_directive.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(26);
/* unused harmony export NUMBER_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NumberValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var NUMBER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["NG_VALUE_ACCESSOR"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var normalizedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value) ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ];
    return NumberValueAccessor;
}());
//# sourceMappingURL=number_value_accessor.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_control__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(72);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_4__ng_control__["NgControl"],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * @whatItDoes Syncs a standalone {@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {@link FormControl} instance (view -> model).
 *
 * @howToUse
 *
 * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
 * Simply create a {@link FormControl}, save it to your component class, and pass it into the
 * {@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
 * it does not require that your {@link FormControl} instance be part of any parent
 * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {@link FormControl} instance. See a full list of available properties in
 * {@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
 * or you can set it programmatically later using {@link AbstractControl.setValue} or
 * {@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
 * {@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  @stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["NG_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["NG_ASYNC_VALIDATORS"],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["NG_VALUE_ACCESSOR"],] },] },
    ];
    FormControlDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(__WEBPACK_IMPORTED_MODULE_4__ng_control__["NgControl"]));
//# sourceMappingURL=form_control_directive.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "JSONP_HOME", function() { return JSONP_HOME; });
/* harmony export (binding) */ __webpack_require__.d(exports, "BrowserJsonp", function() { return BrowserJsonp; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var _nextRequestId = 0;
var JSONP_HOME = '__ng_jsonp__';
var _jsonpConnections = null;
function _getJsonpConnections() {
    if (_jsonpConnections === null) {
        _jsonpConnections = __WEBPACK_IMPORTED_MODULE_1__facade_lang__["a" /* global */][JSONP_HOME] = {};
    }
    return _jsonpConnections;
}
// Make sure not to evaluate this in a non-browser environment!
var BrowserJsonp = (function () {
    function BrowserJsonp() {
    }
    // Construct a <script> element with the specified URL
    BrowserJsonp.prototype.build = function (url) {
        var node = document.createElement('script');
        node.src = url;
        return node;
    };
    BrowserJsonp.prototype.nextRequestID = function () { return "__req" + _nextRequestId++; };
    BrowserJsonp.prototype.requestCallback = function (id) { return JSONP_HOME + "." + id + ".finished"; };
    BrowserJsonp.prototype.exposeConnection = function (id, connection) {
        var connections = _getJsonpConnections();
        connections[id] = connection;
    };
    BrowserJsonp.prototype.removeConnection = function (id) {
        var connections = _getJsonpConnections();
        connections[id] = null;
    };
    // Attach the <script> element to the DOM
    BrowserJsonp.prototype.send = function (node) { document.body.appendChild((node)); };
    // Remove <script> element from the DOM
    BrowserJsonp.prototype.cleanup = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild((node));
        }
    };
    BrowserJsonp.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BrowserJsonp.ctorParameters = [];
    return BrowserJsonp;
}());
//# sourceMappingURL=browser_jsonp.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_response_options__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_response__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_jsonp__ = __webpack_require__(202);
/* harmony export (binding) */ __webpack_require__.d(exports, "JSONPConnection", function() { return JSONPConnection; });
/* harmony export (binding) */ __webpack_require__.d(exports, "JSONPConnection_", function() { return JSONPConnection_; });
/* harmony export (binding) */ __webpack_require__.d(exports, "JSONPBackend", function() { return JSONPBackend; });
/* harmony export (binding) */ __webpack_require__.d(exports, "JSONPBackend_", function() { return JSONPBackend_; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};








var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
/**
 * Abstract base class for an in-flight JSONP request.
 *
 * @experimental
 */
var JSONPConnection = (function () {
    function JSONPConnection() {
    }
    return JSONPConnection;
}());
var JSONPConnection_ = (function (_super) {
    __extends(JSONPConnection_, _super);
    function JSONPConnection_(req, _dom, baseResponseOptions) {
        var _this = this;
        _super.call(this);
        this._dom = _dom;
        this.baseResponseOptions = baseResponseOptions;
        this._finished = false;
        if (req.method !== __WEBPACK_IMPORTED_MODULE_3__enums__["b" /* RequestMethod */].Get) {
            throw new TypeError(JSONP_ERR_WRONG_METHOD);
        }
        this.request = req;
        this.response = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (responseObserver) {
            _this.readyState = __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Loading;
            var id = _this._id = _dom.nextRequestID();
            _dom.exposeConnection(id, _this);
            // Workaround Dart
            // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
            var callback = _dom.requestCallback(_this._id);
            var url = req.url;
            if (url.indexOf('=JSONP_CALLBACK&') > -1) {
                url = url.replace('=JSONP_CALLBACK&', "=" + callback + "&");
            }
            else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
                url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
            }
            var script = _this._script = _dom.build(url);
            var onLoad = function (event) {
                if (_this.readyState === __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Cancelled)
                    return;
                _this.readyState = __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Done;
                _dom.cleanup(script);
                if (!_this._finished) {
                    var responseOptions_1 = new __WEBPACK_IMPORTED_MODULE_2__base_response_options__["ResponseOptions"]({ body: JSONP_ERR_NO_CALLBACK, type: __WEBPACK_IMPORTED_MODULE_3__enums__["a" /* ResponseType */].Error, url: url });
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(baseResponseOptions)) {
                        responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
                    }
                    responseObserver.error(new __WEBPACK_IMPORTED_MODULE_6__static_response__["a" /* Response */](responseOptions_1));
                    return;
                }
                var responseOptions = new __WEBPACK_IMPORTED_MODULE_2__base_response_options__["ResponseOptions"]({ body: _this._responseData, url: url });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(_this.baseResponseOptions)) {
                    responseOptions = _this.baseResponseOptions.merge(responseOptions);
                }
                responseObserver.next(new __WEBPACK_IMPORTED_MODULE_6__static_response__["a" /* Response */](responseOptions));
                responseObserver.complete();
            };
            var onError = function (error) {
                if (_this.readyState === __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Cancelled)
                    return;
                _this.readyState = __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Done;
                _dom.cleanup(script);
                var responseOptions = new __WEBPACK_IMPORTED_MODULE_2__base_response_options__["ResponseOptions"]({ body: error.message, type: __WEBPACK_IMPORTED_MODULE_3__enums__["a" /* ResponseType */].Error });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(baseResponseOptions)) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new __WEBPACK_IMPORTED_MODULE_6__static_response__["a" /* Response */](responseOptions));
            };
            script.addEventListener('load', onLoad);
            script.addEventListener('error', onError);
            _dom.send(script);
            return function () {
                _this.readyState = __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Cancelled;
                script.removeEventListener('load', onLoad);
                script.removeEventListener('error', onError);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__facade_lang__["d" /* isPresent */])(script)) {
                    _this._dom.cleanup(script);
                }
            };
        });
    }
    JSONPConnection_.prototype.finished = function (data) {
        // Don't leak connections
        this._finished = true;
        this._dom.removeConnection(this._id);
        if (this.readyState === __WEBPACK_IMPORTED_MODULE_3__enums__["c" /* ReadyState */].Cancelled)
            return;
        this._responseData = data;
    };
    return JSONPConnection_;
}(JSONPConnection));
/**
 * A {@link ConnectionBackend} that uses the JSONP strategy of making requests.
 *
 * @experimental
 */
var JSONPBackend = (function (_super) {
    __extends(JSONPBackend, _super);
    function JSONPBackend() {
        _super.apply(this, arguments);
    }
    return JSONPBackend;
}(__WEBPACK_IMPORTED_MODULE_5__interfaces__["ConnectionBackend"]));
var JSONPBackend_ = (function (_super) {
    __extends(JSONPBackend_, _super);
    function JSONPBackend_(_browserJSONP, _baseResponseOptions) {
        _super.call(this);
        this._browserJSONP = _browserJSONP;
        this._baseResponseOptions = _baseResponseOptions;
    }
    JSONPBackend_.prototype.createConnection = function (request) {
        return new JSONPConnection_(request, this._browserJSONP, this._baseResponseOptions);
    };
    JSONPBackend_.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    JSONPBackend_.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_7__browser_jsonp__["BrowserJsonp"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__base_response_options__["ResponseOptions"], },
    ];
    return JSONPBackend_;
}(JSONPBackend));
//# sourceMappingURL=jsonp_backend.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_response_options__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__headers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interfaces__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_response__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__browser_xhr__ = __webpack_require__(141);
/* harmony export (binding) */ __webpack_require__.d(exports, "XHRConnection", function() { return XHRConnection; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CookieXSRFStrategy", function() { return CookieXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "XHRBackend", function() { return XHRBackend; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */











var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Creates connections using `XMLHttpRequest`. Given a fully-qualified
 * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
 * request.
 *
 * This class would typically not be created or interacted with directly inside applications, though
 * the {@link MockConnection} may be interacted with in tests.
 *
 * @experimental
 */
var XHRConnection = (function () {
    function XHRConnection(req, browserXHR, baseResponseOptions) {
        var _this = this;
        this.request = req;
        this.response = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"](function (responseObserver) {
            var _xhr = browserXHR.build();
            _xhr.open(__WEBPACK_IMPORTED_MODULE_4__enums__["b" /* RequestMethod */][req.method].toUpperCase(), req.url);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(req.withCredentials)) {
                _xhr.withCredentials = req.withCredentials;
            }
            // load event handler
            var onLoad = function () {
                // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                // response/responseType properties were introduced in ResourceLoader Level2 spec (supported
                // by IE10)
                var body = _xhr.response === undefined ? _xhr.responseText : _xhr.response;
                // Implicitly strip a potential XSSI prefix.
                if (typeof body === 'string')
                    body = body.replace(XSSI_PREFIX, '');
                var headers = __WEBPACK_IMPORTED_MODULE_6__headers__["a" /* Headers */].fromResponseHeaderString(_xhr.getAllResponseHeaders());
                var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__http_utils__["c" /* getResponseURL */])(_xhr);
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status = _xhr.status === 1223 ? 204 : _xhr.status;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status === 0) {
                    status = body ? 200 : 0;
                }
                var statusText = _xhr.statusText || 'OK';
                var responseOptions = new __WEBPACK_IMPORTED_MODULE_3__base_response_options__["ResponseOptions"]({ body: body, status: status, headers: headers, statusText: statusText, url: url });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(baseResponseOptions)) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                var response = new __WEBPACK_IMPORTED_MODULE_9__static_response__["a" /* Response */](responseOptions);
                response.ok = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__http_utils__["d" /* isSuccess */])(status);
                if (response.ok) {
                    responseObserver.next(response);
                    // TODO(gdi2290): defer complete if array buffer until done
                    responseObserver.complete();
                    return;
                }
                responseObserver.error(response);
            };
            // error event handler
            var onError = function (err) {
                var responseOptions = new __WEBPACK_IMPORTED_MODULE_3__base_response_options__["ResponseOptions"]({
                    body: err,
                    type: __WEBPACK_IMPORTED_MODULE_4__enums__["a" /* ResponseType */].Error,
                    status: _xhr.status,
                    statusText: _xhr.statusText,
                });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(baseResponseOptions)) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new __WEBPACK_IMPORTED_MODULE_9__static_response__["a" /* Response */](responseOptions));
            };
            _this.setDetectedContentType(req, _xhr);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(req.headers)) {
                req.headers.forEach(function (values, name) { return _xhr.setRequestHeader(name, values.join(',')); });
            }
            // Select the correct buffer type to store the response
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(req.responseType) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(_xhr.responseType)) {
                switch (req.responseType) {
                    case __WEBPACK_IMPORTED_MODULE_4__enums__["d" /* ResponseContentType */].ArrayBuffer:
                        _xhr.responseType = 'arraybuffer';
                        break;
                    case __WEBPACK_IMPORTED_MODULE_4__enums__["d" /* ResponseContentType */].Json:
                        _xhr.responseType = 'json';
                        break;
                    case __WEBPACK_IMPORTED_MODULE_4__enums__["d" /* ResponseContentType */].Text:
                        _xhr.responseType = 'text';
                        break;
                    case __WEBPACK_IMPORTED_MODULE_4__enums__["d" /* ResponseContentType */].Blob:
                        _xhr.responseType = 'blob';
                        break;
                    default:
                        throw new Error('The selected responseType is not supported');
                }
            }
            _xhr.addEventListener('load', onLoad);
            _xhr.addEventListener('error', onError);
            _xhr.send(_this.request.getBody());
            return function () {
                _xhr.removeEventListener('load', onLoad);
                _xhr.removeEventListener('error', onError);
                _xhr.abort();
            };
        });
    }
    XHRConnection.prototype.setDetectedContentType = function (req /** TODO #9100 */, _xhr /** TODO #9100 */) {
        // Skip if a custom Content-Type header is provided
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(req.headers) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__facade_lang__["d" /* isPresent */])(req.headers.get('Content-Type'))) {
            return;
        }
        // Set the detected content type
        switch (req.contentType) {
            case __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* ContentType */].NONE:
                break;
            case __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* ContentType */].JSON:
                _xhr.setRequestHeader('content-type', 'application/json');
                break;
            case __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* ContentType */].FORM:
                _xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                break;
            case __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* ContentType */].TEXT:
                _xhr.setRequestHeader('content-type', 'text/plain');
                break;
            case __WEBPACK_IMPORTED_MODULE_4__enums__["e" /* ContentType */].BLOB:
                var blob = req.blob();
                if (blob.type) {
                    _xhr.setRequestHeader('content-type', blob.type);
                }
                break;
        }
    };
    return XHRConnection;
}());
/**
 * `XSRFConfiguration` sets up Cross Site Request Forgery (XSRF) protection for the application
 * using a cookie. See {@link https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)}
 * for more information on XSRF.
 *
 * Applications can configure custom cookie and header names by binding an instance of this class
 * with different `cookieName` and `headerName` values. See the main HTTP documentation for more
 * details.
 *
 * @experimental
 */
var CookieXSRFStrategy = (function () {
    function CookieXSRFStrategy(_cookieName, _headerName) {
        if (_cookieName === void 0) { _cookieName = 'XSRF-TOKEN'; }
        if (_headerName === void 0) { _headerName = 'X-XSRF-TOKEN'; }
        this._cookieName = _cookieName;
        this._headerName = _headerName;
    }
    CookieXSRFStrategy.prototype.configureRequest = function (req) {
        var xsrfToken = __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["__platform_browser_private__"].getDOM().getCookie(this._cookieName);
        if (xsrfToken) {
            req.headers.set(this._headerName, xsrfToken);
        }
    };
    return CookieXSRFStrategy;
}());
/**
 * Creates {@link XHRConnection} instances.
 *
 * This class would typically not be used by end users, but could be
 * overridden if a different backend implementation should be used,
 * such as in a node backend.
 *
 * ### Example
 *
 * ```
 * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from '@angular/http';
 * @Component({
 *   viewProviders: [
 *     HTTP_PROVIDERS,
 *     {provide: Http, useFactory: (backend, options) => {
 *       return new Http(backend, options);
 *     }, deps: [MyNodeBackend, BaseRequestOptions]}]
 * })
 * class MyComponent {
 *   constructor(http:Http) {
 *     http.request('people.json').subscribe(res => this.people = res.json());
 *   }
 * }
 * ```
 * @experimental
 */
var XHRBackend = (function () {
    function XHRBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy) {
        this._browserXHR = _browserXHR;
        this._baseResponseOptions = _baseResponseOptions;
        this._xsrfStrategy = _xsrfStrategy;
    }
    XHRBackend.prototype.createConnection = function (request) {
        this._xsrfStrategy.configureRequest(request);
        return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
    };
    XHRBackend.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    XHRBackend.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_10__browser_xhr__["BrowserXhr"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__base_response_options__["ResponseOptions"], },
        { type: __WEBPACK_IMPORTED_MODULE_8__interfaces__["XSRFStrategy"], },
    ];
    return XHRBackend;
}());
//# sourceMappingURL=xhr_backend.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__body__ = __webpack_require__(281);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Response; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * Creates `Response` instances from provided values.
 *
 * Though this object isn't
 * usually instantiated by end-users, it is the primary object interacted with when it comes time to
 * add data to a view.
 *
 * ### Example
 *
 * ```
 * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
 * ```
 *
 * The Response's interface is inspired by the Response constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
 * can be accessed many times. There are other differences in the implementation, but this is the
 * most significant.
 *
 * @experimental
 */
var Response = (function (_super) {
    __extends(Response, _super);
    function Response(responseOptions) {
        _super.call(this);
        this._body = responseOptions.body;
        this.status = responseOptions.status;
        this.ok = (this.status >= 200 && this.status <= 299);
        this.statusText = responseOptions.statusText;
        this.headers = responseOptions.headers;
        this.type = responseOptions.type;
        this.url = responseOptions.url;
    }
    Response.prototype.toString = function () {
        return "Response with status: " + this.status + " " + this.statusText + " for URL: " + this.url;
    };
    return Response;
}(__WEBPACK_IMPORTED_MODULE_0__body__["a" /* Body */]));
//# sourceMappingURL=static_response.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_dom_animation_driver__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_dom_web_animations_driver__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__browser_browser_adapter__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__browser_location_browser_platform_location__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__browser_testability__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__browser_title__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_debug_ng_probe__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_debug_ng_probe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__dom_debug_ng_probe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dom_dom_renderer__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dom_dom_tokens__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dom_events_dom_events__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dom_events_event_manager__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dom_events_hammer_gestures__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dom_events_key_events__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dom_shared_styles_host__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__security_dom_sanitization_service__ = __webpack_require__(211);
/* harmony export (binding) */ __webpack_require__.d(exports, "INTERNAL_BROWSER_PLATFORM_PROVIDERS", function() { return INTERNAL_BROWSER_PLATFORM_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "BROWSER_SANITIZATION_PROVIDERS", function() { return BROWSER_SANITIZATION_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "platformBrowser", function() { return platformBrowser; });
/* harmony export (immutable) */ exports["initDomAdapter"] = initDomAdapter;
/* harmony export (immutable) */ exports["errorHandler"] = errorHandler;
/* harmony export (immutable) */ exports["_document"] = _document;
/* harmony export (immutable) */ exports["_resolveDefaultAnimationDriver"] = _resolveDefaultAnimationDriver;
/* harmony export (binding) */ __webpack_require__.d(exports, "BrowserModule", function() { return BrowserModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


















var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["PLATFORM_INITIALIZER"], useValue: initDomAdapter, multi: true },
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"], useClass: __WEBPACK_IMPORTED_MODULE_5__browser_location_browser_platform_location__["a" /* BrowserPlatformLocation */] }
];
/**
 * @security Replacing built-in sanitization providers exposes the application to XSS risks.
 * Attacker-controlled data introduced by an unsanitized provider could expose your
 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
 * @experimental
 */
var BROWSER_SANITIZATION_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Sanitizer"], useExisting: __WEBPACK_IMPORTED_MODULE_17__security_dom_sanitization_service__["DomSanitizer"] },
    { provide: __WEBPACK_IMPORTED_MODULE_17__security_dom_sanitization_service__["DomSanitizer"], useClass: __WEBPACK_IMPORTED_MODULE_17__security_dom_sanitization_service__["DomSanitizerImpl"] },
];
/**
 * @stable
 */
var platformBrowser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["createPlatformFactory"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["platformCore"], 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
function initDomAdapter() {
    __WEBPACK_IMPORTED_MODULE_4__browser_browser_adapter__["a" /* BrowserDomAdapter */].makeCurrent();
    __WEBPACK_IMPORTED_MODULE_6__browser_testability__["a" /* BrowserGetTestability */].init();
}
function errorHandler() {
    return new __WEBPACK_IMPORTED_MODULE_1__angular_core__["ErrorHandler"]();
}
function _document() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__dom_dom_adapter__["getDOM"])().defaultDoc();
}
function _resolveDefaultAnimationDriver() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__dom_dom_adapter__["getDOM"])().supportsWebAnimation()) {
        return new __WEBPACK_IMPORTED_MODULE_3__src_dom_web_animations_driver__["a" /* WebAnimationsDriver */]();
    }
    return __WEBPACK_IMPORTED_MODULE_2__src_dom_animation_driver__["AnimationDriver"].NOOP;
}
/**
 * The ng module for the browser.
 *
 * @stable
 */
var BrowserModule = (function () {
    function BrowserModule(parentModule) {
        if (parentModule) {
            throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
        }
    }
    BrowserModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    providers: [
                        BROWSER_SANITIZATION_PROVIDERS, { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ErrorHandler"], useFactory: errorHandler, deps: [] },
                        { provide: __WEBPACK_IMPORTED_MODULE_11__dom_dom_tokens__["DOCUMENT"], useFactory: _document, deps: [] },
                        { provide: __WEBPACK_IMPORTED_MODULE_13__dom_events_event_manager__["EVENT_MANAGER_PLUGINS"], useClass: __WEBPACK_IMPORTED_MODULE_12__dom_events_dom_events__["DomEventsPlugin"], multi: true },
                        { provide: __WEBPACK_IMPORTED_MODULE_13__dom_events_event_manager__["EVENT_MANAGER_PLUGINS"], useClass: __WEBPACK_IMPORTED_MODULE_15__dom_events_key_events__["KeyEventsPlugin"], multi: true },
                        { provide: __WEBPACK_IMPORTED_MODULE_13__dom_events_event_manager__["EVENT_MANAGER_PLUGINS"], useClass: __WEBPACK_IMPORTED_MODULE_14__dom_events_hammer_gestures__["HammerGesturesPlugin"], multi: true },
                        { provide: __WEBPACK_IMPORTED_MODULE_14__dom_events_hammer_gestures__["HAMMER_GESTURE_CONFIG"], useClass: __WEBPACK_IMPORTED_MODULE_14__dom_events_hammer_gestures__["HammerGestureConfig"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_10__dom_dom_renderer__["DomRootRenderer"], useClass: __WEBPACK_IMPORTED_MODULE_10__dom_dom_renderer__["DomRootRenderer_"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["RootRenderer"], useExisting: __WEBPACK_IMPORTED_MODULE_10__dom_dom_renderer__["DomRootRenderer"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_16__dom_shared_styles_host__["SharedStylesHost"], useExisting: __WEBPACK_IMPORTED_MODULE_16__dom_shared_styles_host__["DomSharedStylesHost"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_2__src_dom_animation_driver__["AnimationDriver"], useFactory: _resolveDefaultAnimationDriver }, __WEBPACK_IMPORTED_MODULE_16__dom_shared_styles_host__["DomSharedStylesHost"],
                        __WEBPACK_IMPORTED_MODULE_1__angular_core__["Testability"], __WEBPACK_IMPORTED_MODULE_13__dom_events_event_manager__["EventManager"], __WEBPACK_IMPORTED_MODULE_8__dom_debug_ng_probe__["ELEMENT_PROBE_PROVIDERS"], __WEBPACK_IMPORTED_MODULE_7__browser_title__["Title"]
                    ],
                    exports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationModule"]]
                },] },
    ];
    /** @nocollapse */
    BrowserModule.ctorParameters = [
        { type: BrowserModule, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
    ];
    return BrowserModule;
}());
//# sourceMappingURL=browser.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(exports, "Title", function() { return Title; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * A service that can be used to get and set the title of a current HTML document.
 *
 * Since an Angular 2 application can't be bootstrapped on the entire HTML document (`<html>` tag)
 * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
 * (representing the `<title>` tag). Instead, this service can be used to set and get the current
 * title value.
 *
 * @experimental
 */
var Title = (function () {
    function Title() {
    }
    /**
     * Get the title of the current HTML document.
     * @returns {string}
     */
    Title.prototype.getTitle = function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__["getDOM"])().getTitle(); };
    /**
     * Set the title of the current HTML document.
     * @param newTitle
     */
    Title.prototype.setTitle = function (newTitle) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__["getDOM"])().setTitle(newTitle); };
    return Title;
}());
//# sourceMappingURL=title.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation_driver__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_tokens__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_event_manager__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_styles_host__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(287);
/* harmony export (binding) */ __webpack_require__.d(exports, "DomRootRenderer", function() { return DomRootRenderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DomRootRenderer_", function() { return DomRootRenderer_; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DomRenderer", function() { return DomRenderer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "COMPONENT_VARIABLE", function() { return COMPONENT_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(exports, "HOST_ATTR", function() { return HOST_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CONTENT_ATTR", function() { return CONTENT_ATTR; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};








var NAMESPACE_URIS = {
    'xlink': 'http://www.w3.org/1999/xlink',
    'svg': 'http://www.w3.org/2000/svg',
    'xhtml': 'http://www.w3.org/1999/xhtml'
};
var TEMPLATE_COMMENT_TEXT = 'template bindings={}';
var TEMPLATE_BINDINGS_EXP = /^template bindings=(.*)$/;
var DomRootRenderer = (function () {
    function DomRootRenderer(document, eventManager, sharedStylesHost, animationDriver) {
        this.document = document;
        this.eventManager = eventManager;
        this.sharedStylesHost = sharedStylesHost;
        this.animationDriver = animationDriver;
        this.registeredComponents = new Map();
    }
    DomRootRenderer.prototype.renderComponent = function (componentProto) {
        var renderer = this.registeredComponents.get(componentProto.id);
        if (!renderer) {
            renderer = new DomRenderer(this, componentProto, this.animationDriver);
            this.registeredComponents.set(componentProto.id, renderer);
        }
        return renderer;
    };
    return DomRootRenderer;
}());
var DomRootRenderer_ = (function (_super) {
    __extends(DomRootRenderer_, _super);
    function DomRootRenderer_(_document, _eventManager, sharedStylesHost, animationDriver) {
        _super.call(this, _document, _eventManager, sharedStylesHost, animationDriver);
    }
    DomRootRenderer_.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DomRootRenderer_.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_4__dom_tokens__["DOCUMENT"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_5__events_event_manager__["EventManager"], },
        { type: __WEBPACK_IMPORTED_MODULE_6__shared_styles_host__["DomSharedStylesHost"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__animation_driver__["AnimationDriver"], },
    ];
    return DomRootRenderer_;
}(DomRootRenderer));
var DomRenderer = (function () {
    function DomRenderer(_rootRenderer, componentProto, _animationDriver) {
        this._rootRenderer = _rootRenderer;
        this.componentProto = componentProto;
        this._animationDriver = _animationDriver;
        this._styles = _flattenStyles(componentProto.id, componentProto.styles, []);
        if (componentProto.encapsulation !== __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Native) {
            this._rootRenderer.sharedStylesHost.addStyles(this._styles);
        }
        if (this.componentProto.encapsulation === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated) {
            this._contentAttr = _shimContentAttribute(componentProto.id);
            this._hostAttr = _shimHostAttribute(componentProto.id);
        }
        else {
            this._contentAttr = null;
            this._hostAttr = null;
        }
    }
    DomRenderer.prototype.selectRootElement = function (selectorOrNode, debugInfo) {
        var el;
        if (typeof selectorOrNode === 'string') {
            el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().querySelector(this._rootRenderer.document, selectorOrNode);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(el)) {
                throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
            }
        }
        else {
            el = selectorOrNode;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().clearNodes(el);
        return el;
    };
    DomRenderer.prototype.createElement = function (parent, name, debugInfo) {
        var nsAndName = splitNamespace(name);
        var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(nsAndName[0]) ?
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createElementNS(NAMESPACE_URIS[nsAndName[0]], nsAndName[1]) :
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createElement(nsAndName[1]);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._contentAttr)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setAttribute(el, this._contentAttr, '');
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parent)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(parent, el);
        }
        return el;
    };
    DomRenderer.prototype.createViewRoot = function (hostElement) {
        var nodesParent;
        if (this.componentProto.encapsulation === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Native) {
            nodesParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createShadowRoot(hostElement);
            this._rootRenderer.sharedStylesHost.addHost(nodesParent);
            for (var i = 0; i < this._styles.length; i++) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(nodesParent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createStyleElement(this._styles[i]));
            }
        }
        else {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._hostAttr)) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setAttribute(hostElement, this._hostAttr, '');
            }
            nodesParent = hostElement;
        }
        return nodesParent;
    };
    DomRenderer.prototype.createTemplateAnchor = function (parentElement, debugInfo) {
        var comment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createComment(TEMPLATE_COMMENT_TEXT);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parentElement)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(parentElement, comment);
        }
        return comment;
    };
    DomRenderer.prototype.createText = function (parentElement, value, debugInfo) {
        var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().createTextNode(value);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parentElement)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(parentElement, node);
        }
        return node;
    };
    DomRenderer.prototype.projectNodes = function (parentElement, nodes) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(parentElement))
            return;
        appendNodes(parentElement, nodes);
    };
    DomRenderer.prototype.attachViewAfter = function (node, viewRootNodes) { moveNodesAfterSibling(node, viewRootNodes); };
    DomRenderer.prototype.detachView = function (viewRootNodes) {
        for (var i = 0; i < viewRootNodes.length; i++) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().remove(viewRootNodes[i]);
        }
    };
    DomRenderer.prototype.destroyView = function (hostElement, viewAllNodes) {
        if (this.componentProto.encapsulation === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Native && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(hostElement)) {
            this._rootRenderer.sharedStylesHost.removeHost(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().getShadowRoot(hostElement));
        }
    };
    DomRenderer.prototype.listen = function (renderElement, name, callback) {
        return this._rootRenderer.eventManager.addEventListener(renderElement, name, decoratePreventDefault(callback));
    };
    DomRenderer.prototype.listenGlobal = function (target, name, callback) {
        return this._rootRenderer.eventManager.addGlobalEventListener(target, name, decoratePreventDefault(callback));
    };
    DomRenderer.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setProperty(renderElement, propertyName, propertyValue);
    };
    DomRenderer.prototype.setElementAttribute = function (renderElement, attributeName, attributeValue) {
        var attrNs;
        var nsAndName = splitNamespace(attributeName);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(nsAndName[0])) {
            attributeName = nsAndName[0] + ':' + nsAndName[1];
            attrNs = NAMESPACE_URIS[nsAndName[0]];
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(attributeValue)) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(attrNs)) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setAttributeNS(renderElement, attrNs, attributeName, attributeValue);
            }
            else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setAttribute(renderElement, attributeName, attributeValue);
            }
        }
        else {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(attrNs)) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().removeAttributeNS(renderElement, attrNs, nsAndName[1]);
            }
            else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().removeAttribute(renderElement, attributeName);
            }
        }
    };
    DomRenderer.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) {
        var dashCasedPropertyName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* camelCaseToDashCase */])(propertyName);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().isCommentNode(renderElement)) {
            var existingBindings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().getText(renderElement).replace(/\n/g, '').match(TEMPLATE_BINDINGS_EXP);
            var parsedBindings = JSON.parse(existingBindings[1]);
            parsedBindings[dashCasedPropertyName] = propertyValue;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setText(renderElement, TEMPLATE_COMMENT_TEXT.replace('{}', JSON.stringify(parsedBindings, null, 2)));
        }
        else {
            this.setElementAttribute(renderElement, propertyName, propertyValue);
        }
    };
    DomRenderer.prototype.setElementClass = function (renderElement, className, isAdd) {
        if (isAdd) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().addClass(renderElement, className);
        }
        else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().removeClass(renderElement, className);
        }
    };
    DomRenderer.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(styleValue)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setStyle(renderElement, styleName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(styleValue));
        }
        else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().removeStyle(renderElement, styleName);
        }
    };
    DomRenderer.prototype.invokeElementMethod = function (renderElement, methodName, args) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().invoke(renderElement, methodName, args);
    };
    DomRenderer.prototype.setText = function (renderNode, text) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().setText(renderNode, text); };
    DomRenderer.prototype.animate = function (element, startingStyles, keyframes, duration, delay, easing) {
        return this._animationDriver.animate(element, startingStyles, keyframes, duration, delay, easing);
    };
    return DomRenderer;
}());
function moveNodesAfterSibling(sibling /** TODO #9100 */, nodes /** TODO #9100 */) {
    var parent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().parentElement(sibling);
    if (nodes.length > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(parent)) {
        var nextSibling = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().nextSibling(sibling);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(nextSibling)) {
            for (var i = 0; i < nodes.length; i++) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().insertBefore(nextSibling, nodes[i]);
            }
        }
        else {
            for (var i = 0; i < nodes.length; i++) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(parent, nodes[i]);
            }
        }
    }
}
function appendNodes(parent /** TODO #9100 */, nodes /** TODO #9100 */) {
    for (var i = 0; i < nodes.length; i++) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().appendChild(parent, nodes[i]);
    }
}
function decoratePreventDefault(eventHandler) {
    return function (event /** TODO #9100 */) {
        var allowDefaultBehavior = eventHandler(event);
        if (allowDefaultBehavior === false) {
            // TODO(tbosch): move preventDefault into event plugins...
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().preventDefault(event);
        }
    };
}
var COMPONENT_REGEX = /%COMP%/g;
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
function _shimContentAttribute(componentShortId) {
    return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
function _shimHostAttribute(componentShortId) {
    return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
function _flattenStyles(compId, styles, target) {
    for (var i = 0; i < styles.length; i++) {
        var style = styles[i];
        if (Array.isArray(style)) {
            _flattenStyles(compId, style, target);
        }
        else {
            style = style.replace(COMPONENT_REGEX, compId);
            target.push(style);
        }
    }
    return target;
}
var NS_PREFIX_RE = /^:([^:]+):(.+)$/;
function splitNamespace(name) {
    if (name[0] != ':') {
        return [null, name];
    }
    var match = name.match(NS_PREFIX_RE);
    return [match[1], match[2]];
}
//# sourceMappingURL=dom_renderer.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_manager__ = __webpack_require__(84);
/* harmony export (binding) */ __webpack_require__.d(exports, "DomEventsPlugin", function() { return DomEventsPlugin; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var DomEventsPlugin = (function (_super) {
    __extends(DomEventsPlugin, _super);
    function DomEventsPlugin() {
        _super.apply(this, arguments);
    }
    // This plugin should come last in the list of plugins, because it accepts all
    // events.
    DomEventsPlugin.prototype.supports = function (eventName) { return true; };
    DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var zone = this.manager.getZone();
        var outsideHandler = function (event /** TODO #9100 */) { return zone.runGuarded(function () { return handler(event); }); };
        return this.manager.getZone().runOutsideAngular(function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_adapter__["getDOM"])().onAndCancel(element, eventName, outsideHandler); });
    };
    DomEventsPlugin.prototype.addGlobalEventListener = function (target, eventName, handler) {
        var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_adapter__["getDOM"])().getGlobalEventTarget(target);
        var zone = this.manager.getZone();
        var outsideHandler = function (event /** TODO #9100 */) { return zone.runGuarded(function () { return handler(event); }); };
        return this.manager.getZone().runOutsideAngular(function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_adapter__["getDOM"])().onAndCancel(element, eventName, outsideHandler); });
    };
    DomEventsPlugin.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DomEventsPlugin.ctorParameters = [];
    return DomEventsPlugin;
}(__WEBPACK_IMPORTED_MODULE_2__event_manager__["EventManagerPlugin"]));
//# sourceMappingURL=dom_events.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_manager__ = __webpack_require__(84);
/* harmony export (binding) */ __webpack_require__.d(exports, "KeyEventsPlugin", function() { return KeyEventsPlugin; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





var modifierKeys = ['alt', 'control', 'meta', 'shift'];
var modifierKeyGetters = {
    'alt': function (event) { return event.altKey; },
    'control': function (event) { return event.ctrlKey; },
    'meta': function (event) { return event.metaKey; },
    'shift': function (event) { return event.shiftKey; }
};
/**
 * @experimental
 */
var KeyEventsPlugin = (function (_super) {
    __extends(KeyEventsPlugin, _super);
    function KeyEventsPlugin() {
        _super.call(this);
    }
    KeyEventsPlugin.prototype.supports = function (eventName) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(KeyEventsPlugin.parseEventName(eventName));
    };
    KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var parsedEvent = KeyEventsPlugin.parseEventName(eventName);
        var outsideHandler = KeyEventsPlugin.eventCallback(element, parsedEvent['fullKey'], handler, this.manager.getZone());
        return this.manager.getZone().runOutsideAngular(function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
        });
    };
    KeyEventsPlugin.parseEventName = function (eventName) {
        var parts = eventName.toLowerCase().split('.');
        var domEventName = parts.shift();
        if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
            return null;
        }
        var key = KeyEventsPlugin._normalizeKey(parts.pop());
        var fullKey = '';
        modifierKeys.forEach(function (modifierName) {
            if (parts.indexOf(modifierName) > -1) {
                __WEBPACK_IMPORTED_MODULE_1__facade_collection__["e" /* ListWrapper */].remove(parts, modifierName);
                fullKey += modifierName + '.';
            }
        });
        fullKey += key;
        if (parts.length != 0 || key.length === 0) {
            // returning null instead of throwing to let another plugin process the event
            return null;
        }
        var result = {};
        result['domEventName'] = domEventName;
        result['fullKey'] = fullKey;
        return result;
    };
    KeyEventsPlugin.getEventFullKey = function (event) {
        var fullKey = '';
        var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_adapter__["getDOM"])().getEventKey(event);
        key = key.toLowerCase();
        if (key === ' ') {
            key = 'space'; // for readability
        }
        else if (key === '.') {
            key = 'dot'; // because '.' is used as a separator in event names
        }
        modifierKeys.forEach(function (modifierName) {
            if (modifierName != key) {
                var modifierGetter = modifierKeyGetters[modifierName];
                if (modifierGetter(event)) {
                    fullKey += modifierName + '.';
                }
            }
        });
        fullKey += key;
        return fullKey;
    };
    KeyEventsPlugin.eventCallback = function (element, fullKey, handler, zone) {
        return function (event /** TODO #9100 */) {
            if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
                zone.runGuarded(function () { return handler(event); });
            }
        };
    };
    /** @internal */
    KeyEventsPlugin._normalizeKey = function (keyName) {
        // TODO: switch to a StringMap if the mapping grows too much
        switch (keyName) {
            case 'esc':
                return 'escape';
            default:
                return keyName;
        }
    };
    KeyEventsPlugin.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    KeyEventsPlugin.ctorParameters = [];
    return KeyEventsPlugin;
}(__WEBPACK_IMPORTED_MODULE_4__event_manager__["EventManagerPlugin"]));
//# sourceMappingURL=key_events.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_sanitizer__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_sanitizer__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_sanitizer__ = __webpack_require__(212);
/* harmony export (binding) */ __webpack_require__.d(exports, "DomSanitizer", function() { return DomSanitizer; });
/* harmony export (binding) */ __webpack_require__.d(exports, "DomSanitizerImpl", function() { return DomSanitizerImpl; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/* harmony reexport (binding) */ __webpack_require__.d(exports, "SecurityContext", function() { return __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"]; });

/**
 * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
 * values to be safe to use in the different DOM contexts.
 *
 * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
 * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
 * the website.
 *
 * In specific situations, it might be necessary to disable sanitization, for example if the
 * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
 * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
 * methods, and then binding to that value from the template.
 *
 * These situations should be very rare, and extraordinary care must be taken to avoid creating a
 * Cross Site Scripting (XSS) security bug!
 *
 * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
 * close as possible to the source of the value, to make it easy to verify no security bug is
 * created by its use.
 *
 * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
 * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
 * code. The sanitizer leaves safe values intact.
 *
 * @security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
 * sanitization for the value passed in. Carefully check and audit all values and code paths going
 * into this call. Make sure any user data is appropriately escaped for this security context.
 * For more detail, see the [Security Guide](http://g.co/ng/security).
 *
 * @stable
 */
var DomSanitizer = (function () {
    function DomSanitizer() {
    }
    return DomSanitizer;
}());
var DomSanitizerImpl = (function (_super) {
    __extends(DomSanitizerImpl, _super);
    function DomSanitizerImpl() {
        _super.apply(this, arguments);
    }
    DomSanitizerImpl.prototype.sanitize = function (ctx, value) {
        if (value == null)
            return null;
        switch (ctx) {
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].NONE:
                return value;
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].HTML:
                if (value instanceof SafeHtmlImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'HTML');
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__html_sanitizer__["a" /* sanitizeHtml */])(String(value));
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].STYLE:
                if (value instanceof SafeStyleImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Style');
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__style_sanitizer__["a" /* sanitizeStyle */])(value);
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].SCRIPT:
                if (value instanceof SafeScriptImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Script');
                throw new Error('unsafe value used in a script context');
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].URL:
                if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                    // Allow resource URLs in URL contexts, they are strictly more trusted.
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'URL');
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__url_sanitizer__["a" /* sanitizeUrl */])(String(value));
            case __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].RESOURCE_URL:
                if (value instanceof SafeResourceUrlImpl) {
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'ResourceURL');
                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
            default:
                throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
        }
    };
    DomSanitizerImpl.prototype.checkNotSafeValue = function (value, expectedType) {
        if (value instanceof SafeValueImpl) {
            throw new Error(("Required a safe " + expectedType + ", got a " + value.getTypeName() + " ") +
                "(see http://g.co/ng/security#xss)");
        }
    };
    DomSanitizerImpl.prototype.bypassSecurityTrustHtml = function (value) { return new SafeHtmlImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustStyle = function (value) { return new SafeStyleImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustScript = function (value) { return new SafeScriptImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustUrl = function (value) { return new SafeUrlImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = function (value) {
        return new SafeResourceUrlImpl(value);
    };
    DomSanitizerImpl.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DomSanitizerImpl.ctorParameters = [];
    return DomSanitizerImpl;
}(DomSanitizer));
var SafeValueImpl = (function () {
    function SafeValueImpl(changingThisBreaksApplicationSecurity) {
        this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
        // empty
    }
    SafeValueImpl.prototype.toString = function () {
        return ("SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity) +
            " (see http://g.co/ng/security#xss)";
    };
    return SafeValueImpl;
}());
var SafeHtmlImpl = (function (_super) {
    __extends(SafeHtmlImpl, _super);
    function SafeHtmlImpl() {
        _super.apply(this, arguments);
    }
    SafeHtmlImpl.prototype.getTypeName = function () { return 'HTML'; };
    return SafeHtmlImpl;
}(SafeValueImpl));
var SafeStyleImpl = (function (_super) {
    __extends(SafeStyleImpl, _super);
    function SafeStyleImpl() {
        _super.apply(this, arguments);
    }
    SafeStyleImpl.prototype.getTypeName = function () { return 'Style'; };
    return SafeStyleImpl;
}(SafeValueImpl));
var SafeScriptImpl = (function (_super) {
    __extends(SafeScriptImpl, _super);
    function SafeScriptImpl() {
        _super.apply(this, arguments);
    }
    SafeScriptImpl.prototype.getTypeName = function () { return 'Script'; };
    return SafeScriptImpl;
}(SafeValueImpl));
var SafeUrlImpl = (function (_super) {
    __extends(SafeUrlImpl, _super);
    function SafeUrlImpl() {
        _super.apply(this, arguments);
    }
    SafeUrlImpl.prototype.getTypeName = function () { return 'URL'; };
    return SafeUrlImpl;
}(SafeValueImpl));
var SafeResourceUrlImpl = (function (_super) {
    __extends(SafeResourceUrlImpl, _super);
    function SafeResourceUrlImpl() {
        _super.apply(this, arguments);
    }
    SafeResourceUrlImpl.prototype.getTypeName = function () { return 'ResourceURL'; };
    return SafeResourceUrlImpl;
}(SafeValueImpl));
//# sourceMappingURL=dom_sanitization_service.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__ = __webpack_require__(34);
/* harmony export (immutable) */ exports["a"] = sanitizeUrl;
/* harmony export (immutable) */ exports["b"] = sanitizeSrcset;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * This regular expression matches a subset of URLs that will not cause script
 * execution if used in URL context within a HTML document. Specifically, this
 * regular expression matches if (comment from here on and regex copied from
 * Soy's EscapingConventions):
 * (1) Either a protocol in a whitelist (http, https, mailto or ftp).
 * (2) or no protocol.  A protocol must be followed by a colon. The below
 *     allows that by allowing colons only after one of the characters [/?#].
 *     A colon after a hash (#) must be in the fragment.
 *     Otherwise, a colon after a (?) must be in a query.
 *     Otherwise, a colon after a single solidus (/) must be in a path.
 *     Otherwise, a colon after a double solidus (//) must be in the authority
 *     (before port).
 *
 * The pattern disallows &, used in HTML entity declarations before
 * one of the characters in [/?#]. This disallows HTML entities used in the
 * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
 * It also disallows HTML entities in the first path part of a relative path,
 * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
 * that. More importantly, it disallows masking of a colon,
 * e.g. "javascript&#58;...".
 *
 * This regular expression was taken from the Closure sanitization library.
 */
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
/* A pattern that matches safe srcset values */
var SAFE_SRCSET_PATTERN = /^(?:(?:https?|file):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. Only matches image, video and audio types. */
var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
function sanitizeUrl(url) {
    url = String(url);
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
        return url;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().log("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
    }
    return 'unsafe:' + url;
}
function sanitizeSrcset(srcset) {
    srcset = String(srcset);
    return srcset.split(',').map(function (srcset) { return sanitizeUrl(srcset.trim()); }).join(', ');
}
//# sourceMappingURL=url_sanitizer.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_router_link__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_router_link_active__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_router_outlet__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_config_loader__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_outlet_map__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_preloader__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_state__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_collection__ = __webpack_require__(63);
/* harmony export (binding) */ __webpack_require__.d(exports, "ROUTER_CONFIGURATION", function() { return ROUTER_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ROUTER_FORROOT_GUARD", function() { return ROUTER_FORROOT_GUARD; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ROUTER_PROVIDERS", function() { return ROUTER_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterModule", function() { return RouterModule; });
/* harmony export (immutable) */ exports["provideLocationStrategy"] = provideLocationStrategy;
/* harmony export (immutable) */ exports["provideForRootGuard"] = provideForRootGuard;
/* harmony export (immutable) */ exports["provideRoutes"] = provideRoutes;
/* harmony export (immutable) */ exports["setupRouter"] = setupRouter;
/* harmony export (immutable) */ exports["rootRoute"] = rootRoute;
/* harmony export (immutable) */ exports["initialRouterNavigation"] = initialRouterNavigation;
/* harmony export (immutable) */ exports["provideRouterInitializer"] = provideRouterInitializer;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */












/**
 * @whatItDoes Contains a list of directives
 * @stable
 */
var ROUTER_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_4__directives_router_outlet__["RouterOutlet"], __WEBPACK_IMPORTED_MODULE_2__directives_router_link__["RouterLink"], __WEBPACK_IMPORTED_MODULE_2__directives_router_link__["RouterLinkWithHref"], __WEBPACK_IMPORTED_MODULE_3__directives_router_link_active__["a" /* RouterLinkActive */]];
/**
 * @whatItDoes Is used in DI to configure the router.
 * @stable
 */
var ROUTER_CONFIGURATION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["OpaqueToken"]('ROUTER_CONFIGURATION');
/**
 * @docsNotRequired
 */
var ROUTER_FORROOT_GUARD = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["OpaqueToken"]('ROUTER_FORROOT_GUARD');
var pathLocationStrategy = {
    provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"],
    useClass: __WEBPACK_IMPORTED_MODULE_0__angular_common__["PathLocationStrategy"]
};
var hashLocationStrategy = {
    provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"],
    useClass: __WEBPACK_IMPORTED_MODULE_0__angular_common__["HashLocationStrategy"]
};
var ROUTER_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"], { provide: __WEBPACK_IMPORTED_MODULE_10__url_tree__["UrlSerializer"], useClass: __WEBPACK_IMPORTED_MODULE_10__url_tree__["DefaultUrlSerializer"] }, {
        provide: __WEBPACK_IMPORTED_MODULE_5__router__["Router"],
        useFactory: setupRouter,
        deps: [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], __WEBPACK_IMPORTED_MODULE_10__url_tree__["UrlSerializer"], __WEBPACK_IMPORTED_MODULE_7__router_outlet_map__["RouterOutletMap"], __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Compiler"], __WEBPACK_IMPORTED_MODULE_6__router_config_loader__["ROUTES"], ROUTER_CONFIGURATION
        ]
    },
    __WEBPACK_IMPORTED_MODULE_7__router_outlet_map__["RouterOutletMap"], { provide: __WEBPACK_IMPORTED_MODULE_9__router_state__["ActivatedRoute"], useFactory: rootRoute, deps: [__WEBPACK_IMPORTED_MODULE_5__router__["Router"]] },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], useClass: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SystemJsNgModuleLoader"] }, __WEBPACK_IMPORTED_MODULE_8__router_preloader__["RouterPreloader"], __WEBPACK_IMPORTED_MODULE_8__router_preloader__["NoPreloading"],
    __WEBPACK_IMPORTED_MODULE_8__router_preloader__["PreloadAllModules"], { provide: ROUTER_CONFIGURATION, useValue: { enableTracing: false } }
];
/**
 * @whatItDoes Adds router directives and providers.
 *
 * @howToUse
 *
 * RouterModule can be imported multiple times: once per lazily-loaded bundle.
 * Since the router deals with a global shared resource--location, we cannot have
 * more than one router service active.
 *
 * That is why there are two ways to create the module: `RouterModule.forRoot` and
 * `RouterModule.forChild`.
 *
 * * `forRoot` creates a module that contains all the directives, the given routes, and the router
 * service itself.
 * * `forChild` creates a module that contains all the directives and the given routes, but does not
 * include
 * the router service.
 *
 * When registered at the root, the module should be used as follows
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forRoot(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * For submodules and lazy loaded submodules the module should be used as follows:
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forChild(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * @description
 *
 * Managing state transitions is one of the hardest parts of building applications. This is
 * especially true on the web, where you also need to ensure that the state is reflected in the URL.
 * In addition, we often want to split applications into multiple bundles and load them on demand.
 * Doing this transparently is not trivial.
 *
 * The Angular 2 router solves these problems. Using the router, you can declaratively specify
 * application states, manage state transitions while taking care of the URL, and load bundles on
 * demand.
 *
 * [Read this developer guide](https://angular.io/docs/ts/latest/guide/router.html) to get an
 * overview of how the router should be used.
 *
 * @stable
 */
var RouterModule = (function () {
    function RouterModule(guard) {
    }
    /**
     * Creates a module with all the router providers and directives. It also optionally sets up an
     * application listener to perform an initial navigation.
     *
     * Options:
     * * `enableTracing` makes the router log all its internal events to the console.
     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
     * API.
     * * `initialNavigation` disables the initial navigation.
     * * `errorHandler` provides a custom error handler.
     */
    RouterModule.forRoot = function (routes, config) {
        return {
            ngModule: RouterModule,
            providers: [
                ROUTER_PROVIDERS, provideRoutes(routes), {
                    provide: ROUTER_FORROOT_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [[__WEBPACK_IMPORTED_MODULE_5__router__["Router"], new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"]()]]
                },
                { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} }, {
                    provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"],
                    useFactory: provideLocationStrategy,
                    deps: [
                        __WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"], [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_0__angular_common__["APP_BASE_HREF"]), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()], ROUTER_CONFIGURATION
                    ]
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_8__router_preloader__["PreloadingStrategy"],
                    useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
                        __WEBPACK_IMPORTED_MODULE_8__router_preloader__["NoPreloading"]
                },
                provideRouterInitializer()
            ]
        };
    };
    /**
     * Creates a module with all the router directives and a provider registering routes.
     */
    RouterModule.forChild = function (routes) {
        return { ngModule: RouterModule, providers: [provideRoutes(routes)] };
    };
    RouterModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{ declarations: ROUTER_DIRECTIVES, exports: ROUTER_DIRECTIVES },] },
    ];
    /** @nocollapse */
    RouterModule.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [ROUTER_FORROOT_GUARD,] },] },
    ];
    return RouterModule;
}());
function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
    if (options === void 0) { options = {}; }
    return options.useHash ? new __WEBPACK_IMPORTED_MODULE_0__angular_common__["HashLocationStrategy"](platformLocationStrategy, baseHref) :
        new __WEBPACK_IMPORTED_MODULE_0__angular_common__["PathLocationStrategy"](platformLocationStrategy, baseHref);
}
function provideForRootGuard(router) {
    if (router) {
        throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
    }
    return 'guarded';
}
/**
 * @whatItDoes Registers routes.
 *
 * @howToUse
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forChild(ROUTES)],
 *   providers: [provideRoutes(EXTRA_ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * @stable
 */
function provideRoutes(routes) {
    return [
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], multi: true, useValue: routes },
        { provide: __WEBPACK_IMPORTED_MODULE_6__router_config_loader__["ROUTES"], multi: true, useValue: routes }
    ];
}
function setupRouter(ref, urlSerializer, outletMap, location, injector, loader, compiler, config, opts) {
    if (opts === void 0) { opts = {}; }
    var r = new __WEBPACK_IMPORTED_MODULE_5__router__["Router"](null, urlSerializer, outletMap, location, injector, loader, compiler, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_collection__["a" /* flatten */])(config));
    if (opts.errorHandler) {
        r.errorHandler = opts.errorHandler;
    }
    if (opts.enableTracing) {
        r.events.subscribe(function (e) {
            console.group("Router Event: " + e.constructor.name);
            console.log(e.toString());
            console.log(e);
            console.groupEnd();
        });
    }
    return r;
}
function rootRoute(router) {
    return router.routerState.root;
}
function initialRouterNavigation(router, ref, preloader, opts) {
    return function () {
        router.resetRootComponentType(ref.componentTypes[0]);
        preloader.setUpPreloading();
        if (opts.initialNavigation === false) {
            router.setUpLocationChangeListener();
        }
        else {
            router.initialNavigation();
        }
    };
}
function provideRouterInitializer() {
    return {
        provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_BOOTSTRAP_LISTENER"],
        multi: true,
        useFactory: initialRouterNavigation,
        deps: [__WEBPACK_IMPORTED_MODULE_5__router__["Router"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], __WEBPACK_IMPORTED_MODULE_8__router_preloader__["RouterPreloader"], ROUTER_CONFIGURATION]
    };
}
//# sourceMappingURL=router_module.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_config_loader__ = __webpack_require__(94);
/* harmony export (binding) */ __webpack_require__.d(exports, "PreloadingStrategy", function() { return PreloadingStrategy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PreloadAllModules", function() { return PreloadAllModules; });
/* harmony export (binding) */ __webpack_require__.d(exports, "NoPreloading", function() { return NoPreloading; });
/* harmony export (binding) */ __webpack_require__.d(exports, "RouterPreloader", function() { return RouterPreloader; });
/**
*@license
*Copyright Google Inc. All Rights Reserved.
*
*Use of this source code is governed by an MIT-style license that can be
*found in the LICENSE file at https://angular.io/license
*/










/**
 * @whatItDoes Provides a preloading strategy.
 *
 * @experimental
 */
var PreloadingStrategy = (function () {
    function PreloadingStrategy() {
    }
    return PreloadingStrategy;
}());
/**
 * @whatItDoes Provides a preloading strategy that preloads all modules as quicky as possible.
 *
 * @howToUse
 *
 * ```
 * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
 * ```
 *
 * @experimental
 */
var PreloadAllModules = (function () {
    function PreloadAllModules() {
    }
    PreloadAllModules.prototype.preload = function (route, fn) {
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(fn(), function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null); });
    };
    return PreloadAllModules;
}());
/**
 * @whatItDoes Provides a preloading strategy that does not preload any modules.
 *
 * @description
 *
 * This strategy is enabled by default.
 *
 * @experimental
 */
var NoPreloading = (function () {
    function NoPreloading() {
    }
    NoPreloading.prototype.preload = function (route, fn) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null); };
    return NoPreloading;
}());
/**
 * The preloader optimistically loads all router configurations to
 * make navigations into lazily-loaded sections of the application faster.
 *
 * The preloader runs in the background. When the router bootstraps, the preloader
 * starts listening to all navigation events. After every such event, the preloader
 * will check if any configurations can be loaded lazily.
 *
 * If a route is protected by `canLoad` guards, the preloaded will not load it.
 */
var RouterPreloader = (function () {
    function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
        this.router = router;
        this.injector = injector;
        this.preloadingStrategy = preloadingStrategy;
        this.loader = new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["RouterConfigLoader"](moduleLoader, compiler);
    }
    ;
    RouterPreloader.prototype.setUpPreloading = function () {
        var _this = this;
        var navigations = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_filter__["filter"].call(this.router.events, function (e) { return e instanceof __WEBPACK_IMPORTED_MODULE_8__router__["NavigationEnd"]; });
        this.subscription = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatMap__["concatMap"].call(navigations, function () { return _this.preload(); }).subscribe(function (v) { });
    };
    RouterPreloader.prototype.preload = function () { return this.processRoutes(this.injector, this.router.config); };
    RouterPreloader.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterPreloader.prototype.processRoutes = function (injector, routes) {
        var res = [];
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var c = routes_1[_i];
            // we already have the config loaded, just recurce
            if (c.loadChildren && !c.canLoad && c._loadedConfig) {
                var childConfig = c._loadedConfig;
                res.push(this.processRoutes(childConfig.injector, childConfig.routes));
            }
            else if (c.loadChildren && !c.canLoad) {
                res.push(this.preloadConfig(injector, c));
            }
            else if (c.children) {
                res.push(this.processRoutes(injector, c.children));
            }
        }
        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_mergeAll__["mergeAll"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__["from"])(res));
    };
    RouterPreloader.prototype.preloadConfig = function (injector, route) {
        var _this = this;
        return this.preloadingStrategy.preload(route, function () {
            var loaded = _this.loader.load(injector, route.loadChildren);
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(loaded, function (config) {
                var c = route;
                c._loadedConfig = config;
                return _this.processRoutes(config.injector, config.routes);
            });
        });
    };
    RouterPreloader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RouterPreloader.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_8__router__["Router"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactoryLoader"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
        { type: PreloadingStrategy, },
    ];
    return RouterPreloader;
}());
//# sourceMappingURL=router_preloader.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Tree; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return TreeNode; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Tree = (function () {
    function Tree(root) {
        this._root = root;
    }
    Object.defineProperty(Tree.prototype, "root", {
        get: function () { return this._root.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * @internal
     */
    Tree.prototype.parent = function (t) {
        var p = this.pathFromRoot(t);
        return p.length > 1 ? p[p.length - 2] : null;
    };
    /**
     * @internal
     */
    Tree.prototype.children = function (t) {
        var n = findNode(t, this._root);
        return n ? n.children.map(function (t) { return t.value; }) : [];
    };
    /**
     * @internal
     */
    Tree.prototype.firstChild = function (t) {
        var n = findNode(t, this._root);
        return n && n.children.length > 0 ? n.children[0].value : null;
    };
    /**
     * @internal
     */
    Tree.prototype.siblings = function (t) {
        var p = findPath(t, this._root, []);
        if (p.length < 2)
            return [];
        var c = p[p.length - 2].children.map(function (c) { return c.value; });
        return c.filter(function (cc) { return cc !== t; });
    };
    /**
     * @internal
     */
    Tree.prototype.pathFromRoot = function (t) { return findPath(t, this._root, []).map(function (s) { return s.value; }); };
    return Tree;
}());
function findNode(expected, c) {
    if (expected === c.value)
        return c;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var r = findNode(expected, cc);
        if (r)
            return r;
    }
    return null;
}
function findPath(expected, c, collected) {
    collected.push(c);
    if (expected === c.value)
        return collected;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var cloned = collected.slice(0);
        var r = findPath(expected, cc, cloned);
        if (r.length > 0)
            return r;
    }
    return [];
}
var TreeNode = (function () {
    function TreeNode(value, children) {
        this.value = value;
        this.children = children;
    }
    TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
    return TreeNode;
}());
//# sourceMappingURL=tree.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(102);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgStyle = (function () {
    function Wrapper_NgStyle(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.NgStyle(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_NgStyle.prototype.check_ngStyle = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngStyle = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgStyle.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            this.context.ngDoCheck();
        }
        return changed;
    };
    Wrapper_NgStyle.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgStyle;
}());
exports.Wrapper_NgStyle = Wrapper_NgStyle;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(70);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgSelectOption = (function () {
    function Wrapper_NgSelectOption(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.NgSelectOption(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_NgSelectOption.prototype.check_ngValue = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngValue = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgSelectOption.prototype.check_value = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.value = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_NgSelectOption.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgSelectOption.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgSelectOption;
}());
exports.Wrapper_NgSelectOption = Wrapper_NgSelectOption;
var Wrapper_SelectControlValueAccessor = (function () {
    function Wrapper_SelectControlValueAccessor(p0, p1) {
        this.changed = false;
        this.context = new import0.SelectControlValueAccessor(p0, p1);
    }
    Wrapper_SelectControlValueAccessor.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_SelectControlValueAccessor.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SelectControlValueAccessor;
}());
exports.Wrapper_SelectControlValueAccessor = Wrapper_SelectControlValueAccessor;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(71);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_NgSelectMultipleOption = (function () {
    function Wrapper_NgSelectMultipleOption(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.NgSelectMultipleOption(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_NgSelectMultipleOption.prototype.check_ngValue = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.ngValue = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_NgSelectMultipleOption.prototype.check_value = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.value = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_NgSelectMultipleOption.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgSelectMultipleOption.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgSelectMultipleOption;
}());
exports.Wrapper_NgSelectMultipleOption = Wrapper_NgSelectMultipleOption;
var Wrapper_SelectMultipleControlValueAccessor = (function () {
    function Wrapper_SelectMultipleControlValueAccessor(p0, p1) {
        this.changed = false;
        this.context = new import0.SelectMultipleControlValueAccessor(p0, p1);
    }
    Wrapper_SelectMultipleControlValueAccessor.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_SelectMultipleControlValueAccessor.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SelectMultipleControlValueAccessor;
}());
exports.Wrapper_SelectMultipleControlValueAccessor = Wrapper_SelectMultipleControlValueAccessor;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(93);
var Wrapper_RouterOutlet = (function () {
    function Wrapper_RouterOutlet(p0, p1, p2, p3) {
        this.changed = false;
        this.context = new import0.RouterOutlet(p0, p1, p2, p3);
    }
    Wrapper_RouterOutlet.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_RouterOutlet.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_RouterOutlet;
}());
exports.Wrapper_RouterOutlet = Wrapper_RouterOutlet;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(95);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(11);
var import9 = __webpack_require__(10);
var import10 = __webpack_require__(22);
var import11 = __webpack_require__(14);
var import12 = __webpack_require__(19);
var import13 = __webpack_require__(24);
var import14 = __webpack_require__(20);
var import15 = __webpack_require__(21);
var import16 = __webpack_require__(31);
var import17 = __webpack_require__(78);
var import18 = __webpack_require__(40);
var import19 = __webpack_require__(18);
var import20 = __webpack_require__(57);
var Wrapper_PaginationComponent = (function () {
    function Wrapper_PaginationComponent() {
        this.changed = false;
        this.changes = {};
        this.context = new import0.PaginationComponent();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    Wrapper_PaginationComponent.prototype.check_previousText = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.previousText = currValue;
            this.changes['previousText'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_nextText = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.nextText = currValue;
            this.changes['nextText'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_firstText = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.firstText = currValue;
            this.changes['firstText'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_lastText = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.lastText = currValue;
            this.changes['lastText'] = new import1.SimpleChange(this._expr_3, currValue);
            this._expr_3 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_totalItems = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.totalItems = currValue;
            this.changes['totalItems'] = new import1.SimpleChange(this._expr_4, currValue);
            this._expr_4 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_currentPage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.currentPage = currValue;
            this.changes['currentPage'] = new import1.SimpleChange(this._expr_5, currValue);
            this._expr_5 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_pageSize = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_6, currValue))) {
            this.changed = true;
            this.context.pageSize = currValue;
            this.changes['pageSize'] = new import1.SimpleChange(this._expr_6, currValue);
            this._expr_6 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.check_offset = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_7, currValue))) {
            this.changed = true;
            this.context.offset = currValue;
            this.changes['offset'] = new import1.SimpleChange(this._expr_7, currValue);
            this._expr_7 = currValue;
        }
    };
    Wrapper_PaginationComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_PaginationComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_PaginationComponent;
}());
exports.Wrapper_PaginationComponent = Wrapper_PaginationComponent;
var renderType_PaginationComponent_Host = null;
var _View_PaginationComponent_Host0 = (function (_super) {
    __extends(_View_PaginationComponent_Host0, _super);
    function _View_PaginationComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent_Host0, renderType_PaginationComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_PaginationComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'ng-pagination', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_PaginationComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._PaginationComponent_0_4 = new Wrapper_PaginationComponent();
        this._appEl_0.initComponent(this._PaginationComponent_0_4.context, [], compView_0);
        compView_0.create(this._PaginationComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_PaginationComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.PaginationComponent) && (0 === requestNodeIndex))) {
            return this._PaginationComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_PaginationComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._PaginationComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._PaginationComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PaginationComponent_Host0;
}(import3.AppView));
function viewFactory_PaginationComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PaginationComponent_Host === null)) {
        (renderType_PaginationComponent_Host = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {}));
    }
    return new _View_PaginationComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.PaginationComponentNgFactory = new import9.ComponentFactory('ng-pagination', viewFactory_PaginationComponent_Host0, import0.PaginationComponent);
var styles_PaginationComponent = [];
var renderType_PaginationComponent = null;
var _View_PaginationComponent0 = (function (_super) {
    __extends(_View_PaginationComponent0, _super);
    function _View_PaginationComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent0, renderType_PaginationComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_PaginationComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._anchor_0);
        this._TemplateRef_0_5 = new import11.TemplateRef_(this._appEl_0, viewFactory_PaginationComponent1);
        this._NgIf_0_6 = new import10.Wrapper_NgIf(this._appEl_0.vcRef, this._TemplateRef_0_5);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n', null);
        this.init([], [
            this._anchor_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_PaginationComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import11.TemplateRef) && (0 === requestNodeIndex))) {
            return this._TemplateRef_0_5;
        }
        if (((token === import12.NgIf) && (0 === requestNodeIndex))) {
            return this._NgIf_0_6.context;
        }
        return notFoundResult;
    };
    _View_PaginationComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = (this.context.totalSize > 1);
        this._NgIf_0_6.check_ngIf(currVal_0_0_0, throwOnChange, false);
        this._NgIf_0_6.detectChangesInInputProps(this, this._anchor_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PaginationComponent0;
}(import3.AppView));
function viewFactory_PaginationComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PaginationComponent === null)) {
        (renderType_PaginationComponent = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, styles_PaginationComponent, {}));
    }
    return new _View_PaginationComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_PaginationComponent0 = viewFactory_PaginationComponent0;
var _View_PaginationComponent1 = (function (_super) {
    __extends(_View_PaginationComponent1, _super);
    function _View_PaginationComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent1, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_PaginationComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'pagination'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import11.TemplateRef_(this._appEl_2, viewFactory_PaginationComponent2);
        this._NgIf_2_6 = new import10.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_4 = new import5.AppElement(4, 0, this, this._anchor_4);
        this._TemplateRef_4_5 = new import11.TemplateRef_(this._appEl_4, viewFactory_PaginationComponent3);
        this._NgIf_4_6 = new import10.Wrapper_NgIf(this._appEl_4.vcRef, this._TemplateRef_4_5);
        this._text_5 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_6 = new import5.AppElement(6, 0, this, this._anchor_6);
        this._TemplateRef_6_5 = new import11.TemplateRef_(this._appEl_6, viewFactory_PaginationComponent4);
        this._NgFor_6_6 = new import13.Wrapper_NgFor(this._appEl_6.vcRef, this._TemplateRef_6_5, this.parentInjector.get(import14.IterableDiffers), this.parent.ref);
        this._text_7 = this.renderer.createText(this._el_0, '\n    \n    ', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_8 = new import5.AppElement(8, 0, this, this._anchor_8);
        this._TemplateRef_8_5 = new import11.TemplateRef_(this._appEl_8, viewFactory_PaginationComponent5);
        this._NgIf_8_6 = new import10.Wrapper_NgIf(this._appEl_8.vcRef, this._TemplateRef_8_5);
        this._text_9 = this.renderer.createText(this._el_0, '\n    \n    ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_10 = new import5.AppElement(10, 0, this, this._anchor_10);
        this._TemplateRef_10_5 = new import11.TemplateRef_(this._appEl_10, viewFactory_PaginationComponent6);
        this._NgIf_10_6 = new import10.Wrapper_NgIf(this._appEl_10.vcRef, this._TemplateRef_10_5);
        this._text_11 = this.renderer.createText(this._el_0, '\n \n', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3,
            this._anchor_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._anchor_10,
            this._text_11
        ], [], []);
        return null;
    };
    _View_PaginationComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import11.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import12.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        if (((token === import11.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import12.NgIf) && (4 === requestNodeIndex))) {
            return this._NgIf_4_6.context;
        }
        if (((token === import11.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import15.NgFor) && (6 === requestNodeIndex))) {
            return this._NgFor_6_6.context;
        }
        if (((token === import11.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import12.NgIf) && (8 === requestNodeIndex))) {
            return this._NgIf_8_6.context;
        }
        if (((token === import11.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import12.NgIf) && (10 === requestNodeIndex))) {
            return this._NgIf_10_6.context;
        }
        return notFoundResult;
    };
    _View_PaginationComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = (this.parent.context.previousItemValid && this.parent.context.firstText);
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        var currVal_4_0_0 = this.parent.context.previousItemValid;
        this._NgIf_4_6.check_ngIf(currVal_4_0_0, throwOnChange, false);
        this._NgIf_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        var currVal_6_0_0 = this.parent.context.pageList;
        this._NgFor_6_6.check_ngForOf(currVal_6_0_0, throwOnChange, false);
        this._NgFor_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_8_0_0 = this.parent.context.nextItemValid;
        this._NgIf_8_6.check_ngIf(currVal_8_0_0, throwOnChange, false);
        this._NgIf_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        var currVal_10_0_0 = (this.parent.context.nextItemValid && this.parent.context.lastText);
        this._NgIf_10_6.check_ngIf(currVal_10_0_0, throwOnChange, false);
        this._NgIf_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PaginationComponent1;
}(import3.AppView));
function viewFactory_PaginationComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_PaginationComponent2 = (function (_super) {
    __extends(_View_PaginationComponent2, _super);
    function _View_PaginationComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent2, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_PaginationComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'First', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_PaginationComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.parent.context.firstText;
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import16.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PaginationComponent2.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.firstPage() !== false);
        return (true && pd_0_0);
    };
    return _View_PaginationComponent2;
}(import3.AppView));
function viewFactory_PaginationComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_PaginationComponent3 = (function (_super) {
    __extends(_View_PaginationComponent3, _super);
    function _View_PaginationComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent3, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_PaginationComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '«', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_PaginationComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.parent.context.previousText;
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import16.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PaginationComponent3.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.previousPage(this.parent.parent.context.nextItem) !== false);
        return (true && pd_0_0);
    };
    return _View_PaginationComponent3;
}(import3.AppView));
function viewFactory_PaginationComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_PaginationComponent4 = (function (_super) {
    __extends(_View_PaginationComponent4, _super);
    function _View_PaginationComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent4, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_3 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_4 = import1.UNINITIALIZED;
    }
    _View_PaginationComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._NgClass_0_3 = new import17.Wrapper_NgClass(this.parent.parentInjector.get(import14.IterableDiffers), this.parent.parentInjector.get(import18.KeyValueDiffers), new import19.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_PaginationComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import20.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_PaginationComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._map_3((this.parent.parent.context.selectedPageNo == this.context.$implicit));
        this._NgClass_0_3.check_ngClass(currVal_0_0_0, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_4 = import2.interpolate(1, '', this.context.$implicit, '');
        if (import2.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PaginationComponent4.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.setCurrentPage(this.context.$implicit) !== false);
        return (true && pd_0_0);
    };
    return _View_PaginationComponent4;
}(import3.AppView));
function viewFactory_PaginationComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_PaginationComponent5 = (function (_super) {
    __extends(_View_PaginationComponent5, _super);
    function _View_PaginationComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent5, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_PaginationComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '»', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_PaginationComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.parent.context.nextText;
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import16.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PaginationComponent5.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.nextPage(this.parent.parent.context.nextItem) !== false);
        return (true && pd_0_0);
    };
    return _View_PaginationComponent5;
}(import3.AppView));
function viewFactory_PaginationComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_PaginationComponent6 = (function (_super) {
    __extends(_View_PaginationComponent6, _super);
    function _View_PaginationComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaginationComponent6, renderType_PaginationComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_PaginationComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Last', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_PaginationComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.parent.context.lastText;
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import16.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PaginationComponent6.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.lastPage() !== false);
        return (true && pd_0_0);
    };
    return _View_PaginationComponent6;
}(import3.AppView));
function viewFactory_PaginationComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_PaginationComponent6(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var AdminFooterComponent = (function () {
    function AdminFooterComponent() {
    }
    AdminFooterComponent = __decorate([
        core_1.Component({
            selector: 'admin-footer',
            template: __webpack_require__(471),
        }), 
        __metadata('design:paramtypes', [])
    ], AdminFooterComponent);
    return AdminFooterComponent;
}());
exports.AdminFooterComponent = AdminFooterComponent;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var config_service_1 = __webpack_require__(5);
var language_routing_component_1 = __webpack_require__(117);
var AdminHeaderComponent = (function () {
    // @Input() currentLanguage: string;
    // @Input() resourcePath: string;
    // @Input() lgRoutingCallback: Function;
    function AdminHeaderComponent(config) {
        this.config = config;
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', (typeof (_a = typeof language_routing_component_1.LanguageRoutingComponent !== 'undefined' && language_routing_component_1.LanguageRoutingComponent) === 'function' && _a) || Object)
    ], AdminHeaderComponent.prototype, "lgRouting", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], AdminHeaderComponent.prototype, "loggedInUser", void 0);
    AdminHeaderComponent = __decorate([
        core_1.Component({
            selector: 'admin-header',
            template: __webpack_require__(472),
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object])
    ], AdminHeaderComponent);
    return AdminHeaderComponent;
    var _a, _b;
}());
exports.AdminHeaderComponent = AdminHeaderComponent;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var utils_service_1 = __webpack_require__(2);
var AdminMenuComponent = (function () {
    function AdminMenuComponent(utils) {
        this.utils = utils;
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], AdminMenuComponent.prototype, "currentLanguage", void 0);
    AdminMenuComponent = __decorate([
        core_1.Component({
            selector: 'admin-menu',
            template: __webpack_require__(474)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _a) || Object])
    ], AdminMenuComponent);
    return AdminMenuComponent;
    var _a;
}());
exports.AdminMenuComponent = AdminMenuComponent;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var ng2_file_upload_1 = __webpack_require__(319);
var data_service_1 = __webpack_require__(116);
var ImageUploadComponent = (function () {
    function ImageUploadComponent(dataService) {
        this.dataService = dataService;
        this.uploaders = [];
        this.tempData = {}; // indexed by itemAlias for image display
        this.defaultImage = 'default.png';
    }
    ImageUploadComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Uploaders
        Object.keys(this.form.get(this.groupName).controls).forEach(function (alias) {
            _this.uploaders.push(new ng2_file_upload_1.FileUploader({ itemAlias: alias, url: _this.addApi, queueLimit: 1 }));
        });
        // Callbacks
        for (var _i = 0, _a = this.uploaders; _i < _a.length; _i++) {
            var uploader = _a[_i];
            uploader.onSuccessItem = (function (item, response, status, headers) {
                // response contains the uploaded file name
                _this.form.get([_this.groupName, item.alias]).patchValue(response);
            });
            uploader.onErrorItem = (function (item, response, status, headers) {
                console.error("[Upload]", response, status);
            });
            uploader.onCompleteItem = (function (item, response, status, headers) {
                console.log("[Upload]", response, status); // the url will be in the response
            });
        }
    };
    ImageUploadComponent.prototype.onRemoveImage = function (item) {
        if (this.form.get([this.groupName, item.alias]).value) {
            // delete from server
            this.dataService.delete(this.deleteDir, item._file.name);
            this.form.get([this.groupName, item.alias]).patchValue(null);
        }
        item.remove();
    };
    ImageUploadComponent.prototype.onChangeImageHandler = function (imgId, event) {
        var _this = this;
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            reader.onload = function (event) {
                _this.tempData[imgId] = event.target['result'];
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };
    __decorate([
        core_1.Input('reactiveForm'), 
        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
    ], ImageUploadComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ImageUploadComponent.prototype, "groupName", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ImageUploadComponent.prototype, "imagePath", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ImageUploadComponent.prototype, "addApi", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ImageUploadComponent.prototype, "deleteApi", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ImageUploadComponent.prototype, "deleteDir", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], ImageUploadComponent.prototype, "images", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], ImageUploadComponent.prototype, "thumbSize", void 0);
    ImageUploadComponent = __decorate([
        core_1.Component({
            selector: 'image-uploads',
            template: __webpack_require__(486),
            styles: ['.upload-tool {height: 20px; margin-top: -5px}',
                '.progress-cover {margin-right: 5px; float: left}',
                '.uploader {margin: 15px 10px 0px 0px}',
                '.clickLink {cursor: pointer}']
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _b) || Object])
    ], ImageUploadComponent);
    return ImageUploadComponent;
    var _a, _b;
}());
exports.ImageUploadComponent = ImageUploadComponent;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var MaskService = (function () {
    function MaskService() {
        this.brDate = '00/00/0000';
        this.brTime = '00:00:00';
        this.brDateTime = '00/00/0000 00:00:00';
        this.cep = '00000-000';
        this.brLandlinePhone = '(00) 0000-0000';
        this.brCellPhone = '(00) 00000-0000';
        this.usPhone = '(000) 000-0000';
        this.mixed = 'AAA 000-S0S';
        this.cpf = '000.000.000-00';
        this.cnpj = '00.000.000/0000-00';
        this.money = '000.000.000.000.000,00';
        this.money2 = "#.##0,00";
        this.ipAddress = '099.099.099.099';
        this.percent = '##0,00%';
    }
    MaskService.prototype.getBrDate = function () {
        return this.brDate;
    };
    MaskService.prototype.getBrTime = function () {
        return this.brTime;
    };
    MaskService.prototype.getBrDateTime = function () {
        return this.brDateTime;
    };
    MaskService.prototype.getCep = function () {
        return this.cep;
    };
    MaskService.prototype.getBrLandlinePhone = function () {
        return this.brLandlinePhone;
    };
    MaskService.prototype.getBrCellPhone = function () {
        return this.brCellPhone;
    };
    MaskService.prototype.getUsPhone = function () {
        return this.usPhone;
    };
    MaskService.prototype.getMixed = function () {
        return this.mixed;
    };
    MaskService.prototype.getCpf = function () {
        return this.cpf;
    };
    MaskService.prototype.getCnpj = function () {
        return this.cnpj;
    };
    MaskService.prototype.getMoney = function () {
        return this.money;
    };
    MaskService.prototype.getMoney2 = function () {
        return this.money2;
    };
    MaskService.prototype.getIpAddress = function () {
        return this.ipAddress;
    };
    MaskService.prototype.getPercent = function () {
        return this.percent;
    };
    MaskService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], MaskService);
    return MaskService;
}());
exports.MaskService = MaskService;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var content_service_1 = __webpack_require__(9);
var SearchResultsComponent = (function () {
    function SearchResultsComponent(config, contentService, utils, router, route) {
        this.config = config;
        this.contentService = contentService;
        this.utils = utils;
        this.router = router;
        this.route = route;
        this.onSearch = new core_1.EventEmitter();
        this.currentPage = 1;
    }
    SearchResultsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.parent.params.subscribe(function (params) {
            _this.currentLanguage = params['lg'];
        });
    };
    SearchResultsComponent.prototype.ngAfterContentChecked = function () {
        if (!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    };
    SearchResultsComponent.prototype.onStatusChange = function (status, item) {
        item.active = status;
        this.contentService.saveContent('record', 'update', item).then(function (res) {
            console.log("Content set to " + status);
        });
    };
    SearchResultsComponent.prototype.onPageChange = function (event) {
        this.currentPage = event.currentPage;
        var from = (this.currentPage - 1) * this.pageSize;
        // Callback log
        this.onSearch.emit('page ' + this.currentPage);
        // Nav
        var params = {};
        for (var qp in this.route.snapshot.queryParams) {
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from;
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    };
    ;
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchResultsComponent.prototype, "esContents", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchResultsComponent.prototype, "dbContents", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchResultsComponent.prototype, "pageSize", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], SearchResultsComponent.prototype, "onSearch", void 0);
    SearchResultsComponent = __decorate([
        core_1.Component({
            selector: 'admin-search-results',
            template: __webpack_require__(488)
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof content_service_1.ContentService !== 'undefined' && content_service_1.ContentService) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object])
    ], SearchResultsComponent);
    return SearchResultsComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.SearchResultsComponent = SearchResultsComponent;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
//, Directive, ElementRef, Renderer, ChangeDetectionStrategy, ViewEncapsulation
var core_1 = __webpack_require__(0);
var AppComponent = (function () {
    function AppComponent() {
    }
    AppComponent = __decorate([
        core_1.Component({
            selector: 'guern-cms',
            template: "<router-outlet></router-outlet> "
        }), 
        __metadata('design:paramtypes', [])
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(49);
var utils_service_1 = __webpack_require__(2);
var notification_service_1 = __webpack_require__(45);
var intl_service_1 = __webpack_require__(17);
var angular2_universal_1 = __webpack_require__(27);
// declare var isMobile: any;
var CartWidgetComponent = (function () {
    function CartWidgetComponent(notification, intl, utils, cartService, route, router) {
        this.notification = notification;
        this.intl = intl;
        this.utils = utils;
        this.cartService = cartService;
        this.route = route;
        this.router = router;
    }
    CartWidgetComponent.prototype.removeFromCart = function (id) {
        this.cartContentElement.css('visibility', 'hidden');
        this.cartService.remove(id);
        this.notification.notify(this.labels.NOTIFICATION[this.language]);
    };
    CartWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (angular2_universal_1.isBrowser) {
            this.cartContentElement = $(".cart-content");
            if (this.utils.isMobile()) {
                this.cartContentElement.addClass("force-hide");
            }
            this.router.events.subscribe(function (event) {
                if (event instanceof router_1.NavigationStart) {
                    _this.cartContentElement.css('visibility', 'hidden');
                }
            });
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], CartWidgetComponent.prototype, "language", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], CartWidgetComponent.prototype, "labels", void 0);
    CartWidgetComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(489),
            selector: 'cart-widget',
            providers: [notification_service_1.NotificationService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof notification_service_1.NotificationService !== 'undefined' && notification_service_1.NotificationService) === 'function' && _a) || Object, (typeof (_b = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _b) || Object, (typeof (_c = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _c) || Object, (typeof (_d = typeof cart_service_1.CartService !== 'undefined' && cart_service_1.CartService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
    ], CartWidgetComponent);
    return CartWidgetComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.CartWidgetComponent = CartWidgetComponent;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var angular2_universal_1 = __webpack_require__(27);
var core_2 = __webpack_require__(112);
var intl_service_1 = __webpack_require__(17);
var config_service_1 = __webpack_require__(5);
var utils_service_1 = __webpack_require__(2);
var CookieConsentComponent = (function () {
    function CookieConsentComponent(intl, config, utils, cookieService, renderer, el) {
        this.intl = intl;
        this.config = config;
        this.utils = utils;
        this.cookieService = cookieService;
        this.renderer = renderer;
        this.el = el;
        this.hasConsented = true;
        this.cookieName = 'cookie-consent';
    }
    CookieConsentComponent.prototype.ngOnInit = function () {
        // Check if policy has been accepted
        this.getConsent();
    };
    CookieConsentComponent.prototype.ngAfterViewInit = function () {
        if (angular2_universal_1.isBrowser && !this.hasConsented) {
            $.magnificPopup.open({ items: { src: '#' + this.cookieName }, type: 'inline' });
            $(".mfp-bg").addClass("mfp-black-bg");
        }
    };
    CookieConsentComponent.prototype.onConsent = function (answser) {
        if (angular2_universal_1.isBrowser) {
            this.hasConsented = true;
            this.cookieService.put(this.cookieName, answser, { expires: this.utils.dateNowPlusDays(this.config.data.APP.LANGUAGES.COOKIE_DAY_AGE) });
            $(".mfp-bg").removeClass("mfp-black-bg");
            $('#' + this.cookieName).magnificPopup('close');
        }
    };
    CookieConsentComponent.prototype.getConsent = function () {
        if (angular2_universal_1.isBrowser) {
            var cookie = this.cookieService.getObject(this.cookieName);
            if (cookie == undefined)
                this.hasConsented = false;
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], CookieConsentComponent.prototype, "language", void 0);
    CookieConsentComponent = __decorate([
        core_1.Component({
            selector: 'policy-checker',
            template: __webpack_require__(496)
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof intl_service_1.IntlService !== 'undefined' && intl_service_1.IntlService) === 'function' && _a) || Object, (typeof (_b = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _b) || Object, (typeof (_c = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _c) || Object, (typeof (_d = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _d) || Object, (typeof (_e = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _e) || Object, (typeof (_f = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _f) || Object])
    ], CookieConsentComponent);
    return CookieConsentComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.CookieConsentComponent = CookieConsentComponent;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var angular2_universal_1 = __webpack_require__(27);
var cart_service_1 = __webpack_require__(49);
var utils_service_1 = __webpack_require__(2);
var config_service_1 = __webpack_require__(5);
var PaymentPayPalExpressCheckoutComponent = (function () {
    function PaymentPayPalExpressCheckoutComponent(cartService, utils, configService) {
        this.cartService = cartService;
        this.utils = utils;
        this.configService = configService;
    }
    PaymentPayPalExpressCheckoutComponent.prototype.transactionItems = function () {
        var items = [];
        for (var _i = 0, _a = this.cartService.items; _i < _a.length; _i++) {
            var item = _a[_i];
            items.push({
                sku: item.content.reference,
                name: item.content.title.substring(0, 126),
                quantity: item.qty,
                price: item.content.price,
                currency: 'EUR'
            });
        }
        return items;
    };
    PaymentPayPalExpressCheckoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log(this.configService);
        if (angular2_universal_1.isBrowser) {
            $.getScript('https://www.paypalobjects.com/api/checkout.js', function () {
                paypal.Button.render({
                    // environment
                    env: _this.configService.data.CART.PAYPAL.ENV,
                    // style of the button
                    style: {
                        label: 'checkout',
                        size: 'responsive',
                        shape: 'rect',
                        color: 'blue' // gold | blue | silver
                    },
                    client: {
                        sandbox: 'AQNZSlVenpCKXfVDWSO-yDVMTDRlx_yiRK0drTN-AGmJQl0FdUR2sJFrjLuFCeIEN1S-rpsw-EJh21SM',
                        production: 'AQFZ3hsSn5_-qpeffTa69yKgzE6-mOCorPNSKkePo2Y3LXdc9fhB5AGu60XopuZNXy2rn5iifFmcX2iA'
                    },
                    locale: _this.utils.toLocale(_this.language),
                    payment: function (data, actions) {
                        return actions.payment.create({
                            payment: {
                                transactions: [
                                    {
                                        amount: {
                                            total: _this.cartService.total(),
                                            currency: 'EUR',
                                            details: {
                                                subtotal: _this.cartService.subtotal(),
                                                shipping: _this.cartService.shipping()
                                            }
                                        },
                                        item_list: {
                                            items: _this.transactionItems()
                                        }
                                    }
                                ]
                            }
                        });
                    },
                    onAuthorize: function (data, actions) {
                        return actions.payment.execute().then(function () {
                            _this.cartService.paymentData = data;
                            _this.cartService.clear();
                        });
                    }
                }, '#paypal-button-container');
            });
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], PaymentPayPalExpressCheckoutComponent.prototype, "language", void 0);
    PaymentPayPalExpressCheckoutComponent = __decorate([
        core_1.Component({
            selector: 'payment-paypal-express-checkout',
            template: '<div class="text-right" id="paypal-button-container"></div>',
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof cart_service_1.CartService !== 'undefined' && cart_service_1.CartService) === 'function' && _a) || Object, (typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof config_service_1.ConfigService !== 'undefined' && config_service_1.ConfigService) === 'function' && _c) || Object])
    ], PaymentPayPalExpressCheckoutComponent);
    return PaymentPayPalExpressCheckoutComponent;
    var _a, _b, _c;
}());
exports.PaymentPayPalExpressCheckoutComponent = PaymentPayPalExpressCheckoutComponent;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var search_service_1 = __webpack_require__(30);
var utils_service_1 = __webpack_require__(2);
var angular2_universal_1 = __webpack_require__(27);
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
var SearchAZComponent = (function () {
    function SearchAZComponent(searchService, elementRef, utils, route, router, es) {
        this.searchService = searchService;
        this.elementRef = elementRef;
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.onFilter = new core_1.EventEmitter();
        this.azData = {};
        this.fields = ['soloist', 'composer', 'conductor']; // , 'orchestra.fr'
        this.ready = false;
    }
    SearchAZComponent.prototype.ngOnInit = function () {
        // Build query
        this.query = this.es.query_search_all_nosort;
        this.query['aggregations'] = this.es.buildQuery_agg(this.fields, 10000);
        for (var _i = 0, _a = Object.keys(this.query['aggregations']); _i < _a.length; _i++) {
            var type = _a[_i];
            this.query['aggregations'][type]['terms']['order'] = { _term: 'asc' };
        }
        this.query['size'] = 0;
        // JS file path must be configurable
        if (angular2_universal_1.isBrowser) {
            this.utils.loadScripts(["/resources_front/assets/custom/popup-gallery-bundle.js"], this.elementRef.nativeElement);
        }
    };
    SearchAZComponent.prototype.onClickLoad = function (type) {
        var _this = this;
        this.requestType = type;
        this.searchService.search('record', this.query)
            .then(function (response) {
            _this.aggs = JSON.parse(response.body)['aggregations'];
            _this.azify(_this.aggs);
            _this.ready = true;
        });
    };
    SearchAZComponent.prototype.azify = function (data) {
        for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
            var type = _a[_i];
            var typeSafe = type.replace(/\./, "_DOT_");
            this.azData[typeSafe] = {};
            for (var _b = 0, _c = data[type].buckets; _b < _c.length; _b++) {
                var e = _c[_b];
                var name = e.key.replace(/^ +/, "");
                var letter = name.substring(0, 1).toLowerCase();
                if (!this.azData[typeSafe][letter])
                    this.azData[typeSafe][letter] = [];
                this.azData[typeSafe][letter].push(name);
            }
        }
    };
    SearchAZComponent.prototype.onSelect = function (type, value) {
        // Restore actual value for type
        type = type.replace(/_DOT_/, ".");
        // Callback 
        this.onFilter.emit({ type: type, value: value });
        // Nav (new search)
        var newQueryParams = { queryParams: {} };
        newQueryParams.queryParams['f'] = this.utils.appendQueryParam('', type, value);
        newQueryParams['relativeTo'] = this.route.parent;
        this.router.navigate([this.target], newQueryParams);
        if (angular2_universal_1.isBrowser) {
            //setTimeout(() => window.scrollTo(0, this.utils.getElementPosition('#content-start', 20, -20)), 1000);
            setTimeout(function () { return window.scrollTo(0, 0); }, 1000);
        }
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], SearchAZComponent.prototype, "onFilter", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchAZComponent.prototype, "labels", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAZComponent.prototype, "language", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAZComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAZComponent.prototype, "target", void 0);
    SearchAZComponent = __decorate([
        core_1.Component({
            selector: 'search-az',
            template: __webpack_require__(500)
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _g) || Object])
    ], SearchAZComponent);
    return SearchAZComponent;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.SearchAZComponent = SearchAZComponent;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
var Observable_1 = __webpack_require__(13);
__webpack_require__(512);
__webpack_require__(241);
__webpack_require__(120);
var ApiService = (function () {
    function ApiService(_http) {
        this._http = _http;
    }
    /**
     * whatever domain/feature method name
     */
    ApiService.prototype.get = function (url, options) {
        return this._http.get(url, options)
            .map(function (res) { return res.json(); })
            .catch(function (err) {
            console.log('Error: ', err);
            return Observable_1.Observable.throw(err);
        });
    };
    ApiService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object])
    ], ApiService);
    return ApiService;
    var _a;
}());
exports.ApiService = ApiService;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var auth_service_1 = __webpack_require__(86);
var AuthGuard = (function () {
    function AuthGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    AuthGuard.prototype.canActivateChild = function () {
        if (!this.authService.isLoggedIn) {
            console.log('[auth]', 'login redirect');
            this.router.navigateByUrl('/admin/login');
        }
        return true;
    };
    AuthGuard = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
    ], AuthGuard);
    return AuthGuard;
    var _a, _b;
}());
exports.AuthGuard = AuthGuard;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var CacheService = (function () {
    function CacheService(_cache) {
        this._cache = _cache;
    }
    /**
     * check if there is a value in our store
     */
    CacheService.prototype.has = function (key) {
        var _key = this.normalizeKey(key);
        return this._cache.has(_key);
    };
    /**
     * store our state
     */
    CacheService.prototype.set = function (key, value) {
        var _key = this.normalizeKey(key);
        this._cache.set(_key, value);
    };
    /**
     * get our cached value
     */
    CacheService.prototype.get = function (key) {
        var _key = this.normalizeKey(key);
        return this._cache.get(_key);
    };
    /**
     * release memory refs
     */
    CacheService.prototype.clear = function () {
        this._cache.clear();
    };
    /**
     * convert to json for the client
     */
    CacheService.prototype.dehydrate = function () {
        var json = {};
        this._cache.forEach(function (value, key) { return json[key] = value; });
        return json;
    };
    /**
     * convert server json into out initial state
     */
    CacheService.prototype.rehydrate = function (json) {
        var _this = this;
        Object.keys(json).forEach(function (key) {
            var _key = _this.normalizeKey(key);
            var value = json[_key];
            _this._cache.set(_key, value);
        });
    };
    /**
     * allow JSON.stringify to work
     */
    CacheService.prototype.toJSON = function () {
        return this.dehydrate();
    };
    /**
     * convert numbers into strings
     */
    CacheService.prototype.normalizeKey = function (key) {
        if (core_1.isDevMode() && this._isInvalidValue(key)) {
            throw new Error('Please provide a valid key to save in the CacheService');
        }
        return key + '';
    };
    CacheService.prototype._isInvalidValue = function (key) {
        return key === null ||
            key === undefined ||
            key === 0 ||
            key === '' ||
            typeof key === 'boolean' ||
            Number.isNaN(key);
    };
    CacheService.KEY = 'CacheService';
    CacheService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject('LRU')), 
        __metadata('design:paramtypes', [Object])
    ], CacheService);
    return CacheService;
}());
exports.CacheService = CacheService;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var MapToIterable = (function () {
    function MapToIterable() {
    }
    MapToIterable.prototype.transform = function (dict) {
        var a = [];
        for (var key in dict) {
            if (dict.hasOwnProperty(key)) {
                a.push({ key: key, value: dict[key] });
            }
        }
        return a;
    };
    MapToIterable = __decorate([
        core_1.Pipe({ name: 'mapToIterable' }), 
        __metadata('design:paramtypes', [])
    ], MapToIterable);
    return MapToIterable;
}());
exports.MapToIterable = MapToIterable;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var Subject_1 = __webpack_require__(66);
__webpack_require__(100);
__webpack_require__(121);
__webpack_require__(120);
__webpack_require__(183);
__webpack_require__(240);
var search_service_1 = __webpack_require__(30);
var utils_service_1 = __webpack_require__(2);
var SearchAutocompleteComponent = (function () {
    function SearchAutocompleteComponent(el, searchService, utils) {
        this.el = el;
        this.searchService = searchService;
        this.utils = utils;
        this.autocompleteEventEmitter = new Subject_1.Subject();
        this.autocompleteTriggerThreshold = 2;
    }
    SearchAutocompleteComponent.prototype.onSelect = function (val) {
        this.input.element.value = val;
        // Update reactive form
        if (this.form && this.formPath)
            this.form.get(this.formPath).setValue(val);
        // Clear
        this.autocompleteContent = null;
    };
    SearchAutocompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.autocompleteEventEmitter
            .debounceTime(300)
            .switchMap(function (input) {
            return _this.searchService.autocomplete('record', _this.esType, input);
        }).subscribe(function (res) {
            _this.autocompleteContent = res[_this.esType];
        }, function (error) {
            console.log(error);
        });
    };
    SearchAutocompleteComponent.prototype.ngOnChanges = function (changes) {
        if (this.isOnFocus()) {
            if (this.input.element && this.input.element.value.length >= this.autocompleteTriggerThreshold)
                this.autocompleteEventEmitter.next(this.input.element.value);
            else
                this.autocompleteContent = null;
        }
    };
    SearchAutocompleteComponent.prototype.isOnFocus = function () {
        if (this.input.element && this.target == this.input.element.id)
            return true;
        return false;
    };
    SearchAutocompleteComponent.prototype.onAutocompleteLeave = function () {
        var _this = this;
        // In the mean time, move may have come back over
        setTimeout(function () {
            _this.autocompleteContent = null;
        }, 1000);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', (typeof (_a = typeof forms_1.FormGroup !== 'undefined' && forms_1.FormGroup) === 'function' && _a) || Object)
    ], SearchAutocompleteComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAutocompleteComponent.prototype, "formPath", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchAutocompleteComponent.prototype, "onSelectCallBack", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAutocompleteComponent.prototype, "target", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SearchAutocompleteComponent.prototype, "input", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SearchAutocompleteComponent.prototype, "esType", void 0);
    SearchAutocompleteComponent = __decorate([
        core_1.Component({
            selector: 'search-autocomplete',
            template: "\n        <ul *ngIf=\"isOnFocus() && autocompleteContent\" class=\"autocomplete\" (mouseleave)=\"onAutocompleteLeave()\">\n            <li *ngFor=\"let e of autocompleteContent\">\n                <a (click)=\"onSelect(e.name)\">{{e.name}}</a>\n            </li>\n        </ul>\n    "
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object, (typeof (_c = typeof search_service_1.SearchService !== 'undefined' && search_service_1.SearchService) === 'function' && _c) || Object, (typeof (_d = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _d) || Object])
    ], SearchAutocompleteComponent);
    return SearchAutocompleteComponent;
    var _a, _b, _c, _d;
}());
exports.SearchAutocompleteComponent = SearchAutocompleteComponent;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(119);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(15);
var import10 = __webpack_require__(16);
var import11 = __webpack_require__(29);
var import12 = __webpack_require__(11);
var import13 = __webpack_require__(10);
var import14 = __webpack_require__(22);
var import15 = __webpack_require__(24);
var import16 = __webpack_require__(235);
var import17 = __webpack_require__(118);
var import18 = __webpack_require__(14);
var import19 = __webpack_require__(20);
var import20 = __webpack_require__(19);
var import21 = __webpack_require__(21);
var Wrapper_SearchFilterComponent = (function () {
    function Wrapper_SearchFilterComponent(p0, p1, p2, p3) {
        this.changed = false;
        this.context = new import0.SearchFilterComponent(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_SearchFilterComponent.prototype.check_esQuery = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.esQuery = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.check_esFilters = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.esFilters = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.check_title = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.title = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_5 = currValue;
        }
    };
    Wrapper_SearchFilterComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchFilterComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchFilterComponent;
}());
exports.Wrapper_SearchFilterComponent = Wrapper_SearchFilterComponent;
var renderType_SearchFilterComponent_Host = null;
var _View_SearchFilterComponent_Host0 = (function (_super) {
    __extends(_View_SearchFilterComponent_Host0, _super);
    function _View_SearchFilterComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent_Host0, renderType_SearchFilterComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFilterComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'search-filters', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchFilterComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchFilterComponent_0_4 = new Wrapper_SearchFilterComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import9.Router), this.parentInjector.get(import10.ActivatedRoute), this.parentInjector.get(import11.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchFilterComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchFilterComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchFilterComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchFilterComponent) && (0 === requestNodeIndex))) {
            return this._SearchFilterComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchFilterComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchFilterComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFilterComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFilterComponent_Host0;
}(import3.AppView));
function viewFactory_SearchFilterComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchFilterComponent_Host === null)) {
        (renderType_SearchFilterComponent_Host = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchFilterComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchFilterComponentNgFactory = new import13.ComponentFactory('search-filters', viewFactory_SearchFilterComponent_Host0, import0.SearchFilterComponent);
var styles_SearchFilterComponent = [];
var renderType_SearchFilterComponent = null;
var _View_SearchFilterComponent0 = (function (_super) {
    __extends(_View_SearchFilterComponent0, _super);
    function _View_SearchFilterComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent0, renderType_SearchFilterComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFilterComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this._el_1 = import2.createRenderElement(this.renderer, parentRenderNode, 'p', new import2.InlineArray2(2, 'class', 'font-alt text-uppercase'), null);
        this._text_2 = this.renderer.createText(this._el_1, '\n      ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_3 = new import5.AppElement(3, 1, this, this._anchor_3);
        this._TemplateRef_3_5 = new import18.TemplateRef_(this._appEl_3, viewFactory_SearchFilterComponent1);
        this._NgIf_3_6 = new import14.Wrapper_NgIf(this._appEl_3.vcRef, this._TemplateRef_3_5);
        this._text_4 = this.renderer.createText(this._el_1, '\n          ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_5 = new import5.AppElement(5, 1, this, this._anchor_5);
        this._TemplateRef_5_5 = new import18.TemplateRef_(this._appEl_5, viewFactory_SearchFilterComponent2);
        this._NgIf_5_6 = new import14.Wrapper_NgIf(this._appEl_5.vcRef, this._TemplateRef_5_5);
        this._text_6 = this.renderer.createText(this._el_1, '\n      ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_7 = new import5.AppElement(7, 1, this, this._anchor_7);
        this._TemplateRef_7_5 = new import18.TemplateRef_(this._appEl_7, viewFactory_SearchFilterComponent3);
        this._NgFor_7_6 = new import15.Wrapper_NgFor(this._appEl_7.vcRef, this._TemplateRef_7_5, this.parentInjector.get(import19.IterableDiffers), this.ref);
        this._text_8 = this.renderer.createText(this._el_1, '\n    ', null);
        this._pipe_mapToIterable_0 = new import16.MapToIterable();
        this._pipe_nameResolver_1 = new import17.NameResolverPipe();
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._anchor_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8
        ], [], []);
        return null;
    };
    _View_SearchFilterComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import20.NgIf) && (3 === requestNodeIndex))) {
            return this._NgIf_3_6.context;
        }
        if (((token === import18.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import20.NgIf) && (5 === requestNodeIndex))) {
            return this._NgIf_5_6.context;
        }
        if (((token === import18.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import21.NgFor) && (7 === requestNodeIndex))) {
            return this._NgFor_7_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFilterComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = ((this.context.esFilters.length > 1) || (this.context.searchQueryParams != null));
        this._NgIf_3_6.check_ngIf(currVal_3_0_0, throwOnChange, false);
        this._NgIf_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        var currVal_5_0_0 = (this.context.searchQueryParams != null);
        this._NgIf_5_6.check_ngIf(currVal_5_0_0, throwOnChange, false);
        this._NgIf_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = this.context.esFilters;
        this._NgFor_7_6.check_ngForOf(currVal_7_0_0, throwOnChange, false);
        this._NgFor_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFilterComponent0;
}(import3.AppView));
function viewFactory_SearchFilterComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchFilterComponent === null)) {
        (renderType_SearchFilterComponent = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.None, styles_SearchFilterComponent, {}));
    }
    return new _View_SearchFilterComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchFilterComponent0 = viewFactory_SearchFilterComponent0;
var _View_SearchFilterComponent1 = (function (_super) {
    __extends(_View_SearchFilterComponent1, _super);
    function _View_SearchFilterComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent1, renderType_SearchFilterComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_SearchFilterComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', new import2.InlineArray2(2, 'class', 'search-filters-intro letter-spacing-4 font-weight-600'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_SearchFilterComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = import2.interpolate(1, '\n          ', this.parent.context.title, ': ');
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFilterComponent1;
}(import3.AppView));
function viewFactory_SearchFilterComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFilterComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFilterComponent2 = (function (_super) {
    __extends(_View_SearchFilterComponent2, _super);
    function _View_SearchFilterComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent2, renderType_SearchFilterComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_8 = import1.UNINITIALIZED;
    }
    _View_SearchFilterComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', new import2.InlineArray2(2, 'title', 'search'), null);
        this._text_1 = this.renderer.createText(this._el_0, ' \n            ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray4(4, 'class', 'pointer letter-spacing-3 search-filter', 'title', 'search'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_2, 'small', import2.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, 'x', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n      ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7
        ], [disposable_0], []);
        return null;
    };
    _View_SearchFilterComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_8 = import2.interpolate(1, '\n              "', this.parent.context.esQuery.query.bool.must.multi_match.query, '" ');
        if (import2.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setText(this._text_3, currVal_8);
            this._expr_8 = currVal_8;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchFilterComponent2.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.onRemoveSearch() !== false);
        return (true && pd_2_0);
    };
    return _View_SearchFilterComponent2;
}(import3.AppView));
function viewFactory_SearchFilterComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFilterComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFilterComponent3 = (function (_super) {
    __extends(_View_SearchFilterComponent3, _super);
    function _View_SearchFilterComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent3, renderType_SearchFilterComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFilterComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', new import2.InlineArray2(2, 'title', 'filter'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import18.TemplateRef_(this._appEl_2, viewFactory_SearchFilterComponent4);
        this._NgFor_2_6 = new import15.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parent.parentInjector.get(import19.IterableDiffers), this.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n      ', null);
        this._pipe_mapToIterable_0_0 = import2.pureProxy1(this.parent._pipe_mapToIterable_0.transform.bind(this.parent._pipe_mapToIterable_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_SearchFilterComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import21.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFilterComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        valUnwrapper.reset();
        var currVal_2_0_0 = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_0, this.parent._pipe_mapToIterable_0.transform)(this.context.$implicit.term));
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, valUnwrapper.hasWrappedValue);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFilterComponent3;
}(import3.AppView));
function viewFactory_SearchFilterComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFilterComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFilterComponent4 = (function (_super) {
    __extends(_View_SearchFilterComponent4, _super);
    function _View_SearchFilterComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent4, renderType_SearchFilterComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFilterComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', new import2.InlineArray2(2, 'class', 'pointer letter-spacing-3 search-filter'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import18.TemplateRef_(this._appEl_2, viewFactory_SearchFilterComponent5);
        this._NgIf_2_6 = new import14.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [disposable_0], []);
        return null;
    };
    _View_SearchFilterComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import20.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFilterComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = (this.context.$implicit.key != 'active');
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchFilterComponent4.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.onRemoveFilter(this.context.$implicit.key, this.context.$implicit.value) !== false);
        return (true && pd_0_0);
    };
    return _View_SearchFilterComponent4;
}(import3.AppView));
function viewFactory_SearchFilterComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFilterComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFilterComponent5 = (function (_super) {
    __extends(_View_SearchFilterComponent5, _super);
    function _View_SearchFilterComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFilterComponent5, renderType_SearchFilterComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_SearchFilterComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._pipe_nameResolver_1_0 = import2.pureProxy1(this.parent.parent.parent._pipe_nameResolver_1.transform.bind(this.parent.parent.parent._pipe_nameResolver_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_SearchFilterComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_2 = import2.interpolate(1, '\n            ', ((this.parent.parent.parent.context.labels && this.parent.parent.parent.context.labels[this.parent.context.$implicit.key.replace('.raw', '')].VALUES) ? this.parent.parent.parent.context.labels[this.parent.context.$implicit.key.replace('.raw', '')].VALUES[this.parent.context.$implicit.value][this.parent.parent.parent.context.language] : valUnwrapper.unwrap(import2.castByValue(this._pipe_nameResolver_1_0, this.parent.parent.parent._pipe_nameResolver_1.transform)(this.parent.context.$implicit.value))), ' ×');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_2, currVal_2))) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFilterComponent5;
}(import3.AppView));
function viewFactory_SearchFilterComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFilterComponent5(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 238 */
/***/ (function(module, exports) {

"use strict";
"use strict";
function isElement(node) {
    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
}
var FileLikeObject = (function () {
    function FileLikeObject(fileOrInput) {
        var isInput = isElement(fileOrInput);
        var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        var postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
        var method = '_createFrom' + postfix;
        this[method](fakePathOrObject);
    }
    FileLikeObject.prototype._createFromFakePath = function (path) {
        this.lastModifiedDate = void 0;
        this.size = void 0;
        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    };
    FileLikeObject.prototype._createFromObject = function (object) {
        // this.lastModifiedDate = copy(object.lastModifiedDate);
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    };
    return FileLikeObject;
}());
exports.FileLikeObject = FileLikeObject;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var file_like_object_class_1 = __webpack_require__(238);
var file_item_class_1 = __webpack_require__(317);
var file_type_class_1 = __webpack_require__(467);
function isFile(value) {
    return (File && value instanceof File);
}
var FileUploader = (function () {
    function FileUploader(options) {
        this.isUploading = false;
        this.queue = [];
        this.progress = 0;
        this._nextIndex = 0;
        this.options = {
            autoUpload: false,
            isHTML5: true,
            filters: [],
            removeAfterUpload: false,
            disableMultipart: false
        };
        this.setOptions(options);
    }
    FileUploader.prototype.setOptions = function (options) {
        this.options = Object.assign(this.options, options);
        this.authToken = options.authToken;
        this.authTokenHeader = options.authTokenHeader || 'Authorization';
        this.autoUpload = options.autoUpload;
        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
        if (this.options.maxFileSize) {
            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
        }
        if (this.options.allowedFileType) {
            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
        }
        if (this.options.allowedMimeType) {
            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
        }
        for (var i = 0; i < this.queue.length; i++) {
            this.queue[i].url = this.options.url;
        }
        // this.options.filters.unshift({name: 'folder', fn: this._folderFilter});
    };
    FileUploader.prototype.addToQueue = function (files, options, filters) {
        var _this = this;
        var list = [];
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            list.push(file);
        }
        var arrayOfFilters = this._getFilters(filters);
        var count = this.queue.length;
        var addedFileItems = [];
        list.map(function (some) {
            if (!options) {
                options = _this.options;
            }
            var temp = new file_like_object_class_1.FileLikeObject(some);
            if (_this._isValidFile(temp, arrayOfFilters, options)) {
                var fileItem = new file_item_class_1.FileItem(_this, some, options);
                addedFileItems.push(fileItem);
                _this.queue.push(fileItem);
                _this._onAfterAddingFile(fileItem);
            }
            else {
                var filter = arrayOfFilters[_this._failFilterIndex];
                _this._onWhenAddingFileFailed(temp, filter, options);
            }
        });
        if (this.queue.length !== count) {
            this._onAfterAddingAll(addedFileItems);
            this.progress = this._getTotalProgress();
        }
        this._render();
        if (this.options.autoUpload) {
            this.uploadAll();
        }
    };
    FileUploader.prototype.removeFromQueue = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        if (item.isUploading) {
            item.cancel();
        }
        this.queue.splice(index, 1);
        this.progress = this._getTotalProgress();
    };
    FileUploader.prototype.clearQueue = function () {
        while (this.queue.length) {
            this.queue[0].remove();
        }
        this.progress = 0;
    };
    FileUploader.prototype.uploadItem = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        var transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
        item._prepareToUploading();
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        this[transport](item);
    };
    FileUploader.prototype.cancelItem = function (value) {
        var index = this.getIndexOfItem(value);
        var item = this.queue[index];
        var prop = this.options.isHTML5 ? item._xhr : item._form;
        if (item && item.isUploading) {
            prop.abort();
        }
    };
    FileUploader.prototype.uploadAll = function () {
        var items = this.getNotUploadedItems().filter(function (item) { return !item.isUploading; });
        if (!items.length) {
            return;
        }
        items.map(function (item) { return item._prepareToUploading(); });
        items[0].upload();
    };
    FileUploader.prototype.cancelAll = function () {
        var items = this.getNotUploadedItems();
        items.map(function (item) { return item.cancel(); });
    };
    FileUploader.prototype.isFile = function (value) {
        return isFile(value);
    };
    FileUploader.prototype.isFileLikeObject = function (value) {
        return value instanceof file_like_object_class_1.FileLikeObject;
    };
    FileUploader.prototype.getIndexOfItem = function (value) {
        return typeof value === 'number' ? value : this.queue.indexOf(value);
    };
    FileUploader.prototype.getNotUploadedItems = function () {
        return this.queue.filter(function (item) { return !item.isUploaded; });
    };
    FileUploader.prototype.getReadyItems = function () {
        return this.queue
            .filter(function (item) { return (item.isReady && !item.isUploading); })
            .sort(function (item1, item2) { return item1.index - item2.index; });
    };
    FileUploader.prototype.destroy = function () {
        return void 0;
        /*forEach(this._directives, (key) => {
         forEach(this._directives[key], (object) => {
         object.destroy();
         });
         });*/
    };
    FileUploader.prototype.onAfterAddingAll = function (fileItems) {
        return { fileItems: fileItems };
    };
    FileUploader.prototype.onBuildItemForm = function (fileItem, form) {
        return { fileItem: fileItem, form: form };
    };
    FileUploader.prototype.onAfterAddingFile = function (fileItem) {
        return { fileItem: fileItem };
    };
    FileUploader.prototype.onWhenAddingFileFailed = function (item, filter, options) {
        return { item: item, filter: filter, options: options };
    };
    FileUploader.prototype.onBeforeUploadItem = function (fileItem) {
        return { fileItem: fileItem };
    };
    FileUploader.prototype.onProgressItem = function (fileItem, progress) {
        return { fileItem: fileItem, progress: progress };
    };
    FileUploader.prototype.onProgressAll = function (progress) {
        return { progress: progress };
    };
    FileUploader.prototype.onSuccessItem = function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    FileUploader.prototype.onErrorItem = function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    FileUploader.prototype.onCancelItem = function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    FileUploader.prototype.onCompleteItem = function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    FileUploader.prototype.onCompleteAll = function () {
        return void 0;
    };
    FileUploader.prototype._mimeTypeFilter = function (item) {
        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
    };
    FileUploader.prototype._fileSizeFilter = function (item) {
        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
    };
    FileUploader.prototype._fileTypeFilter = function (item) {
        return !(this.options.allowedFileType &&
            this.options.allowedFileType.indexOf(file_type_class_1.FileType.getMimeClass(item)) === -1);
    };
    FileUploader.prototype._onErrorItem = function (item, response, status, headers) {
        item._onError(response, status, headers);
        this.onErrorItem(item, response, status, headers);
    };
    FileUploader.prototype._onCompleteItem = function (item, response, status, headers) {
        item._onComplete(response, status, headers);
        this.onCompleteItem(item, response, status, headers);
        var nextItem = this.getReadyItems()[0];
        this.isUploading = false;
        if (nextItem) {
            nextItem.upload();
            return;
        }
        this.onCompleteAll();
        this.progress = this._getTotalProgress();
        this._render();
    };
    FileUploader.prototype._headersGetter = function (parsedHeaders) {
        return function (name) {
            if (name) {
                return parsedHeaders[name.toLowerCase()] || void 0;
            }
            return parsedHeaders;
        };
    };
    FileUploader.prototype._xhrTransport = function (item) {
        var _this = this;
        var xhr = item._xhr = new XMLHttpRequest();
        var sendable;
        this._onBeforeUploadItem(item);
        // todo
        /*item.formData.map(obj => {
         obj.map((value, key) => {
         form.append(key, value);
         });
         });*/
        if (typeof item._file.size !== 'number') {
            throw new TypeError('The file specified is no longer valid');
        }
        if (!this.options.disableMultipart) {
            sendable = new FormData();
            this._onBuildItemForm(item, sendable);
            sendable.append(item.alias, item._file, item.file.name);
            if (this.options.additionalParameter !== undefined) {
                Object.keys(this.options.additionalParameter).forEach(function (key) {
                    sendable.append(key, _this.options.additionalParameter[key]);
                });
            }
        }
        else {
            sendable = item._file;
        }
        xhr.upload.onprogress = function (event) {
            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            _this._onProgressItem(item, progress);
        };
        xhr.onload = function () {
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            var response = _this._transformResponse(xhr.response, headers);
            var gist = _this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            var method = '_on' + gist + 'Item';
            _this[method](item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onerror = function () {
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            var response = _this._transformResponse(xhr.response, headers);
            _this._onErrorItem(item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onabort = function () {
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            var response = _this._transformResponse(xhr.response, headers);
            _this._onCancelItem(item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.open(item.method, item.url, true);
        xhr.withCredentials = item.withCredentials;
        if (this.options.headers) {
            for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
                var header = _a[_i];
                xhr.setRequestHeader(header.name, header.value);
            }
        }
        if (item.headers.length) {
            for (var _b = 0, _c = item.headers; _b < _c.length; _b++) {
                var header = _c[_b];
                xhr.setRequestHeader(header.name, header.value);
            }
        }
        if (this.authToken) {
            xhr.setRequestHeader(this.authTokenHeader, this.authToken);
        }
        xhr.send(sendable);
        this._render();
    };
    FileUploader.prototype._getTotalProgress = function (value) {
        if (value === void 0) { value = 0; }
        if (this.options.removeAfterUpload) {
            return value;
        }
        var notUploaded = this.getNotUploadedItems().length;
        var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
        var ratio = 100 / this.queue.length;
        var current = value * ratio / 100;
        return Math.round(uploaded * ratio + current);
    };
    FileUploader.prototype._getFilters = function (filters) {
        if (!filters) {
            return this.options.filters;
        }
        if (Array.isArray(filters)) {
            return filters;
        }
        if (typeof filters === 'string') {
            var names_1 = filters.match(/[^\s,]+/g);
            return this.options.filters
                .filter(function (filter) { return names_1.indexOf(filter.name) !== -1; });
        }
        return this.options.filters;
    };
    FileUploader.prototype._render = function () {
        return void 0;
        // todo: ?
    };
    // protected _folderFilter(item:FileItem):boolean {
    //   return !!(item.size || item.type);
    // }
    FileUploader.prototype._queueLimitFilter = function () {
        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
    };
    FileUploader.prototype._isValidFile = function (file, filters, options) {
        var _this = this;
        this._failFilterIndex = -1;
        return !filters.length ? true : filters.every(function (filter) {
            _this._failFilterIndex++;
            return filter.fn.call(_this, file, options);
        });
    };
    FileUploader.prototype._isSuccessCode = function (status) {
        return (status >= 200 && status < 300) || status === 304;
    };
    /* tslint:disable */
    FileUploader.prototype._transformResponse = function (response, headers) {
        // todo: ?
        /*var headersGetter = this._headersGetter(headers);
         forEach($http.defaults.transformResponse, (transformFn) => {
         response = transformFn(response, headersGetter);
         });*/
        return response;
    };
    /* tslint:enable */
    FileUploader.prototype._parseHeaders = function (headers) {
        var parsed = {};
        var key;
        var val;
        var i;
        if (!headers) {
            return parsed;
        }
        headers.split('\n').map(function (line) {
            i = line.indexOf(':');
            key = line.slice(0, i).trim().toLowerCase();
            val = line.slice(i + 1).trim();
            if (key) {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        });
        return parsed;
    };
    /*protected _iframeTransport(item:FileItem) {
     // todo: implement it later
     }*/
    FileUploader.prototype._onWhenAddingFileFailed = function (item, filter, options) {
        this.onWhenAddingFileFailed(item, filter, options);
    };
    FileUploader.prototype._onAfterAddingFile = function (item) {
        this.onAfterAddingFile(item);
    };
    FileUploader.prototype._onAfterAddingAll = function (items) {
        this.onAfterAddingAll(items);
    };
    FileUploader.prototype._onBeforeUploadItem = function (item) {
        item._onBeforeUpload();
        this.onBeforeUploadItem(item);
    };
    FileUploader.prototype._onBuildItemForm = function (item, form) {
        item._onBuildForm(form);
        this.onBuildItemForm(item, form);
    };
    FileUploader.prototype._onProgressItem = function (item, progress) {
        var total = this._getTotalProgress(progress);
        this.progress = total;
        item._onProgress(progress);
        this.onProgressItem(item, progress);
        this.onProgressAll(total);
        this._render();
    };
    /* tslint:disable */
    FileUploader.prototype._onSuccessItem = function (item, response, status, headers) {
        item._onSuccess(response, status, headers);
        this.onSuccessItem(item, response, status, headers);
    };
    /* tslint:enable */
    FileUploader.prototype._onCancelItem = function (item, response, status, headers) {
        item._onCancel(response, status, headers);
        this.onCancelItem(item, response, status, headers);
    };
    return FileUploader;
}());
exports.FileUploader = FileUploader;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var distinctUntilChanged_1 = __webpack_require__(528);
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var map_1 = __webpack_require__(124);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var FromObservable_1 = __webpack_require__(522);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var PromiseObservable_1 = __webpack_require__(326);
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(182);
var subscribeToResult_1 = __webpack_require__(185);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} an observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */
function _catch(selector) {
    var operator = new CatchOperator(selector);
    var caught = this.lift(operator);
    return (operator.caught = caught);
}
exports._catch = _catch;
var CatchOperator = (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CatchSubscriber = (function (_super) {
    __extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.unsubscribe();
            this.destination.remove(this);
            subscribeToResult_1.subscribeToResult(this, result);
        }
    };
    return CatchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=catch.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.$$iterator = symbolIteratorPonyfill(root_1.root);
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.$$observable = getSymbolObservable(root_1.root);
//# sourceMappingURL=observable.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
var Symbol = root_1.root.Symbol;
exports.$$rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = (function (_super) {
    __extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error));
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports) {

"use strict";
"use strict";
// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports) {

"use strict";
"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports) {

"use strict";
"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_index__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localization__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pipes_index__ = __webpack_require__(257);
/* harmony export (binding) */ __webpack_require__.d(exports, "CommonModule", function() { return CommonModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




// Note: This does not contain the location providers,
// as they need some platform specific implementations to work.
/**
 * The module that includes all the basic Angular directives like {@link NgIf}, {@link NgFor}, ...
 *
 * @stable
 */
var CommonModule = (function () {
    function CommonModule() {
    }
    CommonModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__directives_index__["a" /* COMMON_DIRECTIVES */], __WEBPACK_IMPORTED_MODULE_3__pipes_index__["a" /* COMMON_PIPES */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives_index__["a" /* COMMON_DIRECTIVES */], __WEBPACK_IMPORTED_MODULE_3__pipes_index__["a" /* COMMON_PIPES */]],
                    providers: [
                        { provide: __WEBPACK_IMPORTED_MODULE_2__localization__["NgLocalization"], useClass: __WEBPACK_IMPORTED_MODULE_2__localization__["NgLocaleLocalization"] },
                    ],
                },] },
    ];
    /** @nocollapse */
    CommonModule.ctorParameters = [];
    return CommonModule;
}());
//# sourceMappingURL=common_module.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ng_class__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng_for__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_if__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ng_plural__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_style__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ng_switch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng_template_outlet__ = __webpack_require__(350);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return COMMON_DIRECTIVES; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */







/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ng_class__["NgClass"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ng_for__["NgFor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ng_if__["NgIf"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__ng_plural__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__ng_plural__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__ng_style__["NgStyle"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitch"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitchCase"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitchDefault"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__ng_template_outlet__["a"]; });

/**
 * A collection of Angular directives that are likely to be used in each and every Angular
 * application.
 */
var COMMON_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_0__ng_class__["NgClass"],
    __WEBPACK_IMPORTED_MODULE_1__ng_for__["NgFor"],
    __WEBPACK_IMPORTED_MODULE_2__ng_if__["NgIf"],
    __WEBPACK_IMPORTED_MODULE_6__ng_template_outlet__["a" /* NgTemplateOutlet */],
    __WEBPACK_IMPORTED_MODULE_4__ng_style__["NgStyle"],
    __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitch"],
    __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitchCase"],
    __WEBPACK_IMPORTED_MODULE_5__ng_switch__["NgSwitchDefault"],
    __WEBPACK_IMPORTED_MODULE_3__ng_plural__["a" /* NgPlural */],
    __WEBPACK_IMPORTED_MODULE_3__ng_plural__["b" /* NgPluralCase */],
];
//# sourceMappingURL=index.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NumberFormatStyle; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NumberFormatter; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DateFormatter; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NumberFormatStyle;
(function (NumberFormatStyle) {
    NumberFormatStyle[NumberFormatStyle["Decimal"] = 0] = "Decimal";
    NumberFormatStyle[NumberFormatStyle["Percent"] = 1] = "Percent";
    NumberFormatStyle[NumberFormatStyle["Currency"] = 2] = "Currency";
})(NumberFormatStyle || (NumberFormatStyle = {}));
var NumberFormatter = (function () {
    function NumberFormatter() {
    }
    NumberFormatter.format = function (num, locale, style, _a) {
        var _b = _a === void 0 ? {} : _a, minimumIntegerDigits = _b.minimumIntegerDigits, minimumFractionDigits = _b.minimumFractionDigits, maximumFractionDigits = _b.maximumFractionDigits, currency = _b.currency, _c = _b.currencyAsSymbol, currencyAsSymbol = _c === void 0 ? false : _c;
        var options = {
            minimumIntegerDigits: minimumIntegerDigits,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
            style: NumberFormatStyle[style].toLowerCase()
        };
        if (style == NumberFormatStyle.Currency) {
            options.currency = currency;
            options.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
        }
        return new Intl.NumberFormat(locale, options).format(num);
    };
    return NumberFormatter;
}());
var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsazZEwGjJ']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|J+|j+|m+|s+|a|z|Z|G+|w+))(.*)/;
var PATTERN_ALIASES = {
    yMMMdjms: datePartGetterFactory(combine([
        digitCondition('year', 1),
        nameCondition('month', 3),
        digitCondition('day', 1),
        digitCondition('hour', 1),
        digitCondition('minute', 1),
        digitCondition('second', 1),
    ])),
    yMdjm: datePartGetterFactory(combine([
        digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1),
        digitCondition('hour', 1), digitCondition('minute', 1)
    ])),
    yMMMMEEEEd: datePartGetterFactory(combine([
        digitCondition('year', 1), nameCondition('month', 4), nameCondition('weekday', 4),
        digitCondition('day', 1)
    ])),
    yMMMMd: datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 4), digitCondition('day', 1)])),
    yMMMd: datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 3), digitCondition('day', 1)])),
    yMd: datePartGetterFactory(combine([digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1)])),
    jms: datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('second', 1), digitCondition('minute', 1)])),
    jm: datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('minute', 1)]))
};
var DATE_FORMATS = {
    yyyy: datePartGetterFactory(digitCondition('year', 4)),
    yy: datePartGetterFactory(digitCondition('year', 2)),
    y: datePartGetterFactory(digitCondition('year', 1)),
    MMMM: datePartGetterFactory(nameCondition('month', 4)),
    MMM: datePartGetterFactory(nameCondition('month', 3)),
    MM: datePartGetterFactory(digitCondition('month', 2)),
    M: datePartGetterFactory(digitCondition('month', 1)),
    LLLL: datePartGetterFactory(nameCondition('month', 4)),
    dd: datePartGetterFactory(digitCondition('day', 2)),
    d: datePartGetterFactory(digitCondition('day', 1)),
    HH: digitModifier(hourExtracter(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), false)))),
    H: hourExtracter(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), false))),
    hh: digitModifier(hourExtracter(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), true)))),
    h: hourExtracter(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
    jj: datePartGetterFactory(digitCondition('hour', 2)),
    j: datePartGetterFactory(digitCondition('hour', 1)),
    mm: digitModifier(datePartGetterFactory(digitCondition('minute', 2))),
    m: datePartGetterFactory(digitCondition('minute', 1)),
    ss: digitModifier(datePartGetterFactory(digitCondition('second', 2))),
    s: datePartGetterFactory(digitCondition('second', 1)),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit
    // fractions
    sss: datePartGetterFactory(digitCondition('second', 3)),
    EEEE: datePartGetterFactory(nameCondition('weekday', 4)),
    EEE: datePartGetterFactory(nameCondition('weekday', 3)),
    EE: datePartGetterFactory(nameCondition('weekday', 2)),
    E: datePartGetterFactory(nameCondition('weekday', 1)),
    a: hourClockExtracter(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
    Z: timeZoneGetter('short'),
    z: timeZoneGetter('long'),
    ww: datePartGetterFactory({}),
    // first Thursday of the year. not support ?
    w: datePartGetterFactory({}),
    // of the year not support ?
    G: datePartGetterFactory(nameCondition('era', 1)),
    GG: datePartGetterFactory(nameCondition('era', 2)),
    GGG: datePartGetterFactory(nameCondition('era', 3)),
    GGGG: datePartGetterFactory(nameCondition('era', 4))
};
function digitModifier(inner) {
    return function (date, locale) {
        var result = inner(date, locale);
        return result.length == 1 ? '0' + result : result;
    };
}
function hourClockExtracter(inner) {
    return function (date, locale) {
        var result = inner(date, locale);
        return result.split(' ')[1];
    };
}
function hourExtracter(inner) {
    return function (date, locale) {
        var result = inner(date, locale);
        return result.split(' ')[0];
    };
}
function intlDateFormat(date, locale, options) {
    return new Intl.DateTimeFormat(locale, options).format(date).replace(/[\u200e\u200f]/g, '');
}
function timeZoneGetter(timezone) {
    // To workaround `Intl` API restriction for single timezone let format with 24 hours
    var options = { hour: '2-digit', hour12: false, timeZoneName: timezone };
    return function (date, locale) {
        var result = intlDateFormat(date, locale, options);
        // Then extract first 3 letters that related to hours
        return result ? result.substring(3) : '';
    };
}
function hour12Modify(options, value) {
    options.hour12 = value;
    return options;
}
function digitCondition(prop, len) {
    var result = {};
    result[prop] = len == 2 ? '2-digit' : 'numeric';
    return result;
}
function nameCondition(prop, len) {
    var result = {};
    result[prop] = len < 4 ? 'short' : 'long';
    return result;
}
function combine(options) {
    var result = {};
    options.forEach(function (option) { Object.assign(result, option); });
    return result;
}
function datePartGetterFactory(ret) {
    return function (date, locale) { return intlDateFormat(date, locale, ret); };
}
var datePartsFormatterCache = new Map();
function dateFormatter(format, date, locale) {
    var text = '';
    var match;
    var fn;
    var parts = [];
    if (PATTERN_ALIASES[format]) {
        return PATTERN_ALIASES[format](date, locale);
    }
    if (datePartsFormatterCache.has(format)) {
        parts = datePartsFormatterCache.get(format);
    }
    else {
        var matches = DATE_FORMATS_SPLIT.exec(format);
        while (format) {
            match = DATE_FORMATS_SPLIT.exec(format);
            if (match) {
                parts = concat(parts, match, 1);
                format = parts.pop();
            }
            else {
                parts.push(format);
                format = null;
            }
        }
        datePartsFormatterCache.set(format, parts);
    }
    parts.forEach(function (part) {
        fn = DATE_FORMATS[part];
        text += fn ? fn(date, locale) :
            part === '\'\'' ? '\'' : part.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });
    return text;
}
var slice = [].slice;
function concat(array1 /** TODO #9100 */, array2 /** TODO #9100 */, index /** TODO #9100 */) {
    return array1.concat(slice.call(array2, index));
}
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.format = function (date, locale, pattern) {
        return dateFormatter(pattern, date, locale);
    };
    return DateFormatter;
}());
//# sourceMappingURL=intl.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_pipe__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_pipe__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_plural_pipe__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_select_pipe__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_pipe__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lowercase_pipe__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__number_pipe__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__slice_pipe__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__uppercase_pipe__ = __webpack_require__(82);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return COMMON_PIPES; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__async_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__number_pipe__["CurrencyPipe"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__date_pipe__["DatePipe"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__number_pipe__["DecimalPipe"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__i18n_plural_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__i18n_select_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__json_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__lowercase_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__number_pipe__["PercentPipe"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__slice_pipe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__uppercase_pipe__["UpperCasePipe"]; });

/**
 * A collection of Angular pipes that are likely to be used in each and every application.
 */
var COMMON_PIPES = [
    __WEBPACK_IMPORTED_MODULE_0__async_pipe__["a" /* AsyncPipe */],
    __WEBPACK_IMPORTED_MODULE_8__uppercase_pipe__["UpperCasePipe"],
    __WEBPACK_IMPORTED_MODULE_5__lowercase_pipe__["a" /* LowerCasePipe */],
    __WEBPACK_IMPORTED_MODULE_4__json_pipe__["a" /* JsonPipe */],
    __WEBPACK_IMPORTED_MODULE_7__slice_pipe__["a" /* SlicePipe */],
    __WEBPACK_IMPORTED_MODULE_6__number_pipe__["DecimalPipe"],
    __WEBPACK_IMPORTED_MODULE_6__number_pipe__["PercentPipe"],
    __WEBPACK_IMPORTED_MODULE_6__number_pipe__["CurrencyPipe"],
    __WEBPACK_IMPORTED_MODULE_1__date_pipe__["DatePipe"],
    __WEBPACK_IMPORTED_MODULE_2__i18n_plural_pipe__["a" /* I18nPluralPipe */],
    __WEBPACK_IMPORTED_MODULE_3__i18n_select_pipe__["a" /* I18nSelectPipe */],
];
//# sourceMappingURL=index.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_intl__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "DecimalPipe", function() { return DecimalPipe; });
/* harmony export (binding) */ __webpack_require__.d(exports, "PercentPipe", function() { return PercentPipe; });
/* harmony export (binding) */ __webpack_require__.d(exports, "CurrencyPipe", function() { return CurrencyPipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var _NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
function formatNumber(pipe, locale, value, style, digits, currency, currencyAsSymbol) {
    if (currency === void 0) { currency = null; }
    if (currencyAsSymbol === void 0) { currencyAsSymbol = false; }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["c" /* isBlank */])(value))
        return null;
    // Convert strings to numbers
    value = typeof value === 'string' && __WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].isNumeric(value) ? +value : value;
    if (typeof value !== 'number') {
        throw new __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](pipe, value);
    }
    var minInt;
    var minFraction;
    var maxFraction;
    if (style !== __WEBPACK_IMPORTED_MODULE_1__facade_intl__["b" /* NumberFormatStyle */].Currency) {
        // rely on Intl default for currency
        minInt = 1;
        minFraction = 0;
        maxFraction = 3;
    }
    if (digits) {
        var parts = digits.match(_NUMBER_FORMAT_REGEXP);
        if (parts === null) {
            throw new Error(digits + " is not a valid digit info for number pipes");
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(parts[1])) {
            minInt = __WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].parseIntAutoRadix(parts[1]);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(parts[3])) {
            minFraction = __WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].parseIntAutoRadix(parts[3]);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(parts[5])) {
            maxFraction = __WEBPACK_IMPORTED_MODULE_2__facade_lang__["m" /* NumberWrapper */].parseIntAutoRadix(parts[5]);
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1__facade_intl__["c" /* NumberFormatter */].format(value, locale, style, {
        minimumIntegerDigits: minInt,
        minimumFractionDigits: minFraction,
        maximumFractionDigits: maxFraction,
        currency: currency,
        currencyAsSymbol: currencyAsSymbol,
    });
}
/**
 * @ngModule CommonModule
 * @whatItDoes Formats a number according to locale rules.
 * @howToUse `number_expression | number[:digitInfo]`
 *
 * Formats a number as text. Group sizing and separator and other locale-specific
 * configurations are based on the active locale.
 *
 * where `expression` is a number:
 *  - `digitInfo` is a `string` which has a following format: <br>
 *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
 *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
 *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
 *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
 *
 * For more information on the acceptable range for each of these numbers and other
 * details see your native internationalization library.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {@example common/pipes/ts/number_pipe.ts region='NumberPipe'}
 *
 * @stable
 */
var DecimalPipe = (function () {
    function DecimalPipe(_locale) {
        this._locale = _locale;
    }
    DecimalPipe.prototype.transform = function (value, digits) {
        if (digits === void 0) { digits = null; }
        return formatNumber(DecimalPipe, this._locale, value, __WEBPACK_IMPORTED_MODULE_1__facade_intl__["b" /* NumberFormatStyle */].Decimal, digits);
    };
    DecimalPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'number' },] },
    ];
    /** @nocollapse */
    DecimalPipe.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
    ];
    return DecimalPipe;
}());
/**
 * @ngModule CommonModule
 * @whatItDoes Formats a number as a percentage according to locale rules.
 * @howToUse `number_expression | percent[:digitInfo]`
 *
 * @description
 *
 * Formats a number as percentage.
 *
 * - `digitInfo` See {@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {@example common/pipes/ts/number_pipe.ts region='PercentPipe'}
 *
 * @stable
 */
var PercentPipe = (function () {
    function PercentPipe(_locale) {
        this._locale = _locale;
    }
    PercentPipe.prototype.transform = function (value, digits) {
        if (digits === void 0) { digits = null; }
        return formatNumber(PercentPipe, this._locale, value, __WEBPACK_IMPORTED_MODULE_1__facade_intl__["b" /* NumberFormatStyle */].Percent, digits);
    };
    PercentPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'percent' },] },
    ];
    /** @nocollapse */
    PercentPipe.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
    ];
    return PercentPipe;
}());
/**
 * @ngModule CommonModule
 * @whatItDoes Formats a number as currency using locale rules.
 * @howToUse `number_expression | currency[:currencyCode[:symbolDisplay[:digitInfo]]]`
 * @description
 *
 * Use `currency` to format a number as currency.
 *
 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
 *    as `USD` for the US dollar and `EUR` for the euro.
 * - `symbolDisplay` is a boolean indicating whether to use the currency symbol or code.
 *   - `true`: use symbol (e.g. `$`).
 *   - `false`(default): use code (e.g. `USD`).
 * - `digitInfo` See {@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {@example common/pipes/ts/number_pipe.ts region='CurrencyPipe'}
 *
 * @stable
 */
var CurrencyPipe = (function () {
    function CurrencyPipe(_locale) {
        this._locale = _locale;
    }
    CurrencyPipe.prototype.transform = function (value, currencyCode, symbolDisplay, digits) {
        if (currencyCode === void 0) { currencyCode = 'USD'; }
        if (symbolDisplay === void 0) { symbolDisplay = false; }
        if (digits === void 0) { digits = null; }
        return formatNumber(CurrencyPipe, this._locale, value, __WEBPACK_IMPORTED_MODULE_1__facade_intl__["b" /* NumberFormatStyle */].Currency, digits, currencyCode, symbolDisplay);
    };
    CurrencyPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'currency' },] },
    ];
    /** @nocollapse */
    CurrencyPipe.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
    ];
    return CurrencyPipe;
}());
//# sourceMappingURL=number_pipe.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FILL_STYLE_FLAG; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ANY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return DEFAULT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return EMPTY_STATE; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FILL_STYLE_FLAG = 'true'; // TODO (matsko): change to boolean
var ANY_STATE = '*';
var DEFAULT_STATE = '*';
var EMPTY_STATE = 'void';
//# sourceMappingURL=animation_constants.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationGroupPlayer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var AnimationGroupPlayer = (function () {
    function AnimationGroupPlayer(_players) {
        var _this = this;
        this._players = _players;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this.parentPlayer = null;
        var count = 0;
        var total = this._players.length;
        if (total == 0) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["l" /* scheduleMicroTask */])(function () { return _this._onFinish(); });
        }
        else {
            this._players.forEach(function (player) {
                player.parentPlayer = _this;
                player.onDone(function () {
                    if (++count >= total) {
                        _this._onFinish();
                    }
                });
            });
        }
    }
    AnimationGroupPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.parentPlayer)) {
                this.destroy();
            }
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    AnimationGroupPlayer.prototype.init = function () { this._players.forEach(function (player) { return player.init(); }); };
    AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
    AnimationGroupPlayer.prototype.play = function () {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.parentPlayer)) {
            this.init();
        }
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._players.forEach(function (player) { return player.play(); });
    };
    AnimationGroupPlayer.prototype.pause = function () { this._players.forEach(function (player) { return player.pause(); }); };
    AnimationGroupPlayer.prototype.restart = function () { this._players.forEach(function (player) { return player.restart(); }); };
    AnimationGroupPlayer.prototype.finish = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.finish(); });
    };
    AnimationGroupPlayer.prototype.destroy = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.destroy(); });
    };
    AnimationGroupPlayer.prototype.reset = function () { this._players.forEach(function (player) { return player.reset(); }); };
    AnimationGroupPlayer.prototype.setPosition = function (p /** TODO #9100 */) {
        this._players.forEach(function (player) { player.setPosition(p); });
    };
    AnimationGroupPlayer.prototype.getPosition = function () {
        var min = 0;
        this._players.forEach(function (player) {
            var p = player.getPosition();
            min = Math.min(p, min);
        });
        return min;
    };
    return AnimationGroupPlayer;
}());
//# sourceMappingURL=animation_group_player.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["b"] = queueAnimation;
/* harmony export (immutable) */ exports["a"] = triggerQueuedAnimations;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _queuedAnimations = [];
/** @internal */
function queueAnimation(player) {
    _queuedAnimations.push(player);
}
/** @internal */
function triggerQueuedAnimations() {
    for (var i = 0; i < _queuedAnimations.length; i++) {
        var player = _queuedAnimations[i];
        player.play();
    }
    _queuedAnimations = [];
}
//# sourceMappingURL=animation_queue.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationTransitionEvent; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An instance of this class is returned as an event parameter when an animation
 * callback is captured for an animation either during the start or done phase.
 *
 * ```typescript
 * @Component({
 *   host: {
 *     '[@myAnimationTrigger]': 'someExpression',
 *     '(@myAnimationTrigger.start)': 'captureStartEvent($event)',
 *     '(@myAnimationTrigger.done)': 'captureDoneEvent($event)',
 *   },
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *        // ...
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   someExpression: any = false;
 *   captureStartEvent(event: AnimationTransitionEvent) {
 *     // the toState, fromState and totalTime data is accessible from the event variable
 *   }
 *
 *   captureDoneEvent(event: AnimationTransitionEvent) {
 *     // the toState, fromState and totalTime data is accessible from the event variable
 *   }
 * }
 * ```
 *
 * @experimental Animation support is experimental.
 */
var AnimationTransitionEvent = (function () {
    function AnimationTransitionEvent(_a) {
        var fromState = _a.fromState, toState = _a.toState, totalTime = _a.totalTime, phaseName = _a.phaseName;
        this.fromState = fromState;
        this.toState = toState;
        this.totalTime = totalTime;
        this.phaseName = phaseName;
    }
    return AnimationTransitionEvent;
}());
//# sourceMappingURL=animation_transition_event.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AUTO_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return AnimationEntryMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return AnimationStateMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AnimationStateDeclarationMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return AnimationStateTransitionMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return AnimationMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "g", function() { return AnimationKeyframesSequenceMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "h", function() { return AnimationStyleMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "i", function() { return AnimationAnimateMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "j", function() { return AnimationWithStepsMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "k", function() { return AnimationSequenceMetadata; });
/* harmony export (binding) */ __webpack_require__.d(exports, "l", function() { return AnimationGroupMetadata; });
/* harmony export (immutable) */ exports["m"] = animate;
/* harmony export (immutable) */ exports["n"] = group;
/* harmony export (immutable) */ exports["o"] = sequence;
/* harmony export (immutable) */ exports["p"] = style;
/* harmony export (immutable) */ exports["q"] = state;
/* harmony export (immutable) */ exports["r"] = keyframes;
/* harmony export (immutable) */ exports["s"] = transition;
/* harmony export (immutable) */ exports["t"] = trigger;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * @experimental Animation support is experimental.
 */
var AUTO_STYLE = '*';
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link trigger trigger
 * animation function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationEntryMetadata = (function () {
    function AnimationEntryMetadata(name, definitions) {
        this.name = name;
        this.definitions = definitions;
    }
    return AnimationEntryMetadata;
}());
/**
 * @experimental Animation support is experimental.
 */
var AnimationStateMetadata = (function () {
    function AnimationStateMetadata() {
    }
    return AnimationStateMetadata;
}());
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link state state animation
 * function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationStateDeclarationMetadata = (function (_super) {
    __extends(AnimationStateDeclarationMetadata, _super);
    function AnimationStateDeclarationMetadata(stateNameExpr, styles) {
        _super.call(this);
        this.stateNameExpr = stateNameExpr;
        this.styles = styles;
    }
    return AnimationStateDeclarationMetadata;
}(AnimationStateMetadata));
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the
 * {@link transition transition animation function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationStateTransitionMetadata = (function (_super) {
    __extends(AnimationStateTransitionMetadata, _super);
    function AnimationStateTransitionMetadata(stateChangeExpr, steps) {
        _super.call(this);
        this.stateChangeExpr = stateChangeExpr;
        this.steps = steps;
    }
    return AnimationStateTransitionMetadata;
}(AnimationStateMetadata));
/**
 * @experimental Animation support is experimental.
 */
var AnimationMetadata = (function () {
    function AnimationMetadata() {
    }
    return AnimationMetadata;
}());
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link keyframes keyframes
 * animation function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationKeyframesSequenceMetadata = (function (_super) {
    __extends(AnimationKeyframesSequenceMetadata, _super);
    function AnimationKeyframesSequenceMetadata(steps) {
        _super.call(this);
        this.steps = steps;
    }
    return AnimationKeyframesSequenceMetadata;
}(AnimationMetadata));
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link style style animation
 * function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationStyleMetadata = (function (_super) {
    __extends(AnimationStyleMetadata, _super);
    function AnimationStyleMetadata(styles, offset) {
        if (offset === void 0) { offset = null; }
        _super.call(this);
        this.styles = styles;
        this.offset = offset;
    }
    return AnimationStyleMetadata;
}(AnimationMetadata));
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link animate animate
 * animation function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationAnimateMetadata = (function (_super) {
    __extends(AnimationAnimateMetadata, _super);
    function AnimationAnimateMetadata(timings, styles) {
        _super.call(this);
        this.timings = timings;
        this.styles = styles;
    }
    return AnimationAnimateMetadata;
}(AnimationMetadata));
/**
 * @experimental Animation support is experimental.
 */
var AnimationWithStepsMetadata = (function (_super) {
    __extends(AnimationWithStepsMetadata, _super);
    function AnimationWithStepsMetadata() {
        _super.call(this);
    }
    Object.defineProperty(AnimationWithStepsMetadata.prototype, "steps", {
        get: function () { throw new Error('NOT IMPLEMENTED: Base Class'); },
        enumerable: true,
        configurable: true
    });
    return AnimationWithStepsMetadata;
}(AnimationMetadata));
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link sequence sequence
 * animation function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationSequenceMetadata = (function (_super) {
    __extends(AnimationSequenceMetadata, _super);
    function AnimationSequenceMetadata(_steps) {
        _super.call(this);
        this._steps = _steps;
    }
    Object.defineProperty(AnimationSequenceMetadata.prototype, "steps", {
        get: function () { return this._steps; },
        enumerable: true,
        configurable: true
    });
    return AnimationSequenceMetadata;
}(AnimationWithStepsMetadata));
/**
 * Metadata representing the entry of animations.
 * Instances of this class are provided via the animation DSL when the {@link group group animation
 * function} is called.
 *
 * @experimental Animation support is experimental.
 */
var AnimationGroupMetadata = (function (_super) {
    __extends(AnimationGroupMetadata, _super);
    function AnimationGroupMetadata(_steps) {
        _super.call(this);
        this._steps = _steps;
    }
    Object.defineProperty(AnimationGroupMetadata.prototype, "steps", {
        get: function () { return this._steps; },
        enumerable: true,
        configurable: true
    });
    return AnimationGroupMetadata;
}(AnimationWithStepsMetadata));
/**
 * `animate` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `animate` specifies an animation step that will apply the provided `styles` data for a given
 * amount of
 * time based on the provided `timing` expression value. Calls to `animate` are expected to be
 * used within {@link sequence an animation sequence}, {@link group group}, or {@link transition
 * transition}.
 *
 * ### Usage
 *
 * The `animate` function accepts two input parameters: `timing` and `styles`:
 *
 * - `timing` is a string based value that can be a combination of a duration with optional
 * delay and easing values. The format for the expression breaks down to `duration delay easing`
 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
 * delay=100, easing=ease-out`.
 * If a numeric value is provided then that will be used as the `duration` value in millisecond
 * form.
 * - `styles` is the style input data which can either be a call to {@link style style} or {@link
 * keyframes keyframes}.
 * If left empty then the styles from the destination state will be collected and used (this is
 * useful when
 * describing an animation step that will complete an animation by {@link
 * transition#the-final-animate-call animating to the final state}).
 *
 * ```typescript
 * // various functions for specifying timing data
 * animate(500, style(...))
 * animate("1s", style(...))
 * animate("100ms 0.5s", style(...))
 * animate("5s ease", style(...))
 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
 *
 * // either style() of keyframes() can be used
 * animate(500, style({ background: "red" }))
 * animate(500, keyframes([
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 * ])
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function animate(timing, styles) {
    if (styles === void 0) { styles = null; }
    var stylesEntry = styles;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(stylesEntry)) {
        var EMPTY_STYLE = {};
        stylesEntry = new AnimationStyleMetadata([EMPTY_STYLE], 1);
    }
    return new AnimationAnimateMetadata(timing, stylesEntry);
}
/**
 * `group` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations
 * are useful when a series of styles must be animated/closed off
 * at different statrting/ending times.
 *
 * The `group` function can either be used within a {@link sequence sequence} or a {@link transition
 * transition}
 * and it will only continue to the next instruction once all of the inner animation steps
 * have completed.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `group` animation function can either consist
 * of {@link style style} or {@link animate animate} function calls. Each call to `style()` or
 * `animate()`
 * within a group will be executed instantly (use {@link keyframes keyframes} or a
 * {@link animate#usage animate() with a delay value} to offset styles to be applied at a later
 * time).
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function group(steps) {
    return new AnimationGroupMetadata(steps);
}
/**
 * `sequence` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used
 * by default when an array is passed as animation data into {@link transition transition}.)
 *
 * The `sequence` function can either be used within a {@link group group} or a {@link transition
 * transition}
 * and it will only continue to the next instruction once each of the inner animation steps
 * have completed.
 *
 * To perform animation styling in parallel with other animation steps then
 * have a look at the {@link group group} animation function.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `sequence` animation function can either consist
 * of {@link style style} or {@link animate animate} function calls. A call to `style()` will apply
 * the
 * provided styling data immediately while a call to `animate()` will apply its styling
 * data over a given time depending on its timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function sequence(steps) {
    return new AnimationSequenceMetadata(steps);
}
/**
 * `style` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `style` declares a key/value object containing CSS properties/styles that can then
 * be used for {@link state animation states}, within an {@link sequence animation sequence}, or as
 * styling data for both {@link animate animate} and {@link keyframes keyframes}.
 *
 * ### Usage
 *
 * `style` takes in a key/value string map as data and expects one or more CSS property/value
 * pairs to be defined.
 *
 * ```typescript
 * // string values are used for css properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical (pixel) values are also supported
 * style({ width: 100, height: 0 })
 * ```
 *
 * #### Auto-styles (using `*`)
 *
 * When an asterix (`*`) character is used as a value then it will be detected from the element
 * being animated
 * and applied as animation data when the animation starts.
 *
 * This feature proves useful for a state depending on layout and/or environment factors; in such
 * cases
 * the styles are calculated just before the animation starts.
 *
 * ```typescript
 * // the steps below will animate from 0 to the
 * // actual height of the element
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function style(tokens) {
    var input;
    var offset = null;
    if (typeof tokens === 'string') {
        input = [tokens];
    }
    else {
        if (Array.isArray(tokens)) {
            input = tokens;
        }
        else {
            input = [tokens];
        }
        input.forEach(function (entry) {
            var entryOffset = entry['offset'];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(entryOffset)) {
                offset = offset == null ? parseFloat(entryOffset) : offset;
            }
        });
    }
    return new AnimationStyleMetadata(input, offset);
}
/**
 * `state` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `state` declares an animation state within the given trigger. When a state is
 * active within a component then its associated styles will persist on
 * the element that the trigger is attached to (even when the animation ends).
 *
 * To animate between states, have a look at the animation {@link transition transition}
 * DSL function. To register states to an animation trigger please have a look
 * at the {@link trigger trigger} function.
 *
 * #### The `void` state
 *
 * The `void` state value is a reserved word that angular uses to determine when the element is not
 * apart
 * of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
 * associated element
 * is void).
 *
 * #### The `*` (default) state
 *
 * The `*` state (when styled) is a fallback state that will be used if
 * the state that is being animated is not declared within the trigger.
 *
 * ### Usage
 *
 * `state` will declare an animation state with its associated styles
 * within the given trigger.
 *
 * - `stateNameExpr` can be one or more state names separated by commas.
 * - `styles` refers to the {@link style styling data} that will be persisted on the element once
 * the state
 * has been reached.
 *
 * ```typescript
 * // "void" is a reserved name for a state and is used to represent
 * // the state in which an element is detached from from the application.
 * state("void", style({ height: 0 }))
 *
 * // user-defined states
 * state("closed", style({ height: 0 }))
 * state("open, visible", style({ height: "*" }))
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function state(stateNameExpr, styles) {
    return new AnimationStateDeclarationMetadata(stateNameExpr, styles);
}
/**
 * `keyframes` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `keyframes` specifies a collection of {@link style style} entries each optionally characterized
 * by an `offset` value.
 *
 * ### Usage
 *
 * The `keyframes` animation function is designed to be used alongside the {@link animate animate}
 * animation function. Instead of applying animations from where they are
 * currently to their destination, keyframes can describe how each style entry is applied
 * and at what point within the animation arc (much like CSS Keyframe Animations do).
 *
 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at
 * what percentage of the animate time the styles will be applied.
 *
 * ```typescript
 * // the provided offset values describe when each backgroundColor value is applied.
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * Alternatively, if there are no `offset` values used within the style entries then the offsets
 * will
 * be calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function keyframes(steps) {
    return new AnimationKeyframesSequenceMetadata(steps);
}
/**
 * `transition` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `transition` declares the {@link sequence sequence of animation steps} that will be run when the
 * provided
 * `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 => state2`
 * which consists
 * of two known states (use an asterix (`*`) to refer to a dynamic starting and/or ending state).
 *
 * Animation transitions are placed within an {@link trigger animation trigger}. For an transition
 * to animate to
 * a state value and persist its styles then one or more {@link state animation states} is expected
 * to be defined.
 *
 * ### Usage
 *
 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
 * what the
 * previous state is and what the current state has become. In other words, if a transition is
 * defined that
 * matches the old/current state criteria then the associated animation will be triggered.
 *
 * ```typescript
 * // all transition/state changes are defined within an animation trigger
 * trigger("myAnimationTrigger", [
 *   // if a state is defined then its styles will be persisted when the
 *   // animation has fully completed itself
 *   state("on", style({ background: "green" })),
 *   state("off", style({ background: "grey" })),
 *
 *   // a transition animation that will be kicked off when the state value
 *   // bound to "myAnimationTrigger" changes from "on" to "off"
 *   transition("on => off", animate(500)),
 *
 *   // it is also possible to do run the same animation for both directions
 *   transition("on <=> off", animate(500)),
 *
 *   // or to define multiple states pairs separated by commas
 *   transition("on => off, off => void", animate(500)),
 *
 *   // this is a catch-all state change for when an element is inserted into
 *   // the page and the destination state is unknown
 *   transition("void => *", [
 *     style({ opacity: 0 }),
 *     animate(500)
 *   ]),
 *
 *   // this will capture a state change between any states
 *   transition("* => *", animate("1s 0s")),
 * ])
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger`
 * animation trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * #### The final `animate` call
 *
 * If the final step within the transition steps is a call to `animate()` that **only**
 * uses a timing value with **no style data** then it will be automatically used as the final
 * animation
 * arc for the element to animate itself to the final state. This involves an automatic mix of
 * adding/removing CSS styles so that the element will be in the exact state it should be for the
 * applied state to be presented correctly.
 *
 * ```
 * // start off by hiding the element, but make sure that it animates properly to whatever state
 * // is currently active for "myAnimationTrigger"
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 * ])
 * ```
 *
 * ### Transition Aliases (`:enter` and `:leave`)
 *
 * Given that enter (insertion) and leave (removal) animations are so common,
 * the `transition` function accepts both `:enter` and `:leave` values which
 * are aliases for the `void => *` and `* => void` state changes.
 *
 * ```
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 * ])
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 * ])
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function transition(stateChangeExpr, steps) {
    var animationData = Array.isArray(steps) ? new AnimationSequenceMetadata(steps) : steps;
    return new AnimationStateTransitionMetadata(stateChangeExpr, animationData);
}
/**
 * `trigger` is an animation-specific function that is designed to be used inside of Angular2's
 * animation
 * DSL language. If this information is new, please navigate to the
 * {@link Component#animations-anchor component animations metadata
 * page} to gain a better understanding of how animations in Angular2 are used.
 *
 * `trigger` Creates an animation trigger which will a list of {@link state state} and {@link
 * transition transition}
 * entries that will be evaluated when the expression bound to the trigger changes.
 *
 * Triggers are registered within the component annotation data under the
 * {@link Component#animations-anchor animations section}. An animation trigger can
 * be placed on an element within a template by referencing the name of the
 * trigger followed by the expression value that the trigger is bound to
 * (in the form of `[@triggerName]="expression"`.
 *
 * ### Usage
 *
 * `trigger` will create an animation trigger reference based on the provided `name` value.
 * The provided `animation` value is expected to be an array consisting of {@link state state} and
 * {@link transition transition}
 * declarations.
 *
 * ```typescript
 * @Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger`
 * animation trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * ### Example ([live demo](http://plnkr.co/edit/Kez8XGWBxWue7qP7nNvF?p=preview))
 *
 * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * @experimental Animation support is experimental.
 */
function trigger(name, animation) {
    return new AnimationEntryMetadata(name, animation);
}
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_init__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__application_ref__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__application_tokens__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__change_detection_change_detection__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_tokens__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__linker_compiler__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__linker_view_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata__ = __webpack_require__(272);
/* harmony export (immutable) */ exports["_iterableDiffersFactory"] = _iterableDiffersFactory;
/* harmony export (immutable) */ exports["_keyValueDiffersFactory"] = _keyValueDiffersFactory;
/* harmony export (binding) */ __webpack_require__.d(exports, "ApplicationModule", function() { return ApplicationModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */








function _iterableDiffersFactory() {
    return __WEBPACK_IMPORTED_MODULE_3__change_detection_change_detection__["defaultIterableDiffers"];
}
function _keyValueDiffersFactory() {
    return __WEBPACK_IMPORTED_MODULE_3__change_detection_change_detection__["defaultKeyValueDiffers"];
}
/**
 * This module includes the providers of @angular/core that are needed
 * to bootstrap components via `ApplicationRef`.
 *
 * @experimental
 */
var ApplicationModule = (function () {
    function ApplicationModule() {
    }
    ApplicationModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_7__metadata__["a" /* NgModule */], args: [{
                    providers: [
                        __WEBPACK_IMPORTED_MODULE_1__application_ref__["ApplicationRef_"],
                        { provide: __WEBPACK_IMPORTED_MODULE_1__application_ref__["ApplicationRef"], useExisting: __WEBPACK_IMPORTED_MODULE_1__application_ref__["ApplicationRef_"] },
                        __WEBPACK_IMPORTED_MODULE_0__application_init__["ApplicationInitStatus"],
                        __WEBPACK_IMPORTED_MODULE_5__linker_compiler__["Compiler"],
                        __WEBPACK_IMPORTED_MODULE_2__application_tokens__["APP_ID_RANDOM_PROVIDER"],
                        __WEBPACK_IMPORTED_MODULE_6__linker_view_utils__["ViewUtils"],
                        { provide: __WEBPACK_IMPORTED_MODULE_3__change_detection_change_detection__["IterableDiffers"], useFactory: _iterableDiffersFactory },
                        { provide: __WEBPACK_IMPORTED_MODULE_3__change_detection_change_detection__["KeyValueDiffers"], useFactory: _keyValueDiffersFactory },
                        { provide: __WEBPACK_IMPORTED_MODULE_4__i18n_tokens__["LOCALE_ID"], useValue: 'en-US' },
                    ]
                },] },
    ];
    /** @nocollapse */
    ApplicationModule.ctorParameters = [];
    return ApplicationModule;
}());
//# sourceMappingURL=application_module.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultKeyValueDifferFactory; });
/* unused harmony export DefaultKeyValueDiffer */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return KeyValueChangeRecord; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var DefaultKeyValueDifferFactory = (function () {
    function DefaultKeyValueDifferFactory() {
    }
    DefaultKeyValueDifferFactory.prototype.supports = function (obj) { return obj instanceof Map || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["e" /* isJsObject */])(obj); };
    DefaultKeyValueDifferFactory.prototype.create = function (cdRef) { return new DefaultKeyValueDiffer(); };
    return DefaultKeyValueDifferFactory;
}());
var DefaultKeyValueDiffer = (function () {
    function DefaultKeyValueDiffer() {
        this._records = new Map();
        this._mapHead = null;
        this._previousMapHead = null;
        this._changesHead = null;
        this._changesTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
    }
    Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
        get: function () {
            return this._additionsHead !== null || this._changesHead !== null ||
                this._removalsHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    DefaultKeyValueDiffer.prototype.forEachItem = function (fn) {
        var record;
        for (record = this._mapHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachPreviousItem = function (fn) {
        var record;
        for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachChangedItem = function (fn) {
        var record;
        for (record = this._changesHead; record !== null; record = record._nextChanged) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachAddedItem = function (fn) {
        var record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachRemovedItem = function (fn) {
        var record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.diff = function (map) {
        if (!map) {
            map = new Map();
        }
        else if (!(map instanceof Map || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["e" /* isJsObject */])(map))) {
            throw new Error("Error trying to diff '" + map + "'");
        }
        return this.check(map) ? this : null;
    };
    DefaultKeyValueDiffer.prototype.onDestroy = function () { };
    DefaultKeyValueDiffer.prototype.check = function (map) {
        var _this = this;
        this._reset();
        var records = this._records;
        var oldSeqRecord = this._mapHead;
        var lastOldSeqRecord = null;
        var lastNewSeqRecord = null;
        var seqChanged = false;
        this._forEach(map, function (value, key) {
            var newSeqRecord;
            if (oldSeqRecord && key === oldSeqRecord.key) {
                newSeqRecord = oldSeqRecord;
                _this._maybeAddToChanges(newSeqRecord, value);
            }
            else {
                seqChanged = true;
                if (oldSeqRecord !== null) {
                    _this._removeFromSeq(lastOldSeqRecord, oldSeqRecord);
                    _this._addToRemovals(oldSeqRecord);
                }
                if (records.has(key)) {
                    newSeqRecord = records.get(key);
                    _this._maybeAddToChanges(newSeqRecord, value);
                }
                else {
                    newSeqRecord = new KeyValueChangeRecord(key);
                    records.set(key, newSeqRecord);
                    newSeqRecord.currentValue = value;
                    _this._addToAdditions(newSeqRecord);
                }
            }
            if (seqChanged) {
                if (_this._isInRemovals(newSeqRecord)) {
                    _this._removeFromRemovals(newSeqRecord);
                }
                if (lastNewSeqRecord == null) {
                    _this._mapHead = newSeqRecord;
                }
                else {
                    lastNewSeqRecord._next = newSeqRecord;
                }
            }
            lastOldSeqRecord = oldSeqRecord;
            lastNewSeqRecord = newSeqRecord;
            oldSeqRecord = oldSeqRecord && oldSeqRecord._next;
        });
        this._truncate(lastOldSeqRecord, oldSeqRecord);
        return this.isDirty;
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var record = void 0;
            // Record the state of the mapping
            for (record = this._previousMapHead = this._mapHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            for (record = this._changesHead; record !== null; record = record._nextChanged) {
                record.previousValue = record.currentValue;
            }
            for (record = this._additionsHead; record != null; record = record._nextAdded) {
                record.previousValue = record.currentValue;
            }
            this._changesHead = this._changesTail = null;
            this._additionsHead = this._additionsTail = null;
            this._removalsHead = this._removalsTail = null;
        }
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._truncate = function (lastRecord, record) {
        while (record !== null) {
            if (lastRecord === null) {
                this._mapHead = null;
            }
            else {
                lastRecord._next = null;
            }
            var nextRecord = record._next;
            this._addToRemovals(record);
            lastRecord = record;
            record = nextRecord;
        }
        for (var rec = this._removalsHead; rec !== null; rec = rec._nextRemoved) {
            rec.previousValue = rec.currentValue;
            rec.currentValue = null;
            this._records.delete(rec.key);
        }
    };
    DefaultKeyValueDiffer.prototype._maybeAddToChanges = function (record, newValue) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["i" /* looseIdentical */])(newValue, record.currentValue)) {
            record.previousValue = record.currentValue;
            record.currentValue = newValue;
            this._addToChanges(record);
        }
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._isInRemovals = function (record) {
        return record === this._removalsHead || record._nextRemoved !== null ||
            record._prevRemoved !== null;
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._addToRemovals = function (record) {
        if (this._removalsHead === null) {
            this._removalsHead = this._removalsTail = record;
        }
        else {
            this._removalsTail._nextRemoved = record;
            record._prevRemoved = this._removalsTail;
            this._removalsTail = record;
        }
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._removeFromSeq = function (prev, record) {
        var next = record._next;
        if (prev === null) {
            this._mapHead = next;
        }
        else {
            prev._next = next;
        }
        record._next = null;
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._removeFromRemovals = function (record) {
        var prev = record._prevRemoved;
        var next = record._nextRemoved;
        if (prev === null) {
            this._removalsHead = next;
        }
        else {
            prev._nextRemoved = next;
        }
        if (next === null) {
            this._removalsTail = prev;
        }
        else {
            next._prevRemoved = prev;
        }
        record._prevRemoved = record._nextRemoved = null;
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._addToAdditions = function (record) {
        if (this._additionsHead === null) {
            this._additionsHead = this._additionsTail = record;
        }
        else {
            this._additionsTail._nextAdded = record;
            this._additionsTail = record;
        }
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._addToChanges = function (record) {
        if (this._changesHead === null) {
            this._changesHead = this._changesTail = record;
        }
        else {
            this._changesTail._nextChanged = record;
            this._changesTail = record;
        }
    };
    DefaultKeyValueDiffer.prototype.toString = function () {
        var items = [];
        var previous = [];
        var changes = [];
        var additions = [];
        var removals = [];
        var record;
        for (record = this._mapHead; record !== null; record = record._next) {
            items.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(record));
        }
        for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
            previous.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(record));
        }
        for (record = this._changesHead; record !== null; record = record._nextChanged) {
            changes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(record));
        }
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            additions.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(record));
        }
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            removals.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(record));
        }
        return 'map: ' + items.join(', ') + '\n' +
            'previous: ' + previous.join(', ') + '\n' +
            'additions: ' + additions.join(', ') + '\n' +
            'changes: ' + changes.join(', ') + '\n' +
            'removals: ' + removals.join(', ') + '\n';
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._forEach = function (obj, fn) {
        if (obj instanceof Map) {
            obj.forEach(fn);
        }
        else {
            Object.keys(obj).forEach(function (k) { return fn(obj[k], k); });
        }
    };
    return DefaultKeyValueDiffer;
}());
/**
 * @stable
 */
var KeyValueChangeRecord = (function () {
    function KeyValueChangeRecord(key) {
        this.key = key;
        this.previousValue = null;
        this.currentValue = null;
        /** @internal */
        this._nextPrevious = null;
        /** @internal */
        this._next = null;
        /** @internal */
        this._nextAdded = null;
        /** @internal */
        this._nextRemoved = null;
        /** @internal */
        this._prevRemoved = null;
        /** @internal */
        this._nextChanged = null;
    }
    KeyValueChangeRecord.prototype.toString = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["i" /* looseIdentical */])(this.previousValue, this.currentValue) ?
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this.key) :
            (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this.key) + '[' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this.previousValue) + '->' +
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(this.currentValue) + ']');
    };
    return KeyValueChangeRecord;
}());
//# sourceMappingURL=default_keyvalue_differ.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return AbstractProviderError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "h", function() { return NoProviderError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return CyclicDependencyError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "g", function() { return InstantiationError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return InvalidProviderError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NoAnnotationError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return OutOfBoundsError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return MixingMultiProvidersWithRegularProvidersError; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


function findFirstClosedCycle(keys) {
    var res = [];
    for (var i = 0; i < keys.length; ++i) {
        if (res.indexOf(keys[i]) > -1) {
            res.push(keys[i]);
            return res;
        }
        res.push(keys[i]);
    }
    return res;
}
function constructResolvingPath(keys) {
    if (keys.length > 1) {
        var reversed = findFirstClosedCycle(keys.slice().reverse());
        var tokenStrs = reversed.map(function (k) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(k.token); });
        return ' (' + tokenStrs.join(' -> ') + ')';
    }
    return '';
}
/**
 * Base class for all errors arising from misconfigured providers.
 * @stable
 */
var AbstractProviderError = (function (_super) {
    __extends(AbstractProviderError, _super);
    function AbstractProviderError(injector, key, constructResolvingMessage) {
        _super.call(this, 'DI Error');
        this.keys = [key];
        this.injectors = [injector];
        this.constructResolvingMessage = constructResolvingMessage;
        this.message = this.constructResolvingMessage(this.keys);
    }
    AbstractProviderError.prototype.addKey = function (injector, key) {
        this.injectors.push(injector);
        this.keys.push(key);
        this.message = this.constructResolvingMessage(this.keys);
    };
    return AbstractProviderError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
/**
 * Thrown when trying to retrieve a dependency by key from {@link Injector}, but the
 * {@link Injector} does not have a {@link Provider} for the given key.
 *
 * ### Example ([live demo](http://plnkr.co/edit/vq8D3FRB9aGbnWJqtEPE?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor(b:B) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 * @stable
 */
var NoProviderError = (function (_super) {
    __extends(NoProviderError, _super);
    function NoProviderError(injector, key) {
        _super.call(this, injector, key, function (keys) {
            var first = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(keys[0].token);
            return "No provider for " + first + "!" + constructResolvingPath(keys);
        });
    }
    return NoProviderError;
}(AbstractProviderError));
/**
 * Thrown when dependencies form a cycle.
 *
 * ### Example ([live demo](http://plnkr.co/edit/wYQdNos0Tzql3ei1EV9j?p=info))
 *
 * ```typescript
 * var injector = Injector.resolveAndCreate([
 *   {provide: "one", useFactory: (two) => "two", deps: [[new Inject("two")]]},
 *   {provide: "two", useFactory: (one) => "one", deps: [[new Inject("one")]]}
 * ]);
 *
 * expect(() => injector.get("one")).toThrowError();
 * ```
 *
 * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
 * @stable
 */
var CyclicDependencyError = (function (_super) {
    __extends(CyclicDependencyError, _super);
    function CyclicDependencyError(injector, key) {
        _super.call(this, injector, key, function (keys) {
            return "Cannot instantiate cyclic dependency!" + constructResolvingPath(keys);
        });
    }
    return CyclicDependencyError;
}(AbstractProviderError));
/**
 * Thrown when a constructing type returns with an Error.
 *
 * The `InstantiationError` class contains the original error plus the dependency graph which caused
 * this object to be instantiated.
 *
 * ### Example ([live demo](http://plnkr.co/edit/7aWYdcqTQsP0eNqEdUAf?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor() {
 *     throw new Error('message');
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([A]);

 * try {
 *   injector.get(A);
 * } catch (e) {
 *   expect(e instanceof InstantiationError).toBe(true);
 *   expect(e.originalException.message).toEqual("message");
 *   expect(e.originalStack).toBeDefined();
 * }
 * ```
 * @stable
 */
var InstantiationError = (function (_super) {
    __extends(InstantiationError, _super);
    function InstantiationError(injector, originalException, originalStack, key) {
        _super.call(this, 'DI Error', originalException);
        this.keys = [key];
        this.injectors = [injector];
    }
    InstantiationError.prototype.addKey = function (injector, key) {
        this.injectors.push(injector);
        this.keys.push(key);
    };
    Object.defineProperty(InstantiationError.prototype, "message", {
        get: function () {
            var first = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(this.keys[0].token);
            return this.originalError.message + ": Error during instantiation of " + first + "!" + constructResolvingPath(this.keys) + ".";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InstantiationError.prototype, "causeKey", {
        get: function () { return this.keys[0]; },
        enumerable: true,
        configurable: true
    });
    return InstantiationError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["c" /* WrappedError */]));
/**
 * Thrown when an object other then {@link Provider} (or `Type`) is passed to {@link Injector}
 * creation.
 *
 * ### Example ([live demo](http://plnkr.co/edit/YatCFbPAMCL0JSSQ4mvH?p=preview))
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
 * ```
 * @stable
 */
var InvalidProviderError = (function (_super) {
    __extends(InvalidProviderError, _super);
    function InvalidProviderError(provider) {
        _super.call(this, "Invalid provider - only instances of Provider and Type are allowed, got: " + provider);
    }
    return InvalidProviderError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
/**
 * Thrown when the class has no annotation information.
 *
 * Lack of annotation information prevents the {@link Injector} from determining which dependencies
 * need to be injected into the constructor.
 *
 * ### Example ([live demo](http://plnkr.co/edit/rHnZtlNS7vJOPQ6pcVkm?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor(b) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 *
 * This error is also thrown when the class not marked with {@link Injectable} has parameter types.
 *
 * ```typescript
 * class B {}
 *
 * class A {
 *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
 * }
 *
 * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
 * ```
 * @stable
 */
var NoAnnotationError = (function (_super) {
    __extends(NoAnnotationError, _super);
    function NoAnnotationError(typeOrFunc, params) {
        _super.call(this, NoAnnotationError._genMessage(typeOrFunc, params));
    }
    NoAnnotationError._genMessage = function (typeOrFunc, params) {
        var signature = [];
        for (var i = 0, ii = params.length; i < ii; i++) {
            var parameter = params[i];
            if (!parameter || parameter.length == 0) {
                signature.push('?');
            }
            else {
                signature.push(parameter.map(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */]).join(' '));
            }
        }
        return 'Cannot resolve all parameters for \'' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(typeOrFunc) + '\'(' +
            signature.join(', ') + '). ' +
            'Make sure that all the parameters are decorated with Inject or have valid type annotations and that \'' +
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["b" /* stringify */])(typeOrFunc) + '\' is decorated with Injectable.';
    };
    return NoAnnotationError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
/**
 * Thrown when getting an object by index.
 *
 * ### Example ([live demo](http://plnkr.co/edit/bRs0SX2OTQiJzqvjgl8P?p=preview))
 *
 * ```typescript
 * class A {}
 *
 * var injector = Injector.resolveAndCreate([A]);
 *
 * expect(() => injector.getAt(100)).toThrowError();
 * ```
 * @stable
 */
var OutOfBoundsError = (function (_super) {
    __extends(OutOfBoundsError, _super);
    function OutOfBoundsError(index) {
        _super.call(this, "Index " + index + " is out-of-bounds.");
    }
    return OutOfBoundsError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
// TODO: add a working example after alpha38 is released
/**
 * Thrown when a multi provider and a regular provider are bound to the same token.
 *
 * ### Example
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate([
 *   { provide: "Strings", useValue: "string1", multi: true},
 *   { provide: "Strings", useValue: "string2", multi: false}
 * ])).toThrowError();
 * ```
 */
var MixingMultiProvidersWithRegularProvidersError = (function (_super) {
    __extends(MixingMultiProvidersWithRegularProvidersError, _super);
    function MixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
        _super.call(this, 'Cannot mix multi providers and regular providers, got: ' + provider1.toString() + ' ' +
            provider2.toString());
    }
    return MixingMultiProvidersWithRegularProvidersError;
}(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["b" /* BaseError */]));
//# sourceMappingURL=reflective_errors.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_type__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return StaticNodeDebugInfo; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DebugContext; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var StaticNodeDebugInfo = (function () {
    function StaticNodeDebugInfo(providerTokens, componentToken, refTokens) {
        this.providerTokens = providerTokens;
        this.componentToken = componentToken;
        this.refTokens = refTokens;
    }
    return StaticNodeDebugInfo;
}());
var DebugContext = (function () {
    function DebugContext(_view, _nodeIndex, _tplRow, _tplCol) {
        this._view = _view;
        this._nodeIndex = _nodeIndex;
        this._tplRow = _tplRow;
        this._tplCol = _tplCol;
    }
    Object.defineProperty(DebugContext.prototype, "_staticNodeInfo", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this._nodeIndex) ? this._view.staticNodeDebugInfos[this._nodeIndex] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "context", {
        get: function () { return this._view.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "component", {
        get: function () {
            var staticNodeInfo = this._staticNodeInfo;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(staticNodeInfo) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(staticNodeInfo.componentToken)) {
                return this.injector.get(staticNodeInfo.componentToken);
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "componentRenderElement", {
        get: function () {
            var componentView = this._view;
            while (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(componentView.declarationAppElement) &&
                componentView.type !== __WEBPACK_IMPORTED_MODULE_1__view_type__["ViewType"].COMPONENT) {
                componentView = componentView.declarationAppElement.parentView;
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(componentView.declarationAppElement) ?
                componentView.declarationAppElement.nativeElement :
                null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "injector", {
        get: function () { return this._view.injector(this._nodeIndex); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "renderNode", {
        get: function () {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this._nodeIndex) && this._view.allNodes) {
                return this._view.allNodes[this._nodeIndex];
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "providerTokens", {
        get: function () {
            var staticNodeInfo = this._staticNodeInfo;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(staticNodeInfo) ? staticNodeInfo.providerTokens : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "source", {
        get: function () {
            return this._view.componentType.templateUrl + ":" + this._tplRow + ":" + this._tplCol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext.prototype, "references", {
        get: function () {
            var _this = this;
            var varValues = {};
            var staticNodeInfo = this._staticNodeInfo;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(staticNodeInfo)) {
                var refs = staticNodeInfo.refTokens;
                Object.keys(refs).forEach(function (refName) {
                    var refToken = refs[refName];
                    var varValue;
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isBlank */])(refToken)) {
                        varValue = _this._view.allNodes ? _this._view.allNodes[_this._nodeIndex] : null;
                    }
                    else {
                        varValue = _this._view.injectorGet(refToken, _this._nodeIndex, null);
                    }
                    varValues[refName] = varValue;
                });
            }
            return varValues;
        },
        enumerable: true,
        configurable: true
    });
    return DebugContext;
}());
//# sourceMappingURL=debug_context.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection_util__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_errors__ = __webpack_require__(42);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ExpressionChangedAfterItHasBeenCheckedError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ViewWrappedError; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ViewDestroyedError; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * An error thrown if application changes model breaking the top-down data flow.
 *
 * This exception is only thrown in dev mode.
 *
 * <!-- TODO: Add a link once the dev mode option is configurable -->
 *
 * ### Example
 *
 * ```typescript
 * @Component({
 *   selector: 'parent',
 *   template: '<child [prop]="parentProp"></child>',
 * })
 * class Parent {
 *   parentProp = 'init';
 * }
 *
 * @Directive({selector: 'child', inputs: ['prop']})
 * class Child {
 *   constructor(public parent: Parent) {}
 *
 *   set prop(v) {
 *     // this updates the parent property, which is disallowed during change detection
 *     // this will result in ExpressionChangedAfterItHasBeenCheckedError
 *     this.parent.parentProp = 'updated';
 *   }
 * }
 * ```
 * @stable
 */
var ExpressionChangedAfterItHasBeenCheckedError = (function (_super) {
    __extends(ExpressionChangedAfterItHasBeenCheckedError, _super);
    function ExpressionChangedAfterItHasBeenCheckedError(oldValue, currValue) {
        var msg = "Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
        if (oldValue === __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection_util__["a" /* UNINITIALIZED */]) {
            msg +=
                " It seems like the view has been created after its parent and its children have been dirty checked." +
                    " Has it been created in a change detection hook ?";
        }
        _super.call(this, msg);
    }
    return ExpressionChangedAfterItHasBeenCheckedError;
}(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["b" /* BaseError */]));
/**
 * Thrown when an exception was raised during view creation, change detection or destruction.
 *
 * This error wraps the original exception to attach additional contextual information that can
 * be useful for debugging.
 * @stable
 */
var ViewWrappedError = (function (_super) {
    __extends(ViewWrappedError, _super);
    function ViewWrappedError(originalError, context) {
        _super.call(this, "Error in " + context.source, originalError);
        this.context = context;
    }
    return ViewWrappedError;
}(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["c" /* WrappedError */]));
/**
 * Thrown when a destroyed view is used.
 *
 * This error indicates a bug in the framework.
 *
 * This is an internal Angular error.
 * @stable
 */
var ViewDestroyedError = (function (_super) {
    __extends(ViewDestroyedError, _super);
    function ViewDestroyedError(details) {
        _super.call(this, "Attempt to use a destroyed view: " + details);
    }
    return ViewDestroyedError;
}(__WEBPACK_IMPORTED_MODULE_1__facade_errors__["b" /* BaseError */]));
//# sourceMappingURL=errors.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compiler__ = __webpack_require__(89);
/* harmony export (binding) */ __webpack_require__.d(exports, "SystemJsNgModuleLoaderConfig", function() { return SystemJsNgModuleLoaderConfig; });
/* harmony export (binding) */ __webpack_require__.d(exports, "SystemJsNgModuleLoader", function() { return SystemJsNgModuleLoader; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var _SEPARATOR = '#';
var FACTORY_CLASS_SUFFIX = 'NgFactory';
/**
 * Configuration for SystemJsNgModuleLoader.
 * token.
 *
 * @experimental
 */
var SystemJsNgModuleLoaderConfig = (function () {
    function SystemJsNgModuleLoaderConfig() {
    }
    return SystemJsNgModuleLoaderConfig;
}());
var DEFAULT_CONFIG = {
    factoryPathPrefix: '',
    factoryPathSuffix: '.ngfactory',
};
/**
 * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
 * @experimental
 */
var SystemJsNgModuleLoader = (function () {
    function SystemJsNgModuleLoader(_compiler, config) {
        this._compiler = _compiler;
        this._config = config || DEFAULT_CONFIG;
    }
    SystemJsNgModuleLoader.prototype.load = function (path) {
        var offlineMode = this._compiler instanceof __WEBPACK_IMPORTED_MODULE_1__compiler__["Compiler"];
        return offlineMode ? this.loadFactory(path) : this.loadAndCompile(path);
    };
    SystemJsNgModuleLoader.prototype.loadAndCompile = function (path) {
        var _this = this;
        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
        if (exportName === undefined)
            exportName = 'default';
        return __webpack_require__(340)(module)
            .then(function (module) { return module[exportName]; })
            .then(function (type) { return checkNotEmpty(type, module, exportName); })
            .then(function (type) { return _this._compiler.compileModuleAsync(type); });
    };
    SystemJsNgModuleLoader.prototype.loadFactory = function (path) {
        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
        var factoryClassSuffix = FACTORY_CLASS_SUFFIX;
        if (exportName === undefined) {
            exportName = 'default';
            factoryClassSuffix = '';
        }
        return __webpack_require__(340)(this._config.factoryPathPrefix + module + this._config.factoryPathSuffix)
            .then(function (module) { return module[exportName + factoryClassSuffix]; })
            .then(function (factory) { return checkNotEmpty(factory, module, exportName); });
    };
    SystemJsNgModuleLoader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__di__["b" /* Injectable */] },
    ];
    /** @nocollapse */
    SystemJsNgModuleLoader.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__compiler__["Compiler"], },
        { type: SystemJsNgModuleLoaderConfig, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__di__["d" /* Optional */] },] },
    ];
    return SystemJsNgModuleLoader;
}());
function checkNotEmpty(value, modulePath, exportName) {
    if (!value) {
        throw new Error("Cannot find '" + exportName + "' in '" + modulePath + "'");
    }
    return value;
}
//# sourceMappingURL=system_js_ng_module_factory_loader.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_profile__ = __webpack_require__(135);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ViewContainerRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ViewContainerRef_; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * Represents a container where one or more Views can be attached.
 *
 * The container can contain two kinds of Views. Host Views, created by instantiating a
 * {@link Component} via {@link #createComponent}, and Embedded Views, created by instantiating an
 * {@link TemplateRef Embedded Template} via {@link #createEmbeddedView}.
 *
 * The location of the View Container within the containing View is specified by the Anchor
 * `element`. Each View Container can have only one Anchor Element and each Anchor Element can only
 * have a single View Container.
 *
 * Root elements of Views attached to this container become siblings of the Anchor Element in
 * the Rendered View.
 *
 * To access a `ViewContainerRef` of an Element, you can either place a {@link Directive} injected
 * with `ViewContainerRef` on the Element, or you obtain it via a {@link ViewChild} query.
 * @stable
 */
var ViewContainerRef = (function () {
    function ViewContainerRef() {
    }
    Object.defineProperty(ViewContainerRef.prototype, "element", {
        /**
         * Anchor element that specifies the location of this container in the containing View.
         * <!-- TODO: rename to anchorElement -->
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef.prototype, "injector", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef.prototype, "parentInjector", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef.prototype, "length", {
        /**
         * Returns the number of Views currently attached to this container.
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    return ViewContainerRef;
}());
var ViewContainerRef_ = (function () {
    function ViewContainerRef_(_element) {
        this._element = _element;
        /** @internal */
        this._createComponentInContainerScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["a" /* wtfCreateScope */])('ViewContainerRef#createComponent()');
        /** @internal */
        this._insertScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["a" /* wtfCreateScope */])('ViewContainerRef#insert()');
        /** @internal */
        this._removeScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["a" /* wtfCreateScope */])('ViewContainerRef#remove()');
        /** @internal */
        this._detachScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["a" /* wtfCreateScope */])('ViewContainerRef#detach()');
    }
    ViewContainerRef_.prototype.get = function (index) { return this._element.nestedViews[index].ref; };
    Object.defineProperty(ViewContainerRef_.prototype, "length", {
        get: function () {
            var views = this._element.nestedViews;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(views) ? views.length : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "element", {
        get: function () { return this._element.elementRef; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "injector", {
        get: function () { return this._element.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
        get: function () { return this._element.parentInjector; },
        enumerable: true,
        configurable: true
    });
    // TODO(rado): profile and decide whether bounds checks should be added
    // to the methods below.
    ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, context, index) {
        if (context === void 0) { context = null; }
        if (index === void 0) { index = -1; }
        var viewRef = templateRef.createEmbeddedView(context);
        this.insert(viewRef, index);
        return viewRef;
    };
    ViewContainerRef_.prototype.createComponent = function (componentFactory, index, injector, projectableNodes) {
        if (index === void 0) { index = -1; }
        if (injector === void 0) { injector = null; }
        if (projectableNodes === void 0) { projectableNodes = null; }
        var s = this._createComponentInContainerScope();
        var contextInjector = injector || this._element.parentInjector;
        var componentRef = componentFactory.create(contextInjector, projectableNodes);
        this.insert(componentRef.hostView, index);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["b" /* wtfLeave */])(s, componentRef);
    };
    // TODO(i): refactor insert+remove into move
    ViewContainerRef_.prototype.insert = function (viewRef, index) {
        if (index === void 0) { index = -1; }
        var s = this._insertScope();
        if (index == -1)
            index = this.length;
        var viewRef_ = viewRef;
        this._element.attachView(viewRef_.internalView, index);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["b" /* wtfLeave */])(s, viewRef_);
    };
    ViewContainerRef_.prototype.move = function (viewRef, currentIndex) {
        var s = this._insertScope();
        if (currentIndex == -1)
            return;
        var viewRef_ = viewRef;
        this._element.moveView(viewRef_.internalView, currentIndex);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["b" /* wtfLeave */])(s, viewRef_);
    };
    ViewContainerRef_.prototype.indexOf = function (viewRef) {
        return this._element.nestedViews.indexOf(viewRef.internalView);
    };
    // TODO(i): rename to destroy
    ViewContainerRef_.prototype.remove = function (index) {
        if (index === void 0) { index = -1; }
        var s = this._removeScope();
        if (index == -1)
            index = this.length - 1;
        var view = this._element.detachView(index);
        view.destroy();
        // view is intentionally not returned to the client.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["b" /* wtfLeave */])(s);
    };
    // TODO(i): refactor insert+remove into move
    ViewContainerRef_.prototype.detach = function (index) {
        if (index === void 0) { index = -1; }
        var s = this._detachScope();
        if (index == -1)
            index = this.length - 1;
        var view = this._element.detachView(index);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__profile_profile__["b" /* wtfLeave */])(s, view.ref);
    };
    ViewContainerRef_.prototype.clear = function () {
        for (var i = this.length - 1; i >= 0; i--) {
            this.remove(i);
        }
    };
    return ViewContainerRef_;
}());
//# sourceMappingURL=view_container_ref.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_animation_queue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__change_detection_constants__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_errors__ = __webpack_require__(42);
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ViewRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return EmbeddedViewRef; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ViewRef_; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 * @stable
 */
var ViewRef = (function () {
    function ViewRef() {
    }
    Object.defineProperty(ViewRef.prototype, "destroyed", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    return ViewRef;
}());
/**
 * Represents an Angular View.
 *
 * <!-- TODO: move the next two paragraphs to the dev guide -->
 * A View is a fundamental building block of the application UI. It is the smallest grouping of
 * Elements which are created and destroyed together.
 *
 * Properties of elements in a View can change, but the structure (number and order) of elements in
 * a View cannot. Changing the structure of Elements can only be done by inserting, moving or
 * removing nested Views via a {@link ViewContainerRef}. Each View can contain many View Containers.
 * <!-- /TODO -->
 *
 * ### Example
 *
 * Given this template...
 *
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <li *ngFor="let  item of items">{{item}}</li>
 * </ul>
 * ```
 *
 * We have two {@link TemplateRef}s:
 *
 * Outer {@link TemplateRef}:
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <template ngFor let-item [ngForOf]="items"></template>
 * </ul>
 * ```
 *
 * Inner {@link TemplateRef}:
 * ```
 *   <li>{{item}}</li>
 * ```
 *
 * Notice that the original template is broken down into two separate {@link TemplateRef}s.
 *
 * The outer/inner {@link TemplateRef}s are then assembled into views like so:
 *
 * ```
 * <!-- ViewRef: outer-0 -->
 * Count: 2
 * <ul>
 *   <template view-container-ref></template>
 *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
 *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
 * </ul>
 * <!-- /ViewRef: outer-0 -->
 * ```
 * @experimental
 */
var EmbeddedViewRef = (function (_super) {
    __extends(EmbeddedViewRef, _super);
    function EmbeddedViewRef() {
        _super.apply(this, arguments);
    }
    Object.defineProperty(EmbeddedViewRef.prototype, "context", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmbeddedViewRef.prototype, "rootNodes", {
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    ;
    return EmbeddedViewRef;
}(ViewRef));
var ViewRef_ = (function () {
    function ViewRef_(_view) {
        this._view = _view;
        this._view = _view;
        this._originalMode = this._view.cdMode;
    }
    Object.defineProperty(ViewRef_.prototype, "internalView", {
        get: function () { return this._view; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "rootNodes", {
        get: function () { return this._view.flatRootNodes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "context", {
        get: function () { return this._view.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "destroyed", {
        get: function () { return this._view.destroyed; },
        enumerable: true,
        configurable: true
    });
    ViewRef_.prototype.markForCheck = function () { this._view.markPathToRootAsCheckOnce(); };
    ViewRef_.prototype.detach = function () { this._view.cdMode = __WEBPACK_IMPORTED_MODULE_1__change_detection_constants__["b" /* ChangeDetectorStatus */].Detached; };
    ViewRef_.prototype.detectChanges = function () {
        this._view.detectChanges(false);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__animation_animation_queue__["a" /* triggerQueuedAnimations */])();
    };
    ViewRef_.prototype.checkNoChanges = function () { this._view.detectChanges(true); };
    ViewRef_.prototype.reattach = function () {
        this._view.cdMode = this._originalMode;
        this.markForCheck();
    };
    ViewRef_.prototype.onDestroy = function (callback) { this._view.disposables.push(callback); };
    ViewRef_.prototype.destroy = function () { this._view.destroy(); };
    return ViewRef_;
}());
//# sourceMappingURL=view_ref.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_di__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata_directives__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_ng_module__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_view__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata_di__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__metadata_directives__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__metadata_lifecycle_hooks__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_3__metadata_ng_module__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__metadata_ng_module__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__metadata_ng_module__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_4__metadata_view__["ViewEncapsulation"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





//# sourceMappingURL=metadata.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return LifecycleHooks; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return LIFECYCLE_HOOKS_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "h", function() { return OnChanges; });
/* harmony export (binding) */ __webpack_require__.d(exports, "j", function() { return OnInit; });
/* harmony export (binding) */ __webpack_require__.d(exports, "g", function() { return DoCheck; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return OnDestroy; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AfterContentInit; });
/* harmony export (binding) */ __webpack_require__.d(exports, "i", function() { return AfterContentChecked; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return AfterViewInit; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return AfterViewChecked; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @stable
 */
var LifecycleHooks;
(function (LifecycleHooks) {
    LifecycleHooks[LifecycleHooks["OnInit"] = 0] = "OnInit";
    LifecycleHooks[LifecycleHooks["OnDestroy"] = 1] = "OnDestroy";
    LifecycleHooks[LifecycleHooks["DoCheck"] = 2] = "DoCheck";
    LifecycleHooks[LifecycleHooks["OnChanges"] = 3] = "OnChanges";
    LifecycleHooks[LifecycleHooks["AfterContentInit"] = 4] = "AfterContentInit";
    LifecycleHooks[LifecycleHooks["AfterContentChecked"] = 5] = "AfterContentChecked";
    LifecycleHooks[LifecycleHooks["AfterViewInit"] = 6] = "AfterViewInit";
    LifecycleHooks[LifecycleHooks["AfterViewChecked"] = 7] = "AfterViewChecked";
})(LifecycleHooks || (LifecycleHooks = {}));
var LIFECYCLE_HOOKS_VALUES = [
    LifecycleHooks.OnInit, LifecycleHooks.OnDestroy, LifecycleHooks.DoCheck, LifecycleHooks.OnChanges,
    LifecycleHooks.AfterContentInit, LifecycleHooks.AfterContentChecked, LifecycleHooks.AfterViewInit,
    LifecycleHooks.AfterViewChecked
];
/**
 * @whatItDoes Lifecycle hook that is called when any data-bound property of a directive changes.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='OnChanges'}
 *
 * @description
 * `ngOnChanges` is called right after the data-bound properties have been checked and before view
 * and content children are checked if at least one of them has changed.
 * The `changes` parameter contains the changed properties.
 *
 * See {@linkDocs guide/lifecycle-hooks#onchanges "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var OnChanges = (function () {
    function OnChanges() {
    }
    return OnChanges;
}());
/**
 * @whatItDoes Lifecycle hook that is called after data-bound properties of a directive are
 * initialized.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='OnInit'}
 *
 * @description
 * `ngOnInit` is called right after the directive's data-bound properties have been checked for the
 * first time, and before any of its children have been checked. It is invoked only once when the
 * directive is instantiated.
 *
 * See {@linkDocs guide/lifecycle-hooks "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var OnInit = (function () {
    function OnInit() {
    }
    return OnInit;
}());
/**
 * @whatItDoes Lifecycle hook that is called when Angular dirty checks a directive.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='DoCheck'}
 *
 * @description
 * `ngDoCheck` gets called to check the changes in the directives in addition to the default
 * algorithm. The default change detection algorithm looks for differences by comparing
 * bound-property values by reference across change detection runs.
 *
 * Note that a directive typically should not use both `DoCheck` and {@link OnChanges} to respond to
 * changes on the same input, as `ngOnChanges` will continue to be called when the default change
 * detector detects changes.
 *
 * See {@link KeyValueDiffers} and {@link IterableDiffers} for implementing custom dirty checking
 * for collections.
 *
 * See {@linkDocs guide/lifecycle-hooks#docheck "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var DoCheck = (function () {
    function DoCheck() {
    }
    return DoCheck;
}());
/**
 * @whatItDoes Lifecycle hook that is called when a directive or pipe is destroyed.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='OnDestroy'}
 *
 * @description
 * `ngOnDestroy` callback is typically used for any custom cleanup that needs to occur when the
 * instance is destroyed.
 *
 * See {@linkDocs guide/lifecycle-hooks "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var OnDestroy = (function () {
    function OnDestroy() {
    }
    return OnDestroy;
}());
/**
 *
 * @whatItDoes Lifecycle hook that is called after a directive's content has been fully
 * initialized.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='AfterContentInit'}
 *
 * @description
 * See {@linkDocs guide/lifecycle-hooks#aftercontent "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var AfterContentInit = (function () {
    function AfterContentInit() {
    }
    return AfterContentInit;
}());
/**
 * @whatItDoes Lifecycle hook that is called after every check of a directive's content.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='AfterContentChecked'}
 *
 * @description
 * See {@linkDocs guide/lifecycle-hooks#aftercontent "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var AfterContentChecked = (function () {
    function AfterContentChecked() {
    }
    return AfterContentChecked;
}());
/**
 * @whatItDoes Lifecycle hook that is called after a component's view has been fully
 * initialized.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='AfterViewInit'}
 *
 * @description
 * See {@linkDocs guide/lifecycle-hooks#afterview "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var AfterViewInit = (function () {
    function AfterViewInit() {
    }
    return AfterViewInit;
}());
/**
 * @whatItDoes Lifecycle hook that is called after every check of a component's view.
 * @howToUse
 * {@example core/ts/metadata/lifecycle_hooks_spec.ts region='AfterViewChecked'}
 *
 * @description
 * See {@linkDocs guide/lifecycle-hooks#afterview "Lifecycle Hooks Guide"}.
 *
 * @stable
 */
var AfterViewChecked = (function () {
    function AfterViewChecked() {
    }
    return AfterViewChecked;
}());
//# sourceMappingURL=lifecycle_hooks.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(197);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReflectionCapabilities; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var ReflectionCapabilities = (function () {
    function ReflectionCapabilities(reflect) {
        this._reflect = reflect || __WEBPACK_IMPORTED_MODULE_0__facade_lang__["a" /* global */].Reflect;
    }
    ReflectionCapabilities.prototype.isReflectionEnabled = function () { return true; };
    ReflectionCapabilities.prototype.factory = function (t) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        return new (t.bind.apply(t, [void 0].concat(args)))();
    }; };
    /** @internal */
    ReflectionCapabilities.prototype._zipTypesAndAnnotations = function (paramTypes, paramAnnotations) {
        var result;
        if (typeof paramTypes === 'undefined') {
            result = new Array(paramAnnotations.length);
        }
        else {
            result = new Array(paramTypes.length);
        }
        for (var i = 0; i < result.length; i++) {
            // TS outputs Object for parameters without types, while Traceur omits
            // the annotations. For now we preserve the Traceur behavior to aid
            // migration, but this can be revisited.
            if (typeof paramTypes === 'undefined') {
                result[i] = [];
            }
            else if (paramTypes[i] != Object) {
                result[i] = [paramTypes[i]];
            }
            else {
                result[i] = [];
            }
            if (paramAnnotations && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(paramAnnotations[i])) {
                result[i] = result[i].concat(paramAnnotations[i]);
            }
        }
        return result;
    };
    ReflectionCapabilities.prototype.parameters = function (type) {
        // Prefer the direct API.
        if (type.parameters) {
            return type.parameters;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (type.ctorParameters) {
            var ctorParameters = type.ctorParameters;
            var paramTypes = ctorParameters.map(function (ctorParam) { return ctorParam && ctorParam.type; });
            var paramAnnotations = ctorParameters.map(function (ctorParam) {
                return ctorParam && convertTsickleDecoratorIntoMetadata(ctorParam.decorators);
            });
            return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
        }
        // API for metadata created by invoking the decorators.
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this._reflect) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this._reflect.getMetadata)) {
            var paramAnnotations = this._reflect.getMetadata('parameters', type);
            var paramTypes = this._reflect.getMetadata('design:paramtypes', type);
            if (paramTypes || paramAnnotations) {
                return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
            }
        }
        // The array has to be filled with `undefined` because holes would be skipped by `some`
        return new Array(type.length).fill(undefined);
    };
    ReflectionCapabilities.prototype.annotations = function (typeOrFunc) {
        // Prefer the direct API.
        if (typeOrFunc.annotations) {
            var annotations = typeOrFunc.annotations;
            if (typeof annotations === 'function' && annotations.annotations) {
                annotations = annotations.annotations;
            }
            return annotations;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (typeOrFunc.decorators) {
            return convertTsickleDecoratorIntoMetadata(typeOrFunc.decorators);
        }
        // API for metadata created by invoking the decorators.
        if (this._reflect && this._reflect.getMetadata) {
            var annotations = this._reflect.getMetadata('annotations', typeOrFunc);
            if (annotations)
                return annotations;
        }
        return [];
    };
    ReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
        // Prefer the direct API.
        if (typeOrFunc.propMetadata) {
            var propMetadata = typeOrFunc.propMetadata;
            if (typeof propMetadata === 'function' && propMetadata.propMetadata) {
                propMetadata = propMetadata.propMetadata;
            }
            return propMetadata;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (typeOrFunc.propDecorators) {
            var propDecorators_1 = typeOrFunc.propDecorators;
            var propMetadata_1 = {};
            Object.keys(propDecorators_1).forEach(function (prop) {
                propMetadata_1[prop] = convertTsickleDecoratorIntoMetadata(propDecorators_1[prop]);
            });
            return propMetadata_1;
        }
        // API for metadata created by invoking the decorators.
        if (this._reflect && this._reflect.getMetadata) {
            var propMetadata = this._reflect.getMetadata('propMetadata', typeOrFunc);
            if (propMetadata)
                return propMetadata;
        }
        return {};
    };
    ReflectionCapabilities.prototype.hasLifecycleHook = function (type, lcProperty) {
        return type instanceof __WEBPACK_IMPORTED_MODULE_1__type__["a" /* Type */] && lcProperty in type.prototype;
    };
    ReflectionCapabilities.prototype.getter = function (name) { return new Function('o', 'return o.' + name + ';'); };
    ReflectionCapabilities.prototype.setter = function (name) {
        return new Function('o', 'v', 'return o.' + name + ' = v;');
    };
    ReflectionCapabilities.prototype.method = function (name) {
        var functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
        return new Function('o', 'args', functionBody);
    };
    // There is not a concept of import uri in Js, but this is useful in developing Dart applications.
    ReflectionCapabilities.prototype.importUri = function (type) {
        // StaticSymbol
        if (typeof type === 'object' && type['filePath']) {
            return type['filePath'];
        }
        // Runtime type
        return "./" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["b" /* stringify */])(type);
    };
    ReflectionCapabilities.prototype.resolveIdentifier = function (name, moduleUrl, runtime) { return runtime; };
    ReflectionCapabilities.prototype.resolveEnum = function (enumIdentifier, name) { return enumIdentifier[name]; };
    return ReflectionCapabilities;
}());
function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
    if (!decoratorInvocations) {
        return [];
    }
    return decoratorInvocations.map(function (decoratorInvocation) {
        var decoratorType = decoratorInvocation.type;
        var annotationCls = decoratorType.annotationCls;
        var annotationArgs = decoratorInvocation.args ? decoratorInvocation.args : [];
        return new (annotationCls.bind.apply(annotationCls, [void 0].concat(annotationArgs)))();
    });
}
//# sourceMappingURL=reflection_capabilities.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reflector_reader__ = __webpack_require__(196);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Reflector; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * Provides access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
var Reflector = (function (_super) {
    __extends(Reflector, _super);
    function Reflector(reflectionCapabilities) {
        _super.call(this);
        this.reflectionCapabilities = reflectionCapabilities;
    }
    Reflector.prototype.updateCapabilities = function (caps) { this.reflectionCapabilities = caps; };
    Reflector.prototype.factory = function (type) { return this.reflectionCapabilities.factory(type); };
    Reflector.prototype.parameters = function (typeOrFunc) {
        return this.reflectionCapabilities.parameters(typeOrFunc);
    };
    Reflector.prototype.annotations = function (typeOrFunc) {
        return this.reflectionCapabilities.annotations(typeOrFunc);
    };
    Reflector.prototype.propMetadata = function (typeOrFunc) {
        return this.reflectionCapabilities.propMetadata(typeOrFunc);
    };
    Reflector.prototype.hasLifecycleHook = function (type, lcProperty) {
        return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
    };
    Reflector.prototype.getter = function (name) { return this.reflectionCapabilities.getter(name); };
    Reflector.prototype.setter = function (name) { return this.reflectionCapabilities.setter(name); };
    Reflector.prototype.method = function (name) { return this.reflectionCapabilities.method(name); };
    Reflector.prototype.importUri = function (type) { return this.reflectionCapabilities.importUri(type); };
    Reflector.prototype.resolveIdentifier = function (name, moduleUrl, runtime) {
        return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, runtime);
    };
    Reflector.prototype.resolveEnum = function (identifier, name) {
        return this.reflectionCapabilities.resolveEnum(identifier, name);
    };
    return Reflector;
}(__WEBPACK_IMPORTED_MODULE_0__reflector_reader__["a" /* ReflectorReader */]));
//# sourceMappingURL=reflector.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_ng_model__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_reactive_directives_form_control_directive__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_name__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_group_directive__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_name__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_select_control_value_accessor__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_select_multiple_control_value_accessor__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_validators__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_ng_control__ = __webpack_require__(28);
/* harmony export (binding) */ __webpack_require__.d(exports, "SHARED_FORM_DIRECTIVES", function() { return SHARED_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "TEMPLATE_DRIVEN_DIRECTIVES", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "REACTIVE_DRIVEN_DIRECTIVES", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "FORM_DIRECTIVES", function() { return FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "REACTIVE_FORM_DIRECTIVES", function() { return REACTIVE_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "InternalFormsSharedModule", function() { return InternalFormsSharedModule; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__["CheckboxControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__["DefaultValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControl", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_ng_control__["NgControl"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatus", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["NgControlStatus"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["NgControlStatusGroup"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgForm", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__["NgForm"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModel", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_ng_model__["NgModel"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModelGroup", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NumberValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__["RadioControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_9__directives_reactive_directives_form_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlName", function() { return __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_name__["FormControlName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_group_directive__["FormGroupDirective"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormArrayName", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_name__["FormArrayName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupName", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_name__["FormGroupName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_select_control_value_accessor__["NgSelectOption"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_select_control_value_accessor__["SelectControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSelectMultipleOption", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_select_multiple_control_value_accessor__["NgSelectMultipleOption"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_select_multiple_control_value_accessor__["SelectMultipleControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_validators__["MaxLengthValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_validators__["MinLengthValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PatternValidator", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_validators__["PatternValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_validators__["RequiredValidator"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
































var SHARED_FORM_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_13__directives_select_control_value_accessor__["NgSelectOption"], __WEBPACK_IMPORTED_MODULE_14__directives_select_multiple_control_value_accessor__["NgSelectMultipleOption"], __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__["DefaultValueAccessor"], __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__["CheckboxControlValueAccessor"], __WEBPACK_IMPORTED_MODULE_13__directives_select_control_value_accessor__["SelectControlValueAccessor"], __WEBPACK_IMPORTED_MODULE_14__directives_select_multiple_control_value_accessor__["SelectMultipleControlValueAccessor"],
    __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__["RadioControlValueAccessor"], __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["NgControlStatus"], __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["NgControlStatusGroup"], __WEBPACK_IMPORTED_MODULE_15__directives_validators__["RequiredValidator"],
    __WEBPACK_IMPORTED_MODULE_15__directives_validators__["MinLengthValidator"], __WEBPACK_IMPORTED_MODULE_15__directives_validators__["MaxLengthValidator"], __WEBPACK_IMPORTED_MODULE_15__directives_validators__["PatternValidator"]
];
var TEMPLATE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_5__directives_ng_model__["NgModel"], __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__["a" /* NgModelGroup */], __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__["NgForm"]];
var REACTIVE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_9__directives_reactive_directives_form_control_directive__["a" /* FormControlDirective */], __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_group_directive__["FormGroupDirective"], __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_name__["FormControlName"], __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_name__["FormGroupName"], __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_name__["FormArrayName"]];
/**
 * A list of all the form directives.
 *
 * @stable
 */
var FORM_DIRECTIVES = [TEMPLATE_DRIVEN_DIRECTIVES, SHARED_FORM_DIRECTIVES];
/**
 * @stable
 */
var REACTIVE_FORM_DIRECTIVES = [REACTIVE_DRIVEN_DIRECTIVES, SHARED_FORM_DIRECTIVES];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: SHARED_FORM_DIRECTIVES, exports: SHARED_FORM_DIRECTIVES },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = [];
    return InternalFormsSharedModule;
}());
//# sourceMappingURL=directives.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormErrorExamples; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
//# sourceMappingURL=error_examples.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(277);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TemplateDrivenErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelWithFormGroup);
    };
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
//# sourceMappingURL=template_driven_errors.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_builder__ = __webpack_require__(73);
/* harmony export (binding) */ __webpack_require__.d(exports, "FormsModule", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(exports, "ReactiveFormsModule", function() { return ReactiveFormsModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * The ng module for forms.
 * @stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: __WEBPACK_IMPORTED_MODULE_1__directives__["TEMPLATE_DRIVEN_DIRECTIVES"],
                    providers: [__WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["RadioControlRegistry"]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["InternalFormsSharedModule"], __WEBPACK_IMPORTED_MODULE_1__directives__["TEMPLATE_DRIVEN_DIRECTIVES"]]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = [];
    return FormsModule;
}());
/**
 * The ng module for reactive forms.
 * @stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__directives__["REACTIVE_DRIVEN_DIRECTIVES"]],
                    providers: [__WEBPACK_IMPORTED_MODULE_3__form_builder__["FormBuilder"], __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["RadioControlRegistry"]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["InternalFormsSharedModule"], __WEBPACK_IMPORTED_MODULE_1__directives__["REACTIVE_DRIVEN_DIRECTIVES"]]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = [];
    return ReactiveFormsModule;
}());
//# sourceMappingURL=form_providers.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isPromise; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
//# sourceMappingURL=private_import_core.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_search_params__ = __webpack_require__(145);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Body; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * HTTP request body used by both {@link Request} and {@link Response}
 * https://fetch.spec.whatwg.org/#body
 */
var Body = (function () {
    function Body() {
    }
    /**
     * Attempts to return body as parsed `JSON` object, or raises an exception.
     */
    Body.prototype.json = function () {
        if (typeof this._body === 'string') {
            return JSON.parse(this._body);
        }
        if (this._body instanceof ArrayBuffer) {
            return JSON.parse(this.text());
        }
        return this._body;
    };
    /**
     * Returns the body as a string, presuming `toString()` can be called on the response body.
     */
    Body.prototype.text = function () {
        if (this._body instanceof __WEBPACK_IMPORTED_MODULE_1__url_search_params__["a" /* URLSearchParams */]) {
            return this._body.toString();
        }
        if (this._body instanceof ArrayBuffer) {
            return String.fromCharCode.apply(null, new Uint16Array(this._body));
        }
        if (this._body === null) {
            return '';
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http_utils__["a" /* isJsObject */])(this._body)) {
            return JSON.stringify(this._body, null, 2);
        }
        return this._body.toString();
    };
    /**
     * Return the body as an ArrayBuffer
     */
    Body.prototype.arrayBuffer = function () {
        if (this._body instanceof ArrayBuffer) {
            return this._body;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__http_utils__["b" /* stringToArrayBuffer */])(this.text());
    };
    /**
      * Returns the request's body as a Blob, assuming that body exists.
      */
    Body.prototype.blob = function () {
        if (this._body instanceof Blob) {
            return this._body;
        }
        if (this._body instanceof ArrayBuffer) {
            return new Blob([this._body]);
        }
        throw new Error('The request body isn\'t either a blob or an array buffer');
    };
    return Body;
}());
//# sourceMappingURL=body.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backends_browser_jsonp__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backends_browser_xhr__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backends_jsonp_backend__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__backends_xhr_backend__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_request_options__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_response_options__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interfaces__ = __webpack_require__(92);
/* harmony export (immutable) */ exports["_createDefaultCookieXSRFStrategy"] = _createDefaultCookieXSRFStrategy;
/* harmony export (immutable) */ exports["httpFactory"] = httpFactory;
/* harmony export (immutable) */ exports["jsonpFactory"] = jsonpFactory;
/* harmony export (binding) */ __webpack_require__.d(exports, "HttpModule", function() { return HttpModule; });
/* harmony export (binding) */ __webpack_require__.d(exports, "JsonpModule", function() { return JsonpModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */









function _createDefaultCookieXSRFStrategy() {
    return new __WEBPACK_IMPORTED_MODULE_4__backends_xhr_backend__["CookieXSRFStrategy"]();
}
function httpFactory(xhrBackend, requestOptions) {
    return new __WEBPACK_IMPORTED_MODULE_7__http__["Http"](xhrBackend, requestOptions);
}
function jsonpFactory(jsonpBackend, requestOptions) {
    return new __WEBPACK_IMPORTED_MODULE_7__http__["Jsonp"](jsonpBackend, requestOptions);
}
/**
 * The module that includes http's providers
 *
 * @experimental
 */
var HttpModule = (function () {
    function HttpModule() {
    }
    HttpModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        // TODO(pascal): use factory type annotations once supported in DI
                        // issue: https://github.com/angular/angular/issues/3183
                        { provide: __WEBPACK_IMPORTED_MODULE_7__http__["Http"], useFactory: httpFactory, deps: [__WEBPACK_IMPORTED_MODULE_4__backends_xhr_backend__["XHRBackend"], __WEBPACK_IMPORTED_MODULE_5__base_request_options__["RequestOptions"]] },
                        __WEBPACK_IMPORTED_MODULE_2__backends_browser_xhr__["BrowserXhr"],
                        { provide: __WEBPACK_IMPORTED_MODULE_5__base_request_options__["RequestOptions"], useClass: __WEBPACK_IMPORTED_MODULE_5__base_request_options__["BaseRequestOptions"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_6__base_response_options__["ResponseOptions"], useClass: __WEBPACK_IMPORTED_MODULE_6__base_response_options__["BaseResponseOptions"] },
                        __WEBPACK_IMPORTED_MODULE_4__backends_xhr_backend__["XHRBackend"],
                        { provide: __WEBPACK_IMPORTED_MODULE_8__interfaces__["XSRFStrategy"], useFactory: _createDefaultCookieXSRFStrategy },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpModule.ctorParameters = [];
    return HttpModule;
}());
/**
 * The module that includes jsonp's providers
 *
 * @experimental
 */
var JsonpModule = (function () {
    function JsonpModule() {
    }
    JsonpModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        // TODO(pascal): use factory type annotations once supported in DI
                        // issue: https://github.com/angular/angular/issues/3183
                        { provide: __WEBPACK_IMPORTED_MODULE_7__http__["Jsonp"], useFactory: jsonpFactory, deps: [__WEBPACK_IMPORTED_MODULE_3__backends_jsonp_backend__["JSONPBackend"], __WEBPACK_IMPORTED_MODULE_5__base_request_options__["RequestOptions"]] },
                        __WEBPACK_IMPORTED_MODULE_1__backends_browser_jsonp__["BrowserJsonp"],
                        { provide: __WEBPACK_IMPORTED_MODULE_5__base_request_options__["RequestOptions"], useClass: __WEBPACK_IMPORTED_MODULE_5__base_request_options__["BaseRequestOptions"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_6__base_response_options__["ResponseOptions"], useClass: __WEBPACK_IMPORTED_MODULE_6__base_response_options__["BaseResponseOptions"] },
                        { provide: __WEBPACK_IMPORTED_MODULE_3__backends_jsonp_backend__["JSONPBackend"], useClass: __WEBPACK_IMPORTED_MODULE_3__backends_jsonp_backend__["JSONPBackend_"] },
                    ],
                },] },
    ];
    /** @nocollapse */
    JsonpModule.ctorParameters = [];
    return JsonpModule;
}());
//# sourceMappingURL=http_module.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__body__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http_utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__url_search_params__ = __webpack_require__(145);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Request; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






// TODO(jeffbcross): properly implement body accessors
/**
 * Creates `Request` instances from provided values.
 *
 * The Request's interface is inspired by the Request constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#request-class),
 * but is considered a static value whose body can be accessed many times. There are other
 * differences in the implementation, but this is the most significant.
 *
 * `Request` instances are typically created by higher-level classes, like {@link Http} and
 * {@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
 * One such example is when creating services that wrap higher-level services, like {@link Http},
 * where it may be useful to generate a `Request` with arbitrary headers and search params.
 *
 * ```typescript
 * import {Injectable, Injector} from '@angular/core';
 * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from '@angular/http';
 *
 * @Injectable()
 * class AutoAuthenticator {
 *   constructor(public http:Http) {}
 *   request(url:string) {
 *     return this.http.request(new Request({
 *       method: RequestMethod.Get,
 *       url: url,
 *       search: 'password=123'
 *     }));
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
 * var authenticator = injector.get(AutoAuthenticator);
 * authenticator.request('people.json').subscribe(res => {
 *   //URL should have included '?password=123'
 *   console.log('people', res.json());
 * });
 * ```
 *
 * @experimental
 */
var Request = (function (_super) {
    __extends(Request, _super);
    function Request(requestOptions) {
        _super.call(this);
        // TODO: assert that url is present
        var url = requestOptions.url;
        this.url = requestOptions.url;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__src_facade_lang__["d" /* isPresent */])(requestOptions.search)) {
            var search = requestOptions.search.toString();
            if (search.length > 0) {
                var prefix = '?';
                if (this.url.indexOf('?') != -1) {
                    prefix = (this.url[this.url.length - 1] == '&') ? '' : '&';
                }
                // TODO: just delete search-query-looking string in url?
                this.url = url + prefix + search;
            }
        }
        this._body = requestOptions.body;
        this.method = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__http_utils__["e" /* normalizeMethodName */])(requestOptions.method);
        // TODO(jeffbcross): implement behavior
        // Defaults to 'omit', consistent with browser
        // TODO(jeffbcross): implement behavior
        this.headers = new __WEBPACK_IMPORTED_MODULE_3__headers__["a" /* Headers */](requestOptions.headers);
        this.contentType = this.detectContentType();
        this.withCredentials = requestOptions.withCredentials;
        this.responseType = requestOptions.responseType;
    }
    /**
     * Returns the content type enum based on header options.
     */
    Request.prototype.detectContentType = function () {
        switch (this.headers.get('content-type')) {
            case 'application/json':
                return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].JSON;
            case 'application/x-www-form-urlencoded':
                return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM;
            case 'multipart/form-data':
                return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM_DATA;
            case 'text/plain':
            case 'text/html':
                return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].TEXT;
            case 'application/octet-stream':
                return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].BLOB;
            default:
                return this.detectContentTypeFromBody();
        }
    };
    /**
     * Returns the content type of request's body based on its type.
     */
    Request.prototype.detectContentTypeFromBody = function () {
        if (this._body == null) {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].NONE;
        }
        else if (this._body instanceof __WEBPACK_IMPORTED_MODULE_5__url_search_params__["a" /* URLSearchParams */]) {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM;
        }
        else if (this._body instanceof FormData) {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM_DATA;
        }
        else if (this._body instanceof Blob) {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].BLOB;
        }
        else if (this._body instanceof ArrayBuffer) {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].ARRAY_BUFFER;
        }
        else if (this._body && typeof this._body == 'object') {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].JSON;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].TEXT;
        }
    };
    /**
     * Returns the request's body according to its type. If body is undefined, return
     * null.
     */
    Request.prototype.getBody = function () {
        switch (this.contentType) {
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].JSON:
                return this.text();
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM:
                return this.text();
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].FORM_DATA:
                return this._body;
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].TEXT:
                return this.text();
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].BLOB:
                return this.blob();
            case __WEBPACK_IMPORTED_MODULE_2__enums__["e" /* ContentType */].ARRAY_BUFFER:
                return this.arrayBuffer();
            default:
                return null;
        }
    };
    return Request;
}(__WEBPACK_IMPORTED_MODULE_1__body__["a" /* Body */]));
var noop = function () { };
var w = typeof window == 'object' ? window : noop;
var FormData = w['FormData'] || noop;
var Blob = w['Blob'] || noop;
var ArrayBuffer = w['ArrayBuffer'] || noop;
//# sourceMappingURL=static_request.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic_browser_adapter__ = __webpack_require__(389);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return BrowserDomAdapter; });
/* unused harmony export parseCookieValue */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var _attrToPropMap = {
    'class': 'className',
    'innerHtml': 'innerHTML',
    'readonly': 'readOnly',
    'tabindex': 'tabIndex',
};
var DOM_KEY_LOCATION_NUMPAD = 3;
// Map to convert some key or keyIdentifier values to what will be returned by getEventKey
var _keyMap = {
    // The following values are here for cross-browser compatibility and to match the W3C standard
    // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
    '\b': 'Backspace',
    '\t': 'Tab',
    '\x7F': 'Delete',
    '\x1B': 'Escape',
    'Del': 'Delete',
    'Esc': 'Escape',
    'Left': 'ArrowLeft',
    'Right': 'ArrowRight',
    'Up': 'ArrowUp',
    'Down': 'ArrowDown',
    'Menu': 'ContextMenu',
    'Scroll': 'ScrollLock',
    'Win': 'OS'
};
// There is a bug in Chrome for numeric keypad keys:
// https://code.google.com/p/chromium/issues/detail?id=155654
// 1, 2, 3 ... are reported as A, B, C ...
var _chromeNumKeyPadMap = {
    'A': '1',
    'B': '2',
    'C': '3',
    'D': '4',
    'E': '5',
    'F': '6',
    'G': '7',
    'H': '8',
    'I': '9',
    'J': '*',
    'K': '+',
    'M': '-',
    'N': '.',
    'O': '/',
    '\x60': '0',
    '\x90': 'NumLock'
};
/**
 * A `DomAdapter` powered by full browser DOM APIs.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
/* tslint:disable:requireParameterType */
var BrowserDomAdapter = (function (_super) {
    __extends(BrowserDomAdapter, _super);
    function BrowserDomAdapter() {
        _super.apply(this, arguments);
    }
    BrowserDomAdapter.prototype.parse = function (templateHtml) { throw new Error('parse not implemented'); };
    BrowserDomAdapter.makeCurrent = function () { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__["setRootDomAdapter"])(new BrowserDomAdapter()); };
    BrowserDomAdapter.prototype.hasProperty = function (element, name) { return name in element; };
    BrowserDomAdapter.prototype.setProperty = function (el, name, value) { el[name] = value; };
    BrowserDomAdapter.prototype.getProperty = function (el, name) { return el[name]; };
    BrowserDomAdapter.prototype.invoke = function (el, methodName, args) { (_a = el)[methodName].apply(_a, args); var _a; };
    // TODO(tbosch): move this into a separate environment class once we have it
    BrowserDomAdapter.prototype.logError = function (error) { (window.console.error || window.console.log)(error); };
    BrowserDomAdapter.prototype.log = function (error) { window.console.log(error); };
    BrowserDomAdapter.prototype.logGroup = function (error) {
        window.console.group && window.console.group(error);
        this.logError(error);
    };
    BrowserDomAdapter.prototype.logGroupEnd = function () { window.console.groupEnd && window.console.groupEnd(); };
    Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
        get: function () { return _attrToPropMap; },
        enumerable: true,
        configurable: true
    });
    BrowserDomAdapter.prototype.query = function (selector) { return document.querySelector(selector); };
    BrowserDomAdapter.prototype.querySelector = function (el, selector) {
        return el.querySelector(selector);
    };
    BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) { return el.querySelectorAll(selector); };
    BrowserDomAdapter.prototype.on = function (el, evt, listener) { el.addEventListener(evt, listener, false); };
    BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
        el.addEventListener(evt, listener, false);
        // Needed to follow Dart's subscription semantic, until fix of
        // https://code.google.com/p/dart/issues/detail?id=17406
        return function () { el.removeEventListener(evt, listener, false); };
    };
    BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) { el.dispatchEvent(evt); };
    BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
        var evt = document.createEvent('MouseEvent');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    BrowserDomAdapter.prototype.createEvent = function (eventType) {
        var evt = document.createEvent('Event');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    BrowserDomAdapter.prototype.preventDefault = function (evt) {
        evt.preventDefault();
        evt.returnValue = false;
    };
    BrowserDomAdapter.prototype.isPrevented = function (evt) {
        return evt.defaultPrevented || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(evt.returnValue) && !evt.returnValue;
    };
    BrowserDomAdapter.prototype.getInnerHTML = function (el) { return el.innerHTML; };
    BrowserDomAdapter.prototype.getTemplateContent = function (el) {
        return 'content' in el && el instanceof HTMLTemplateElement ? el.content : null;
    };
    BrowserDomAdapter.prototype.getOuterHTML = function (el) { return el.outerHTML; };
    BrowserDomAdapter.prototype.nodeName = function (node) { return node.nodeName; };
    BrowserDomAdapter.prototype.nodeValue = function (node) { return node.nodeValue; };
    BrowserDomAdapter.prototype.type = function (node) { return node.type; };
    BrowserDomAdapter.prototype.content = function (node) {
        if (this.hasProperty(node, 'content')) {
            return node.content;
        }
        else {
            return node;
        }
    };
    BrowserDomAdapter.prototype.firstChild = function (el) { return el.firstChild; };
    BrowserDomAdapter.prototype.nextSibling = function (el) { return el.nextSibling; };
    BrowserDomAdapter.prototype.parentElement = function (el) { return el.parentNode; };
    BrowserDomAdapter.prototype.childNodes = function (el) { return el.childNodes; };
    BrowserDomAdapter.prototype.childNodesAsList = function (el) {
        var childNodes = el.childNodes;
        var res = new Array(childNodes.length);
        for (var i = 0; i < childNodes.length; i++) {
            res[i] = childNodes[i];
        }
        return res;
    };
    BrowserDomAdapter.prototype.clearNodes = function (el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    };
    BrowserDomAdapter.prototype.appendChild = function (el, node) { el.appendChild(node); };
    BrowserDomAdapter.prototype.removeChild = function (el, node) { el.removeChild(node); };
    BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
    BrowserDomAdapter.prototype.remove = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
        return node;
    };
    BrowserDomAdapter.prototype.insertBefore = function (el, node) { el.parentNode.insertBefore(node, el); };
    BrowserDomAdapter.prototype.insertAllBefore = function (el, nodes) {
        nodes.forEach(function (n) { return el.parentNode.insertBefore(n, el); });
    };
    BrowserDomAdapter.prototype.insertAfter = function (el, node) { el.parentNode.insertBefore(node, el.nextSibling); };
    BrowserDomAdapter.prototype.setInnerHTML = function (el, value) { el.innerHTML = value; };
    BrowserDomAdapter.prototype.getText = function (el) { return el.textContent; };
    BrowserDomAdapter.prototype.setText = function (el, value) { el.textContent = value; };
    BrowserDomAdapter.prototype.getValue = function (el) { return el.value; };
    BrowserDomAdapter.prototype.setValue = function (el, value) { el.value = value; };
    BrowserDomAdapter.prototype.getChecked = function (el) { return el.checked; };
    BrowserDomAdapter.prototype.setChecked = function (el, value) { el.checked = value; };
    BrowserDomAdapter.prototype.createComment = function (text) { return document.createComment(text); };
    BrowserDomAdapter.prototype.createTemplate = function (html) {
        var t = document.createElement('template');
        t.innerHTML = html;
        return t;
    };
    BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createElement(tagName);
    };
    BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createElementNS(ns, tagName);
    };
    BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createTextNode(text);
    };
    BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
        if (doc === void 0) { doc = document; }
        var el = doc.createElement('SCRIPT');
        el.setAttribute(attrName, attrValue);
        return el;
    };
    BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
        if (doc === void 0) { doc = document; }
        var style = doc.createElement('style');
        this.appendChild(style, this.createTextNode(css));
        return style;
    };
    BrowserDomAdapter.prototype.createShadowRoot = function (el) { return el.createShadowRoot(); };
    BrowserDomAdapter.prototype.getShadowRoot = function (el) { return el.shadowRoot; };
    BrowserDomAdapter.prototype.getHost = function (el) { return el.host; };
    BrowserDomAdapter.prototype.clone = function (node) { return node.cloneNode(true); };
    BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
        return element.getElementsByClassName(name);
    };
    BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
        return element.getElementsByTagName(name);
    };
    BrowserDomAdapter.prototype.classList = function (element) { return Array.prototype.slice.call(element.classList, 0); };
    BrowserDomAdapter.prototype.addClass = function (element, className) { element.classList.add(className); };
    BrowserDomAdapter.prototype.removeClass = function (element, className) { element.classList.remove(className); };
    BrowserDomAdapter.prototype.hasClass = function (element, className) {
        return element.classList.contains(className);
    };
    BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
        element.style[styleName] = styleValue;
    };
    BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
        // IE requires '' instead of null
        // see https://github.com/angular/angular/issues/7916
        element.style[stylename] = '';
    };
    BrowserDomAdapter.prototype.getStyle = function (element, stylename) { return element.style[stylename]; };
    BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
        if (styleValue === void 0) { styleValue = null; }
        var value = this.getStyle(element, styleName) || '';
        return styleValue ? value == styleValue : value.length > 0;
    };
    BrowserDomAdapter.prototype.tagName = function (element) { return element.tagName; };
    BrowserDomAdapter.prototype.attributeMap = function (element) {
        var res = new Map();
        var elAttrs = element.attributes;
        for (var i = 0; i < elAttrs.length; i++) {
            var attrib = elAttrs[i];
            res.set(attrib.name, attrib.value);
        }
        return res;
    };
    BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
        return element.hasAttribute(attribute);
    };
    BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
        return element.hasAttributeNS(ns, attribute);
    };
    BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
        return element.getAttribute(attribute);
    };
    BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
        return element.getAttributeNS(ns, name);
    };
    BrowserDomAdapter.prototype.setAttribute = function (element, name, value) { element.setAttribute(name, value); };
    BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
        element.setAttributeNS(ns, name, value);
    };
    BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) { element.removeAttribute(attribute); };
    BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
        element.removeAttributeNS(ns, name);
    };
    BrowserDomAdapter.prototype.templateAwareRoot = function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
    BrowserDomAdapter.prototype.createHtmlDocument = function () {
        return document.implementation.createHTMLDocument('fakeTitle');
    };
    BrowserDomAdapter.prototype.defaultDoc = function () { return document; };
    BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
        try {
            return el.getBoundingClientRect();
        }
        catch (e) {
            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
        }
    };
    BrowserDomAdapter.prototype.getTitle = function () { return document.title; };
    BrowserDomAdapter.prototype.setTitle = function (newTitle) { document.title = newTitle || ''; };
    BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
        if (n instanceof HTMLElement) {
            return n.matches && n.matches(selector) ||
                n.msMatchesSelector && n.msMatchesSelector(selector) ||
                n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
        }
        return false;
    };
    BrowserDomAdapter.prototype.isTemplateElement = function (el) {
        return el instanceof HTMLElement && el.nodeName == 'TEMPLATE';
    };
    BrowserDomAdapter.prototype.isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    BrowserDomAdapter.prototype.isCommentNode = function (node) { return node.nodeType === Node.COMMENT_NODE; };
    BrowserDomAdapter.prototype.isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(node.shadowRoot) && node instanceof HTMLElement;
    };
    BrowserDomAdapter.prototype.isShadowRoot = function (node) { return node instanceof DocumentFragment; };
    BrowserDomAdapter.prototype.importIntoDoc = function (node) { return document.importNode(this.templateAwareRoot(node), true); };
    BrowserDomAdapter.prototype.adoptNode = function (node) { return document.adoptNode(node); };
    BrowserDomAdapter.prototype.getHref = function (el) { return el.href; };
    BrowserDomAdapter.prototype.getEventKey = function (event) {
        var key = event.key;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(key)) {
            key = event.keyIdentifier;
            // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
            // Safari cf
            // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(key)) {
                return 'Unidentified';
            }
            if (key.startsWith('U+')) {
                key = String.fromCharCode(parseInt(key.substring(2), 16));
                if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                    // There is a bug in Chrome for numeric keypad keys:
                    // https://code.google.com/p/chromium/issues/detail?id=155654
                    // 1, 2, 3 ... are reported as A, B, C ...
                    key = _chromeNumKeyPadMap[key];
                }
            }
        }
        return _keyMap[key] || key;
    };
    BrowserDomAdapter.prototype.getGlobalEventTarget = function (target) {
        if (target === 'window') {
            return window;
        }
        if (target === 'document') {
            return document;
        }
        if (target === 'body') {
            return document.body;
        }
    };
    BrowserDomAdapter.prototype.getHistory = function () { return window.history; };
    BrowserDomAdapter.prototype.getLocation = function () { return window.location; };
    BrowserDomAdapter.prototype.getBaseHref = function () {
        var href = getBaseElementHref();
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(href) ? null : relativePath(href);
    };
    BrowserDomAdapter.prototype.resetBaseElement = function () { baseElement = null; };
    BrowserDomAdapter.prototype.getUserAgent = function () { return window.navigator.userAgent; };
    BrowserDomAdapter.prototype.setData = function (element, name, value) {
        this.setAttribute(element, 'data-' + name, value);
    };
    BrowserDomAdapter.prototype.getData = function (element, name) {
        return this.getAttribute(element, 'data-' + name);
    };
    BrowserDomAdapter.prototype.getComputedStyle = function (element) { return getComputedStyle(element); };
    // TODO(tbosch): move this into a separate environment class once we have it
    BrowserDomAdapter.prototype.setGlobalVar = function (path, value) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["o" /* setValueOnPath */])(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["a" /* global */], path, value); };
    BrowserDomAdapter.prototype.supportsWebAnimation = function () {
        return typeof Element.prototype['animate'] === 'function';
    };
    BrowserDomAdapter.prototype.performanceNow = function () {
        // performance.now() is not available in all browsers, see
        // http://caniuse.com/#search=performance.now
        return window.performance && window.performance.now ? window.performance.now() :
            new Date().getTime();
    };
    BrowserDomAdapter.prototype.supportsCookies = function () { return true; };
    BrowserDomAdapter.prototype.getCookie = function (name) { return parseCookieValue(document.cookie, name); };
    BrowserDomAdapter.prototype.setCookie = function (name, value) {
        // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
        // not clear other cookies.
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    };
    return BrowserDomAdapter;
}(__WEBPACK_IMPORTED_MODULE_2__generic_browser_adapter__["a" /* GenericBrowserDomAdapter */]));
var baseElement = null;
function getBaseElementHref() {
    if (!baseElement) {
        baseElement = document.querySelector('base');
        if (!baseElement) {
            return null;
        }
    }
    return baseElement.getAttribute('href');
}
// based on urlUtils.js in AngularJS 1
var urlParsingNode;
function relativePath(url) {
    if (!urlParsingNode) {
        urlParsingNode = document.createElement('a');
    }
    urlParsingNode.setAttribute('href', url);
    return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
        '/' + urlParsingNode.pathname;
}
function parseCookieValue(cookieStr, name) {
    name = encodeURIComponent(name);
    for (var _i = 0, _a = cookieStr.split(';'); _i < _a.length; _i++) {
        var cookie = _a[_i];
        var eqIndex = cookie.indexOf('=');
        var _b = eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)], cookieName = _b[0], cookieValue = _b[1];
        if (cookieName.trim() === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}
//# sourceMappingURL=browser_adapter.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__history__ = __webpack_require__(390);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return BrowserPlatformLocation; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
 * This class should not be used directly by an application developer. Instead, use
 * {@link Location}.
 */
var BrowserPlatformLocation = (function (_super) {
    __extends(BrowserPlatformLocation, _super);
    function BrowserPlatformLocation() {
        _super.call(this);
        this._init();
    }
    // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
    /** @internal */
    BrowserPlatformLocation.prototype._init = function () {
        this._location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__["getDOM"])().getLocation();
        this._history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__["getDOM"])().getHistory();
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "location", {
        get: function () { return this._location; },
        enumerable: true,
        configurable: true
    });
    BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__["getDOM"])().getBaseHref(); };
    BrowserPlatformLocation.prototype.onPopState = function (fn) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__["getDOM"])().getGlobalEventTarget('window').addEventListener('popstate', fn, false);
    };
    BrowserPlatformLocation.prototype.onHashChange = function (fn) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_dom_adapter__["getDOM"])().getGlobalEventTarget('window').addEventListener('hashchange', fn, false);
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
        get: function () { return this._location.pathname; },
        set: function (newPath) { this._location.pathname = newPath; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
        get: function () { return this._location.search; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
        get: function () { return this._location.hash; },
        enumerable: true,
        configurable: true
    });
    BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__history__["a" /* supportsState */])()) {
            this._history.pushState(state, title, url);
        }
        else {
            this._location.hash = url;
        }
    };
    BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__history__["a" /* supportsState */])()) {
            this._history.replaceState(state, title, url);
        }
        else {
            this._location.hash = url;
        }
    };
    BrowserPlatformLocation.prototype.forward = function () { this._history.forward(); };
    BrowserPlatformLocation.prototype.back = function () { this._history.back(); };
    BrowserPlatformLocation.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BrowserPlatformLocation.ctorParameters = [];
    return BrowserPlatformLocation;
}(__WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"]));
//# sourceMappingURL=browser_platform_location.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return BrowserGetTestability; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var BrowserGetTestability = (function () {
    function BrowserGetTestability() {
    }
    BrowserGetTestability.init = function () { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["setTestabilityGetter"])(new BrowserGetTestability()); };
    BrowserGetTestability.prototype.addToWindow = function (registry) {
        __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */].getAngularTestability = function (elem, findInAncestors) {
            if (findInAncestors === void 0) { findInAncestors = true; }
            var testability = registry.findTestabilityInTree(elem, findInAncestors);
            if (testability == null) {
                throw new Error('Could not find testability for element.');
            }
            return testability;
        };
        __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */].getAllAngularTestabilities = function () { return registry.getAllTestabilities(); };
        __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */].getAllAngularRootElements = function () { return registry.getAllRootElements(); };
        var whenAllStable = function (callback /** TODO #9100 */) {
            var testabilities = __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */].getAllAngularTestabilities();
            var count = testabilities.length;
            var didWork = false;
            var decrement = function (didWork_ /** TODO #9100 */) {
                didWork = didWork || didWork_;
                count--;
                if (count == 0) {
                    callback(didWork);
                }
            };
            testabilities.forEach(function (testability /** TODO #9100 */) {
                testability.whenStable(decrement);
            });
        };
        if (!__WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */]['frameworkStabilizers']) {
            __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */]['frameworkStabilizers'] = [];
        }
        __WEBPACK_IMPORTED_MODULE_2__facade_lang__["a" /* global */]['frameworkStabilizers'].push(whenAllStable);
    };
    BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        if (elem == null) {
            return null;
        }
        var t = registry.getTestability(elem);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["d" /* isPresent */])(t)) {
            return t;
        }
        else if (!findInAncestors) {
            return null;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().isShadowRoot(elem)) {
            return this.findTestabilityInTree(registry, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().getHost(elem), true);
        }
        return this.findTestabilityInTree(registry, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().parentElement(elem), true);
    };
    return BrowserGetTestability;
}());
//# sourceMappingURL=testability.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["b"] = camelCaseToDashCase;
/* harmony export (immutable) */ exports["a"] = dashCaseToCamelCase;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CAMEL_CASE_REGEXP = /([A-Z])/g;
var DASH_CASE_REGEXP = /-([a-z])/g;
function camelCaseToDashCase(input) {
    return input.replace(CAMEL_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i - 0] = arguments[_i];
        }
        return '-' + m[1].toLowerCase();
    });
}
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i - 0] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_link__ = __webpack_require__(111);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RouterLinkActive; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @whatItDoes Lets you add a CSS class to an element when the link's route becomes active.
 *
 * @howToUse
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * @description
 *
 * The RouterLinkActive directive lets you add a CSS class to an element when the link's route
 * becomes active.
 *
 * Consider the following example:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * When the url is either '/user' or '/user/bob', the active-link class will
 * be added to the `a` tag. If the url changes, the class will be removed.
 *
 * You can set more than one class, as follows:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
 * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
 * ```
 *
 * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
 * only when the url matches the link exactly.
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
 * true}">Bob</a>
 * ```
 *
 * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
 *
 * ```
 * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
 *   <a routerLink="/user/jim">Jim</a>
 *   <a routerLink="/user/bob">Bob</a>
 * </div>
 * ```
 *
 * This will set the active-link class on the div tag if the url is either '/user/jim' or
 * '/user/bob'.
 *
 * @selector ':not(a)[routerLink]'
 * @ngModule RouterModule
 *
 * @stable
 */
var RouterLinkActive = (function () {
    function RouterLinkActive(router, element, renderer) {
        var _this = this;
        this.router = router;
        this.element = element;
        this.renderer = renderer;
        this.classes = [];
        this.routerLinkActiveOptions = { exact: false };
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof __WEBPACK_IMPORTED_MODULE_1__router__["NavigationEnd"]) {
                _this.update();
            }
        });
    }
    RouterLinkActive.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.links.changes.subscribe(function (s) { return _this.update(); });
        this.linksWithHrefs.changes.subscribe(function (s) { return _this.update(); });
        this.update();
    };
    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
        set: function (data) {
            if (Array.isArray(data)) {
                this.classes = data;
            }
            else {
                this.classes = data.split(' ');
            }
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
    RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterLinkActive.prototype.update = function () {
        var _this = this;
        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
            return;
        var isActive = this.hasActiveLink();
        this.classes.forEach(function (c) { return _this.renderer.setElementClass(_this.element.nativeElement, c, isActive); });
    };
    RouterLinkActive.prototype.isLinkActive = function (router) {
        var _this = this;
        return function (link) {
            return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact);
        };
    };
    RouterLinkActive.prototype.hasActiveLink = function () {
        return this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));
    };
    RouterLinkActive.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[routerLinkActive]' },] },
    ];
    /** @nocollapse */
    RouterLinkActive.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__router__["Router"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    ];
    RouterLinkActive.propDecorators = {
        'links': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__router_link__["RouterLink"], { descendants: true },] },],
        'linksWithHrefs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__router_link__["RouterLinkWithHref"], { descendants: true },] },],
        'routerLinkActiveOptions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'routerLinkActive': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RouterLinkActive;
}());
//# sourceMappingURL=router_link_active.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * @AngularClass
 */
"use strict";
var core_1 = __webpack_require__(0);
// import { PreloadingStrategy, Route } from '@angular/router';
var Observable_1 = __webpack_require__(13);
__webpack_require__(100);
/*
 * token to requestIdleCallback
 */
exports.REQUEST_IDLE_CALLBACK = new core_1.OpaqueToken('REQUEST_IDLE_CALLBACK');
/*
 * Private please use @angularclass/request-idle-callback if you want to use this
 */
function _requestIdle(zone) {
    var win = window;
    if (win.requestIdleCallback) {
        return function (fn) { return win.requestIdleCallback(fn); };
    }
    return function (fn) { return zone.runOutsideAngular(function () { return win.setTimeout(fn, 10); }); };
}
exports._requestIdle = _requestIdle;
var IdlePreload /*implements PreloadingStrategy*/ = (function () {
    /*
     * include zone to run outside of zone.js
     */
    function IdlePreload /*implements PreloadingStrategy*/(_ngZone, requestIdleCallback) {
        this._ngZone = _ngZone;
        this.requestIdleCallback = requestIdleCallback;
    }
    /*
     * fire off preloading async modules
     */
    IdlePreload /*implements PreloadingStrategy*/.prototype.preload = function (route, fn) {
        this.requestIdleCallback(fn);
        return Observable_1.Observable.of(null);
    };
    IdlePreload /*implements PreloadingStrategy*/.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    IdlePreload /*implements PreloadingStrategy*/.ctorParameters = [
        { type: core_1.NgZone, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [exports.REQUEST_IDLE_CALLBACK,] },] },
    ];
    return IdlePreload /*implements PreloadingStrategy*/;
}());
exports.IdlePreload /*implements PreloadingStrategy*/ = IdlePreload /*implements PreloadingStrategy*/;
/*
 * raw providers
 */
exports.ANGULARCLASS_IDLE_PRELOAD_PROVIDERS = [
    { provide: IdlePreload, useClass: IdlePreload }
];
exports.ANGULARCLASS_REQUEST_IDLE_CALLBACK_PROVIDERS = [
    { provide: exports.REQUEST_IDLE_CALLBACK, useFactory: _requestIdle, deps: [core_1.NgZone] }
];
var IdlePreloadModule = (function () {
    function IdlePreloadModule() {
    }
    /*
     * forRoot() to allow providers only be created once
     */
    IdlePreloadModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: IdlePreloadModule,
            providers: (config.requestIdleCallback === false ? [] : exports.ANGULARCLASS_REQUEST_IDLE_CALLBACK_PROVIDERS).concat(exports.ANGULARCLASS_IDLE_PRELOAD_PROVIDERS)
        };
    };
    /*
     * alias for reference to IdlePreload token
     */
    IdlePreloadModule.IdleStrategy = function () {
        return IdlePreload;
    };
    IdlePreloadModule.decorators = [
        { type: core_1.NgModule, args: [{},] },
    ];
    /** @nocollapse */
    IdlePreloadModule.ctorParameters = [];
    return IdlePreloadModule;
}());
exports.IdlePreloadModule = IdlePreloadModule;
//# sourceMappingURL=index.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */
"use strict";
var base_cookie_options_1 = __webpack_require__(291);
exports.BaseCookieOptions = base_cookie_options_1.BaseCookieOptions;
exports.CookieOptions = base_cookie_options_1.CookieOptions;
var cookies_service_1 = __webpack_require__(77);
exports.CookieService = cookies_service_1.CookieService;

//# sourceMappingURL=services.js.map


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var common_1 = __webpack_require__(23);
var core_1 = __webpack_require__(0);
/** @private */
var CookieOptions = (function () {
    function CookieOptions(_a) {
        var _b = _a === void 0 ? {} : _a, path = _b.path, domain = _b.domain, expires = _b.expires, secure = _b.secure;
        this.path = this.isPresent(path) ? path : null;
        this.domain = this.isPresent(domain) ? domain : null;
        this.expires = this.isPresent(expires) ? expires : null;
        this.secure = this.isPresent(secure) ? secure : false;
    }
    CookieOptions.prototype.merge = function (options) {
        return new CookieOptions({
            path: this.isPresent(options) && this.isPresent(options.path) ? options.path : this.path,
            domain: this.isPresent(options) && this.isPresent(options.domain) ? options.domain :
                this.domain,
            expires: this.isPresent(options) && this.isPresent(options.expires) ? options.expires :
                this.expires,
            secure: this.isPresent(options) && this.isPresent(options.secure) ? options.secure :
                this.secure,
        });
    };
    CookieOptions.prototype.isPresent = function (obj) {
        return obj !== undefined && obj !== null;
    };
    return CookieOptions;
}());
exports.CookieOptions = CookieOptions;
/** @private */
var BaseCookieOptions = (function (_super) {
    __extends(BaseCookieOptions, _super);
    function BaseCookieOptions(baseHref) {
        _super.call(this, { path: baseHref || '/' });
        this.baseHref = baseHref;
    }
    BaseCookieOptions = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(common_1.APP_BASE_HREF)), 
        __metadata('design:paramtypes', [String])
    ], BaseCookieOptions);
    return BaseCookieOptions;
}(CookieOptions));
exports.BaseCookieOptions = BaseCookieOptions;

//# sourceMappingURL=base-cookie-options.js.map


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(293));
__export(__webpack_require__(294));
__export(__webpack_require__(411));
//# sourceMappingURL=browser.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports) {

"use strict";
"use strict";
exports.isBrowser = true;
exports.isNode = false;
//# sourceMappingURL=env.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(62);
var platform_browser_dynamic_1 = __webpack_require__(81);
var platform_browser_1 = __webpack_require__(126);
var prebootClient;
try {
    prebootClient = __webpack_require__(468);
    prebootClient = (prebootClient && prebootClient.prebootClient) || prebootClient;
}
catch (e) { }
function _randomChar() {
    return String.fromCharCode(97 + Math.floor(Math.random() * 25));
}
function _appIdRandomProviderFactory() {
    return "" + _randomChar() + _randomChar() + _randomChar();
}
var SharedStylesHost = platform_browser_1.__platform_browser_private__.SharedStylesHost;
exports.UNIVERSAL_CACHE = new core_1.OpaqueToken('UNIVERSAL_CACHE');
exports.AUTO_PREBOOT = new core_1.OpaqueToken('AUTO_PREBOOT');
function universalCacheFactory() {
    var _win = window;
    var CACHE = Object.assign({}, _win.UNIVERSAL_CACHE || {});
    delete _win.UNIVERSAL_CACHE;
    return CACHE;
}
exports.universalCacheFactory = universalCacheFactory;
function appIdFactory() {
    var _win = window;
    var CACHE = _win.UNIVERSAL_CACHE || {};
    var appId = null;
    if (CACHE.APP_ID) {
        appId = CACHE.APP_ID;
    }
    else {
        appId = _appIdRandomProviderFactory();
    }
    return appId;
}
exports.appIdFactory = appIdFactory;
function appBootstrapListenerFactory(autoPreboot) {
    return autoPreboot ? prebootComplete : function () { };
}
exports.appBootstrapListenerFactory = appBootstrapListenerFactory;
function prebootComplete(value) {
    var _win = window;
    if (_win && prebootClient) {
        setTimeout(function () { return prebootClient().complete(); });
    }
    return value;
}
exports.prebootComplete = prebootComplete;
var UniversalModule = (function () {
    function UniversalModule(sharedStylesHost) {
        var domStyles = document.head.querySelectorAll('style');
        var styles = Array.prototype.slice.call(domStyles)
            .filter(function (style) { return (style.innerText || style.textContent).indexOf('_ng') !== -1; })
            .map(function (style) { return (style.innerText || style.textContent); });
        styles.forEach(function (style) {
            sharedStylesHost._stylesSet.add(style);
            sharedStylesHost._styles.push(style);
        });
    }
    UniversalModule.withConfig = function (_config) {
        if (_config === void 0) { _config = {}; }
        var providers = [];
        if (typeof _config.autoPreboot === 'boolean') {
            providers.push({
                provide: exports.AUTO_PREBOOT,
                useValue: _config.autoPreboot,
            });
        }
        return {
            ngModule: UniversalModule,
            providers: providers,
        };
    };
    UniversalModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [],
                    exports: [
                        platform_browser_1.BrowserModule,
                        http_1.HttpModule,
                        http_1.JsonpModule
                    ],
                    providers: [
                        {
                            provide: exports.UNIVERSAL_CACHE,
                            useFactory: universalCacheFactory,
                        },
                        {
                            provide: core_1.APP_ID,
                            useFactory: appIdFactory,
                            deps: []
                        },
                        {
                            provide: exports.AUTO_PREBOOT,
                            useValue: true
                        },
                        {
                            multi: true,
                            provide: core_1.APP_BOOTSTRAP_LISTENER,
                            useFactory: appBootstrapListenerFactory,
                            deps: [exports.AUTO_PREBOOT],
                        },
                    ]
                },] },
    ];
    UniversalModule.ctorParameters = [
        { type: undefined, decorators: [{ type: core_1.Inject, args: [SharedStylesHost,] },] },
    ];
    return UniversalModule;
}());
exports.UniversalModule = UniversalModule;
function platformUniversalDynamic(extraProviders) {
    var platform = core_1.createPlatformFactory(platform_browser_dynamic_1.platformBrowserDynamic, 'universalBrowserDynamic', [])(extraProviders);
    return platform;
}
exports.platformUniversalDynamic = platformUniversalDynamic;
;
//# sourceMappingURL=universal-module.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(69);
var Wrapper_NgForm = (function () {
    function Wrapper_NgForm(p0, p1) {
        this.changed = false;
        this.context = new import0.NgForm(p0, p1);
    }
    Wrapper_NgForm.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_NgForm.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_NgForm;
}());
exports.Wrapper_NgForm = Wrapper_NgForm;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var common_1 = __webpack_require__(23);
var pagination_pipe_1 = __webpack_require__(297);
var pagination_component_1 = __webpack_require__(95);
var core_1 = __webpack_require__(0);
var PaginationModule = (function () {
    function PaginationModule() {
    }
    PaginationModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule
            ],
            declarations: [
                pagination_component_1.PaginationComponent,
                pagination_pipe_1.PaginationPipe
            ],
            exports: [
                pagination_component_1.PaginationComponent,
                pagination_pipe_1.PaginationPipe
            ],
            providers: []
        }), 
        __metadata('design:paramtypes', [])
    ], PaginationModule);
    return PaginationModule;
}());
exports.PaginationModule = PaginationModule;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var PaginationPipe = (function () {
    function PaginationPipe() {
    }
    PaginationPipe.prototype.transform = function (collection, args) {
        var start = (args.currentPage - 1) * args.pageSize, end = start + args.pageSize;
        var data = collection.slice(start, end);
        return data;
    };
    PaginationPipe = __decorate([
        core_1.Pipe({
            name: 'pagination'
        }), 
        __metadata('design:paramtypes', [])
    ], PaginationPipe);
    return PaginationPipe;
}());
exports.PaginationPipe = PaginationPipe;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var content_pages_component_1 = __webpack_require__(155);
var content_records_component_1 = __webpack_require__(157);
var auth_gard_service_1 = __webpack_require__(233);
var admin_login_component_1 = __webpack_require__(150);
var admin_root_component_1 = __webpack_require__(151);
var content_page_edit_component_1 = __webpack_require__(154);
var content_record_edit_component_1 = __webpack_require__(156);
var content_special_edit_component_1 = __webpack_require__(158);
var content_specials_component_1 = __webpack_require__(159);
var content_writing_edit_component_1 = __webpack_require__(160);
var content_writings_component_1 = __webpack_require__(161);
var content_messages_component_1 = __webpack_require__(153);
var content_message_edit_component_1 = __webpack_require__(152);
var contentRoutes = [
    // HOME 
    { path: '', redirectTo: 'records', pathMatch: 'full' },
    // PAGE  
    { path: 'pages', component: content_pages_component_1.ContentPagesComponent },
    /*fake reload*/ { path: 'pages/reload', component: content_pages_component_1.ContentPagesComponent },
    { path: 'page/edit/:id', component: content_page_edit_component_1.ContentPageEditComponent },
    // RECORD 
    { path: 'records', component: content_records_component_1.ContentRecordsComponent },
    { path: 'records/active/:active', component: content_records_component_1.ContentRecordsComponent },
    /*fake reload*/ { path: 'records/reload', component: content_records_component_1.ContentRecordsComponent },
    { path: 'record/edit/:id', component: content_record_edit_component_1.ContentRecordEditComponent },
    // SPECIAL
    { path: 'specials', component: content_specials_component_1.ContentSpecialsComponent },
    /*fake reload*/ { path: 'specials/reload', component: content_specials_component_1.ContentSpecialsComponent },
    { path: 'special/edit/:id', component: content_special_edit_component_1.ContentSpecialEditComponent },
    // WRITING
    { path: 'writings', component: content_writings_component_1.ContentWritingsComponent },
    /*fake reload*/ { path: 'writings/reload', component: content_writings_component_1.ContentWritingsComponent },
    { path: 'writing/edit/:id', component: content_writing_edit_component_1.ContentWritingEditComponent },
    // MESSAGE
    { path: 'messages', component: content_messages_component_1.ContentMessagesComponent },
    /*fake reload*/ { path: 'messages/reload', component: content_messages_component_1.ContentMessagesComponent },
    { path: 'message/edit/:id', component: content_message_edit_component_1.ContentMessageEditComponent },
];
var AdminRoutingModule = (function () {
    function AdminRoutingModule() {
    }
    AdminRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild([
                    { path: 'admin/login', component: admin_login_component_1.AdminLoginComponent },
                    // , canActivateChild: [AuthGuard],
                    { path: 'admin', component: admin_root_component_1.AdminRootComponent, children: contentRoutes, canActivateChild: [auth_gard_service_1.AuthGuard] },
                    // , canActivateChild: [AuthGuard],
                    { path: ':lg/admin', component: admin_root_component_1.AdminRootComponent, children: contentRoutes, canActivateChild: [auth_gard_service_1.AuthGuard] }
                ])
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], AdminRoutingModule);
    return AdminRoutingModule;
}());
exports.AdminRoutingModule = AdminRoutingModule;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(23);
var router_1 = __webpack_require__(8);
var forms_1 = __webpack_require__(52);
// import { FileSelectDirective } from 'ng2-file-upload';
var ng2_file_upload_1 = __webpack_require__(319);
var ng2_input_mask_module_1 = __webpack_require__(300);
var ng2_bs_pagination_1 = __webpack_require__(315); // shared ??
// SHARED
var shared_module_1 = __webpack_require__(179);
// ADMIN
var admin_app_component_1 = __webpack_require__(417);
var admin_root_component_1 = __webpack_require__(151);
var admin_routing_module_1 = __webpack_require__(298);
var admin_menu_component_1 = __webpack_require__(223);
var admin_header_component_1 = __webpack_require__(222);
var admin_footer_component_1 = __webpack_require__(221);
var admin_login_component_1 = __webpack_require__(150);
var admin_search_facets_component_1 = __webpack_require__(423);
var search_results_component_1 = __webpack_require__(226);
var content_page_edit_component_1 = __webpack_require__(154);
var content_pages_component_1 = __webpack_require__(155);
var content_record_edit_component_1 = __webpack_require__(156);
var content_records_component_1 = __webpack_require__(157);
var content_special_edit_component_1 = __webpack_require__(158);
var content_specials_component_1 = __webpack_require__(159);
var content_writing_edit_component_1 = __webpack_require__(160);
var content_writings_component_1 = __webpack_require__(161);
var content_messages_component_1 = __webpack_require__(153);
var content_message_edit_component_1 = __webpack_require__(152);
var html_editor_component_1 = __webpack_require__(96);
var image_upload_component_1 = __webpack_require__(224);
var MODULES = [
    // Do NOT include UniversalModule, HttpModule, or JsonpModule here! 
    common_1.CommonModule,
    router_1.RouterModule,
    forms_1.FormsModule,
    forms_1.ReactiveFormsModule,
    ng2_input_mask_module_1.Ng2InputMaskModule,
    ng2_file_upload_1.FileUploadModule,
    ng2_bs_pagination_1.PaginationModule,
    shared_module_1.SharedModule,
    admin_routing_module_1.AdminRoutingModule
];
var PIPES = [];
var COMPONENTS = [
    // put shared components here
    // FileSelectDirective,
    admin_app_component_1.AdminAppComponent,
    admin_root_component_1.AdminRootComponent,
    admin_menu_component_1.AdminMenuComponent,
    admin_header_component_1.AdminHeaderComponent,
    admin_footer_component_1.AdminFooterComponent,
    admin_login_component_1.AdminLoginComponent,
    admin_search_facets_component_1.AdminSearchFacetsComponent,
    search_results_component_1.SearchResultsComponent,
    content_page_edit_component_1.ContentPageEditComponent,
    content_pages_component_1.ContentPagesComponent,
    content_record_edit_component_1.ContentRecordEditComponent,
    content_records_component_1.ContentRecordsComponent,
    content_special_edit_component_1.ContentSpecialEditComponent,
    content_specials_component_1.ContentSpecialsComponent,
    content_writing_edit_component_1.ContentWritingEditComponent,
    content_writings_component_1.ContentWritingsComponent,
    content_messages_component_1.ContentMessagesComponent,
    content_message_edit_component_1.ContentMessageEditComponent,
    html_editor_component_1.HtmlEditorComponent,
    image_upload_component_1.ImageUploadComponent
];
var PROVIDERS = [];
var AdminModule = (function () {
    function AdminModule() {
    }
    AdminModule.forRoot = function () {
        return {
            ngModule: AdminModule,
            providers: PROVIDERS.slice()
        };
    };
    AdminModule = __decorate([
        core_1.NgModule({
            imports: MODULES.slice(),
            declarations: PIPES.concat(COMPONENTS),
            exports: MODULES.concat(PIPES, COMPONENTS)
        }), 
        __metadata('design:paramtypes', [])
    ], AdminModule);
    return AdminModule;
}());
exports.AdminModule = AdminModule;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var mask_directive_1 = __webpack_require__(435);
var mask_service_1 = __webpack_require__(225);
var Ng2InputMaskModule = (function () {
    function Ng2InputMaskModule() {
    }
    Ng2InputMaskModule = __decorate([
        core_1.NgModule({
            exports: [
                mask_directive_1.MaskDirective
            ],
            declarations: [
                mask_directive_1.MaskDirective
            ],
            providers: [
                mask_service_1.MaskService
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], Ng2InputMaskModule);
    return Ng2InputMaskModule;
}());
exports.Ng2InputMaskModule = Ng2InputMaskModule;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var app_component_1 = __webpack_require__(227);
var admin_module_1 = __webpack_require__(299);
var front_module_1 = __webpack_require__(304);
var shared_module_1 = __webpack_require__(179);
//     
var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        core_1.NgModule({
            declarations: [
                app_component_1.AppComponent
            ],
            imports: [
                shared_module_1.SharedModule.forRoot(),
                admin_module_1.AdminModule,
                front_module_1.FrontModule,
            ],
            providers: [],
        }), 
        __metadata('design:paramtypes', [])
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;
var app_component_2 = __webpack_require__(227);
exports.AppComponent = app_component_2.AppComponent;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(166);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_ContentRecordsFeaturedComponent = (function () {
    function Wrapper_ContentRecordsFeaturedComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.ContentRecordsFeaturedComponent(p0, p1, p2, p3, p4);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_ContentRecordsFeaturedComponent.prototype.check_currentLanguage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.currentLanguage = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_ContentRecordsFeaturedComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentRecordsFeaturedComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentRecordsFeaturedComponent;
}());
exports.Wrapper_ContentRecordsFeaturedComponent = Wrapper_ContentRecordsFeaturedComponent;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(168);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_ContentSpecialsComponent = (function () {
    function Wrapper_ContentSpecialsComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.ContentSpecialsComponent(p0, p1, p2, p3, p4);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_ContentSpecialsComponent.prototype.check_currentLanguage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.currentLanguage = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_ContentSpecialsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentSpecialsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentSpecialsComponent;
}());
exports.Wrapper_ContentSpecialsComponent = Wrapper_ContentSpecialsComponent;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var shared_module_1 = __webpack_require__(179);
var ng_lazyload_image_1 = __webpack_require__(464);
var routing_module_1 = __webpack_require__(305);
var root_component_1 = __webpack_require__(173);
var cookie_consent_component_1 = __webpack_require__(229);
var content_records_component_1 = __webpack_require__(167);
var search_facets_component_1 = __webpack_require__(174);
var home_component_1 = __webpack_require__(171);
var content_records_featured_component_1 = __webpack_require__(166);
var content_specials_component_1 = __webpack_require__(168);
var content_writing_component_1 = __webpack_require__(169);
var content_writings_component_1 = __webpack_require__(170);
var search_az_component_1 = __webpack_require__(231);
var content_page_component_1 = __webpack_require__(164);
var content_record_component_1 = __webpack_require__(165);
var cart_service_1 = __webpack_require__(49);
var cart_widget_component_1 = __webpack_require__(228);
var cart_component_1 = __webpack_require__(163);
var payment_paypal_express_checkout_component_1 = __webpack_require__(230);
var page_not_found_component_1 = __webpack_require__(172);
// test
var browser_component_1 = __webpack_require__(438);
var angular2_universal_1 = __webpack_require__(27);
var FrontModule = (function () {
    function FrontModule() {
    }
    FrontModule = __decorate([
        core_1.NgModule({
            declarations: [
                root_component_1.FrontRootComponent, home_component_1.HomeComponent, cookie_consent_component_1.CookieConsentComponent,
                content_page_component_1.ContentPageComponent, content_record_component_1.ContentRecordComponent, content_records_component_1.ContentRecordsComponent,
                content_records_featured_component_1.ContentRecordsFeaturedComponent, content_specials_component_1.ContentSpecialsComponent,
                content_writing_component_1.ContentWritingComponent, content_writings_component_1.ContentWritingsComponent,
                search_facets_component_1.SearchFacetsComponent, search_az_component_1.SearchAZComponent,
                cart_widget_component_1.CartWidgetComponent, cart_component_1.CartComponent, payment_paypal_express_checkout_component_1.PaymentPayPalExpressCheckoutComponent,
                page_not_found_component_1.PageNotFoundComponent,
                browser_component_1.BrowserComponent
            ],
            imports: [
                routing_module_1.FrontRoutingModule,
                shared_module_1.SharedModule,
                ng_lazyload_image_1.LazyLoadImageModule
            ],
            providers: [
                cart_service_1.CartService,
                {
                    provide: angular2_universal_1.AUTO_PREBOOT,
                    useValue: false
                }
            ],
        }), 
        __metadata('design:paramtypes', [])
    ], FrontModule);
    return FrontModule;
}());
exports.FrontModule = FrontModule;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var home_component_1 = __webpack_require__(171);
var root_component_1 = __webpack_require__(173);
var content_records_component_1 = __webpack_require__(167);
var cart_component_1 = __webpack_require__(163);
var content_page_component_1 = __webpack_require__(164);
var content_record_component_1 = __webpack_require__(165);
var content_writing_component_1 = __webpack_require__(169);
var content_writings_component_1 = __webpack_require__(170);
var page_not_found_component_1 = __webpack_require__(172);
// Cannot be used in OAT mode (function call not allowed for some reason)
// var homeRoutes = () => {
//   let routes: any[] = [{ path: '',  component: HomeComponent }];
//   // Home routes
//   AppConfig.SUPPORTED_LANGUAGES.forEach(lg=>{
//     routes.push({ path: lg,  component: HomeComponent })
//   });
//   return routes;
// }
// Home routes hard-coded with languages for AOT mode
var contentRoutes = [
    { path: '', component: home_component_1.HomeComponent },
    { path: 'fr', component: home_component_1.HomeComponent },
    { path: 'en', component: home_component_1.HomeComponent },
    // PAGE 
    { path: 'page/:url', component: content_page_component_1.ContentPageComponent },
    // WRITINGS 
    { path: 'writings', component: content_writings_component_1.ContentWritingsComponent },
    { path: 'writing/:url', component: content_writing_component_1.ContentWritingComponent },
    // CATALOGUE 
    { path: 'catalogue', component: content_records_component_1.ContentRecordsComponent },
    { path: 'catalogue/:type', component: content_records_component_1.ContentRecordsComponent },
    { path: 'catalogue/:field/:value', component: content_records_component_1.ContentRecordsComponent },
    // CART
    { path: 'cart', component: cart_component_1.CartComponent },
    // PAGE NOT FOUND 
    { path: 'page-not-found', component: page_not_found_component_1.PageNotFoundComponent },
    // RECORD 
    { path: ':url', component: content_record_component_1.ContentRecordComponent },
];
// cannot be used in OAT: homeRoutes().concat(contentRoutes)
var FrontRoutingModule = (function () {
    function FrontRoutingModule() {
    }
    FrontRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild([
                    { path: '', component: root_component_1.FrontRootComponent, children: contentRoutes },
                    { path: ':lg', component: root_component_1.FrontRootComponent, children: contentRoutes },
                ])
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], FrontRoutingModule);
    return FrontRoutingModule;
}());
exports.FrontRoutingModule = FrontRoutingModule;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(174);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(16);
var import10 = __webpack_require__(15);
var import11 = __webpack_require__(29);
var import12 = __webpack_require__(11);
var import13 = __webpack_require__(10);
var import14 = __webpack_require__(24);
var import15 = __webpack_require__(98);
var import16 = __webpack_require__(14);
var import17 = __webpack_require__(20);
var import18 = __webpack_require__(21);
var import19 = __webpack_require__(22);
var import20 = __webpack_require__(19);
var Wrapper_SearchFacetsComponent = (function () {
    function Wrapper_SearchFacetsComponent(p0, p1, p2, p3) {
        this.changed = false;
        this.context = new import0.SearchFacetsComponent(p0, p1, p2, p3);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_SearchFacetsComponent.prototype.check_esAggregations = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.esAggregations = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.check_fields = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.fields = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.check_esFilters = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.esFilters = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this._expr_5 = currValue;
        }
    };
    Wrapper_SearchFacetsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchFacetsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchFacetsComponent;
}());
exports.Wrapper_SearchFacetsComponent = Wrapper_SearchFacetsComponent;
var renderType_SearchFacetsComponent_Host = null;
var _View_SearchFacetsComponent_Host0 = (function (_super) {
    __extends(_View_SearchFacetsComponent_Host0, _super);
    function _View_SearchFacetsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent_Host0, renderType_SearchFacetsComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'search-facets', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchFacetsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchFacetsComponent_0_4 = new Wrapper_SearchFacetsComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import9.ActivatedRoute), this.parentInjector.get(import10.Router), this.parentInjector.get(import11.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchFacetsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchFacetsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchFacetsComponent) && (0 === requestNodeIndex))) {
            return this._SearchFacetsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchFacetsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchFacetsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFacetsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent_Host0;
}(import3.AppView));
function viewFactory_SearchFacetsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchFacetsComponent_Host === null)) {
        (renderType_SearchFacetsComponent_Host = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchFacetsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchFacetsComponentNgFactory = new import13.ComponentFactory('search-facets', viewFactory_SearchFacetsComponent_Host0, import0.SearchFacetsComponent);
var styles_SearchFacetsComponent = [];
var renderType_SearchFacetsComponent = null;
var _View_SearchFacetsComponent0 = (function (_super) {
    __extends(_View_SearchFacetsComponent0, _super);
    function _View_SearchFacetsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent0, renderType_SearchFacetsComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n', null);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_1 = new import5.AppElement(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import16.TemplateRef_(this._appEl_1, viewFactory_SearchFacetsComponent1);
        this._NgFor_1_6 = new import14.Wrapper_NgFor(this._appEl_1.vcRef, this._TemplateRef_1_5, this.parentInjector.get(import17.IterableDiffers), this.ref);
        this._pipe_truncate_0 = new import15.TruncatePipe();
        this.init([], [
            this._text_0,
            this._anchor_1
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import18.NgFor) && (1 === requestNodeIndex))) {
            return this._NgFor_1_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFacetsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = this.context.fields;
        this._NgFor_1_6.check_ngForOf(currVal_1_0_0, throwOnChange, false);
        this._NgFor_1_6.detectChangesInInputProps(this, this._anchor_1, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent0;
}(import3.AppView));
function viewFactory_SearchFacetsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchFacetsComponent === null)) {
        (renderType_SearchFacetsComponent = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.None, styles_SearchFacetsComponent, {}));
    }
    return new _View_SearchFacetsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchFacetsComponent0 = viewFactory_SearchFacetsComponent0;
var _View_SearchFacetsComponent1 = (function (_super) {
    __extends(_View_SearchFacetsComponent1, _super);
    function _View_SearchFacetsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent1, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'facet widget'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2, viewFactory_SearchFacetsComponent2);
        this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import20.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFacetsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = (this.parent.context.esAggregations && (this.parent.context.esAggregations[this.context.$implicit].buckets.length > 0));
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent1;
}(import3.AppView));
function viewFactory_SearchFacetsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent2 = (function (_super) {
    __extends(_View_SearchFacetsComponent2, _super);
    function _View_SearchFacetsComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent2, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2, viewFactory_SearchFacetsComponent3);
        this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_4 = new import5.AppElement(4, 0, this, this._anchor_4);
        this._TemplateRef_4_5 = new import16.TemplateRef_(this._appEl_4, viewFactory_SearchFacetsComponent4);
        this._NgIf_4_6 = new import19.Wrapper_NgIf(this._appEl_4.vcRef, this._TemplateRef_4_5);
        this._text_5 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'widget-body'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n            ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_6, 'ul', new import2.InlineArray2(2, 'class', 'category-list'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8, null);
        this._appEl_10 = new import5.AppElement(10, 8, this, this._anchor_10);
        this._TemplateRef_10_5 = new import16.TemplateRef_(this._appEl_10, viewFactory_SearchFacetsComponent5);
        this._NgFor_10_6 = new import14.Wrapper_NgFor(this._appEl_10.vcRef, this._TemplateRef_10_5, this.parent.parentInjector.get(import17.IterableDiffers), this.parent.parent.ref);
        this._text_11 = this.renderer.createText(this._el_8, '\n            ', null);
        this._text_12 = this.renderer.createText(this._el_6, '\n        ', null);
        this._text_13 = this.renderer.createText(this._el_0, '\n    ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3,
            this._anchor_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import20.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        if (((token === import16.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import20.NgIf) && (4 === requestNodeIndex))) {
            return this._NgIf_4_6.context;
        }
        if (((token === import16.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import18.NgFor) && (10 === requestNodeIndex))) {
            return this._NgFor_10_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFacetsComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = (this.parent.context.$implicit != 'type');
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        var currVal_4_0_0 = (this.parent.context.$implicit != 'type');
        this._NgIf_4_6.check_ngIf(currVal_4_0_0, throwOnChange, false);
        this._NgIf_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        var currVal_10_0_0 = this.parent.parent.context.esAggregations[this.parent.context.$implicit].buckets;
        this._NgFor_10_6.check_ngForOf(currVal_10_0_0, throwOnChange, false);
        this._NgFor_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent2;
}(import3.AppView));
function viewFactory_SearchFacetsComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent3 = (function (_super) {
    __extends(_View_SearchFacetsComponent3, _super);
    function _View_SearchFacetsComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent3, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_SearchFacetsComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'h5', new import2.InlineArray2(2, 'class', 'widget-title font-alt'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = import2.interpolate(1, '', ((this.parent.parent.parent.context.labels && this.parent.parent.parent.context.labels[this.parent.parent.context.$implicit]) ? this.parent.parent.parent.context.labels[this.parent.parent.context.$implicit][this.parent.parent.parent.context.language] : this.parent.parent.context.$implicit), '');
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent3;
}(import3.AppView));
function viewFactory_SearchFacetsComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent4 = (function (_super) {
    __extends(_View_SearchFacetsComponent4, _super);
    function _View_SearchFacetsComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent4, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'thin-separator-line bg-dark-gray no-margin-lr margin-ten'), null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    return _View_SearchFacetsComponent4;
}(import3.AppView));
function viewFactory_SearchFacetsComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent5 = (function (_super) {
    __extends(_View_SearchFacetsComponent5, _super);
    function _View_SearchFacetsComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent5, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchFacetsComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', new import2.InlineArray2(2, 'class', 'facet-element'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import16.TemplateRef_(this._appEl_2, viewFactory_SearchFacetsComponent6);
        this._NgIf_2_6 = new import19.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_4 = new import5.AppElement(4, 0, this, this._anchor_4);
        this._TemplateRef_4_5 = new import16.TemplateRef_(this._appEl_4, viewFactory_SearchFacetsComponent7);
        this._NgIf_4_6 = new import19.Wrapper_NgIf(this._appEl_4.vcRef, this._TemplateRef_4_5);
        this._text_5 = this.renderer.createText(this._el_0, '\n                ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3,
            this._anchor_4,
            this._text_5
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import20.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        if (((token === import16.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import20.NgIf) && (4 === requestNodeIndex))) {
            return this._NgIf_4_6.context;
        }
        return notFoundResult;
    };
    _View_SearchFacetsComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = !this.parent.parent.parent.context.utils.isInFilters(this.parent.parent.parent.context.esFilters, this.parent.parent.context.$implicit, this.context.$implicit.key);
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        var currVal_4_0_0 = this.parent.parent.parent.context.utils.isInFilters(this.parent.parent.parent.context.esFilters, this.parent.parent.context.$implicit, this.context.$implicit.key);
        this._NgIf_4_6.check_ngIf(currVal_4_0_0, throwOnChange, false);
        this._NgIf_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent5;
}(import3.AppView));
function viewFactory_SearchFacetsComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent6 = (function (_super) {
    __extends(_View_SearchFacetsComponent6, _super);
    function _View_SearchFacetsComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent6, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    _View_SearchFacetsComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', new import2.InlineArray2(2, 'style', 'cursor: pointer'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this._pipe_truncate_0_0 = import2.pureProxy2(this.parent.parent.parent.parent._pipe_truncate_0.transform.bind(this.parent.parent.parent.parent._pipe_truncate_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_SearchFacetsComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import2.interpolate(1, '\n                    ', valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_0, this.parent.parent.parent.parent._pipe_truncate_0.transform)((((this.parent.parent.parent.parent.context.labels && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES) && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key]) ? this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key][this.parent.parent.parent.parent.context.language] : this.parent.context.$implicit.key), '20')), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_1, currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_7 = import2.interpolate(1, '', this.parent.context.$implicit.doc_count, '');
        if (import2.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setText(this._text_3, currVal_7);
            this._expr_7 = currVal_7;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchFacetsComponent6.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.parent.parent.context.onSelect(this.parent.parent.parent.context.$implicit, this.parent.context.$implicit.key) !== false);
        return (true && pd_0_0);
    };
    return _View_SearchFacetsComponent6;
}(import3.AppView));
function viewFactory_SearchFacetsComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_SearchFacetsComponent7 = (function (_super) {
    __extends(_View_SearchFacetsComponent7, _super);
    function _View_SearchFacetsComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchFacetsComponent7, renderType_SearchFacetsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    _View_SearchFacetsComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', new import2.InlineArray2(2, 'class', 'facet-active'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._pipe_truncate_0_1 = import2.pureProxy2(this.parent.parent.parent.parent._pipe_truncate_0.transform.bind(this.parent.parent.parent.parent._pipe_truncate_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [], []);
        return null;
    };
    _View_SearchFacetsComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import2.interpolate(1, '\n                    ', valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_1, this.parent.parent.parent.parent._pipe_truncate_0.transform)((((this.parent.parent.parent.parent.context.labels && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES) && this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key]) ? this.parent.parent.parent.parent.context.labels[this.parent.parent.parent.context.$implicit].VALUES[this.parent.context.$implicit.key][this.parent.parent.parent.parent.context.language] : this.parent.context.$implicit.key), '20')), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_1, currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_7 = import2.interpolate(1, '', this.parent.context.$implicit.doc_count, '');
        if (import2.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setText(this._text_3, currVal_7);
            this._expr_7 = currVal_7;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchFacetsComponent7;
}(import3.AppView));
function viewFactory_SearchFacetsComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchFacetsComponent7(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var Date2YearPipe = (function () {
    function Date2YearPipe() {
    }
    Date2YearPipe.prototype.transform = function (value) {
        if (!value)
            return value;
        return value.replace(new RegExp('-[0-9][0-9]-[0-9][0-9]T.+', 'gi'), '');
    };
    Date2YearPipe = __decorate([
        core_1.Pipe({
            name: 'toYear'
        }), 
        __metadata('design:paramtypes', [])
    ], Date2YearPipe);
    return Date2YearPipe;
}());
exports.Date2YearPipe = Date2YearPipe;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var JoinPipe = (function () {
    function JoinPipe() {
    }
    JoinPipe.prototype.transform = function (array, sep) {
        return array.join(sep);
    };
    JoinPipe = __decorate([
        core_1.Pipe({
            name: 'join'
        }), 
        __metadata('design:paramtypes', [])
    ], JoinPipe);
    return JoinPipe;
}());
exports.JoinPipe = JoinPipe;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(117);
var Wrapper_LanguageRoutingComponent = (function () {
    function Wrapper_LanguageRoutingComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.LanguageRoutingComponent(p0, p1, p2, p3, p4);
    }
    Wrapper_LanguageRoutingComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_LanguageRoutingComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_LanguageRoutingComponent;
}());
exports.Wrapper_LanguageRoutingComponent = Wrapper_LanguageRoutingComponent;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(175);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(32);
var import10 = __webpack_require__(15);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(77);
var import13 = __webpack_require__(11);
var import14 = __webpack_require__(10);
var import15 = __webpack_require__(22);
var import16 = __webpack_require__(82);
var import17 = __webpack_require__(14);
var import18 = __webpack_require__(19);
var import19 = __webpack_require__(78);
var import20 = __webpack_require__(20);
var import21 = __webpack_require__(40);
var import22 = __webpack_require__(18);
var import23 = __webpack_require__(57);
var Wrapper_LanguageSelectorComponent = (function () {
    function Wrapper_LanguageSelectorComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.LanguageSelectorComponent(p0, p1, p2, p3, p4);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
    }
    Wrapper_LanguageSelectorComponent.prototype.check_resourcePath = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.resourcePath = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_LanguageSelectorComponent.prototype.check_currentLanguage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.currentLanguage = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_LanguageSelectorComponent.prototype.check_displayCurrent = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.displayCurrent = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_LanguageSelectorComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_LanguageSelectorComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_LanguageSelectorComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_LanguageSelectorComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_LanguageSelectorComponent;
}());
exports.Wrapper_LanguageSelectorComponent = Wrapper_LanguageSelectorComponent;
var renderType_LanguageSelectorComponent_Host = null;
var _View_LanguageSelectorComponent_Host0 = (function (_super) {
    __extends(_View_LanguageSelectorComponent_Host0, _super);
    function _View_LanguageSelectorComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LanguageSelectorComponent_Host0, renderType_LanguageSelectorComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_LanguageSelectorComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'div', new import2.InlineArray2(2, 'language-selector', ''), rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_LanguageSelectorComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LanguageSelectorComponent_0_4 = new Wrapper_LanguageSelectorComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.Location), this.parentInjector.get(import10.Router), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.CookieService));
        this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context, [], compView_0);
        compView_0.create(this._LanguageSelectorComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_LanguageSelectorComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.LanguageSelectorComponent) && (0 === requestNodeIndex))) {
            return this._LanguageSelectorComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_LanguageSelectorComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LanguageSelectorComponent_Host0;
}(import3.AppView));
function viewFactory_LanguageSelectorComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_LanguageSelectorComponent_Host === null)) {
        (renderType_LanguageSelectorComponent_Host = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, [], {}));
    }
    return new _View_LanguageSelectorComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.LanguageSelectorComponentNgFactory = new import14.ComponentFactory('[language-selector]', viewFactory_LanguageSelectorComponent_Host0, import0.LanguageSelectorComponent);
var styles_LanguageSelectorComponent = [];
var renderType_LanguageSelectorComponent = null;
var _View_LanguageSelectorComponent0 = (function (_super) {
    __extends(_View_LanguageSelectorComponent0, _super);
    function _View_LanguageSelectorComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LanguageSelectorComponent0, renderType_LanguageSelectorComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_LanguageSelectorComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_1 = new import5.AppElement(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import17.TemplateRef_(this._appEl_1, viewFactory_LanguageSelectorComponent1);
        this._NgIf_1_6 = new import15.Wrapper_NgIf(this._appEl_1.vcRef, this._TemplateRef_1_5);
        this._text_2 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this._pipe_uppercase_0 = new import16.UpperCasePipe();
        this.init([], [
            this._text_0,
            this._anchor_1,
            this._text_2
        ], [], []);
        return null;
    };
    _View_LanguageSelectorComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import18.NgIf) && (1 === requestNodeIndex))) {
            return this._NgIf_1_6.context;
        }
        return notFoundResult;
    };
    _View_LanguageSelectorComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = ((this.context.language != this.context.currentLanguage) || this.context.displayCurrent);
        this._NgIf_1_6.check_ngIf(currVal_1_0_0, throwOnChange, false);
        this._NgIf_1_6.detectChangesInInputProps(this, this._anchor_1, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_LanguageSelectorComponent0;
}(import3.AppView));
function viewFactory_LanguageSelectorComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_LanguageSelectorComponent === null)) {
        (renderType_LanguageSelectorComponent = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, styles_LanguageSelectorComponent, {}));
    }
    return new _View_LanguageSelectorComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_LanguageSelectorComponent0 = viewFactory_LanguageSelectorComponent0;
var _View_LanguageSelectorComponent1 = (function (_super) {
    __extends(_View_LanguageSelectorComponent1, _super);
    function _View_LanguageSelectorComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_LanguageSelectorComponent1, renderType_LanguageSelectorComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_3 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_4 = import1.UNINITIALIZED;
    }
    _View_LanguageSelectorComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', new import2.InlineArray2(2, 'class', 'lgSelect lLink'), null);
        this._NgClass_0_3 = new import19.Wrapper_NgClass(this.parentInjector.get(import20.IterableDiffers), this.parentInjector.get(import21.KeyValueDiffers), new import22.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this._pipe_uppercase_0_0 = import2.pureProxy1(this.parent._pipe_uppercase_0.transform.bind(this.parent._pipe_uppercase_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_LanguageSelectorComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_LanguageSelectorComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        var currVal_0_0_0 = 'lgSelect lLink';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_3(((this.parent.context.language === this.parent.context.currentLanguage) || !this.parent.context.displayCurrent));
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import2.interpolate(1, '\n                    ', valUnwrapper.unwrap(import2.castByValue(this._pipe_uppercase_0_0, this.parent._pipe_uppercase_0.transform)((this.parent.context.labels ? this.parent.context.labels[this.parent.context.language] : this.parent.context.language))), '\n        ');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_LanguageSelectorComponent1.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.select() !== false);
        return (true && pd_0_0);
    };
    return _View_LanguageSelectorComponent1;
}(import3.AppView));
function viewFactory_LanguageSelectorComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_LanguageSelectorComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(13);
__webpack_require__(100);
__webpack_require__(324);
__webpack_require__(325);
var cache_service_1 = __webpack_require__(234);
var api_service_1 = __webpack_require__(232);
function hashCodeString(str) {
    var hash = 0;
    if (str.length === 0) {
        return hash + '';
    }
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash + '';
}
exports.hashCodeString = hashCodeString;
// domain/feature service
var ModelService = (function () {
    // This is only one example of one Model depending on your domain
    function ModelService(_api, _cache) {
        this._api = _api;
        this._cache = _cache;
    }
    /**
     * whatever domain/feature method name
     */
    ModelService.prototype.get = function (url) {
        var _this = this;
        // you want to return the cache if there is a response in it.
        // This would cache the first response so if your API isn't idempotent
        // you probably want to remove the item from the cache after you use it. LRU of 10
        // you can use also hashCodeString here
        var key = url;
        if (this._cache.has(key)) {
            return Observable_1.Observable.of(this._cache.get(key));
        }
        // you probably shouldn't .share() and you should write the correct logic
        return this._api.get(url)
            .do(function (json) {
            _this._cache.set(key, json);
        })
            .share();
    };
    // don't cache here since we're creating
    ModelService.prototype.create = function () {
        // TODO
    };
    ModelService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [(typeof (_a = typeof api_service_1.ApiService !== 'undefined' && api_service_1.ApiService) === 'function' && _a) || Object, (typeof (_b = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _b) || Object])
    ], ModelService);
    return ModelService;
    var _a, _b;
}());
exports.ModelService = ModelService;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ReplacePipe = (function () {
    function ReplacePipe() {
    }
    ReplacePipe.prototype.transform = function (value, expr, arg2) {
        if (!value)
            return value;
        return value.replace(new RegExp(expr, 'gi'), arg2);
    };
    ReplacePipe = __decorate([
        core_1.Pipe({
            name: 'replace'
        }), 
        __metadata('design:paramtypes', [])
    ], ReplacePipe);
    return ReplacePipe;
}());
exports.ReplacePipe = ReplacePipe;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(177);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(30);
var import10 = __webpack_require__(29);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(15);
var import13 = __webpack_require__(11);
var import14 = __webpack_require__(10);
var import15 = __webpack_require__(452);
var import16 = __webpack_require__(78);
var import17 = __webpack_require__(295);
var import18 = __webpack_require__(43);
var import19 = __webpack_require__(85);
var import20 = __webpack_require__(79);
var import21 = __webpack_require__(22);
var import22 = __webpack_require__(20);
var import23 = __webpack_require__(40);
var import24 = __webpack_require__(18);
var import25 = __webpack_require__(14);
var import26 = __webpack_require__(57);
var import27 = __webpack_require__(47);
var import28 = __webpack_require__(26);
var import29 = __webpack_require__(48);
var import30 = __webpack_require__(28);
var import31 = __webpack_require__(33);
var import32 = __webpack_require__(69);
var import33 = __webpack_require__(37);
var import34 = __webpack_require__(19);
var import35 = __webpack_require__(24);
var import36 = __webpack_require__(21);
var Wrapper_SearchComponent = (function () {
    function Wrapper_SearchComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.SearchComponent(p0, p1, p2, p3, p4);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    Wrapper_SearchComponent.prototype.check_type = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.type = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_order = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.order = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_scrollOnClick = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.scrollOnClick = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_placeholder = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.placeholder = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_5 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_6, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_6 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.check_expand = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_7, currValue))) {
            this.changed = true;
            this.context.expand = currValue;
            this._expr_7 = currValue;
        }
    };
    Wrapper_SearchComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchComponent;
}());
exports.Wrapper_SearchComponent = Wrapper_SearchComponent;
var renderType_SearchComponent_Host = null;
var _View_SearchComponent_Host0 = (function (_super) {
    __extends(_View_SearchComponent_Host0, _super);
    function _View_SearchComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent_Host0, renderType_SearchComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'search', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchComponent_0_4 = new Wrapper_SearchComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import9.SearchService), this.parentInjector.get(import10.ElasticSearchService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Router));
        this._appEl_0.initComponent(this._SearchComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchComponent) && (0 === requestNodeIndex))) {
            return this._SearchComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchComponent_Host0;
}(import3.AppView));
function viewFactory_SearchComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchComponent_Host === null)) {
        (renderType_SearchComponent_Host = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchComponentNgFactory = new import14.ComponentFactory('search', viewFactory_SearchComponent_Host0, import0.SearchComponent);
var styles_SearchComponent = [import15.styles];
var renderType_SearchComponent = null;
var _View_SearchComponent0 = (function (_super) {
    __extends(_View_SearchComponent0, _super);
    function _View_SearchComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent0, renderType_SearchComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_32 = import2.pureProxy1(function (p0) {
            return { hide: p0 };
        });
        this._expr_33 = import1.UNINITIALIZED;
        this._map_34 = import2.pureProxy2(function (p0, p1) {
            return {
                'search-box': p0,
                'search-box-expand': p1
            };
        });
    }
    _View_SearchComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', new import2.InlineArray2(2, 'class', 'search-c widget'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_3 = import2.createRenderElement(this.renderer, this._el_0, 'form', new import2.InlineArray4(4, 'autocomplete', 'off', 'class', 'sidebar-form'), null);
        this._NgClass_3_3 = new import16.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers), this.parentInjector.get(import23.KeyValueDiffers), new import24.ElementRef(this._el_3), this.renderer);
        this._NgForm_3_4 = new import17.Wrapper_NgForm(null, null);
        this._ControlContainer_3_5 = this._NgForm_3_4.context;
        this._NgControlStatusGroup_3_6 = new import18.Wrapper_NgControlStatusGroup(this._ControlContainer_3_5);
        this._text_4 = this.renderer.createText(this._el_3, '\n        ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_3, 'div', new import2.InlineArray2(2, 'class', 'input-group'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_7 = import2.createRenderElement(this.renderer, this._el_5, 'input', new import2.InlineArray8(8, 'class', 'form-control search-input', 'id', 'search-box', 'name', 'search', 'type', 'text'), null);
        this._NgClass_7_3 = new import16.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers), this.parentInjector.get(import23.KeyValueDiffers), new import24.ElementRef(this._el_7), this.renderer);
        this._DefaultValueAccessor_7_4 = new import19.Wrapper_DefaultValueAccessor(this.renderer, new import24.ElementRef(this._el_7));
        this._NG_VALUE_ACCESSOR_7_5 = [this._DefaultValueAccessor_7_4.context];
        this._NgModel_7_6 = new import20.Wrapper_NgModel(this._ControlContainer_3_5, null, null, this._NG_VALUE_ACCESSOR_7_5);
        this._NgControl_7_7 = this._NgModel_7_6.context;
        this._NgControlStatus_7_8 = new import18.Wrapper_NgControlStatus(this._NgControl_7_7);
        this._text_8 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_9 = import2.createRenderElement(this.renderer, this._el_5, 'button', new import2.InlineArray8(6, 'class', 'search-button', 'name', 'search', 'type', 'submit'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                ', null);
        this._el_11 = import2.createRenderElement(this.renderer, this._el_9, 'i', new import2.InlineArray2(2, 'class', 'fa fa-search search-icon'), null);
        this._text_12 = this.renderer.createText(this._el_9, '\n            ', null);
        this._text_13 = this.renderer.createText(this._el_5, '\n        ', null);
        this._text_14 = this.renderer.createText(this._el_3, '\n    ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._anchor_17 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_17 = new import5.AppElement(17, 0, this, this._anchor_17);
        this._TemplateRef_17_5 = new import25.TemplateRef_(this._appEl_17, viewFactory_SearchComponent1);
        this._NgIf_17_6 = new import21.Wrapper_NgIf(this._appEl_17.vcRef, this._TemplateRef_17_5);
        this._text_18 = this.renderer.createText(this._el_0, '\n\n', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'mouseout', this.eventHandler(this._handle_mouseout_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'mouseover', this.eventHandler(this._handle_mouseover_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_3, 'submit', this.eventHandler(this._handle_submit_3_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_3, 'reset', this.eventHandler(this._handle_reset_3_1.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_7, 'click', this.eventHandler(this._handle_click_7_0.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_7, 'keyup', this.eventHandler(this._handle_keyup_7_1.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_7, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_7_2.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_7, 'input', this.eventHandler(this._handle_input_7_3.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_7, 'blur', this.eventHandler(this._handle_blur_7_4.bind(this)));
        var subscription_0 = this._NgModel_7_6.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_7_2.bind(this)));
        this.init([], [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._anchor_17,
            this._text_18
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], [subscription_0]);
        return null;
    };
    _View_SearchComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.NgClass) && (7 === requestNodeIndex))) {
            return this._NgClass_7_3.context;
        }
        if (((token === import27.DefaultValueAccessor) && (7 === requestNodeIndex))) {
            return this._DefaultValueAccessor_7_4.context;
        }
        if (((token === import28.NG_VALUE_ACCESSOR) && (7 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_7_5;
        }
        if (((token === import29.NgModel) && (7 === requestNodeIndex))) {
            return this._NgModel_7_6.context;
        }
        if (((token === import30.NgControl) && (7 === requestNodeIndex))) {
            return this._NgControl_7_7;
        }
        if (((token === import31.NgControlStatus) && (7 === requestNodeIndex))) {
            return this._NgControlStatus_7_8.context;
        }
        if (((token === import26.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._NgClass_3_3.context;
        }
        if (((token === import32.NgForm) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._NgForm_3_4.context;
        }
        if (((token === import33.ControlContainer) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._ControlContainer_3_5;
        }
        if (((token === import31.NgControlStatusGroup) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._NgControlStatusGroup_3_6.context;
        }
        if (((token === import25.TemplateRef) && (17 === requestNodeIndex))) {
            return this._TemplateRef_17_5;
        }
        if (((token === import34.NgIf) && (17 === requestNodeIndex))) {
            return this._NgIf_17_6.context;
        }
        return notFoundResult;
    };
    _View_SearchComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = 'sidebar-form';
        this._NgClass_3_3.check_klass(currVal_3_0_0, throwOnChange, false);
        var currVal_3_0_1 = this._map_32((this.context.type == 'global'));
        this._NgClass_3_3.check_ngClass(currVal_3_0_1, throwOnChange, false);
        this._NgClass_3_3.detectChangesInInputProps(this, this._el_3, throwOnChange);
        this._NgForm_3_4.detectChangesInInputProps(this, this._el_3, throwOnChange);
        this._NgControlStatusGroup_3_6.detectChangesInInputProps(this, this._el_3, throwOnChange);
        var currVal_7_0_0 = 'form-control search-input';
        this._NgClass_7_3.check_klass(currVal_7_0_0, throwOnChange, false);
        var currVal_7_0_1 = this._map_34(!this.context.expand, this.context.expand);
        this._NgClass_7_3.check_ngClass(currVal_7_0_1, throwOnChange, false);
        this._NgClass_7_3.detectChangesInInputProps(this, this._el_7, throwOnChange);
        this._DefaultValueAccessor_7_4.detectChangesInInputProps(this, this._el_7, throwOnChange);
        var currVal_7_2_0 = 'search';
        this._NgModel_7_6.check_name(currVal_7_2_0, throwOnChange, false);
        var currVal_7_2_1 = this.context.formQuery;
        this._NgModel_7_6.check_model(currVal_7_2_1, throwOnChange, false);
        this._NgModel_7_6.detectChangesInInputProps(this, this._el_7, throwOnChange);
        this._NgControlStatus_7_8.detectChangesInInputProps(this, this._el_7, throwOnChange);
        var currVal_17_0_0 = this.context.suggestions;
        this._NgIf_17_6.check_ngIf(currVal_17_0_0, throwOnChange, false);
        this._NgIf_17_6.detectChangesInInputProps(this, this._anchor_17, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_3_3.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this._NgForm_3_4.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this._NgControlStatusGroup_3_6.detectChangesInHostProps(this, this._el_3, throwOnChange);
        var currVal_33 = import2.interpolate(1, '', this.context.placeholder, '...');
        if (import2.checkBinding(throwOnChange, this._expr_33, currVal_33)) {
            this.renderer.setElementProperty(this._el_7, 'placeholder', currVal_33);
            this._expr_33 = currVal_33;
        }
        this._NgClass_7_3.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this._DefaultValueAccessor_7_4.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this._NgModel_7_6.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this._NgControlStatus_7_8.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchComponent0.prototype.destroyInternal = function () {
        this._NgModel_7_6.context.ngOnDestroy();
    };
    _View_SearchComponent0.prototype._handle_mouseout_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.context.onSearchLeave() !== false);
        return (true && pd_0_0);
    };
    _View_SearchComponent0.prototype._handle_mouseover_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.context.onSearchOver() !== false);
        return (true && pd_0_0);
    };
    _View_SearchComponent0.prototype._handle_submit_3_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_3_0 = (this.context.onSubmit() !== false);
        var pd_3_1 = (this._NgForm_3_4.context.onSubmit($event) !== false);
        return ((true && pd_3_0) && pd_3_1);
    };
    _View_SearchComponent0.prototype._handle_reset_3_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_3_0 = (this._NgForm_3_4.context.onReset() !== false);
        return (true && pd_3_0);
    };
    _View_SearchComponent0.prototype._handle_click_7_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = (this.context.onInputClick(this._el_7.value, $event) !== false);
        return (true && pd_7_0);
    };
    _View_SearchComponent0.prototype._handle_keyup_7_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = (this.context.onInputChange(this._el_7.value, $event) !== false);
        return (true && pd_7_0);
    };
    _View_SearchComponent0.prototype._handle_ngModelChange_7_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = ((this.context.formQuery = $event) !== false);
        return (true && pd_7_0);
    };
    _View_SearchComponent0.prototype._handle_input_7_3 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = (this._DefaultValueAccessor_7_4.context.onChange($event.target.value) !== false);
        return (true && pd_7_0);
    };
    _View_SearchComponent0.prototype._handle_blur_7_4 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = (this._DefaultValueAccessor_7_4.context.onTouched() !== false);
        return (true && pd_7_0);
    };
    return _View_SearchComponent0;
}(import3.AppView));
function viewFactory_SearchComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchComponent === null)) {
        (renderType_SearchComponent = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.Emulated, styles_SearchComponent, {}));
    }
    return new _View_SearchComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchComponent0 = viewFactory_SearchComponent0;
var _View_SearchComponent1 = (function (_super) {
    __extends(_View_SearchComponent1, _super);
    function _View_SearchComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent1, renderType_SearchComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'suggestions'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'suggestion-search-msg'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n            ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_2, 'a', new import2.InlineArray2(2, 'style', 'cursor: pointer'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n                ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5, null);
        this._appEl_7 = new import5.AppElement(7, 5, this, this._anchor_7);
        this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7, viewFactory_SearchComponent2);
        this._NgIf_7_6 = new import21.Wrapper_NgIf(this._appEl_7.vcRef, this._TemplateRef_7_5);
        this._text_8 = this.renderer.createText(this._el_5, '\n            ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_11 = new import5.AppElement(11, 0, this, this._anchor_11);
        this._TemplateRef_11_5 = new import25.TemplateRef_(this._appEl_11, viewFactory_SearchComponent3);
        this._NgFor_11_6 = new import35.Wrapper_NgFor(this._appEl_11.vcRef, this._TemplateRef_11_5, this.parent.parentInjector.get(import22.IterableDiffers), this.parent.ref);
        this._text_12 = this.renderer.createText(this._el_0, '\n    ', null);
        var disposable_0 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._anchor_11,
            this._text_12
        ], [disposable_0], []);
        return null;
    };
    _View_SearchComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import34.NgIf) && (7 === requestNodeIndex))) {
            return this._NgIf_7_6.context;
        }
        if (((token === import25.TemplateRef) && (11 === requestNodeIndex))) {
            return this._TemplateRef_11_5;
        }
        if (((token === import36.NgFor) && (11 === requestNodeIndex))) {
            return this._NgFor_11_6.context;
        }
        return notFoundResult;
    };
    _View_SearchComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_7_0_0 = (this.parent._el_7.value.length >= this.parent.context.suggestionTriggerThreshold);
        this._NgIf_7_6.check_ngIf(currVal_7_0_0, throwOnChange, false);
        this._NgIf_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        var currVal_11_0_0 = this.parent.context.order;
        this._NgFor_11_6.check_ngForOf(currVal_11_0_0, throwOnChange, false);
        this._NgFor_11_6.detectChangesInInputProps(this, this._anchor_11, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchComponent1.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_5_0);
    };
    return _View_SearchComponent1;
}(import3.AppView));
function viewFactory_SearchComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchComponent2 = (function (_super) {
    __extends(_View_SearchComponent2, _super);
    function _View_SearchComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent2, renderType_SearchComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
    }
    _View_SearchComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'i', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [], []);
        return null;
    };
    _View_SearchComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_5 = import2.interpolate(1, '\n                    ', this.parent.parent.context.placeholder, ' ');
        if (import2.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            this.renderer.setText(this._text_1, currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_6 = import2.interpolate(1, '"', this.parent.parent._el_7.value, '"');
        if (import2.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            this.renderer.setText(this._text_3, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchComponent2;
}(import3.AppView));
function viewFactory_SearchComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_SearchComponent3 = (function (_super) {
    __extends(_View_SearchComponent3, _super);
    function _View_SearchComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent3, renderType_SearchComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import25.TemplateRef_(this._appEl_2, viewFactory_SearchComponent4);
        this._NgIf_2_6 = new import21.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_SearchComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import34.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = (this.parent.parent.context.suggestions[this.context.$implicit].length > 0);
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchComponent3;
}(import3.AppView));
function viewFactory_SearchComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_SearchComponent4 = (function (_super) {
    __extends(_View_SearchComponent4, _super);
    function _View_SearchComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent4, renderType_SearchComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import1.UNINITIALIZED;
    }
    _View_SearchComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'ul', new import2.InlineArray2(2, 'class', 'col-sm-4'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'li', new import2.InlineArray2(2, 'class', 'dropdown-header text-uppercase'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_5 = new import5.AppElement(5, 0, this, this._anchor_5);
        this._TemplateRef_5_5 = new import25.TemplateRef_(this._appEl_5, viewFactory_SearchComponent5);
        this._NgFor_5_6 = new import35.Wrapper_NgFor(this._appEl_5.vcRef, this._TemplateRef_5_5, this.parent.parent.parent.parentInjector.get(import22.IterableDiffers), this.parent.parent.parent.ref);
        this._text_6 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6
        ], [], []);
        return null;
    };
    _View_SearchComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import36.NgFor) && (5 === requestNodeIndex))) {
            return this._NgFor_5_6.context;
        }
        return notFoundResult;
    };
    _View_SearchComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_5_0_0 = this.parent.parent.parent.context.suggestions[this.parent.context.$implicit];
        this._NgFor_5_6.check_ngForOf(currVal_5_0_0, throwOnChange, false);
        this._NgFor_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_10 = import2.interpolate(1, '', (this.parent.parent.parent.context.labels ? this.parent.parent.parent.context.labels[this.parent.context.$implicit][this.parent.parent.parent.context.language] : this.parent.context.$implicit), '');
        if (import2.checkBinding(throwOnChange, this._expr_10, currVal_10)) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchComponent4;
}(import3.AppView));
function viewFactory_SearchComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_SearchComponent5 = (function (_super) {
    __extends(_View_SearchComponent5, _super);
    function _View_SearchComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchComponent5, renderType_SearchComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_8 = import1.UNINITIALIZED;
        this._expr_9 = import1.UNINITIALIZED;
    }
    _View_SearchComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'class', 'pointer'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_2, 'small', import2.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, '', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n                ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7
        ], [disposable_0], []);
        return null;
    };
    _View_SearchComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_8 = import2.interpolate(1, '\n                        ', this.context.$implicit.name, ' ');
        if (import2.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setText(this._text_3, currVal_8);
            this._expr_8 = currVal_8;
        }
        var currVal_9 = import2.interpolate(1, '(', this.context.$implicit.freq, ')');
        if (import2.checkBinding(throwOnChange, this._expr_9, currVal_9)) {
            this.renderer.setText(this._text_5, currVal_9);
            this._expr_9 = currVal_9;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchComponent5.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.parent.context.onSuggestSelect(this.parent.parent.context.$implicit, this.context.$implicit.name) !== false);
        return (true && pd_2_0);
    };
    return _View_SearchComponent5;
}(import3.AppView));
function viewFactory_SearchComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchComponent5(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var lazyload_image_directive_1 = __webpack_require__(180);
var LazyLoadImageModule = (function () {
    function LazyLoadImageModule() {
    }
    LazyLoadImageModule = __decorate([
        core_1.NgModule({
            declarations: [lazyload_image_directive_1.LazyLoadImageDirective],
            exports: [lazyload_image_directive_1.LazyLoadImageDirective]
        })
    ], LazyLoadImageModule);
    return LazyLoadImageModule;
}());
exports.LazyLoadImageModule = LazyLoadImageModule;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(296));
__export(__webpack_require__(297));
__export(__webpack_require__(95));
//# sourceMappingURL=index.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var file_uploader_class_1 = __webpack_require__(239);
var FileDropDirective = (function () {
    function FileDropDirective(element) {
        this.fileOver = new core_1.EventEmitter();
        this.onFileDrop = new core_1.EventEmitter();
        this.element = element;
    }
    FileDropDirective.prototype.getOptions = function () {
        return this.uploader.options;
    };
    FileDropDirective.prototype.getFilters = function () {
        return {};
    };
    FileDropDirective.prototype.onDrop = function (event) {
        var transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        var options = this.getOptions();
        var filters = this.getFilters();
        this._preventAndStop(event);
        this.uploader.addToQueue(transfer.files, options, filters);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    };
    FileDropDirective.prototype.onDragOver = function (event) {
        var transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    };
    FileDropDirective.prototype.onDragLeave = function (event) {
        if (this.element) {
            if (event.currentTarget === this.element[0]) {
                return;
            }
        }
        this._preventAndStop(event);
        this.fileOver.emit(false);
    };
    FileDropDirective.prototype._getTransfer = function (event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    };
    FileDropDirective.prototype._preventAndStop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    FileDropDirective.prototype._haveFiles = function (types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        else {
            return false;
        }
    };
    return FileDropDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", file_uploader_class_1.FileUploader)
], FileDropDirective.prototype, "uploader", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FileDropDirective.prototype, "fileOver", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FileDropDirective.prototype, "onFileDrop", void 0);
__decorate([
    core_1.HostListener('drop', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropDirective.prototype, "onDrop", null);
__decorate([
    core_1.HostListener('dragover', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropDirective.prototype, "onDragOver", null);
__decorate([
    core_1.HostListener('dragleave', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], FileDropDirective.prototype, "onDragLeave", null);
FileDropDirective = __decorate([
    core_1.Directive({ selector: '[ng2FileDrop]' }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], FileDropDirective);
exports.FileDropDirective = FileDropDirective;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var file_like_object_class_1 = __webpack_require__(238);
var FileItem = (function () {
    function FileItem(uploader, some, options) {
        this.url = '/';
        this.headers = [];
        this.withCredentials = true;
        this.formData = [];
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.uploader = uploader;
        this.some = some;
        this.options = options;
        this.file = new file_like_object_class_1.FileLikeObject(some);
        this._file = some;
        if (uploader.options) {
            this.method = uploader.options.method || 'POST';
            this.alias = uploader.options.itemAlias || 'file';
        }
        this.url = uploader.options.url;
    }
    FileItem.prototype.upload = function () {
        try {
            this.uploader.uploadItem(this);
        }
        catch (e) {
            this.uploader._onCompleteItem(this, '', 0, {});
            this.uploader._onErrorItem(this, '', 0, {});
        }
    };
    FileItem.prototype.cancel = function () {
        this.uploader.cancelItem(this);
    };
    FileItem.prototype.remove = function () {
        this.uploader.removeFromQueue(this);
    };
    FileItem.prototype.onBeforeUpload = function () {
        return void 0;
    };
    FileItem.prototype.onBuildForm = function (form) {
        return { form: form };
    };
    FileItem.prototype.onProgress = function (progress) {
        return { progress: progress };
    };
    FileItem.prototype.onSuccess = function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    FileItem.prototype.onError = function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    FileItem.prototype.onCancel = function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    FileItem.prototype.onComplete = function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    FileItem.prototype._onBeforeUpload = function () {
        this.isReady = true;
        this.isUploading = true;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.onBeforeUpload();
    };
    FileItem.prototype._onBuildForm = function (form) {
        this.onBuildForm(form);
    };
    FileItem.prototype._onProgress = function (progress) {
        this.progress = progress;
        this.onProgress(progress);
    };
    FileItem.prototype._onSuccess = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = true;
        this.isCancel = false;
        this.isError = false;
        this.progress = 100;
        this.index = void 0;
        this.onSuccess(response, status, headers);
    };
    FileItem.prototype._onError = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = true;
        this.progress = 0;
        this.index = void 0;
        this.onError(response, status, headers);
    };
    FileItem.prototype._onCancel = function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = true;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.onCancel(response, status, headers);
    };
    FileItem.prototype._onComplete = function (response, status, headers) {
        this.onComplete(response, status, headers);
        if (this.uploader.options.removeAfterUpload) {
            this.remove();
        }
    };
    FileItem.prototype._prepareToUploading = function () {
        this.index = this.index || ++this.uploader._nextIndex;
        this.isReady = true;
    };
    return FileItem;
}());
exports.FileItem = FileItem;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var common_1 = __webpack_require__(23);
var core_1 = __webpack_require__(0);
var file_drop_directive_1 = __webpack_require__(316);
var file_select_directive_1 = __webpack_require__(181);
var FileUploadModule = (function () {
    function FileUploadModule() {
    }
    return FileUploadModule;
}());
FileUploadModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule],
        declarations: [file_drop_directive_1.FileDropDirective, file_select_directive_1.FileSelectDirective],
        exports: [file_drop_directive_1.FileDropDirective, file_select_directive_1.FileSelectDirective]
    })
], FileUploadModule);
exports.FileUploadModule = FileUploadModule;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(181));
__export(__webpack_require__(316));
__export(__webpack_require__(239));
__export(__webpack_require__(317));
__export(__webpack_require__(238));
var file_upload_module_1 = __webpack_require__(318);
exports.FileUploadModule = file_upload_module_1.FileUploadModule;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(66);
var ObjectUnsubscribedError_1 = __webpack_require__(250);
/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports) {

"use strict";
"use strict";
exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(99);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var do_1 = __webpack_require__(529);
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var share_1 = __webpack_require__(536);
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(67);
var Observable_1 = __webpack_require__(13);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {Promise<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional Scheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var mergeAll_1 = __webpack_require__(125);
/* tslint:disable:max-line-length */
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return this.lift(new mergeAll_1.MergeAllOperator(1));
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var mergeMap_1 = __webpack_require__(101);
/* tslint:disable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): Observable} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} an observable of values merged from the projected
 * Observables as they were subscribed to, one at a time. Optionally, these
 * values may have been projected from a passed `projectResult` argument.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return this.lift(new mergeMap_1.MergeMapOperator(project, resultSelector, 1));
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 * @param {function} predicate a function for determining if an item meets a specified condition.
 * @param {any} [thisArg] optional object to use for `this` in the callback
 * @return {Observable} an Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return this.lift(new EveryOperator(predicate, thisArg, this));
}
exports.every = every;
var EveryOperator = (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var EverySubscriber = (function (_super) {
    __extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=every.js.map

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/* tslint:disable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return this.lift(new FilterOperator(predicate, thisArg));
}
exports.filter = filter;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FilterSubscriber = (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
        this.predicate = predicate;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=filter.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var Notification_1 = __webpack_require__(508);
/**
 * @see {@link Notification}
 *
 * @param scheduler
 * @param delay
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return this.lift(new ObserveOnOperator(scheduler, delay));
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var root_1 = __webpack_require__(67);
/* tslint:disable:max-line-length */
/**
 * @param PromiseCtor
 * @return {Promise<T>}
 * @method toPromise
 * @owner Observable
 */
function toPromise(PromiseCtor) {
    var _this = this;
    if (!PromiseCtor) {
        if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
            PromiseCtor = root_1.root.Rx.config.Promise;
        }
        else if (root_1.root.Promise) {
            PromiseCtor = root_1.root.Promise;
        }
    }
    if (!PromiseCtor) {
        throw new Error('no Promise impl found');
    }
    return new PromiseCtor(function (resolve, reject) {
        var value;
        _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
    });
}
exports.toPromise = toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(67);
var Action_1 = __webpack_require__(540);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.pending = false;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.delay = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__(510);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var AsyncAction_1 = __webpack_require__(333);
var AsyncScheduler_1 = __webpack_require__(334);
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports) {

"use strict";
"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports) {

"use strict";
"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports) {

"use strict";
"use strict";
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var errorObject_1 = __webpack_require__(251);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 340;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["bootloader"] = bootloader;
/*
 * @AngularClass
 */
function bootloader(main) {
    switch (document.readyState) {
        case 'loading':
            document.addEventListener('DOMContentLoaded', function () { return main(); });
            break;
        case 'interactive':
        case 'complete':
        default:
            main();
    }
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(506);
__webpack_require__(409);
//# sourceMappingURL=browser.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * THIS IS TEMPORARY TO PATCH 2.1.1+ Core bugs
 */
"use strict";
/* tslint:disable */
var __compiler__ = __webpack_require__(81);
var core_1 = __webpack_require__(0);
if (!core_1.__core_private__['ViewUtils']) {
    core_1.__core_private__['ViewUtils'] = core_1.__core_private__['view_utils'];
}
if (__compiler__ && __compiler__.SelectorMatcher && __compiler__.CssSelector) {
    (__compiler__).__compiler_private__ = {
        SelectorMatcher: __compiler__.SelectorMatcher,
        CssSelector: __compiler__.CssSelector
    };
}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(193);
var import1 = __webpack_require__(457);
var import2 = __webpack_require__(254);
var import3 = __webpack_require__(264);
var import4 = __webpack_require__(206);
var import5 = __webpack_require__(282);
var import6 = __webpack_require__(148);
var import7 = __webpack_require__(294);
var import8 = __webpack_require__(276);
var import9 = __webpack_require__(279);
var import10 = __webpack_require__(213);
var import11 = __webpack_require__(289);
var import12 = __webpack_require__(296);
var import13 = __webpack_require__(179);
var import14 = __webpack_require__(300);
var import15 = __webpack_require__(318);
var import16 = __webpack_require__(298);
var import17 = __webpack_require__(299);
var import18 = __webpack_require__(305);
var import19 = __webpack_require__(314);
var import20 = __webpack_require__(304);
var import21 = __webpack_require__(301);
var import22 = __webpack_require__(234);
var import23 = __webpack_require__(103);
var import24 = __webpack_require__(128);
var import25 = __webpack_require__(137);
var import26 = __webpack_require__(129);
var import27 = __webpack_require__(89);
var import28 = __webpack_require__(147);
var import29 = __webpack_require__(84);
var import30 = __webpack_require__(208);
var import31 = __webpack_require__(211);
var import32 = __webpack_require__(3);
var import33 = __webpack_require__(207);
var import34 = __webpack_require__(141);
var import35 = __webpack_require__(108);
var import36 = __webpack_require__(204);
var import37 = __webpack_require__(142);
var import38 = __webpack_require__(202);
var import39 = __webpack_require__(203);
var import40 = __webpack_require__(76);
var import41 = __webpack_require__(75);
var import42 = __webpack_require__(32);
var import43 = __webpack_require__(269);
var import44 = __webpack_require__(214);
var import45 = __webpack_require__(91);
var import46 = __webpack_require__(73);
var import47 = __webpack_require__(225);
var import48 = __webpack_require__(5);
var import49 = __webpack_require__(2);
var import50 = __webpack_require__(9);
var import51 = __webpack_require__(77);
var import52 = __webpack_require__(49);
var import53 = __webpack_require__(232);
var import54 = __webpack_require__(311);
var import55 = __webpack_require__(86);
var import56 = __webpack_require__(233);
var import57 = __webpack_require__(116);
var import58 = __webpack_require__(29);
var import59 = __webpack_require__(30);
var import60 = __webpack_require__(149);
var import61 = __webpack_require__(25);
var import62 = __webpack_require__(45);
var import63 = __webpack_require__(17);
var import65 = __webpack_require__(420);
var import66 = __webpack_require__(422);
var import67 = __webpack_require__(427);
var import68 = __webpack_require__(426);
var import69 = __webpack_require__(429);
var import70 = __webpack_require__(428);
var import71 = __webpack_require__(431);
var import72 = __webpack_require__(430);
var import73 = __webpack_require__(433);
var import74 = __webpack_require__(432);
var import75 = __webpack_require__(425);
var import76 = __webpack_require__(424);
var import77 = __webpack_require__(450);
var import78 = __webpack_require__(447);
var import79 = __webpack_require__(441);
var import80 = __webpack_require__(445);
var import81 = __webpack_require__(444);
var import82 = __webpack_require__(443);
var import83 = __webpack_require__(440);
var import84 = __webpack_require__(448);
var import85 = __webpack_require__(442);
var import86 = __webpack_require__(437);
var import87 = __webpack_require__(209);
var import88 = __webpack_require__(210);
var import89 = __webpack_require__(105);
var import90 = __webpack_require__(81);
var import91 = __webpack_require__(127);
var import92 = __webpack_require__(88);
var import93 = __webpack_require__(150);
var import94 = __webpack_require__(151);
var import95 = __webpack_require__(155);
var import96 = __webpack_require__(154);
var import97 = __webpack_require__(157);
var import98 = __webpack_require__(156);
var import99 = __webpack_require__(159);
var import100 = __webpack_require__(158);
var import101 = __webpack_require__(161);
var import102 = __webpack_require__(160);
var import103 = __webpack_require__(153);
var import104 = __webpack_require__(152);
var import105 = __webpack_require__(173);
var import106 = __webpack_require__(171);
var import107 = __webpack_require__(164);
var import108 = __webpack_require__(170);
var import109 = __webpack_require__(169);
var import110 = __webpack_require__(167);
var import111 = __webpack_require__(163);
var import112 = __webpack_require__(172);
var import113 = __webpack_require__(165);
var import114 = __webpack_require__(18);
var import115 = __webpack_require__(136);
var import116 = __webpack_require__(293);
var import117 = __webpack_require__(15);
var import118 = __webpack_require__(132);
var import119 = __webpack_require__(110);
var import120 = __webpack_require__(38);
var import121 = __webpack_require__(192);
var import122 = __webpack_require__(104);
var import123 = __webpack_require__(146);
var import124 = __webpack_require__(31);
var import125 = __webpack_require__(20);
var import126 = __webpack_require__(40);
var import127 = __webpack_require__(92);
var import128 = __webpack_require__(143);
var import129 = __webpack_require__(194);
var import130 = __webpack_require__(94);
var import131 = __webpack_require__(16);
var MainModuleInjector = (function (_super) {
    __extends(MainModuleInjector, _super);
    function MainModuleInjector(parent) {
        _super.call(this, parent, [
            import65.AdminLoginComponentNgFactory,
            import66.AdminRootComponentNgFactory,
            import67.ContentPagesComponentNgFactory,
            import67.ContentPagesComponentNgFactory,
            import68.ContentPageEditComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import70.ContentRecordEditComponentNgFactory,
            import71.ContentSpecialsComponentNgFactory,
            import71.ContentSpecialsComponentNgFactory,
            import72.ContentSpecialEditComponentNgFactory,
            import73.ContentWritingsComponentNgFactory,
            import73.ContentWritingsComponentNgFactory,
            import74.ContentWritingEditComponentNgFactory,
            import75.ContentMessagesComponentNgFactory,
            import75.ContentMessagesComponentNgFactory,
            import76.ContentMessageEditComponentNgFactory,
            import66.AdminRootComponentNgFactory,
            import67.ContentPagesComponentNgFactory,
            import67.ContentPagesComponentNgFactory,
            import68.ContentPageEditComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import69.ContentRecordsComponentNgFactory,
            import70.ContentRecordEditComponentNgFactory,
            import71.ContentSpecialsComponentNgFactory,
            import71.ContentSpecialsComponentNgFactory,
            import72.ContentSpecialEditComponentNgFactory,
            import73.ContentWritingsComponentNgFactory,
            import73.ContentWritingsComponentNgFactory,
            import74.ContentWritingEditComponentNgFactory,
            import75.ContentMessagesComponentNgFactory,
            import75.ContentMessagesComponentNgFactory,
            import76.ContentMessageEditComponentNgFactory,
            import77.FrontRootComponentNgFactory,
            import78.HomeComponentNgFactory,
            import78.HomeComponentNgFactory,
            import78.HomeComponentNgFactory,
            import79.ContentPageComponentNgFactory,
            import80.ContentWritingsComponentNgFactory,
            import81.ContentWritingComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import83.CartComponentNgFactory,
            import84.PageNotFoundComponentNgFactory,
            import85.ContentRecordComponentNgFactory,
            import77.FrontRootComponentNgFactory,
            import78.HomeComponentNgFactory,
            import78.HomeComponentNgFactory,
            import78.HomeComponentNgFactory,
            import79.ContentPageComponentNgFactory,
            import80.ContentWritingsComponentNgFactory,
            import81.ContentWritingComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import82.ContentRecordsComponentNgFactory,
            import83.CartComponentNgFactory,
            import84.PageNotFoundComponentNgFactory,
            import85.ContentRecordComponentNgFactory,
            import86.AppComponentNgFactory
        ], [import86.AppComponentNgFactory]);
    }
    Object.defineProperty(MainModuleInjector.prototype, "_LOCALE_ID_28", {
        get: function () {
            if ((this.__LOCALE_ID_28 == null)) {
                (this.__LOCALE_ID_28 = 'en-US');
            }
            return this.__LOCALE_ID_28;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_NgLocalization_29", {
        get: function () {
            if ((this.__NgLocalization_29 == null)) {
                (this.__NgLocalization_29 = new import23.NgLocaleLocalization(this._LOCALE_ID_28));
            }
            return this.__NgLocalization_29;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ApplicationRef_34", {
        get: function () {
            if ((this.__ApplicationRef_34 == null)) {
                (this.__ApplicationRef_34 = this._ApplicationRef__33);
            }
            return this.__ApplicationRef_34;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Compiler_35", {
        get: function () {
            if ((this.__Compiler_35 == null)) {
                (this.__Compiler_35 = new import27.Compiler());
            }
            return this.__Compiler_35;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_APP_ID_36", {
        get: function () {
            if ((this.__APP_ID_36 == null)) {
                (this.__APP_ID_36 = import7.appIdFactory());
            }
            return this.__APP_ID_36;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_HAMMER_GESTURE_CONFIG_37", {
        get: function () {
            if ((this.__HAMMER_GESTURE_CONFIG_37 == null)) {
                (this.__HAMMER_GESTURE_CONFIG_37 = new import28.HammerGestureConfig());
            }
            return this.__HAMMER_GESTURE_CONFIG_37;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_EVENT_MANAGER_PLUGINS_38", {
        get: function () {
            if ((this.__EVENT_MANAGER_PLUGINS_38 == null)) {
                (this.__EVENT_MANAGER_PLUGINS_38 = [
                    new import87.DomEventsPlugin(),
                    new import88.KeyEventsPlugin(),
                    new import28.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_37)
                ]);
            }
            return this.__EVENT_MANAGER_PLUGINS_38;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_EventManager_39", {
        get: function () {
            if ((this.__EventManager_39 == null)) {
                (this.__EventManager_39 = new import29.EventManager(this._EVENT_MANAGER_PLUGINS_38, this.parent.get(import89.NgZone)));
            }
            return this.__EventManager_39;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_AnimationDriver_40", {
        get: function () {
            if ((this.__AnimationDriver_40 == null)) {
                (this.__AnimationDriver_40 = import4._resolveDefaultAnimationDriver());
            }
            return this.__AnimationDriver_40;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_DomRootRenderer_41", {
        get: function () {
            if ((this.__DomRootRenderer_41 == null)) {
                (this.__DomRootRenderer_41 = new import30.DomRootRenderer_(this._DOCUMENT_5, this._EventManager_39, this._DomSharedStylesHost_6, this._AnimationDriver_40));
            }
            return this.__DomRootRenderer_41;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_RootRenderer_42", {
        get: function () {
            if ((this.__RootRenderer_42 == null)) {
                (this.__RootRenderer_42 = import90._createConditionalRootRenderer(this._DomRootRenderer_41, this.parent.get(import90.NgProbeToken, null)));
            }
            return this.__RootRenderer_42;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_DomSanitizer_43", {
        get: function () {
            if ((this.__DomSanitizer_43 == null)) {
                (this.__DomSanitizer_43 = new import31.DomSanitizerImpl());
            }
            return this.__DomSanitizer_43;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Sanitizer_44", {
        get: function () {
            if ((this.__Sanitizer_44 == null)) {
                (this.__Sanitizer_44 = this._DomSanitizer_43);
            }
            return this.__Sanitizer_44;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ViewUtils_45", {
        get: function () {
            if ((this.__ViewUtils_45 == null)) {
                (this.__ViewUtils_45 = new import32.ViewUtils(this._RootRenderer_42, this._APP_ID_36, this._Sanitizer_44));
            }
            return this.__ViewUtils_45;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_IterableDiffers_46", {
        get: function () {
            if ((this.__IterableDiffers_46 == null)) {
                (this.__IterableDiffers_46 = import3._iterableDiffersFactory());
            }
            return this.__IterableDiffers_46;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_KeyValueDiffers_47", {
        get: function () {
            if ((this.__KeyValueDiffers_47 == null)) {
                (this.__KeyValueDiffers_47 = import3._keyValueDiffersFactory());
            }
            return this.__KeyValueDiffers_47;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Title_48", {
        get: function () {
            if ((this.__Title_48 == null)) {
                (this.__Title_48 = new import33.Title());
            }
            return this.__Title_48;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_BrowserXhr_49", {
        get: function () {
            if ((this.__BrowserXhr_49 == null)) {
                (this.__BrowserXhr_49 = new import34.BrowserXhr());
            }
            return this.__BrowserXhr_49;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ResponseOptions_50", {
        get: function () {
            if ((this.__ResponseOptions_50 == null)) {
                (this.__ResponseOptions_50 = new import35.BaseResponseOptions());
            }
            return this.__ResponseOptions_50;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_XSRFStrategy_51", {
        get: function () {
            if ((this.__XSRFStrategy_51 == null)) {
                (this.__XSRFStrategy_51 = import5._createDefaultCookieXSRFStrategy());
            }
            return this.__XSRFStrategy_51;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_XHRBackend_52", {
        get: function () {
            if ((this.__XHRBackend_52 == null)) {
                (this.__XHRBackend_52 = new import36.XHRBackend(this._BrowserXhr_49, this._ResponseOptions_50, this._XSRFStrategy_51));
            }
            return this.__XHRBackend_52;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_RequestOptions_53", {
        get: function () {
            if ((this.__RequestOptions_53 == null)) {
                (this.__RequestOptions_53 = new import37.BaseRequestOptions());
            }
            return this.__RequestOptions_53;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Http_54", {
        get: function () {
            if ((this.__Http_54 == null)) {
                (this.__Http_54 = import5.httpFactory(this._XHRBackend_52, this._RequestOptions_53));
            }
            return this.__Http_54;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_BrowserJsonp_55", {
        get: function () {
            if ((this.__BrowserJsonp_55 == null)) {
                (this.__BrowserJsonp_55 = new import38.BrowserJsonp());
            }
            return this.__BrowserJsonp_55;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_JSONPBackend_56", {
        get: function () {
            if ((this.__JSONPBackend_56 == null)) {
                (this.__JSONPBackend_56 = new import39.JSONPBackend_(this._BrowserJsonp_55, this._ResponseOptions_50));
            }
            return this.__JSONPBackend_56;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Jsonp_57", {
        get: function () {
            if ((this.__Jsonp_57 == null)) {
                (this.__Jsonp_57 = import5.jsonpFactory(this._JSONPBackend_56, this._RequestOptions_53));
            }
            return this.__Jsonp_57;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_UNIVERSAL_CACHE_58", {
        get: function () {
            if ((this.__UNIVERSAL_CACHE_58 == null)) {
                (this.__UNIVERSAL_CACHE_58 = import7.universalCacheFactory());
            }
            return this.__UNIVERSAL_CACHE_58;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_AUTO_PREBOOT_59", {
        get: function () {
            if ((this.__AUTO_PREBOOT_59 == null)) {
                (this.__AUTO_PREBOOT_59 = false);
            }
            return this.__AUTO_PREBOOT_59;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_UrlSerializer_60", {
        get: function () {
            if ((this.__UrlSerializer_60 == null)) {
                (this.__UrlSerializer_60 = new import40.DefaultUrlSerializer());
            }
            return this.__UrlSerializer_60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_RouterOutletMap_61", {
        get: function () {
            if ((this.__RouterOutletMap_61 == null)) {
                (this.__RouterOutletMap_61 = new import41.RouterOutletMap());
            }
            return this.__RouterOutletMap_61;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ROUTER_CONFIGURATION_62", {
        get: function () {
            if ((this.__ROUTER_CONFIGURATION_62 == null)) {
                (this.__ROUTER_CONFIGURATION_62 = {
                    useHash: false,
                    preloadingStrategy: import11.IdlePreload
                });
            }
            return this.__ROUTER_CONFIGURATION_62;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_LocationStrategy_63", {
        get: function () {
            if ((this.__LocationStrategy_63 == null)) {
                (this.__LocationStrategy_63 = import10.provideLocationStrategy(this.parent.get(import91.PlatformLocation), this.parent.get(import92.APP_BASE_HREF, null), this._ROUTER_CONFIGURATION_62));
            }
            return this.__LocationStrategy_63;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Location_64", {
        get: function () {
            if ((this.__Location_64 == null)) {
                (this.__Location_64 = new import42.Location(this._LocationStrategy_63));
            }
            return this.__Location_64;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_NgModuleFactoryLoader_65", {
        get: function () {
            if ((this.__NgModuleFactoryLoader_65 == null)) {
                (this.__NgModuleFactoryLoader_65 = new import43.SystemJsNgModuleLoader(this._Compiler_35, this.parent.get(import43.SystemJsNgModuleLoaderConfig, null)));
            }
            return this.__NgModuleFactoryLoader_65;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ROUTES_66", {
        get: function () {
            if ((this.__ROUTES_66 == null)) {
                (this.__ROUTES_66 = [
                    [
                        {
                            path: 'admin/login',
                            component: import93.AdminLoginComponent
                        },
                        {
                            path: 'admin',
                            component: import94.AdminRootComponent,
                            children: [
                                {
                                    path: '',
                                    redirectTo: 'records',
                                    pathMatch: 'full'
                                },
                                {
                                    path: 'pages',
                                    component: import95.ContentPagesComponent
                                },
                                {
                                    path: 'pages/reload',
                                    component: import95.ContentPagesComponent
                                },
                                {
                                    path: 'page/edit/:id',
                                    component: import96.ContentPageEditComponent
                                },
                                {
                                    path: 'records',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'records/active/:active',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'records/reload',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'record/edit/:id',
                                    component: import98.ContentRecordEditComponent
                                },
                                {
                                    path: 'specials',
                                    component: import99.ContentSpecialsComponent
                                },
                                {
                                    path: 'specials/reload',
                                    component: import99.ContentSpecialsComponent
                                },
                                {
                                    path: 'special/edit/:id',
                                    component: import100.ContentSpecialEditComponent
                                },
                                {
                                    path: 'writings',
                                    component: import101.ContentWritingsComponent
                                },
                                {
                                    path: 'writings/reload',
                                    component: import101.ContentWritingsComponent
                                },
                                {
                                    path: 'writing/edit/:id',
                                    component: import102.ContentWritingEditComponent
                                },
                                {
                                    path: 'messages',
                                    component: import103.ContentMessagesComponent
                                },
                                {
                                    path: 'messages/reload',
                                    component: import103.ContentMessagesComponent
                                },
                                {
                                    path: 'message/edit/:id',
                                    component: import104.ContentMessageEditComponent
                                }
                            ],
                            canActivateChild: [import56.AuthGuard]
                        },
                        {
                            path: ':lg/admin',
                            component: import94.AdminRootComponent,
                            children: [
                                {
                                    path: '',
                                    redirectTo: 'records',
                                    pathMatch: 'full'
                                },
                                {
                                    path: 'pages',
                                    component: import95.ContentPagesComponent
                                },
                                {
                                    path: 'pages/reload',
                                    component: import95.ContentPagesComponent
                                },
                                {
                                    path: 'page/edit/:id',
                                    component: import96.ContentPageEditComponent
                                },
                                {
                                    path: 'records',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'records/active/:active',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'records/reload',
                                    component: import97.ContentRecordsComponent
                                },
                                {
                                    path: 'record/edit/:id',
                                    component: import98.ContentRecordEditComponent
                                },
                                {
                                    path: 'specials',
                                    component: import99.ContentSpecialsComponent
                                },
                                {
                                    path: 'specials/reload',
                                    component: import99.ContentSpecialsComponent
                                },
                                {
                                    path: 'special/edit/:id',
                                    component: import100.ContentSpecialEditComponent
                                },
                                {
                                    path: 'writings',
                                    component: import101.ContentWritingsComponent
                                },
                                {
                                    path: 'writings/reload',
                                    component: import101.ContentWritingsComponent
                                },
                                {
                                    path: 'writing/edit/:id',
                                    component: import102.ContentWritingEditComponent
                                },
                                {
                                    path: 'messages',
                                    component: import103.ContentMessagesComponent
                                },
                                {
                                    path: 'messages/reload',
                                    component: import103.ContentMessagesComponent
                                },
                                {
                                    path: 'message/edit/:id',
                                    component: import104.ContentMessageEditComponent
                                }
                            ],
                            canActivateChild: [import56.AuthGuard]
                        }
                    ],
                    [
                        {
                            path: '',
                            component: import105.FrontRootComponent,
                            children: [
                                {
                                    path: '',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'fr',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'en',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'page/:url',
                                    component: import107.ContentPageComponent
                                },
                                {
                                    path: 'writings',
                                    component: import108.ContentWritingsComponent
                                },
                                {
                                    path: 'writing/:url',
                                    component: import109.ContentWritingComponent
                                },
                                {
                                    path: 'catalogue',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'catalogue/:type',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'catalogue/:field/:value',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'cart',
                                    component: import111.CartComponent
                                },
                                {
                                    path: 'page-not-found',
                                    component: import112.PageNotFoundComponent
                                },
                                {
                                    path: ':url',
                                    component: import113.ContentRecordComponent
                                }
                            ]
                        },
                        {
                            path: ':lg',
                            component: import105.FrontRootComponent,
                            children: [
                                {
                                    path: '',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'fr',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'en',
                                    component: import106.HomeComponent
                                },
                                {
                                    path: 'page/:url',
                                    component: import107.ContentPageComponent
                                },
                                {
                                    path: 'writings',
                                    component: import108.ContentWritingsComponent
                                },
                                {
                                    path: 'writing/:url',
                                    component: import109.ContentWritingComponent
                                },
                                {
                                    path: 'catalogue',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'catalogue/:type',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'catalogue/:field/:value',
                                    component: import110.ContentRecordsComponent
                                },
                                {
                                    path: 'cart',
                                    component: import111.CartComponent
                                },
                                {
                                    path: 'page-not-found',
                                    component: import112.PageNotFoundComponent
                                },
                                {
                                    path: ':url',
                                    component: import113.ContentRecordComponent
                                }
                            ]
                        }
                    ],
                    []
                ]);
            }
            return this.__ROUTES_66;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Router_67", {
        get: function () {
            if ((this.__Router_67 == null)) {
                (this.__Router_67 = import10.setupRouter(this._ApplicationRef_34, this._UrlSerializer_60, this._RouterOutletMap_61, this._Location_64, this, this._NgModuleFactoryLoader_65, this._Compiler_35, this._ROUTES_66, this._ROUTER_CONFIGURATION_62));
            }
            return this.__Router_67;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_REQUEST_IDLE_CALLBACK_68", {
        get: function () {
            if ((this.__REQUEST_IDLE_CALLBACK_68 == null)) {
                (this.__REQUEST_IDLE_CALLBACK_68 = import11._requestIdle(this.parent.get(import89.NgZone)));
            }
            return this.__REQUEST_IDLE_CALLBACK_68;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_IdlePreload_69", {
        get: function () {
            if ((this.__IdlePreload_69 == null)) {
                (this.__IdlePreload_69 = new import11.IdlePreload(this.parent.get(import89.NgZone), this._REQUEST_IDLE_CALLBACK_68));
            }
            return this.__IdlePreload_69;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_PreloadingStrategy_70", {
        get: function () {
            if ((this.__PreloadingStrategy_70 == null)) {
                (this.__PreloadingStrategy_70 = this._IdlePreload_69);
            }
            return this.__PreloadingStrategy_70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_APP_BOOTSTRAP_LISTENER_72", {
        get: function () {
            if ((this.__APP_BOOTSTRAP_LISTENER_72 == null)) {
                (this.__APP_BOOTSTRAP_LISTENER_72 = [
                    import7.appBootstrapListenerFactory(this._AUTO_PREBOOT_59),
                    import10.initialRouterNavigation(this._Router_67, this._ApplicationRef_34, this._RouterPreloader_71, this._ROUTER_CONFIGURATION_62)
                ]);
            }
            return this.__APP_BOOTSTRAP_LISTENER_72;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_RadioControlRegistry_73", {
        get: function () {
            if ((this.__RadioControlRegistry_73 == null)) {
                (this.__RadioControlRegistry_73 = new import45.RadioControlRegistry());
            }
            return this.__RadioControlRegistry_73;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_FormBuilder_74", {
        get: function () {
            if ((this.__FormBuilder_74 == null)) {
                (this.__FormBuilder_74 = new import46.FormBuilder());
            }
            return this.__FormBuilder_74;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_MaskService_75", {
        get: function () {
            if ((this.__MaskService_75 == null)) {
                (this.__MaskService_75 = new import47.MaskService());
            }
            return this.__MaskService_75;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ConfigService_76", {
        get: function () {
            if ((this.__ConfigService_76 == null)) {
                (this.__ConfigService_76 = new import48.ConfigService());
            }
            return this.__ConfigService_76;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_UtilsService_77", {
        get: function () {
            if ((this.__UtilsService_77 == null)) {
                (this.__UtilsService_77 = new import49.UtilsService(this._ConfigService_76, this._Router_67));
            }
            return this.__UtilsService_77;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ContentService_78", {
        get: function () {
            if ((this.__ContentService_78 == null)) {
                (this.__ContentService_78 = new import50.ContentService(this._Http_54, this._Router_67));
            }
            return this.__ContentService_78;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_CookieService_79", {
        get: function () {
            if ((this.__CookieService_79 == null)) {
                (this.__CookieService_79 = new import51.CookieService());
            }
            return this.__CookieService_79;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_CartService_80", {
        get: function () {
            if ((this.__CartService_80 == null)) {
                (this.__CartService_80 = new import52.CartService(this._ConfigService_76, this._UtilsService_77, this._Router_67, this._ContentService_78, this._CookieService_79, this._Http_54));
            }
            return this.__CartService_80;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ApiService_81", {
        get: function () {
            if ((this.__ApiService_81 == null)) {
                (this.__ApiService_81 = new import53.ApiService(this._Http_54));
            }
            return this.__ApiService_81;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ModelService_82", {
        get: function () {
            if ((this.__ModelService_82 == null)) {
                (this.__ModelService_82 = new import54.ModelService(this._ApiService_81, this._CacheService_26));
            }
            return this.__ModelService_82;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_AuthService_83", {
        get: function () {
            if ((this.__AuthService_83 == null)) {
                (this.__AuthService_83 = new import55.AuthService(this._Http_54));
            }
            return this.__AuthService_83;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_AuthGuard_84", {
        get: function () {
            if ((this.__AuthGuard_84 == null)) {
                (this.__AuthGuard_84 = new import56.AuthGuard(this._AuthService_83, this._Router_67));
            }
            return this.__AuthGuard_84;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_DataService_85", {
        get: function () {
            if ((this.__DataService_85 == null)) {
                (this.__DataService_85 = new import57.DataService(this._Http_54));
            }
            return this.__DataService_85;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ElasticSearchService_86", {
        get: function () {
            if ((this.__ElasticSearchService_86 == null)) {
                (this.__ElasticSearchService_86 = new import58.ElasticSearchService(this._Http_54));
            }
            return this.__ElasticSearchService_86;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_SearchService_87", {
        get: function () {
            if ((this.__SearchService_87 == null)) {
                (this.__SearchService_87 = new import59.SearchService(this._Http_54, this._ElasticSearchService_86));
            }
            return this.__SearchService_87;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_Meta_88", {
        get: function () {
            if ((this.__Meta_88 == null)) {
                (this.__Meta_88 = new import60.Meta(this._DOCUMENT_5));
            }
            return this.__Meta_88;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_MetaService_89", {
        get: function () {
            if ((this.__MetaService_89 == null)) {
                (this.__MetaService_89 = new import61.MetaService(this._Meta_88));
            }
            return this.__MetaService_89;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_NotificationService_90", {
        get: function () {
            if ((this.__NotificationService_90 == null)) {
                (this.__NotificationService_90 = new import62.NotificationService(this.parent.get(import114.ElementRef), this.parent.get(import115.Renderer)));
            }
            return this.__NotificationService_90;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_IntlService_91", {
        get: function () {
            if ((this.__IntlService_91 == null)) {
                (this.__IntlService_91 = new import63.IntlService(this._Http_54));
            }
            return this.__IntlService_91;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_ActivatedRoute_92", {
        get: function () {
            if ((this.__ActivatedRoute_92 == null)) {
                (this.__ActivatedRoute_92 = import10.rootRoute(this._Router_67));
            }
            return this.__ActivatedRoute_92;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_NoPreloading_93", {
        get: function () {
            if ((this.__NoPreloading_93 == null)) {
                (this.__NoPreloading_93 = new import44.NoPreloading());
            }
            return this.__NoPreloading_93;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_PreloadAllModules_94", {
        get: function () {
            if ((this.__PreloadAllModules_94 == null)) {
                (this.__PreloadAllModules_94 = new import44.PreloadAllModules());
            }
            return this.__PreloadAllModules_94;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_isBrowser_95", {
        get: function () {
            if ((this.__isBrowser_95 == null)) {
                (this.__isBrowser_95 = true);
            }
            return this.__isBrowser_95;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_isNode_96", {
        get: function () {
            if ((this.__isNode_96 == null)) {
                (this.__isNode_96 = import116.isNode);
            }
            return this.__isNode_96;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_req_97", {
        get: function () {
            if ((this.__req_97 == null)) {
                (this.__req_97 = import1.getRequest());
            }
            return this.__req_97;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainModuleInjector.prototype, "_res_98", {
        get: function () {
            if ((this.__res_98 == null)) {
                (this.__res_98 = import1.getResponse());
            }
            return this.__res_98;
        },
        enumerable: true,
        configurable: true
    });
    MainModuleInjector.prototype.createInternal = function () {
        this._CommonModule_0 = new import2.CommonModule();
        this._ApplicationModule_1 = new import3.ApplicationModule();
        this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule, null));
        this._HttpModule_3 = new import5.HttpModule();
        this._JsonpModule_4 = new import5.JsonpModule();
        this._DOCUMENT_5 = import4._document();
        this._DomSharedStylesHost_6 = new import6.DomSharedStylesHost(this._DOCUMENT_5);
        this._SharedStylesHost_7 = this._DomSharedStylesHost_6;
        this._UniversalModule_8 = new import7.UniversalModule(this._SharedStylesHost_7);
        this._InternalFormsSharedModule_9 = new import8.InternalFormsSharedModule();
        this._FormsModule_10 = new import9.FormsModule();
        this._ROUTER_FORROOT_GUARD_11 = import10.provideForRootGuard(this.parent.get(import117.Router, null));
        this._RouterModule_12 = new import10.RouterModule(this._ROUTER_FORROOT_GUARD_11);
        this._IdlePreloadModule_13 = new import11.IdlePreloadModule();
        this._ReactiveFormsModule_14 = new import9.ReactiveFormsModule();
        this._PaginationModule_15 = new import12.PaginationModule();
        this._SharedModule_16 = new import13.SharedModule();
        this._Ng2InputMaskModule_17 = new import14.Ng2InputMaskModule();
        this._FileUploadModule_18 = new import15.FileUploadModule();
        this._AdminRoutingModule_19 = new import16.AdminRoutingModule();
        this._AdminModule_20 = new import17.AdminModule();
        this._FrontRoutingModule_21 = new import18.FrontRoutingModule();
        this._LazyLoadImageModule_22 = new import19.LazyLoadImageModule();
        this._FrontModule_23 = new import20.FrontModule();
        this._AppModule_24 = new import21.AppModule();
        this._LRU_25 = import1.getLRU();
        this._CacheService_26 = new import22.CacheService(this._LRU_25);
        this._MainModule_27 = new import1.MainModule(this._CacheService_26);
        this._ErrorHandler_30 = import4.errorHandler();
        this._ApplicationInitStatus_31 = new import24.ApplicationInitStatus(this.parent.get(import24.APP_INITIALIZER, null));
        this._Testability_32 = new import25.Testability(this.parent.get(import89.NgZone));
        this._ApplicationRef__33 = new import26.ApplicationRef_(this.parent.get(import89.NgZone), this.parent.get(import118.Console), this, this._ErrorHandler_30, this, this._ApplicationInitStatus_31, this.parent.get(import25.TestabilityRegistry, null), this._Testability_32);
        this._RouterPreloader_71 = new import44.RouterPreloader(this._Router_67, this._NgModuleFactoryLoader_65, this._Compiler_35, this, this._PreloadingStrategy_70);
        return this._MainModule_27;
    };
    MainModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === import2.CommonModule)) {
            return this._CommonModule_0;
        }
        if ((token === import3.ApplicationModule)) {
            return this._ApplicationModule_1;
        }
        if ((token === import4.BrowserModule)) {
            return this._BrowserModule_2;
        }
        if ((token === import5.HttpModule)) {
            return this._HttpModule_3;
        }
        if ((token === import5.JsonpModule)) {
            return this._JsonpModule_4;
        }
        if ((token === import119.DOCUMENT)) {
            return this._DOCUMENT_5;
        }
        if ((token === import6.DomSharedStylesHost)) {
            return this._DomSharedStylesHost_6;
        }
        if ((token === import6.SharedStylesHost)) {
            return this._SharedStylesHost_7;
        }
        if ((token === import7.UniversalModule)) {
            return this._UniversalModule_8;
        }
        if ((token === import8.InternalFormsSharedModule)) {
            return this._InternalFormsSharedModule_9;
        }
        if ((token === import9.FormsModule)) {
            return this._FormsModule_10;
        }
        if ((token === import10.ROUTER_FORROOT_GUARD)) {
            return this._ROUTER_FORROOT_GUARD_11;
        }
        if ((token === import10.RouterModule)) {
            return this._RouterModule_12;
        }
        if ((token === import11.IdlePreloadModule)) {
            return this._IdlePreloadModule_13;
        }
        if ((token === import9.ReactiveFormsModule)) {
            return this._ReactiveFormsModule_14;
        }
        if ((token === import12.PaginationModule)) {
            return this._PaginationModule_15;
        }
        if ((token === import13.SharedModule)) {
            return this._SharedModule_16;
        }
        if ((token === import14.Ng2InputMaskModule)) {
            return this._Ng2InputMaskModule_17;
        }
        if ((token === import15.FileUploadModule)) {
            return this._FileUploadModule_18;
        }
        if ((token === import16.AdminRoutingModule)) {
            return this._AdminRoutingModule_19;
        }
        if ((token === import17.AdminModule)) {
            return this._AdminModule_20;
        }
        if ((token === import18.FrontRoutingModule)) {
            return this._FrontRoutingModule_21;
        }
        if ((token === import19.LazyLoadImageModule)) {
            return this._LazyLoadImageModule_22;
        }
        if ((token === import20.FrontModule)) {
            return this._FrontModule_23;
        }
        if ((token === import21.AppModule)) {
            return this._AppModule_24;
        }
        if ((token === 'LRU')) {
            return this._LRU_25;
        }
        if ((token === import22.CacheService)) {
            return this._CacheService_26;
        }
        if ((token === import1.MainModule)) {
            return this._MainModule_27;
        }
        if ((token === import120.LOCALE_ID)) {
            return this._LOCALE_ID_28;
        }
        if ((token === import23.NgLocalization)) {
            return this._NgLocalization_29;
        }
        if ((token === import121.ErrorHandler)) {
            return this._ErrorHandler_30;
        }
        if ((token === import24.ApplicationInitStatus)) {
            return this._ApplicationInitStatus_31;
        }
        if ((token === import25.Testability)) {
            return this._Testability_32;
        }
        if ((token === import26.ApplicationRef_)) {
            return this._ApplicationRef__33;
        }
        if ((token === import26.ApplicationRef)) {
            return this._ApplicationRef_34;
        }
        if ((token === import27.Compiler)) {
            return this._Compiler_35;
        }
        if ((token === import122.APP_ID)) {
            return this._APP_ID_36;
        }
        if ((token === import28.HAMMER_GESTURE_CONFIG)) {
            return this._HAMMER_GESTURE_CONFIG_37;
        }
        if ((token === import29.EVENT_MANAGER_PLUGINS)) {
            return this._EVENT_MANAGER_PLUGINS_38;
        }
        if ((token === import29.EventManager)) {
            return this._EventManager_39;
        }
        if ((token === import123.AnimationDriver)) {
            return this._AnimationDriver_40;
        }
        if ((token === import30.DomRootRenderer)) {
            return this._DomRootRenderer_41;
        }
        if ((token === import115.RootRenderer)) {
            return this._RootRenderer_42;
        }
        if ((token === import31.DomSanitizer)) {
            return this._DomSanitizer_43;
        }
        if ((token === import124.Sanitizer)) {
            return this._Sanitizer_44;
        }
        if ((token === import32.ViewUtils)) {
            return this._ViewUtils_45;
        }
        if ((token === import125.IterableDiffers)) {
            return this._IterableDiffers_46;
        }
        if ((token === import126.KeyValueDiffers)) {
            return this._KeyValueDiffers_47;
        }
        if ((token === import33.Title)) {
            return this._Title_48;
        }
        if ((token === import34.BrowserXhr)) {
            return this._BrowserXhr_49;
        }
        if ((token === import35.ResponseOptions)) {
            return this._ResponseOptions_50;
        }
        if ((token === import127.XSRFStrategy)) {
            return this._XSRFStrategy_51;
        }
        if ((token === import36.XHRBackend)) {
            return this._XHRBackend_52;
        }
        if ((token === import37.RequestOptions)) {
            return this._RequestOptions_53;
        }
        if ((token === import128.Http)) {
            return this._Http_54;
        }
        if ((token === import38.BrowserJsonp)) {
            return this._BrowserJsonp_55;
        }
        if ((token === import39.JSONPBackend)) {
            return this._JSONPBackend_56;
        }
        if ((token === import128.Jsonp)) {
            return this._Jsonp_57;
        }
        if ((token === import7.UNIVERSAL_CACHE)) {
            return this._UNIVERSAL_CACHE_58;
        }
        if ((token === import7.AUTO_PREBOOT)) {
            return this._AUTO_PREBOOT_59;
        }
        if ((token === import40.UrlSerializer)) {
            return this._UrlSerializer_60;
        }
        if ((token === import41.RouterOutletMap)) {
            return this._RouterOutletMap_61;
        }
        if ((token === import10.ROUTER_CONFIGURATION)) {
            return this._ROUTER_CONFIGURATION_62;
        }
        if ((token === import92.LocationStrategy)) {
            return this._LocationStrategy_63;
        }
        if ((token === import42.Location)) {
            return this._Location_64;
        }
        if ((token === import129.NgModuleFactoryLoader)) {
            return this._NgModuleFactoryLoader_65;
        }
        if ((token === import130.ROUTES)) {
            return this._ROUTES_66;
        }
        if ((token === import117.Router)) {
            return this._Router_67;
        }
        if ((token === import11.REQUEST_IDLE_CALLBACK)) {
            return this._REQUEST_IDLE_CALLBACK_68;
        }
        if ((token === import11.IdlePreload)) {
            return this._IdlePreload_69;
        }
        if ((token === import44.PreloadingStrategy)) {
            return this._PreloadingStrategy_70;
        }
        if ((token === import44.RouterPreloader)) {
            return this._RouterPreloader_71;
        }
        if ((token === import122.APP_BOOTSTRAP_LISTENER)) {
            return this._APP_BOOTSTRAP_LISTENER_72;
        }
        if ((token === import45.RadioControlRegistry)) {
            return this._RadioControlRegistry_73;
        }
        if ((token === import46.FormBuilder)) {
            return this._FormBuilder_74;
        }
        if ((token === import47.MaskService)) {
            return this._MaskService_75;
        }
        if ((token === import48.ConfigService)) {
            return this._ConfigService_76;
        }
        if ((token === import49.UtilsService)) {
            return this._UtilsService_77;
        }
        if ((token === import50.ContentService)) {
            return this._ContentService_78;
        }
        if ((token === import51.CookieService)) {
            return this._CookieService_79;
        }
        if ((token === import52.CartService)) {
            return this._CartService_80;
        }
        if ((token === import53.ApiService)) {
            return this._ApiService_81;
        }
        if ((token === import54.ModelService)) {
            return this._ModelService_82;
        }
        if ((token === import55.AuthService)) {
            return this._AuthService_83;
        }
        if ((token === import56.AuthGuard)) {
            return this._AuthGuard_84;
        }
        if ((token === import57.DataService)) {
            return this._DataService_85;
        }
        if ((token === import58.ElasticSearchService)) {
            return this._ElasticSearchService_86;
        }
        if ((token === import59.SearchService)) {
            return this._SearchService_87;
        }
        if ((token === import60.Meta)) {
            return this._Meta_88;
        }
        if ((token === import61.MetaService)) {
            return this._MetaService_89;
        }
        if ((token === import62.NotificationService)) {
            return this._NotificationService_90;
        }
        if ((token === import63.IntlService)) {
            return this._IntlService_91;
        }
        if ((token === import131.ActivatedRoute)) {
            return this._ActivatedRoute_92;
        }
        if ((token === import44.NoPreloading)) {
            return this._NoPreloading_93;
        }
        if ((token === import44.PreloadAllModules)) {
            return this._PreloadAllModules_94;
        }
        if ((token === 'isBrowser')) {
            return this._isBrowser_95;
        }
        if ((token === 'isNode')) {
            return this._isNode_96;
        }
        if ((token === 'req')) {
            return this._req_97;
        }
        if ((token === 'res')) {
            return this._res_98;
        }
        return notFoundResult;
    };
    MainModuleInjector.prototype.destroyInternal = function () {
        this._ApplicationRef__33.ngOnDestroy();
        this._RouterPreloader_71.ngOnDestroy();
    };
    return MainModuleInjector;
}(import0.NgModuleInjector));
exports.MainModuleNgFactory = new import0.NgModuleFactory(MainModuleInjector, import1.MainModule);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(461);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(550);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 346 */
/***/ (function(module, exports) {

IntlPolyfill.__addLocaleData({locale:"en",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {function __assignFn(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
}
function __extendsFn(d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadataFn(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
}
function __awaiterFn(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator.throw(value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
}
// hook global helpers
(function (__global) {
    __global.__assign = (__global && __global.__assign) || Object.assign || __assignFn;
    __global.__extends = (__global && __global.__extends) || __extendsFn;
    __global.__decorate = (__global && __global.__decorate) || __decorateFn;
    __global.__metadata = (__global && __global.__metadata) || __metadataFn;
    __global.__param = (__global && __global.__param) || __paramFn;
    __global.__awaiter = (__global && __global.__awaiter) || __awaiterFn;
})(typeof window !== "undefined" ? window :
    typeof WorkerGlobalScope !== "undefined" ? self :
        typeof global !== "undefined" ? global :
            Function("return this;")());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.26 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.m=b||a;this.c=this.m.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function z(a){if("string"===typeof a.f)return a.f;var b=a.m.location.protocol;"about:"==b&&(b=a.a.location.protocol);return"https:"==b?"https:":"http:"}function ea(a){return a.m.location.hostname||a.a.location.hostname}
function A(a,b,c){function d(){k&&e&&f&&(k(g),k=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,k=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function B(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function C(){this.a=0;this.c=null}function D(a){a.a++;return function(){a.a--;E(a)}}function F(a,b){a.c=b;E(a)}function E(a){0==a.a&&a.c&&(a.c(),a.c=null)};function G(a){this.a=a||"-"}G.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function H(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return I(a)+" "+(a.f+"00")+" 300px "+J(a.c)}function J(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function K(a){return a.a+a.f}function I(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.m.document.documentElement;this.h=b;this.a=new G("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);L(a,"loading")}function M(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}L(a,"inactive")}function L(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,K(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function N(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function O(a){u(a.c,"body",a.a)}function P(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+J(a.c)+";"+("font-style:"+I(a)+";font-weight:"+(a.f+"00")+";")};function Q(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}Q.prototype.start=function(){var a=this.c.m.document,b=this,c=q(),d=new Promise(function(d,e){function k(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(k,25)},function(){e()})}k()}),e=new Promise(function(a,d){setTimeout(d,b.f)});Promise.race([e,d]).then(function(){b.g(b.a)},function(){b.j(b.a)})};function R(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.o=this.j=this.h=this.g=null;this.g=new N(this.c,this.s);this.h=new N(this.c,this.s);this.j=new N(this.c,this.s);this.o=new N(this.c,this.s);a=new H(this.a.c+",serif",K(this.a));a=P(a);this.g.a.style.cssText=a;a=new H(this.a.c+",sans-serif",K(this.a));a=P(a);this.h.a.style.cssText=a;a=new H("serif",K(this.a));a=P(a);this.j.a.style.cssText=a;a=new H("sans-serif",K(this.a));a=
P(a);this.o.a.style.cssText=a;O(this.g);O(this.h);O(this.j);O(this.o)}var S={D:"serif",C:"sans-serif"},T=null;function U(){if(null===T){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return T}R.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.o.a.offsetWidth;this.A=q();la(this)};
function ma(a,b,c){for(var d in S)if(S.hasOwnProperty(d)&&b===a.f[S[d]]&&c===a.f[S[d]])return!0;return!1}function la(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=U()&&ma(a,b,c));d?q()-a.A>=a.w?U()&&ma(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):na(a):V(a,a.v)}function na(a){setTimeout(p(function(){la(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.o=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,K(a).toString(),"active")],[b.a.c("wf",a.c,K(a).toString(),"loading"),b.a.c("wf",a.c,K(a).toString(),"inactive")]);L(b,"fontactive",a);this.o=!0;oa(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,K(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,K(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,K(a).toString(),"inactive"));w(b.f,d,e)}L(b,"fontinactive",a);oa(this)};function oa(a){0==--a.f&&a.j&&(a.o?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),L(a,"active")):M(a.a))};function pa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}pa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;qa(this,new ha(this.c,a),a)};
function ra(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,k=d||null||{};if(0===c.length&&f)M(b.a);else{b.f+=c.length;f&&(b.j=f);var h,m=[];for(h=0;h<c.length;h++){var l=c[h],n=k[l.c],r=b.a,x=l;r.g&&w(r.f,[r.a.c("wf",x.c,K(x).toString(),"loading")]);L(r,"fontloading",x);r=null;null===X&&(X=window.FontFace?(x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent))?42<parseInt(x[1],10):!0:!1);X?r=new Q(p(b.g,b),p(b.h,b),b.c,l,b.s,n):r=new R(p(b.g,b),p(b.h,b),b.c,l,b.s,a,
n);m.push(r)}for(h=0;h<m.length;h++)m[h].start()}},0)}function qa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){ra(a,f,b,d,c)})};function sa(a,b){this.c=a;this.a=b}function ta(a,b,c){var d=z(a.c);a=(a.a.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return d+"//"+a+"/"+b+".js"+(c?"?v="+c:"")}
sa.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var m=0;m<c.length;m++){var l=c[m].fontfamily;void 0!=c[m].fontStyle&&void 0!=c[m].fontWeight?(h=c[m].fontStyle+c[m].fontWeight,e.push(new H(l,h))):e.push(new H(l))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.m;B(this.c,ta(c,d,e),function(e){e?a([]):(f["__MonotypeConfiguration__"+d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+
d}else a([])};function ua(a,b){this.c=a;this.a=b}ua.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new C;b=0;for(c=d.length;b<c;b++)A(this.c,d[b],D(g));var k=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),m=0;m<h.length;m+=1)k.push(new H(d[0],h[m]));else k.push(new H(d[0]));F(g,function(){a(k,f)})};function va(a,b,c){a?this.c=a:this.c=b+wa;this.a=[];this.f=[];this.g=c||""}var wa="//fonts.googleapis.com/css";function xa(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function ya(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function za(a){this.f=a;this.a=[];this.c={}}
var Aa={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Ba={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ca={i:"i",italic:"i",n:"n",normal:"n"},
Da=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Ea(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var k=d[1];g=[];if(k)for(var k=k.split(","),h=k.length,m=0;m<h;m++){var l;l=k[m];if(l.match(/^[\w-]+$/)){var n=Da.exec(l.toLowerCase());if(null==n)l="";else{l=n[2];l=null==l||""==l?"n":Ca[l];n=n[1];if(null==n||""==n)n="4";else var r=Ba[n],n=r?r:isNaN(n)?"4":n.substr(0,1);l=[l,n].join("")}}else l="";l&&g.push(l)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=Aa[d[0]])&&(a.c[e]=d))}a.c[e]||(d=Aa[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new H(e,f[d]))}};function Fa(a,b){this.c=a;this.a=b}var Ga={Arimo:!0,Cousine:!0,Tinos:!0};Fa.prototype.load=function(a){var b=new C,c=this.c,d=new va(this.a.api,z(c),this.a.text),e=this.a.families;xa(d,e);var f=new za(e);Ea(f);A(c,ya(d),D(b));F(b,function(){a(f.a,f.c,Ga)})};function Ha(a,b){this.c=a;this.a=b}Ha.prototype.load=function(a){var b=this.a.id,c=this.c.m;b?B(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],k=b[f+1],h=0;h<k.length;h++)e.push(new H(g,k[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(m){}a(e)}},2E3):a([])};function Ia(a,b){this.c=a;this.f=b;this.a=[]}Ia.prototype.load=function(a){var b=this.f.id,c=this.c.m,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,k=c.fonts.length;g<k;++g){var h=c.fonts[g];d.a.push(new H(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},B(this.c,z(this.c)+(this.f.api||"//f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new pa(window);Y.a.c.custom=function(a,b){return new ua(b,a)};Y.a.c.fontdeck=function(a,b){return new Ia(b,a)};Y.a.c.monotype=function(a,b){return new sa(b,a)};Y.a.c.typekit=function(a,b){return new Ha(b,a)};Y.a.c.google=function(a,b){return new Fa(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localization__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_switch__ = __webpack_require__(39);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgPlural; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgPluralCase; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 *
 * @whatItDoes Adds / removes DOM sub-trees based on a numeric value. Tailored for pluralization.
 *
 * @howToUse
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-container *ngPluralCase="'=0'">there is nothing</ng-container>
 *   <ng-container *ngPluralCase="'=1'">there is one</ng-container>
 *   <ng-container *ngPluralCase="'few'">there are a few</ng-container>
 *   <ng-container *ngPluralCase="'other'">there are exactly #</ng-container>
 * </some-element>
 * ```
 *
 * @description
 *
 * Displays DOM sub-trees that match the switch expression value, or failing that, DOM sub-trees
 * that match the switch expression's pluralization category.
 *
 * To use this directive you must provide a container element that sets the `[ngPlural]` attribute
 * to a switch expression. Inner elements with a `[ngPluralCase]` will display based on their
 * expression:
 * - if `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
 *   matches the switch expression exactly,
 * - otherwise, the view will be treated as a "category match", and will only display if exact
 *   value matches aren't found and the value maps to its category for the defined locale.
 *
 * See http://cldr.unicode.org/index/cldr-spec/plural-rules
 *
 * @experimental
 */
var NgPlural = (function () {
    function NgPlural(_localization) {
        this._localization = _localization;
        this._caseViews = {};
    }
    Object.defineProperty(NgPlural.prototype, "ngPlural", {
        set: function (value) {
            this._switchValue = value;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    NgPlural.prototype.addCase = function (value, switchView) { this._caseViews[value] = switchView; };
    NgPlural.prototype._updateView = function () {
        this._clearViews();
        var cases = Object.keys(this._caseViews);
        var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__localization__["getPluralCategory"])(this._switchValue, cases, this._localization);
        this._activateView(this._caseViews[key]);
    };
    NgPlural.prototype._clearViews = function () {
        if (this._activeView)
            this._activeView.destroy();
    };
    NgPlural.prototype._activateView = function (view) {
        if (view) {
            this._activeView = view;
            this._activeView.create();
        }
    };
    NgPlural.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngPlural]' },] },
    ];
    /** @nocollapse */
    NgPlural.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_1__localization__["NgLocalization"], },
    ];
    NgPlural.propDecorators = {
        'ngPlural': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgPlural;
}());
/**
 * @ngModule CommonModule
 *
 * @whatItDoes Creates a view that will be added/removed from the parent {@link NgPlural} when the
 *             given expression matches the plural expression according to CLDR rules.
 *
 * @howToUse
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-container *ngPluralCase="'=0'">...</ng-container>
 *   <ng-container *ngPluralCase="'other'">...</ng-container>
 * </some-element>
 *```
 *
 * See {@link NgPlural} for more details and example.
 *
 * @experimental
 */
var NgPluralCase = (function () {
    function NgPluralCase(value, template, viewContainer, ngPlural) {
        this.value = value;
        ngPlural.addCase(value, new __WEBPACK_IMPORTED_MODULE_2__ng_switch__["SwitchView"](viewContainer, template));
    }
    NgPluralCase.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngPluralCase]' },] },
    ];
    /** @nocollapse */
    NgPluralCase.ctorParameters = [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['ngPluralCase',] },] },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
        { type: NgPlural, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ];
    return NgPluralCase;
}());
//# sourceMappingURL=ng_plural.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgTemplateOutlet; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @ngModule CommonModule
 *
 * @whatItDoes Inserts an embedded view from a prepared `TemplateRef`
 *
 * @howToUse
 * ```
 * <template [ngTemplateOutlet]="templateRefExpression"
 *           [ngOutletContext]="objectExpression">
 * </template>
 * ```
 *
 * @description
 *
 * You can attach a context object to the `EmbeddedViewRef` by setting `[ngOutletContext]`.
 * `[ngOutletContext]` should be an object, the object's keys will be the local template variables
 * available within the `TemplateRef`.
 *
 * Note: using the key `$implicit` in the context object will set it's value as default.
 *
 * @experimental
 */
var NgTemplateOutlet = (function () {
    function NgTemplateOutlet(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
    }
    Object.defineProperty(NgTemplateOutlet.prototype, "ngOutletContext", {
        set: function (context) { this._context = context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgTemplateOutlet.prototype, "ngTemplateOutlet", {
        set: function (templateRef) { this._templateRef = templateRef; },
        enumerable: true,
        configurable: true
    });
    NgTemplateOutlet.prototype.ngOnChanges = function (changes) {
        if (this._viewRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
        }
        if (this._templateRef) {
            this._viewRef = this._viewContainerRef.createEmbeddedView(this._templateRef, this._context);
        }
    };
    NgTemplateOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngTemplateOutlet]' },] },
    ];
    /** @nocollapse */
    NgTemplateOutlet.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    ];
    NgTemplateOutlet.propDecorators = {
        'ngOutletContext': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'ngTemplateOutlet': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return NgTemplateOutlet;
}());
//# sourceMappingURL=ng_template_outlet.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_platform_location__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_location_strategy__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location_hash_location_strategy__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location_path_location_strategy__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location_location__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__location_platform_location__["PlatformLocation"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__location_location_strategy__["LocationStrategy"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__location_location_strategy__["APP_BASE_HREF"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__location_hash_location_strategy__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__location_path_location_strategy__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__location_location__["Location"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





//# sourceMappingURL=location.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location_strategy__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_location__ = __webpack_require__(127);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return HashLocationStrategy; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





/**
 * `HashLocationStrategy` is a {@link LocationStrategy} used to configure the
 * {@link Location} service to represent its state in the
 * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
 * of the browser's URL.
 *
 * For instance, if you call `location.go('/foo')`, the browser's URL will become
 * `example.com#/foo`.
 *
 * ### Example
 *
 * ```
 * import {Component, NgModule} from '@angular/core';
 * import {
 *   LocationStrategy,
 *   HashLocationStrategy
 * } from '@angular/common';
 *
 * @NgModule({
 *   providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}]
 * })
 * class AppModule {}
 * ```
 *
 * @stable
 */
var HashLocationStrategy = (function (_super) {
    __extends(HashLocationStrategy, _super);
    function HashLocationStrategy(_platformLocation, _baseHref) {
        _super.call(this);
        this._platformLocation = _platformLocation;
        this._baseHref = '';
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(_baseHref)) {
            this._baseHref = _baseHref;
        }
    }
    HashLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    HashLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    HashLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        // the hash value is always prefixed with a `#`
        // and if it is empty then it will stay empty
        var path = this._platformLocation.hash;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(path))
            path = '#';
        return path.length > 0 ? path.substring(1) : path;
    };
    HashLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        var url = __WEBPACK_IMPORTED_MODULE_2__location__["Location"].joinWithSlash(this._baseHref, internal);
        return url.length > 0 ? ('#' + url) : url;
    };
    HashLocationStrategy.prototype.pushState = function (state, title, path, queryParams) {
        var url = this.prepareExternalUrl(path + __WEBPACK_IMPORTED_MODULE_2__location__["Location"].normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.pushState(state, title, url);
    };
    HashLocationStrategy.prototype.replaceState = function (state, title, path, queryParams) {
        var url = this.prepareExternalUrl(path + __WEBPACK_IMPORTED_MODULE_2__location__["Location"].normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.replaceState(state, title, url);
    };
    HashLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    HashLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    HashLocationStrategy.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HashLocationStrategy.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_location__["PlatformLocation"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__location_strategy__["APP_BASE_HREF"],] },] },
    ];
    return HashLocationStrategy;
}(__WEBPACK_IMPORTED_MODULE_3__location_strategy__["LocationStrategy"]));
//# sourceMappingURL=hash_location_strategy.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__location_strategy__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_location__ = __webpack_require__(127);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return PathLocationStrategy; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};





/**
 * `PathLocationStrategy` is a {@link LocationStrategy} used to configure the
 * {@link Location} service to represent its state in the
 * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
 * browser's URL.
 *
 * `PathLocationStrategy` is the default binding for {@link LocationStrategy}
 * provided in {@link ROUTER_PROVIDERS}.
 *
 * If you're using `PathLocationStrategy`, you must provide a {@link APP_BASE_HREF}
 * or add a base element to the document. This URL prefix that will be preserved
 * when generating and recognizing URLs.
 *
 * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * Similarly, if you add `<base href='/my/app'/>` to the document and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * @stable
 */
var PathLocationStrategy = (function (_super) {
    __extends(PathLocationStrategy, _super);
    function PathLocationStrategy(_platformLocation, href) {
        _super.call(this);
        this._platformLocation = _platformLocation;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(href)) {
            href = this._platformLocation.getBaseHrefFromDOM();
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(href)) {
            throw new Error("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
        }
        this._baseHref = href;
    }
    PathLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    PathLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        return __WEBPACK_IMPORTED_MODULE_2__location__["Location"].joinWithSlash(this._baseHref, internal);
    };
    PathLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        var pathname = this._platformLocation.pathname +
            __WEBPACK_IMPORTED_MODULE_2__location__["Location"].normalizeQueryParams(this._platformLocation.search);
        var hash = this._platformLocation.hash;
        return hash && includeHash ? "" + pathname + hash : pathname;
    };
    PathLocationStrategy.prototype.pushState = function (state, title, url, queryParams) {
        var externalUrl = this.prepareExternalUrl(url + __WEBPACK_IMPORTED_MODULE_2__location__["Location"].normalizeQueryParams(queryParams));
        this._platformLocation.pushState(state, title, externalUrl);
    };
    PathLocationStrategy.prototype.replaceState = function (state, title, url, queryParams) {
        var externalUrl = this.prepareExternalUrl(url + __WEBPACK_IMPORTED_MODULE_2__location__["Location"].normalizeQueryParams(queryParams));
        this._platformLocation.replaceState(state, title, externalUrl);
    };
    PathLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    PathLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    PathLocationStrategy.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    PathLocationStrategy.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_4__platform_location__["PlatformLocation"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__location_strategy__["APP_BASE_HREF"],] },] },
    ];
    return PathLocationStrategy;
}(__WEBPACK_IMPORTED_MODULE_3__location_strategy__["LocationStrategy"]));
//# sourceMappingURL=path_location_strategy.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__private_import_core__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AsyncPipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var ObservableStrategy = (function () {
    function ObservableStrategy() {
    }
    ObservableStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.subscribe({ next: updateLatestValue, error: function (e) { throw e; } });
    };
    ObservableStrategy.prototype.dispose = function (subscription) { subscription.unsubscribe(); };
    ObservableStrategy.prototype.onDestroy = function (subscription) { subscription.unsubscribe(); };
    return ObservableStrategy;
}());
var PromiseStrategy = (function () {
    function PromiseStrategy() {
    }
    PromiseStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.then(updateLatestValue, function (e) { throw e; });
    };
    PromiseStrategy.prototype.dispose = function (subscription) { };
    PromiseStrategy.prototype.onDestroy = function (subscription) { };
    return PromiseStrategy;
}());
var _promiseStrategy = new PromiseStrategy();
var _observableStrategy = new ObservableStrategy();
/**
 * @ngModule CommonModule
 * @whatItDoes Unwraps a value from an asynchronous primitive.
 * @howToUse `observable_or_promise_expression | async`
 * @description
 * The `async` pipe subscribes to an `Observable` or `Promise` and returns the latest value it has
 * emitted. When a new value is emitted, the `async` pipe marks the component to be checked for
 * changes. When the component gets destroyed, the `async` pipe unsubscribes automatically to avoid
 * potential memory leaks.
 *
 *
 * ## Examples
 *
 * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
 * promise.
 *
 * {@example common/pipes/ts/async_pipe.ts region='AsyncPipePromise'}
 *
 * It's also possible to use `async` with Observables. The example below binds the `time` Observable
 * to the view. The Observable continuesly updates the view with the current time.
 *
 * {@example common/pipes/ts/async_pipe.ts region='AsyncPipeObservable'}
 *
 * @stable
 */
var AsyncPipe = (function () {
    function AsyncPipe(_ref) {
        this._ref = _ref;
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
        this._strategy = null;
    }
    AsyncPipe.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._dispose();
        }
    };
    AsyncPipe.prototype.transform = function (obj) {
        if (!this._obj) {
            if (obj) {
                this._subscribe(obj);
            }
            this._latestReturnedValue = this._latestValue;
            return this._latestValue;
        }
        if (obj !== this._obj) {
            this._dispose();
            return this.transform(obj);
        }
        if (this._latestValue === this._latestReturnedValue) {
            return this._latestReturnedValue;
        }
        this._latestReturnedValue = this._latestValue;
        return __WEBPACK_IMPORTED_MODULE_0__angular_core__["WrappedValue"].wrap(this._latestValue);
    };
    AsyncPipe.prototype._subscribe = function (obj) {
        var _this = this;
        this._obj = obj;
        this._strategy = this._selectStrategy(obj);
        this._subscription = this._strategy.createSubscription(obj, function (value) { return _this._updateLatestValue(obj, value); });
    };
    AsyncPipe.prototype._selectStrategy = function (obj) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__private_import_core__["a" /* isPromise */])(obj)) {
            return _promiseStrategy;
        }
        if (obj.subscribe) {
            return _observableStrategy;
        }
        throw new __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](AsyncPipe, obj);
    };
    AsyncPipe.prototype._dispose = function () {
        this._strategy.dispose(this._subscription);
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
    };
    AsyncPipe.prototype._updateLatestValue = function (async, value) {
        if (async === this._obj) {
            this._latestValue = value;
            this._ref.markForCheck();
        }
    };
    AsyncPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'async', pure: false },] },
    ];
    /** @nocollapse */
    AsyncPipe.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    ];
    return AsyncPipe;
}());
//# sourceMappingURL=async_pipe.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localization__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return I18nPluralPipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var _INTERPOLATION_REGEXP = /#/g;
/**
 * @ngModule CommonModule
 * @whatItDoes Maps a value to a string that pluralizes the value according to locale rules.
 * @howToUse `expression | i18nPlural:mapping`
 * @description
 *
 *  Where:
 *  - `expression` is a number.
 *  - `mapping` is an object that mimics the ICU format, see
 *    http://userguide.icu-project.org/formatparse/messages
 *
 *  ## Example
 *
 * {@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
 *
 * @experimental
 */
var I18nPluralPipe = (function () {
    function I18nPluralPipe(_localization) {
        this._localization = _localization;
    }
    I18nPluralPipe.prototype.transform = function (value, pluralMap) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value))
            return '';
        if (typeof pluralMap !== 'object' || pluralMap === null) {
            throw new __WEBPACK_IMPORTED_MODULE_3__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](I18nPluralPipe, pluralMap);
        }
        var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__localization__["getPluralCategory"])(value, Object.keys(pluralMap), this._localization);
        return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
    };
    I18nPluralPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'i18nPlural', pure: true },] },
    ];
    /** @nocollapse */
    I18nPluralPipe.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__localization__["NgLocalization"], },
    ];
    return I18nPluralPipe;
}());
//# sourceMappingURL=i18n_plural_pipe.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return I18nSelectPipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 * @whatItDoes Generic selector that displays the string that matches the current value.
 * @howToUse `expression | i18nSelect:mapping`
 * @description
 *
 *  Where:
 *  - `mapping`: is an object that indicates the text that should be displayed
 *  for different values of the provided `expression`.
 *
 *  ## Example
 *
 * {@example common/pipes/ts/i18n_pipe.ts region='I18nSelectPipeComponent'}
 *
 *  @experimental
 */
var I18nSelectPipe = (function () {
    function I18nSelectPipe() {
    }
    I18nSelectPipe.prototype.transform = function (value, mapping) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value))
            return '';
        if (typeof mapping !== 'object' || mapping === null) {
            throw new __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](I18nSelectPipe, mapping);
        }
        return mapping[value] || '';
    };
    I18nSelectPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'i18nSelect', pure: true },] },
    ];
    /** @nocollapse */
    I18nSelectPipe.ctorParameters = [];
    return I18nSelectPipe;
}());
//# sourceMappingURL=i18n_select_pipe.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return JsonPipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @ngModule CommonModule
 * @whatItDoes Converts value into JSON string.
 * @howToUse `expression | json`
 * @description
 *
 * Converts value into string using `JSON.stringify`. Useful for debugging.
 *
 * ### Example
 * {@example common/pipes/ts/json_pipe.ts region='JsonPipe'}
 *
 * @stable
 */
var JsonPipe = (function () {
    function JsonPipe() {
    }
    JsonPipe.prototype.transform = function (value) { return JSON.stringify(value, null, 2); };
    JsonPipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'json', pure: false },] },
    ];
    /** @nocollapse */
    JsonPipe.ctorParameters = [];
    return JsonPipe;
}());
//# sourceMappingURL=json_pipe.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return LowerCasePipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 * @whatItDoes Transforms string to lowercase.
 * @howToUse `expression | lowercase`
 * @description
 *
 * Converts value into lowercase string using `String.prototype.toLowerCase()`.
 *
 * ### Example
 *
 * {@example common/pipes/ts/lowerupper_pipe.ts region='LowerUpperPipe'}
 *
 * @stable
 */
var LowerCasePipe = (function () {
    function LowerCasePipe() {
    }
    LowerCasePipe.prototype.transform = function (value) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value))
            return value;
        if (typeof value !== 'string') {
            throw new __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](LowerCasePipe, value);
        }
        return value.toLowerCase();
    };
    LowerCasePipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'lowercase' },] },
    ];
    /** @nocollapse */
    LowerCasePipe.ctorParameters = [];
    return LowerCasePipe;
}());
//# sourceMappingURL=lowercase_pipe.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__ = __webpack_require__(68);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SlicePipe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @ngModule CommonModule
 * @whatItDoes Creates a new List or String containing a subset (slice) of the elements.
 * @howToUse `array_or_string_expression | slice:start[:end]`
 * @description
 *
 * Where the input expression is a `List` or `String`, and:
 * - `start`: The starting index of the subset to return.
 *   - **a positive integer**: return the item at `start` index and all items after
 *     in the list or string expression.
 *   - **a negative integer**: return the item at `start` index from the end and all items after
 *     in the list or string expression.
 *   - **if positive and greater than the size of the expression**: return an empty list or string.
 *   - **if negative and greater than the size of the expression**: return entire list or string.
 * - `end`: The ending index of the subset to return.
 *   - **omitted**: return all items until the end.
 *   - **if positive**: return all items before `end` index of the list or string.
 *   - **if negative**: return all items before `end` index from the end of the list or string.
 *
 * All behavior is based on the expected behavior of the JavaScript API `Array.prototype.slice()`
 * and `String.prototype.slice()`.
 *
 * When operating on a [List], the returned list is always a copy even when all
 * the elements are being returned.
 *
 * When operating on a blank value, the pipe returns the blank value.
 *
 * ## List Example
 *
 * This `ngFor` example:
 *
 * {@example common/pipes/ts/slice_pipe.ts region='SlicePipe_list'}
 *
 * produces the following:
 *
 *     <li>b</li>
 *     <li>c</li>
 *
 * ## String Examples
 *
 * {@example common/pipes/ts/slice_pipe.ts region='SlicePipe_string'}
 *
 * @stable
 */
var SlicePipe = (function () {
    function SlicePipe() {
    }
    SlicePipe.prototype.transform = function (value, start, end) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isBlank */])(value))
            return value;
        if (!this.supports(value)) {
            throw new __WEBPACK_IMPORTED_MODULE_2__invalid_pipe_argument_error__["a" /* InvalidPipeArgumentError */](SlicePipe, value);
        }
        return value.slice(start, end);
    };
    SlicePipe.prototype.supports = function (obj) { return typeof obj === 'string' || Array.isArray(obj); };
    SlicePipe.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'slice', pure: false },] },
    ];
    /** @nocollapse */
    SlicePipe.ctorParameters = [];
    return SlicePipe;
}());
//# sourceMappingURL=slice_pipe.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isPromise; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
//# sourceMappingURL=private_import_core.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationKeyframe; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationKeyframe = (function () {
    function AnimationKeyframe(offset, styles) {
        this.offset = offset;
        this.styles = styles;
    }
    return AnimationKeyframe;
}());
//# sourceMappingURL=animation_keyframe.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation_player__ = __webpack_require__(186);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationSequencePlayer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var AnimationSequencePlayer = (function () {
    function AnimationSequencePlayer(_players) {
        var _this = this;
        this._players = _players;
        this._currentIndex = 0;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this.parentPlayer = null;
        this._players.forEach(function (player) { player.parentPlayer = _this; });
        this._onNext(false);
    }
    AnimationSequencePlayer.prototype._onNext = function (start) {
        var _this = this;
        if (this._finished)
            return;
        if (this._players.length == 0) {
            this._activePlayer = new __WEBPACK_IMPORTED_MODULE_1__animation_player__["a" /* NoOpAnimationPlayer */]();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["l" /* scheduleMicroTask */])(function () { return _this._onFinish(); });
        }
        else if (this._currentIndex >= this._players.length) {
            this._activePlayer = new __WEBPACK_IMPORTED_MODULE_1__animation_player__["a" /* NoOpAnimationPlayer */]();
            this._onFinish();
        }
        else {
            var player = this._players[this._currentIndex++];
            player.onDone(function () { return _this._onNext(true); });
            this._activePlayer = player;
            if (start) {
                player.play();
            }
        }
    };
    AnimationSequencePlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.parentPlayer)) {
                this.destroy();
            }
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    AnimationSequencePlayer.prototype.init = function () { this._players.forEach(function (player) { return player.init(); }); };
    AnimationSequencePlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    AnimationSequencePlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    AnimationSequencePlayer.prototype.hasStarted = function () { return this._started; };
    AnimationSequencePlayer.prototype.play = function () {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(this.parentPlayer)) {
            this.init();
        }
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._activePlayer.play();
    };
    AnimationSequencePlayer.prototype.pause = function () { this._activePlayer.pause(); };
    AnimationSequencePlayer.prototype.restart = function () {
        if (this._players.length > 0) {
            this.reset();
            this._players[0].restart();
        }
    };
    AnimationSequencePlayer.prototype.reset = function () { this._players.forEach(function (player) { return player.reset(); }); };
    AnimationSequencePlayer.prototype.finish = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.finish(); });
    };
    AnimationSequencePlayer.prototype.destroy = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.destroy(); });
    };
    AnimationSequencePlayer.prototype.setPosition = function (p /** TODO #9100 */) { this._players[0].setPosition(p); };
    AnimationSequencePlayer.prototype.getPosition = function () { return this._players[0].getPosition(); };
    return AnimationSequencePlayer;
}());
//# sourceMappingURL=animation_sequence_player.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation_constants__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(263);
/* harmony export (immutable) */ exports["a"] = prepareFinalAnimationStyles;
/* harmony export (immutable) */ exports["b"] = balanceAnimationKeyframes;
/* harmony export (immutable) */ exports["d"] = clearStyles;
/* harmony export (immutable) */ exports["f"] = collectAndResolveStyles;
/* harmony export (immutable) */ exports["e"] = renderStyles;
/* harmony export (immutable) */ exports["c"] = flattenStyles;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




function prepareFinalAnimationStyles(previousStyles, newStyles, nullValue) {
    if (nullValue === void 0) { nullValue = null; }
    var finalStyles = {};
    Object.keys(newStyles).forEach(function (prop) {
        var value = newStyles[prop];
        finalStyles[prop] = value == __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* AUTO_STYLE */] ? nullValue : value.toString();
    });
    Object.keys(previousStyles).forEach(function (prop) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(finalStyles[prop])) {
            finalStyles[prop] = nullValue;
        }
    });
    return finalStyles;
}
function balanceAnimationKeyframes(collectedStyles, finalStateStyles, keyframes) {
    var limit = keyframes.length - 1;
    var firstKeyframe = keyframes[0];
    // phase 1: copy all the styles from the first keyframe into the lookup map
    var flatenedFirstKeyframeStyles = flattenStyles(firstKeyframe.styles.styles);
    var extraFirstKeyframeStyles = {};
    var hasExtraFirstStyles = false;
    Object.keys(collectedStyles).forEach(function (prop) {
        var value = collectedStyles[prop];
        // if the style is already defined in the first keyframe then
        // we do not replace it.
        if (!flatenedFirstKeyframeStyles[prop]) {
            flatenedFirstKeyframeStyles[prop] = value;
            extraFirstKeyframeStyles[prop] = value;
            hasExtraFirstStyles = true;
        }
    });
    var keyframeCollectedStyles = __WEBPACK_IMPORTED_MODULE_0__facade_collection__["f" /* StringMapWrapper */].merge({}, flatenedFirstKeyframeStyles);
    // phase 2: normalize the final keyframe
    var finalKeyframe = keyframes[limit];
    finalKeyframe.styles.styles.unshift(finalStateStyles);
    var flatenedFinalKeyframeStyles = flattenStyles(finalKeyframe.styles.styles);
    var extraFinalKeyframeStyles = {};
    var hasExtraFinalStyles = false;
    Object.keys(keyframeCollectedStyles).forEach(function (prop) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(flatenedFinalKeyframeStyles[prop])) {
            extraFinalKeyframeStyles[prop] = __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* AUTO_STYLE */];
            hasExtraFinalStyles = true;
        }
    });
    if (hasExtraFinalStyles) {
        finalKeyframe.styles.styles.push(extraFinalKeyframeStyles);
    }
    Object.keys(flatenedFinalKeyframeStyles).forEach(function (prop) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(flatenedFirstKeyframeStyles[prop])) {
            extraFirstKeyframeStyles[prop] = __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* AUTO_STYLE */];
            hasExtraFirstStyles = true;
        }
    });
    if (hasExtraFirstStyles) {
        firstKeyframe.styles.styles.push(extraFirstKeyframeStyles);
    }
    return keyframes;
}
function clearStyles(styles) {
    var finalStyles = {};
    Object.keys(styles).forEach(function (key) { finalStyles[key] = null; });
    return finalStyles;
}
function collectAndResolveStyles(collection, styles) {
    return styles.map(function (entry) {
        var stylesObj = {};
        Object.keys(entry).forEach(function (prop) {
            var value = entry[prop];
            if (value == __WEBPACK_IMPORTED_MODULE_2__animation_constants__["a" /* FILL_STYLE_FLAG */]) {
                value = collection[prop];
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(value)) {
                    value = __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* AUTO_STYLE */];
                }
            }
            collection[prop] = value;
            stylesObj[prop] = value;
        });
        return stylesObj;
    });
}
function renderStyles(element, renderer, styles) {
    Object.keys(styles).forEach(function (prop) { renderer.setElementStyle(element, prop, styles[prop]); });
}
function flattenStyles(styles) {
    var finalStyles = {};
    styles.forEach(function (entry) {
        Object.keys(entry).forEach(function (prop) { finalStyles[prop] = entry[prop]; });
    });
    return finalStyles;
}
//# sourceMappingURL=animation_style_util.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationStyles; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationStyles = (function () {
    function AnimationStyles(styles) {
        this.styles = styles;
    }
    return AnimationStyles;
}());
//# sourceMappingURL=animation_styles.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_transition_event__ = __webpack_require__(262);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationTransition; });

var AnimationTransition = (function () {
    function AnimationTransition(_player, _fromState, _toState, _totalTime) {
        this._player = _player;
        this._fromState = _fromState;
        this._toState = _toState;
        this._totalTime = _totalTime;
    }
    AnimationTransition.prototype._createEvent = function (phaseName) {
        return new __WEBPACK_IMPORTED_MODULE_0__animation_transition_event__["a" /* AnimationTransitionEvent */]({
            fromState: this._fromState,
            toState: this._toState,
            totalTime: this._totalTime,
            phaseName: phaseName
        });
    };
    AnimationTransition.prototype.onStart = function (callback) {
        var event = this._createEvent('start');
        this._player.onStart(function () { return callback(event); });
    };
    AnimationTransition.prototype.onDone = function (callback) {
        var event = this._createEvent('done');
        this._player.onDone(function () { return callback(event); });
    };
    return AnimationTransition;
}());
//# sourceMappingURL=animation_transition.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ViewAnimationMap; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ViewAnimationMap = (function () {
    function ViewAnimationMap() {
        this._map = new Map();
        this._allPlayers = [];
    }
    ViewAnimationMap.prototype.find = function (element, animationName) {
        var playersByAnimation = this._map.get(element);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(playersByAnimation)) {
            return playersByAnimation[animationName];
        }
    };
    ViewAnimationMap.prototype.findAllPlayersByElement = function (element) {
        var el = this._map.get(element);
        return el ? Object.keys(el).map(function (k) { return el[k]; }) : [];
    };
    ViewAnimationMap.prototype.set = function (element, animationName, player) {
        var playersByAnimation = this._map.get(element);
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(playersByAnimation)) {
            playersByAnimation = {};
        }
        var existingEntry = playersByAnimation[animationName];
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["d" /* isPresent */])(existingEntry)) {
            this.remove(element, animationName);
        }
        playersByAnimation[animationName] = player;
        this._allPlayers.push(player);
        this._map.set(element, playersByAnimation);
    };
    ViewAnimationMap.prototype.getAllPlayers = function () { return this._allPlayers; };
    ViewAnimationMap.prototype.remove = function (element, animationName) {
        var playersByAnimation = this._map.get(element);
        if (playersByAnimation) {
            var player = playersByAnimation[animationName];
            delete playersByAnimation[animationName];
            var index = this._allPlayers.indexOf(player);
            this._allPlayers.splice(index, 1);
            if (Object.keys(playersByAnimation).length === 0) {
                this._map.delete(element);
            }
        }
    };
    return ViewAnimationMap;
}());
//# sourceMappingURL=view_animation_map.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectionStrategy"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["ChangeDetectorRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["CollectionChangeRecord"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["DefaultIterableDiffer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["IterableDiffers"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["KeyValueChangeRecord"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["KeyValueDiffers"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["SimpleChange"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__change_detection_change_detection__["WrappedValue"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Change detection enables data binding in Angular.
 */

//# sourceMappingURL=change_detection.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ChangeDetectorRef; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @stable
 */
var ChangeDetectorRef = (function () {
    function ChangeDetectorRef() {
    }
    return ChangeDetectorRef;
}());
//# sourceMappingURL=change_detector_ref.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__di__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__application_ref__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__application_tokens__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__application_init__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zone__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__render__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__linker__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__debug_debug_node__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__debug_debug_node___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__debug_debug_node__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__testability_testability__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__change_detection__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__platform_core_providers__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_tokens__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__application_module__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__profile_profile__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__type__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__error_handler__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__core_private_export__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__animation_metadata__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__animation_animation_transition_event__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__animation_animation_player__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__security__ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_1", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_6", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_8", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_9", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_10", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_11", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_12", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_13", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_14", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_15", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_16", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_17", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_18", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_73", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_74", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_75", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_76", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_77", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_78", function() { return __WEBPACK_IMPORTED_MODULE_2__di__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["assertPlatform"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["destroyPlatform"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["getPlatform"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["createPlatform"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["ApplicationRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["enableProdMode"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["isDevMode"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["createPlatformFactory"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__application_ref__["PlatformRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__application_tokens__["APP_ID"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__application_tokens__["PACKAGE_ROOT_URL"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__application_tokens__["APP_BOOTSTRAP_LISTENER"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__application_tokens__["PLATFORM_INITIALIZER"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__application_init__["ApplicationInitStatus"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__application_init__["APP_INITIALIZER"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_19", function() { return __WEBPACK_IMPORTED_MODULE_6__zone__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_20", function() { return __WEBPACK_IMPORTED_MODULE_7__render__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_21", function() { return __WEBPACK_IMPORTED_MODULE_7__render__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_22", function() { return __WEBPACK_IMPORTED_MODULE_7__render__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_23", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_24", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_25", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_26", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_27", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_28", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_29", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_30", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_31", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_32", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_33", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_34", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_35", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_36", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_37", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_38", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_39", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_40", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_41", function() { return __WEBPACK_IMPORTED_MODULE_8__linker__["s"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_9__debug_debug_node__, "DebugElement")) __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_9__debug_debug_node__["DebugElement"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_9__debug_debug_node__, "DebugNode")) __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__debug_debug_node__["DebugNode"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_9__debug_debug_node__, "asNativeElements")) __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__debug_debug_node__["asNativeElements"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_9__debug_debug_node__, "getDebugNode")) __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__debug_debug_node__["getDebugNode"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__testability_testability__["Testability"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_10__testability_testability__["TestabilityRegistry"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__testability_testability__["setTestabilityGetter"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_42", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_43", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_44", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_45", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_46", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_47", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_48", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_49", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_50", function() { return __WEBPACK_IMPORTED_MODULE_11__change_detection__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_51", function() { return __WEBPACK_IMPORTED_MODULE_12__platform_core_providers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_13__i18n_tokens__["TRANSLATIONS"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_13__i18n_tokens__["TRANSLATIONS_FORMAT"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_13__i18n_tokens__["LOCALE_ID"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_14__application_module__["ApplicationModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_15__profile_profile__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_15__profile_profile__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_15__profile_profile__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_15__profile_profile__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_16__type__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_17__facade_async__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_18__error_handler__["ErrorHandler"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_52", function() { return __WEBPACK_IMPORTED_MODULE_19__core_private_export__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_53", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_54", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_55", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_56", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_57", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_58", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_59", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_60", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_61", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_62", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_63", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_64", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_65", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_66", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_67", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_68", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_69", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_70", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_71", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "_72", function() { return __WEBPACK_IMPORTED_MODULE_20__animation_metadata__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "H", function() { return __WEBPACK_IMPORTED_MODULE_21__animation_animation_transition_event__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__animation_animation_player__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__security__["Sanitizer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "K", function() { return __WEBPACK_IMPORTED_MODULE_23__security__["SecurityContext"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point from which you should import all public core APIs.
 */
























//# sourceMappingURL=core.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_animation_constants__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation_animation_group_player__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation_animation_keyframe__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_animation_player__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation_animation_sequence_player__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation_animation_styles__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__animation_animation_transition__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__change_detection_change_detection_util__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__change_detection_constants__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__console__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__debug_debug_renderer__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__debug_debug_renderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__debug_debug_renderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__di_reflective_provider__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__linker_compiler__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__linker_component_factory_resolver__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__linker_debug_context__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__linker_element__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__linker_ng_module_factory__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__linker_ng_module_factory_loader__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__linker_template_ref__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__linker_view__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__linker_view_type__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__linker_view_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__metadata_lifecycle_hooks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__metadata_view__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reflection_reflection__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__reflection_reflection_capabilities__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__reflection_reflector_reader__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__render_api__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_decorators__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__util_lang__ = __webpack_require__(198);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return __core_private__; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */































var __core_private__ = {
    isDefaultChangeDetectionStrategy: __WEBPACK_IMPORTED_MODULE_9__change_detection_constants__["c" /* isDefaultChangeDetectionStrategy */],
    ChangeDetectorStatus: __WEBPACK_IMPORTED_MODULE_9__change_detection_constants__["b" /* ChangeDetectorStatus */],
    constructDependencies: __WEBPACK_IMPORTED_MODULE_12__di_reflective_provider__["b" /* constructDependencies */],
    LifecycleHooks: __WEBPACK_IMPORTED_MODULE_23__metadata_lifecycle_hooks__["a" /* LifecycleHooks */],
    LIFECYCLE_HOOKS_VALUES: __WEBPACK_IMPORTED_MODULE_23__metadata_lifecycle_hooks__["b" /* LIFECYCLE_HOOKS_VALUES */],
    ReflectorReader: __WEBPACK_IMPORTED_MODULE_27__reflection_reflector_reader__["a" /* ReflectorReader */],
    CodegenComponentFactoryResolver: __WEBPACK_IMPORTED_MODULE_14__linker_component_factory_resolver__["CodegenComponentFactoryResolver"],
    AppElement: __WEBPACK_IMPORTED_MODULE_16__linker_element__["AppElement"],
    AppView: __WEBPACK_IMPORTED_MODULE_20__linker_view__["AppView"],
    DebugAppView: __WEBPACK_IMPORTED_MODULE_20__linker_view__["DebugAppView"],
    NgModuleInjector: __WEBPACK_IMPORTED_MODULE_17__linker_ng_module_factory__["NgModuleInjector"],
    registerModuleFactory: __WEBPACK_IMPORTED_MODULE_18__linker_ng_module_factory_loader__["registerModuleFactory"],
    ViewType: __WEBPACK_IMPORTED_MODULE_21__linker_view_type__["ViewType"],
    view_utils: __WEBPACK_IMPORTED_MODULE_22__linker_view_utils__,
    ViewMetadata: __WEBPACK_IMPORTED_MODULE_24__metadata_view__["ViewMetadata"],
    DebugContext: __WEBPACK_IMPORTED_MODULE_15__linker_debug_context__["a" /* DebugContext */],
    StaticNodeDebugInfo: __WEBPACK_IMPORTED_MODULE_15__linker_debug_context__["b" /* StaticNodeDebugInfo */],
    devModeEqual: __WEBPACK_IMPORTED_MODULE_8__change_detection_change_detection_util__["b" /* devModeEqual */],
    UNINITIALIZED: __WEBPACK_IMPORTED_MODULE_8__change_detection_change_detection_util__["a" /* UNINITIALIZED */],
    ValueUnwrapper: __WEBPACK_IMPORTED_MODULE_8__change_detection_change_detection_util__["c" /* ValueUnwrapper */],
    RenderDebugInfo: __WEBPACK_IMPORTED_MODULE_28__render_api__["RenderDebugInfo"],
    TemplateRef_: __WEBPACK_IMPORTED_MODULE_19__linker_template_ref__["TemplateRef_"],
    ReflectionCapabilities: __WEBPACK_IMPORTED_MODULE_26__reflection_reflection_capabilities__["a" /* ReflectionCapabilities */],
    makeDecorator: __WEBPACK_IMPORTED_MODULE_29__util_decorators__["c" /* makeDecorator */],
    DebugDomRootRenderer: __WEBPACK_IMPORTED_MODULE_11__debug_debug_renderer__["DebugDomRootRenderer"],
    Console: __WEBPACK_IMPORTED_MODULE_10__console__["Console"],
    reflector: __WEBPACK_IMPORTED_MODULE_25__reflection_reflection__["a" /* reflector */],
    Reflector: __WEBPACK_IMPORTED_MODULE_25__reflection_reflection__["b" /* Reflector */],
    NoOpAnimationPlayer: __WEBPACK_IMPORTED_MODULE_3__animation_animation_player__["a" /* NoOpAnimationPlayer */],
    AnimationPlayer: __WEBPACK_IMPORTED_MODULE_3__animation_animation_player__["b" /* AnimationPlayer */],
    AnimationSequencePlayer: __WEBPACK_IMPORTED_MODULE_4__animation_animation_sequence_player__["a" /* AnimationSequencePlayer */],
    AnimationGroupPlayer: __WEBPACK_IMPORTED_MODULE_1__animation_animation_group_player__["a" /* AnimationGroupPlayer */],
    AnimationKeyframe: __WEBPACK_IMPORTED_MODULE_2__animation_animation_keyframe__["a" /* AnimationKeyframe */],
    prepareFinalAnimationStyles: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["a" /* prepareFinalAnimationStyles */],
    balanceAnimationKeyframes: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["b" /* balanceAnimationKeyframes */],
    flattenStyles: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["c" /* flattenStyles */],
    clearStyles: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["d" /* clearStyles */],
    renderStyles: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["e" /* renderStyles */],
    collectAndResolveStyles: __WEBPACK_IMPORTED_MODULE_5__animation_animation_style_util__["f" /* collectAndResolveStyles */],
    AnimationStyles: __WEBPACK_IMPORTED_MODULE_6__animation_animation_styles__["a" /* AnimationStyles */],
    ANY_STATE: __WEBPACK_IMPORTED_MODULE_0__animation_animation_constants__["b" /* ANY_STATE */],
    DEFAULT_STATE: __WEBPACK_IMPORTED_MODULE_0__animation_animation_constants__["c" /* DEFAULT_STATE */],
    EMPTY_STATE: __WEBPACK_IMPORTED_MODULE_0__animation_animation_constants__["d" /* EMPTY_STATE */],
    FILL_STYLE_FLAG: __WEBPACK_IMPORTED_MODULE_0__animation_animation_constants__["a" /* FILL_STYLE_FLAG */],
    ComponentStillLoadingError: __WEBPACK_IMPORTED_MODULE_13__linker_compiler__["ComponentStillLoadingError"],
    isPromise: __WEBPACK_IMPORTED_MODULE_30__util_lang__["a" /* isPromise */],
    AnimationTransition: __WEBPACK_IMPORTED_MODULE_7__animation_animation_transition__["a" /* AnimationTransition */]
};
//# sourceMappingURL=core_private_export.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_errors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__injector__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reflective_errors__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reflective_key__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reflective_provider__ = __webpack_require__(191);
/* unused harmony export ReflectiveProtoInjectorInlineStrategy */
/* unused harmony export ReflectiveProtoInjectorDynamicStrategy */
/* unused harmony export ReflectiveProtoInjector */
/* unused harmony export ReflectiveInjectorInlineStrategy */
/* unused harmony export ReflectiveInjectorDynamicStrategy */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReflectiveInjector; });
/* unused harmony export ReflectiveInjector_ */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






// Threshold for the dynamic version
var _MAX_CONSTRUCTION_COUNTER = 10;
var UNDEFINED = new Object();
var ReflectiveProtoInjectorInlineStrategy = (function () {
    function ReflectiveProtoInjectorInlineStrategy(protoEI, providers) {
        this.provider0 = null;
        this.provider1 = null;
        this.provider2 = null;
        this.provider3 = null;
        this.provider4 = null;
        this.provider5 = null;
        this.provider6 = null;
        this.provider7 = null;
        this.provider8 = null;
        this.provider9 = null;
        this.keyId0 = null;
        this.keyId1 = null;
        this.keyId2 = null;
        this.keyId3 = null;
        this.keyId4 = null;
        this.keyId5 = null;
        this.keyId6 = null;
        this.keyId7 = null;
        this.keyId8 = null;
        this.keyId9 = null;
        var length = providers.length;
        if (length > 0) {
            this.provider0 = providers[0];
            this.keyId0 = providers[0].key.id;
        }
        if (length > 1) {
            this.provider1 = providers[1];
            this.keyId1 = providers[1].key.id;
        }
        if (length > 2) {
            this.provider2 = providers[2];
            this.keyId2 = providers[2].key.id;
        }
        if (length > 3) {
            this.provider3 = providers[3];
            this.keyId3 = providers[3].key.id;
        }
        if (length > 4) {
            this.provider4 = providers[4];
            this.keyId4 = providers[4].key.id;
        }
        if (length > 5) {
            this.provider5 = providers[5];
            this.keyId5 = providers[5].key.id;
        }
        if (length > 6) {
            this.provider6 = providers[6];
            this.keyId6 = providers[6].key.id;
        }
        if (length > 7) {
            this.provider7 = providers[7];
            this.keyId7 = providers[7].key.id;
        }
        if (length > 8) {
            this.provider8 = providers[8];
            this.keyId8 = providers[8].key.id;
        }
        if (length > 9) {
            this.provider9 = providers[9];
            this.keyId9 = providers[9].key.id;
        }
    }
    ReflectiveProtoInjectorInlineStrategy.prototype.getProviderAtIndex = function (index) {
        if (index == 0)
            return this.provider0;
        if (index == 1)
            return this.provider1;
        if (index == 2)
            return this.provider2;
        if (index == 3)
            return this.provider3;
        if (index == 4)
            return this.provider4;
        if (index == 5)
            return this.provider5;
        if (index == 6)
            return this.provider6;
        if (index == 7)
            return this.provider7;
        if (index == 8)
            return this.provider8;
        if (index == 9)
            return this.provider9;
        throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["d" /* OutOfBoundsError */](index);
    };
    ReflectiveProtoInjectorInlineStrategy.prototype.createInjectorStrategy = function (injector) {
        return new ReflectiveInjectorInlineStrategy(injector, this);
    };
    return ReflectiveProtoInjectorInlineStrategy;
}());
var ReflectiveProtoInjectorDynamicStrategy = (function () {
    function ReflectiveProtoInjectorDynamicStrategy(protoInj, providers) {
        this.providers = providers;
        var len = providers.length;
        this.keyIds = new Array(len);
        for (var i = 0; i < len; i++) {
            this.keyIds[i] = providers[i].key.id;
        }
    }
    ReflectiveProtoInjectorDynamicStrategy.prototype.getProviderAtIndex = function (index) {
        if (index < 0 || index >= this.providers.length) {
            throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["d" /* OutOfBoundsError */](index);
        }
        return this.providers[index];
    };
    ReflectiveProtoInjectorDynamicStrategy.prototype.createInjectorStrategy = function (ei) {
        return new ReflectiveInjectorDynamicStrategy(this, ei);
    };
    return ReflectiveProtoInjectorDynamicStrategy;
}());
var ReflectiveProtoInjector = (function () {
    function ReflectiveProtoInjector(providers) {
        this.numberOfProviders = providers.length;
        this._strategy = providers.length > _MAX_CONSTRUCTION_COUNTER ?
            new ReflectiveProtoInjectorDynamicStrategy(this, providers) :
            new ReflectiveProtoInjectorInlineStrategy(this, providers);
    }
    ReflectiveProtoInjector.fromResolvedProviders = function (providers) {
        return new ReflectiveProtoInjector(providers);
    };
    ReflectiveProtoInjector.prototype.getProviderAtIndex = function (index) {
        return this._strategy.getProviderAtIndex(index);
    };
    return ReflectiveProtoInjector;
}());
var ReflectiveInjectorInlineStrategy = (function () {
    function ReflectiveInjectorInlineStrategy(injector, protoStrategy) {
        this.injector = injector;
        this.protoStrategy = protoStrategy;
        this.obj0 = UNDEFINED;
        this.obj1 = UNDEFINED;
        this.obj2 = UNDEFINED;
        this.obj3 = UNDEFINED;
        this.obj4 = UNDEFINED;
        this.obj5 = UNDEFINED;
        this.obj6 = UNDEFINED;
        this.obj7 = UNDEFINED;
        this.obj8 = UNDEFINED;
        this.obj9 = UNDEFINED;
    }
    ReflectiveInjectorInlineStrategy.prototype.resetConstructionCounter = function () { this.injector._constructionCounter = 0; };
    ReflectiveInjectorInlineStrategy.prototype.instantiateProvider = function (provider) {
        return this.injector._new(provider);
    };
    ReflectiveInjectorInlineStrategy.prototype.getObjByKeyId = function (keyId) {
        var p = this.protoStrategy;
        var inj = this.injector;
        if (p.keyId0 === keyId) {
            if (this.obj0 === UNDEFINED) {
                this.obj0 = inj._new(p.provider0);
            }
            return this.obj0;
        }
        if (p.keyId1 === keyId) {
            if (this.obj1 === UNDEFINED) {
                this.obj1 = inj._new(p.provider1);
            }
            return this.obj1;
        }
        if (p.keyId2 === keyId) {
            if (this.obj2 === UNDEFINED) {
                this.obj2 = inj._new(p.provider2);
            }
            return this.obj2;
        }
        if (p.keyId3 === keyId) {
            if (this.obj3 === UNDEFINED) {
                this.obj3 = inj._new(p.provider3);
            }
            return this.obj3;
        }
        if (p.keyId4 === keyId) {
            if (this.obj4 === UNDEFINED) {
                this.obj4 = inj._new(p.provider4);
            }
            return this.obj4;
        }
        if (p.keyId5 === keyId) {
            if (this.obj5 === UNDEFINED) {
                this.obj5 = inj._new(p.provider5);
            }
            return this.obj5;
        }
        if (p.keyId6 === keyId) {
            if (this.obj6 === UNDEFINED) {
                this.obj6 = inj._new(p.provider6);
            }
            return this.obj6;
        }
        if (p.keyId7 === keyId) {
            if (this.obj7 === UNDEFINED) {
                this.obj7 = inj._new(p.provider7);
            }
            return this.obj7;
        }
        if (p.keyId8 === keyId) {
            if (this.obj8 === UNDEFINED) {
                this.obj8 = inj._new(p.provider8);
            }
            return this.obj8;
        }
        if (p.keyId9 === keyId) {
            if (this.obj9 === UNDEFINED) {
                this.obj9 = inj._new(p.provider9);
            }
            return this.obj9;
        }
        return UNDEFINED;
    };
    ReflectiveInjectorInlineStrategy.prototype.getObjAtIndex = function (index) {
        if (index == 0)
            return this.obj0;
        if (index == 1)
            return this.obj1;
        if (index == 2)
            return this.obj2;
        if (index == 3)
            return this.obj3;
        if (index == 4)
            return this.obj4;
        if (index == 5)
            return this.obj5;
        if (index == 6)
            return this.obj6;
        if (index == 7)
            return this.obj7;
        if (index == 8)
            return this.obj8;
        if (index == 9)
            return this.obj9;
        throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["d" /* OutOfBoundsError */](index);
    };
    ReflectiveInjectorInlineStrategy.prototype.getMaxNumberOfObjects = function () { return _MAX_CONSTRUCTION_COUNTER; };
    return ReflectiveInjectorInlineStrategy;
}());
var ReflectiveInjectorDynamicStrategy = (function () {
    function ReflectiveInjectorDynamicStrategy(protoStrategy, injector) {
        this.protoStrategy = protoStrategy;
        this.injector = injector;
        this.objs = new Array(protoStrategy.providers.length).fill(UNDEFINED);
    }
    ReflectiveInjectorDynamicStrategy.prototype.resetConstructionCounter = function () { this.injector._constructionCounter = 0; };
    ReflectiveInjectorDynamicStrategy.prototype.instantiateProvider = function (provider) {
        return this.injector._new(provider);
    };
    ReflectiveInjectorDynamicStrategy.prototype.getObjByKeyId = function (keyId) {
        var p = this.protoStrategy;
        for (var i = 0; i < p.keyIds.length; i++) {
            if (p.keyIds[i] === keyId) {
                if (this.objs[i] === UNDEFINED) {
                    this.objs[i] = this.injector._new(p.providers[i]);
                }
                return this.objs[i];
            }
        }
        return UNDEFINED;
    };
    ReflectiveInjectorDynamicStrategy.prototype.getObjAtIndex = function (index) {
        if (index < 0 || index >= this.objs.length) {
            throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["d" /* OutOfBoundsError */](index);
        }
        return this.objs[index];
    };
    ReflectiveInjectorDynamicStrategy.prototype.getMaxNumberOfObjects = function () { return this.objs.length; };
    return ReflectiveInjectorDynamicStrategy;
}());
/**
 * A ReflectiveDependency injection container used for instantiating objects and resolving
 * dependencies.
 *
 * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
 * constructor dependencies.
 *
 * In typical use, application code asks for the dependencies in the constructor and they are
 * resolved by the `Injector`.
 *
 * ### Example ([live demo](http://plnkr.co/edit/jzjec0?p=preview))
 *
 * The following example creates an `Injector` configured to create `Engine` and `Car`.
 *
 * ```typescript
 * @Injectable()
 * class Engine {
 * }
 *
 * @Injectable()
 * class Car {
 *   constructor(public engine:Engine) {}
 * }
 *
 * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
 * var car = injector.get(Car);
 * expect(car instanceof Car).toBe(true);
 * expect(car.engine instanceof Engine).toBe(true);
 * ```
 *
 * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
 * resolve all of the object's dependencies automatically.
 *
 * @stable
 */
var ReflectiveInjector = (function () {
    function ReflectiveInjector() {
    }
    /**
     * Turns an array of provider definitions into an array of resolved providers.
     *
     * A resolution is a process of flattening multiple nested arrays and converting individual
     * providers into an array of {@link ResolvedReflectiveProvider}s.
     *
     * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
     *
     * expect(providers.length).toEqual(2);
     *
     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
     * expect(providers[0].key.displayName).toBe("Car");
     * expect(providers[0].dependencies.length).toEqual(1);
     * expect(providers[0].factory).toBeDefined();
     *
     * expect(providers[1].key.displayName).toBe("Engine");
     * });
     * ```
     *
     * See {@link ReflectiveInjector#fromResolvedProviders} for more info.
     */
    ReflectiveInjector.resolve = function (providers) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__reflective_provider__["a" /* resolveReflectiveProviders */])(providers);
    };
    /**
     * Resolves an array of providers and creates an injector from those providers.
     *
     * The passed-in providers can be an array of `Type`, {@link Provider},
     * or a recursive array of more providers.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     *
     * This function is slower than the corresponding `fromResolvedProviders`
     * because it needs to resolve the passed-in providers first.
     * See {@link Injector#resolve} and {@link Injector#fromResolvedProviders}.
     */
    ReflectiveInjector.resolveAndCreate = function (providers, parent) {
        if (parent === void 0) { parent = null; }
        var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return ReflectiveInjector.fromResolvedProviders(ResolvedReflectiveProviders, parent);
    };
    /**
     * Creates an injector from previously resolved providers.
     *
     * This API is the recommended way to construct injectors in performance-sensitive parts.
     *
     * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, Engine]);
     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     * @experimental
     */
    ReflectiveInjector.fromResolvedProviders = function (providers, parent) {
        if (parent === void 0) { parent = null; }
        return new ReflectiveInjector_(ReflectiveProtoInjector.fromResolvedProviders(providers), parent);
    };
    Object.defineProperty(ReflectiveInjector.prototype, "parent", {
        /**
         * Parent of this injector.
         *
         * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
         * -->
         *
         * ### Example ([live demo](http://plnkr.co/edit/eosMGo?p=preview))
         *
         * ```typescript
         * var parent = ReflectiveInjector.resolveAndCreate([]);
         * var child = parent.resolveAndCreateChild([]);
         * expect(child.parent).toBe(parent);
         * ```
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); },
        enumerable: true,
        configurable: true
    });
    /**
     * Resolves an array of providers and creates a child injector from those providers.
     *
     * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
     * -->
     *
     * The passed-in providers can be an array of `Type`, {@link Provider},
     * or a recursive array of more providers.
     *
     * ### Example ([live demo](http://plnkr.co/edit/opB3T4?p=preview))
     *
     * ```typescript
     * class ParentProvider {}
     * class ChildProvider {}
     *
     * var parent = ReflectiveInjector.resolveAndCreate([ParentProvider]);
     * var child = parent.resolveAndCreateChild([ChildProvider]);
     *
     * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
     * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
     * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
     * ```
     *
     * This function is slower than the corresponding `createChildFromResolved`
     * because it needs to resolve the passed-in providers first.
     * See {@link Injector#resolve} and {@link Injector#createChildFromResolved}.
     */
    ReflectiveInjector.prototype.resolveAndCreateChild = function (providers) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); };
    /**
     * Creates a child injector from previously resolved providers.
     *
     * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
     * -->
     *
     * This API is the recommended way to construct injectors in performance-sensitive parts.
     *
     * ### Example ([live demo](http://plnkr.co/edit/VhyfjN?p=preview))
     *
     * ```typescript
     * class ParentProvider {}
     * class ChildProvider {}
     *
     * var parentProviders = ReflectiveInjector.resolve([ParentProvider]);
     * var childProviders = ReflectiveInjector.resolve([ChildProvider]);
     *
     * var parent = ReflectiveInjector.fromResolvedProviders(parentProviders);
     * var child = parent.createChildFromResolved(childProviders);
     *
     * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
     * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
     * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
     * ```
     */
    ReflectiveInjector.prototype.createChildFromResolved = function (providers) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])();
    };
    /**
     * Resolves a provider and instantiates an object in the context of the injector.
     *
     * The created object does not get cached by the injector.
     *
     * ### Example ([live demo](http://plnkr.co/edit/yvVXoB?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Engine]);
     *
     * var car = injector.resolveAndInstantiate(Car);
     * expect(car.engine).toBe(injector.get(Engine));
     * expect(car).not.toBe(injector.resolveAndInstantiate(Car));
     * ```
     */
    ReflectiveInjector.prototype.resolveAndInstantiate = function (provider) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); };
    /**
     * Instantiates an object using a resolved provider in the context of the injector.
     *
     * The created object does not get cached by the injector.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ptCImQ?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Engine]);
     * var carProvider = ReflectiveInjector.resolve([Car])[0];
     * var car = injector.instantiateResolved(carProvider);
     * expect(car.engine).toBe(injector.get(Engine));
     * expect(car).not.toBe(injector.instantiateResolved(carProvider));
     * ```
     */
    ReflectiveInjector.prototype.instantiateResolved = function (provider) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_errors__["a" /* unimplemented */])(); };
    return ReflectiveInjector;
}());
var ReflectiveInjector_ = (function () {
    /**
     * Private
     */
    function ReflectiveInjector_(_proto /* ProtoInjector */, _parent) {
        if (_parent === void 0) { _parent = null; }
        /** @internal */
        this._constructionCounter = 0;
        this._proto = _proto;
        this._parent = _parent;
        this._strategy = _proto._strategy.createInjectorStrategy(this);
    }
    ReflectiveInjector_.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = __WEBPACK_IMPORTED_MODULE_1__injector__["a" /* THROW_IF_NOT_FOUND */]; }
        return this._getByKey(__WEBPACK_IMPORTED_MODULE_4__reflective_key__["a" /* ReflectiveKey */].get(token), null, null, notFoundValue);
    };
    ReflectiveInjector_.prototype.getAt = function (index) { return this._strategy.getObjAtIndex(index); };
    Object.defineProperty(ReflectiveInjector_.prototype, "parent", {
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReflectiveInjector_.prototype, "internalStrategy", {
        /**
         * @internal
         * Internal. Do not use.
         * We return `any` not to export the InjectorStrategy type.
         */
        get: function () { return this._strategy; },
        enumerable: true,
        configurable: true
    });
    ReflectiveInjector_.prototype.resolveAndCreateChild = function (providers) {
        var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return this.createChildFromResolved(ResolvedReflectiveProviders);
    };
    ReflectiveInjector_.prototype.createChildFromResolved = function (providers) {
        var proto = new ReflectiveProtoInjector(providers);
        var inj = new ReflectiveInjector_(proto);
        inj._parent = this;
        return inj;
    };
    ReflectiveInjector_.prototype.resolveAndInstantiate = function (provider) {
        return this.instantiateResolved(ReflectiveInjector.resolve([provider])[0]);
    };
    ReflectiveInjector_.prototype.instantiateResolved = function (provider) {
        return this._instantiateProvider(provider);
    };
    /** @internal */
    ReflectiveInjector_.prototype._new = function (provider) {
        if (this._constructionCounter++ > this._strategy.getMaxNumberOfObjects()) {
            throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["e" /* CyclicDependencyError */](this, provider.key);
        }
        return this._instantiateProvider(provider);
    };
    ReflectiveInjector_.prototype._instantiateProvider = function (provider) {
        if (provider.multiProvider) {
            var res = new Array(provider.resolvedFactories.length);
            for (var i = 0; i < provider.resolvedFactories.length; ++i) {
                res[i] = this._instantiate(provider, provider.resolvedFactories[i]);
            }
            return res;
        }
        else {
            return this._instantiate(provider, provider.resolvedFactories[0]);
        }
    };
    ReflectiveInjector_.prototype._instantiate = function (provider, ResolvedReflectiveFactory) {
        var factory = ResolvedReflectiveFactory.factory;
        var deps = ResolvedReflectiveFactory.dependencies;
        var length = deps.length;
        var d0;
        var d1;
        var d2;
        var d3;
        var d4;
        var d5;
        var d6;
        var d7;
        var d8;
        var d9;
        var d10;
        var d11;
        var d12;
        var d13;
        var d14;
        var d15;
        var d16;
        var d17;
        var d18;
        var d19;
        try {
            d0 = length > 0 ? this._getByReflectiveDependency(provider, deps[0]) : null;
            d1 = length > 1 ? this._getByReflectiveDependency(provider, deps[1]) : null;
            d2 = length > 2 ? this._getByReflectiveDependency(provider, deps[2]) : null;
            d3 = length > 3 ? this._getByReflectiveDependency(provider, deps[3]) : null;
            d4 = length > 4 ? this._getByReflectiveDependency(provider, deps[4]) : null;
            d5 = length > 5 ? this._getByReflectiveDependency(provider, deps[5]) : null;
            d6 = length > 6 ? this._getByReflectiveDependency(provider, deps[6]) : null;
            d7 = length > 7 ? this._getByReflectiveDependency(provider, deps[7]) : null;
            d8 = length > 8 ? this._getByReflectiveDependency(provider, deps[8]) : null;
            d9 = length > 9 ? this._getByReflectiveDependency(provider, deps[9]) : null;
            d10 = length > 10 ? this._getByReflectiveDependency(provider, deps[10]) : null;
            d11 = length > 11 ? this._getByReflectiveDependency(provider, deps[11]) : null;
            d12 = length > 12 ? this._getByReflectiveDependency(provider, deps[12]) : null;
            d13 = length > 13 ? this._getByReflectiveDependency(provider, deps[13]) : null;
            d14 = length > 14 ? this._getByReflectiveDependency(provider, deps[14]) : null;
            d15 = length > 15 ? this._getByReflectiveDependency(provider, deps[15]) : null;
            d16 = length > 16 ? this._getByReflectiveDependency(provider, deps[16]) : null;
            d17 = length > 17 ? this._getByReflectiveDependency(provider, deps[17]) : null;
            d18 = length > 18 ? this._getByReflectiveDependency(provider, deps[18]) : null;
            d19 = length > 19 ? this._getByReflectiveDependency(provider, deps[19]) : null;
        }
        catch (e) {
            if (e instanceof __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["f" /* AbstractProviderError */] || e instanceof __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["g" /* InstantiationError */]) {
                e.addKey(this, provider.key);
            }
            throw e;
        }
        var obj;
        try {
            switch (length) {
                case 0:
                    obj = factory();
                    break;
                case 1:
                    obj = factory(d0);
                    break;
                case 2:
                    obj = factory(d0, d1);
                    break;
                case 3:
                    obj = factory(d0, d1, d2);
                    break;
                case 4:
                    obj = factory(d0, d1, d2, d3);
                    break;
                case 5:
                    obj = factory(d0, d1, d2, d3, d4);
                    break;
                case 6:
                    obj = factory(d0, d1, d2, d3, d4, d5);
                    break;
                case 7:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6);
                    break;
                case 8:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7);
                    break;
                case 9:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8);
                    break;
                case 10:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9);
                    break;
                case 11:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10);
                    break;
                case 12:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11);
                    break;
                case 13:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12);
                    break;
                case 14:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13);
                    break;
                case 15:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14);
                    break;
                case 16:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15);
                    break;
                case 17:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16);
                    break;
                case 18:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17);
                    break;
                case 19:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17, d18);
                    break;
                case 20:
                    obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17, d18, d19);
                    break;
                default:
                    throw new Error("Cannot instantiate '" + provider.key.displayName + "' because it has more than 20 dependencies");
            }
        }
        catch (e) {
            throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["g" /* InstantiationError */](this, e, e.stack, provider.key);
        }
        return obj;
    };
    ReflectiveInjector_.prototype._getByReflectiveDependency = function (provider, dep) {
        return this._getByKey(dep.key, dep.lowerBoundVisibility, dep.upperBoundVisibility, dep.optional ? null : __WEBPACK_IMPORTED_MODULE_1__injector__["a" /* THROW_IF_NOT_FOUND */]);
    };
    ReflectiveInjector_.prototype._getByKey = function (key, lowerBoundVisibility, upperBoundVisibility, notFoundValue) {
        if (key === INJECTOR_KEY) {
            return this;
        }
        if (upperBoundVisibility instanceof __WEBPACK_IMPORTED_MODULE_2__metadata__["d" /* Self */]) {
            return this._getByKeySelf(key, notFoundValue);
        }
        else {
            return this._getByKeyDefault(key, notFoundValue, lowerBoundVisibility);
        }
    };
    /** @internal */
    ReflectiveInjector_.prototype._throwOrNull = function (key, notFoundValue) {
        if (notFoundValue !== __WEBPACK_IMPORTED_MODULE_1__injector__["a" /* THROW_IF_NOT_FOUND */]) {
            return notFoundValue;
        }
        else {
            throw new __WEBPACK_IMPORTED_MODULE_3__reflective_errors__["h" /* NoProviderError */](this, key);
        }
    };
    /** @internal */
    ReflectiveInjector_.prototype._getByKeySelf = function (key, notFoundValue) {
        var obj = this._strategy.getObjByKeyId(key.id);
        return (obj !== UNDEFINED) ? obj : this._throwOrNull(key, notFoundValue);
    };
    /** @internal */
    ReflectiveInjector_.prototype._getByKeyDefault = function (key, notFoundValue, lowerBoundVisibility) {
        var inj;
        if (lowerBoundVisibility instanceof __WEBPACK_IMPORTED_MODULE_2__metadata__["f" /* SkipSelf */]) {
            inj = this._parent;
        }
        else {
            inj = this;
        }
        while (inj instanceof ReflectiveInjector_) {
            var inj_ = inj;
            var obj = inj_._strategy.getObjByKeyId(key.id);
            if (obj !== UNDEFINED)
                return obj;
            inj = inj_._parent;
        }
        if (inj !== null) {
            return inj.get(key.token, notFoundValue);
        }
        else {
            return this._throwOrNull(key, notFoundValue);
        }
    };
    Object.defineProperty(ReflectiveInjector_.prototype, "displayName", {
        get: function () {
            var providers = _mapProviders(this, function (b) { return ' "' + b.key.displayName + '" '; })
                .join(', ');
            return "ReflectiveInjector(providers: [" + providers + "])";
        },
        enumerable: true,
        configurable: true
    });
    ReflectiveInjector_.prototype.toString = function () { return this.displayName; };
    return ReflectiveInjector_;
}());
var INJECTOR_KEY = __WEBPACK_IMPORTED_MODULE_4__reflective_key__["a" /* ReflectiveKey */].get(__WEBPACK_IMPORTED_MODULE_1__injector__["b" /* Injector */]);
function _mapProviders(injector, fn) {
    var res = new Array(injector._proto.numberOfProviders);
    for (var i = 0; i < injector._proto.numberOfProviders; ++i) {
        res[i] = fn(injector._proto.getProviderAtIndex(i));
    }
    return res;
}
//# sourceMappingURL=reflective_injector.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linker_compiler__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linker_component_factory__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linker_component_factory_resolver__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linker_element_ref__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__linker_ng_module_factory__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__linker_ng_module_factory_loader__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__linker_query_list__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__linker_system_js_ng_module_factory_loader__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__linker_template_ref__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__linker_view_container_ref__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__linker_view_ref__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__linker_compiler__["COMPILER_OPTIONS"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__linker_compiler__["CompilerFactory"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__linker_compiler__["ModuleWithComponentFactories"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__linker_compiler__["Compiler"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__linker_component_factory__["ComponentFactory"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__linker_component_factory__["ComponentRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__linker_component_factory_resolver__["ComponentFactoryResolver"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__linker_element_ref__["ElementRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__linker_ng_module_factory__["NgModuleFactory"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__linker_ng_module_factory__["NgModuleRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__linker_ng_module_factory_loader__["NgModuleFactoryLoader"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__linker_ng_module_factory_loader__["getModuleFactory"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__linker_query_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__linker_system_js_ng_module_factory_loader__["SystemJsNgModuleLoader"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__linker_system_js_ng_module_factory_loader__["SystemJsNgModuleLoaderConfig"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__linker_template_ref__["TemplateRef"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__linker_view_container_ref__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_10__linker_view_ref__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_10__linker_view_ref__["c"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for compiler











//# sourceMappingURL=linker.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_animation_group_player__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation_animation_queue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation_view_animation_map__ = __webpack_require__(366);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AnimationViewContext; });



var AnimationViewContext = (function () {
    function AnimationViewContext() {
        this._players = new __WEBPACK_IMPORTED_MODULE_2__animation_view_animation_map__["a" /* ViewAnimationMap */]();
    }
    AnimationViewContext.prototype.onAllActiveAnimationsDone = function (callback) {
        var activeAnimationPlayers = this._players.getAllPlayers();
        // we check for the length to avoid having GroupAnimationPlayer
        // issue an unnecessary microtask when zero players are passed in
        if (activeAnimationPlayers.length) {
            new __WEBPACK_IMPORTED_MODULE_0__animation_animation_group_player__["a" /* AnimationGroupPlayer */](activeAnimationPlayers).onDone(function () { return callback(); });
        }
        else {
            callback();
        }
    };
    AnimationViewContext.prototype.queueAnimation = function (element, animationName, player) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__animation_animation_queue__["b" /* queueAnimation */])(player);
        this._players.set(element, animationName, player);
    };
    AnimationViewContext.prototype.cancelActiveAnimation = function (element, animationName, removeAllAnimations) {
        if (removeAllAnimations === void 0) { removeAllAnimations = false; }
        if (removeAllAnimations) {
            this._players.findAllPlayersByElement(element).forEach(function (player) { return player.destroy(); });
        }
        else {
            var player = this._players.find(element, animationName);
            if (player) {
                player.destroy();
            }
        }
    };
    return AnimationViewContext;
}());
//# sourceMappingURL=animation_view_context.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di_injector__ = __webpack_require__(133);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ElementInjector; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var _UNDEFINED = new Object();
var ElementInjector = (function (_super) {
    __extends(ElementInjector, _super);
    function ElementInjector(_view, _nodeIndex) {
        _super.call(this);
        this._view = _view;
        this._nodeIndex = _nodeIndex;
    }
    ElementInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = __WEBPACK_IMPORTED_MODULE_0__di_injector__["a" /* THROW_IF_NOT_FOUND */]; }
        var result = _UNDEFINED;
        if (result === _UNDEFINED) {
            result = this._view.injectorGet(token, this._nodeIndex, _UNDEFINED);
        }
        if (result === _UNDEFINED) {
            result = this._view.parentInjector.get(token, notFoundValue);
        }
        return result;
    };
    return ElementInjector;
}(__WEBPACK_IMPORTED_MODULE_0__di_injector__["b" /* Injector */]));
//# sourceMappingURL=element_injector.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_async__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_collection__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return QueryList; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * An unmodifiable list of items that Angular keeps up to date when the state
 * of the application changes.
 *
 * The type of object that {@link Query} and {@link ViewQueryMetadata} provide.
 *
 * Implements an iterable interface, therefore it can be used in both ES6
 * javascript `for (var i of items)` loops as well as in Angular templates with
 * `*ngFor="let i of myList"`.
 *
 * Changes can be observed by subscribing to the changes `Observable`.
 *
 * NOTE: In the future this class will implement an `Observable` interface.
 *
 * ### Example ([live demo](http://plnkr.co/edit/RX8sJnQYl9FWuSCWme5z?p=preview))
 * ```typescript
 * @Component({...})
 * class Container {
 *   @ViewChildren(Item) items:QueryList<Item>;
 * }
 * ```
 * @stable
 */
var QueryList = (function () {
    function QueryList() {
        this._dirty = true;
        this._results = [];
        this._emitter = new __WEBPACK_IMPORTED_MODULE_0__facade_async__["a" /* EventEmitter */]();
    }
    Object.defineProperty(QueryList.prototype, "changes", {
        get: function () { return this._emitter; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "length", {
        get: function () { return this._results.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "first", {
        get: function () { return this._results[0]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "last", {
        get: function () { return this._results[this.length - 1]; },
        enumerable: true,
        configurable: true
    });
    /**
     * See
     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
     */
    QueryList.prototype.map = function (fn) { return this._results.map(fn); };
    /**
     * See
     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
     */
    QueryList.prototype.filter = function (fn) {
        return this._results.filter(fn);
    };
    /**
     * See
     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
     */
    QueryList.prototype.reduce = function (fn, init) {
        return this._results.reduce(fn, init);
    };
    /**
     * See
     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
     */
    QueryList.prototype.forEach = function (fn) { this._results.forEach(fn); };
    /**
     * See
     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
     */
    QueryList.prototype.some = function (fn) {
        return this._results.some(fn);
    };
    QueryList.prototype.toArray = function () { return this._results.slice(); };
    QueryList.prototype[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["f" /* getSymbolIterator */])()] = function () { return this._results[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__facade_lang__["f" /* getSymbolIterator */])()](); };
    QueryList.prototype.toString = function () { return this._results.toString(); };
    QueryList.prototype.reset = function (res) {
        this._results = __WEBPACK_IMPORTED_MODULE_1__facade_collection__["e" /* ListWrapper */].flatten(res);
        this._dirty = false;
    };
    QueryList.prototype.notifyOnChanges = function () { this._emitter.emit(this); };
    /** internal */
    QueryList.prototype.setDirty = function () { this._dirty = true; };
    Object.defineProperty(QueryList.prototype, "dirty", {
        /** internal */
        get: function () { return this._dirty; },
        enumerable: true,
        configurable: true
    });
    return QueryList;
}());
//# sourceMappingURL=query_list.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_decorators__ = __webpack_require__(90);
/* harmony export (binding) */ __webpack_require__.d(exports, "g", function() { return ANALYZE_FOR_ENTRY_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Attribute; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return Query; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return ContentChildren; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ContentChild; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return ViewChildren; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return ViewChild; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * This token can be used to create a virtual provider that will populate the
 * `entryComponents` fields of components and ng modules based on its `useValue`.
 * All components that are referenced in the `useValue` value (either directly
 * or in a nested array or map) will be added to the `entryComponents` property.
 *
 * ### Example
 * The following example shows how the router can populate the `entryComponents`
 * field of an NgModule based on the router configuration which refers
 * to components.
 *
 * ```typescript
 * // helper function inside the router
 * function provideRoutes(routes) {
 *   return [
 *     {provide: ROUTES, useValue: routes},
 *     {provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: routes, multi: true}
 *   ];
 * }
 *
 * // user code
 * let routes = [
 *   {path: '/root', component: RootComp},
 *   {path: '/teams', component: TeamsComp}
 * ];
 *
 * @NgModule({
 *   providers: [provideRoutes(routes)]
 * })
 * class ModuleWithRoutes {}
 * ```
 *
 * @experimental
 */
var ANALYZE_FOR_ENTRY_COMPONENTS = new __WEBPACK_IMPORTED_MODULE_0__di_opaque_token__["a" /* OpaqueToken */]('AnalyzeForEntryComponents');
/**
 * Attribute decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Attribute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["a" /* makeParamDecorator */])('Attribute', [['attributeName', undefined]]);
/**
 * Base class for query metadata.
 *
 * See {@link ContentChildren}, {@link ContentChild}, {@link ViewChildren}, {@link ViewChild} for
 * more information.
 *
 * @stable
 */
var Query = (function () {
    function Query() {
    }
    return Query;
}());
/**
 * ContentChildren decorator and metadata.
 *
 *  @stable
 *  @Annotation
 */
var ContentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('ContentChildren', [
    ['selector', undefined], {
        first: false,
        isViewQuery: false,
        descendants: false,
        read: undefined,
    }
], Query);
/**
 * @whatItDoes Configures a content query.
 *
 * @howToUse
 *
 * {@example core/di/ts/contentChild/content_child_howto.ts region='HowTo'}
 *
 * @description
 *
 * You can use ContentChild to get the first element or the directive matching the selector from the
 * content DOM. If the content DOM changes, and a new child matches the selector,
 * the property will be updated.
 *
 * Content queries are set before the `ngAfterContentInit` callback is called.
 *
 * **Metadata Properties**:
 *
 * * **selector** - the directive type or the name used for querying.
 * * **read** - read a different token from the queried element.
 *
 * Let's look at an example:
 *
 * {@example core/di/ts/contentChild/content_child_example.ts region='Component'}
 *
 * **npm package**: `@angular/core`
 *
 * @stable
 * @Annotation
 */
var ContentChild = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('ContentChild', [
    ['selector', undefined], {
        first: true,
        isViewQuery: false,
        descendants: true,
        read: undefined,
    }
], Query);
/**
 * @whatItDoes Configures a view query.
 *
 * @howToUse
 *
 * {@example core/di/ts/viewChildren/view_children_howto.ts region='HowTo'}
 *
 * @description
 *
 * You can use ViewChildren to get the {@link QueryList} of elements or directives from the
 * view DOM. Any time a child element is added, removed, or moved, the query list will be updated,
 * and the changes observable of the query list will emit a new value.
 *
 * View queries are set before the `ngAfterViewInit` callback is called.
 *
 * **Metadata Properties**:
 *
 * * **selector** - the directive type or the name used for querying.
 * * **read** - read a different token from the queried elements.
 *
 * Let's look at an example:
 *
 * {@example core/di/ts/viewChildren/view_children_example.ts region='Component'}
 *
 * **npm package**: `@angular/core`
 *
 * @stable
 * @Annotation
 */
var ViewChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('ViewChildren', [
    ['selector', undefined], {
        first: false,
        isViewQuery: true,
        descendants: true,
        read: undefined,
    }
], Query);
/**
 * ViewChild decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var ViewChild = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('ViewChild', [
    ['selector', undefined], {
        first: true,
        isViewQuery: true,
        descendants: true,
        read: undefined,
    }
], Query);
//# sourceMappingURL=di.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__change_detection_constants__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_decorators__ = __webpack_require__(90);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return Directive; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(exports, "g", function() { return Pipe; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(exports, "f", function() { return Output; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return HostBinding; });
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return HostListener; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * Directive decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Directive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["c" /* makeDecorator */])('Directive', {
    selector: undefined,
    inputs: undefined,
    outputs: undefined,
    host: undefined,
    providers: undefined,
    exportAs: undefined,
    queries: undefined
});
/**
 * Component decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["c" /* makeDecorator */])('Component', {
    selector: undefined,
    inputs: undefined,
    outputs: undefined,
    host: undefined,
    exportAs: undefined,
    moduleId: undefined,
    providers: undefined,
    viewProviders: undefined,
    changeDetection: __WEBPACK_IMPORTED_MODULE_0__change_detection_constants__["a" /* ChangeDetectionStrategy */].Default,
    queries: undefined,
    templateUrl: undefined,
    template: undefined,
    styleUrls: undefined,
    styles: undefined,
    animations: undefined,
    encapsulation: undefined,
    interpolation: undefined,
    entryComponents: undefined
}, Directive);
/**
 * Pipe decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Pipe = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["c" /* makeDecorator */])('Pipe', {
    name: undefined,
    pure: true,
});
/**
 * Input decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('Input', [['bindingPropertyName', undefined]]);
/**
 * Output decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var Output = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('Output', [['bindingPropertyName', undefined]]);
/**
 * HostBinding decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var HostBinding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('HostBinding', [['hostPropertyName', undefined]]);
/**
 * HostBinding decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var HostListener = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorators__["b" /* makePropDecorator */])('HostListener', [['eventName', undefined], ['args', []]]);
//# sourceMappingURL=directives.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_decorators__ = __webpack_require__(90);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return CUSTOM_ELEMENTS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NO_ERRORS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Defines a schema that will allow:
 * - any non-Angular elements with a `-` in their name,
 * - any properties on elements with a `-` in their name which is the common rule for custom
 * elements.
 *
 * @stable
 */
var CUSTOM_ELEMENTS_SCHEMA = {
    name: 'custom-elements'
};
/**
 * Defines a schema that will allow any property on any element.
 *
 * @experimental
 */
var NO_ERRORS_SCHEMA = {
    name: 'no-errors-schema'
};
/**
 * NgModule decorator and metadata.
 *
 * @stable
 * @Annotation
 */
var NgModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decorators__["c" /* makeDecorator */])('NgModule', {
    providers: undefined,
    declarations: undefined,
    imports: undefined,
    exports: undefined,
    entryComponents: undefined,
    bootstrap: undefined,
    schemas: undefined,
    id: undefined,
});
//# sourceMappingURL=ng_module.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_ref__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__console__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reflection_reflector_reader__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__testability_testability__ = __webpack_require__(137);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return platformCore; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





function _reflector() {
    return __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__["a" /* reflector */];
}
var _CORE_PLATFORM_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_0__application_ref__["PlatformRef_"],
    { provide: __WEBPACK_IMPORTED_MODULE_0__application_ref__["PlatformRef"], useExisting: __WEBPACK_IMPORTED_MODULE_0__application_ref__["PlatformRef_"] },
    { provide: __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__["b" /* Reflector */], useFactory: _reflector, deps: [] },
    { provide: __WEBPACK_IMPORTED_MODULE_3__reflection_reflector_reader__["a" /* ReflectorReader */], useExisting: __WEBPACK_IMPORTED_MODULE_2__reflection_reflection__["b" /* Reflector */] },
    __WEBPACK_IMPORTED_MODULE_4__testability_testability__["TestabilityRegistry"],
    __WEBPACK_IMPORTED_MODULE_1__console__["Console"],
];
/**
 * This platform has to be included in any other platform
 *
 * @experimental
 */
var platformCore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__application_ref__["createPlatformFactory"])(null, 'core', _CORE_PLATFORM_PROVIDERS);
//# sourceMappingURL=platform_core_providers.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony export (immutable) */ exports["a"] = detectWTF;
/* harmony export (immutable) */ exports["b"] = createScope;
/* harmony export (immutable) */ exports["c"] = leave;
/* harmony export (immutable) */ exports["d"] = startTimeRange;
/* harmony export (immutable) */ exports["e"] = endTimeRange;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var trace;
var events;
function detectWTF() {
    var wtf = __WEBPACK_IMPORTED_MODULE_0__facade_lang__["a" /* global */]['wtf'];
    if (wtf) {
        trace = wtf['trace'];
        if (trace) {
            events = trace['events'];
            return true;
        }
    }
    return false;
}
function createScope(signature, flags) {
    if (flags === void 0) { flags = null; }
    return events.createScope(signature, flags);
}
function leave(scope, returnValue) {
    trace.leaveScope(scope, returnValue);
    return returnValue;
}
function startTimeRange(rangeType, action) {
    return trace.beginTimeRange(rangeType, action);
}
function endTimeRange(range) {
    trace.endTimeRange(range);
}
//# sourceMappingURL=wtf_impl.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__render_api__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__render_api__["RenderComponentType"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__render_api__["Renderer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__render_api__["RootRenderer"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for render

//# sourceMappingURL=render.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_decorators__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__util_decorators__["d"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for util

//# sourceMappingURL=util.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zone_ng_zone__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__zone_ng_zone__["NgZone"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for Zone

//# sourceMappingURL=zone.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = normalizeValidator;
/* harmony export (immutable) */ exports["b"] = normalizeAsyncValidator;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function normalizeValidator(validator) {
    if (validator.validate !== undefined) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
function normalizeAsyncValidator(validator) {
    if (validator.validate !== undefined) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
//# sourceMappingURL=normalize_validator.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_control_container__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_validators__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_builder__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__model__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__form_providers__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__["CheckboxControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_control_container__["ControlContainer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__["NG_VALUE_ACCESSOR"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__["DefaultValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__["NgControl"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["NgControlStatus"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["NgControlStatusGroup"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__["NgForm"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__["NgModel"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__["RadioControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__["FormControlName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__["FormGroupDirective"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["FormArrayName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["FormGroupName"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["NgSelectOption"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["SelectControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__["SelectMultipleControlValueAccessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["MaxLengthValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["MinLengthValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["PatternValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["RequiredValidator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_19__form_builder__["FormBuilder"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["NG_ASYNC_VALIDATORS"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["NG_VALIDATORS"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["Validators"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "H", function() { return __WEBPACK_IMPORTED_MODULE_22__form_providers__["FormsModule"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__form_providers__["ReactiveFormsModule"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */
























//# sourceMappingURL=forms.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backends_browser_xhr__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backends_jsonp_backend__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backends_xhr_backend__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_request_options__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_response_options__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__headers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_module__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__interfaces__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_request__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_response__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__url_search_params__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__backends_browser_xhr__["BrowserXhr"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__backends_jsonp_backend__["JSONPBackend"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__backends_jsonp_backend__["JSONPConnection"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__backends_xhr_backend__["CookieXSRFStrategy"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__backends_xhr_backend__["XHRBackend"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__backends_xhr_backend__["XHRConnection"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__base_request_options__["BaseRequestOptions"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__base_request_options__["RequestOptions"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__base_response_options__["BaseResponseOptions"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__base_response_options__["ResponseOptions"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__enums__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__enums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__enums__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__enums__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__headers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__http__["Http"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__http__["Jsonp"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__http_module__["HttpModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__http_module__["JsonpModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__interfaces__["Connection"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__interfaces__["ConnectionBackend"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__interfaces__["XSRFStrategy"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__static_request__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_11__static_response__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_12__url_search_params__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_12__url_search_params__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */













//# sourceMappingURL=index.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return GenericBrowserDomAdapter; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 * Provides DOM operations in any browser environment.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
var GenericBrowserDomAdapter = (function (_super) {
    __extends(GenericBrowserDomAdapter, _super);
    function GenericBrowserDomAdapter() {
        var _this = this;
        _super.call(this);
        this._animationPrefix = null;
        this._transitionEnd = null;
        try {
            var element_1 = this.createElement('div', this.defaultDoc());
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.getStyle(element_1, 'animationName'))) {
                this._animationPrefix = '';
            }
            else {
                var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                for (var i = 0; i < domPrefixes.length; i++) {
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.getStyle(element_1, domPrefixes[i] + 'AnimationName'))) {
                        this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                        break;
                    }
                }
            }
            var transEndEventNames_1 = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd otransitionend',
                transition: 'transitionend'
            };
            Object.keys(transEndEventNames_1).forEach(function (key) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(_this.getStyle(element_1, key))) {
                    _this._transitionEnd = transEndEventNames_1[key];
                }
            });
        }
        catch (e) {
            this._animationPrefix = null;
            this._transitionEnd = null;
        }
    }
    GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) { return el.getDistributedNodes(); };
    GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
        el.href = href == null ? baseUrl : baseUrl + '/../' + href;
    };
    GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () { return true; };
    GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
        return typeof this.defaultDoc().body.createShadowRoot === 'function';
    };
    GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () { return this._animationPrefix ? this._animationPrefix : ''; };
    GenericBrowserDomAdapter.prototype.getTransitionEnd = function () { return this._transitionEnd ? this._transitionEnd : ''; };
    GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._animationPrefix) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this._transitionEnd);
    };
    return GenericBrowserDomAdapter;
}(__WEBPACK_IMPORTED_MODULE_0__dom_dom_adapter__["DomAdapter"]));
//# sourceMappingURL=generic_browser_adapter.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = supportsState;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function supportsState() {
    return !!window.history.pushState;
}
//# sourceMappingURL=history.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_browser__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facade_lang__ = __webpack_require__(1);
/* unused harmony export ChangeDetectionPerfRecord */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AngularTools; });
/* unused harmony export AngularProfiler */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var ChangeDetectionPerfRecord = (function () {
    function ChangeDetectionPerfRecord(msPerTick, numTicks) {
        this.msPerTick = msPerTick;
        this.numTicks = numTicks;
    }
    return ChangeDetectionPerfRecord;
}());
/**
 * Entry point for all Angular debug tools. This object corresponds to the `ng`
 * global variable accessible in the dev console.
 */
var AngularTools = (function () {
    function AngularTools(ref) {
        this.profiler = new AngularProfiler(ref);
    }
    return AngularTools;
}());
/**
 * Entry point for all Angular profiling-related debug tools. This object
 * corresponds to the `ng.profiler` in the dev console.
 */
var AngularProfiler = (function () {
    function AngularProfiler(ref) {
        this.appRef = ref.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]);
    }
    /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     */
    AngularProfiler.prototype.timeChangeDetection = function (config) {
        var record = config && config['record'];
        var profileName = 'Change Detection';
        // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
        var isProfilerAvailable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["d" /* isPresent */])(__WEBPACK_IMPORTED_MODULE_2__facade_browser__["a" /* window */].console.profile);
        if (record && isProfilerAvailable) {
            __WEBPACK_IMPORTED_MODULE_2__facade_browser__["a" /* window */].console.profile(profileName);
        }
        var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().performanceNow();
        var numTicks = 0;
        while (numTicks < 5 || (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().performanceNow() - start) < 500) {
            this.appRef.tick();
            numTicks++;
        }
        var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().performanceNow();
        if (record && isProfilerAvailable) {
            // need to cast to <any> because type checker thinks there's no argument
            // while in fact there is:
            //
            // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
            __WEBPACK_IMPORTED_MODULE_2__facade_browser__["a" /* window */].console.profileEnd(profileName);
        }
        var msPerTick = (end - start) / numTicks;
        __WEBPACK_IMPORTED_MODULE_2__facade_browser__["a" /* window */].console.log("ran " + numTicks + " change detection cycles");
        __WEBPACK_IMPORTED_MODULE_2__facade_browser__["a" /* window */].console.log(msPerTick.toFixed(2) + " ms per check");
        return new ChangeDetectionPerfRecord(msPerTick, numTicks);
    };
    return AngularProfiler;
}());
//# sourceMappingURL=common_tools.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_tools__ = __webpack_require__(391);
/* harmony export (immutable) */ exports["b"] = enableDebugTools;
/* harmony export (immutable) */ exports["a"] = disableDebugTools;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var context = __WEBPACK_IMPORTED_MODULE_0__facade_lang__["a" /* global */];
/**
 * Enabled Angular 2 debug tools that are accessible via your browser's
 * developer console.
 *
 * Usage:
 *
 * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
 * 1. Type `ng.` (usually the console will show auto-complete suggestion)
 * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
 *    then hit Enter.
 *
 * @experimental All debugging apis are currently experimental.
 */
function enableDebugTools(ref) {
    context.ng = new __WEBPACK_IMPORTED_MODULE_1__common_tools__["a" /* AngularTools */](ref);
    return ref;
}
/**
 * Disables Angular 2 tools.
 *
 * @experimental All debugging apis are currently experimental.
 */
function disableDebugTools() {
    delete context.ng;
}
//# sourceMappingURL=tools.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_manager__ = __webpack_require__(84);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return HammerGesturesPluginCommon; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var _eventNames = {
    // pan
    'pan': true,
    'panstart': true,
    'panmove': true,
    'panend': true,
    'pancancel': true,
    'panleft': true,
    'panright': true,
    'panup': true,
    'pandown': true,
    // pinch
    'pinch': true,
    'pinchstart': true,
    'pinchmove': true,
    'pinchend': true,
    'pinchcancel': true,
    'pinchin': true,
    'pinchout': true,
    // press
    'press': true,
    'pressup': true,
    // rotate
    'rotate': true,
    'rotatestart': true,
    'rotatemove': true,
    'rotateend': true,
    'rotatecancel': true,
    // swipe
    'swipe': true,
    'swipeleft': true,
    'swiperight': true,
    'swipeup': true,
    'swipedown': true,
    // tap
    'tap': true,
};
var HammerGesturesPluginCommon = (function (_super) {
    __extends(HammerGesturesPluginCommon, _super);
    function HammerGesturesPluginCommon() {
        _super.call(this);
    }
    HammerGesturesPluginCommon.prototype.supports = function (eventName) {
        return _eventNames.hasOwnProperty(eventName.toLowerCase());
    };
    return HammerGesturesPluginCommon;
}(__WEBPACK_IMPORTED_MODULE_0__event_manager__["EventManagerPlugin"]));
//# sourceMappingURL=hammer_common.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__web_animations_player__ = __webpack_require__(395);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return WebAnimationsDriver; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var WebAnimationsDriver = (function () {
    function WebAnimationsDriver() {
    }
    WebAnimationsDriver.prototype.animate = function (element, startingStyles, keyframes, duration, delay, easing) {
        var formattedSteps = [];
        var startingStyleLookup = {};
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(startingStyles) && startingStyles.styles.length > 0) {
            startingStyleLookup = _populateStyles(element, startingStyles, {});
            startingStyleLookup['offset'] = 0;
            formattedSteps.push(startingStyleLookup);
        }
        keyframes.forEach(function (keyframe) {
            var data = _populateStyles(element, keyframe.styles, startingStyleLookup);
            data['offset'] = keyframe.offset;
            formattedSteps.push(data);
        });
        // this is a special case when only styles are applied as an
        // animation. When this occurs we want to animate from start to
        // end with the same values. Removing the offset and having only
        // start/end values is suitable enough for the web-animations API
        if (formattedSteps.length == 1) {
            var start = formattedSteps[0];
            start['offset'] = null;
            formattedSteps = [start, start];
        }
        var playerOptions = {
            'duration': duration,
            'delay': delay,
            'fill': 'both' // we use `both` because it allows for styling at 0% to work with `delay`
        };
        // we check for this to avoid having a null|undefined value be present
        // for the easing (which results in an error for certain browsers #9752)
        if (easing) {
            playerOptions['easing'] = easing;
        }
        return new __WEBPACK_IMPORTED_MODULE_3__web_animations_player__["a" /* WebAnimationsPlayer */](element, formattedSteps, playerOptions);
    };
    return WebAnimationsDriver;
}());
function _populateStyles(element, styles, defaultStyles) {
    var data = {};
    styles.styles.forEach(function (entry) {
        Object.keys(entry).forEach(function (prop) {
            var val = entry[prop];
            var formattedProp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* dashCaseToCamelCase */])(prop);
            data[formattedProp] =
                val == __WEBPACK_IMPORTED_MODULE_0__angular_core__["AUTO_STYLE"] ? val : val.toString() + _resolveStyleUnit(val, prop, formattedProp);
        });
    });
    Object.keys(defaultStyles).forEach(function (prop) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(data[prop])) {
            data[prop] = defaultStyles[prop];
        }
    });
    return data;
}
function _resolveStyleUnit(val, userProvidedProp, formattedProp) {
    var unit = '';
    if (_isPixelDimensionStyle(formattedProp) && val != 0 && val != '0') {
        if (typeof val === 'number') {
            unit = 'px';
        }
        else if (_findDimensionalSuffix(val.toString()).length == 0) {
            throw new Error('Please provide a CSS unit value for ' + userProvidedProp + ':' + val);
        }
    }
    return unit;
}
var _$0 = 48;
var _$9 = 57;
var _$PERIOD = 46;
function _findDimensionalSuffix(value) {
    for (var i = 0; i < value.length; i++) {
        var c = value.charCodeAt(i);
        if ((c >= _$0 && c <= _$9) || c == _$PERIOD)
            continue;
        return value.substring(i, value.length);
    }
    return '';
}
function _isPixelDimensionStyle(prop) {
    switch (prop) {
        case 'width':
        case 'height':
        case 'minWidth':
        case 'minHeight':
        case 'maxWidth':
        case 'maxHeight':
        case 'left':
        case 'top':
        case 'bottom':
        case 'right':
        case 'fontSize':
        case 'outlineWidth':
        case 'outlineOffset':
        case 'paddingTop':
        case 'paddingLeft':
        case 'paddingBottom':
        case 'paddingRight':
        case 'marginTop':
        case 'marginLeft':
        case 'marginBottom':
        case 'marginRight':
        case 'borderRadius':
        case 'borderWidth':
        case 'borderTopWidth':
        case 'borderLeftWidth':
        case 'borderRightWidth':
        case 'borderBottomWidth':
        case 'textIndent':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=web_animations_driver.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_adapter__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return WebAnimationsPlayer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var WebAnimationsPlayer = (function () {
    function WebAnimationsPlayer(element, keyframes, options) {
        this.element = element;
        this.keyframes = keyframes;
        this.options = options;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._initialized = false;
        this._started = false;
        this.parentPlayer = null;
        this._duration = options['duration'];
    }
    WebAnimationsPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPresent */])(this.parentPlayer)) {
                this.destroy();
            }
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    WebAnimationsPlayer.prototype.init = function () {
        var _this = this;
        if (this._initialized)
            return;
        this._initialized = true;
        var keyframes = this.keyframes.map(function (styles) {
            var formattedKeyframe = {};
            Object.keys(styles).forEach(function (prop) {
                var value = styles[prop];
                formattedKeyframe[prop] = value == __WEBPACK_IMPORTED_MODULE_0__angular_core__["AUTO_STYLE"] ? _computeStyle(_this.element, prop) : value;
            });
            return formattedKeyframe;
        });
        this._player = this._triggerWebAnimation(this.element, keyframes, this.options);
        // this is required so that the player doesn't start to animate right away
        this.reset();
        this._player.onfinish = function () { return _this._onFinish(); };
    };
    /** @internal */
    WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
        return element.animate(keyframes, options);
    };
    WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    WebAnimationsPlayer.prototype.play = function () {
        this.init();
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._player.play();
    };
    WebAnimationsPlayer.prototype.pause = function () {
        this.init();
        this._player.pause();
    };
    WebAnimationsPlayer.prototype.finish = function () {
        this.init();
        this._onFinish();
        this._player.finish();
    };
    WebAnimationsPlayer.prototype.reset = function () { this._player.cancel(); };
    WebAnimationsPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
    WebAnimationsPlayer.prototype.destroy = function () {
        this.reset();
        this._onFinish();
    };
    Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
        get: function () { return this._duration; },
        enumerable: true,
        configurable: true
    });
    WebAnimationsPlayer.prototype.setPosition = function (p) { this._player.currentTime = p * this.totalTime; };
    WebAnimationsPlayer.prototype.getPosition = function () { return this._player.currentTime / this.totalTime; };
    return WebAnimationsPlayer;
}());
function _computeStyle(element, prop) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_adapter__["getDOM"])().getComputedStyle(element)[prop];
}
//# sourceMappingURL=web_animations_player.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return win; });
/* unused harmony export document */
/* unused harmony export location */
/* unused harmony export gc */
/* unused harmony export performance */
/* unused harmony export Event */
/* unused harmony export MouseEvent */
/* unused harmony export KeyboardEvent */
/* unused harmony export EventTarget */
/* unused harmony export History */
/* unused harmony export Location */
/* unused harmony export EventListener */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * JS version of browser APIs. This library can only run in the browser.
 */
var win = typeof window !== 'undefined' && window || {};

var document = win.document;
var location = win.location;
var gc = win['gc'] ? function () { return win['gc'](); } : function () { return null; };
var performance = win['performance'] ? win['performance'] : null;
var Event = win['Event'];
var MouseEvent = win['MouseEvent'];
var KeyboardEvent = win['KeyboardEvent'];
var EventTarget = win['EventTarget'];
var History = win['History'];
var Location = win['Location'];
var EventListener = win['EventListener'];
//# sourceMappingURL=browser.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_title__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_tools_tools__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_animation_driver__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_debug_by__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_debug_by___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dom_debug_by__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_debug_ng_probe__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_debug_ng_probe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__dom_debug_ng_probe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_dom_tokens__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom_events_event_manager__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_events_hammer_gestures__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__security_dom_sanitization_service__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__private_export__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__browser__["BrowserModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__browser__["platformBrowser"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__browser_title__["Title"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__browser_tools_tools__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__browser_tools_tools__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__dom_animation_driver__["AnimationDriver"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__dom_debug_by__, "By")) __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__dom_debug_by__["By"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_5__dom_debug_ng_probe__, "NgProbeToken")) __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__dom_debug_ng_probe__["NgProbeToken"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__dom_dom_tokens__["DOCUMENT"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__dom_events_event_manager__["EVENT_MANAGER_PLUGINS"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__dom_events_event_manager__["EventManager"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__dom_events_hammer_gestures__["HAMMER_GESTURE_CONFIG"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__dom_events_hammer_gestures__["HammerGestureConfig"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__security_dom_sanitization_service__["DomSanitizer"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_10__private_export__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */











//# sourceMappingURL=platform-browser.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser_browser_adapter__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser_location_browser_platform_location__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_testability__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_debug_ng_probe__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_debug_ng_probe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dom_debug_ng_probe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_dom_renderer__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom_events_dom_events__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_events_hammer_gestures__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_events_key_events__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dom_shared_styles_host__ = __webpack_require__(148);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return __platform_browser_private__; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */











var __platform_browser_private__ = {
    BrowserPlatformLocation: __WEBPACK_IMPORTED_MODULE_2__browser_location_browser_platform_location__["a" /* BrowserPlatformLocation */],
    DomAdapter: __WEBPACK_IMPORTED_MODULE_5__dom_dom_adapter__["DomAdapter"],
    BrowserDomAdapter: __WEBPACK_IMPORTED_MODULE_1__browser_browser_adapter__["a" /* BrowserDomAdapter */],
    BrowserGetTestability: __WEBPACK_IMPORTED_MODULE_3__browser_testability__["a" /* BrowserGetTestability */],
    getDOM: __WEBPACK_IMPORTED_MODULE_5__dom_dom_adapter__["getDOM"],
    setRootDomAdapter: __WEBPACK_IMPORTED_MODULE_5__dom_dom_adapter__["setRootDomAdapter"],
    DomRootRenderer_: __WEBPACK_IMPORTED_MODULE_6__dom_dom_renderer__["DomRootRenderer_"],
    DomRootRenderer: __WEBPACK_IMPORTED_MODULE_6__dom_dom_renderer__["DomRootRenderer"],
    DomSharedStylesHost: __WEBPACK_IMPORTED_MODULE_10__dom_shared_styles_host__["DomSharedStylesHost"],
    SharedStylesHost: __WEBPACK_IMPORTED_MODULE_10__dom_shared_styles_host__["SharedStylesHost"],
    ELEMENT_PROBE_PROVIDERS: __WEBPACK_IMPORTED_MODULE_4__dom_debug_ng_probe__["ELEMENT_PROBE_PROVIDERS"],
    DomEventsPlugin: __WEBPACK_IMPORTED_MODULE_7__dom_events_dom_events__["DomEventsPlugin"],
    KeyEventsPlugin: __WEBPACK_IMPORTED_MODULE_9__dom_events_key_events__["KeyEventsPlugin"],
    HammerGesturesPlugin: __WEBPACK_IMPORTED_MODULE_8__dom_events_hammer_gestures__["HammerGesturesPlugin"],
    initDomAdapter: __WEBPACK_IMPORTED_MODULE_0__browser__["initDomAdapter"],
    INTERNAL_BROWSER_PLATFORM_PROVIDERS: __WEBPACK_IMPORTED_MODULE_0__browser__["INTERNAL_BROWSER_PLATFORM_PROVIDERS"],
    BROWSER_SANITIZATION_PROVIDERS: __WEBPACK_IMPORTED_MODULE_0__browser__["BROWSER_SANITIZATION_PROVIDERS"]
};
//# sourceMappingURL=private_export.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* unused harmony export RenderDebugInfo */
/* unused harmony export ReflectionCapabilities */
/* unused harmony export DebugDomRootRenderer */
/* unused harmony export reflector */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NoOpAnimationPlayer; });
/* unused harmony export AnimationPlayer */
/* unused harmony export AnimationSequencePlayer */
/* unused harmony export AnimationGroupPlayer */
/* unused harmony export AnimationKeyframe */
/* unused harmony export AnimationStyles */
/* unused harmony export prepareFinalAnimationStyles */
/* unused harmony export balanceAnimationKeyframes */
/* unused harmony export clearStyles */
/* unused harmony export collectAndResolveStyles */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var RenderDebugInfo = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].RenderDebugInfo;
var ReflectionCapabilities = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].ReflectionCapabilities;
var DebugDomRootRenderer = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].DebugDomRootRenderer;
var reflector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].reflector;
var NoOpAnimationPlayer = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].NoOpAnimationPlayer;
var AnimationPlayer = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].AnimationPlayer;
var AnimationSequencePlayer = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].AnimationSequencePlayer;
var AnimationGroupPlayer = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].AnimationGroupPlayer;
var AnimationKeyframe = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].AnimationKeyframe;
var AnimationStyles = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].AnimationStyles;
var prepareFinalAnimationStyles = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].prepareFinalAnimationStyles;
var balanceAnimationKeyframes = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].balanceAnimationKeyframes;
var clearStyles = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].clearStyles;
var collectAndResolveStyles = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].collectAndResolveStyles;
//# sourceMappingURL=private_import_core.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_sanitizer__ = __webpack_require__(212);
/* harmony export (immutable) */ exports["a"] = sanitizeHtml;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/** A <body> element that can be safely used to parse untrusted HTML. Lazily initialized below. */
var inertElement = null;
/** Lazily initialized to make sure the DOM adapter gets set before use. */
var DOM = null;
/** Returns an HTML element that is guaranteed to not execute code when creating elements in it. */
function getInertElement() {
    if (inertElement)
        return inertElement;
    DOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])();
    // Prefer using <template> element if supported.
    var templateEl = DOM.createElement('template');
    if ('content' in templateEl)
        return templateEl;
    var doc = DOM.createHtmlDocument();
    inertElement = DOM.querySelector(doc, 'body');
    if (inertElement == null) {
        // usually there should be only one body element in the document, but IE doesn't have any, so we
        // need to create one.
        var html = DOM.createElement('html', doc);
        inertElement = DOM.createElement('body', doc);
        DOM.appendChild(html, inertElement);
        DOM.appendChild(doc, html);
    }
    return inertElement;
}
function tagSet(tags) {
    var res = {};
    for (var _i = 0, _a = tags.split(','); _i < _a.length; _i++) {
        var t = _a[_i];
        res[t] = true;
    }
    return res;
}
function merge() {
    var sets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sets[_i - 0] = arguments[_i];
    }
    var res = {};
    for (var _a = 0, sets_1 = sets; _a < sets_1.length; _a++) {
        var s = sets_1[_a];
        for (var v in s) {
            if (s.hasOwnProperty(v))
                res[v] = true;
        }
    }
    return res;
}
// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements
// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var VOID_ELEMENTS = tagSet('area,br,col,hr,img,wbr');
// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var OPTIONAL_END_TAG_BLOCK_ELEMENTS = tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
var OPTIONAL_END_TAG_INLINE_ELEMENTS = tagSet('rp,rt');
var OPTIONAL_END_TAG_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
// Safe Block Elements - HTML5
var BLOCK_ELEMENTS = merge(OPTIONAL_END_TAG_BLOCK_ELEMENTS, tagSet('address,article,' +
    'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
    'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
// Inline Elements - HTML5
var INLINE_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, tagSet('a,abbr,acronym,audio,b,' +
    'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
    'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
var VALID_ELEMENTS = merge(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
// Attributes that have href and hence need to be sanitized
var URI_ATTRS = tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
// Attributes that have special href set hence need to be sanitized
var SRCSET_ATTRS = tagSet('srcset');
var HTML_ATTRS = tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
    'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
    'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
    'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
    'valign,value,vspace,width');
// NB: This currently conciously doesn't support SVG. SVG sanitization has had several security
// issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
// innerHTML is required, SVG attributes should be added here.
// NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
// can be sanitized, but they increase security surface area without a legitimate use case, so they
// are left out here.
var VALID_ATTRS = merge(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS);
/**
 * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
 * attributes.
 */
var SanitizingHtmlSerializer = (function () {
    function SanitizingHtmlSerializer() {
        // Explicitly track if something was stripped, to avoid accidentally warning of sanitization just
        // because characters were re-encoded.
        this.sanitizedSomething = false;
        this.buf = [];
    }
    SanitizingHtmlSerializer.prototype.sanitizeChildren = function (el) {
        // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
        // However this code never accesses properties off of `document` before deleting its contents
        // again, so it shouldn't be vulnerable to DOM clobbering.
        var current = el.firstChild;
        while (current) {
            if (DOM.isElementNode(current)) {
                this.startElement(current);
            }
            else if (DOM.isTextNode(current)) {
                this.chars(DOM.nodeValue(current));
            }
            else {
                // Strip non-element, non-text nodes.
                this.sanitizedSomething = true;
            }
            if (DOM.firstChild(current)) {
                current = DOM.firstChild(current);
                continue;
            }
            while (current) {
                // Leaving the element. Walk up and to the right, closing tags as we go.
                if (DOM.isElementNode(current)) {
                    this.endElement(current);
                }
                if (DOM.nextSibling(current)) {
                    current = DOM.nextSibling(current);
                    break;
                }
                current = DOM.parentElement(current);
            }
        }
        return this.buf.join('');
    };
    SanitizingHtmlSerializer.prototype.startElement = function (element) {
        var _this = this;
        var tagName = DOM.nodeName(element).toLowerCase();
        if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
            this.sanitizedSomething = true;
            return;
        }
        this.buf.push('<');
        this.buf.push(tagName);
        DOM.attributeMap(element).forEach(function (value, attrName) {
            var lower = attrName.toLowerCase();
            if (!VALID_ATTRS.hasOwnProperty(lower)) {
                _this.sanitizedSomething = true;
                return;
            }
            // TODO(martinprobst): Special case image URIs for data:image/...
            if (URI_ATTRS[lower])
                value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__url_sanitizer__["a" /* sanitizeUrl */])(value);
            if (SRCSET_ATTRS[lower])
                value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__url_sanitizer__["b" /* sanitizeSrcset */])(value);
            _this.buf.push(' ');
            _this.buf.push(attrName);
            _this.buf.push('="');
            _this.buf.push(encodeEntities(value));
            _this.buf.push('"');
        });
        this.buf.push('>');
    };
    SanitizingHtmlSerializer.prototype.endElement = function (current) {
        var tagName = DOM.nodeName(current).toLowerCase();
        if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
            this.buf.push('</');
            this.buf.push(tagName);
            this.buf.push('>');
        }
    };
    SanitizingHtmlSerializer.prototype.chars = function (chars /** TODO #9100 */) { this.buf.push(encodeEntities(chars)); };
    return SanitizingHtmlSerializer;
}());
// Regular Expressions for parsing tags and attributes
var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// ! to ~ is the ASCII range.
var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param value
 * @returns {string} escaped text
 */
function encodeEntities(value) {
    return value.replace(/&/g, '&amp;')
        .replace(SURROGATE_PAIR_REGEXP, function (match) {
        var hi = match.charCodeAt(0);
        var low = match.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    })
        .replace(NON_ALPHANUMERIC_REGEXP, function (match) { return '&#' + match.charCodeAt(0) + ';'; })
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/**
 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
 * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo').
 *
 * This is undesirable since we don't want to allow any of these custom attributes. This method
 * strips them all.
 */
function stripCustomNsAttrs(el) {
    DOM.attributeMap(el).forEach(function (_, attrName) {
        if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
            DOM.removeAttribute(el, attrName);
        }
    });
    for (var _i = 0, _a = DOM.childNodesAsList(el); _i < _a.length; _i++) {
        var n = _a[_i];
        if (DOM.isElementNode(n))
            stripCustomNsAttrs(n);
    }
}
/**
 * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
 * the DOM in a browser environment.
 */
function sanitizeHtml(unsafeHtmlInput) {
    try {
        var containerEl = getInertElement();
        // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
        var unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
        // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
        // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
        var mXSSAttempts = 5;
        var parsedHtml = unsafeHtml;
        do {
            if (mXSSAttempts === 0) {
                throw new Error('Failed to sanitize html because the input is unstable');
            }
            mXSSAttempts--;
            unsafeHtml = parsedHtml;
            DOM.setInnerHTML(containerEl, unsafeHtml);
            if (DOM.defaultDoc().documentMode) {
                // strip custom-namespaced attributes on IE<=11
                stripCustomNsAttrs(containerEl);
            }
            parsedHtml = DOM.getInnerHTML(containerEl);
        } while (unsafeHtml !== parsedHtml);
        var sanitizer = new SanitizingHtmlSerializer();
        var safeHtml = sanitizer.sanitizeChildren(DOM.getTemplateContent(containerEl) || containerEl);
        // Clear out the body element.
        var parent_1 = DOM.getTemplateContent(containerEl) || containerEl;
        for (var _i = 0, _a = DOM.childNodesAsList(parent_1); _i < _a.length; _i++) {
            var child = _a[_i];
            DOM.removeChild(parent_1, child);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() && sanitizer.sanitizedSomething) {
            DOM.log('WARNING: sanitizing HTML stripped some content (see http://g.co/ng/security#xss).');
        }
        return safeHtml;
    }
    catch (e) {
        // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
        inertElement = null;
        throw e;
    }
}
//# sourceMappingURL=html_sanitizer.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_sanitizer__ = __webpack_require__(212);
/* harmony export (immutable) */ exports["a"] = sanitizeStyle;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * Regular expression for safe style values.
 *
 * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
 *
 * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
 * font-family) and hence could allow multiple values to get injected, but that should pose no risk
 * of XSS.
 *
 * The function expression checks only for XSS safety, not for CSS validity.
 *
 * This regular expression was taken from the Closure sanitization library, and augmented for
 * transformation values.
 */
var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|3d)?';
var COLOR_FNS = '(?:rgb|hsl)a?';
var FN_ARGS = '\\([-0-9.%, a-zA-Z]+\\)';
var SAFE_STYLE_VALUE = new RegExp("^(" + VALUES + "|(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + ")" + FN_ARGS + ")$", 'g');
/**
 * Matches a `url(...)` value with an arbitrary argument as long as it does
 * not contain parentheses.
 *
 * The URL value still needs to be sanitized separately.
 *
 * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
 * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
 * by observing whether scroll bars are displayed, or character ranges used by a font face
 * definition.
 *
 * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
 * binding a URL value without further cooperation from the page will cause an information leak, and
 * if so, it is just a leak, not a full blown XSS vulnerability.
 *
 * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
 * code is permissive and allows URLs that sanitize otherwise.
 */
var URL_RE = /^url\(([^)]+)\)$/;
/**
 * Checks that quotes (" and ') are properly balanced inside a string. Assumes
 * that neither escape (\) nor any other character that could result in
 * breaking out of a string parsing context are allowed;
 * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
 *
 * This code was taken from the Closure sanitization library.
 */
function hasBalancedQuotes(value) {
    var outsideSingle = true;
    var outsideDouble = true;
    for (var i = 0; i < value.length; i++) {
        var c = value.charAt(i);
        if (c === '\'' && outsideDouble) {
            outsideSingle = !outsideSingle;
        }
        else if (c === '"' && outsideSingle) {
            outsideDouble = !outsideDouble;
        }
    }
    return outsideSingle && outsideDouble;
}
/**
 * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
 * value) and returns a value that is safe to use in a browser environment.
 */
function sanitizeStyle(value) {
    value = String(value).trim(); // Make sure it's actually a string.
    if (!value)
        return '';
    // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
    // reasoning behind this.
    var urlMatch = value.match(URL_RE);
    if ((urlMatch && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__url_sanitizer__["a" /* sanitizeUrl */])(urlMatch[1]) === urlMatch[1]) ||
        value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
        return value; // Safe style values.
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_dom_adapter__["getDOM"])().log("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
    }
    return 'unsafe';
}
//# sourceMappingURL=style_sanitizer.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_config_loader__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_collection__ = __webpack_require__(63);
/* harmony export (immutable) */ exports["a"] = applyRedirects;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */













var NoMatch = (function () {
    function NoMatch(segmentGroup) {
        if (segmentGroup === void 0) { segmentGroup = null; }
        this.segmentGroup = segmentGroup;
    }
    return NoMatch;
}());
var AbsoluteRedirect = (function () {
    function AbsoluteRedirect(segments) {
        this.segments = segments;
    }
    return AbsoluteRedirect;
}());
function noMatch(segmentGroup) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new NoMatch(segmentGroup)); });
}
function absoluteRedirect(segments) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new AbsoluteRedirect(segments)); });
}
function canLoadFails(route) {
    return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(new __WEBPACK_IMPORTED_MODULE_10__shared__["b" /* NavigationCancelingError */]("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false")); });
}
function applyRedirects(injector, configLoader, urlTree, config) {
    return new ApplyRedirects(injector, configLoader, urlTree, config).apply();
}
var ApplyRedirects = (function () {
    function ApplyRedirects(injector, configLoader, urlTree, config) {
        this.injector = injector;
        this.configLoader = configLoader;
        this.urlTree = urlTree;
        this.config = config;
        this.allowRedirects = true;
    }
    ApplyRedirects.prototype.apply = function () {
        var _this = this;
        var expanded$ = this.expandSegmentGroup(this.injector, this.config, this.urlTree.root, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]);
        var urlTrees$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup); });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(urlTrees$, function (e) {
            if (e instanceof AbsoluteRedirect) {
                // after an absolute redirect we do not apply any more redirects!
                _this.allowRedirects = false;
                var group = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"]([], (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]] = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](e.segments, {}), _a));
                // we need to run matching, so we can fetch all lazy-loaded modules
                return _this.match(group);
            }
            else if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            else {
                throw e;
            }
            var _a;
        });
    };
    ApplyRedirects.prototype.match = function (segmentGroup) {
        var _this = this;
        var expanded$ = this.expandSegmentGroup(this.injector, this.config, segmentGroup, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]);
        var mapped$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup); });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(mapped$, function (e) {
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            else {
                throw e;
            }
        });
    };
    ApplyRedirects.prototype.noMatchError = function (e) {
        return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
    };
    ApplyRedirects.prototype.createUrlTree = function (rootCandidate) {
        var root = rootCandidate.segments.length > 0 ?
            new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"]([], (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]] = rootCandidate, _a)) :
            rootCandidate;
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlTree"](root, this.urlTree.queryParams, this.urlTree.fragment);
        var _a;
    };
    ApplyRedirects.prototype.expandSegmentGroup = function (injector, routes, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(this.expandChildren(injector, routes, segmentGroup), function (children) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"]([], children); });
        }
        else {
            return this.expandSegment(injector, segmentGroup, routes, segmentGroup.segments, outlet, true);
        }
    };
    ApplyRedirects.prototype.expandChildren = function (injector, routes, segmentGroup) {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["e" /* waitForMap */])(segmentGroup.children, function (childOutlet, child) { return _this.expandSegmentGroup(injector, routes, child, childOutlet); });
    };
    ApplyRedirects.prototype.expandSegment = function (injector, segmentGroup, routes, segments, outlet, allowRedirects) {
        var _this = this;
        var routes$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"].apply(void 0, routes);
        var processedRoutes$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(routes$, function (r) {
            var expanded$ = _this.expandSegmentAgainstRoute(injector, segmentGroup, routes, r, segments, outlet, allowRedirects);
            return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(expanded$, function (e) {
                if (e instanceof NoMatch)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(null);
                else
                    throw e;
            });
        });
        var concattedProcessedRoutes$ = __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_concatAll__["concatAll"].call(processedRoutes$);
        var first$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_first__["first"].call(concattedProcessedRoutes$, function (s) { return !!s; });
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_catch__["_catch"].call(first$, function (e, _) {
            if (e instanceof __WEBPACK_IMPORTED_MODULE_8_rxjs_util_EmptyError__["EmptyError"]) {
                throw new NoMatch(segmentGroup);
            }
            else {
                throw e;
            }
        });
    };
    ApplyRedirects.prototype.expandSegmentAgainstRoute = function (injector, segmentGroup, routes, route, paths, outlet, allowRedirects) {
        if (getOutlet(route) !== outlet)
            return noMatch(segmentGroup);
        if (route.redirectTo !== undefined && !(allowRedirects && this.allowRedirects))
            return noMatch(segmentGroup);
        if (route.redirectTo === undefined) {
            return this.matchSegmentAgainstRoute(injector, segmentGroup, route, paths);
        }
        else {
            return this.expandSegmentAgainstRouteUsingRedirect(injector, segmentGroup, routes, route, paths, outlet);
        }
    };
    ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = function (injector, segmentGroup, routes, route, segments, outlet) {
        if (route.path === '**') {
            return this.expandWildCardWithParamsAgainstRouteUsingRedirect(injector, routes, route, outlet);
        }
        else {
            return this.expandRegularSegmentAgainstRouteUsingRedirect(injector, segmentGroup, routes, route, segments, outlet);
        }
    };
    ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = function (injector, routes, route, outlet) {
        var newSegments = applyRedirectCommands([], route.redirectTo, {});
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newSegments);
        }
        else {
            var group = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](newSegments, {});
            return this.expandSegment(injector, group, routes, newSegments, outlet, false);
        }
    };
    ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = function (injector, segmentGroup, routes, route, segments, outlet) {
        var _a = match(segmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
        if (!matched)
            return noMatch(segmentGroup);
        var newSegments = applyRedirectCommands(consumedSegments, route.redirectTo, positionalParamSegments);
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newSegments);
        }
        else {
            return this.expandSegment(injector, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
        }
    };
    ApplyRedirects.prototype.matchSegmentAgainstRoute = function (injector, rawSegmentGroup, route, segments) {
        var _this = this;
        if (route.path === '**') {
            if (route.loadChildren) {
                return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(this.configLoader.load(injector, route.loadChildren), function (r) {
                    route._loadedConfig = r;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](segments, {}));
                });
            }
            else {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](segments, {}));
            }
        }
        else {
            var _a = match(rawSegmentGroup, route, segments), matched = _a.matched, consumedSegments_1 = _a.consumedSegments, lastChild = _a.lastChild;
            if (!matched)
                return noMatch(rawSegmentGroup);
            var rawSlicedSegments_1 = segments.slice(lastChild);
            var childConfig$ = this.getChildConfig(injector, route);
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(childConfig$, function (routerConfig) {
                var childInjector = routerConfig.injector;
                var childConfig = routerConfig.routes;
                var _a = split(rawSegmentGroup, consumedSegments_1, rawSlicedSegments_1, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
                if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                    var expanded$ = _this.expandChildren(childInjector, childConfig, segmentGroup);
                    return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (children) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](consumedSegments_1, children); });
                }
                else if (childConfig.length === 0 && slicedSegments.length === 0) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](consumedSegments_1, {}));
                }
                else {
                    var expanded$ = _this.expandSegment(childInjector, segmentGroup, childConfig, slicedSegments, __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */], true);
                    return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(expanded$, function (cs) { return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](consumedSegments_1.concat(cs.segments), cs.children); });
                }
            });
        }
    };
    ApplyRedirects.prototype.getChildConfig = function (injector, route) {
        var _this = this;
        if (route.children) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["LoadedRouterConfig"](route.children, injector, null));
        }
        else if (route.loadChildren) {
            return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_mergeMap__["mergeMap"].call(runGuards(injector, route), function (shouldLoad) {
                if (shouldLoad) {
                    if (route._loadedConfig) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(route._loadedConfig);
                    }
                    else {
                        return __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(_this.configLoader.load(injector, route.loadChildren), function (r) {
                            route._loadedConfig = r;
                            return r;
                        });
                    }
                }
                else {
                    return canLoadFails(route);
                }
            });
        }
        else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(new __WEBPACK_IMPORTED_MODULE_9__router_config_loader__["LoadedRouterConfig"]([], injector, null));
        }
    };
    return ApplyRedirects;
}());
function runGuards(injector, route) {
    var canLoad = route.canLoad;
    if (!canLoad || canLoad.length === 0)
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(true);
    var obs = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_from__["from"])(canLoad), function (c) {
        var guard = injector.get(c);
        if (guard.canLoad) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["b" /* wrapIntoObservable */])(guard.canLoad(route));
        }
        else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["b" /* wrapIntoObservable */])(guard(route));
        }
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["f" /* andObservables */])(obs);
}
function match(segmentGroup, route, segments) {
    var noMatch = { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
    if (route.path === '') {
        if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
            return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
        else {
            return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
    }
    var path = route.path;
    var parts = path.split('/');
    var positionalParamSegments = {};
    var consumedSegments = [];
    var currentIndex = 0;
    for (var i = 0; i < parts.length; ++i) {
        if (currentIndex >= segments.length)
            return noMatch;
        var current = segments[currentIndex];
        var p = parts[i];
        var isPosParam = p.startsWith(':');
        if (!isPosParam && p !== current.path)
            return noMatch;
        if (isPosParam) {
            positionalParamSegments[p.substring(1)] = current;
        }
        consumedSegments.push(current);
        currentIndex++;
    }
    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || currentIndex < segments.length)) {
        return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
    }
    return { matched: true, consumedSegments: consumedSegments, lastChild: currentIndex, positionalParamSegments: positionalParamSegments };
}
function applyRedirectCommands(segments, redirectTo, posParams) {
    var r = redirectTo.startsWith('/') ? redirectTo.substring(1) : redirectTo;
    if (r === '') {
        return [];
    }
    else {
        return createSegments(redirectTo, r.split('/'), segments, posParams);
    }
}
function createSegments(redirectTo, parts, segments, posParams) {
    return parts.map(function (p) { return p.startsWith(':') ? findPosParam(p, posParams, redirectTo) :
        findOrCreateSegment(p, segments); });
}
function findPosParam(part, posParams, redirectTo) {
    var paramName = part.substring(1);
    var pos = posParams[paramName];
    if (!pos)
        throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + part + "'.");
    return pos;
}
function findOrCreateSegment(part, segments) {
    var idx = 0;
    for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
        var s = segments_1[_i];
        if (s.path === part) {
            segments.splice(idx);
            return s;
        }
        idx++;
    }
    return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegment"](part, {});
}
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var s = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](consumedSegments, createChildrenForEmptySegments(config, new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](slicedSegments, segmentGroup.children)));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
    }
    else if (slicedSegments.length === 0 &&
        containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
        var s = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
    }
    else {
        return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
    }
}
function mergeTrivialChildren(s) {
    if (s.numberOfChildren === 1 && s.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]]) {
        var c = s.children[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]];
        return new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"](s.segments.concat(c.segments), c.children);
    }
    else {
        return s;
    }
}
function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var res = {};
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var r = routes_1[_i];
        if (emptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
            res[getOutlet(r)] = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"]([], {});
        }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_collection__["g" /* merge */])(children, res);
}
function createChildrenForEmptySegments(routes, primarySegmentGroup) {
    var res = {};
    res[__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]] = primarySegmentGroup;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var r = routes_2[_i];
        if (r.path === '' && getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]) {
            res[getOutlet(r)] = new __WEBPACK_IMPORTED_MODULE_11__url_tree__["UrlSegmentGroup"]([], {});
        }
    }
    return res;
}
function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes
        .filter(function (r) { return emptyPathRedirect(segmentGroup, slicedSegments, r) &&
        getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */]; })
        .length > 0;
}
function containsEmptyPathRedirects(segmentGroup, slicedSegments, routes) {
    return routes.filter(function (r) { return emptyPathRedirect(segmentGroup, slicedSegments, r); }).length > 0;
}
function emptyPathRedirect(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full')
        return false;
    return r.path === '' && r.redirectTo !== undefined;
}
function getOutlet(route) {
    return route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_10__shared__["a" /* PRIMARY_OUTLET */];
}
//# sourceMappingURL=apply_redirects.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(58);
/* harmony export (immutable) */ exports["a"] = validateConfig;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

function validateConfig(config) {
    config.forEach(validateNode);
}
function validateNode(route) {
    if (Array.isArray(route)) {
        throw new Error("Invalid route configuration: Array cannot be specified");
    }
    if (route.component === undefined && (route.outlet && route.outlet !== __WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */])) {
        throw new Error("Invalid route configuration of route '" + route.path + "': a componentless route cannot have a named outlet set");
    }
    if (!!route.redirectTo && !!route.children) {
        throw new Error("Invalid configuration of route '" + route.path + "': redirectTo and children cannot be used together");
    }
    if (!!route.redirectTo && !!route.loadChildren) {
        throw new Error("Invalid configuration of route '" + route.path + "': redirectTo and loadChildren cannot be used together");
    }
    if (!!route.children && !!route.loadChildren) {
        throw new Error("Invalid configuration of route '" + route.path + "': children and loadChildren cannot be used together");
    }
    if (!!route.redirectTo && !!route.component) {
        throw new Error("Invalid configuration of route '" + route.path + "': redirectTo and component cannot be used together");
    }
    if (route.redirectTo === undefined && !route.component && !route.children &&
        !route.loadChildren) {
        throw new Error("Invalid configuration of route '" + route.path + "': one of the following must be provided (component or redirectTo or children or loadChildren)");
    }
    if (route.path === undefined) {
        throw new Error("Invalid route configuration: routes must have path specified");
    }
    if (route.path.startsWith('/')) {
        throw new Error("Invalid route configuration of route '" + route.path + "': path cannot start with a slash");
    }
    if (route.path === '' && route.redirectTo !== undefined && route.pathMatch === undefined) {
        var exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
        throw new Error("Invalid route configuration of route '{path: \"" + route.path + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
    }
    if (route.pathMatch !== undefined && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
        throw new Error("Invalid configuration of route '" + route.path + "': pathMatch can only be set to 'prefix' or 'full'");
    }
}
//# sourceMappingURL=config.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_state__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tree__ = __webpack_require__(215);
/* harmony export (immutable) */ exports["a"] = createRouterState;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



function createRouterState(curr, prevState) {
    var root = createNode(curr._root, prevState ? prevState._root : undefined);
    return new __WEBPACK_IMPORTED_MODULE_1__router_state__["RouterState"](root, curr);
}
function createNode(curr, prevState) {
    if (prevState && equalRouteSnapshots(prevState.value.snapshot, curr.value)) {
        var value = prevState.value;
        value._futureSnapshot = curr.value;
        var children = createOrReuseChildren(curr, prevState);
        return new __WEBPACK_IMPORTED_MODULE_2__utils_tree__["b" /* TreeNode */](value, children);
    }
    else {
        var value = createActivatedRoute(curr.value);
        var children = curr.children.map(function (c) { return createNode(c); });
        return new __WEBPACK_IMPORTED_MODULE_2__utils_tree__["b" /* TreeNode */](value, children);
    }
}
function createOrReuseChildren(curr, prevState) {
    return curr.children.map(function (child) {
        for (var _i = 0, _a = prevState.children; _i < _a.length; _i++) {
            var p = _a[_i];
            if (equalRouteSnapshots(p.value.snapshot, child.value)) {
                return createNode(child, p);
            }
        }
        return createNode(child);
    });
}
function createActivatedRoute(c) {
    return new __WEBPACK_IMPORTED_MODULE_1__router_state__["ActivatedRoute"](new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.url), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.params), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.queryParams), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.fragment), new __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"](c.data), c.outlet, c.component, c);
}
function equalRouteSnapshots(a, b) {
    return a._routeConfig === b._routeConfig;
}
//# sourceMappingURL=create_router_state.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_collection__ = __webpack_require__(63);
/* harmony export (immutable) */ exports["a"] = createUrlTree;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



function createUrlTree(route, urlTree, commands, queryParams, fragment) {
    if (commands.length === 0) {
        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
    }
    var normalizedCommands = normalizeCommands(commands);
    validateCommands(normalizedCommands);
    if (navigateToRoot(normalizedCommands)) {
        return tree(urlTree.root, new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"]([], {}), urlTree, queryParams, fragment);
    }
    var startingPosition = findStartingPosition(normalizedCommands, urlTree, route);
    var segmentGroup = startingPosition.processChildren ?
        updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, normalizedCommands.commands) :
        updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, normalizedCommands.commands);
    return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
}
function validateCommands(n) {
    if (n.isAbsolute && n.commands.length > 0 && isMatrixParams(n.commands[0])) {
        throw new Error('Root segment cannot have matrix parameters');
    }
    var c = n.commands.filter(function (c) { return typeof c === 'object' && c.outlets !== undefined; });
    if (c.length > 0 && c[0] !== n.commands[n.commands.length - 1]) {
        throw new Error('{outlets:{}} has to be the last command');
    }
}
function isMatrixParams(command) {
    return typeof command === 'object' && command.outlets === undefined &&
        command.segmentPath === undefined;
}
function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
    if (urlTree.root === oldSegmentGroup) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlTree"](newSegmentGroup, stringify(queryParams), fragment);
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlTree"](replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), stringify(queryParams), fragment);
    }
}
function replaceSegment(current, oldSegment, newSegment) {
    var children = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(current.children, function (c, outletName) {
        if (c === oldSegment) {
            children[outletName] = newSegment;
        }
        else {
            children[outletName] = replaceSegment(c, oldSegment, newSegment);
        }
    });
    return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](current.segments, children);
}
function navigateToRoot(normalizedChange) {
    return normalizedChange.isAbsolute && normalizedChange.commands.length === 1 &&
        normalizedChange.commands[0] == '/';
}
var NormalizedNavigationCommands = (function () {
    function NormalizedNavigationCommands(isAbsolute, numberOfDoubleDots, commands) {
        this.isAbsolute = isAbsolute;
        this.numberOfDoubleDots = numberOfDoubleDots;
        this.commands = commands;
    }
    return NormalizedNavigationCommands;
}());
function normalizeCommands(commands) {
    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] == '/') {
        return new NormalizedNavigationCommands(true, 0, commands);
    }
    var numberOfDoubleDots = 0;
    var isAbsolute = false;
    var res = [];
    var _loop_1 = function(i) {
        var c = commands[i];
        if (typeof c === 'object' && c.outlets !== undefined) {
            var r_1 = {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(c.outlets, function (commands, name) {
                if (typeof commands === 'string') {
                    r_1[name] = commands.split('/');
                }
                else {
                    r_1[name] = commands;
                }
            });
            res.push({ outlets: r_1 });
            return "continue";
        }
        if (typeof c === 'object' && c.segmentPath !== undefined) {
            res.push(c.segmentPath);
            return "continue";
        }
        if (!(typeof c === 'string')) {
            res.push(c);
            return "continue";
        }
        if (i === 0) {
            var parts = c.split('/');
            for (var j = 0; j < parts.length; ++j) {
                var cc = parts[j];
                if (j == 0 && cc == '.') {
                }
                else if (j == 0 && cc == '') {
                    isAbsolute = true;
                }
                else if (cc == '..') {
                    numberOfDoubleDots++;
                }
                else if (cc != '') {
                    res.push(cc);
                }
            }
        }
        else {
            res.push(c);
        }
    };
    for (var i = 0; i < commands.length; ++i) {
        _loop_1(i);
    }
    return new NormalizedNavigationCommands(isAbsolute, numberOfDoubleDots, res);
}
var Position = (function () {
    function Position(segmentGroup, processChildren, index) {
        this.segmentGroup = segmentGroup;
        this.processChildren = processChildren;
        this.index = index;
    }
    return Position;
}());
function findStartingPosition(normalizedChange, urlTree, route) {
    if (normalizedChange.isAbsolute) {
        return new Position(urlTree.root, true, 0);
    }
    else if (route.snapshot._lastPathIndex === -1) {
        return new Position(route.snapshot._urlSegment, true, 0);
    }
    else {
        var modifier = isMatrixParams(normalizedChange.commands[0]) ? 0 : 1;
        var index = route.snapshot._lastPathIndex + modifier;
        return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, normalizedChange.numberOfDoubleDots);
    }
}
function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
    var g = group;
    var ci = index;
    var dd = numberOfDoubleDots;
    while (dd > ci) {
        dd -= ci;
        g = g.parent;
        if (!g) {
            throw new Error('Invalid number of \'../\'');
        }
        ci = g.segments.length;
    }
    return new Position(g, false, ci - dd);
}
function getPath(command) {
    if (typeof command === 'object' && command.outlets)
        return command.outlets[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]];
    return "" + command;
}
function getOutlets(commands) {
    if (!(typeof commands[0] === 'object'))
        return (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = commands, _a);
    if (commands[0].outlets === undefined)
        return (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] = commands, _b);
    return commands[0].outlets;
    var _a, _b;
}
function updateSegmentGroup(segmentGroup, startIndex, commands) {
    if (!segmentGroup) {
        segmentGroup = new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"]([], {});
    }
    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
        return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
    }
    var m = prefixedWith(segmentGroup, startIndex, commands);
    var slicedCommands = commands.slice(m.commandIndex);
    if (m.match && m.pathIndex < segmentGroup.segments.length) {
        var g = new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](segmentGroup.segments.slice(0, m.pathIndex), {});
        g.children[__WEBPACK_IMPORTED_MODULE_0__shared__["a" /* PRIMARY_OUTLET */]] =
            new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
        return updateSegmentGroupChildren(g, 0, slicedCommands);
    }
    else if (m.match && slicedCommands.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](segmentGroup.segments, {});
    }
    else if (m.match && !segmentGroup.hasChildren()) {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
    else if (m.match) {
        return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
    }
    else {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
}
function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
    if (commands.length === 0) {
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](segmentGroup.segments, {});
    }
    else {
        var outlets_1 = getOutlets(commands);
        var children_1 = {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(outlets_1, function (commands, outlet) {
            if (commands !== null) {
                children_1[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
            }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(segmentGroup.children, function (child, childOutlet) {
            if (outlets_1[childOutlet] === undefined) {
                children_1[childOutlet] = child;
            }
        });
        return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](segmentGroup.segments, children_1);
    }
}
function prefixedWith(segmentGroup, startIndex, commands) {
    var currentCommandIndex = 0;
    var currentPathIndex = startIndex;
    var noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
    while (currentPathIndex < segmentGroup.segments.length) {
        if (currentCommandIndex >= commands.length)
            return noMatch;
        var path = segmentGroup.segments[currentPathIndex];
        var curr = getPath(commands[currentCommandIndex]);
        var next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
        if (currentPathIndex > 0 && curr === undefined)
            break;
        if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
            if (!compare(curr, next, path))
                return noMatch;
            currentCommandIndex += 2;
        }
        else {
            if (!compare(curr, {}, path))
                return noMatch;
            currentCommandIndex++;
        }
        currentPathIndex++;
    }
    return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
}
function createNewSegmentGroup(segmentGroup, startIndex, commands) {
    var paths = segmentGroup.segments.slice(0, startIndex);
    var i = 0;
    while (i < commands.length) {
        if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
            var children = createNewSegmentChldren(commands[i].outlets);
            return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](paths, children);
        }
        // if we start with an object literal, we need to reuse the path part from the segment
        if (i === 0 && isMatrixParams(commands[0])) {
            var p = segmentGroup.segments[startIndex];
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegment"](p.path, commands[0]));
            i++;
            continue;
        }
        var curr = getPath(commands[i]);
        var next = (i < commands.length - 1) ? commands[i + 1] : null;
        if (curr && next && isMatrixParams(next)) {
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegment"](curr, stringify(next)));
            i += 2;
        }
        else {
            paths.push(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegment"](curr, {}));
            i++;
        }
    }
    return new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"](paths, {});
}
function createNewSegmentChldren(outlets) {
    var children = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(outlets, function (commands, outlet) {
        if (commands !== null) {
            children[outlet] = createNewSegmentGroup(new __WEBPACK_IMPORTED_MODULE_1__url_tree__["UrlSegmentGroup"]([], {}), 0, commands);
        }
    });
    return children;
}
function stringify(params) {
    var res = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["c" /* forEach */])(params, function (v, k) { return res[k] = "" + v; });
    return res;
}
function compare(path, params, segment) {
    return path == segment.path && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_collection__["d" /* shallowEqual */])(params, segment.parameters);
}
//# sourceMappingURL=create_url_tree.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_router_link__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_router_link_active__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_router_outlet__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_module__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_outlet_map__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_preloader__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_state__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__private_export__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_router_link__["RouterLink"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_router_link__["RouterLinkWithHref"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_router_link_active__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_router_outlet__["RouterOutlet"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["NavigationCancel"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["NavigationEnd"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["NavigationError"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["Router"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["RoutesRecognized"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__router__["NavigationStart"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__router_module__["RouterModule"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__router_module__["provideRoutes"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__router_outlet_map__["RouterOutletMap"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__router_preloader__["PreloadAllModules"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__router_preloader__["PreloadingStrategy"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__router_preloader__["NoPreloading"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__router_state__["ActivatedRoute"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__router_state__["ActivatedRouteSnapshot"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__router_state__["RouterState"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_7__router_state__["RouterStateSnapshot"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__shared__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__url_tree__["DefaultUrlSerializer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__url_tree__["UrlSegment"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__url_tree__["UrlSerializer"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__url_tree__["UrlTree"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__private_export__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */











//# sourceMappingURL=index.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_config_loader__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_module__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_collection__ = __webpack_require__(63);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return __router_private__; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var __router_private__ = {
    ROUTER_PROVIDERS: __WEBPACK_IMPORTED_MODULE_1__router_module__["ROUTER_PROVIDERS"],
    ROUTES: __WEBPACK_IMPORTED_MODULE_0__router_config_loader__["ROUTES"],
    flatten: __WEBPACK_IMPORTED_MODULE_2__utils_collection__["a" /* flatten */]
};
//# sourceMappingURL=private_export.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_state__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url_tree__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_collection__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tree__ = __webpack_require__(215);
/* harmony export (immutable) */ exports["a"] = recognize;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */







var NoMatch = (function () {
    function NoMatch() {
    }
    return NoMatch;
}());
function recognize(rootComponentType, config, urlTree, url) {
    return new Recognizer(rootComponentType, config, urlTree, url).recognize();
}
var Recognizer = (function () {
    function Recognizer(rootComponentType, config, urlTree, url) {
        this.rootComponentType = rootComponentType;
        this.config = config;
        this.urlTree = urlTree;
        this.url = url;
    }
    Recognizer.prototype.recognize = function () {
        try {
            var rootSegmentGroup = split(this.urlTree.root, [], [], this.config).segmentGroup;
            var children = this.processSegmentGroup(this.config, rootSegmentGroup, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]);
            var root = new __WEBPACK_IMPORTED_MODULE_2__router_state__["ActivatedRouteSnapshot"]([], Object.freeze({}), Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, {}, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */], this.rootComponentType, null, this.urlTree.root, -1, {});
            var rootNode = new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](root, children);
            var routeState = new __WEBPACK_IMPORTED_MODULE_2__router_state__["RouterStateSnapshot"](this.url, rootNode);
            this.inheriteParamsAndData(routeState._root);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(routeState);
        }
        catch (e) {
            return new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (obs) { return obs.error(e); });
        }
    };
    Recognizer.prototype.inheriteParamsAndData = function (routeNode) {
        var _this = this;
        var route = routeNode.value;
        var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router_state__["inheritedParamsDataResolve"])(route);
        route.params = Object.freeze(i.params);
        route.data = Object.freeze(i.data);
        routeNode.children.forEach(function (n) { return _this.inheriteParamsAndData(n); });
    };
    Recognizer.prototype.processSegmentGroup = function (config, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return this.processChildren(config, segmentGroup);
        }
        else {
            return this.processSegment(config, segmentGroup, 0, segmentGroup.segments, outlet);
        }
    };
    Recognizer.prototype.processChildren = function (config, segmentGroup) {
        var _this = this;
        var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__url_tree__["mapChildrenIntoArray"])(segmentGroup, function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); });
        checkOutletNameUniqueness(children);
        sortActivatedRouteSnapshots(children);
        return children;
    };
    Recognizer.prototype.processSegment = function (config, segmentGroup, pathIndex, segments, outlet) {
        for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
            var r = config_1[_i];
            try {
                return this.processSegmentAgainstRoute(r, segmentGroup, pathIndex, segments, outlet);
            }
            catch (e) {
                if (!(e instanceof NoMatch))
                    throw e;
            }
        }
        throw new NoMatch();
    };
    Recognizer.prototype.processSegmentAgainstRoute = function (route, rawSegment, pathIndex, segments, outlet) {
        if (route.redirectTo)
            throw new NoMatch();
        if ((route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]) !== outlet)
            throw new NoMatch();
        if (route.path === '**') {
            var params = segments.length > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["i" /* last */])(segments).parameters : {};
            var snapshot_1 = new __WEBPACK_IMPORTED_MODULE_2__router_state__["ActivatedRouteSnapshot"](segments, params, Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot_1, [])];
        }
        var _a = match(rawSegment, route, segments), consumedSegments = _a.consumedSegments, parameters = _a.parameters, lastChild = _a.lastChild;
        var rawSlicedSegments = segments.slice(lastChild);
        var childConfig = getChildConfig(route);
        var _b = split(rawSegment, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _b.segmentGroup, slicedSegments = _b.slicedSegments;
        var snapshot = new __WEBPACK_IMPORTED_MODULE_2__router_state__["ActivatedRouteSnapshot"](consumedSegments, parameters, Object.freeze(this.urlTree.queryParams), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
            var children = this.processChildren(childConfig, segmentGroup);
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, children)];
        }
        else if (childConfig.length === 0 && slicedSegments.length === 0) {
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, [])];
        }
        else {
            var children = this.processSegment(childConfig, segmentGroup, pathIndex + lastChild, slicedSegments, __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]);
            return [new __WEBPACK_IMPORTED_MODULE_6__utils_tree__["b" /* TreeNode */](snapshot, children)];
        }
    };
    return Recognizer;
}());
function sortActivatedRouteSnapshots(nodes) {
    nodes.sort(function (a, b) {
        if (a.value.outlet === __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */])
            return -1;
        if (b.value.outlet === __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */])
            return 1;
        return a.value.outlet.localeCompare(b.value.outlet);
    });
}
function getChildConfig(route) {
    if (route.children) {
        return route.children;
    }
    else if (route.loadChildren) {
        return route._loadedConfig.routes;
    }
    else {
        return [];
    }
}
function match(segmentGroup, route, segments) {
    if (route.path === '') {
        if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
            throw new NoMatch();
        }
        else {
            return { consumedSegments: [], lastChild: 0, parameters: {} };
        }
    }
    var path = route.path;
    var parts = path.split('/');
    var posParameters = {};
    var consumedSegments = [];
    var currentIndex = 0;
    for (var i = 0; i < parts.length; ++i) {
        if (currentIndex >= segments.length)
            throw new NoMatch();
        var current = segments[currentIndex];
        var p = parts[i];
        var isPosParam = p.startsWith(':');
        if (!isPosParam && p !== current.path)
            throw new NoMatch();
        if (isPosParam) {
            posParameters[p.substring(1)] = current.path;
        }
        consumedSegments.push(current);
        currentIndex++;
    }
    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || currentIndex < segments.length)) {
        throw new NoMatch();
    }
    var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["g" /* merge */])(posParameters, consumedSegments[consumedSegments.length - 1].parameters);
    return { consumedSegments: consumedSegments, lastChild: currentIndex, parameters: parameters };
}
function checkOutletNameUniqueness(nodes) {
    var names = {};
    nodes.forEach(function (n) {
        var routeWithSameOutletName = names[n.value.outlet];
        if (routeWithSameOutletName) {
            var p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
            var c = n.value.url.map(function (s) { return s.toString(); }).join('/');
            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
        }
        names[n.value.outlet] = n.value;
    });
}
function getSourceSegmentGroup(segmentGroup) {
    var s = segmentGroup;
    while (s._sourceSegment) {
        s = s._sourceSegment;
    }
    return s;
}
function getPathIndexShift(segmentGroup) {
    var s = segmentGroup;
    var res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
    while (s._sourceSegment) {
        s = s._sourceSegment;
        res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
    }
    return res - 1;
}
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"](consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"](slicedSegments, segmentGroup.children)));
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: [] };
    }
    else if (slicedSegments.length === 0 &&
        containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
        var s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"](segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: slicedSegments };
    }
    else {
        var s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"](segmentGroup.segments, segmentGroup.children);
        s._sourceSegment = segmentGroup;
        s._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s, slicedSegments: slicedSegments };
    }
}
function addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var res = {};
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var r = routes_1[_i];
        if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
            var s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"]([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = segmentGroup.segments.length;
            res[getOutlet(r)] = s;
        }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_collection__["g" /* merge */])(children, res);
}
function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
    var res = {};
    res[__WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]] = primarySegment;
    primarySegment._sourceSegment = segmentGroup;
    primarySegment._segmentIndexShift = consumedSegments.length;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var r = routes_2[_i];
        if (r.path === '' && getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]) {
            var s = new __WEBPACK_IMPORTED_MODULE_4__url_tree__["UrlSegmentGroup"]([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = consumedSegments.length;
            res[getOutlet(r)] = s;
        }
    }
    return res;
}
function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes
        .filter(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r) &&
        getOutlet(r) !== __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */]; })
        .length > 0;
}
function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
    return routes.filter(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r); }).length > 0;
}
function emptyPathMatch(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full')
        return false;
    return r.path === '' && r.redirectTo === undefined;
}
function getOutlet(route) {
    return route.outlet ? route.outlet : __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* PRIMARY_OUTLET */];
}
function getData(route) {
    return route.data ? route.data : {};
}
function getResolve(route) {
    return route.resolve ? route.resolve : {};
}
//# sourceMappingURL=recognize.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(548);
__webpack_require__(547);
//# sourceMappingURL=zone-browser.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(27));
//# sourceMappingURL=browser.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports) {

"use strict";
"use strict";
exports.zoneProps = new WeakMap();
var ZoneStore = (function () {
    function ZoneStore(props) {
        if (props === void 0) { props = Object.create(null); }
        var store = new Map();
        try {
            Object.keys(props).forEach(function (prop) {
                store.set(prop, props[prop]);
            });
        }
        catch (e) {
            console.log('e', e);
        }
        exports.zoneProps.set(this, store);
        this.zone = Zone.current.fork({
            name: 'ZoneStore',
            properties: { 'ZoneStore': this }
        });
    }
    ZoneStore.prototype.clear = function () {
        exports.zoneProps.get(this).clear();
    };
    ZoneStore.prototype.setMap = function (obj) {
        var props = exports.zoneProps.get(this);
        for (var _i = 0, obj_1 = obj; _i < obj_1.length; _i++) {
            var prop = obj_1[_i];
            props.set(prop, obj);
        }
    };
    ZoneStore.prototype.get = function (key) {
        var props = exports.zoneProps.get(this);
        if (this.has(key)) {
            return props.get(key);
        }
        return null;
    };
    ZoneStore.prototype.set = function (key, value) {
        var props = exports.zoneProps.get(this);
        if (this.has(key)) {
            props.set(key, value);
            return this;
        }
        return null;
    };
    ZoneStore.prototype.has = function (key) {
        var props = exports.zoneProps.get(this);
        return props.has && props.has(key);
    };
    return ZoneStore;
}());
exports.ZoneStore = ZoneStore;
//# sourceMappingURL=index.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(107);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_RequiredValidator = (function () {
    function Wrapper_RequiredValidator() {
        this.changed = false;
        this.context = new import0.RequiredValidator();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_RequiredValidator.prototype.check_required = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.required = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_RequiredValidator.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_RequiredValidator.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_1 = (this.context.required ? '' : null);
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementAttribute(el, 'required', ((currVal_1 == null) ? null : currVal_1.toString()));
            this._expr_1 = currVal_1;
        }
    };
    return Wrapper_RequiredValidator;
}());
exports.Wrapper_RequiredValidator = Wrapper_RequiredValidator;
var Wrapper_MinLengthValidator = (function () {
    function Wrapper_MinLengthValidator() {
        this.changed = false;
        this.changes = {};
        this.context = new import0.MinLengthValidator();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_MinLengthValidator.prototype.check_minlength = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.minlength = currValue;
            this.changes['minlength'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_MinLengthValidator.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_MinLengthValidator.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_1 = (this.context.minlength ? this.context.minlength : null);
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementAttribute(el, 'minlength', ((currVal_1 == null) ? null : currVal_1.toString()));
            this._expr_1 = currVal_1;
        }
    };
    return Wrapper_MinLengthValidator;
}());
exports.Wrapper_MinLengthValidator = Wrapper_MinLengthValidator;
var Wrapper_MaxLengthValidator = (function () {
    function Wrapper_MaxLengthValidator() {
        this.changed = false;
        this.changes = {};
        this.context = new import0.MaxLengthValidator();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_MaxLengthValidator.prototype.check_maxlength = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.maxlength = currValue;
            this.changes['maxlength'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_MaxLengthValidator.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_MaxLengthValidator.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_1 = (this.context.maxlength ? this.context.maxlength : null);
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementAttribute(el, 'maxlength', ((currVal_1 == null) ? null : currVal_1.toString()));
            this._expr_1 = currVal_1;
        }
    };
    return Wrapper_MaxLengthValidator;
}());
exports.Wrapper_MaxLengthValidator = Wrapper_MaxLengthValidator;
var Wrapper_PatternValidator = (function () {
    function Wrapper_PatternValidator() {
        this.changed = false;
        this.changes = {};
        this.context = new import0.PatternValidator();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_PatternValidator.prototype.check_pattern = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.pattern = currValue;
            this.changes['pattern'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_PatternValidator.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_PatternValidator.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_1 = (this.context.pattern ? this.context.pattern : null);
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementAttribute(el, 'pattern', ((currVal_1 == null) ? null : currVal_1.toString()));
            this._expr_1 = currVal_1;
        }
    };
    return Wrapper_PatternValidator;
}());
exports.Wrapper_PatternValidator = Wrapper_PatternValidator;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(111);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import4 = __webpack_require__(31);
var Wrapper_RouterLink = (function () {
    function Wrapper_RouterLink(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.RouterLink(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
    }
    Wrapper_RouterLink.prototype.check_queryParams = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.queryParams = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_RouterLink.prototype.check_fragment = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.fragment = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_RouterLink.prototype.check_preserveQueryParams = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.preserveQueryParams = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_RouterLink.prototype.check_preserveFragment = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.preserveFragment = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_RouterLink.prototype.check_routerLink = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.routerLink = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_RouterLink.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_RouterLink.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_RouterLink;
}());
exports.Wrapper_RouterLink = Wrapper_RouterLink;
var Wrapper_RouterLinkWithHref = (function () {
    function Wrapper_RouterLinkWithHref(p0, p1, p2) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.RouterLinkWithHref(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    Wrapper_RouterLinkWithHref.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this.changes['target'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_queryParams = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.queryParams = currValue;
            this.changes['queryParams'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_fragment = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.fragment = currValue;
            this.changes['fragment'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_routerLinkOptions = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.routerLinkOptions = currValue;
            this.changes['routerLinkOptions'] = new import1.SimpleChange(this._expr_3, currValue);
            this._expr_3 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_preserveQueryParams = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.preserveQueryParams = currValue;
            this.changes['preserveQueryParams'] = new import1.SimpleChange(this._expr_4, currValue);
            this._expr_4 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_preserveFragment = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.preserveFragment = currValue;
            this.changes['preserveFragment'] = new import1.SimpleChange(this._expr_5, currValue);
            this._expr_5 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.check_routerLink = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_6, currValue))) {
            this.changed = true;
            this.context.routerLink = currValue;
            this.changes['routerLink'] = new import1.SimpleChange(this._expr_6, currValue);
            this._expr_6 = currValue;
        }
    };
    Wrapper_RouterLinkWithHref.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_RouterLinkWithHref.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
        var currVal_7 = this.context.href;
        if (import2.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            view.renderer.setElementProperty(el, 'href', view.viewUtils.sanitizer.sanitize(import4.SecurityContext.URL, currVal_7));
            this._expr_7 = currVal_7;
        }
    };
    return Wrapper_RouterLinkWithHref;
}());
exports.Wrapper_RouterLinkWithHref = Wrapper_RouterLinkWithHref;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
exports.styles = ['@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic);html[_ngcontent-%COMP%], body[_ngcontent-%COMP%]{height:100%}.layout-boxed[_ngcontent-%COMP%]   html[_ngcontent-%COMP%], .layout-boxed[_ngcontent-%COMP%]   body[_ngcontent-%COMP%]{height:100%}body[_ngcontent-%COMP%]{font-family:\'Source Sans Pro\',\'Helvetica Neue\',Helvetica,Arial,sans-serif;font-weight:400;overflow-x:hidden;overflow-y:auto}.wrapper[_ngcontent-%COMP%]{height:100%;position:relative;overflow-x:hidden;overflow-y:auto}.wrapper[_ngcontent-%COMP%]:before, .wrapper[_ngcontent-%COMP%]:after{content:" ";display:table}.wrapper[_ngcontent-%COMP%]:after{clear:both}.layout-boxed[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{max-width:1250px;margin:0 auto;min-height:100%;box-shadow:0 0 8px rgba(0,0,0,0.5);position:relative}.layout-boxed[_ngcontent-%COMP%]{background:url(\'../img/boxed-bg.jpg\') repeat fixed}.content-wrapper[_ngcontent-%COMP%], .right-side[_ngcontent-%COMP%], .main-footer[_ngcontent-%COMP%]{-webkit-transition:-webkit-transform .3s ease-in-out,margin .3s ease-in-out;-moz-transition:-moz-transform .3s ease-in-out,margin .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out,margin .3s ease-in-out;transition:transform .3s ease-in-out,margin .3s ease-in-out;margin-left:230px;z-index:820}.layout-top-nav[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .layout-top-nav[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], .layout-top-nav[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%]{margin-left:0}@media (max-width:767px){.content-wrapper[_ngcontent-%COMP%], .right-side[_ngcontent-%COMP%], .main-footer[_ngcontent-%COMP%]{margin-left:0}}@media (min-width:768px){.sidebar-collapse[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .sidebar-collapse[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], .sidebar-collapse[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%]{margin-left:0}}@media (max-width:767px){.sidebar-open[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .sidebar-open[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], .sidebar-open[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%]{-webkit-transform:translate(230px, 0);-ms-transform:translate(230px, 0);-o-transform:translate(230px, 0);transform:translate(230px, 0)}}.content-wrapper[_ngcontent-%COMP%], .right-side[_ngcontent-%COMP%]{min-height:100%;background-color:#ecf0f5;z-index:800}.main-footer[_ngcontent-%COMP%]{background:#fff;padding:15px;color:#444;border-top:1px solid #d2d6de}.fixed[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%], .fixed[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%], .fixed[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]{position:fixed}.fixed[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]{top:0;right:0;left:0}.fixed[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .fixed[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%]{padding-top:50px}@media (max-width:767px){.fixed[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .fixed[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%]{padding-top:100px}}.fixed.layout-boxed[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{max-width:100%}body.hold-transition[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%], body.hold-transition[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{-webkit-transition:none;-o-transition:none;transition:none}.content[_ngcontent-%COMP%]{min-height:250px;padding:15px;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], .h1[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%]{font-family:\'Source Sans Pro\',sans-serif}a[_ngcontent-%COMP%]{color:#3c8dbc}a[_ngcontent-%COMP%]:hover, a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:focus{outline:none;text-decoration:none;color:#72afd2}.page-header[_ngcontent-%COMP%]{margin:10px 0 20px 0;font-size:22px}.page-header[_ngcontent-%COMP%] > small[_ngcontent-%COMP%]{color:#666;display:block;margin-top:5px}.main-header[_ngcontent-%COMP%]{position:relative;max-height:100px;z-index:1030}.main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]{-webkit-transition:margin-left .3s ease-in-out;-o-transition:margin-left .3s ease-in-out;transition:margin-left .3s ease-in-out;margin-bottom:0;margin-left:230px;border:none;min-height:50px;border-radius:0}.layout-top-nav[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]{margin-left:0}.main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]{background:rgba(255,255,255,0.2);border-color:transparent}.main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]:focus, .main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]:active{border-color:rgba(0,0,0,0.1);background:rgba(255,255,255,0.9)}.main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]::-moz-placeholder{color:#ccc;opacity:1}.main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]:-ms-input-placeholder{color:#ccc}.main-header[_ngcontent-%COMP%]   #navbar-search-input.form-control[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#ccc}.main-header[_ngcontent-%COMP%]   .navbar-custom-menu[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%]   .navbar-right[_ngcontent-%COMP%]{float:right}@media (max-width:991px){.main-header[_ngcontent-%COMP%]   .navbar-custom-menu[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%]   .navbar-right[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:inherit;background:transparent}}@media (max-width:767px){.main-header[_ngcontent-%COMP%]   .navbar-right[_ngcontent-%COMP%]{float:none}.navbar-collapse[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .navbar-right[_ngcontent-%COMP%]{margin:7.5px -15px}.main-header[_ngcontent-%COMP%]   .navbar-right[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{color:inherit;border:0}}.main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]{float:left;background-color:transparent;background-image:none;padding:15px 15px;font-family:fontAwesome}.main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]:before{content:"\\f0c9"}.main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]:hover{color:#fff}.main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]:focus, .main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]:active{background:transparent}.main-header[_ngcontent-%COMP%]   .sidebar-toggle[_ngcontent-%COMP%]   .icon-bar[_ngcontent-%COMP%]{display:none}.main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%] > li.user[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%] > li.user[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%] > li.user[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px}.main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]   .nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]{position:absolute;top:9px;right:7px;text-align:center;font-size:9px;padding:2px 3px;line-height:.9}.main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{-webkit-transition:width .3s ease-in-out;-o-transition:width .3s ease-in-out;transition:width .3s ease-in-out;display:block;float:left;height:50px;font-size:20px;line-height:50px;text-align:center;width:230px;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;padding:0 15px;font-weight:300;overflow:hidden}.main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   .logo-lg[_ngcontent-%COMP%]{display:block}.main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   .logo-mini[_ngcontent-%COMP%]{display:none}.main-header[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]{color:#fff}.content-header[_ngcontent-%COMP%]{position:relative;padding:15px 15px 0 15px}.content-header[_ngcontent-%COMP%] > h1[_ngcontent-%COMP%]{margin:0;font-size:24px}.content-header[_ngcontent-%COMP%] > h1[_ngcontent-%COMP%] > small[_ngcontent-%COMP%]{font-size:15px;display:inline-block;padding-left:4px;font-weight:300}.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%]{float:right;background:transparent;margin-top:0;margin-bottom:0;font-size:12px;padding:7px 5px;position:absolute;top:15px;right:10px;border-radius:2px}.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#444;text-decoration:none;display:inline-block}.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px}.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]:before{content:\'>\\00a0\'}@media (max-width:991px){.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%]{position:relative;margin-top:5px;top:0;right:0;float:none;background:#d2d6de;padding-left:10px}.content-header[_ngcontent-%COMP%] > .breadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{color:#97a0b3}}.navbar-toggle[_ngcontent-%COMP%]{color:#fff;border:0;margin:0;padding:15px 15px}@media (max-width:991px){.navbar-custom-menu[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{float:left}.navbar-custom-menu[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{margin:0;float:left}.navbar-custom-menu[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding-top:15px;padding-bottom:15px;line-height:20px}}@media (max-width:767px){.main-header[_ngcontent-%COMP%]{position:relative}.main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]{width:100%;float:none}.main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]{margin:0}.main-header[_ngcontent-%COMP%]   .navbar-custom-menu[_ngcontent-%COMP%]{float:right}}@media (max-width:991px){.navbar-collapse.pull-left[_ngcontent-%COMP%]{float:none !important}.navbar-collapse.pull-left[_ngcontent-%COMP%] + .navbar-custom-menu[_ngcontent-%COMP%]{display:block;position:absolute;top:0;right:40px}}.main-sidebar[_ngcontent-%COMP%], .left-side[_ngcontent-%COMP%]{position:absolute;top:0;left:0;padding-top:50px;min-height:100%;width:230px;z-index:810;-webkit-transition:-webkit-transform .3s ease-in-out,width .3s ease-in-out;-moz-transition:-moz-transform .3s ease-in-out,width .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out,width .3s ease-in-out;transition:transform .3s ease-in-out,width .3s ease-in-out}@media (max-width:767px){.main-sidebar[_ngcontent-%COMP%], .left-side[_ngcontent-%COMP%]{padding-top:100px}}@media (max-width:767px){.main-sidebar[_ngcontent-%COMP%], .left-side[_ngcontent-%COMP%]{-webkit-transform:translate(-230px, 0);-ms-transform:translate(-230px, 0);-o-transform:translate(-230px, 0);transform:translate(-230px, 0)}}@media (min-width:768px){.sidebar-collapse[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%], .sidebar-collapse[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]{-webkit-transform:translate(-230px, 0);-ms-transform:translate(-230px, 0);-o-transform:translate(-230px, 0);transform:translate(-230px, 0)}}@media (max-width:767px){.sidebar-open[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%], .sidebar-open[_ngcontent-%COMP%]   .left-side[_ngcontent-%COMP%]{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}}.sidebar[_ngcontent-%COMP%]{padding-bottom:10px}.sidebar-form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border-color:transparent}.user-panel[_ngcontent-%COMP%]{position:relative;width:100%;padding:10px;overflow:hidden}.user-panel[_ngcontent-%COMP%]:before, .user-panel[_ngcontent-%COMP%]:after{content:" ";display:table}.user-panel[_ngcontent-%COMP%]:after{clear:both}.user-panel[_ngcontent-%COMP%] > .image[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{width:100%;max-width:45px;height:auto}.user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%]{padding:5px 5px 5px 15px;line-height:1;position:absolute;left:55px}.user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-weight:600;margin-bottom:9px}.user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{text-decoration:none;padding-right:5px;margin-top:3px;font-size:11px}.user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%], .user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%]{margin-right:3px}.sidebar-menu[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0}.sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:relative;margin:0;padding:0}.sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding:12px 5px 12px 15px;display:block}.sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{width:20px}.sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{margin-right:5px}.sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{margin-top:3px}.sidebar-menu[_ngcontent-%COMP%]   li.header[_ngcontent-%COMP%]{padding:10px 25px 10px 15px;font-size:12px}.sidebar-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%]{width:auto;height:auto;padding:0;margin-right:10px}.sidebar-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%]{position:absolute;top:50%;right:10px;margin-top:-8px}.sidebar-menu[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%]{-webkit-transform:rotate(-90deg);-ms-transform:rotate(-90deg);-o-transform:rotate(-90deg);transform:rotate(-90deg)}.sidebar-menu[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%] > .treeview-menu[_ngcontent-%COMP%]{display:block}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%]{display:none;list-style:none;padding:0;margin:0;padding-left:5px}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%]{padding-left:20px}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{margin:0}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding:5px 5px 5px 15px;display:block;font-size:14px}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{width:20px}.sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%] > .fa-angle-down[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa-angle-left[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%]   .treeview-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa-angle-down[_ngcontent-%COMP%]{width:auto}@media (min-width:768px){.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%]{margin-left:50px !important;z-index:840}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%]{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0);width:50px !important;z-index:850}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:relative}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{margin-right:0}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{border-top-right-radius:4px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.treeview) > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .treeview-menu[_ngcontent-%COMP%]{padding-top:5px;padding-bottom:5px;border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:not(.pull-right), .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > .treeview-menu[_ngcontent-%COMP%]{display:block !important;position:absolute;width:180px;left:50px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{top:0;margin-left:-3px;padding:12px 5px 12px 20px;background-color:inherit}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%]{position:relative!important;float:right;width:auto!important;left:180px !important;top:-22px !important;z-index:900}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%] > .label[_ngcontent-%COMP%]:not(:first-of-type){display:none}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover > .treeview-menu[_ngcontent-%COMP%]{top:44px;margin-left:0}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-sidebar[_ngcontent-%COMP%]   .user-panel[_ngcontent-%COMP%] > .info[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-form[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > span[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .treeview-menu[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right[_ngcontent-%COMP%], .sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .sidebar-menu[_ngcontent-%COMP%]   li.header[_ngcontent-%COMP%]{display:none !important;-webkit-transform:translateZ(0)}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{width:50px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%] > .logo-mini[_ngcontent-%COMP%]{display:block;margin-left:-15px;margin-right:-15px;font-size:18px}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%] > .logo-lg[_ngcontent-%COMP%]{display:none}.sidebar-mini.sidebar-collapse[_ngcontent-%COMP%]   .main-header[_ngcontent-%COMP%]   .navbar[_ngcontent-%COMP%]{margin-left:50px}}.sidebar-menu[_ngcontent-%COMP%], .main-sidebar[_ngcontent-%COMP%]   .user-panel[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden}.sidebar-menu[_ngcontent-%COMP%]:hover{overflow:visible}.sidebar-form[_ngcontent-%COMP%], .sidebar-menu[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{overflow:hidden;text-overflow:clip}.sidebar-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative}.sidebar-menu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .pull-right-container[_ngcontent-%COMP%]{position:absolute;right:10px;top:50%;margin-top:-7px}.control-sidebar-bg[_ngcontent-%COMP%]{position:fixed;z-index:1000;bottom:0}.control-sidebar-bg[_ngcontent-%COMP%], .control-sidebar[_ngcontent-%COMP%]{top:0;right:-230px;width:230px;-webkit-transition:right .3s ease-in-out;-o-transition:right .3s ease-in-out;transition:right .3s ease-in-out}.control-sidebar[_ngcontent-%COMP%]{position:absolute;padding-top:50px;z-index:1010}@media (max-width:768px){.control-sidebar[_ngcontent-%COMP%]{padding-top:100px}}.control-sidebar[_ngcontent-%COMP%] > .tab-content[_ngcontent-%COMP%]{padding:10px 15px}.control-sidebar.control-sidebar-open[_ngcontent-%COMP%], .control-sidebar.control-sidebar-open[_ngcontent-%COMP%] + .control-sidebar-bg[_ngcontent-%COMP%]{right:0}.control-sidebar-open[_ngcontent-%COMP%]   .control-sidebar-bg[_ngcontent-%COMP%], .control-sidebar-open[_ngcontent-%COMP%]   .control-sidebar[_ngcontent-%COMP%]{right:0}@media (min-width:768px){.control-sidebar-open[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .control-sidebar-open[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%], .control-sidebar-open[_ngcontent-%COMP%]   .main-footer[_ngcontent-%COMP%]{margin-right:230px}}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type > a[_ngcontent-%COMP%], .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type > a[_ngcontent-%COMP%]:hover, .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type > a[_ngcontent-%COMP%]:focus{border-left-width:0}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-radius:0}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{border-top:none;border-right:none;border-left:1px solid transparent;border-bottom:1px solid transparent}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:16px}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active{border-top:none;border-right:none;border-bottom:none}@media (max-width:768px){.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%]{display:table}.nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{display:table-cell}}.control-sidebar-heading[_ngcontent-%COMP%]{font-weight:400;font-size:16px;padding:10px 0;margin-bottom:10px}.control-sidebar-subheading[_ngcontent-%COMP%]{display:block;font-weight:400;font-size:14px}.control-sidebar-menu[_ngcontent-%COMP%]{list-style:none;padding:0;margin:0 -15px}.control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{display:block;padding:10px 15px}.control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before, .control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{content:" ";display:table}.control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{clear:both}.control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .control-sidebar-subheading[_ngcontent-%COMP%]{margin-top:0}.control-sidebar-menu[_ngcontent-%COMP%]   .menu-icon[_ngcontent-%COMP%]{float:left;width:35px;height:35px;border-radius:50%;text-align:center;line-height:35px}.control-sidebar-menu[_ngcontent-%COMP%]   .menu-info[_ngcontent-%COMP%]{margin-left:45px;margin-top:3px}.control-sidebar-menu[_ngcontent-%COMP%]   .menu-info[_ngcontent-%COMP%] > .control-sidebar-subheading[_ngcontent-%COMP%]{margin:0}.control-sidebar-menu[_ngcontent-%COMP%]   .menu-info[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin:0;font-size:11px}.control-sidebar-menu[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{margin:0}.control-sidebar-dark[_ngcontent-%COMP%]{color:#b8c7ce}.control-sidebar-dark[_ngcontent-%COMP%], .control-sidebar-dark[_ngcontent-%COMP%] + .control-sidebar-bg[_ngcontent-%COMP%]{background:#222d32}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%]{border-bottom:#1c2529}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#181f23;color:#b8c7ce}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{border-left-color:#141a1d;border-bottom-color:#141a1d}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active{background:#1c2529}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{color:#fff}.control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .control-sidebar-dark[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active{background:#222d32;color:#fff}.control-sidebar-dark[_ngcontent-%COMP%]   .control-sidebar-heading[_ngcontent-%COMP%], .control-sidebar-dark[_ngcontent-%COMP%]   .control-sidebar-subheading[_ngcontent-%COMP%]{color:#fff}.control-sidebar-dark[_ngcontent-%COMP%]   .control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#1e282c}.control-sidebar-dark[_ngcontent-%COMP%]   .control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .menu-info[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:#b8c7ce}.control-sidebar-light[_ngcontent-%COMP%]{color:#5e5e5e}.control-sidebar-light[_ngcontent-%COMP%], .control-sidebar-light[_ngcontent-%COMP%] + .control-sidebar-bg[_ngcontent-%COMP%]{background:#f9fafc;border-left:1px solid #d2d6de}.control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%]{border-bottom:#d2d6de}.control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#e8ecf4;color:#444}.control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{border-left-color:#d2d6de;border-bottom-color:#d2d6de}.control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active{background:#eff1f7}.control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .control-sidebar-light[_ngcontent-%COMP%]   .nav-tabs.control-sidebar-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active{background:#f9fafc;color:#111}.control-sidebar-light[_ngcontent-%COMP%]   .control-sidebar-heading[_ngcontent-%COMP%], .control-sidebar-light[_ngcontent-%COMP%]   .control-sidebar-subheading[_ngcontent-%COMP%]{color:#111}.control-sidebar-light[_ngcontent-%COMP%]   .control-sidebar-menu[_ngcontent-%COMP%]{margin-left:-14px}.control-sidebar-light[_ngcontent-%COMP%]   .control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#f4f4f5}.control-sidebar-light[_ngcontent-%COMP%]   .control-sidebar-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .menu-info[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{color:#5e5e5e}.dropdown-menu[_ngcontent-%COMP%]{box-shadow:none;border-color:#eee}.dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#777}.dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:10px}.dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background-color:#e1e3e9;color:#333}.dropdown-menu[_ngcontent-%COMP%] > .divider[_ngcontent-%COMP%]{background-color:#eee}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%]{width:280px;padding:0 0 0 0;margin:0;top:100%}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:relative}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0;background-color:#ffffff;padding:7px 10px;border-bottom:1px solid #f4f4f4;color:#444444;font-size:14px}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px;font-size:12px;background-color:#fff;padding:7px 10px;border-bottom:1px solid #eeeeee;color:#444 !important;text-align:center}@media (max-width:991px){.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#fff !important;color:#444 !important}}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.footer[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{text-decoration:none;font-weight:normal}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%]{max-height:200px;margin:0;padding:0;list-style:none;overflow-x:hidden}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{display:block;white-space:nowrap;border-bottom:1px solid #f4f4f4}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:#f4f4f4;text-decoration:none}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#444444;overflow:hidden;text-overflow:ellipsis;padding:10px}.navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .notifications-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{width:20px}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{margin:0;padding:10px 10px}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{margin:auto 10px auto auto;width:40px;height:40px}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > h4[_ngcontent-%COMP%]{padding:0;margin:0 0 0 45px;color:#444444;font-size:15px;position:relative}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > h4[_ngcontent-%COMP%] > small[_ngcontent-%COMP%]{color:#999999;font-size:10px;position:absolute;top:0;right:0}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin:0 0 0 45px;font-size:12px;color:#888888}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before, .navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{content:" ";display:table}.navbar-nav[_ngcontent-%COMP%] > .messages-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:after{clear:both}.navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding:10px}.navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > h3[_ngcontent-%COMP%]{font-size:14px;padding:0;margin:0 0 10px 0;color:#666666}.navbar-nav[_ngcontent-%COMP%] > .tasks-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .progress[_ngcontent-%COMP%]{padding:0;margin:0}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%]{border-top-right-radius:0;border-top-left-radius:0;padding:1px 0 0 0;border-top-width:0;width:280px}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%], .navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.user-header[_ngcontent-%COMP%]{height:175px;padding:10px;text-align:center}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.user-header[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{z-index:5;height:90px;width:90px;border:3px solid;border-color:transparent;border-color:rgba(255,255,255,0.2)}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.user-header[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{z-index:5;color:#fff;color:rgba(255,255,255,0.8);font-size:17px;margin-top:10px}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > li.user-header[_ngcontent-%COMP%] > p[_ngcontent-%COMP%] > small[_ngcontent-%COMP%]{display:block;font-size:12px}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]{padding:15px;border-bottom:1px solid #f4f4f4;border-top:1px solid #dddddd}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]:before, .navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]:after{content:" ";display:table}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]:after{clear:both}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#444 !important}@media (max-width:991px){.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{background:#fff !important;color:#444 !important}}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]{background-color:#f9f9f9;padding:10px}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]:before, .navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]:after{content:" ";display:table}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]:after{clear:both}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]   .btn-default[_ngcontent-%COMP%]{color:#666666}@media (max-width:991px){.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%] > .user-footer[_ngcontent-%COMP%]   .btn-default[_ngcontent-%COMP%]:hover{background-color:#f9f9f9}}.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%]   .user-image[_ngcontent-%COMP%]{float:left;width:25px;height:25px;border-radius:50%;margin-right:10px;margin-top:-2px}@media (max-width:767px){.navbar-nav[_ngcontent-%COMP%] > .user-menu[_ngcontent-%COMP%]   .user-image[_ngcontent-%COMP%]{float:none;margin-right:0;margin-top:-8px;line-height:10px}}.open[_ngcontent-%COMP%]:not(.dropup) > .animated-dropdown-menu[_ngcontent-%COMP%]{backface-visibility:visible !important;-webkit-animation:flipInX .7s both;-o-animation:flipInX .7s both;animation:flipInX .7s both}@keyframes flipInX{0%{transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}100%{transform:perspective(400px)}}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);-webkit-transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);-webkit-transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}100%{-webkit-transform:perspective(400px)}}.navbar-custom-menu[_ngcontent-%COMP%] > .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:relative}.navbar-custom-menu[_ngcontent-%COMP%] > .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%]{position:absolute;right:0;left:auto}@media (max-width:991px){.navbar-custom-menu[_ngcontent-%COMP%] > .navbar-nav[_ngcontent-%COMP%]{float:right}.navbar-custom-menu[_ngcontent-%COMP%] > .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:static}.navbar-custom-menu[_ngcontent-%COMP%] > .navbar-nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .dropdown-menu[_ngcontent-%COMP%]{position:absolute;right:5%;left:auto;border:1px solid #ddd;background:#fff}}.form-control[_ngcontent-%COMP%]{border-radius:0;box-shadow:none;border-color:#d2d6de}.form-control[_ngcontent-%COMP%]:focus{border-color:#3c8dbc;box-shadow:none}.form-control[_ngcontent-%COMP%]::-moz-placeholder, .form-control[_ngcontent-%COMP%]:-ms-input-placeholder, .form-control[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#bbb;opacity:1}.form-control[_ngcontent-%COMP%]:not(select){-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-group.has-success[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#00a65a}.form-group.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], .form-group.has-success[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%]{border-color:#00a65a;box-shadow:none}.form-group.has-success[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%]{color:#00a65a}.form-group.has-warning[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#f39c12}.form-group.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], .form-group.has-warning[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%]{border-color:#f39c12;box-shadow:none}.form-group.has-warning[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%]{color:#f39c12}.form-group.has-error[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#dd4b39}.form-group.has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], .form-group.has-error[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%]{border-color:#dd4b39;box-shadow:none}.form-group.has-error[_ngcontent-%COMP%]   .help-block[_ngcontent-%COMP%]{color:#dd4b39}.input-group[_ngcontent-%COMP%]   .input-group-addon[_ngcontent-%COMP%]{border-radius:0;border-color:#d2d6de;background-color:#fff}.btn-group-vertical[_ngcontent-%COMP%]   .btn.btn-flat[_ngcontent-%COMP%]:first-of-type, .btn-group-vertical[_ngcontent-%COMP%]   .btn.btn-flat[_ngcontent-%COMP%]:last-of-type{border-radius:0}.icheck[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{padding-left:0}.form-control-feedback.fa[_ngcontent-%COMP%]{line-height:34px}.input-lg[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%], .form-group-lg[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%]{line-height:46px}.input-sm[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%], .form-group-sm[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%] + .form-control-feedback.fa[_ngcontent-%COMP%]{line-height:30px}.progress[_ngcontent-%COMP%], .progress[_ngcontent-%COMP%] > .progress-bar[_ngcontent-%COMP%]{-webkit-box-shadow:none;box-shadow:none}.progress[_ngcontent-%COMP%], .progress[_ngcontent-%COMP%] > .progress-bar[_ngcontent-%COMP%], .progress[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress[_ngcontent-%COMP%] > .progress-bar[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:1px}.progress.sm[_ngcontent-%COMP%], .progress-sm[_ngcontent-%COMP%]{height:10px}.progress.sm[_ngcontent-%COMP%], .progress-sm[_ngcontent-%COMP%], .progress.sm[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress-sm[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:1px}.progress.xs[_ngcontent-%COMP%], .progress-xs[_ngcontent-%COMP%]{height:7px}.progress.xs[_ngcontent-%COMP%], .progress-xs[_ngcontent-%COMP%], .progress.xs[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress-xs[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:1px}.progress.xxs[_ngcontent-%COMP%], .progress-xxs[_ngcontent-%COMP%]{height:3px}.progress.xxs[_ngcontent-%COMP%], .progress-xxs[_ngcontent-%COMP%], .progress.xxs[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%], .progress-xxs[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:1px}.progress.vertical[_ngcontent-%COMP%]{position:relative;width:30px;height:200px;display:inline-block;margin-right:10px}.progress.vertical[_ngcontent-%COMP%] > .progress-bar[_ngcontent-%COMP%]{width:100%;position:absolute;bottom:0}.progress.vertical.sm[_ngcontent-%COMP%], .progress.vertical.progress-sm[_ngcontent-%COMP%]{width:20px}.progress.vertical.xs[_ngcontent-%COMP%], .progress.vertical.progress-xs[_ngcontent-%COMP%]{width:10px}.progress.vertical.xxs[_ngcontent-%COMP%], .progress.vertical.progress-xxs[_ngcontent-%COMP%]{width:3px}.progress-group[_ngcontent-%COMP%]   .progress-text[_ngcontent-%COMP%]{font-weight:600}.progress-group[_ngcontent-%COMP%]   .progress-number[_ngcontent-%COMP%]{float:right}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{margin:0}.progress-bar-light-blue[_ngcontent-%COMP%], .progress-bar-primary[_ngcontent-%COMP%]{background-color:#3c8dbc}.progress-striped[_ngcontent-%COMP%]   .progress-bar-light-blue[_ngcontent-%COMP%], .progress-striped[_ngcontent-%COMP%]   .progress-bar-primary[_ngcontent-%COMP%]{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-green[_ngcontent-%COMP%], .progress-bar-success[_ngcontent-%COMP%]{background-color:#00a65a}.progress-striped[_ngcontent-%COMP%]   .progress-bar-green[_ngcontent-%COMP%], .progress-striped[_ngcontent-%COMP%]   .progress-bar-success[_ngcontent-%COMP%]{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-aqua[_ngcontent-%COMP%], .progress-bar-info[_ngcontent-%COMP%]{background-color:#00c0ef}.progress-striped[_ngcontent-%COMP%]   .progress-bar-aqua[_ngcontent-%COMP%], .progress-striped[_ngcontent-%COMP%]   .progress-bar-info[_ngcontent-%COMP%]{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-yellow[_ngcontent-%COMP%], .progress-bar-warning[_ngcontent-%COMP%]{background-color:#f39c12}.progress-striped[_ngcontent-%COMP%]   .progress-bar-yellow[_ngcontent-%COMP%], .progress-striped[_ngcontent-%COMP%]   .progress-bar-warning[_ngcontent-%COMP%]{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-red[_ngcontent-%COMP%], .progress-bar-danger[_ngcontent-%COMP%]{background-color:#dd4b39}.progress-striped[_ngcontent-%COMP%]   .progress-bar-red[_ngcontent-%COMP%], .progress-striped[_ngcontent-%COMP%]   .progress-bar-danger[_ngcontent-%COMP%]{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.small-box[_ngcontent-%COMP%]{border-radius:2px;position:relative;display:block;margin-bottom:20px;box-shadow:0 1px 1px rgba(0,0,0,0.1)}.small-box[_ngcontent-%COMP%] > .inner[_ngcontent-%COMP%]{padding:10px}.small-box[_ngcontent-%COMP%] > .small-box-footer[_ngcontent-%COMP%]{position:relative;text-align:center;padding:3px 0;color:#fff;color:rgba(255,255,255,0.8);display:block;z-index:10;background:rgba(0,0,0,0.1);text-decoration:none}.small-box[_ngcontent-%COMP%] > .small-box-footer[_ngcontent-%COMP%]:hover{color:#fff;background:rgba(0,0,0,0.15)}.small-box[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:38px;font-weight:bold;margin:0 0 10px 0;white-space:nowrap;padding:0}.small-box[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:15px}.small-box[_ngcontent-%COMP%]   p[_ngcontent-%COMP%] > small[_ngcontent-%COMP%]{display:block;color:#f9f9f9;font-size:13px;margin-top:5px}.small-box[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .small-box[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{z-index:5}.small-box[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear;position:absolute;top:-10px;right:10px;z-index:0;font-size:90px;color:rgba(0,0,0,0.15)}.small-box[_ngcontent-%COMP%]:hover{text-decoration:none;color:#f9f9f9}.small-box[_ngcontent-%COMP%]:hover   .icon[_ngcontent-%COMP%]{font-size:95px}@media (max-width:767px){.small-box[_ngcontent-%COMP%]{text-align:center}.small-box[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:none}.small-box[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:12px}}.box[_ngcontent-%COMP%]{position:relative;border-radius:3px;background:#ffffff;border-top:3px solid #d2d6de;margin-bottom:20px;width:100%;box-shadow:0 1px 1px rgba(0,0,0,0.1)}.box.box-primary[_ngcontent-%COMP%]{border-top-color:#3c8dbc}.box.box-info[_ngcontent-%COMP%]{border-top-color:#00c0ef}.box.box-danger[_ngcontent-%COMP%]{border-top-color:#dd4b39}.box.box-warning[_ngcontent-%COMP%]{border-top-color:#f39c12}.box.box-success[_ngcontent-%COMP%]{border-top-color:#00a65a}.box.box-default[_ngcontent-%COMP%]{border-top-color:#d2d6de}.box.collapsed-box[_ngcontent-%COMP%]   .box-body[_ngcontent-%COMP%], .box.collapsed-box[_ngcontent-%COMP%]   .box-footer[_ngcontent-%COMP%]{display:none}.box[_ngcontent-%COMP%]   .nav-stacked[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{border-bottom:1px solid #f4f4f4;margin:0}.box[_ngcontent-%COMP%]   .nav-stacked[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:last-of-type{border-bottom:none}.box.height-control[_ngcontent-%COMP%]   .box-body[_ngcontent-%COMP%]{max-height:300px;overflow:auto}.box[_ngcontent-%COMP%]   .border-right[_ngcontent-%COMP%]{border-right:1px solid #f4f4f4}.box[_ngcontent-%COMP%]   .border-left[_ngcontent-%COMP%]{border-left:1px solid #f4f4f4}.box.box-solid[_ngcontent-%COMP%]{border-top:0}.box.box-solid[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn.btn-default[_ngcontent-%COMP%]{background:transparent}.box.box-solid[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover, .box.box-solid[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{background:rgba(0,0,0,0.1)}.box.box-solid.box-default[_ngcontent-%COMP%]{border:1px solid #d2d6de}.box.box-solid.box-default[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#444;background:#d2d6de;background-color:#d2d6de}.box.box-solid.box-default[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-default[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#444}.box.box-solid.box-primary[_ngcontent-%COMP%]{border:1px solid #3c8dbc}.box.box-solid.box-primary[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff;background:#3c8dbc;background-color:#3c8dbc}.box.box-solid.box-primary[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-primary[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff}.box.box-solid.box-info[_ngcontent-%COMP%]{border:1px solid #00c0ef}.box.box-solid.box-info[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff;background:#00c0ef;background-color:#00c0ef}.box.box-solid.box-info[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-info[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff}.box.box-solid.box-danger[_ngcontent-%COMP%]{border:1px solid #dd4b39}.box.box-solid.box-danger[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff;background:#dd4b39;background-color:#dd4b39}.box.box-solid.box-danger[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-danger[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff}.box.box-solid.box-warning[_ngcontent-%COMP%]{border:1px solid #f39c12}.box.box-solid.box-warning[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff;background:#f39c12;background-color:#f39c12}.box.box-solid.box-warning[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-warning[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff}.box.box-solid.box-success[_ngcontent-%COMP%]{border:1px solid #00a65a}.box.box-solid.box-success[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff;background:#00a65a;background-color:#00a65a}.box.box-solid.box-success[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .box.box-solid.box-success[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{color:#fff}.box.box-solid[_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%] > .box-tools[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{border:0;box-shadow:none}.box.box-solid[class*=\'bg\'][_ngcontent-%COMP%] > .box-header[_ngcontent-%COMP%]{color:#fff}.box[_ngcontent-%COMP%]   .box-group[_ngcontent-%COMP%] > .box[_ngcontent-%COMP%]{margin-bottom:5px}.box[_ngcontent-%COMP%]   .knob-label[_ngcontent-%COMP%]{text-align:center;color:#333;font-weight:100;font-size:12px;margin-bottom:0.3em}.box[_ngcontent-%COMP%] > .overlay[_ngcontent-%COMP%], .overlay-wrapper[_ngcontent-%COMP%] > .overlay[_ngcontent-%COMP%], .box[_ngcontent-%COMP%] > .loading-img[_ngcontent-%COMP%], .overlay-wrapper[_ngcontent-%COMP%] > .loading-img[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}.box[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%], .overlay-wrapper[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%]{z-index:50;background:rgba(255,255,255,0.7);border-radius:3px}.box[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .overlay-wrapper[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.box[_ngcontent-%COMP%]   .overlay.dark[_ngcontent-%COMP%], .overlay-wrapper[_ngcontent-%COMP%]   .overlay.dark[_ngcontent-%COMP%]{background:rgba(0,0,0,0.5)}.box-header[_ngcontent-%COMP%]:before, .box-body[_ngcontent-%COMP%]:before, .box-footer[_ngcontent-%COMP%]:before, .box-header[_ngcontent-%COMP%]:after, .box-body[_ngcontent-%COMP%]:after, .box-footer[_ngcontent-%COMP%]:after{content:" ";display:table}.box-header[_ngcontent-%COMP%]:after, .box-body[_ngcontent-%COMP%]:after, .box-footer[_ngcontent-%COMP%]:after{clear:both}.box-header[_ngcontent-%COMP%]{color:#444;display:block;padding:10px;position:relative}.box-header.with-border[_ngcontent-%COMP%]{border-bottom:1px solid #f4f4f4}.collapsed-box[_ngcontent-%COMP%]   .box-header.with-border[_ngcontent-%COMP%]{border-bottom:none}.box-header[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%]   .box-title[_ngcontent-%COMP%]{display:inline-block;font-size:18px;margin:0;line-height:1}.box-header[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px}.box-header[_ngcontent-%COMP%] > .box-tools[_ngcontent-%COMP%]{position:absolute;right:10px;top:5px}.box-header[_ngcontent-%COMP%] > .box-tools[_ngcontent-%COMP%]   [data-toggle="tooltip"][_ngcontent-%COMP%]{position:relative}.box-header[_ngcontent-%COMP%] > .box-tools.pull-right[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{right:0;left:auto}.box-header[_ngcontent-%COMP%] > .box-tools[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#444!important}.btn-box-tool[_ngcontent-%COMP%]{padding:5px;font-size:12px;background:transparent;color:#97a0b3}.open[_ngcontent-%COMP%]   .btn-box-tool[_ngcontent-%COMP%], .btn-box-tool[_ngcontent-%COMP%]:hover{color:#606c84}.btn-box-tool.btn[_ngcontent-%COMP%]:active{box-shadow:none}.box-body[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;padding:10px}.no-header[_ngcontent-%COMP%]   .box-body[_ngcontent-%COMP%]{border-top-right-radius:3px;border-top-left-radius:3px}.box-body[_ngcontent-%COMP%] > .table[_ngcontent-%COMP%]{margin-bottom:0}.box-body[_ngcontent-%COMP%]   .fc[_ngcontent-%COMP%]{margin-top:5px}.box-body[_ngcontent-%COMP%]   .full-width-chart[_ngcontent-%COMP%]{margin:-19px}.box-body.no-padding[_ngcontent-%COMP%]   .full-width-chart[_ngcontent-%COMP%]{margin:-9px}.box-body[_ngcontent-%COMP%]   .box-pane[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:3px}.box-body[_ngcontent-%COMP%]   .box-pane-right[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:0}.box-footer[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;border-top:1px solid #f4f4f4;padding:10px;background-color:#fff}.chart-legend[_ngcontent-%COMP%]{margin:10px 0}@media (max-width:991px){.chart-legend[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{float:left;margin-right:10px}}.box-comments[_ngcontent-%COMP%]{background:#f7f7f7}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]{padding:8px 0;border-bottom:1px solid #eee}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]:before, .box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]:after{content:" ";display:table}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]:after{clear:both}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]:last-of-type{border-bottom:0}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]:first-of-type{padding-top:0}.box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{float:left}.box-comments[_ngcontent-%COMP%]   .comment-text[_ngcontent-%COMP%]{margin-left:40px;color:#555}.box-comments[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{color:#444;display:block;font-weight:600}.box-comments[_ngcontent-%COMP%]   .text-muted[_ngcontent-%COMP%]{font-weight:400;font-size:12px}.todo-list[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;overflow:auto}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{border-radius:2px;padding:10px;background:#f4f4f4;margin-bottom:2px;border-left:2px solid #e6e7e8;color:#444}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:last-of-type{margin-bottom:0}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > input[type=\'checkbox\'][_ngcontent-%COMP%]{margin:0 10px 0 5px}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{display:inline-block;margin-left:5px;font-weight:600}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:10px;font-size:9px}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%]{display:none;float:right;color:#dd4b39}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px;cursor:pointer}.todo-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:hover   .tools[_ngcontent-%COMP%]{display:inline-block}.todo-list[_ngcontent-%COMP%] > li.done[_ngcontent-%COMP%]{color:#999}.todo-list[_ngcontent-%COMP%] > li.done[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{text-decoration:line-through;font-weight:500}.todo-list[_ngcontent-%COMP%] > li.done[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{background:#d2d6de !important}.todo-list[_ngcontent-%COMP%]   .danger[_ngcontent-%COMP%]{border-left-color:#dd4b39}.todo-list[_ngcontent-%COMP%]   .warning[_ngcontent-%COMP%]{border-left-color:#f39c12}.todo-list[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{border-left-color:#00c0ef}.todo-list[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]{border-left-color:#00a65a}.todo-list[_ngcontent-%COMP%]   .primary[_ngcontent-%COMP%]{border-left-color:#3c8dbc}.todo-list[_ngcontent-%COMP%]   .handle[_ngcontent-%COMP%]{display:inline-block;cursor:move;margin:0 5px}.chat[_ngcontent-%COMP%]{padding:5px 20px 5px 10px}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{margin-bottom:10px}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]:before, .chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]:after{content:" ";display:table}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]:after{clear:both}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{width:40px;height:40px;border:2px solid transparent;border-radius:50%}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .online[_ngcontent-%COMP%]{border:2px solid #00a65a}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .offline[_ngcontent-%COMP%]{border:2px solid #dd4b39}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .message[_ngcontent-%COMP%]{margin-left:55px;margin-top:-40px}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .message[_ngcontent-%COMP%] > .name[_ngcontent-%COMP%]{display:block;font-weight:600}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%]{border-radius:3px;background:#f4f4f4;margin-left:65px;margin-right:15px;padding:10px}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%] > h4[_ngcontent-%COMP%]{margin:0 0 5px 0;font-weight:600;font-size:14px}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%] > p[_ngcontent-%COMP%], .chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%] > .filename[_ngcontent-%COMP%]{font-weight:600;font-size:13px;font-style:italic;margin:0}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%]:before, .chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%]:after{content:" ";display:table}.chat[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] > .attachment[_ngcontent-%COMP%]:after{clear:both}.box-input[_ngcontent-%COMP%]{max-width:200px}.modal[_ngcontent-%COMP%]   .panel-body[_ngcontent-%COMP%]{color:#444}.info-box[_ngcontent-%COMP%]{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:2px;margin-bottom:15px}.info-box[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]{font-size:14px}.info-box[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{background:rgba(0,0,0,0.2);margin:5px -10px 5px -10px;height:2px}.info-box[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%], .info-box[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{border-radius:0}.info-box[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{background:#fff}.info-box-icon[_ngcontent-%COMP%]{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;height:90px;width:90px;text-align:center;font-size:45px;line-height:90px;background:rgba(0,0,0,0.2)}.info-box-icon[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{max-width:100%}.info-box-content[_ngcontent-%COMP%]{padding:5px 10px;margin-left:90px}.info-box-number[_ngcontent-%COMP%]{display:block;font-weight:bold;font-size:18px}.progress-description[_ngcontent-%COMP%], .info-box-text[_ngcontent-%COMP%]{display:block;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info-box-text[_ngcontent-%COMP%]{text-transform:uppercase}.info-box-more[_ngcontent-%COMP%]{display:block}.progress-description[_ngcontent-%COMP%]{margin:0}.timeline[_ngcontent-%COMP%]{position:relative;margin:0 0 30px 0;padding:0;list-style:none}.timeline[_ngcontent-%COMP%]:before{content:\'\';position:absolute;top:0;bottom:0;width:4px;background:#ddd;left:31px;margin:0;border-radius:2px}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{position:relative;margin-right:10px;margin-bottom:15px}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:before, .timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:after{content:" ";display:table}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:after{clear:both}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%]{-webkit-box-shadow:0 1px 1px rgba(0,0,0,0.1);box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px;margin-top:0;background:#fff;color:#444;margin-left:60px;margin-right:15px;padding:0;position:relative}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .time[_ngcontent-%COMP%]{color:#999;float:right;padding:10px;font-size:12px}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .timeline-header[_ngcontent-%COMP%]{margin:0;color:#555;border-bottom:1px solid #f4f4f4;padding:10px;font-size:16px;line-height:1.1}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .timeline-header[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-weight:600}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .timeline-body[_ngcontent-%COMP%], .timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .timeline-footer[_ngcontent-%COMP%]{padding:10px}.timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .timeline[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{width:30px;height:30px;font-size:15px;line-height:30px;position:absolute;color:#666;background:#d2d6de;border-radius:50%;text-align:center;left:18px;top:0}.timeline[_ngcontent-%COMP%] > .time-label[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-weight:600;padding:5px;display:inline-block;background-color:#fff;border-radius:4px}.timeline-inverse[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%]{background:#f0f0f0;border:1px solid #ddd;-webkit-box-shadow:none;box-shadow:none}.timeline-inverse[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > .timeline-item[_ngcontent-%COMP%] > .timeline-header[_ngcontent-%COMP%]{border-bottom-color:#ddd}.btn[_ngcontent-%COMP%]{border-radius:3px;-webkit-box-shadow:none;box-shadow:none;border:1px solid transparent}.btn.uppercase[_ngcontent-%COMP%]{text-transform:uppercase}.btn.btn-flat[_ngcontent-%COMP%]{border-radius:0;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;border-width:1px}.btn[_ngcontent-%COMP%]:active{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);box-shadow:inset 0 3px 5px rgba(0,0,0,0.125)}.btn[_ngcontent-%COMP%]:focus{outline:none}.btn.btn-file[_ngcontent-%COMP%]{position:relative;overflow:hidden}.btn.btn-file[_ngcontent-%COMP%] > input[type=\'file\'][_ngcontent-%COMP%]{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;opacity:0;filter:alpha(opacity=0);outline:none;background:white;cursor:inherit;display:block}.btn-default[_ngcontent-%COMP%]{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-default[_ngcontent-%COMP%]:hover, .btn-default[_ngcontent-%COMP%]:active, .btn-default.hover[_ngcontent-%COMP%]{background-color:#e7e7e7}.btn-primary[_ngcontent-%COMP%]{background-color:#3c8dbc;border-color:#367fa9}.btn-primary[_ngcontent-%COMP%]:hover, .btn-primary[_ngcontent-%COMP%]:active, .btn-primary.hover[_ngcontent-%COMP%]{background-color:#367fa9}.btn-success[_ngcontent-%COMP%]{background-color:#00a65a;border-color:#008d4c}.btn-success[_ngcontent-%COMP%]:hover, .btn-success[_ngcontent-%COMP%]:active, .btn-success.hover[_ngcontent-%COMP%]{background-color:#008d4c}.btn-info[_ngcontent-%COMP%]{background-color:#00c0ef;border-color:#00acd6}.btn-info[_ngcontent-%COMP%]:hover, .btn-info[_ngcontent-%COMP%]:active, .btn-info.hover[_ngcontent-%COMP%]{background-color:#00acd6}.btn-danger[_ngcontent-%COMP%]{background-color:#dd4b39;border-color:#d73925}.btn-danger[_ngcontent-%COMP%]:hover, .btn-danger[_ngcontent-%COMP%]:active, .btn-danger.hover[_ngcontent-%COMP%]{background-color:#d73925}.btn-warning[_ngcontent-%COMP%]{background-color:#f39c12;border-color:#e08e0b}.btn-warning[_ngcontent-%COMP%]:hover, .btn-warning[_ngcontent-%COMP%]:active, .btn-warning.hover[_ngcontent-%COMP%]{background-color:#e08e0b}.btn-outline[_ngcontent-%COMP%]{border:1px solid #fff;background:transparent;color:#fff}.btn-outline[_ngcontent-%COMP%]:hover, .btn-outline[_ngcontent-%COMP%]:focus, .btn-outline[_ngcontent-%COMP%]:active{color:rgba(255,255,255,0.7);border-color:rgba(255,255,255,0.7)}.btn-link[_ngcontent-%COMP%]{-webkit-box-shadow:none;box-shadow:none}.btn[class*=\'bg-\'][_ngcontent-%COMP%]:hover{-webkit-box-shadow:inset 0 0 100px rgba(0,0,0,0.2);box-shadow:inset 0 0 100px rgba(0,0,0,0.2)}.btn-app[_ngcontent-%COMP%]{border-radius:3px;position:relative;padding:15px 5px;margin:0 0 10px 10px;min-width:80px;height:60px;text-align:center;color:#666;border:1px solid #ddd;background-color:#f4f4f4;font-size:12px}.btn-app[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .btn-app[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .btn-app[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{font-size:20px;display:block}.btn-app[_ngcontent-%COMP%]:hover{background:#f4f4f4;color:#444;border-color:#aaa}.btn-app[_ngcontent-%COMP%]:active, .btn-app[_ngcontent-%COMP%]:focus{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);box-shadow:inset 0 3px 5px rgba(0,0,0,0.125)}.btn-app[_ngcontent-%COMP%] > .badge[_ngcontent-%COMP%]{position:absolute;top:-3px;right:-10px;font-size:10px;font-weight:400}.callout[_ngcontent-%COMP%]{border-radius:3px;margin:0 0 20px 0;padding:15px 30px 15px 15px;border-left:5px solid #eee}.callout[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;text-decoration:underline}.callout[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#eee}.callout[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:0;font-weight:600}.callout[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:last-child{margin-bottom:0}.callout[_ngcontent-%COMP%]   code[_ngcontent-%COMP%], .callout[_ngcontent-%COMP%]   .highlight[_ngcontent-%COMP%]{background-color:#fff}.callout.callout-danger[_ngcontent-%COMP%]{border-color:#c23321}.callout.callout-warning[_ngcontent-%COMP%]{border-color:#c87f0a}.callout.callout-info[_ngcontent-%COMP%]{border-color:#0097bc}.callout.callout-success[_ngcontent-%COMP%]{border-color:#00733e}.alert[_ngcontent-%COMP%]{border-radius:3px}.alert[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600}.alert[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-right:10px}.alert[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{color:#000;opacity:.2;filter:alpha(opacity=20)}.alert[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:hover{opacity:.5;filter:alpha(opacity=50)}.alert[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;text-decoration:underline}.alert-success[_ngcontent-%COMP%]{border-color:#008d4c}.alert-danger[_ngcontent-%COMP%], .alert-error[_ngcontent-%COMP%]{border-color:#d73925}.alert-warning[_ngcontent-%COMP%]{border-color:#e08e0b}.alert-info[_ngcontent-%COMP%]{border-color:#00acd6}.nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active, .nav[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{color:#444;background:#f7f7f7}.nav-pills[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-radius:0;border-top:3px solid transparent;color:#444}.nav-pills[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px}.nav-pills[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .nav-pills[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{border-top-color:#3c8dbc}.nav-pills[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-weight:600}.nav-stacked[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-radius:0;border-top:0;border-left:3px solid transparent;color:#444}.nav-stacked[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-stacked[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:transparent;color:#444;border-top:0;border-left-color:#3c8dbc}.nav-stacked[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{border-bottom:1px solid #ddd;color:#777;margin-bottom:10px;padding:5px 10px;text-transform:uppercase}.nav-tabs-custom[_ngcontent-%COMP%]{margin-bottom:20px;background:#fff;box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%]{margin:0;border-bottom-color:#f4f4f4;border-top-right-radius:3px;border-top-left-radius:3px}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{border-top:3px solid transparent;margin-bottom:-2px;margin-right:5px}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#444;border-radius:0}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a.text-muted[_ngcontent-%COMP%]{color:#999}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background:transparent;margin:0}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{color:#999}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.active) > a[_ngcontent-%COMP%]:hover, .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.active) > a[_ngcontent-%COMP%]:focus, .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:not(.active) > a[_ngcontent-%COMP%]:active{border-color:transparent}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#3c8dbc}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%], .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]:hover > a[_ngcontent-%COMP%]{background-color:#fff;color:#444}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-top-color:transparent;border-left-color:#f4f4f4;border-right-color:#f4f4f4}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type{margin-left:0}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type.active > a[_ngcontent-%COMP%]{border-left-color:transparent}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs.pull-right[_ngcontent-%COMP%]{float:none !important}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs.pull-right[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{float:right}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs.pull-right[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type{margin-right:0}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs.pull-right[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type > a[_ngcontent-%COMP%]{border-left-width:1px}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs.pull-right[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:first-of-type.active > a[_ngcontent-%COMP%]{border-left-color:#f4f4f4;border-right-color:transparent}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%]{line-height:35px;padding:0 10px;font-size:20px;color:#444}.nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%], .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%] > .glyphicon[_ngcontent-%COMP%], .nav-tabs-custom[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.header[_ngcontent-%COMP%] > .ion[_ngcontent-%COMP%]{margin-right:5px}.nav-tabs-custom[_ngcontent-%COMP%] > .tab-content[_ngcontent-%COMP%]{background:#fff;padding:10px;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.nav-tabs-custom[_ngcontent-%COMP%]   .dropdown.open[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:active, .nav-tabs-custom[_ngcontent-%COMP%]   .dropdown.open[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus{background:transparent;color:#999}.nav-tabs-custom.tab-primary[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#3c8dbc}.nav-tabs-custom.tab-info[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#00c0ef}.nav-tabs-custom.tab-danger[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#dd4b39}.nav-tabs-custom.tab-warning[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#f39c12}.nav-tabs-custom.tab-success[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#00a65a}.nav-tabs-custom.tab-default[_ngcontent-%COMP%] > .nav-tabs[_ngcontent-%COMP%] > li.active[_ngcontent-%COMP%]{border-top-color:#d2d6de}.pagination[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background:#fafafa;color:#666}.pagination.pagination-flat[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-radius:0 !important}.products-list[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0}.products-list[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]{border-radius:3px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,0.1);box-shadow:0 1px 1px rgba(0,0,0,0.1);padding:10px 0;background:#fff}.products-list[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]:before, .products-list[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]:after{content:" ";display:table}.products-list[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]:after{clear:both}.products-list[_ngcontent-%COMP%]   .product-img[_ngcontent-%COMP%]{float:left}.products-list[_ngcontent-%COMP%]   .product-img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:50px;height:50px}.products-list[_ngcontent-%COMP%]   .product-info[_ngcontent-%COMP%]{margin-left:60px}.products-list[_ngcontent-%COMP%]   .product-title[_ngcontent-%COMP%]{font-weight:600}.products-list[_ngcontent-%COMP%]   .product-description[_ngcontent-%COMP%]{display:block;color:#999;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.product-list-in-box[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]{-webkit-box-shadow:none;box-shadow:none;border-radius:0;border-bottom:1px solid #f4f4f4}.product-list-in-box[_ngcontent-%COMP%] > .item[_ngcontent-%COMP%]:last-of-type{border-bottom-width:0}.table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%] > tfoot[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%] > tfoot[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{border-top:1px solid #f4f4f4}.table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{border-bottom:2px solid #f4f4f4}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{margin-top:5px}.table-bordered[_ngcontent-%COMP%]{border:1px solid #f4f4f4}.table-bordered[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > tfoot[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > tfoot[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{border:1px solid #f4f4f4}.table-bordered[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{border-bottom-width:2px}.table.no-border[_ngcontent-%COMP%], .table.no-border[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table.no-border[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:0}table.text-center[_ngcontent-%COMP%], table.text-center[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table.text-center[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:center}.table.align[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left}.table.align[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{text-align:right}.label-default[_ngcontent-%COMP%]{background-color:#d2d6de;color:#444}.direct-chat[_ngcontent-%COMP%]   .box-body[_ngcontent-%COMP%]{border-bottom-right-radius:0;border-bottom-left-radius:0;position:relative;overflow-x:hidden;padding:0}.direct-chat.chat-pane-open[_ngcontent-%COMP%]   .direct-chat-contacts[_ngcontent-%COMP%]{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}.direct-chat-messages[_ngcontent-%COMP%]{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0);padding:10px;height:250px;overflow:auto}.direct-chat-msg[_ngcontent-%COMP%], .direct-chat-text[_ngcontent-%COMP%]{display:block}.direct-chat-msg[_ngcontent-%COMP%]{margin-bottom:10px}.direct-chat-msg[_ngcontent-%COMP%]:before, .direct-chat-msg[_ngcontent-%COMP%]:after{content:" ";display:table}.direct-chat-msg[_ngcontent-%COMP%]:after{clear:both}.direct-chat-messages[_ngcontent-%COMP%], .direct-chat-contacts[_ngcontent-%COMP%]{-webkit-transition:-webkit-transform .5s ease-in-out;-moz-transition:-moz-transform .5s ease-in-out;-o-transition:-o-transform .5s ease-in-out;transition:transform .5s ease-in-out}.direct-chat-text[_ngcontent-%COMP%]{border-radius:5px;position:relative;padding:5px 10px;background:#d2d6de;border:1px solid #d2d6de;margin:5px 0 0 50px;color:#444}.direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-text[_ngcontent-%COMP%]:before{position:absolute;right:100%;top:15px;border:solid transparent;border-right-color:#d2d6de;content:\' \';height:0;width:0;pointer-events:none}.direct-chat-text[_ngcontent-%COMP%]:after{border-width:5px;margin-top:-5px}.direct-chat-text[_ngcontent-%COMP%]:before{border-width:6px;margin-top:-6px}.right[_ngcontent-%COMP%]   .direct-chat-text[_ngcontent-%COMP%]{margin-right:50px;margin-left:0}.right[_ngcontent-%COMP%]   .direct-chat-text[_ngcontent-%COMP%]:after, .right[_ngcontent-%COMP%]   .direct-chat-text[_ngcontent-%COMP%]:before{right:auto;left:100%;border-right-color:transparent;border-left-color:#d2d6de}.direct-chat-img[_ngcontent-%COMP%]{border-radius:50%;float:left;width:40px;height:40px}.right[_ngcontent-%COMP%]   .direct-chat-img[_ngcontent-%COMP%]{float:right}.direct-chat-info[_ngcontent-%COMP%]{display:block;margin-bottom:2px;font-size:12px}.direct-chat-name[_ngcontent-%COMP%]{font-weight:600}.direct-chat-timestamp[_ngcontent-%COMP%]{color:#999}.direct-chat-contacts-open[_ngcontent-%COMP%]   .direct-chat-contacts[_ngcontent-%COMP%]{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}.direct-chat-contacts[_ngcontent-%COMP%]{-webkit-transform:translate(101%, 0);-ms-transform:translate(101%, 0);-o-transform:translate(101%, 0);transform:translate(101%, 0);position:absolute;top:0;bottom:0;height:250px;width:100%;background:#222d32;color:#fff;overflow:auto}.contacts-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,0.2);padding:10px;margin:0}.contacts-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:before, .contacts-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:after{content:" ";display:table}.contacts-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:after{clear:both}.contacts-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]:last-of-type{border-bottom:none}.contacts-list-img[_ngcontent-%COMP%]{border-radius:50%;width:40px;float:left}.contacts-list-info[_ngcontent-%COMP%]{margin-left:45px;color:#fff}.contacts-list-name[_ngcontent-%COMP%], .contacts-list-status[_ngcontent-%COMP%]{display:block}.contacts-list-name[_ngcontent-%COMP%]{font-weight:600}.contacts-list-status[_ngcontent-%COMP%]{font-size:12px}.contacts-list-date[_ngcontent-%COMP%]{color:#aaa;font-weight:normal}.contacts-list-msg[_ngcontent-%COMP%]{color:#999}.direct-chat-danger[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]{background:#dd4b39;border-color:#dd4b39;color:#fff}.direct-chat-danger[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-danger[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:before{border-left-color:#dd4b39}.direct-chat-primary[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]{background:#3c8dbc;border-color:#3c8dbc;color:#fff}.direct-chat-primary[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-primary[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:before{border-left-color:#3c8dbc}.direct-chat-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]{background:#f39c12;border-color:#f39c12;color:#fff}.direct-chat-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:before{border-left-color:#f39c12}.direct-chat-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]{background:#00c0ef;border-color:#00c0ef;color:#fff}.direct-chat-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:before{border-left-color:#00c0ef}.direct-chat-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]{background:#00a65a;border-color:#00a65a;color:#fff}.direct-chat-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:after, .direct-chat-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] > .direct-chat-text[_ngcontent-%COMP%]:before{border-left-color:#00a65a}.users-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{width:25%;float:left;padding:10px;text-align:center}.users-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border-radius:50%;max-width:100%;height:auto}.users-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover, .users-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover   .users-list-name[_ngcontent-%COMP%]{color:#999}.users-list-name[_ngcontent-%COMP%], .users-list-date[_ngcontent-%COMP%]{display:block}.users-list-name[_ngcontent-%COMP%]{font-weight:600;color:#444;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.users-list-date[_ngcontent-%COMP%]{color:#999;font-size:12px}.carousel-control.left[_ngcontent-%COMP%], .carousel-control.right[_ngcontent-%COMP%]{background-image:none}.carousel-control[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.modal[_ngcontent-%COMP%]{background:rgba(0,0,0,0.3)}.modal-content[_ngcontent-%COMP%]{border-radius:0;-webkit-box-shadow:0 2px 3px rgba(0,0,0,0.125);box-shadow:0 2px 3px rgba(0,0,0,0.125);border:0}@media (min-width:768px){.modal-content[_ngcontent-%COMP%]{-webkit-box-shadow:0 2px 3px rgba(0,0,0,0.125);box-shadow:0 2px 3px rgba(0,0,0,0.125)}}.modal-header[_ngcontent-%COMP%]{border-bottom-color:#f4f4f4}.modal-footer[_ngcontent-%COMP%]{border-top-color:#f4f4f4}.modal-primary[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{border-color:#307095}.modal-warning[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{border-color:#c87f0a}.modal-info[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{border-color:#0097bc}.modal-success[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{border-color:#00733e}.modal-danger[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{border-color:#c23321}.box-widget[_ngcontent-%COMP%]{border:none;position:relative}.widget-user[_ngcontent-%COMP%]   .widget-user-header[_ngcontent-%COMP%]{padding:20px;height:120px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user[_ngcontent-%COMP%]   .widget-user-username[_ngcontent-%COMP%]{margin-top:0;margin-bottom:5px;font-size:25px;font-weight:300;text-shadow:0 1px 1px rgba(0,0,0,0.2)}.widget-user[_ngcontent-%COMP%]   .widget-user-desc[_ngcontent-%COMP%]{margin-top:0}.widget-user[_ngcontent-%COMP%]   .widget-user-image[_ngcontent-%COMP%]{position:absolute;top:65px;left:50%;margin-left:-45px}.widget-user[_ngcontent-%COMP%]   .widget-user-image[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{width:90px;height:auto;border:3px solid #fff}.widget-user[_ngcontent-%COMP%]   .box-footer[_ngcontent-%COMP%]{padding-top:30px}.widget-user-2[_ngcontent-%COMP%]   .widget-user-header[_ngcontent-%COMP%]{padding:20px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user-2[_ngcontent-%COMP%]   .widget-user-username[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:5px;font-size:25px;font-weight:300}.widget-user-2[_ngcontent-%COMP%]   .widget-user-desc[_ngcontent-%COMP%]{margin-top:0}.widget-user-2[_ngcontent-%COMP%]   .widget-user-username[_ngcontent-%COMP%], .widget-user-2[_ngcontent-%COMP%]   .widget-user-desc[_ngcontent-%COMP%]{margin-left:75px}.widget-user-2[_ngcontent-%COMP%]   .widget-user-image[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{width:65px;height:auto;float:left}.mailbox-messages[_ngcontent-%COMP%] > .table[_ngcontent-%COMP%]{margin:0}.mailbox-controls[_ngcontent-%COMP%]{padding:5px}.mailbox-controls.with-border[_ngcontent-%COMP%]{border-bottom:1px solid #f4f4f4}.mailbox-read-info[_ngcontent-%COMP%]{border-bottom:1px solid #f4f4f4;padding:10px}.mailbox-read-info[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:20px;margin:0}.mailbox-read-info[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;padding:5px 0 0 0}.mailbox-read-time[_ngcontent-%COMP%]{color:#999;font-size:13px}.mailbox-read-message[_ngcontent-%COMP%]{padding:10px}.mailbox-attachments[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left;width:200px;border:1px solid #eee;margin-bottom:10px;margin-right:10px}.mailbox-attachment-name[_ngcontent-%COMP%]{font-weight:bold;color:#666}.mailbox-attachment-icon[_ngcontent-%COMP%], .mailbox-attachment-info[_ngcontent-%COMP%], .mailbox-attachment-size[_ngcontent-%COMP%]{display:block}.mailbox-attachment-info[_ngcontent-%COMP%]{padding:10px;background:#f4f4f4}.mailbox-attachment-size[_ngcontent-%COMP%]{color:#999;font-size:12px}.mailbox-attachment-icon[_ngcontent-%COMP%]{text-align:center;font-size:65px;color:#666;padding:20px 10px}.mailbox-attachment-icon.has-img[_ngcontent-%COMP%]{padding:0}.mailbox-attachment-icon.has-img[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{max-width:100%;height:auto}.lockscreen[_ngcontent-%COMP%]{background:#d2d6de}.lockscreen-logo[_ngcontent-%COMP%]{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.lockscreen-logo[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#444}.lockscreen-wrapper[_ngcontent-%COMP%]{max-width:400px;margin:0 auto;margin-top:10%}.lockscreen[_ngcontent-%COMP%]   .lockscreen-name[_ngcontent-%COMP%]{text-align:center;font-weight:600}.lockscreen-item[_ngcontent-%COMP%]{border-radius:4px;padding:0;background:#fff;position:relative;margin:10px auto 30px auto;width:290px}.lockscreen-image[_ngcontent-%COMP%]{border-radius:50%;position:absolute;left:-10px;top:-25px;background:#fff;padding:5px;z-index:10}.lockscreen-image[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{border-radius:50%;width:70px;height:70px}.lockscreen-credentials[_ngcontent-%COMP%]{margin-left:70px}.lockscreen-credentials[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border:0}.lockscreen-credentials[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{background-color:#fff;border:0;padding:0 10px}.lockscreen-footer[_ngcontent-%COMP%]{margin-top:10px}.login-logo[_ngcontent-%COMP%], .register-logo[_ngcontent-%COMP%]{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.login-logo[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .register-logo[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#444}.login-page[_ngcontent-%COMP%], .register-page[_ngcontent-%COMP%]{background:#d2d6de}.login-box[_ngcontent-%COMP%], .register-box[_ngcontent-%COMP%]{width:360px;margin:7% auto}@media (max-width:768px){.login-box[_ngcontent-%COMP%], .register-box[_ngcontent-%COMP%]{width:90%;margin-top:20px}}.login-box-body[_ngcontent-%COMP%], .register-box-body[_ngcontent-%COMP%]{background:#fff;padding:20px;border-top:0;color:#666}.login-box-body[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%], .register-box-body[_ngcontent-%COMP%]   .form-control-feedback[_ngcontent-%COMP%]{color:#777}.login-box-msg[_ngcontent-%COMP%], .register-box-msg[_ngcontent-%COMP%]{margin:0;text-align:center;padding:0 20px 20px 20px}.social-auth-links[_ngcontent-%COMP%]{margin:10px 0}.error-page[_ngcontent-%COMP%]{width:600px;margin:20px auto 0 auto}@media (max-width:991px){.error-page[_ngcontent-%COMP%]{width:100%}}.error-page[_ngcontent-%COMP%] > .headline[_ngcontent-%COMP%]{float:left;font-size:100px;font-weight:300}@media (max-width:991px){.error-page[_ngcontent-%COMP%] > .headline[_ngcontent-%COMP%]{float:none;text-align:center}}.error-page[_ngcontent-%COMP%] > .error-content[_ngcontent-%COMP%]{margin-left:190px;display:block}@media (max-width:991px){.error-page[_ngcontent-%COMP%] > .error-content[_ngcontent-%COMP%]{margin-left:0}}.error-page[_ngcontent-%COMP%] > .error-content[_ngcontent-%COMP%] > h3[_ngcontent-%COMP%]{font-weight:300;font-size:25px}@media (max-width:991px){.error-page[_ngcontent-%COMP%] > .error-content[_ngcontent-%COMP%] > h3[_ngcontent-%COMP%]{text-align:center}}.invoice[_ngcontent-%COMP%]{position:relative;background:#fff;border:1px solid #f4f4f4;padding:20px;margin:10px 25px}.invoice-title[_ngcontent-%COMP%]{margin-top:0}.profile-user-img[_ngcontent-%COMP%]{margin:0 auto;width:100px;padding:3px;border:3px solid #d2d6de}.profile-username[_ngcontent-%COMP%]{font-size:21px;margin-top:5px}.post[_ngcontent-%COMP%]{border-bottom:1px solid #d2d6de;margin-bottom:15px;padding-bottom:15px;color:#666}.post[_ngcontent-%COMP%]:last-of-type{border-bottom:0;margin-bottom:0;padding-bottom:0}.post[_ngcontent-%COMP%]   .user-block[_ngcontent-%COMP%]{margin-bottom:15px}.btn-social[_ngcontent-%COMP%]{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn-social[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,0.2)}.btn-social.btn-lg[_ngcontent-%COMP%]{padding-left:61px}.btn-social.btn-lg[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social.btn-sm[_ngcontent-%COMP%]{padding-left:38px}.btn-social.btn-sm[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social.btn-xs[_ngcontent-%COMP%]{padding-left:30px}.btn-social.btn-xs[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon[_ngcontent-%COMP%]{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:34px;width:34px;padding:0}.btn-social-icon[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,0.2)}.btn-social-icon.btn-lg[_ngcontent-%COMP%]{padding-left:61px}.btn-social-icon.btn-lg[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social-icon.btn-sm[_ngcontent-%COMP%]{padding-left:38px}.btn-social-icon.btn-sm[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social-icon.btn-xs[_ngcontent-%COMP%]{padding-left:30px}.btn-social-icon.btn-xs[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{border:none;text-align:center;width:100%}.btn-social-icon.btn-lg[_ngcontent-%COMP%]{height:45px;width:45px;padding-left:0;padding-right:0}.btn-social-icon.btn-sm[_ngcontent-%COMP%]{height:30px;width:30px;padding-left:0;padding-right:0}.btn-social-icon.btn-xs[_ngcontent-%COMP%]{height:22px;width:22px;padding-left:0;padding-right:0}.btn-adn[_ngcontent-%COMP%]{color:#fff;background-color:#d87a68;border-color:rgba(0,0,0,0.2)}.btn-adn[_ngcontent-%COMP%]:focus, .btn-adn.focus[_ngcontent-%COMP%]{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn[_ngcontent-%COMP%]:hover{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn[_ngcontent-%COMP%]:active, .btn-adn.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-adn[_ngcontent-%COMP%]{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn[_ngcontent-%COMP%]:active, .btn-adn.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-adn[_ngcontent-%COMP%]{background-image:none}.btn-adn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#d87a68;background-color:#fff}.btn-bitbucket[_ngcontent-%COMP%]{color:#fff;background-color:#205081;border-color:rgba(0,0,0,0.2)}.btn-bitbucket[_ngcontent-%COMP%]:focus, .btn-bitbucket.focus[_ngcontent-%COMP%]{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket[_ngcontent-%COMP%]:hover{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket[_ngcontent-%COMP%]:active, .btn-bitbucket.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-bitbucket[_ngcontent-%COMP%]{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket[_ngcontent-%COMP%]:active, .btn-bitbucket.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-bitbucket[_ngcontent-%COMP%]{background-image:none}.btn-bitbucket[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#205081;background-color:#fff}.btn-dropbox[_ngcontent-%COMP%]{color:#fff;background-color:#1087dd;border-color:rgba(0,0,0,0.2)}.btn-dropbox[_ngcontent-%COMP%]:focus, .btn-dropbox.focus[_ngcontent-%COMP%]{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox[_ngcontent-%COMP%]:hover{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox[_ngcontent-%COMP%]:active, .btn-dropbox.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-dropbox[_ngcontent-%COMP%]{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox[_ngcontent-%COMP%]:active, .btn-dropbox.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-dropbox[_ngcontent-%COMP%]{background-image:none}.btn-dropbox[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#1087dd;background-color:#fff}.btn-facebook[_ngcontent-%COMP%]{color:#fff;background-color:#3b5998;border-color:rgba(0,0,0,0.2)}.btn-facebook[_ngcontent-%COMP%]:focus, .btn-facebook.focus[_ngcontent-%COMP%]{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook[_ngcontent-%COMP%]:hover{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook[_ngcontent-%COMP%]:active, .btn-facebook.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-facebook[_ngcontent-%COMP%]{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook[_ngcontent-%COMP%]:active, .btn-facebook.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-facebook[_ngcontent-%COMP%]{background-image:none}.btn-facebook[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#3b5998;background-color:#fff}.btn-flickr[_ngcontent-%COMP%]{color:#fff;background-color:#ff0084;border-color:rgba(0,0,0,0.2)}.btn-flickr[_ngcontent-%COMP%]:focus, .btn-flickr.focus[_ngcontent-%COMP%]{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr[_ngcontent-%COMP%]:hover{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr[_ngcontent-%COMP%]:active, .btn-flickr.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-flickr[_ngcontent-%COMP%]{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr[_ngcontent-%COMP%]:active, .btn-flickr.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-flickr[_ngcontent-%COMP%]{background-image:none}.btn-flickr[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#ff0084;background-color:#fff}.btn-foursquare[_ngcontent-%COMP%]{color:#fff;background-color:#f94877;border-color:rgba(0,0,0,0.2)}.btn-foursquare[_ngcontent-%COMP%]:focus, .btn-foursquare.focus[_ngcontent-%COMP%]{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare[_ngcontent-%COMP%]:hover{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare[_ngcontent-%COMP%]:active, .btn-foursquare.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-foursquare[_ngcontent-%COMP%]{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare[_ngcontent-%COMP%]:active, .btn-foursquare.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-foursquare[_ngcontent-%COMP%]{background-image:none}.btn-foursquare[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#f94877;background-color:#fff}.btn-github[_ngcontent-%COMP%]{color:#fff;background-color:#444;border-color:rgba(0,0,0,0.2)}.btn-github[_ngcontent-%COMP%]:focus, .btn-github.focus[_ngcontent-%COMP%]{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github[_ngcontent-%COMP%]:hover{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github[_ngcontent-%COMP%]:active, .btn-github.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-github[_ngcontent-%COMP%]{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github[_ngcontent-%COMP%]:active, .btn-github.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-github[_ngcontent-%COMP%]{background-image:none}.btn-github[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#444;background-color:#fff}.btn-google[_ngcontent-%COMP%]{color:#fff;background-color:#dd4b39;border-color:rgba(0,0,0,0.2)}.btn-google[_ngcontent-%COMP%]:focus, .btn-google.focus[_ngcontent-%COMP%]{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google[_ngcontent-%COMP%]:hover{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google[_ngcontent-%COMP%]:active, .btn-google.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-google[_ngcontent-%COMP%]{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google[_ngcontent-%COMP%]:active, .btn-google.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-google[_ngcontent-%COMP%]{background-image:none}.btn-google[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#dd4b39;background-color:#fff}.btn-instagram[_ngcontent-%COMP%]{color:#fff;background-color:#3f729b;border-color:rgba(0,0,0,0.2)}.btn-instagram[_ngcontent-%COMP%]:focus, .btn-instagram.focus[_ngcontent-%COMP%]{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram[_ngcontent-%COMP%]:hover{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram[_ngcontent-%COMP%]:active, .btn-instagram.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-instagram[_ngcontent-%COMP%]{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram[_ngcontent-%COMP%]:active, .btn-instagram.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-instagram[_ngcontent-%COMP%]{background-image:none}.btn-instagram[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#3f729b;background-color:#fff}.btn-linkedin[_ngcontent-%COMP%]{color:#fff;background-color:#007bb6;border-color:rgba(0,0,0,0.2)}.btn-linkedin[_ngcontent-%COMP%]:focus, .btn-linkedin.focus[_ngcontent-%COMP%]{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin[_ngcontent-%COMP%]:hover{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin[_ngcontent-%COMP%]:active, .btn-linkedin.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-linkedin[_ngcontent-%COMP%]{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin[_ngcontent-%COMP%]:active, .btn-linkedin.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-linkedin[_ngcontent-%COMP%]{background-image:none}.btn-linkedin[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#007bb6;background-color:#fff}.btn-microsoft[_ngcontent-%COMP%]{color:#fff;background-color:#2672ec;border-color:rgba(0,0,0,0.2)}.btn-microsoft[_ngcontent-%COMP%]:focus, .btn-microsoft.focus[_ngcontent-%COMP%]{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft[_ngcontent-%COMP%]:hover{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft[_ngcontent-%COMP%]:active, .btn-microsoft.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-microsoft[_ngcontent-%COMP%]{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft[_ngcontent-%COMP%]:active, .btn-microsoft.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-microsoft[_ngcontent-%COMP%]{background-image:none}.btn-microsoft[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#2672ec;background-color:#fff}.btn-openid[_ngcontent-%COMP%]{color:#fff;background-color:#f7931e;border-color:rgba(0,0,0,0.2)}.btn-openid[_ngcontent-%COMP%]:focus, .btn-openid.focus[_ngcontent-%COMP%]{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid[_ngcontent-%COMP%]:hover{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid[_ngcontent-%COMP%]:active, .btn-openid.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-openid[_ngcontent-%COMP%]{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid[_ngcontent-%COMP%]:active, .btn-openid.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-openid[_ngcontent-%COMP%]{background-image:none}.btn-openid[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#f7931e;background-color:#fff}.btn-pinterest[_ngcontent-%COMP%]{color:#fff;background-color:#cb2027;border-color:rgba(0,0,0,0.2)}.btn-pinterest[_ngcontent-%COMP%]:focus, .btn-pinterest.focus[_ngcontent-%COMP%]{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest[_ngcontent-%COMP%]:hover{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest[_ngcontent-%COMP%]:active, .btn-pinterest.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-pinterest[_ngcontent-%COMP%]{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest[_ngcontent-%COMP%]:active, .btn-pinterest.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-pinterest[_ngcontent-%COMP%]{background-image:none}.btn-pinterest[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#cb2027;background-color:#fff}.btn-reddit[_ngcontent-%COMP%]{color:#000;background-color:#eff7ff;border-color:rgba(0,0,0,0.2)}.btn-reddit[_ngcontent-%COMP%]:focus, .btn-reddit.focus[_ngcontent-%COMP%]{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit[_ngcontent-%COMP%]:hover{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit[_ngcontent-%COMP%]:active, .btn-reddit.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-reddit[_ngcontent-%COMP%]{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit[_ngcontent-%COMP%]:active, .btn-reddit.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-reddit[_ngcontent-%COMP%]{background-image:none}.btn-reddit[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#eff7ff;background-color:#000}.btn-soundcloud[_ngcontent-%COMP%]{color:#fff;background-color:#f50;border-color:rgba(0,0,0,0.2)}.btn-soundcloud[_ngcontent-%COMP%]:focus, .btn-soundcloud.focus[_ngcontent-%COMP%]{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud[_ngcontent-%COMP%]:hover{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud[_ngcontent-%COMP%]:active, .btn-soundcloud.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-soundcloud[_ngcontent-%COMP%]{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud[_ngcontent-%COMP%]:active, .btn-soundcloud.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-soundcloud[_ngcontent-%COMP%]{background-image:none}.btn-soundcloud[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#f50;background-color:#fff}.btn-tumblr[_ngcontent-%COMP%]{color:#fff;background-color:#2c4762;border-color:rgba(0,0,0,0.2)}.btn-tumblr[_ngcontent-%COMP%]:focus, .btn-tumblr.focus[_ngcontent-%COMP%]{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr[_ngcontent-%COMP%]:hover{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr[_ngcontent-%COMP%]:active, .btn-tumblr.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-tumblr[_ngcontent-%COMP%]{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr[_ngcontent-%COMP%]:active, .btn-tumblr.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-tumblr[_ngcontent-%COMP%]{background-image:none}.btn-tumblr[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#2c4762;background-color:#fff}.btn-twitter[_ngcontent-%COMP%]{color:#fff;background-color:#55acee;border-color:rgba(0,0,0,0.2)}.btn-twitter[_ngcontent-%COMP%]:focus, .btn-twitter.focus[_ngcontent-%COMP%]{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter[_ngcontent-%COMP%]:hover{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter[_ngcontent-%COMP%]:active, .btn-twitter.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-twitter[_ngcontent-%COMP%]{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter[_ngcontent-%COMP%]:active, .btn-twitter.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-twitter[_ngcontent-%COMP%]{background-image:none}.btn-twitter[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#55acee;background-color:#fff}.btn-vimeo[_ngcontent-%COMP%]{color:#fff;background-color:#1ab7ea;border-color:rgba(0,0,0,0.2)}.btn-vimeo[_ngcontent-%COMP%]:focus, .btn-vimeo.focus[_ngcontent-%COMP%]{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo[_ngcontent-%COMP%]:hover{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo[_ngcontent-%COMP%]:active, .btn-vimeo.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-vimeo[_ngcontent-%COMP%]{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo[_ngcontent-%COMP%]:active, .btn-vimeo.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-vimeo[_ngcontent-%COMP%]{background-image:none}.btn-vimeo[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#1ab7ea;background-color:#fff}.btn-vk[_ngcontent-%COMP%]{color:#fff;background-color:#587ea3;border-color:rgba(0,0,0,0.2)}.btn-vk[_ngcontent-%COMP%]:focus, .btn-vk.focus[_ngcontent-%COMP%]{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk[_ngcontent-%COMP%]:hover{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk[_ngcontent-%COMP%]:active, .btn-vk.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-vk[_ngcontent-%COMP%]{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk[_ngcontent-%COMP%]:active, .btn-vk.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-vk[_ngcontent-%COMP%]{background-image:none}.btn-vk[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#587ea3;background-color:#fff}.btn-yahoo[_ngcontent-%COMP%]{color:#fff;background-color:#720e9e;border-color:rgba(0,0,0,0.2)}.btn-yahoo[_ngcontent-%COMP%]:focus, .btn-yahoo.focus[_ngcontent-%COMP%]{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo[_ngcontent-%COMP%]:hover{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo[_ngcontent-%COMP%]:active, .btn-yahoo.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-yahoo[_ngcontent-%COMP%]{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo[_ngcontent-%COMP%]:active, .btn-yahoo.active[_ngcontent-%COMP%], .open[_ngcontent-%COMP%] > .dropdown-toggle.btn-yahoo[_ngcontent-%COMP%]{background-image:none}.btn-yahoo[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{color:#720e9e;background-color:#fff}.fc-button[_ngcontent-%COMP%]{background:#f4f4f4;background-image:none;color:#444;border-color:#ddd;border-bottom-color:#ddd}.fc-button[_ngcontent-%COMP%]:hover, .fc-button[_ngcontent-%COMP%]:active, .fc-button.hover[_ngcontent-%COMP%]{background-color:#e9e9e9}.fc-header-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:15px;line-height:1.6em;color:#666;margin-left:10px}.fc-header-right[_ngcontent-%COMP%]{padding-right:10px}.fc-header-left[_ngcontent-%COMP%]{padding-left:10px}.fc-widget-header[_ngcontent-%COMP%]{background:#fafafa}.fc-grid[_ngcontent-%COMP%]{width:100%;border:0}.fc-widget-header[_ngcontent-%COMP%]:first-of-type, .fc-widget-content[_ngcontent-%COMP%]:first-of-type{border-left:0;border-right:0}.fc-widget-header[_ngcontent-%COMP%]:last-of-type, .fc-widget-content[_ngcontent-%COMP%]:last-of-type{border-right:0}.fc-toolbar[_ngcontent-%COMP%]{padding:10px;margin:0}.fc-day-number[_ngcontent-%COMP%]{font-size:20px;font-weight:300;padding-right:10px}.fc-color-picker[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0}.fc-color-picker[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{float:left;font-size:30px;margin-right:5px;line-height:30px}.fc-color-picker[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{-webkit-transition:-webkit-transform linear .3s;-moz-transition:-moz-transform linear .3s;-o-transition:-o-transform linear .3s;transition:transform linear .3s}.fc-color-picker[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]:hover{-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);-o-transform:rotate(30deg);transform:rotate(30deg)}#add-new-event[_ngcontent-%COMP%]{-webkit-transition:all linear .3s;-o-transition:all linear .3s;transition:all linear .3s}.external-event[_ngcontent-%COMP%]{padding:5px 10px;font-weight:bold;margin-bottom:4px;box-shadow:0 1px 1px rgba(0,0,0,0.1);text-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px;cursor:move}.external-event[_ngcontent-%COMP%]:hover{box-shadow:inset 0 0 90px rgba(0,0,0,0.2)}.select2-container--default.select2-container--focus[_ngcontent-%COMP%], .select2-selection.select2-container--focus[_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]:focus, .select2-selection[_ngcontent-%COMP%]:focus, .select2-container--default[_ngcontent-%COMP%]:active, .select2-selection[_ngcontent-%COMP%]:active{outline:none}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%], .select2-selection[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]{border:1px solid #d2d6de;border-radius:0;padding:6px 12px;height:34px}.select2-container--default.select2-container--open[_ngcontent-%COMP%]{border-color:#3c8dbc}.select2-dropdown[_ngcontent-%COMP%]{border:1px solid #d2d6de;border-radius:0}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option--highlighted[aria-selected][_ngcontent-%COMP%]{background-color:#3c8dbc;color:white}.select2-results__option[_ngcontent-%COMP%]{padding:6px 12px;user-select:none;-webkit-user-select:none}.select2-container[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{padding-left:0;padding-right:0;height:auto;margin-top:-4px}.select2-container[dir="rtl"][_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{padding-right:6px;padding-left:20px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]{height:28px;right:3px}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__arrow[_ngcontent-%COMP%]   b[_ngcontent-%COMP%]{margin-top:0}.select2-dropdown[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%], .select2-search--inline[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]{border:1px solid #d2d6de}.select2-dropdown[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]:focus, .select2-search--inline[_ngcontent-%COMP%]   .select2-search__field[_ngcontent-%COMP%]:focus{outline:none;border:1px solid #3c8dbc}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-disabled=true][_ngcontent-%COMP%]{color:#999}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%]{background-color:#ddd}.select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%], .select2-container--default[_ngcontent-%COMP%]   .select2-results__option[aria-selected=true][_ngcontent-%COMP%]:hover{color:#444}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border:1px solid #d2d6de;border-radius:0}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]:focus{border-color:#3c8dbc}.select2-container--default.select2-container--focus[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]{border-color:#d2d6de}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice[_ngcontent-%COMP%]{background-color:#3c8dbc;border-color:#367fa9;padding:1px 10px;color:#fff}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice__remove[_ngcontent-%COMP%]{margin-right:5px;color:rgba(255,255,255,0.7)}.select2-container--default[_ngcontent-%COMP%]   .select2-selection--multiple[_ngcontent-%COMP%]   .select2-selection__choice__remove[_ngcontent-%COMP%]:hover{color:#fff}.select2-container[_ngcontent-%COMP%]   .select2-selection--single[_ngcontent-%COMP%]   .select2-selection__rendered[_ngcontent-%COMP%]{padding-right:10px}.pad[_ngcontent-%COMP%]{padding:10px}.margin[_ngcontent-%COMP%]{margin:10px}.margin-bottom[_ngcontent-%COMP%]{margin-bottom:20px}.margin-bottom-none[_ngcontent-%COMP%]{margin-bottom:0}.margin-r-5[_ngcontent-%COMP%]{margin-right:5px}.inline[_ngcontent-%COMP%]{display:inline}.description-block[_ngcontent-%COMP%]{display:block;margin:10px 0;text-align:center}.description-block.margin-bottom[_ngcontent-%COMP%]{margin-bottom:25px}.description-block[_ngcontent-%COMP%] > .description-header[_ngcontent-%COMP%]{margin:0;padding:0;font-weight:600;font-size:16px}.description-block[_ngcontent-%COMP%] > .description-text[_ngcontent-%COMP%]{text-transform:uppercase}.bg-red[_ngcontent-%COMP%], .bg-yellow[_ngcontent-%COMP%], .bg-aqua[_ngcontent-%COMP%], .bg-blue[_ngcontent-%COMP%], .bg-light-blue[_ngcontent-%COMP%], .bg-green[_ngcontent-%COMP%], .bg-navy[_ngcontent-%COMP%], .bg-teal[_ngcontent-%COMP%], .bg-olive[_ngcontent-%COMP%], .bg-lime[_ngcontent-%COMP%], .bg-orange[_ngcontent-%COMP%], .bg-fuchsia[_ngcontent-%COMP%], .bg-purple[_ngcontent-%COMP%], .bg-maroon[_ngcontent-%COMP%], .bg-black[_ngcontent-%COMP%], .bg-red-active[_ngcontent-%COMP%], .bg-yellow-active[_ngcontent-%COMP%], .bg-aqua-active[_ngcontent-%COMP%], .bg-blue-active[_ngcontent-%COMP%], .bg-light-blue-active[_ngcontent-%COMP%], .bg-green-active[_ngcontent-%COMP%], .bg-navy-active[_ngcontent-%COMP%], .bg-teal-active[_ngcontent-%COMP%], .bg-olive-active[_ngcontent-%COMP%], .bg-lime-active[_ngcontent-%COMP%], .bg-orange-active[_ngcontent-%COMP%], .bg-fuchsia-active[_ngcontent-%COMP%], .bg-purple-active[_ngcontent-%COMP%], .bg-maroon-active[_ngcontent-%COMP%], .bg-black-active[_ngcontent-%COMP%], .callout.callout-danger[_ngcontent-%COMP%], .callout.callout-warning[_ngcontent-%COMP%], .callout.callout-info[_ngcontent-%COMP%], .callout.callout-success[_ngcontent-%COMP%], .alert-success[_ngcontent-%COMP%], .alert-danger[_ngcontent-%COMP%], .alert-error[_ngcontent-%COMP%], .alert-warning[_ngcontent-%COMP%], .alert-info[_ngcontent-%COMP%], .label-danger[_ngcontent-%COMP%], .label-info[_ngcontent-%COMP%], .label-warning[_ngcontent-%COMP%], .label-primary[_ngcontent-%COMP%], .label-success[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{color:#fff !important}.bg-gray[_ngcontent-%COMP%]{color:#000;background-color:#d2d6de !important}.bg-gray-light[_ngcontent-%COMP%]{background-color:#f7f7f7}.bg-black[_ngcontent-%COMP%]{background-color:#111 !important}.bg-red[_ngcontent-%COMP%], .callout.callout-danger[_ngcontent-%COMP%], .alert-danger[_ngcontent-%COMP%], .alert-error[_ngcontent-%COMP%], .label-danger[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{background-color:#dd4b39 !important}.bg-yellow[_ngcontent-%COMP%], .callout.callout-warning[_ngcontent-%COMP%], .alert-warning[_ngcontent-%COMP%], .label-warning[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{background-color:#f39c12 !important}.bg-aqua[_ngcontent-%COMP%], .callout.callout-info[_ngcontent-%COMP%], .alert-info[_ngcontent-%COMP%], .label-info[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{background-color:#00c0ef !important}.bg-blue[_ngcontent-%COMP%]{background-color:#0073b7 !important}.bg-light-blue[_ngcontent-%COMP%], .label-primary[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{background-color:#3c8dbc !important}.bg-green[_ngcontent-%COMP%], .callout.callout-success[_ngcontent-%COMP%], .alert-success[_ngcontent-%COMP%], .label-success[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{background-color:#00a65a !important}.bg-navy[_ngcontent-%COMP%]{background-color:#001f3f !important}.bg-teal[_ngcontent-%COMP%]{background-color:#39cccc !important}.bg-olive[_ngcontent-%COMP%]{background-color:#3d9970 !important}.bg-lime[_ngcontent-%COMP%]{background-color:#01ff70 !important}.bg-orange[_ngcontent-%COMP%]{background-color:#ff851b !important}.bg-fuchsia[_ngcontent-%COMP%]{background-color:#f012be !important}.bg-purple[_ngcontent-%COMP%]{background-color:#605ca8 !important}.bg-maroon[_ngcontent-%COMP%]{background-color:#d81b60 !important}.bg-gray-active[_ngcontent-%COMP%]{color:#000;background-color:#b5bbc8 !important}.bg-black-active[_ngcontent-%COMP%]{background-color:#000 !important}.bg-red-active[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-danger[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#d33724 !important}.bg-yellow-active[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-warning[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#db8b0b !important}.bg-aqua-active[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-info[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#00a7d0 !important}.bg-blue-active[_ngcontent-%COMP%]{background-color:#005384 !important}.bg-light-blue-active[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-primary[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#357ca5 !important}.bg-green-active[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%], .modal-success[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%]{background-color:#008d4c !important}.bg-navy-active[_ngcontent-%COMP%]{background-color:#001a35 !important}.bg-teal-active[_ngcontent-%COMP%]{background-color:#30bbbb !important}.bg-olive-active[_ngcontent-%COMP%]{background-color:#368763 !important}.bg-lime-active[_ngcontent-%COMP%]{background-color:#00e765 !important}.bg-orange-active[_ngcontent-%COMP%]{background-color:#ff7701 !important}.bg-fuchsia-active[_ngcontent-%COMP%]{background-color:#db0ead !important}.bg-purple-active[_ngcontent-%COMP%]{background-color:#555299 !important}.bg-maroon-active[_ngcontent-%COMP%]{background-color:#ca195a !important}[class^="bg-"].disabled[_ngcontent-%COMP%]{opacity:.65;filter:alpha(opacity=65)}.text-red[_ngcontent-%COMP%]{color:#dd4b39 !important}.text-yellow[_ngcontent-%COMP%]{color:#f39c12 !important}.text-aqua[_ngcontent-%COMP%]{color:#00c0ef !important}.text-blue[_ngcontent-%COMP%]{color:#0073b7 !important}.text-black[_ngcontent-%COMP%]{color:#111 !important}.text-light-blue[_ngcontent-%COMP%]{color:#3c8dbc !important}.text-green[_ngcontent-%COMP%]{color:#00a65a !important}.text-gray[_ngcontent-%COMP%]{color:#d2d6de !important}.text-navy[_ngcontent-%COMP%]{color:#001f3f !important}.text-teal[_ngcontent-%COMP%]{color:#39cccc !important}.text-olive[_ngcontent-%COMP%]{color:#3d9970 !important}.text-lime[_ngcontent-%COMP%]{color:#01ff70 !important}.text-orange[_ngcontent-%COMP%]{color:#ff851b !important}.text-fuchsia[_ngcontent-%COMP%]{color:#f012be !important}.text-purple[_ngcontent-%COMP%]{color:#605ca8 !important}.text-maroon[_ngcontent-%COMP%]{color:#d81b60 !important}.link-muted[_ngcontent-%COMP%]{color:#7a869d}.link-muted[_ngcontent-%COMP%]:hover, .link-muted[_ngcontent-%COMP%]:focus{color:#606c84}.link-black[_ngcontent-%COMP%]{color:#666}.link-black[_ngcontent-%COMP%]:hover, .link-black[_ngcontent-%COMP%]:focus{color:#999}.hide[_ngcontent-%COMP%]{display:none !important}.no-border[_ngcontent-%COMP%]{border:0 !important}.no-padding[_ngcontent-%COMP%]{padding:0 !important}.no-margin[_ngcontent-%COMP%]{margin:0 !important}.no-shadow[_ngcontent-%COMP%]{box-shadow:none !important}.list-unstyled[_ngcontent-%COMP%], .chart-legend[_ngcontent-%COMP%], .contacts-list[_ngcontent-%COMP%], .users-list[_ngcontent-%COMP%], .mailbox-attachments[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0}.list-group-unbordered[_ngcontent-%COMP%] > .list-group-item[_ngcontent-%COMP%]{border-left:0;border-right:0;border-radius:0;padding-left:0;padding-right:0}.flat[_ngcontent-%COMP%]{border-radius:0 !important}.text-bold[_ngcontent-%COMP%], .text-bold.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .text-bold.table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-weight:700}.text-sm[_ngcontent-%COMP%]{font-size:12px}.jqstooltip[_ngcontent-%COMP%]{padding:5px !important;width:auto !important;height:auto !important}.bg-teal-gradient[_ngcontent-%COMP%]{background:#39cccc !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #39cccc), color-stop(1, #7adddd)) !important;background:-ms-linear-gradient(bottom, #39cccc, #7adddd) !important;background:-moz-linear-gradient(center bottom, #39cccc 0, #7adddd 100%) !important;background:-o-linear-gradient(#7adddd, #39cccc) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#7adddd\', endColorstr=\'#39cccc\', GradientType=0) !important;color:#fff}.bg-light-blue-gradient[_ngcontent-%COMP%]{background:#3c8dbc !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #3c8dbc), color-stop(1, #67a8ce)) !important;background:-ms-linear-gradient(bottom, #3c8dbc, #67a8ce) !important;background:-moz-linear-gradient(center bottom, #3c8dbc 0, #67a8ce 100%) !important;background:-o-linear-gradient(#67a8ce, #3c8dbc) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#67a8ce\', endColorstr=\'#3c8dbc\', GradientType=0) !important;color:#fff}.bg-blue-gradient[_ngcontent-%COMP%]{background:#0073b7 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #0073b7), color-stop(1, #0089db)) !important;background:-ms-linear-gradient(bottom, #0073b7, #0089db) !important;background:-moz-linear-gradient(center bottom, #0073b7 0, #0089db 100%) !important;background:-o-linear-gradient(#0089db, #0073b7) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#0089db\', endColorstr=\'#0073b7\', GradientType=0) !important;color:#fff}.bg-aqua-gradient[_ngcontent-%COMP%]{background:#00c0ef !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #00c0ef), color-stop(1, #14d1ff)) !important;background:-ms-linear-gradient(bottom, #00c0ef, #14d1ff) !important;background:-moz-linear-gradient(center bottom, #00c0ef 0, #14d1ff 100%) !important;background:-o-linear-gradient(#14d1ff, #00c0ef) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#14d1ff\', endColorstr=\'#00c0ef\', GradientType=0) !important;color:#fff}.bg-yellow-gradient[_ngcontent-%COMP%]{background:#f39c12 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #f39c12), color-stop(1, #f7bc60)) !important;background:-ms-linear-gradient(bottom, #f39c12, #f7bc60) !important;background:-moz-linear-gradient(center bottom, #f39c12 0, #f7bc60 100%) !important;background:-o-linear-gradient(#f7bc60, #f39c12) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#f7bc60\', endColorstr=\'#f39c12\', GradientType=0) !important;color:#fff}.bg-purple-gradient[_ngcontent-%COMP%]{background:#605ca8 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #605ca8), color-stop(1, #9491c4)) !important;background:-ms-linear-gradient(bottom, #605ca8, #9491c4) !important;background:-moz-linear-gradient(center bottom, #605ca8 0, #9491c4 100%) !important;background:-o-linear-gradient(#9491c4, #605ca8) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#9491c4\', endColorstr=\'#605ca8\', GradientType=0) !important;color:#fff}.bg-green-gradient[_ngcontent-%COMP%]{background:#00a65a !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #00a65a), color-stop(1, #00ca6d)) !important;background:-ms-linear-gradient(bottom, #00a65a, #00ca6d) !important;background:-moz-linear-gradient(center bottom, #00a65a 0, #00ca6d 100%) !important;background:-o-linear-gradient(#00ca6d, #00a65a) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#00ca6d\', endColorstr=\'#00a65a\', GradientType=0) !important;color:#fff}.bg-red-gradient[_ngcontent-%COMP%]{background:#dd4b39 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #dd4b39), color-stop(1, #e47365)) !important;background:-ms-linear-gradient(bottom, #dd4b39, #e47365) !important;background:-moz-linear-gradient(center bottom, #dd4b39 0, #e47365 100%) !important;background:-o-linear-gradient(#e47365, #dd4b39) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#e47365\', endColorstr=\'#dd4b39\', GradientType=0) !important;color:#fff}.bg-black-gradient[_ngcontent-%COMP%]{background:#111 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #111), color-stop(1, #2b2b2b)) !important;background:-ms-linear-gradient(bottom, #111, #2b2b2b) !important;background:-moz-linear-gradient(center bottom, #111 0, #2b2b2b 100%) !important;background:-o-linear-gradient(#2b2b2b, #111) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#2b2b2b\', endColorstr=\'#111111\', GradientType=0) !important;color:#fff}.bg-maroon-gradient[_ngcontent-%COMP%]{background:#d81b60 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #d81b60), color-stop(1, #e73f7c)) !important;background:-ms-linear-gradient(bottom, #d81b60, #e73f7c) !important;background:-moz-linear-gradient(center bottom, #d81b60 0, #e73f7c 100%) !important;background:-o-linear-gradient(#e73f7c, #d81b60) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#e73f7c\', endColorstr=\'#d81b60\', GradientType=0) !important;color:#fff}.description-block[_ngcontent-%COMP%]   .description-icon[_ngcontent-%COMP%]{font-size:16px}.no-pad-top[_ngcontent-%COMP%]{padding-top:0}.position-static[_ngcontent-%COMP%]{position:static !important}.list-header[_ngcontent-%COMP%]{font-size:15px;padding:10px 4px;font-weight:bold;color:#666}.list-seperator[_ngcontent-%COMP%]{height:1px;background:#f4f4f4;margin:15px 0 9px 0}.list-link[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{padding:4px;color:#777}.list-link[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{color:#222}.font-light[_ngcontent-%COMP%]{font-weight:300}.user-block[_ngcontent-%COMP%]:before, .user-block[_ngcontent-%COMP%]:after{content:" ";display:table}.user-block[_ngcontent-%COMP%]:after{clear:both}.user-block[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:40px;height:40px;float:left}.user-block[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%], .user-block[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%], .user-block[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]{display:block;margin-left:50px}.user-block[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{font-size:16px;font-weight:600}.user-block[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#999;font-size:13px}.user-block.user-block-sm[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%], .user-block.user-block-sm[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%], .user-block.user-block-sm[_ngcontent-%COMP%]   .comment[_ngcontent-%COMP%]{margin-left:40px}.user-block.user-block-sm[_ngcontent-%COMP%]   .username[_ngcontent-%COMP%]{font-size:14px}.img-sm[_ngcontent-%COMP%], .img-md[_ngcontent-%COMP%], .img-lg[_ngcontent-%COMP%], .box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .user-block.user-block-sm[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{float:left}.img-sm[_ngcontent-%COMP%], .box-comments[_ngcontent-%COMP%]   .box-comment[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .user-block.user-block-sm[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:30px !important;height:30px !important}.img-sm[_ngcontent-%COMP%] + .img-push[_ngcontent-%COMP%]{margin-left:40px}.img-md[_ngcontent-%COMP%]{width:60px;height:60px}.img-md[_ngcontent-%COMP%] + .img-push[_ngcontent-%COMP%]{margin-left:70px}.img-lg[_ngcontent-%COMP%]{width:100px;height:100px}.img-lg[_ngcontent-%COMP%] + .img-push[_ngcontent-%COMP%]{margin-left:110px}.img-bordered[_ngcontent-%COMP%]{border:3px solid #d2d6de;padding:3px}.img-bordered-sm[_ngcontent-%COMP%]{border:2px solid #d2d6de;padding:2px}.attachment-block[_ngcontent-%COMP%]{border:1px solid #f4f4f4;padding:5px;margin-bottom:10px;background:#f7f7f7}.attachment-block[_ngcontent-%COMP%]   .attachment-img[_ngcontent-%COMP%]{max-width:100px;max-height:100px;height:auto;float:left}.attachment-block[_ngcontent-%COMP%]   .attachment-pushed[_ngcontent-%COMP%]{margin-left:110px}.attachment-block[_ngcontent-%COMP%]   .attachment-heading[_ngcontent-%COMP%]{margin:0}.attachment-block[_ngcontent-%COMP%]   .attachment-text[_ngcontent-%COMP%]{color:#555}.connectedSortable[_ngcontent-%COMP%]{min-height:100px}.ui-helper-hidden-accessible[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sort-highlight[_ngcontent-%COMP%]{background:#f4f4f4;border:1px dashed #ddd;margin-bottom:10px}.full-opacity-hover[_ngcontent-%COMP%]{opacity:.65;filter:alpha(opacity=65)}.full-opacity-hover[_ngcontent-%COMP%]:hover{opacity:1;filter:alpha(opacity=100)}.chart[_ngcontent-%COMP%]{position:relative;overflow:hidden;width:100%}.chart[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .chart[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{width:100% !important}@media print{.no-print[_ngcontent-%COMP%], .main-sidebar[_ngcontent-%COMP%], .left-side[_ngcontent-%COMP%], .main-header[_ngcontent-%COMP%], .content-header[_ngcontent-%COMP%]{display:none !important}.content-wrapper[_ngcontent-%COMP%], .right-side[_ngcontent-%COMP%], .main-footer[_ngcontent-%COMP%]{margin-left:0 !important;min-height:0 !important;-webkit-transform:translate(0, 0) !important;-ms-transform:translate(0, 0) !important;-o-transform:translate(0, 0) !important;transform:translate(0, 0) !important}.fixed[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%], .fixed[_ngcontent-%COMP%]   .right-side[_ngcontent-%COMP%]{padding-top:0 !important}.invoice[_ngcontent-%COMP%]{width:100%;border:0;margin:0;padding:0}.invoice-col[_ngcontent-%COMP%]{float:left;width:33.3333333%}.table-responsive[_ngcontent-%COMP%]{overflow:auto}.table-responsive[_ngcontent-%COMP%] > .table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-responsive[_ngcontent-%COMP%] > .table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{white-space:normal !important}}'];


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(180);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_LazyLoadImageDirective = (function () {
    function Wrapper_LazyLoadImageDirective(p0, p1) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.LazyLoadImageDirective(p0, p1);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_LazyLoadImageDirective.prototype.check_lazyImage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.lazyImage = currValue;
            this.changes['lazyImage'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.check_defaultImage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.defaultImage = currValue;
            this.changes['defaultImage'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.check_errorImage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.errorImage = currValue;
            this.changes['errorImage'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.check_scrollTarget = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.scrollTarget = currValue;
            this.changes['scrollTarget'] = new import1.SimpleChange(this._expr_3, currValue);
            this._expr_3 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.check_scrollObservable = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.scrollObservable = currValue;
            this.changes['scrollObservable'] = new import1.SimpleChange(this._expr_4, currValue);
            this._expr_4 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.check_offset = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.offset = currValue;
            this.changes['offset'] = new import1.SimpleChange(this._expr_5, currValue);
            this._expr_5 = currValue;
        }
    };
    Wrapper_LazyLoadImageDirective.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
        }
        return changed;
    };
    Wrapper_LazyLoadImageDirective.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_LazyLoadImageDirective;
}());
exports.Wrapper_LazyLoadImageDirective = Wrapper_LazyLoadImageDirective;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(181);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var Wrapper_FileSelectDirective = (function () {
    function Wrapper_FileSelectDirective(p0) {
        this.changed = false;
        this.context = new import0.FileSelectDirective(p0);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_FileSelectDirective.prototype.check_uploader = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.uploader = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_FileSelectDirective.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_FileSelectDirective.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FileSelectDirective;
}());
exports.Wrapper_FileSelectDirective = Wrapper_FileSelectDirective;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var AdminAppComponent = (function () {
    function AdminAppComponent() {
    }
    AdminAppComponent = __decorate([
        core_1.Component({
            selector: 'guern-cms-admin',
            template: '<router-outlet></router-outlet>',
        }), 
        __metadata('design:paramtypes', [])
    ], AdminAppComponent);
    return AdminAppComponent;
}());
exports.AdminAppComponent = AdminAppComponent;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(221);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(11);
var import9 = __webpack_require__(10);
var Wrapper_AdminFooterComponent = (function () {
    function Wrapper_AdminFooterComponent() {
        this.changed = false;
        this.context = new import0.AdminFooterComponent();
    }
    Wrapper_AdminFooterComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_AdminFooterComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AdminFooterComponent;
}());
exports.Wrapper_AdminFooterComponent = Wrapper_AdminFooterComponent;
var renderType_AdminFooterComponent_Host = null;
var _View_AdminFooterComponent_Host0 = (function (_super) {
    __extends(_View_AdminFooterComponent_Host0, _super);
    function _View_AdminFooterComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminFooterComponent_Host0, renderType_AdminFooterComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminFooterComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'admin-footer', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AdminFooterComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AdminFooterComponent_0_4 = new Wrapper_AdminFooterComponent();
        this._appEl_0.initComponent(this._AdminFooterComponent_0_4.context, [], compView_0);
        compView_0.create(this._AdminFooterComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AdminFooterComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AdminFooterComponent) && (0 === requestNodeIndex))) {
            return this._AdminFooterComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AdminFooterComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AdminFooterComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AdminFooterComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminFooterComponent_Host0;
}(import1.AppView));
function viewFactory_AdminFooterComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminFooterComponent_Host === null)) {
        (renderType_AdminFooterComponent_Host = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {}));
    }
    return new _View_AdminFooterComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AdminFooterComponentNgFactory = new import9.ComponentFactory('admin-footer', viewFactory_AdminFooterComponent_Host0, import0.AdminFooterComponent);
var styles_AdminFooterComponent = [];
var renderType_AdminFooterComponent = null;
var _View_AdminFooterComponent0 = (function (_super) {
    __extends(_View_AdminFooterComponent0, _super);
    function _View_AdminFooterComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminFooterComponent0, renderType_AdminFooterComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminFooterComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '      ', null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n      ', null);
        this._el_2 = import4.createRenderElement(this.renderer, parentRenderNode, 'footer', new import4.InlineArray2(2, 'class', 'main-footer'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'pull-right hidden-xs'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n        ', null);
        this._text_7 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n        © 2017 ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray4(4, 'href', 'http://www.forgottenrecords.com', 'target', '_blank'), null);
        this._text_10 = this.renderer.createText(this._el_9, 'Forgotten Records', null);
        this._text_11 = this.renderer.createText(this._el_2, '. Tous droits réservés.\n      ', null);
        this.init([], [
            this._text_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11
        ], [], []);
        return null;
    };
    return _View_AdminFooterComponent0;
}(import1.AppView));
function viewFactory_AdminFooterComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminFooterComponent === null)) {
        (renderType_AdminFooterComponent = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, styles_AdminFooterComponent, {}));
    }
    return new _View_AdminFooterComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AdminFooterComponent0 = viewFactory_AdminFooterComponent0;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(222);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(11);
var import10 = __webpack_require__(10);
var import11 = __webpack_require__(24);
var import12 = __webpack_require__(413);
var import13 = __webpack_require__(22);
var import14 = __webpack_require__(14);
var import15 = __webpack_require__(20);
var import16 = __webpack_require__(15);
var import17 = __webpack_require__(16);
var import18 = __webpack_require__(88);
var import19 = __webpack_require__(21);
var import20 = __webpack_require__(19);
var import21 = __webpack_require__(111);
var import22 = __webpack_require__(310);
var import23 = __webpack_require__(32);
var import24 = __webpack_require__(2);
var import25 = __webpack_require__(77);
var import26 = __webpack_require__(175);
var Wrapper_AdminHeaderComponent = (function () {
    function Wrapper_AdminHeaderComponent(p0) {
        this.changed = false;
        this.context = new import0.AdminHeaderComponent(p0);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_AdminHeaderComponent.prototype.check_lgRouting = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.lgRouting = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_AdminHeaderComponent.prototype.check_loggedInUser = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.loggedInUser = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_AdminHeaderComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_AdminHeaderComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AdminHeaderComponent;
}());
exports.Wrapper_AdminHeaderComponent = Wrapper_AdminHeaderComponent;
var renderType_AdminHeaderComponent_Host = null;
var _View_AdminHeaderComponent_Host0 = (function (_super) {
    __extends(_View_AdminHeaderComponent_Host0, _super);
    function _View_AdminHeaderComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminHeaderComponent_Host0, renderType_AdminHeaderComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminHeaderComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'admin-header', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AdminHeaderComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AdminHeaderComponent_0_4 = new Wrapper_AdminHeaderComponent(this.parentInjector.get(import8.ConfigService));
        this._appEl_0.initComponent(this._AdminHeaderComponent_0_4.context, [], compView_0);
        compView_0.create(this._AdminHeaderComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AdminHeaderComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AdminHeaderComponent) && (0 === requestNodeIndex))) {
            return this._AdminHeaderComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AdminHeaderComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AdminHeaderComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AdminHeaderComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminHeaderComponent_Host0;
}(import3.AppView));
function viewFactory_AdminHeaderComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminHeaderComponent_Host === null)) {
        (renderType_AdminHeaderComponent_Host = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.None, [], {}));
    }
    return new _View_AdminHeaderComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AdminHeaderComponentNgFactory = new import10.ComponentFactory('admin-header', viewFactory_AdminHeaderComponent_Host0, import0.AdminHeaderComponent);
var styles_AdminHeaderComponent = [];
var renderType_AdminHeaderComponent = null;
var _View_AdminHeaderComponent0 = (function (_super) {
    __extends(_View_AdminHeaderComponent0, _super);
    function _View_AdminHeaderComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminHeaderComponent0, renderType_AdminHeaderComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_68 = import1.UNINITIALIZED;
        this._expr_69 = import1.UNINITIALIZED;
        this._arr_70 = import2.pureProxy1(function (p0) {
            return [p0];
        });
    }
    _View_AdminHeaderComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '       ', null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this._el_2 = import2.createRenderElement(this.renderer, parentRenderNode, 'header', new import2.InlineArray2(2, 'class', 'main-header'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n          ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n          ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_2, 'a', new import2.InlineArray4(4, 'class', 'logo', 'href', '#'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n            ', null);
        this._text_7 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_5, 'span', new import2.InlineArray2(2, 'class', 'logo-mini logo-custum'), null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_5, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_12 = import2.createRenderElement(this.renderer, this._el_5, 'span', new import2.InlineArray2(2, 'class', 'logo-lg logo-custum'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_5, '\n          ', null);
        this._text_15 = this.renderer.createText(this._el_2, '\n\n          ', null);
        this._text_16 = this.renderer.createText(this._el_2, '\n          ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_2, 'nav', new import2.InlineArray4(4, 'class', 'navbar navbar-static-top', 'role', 'navigation'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n            ', null);
        this._text_19 = this.renderer.createText(this._el_17, '\n            ', null);
        this._el_20 = import2.createRenderElement(this.renderer, this._el_17, 'a', new import2.InlineArray8(8, 'class', 'sidebar-toggle', 'data-toggle', 'offcanvas', 'href', '#', 'role', 'button'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n              ', null);
        this._el_22 = import2.createRenderElement(this.renderer, this._el_20, 'span', new import2.InlineArray2(2, 'class', 'sr-only'), null);
        this._text_23 = this.renderer.createText(this._el_22, 'toggle', null);
        this._text_24 = this.renderer.createText(this._el_20, '\n            ', null);
        this._text_25 = this.renderer.createText(this._el_17, '\n            ', null);
        this._text_26 = this.renderer.createText(this._el_17, '\n            ', null);
        this._text_27 = this.renderer.createText(this._el_17, '\n            ', null);
        this._el_28 = import2.createRenderElement(this.renderer, this._el_17, 'div', new import2.InlineArray2(2, 'class', 'navbar-custom-menu'), null);
        this._text_29 = this.renderer.createText(this._el_28, '\n              ', null);
        this._el_30 = import2.createRenderElement(this.renderer, this._el_28, 'ul', new import2.InlineArray2(2, 'class', 'nav navbar-nav'), null);
        this._text_31 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_32 = this.renderer.createText(this._el_30, '\n                ', null);
        this._anchor_33 = this.renderer.createTemplateAnchor(this._el_30, null);
        this._appEl_33 = new import5.AppElement(33, 30, this, this._anchor_33);
        this._TemplateRef_33_5 = new import14.TemplateRef_(this._appEl_33, viewFactory_AdminHeaderComponent1);
        this._NgFor_33_6 = new import11.Wrapper_NgFor(this._appEl_33.vcRef, this._TemplateRef_33_5, this.parentInjector.get(import15.IterableDiffers), this.ref);
        this._text_34 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_35 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_36 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_37 = this.renderer.createText(this._el_30, '\n                ', null);
        this._el_38 = import2.createRenderElement(this.renderer, this._el_30, 'li', new import2.InlineArray2(2, 'class', 'dropdown user user-menu'), null);
        this._text_39 = this.renderer.createText(this._el_38, '\n                  ', null);
        this._text_40 = this.renderer.createText(this._el_38, '\n                  ', null);
        this._el_41 = import2.createRenderElement(this.renderer, this._el_38, 'a', new import2.InlineArray2(2, 'href', '#'), null);
        this._RouterLinkWithHref_41_3 = new import12.Wrapper_RouterLinkWithHref(this.parentInjector.get(import16.Router), this.parentInjector.get(import17.ActivatedRoute), this.parentInjector.get(import18.LocationStrategy));
        this._text_42 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._text_43 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._el_44 = import2.createRenderElement(this.renderer, this._el_41, 'div', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-off'), null);
        this._text_45 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._text_46 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._anchor_47 = this.renderer.createTemplateAnchor(this._el_41, null);
        this._appEl_47 = new import5.AppElement(47, 41, this, this._anchor_47);
        this._TemplateRef_47_5 = new import14.TemplateRef_(this._appEl_47, viewFactory_AdminHeaderComponent2);
        this._NgIf_47_6 = new import13.Wrapper_NgIf(this._appEl_47.vcRef, this._TemplateRef_47_5);
        this._text_48 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._anchor_49 = this.renderer.createTemplateAnchor(this._el_41, null);
        this._appEl_49 = new import5.AppElement(49, 41, this, this._anchor_49);
        this._TemplateRef_49_5 = new import14.TemplateRef_(this._appEl_49, viewFactory_AdminHeaderComponent3);
        this._NgIf_49_6 = new import13.Wrapper_NgIf(this._appEl_49.vcRef, this._TemplateRef_49_5);
        this._text_50 = this.renderer.createText(this._el_41, '\n                  ', null);
        this._text_51 = this.renderer.createText(this._el_38, '\n                ', null);
        this._text_52 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_53 = this.renderer.createText(this._el_30, '\n                 ', null);
        this._text_54 = this.renderer.createText(this._el_30, '\n              ', null);
        this._text_55 = this.renderer.createText(this._el_28, '\n            ', null);
        this._text_56 = this.renderer.createText(this._el_17, '\n          ', null);
        this._text_57 = this.renderer.createText(this._el_2, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_41, 'click', this.eventHandler(this._handle_click_41_0.bind(this)));
        this.init([], [
            this._text_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._anchor_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._text_40,
            this._el_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._text_46,
            this._anchor_47,
            this._text_48,
            this._anchor_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._text_53,
            this._text_54,
            this._text_55,
            this._text_56,
            this._text_57
        ], [disposable_0], []);
        return null;
    };
    _View_AdminHeaderComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import14.TemplateRef) && (33 === requestNodeIndex))) {
            return this._TemplateRef_33_5;
        }
        if (((token === import19.NgFor) && (33 === requestNodeIndex))) {
            return this._NgFor_33_6.context;
        }
        if (((token === import14.TemplateRef) && (47 === requestNodeIndex))) {
            return this._TemplateRef_47_5;
        }
        if (((token === import20.NgIf) && (47 === requestNodeIndex))) {
            return this._NgIf_47_6.context;
        }
        if (((token === import14.TemplateRef) && (49 === requestNodeIndex))) {
            return this._TemplateRef_49_5;
        }
        if (((token === import20.NgIf) && (49 === requestNodeIndex))) {
            return this._NgIf_49_6.context;
        }
        if (((token === import21.RouterLinkWithHref) && ((41 <= requestNodeIndex) && (requestNodeIndex <= 50)))) {
            return this._RouterLinkWithHref_41_3.context;
        }
        return notFoundResult;
    };
    _View_AdminHeaderComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_33_0_0 = ((this.context.config.data == null) ? null : this.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_33_6.check_ngForOf(currVal_33_0_0, throwOnChange, false);
        this._NgFor_33_6.detectChangesInInputProps(this, this._anchor_33, throwOnChange);
        var currVal_41_0_0 = this._arr_70('/admin/login');
        this._RouterLinkWithHref_41_3.check_routerLink(currVal_41_0_0, throwOnChange, false);
        this._RouterLinkWithHref_41_3.detectChangesInInputProps(this, this._el_41, throwOnChange);
        var currVal_47_0_0 = this.context.loggedInUser;
        this._NgIf_47_6.check_ngIf(currVal_47_0_0, throwOnChange, false);
        this._NgIf_47_6.detectChangesInInputProps(this, this._anchor_47, throwOnChange);
        var currVal_49_0_0 = !this.context.loggedInUser;
        this._NgIf_49_6.check_ngIf(currVal_49_0_0, throwOnChange, false);
        this._NgIf_49_6.detectChangesInInputProps(this, this._anchor_49, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_68 = import2.interpolate(1, '', ((this.context.config.data == null) ? null : this.context.config.data.APP.ADMIN.TITLE_MINI), '');
        if (import2.checkBinding(throwOnChange, this._expr_68, currVal_68)) {
            this.renderer.setText(this._text_9, currVal_68);
            this._expr_68 = currVal_68;
        }
        var currVal_69 = import2.interpolate(1, '', ((this.context.config.data == null) ? null : this.context.config.data.APP.ADMIN.TITLE), '');
        if (import2.checkBinding(throwOnChange, this._expr_69, currVal_69)) {
            this.renderer.setText(this._text_13, currVal_69);
            this._expr_69 = currVal_69;
        }
        this._RouterLinkWithHref_41_3.detectChangesInHostProps(this, this._el_41, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AdminHeaderComponent0.prototype.destroyInternal = function () {
        this._RouterLinkWithHref_41_3.context.ngOnDestroy();
    };
    _View_AdminHeaderComponent0.prototype._handle_click_41_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_41_0 = (this._RouterLinkWithHref_41_3.context.onClick($event.button, $event.ctrlKey, $event.metaKey) !== false);
        return (true && pd_41_0);
    };
    return _View_AdminHeaderComponent0;
}(import3.AppView));
function viewFactory_AdminHeaderComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminHeaderComponent === null)) {
        (renderType_AdminHeaderComponent = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.None, styles_AdminHeaderComponent, {}));
    }
    return new _View_AdminHeaderComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AdminHeaderComponent0 = viewFactory_AdminHeaderComponent0;
var _View_AdminHeaderComponent1 = (function (_super) {
    __extends(_View_AdminHeaderComponent1, _super);
    function _View_AdminHeaderComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminHeaderComponent1, renderType_AdminHeaderComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminHeaderComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', new import2.InlineArray2(2, 'language-selector', ''), null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = import22.viewFactory_LanguageSelectorComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LanguageSelectorComponent_0_4 = new import22.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService), this.parent.parentInjector.get(import23.Location), this.parent.parentInjector.get(import16.Router), this.parent.parentInjector.get(import24.UtilsService), this.parent.parentInjector.get(import25.CookieService));
        this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n                ', null);
        compView_0.create(this._LanguageSelectorComponent_0_4.context, [], null);
        var disposable_0 = this.renderer.listen(this._el_0, 'onLanguageSelect', this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        var subscription_0 = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_AdminHeaderComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._LanguageSelectorComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AdminHeaderComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.lgRouting.resourcePath;
        this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent.context.lgRouting.currentLanguage;
        this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = this.context.$implicit;
        this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_2, throwOnChange, false);
        this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AdminHeaderComponent1.prototype._handle_onLanguageSelect_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.lgRouting.onSelect($event) !== false);
        return (true && pd_0_0);
    };
    return _View_AdminHeaderComponent1;
}(import3.AppView));
function viewFactory_AdminHeaderComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_AdminHeaderComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_AdminHeaderComponent2 = (function (_super) {
    __extends(_View_AdminHeaderComponent2, _super);
    function _View_AdminHeaderComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminHeaderComponent2, renderType_AdminHeaderComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_AdminHeaderComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', new import2.InlineArray2(2, 'class', 'hidden-xs'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_AdminHeaderComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = import2.interpolate(1, '', this.parent.context.loggedInUser, '');
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminHeaderComponent2;
}(import3.AppView));
function viewFactory_AdminHeaderComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_AdminHeaderComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_AdminHeaderComponent3 = (function (_super) {
    __extends(_View_AdminHeaderComponent3, _super);
    function _View_AdminHeaderComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminHeaderComponent3, renderType_AdminHeaderComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminHeaderComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'span', new import2.InlineArray2(2, 'class', 'hidden-xs'), null);
        this._text_1 = this.renderer.createText(this._el_0, '-', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_AdminHeaderComponent3;
}(import3.AppView));
function viewFactory_AdminHeaderComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_AdminHeaderComponent3(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(150);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(32);
var import9 = __webpack_require__(15);
var import10 = __webpack_require__(86);
var import11 = __webpack_require__(11);
var import12 = __webpack_require__(10);
var import13 = __webpack_require__(22);
var import14 = __webpack_require__(14);
var import15 = __webpack_require__(19);
var import16 = __webpack_require__(295);
var import17 = __webpack_require__(43);
var import18 = __webpack_require__(85);
var import19 = __webpack_require__(412);
var import20 = __webpack_require__(79);
var import21 = __webpack_require__(18);
var import22 = __webpack_require__(47);
var import23 = __webpack_require__(107);
var import24 = __webpack_require__(55);
var import25 = __webpack_require__(26);
var import26 = __webpack_require__(48);
var import27 = __webpack_require__(28);
var import28 = __webpack_require__(33);
var import29 = __webpack_require__(69);
var import30 = __webpack_require__(37);
var Wrapper_AdminLoginComponent = (function () {
    function Wrapper_AdminLoginComponent(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.AdminLoginComponent(p0, p1, p2);
    }
    Wrapper_AdminLoginComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_AdminLoginComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AdminLoginComponent;
}());
exports.Wrapper_AdminLoginComponent = Wrapper_AdminLoginComponent;
var renderType_AdminLoginComponent_Host = null;
var _View_AdminLoginComponent_Host0 = (function (_super) {
    __extends(_View_AdminLoginComponent_Host0, _super);
    function _View_AdminLoginComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminLoginComponent_Host0, renderType_AdminLoginComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminLoginComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'admin-logged-out', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AdminLoginComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AdminLoginComponent_0_4 = new Wrapper_AdminLoginComponent(this.parentInjector.get(import8.Location), this.parentInjector.get(import9.Router), this.parentInjector.get(import10.AuthService));
        this._appEl_0.initComponent(this._AdminLoginComponent_0_4.context, [], compView_0);
        compView_0.create(this._AdminLoginComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AdminLoginComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AdminLoginComponent) && (0 === requestNodeIndex))) {
            return this._AdminLoginComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AdminLoginComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AdminLoginComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AdminLoginComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminLoginComponent_Host0;
}(import1.AppView));
function viewFactory_AdminLoginComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminLoginComponent_Host === null)) {
        (renderType_AdminLoginComponent_Host = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, [], {}));
    }
    return new _View_AdminLoginComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AdminLoginComponentNgFactory = new import12.ComponentFactory('admin-logged-out', viewFactory_AdminLoginComponent_Host0, import0.AdminLoginComponent);
var styles_AdminLoginComponent = [];
var renderType_AdminLoginComponent = null;
var _View_AdminLoginComponent0 = (function (_super) {
    __extends(_View_AdminLoginComponent0, _super);
    function _View_AdminLoginComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminLoginComponent0, renderType_AdminLoginComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminLoginComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n', null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_2 = import4.createRenderElement(this.renderer, parentRenderNode, 'div', new import4.InlineArray4(4, 'class', 'login-box', 'ng-controller', 'AdminLoginCtrl'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n  ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'login-logo logo-custum '), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n    GuernCMS\n  ', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_7 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n  ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'login-box-body'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n    ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'p', new import4.InlineArray2(2, 'class', 'login-box-msg'), null);
        this._text_12 = this.renderer.createText(this._el_11, 'Connexion à l\'administration', null);
        this._text_13 = this.renderer.createText(this._el_9, '\n\n        ', null);
        this._text_14 = this.renderer.createText(this._el_9, '\n\n      ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_9, null);
        this._appEl_15 = new import3.AppElement(15, 9, this, this._anchor_15);
        this._TemplateRef_15_5 = new import14.TemplateRef_(this._appEl_15, viewFactory_AdminLoginComponent1);
        this._NgIf_15_6 = new import13.Wrapper_NgIf(this._appEl_15.vcRef, this._TemplateRef_15_5);
        this._text_16 = this.renderer.createText(this._el_9, '\n\n  ', null);
        this._text_17 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_18 = this.renderer.createText(this._el_2, '\n', null);
        this._text_19 = this.renderer.createText(parentRenderNode, '\n', null);
        this.init([], [
            this._text_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._text_19
        ], [], []);
        return null;
    };
    _View_AdminLoginComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import14.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import15.NgIf) && (15 === requestNodeIndex))) {
            return this._NgIf_15_6.context;
        }
        return notFoundResult;
    };
    _View_AdminLoginComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_15_0_0 = this.context.credentials;
        this._NgIf_15_6.check_ngIf(currVal_15_0_0, throwOnChange, false);
        this._NgIf_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminLoginComponent0;
}(import1.AppView));
function viewFactory_AdminLoginComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminLoginComponent === null)) {
        (renderType_AdminLoginComponent = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, styles_AdminLoginComponent, {}));
    }
    return new _View_AdminLoginComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AdminLoginComponent0 = viewFactory_AdminLoginComponent0;
var _View_AdminLoginComponent1 = (function (_super) {
    __extends(_View_AdminLoginComponent1, _super);
    function _View_AdminLoginComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminLoginComponent1, renderType_AdminLoginComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminLoginComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'form', import4.EMPTY_INLINE_ARRAY, null);
        this._NgForm_0_3 = new import16.Wrapper_NgForm(null, null);
        this._ControlContainer_0_4 = this._NgForm_0_3.context;
        this._NgControlStatusGroup_0_5 = new import17.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'form-group has-feedback'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n            ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'input', new import4.InlineArray16(10, 'class', 'form-control', 'name', 'username', 'placeholder', 'Utilisateur', 'required', '', 'type', 'text'), null);
        this._DefaultValueAccessor_4_3 = new import18.Wrapper_DefaultValueAccessor(this.renderer, new import21.ElementRef(this._el_4));
        this._RequiredValidator_4_4 = new import19.Wrapper_RequiredValidator();
        this._NG_VALIDATORS_4_5 = [this._RequiredValidator_4_4.context];
        this._NG_VALUE_ACCESSOR_4_6 = [this._DefaultValueAccessor_4_3.context];
        this._NgModel_4_7 = new import20.Wrapper_NgModel(this._ControlContainer_0_4, this._NG_VALIDATORS_4_5, null, this._NG_VALUE_ACCESSOR_4_6);
        this._NgControl_4_8 = this._NgModel_4_7.context;
        this._NgControlStatus_4_9 = new import17.Wrapper_NgControlStatus(this._NgControl_4_8);
        this._text_5 = this.renderer.createText(this._el_2, '\n            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_2, 'span', new import4.InlineArray2(2, 'class', 'glyphicon glyphicon-user form-control-feedback'), null);
        this._text_7 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_8 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'form-group has-feedback'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n            ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'input', new import4.InlineArray16(10, 'class', 'form-control', 'name', 'password', 'placeholder', 'Mot de passe', 'required', '', 'type', 'password'), null);
        this._DefaultValueAccessor_11_3 = new import18.Wrapper_DefaultValueAccessor(this.renderer, new import21.ElementRef(this._el_11));
        this._RequiredValidator_11_4 = new import19.Wrapper_RequiredValidator();
        this._NG_VALIDATORS_11_5 = [this._RequiredValidator_11_4.context];
        this._NG_VALUE_ACCESSOR_11_6 = [this._DefaultValueAccessor_11_3.context];
        this._NgModel_11_7 = new import20.Wrapper_NgModel(this._ControlContainer_0_4, this._NG_VALIDATORS_11_5, null, this._NG_VALUE_ACCESSOR_11_6);
        this._NgControl_11_8 = this._NgModel_11_7.context;
        this._NgControlStatus_11_9 = new import17.Wrapper_NgControlStatus(this._NgControl_11_8);
        this._text_12 = this.renderer.createText(this._el_9, '\n            ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_9, 'span', new import4.InlineArray2(2, 'class', 'glyphicon glyphicon-lock form-control-feedback'), null);
        this._text_14 = this.renderer.createText(this._el_9, '\n        ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n            ', null);
        this._text_18 = this.renderer.createText(this._el_16, '\n            ', null);
        this._text_19 = this.renderer.createText(this._el_16, '\n            ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_16, 'div', new import4.InlineArray2(2, 'class', 'col-xs-4 pull-right'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n            ', null);
        this._text_22 = this.renderer.createText(this._el_20, '\n            ', null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_20, 'button', new import4.InlineArray4(4, 'class', 'btn btn-primary btn-block btn-flat btn-custom', 'type', 'submit'), null);
        this._text_24 = this.renderer.createText(this._el_23, 'Valider', null);
        this._text_25 = this.renderer.createText(this._el_20, '\n            ', null);
        this._text_26 = this.renderer.createText(this._el_16, '\n            ', null);
        this._text_27 = this.renderer.createText(this._el_16, '\n        ', null);
        this._text_28 = this.renderer.createText(this._el_0, '\n    ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._NgForm_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_4, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_4_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_4, 'input', this.eventHandler(this._handle_input_4_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_4, 'blur', this.eventHandler(this._handle_blur_4_2.bind(this)));
        var subscription_1 = this._NgModel_4_7.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_4_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_11, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_11_0.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_11, 'input', this.eventHandler(this._handle_input_11_1.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_11, 'blur', this.eventHandler(this._handle_blur_11_2.bind(this)));
        var subscription_2 = this._NgModel_11_7.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_11_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], [
            subscription_0,
            subscription_1,
            subscription_2
        ]);
        return null;
    };
    _View_AdminLoginComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import22.DefaultValueAccessor) && (4 === requestNodeIndex))) {
            return this._DefaultValueAccessor_4_3.context;
        }
        if (((token === import23.RequiredValidator) && (4 === requestNodeIndex))) {
            return this._RequiredValidator_4_4.context;
        }
        if (((token === import24.NG_VALIDATORS) && (4 === requestNodeIndex))) {
            return this._NG_VALIDATORS_4_5;
        }
        if (((token === import25.NG_VALUE_ACCESSOR) && (4 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_4_6;
        }
        if (((token === import26.NgModel) && (4 === requestNodeIndex))) {
            return this._NgModel_4_7.context;
        }
        if (((token === import27.NgControl) && (4 === requestNodeIndex))) {
            return this._NgControl_4_8;
        }
        if (((token === import28.NgControlStatus) && (4 === requestNodeIndex))) {
            return this._NgControlStatus_4_9.context;
        }
        if (((token === import22.DefaultValueAccessor) && (11 === requestNodeIndex))) {
            return this._DefaultValueAccessor_11_3.context;
        }
        if (((token === import23.RequiredValidator) && (11 === requestNodeIndex))) {
            return this._RequiredValidator_11_4.context;
        }
        if (((token === import24.NG_VALIDATORS) && (11 === requestNodeIndex))) {
            return this._NG_VALIDATORS_11_5;
        }
        if (((token === import25.NG_VALUE_ACCESSOR) && (11 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_11_6;
        }
        if (((token === import26.NgModel) && (11 === requestNodeIndex))) {
            return this._NgModel_11_7.context;
        }
        if (((token === import27.NgControl) && (11 === requestNodeIndex))) {
            return this._NgControl_11_8;
        }
        if (((token === import28.NgControlStatus) && (11 === requestNodeIndex))) {
            return this._NgControlStatus_11_9.context;
        }
        if (((token === import29.NgForm) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) {
            return this._NgForm_0_3.context;
        }
        if (((token === import30.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import28.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 28)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_AdminLoginComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        this._NgForm_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_4_3.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_4_1_0 = '';
        this._RequiredValidator_4_4.check_required(currVal_4_1_0, throwOnChange, false);
        this._RequiredValidator_4_4.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_4_2_0 = 'username';
        this._NgModel_4_7.check_name(currVal_4_2_0, throwOnChange, false);
        var currVal_4_2_1 = this.parent.context.credentials.username;
        this._NgModel_4_7.check_model(currVal_4_2_1, throwOnChange, false);
        this._NgModel_4_7.detectChangesInInputProps(this, this._el_4, throwOnChange);
        this._NgControlStatus_4_9.detectChangesInInputProps(this, this._el_4, throwOnChange);
        this._DefaultValueAccessor_11_3.detectChangesInInputProps(this, this._el_11, throwOnChange);
        var currVal_11_1_0 = '';
        this._RequiredValidator_11_4.check_required(currVal_11_1_0, throwOnChange, false);
        this._RequiredValidator_11_4.detectChangesInInputProps(this, this._el_11, throwOnChange);
        var currVal_11_2_0 = 'password';
        this._NgModel_11_7.check_name(currVal_11_2_0, throwOnChange, false);
        var currVal_11_2_1 = this.parent.context.credentials.password;
        this._NgModel_11_7.check_model(currVal_11_2_1, throwOnChange, false);
        this._NgModel_11_7.detectChangesInInputProps(this, this._el_11, throwOnChange);
        this._NgControlStatus_11_9.detectChangesInInputProps(this, this._el_11, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgForm_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_4_3.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._RequiredValidator_4_4.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._NgModel_4_7.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._NgControlStatus_4_9.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._DefaultValueAccessor_11_3.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._RequiredValidator_11_4.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._NgModel_11_7.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._NgControlStatus_11_9.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AdminLoginComponent1.prototype.destroyInternal = function () {
        this._NgModel_4_7.context.ngOnDestroy();
        this._NgModel_11_7.context.ngOnDestroy();
    };
    _View_AdminLoginComponent1.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.login(this.parent.context.credentials) !== false);
        return (true && pd_0_0);
    };
    _View_AdminLoginComponent1.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._NgForm_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_AdminLoginComponent1.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._NgForm_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_AdminLoginComponent1.prototype._handle_ngModelChange_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = ((this.parent.context.credentials.username = $event) !== false);
        return (true && pd_4_0);
    };
    _View_AdminLoginComponent1.prototype._handle_input_4_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this._DefaultValueAccessor_4_3.context.onChange($event.target.value) !== false);
        return (true && pd_4_0);
    };
    _View_AdminLoginComponent1.prototype._handle_blur_4_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this._DefaultValueAccessor_4_3.context.onTouched() !== false);
        return (true && pd_4_0);
    };
    _View_AdminLoginComponent1.prototype._handle_ngModelChange_11_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = ((this.parent.context.credentials.password = $event) !== false);
        return (true && pd_11_0);
    };
    _View_AdminLoginComponent1.prototype._handle_input_11_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = (this._DefaultValueAccessor_11_3.context.onChange($event.target.value) !== false);
        return (true && pd_11_0);
    };
    _View_AdminLoginComponent1.prototype._handle_blur_11_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = (this._DefaultValueAccessor_11_3.context.onTouched() !== false);
        return (true && pd_11_0);
    };
    return _View_AdminLoginComponent1;
}(import1.AppView));
function viewFactory_AdminLoginComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_AdminLoginComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(223);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(11);
var import10 = __webpack_require__(10);
var import11 = __webpack_require__(313);
var import12 = __webpack_require__(30);
var import13 = __webpack_require__(29);
var import14 = __webpack_require__(16);
var import15 = __webpack_require__(15);
var import16 = __webpack_require__(177);
var Wrapper_AdminMenuComponent = (function () {
    function Wrapper_AdminMenuComponent(p0) {
        this.changed = false;
        this.context = new import0.AdminMenuComponent(p0);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_AdminMenuComponent.prototype.check_currentLanguage = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.currentLanguage = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_AdminMenuComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_AdminMenuComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AdminMenuComponent;
}());
exports.Wrapper_AdminMenuComponent = Wrapper_AdminMenuComponent;
var renderType_AdminMenuComponent_Host = null;
var _View_AdminMenuComponent_Host0 = (function (_super) {
    __extends(_View_AdminMenuComponent_Host0, _super);
    function _View_AdminMenuComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminMenuComponent_Host0, renderType_AdminMenuComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminMenuComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'admin-menu', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AdminMenuComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AdminMenuComponent_0_4 = new Wrapper_AdminMenuComponent(this.parentInjector.get(import8.UtilsService));
        this._appEl_0.initComponent(this._AdminMenuComponent_0_4.context, [], compView_0);
        compView_0.create(this._AdminMenuComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AdminMenuComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AdminMenuComponent) && (0 === requestNodeIndex))) {
            return this._AdminMenuComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AdminMenuComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AdminMenuComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AdminMenuComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminMenuComponent_Host0;
}(import3.AppView));
function viewFactory_AdminMenuComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminMenuComponent_Host === null)) {
        (renderType_AdminMenuComponent_Host = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.None, [], {}));
    }
    return new _View_AdminMenuComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AdminMenuComponentNgFactory = new import10.ComponentFactory('admin-menu', viewFactory_AdminMenuComponent_Host0, import0.AdminMenuComponent);
var styles_AdminMenuComponent = [];
var renderType_AdminMenuComponent = null;
var _View_AdminMenuComponent0 = (function (_super) {
    __extends(_View_AdminMenuComponent0, _super);
    function _View_AdminMenuComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminMenuComponent0, renderType_AdminMenuComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._arr_109 = import2.pureProxy3(function (p0, p1, p2) {
            return [
                p0,
                p1,
                p2
            ];
        });
    }
    _View_AdminMenuComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '      ', null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n      ', null);
        this._el_2 = import2.createRenderElement(this.renderer, parentRenderNode, 'aside', new import2.InlineArray2(2, 'class', 'main-sidebar'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n        ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_2, 'section', new import2.InlineArray2(2, 'class', 'sidebar'), null);
        this._text_6 = this.renderer.createText(this._el_5, ' \n\n          ', null);
        this._el_7 = import2.createRenderElement(this.renderer, this._el_5, 'search', new import2.InlineArray4(4, 'placeholder', 'Rechercher', 'target', 'admin/records'), null);
        this._appEl_7 = new import5.AppElement(7, 5, this, this._el_7);
        var compView_7 = import11.viewFactory_SearchComponent0(this.viewUtils, this.injector(7), this._appEl_7);
        this._SearchComponent_7_4 = new import11.Wrapper_SearchComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import12.SearchService), this.parentInjector.get(import13.ElasticSearchService), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router));
        this._appEl_7.initComponent(this._SearchComponent_7_4.context, [], compView_7);
        this._text_8 = this.renderer.createText(null, '\n          ', null);
        compView_7.create(this._SearchComponent_7_4.context, [], null);
        this._text_9 = this.renderer.createText(this._el_5, '\n\n          ', null);
        this._text_10 = this.renderer.createText(this._el_5, ' \n          ', null);
        this._el_11 = import2.createRenderElement(this.renderer, this._el_5, 'ul', new import2.InlineArray2(2, 'class', 'sidebar-menu'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_13 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_14 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n                ', null);
        this._el_16 = import2.createRenderElement(this.renderer, this._el_14, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_16, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-cd'), null);
        this._text_18 = this.renderer.createText(this._el_16, '\n                  ', null);
        this._el_19 = import2.createRenderElement(this.renderer, this._el_16, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_20 = this.renderer.createText(this._el_19, 'Nouveau disque', null);
        this._text_21 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_22 = this.renderer.createText(this._el_14, '\n            ', null);
        this._text_23 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_24 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_25 = this.renderer.createText(this._el_24, '\n                ', null);
        this._el_26 = import2.createRenderElement(this.renderer, this._el_24, 'a', new import2.InlineArray2(2, 'href', '#'), null);
        this._text_27 = this.renderer.createText(this._el_26, '\n                  ', null);
        this._el_28 = import2.createRenderElement(this.renderer, this._el_26, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-list'), null);
        this._text_29 = this.renderer.createText(this._el_26, '\n                  ', null);
        this._el_30 = import2.createRenderElement(this.renderer, this._el_26, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_31 = this.renderer.createText(this._el_30, 'Catalogue', null);
        this._text_32 = this.renderer.createText(this._el_26, '\n                  ', null);
        this._el_33 = import2.createRenderElement(this.renderer, this._el_26, 'span', new import2.InlineArray2(2, 'class', 'pull-right-container'), null);
        this._text_34 = this.renderer.createText(this._el_33, '\n                    ', null);
        this._el_35 = import2.createRenderElement(this.renderer, this._el_33, 'i', new import2.InlineArray2(2, 'class', 'fa fa-angle-left pull-right'), null);
        this._text_36 = this.renderer.createText(this._el_33, '\n                  ', null);
        this._text_37 = this.renderer.createText(this._el_26, '\n                ', null);
        this._text_38 = this.renderer.createText(this._el_24, '\n                ', null);
        this._el_39 = import2.createRenderElement(this.renderer, this._el_24, 'ul', new import2.InlineArray2(2, 'class', 'treeview-menu'), null);
        this._text_40 = this.renderer.createText(this._el_39, '\n                  ', null);
        this._el_41 = import2.createRenderElement(this.renderer, this._el_39, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._el_42 = import2.createRenderElement(this.renderer, this._el_41, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_43 = import2.createRenderElement(this.renderer, this._el_42, 'i', new import2.InlineArray2(2, 'class', 'fa fa-circle-o'), null);
        this._text_44 = this.renderer.createText(this._el_42, ' Tout le catalogue', null);
        this._text_45 = this.renderer.createText(this._el_39, '\n                  ', null);
        this._el_46 = import2.createRenderElement(this.renderer, this._el_39, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._el_47 = import2.createRenderElement(this.renderer, this._el_46, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_48 = import2.createRenderElement(this.renderer, this._el_47, 'i', new import2.InlineArray2(2, 'class', 'fa fa-circle-o'), null);
        this._text_49 = this.renderer.createText(this._el_47, ' Interprètes d\'hier', null);
        this._text_50 = this.renderer.createText(this._el_39, '\n                  ', null);
        this._el_51 = import2.createRenderElement(this.renderer, this._el_39, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._el_52 = import2.createRenderElement(this.renderer, this._el_51, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_53 = import2.createRenderElement(this.renderer, this._el_52, 'i', new import2.InlineArray2(2, 'class', 'fa fa-circle-o'), null);
        this._text_54 = this.renderer.createText(this._el_52, ' Interprètes d\'aujourd\'hui', null);
        this._text_55 = this.renderer.createText(this._el_39, '\n                  ', null);
        this._el_56 = import2.createRenderElement(this.renderer, this._el_39, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._el_57 = import2.createRenderElement(this.renderer, this._el_56, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_58 = import2.createRenderElement(this.renderer, this._el_57, 'i', new import2.InlineArray2(2, 'class', 'fa fa-circle-o'), null);
        this._text_59 = this.renderer.createText(this._el_57, ' Non-publié', null);
        this._text_60 = this.renderer.createText(this._el_39, '\n                ', null);
        this._text_61 = this.renderer.createText(this._el_24, '\n              ', null);
        this._text_62 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_63 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_64 = this.renderer.createText(this._el_63, '\n              ', null);
        this._el_65 = import2.createRenderElement(this.renderer, this._el_63, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_66 = import2.createRenderElement(this.renderer, this._el_65, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-star'), null);
        this._text_67 = this.renderer.createText(this._el_65, '\n                ', null);
        this._el_68 = import2.createRenderElement(this.renderer, this._el_65, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_69 = this.renderer.createText(this._el_68, 'Parmi les interprètes', null);
        this._text_70 = this.renderer.createText(this._el_65, '\n              ', null);
        this._text_71 = this.renderer.createText(this._el_63, '\n            ', null);
        this._text_72 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_73 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_74 = this.renderer.createText(this._el_73, '\n                ', null);
        this._el_75 = import2.createRenderElement(this.renderer, this._el_73, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_76 = import2.createRenderElement(this.renderer, this._el_75, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-text-size'), null);
        this._text_77 = this.renderer.createText(this._el_75, '\n                  ', null);
        this._el_78 = import2.createRenderElement(this.renderer, this._el_75, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_79 = this.renderer.createText(this._el_78, 'Ecrits', null);
        this._text_80 = this.renderer.createText(this._el_75, '\n                ', null);
        this._text_81 = this.renderer.createText(this._el_73, '\n            ', null);
        this._text_82 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_83 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_84 = this.renderer.createText(this._el_83, '\n                ', null);
        this._el_85 = import2.createRenderElement(this.renderer, this._el_83, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_86 = import2.createRenderElement(this.renderer, this._el_85, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-paperclip'), null);
        this._text_87 = this.renderer.createText(this._el_85, '\n                  ', null);
        this._el_88 = import2.createRenderElement(this.renderer, this._el_85, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_89 = this.renderer.createText(this._el_88, 'Messages', null);
        this._text_90 = this.renderer.createText(this._el_85, '\n                ', null);
        this._text_91 = this.renderer.createText(this._el_83, '\n            ', null);
        this._text_92 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_93 = import2.createRenderElement(this.renderer, this._el_11, 'li', new import2.InlineArray2(2, 'class', 'treeview'), null);
        this._text_94 = this.renderer.createText(this._el_93, '\n                ', null);
        this._el_95 = import2.createRenderElement(this.renderer, this._el_93, 'a', new import2.InlineArray2(2, 'class', 'lLink'), null);
        this._el_96 = import2.createRenderElement(this.renderer, this._el_95, 'i', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-file'), null);
        this._text_97 = this.renderer.createText(this._el_95, '\n                  ', null);
        this._el_98 = import2.createRenderElement(this.renderer, this._el_95, 'span', import2.EMPTY_INLINE_ARRAY, null);
        this._text_99 = this.renderer.createText(this._el_98, 'Pages', null);
        this._text_100 = this.renderer.createText(this._el_95, '\n                ', null);
        this._text_101 = this.renderer.createText(this._el_93, '\n              ', null);
        this._text_102 = this.renderer.createText(this._el_11, '\n          ', null);
        this._text_103 = this.renderer.createText(this._el_5, '\n          ', null);
        this._text_104 = this.renderer.createText(this._el_5, '\n        ', null);
        this._text_105 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_106 = this.renderer.createText(this._el_2, '\n      ', null);
        var disposable_0 = this.renderer.listen(this._el_16, 'click', this.eventHandler(this._handle_click_16_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_42, 'click', this.eventHandler(this._handle_click_42_0.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_47, 'click', this.eventHandler(this._handle_click_47_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_52, 'click', this.eventHandler(this._handle_click_52_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_57, 'click', this.eventHandler(this._handle_click_57_0.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_65, 'click', this.eventHandler(this._handle_click_65_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_75, 'click', this.eventHandler(this._handle_click_75_0.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_85, 'click', this.eventHandler(this._handle_click_85_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_95, 'click', this.eventHandler(this._handle_click_95_0.bind(this)));
        this.init([], [
            this._text_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._el_33,
            this._text_34,
            this._el_35,
            this._text_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._el_41,
            this._el_42,
            this._el_43,
            this._text_44,
            this._text_45,
            this._el_46,
            this._el_47,
            this._el_48,
            this._text_49,
            this._text_50,
            this._el_51,
            this._el_52,
            this._el_53,
            this._text_54,
            this._text_55,
            this._el_56,
            this._el_57,
            this._el_58,
            this._text_59,
            this._text_60,
            this._text_61,
            this._text_62,
            this._el_63,
            this._text_64,
            this._el_65,
            this._el_66,
            this._text_67,
            this._el_68,
            this._text_69,
            this._text_70,
            this._text_71,
            this._text_72,
            this._el_73,
            this._text_74,
            this._el_75,
            this._el_76,
            this._text_77,
            this._el_78,
            this._text_79,
            this._text_80,
            this._text_81,
            this._text_82,
            this._el_83,
            this._text_84,
            this._el_85,
            this._el_86,
            this._text_87,
            this._el_88,
            this._text_89,
            this._text_90,
            this._text_91,
            this._text_92,
            this._el_93,
            this._text_94,
            this._el_95,
            this._el_96,
            this._text_97,
            this._el_98,
            this._text_99,
            this._text_100,
            this._text_101,
            this._text_102,
            this._text_103,
            this._text_104,
            this._text_105,
            this._text_106
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], []);
        return null;
    };
    _View_AdminMenuComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.SearchComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) {
            return this._SearchComponent_7_4.context;
        }
        return notFoundResult;
    };
    _View_AdminMenuComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_7_0_0 = this._arr_109('composer', 'soloist', 'conductor');
        this._SearchComponent_7_4.check_order(currVal_7_0_0, throwOnChange, false);
        var currVal_7_0_1 = 'admin/records';
        this._SearchComponent_7_4.check_target(currVal_7_0_1, throwOnChange, false);
        var currVal_7_0_2 = 'Rechercher';
        this._SearchComponent_7_4.check_placeholder(currVal_7_0_2, throwOnChange, false);
        var currVal_7_0_3 = this.context.currentLanguage;
        this._SearchComponent_7_4.check_language(currVal_7_0_3, throwOnChange, false);
        this._SearchComponent_7_4.detectChangesInInputProps(this, this._el_7, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchComponent_7_4.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AdminMenuComponent0.prototype._handle_click_16_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_16_0 = (this.context.utils.lLink('admin/record/edit/0', this.context.currentLanguage) !== false);
        return (true && pd_16_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_42_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_42_0 = (this.context.utils.lLink('admin/records', this.context.currentLanguage) !== false);
        return (true && pd_42_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_47_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_47_0 = (this.context.utils.lLink('admin/records?f=type~reissue', this.context.currentLanguage) !== false);
        return (true && pd_47_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_52_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_52_0 = (this.context.utils.lLink('admin/records?f=type~production', this.context.currentLanguage) !== false);
        return (true && pd_52_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_57_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_57_0 = (this.context.utils.lLink('admin/records/active/false', this.context.currentLanguage) !== false);
        return (true && pd_57_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_65_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_65_0 = (this.context.utils.lLink('admin/specials', this.context.currentLanguage) !== false);
        return (true && pd_65_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_75_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_75_0 = (this.context.utils.lLink('admin/writings', this.context.currentLanguage) !== false);
        return (true && pd_75_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_85_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_85_0 = (this.context.utils.lLink('admin/messages', this.context.currentLanguage) !== false);
        return (true && pd_85_0);
    };
    _View_AdminMenuComponent0.prototype._handle_click_95_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_95_0 = (this.context.utils.lLink('admin/pages', this.context.currentLanguage) !== false);
        return (true && pd_95_0);
    };
    return _View_AdminMenuComponent0;
}(import3.AppView));
function viewFactory_AdminMenuComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminMenuComponent === null)) {
        (renderType_AdminMenuComponent = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.None, styles_AdminMenuComponent, {}));
    }
    return new _View_AdminMenuComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AdminMenuComponent0 = viewFactory_AdminMenuComponent0;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(151);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(45);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(18);
var import10 = __webpack_require__(15);
var import11 = __webpack_require__(86);
var import12 = __webpack_require__(11);
var import13 = __webpack_require__(10);
var import14 = __webpack_require__(414);
var import15 = __webpack_require__(309);
var import16 = __webpack_require__(419);
var import17 = __webpack_require__(421);
var import18 = __webpack_require__(219);
var import19 = __webpack_require__(418);
var import20 = __webpack_require__(5);
var import21 = __webpack_require__(32);
var import22 = __webpack_require__(2);
var import23 = __webpack_require__(77);
var import24 = __webpack_require__(75);
var import25 = __webpack_require__(83);
var import26 = __webpack_require__(222);
var import27 = __webpack_require__(223);
var import28 = __webpack_require__(93);
var import29 = __webpack_require__(221);
var import30 = __webpack_require__(117);
var Wrapper_AdminRootComponent = (function () {
    function Wrapper_AdminRootComponent(p0, p1) {
        this.changed = false;
        this.context = new import0.AdminRootComponent(p0, p1);
    }
    Wrapper_AdminRootComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_AdminRootComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AdminRootComponent;
}());
exports.Wrapper_AdminRootComponent = Wrapper_AdminRootComponent;
var renderType_AdminRootComponent_Host = null;
var _View_AdminRootComponent_Host0 = (function (_super) {
    __extends(_View_AdminRootComponent_Host0, _super);
    function _View_AdminRootComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminRootComponent_Host0, renderType_AdminRootComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    Object.defineProperty(_View_AdminRootComponent_Host0.prototype, "_NotificationService_0_5", {
        get: function () {
            if ((this.__NotificationService_0_5 == null)) {
                (this.__NotificationService_0_5 = new import4.NotificationService(new import9.ElementRef(this._el_0), this.renderer));
            }
            return this.__NotificationService_0_5;
        },
        enumerable: true,
        configurable: true
    });
    _View_AdminRootComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AdminRootComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AdminRootComponent_0_4 = new Wrapper_AdminRootComponent(this.parentInjector.get(import10.Router), this.parentInjector.get(import11.AuthService));
        this._appEl_0.initComponent(this._AdminRootComponent_0_4.context, [], compView_0);
        compView_0.create(this._AdminRootComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AdminRootComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AdminRootComponent) && (0 === requestNodeIndex))) {
            return this._AdminRootComponent_0_4.context;
        }
        if (((token === import4.NotificationService) && (0 === requestNodeIndex))) {
            return this._NotificationService_0_5;
        }
        return notFoundResult;
    };
    _View_AdminRootComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AdminRootComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AdminRootComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AdminRootComponent_Host0;
}(import1.AppView));
function viewFactory_AdminRootComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminRootComponent_Host === null)) {
        (renderType_AdminRootComponent_Host = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.None, [], {}));
    }
    return new _View_AdminRootComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AdminRootComponentNgFactory = new import13.ComponentFactory('ng-component', viewFactory_AdminRootComponent_Host0, import0.AdminRootComponent);
var styles_AdminRootComponent = [import14.styles];
var renderType_AdminRootComponent = null;
var _View_AdminRootComponent0 = (function (_super) {
    __extends(_View_AdminRootComponent0, _super);
    function _View_AdminRootComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AdminRootComponent0, renderType_AdminRootComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_AdminRootComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '    ', null);
        this._el_1 = import5.createRenderElement(this.renderer, parentRenderNode, 'div', new import5.InlineArray4(4, 'class', 'wrapper', 'lg-routing', ''), null);
        this._LanguageRoutingComponent_1_3 = new import15.Wrapper_LanguageRoutingComponent(this.parentInjector.get(import20.ConfigService), this.parentInjector.get(import21.Location), this.parentInjector.get(import10.Router), this.parentInjector.get(import22.UtilsService), this.parentInjector.get(import23.CookieService));
        this._text_2 = this.renderer.createText(this._el_1, '\n\n        ', null);
        this._text_3 = this.renderer.createText(this._el_1, '\n        ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_1, 'admin-header', import5.EMPTY_INLINE_ARRAY, null);
        this._appEl_4 = new import3.AppElement(4, 1, this, this._el_4);
        var compView_4 = import16.viewFactory_AdminHeaderComponent0(this.viewUtils, this.injector(4), this._appEl_4);
        this._AdminHeaderComponent_4_4 = new import16.Wrapper_AdminHeaderComponent(this.parentInjector.get(import20.ConfigService));
        this._appEl_4.initComponent(this._AdminHeaderComponent_4_4.context, [], compView_4);
        this._text_5 = this.renderer.createText(null, '\n        ', null);
        compView_4.create(this._AdminHeaderComponent_4_4.context, [], null);
        this._text_6 = this.renderer.createText(this._el_1, '\n        \n        ', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_1, 'admin-menu', import5.EMPTY_INLINE_ARRAY, null);
        this._appEl_7 = new import3.AppElement(7, 1, this, this._el_7);
        var compView_7 = import17.viewFactory_AdminMenuComponent0(this.viewUtils, this.injector(7), this._appEl_7);
        this._AdminMenuComponent_7_4 = new import17.Wrapper_AdminMenuComponent(this.parentInjector.get(import22.UtilsService));
        this._appEl_7.initComponent(this._AdminMenuComponent_7_4.context, [], compView_7);
        this._text_8 = this.renderer.createText(null, '\n        ', null);
        compView_7.create(this._AdminMenuComponent_7_4.context, [], null);
        this._text_9 = this.renderer.createText(this._el_1, '\n\n        ', null);
        this._el_10 = import5.createRenderElement(this.renderer, this._el_1, 'div', new import5.InlineArray2(2, 'class', 'content-wrapper white-bg'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n            ', null);
        this._text_12 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_10, 'div', new import5.InlineArray2(2, 'id', 'snackbar'), null);
        this._text_14 = this.renderer.createText(this._el_10, '\n\n            ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_10, 'router-outlet', import5.EMPTY_INLINE_ARRAY, null);
        this._appEl_15 = new import3.AppElement(15, 10, this, this._el_15);
        this._RouterOutlet_15_5 = new import18.Wrapper_RouterOutlet(this.parentInjector.get(import24.RouterOutletMap), this._appEl_15.vcRef, this.parentInjector.get(import25.ComponentFactoryResolver), null);
        this._text_16 = this.renderer.createText(this._el_10, '\n        ', null);
        this._text_17 = this.renderer.createText(this._el_1, '\n\n        ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_1, 'admin-footer', import5.EMPTY_INLINE_ARRAY, null);
        this._appEl_18 = new import3.AppElement(18, 1, this, this._el_18);
        var compView_18 = import19.viewFactory_AdminFooterComponent0(this.viewUtils, this.injector(18), this._appEl_18);
        this._AdminFooterComponent_18_4 = new import19.Wrapper_AdminFooterComponent();
        this._appEl_18.initComponent(this._AdminFooterComponent_18_4.context, [], compView_18);
        compView_18.create(this._AdminFooterComponent_18_4.context, [], null);
        this._text_19 = this.renderer.createText(this._el_1, '\n      \n    ', null);
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19
        ], [], []);
        return null;
    };
    _View_AdminRootComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.AdminHeaderComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) {
            return this._AdminHeaderComponent_4_4.context;
        }
        if (((token === import27.AdminMenuComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) {
            return this._AdminMenuComponent_7_4.context;
        }
        if (((token === import28.RouterOutlet) && (15 === requestNodeIndex))) {
            return this._RouterOutlet_15_5.context;
        }
        if (((token === import29.AdminFooterComponent) && (18 === requestNodeIndex))) {
            return this._AdminFooterComponent_18_4.context;
        }
        if (((token === import30.LanguageRoutingComponent) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 19)))) {
            return this._LanguageRoutingComponent_1_3.context;
        }
        return notFoundResult;
    };
    _View_AdminRootComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        this._LanguageRoutingComponent_1_3.detectChangesInInputProps(this, this._el_1, throwOnChange);
        var currVal_4_0_0 = this._LanguageRoutingComponent_1_3.context;
        this._AdminHeaderComponent_4_4.check_lgRouting(currVal_4_0_0, throwOnChange, false);
        var currVal_4_0_1 = this.context.loggedInUser;
        this._AdminHeaderComponent_4_4.check_loggedInUser(currVal_4_0_1, throwOnChange, false);
        this._AdminHeaderComponent_4_4.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_7_0_0 = this._LanguageRoutingComponent_1_3.context.currentLanguage;
        this._AdminMenuComponent_7_4.check_currentLanguage(currVal_7_0_0, throwOnChange, false);
        this._AdminMenuComponent_7_4.detectChangesInInputProps(this, this._el_7, throwOnChange);
        this._RouterOutlet_15_5.detectChangesInInputProps(this, this._el_15, throwOnChange);
        this._AdminFooterComponent_18_4.detectChangesInInputProps(this, this._el_18, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageRoutingComponent_1_3.detectChangesInHostProps(this, this._el_1, throwOnChange);
        this._AdminHeaderComponent_4_4.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this._AdminMenuComponent_7_4.detectChangesInHostProps(this, this._el_7, throwOnChange);
        this._RouterOutlet_15_5.detectChangesInHostProps(this, this._el_15, throwOnChange);
        this._AdminFooterComponent_18_4.detectChangesInHostProps(this, this._el_18, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AdminRootComponent0.prototype.destroyInternal = function () {
        this._RouterOutlet_15_5.context.ngOnDestroy();
    };
    return _View_AdminRootComponent0;
}(import1.AppView));
function viewFactory_AdminRootComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AdminRootComponent === null)) {
        (renderType_AdminRootComponent = viewUtils.createRenderComponentType('', 0, import12.ViewEncapsulation.Emulated, styles_AdminRootComponent, {}));
    }
    return new _View_AdminRootComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AdminRootComponent0 = viewFactory_AdminRootComponent0;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var search_elasticsearch_service_1 = __webpack_require__(29);
var utils_service_1 = __webpack_require__(2);
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
var AdminSearchFacetsComponent = (function () {
    function AdminSearchFacetsComponent(utils, route, router, es) {
        this.utils = utils;
        this.route = route;
        this.router = router;
        this.es = es;
        this.onFilter = new core_1.EventEmitter();
    }
    AdminSearchFacetsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.searchQueryParams = params['s'];
            _this.filterQueryParams = params['f'];
        });
    };
    AdminSearchFacetsComponent.prototype.onSelect = function (type, value) {
        // Callback 
        this.onFilter.emit({ type: type, value: value });
        // Nav
        var newQueryParams = { queryParams: {} };
        // keep current search
        if (this.searchQueryParams)
            newQueryParams.queryParams['s'] = this.searchQueryParams;
        newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
        newQueryParams['relativeTo'] = this.route;
        this.router.navigate(['.'], newQueryParams);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], AdminSearchFacetsComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], AdminSearchFacetsComponent.prototype, "esAggregations", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Array)
    ], AdminSearchFacetsComponent.prototype, "esFilters", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
    ], AdminSearchFacetsComponent.prototype, "onFilter", void 0);
    AdminSearchFacetsComponent = __decorate([
        core_1.Component({
            selector: 'admin-search-facets',
            // template: `
            //     <div *ngFor="let agg of esAggregations | mapToIterable" class="facet">
            //       <div class="facet-title">{{agg.key}}</div>
            //       <ol class="list-unstyled">
            //         <li *ngFor="let term of agg.value.buckets">
            //           <span *ngIf="!utils.isInFilters(esFilters, agg.key, term.key)">
            //             <a (click)="onSelect(agg.key, term.key)" style="cursor: pointer">
            //               {{ term.key | truncate:20 }}
            //             </a> 
            //             <small>({{term.doc_count}})</small>
            //           </span>
            //           <span *ngIf="utils.isInFilters(esFilters, agg.key, term.key)">
            //             {{term.key}} <small>({{term.doc_count}})</small>
            //           </span>
            //         </li>
            //       </ol>
            //     </div>`
            template: __webpack_require__(487)
        }), 
        __metadata('design:paramtypes', [(typeof (_b = typeof utils_service_1.UtilsService !== 'undefined' && utils_service_1.UtilsService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof search_elasticsearch_service_1.ElasticSearchService !== 'undefined' && search_elasticsearch_service_1.ElasticSearchService) === 'function' && _e) || Object])
    ], AdminSearchFacetsComponent);
    return AdminSearchFacetsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.AdminSearchFacetsComponent = AdminSearchFacetsComponent;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(152);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(46);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(38);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(17);
var import12 = __webpack_require__(25);
var import13 = __webpack_require__(18);
var import14 = __webpack_require__(30);
var import15 = __webpack_require__(2);
var import16 = __webpack_require__(73);
var import17 = __webpack_require__(15);
var import18 = __webpack_require__(9);
var import19 = __webpack_require__(16);
var import20 = __webpack_require__(11);
var import21 = __webpack_require__(10);
var import22 = __webpack_require__(56);
var import23 = __webpack_require__(22);
var import24 = __webpack_require__(82);
var import25 = __webpack_require__(14);
var import26 = __webpack_require__(39);
var import27 = __webpack_require__(19);
var import28 = __webpack_require__(114);
var import29 = __webpack_require__(43);
var import30 = __webpack_require__(64);
var import31 = __webpack_require__(113);
var import32 = __webpack_require__(85);
var import33 = __webpack_require__(115);
var import34 = __webpack_require__(24);
var import35 = __webpack_require__(20);
var import36 = __webpack_require__(41);
var import37 = __webpack_require__(26);
var import38 = __webpack_require__(61);
var import39 = __webpack_require__(28);
var import40 = __webpack_require__(33);
var import41 = __webpack_require__(47);
var import42 = __webpack_require__(21);
var import43 = __webpack_require__(54);
var import44 = __webpack_require__(37);
var import45 = __webpack_require__(53);
var import46 = __webpack_require__(162);
var import47 = __webpack_require__(96);
var Wrapper_ContentMessageEditComponent = (function () {
    function Wrapper_ContentMessageEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10) {
        this.changed = false;
        this.context = new import0.ContentMessageEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10);
    }
    Wrapper_ContentMessageEditComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentMessageEditComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentMessageEditComponent;
}());
exports.Wrapper_ContentMessageEditComponent = Wrapper_ContentMessageEditComponent;
var renderType_ContentMessageEditComponent_Host = null;
var _View_ContentMessageEditComponent_Host0 = (function (_super) {
    __extends(_View_ContentMessageEditComponent_Host0, _super);
    function _View_ContentMessageEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent_Host0, renderType_ContentMessageEditComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessageEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentMessageEditComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._ContentMessageEditComponent_0_5 = new Wrapper_ContentMessageEditComponent(this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.IntlService), this.parentInjector.get(import12.MetaService), new import13.ElementRef(this._el_0), this.parentInjector.get(import14.SearchService), this._DatePipe_0_4, this.parentInjector.get(import15.UtilsService), this.parentInjector.get(import16.FormBuilder), this.parentInjector.get(import17.Router), this.parentInjector.get(import18.ContentService), this.parentInjector.get(import19.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentMessageEditComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentMessageEditComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentMessageEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.DatePipe) && (0 === requestNodeIndex))) {
            return this._DatePipe_0_4;
        }
        if (((token === import0.ContentMessageEditComponent) && (0 === requestNodeIndex))) {
            return this._ContentMessageEditComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentMessageEditComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentMessageEditComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentMessageEditComponent_Host0;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentMessageEditComponent_Host === null)) {
        (renderType_ContentMessageEditComponent_Host = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentMessageEditComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentMessageEditComponentNgFactory = new import21.ComponentFactory('ng-component', viewFactory_ContentMessageEditComponent_Host0, import0.ContentMessageEditComponent);
var styles_ContentMessageEditComponent = [];
var renderType_ContentMessageEditComponent = null;
var _View_ContentMessageEditComponent0 = (function (_super) {
    __extends(_View_ContentMessageEditComponent0, _super);
    function _View_ContentMessageEditComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent0, renderType_ContentMessageEditComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessageEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'h1', import5.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_2_3 = new import22.Wrapper_NgSwitch();
        this._text_3 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_5 = new import3.AppElement(5, 2, this, this._anchor_5);
        this._TemplateRef_5_5 = new import25.TemplateRef_(this._appEl_5, viewFactory_ContentMessageEditComponent1);
        this._NgSwitchCase_5_6 = new import22.Wrapper_NgSwitchCase(this._appEl_5.vcRef, this._TemplateRef_5_5, this._NgSwitch_2_3.context);
        this._text_6 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_7 = new import3.AppElement(7, 2, this, this._anchor_7);
        this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7, viewFactory_ContentMessageEditComponent2);
        this._NgSwitchCase_7_6 = new import22.Wrapper_NgSwitchCase(this._appEl_7.vcRef, this._TemplateRef_7_5, this._NgSwitch_2_3.context);
        this._text_8 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_9 = new import3.AppElement(9, 2, this, this._anchor_9);
        this._TemplateRef_9_5 = new import25.TemplateRef_(this._appEl_9, viewFactory_ContentMessageEditComponent3);
        this._NgSwitchCase_9_6 = new import22.Wrapper_NgSwitchCase(this._appEl_9.vcRef, this._TemplateRef_9_5, this._NgSwitch_2_3.context);
        this._text_10 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n', null);
        this._text_12 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_13 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n  ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_13, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n    ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n      ', null);
        this._el_19 = import5.createRenderElement(this.renderer, this._el_17, 'div', new import5.InlineArray2(2, 'class', 'box'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n        ', null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_19, 'div', new import5.InlineArray2(2, 'class', 'box-body'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n\n          ', null);
        this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21, null);
        this._appEl_23 = new import3.AppElement(23, 21, this, this._anchor_23);
        this._TemplateRef_23_5 = new import25.TemplateRef_(this._appEl_23, viewFactory_ContentMessageEditComponent4);
        this._NgIf_23_6 = new import23.Wrapper_NgIf(this._appEl_23.vcRef, this._TemplateRef_23_5);
        this._text_24 = this.renderer.createText(this._el_21, '\n\n\n        ', null);
        this._text_25 = this.renderer.createText(this._el_19, '\n        ', null);
        this._text_26 = this.renderer.createText(this._el_19, '\n      ', null);
        this._text_27 = this.renderer.createText(this._el_17, '\n    ', null);
        this._text_28 = this.renderer.createText(this._el_15, '\n  ', null);
        this._text_29 = this.renderer.createText(this._el_13, '\n', null);
        this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._pipe_uppercase_1 = new import24.UpperCasePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._anchor_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._anchor_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29
        ], [], []);
        return null;
    };
    _View_ContentMessageEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import26.NgSwitchCase) && (5 === requestNodeIndex))) {
            return this._NgSwitchCase_5_6.context;
        }
        if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import26.NgSwitchCase) && (7 === requestNodeIndex))) {
            return this._NgSwitchCase_7_6.context;
        }
        if (((token === import25.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import26.NgSwitchCase) && (9 === requestNodeIndex))) {
            return this._NgSwitchCase_9_6.context;
        }
        if (((token === import26.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._NgSwitch_2_3.context;
        }
        if (((token === import25.TemplateRef) && (23 === requestNodeIndex))) {
            return this._TemplateRef_23_5;
        }
        if (((token === import27.NgIf) && (23 === requestNodeIndex))) {
            return this._NgIf_23_6.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.context.action;
        this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0, throwOnChange, false);
        this._NgSwitch_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_5_0_0 = 'add';
        this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0, throwOnChange, false);
        this._NgSwitchCase_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = 'update';
        this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0, throwOnChange, false);
        this._NgSwitchCase_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        var currVal_9_0_0 = 'update';
        this._NgSwitchCase_9_6.check_ngSwitchCase(currVal_9_0_0, throwOnChange, false);
        this._NgSwitchCase_9_6.detectChangesInInputProps(this, this._anchor_9, throwOnChange);
        var currVal_23_0_0 = (this.context.content || (this.context.action == 'add'));
        this._NgIf_23_6.check_ngIf(currVal_23_0_0, throwOnChange, false);
        this._NgIf_23_6.detectChangesInInputProps(this, this._anchor_23, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentMessageEditComponent0;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentMessageEditComponent === null)) {
        (renderType_ContentMessageEditComponent = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, styles_ContentMessageEditComponent, {}));
    }
    return new _View_ContentMessageEditComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentMessageEditComponent0 = viewFactory_ContentMessageEditComponent0;
var _View_ContentMessageEditComponent1 = (function (_super) {
    __extends(_View_ContentMessageEditComponent1, _super);
    function _View_ContentMessageEditComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent1, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessageEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Nouveau contenu', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentMessageEditComponent1;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent2 = (function (_super) {
    __extends(_View_ContentMessageEditComponent2, _super);
    function _View_ContentMessageEditComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent2, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessageEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Edition', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentMessageEditComponent2;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent3 = (function (_super) {
    __extends(_View_ContentMessageEditComponent3, _super);
    function _View_ContentMessageEditComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent3, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentMessageEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ' ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_date_0_0 = import5.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentMessageEditComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import5.interpolate(1, '(modifié: ', valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(((this.parent.context.content == null) ? null : this.parent.context.content.update_date), 'dd MM yyyy')), ')');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentMessageEditComponent3;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent4 = (function (_super) {
    __extends(_View_ContentMessageEditComponent4, _super);
    function _View_ContentMessageEditComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent4, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_106 = import8.UNINITIALIZED;
    }
    _View_ContentMessageEditComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'form', import5.EMPTY_INLINE_ARRAY, null);
        this._FormGroupDirective_0_3 = new import28.Wrapper_FormGroupDirective(null, null);
        this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
        this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'panel panel-default'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Métadonnées', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_7, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'col-md-1 col-sm-1 input-group switch material-switch'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                    ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'input', new import5.InlineArray8(8, 'formControlName', 'active', 'id', 'act', 'name', 'act', 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_13_3 = new import30.Wrapper_CheckboxControlValueAccessor(this.renderer, new import13.ElementRef(this._el_13));
        this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
        this._FormControlName_13_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_13_4);
        this._NgControl_13_6 = this._FormControlName_13_5.context;
        this._NgControlStatus_13_7 = new import29.Wrapper_NgControlStatus(this._NgControl_13_6);
        this._text_14 = this.renderer.createText(this._el_11, '\n                    ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_11, 'label', new import5.InlineArray4(4, 'class', 'label-primary', 'for', 'act'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                  ', null);
        this._text_17 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4 col-sm-5'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_18, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'label', 'type', 'text'), null);
        this._DefaultValueAccessor_20_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_20));
        this._NG_VALUE_ACCESSOR_20_4 = [this._DefaultValueAccessor_20_3.context];
        this._FormControlName_20_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_20_4);
        this._NgControl_20_6 = this._FormControlName_20_5.context;
        this._NgControlStatus_20_7 = new import29.Wrapper_NgControlStatus(this._NgControl_20_6);
        this._text_21 = this.renderer.createText(this._el_18, '\n                  ', null);
        this._text_22 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-6 col-sm-5'), null);
        this._text_24 = this.renderer.createText(this._el_23, '\n                      ', null);
        this._el_25 = import5.createRenderElement(this.renderer, this._el_23, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_26 = import5.createRenderElement(this.renderer, this._el_25, 'i', new import5.InlineArray2(2, 'class', 'fa fa-external-link'), null);
        this._text_27 = this.renderer.createText(this._el_23, '\n                      ', null);
        this._el_28 = import5.createRenderElement(this.renderer, this._el_23, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'url', 'type', 'text'), null);
        this._DefaultValueAccessor_28_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_28));
        this._NG_VALUE_ACCESSOR_28_4 = [this._DefaultValueAccessor_28_3.context];
        this._FormControlName_28_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_28_4);
        this._NgControl_28_6 = this._FormControlName_28_5.context;
        this._NgControlStatus_28_7 = new import29.Wrapper_NgControlStatus(this._NgControl_28_6);
        this._text_29 = this.renderer.createText(this._el_23, '\n                  ', null);
        this._text_30 = this.renderer.createText(this._el_9, '\n                ', null);
        this._text_31 = this.renderer.createText(this._el_7, '\n              ', null);
        this._text_32 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_33 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_34 = this.renderer.createText(this._el_33, 'Titre', null);
        this._text_35 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_36 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_37 = this.renderer.createText(this._el_36, '\n                ', null);
        this._el_38 = import5.createRenderElement(this.renderer, this._el_36, 'div', new import5.InlineArray4(4, 'class', 'form-inline', 'formGroupName', 'title'), null);
        this._FormGroupName_38_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_38_4 = this._FormGroupName_38_3.context;
        this._NgControlStatusGroup_38_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_38_4);
        this._text_39 = this.renderer.createText(this._el_38, '\n                  ', null);
        this._anchor_40 = this.renderer.createTemplateAnchor(this._el_38, null);
        this._appEl_40 = new import3.AppElement(40, 38, this, this._anchor_40);
        this._TemplateRef_40_5 = new import25.TemplateRef_(this._appEl_40, viewFactory_ContentMessageEditComponent5);
        this._NgFor_40_6 = new import34.Wrapper_NgFor(this._appEl_40.vcRef, this._TemplateRef_40_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_41 = this.renderer.createText(this._el_38, '\n                ', null);
        this._text_42 = this.renderer.createText(this._el_36, '\n              ', null);
        this._text_43 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_44 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_45 = this.renderer.createText(this._el_44, 'Sous-titre', null);
        this._text_46 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_47 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_48 = this.renderer.createText(this._el_47, '\n                ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_47, 'div', new import5.InlineArray4(4, 'class', 'form-inline', 'formGroupName', 'subtitle'), null);
        this._FormGroupName_49_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_49_4 = this._FormGroupName_49_3.context;
        this._NgControlStatusGroup_49_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_49_4);
        this._text_50 = this.renderer.createText(this._el_49, '\n                  ', null);
        this._anchor_51 = this.renderer.createTemplateAnchor(this._el_49, null);
        this._appEl_51 = new import3.AppElement(51, 49, this, this._anchor_51);
        this._TemplateRef_51_5 = new import25.TemplateRef_(this._appEl_51, viewFactory_ContentMessageEditComponent6);
        this._NgFor_51_6 = new import34.Wrapper_NgFor(this._appEl_51.vcRef, this._TemplateRef_51_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_52 = this.renderer.createText(this._el_49, '\n                ', null);
        this._text_53 = this.renderer.createText(this._el_47, '\n              ', null);
        this._text_54 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_55 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_56 = this.renderer.createText(this._el_55, 'Contenu', null);
        this._text_57 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_58 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_59 = this.renderer.createText(this._el_58, '\n                ', null);
        this._el_60 = import5.createRenderElement(this.renderer, this._el_58, 'div', new import5.InlineArray2(2, 'formGroupName', 'content'), null);
        this._FormGroupName_60_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_60_4 = this._FormGroupName_60_3.context;
        this._NgControlStatusGroup_60_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_60_4);
        this._text_61 = this.renderer.createText(this._el_60, '\n                  ', null);
        this._anchor_62 = this.renderer.createTemplateAnchor(this._el_60, null);
        this._appEl_62 = new import3.AppElement(62, 60, this, this._anchor_62);
        this._TemplateRef_62_5 = new import25.TemplateRef_(this._appEl_62, viewFactory_ContentMessageEditComponent7);
        this._NgFor_62_6 = new import34.Wrapper_NgFor(this._appEl_62.vcRef, this._TemplateRef_62_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_63 = this.renderer.createText(this._el_60, '\n                ', null);
        this._text_64 = this.renderer.createText(this._el_58, '\n              ', null);
        this._text_65 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_66 = import5.createRenderElement(this.renderer, this._el_2, 'button', new import5.InlineArray4(4, 'class', 'btn btn-info pull-right', 'type', 'submit'), null);
        this._text_67 = this.renderer.createText(this._el_66, '\n        Sauvegarder\n      ', null);
        this._text_68 = this.renderer.createText(this._el_2, '\n\n            ', null);
        this._text_69 = this.renderer.createText(this._el_0, '\n\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_13, 'change', this.eventHandler(this._handle_change_13_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_13, 'blur', this.eventHandler(this._handle_blur_13_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_20, 'input', this.eventHandler(this._handle_input_20_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_20, 'blur', this.eventHandler(this._handle_blur_20_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_28, 'input', this.eventHandler(this._handle_input_28_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_28, 'blur', this.eventHandler(this._handle_blur_28_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._el_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._el_33,
            this._text_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._anchor_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._anchor_51,
            this._text_52,
            this._text_53,
            this._text_54,
            this._el_55,
            this._text_56,
            this._text_57,
            this._el_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._anchor_62,
            this._text_63,
            this._text_64,
            this._text_65,
            this._el_66,
            this._text_67,
            this._text_68,
            this._text_69
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], [subscription_0]);
        return null;
    };
    _View_ContentMessageEditComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import36.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_13_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_13_4;
        }
        if (((token === import38.FormControlName) && (13 === requestNodeIndex))) {
            return this._FormControlName_13_5.context;
        }
        if (((token === import39.NgControl) && (13 === requestNodeIndex))) {
            return this._NgControl_13_6;
        }
        if (((token === import40.NgControlStatus) && (13 === requestNodeIndex))) {
            return this._NgControlStatus_13_7.context;
        }
        if (((token === import41.DefaultValueAccessor) && (20 === requestNodeIndex))) {
            return this._DefaultValueAccessor_20_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (20 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_20_4;
        }
        if (((token === import38.FormControlName) && (20 === requestNodeIndex))) {
            return this._FormControlName_20_5.context;
        }
        if (((token === import39.NgControl) && (20 === requestNodeIndex))) {
            return this._NgControl_20_6;
        }
        if (((token === import40.NgControlStatus) && (20 === requestNodeIndex))) {
            return this._NgControlStatus_20_7.context;
        }
        if (((token === import41.DefaultValueAccessor) && (28 === requestNodeIndex))) {
            return this._DefaultValueAccessor_28_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (28 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_28_4;
        }
        if (((token === import38.FormControlName) && (28 === requestNodeIndex))) {
            return this._FormControlName_28_5.context;
        }
        if (((token === import39.NgControl) && (28 === requestNodeIndex))) {
            return this._NgControl_28_6;
        }
        if (((token === import40.NgControlStatus) && (28 === requestNodeIndex))) {
            return this._NgControlStatus_28_7.context;
        }
        if (((token === import25.TemplateRef) && (40 === requestNodeIndex))) {
            return this._TemplateRef_40_5;
        }
        if (((token === import42.NgFor) && (40 === requestNodeIndex))) {
            return this._NgFor_40_6.context;
        }
        if (((token === import43.FormGroupName) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) {
            return this._FormGroupName_38_3.context;
        }
        if (((token === import44.ControlContainer) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) {
            return this._ControlContainer_38_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((38 <= requestNodeIndex) && (requestNodeIndex <= 41)))) {
            return this._NgControlStatusGroup_38_5.context;
        }
        if (((token === import25.TemplateRef) && (51 === requestNodeIndex))) {
            return this._TemplateRef_51_5;
        }
        if (((token === import42.NgFor) && (51 === requestNodeIndex))) {
            return this._NgFor_51_6.context;
        }
        if (((token === import43.FormGroupName) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) {
            return this._FormGroupName_49_3.context;
        }
        if (((token === import44.ControlContainer) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) {
            return this._ControlContainer_49_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 52)))) {
            return this._NgControlStatusGroup_49_5.context;
        }
        if (((token === import25.TemplateRef) && (62 === requestNodeIndex))) {
            return this._TemplateRef_62_5;
        }
        if (((token === import42.NgFor) && (62 === requestNodeIndex))) {
            return this._NgFor_62_6.context;
        }
        if (((token === import43.FormGroupName) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) {
            return this._FormGroupName_60_3.context;
        }
        if (((token === import44.ControlContainer) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) {
            return this._ControlContainer_60_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((60 <= requestNodeIndex) && (requestNodeIndex <= 63)))) {
            return this._NgControlStatusGroup_60_5.context;
        }
        if (((token === import45.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._FormGroupDirective_0_3.context;
        }
        if (((token === import44.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.messageForm;
        this._FormGroupDirective_0_3.check_form(currVal_0_0_0, throwOnChange, false);
        this._FormGroupDirective_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this, this._el_13, throwOnChange);
        var currVal_13_1_0 = 'active';
        this._FormControlName_13_5.check_name(currVal_13_1_0, throwOnChange, false);
        this._FormControlName_13_5.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_20_3.detectChangesInInputProps(this, this._el_20, throwOnChange);
        var currVal_20_1_0 = 'label';
        this._FormControlName_20_5.check_name(currVal_20_1_0, throwOnChange, false);
        this._FormControlName_20_5.detectChangesInInputProps(this, this._el_20, throwOnChange);
        this._NgControlStatus_20_7.detectChangesInInputProps(this, this._el_20, throwOnChange);
        this._DefaultValueAccessor_28_3.detectChangesInInputProps(this, this._el_28, throwOnChange);
        var currVal_28_1_0 = 'url';
        this._FormControlName_28_5.check_name(currVal_28_1_0, throwOnChange, false);
        this._FormControlName_28_5.detectChangesInInputProps(this, this._el_28, throwOnChange);
        this._NgControlStatus_28_7.detectChangesInInputProps(this, this._el_28, throwOnChange);
        var currVal_38_0_0 = 'title';
        this._FormGroupName_38_3.check_name(currVal_38_0_0, throwOnChange, false);
        this._FormGroupName_38_3.detectChangesInInputProps(this, this._el_38, throwOnChange);
        this._NgControlStatusGroup_38_5.detectChangesInInputProps(this, this._el_38, throwOnChange);
        var currVal_40_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_40_6.check_ngForOf(currVal_40_0_0, throwOnChange, false);
        this._NgFor_40_6.detectChangesInInputProps(this, this._anchor_40, throwOnChange);
        var currVal_49_0_0 = 'subtitle';
        this._FormGroupName_49_3.check_name(currVal_49_0_0, throwOnChange, false);
        this._FormGroupName_49_3.detectChangesInInputProps(this, this._el_49, throwOnChange);
        this._NgControlStatusGroup_49_5.detectChangesInInputProps(this, this._el_49, throwOnChange);
        var currVal_51_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_51_6.check_ngForOf(currVal_51_0_0, throwOnChange, false);
        this._NgFor_51_6.detectChangesInInputProps(this, this._anchor_51, throwOnChange);
        var currVal_60_0_0 = 'content';
        this._FormGroupName_60_3.check_name(currVal_60_0_0, throwOnChange, false);
        this._FormGroupName_60_3.detectChangesInInputProps(this, this._el_60, throwOnChange);
        this._NgControlStatusGroup_60_5.detectChangesInInputProps(this, this._el_60, throwOnChange);
        var currVal_62_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_62_6.check_ngForOf(currVal_62_0_0, throwOnChange, false);
        this._NgFor_62_6.detectChangesInInputProps(this, this._anchor_62, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupDirective_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._FormControlName_13_5.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_20_3.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._FormControlName_20_5.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._NgControlStatus_20_7.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._DefaultValueAccessor_28_3.detectChangesInHostProps(this, this._el_28, throwOnChange);
        this._FormControlName_28_5.detectChangesInHostProps(this, this._el_28, throwOnChange);
        this._NgControlStatus_28_7.detectChangesInHostProps(this, this._el_28, throwOnChange);
        this._FormGroupName_38_3.detectChangesInHostProps(this, this._el_38, throwOnChange);
        this._NgControlStatusGroup_38_5.detectChangesInHostProps(this, this._el_38, throwOnChange);
        this._FormGroupName_49_3.detectChangesInHostProps(this, this._el_49, throwOnChange);
        this._NgControlStatusGroup_49_5.detectChangesInHostProps(this, this._el_49, throwOnChange);
        this._FormGroupName_60_3.detectChangesInHostProps(this, this._el_60, throwOnChange);
        this._NgControlStatusGroup_60_5.detectChangesInHostProps(this, this._el_60, throwOnChange);
        var currVal_106 = !this.parent.context.messageForm.valid;
        if (import5.checkBinding(throwOnChange, this._expr_106, currVal_106)) {
            this.renderer.setElementProperty(this._el_66, 'disabled', currVal_106);
            this._expr_106 = currVal_106;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentMessageEditComponent4.prototype.destroyInternal = function () {
        this._FormControlName_13_5.context.ngOnDestroy();
        this._FormControlName_20_5.context.ngOnDestroy();
        this._FormControlName_28_5.context.ngOnDestroy();
    };
    _View_ContentMessageEditComponent4.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_0_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_change_13_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked) !== false);
        return (true && pd_13_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_blur_13_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onTouched() !== false);
        return (true && pd_13_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_input_20_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this._DefaultValueAccessor_20_3.context.onChange($event.target.value) !== false);
        return (true && pd_20_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_blur_20_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this._DefaultValueAccessor_20_3.context.onTouched() !== false);
        return (true && pd_20_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_input_28_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this._DefaultValueAccessor_28_3.context.onChange($event.target.value) !== false);
        return (true && pd_28_0);
    };
    _View_ContentMessageEditComponent4.prototype._handle_blur_28_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this._DefaultValueAccessor_28_3.context.onTouched() !== false);
        return (true && pd_28_0);
    };
    return _View_ContentMessageEditComponent4;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent5 = (function (_super) {
    __extends(_View_ContentMessageEditComponent5, _super);
    function _View_ContentMessageEditComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent5, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentMessageEditComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon max-width-20'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import31.Wrapper_FormControlName(this.parent._ControlContainer_38_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_0 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentMessageEditComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import38.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import39.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentMessageEditComponent5.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentMessageEditComponent5.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentMessageEditComponent5.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentMessageEditComponent5;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent6 = (function (_super) {
    __extends(_View_ContentMessageEditComponent6, _super);
    function _View_ContentMessageEditComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent6, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentMessageEditComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon max-width-20'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import31.Wrapper_FormControlName(this.parent._ControlContainer_49_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_1 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentMessageEditComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import38.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import39.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentMessageEditComponent6.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentMessageEditComponent6.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentMessageEditComponent6.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentMessageEditComponent6;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentMessageEditComponent7 = (function (_super) {
    __extends(_View_ContentMessageEditComponent7, _super);
    function _View_ContentMessageEditComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessageEditComponent7, renderType_ContentMessageEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import8.UNINITIALIZED;
    }
    _View_ContentMessageEditComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'html-editor', new import5.InlineArray2(2, 'height', '3'), null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._el_5);
        var compView_5 = import46.viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._HtmlEditorComponent_5_4 = new import46.Wrapper_HtmlEditorComponent();
        this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context, [], compView_5);
        this._text_6 = this.renderer.createText(null, '\n                    ', null);
        compView_5.create(this._HtmlEditorComponent_5_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_2 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'onEditorKeyup', this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        var subscription_0 = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentMessageEditComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import47.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._HtmlEditorComponent_5_4.context;
        }
        return notFoundResult;
    };
    _View_ContentMessageEditComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_5_0_0 = ('editor-content-' + this.context.$implicit);
        this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = (this.parent.parent.context.content ? this.parent.parent.context.content.content[this.context.$implicit] : '');
        this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1, throwOnChange, false);
        var currVal_5_0_2 = '3';
        this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2, throwOnChange, false);
        this._HtmlEditorComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_10 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_10, currVal_10))) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this._HtmlEditorComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentMessageEditComponent7.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_5_4.context.ngOnDestroy();
    };
    _View_ContentMessageEditComponent7.prototype._handle_onEditorKeyup_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.keyupEditorHandlerFunction([
            'content',
            this.context.$implicit
        ], $event) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentMessageEditComponent7;
}(import1.AppView));
function viewFactory_ContentMessageEditComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessageEditComponent7(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(153);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(2);
var import10 = __webpack_require__(9);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(32);
var import13 = __webpack_require__(15);
var import14 = __webpack_require__(11);
var import15 = __webpack_require__(10);
var import16 = __webpack_require__(24);
var import17 = __webpack_require__(46);
var import18 = __webpack_require__(14);
var import19 = __webpack_require__(20);
var import20 = __webpack_require__(38);
var import21 = __webpack_require__(21);
var import22 = __webpack_require__(64);
var import23 = __webpack_require__(79);
var import24 = __webpack_require__(43);
var import25 = __webpack_require__(18);
var import26 = __webpack_require__(41);
var import27 = __webpack_require__(26);
var import28 = __webpack_require__(48);
var import29 = __webpack_require__(28);
var import30 = __webpack_require__(33);
var Wrapper_ContentMessagesComponent = (function () {
    function Wrapper_ContentMessagesComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.ContentMessagesComponent(p0, p1, p2, p3, p4, p5);
    }
    Wrapper_ContentMessagesComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentMessagesComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentMessagesComponent;
}());
exports.Wrapper_ContentMessagesComponent = Wrapper_ContentMessagesComponent;
var renderType_ContentMessagesComponent_Host = null;
var _View_ContentMessagesComponent_Host0 = (function (_super) {
    __extends(_View_ContentMessagesComponent_Host0, _super);
    function _View_ContentMessagesComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessagesComponent_Host0, renderType_ContentMessagesComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessagesComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentMessagesComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentMessagesComponent_0_4 = new Wrapper_ContentMessagesComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.UtilsService), this.parentInjector.get(import10.ContentService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Location), this.parentInjector.get(import13.Router));
        this._appEl_0.initComponent(this._ContentMessagesComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentMessagesComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentMessagesComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentMessagesComponent) && (0 === requestNodeIndex))) {
            return this._ContentMessagesComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentMessagesComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentMessagesComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentMessagesComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentMessagesComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentMessagesComponent_Host0;
}(import1.AppView));
function viewFactory_ContentMessagesComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentMessagesComponent_Host === null)) {
        (renderType_ContentMessagesComponent_Host = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentMessagesComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentMessagesComponentNgFactory = new import15.ComponentFactory('ng-component', viewFactory_ContentMessagesComponent_Host0, import0.ContentMessagesComponent);
var styles_ContentMessagesComponent = [];
var renderType_ContentMessagesComponent = null;
var _View_ContentMessagesComponent0 = (function (_super) {
    __extends(_View_ContentMessagesComponent0, _super);
    function _View_ContentMessagesComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessagesComponent0, renderType_ContentMessagesComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentMessagesComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Messages\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'lLink'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n      ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_7 = this.renderer.createText(this._el_6, 'Nouveau', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n    ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_10 = this.renderer.createText(this._el_0, ' \n', null);
        this._text_11 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_12 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n  ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n\n  ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_14, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n  ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_16, 'div', new import4.InlineArray2(2, 'class', 'box'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n    ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'div', new import4.InlineArray2(2, 'class', 'box-body'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n\n      ', null);
        this._el_22 = import4.createRenderElement(this.renderer, this._el_20, 'table', new import4.InlineArray2(2, 'class', 'table table-striped table-hover'), null);
        this._text_23 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_24 = import4.createRenderElement(this.renderer, this._el_22, 'thead', import4.EMPTY_INLINE_ARRAY, null);
        this._text_25 = this.renderer.createText(this._el_24, '\n          ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_24, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_27 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_29 = this.renderer.createText(this._el_28, 'Statut', null);
        this._text_30 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_31 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_32 = this.renderer.createText(this._el_31, 'Object', null);
        this._text_33 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_34 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_35 = this.renderer.createText(this._el_34, 'Mise à jour', null);
        this._text_36 = this.renderer.createText(this._el_26, '\n          ', null);
        this._text_37 = this.renderer.createText(this._el_24, ' \n        ', null);
        this._text_38 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_39 = import4.createRenderElement(this.renderer, this._el_22, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_40 = this.renderer.createText(this._el_39, '\n          ', null);
        this._anchor_41 = this.renderer.createTemplateAnchor(this._el_39, null);
        this._appEl_41 = new import3.AppElement(41, 39, this, this._anchor_41);
        this._TemplateRef_41_5 = new import18.TemplateRef_(this._appEl_41, viewFactory_ContentMessagesComponent1);
        this._NgFor_41_6 = new import16.Wrapper_NgFor(this._appEl_41.vcRef, this._TemplateRef_41_5, this.parentInjector.get(import19.IterableDiffers), this.ref);
        this._text_42 = this.renderer.createText(this._el_39, '\n        ', null);
        this._text_43 = this.renderer.createText(this._el_22, '\n      ', null);
        this._text_44 = this.renderer.createText(this._el_20, '\n\n\n    ', null);
        this._text_45 = this.renderer.createText(this._el_18, '\n  ', null);
        this._text_46 = this.renderer.createText(this._el_16, '\n  ', null);
        this._text_47 = this.renderer.createText(this._el_14, '\n  ', null);
        this._text_48 = this.renderer.createText(this._el_12, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this._pipe_date_0 = new import17.DatePipe(this.parentInjector.get(import20.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._anchor_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._text_46,
            this._text_47,
            this._text_48
        ], [disposable_0], []);
        return null;
    };
    _View_ContentMessagesComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (41 === requestNodeIndex))) {
            return this._TemplateRef_41_5;
        }
        if (((token === import21.NgFor) && (41 === requestNodeIndex))) {
            return this._NgFor_41_6.context;
        }
        return notFoundResult;
    };
    _View_ContentMessagesComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_41_0_0 = this.context.contents;
        this._NgFor_41_6.check_ngForOf(currVal_41_0_0, throwOnChange, false);
        this._NgFor_41_6.detectChangesInInputProps(this, this._anchor_41, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentMessagesComponent0.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.context.utils.lLink('admin/special/edit/0', this.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    return _View_ContentMessagesComponent0;
}(import1.AppView));
function viewFactory_ContentMessagesComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentMessagesComponent === null)) {
        (renderType_ContentMessagesComponent = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, styles_ContentMessagesComponent, {}));
    }
    return new _View_ContentMessagesComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentMessagesComponent0 = viewFactory_ContentMessagesComponent0;
var _View_ContentMessagesComponent1 = (function (_super) {
    __extends(_View_ContentMessagesComponent1, _super);
    function _View_ContentMessagesComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentMessagesComponent1, renderType_ContentMessagesComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_23 = import7.UNINITIALIZED;
        this._expr_24 = import7.UNINITIALIZED;
        this._expr_25 = import7.UNINITIALIZED;
        this._expr_26 = import7.UNINITIALIZED;
    }
    _View_ContentMessagesComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'switch material-switch'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'input', new import4.InlineArray2(2, 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_6_3 = new import22.Wrapper_CheckboxControlValueAccessor(this.renderer, new import25.ElementRef(this._el_6));
        this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
        this._NgModel_6_5 = new import23.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_6_4);
        this._NgControl_6_6 = this._NgModel_6_5.context;
        this._NgControlStatus_6_7 = new import24.Wrapper_NgControlStatus(this._NgControl_6_6);
        this._text_7 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_4, 'label', new import4.InlineArray2(2, 'class', 'label-primary'), null);
        this._text_9 = this.renderer.createText(this._el_4, '\n              ', null);
        this._text_10 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'lLink'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_6, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_6, 'change', this.eventHandler(this._handle_change_6_2.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_6, 'blur', this.eventHandler(this._handle_blur_6_3.bind(this)));
        var subscription_0 = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_12, 'click', this.eventHandler(this._handle_click_12_0.bind(this)));
        this._pipe_date_0_0 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ], [subscription_0]);
        return null;
    };
    _View_ContentMessagesComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_6_3.context;
        }
        if (((token === import27.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_6_4;
        }
        if (((token === import28.NgModel) && (6 === requestNodeIndex))) {
            return this._NgModel_6_5.context;
        }
        if (((token === import29.NgControl) && (6 === requestNodeIndex))) {
            return this._NgControl_6_6;
        }
        if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) {
            return this._NgControlStatus_6_7.context;
        }
        return notFoundResult;
    };
    _View_ContentMessagesComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_6_1_0 = import4.interpolate(1, '', this.context.$implicit._id, '');
        this._NgModel_6_5.check_name(currVal_6_1_0, throwOnChange, false);
        var currVal_6_1_1 = this.context.$implicit.active;
        this._NgModel_6_5.check_model(currVal_6_1_1, throwOnChange, false);
        this._NgModel_6_5.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_23 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_23, currVal_23)) {
            this.renderer.setElementProperty(this._el_6, 'id', currVal_23);
            this._expr_23 = currVal_23;
        }
        this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgModel_6_5.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInHostProps(this, this._el_6, throwOnChange);
        var currVal_24 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_24, currVal_24)) {
            this.renderer.setElementAttribute(this._el_8, 'for', ((currVal_24 == null) ? null : currVal_24.toString()));
            this._expr_24 = currVal_24;
        }
        var currVal_25 = import4.interpolate(1, '', (this.context.$implicit.title ? this.context.$implicit.label : '-'), '');
        if (import4.checkBinding(throwOnChange, this._expr_25, currVal_25)) {
            this.renderer.setText(this._text_13, currVal_25);
            this._expr_25 = currVal_25;
        }
        valUnwrapper.reset();
        var currVal_26 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(this.context.$implicit.update_date, 'MMM dd yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_26, currVal_26))) {
            this.renderer.setText(this._text_16, currVal_26);
            this._expr_26 = currVal_26;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentMessagesComponent1.prototype.destroyInternal = function () {
        this._NgModel_6_5.context.ngOnDestroy();
    };
    _View_ContentMessagesComponent1.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.context.onStatusChange(!this.context.$implicit.active, this.context.$implicit) !== false);
        return (true && pd_6_0);
    };
    _View_ContentMessagesComponent1.prototype._handle_ngModelChange_6_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = ((this.context.$implicit.active = $event) !== false);
        return (true && pd_6_0);
    };
    _View_ContentMessagesComponent1.prototype._handle_change_6_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked) !== false);
        return (true && pd_6_0);
    };
    _View_ContentMessagesComponent1.prototype._handle_blur_6_3 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onTouched() !== false);
        return (true && pd_6_0);
    };
    _View_ContentMessagesComponent1.prototype._handle_click_12_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_12_0 = (this.parent.context.router.navigate([('message/edit/' + this.context.$implicit._id)], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_12_0);
    };
    return _View_ContentMessagesComponent1;
}(import1.AppView));
function viewFactory_ContentMessagesComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentMessagesComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(154);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(25);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(73);
var import13 = __webpack_require__(15);
var import14 = __webpack_require__(9);
var import15 = __webpack_require__(16);
var import16 = __webpack_require__(11);
var import17 = __webpack_require__(10);
var import18 = __webpack_require__(56);
var import19 = __webpack_require__(22);
var import20 = __webpack_require__(46);
var import21 = __webpack_require__(82);
var import22 = __webpack_require__(14);
var import23 = __webpack_require__(38);
var import24 = __webpack_require__(39);
var import25 = __webpack_require__(19);
var import26 = __webpack_require__(114);
var import27 = __webpack_require__(43);
var import28 = __webpack_require__(64);
var import29 = __webpack_require__(113);
var import30 = __webpack_require__(85);
var import31 = __webpack_require__(115);
var import32 = __webpack_require__(24);
var import33 = __webpack_require__(18);
var import34 = __webpack_require__(20);
var import35 = __webpack_require__(41);
var import36 = __webpack_require__(26);
var import37 = __webpack_require__(61);
var import38 = __webpack_require__(28);
var import39 = __webpack_require__(33);
var import40 = __webpack_require__(47);
var import41 = __webpack_require__(21);
var import42 = __webpack_require__(54);
var import43 = __webpack_require__(37);
var import44 = __webpack_require__(53);
var import45 = __webpack_require__(162);
var import46 = __webpack_require__(96);
var Wrapper_ContentPageEditComponent = (function () {
    function Wrapper_ContentPageEditComponent(p0, p1, p2, p3, p4, p5, p6, p7) {
        this.changed = false;
        this.context = new import0.ContentPageEditComponent(p0, p1, p2, p3, p4, p5, p6, p7);
    }
    Wrapper_ContentPageEditComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentPageEditComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentPageEditComponent;
}());
exports.Wrapper_ContentPageEditComponent = Wrapper_ContentPageEditComponent;
var renderType_ContentPageEditComponent_Host = null;
var _View_ContentPageEditComponent_Host0 = (function (_super) {
    __extends(_View_ContentPageEditComponent_Host0, _super);
    function _View_ContentPageEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent_Host0, renderType_ContentPageEditComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentPageEditComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentPageEditComponent_0_4 = new Wrapper_ContentPageEditComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.IntlService), this.parentInjector.get(import10.MetaService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.FormBuilder), this.parentInjector.get(import13.Router), this.parentInjector.get(import14.ContentService), this.parentInjector.get(import15.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentPageEditComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentPageEditComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentPageEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentPageEditComponent) && (0 === requestNodeIndex))) {
            return this._ContentPageEditComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentPageEditComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentPageEditComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageEditComponent_Host0;
}(import1.AppView));
function viewFactory_ContentPageEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPageEditComponent_Host === null)) {
        (renderType_ContentPageEditComponent_Host = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentPageEditComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentPageEditComponentNgFactory = new import17.ComponentFactory('ng-component', viewFactory_ContentPageEditComponent_Host0, import0.ContentPageEditComponent);
var styles_ContentPageEditComponent = [];
var renderType_ContentPageEditComponent = null;
var _View_ContentPageEditComponent0 = (function (_super) {
    __extends(_View_ContentPageEditComponent0, _super);
    function _View_ContentPageEditComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent0, renderType_ContentPageEditComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_2_3 = new import18.Wrapper_NgSwitch();
        this._text_3 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_5 = new import3.AppElement(5, 2, this, this._anchor_5);
        this._TemplateRef_5_5 = new import22.TemplateRef_(this._appEl_5, viewFactory_ContentPageEditComponent1);
        this._NgSwitchCase_5_6 = new import18.Wrapper_NgSwitchCase(this._appEl_5.vcRef, this._TemplateRef_5_5, this._NgSwitch_2_3.context);
        this._text_6 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_7 = new import3.AppElement(7, 2, this, this._anchor_7);
        this._TemplateRef_7_5 = new import22.TemplateRef_(this._appEl_7, viewFactory_ContentPageEditComponent2);
        this._NgSwitchCase_7_6 = new import18.Wrapper_NgSwitchCase(this._appEl_7.vcRef, this._TemplateRef_7_5, this._NgSwitch_2_3.context);
        this._text_8 = this.renderer.createText(this._el_2, '\n    ', null);
        this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_9 = new import3.AppElement(9, 2, this, this._anchor_9);
        this._TemplateRef_9_5 = new import22.TemplateRef_(this._appEl_9, viewFactory_ContentPageEditComponent3);
        this._NgSwitchCase_9_6 = new import18.Wrapper_NgSwitchCase(this._appEl_9.vcRef, this._TemplateRef_9_5, this._NgSwitch_2_3.context);
        this._text_10 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n', null);
        this._text_12 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_13 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n  ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_13, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n    ', null);
        this._el_17 = import4.createRenderElement(this.renderer, this._el_15, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n      ', null);
        this._el_19 = import4.createRenderElement(this.renderer, this._el_17, 'div', new import4.InlineArray2(2, 'class', 'box'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n        ', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_19, 'div', new import4.InlineArray2(2, 'class', 'box-body'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n\n          ', null);
        this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21, null);
        this._appEl_23 = new import3.AppElement(23, 21, this, this._anchor_23);
        this._TemplateRef_23_5 = new import22.TemplateRef_(this._appEl_23, viewFactory_ContentPageEditComponent4);
        this._NgIf_23_6 = new import19.Wrapper_NgIf(this._appEl_23.vcRef, this._TemplateRef_23_5);
        this._text_24 = this.renderer.createText(this._el_21, '\n\n\n        ', null);
        this._text_25 = this.renderer.createText(this._el_19, '\n        ', null);
        this._text_26 = this.renderer.createText(this._el_19, '\n      ', null);
        this._text_27 = this.renderer.createText(this._el_17, '\n    ', null);
        this._text_28 = this.renderer.createText(this._el_15, '\n  ', null);
        this._text_29 = this.renderer.createText(this._el_13, '\n', null);
        this._pipe_date_0 = new import20.DatePipe(this.parentInjector.get(import23.LOCALE_ID));
        this._pipe_uppercase_1 = new import21.UpperCasePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._anchor_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._anchor_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29
        ], [], []);
        return null;
    };
    _View_ContentPageEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import22.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import24.NgSwitchCase) && (5 === requestNodeIndex))) {
            return this._NgSwitchCase_5_6.context;
        }
        if (((token === import22.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import24.NgSwitchCase) && (7 === requestNodeIndex))) {
            return this._NgSwitchCase_7_6.context;
        }
        if (((token === import22.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import24.NgSwitchCase) && (9 === requestNodeIndex))) {
            return this._NgSwitchCase_9_6.context;
        }
        if (((token === import24.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._NgSwitch_2_3.context;
        }
        if (((token === import22.TemplateRef) && (23 === requestNodeIndex))) {
            return this._TemplateRef_23_5;
        }
        if (((token === import25.NgIf) && (23 === requestNodeIndex))) {
            return this._NgIf_23_6.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.context.action;
        this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0, throwOnChange, false);
        this._NgSwitch_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_5_0_0 = 'add';
        this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0, throwOnChange, false);
        this._NgSwitchCase_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = 'update';
        this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0, throwOnChange, false);
        this._NgSwitchCase_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        var currVal_9_0_0 = 'update';
        this._NgSwitchCase_9_6.check_ngSwitchCase(currVal_9_0_0, throwOnChange, false);
        this._NgSwitchCase_9_6.detectChangesInInputProps(this, this._anchor_9, throwOnChange);
        var currVal_23_0_0 = (this.context.content || (this.context.action == 'add'));
        this._NgIf_23_6.check_ngIf(currVal_23_0_0, throwOnChange, false);
        this._NgIf_23_6.detectChangesInInputProps(this, this._anchor_23, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageEditComponent0;
}(import1.AppView));
function viewFactory_ContentPageEditComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPageEditComponent === null)) {
        (renderType_ContentPageEditComponent = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, styles_ContentPageEditComponent, {}));
    }
    return new _View_ContentPageEditComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentPageEditComponent0 = viewFactory_ContentPageEditComponent0;
var _View_ContentPageEditComponent1 = (function (_super) {
    __extends(_View_ContentPageEditComponent1, _super);
    function _View_ContentPageEditComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent1, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Nouvelle page', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentPageEditComponent1;
}(import1.AppView));
function viewFactory_ContentPageEditComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent2 = (function (_super) {
    __extends(_View_ContentPageEditComponent2, _super);
    function _View_ContentPageEditComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent2, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Edition', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentPageEditComponent2;
}(import1.AppView));
function viewFactory_ContentPageEditComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent3 = (function (_super) {
    __extends(_View_ContentPageEditComponent3, _super);
    function _View_ContentPageEditComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent3, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import7.UNINITIALIZED;
    }
    _View_ContentPageEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ' ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'small', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_date_0_0 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentPageEditComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import4.interpolate(1, '(modifié: ', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(((this.parent.context.content == null) ? null : this.parent.context.content.update_date), 'dd MM yyyy')), ')');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageEditComponent3;
}(import1.AppView));
function viewFactory_ContentPageEditComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent4 = (function (_super) {
    __extends(_View_ContentPageEditComponent4, _super);
    function _View_ContentPageEditComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent4, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_144 = import7.UNINITIALIZED;
    }
    _View_ContentPageEditComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'form', import4.EMPTY_INLINE_ARRAY, null);
        this._FormGroupDirective_0_3 = new import26.Wrapper_FormGroupDirective(null, null);
        this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
        this._NgControlStatusGroup_0_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'panel panel-default'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Métadonnées', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_7, 'div', new import4.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'col-md-1 col-sm-1 input-group switch material-switch'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_11, 'input', new import4.InlineArray8(8, 'formControlName', 'active', 'id', 'act', 'name', 'act', 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_13_3 = new import28.Wrapper_CheckboxControlValueAccessor(this.renderer, new import33.ElementRef(this._el_13));
        this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
        this._FormControlName_13_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_13_4);
        this._NgControl_13_6 = this._FormControlName_13_5.context;
        this._NgControlStatus_13_7 = new import27.Wrapper_NgControlStatus(this._NgControl_13_6);
        this._text_14 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_11, 'label', new import4.InlineArray4(4, 'class', 'label-primary', 'for', 'act'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                  ', null);
        this._text_17 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'input-group col-lg-3 col-md-4 col-sm-5'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'div', new import4.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_20, 'i', new import4.InlineArray2(2, 'class', 'fa fa-external-link'), null);
        this._text_22 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_18, 'input', new import4.InlineArray8(6, 'class', 'form-control', 'formControlName', 'url', 'type', 'text'), null);
        this._DefaultValueAccessor_23_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_23));
        this._NG_VALUE_ACCESSOR_23_4 = [this._DefaultValueAccessor_23_3.context];
        this._FormControlName_23_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_23_4);
        this._NgControl_23_6 = this._FormControlName_23_5.context;
        this._NgControlStatus_23_7 = new import27.Wrapper_NgControlStatus(this._NgControl_23_6);
        this._text_24 = this.renderer.createText(this._el_18, '\n                  ', null);
        this._text_25 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray4(4, 'class', 'input-group col-lg-3 col-md-4 col-sm-5', 'style', 'max-width: 200px'), null);
        this._text_27 = this.renderer.createText(this._el_26, '\n                    ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_26, 'div', new import4.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_29 = import4.createRenderElement(this.renderer, this._el_28, 'i', new import4.InlineArray2(2, 'class', 'fa fa-calendar'), null);
        this._text_30 = this.renderer.createText(this._el_26, '\n                    ', null);
        this._text_31 = this.renderer.createText(this._el_26, '\n                    ', null);
        this._el_32 = import4.createRenderElement(this.renderer, this._el_26, 'input', new import4.InlineArray8(8, 'class', 'form-control', 'formControlName', 'date', 'readonly', '', 'type', 'text'), null);
        this._DefaultValueAccessor_32_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_32));
        this._NG_VALUE_ACCESSOR_32_4 = [this._DefaultValueAccessor_32_3.context];
        this._FormControlName_32_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_32_4);
        this._NgControl_32_6 = this._FormControlName_32_5.context;
        this._NgControlStatus_32_7 = new import27.Wrapper_NgControlStatus(this._NgControl_32_6);
        this._text_33 = this.renderer.createText(this._el_26, '\n                  ', null);
        this._text_34 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_35 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'input-group col-lg-3 col-md-4 col-sm-5'), null);
        this._text_36 = this.renderer.createText(this._el_35, '\n                    ', null);
        this._el_37 = import4.createRenderElement(this.renderer, this._el_35, 'div', new import4.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_38 = import4.createRenderElement(this.renderer, this._el_37, 'i', new import4.InlineArray2(2, 'class', 'fa fa-id-card-o'), null);
        this._text_39 = this.renderer.createText(this._el_35, '\n                    ', null);
        this._el_40 = import4.createRenderElement(this.renderer, this._el_35, 'input', new import4.InlineArray8(8, 'class', 'form-control', 'formControlName', '_id', 'readonly', '', 'type', 'text'), null);
        this._DefaultValueAccessor_40_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_40));
        this._NG_VALUE_ACCESSOR_40_4 = [this._DefaultValueAccessor_40_3.context];
        this._FormControlName_40_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_40_4);
        this._NgControl_40_6 = this._FormControlName_40_5.context;
        this._NgControlStatus_40_7 = new import27.Wrapper_NgControlStatus(this._NgControl_40_6);
        this._text_41 = this.renderer.createText(this._el_35, '\n                  ', null);
        this._text_42 = this.renderer.createText(this._el_9, '\n                ', null);
        this._text_43 = this.renderer.createText(this._el_7, '\n              ', null);
        this._text_44 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_45 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_46 = this.renderer.createText(this._el_45, 'Titre', null);
        this._text_47 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_48 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_49 = this.renderer.createText(this._el_48, '\n                ', null);
        this._el_50 = import4.createRenderElement(this.renderer, this._el_48, 'div', new import4.InlineArray2(2, 'formGroupName', 'title'), null);
        this._FormGroupName_50_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_50_4 = this._FormGroupName_50_3.context;
        this._NgControlStatusGroup_50_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_50_4);
        this._text_51 = this.renderer.createText(this._el_50, '\n                  ', null);
        this._anchor_52 = this.renderer.createTemplateAnchor(this._el_50, null);
        this._appEl_52 = new import3.AppElement(52, 50, this, this._anchor_52);
        this._TemplateRef_52_5 = new import22.TemplateRef_(this._appEl_52, viewFactory_ContentPageEditComponent5);
        this._NgFor_52_6 = new import32.Wrapper_NgFor(this._appEl_52.vcRef, this._TemplateRef_52_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_53 = this.renderer.createText(this._el_50, '\n                ', null);
        this._text_54 = this.renderer.createText(this._el_48, '\n              ', null);
        this._text_55 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._text_56 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_57 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_58 = this.renderer.createText(this._el_57, 'Contenu', null);
        this._text_59 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_60 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_61 = this.renderer.createText(this._el_60, '\n                ', null);
        this._el_62 = import4.createRenderElement(this.renderer, this._el_60, 'div', new import4.InlineArray2(2, 'formGroupName', 'content'), null);
        this._FormGroupName_62_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_62_4 = this._FormGroupName_62_3.context;
        this._NgControlStatusGroup_62_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_62_4);
        this._text_63 = this.renderer.createText(this._el_62, '\n                  ', null);
        this._anchor_64 = this.renderer.createTemplateAnchor(this._el_62, null);
        this._appEl_64 = new import3.AppElement(64, 62, this, this._anchor_64);
        this._TemplateRef_64_5 = new import22.TemplateRef_(this._appEl_64, viewFactory_ContentPageEditComponent6);
        this._NgFor_64_6 = new import32.Wrapper_NgFor(this._appEl_64.vcRef, this._TemplateRef_64_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_65 = this.renderer.createText(this._el_62, '\n                ', null);
        this._text_66 = this.renderer.createText(this._el_60, '\n              ', null);
        this._text_67 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_68 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_69 = this.renderer.createText(this._el_68, 'Résumé', null);
        this._text_70 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_71 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_72 = this.renderer.createText(this._el_71, '\n                ', null);
        this._el_73 = import4.createRenderElement(this.renderer, this._el_71, 'div', new import4.InlineArray2(2, 'formGroupName', 'content'), null);
        this._FormGroupName_73_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_73_4 = this._FormGroupName_73_3.context;
        this._NgControlStatusGroup_73_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_73_4);
        this._text_74 = this.renderer.createText(this._el_73, '\n                  ', null);
        this._anchor_75 = this.renderer.createTemplateAnchor(this._el_73, null);
        this._appEl_75 = new import3.AppElement(75, 73, this, this._anchor_75);
        this._TemplateRef_75_5 = new import22.TemplateRef_(this._appEl_75, viewFactory_ContentPageEditComponent7);
        this._NgFor_75_6 = new import32.Wrapper_NgFor(this._appEl_75.vcRef, this._TemplateRef_75_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_76 = this.renderer.createText(this._el_73, '\n                ', null);
        this._text_77 = this.renderer.createText(this._el_71, '\n              ', null);
        this._text_78 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_79 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_80 = this.renderer.createText(this._el_79, 'Tags', null);
        this._text_81 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_82 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray4(4, 'class', 'panel-body', 'formArrayName', 'tags'), null);
        this._FormArrayName_82_3 = new import31.Wrapper_FormArrayName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_82_4 = this._FormArrayName_82_3.context;
        this._NgControlStatusGroup_82_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_82_4);
        this._text_83 = this.renderer.createText(this._el_82, '\n                ', null);
        this._el_84 = import4.createRenderElement(this.renderer, this._el_82, 'div', new import4.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_85 = this.renderer.createText(this._el_84, '\n                  ', null);
        this._anchor_86 = this.renderer.createTemplateAnchor(this._el_84, null);
        this._appEl_86 = new import3.AppElement(86, 84, this, this._anchor_86);
        this._TemplateRef_86_5 = new import22.TemplateRef_(this._appEl_86, viewFactory_ContentPageEditComponent8);
        this._NgFor_86_6 = new import32.Wrapper_NgFor(this._appEl_86.vcRef, this._TemplateRef_86_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_87 = this.renderer.createText(this._el_84, '\n                  ', null);
        this._el_88 = import4.createRenderElement(this.renderer, this._el_84, 'a', new import4.InlineArray2(2, 'class', 'glyphicon glyphicon-plus clickLink'), null);
        this._text_89 = this.renderer.createText(this._el_88, ' ', null);
        this._text_90 = this.renderer.createText(this._el_84, '\n                ', null);
        this._text_91 = this.renderer.createText(this._el_82, '\n              ', null);
        this._text_92 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_93 = import4.createRenderElement(this.renderer, this._el_2, 'button', new import4.InlineArray4(4, 'class', 'btn btn-info pull-right', 'type', 'submit'), null);
        this._text_94 = this.renderer.createText(this._el_93, '\n        Sauvegarder\n      ', null);
        this._text_95 = this.renderer.createText(this._el_2, '\n\n            ', null);
        this._text_96 = this.renderer.createText(this._el_0, '\n\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_13, 'change', this.eventHandler(this._handle_change_13_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_13, 'blur', this.eventHandler(this._handle_blur_13_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_23, 'input', this.eventHandler(this._handle_input_23_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_23, 'blur', this.eventHandler(this._handle_blur_23_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_32, 'input', this.eventHandler(this._handle_input_32_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_32, 'blur', this.eventHandler(this._handle_blur_32_1.bind(this)));
        var disposable_9 = this.renderer.listen(this._el_40, 'input', this.eventHandler(this._handle_input_40_0.bind(this)));
        var disposable_10 = this.renderer.listen(this._el_40, 'blur', this.eventHandler(this._handle_blur_40_1.bind(this)));
        var disposable_11 = this.renderer.listen(this._el_88, 'click', this.eventHandler(this._handle_click_88_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._el_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._el_35,
            this._text_36,
            this._el_37,
            this._el_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._el_45,
            this._text_46,
            this._text_47,
            this._el_48,
            this._text_49,
            this._el_50,
            this._text_51,
            this._anchor_52,
            this._text_53,
            this._text_54,
            this._text_55,
            this._text_56,
            this._el_57,
            this._text_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._anchor_64,
            this._text_65,
            this._text_66,
            this._text_67,
            this._el_68,
            this._text_69,
            this._text_70,
            this._el_71,
            this._text_72,
            this._el_73,
            this._text_74,
            this._anchor_75,
            this._text_76,
            this._text_77,
            this._text_78,
            this._el_79,
            this._text_80,
            this._text_81,
            this._el_82,
            this._text_83,
            this._el_84,
            this._text_85,
            this._anchor_86,
            this._text_87,
            this._el_88,
            this._text_89,
            this._text_90,
            this._text_91,
            this._text_92,
            this._el_93,
            this._text_94,
            this._text_95,
            this._text_96
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8,
            disposable_9,
            disposable_10,
            disposable_11
        ], [subscription_0]);
        return null;
    };
    _View_ContentPageEditComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import35.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_13_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_13_4;
        }
        if (((token === import37.FormControlName) && (13 === requestNodeIndex))) {
            return this._FormControlName_13_5.context;
        }
        if (((token === import38.NgControl) && (13 === requestNodeIndex))) {
            return this._NgControl_13_6;
        }
        if (((token === import39.NgControlStatus) && (13 === requestNodeIndex))) {
            return this._NgControlStatus_13_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (23 === requestNodeIndex))) {
            return this._DefaultValueAccessor_23_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (23 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_23_4;
        }
        if (((token === import37.FormControlName) && (23 === requestNodeIndex))) {
            return this._FormControlName_23_5.context;
        }
        if (((token === import38.NgControl) && (23 === requestNodeIndex))) {
            return this._NgControl_23_6;
        }
        if (((token === import39.NgControlStatus) && (23 === requestNodeIndex))) {
            return this._NgControlStatus_23_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (32 === requestNodeIndex))) {
            return this._DefaultValueAccessor_32_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (32 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_32_4;
        }
        if (((token === import37.FormControlName) && (32 === requestNodeIndex))) {
            return this._FormControlName_32_5.context;
        }
        if (((token === import38.NgControl) && (32 === requestNodeIndex))) {
            return this._NgControl_32_6;
        }
        if (((token === import39.NgControlStatus) && (32 === requestNodeIndex))) {
            return this._NgControlStatus_32_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (40 === requestNodeIndex))) {
            return this._DefaultValueAccessor_40_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (40 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_40_4;
        }
        if (((token === import37.FormControlName) && (40 === requestNodeIndex))) {
            return this._FormControlName_40_5.context;
        }
        if (((token === import38.NgControl) && (40 === requestNodeIndex))) {
            return this._NgControl_40_6;
        }
        if (((token === import39.NgControlStatus) && (40 === requestNodeIndex))) {
            return this._NgControlStatus_40_7.context;
        }
        if (((token === import22.TemplateRef) && (52 === requestNodeIndex))) {
            return this._TemplateRef_52_5;
        }
        if (((token === import41.NgFor) && (52 === requestNodeIndex))) {
            return this._NgFor_52_6.context;
        }
        if (((token === import42.FormGroupName) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) {
            return this._FormGroupName_50_3.context;
        }
        if (((token === import43.ControlContainer) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) {
            return this._ControlContainer_50_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((50 <= requestNodeIndex) && (requestNodeIndex <= 53)))) {
            return this._NgControlStatusGroup_50_5.context;
        }
        if (((token === import22.TemplateRef) && (64 === requestNodeIndex))) {
            return this._TemplateRef_64_5;
        }
        if (((token === import41.NgFor) && (64 === requestNodeIndex))) {
            return this._NgFor_64_6.context;
        }
        if (((token === import42.FormGroupName) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._FormGroupName_62_3.context;
        }
        if (((token === import43.ControlContainer) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._ControlContainer_62_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._NgControlStatusGroup_62_5.context;
        }
        if (((token === import22.TemplateRef) && (75 === requestNodeIndex))) {
            return this._TemplateRef_75_5;
        }
        if (((token === import41.NgFor) && (75 === requestNodeIndex))) {
            return this._NgFor_75_6.context;
        }
        if (((token === import42.FormGroupName) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) {
            return this._FormGroupName_73_3.context;
        }
        if (((token === import43.ControlContainer) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) {
            return this._ControlContainer_73_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((73 <= requestNodeIndex) && (requestNodeIndex <= 76)))) {
            return this._NgControlStatusGroup_73_5.context;
        }
        if (((token === import22.TemplateRef) && (86 === requestNodeIndex))) {
            return this._TemplateRef_86_5;
        }
        if (((token === import41.NgFor) && (86 === requestNodeIndex))) {
            return this._NgFor_86_6.context;
        }
        if (((token === import42.FormArrayName) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) {
            return this._FormArrayName_82_3.context;
        }
        if (((token === import43.ControlContainer) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) {
            return this._ControlContainer_82_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((82 <= requestNodeIndex) && (requestNodeIndex <= 91)))) {
            return this._NgControlStatusGroup_82_5.context;
        }
        if (((token === import44.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) {
            return this._FormGroupDirective_0_3.context;
        }
        if (((token === import43.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 96)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.pageForm;
        this._FormGroupDirective_0_3.check_form(currVal_0_0_0, throwOnChange, false);
        this._FormGroupDirective_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this, this._el_13, throwOnChange);
        var currVal_13_1_0 = 'active';
        this._FormControlName_13_5.check_name(currVal_13_1_0, throwOnChange, false);
        this._FormControlName_13_5.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_23_3.detectChangesInInputProps(this, this._el_23, throwOnChange);
        var currVal_23_1_0 = 'url';
        this._FormControlName_23_5.check_name(currVal_23_1_0, throwOnChange, false);
        this._FormControlName_23_5.detectChangesInInputProps(this, this._el_23, throwOnChange);
        this._NgControlStatus_23_7.detectChangesInInputProps(this, this._el_23, throwOnChange);
        this._DefaultValueAccessor_32_3.detectChangesInInputProps(this, this._el_32, throwOnChange);
        var currVal_32_1_0 = 'date';
        this._FormControlName_32_5.check_name(currVal_32_1_0, throwOnChange, false);
        this._FormControlName_32_5.detectChangesInInputProps(this, this._el_32, throwOnChange);
        this._NgControlStatus_32_7.detectChangesInInputProps(this, this._el_32, throwOnChange);
        this._DefaultValueAccessor_40_3.detectChangesInInputProps(this, this._el_40, throwOnChange);
        var currVal_40_1_0 = '_id';
        this._FormControlName_40_5.check_name(currVal_40_1_0, throwOnChange, false);
        this._FormControlName_40_5.detectChangesInInputProps(this, this._el_40, throwOnChange);
        this._NgControlStatus_40_7.detectChangesInInputProps(this, this._el_40, throwOnChange);
        var currVal_50_0_0 = 'title';
        this._FormGroupName_50_3.check_name(currVal_50_0_0, throwOnChange, false);
        this._FormGroupName_50_3.detectChangesInInputProps(this, this._el_50, throwOnChange);
        this._NgControlStatusGroup_50_5.detectChangesInInputProps(this, this._el_50, throwOnChange);
        var currVal_52_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_52_6.check_ngForOf(currVal_52_0_0, throwOnChange, false);
        this._NgFor_52_6.detectChangesInInputProps(this, this._anchor_52, throwOnChange);
        var currVal_62_0_0 = 'content';
        this._FormGroupName_62_3.check_name(currVal_62_0_0, throwOnChange, false);
        this._FormGroupName_62_3.detectChangesInInputProps(this, this._el_62, throwOnChange);
        this._NgControlStatusGroup_62_5.detectChangesInInputProps(this, this._el_62, throwOnChange);
        var currVal_64_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_64_6.check_ngForOf(currVal_64_0_0, throwOnChange, false);
        this._NgFor_64_6.detectChangesInInputProps(this, this._anchor_64, throwOnChange);
        var currVal_73_0_0 = 'content';
        this._FormGroupName_73_3.check_name(currVal_73_0_0, throwOnChange, false);
        this._FormGroupName_73_3.detectChangesInInputProps(this, this._el_73, throwOnChange);
        this._NgControlStatusGroup_73_5.detectChangesInInputProps(this, this._el_73, throwOnChange);
        var currVal_75_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_75_6.check_ngForOf(currVal_75_0_0, throwOnChange, false);
        this._NgFor_75_6.detectChangesInInputProps(this, this._anchor_75, throwOnChange);
        var currVal_82_0_0 = 'tags';
        this._FormArrayName_82_3.check_name(currVal_82_0_0, throwOnChange, false);
        this._FormArrayName_82_3.detectChangesInInputProps(this, this._el_82, throwOnChange);
        this._NgControlStatusGroup_82_5.detectChangesInInputProps(this, this._el_82, throwOnChange);
        var currVal_86_0_0 = this.parent.context.pageForm.controls.tags.controls;
        this._NgFor_86_6.check_ngForOf(currVal_86_0_0, throwOnChange, false);
        this._NgFor_86_6.detectChangesInInputProps(this, this._anchor_86, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupDirective_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._FormControlName_13_5.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_23_3.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._FormControlName_23_5.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._NgControlStatus_23_7.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._DefaultValueAccessor_32_3.detectChangesInHostProps(this, this._el_32, throwOnChange);
        this._FormControlName_32_5.detectChangesInHostProps(this, this._el_32, throwOnChange);
        this._NgControlStatus_32_7.detectChangesInHostProps(this, this._el_32, throwOnChange);
        this._DefaultValueAccessor_40_3.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._FormControlName_40_5.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._NgControlStatus_40_7.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._FormGroupName_50_3.detectChangesInHostProps(this, this._el_50, throwOnChange);
        this._NgControlStatusGroup_50_5.detectChangesInHostProps(this, this._el_50, throwOnChange);
        this._FormGroupName_62_3.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._NgControlStatusGroup_62_5.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._FormGroupName_73_3.detectChangesInHostProps(this, this._el_73, throwOnChange);
        this._NgControlStatusGroup_73_5.detectChangesInHostProps(this, this._el_73, throwOnChange);
        this._FormArrayName_82_3.detectChangesInHostProps(this, this._el_82, throwOnChange);
        this._NgControlStatusGroup_82_5.detectChangesInHostProps(this, this._el_82, throwOnChange);
        var currVal_144 = !this.parent.context.pageForm.valid;
        if (import4.checkBinding(throwOnChange, this._expr_144, currVal_144)) {
            this.renderer.setElementProperty(this._el_93, 'disabled', currVal_144);
            this._expr_144 = currVal_144;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPageEditComponent4.prototype.destroyInternal = function () {
        this._FormControlName_13_5.context.ngOnDestroy();
        this._FormControlName_23_5.context.ngOnDestroy();
        this._FormControlName_32_5.context.ngOnDestroy();
        this._FormControlName_40_5.context.ngOnDestroy();
        this._FormArrayName_82_3.context.ngOnDestroy();
    };
    _View_ContentPageEditComponent4.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_0_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_change_13_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked) !== false);
        return (true && pd_13_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_blur_13_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onTouched() !== false);
        return (true && pd_13_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_input_23_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this._DefaultValueAccessor_23_3.context.onChange($event.target.value) !== false);
        return (true && pd_23_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_blur_23_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this._DefaultValueAccessor_23_3.context.onTouched() !== false);
        return (true && pd_23_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_input_32_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_32_0 = (this._DefaultValueAccessor_32_3.context.onChange($event.target.value) !== false);
        return (true && pd_32_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_blur_32_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_32_0 = (this._DefaultValueAccessor_32_3.context.onTouched() !== false);
        return (true && pd_32_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_input_40_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_40_0 = (this._DefaultValueAccessor_40_3.context.onChange($event.target.value) !== false);
        return (true && pd_40_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_blur_40_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_40_0 = (this._DefaultValueAccessor_40_3.context.onTouched() !== false);
        return (true && pd_40_0);
    };
    _View_ContentPageEditComponent4.prototype._handle_click_88_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_88_0 = (this.parent.context.onAddTag() !== false);
        return (true && pd_88_0);
    };
    return _View_ContentPageEditComponent4;
}(import1.AppView));
function viewFactory_ContentPageEditComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent5 = (function (_super) {
    __extends(_View_ContentPageEditComponent5, _super);
    function _View_ContentPageEditComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent5, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import7.UNINITIALIZED;
    }
    _View_ContentPageEditComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'form-group input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_0, 'input', new import4.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import29.Wrapper_FormControlName(this.parent._ControlContainer_50_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_0 = import4.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentPageEditComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import37.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import38.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_0, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPageEditComponent5.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentPageEditComponent5.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentPageEditComponent5.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentPageEditComponent5;
}(import1.AppView));
function viewFactory_ContentPageEditComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent6 = (function (_super) {
    __extends(_View_ContentPageEditComponent6, _super);
    function _View_ContentPageEditComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent6, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import7.UNINITIALIZED;
    }
    _View_ContentPageEditComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'form-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'small', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_0, 'html-editor', new import4.InlineArray2(2, 'height', '50'), null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._el_5);
        var compView_5 = import45.viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
        this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context, [], compView_5);
        this._text_6 = this.renderer.createText(null, '\n                    ', null);
        compView_5.create(this._HtmlEditorComponent_5_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_1 = import4.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'onEditorKeyup', this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        var subscription_0 = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentPageEditComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._HtmlEditorComponent_5_4.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_5_0_0 = ('editor-content-' + this.context.$implicit);
        this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = (this.parent.parent.context.content ? this.parent.parent.context.content.content[this.context.$implicit] : '');
        this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1, throwOnChange, false);
        var currVal_5_0_2 = '50';
        this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2, throwOnChange, false);
        this._HtmlEditorComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_10 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_1, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_10, currVal_10))) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this._HtmlEditorComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentPageEditComponent6.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_5_4.context.ngOnDestroy();
    };
    _View_ContentPageEditComponent6.prototype._handle_onEditorKeyup_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.keyupEditorHandlerFunction([
            'content',
            this.context.$implicit
        ], $event) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentPageEditComponent6;
}(import1.AppView));
function viewFactory_ContentPageEditComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent7 = (function (_super) {
    __extends(_View_ContentPageEditComponent7, _super);
    function _View_ContentPageEditComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent7, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import7.UNINITIALIZED;
    }
    _View_ContentPageEditComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'form-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'small', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_0, 'html-editor', new import4.InlineArray2(2, 'height', '10'), null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._el_5);
        var compView_5 = import45.viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
        this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context, [], compView_5);
        this._text_6 = this.renderer.createText(null, '\n                    ', null);
        compView_5.create(this._HtmlEditorComponent_5_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_2 = import4.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'onEditorKeyup', this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        var subscription_0 = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentPageEditComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._HtmlEditorComponent_5_4.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_5_0_0 = ('editor-summary-' + this.context.$implicit);
        this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = (this.parent.parent.context.content ? this.parent.parent.context.content.summary[this.context.$implicit] : '');
        this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1, throwOnChange, false);
        var currVal_5_0_2 = '10';
        this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2, throwOnChange, false);
        this._HtmlEditorComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_10 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_uppercase_1_2, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_10, currVal_10))) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this._HtmlEditorComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentPageEditComponent7.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_5_4.context.ngOnDestroy();
    };
    _View_ContentPageEditComponent7.prototype._handle_onEditorKeyup_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.keyupEditorHandlerFunction([
            'summary',
            this.context.$implicit
        ], $event) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentPageEditComponent7;
}(import1.AppView));
function viewFactory_ContentPageEditComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageEditComponent8 = (function (_super) {
    __extends(_View_ContentPageEditComponent8, _super);
    function _View_ContentPageEditComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageEditComponent8, renderType_ContentPageEditComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageEditComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray4(4, 'class', 'input-group col-lg-3 col-md-4 col-sm-5', 'style', 'padding: 0px 3px 3px 0px; max-width: 200px'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'input', new import4.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_2_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_2));
        this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
        this._FormControlName_2_5 = new import29.Wrapper_FormControlName(this.parent._ControlContainer_82_4, null, null, this._NG_VALUE_ACCESSOR_2_4);
        this._NgControl_2_6 = this._FormControlName_2_5.context;
        this._NgControlStatus_2_7 = new import27.Wrapper_NgControlStatus(this._NgControl_2_6);
        this._text_3 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_4, 'a', new import4.InlineArray2(2, 'class', 'glyphicon glyphicon-remove clickLink'), null);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'input', this.eventHandler(this._handle_input_2_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_2, 'blur', this.eventHandler(this._handle_blur_2_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentPageEditComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.DefaultValueAccessor) && (2 === requestNodeIndex))) {
            return this._DefaultValueAccessor_2_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_2_4;
        }
        if (((token === import37.FormControlName) && (2 === requestNodeIndex))) {
            return this._FormControlName_2_5.context;
        }
        if (((token === import38.NgControl) && (2 === requestNodeIndex))) {
            return this._NgControl_2_6;
        }
        if (((token === import39.NgControlStatus) && (2 === requestNodeIndex))) {
            return this._NgControlStatus_2_7.context;
        }
        return notFoundResult;
    };
    _View_ContentPageEditComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        this._DefaultValueAccessor_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_2_1_0 = import4.interpolate(1, '', this.context.index, '');
        this._FormControlName_2_5.check_name(currVal_2_1_0, throwOnChange, false);
        this._FormControlName_2_5.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._DefaultValueAccessor_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._FormControlName_2_5.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPageEditComponent8.prototype.destroyInternal = function () {
        this._FormControlName_2_5.context.ngOnDestroy();
    };
    _View_ContentPageEditComponent8.prototype._handle_input_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onChange($event.target.value) !== false);
        return (true && pd_2_0);
    };
    _View_ContentPageEditComponent8.prototype._handle_blur_2_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onTouched() !== false);
        return (true && pd_2_0);
    };
    _View_ContentPageEditComponent8.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.onRemoveTag(this.context.index) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentPageEditComponent8;
}(import1.AppView));
function viewFactory_ContentPageEditComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageEditComponent8(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(155);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(5);
var import10 = __webpack_require__(9);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(32);
var import13 = __webpack_require__(15);
var import14 = __webpack_require__(11);
var import15 = __webpack_require__(10);
var import16 = __webpack_require__(24);
var import17 = __webpack_require__(46);
var import18 = __webpack_require__(14);
var import19 = __webpack_require__(20);
var import20 = __webpack_require__(38);
var import21 = __webpack_require__(21);
var import22 = __webpack_require__(31);
var Wrapper_ContentPagesComponent = (function () {
    function Wrapper_ContentPagesComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.ContentPagesComponent(p0, p1, p2, p3, p4, p5);
    }
    Wrapper_ContentPagesComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentPagesComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentPagesComponent;
}());
exports.Wrapper_ContentPagesComponent = Wrapper_ContentPagesComponent;
var renderType_ContentPagesComponent_Host = null;
var _View_ContentPagesComponent_Host0 = (function (_super) {
    __extends(_View_ContentPagesComponent_Host0, _super);
    function _View_ContentPagesComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPagesComponent_Host0, renderType_ContentPagesComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPagesComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentPagesComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentPagesComponent_0_4 = new Wrapper_ContentPagesComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import9.ConfigService), this.parentInjector.get(import10.ContentService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Location), this.parentInjector.get(import13.Router));
        this._appEl_0.initComponent(this._ContentPagesComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentPagesComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentPagesComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentPagesComponent) && (0 === requestNodeIndex))) {
            return this._ContentPagesComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentPagesComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentPagesComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentPagesComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentPagesComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPagesComponent_Host0;
}(import1.AppView));
function viewFactory_ContentPagesComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPagesComponent_Host === null)) {
        (renderType_ContentPagesComponent_Host = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentPagesComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentPagesComponentNgFactory = new import15.ComponentFactory('ng-component', viewFactory_ContentPagesComponent_Host0, import0.ContentPagesComponent);
var styles_ContentPagesComponent = [];
var renderType_ContentPagesComponent = null;
var _View_ContentPagesComponent0 = (function (_super) {
    __extends(_View_ContentPagesComponent0, _super);
    function _View_ContentPagesComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPagesComponent0, renderType_ContentPagesComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_56 = import7.UNINITIALIZED;
    }
    _View_ContentPagesComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Pages\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'lLink'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n      ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_7 = this.renderer.createText(this._el_6, 'Nouveau', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n    ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n', null);
        this._text_11 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_12 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n  ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n  ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_14, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n  ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_16, 'div', new import4.InlineArray2(2, 'class', 'box'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n    ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'div', new import4.InlineArray2(2, 'class', 'box-body'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n\n      ', null);
        this._el_22 = import4.createRenderElement(this.renderer, this._el_20, 'table', new import4.InlineArray2(2, 'class', 'table table-striped table-hover'), null);
        this._text_23 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_24 = import4.createRenderElement(this.renderer, this._el_22, 'thead', import4.EMPTY_INLINE_ARRAY, null);
        this._text_25 = this.renderer.createText(this._el_24, '\n          ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_24, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_27 = this.renderer.createText(this._el_26, '\n            ', null);
        this._text_28 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_29 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_30 = this.renderer.createText(this._el_29, 'Date', null);
        this._text_31 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_32 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_33 = this.renderer.createText(this._el_32, '', null);
        this._text_34 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_35 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_36 = this.renderer.createText(this._el_35, 'URL', null);
        this._text_37 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_38 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_39 = this.renderer.createText(this._el_38, 'Modifié', null);
        this._text_40 = this.renderer.createText(this._el_26, '\n          ', null);
        this._text_41 = this.renderer.createText(this._el_24, '\n        ', null);
        this._text_42 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_43 = import4.createRenderElement(this.renderer, this._el_22, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_44 = this.renderer.createText(this._el_43, '\n          ', null);
        this._anchor_45 = this.renderer.createTemplateAnchor(this._el_43, null);
        this._appEl_45 = new import3.AppElement(45, 43, this, this._anchor_45);
        this._TemplateRef_45_5 = new import18.TemplateRef_(this._appEl_45, viewFactory_ContentPagesComponent1);
        this._NgFor_45_6 = new import16.Wrapper_NgFor(this._appEl_45.vcRef, this._TemplateRef_45_5, this.parentInjector.get(import19.IterableDiffers), this.ref);
        this._text_46 = this.renderer.createText(this._el_43, '\n        ', null);
        this._text_47 = this.renderer.createText(this._el_22, '\n      ', null);
        this._text_48 = this.renderer.createText(this._el_20, '\n\n\n    ', null);
        this._text_49 = this.renderer.createText(this._el_18, '\n  ', null);
        this._text_50 = this.renderer.createText(this._el_16, '\n  ', null);
        this._text_51 = this.renderer.createText(this._el_14, '\n  ', null);
        this._text_52 = this.renderer.createText(this._el_12, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this._pipe_date_0 = new import17.DatePipe(this.parentInjector.get(import20.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._el_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._el_35,
            this._text_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._text_40,
            this._text_41,
            this._text_42,
            this._el_43,
            this._text_44,
            this._anchor_45,
            this._text_46,
            this._text_47,
            this._text_48,
            this._text_49,
            this._text_50,
            this._text_51,
            this._text_52
        ], [disposable_0], []);
        return null;
    };
    _View_ContentPagesComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (45 === requestNodeIndex))) {
            return this._TemplateRef_45_5;
        }
        if (((token === import21.NgFor) && (45 === requestNodeIndex))) {
            return this._NgFor_45_6.context;
        }
        return notFoundResult;
    };
    _View_ContentPagesComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_45_0_0 = this.context.contents;
        this._NgFor_45_6.check_ngForOf(currVal_45_0_0, throwOnChange, false);
        this._NgFor_45_6.detectChangesInInputProps(this, this._anchor_45, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_56 = import4.interpolate(1, 'Titre (', this.context.currentLanguage, ')');
        if (import4.checkBinding(throwOnChange, this._expr_56, currVal_56)) {
            this.renderer.setText(this._text_33, currVal_56);
            this._expr_56 = currVal_56;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPagesComponent0.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.context.utils.lLink('admin/page/edit/0', this.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    return _View_ContentPagesComponent0;
}(import1.AppView));
function viewFactory_ContentPagesComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPagesComponent === null)) {
        (renderType_ContentPagesComponent = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, styles_ContentPagesComponent, {}));
    }
    return new _View_ContentPagesComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentPagesComponent0 = viewFactory_ContentPagesComponent0;
var _View_ContentPagesComponent1 = (function (_super) {
    __extends(_View_ContentPagesComponent1, _super);
    function _View_ContentPagesComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPagesComponent1, renderType_ContentPagesComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_16 = import7.UNINITIALIZED;
        this._expr_18 = import7.UNINITIALIZED;
        this._expr_19 = import7.UNINITIALIZED;
        this._expr_20 = import7.UNINITIALIZED;
        this._expr_21 = import7.UNINITIALIZED;
    }
    _View_ContentPagesComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_4 = this.renderer.createText(this._el_3, '', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_7 = this.renderer.createText(this._el_6, '', null);
        this._text_8 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_9, 'a', new import4.InlineArray4(4, 'class', 'pointer', 'target', '_blank'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_14 = this.renderer.createText(this._el_13, '', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n          ', null);
        this._pipe_date_0_0 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        this._pipe_date_0_1 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15
        ], [disposable_0], []);
        return null;
    };
    _View_ContentPagesComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_16 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(this.context.$implicit.date, 'MMM dd yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_16, currVal_16))) {
            this.renderer.setText(this._text_4, currVal_16);
            this._expr_16 = currVal_16;
        }
        var currVal_18 = import4.interpolate(1, '', (this.context.$implicit.title ? this.context.$implicit.title[this.parent.context.currentLanguage] : '-'), '');
        if (import4.checkBinding(throwOnChange, this._expr_18, currVal_18)) {
            this.renderer.setText(this._text_7, currVal_18);
            this._expr_18 = currVal_18;
        }
        var currVal_19 = import4.interpolate(1, 'page/', this.context.$implicit.url, '');
        if (import4.checkBinding(throwOnChange, this._expr_19, currVal_19)) {
            this.renderer.setElementProperty(this._el_10, 'href', this.viewUtils.sanitizer.sanitize(import22.SecurityContext.URL, currVal_19));
            this._expr_19 = currVal_19;
        }
        var currVal_20 = import4.interpolate(1, '', this.context.$implicit.url, '');
        if (import4.checkBinding(throwOnChange, this._expr_20, currVal_20)) {
            this.renderer.setText(this._text_11, currVal_20);
            this._expr_20 = currVal_20;
        }
        valUnwrapper.reset();
        var currVal_21 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_1, this.parent._pipe_date_0.transform)(this.context.$implicit.update_date, 'MMM dd yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_21, currVal_21))) {
            this.renderer.setText(this._text_14, currVal_21);
            this._expr_21 = currVal_21;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPagesComponent1.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.context.router.navigate([('page/edit/' + this.context.$implicit._id)], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_6_0);
    };
    return _View_ContentPagesComponent1;
}(import1.AppView));
function viewFactory_ContentPagesComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPagesComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(156);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(46);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(38);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(17);
var import12 = __webpack_require__(25);
var import13 = __webpack_require__(18);
var import14 = __webpack_require__(30);
var import15 = __webpack_require__(2);
var import16 = __webpack_require__(73);
var import17 = __webpack_require__(15);
var import18 = __webpack_require__(9);
var import19 = __webpack_require__(16);
var import20 = __webpack_require__(11);
var import21 = __webpack_require__(10);
var import22 = __webpack_require__(56);
var import23 = __webpack_require__(22);
var import24 = __webpack_require__(82);
var import25 = __webpack_require__(14);
var import26 = __webpack_require__(39);
var import27 = __webpack_require__(19);
var import28 = __webpack_require__(114);
var import29 = __webpack_require__(43);
var import30 = __webpack_require__(64);
var import31 = __webpack_require__(113);
var import32 = __webpack_require__(85);
var import33 = __webpack_require__(115);
var import34 = __webpack_require__(434);
var import35 = __webpack_require__(217);
var import36 = __webpack_require__(218);
var import37 = __webpack_require__(24);
var import38 = __webpack_require__(116);
var import39 = __webpack_require__(20);
var import40 = __webpack_require__(41);
var import41 = __webpack_require__(26);
var import42 = __webpack_require__(61);
var import43 = __webpack_require__(28);
var import44 = __webpack_require__(33);
var import45 = __webpack_require__(47);
var import46 = __webpack_require__(224);
var import47 = __webpack_require__(54);
var import48 = __webpack_require__(37);
var import49 = __webpack_require__(70);
var import50 = __webpack_require__(71);
var import51 = __webpack_require__(21);
var import52 = __webpack_require__(53);
var import53 = __webpack_require__(455);
var import54 = __webpack_require__(236);
var import55 = __webpack_require__(162);
var import56 = __webpack_require__(96);
var Wrapper_ContentRecordEditComponent = (function () {
    function Wrapper_ContentRecordEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10) {
        this.changed = false;
        this.context = new import0.ContentRecordEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10);
    }
    Wrapper_ContentRecordEditComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentRecordEditComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentRecordEditComponent;
}());
exports.Wrapper_ContentRecordEditComponent = Wrapper_ContentRecordEditComponent;
var renderType_ContentRecordEditComponent_Host = null;
var _View_ContentRecordEditComponent_Host0 = (function (_super) {
    __extends(_View_ContentRecordEditComponent_Host0, _super);
    function _View_ContentRecordEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent_Host0, renderType_ContentRecordEditComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentRecordEditComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._ContentRecordEditComponent_0_5 = new Wrapper_ContentRecordEditComponent(this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.IntlService), this.parentInjector.get(import12.MetaService), new import13.ElementRef(this._el_0), this.parentInjector.get(import14.SearchService), this._DatePipe_0_4, this.parentInjector.get(import15.UtilsService), this.parentInjector.get(import16.FormBuilder), this.parentInjector.get(import17.Router), this.parentInjector.get(import18.ContentService), this.parentInjector.get(import19.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentRecordEditComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentRecordEditComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentRecordEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.DatePipe) && (0 === requestNodeIndex))) {
            return this._DatePipe_0_4;
        }
        if (((token === import0.ContentRecordEditComponent) && (0 === requestNodeIndex))) {
            return this._ContentRecordEditComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentRecordEditComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentRecordEditComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordEditComponent_Host0;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordEditComponent_Host === null)) {
        (renderType_ContentRecordEditComponent_Host = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentRecordEditComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentRecordEditComponentNgFactory = new import21.ComponentFactory('ng-component', viewFactory_ContentRecordEditComponent_Host0, import0.ContentRecordEditComponent);
var styles_ContentRecordEditComponent = [];
var renderType_ContentRecordEditComponent = null;
var _View_ContentRecordEditComponent0 = (function (_super) {
    __extends(_View_ContentRecordEditComponent0, _super);
    function _View_ContentRecordEditComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent0, renderType_ContentRecordEditComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n	', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'h1', import5.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_2_3 = new import22.Wrapper_NgSwitch();
        this._text_3 = this.renderer.createText(this._el_2, '\n  		', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_4 = new import3.AppElement(4, 2, this, this._anchor_4);
        this._TemplateRef_4_5 = new import25.TemplateRef_(this._appEl_4, viewFactory_ContentRecordEditComponent1);
        this._NgSwitchCase_4_6 = new import22.Wrapper_NgSwitchCase(this._appEl_4.vcRef, this._TemplateRef_4_5, this._NgSwitch_2_3.context);
        this._text_5 = this.renderer.createText(this._el_2, '\n      ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_6 = new import3.AppElement(6, 2, this, this._anchor_6);
        this._TemplateRef_6_5 = new import25.TemplateRef_(this._appEl_6, viewFactory_ContentRecordEditComponent2);
        this._NgSwitchCase_6_6 = new import22.Wrapper_NgSwitchCase(this._appEl_6.vcRef, this._TemplateRef_6_5, this._NgSwitch_2_3.context);
        this._text_7 = this.renderer.createText(this._el_2, '\n      ', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_8 = new import3.AppElement(8, 2, this, this._anchor_8);
        this._TemplateRef_8_5 = new import25.TemplateRef_(this._appEl_8, viewFactory_ContentRecordEditComponent3);
        this._NgIf_8_6 = new import23.Wrapper_NgIf(this._appEl_8.vcRef, this._TemplateRef_8_5);
        this._text_9 = this.renderer.createText(this._el_2, '\n      ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_10 = new import3.AppElement(10, 2, this, this._anchor_10);
        this._TemplateRef_10_5 = new import25.TemplateRef_(this._appEl_10, viewFactory_ContentRecordEditComponent4);
        this._NgSwitchCase_10_6 = new import22.Wrapper_NgSwitchCase(this._appEl_10.vcRef, this._TemplateRef_10_5, this._NgSwitch_2_3.context);
        this._text_11 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n', null);
        this._text_13 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_14 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n  \n  ', null);
        this._el_16 = import5.createRenderElement(this.renderer, this._el_14, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_17, 'div', new import5.InlineArray2(2, 'class', 'box'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n    ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_18, 'div', new import5.InlineArray2(2, 'class', 'box-body'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n\n    ', null);
        this._anchor_22 = this.renderer.createTemplateAnchor(this._el_20, null);
        this._appEl_22 = new import3.AppElement(22, 20, this, this._anchor_22);
        this._TemplateRef_22_5 = new import25.TemplateRef_(this._appEl_22, viewFactory_ContentRecordEditComponent5);
        this._NgIf_22_6 = new import23.Wrapper_NgIf(this._appEl_22.vcRef, this._TemplateRef_22_5);
        this._text_23 = this.renderer.createText(this._el_20, '  \n\n\n    ', null);
        this._text_24 = this.renderer.createText(this._el_18, '\n  ', null);
        this._text_25 = this.renderer.createText(this._el_14, '\n', null);
        this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._pipe_uppercase_1 = new import24.UpperCasePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._anchor_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._el_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._anchor_22,
            this._text_23,
            this._text_24,
            this._text_25
        ], [], []);
        return null;
    };
    _View_ContentRecordEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import26.NgSwitchCase) && (4 === requestNodeIndex))) {
            return this._NgSwitchCase_4_6.context;
        }
        if (((token === import25.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import26.NgSwitchCase) && (6 === requestNodeIndex))) {
            return this._NgSwitchCase_6_6.context;
        }
        if (((token === import25.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import27.NgIf) && (8 === requestNodeIndex))) {
            return this._NgIf_8_6.context;
        }
        if (((token === import25.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import26.NgSwitchCase) && (10 === requestNodeIndex))) {
            return this._NgSwitchCase_10_6.context;
        }
        if (((token === import26.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._NgSwitch_2_3.context;
        }
        if (((token === import25.TemplateRef) && (22 === requestNodeIndex))) {
            return this._TemplateRef_22_5;
        }
        if (((token === import27.NgIf) && (22 === requestNodeIndex))) {
            return this._NgIf_22_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.context.action;
        this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0, throwOnChange, false);
        this._NgSwitch_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_4_0_0 = 'add';
        this._NgSwitchCase_4_6.check_ngSwitchCase(currVal_4_0_0, throwOnChange, false);
        this._NgSwitchCase_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        var currVal_6_0_0 = 'update';
        this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0, throwOnChange, false);
        this._NgSwitchCase_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_8_0_0 = (this.context.content && (this.context.action == 'update'));
        this._NgIf_8_6.check_ngIf(currVal_8_0_0, throwOnChange, false);
        this._NgIf_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        var currVal_10_0_0 = 'update';
        this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0, throwOnChange, false);
        this._NgSwitchCase_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        var currVal_22_0_0 = (this.context.content || (this.context.action == 'add'));
        this._NgIf_22_6.check_ngIf(currVal_22_0_0, throwOnChange, false);
        this._NgIf_22_6.detectChangesInInputProps(this, this._anchor_22, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordEditComponent0;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordEditComponent === null)) {
        (renderType_ContentRecordEditComponent = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, styles_ContentRecordEditComponent, {}));
    }
    return new _View_ContentRecordEditComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentRecordEditComponent0 = viewFactory_ContentRecordEditComponent0;
var _View_ContentRecordEditComponent1 = (function (_super) {
    __extends(_View_ContentRecordEditComponent1, _super);
    function _View_ContentRecordEditComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent1, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Nouveau disque', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentRecordEditComponent1;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent2 = (function (_super) {
    __extends(_View_ContentRecordEditComponent2, _super);
    function _View_ContentRecordEditComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent2, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Edition ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordEditComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_4 = import5.interpolate(1, '', ((this.parent.context.content == null) ? null : this.parent.context.content.cid), '');
        if (import5.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordEditComponent2;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent3 = (function (_super) {
    __extends(_View_ContentRecordEditComponent3, _super);
    function _View_ContentRecordEditComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent3, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'lLink'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_3 = this.renderer.createText(this._el_2, 'Supprimer', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n      ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent3.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.deleteContent('record', this.parent.context.content._id) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent3;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent4 = (function (_super) {
    __extends(_View_ContentRecordEditComponent4, _super);
    function _View_ContentRecordEditComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent4, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ' ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_date_0_0 = import5.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordEditComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import5.interpolate(1, '(modifié: ', valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(((this.parent.context.content == null) ? null : this.parent.context.content.update_date), 'dd MM yyyy')), ')');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordEditComponent4;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent5 = (function (_super) {
    __extends(_View_ContentRecordEditComponent5, _super);
    function _View_ContentRecordEditComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent5, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_241 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'form', new import5.InlineArray2(2, 'autocomplete', 'off'), null);
        this._FormGroupDirective_0_3 = new import28.Wrapper_FormGroupDirective(null, null);
        this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
        this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n      ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'panel panel-default'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n			', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Titre', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n        ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_7, 'div', new import5.InlineArray2(2, 'class', 'col-xs-1 switch material-switch'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n          ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'input', new import5.InlineArray8(8, 'formControlName', 'active', 'id', 'act', 'name', 'act', 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_11_3 = new import30.Wrapper_CheckboxControlValueAccessor(this.renderer, new import13.ElementRef(this._el_11));
        this._NG_VALUE_ACCESSOR_11_4 = [this._CheckboxControlValueAccessor_11_3.context];
        this._FormControlName_11_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_11_4);
        this._NgControl_11_6 = this._FormControlName_11_5.context;
        this._NgControlStatus_11_7 = new import29.Wrapper_NgControlStatus(this._NgControl_11_6);
        this._text_12 = this.renderer.createText(this._el_9, '\n          ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_9, 'label', new import5.InlineArray4(4, 'class', 'label-primary', 'for', 'act'), null);
        this._text_14 = this.renderer.createText(this._el_9, '\n        ', null);
        this._text_15 = this.renderer.createText(this._el_7, '\n        ', null);
        this._el_16 = import5.createRenderElement(this.renderer, this._el_7, 'div', new import5.InlineArray2(2, 'class', 'col-xs-9'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n          ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_16, 'input', new import5.InlineArray8(8, 'class', 'form-control', 'formControlName', 'title', 'style', 'font-weight:bold', 'type', 'text'), null);
        this._DefaultValueAccessor_18_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_18));
        this._NG_VALUE_ACCESSOR_18_4 = [this._DefaultValueAccessor_18_3.context];
        this._FormControlName_18_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_18_4);
        this._NgControl_18_6 = this._FormControlName_18_5.context;
        this._NgControlStatus_18_7 = new import29.Wrapper_NgControlStatus(this._NgControl_18_6);
        this._text_19 = this.renderer.createText(this._el_16, '\n        ', null);
        this._text_20 = this.renderer.createText(this._el_7, ' \n        ', null);
        this._anchor_21 = this.renderer.createTemplateAnchor(this._el_7, null);
        this._appEl_21 = new import3.AppElement(21, 7, this, this._anchor_21);
        this._TemplateRef_21_5 = new import25.TemplateRef_(this._appEl_21, viewFactory_ContentRecordEditComponent6);
        this._NgIf_21_6 = new import23.Wrapper_NgIf(this._appEl_21.vcRef, this._TemplateRef_21_5);
        this._text_22 = this.renderer.createText(this._el_7, '\n      ', null);
        this._text_23 = this.renderer.createText(this._el_2, '\n\n			 ', null);
        this._el_24 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_25 = this.renderer.createText(this._el_24, 'Pochette', null);
        this._text_26 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_27 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body panel-body-edit-image'), null);
        this._text_28 = this.renderer.createText(this._el_27, '\n        ', null);
        this._el_29 = import5.createRenderElement(this.renderer, this._el_27, 'div', new import5.InlineArray2(2, 'formGroupName', 'cover'), null);
        this._FormGroupName_29_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_29_4 = this._FormGroupName_29_3.context;
        this._NgControlStatusGroup_29_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_29_4);
        this._text_30 = this.renderer.createText(this._el_29, '\n          ', null);
        this._el_31 = import5.createRenderElement(this.renderer, this._el_29, 'image-uploads', new import5.InlineArray16(10, 'addApi', '/api/data/covers/add', 'deleteApi', '/api/data/covers/delete/', 'deleteDir', 'covers', 'groupName', 'cover', 'imagePath', '/data/covers/'), null);
        this._appEl_31 = new import3.AppElement(31, 29, this, this._el_31);
        var compView_31 = import34.viewFactory_ImageUploadComponent0(this.viewUtils, this.injector(31), this._appEl_31);
        this._ImageUploadComponent_31_4 = new import34.Wrapper_ImageUploadComponent(this.parent.parentInjector.get(import38.DataService));
        this._appEl_31.initComponent(this._ImageUploadComponent_31_4.context, [], compView_31);
        this._text_32 = this.renderer.createText(null, '\n          ', null);
        compView_31.create(this._ImageUploadComponent_31_4.context, [], null);
        this._text_33 = this.renderer.createText(this._el_29, '\n        ', null);
        this._text_34 = this.renderer.createText(this._el_27, '\n      ', null);
        this._text_35 = this.renderer.createText(this._el_2, ' \n\n			', null);
        this._el_36 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_37 = this.renderer.createText(this._el_36, 'Métadonnées', null);
        this._text_38 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_39 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_40 = this.renderer.createText(this._el_39, '\n        ', null);
        this._el_41 = import5.createRenderElement(this.renderer, this._el_39, 'div', new import5.InlineArray2(2, 'class', 'form-group'), null);
        this._text_42 = this.renderer.createText(this._el_41, '\n          ', null);
        this._el_43 = import5.createRenderElement(this.renderer, this._el_41, 'div', new import5.InlineArray2(2, 'class', 'block form-inline'), null);
        this._text_44 = this.renderer.createText(this._el_43, '\n            ', null);
        this._el_45 = import5.createRenderElement(this.renderer, this._el_43, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-3'), null);
        this._text_46 = this.renderer.createText(this._el_45, '\n              ', null);
        this._el_47 = import5.createRenderElement(this.renderer, this._el_45, 'select', new import5.InlineArray4(4, 'class', 'form-control', 'formControlName', 'type'), null);
        this._SelectControlValueAccessor_47_3 = new import35.Wrapper_SelectControlValueAccessor(this.renderer, new import13.ElementRef(this._el_47));
        this._NG_VALUE_ACCESSOR_47_4 = [this._SelectControlValueAccessor_47_3.context];
        this._FormControlName_47_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_47_4);
        this._NgControl_47_6 = this._FormControlName_47_5.context;
        this._NgControlStatus_47_7 = new import29.Wrapper_NgControlStatus(this._NgControl_47_6);
        this._text_48 = this.renderer.createText(this._el_47, '\n                ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_47, 'option', new import5.InlineArray2(2, 'value', 'reissue'), null);
        this._NgSelectOption_49_3 = new import35.Wrapper_NgSelectOption(new import13.ElementRef(this._el_49), this.renderer, this._SelectControlValueAccessor_47_3.context);
        this._NgSelectMultipleOption_49_4 = new import36.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_49), this.renderer, null);
        this._text_50 = this.renderer.createText(this._el_49, 'Ré-édition', null);
        this._text_51 = this.renderer.createText(this._el_47, '\n                ', null);
        this._el_52 = import5.createRenderElement(this.renderer, this._el_47, 'option', new import5.InlineArray2(2, 'value', 'production'), null);
        this._NgSelectOption_52_3 = new import35.Wrapper_NgSelectOption(new import13.ElementRef(this._el_52), this.renderer, this._SelectControlValueAccessor_47_3.context);
        this._NgSelectMultipleOption_52_4 = new import36.Wrapper_NgSelectMultipleOption(new import13.ElementRef(this._el_52), this.renderer, null);
        this._text_53 = this.renderer.createText(this._el_52, 'Production', null);
        this._text_54 = this.renderer.createText(this._el_47, '\n              ', null);
        this._text_55 = this.renderer.createText(this._el_45, '\n            ', null);
        this._text_56 = this.renderer.createText(this._el_43, '\n            ', null);
        this._el_57 = import5.createRenderElement(this.renderer, this._el_43, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_58 = this.renderer.createText(this._el_57, '\n              ', null);
        this._el_59 = import5.createRenderElement(this.renderer, this._el_57, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_60 = import5.createRenderElement(this.renderer, this._el_59, 'i', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-cd'), null);
        this._text_61 = this.renderer.createText(this._el_57, '\n              ', null);
        this._el_62 = import5.createRenderElement(this.renderer, this._el_57, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'reference', 'type', 'text'), null);
        this._DefaultValueAccessor_62_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_62));
        this._NG_VALUE_ACCESSOR_62_4 = [this._DefaultValueAccessor_62_3.context];
        this._FormControlName_62_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_62_4);
        this._NgControl_62_6 = this._FormControlName_62_5.context;
        this._NgControlStatus_62_7 = new import29.Wrapper_NgControlStatus(this._NgControl_62_6);
        this._text_63 = this.renderer.createText(this._el_57, '\n            ', null);
        this._text_64 = this.renderer.createText(this._el_43, ' \n             ', null);
        this._el_65 = import5.createRenderElement(this.renderer, this._el_43, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_66 = this.renderer.createText(this._el_65, '\n              ', null);
        this._el_67 = import5.createRenderElement(this.renderer, this._el_65, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_68 = import5.createRenderElement(this.renderer, this._el_67, 'i', new import5.InlineArray2(2, 'class', 'fa fa-calendar'), null);
        this._text_69 = this.renderer.createText(this._el_65, '\n              ', null);
        this._el_70 = import5.createRenderElement(this.renderer, this._el_65, 'input', new import5.InlineArray8(6, 'class', 'date-mask form-control', 'formControlName', 'date', 'type', 'text'), null);
        this._DefaultValueAccessor_70_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_70));
        this._NG_VALUE_ACCESSOR_70_4 = [this._DefaultValueAccessor_70_3.context];
        this._FormControlName_70_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_70_4);
        this._NgControl_70_6 = this._FormControlName_70_5.context;
        this._NgControlStatus_70_7 = new import29.Wrapper_NgControlStatus(this._NgControl_70_6);
        this._text_71 = this.renderer.createText(this._el_65, '\n            ', null);
        this._text_72 = this.renderer.createText(this._el_43, '   \n          ', null);
        this._text_73 = this.renderer.createText(this._el_41, ' \n          ', null);
        this._el_74 = import5.createRenderElement(this.renderer, this._el_41, 'div', new import5.InlineArray2(2, 'class', 'block form-inline'), null);
        this._text_75 = this.renderer.createText(this._el_74, '\n            ', null);
        this._el_76 = import5.createRenderElement(this.renderer, this._el_74, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-3'), null);
        this._text_77 = this.renderer.createText(this._el_76, '\n              ', null);
        this._el_78 = import5.createRenderElement(this.renderer, this._el_76, 'span', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_79 = import5.createRenderElement(this.renderer, this._el_78, 'i', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-euro'), null);
        this._text_80 = this.renderer.createText(this._el_76, '\n              ', null);
        this._el_81 = import5.createRenderElement(this.renderer, this._el_76, 'input', new import5.InlineArray8(6, 'class', 'price-mask form-control', 'formControlName', 'price', 'type', 'text'), null);
        this._DefaultValueAccessor_81_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_81));
        this._NG_VALUE_ACCESSOR_81_4 = [this._DefaultValueAccessor_81_3.context];
        this._FormControlName_81_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_81_4);
        this._NgControl_81_6 = this._FormControlName_81_5.context;
        this._NgControlStatus_81_7 = new import29.Wrapper_NgControlStatus(this._NgControl_81_6);
        this._text_82 = this.renderer.createText(this._el_76, '\n            ', null);
        this._text_83 = this.renderer.createText(this._el_74, '\n            ', null);
        this._el_84 = import5.createRenderElement(this.renderer, this._el_74, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_85 = this.renderer.createText(this._el_84, '\n              ', null);
        this._el_86 = import5.createRenderElement(this.renderer, this._el_84, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_87 = import5.createRenderElement(this.renderer, this._el_86, 'i', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-time'), null);
        this._text_88 = this.renderer.createText(this._el_84, '\n              ', null);
        this._el_89 = import5.createRenderElement(this.renderer, this._el_84, 'input', new import5.InlineArray8(6, 'class', 'length-mask form-control', 'formControlName', 'length', 'type', 'text'), null);
        this._DefaultValueAccessor_89_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_89));
        this._NG_VALUE_ACCESSOR_89_4 = [this._DefaultValueAccessor_89_3.context];
        this._FormControlName_89_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_89_4);
        this._NgControl_89_6 = this._FormControlName_89_5.context;
        this._NgControlStatus_89_7 = new import29.Wrapper_NgControlStatus(this._NgControl_89_6);
        this._text_90 = this.renderer.createText(this._el_84, '\n            ', null);
        this._text_91 = this.renderer.createText(this._el_74, ' \n            ', null);
        this._el_92 = import5.createRenderElement(this.renderer, this._el_74, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_93 = this.renderer.createText(this._el_92, '\n              ', null);
        this._el_94 = import5.createRenderElement(this.renderer, this._el_92, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_95 = import5.createRenderElement(this.renderer, this._el_94, 'i', new import5.InlineArray2(2, 'class', 'fa fa-external-link'), null);
        this._text_96 = this.renderer.createText(this._el_92, '\n              ', null);
        this._el_97 = import5.createRenderElement(this.renderer, this._el_92, 'input', new import5.InlineArray8(8, 'class', 'form-control', 'formControlName', 'url', 'readonly', '', 'type', 'text'), null);
        this._DefaultValueAccessor_97_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_97));
        this._NG_VALUE_ACCESSOR_97_4 = [this._DefaultValueAccessor_97_3.context];
        this._FormControlName_97_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_97_4);
        this._NgControl_97_6 = this._FormControlName_97_5.context;
        this._NgControlStatus_97_7 = new import29.Wrapper_NgControlStatus(this._NgControl_97_6);
        this._text_98 = this.renderer.createText(this._el_92, '\n            ', null);
        this._text_99 = this.renderer.createText(this._el_74, '   \n          ', null);
        this._text_100 = this.renderer.createText(this._el_41, '\n           ', null);
        this._el_101 = import5.createRenderElement(this.renderer, this._el_41, 'div', new import5.InlineArray2(2, 'class', 'block form-inline'), null);
        this._text_102 = this.renderer.createText(this._el_101, '\n            ', null);
        this._anchor_103 = this.renderer.createTemplateAnchor(this._el_101, null);
        this._appEl_103 = new import3.AppElement(103, 101, this, this._anchor_103);
        this._TemplateRef_103_5 = new import25.TemplateRef_(this._appEl_103, viewFactory_ContentRecordEditComponent9);
        this._NgFor_103_6 = new import37.Wrapper_NgFor(this._appEl_103.vcRef, this._TemplateRef_103_5, this.parent.parentInjector.get(import39.IterableDiffers), this.parent.ref);
        this._text_104 = this.renderer.createText(this._el_101, ' \n          ', null);
        this._text_105 = this.renderer.createText(this._el_41, ' \n          ', null);
        this._anchor_106 = this.renderer.createTemplateAnchor(this._el_41, null);
        this._appEl_106 = new import3.AppElement(106, 41, this, this._anchor_106);
        this._TemplateRef_106_5 = new import25.TemplateRef_(this._appEl_106, viewFactory_ContentRecordEditComponent11);
        this._NgIf_106_6 = new import23.Wrapper_NgIf(this._appEl_106.vcRef, this._TemplateRef_106_5);
        this._text_107 = this.renderer.createText(this._el_41, '   \n        ', null);
        this._text_108 = this.renderer.createText(this._el_39, '\n			', null);
        this._text_109 = this.renderer.createText(this._el_2, '\n\n			 ', null);
        this._el_110 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray4(4, 'class', 'panel-heading', 'style', 'margin-bottom: 15px'), null);
        this._text_111 = this.renderer.createText(this._el_110, 'Œuvres', null);
        this._text_112 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_113 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray4(4, 'formArrayName', 'music_pieces', 'ngclass', 'panel-body'), null);
        this._FormArrayName_113_3 = new import33.Wrapper_FormArrayName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_113_4 = this._FormArrayName_113_3.context;
        this._NgControlStatusGroup_113_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_113_4);
        this._text_114 = this.renderer.createText(this._el_113, '\n        ', null);
        this._anchor_115 = this.renderer.createTemplateAnchor(this._el_113, null);
        this._appEl_115 = new import3.AppElement(115, 113, this, this._anchor_115);
        this._TemplateRef_115_5 = new import25.TemplateRef_(this._appEl_115, viewFactory_ContentRecordEditComponent12);
        this._NgFor_115_6 = new import37.Wrapper_NgFor(this._appEl_115.vcRef, this._TemplateRef_115_5, this.parent.parentInjector.get(import39.IterableDiffers), this.parent.ref);
        this._text_116 = this.renderer.createText(this._el_113, '\n        ', null);
        this._anchor_117 = this.renderer.createTemplateAnchor(this._el_113, null);
        this._appEl_117 = new import3.AppElement(117, 113, this, this._anchor_117);
        this._TemplateRef_117_5 = new import25.TemplateRef_(this._appEl_117, viewFactory_ContentRecordEditComponent17);
        this._NgIf_117_6 = new import23.Wrapper_NgIf(this._appEl_117.vcRef, this._TemplateRef_117_5);
        this._text_118 = this.renderer.createText(this._el_113, '\n      ', null);
        this._text_119 = this.renderer.createText(this._el_2, ' \n\n			 ', null);
        this._el_120 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_121 = this.renderer.createText(this._el_120, 'Description', null);
        this._text_122 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_123 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_124 = this.renderer.createText(this._el_123, '\n      ', null);
        this._el_125 = import5.createRenderElement(this.renderer, this._el_123, 'div', new import5.InlineArray2(2, 'formGroupName', 'description'), null);
        this._FormGroupName_125_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_125_4 = this._FormGroupName_125_3.context;
        this._NgControlStatusGroup_125_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_125_4);
        this._text_126 = this.renderer.createText(this._el_125, '\n        ', null);
        this._anchor_127 = this.renderer.createTemplateAnchor(this._el_125, null);
        this._appEl_127 = new import3.AppElement(127, 125, this, this._anchor_127);
        this._TemplateRef_127_5 = new import25.TemplateRef_(this._appEl_127, viewFactory_ContentRecordEditComponent18);
        this._NgFor_127_6 = new import37.Wrapper_NgFor(this._appEl_127.vcRef, this._TemplateRef_127_5, this.parent.parentInjector.get(import39.IterableDiffers), this.parent.ref);
        this._text_128 = this.renderer.createText(this._el_125, '\n      ', null);
        this._text_129 = this.renderer.createText(this._el_123, '\n      ', null);
        this._text_130 = this.renderer.createText(this._el_2, ' \n\n			 ', null);
        this._el_131 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_132 = this.renderer.createText(this._el_131, 'Tags', null);
        this._text_133 = this.renderer.createText(this._el_2, '\n			', null);
        this._el_134 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray4(4, 'class', 'panel-body', 'formArrayName', 'tags'), null);
        this._FormArrayName_134_3 = new import33.Wrapper_FormArrayName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_134_4 = this._FormArrayName_134_3.context;
        this._NgControlStatusGroup_134_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_134_4);
        this._text_135 = this.renderer.createText(this._el_134, '\n        ', null);
        this._el_136 = import5.createRenderElement(this.renderer, this._el_134, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_137 = this.renderer.createText(this._el_136, '\n          ', null);
        this._anchor_138 = this.renderer.createTemplateAnchor(this._el_136, null);
        this._appEl_138 = new import3.AppElement(138, 136, this, this._anchor_138);
        this._TemplateRef_138_5 = new import25.TemplateRef_(this._appEl_138, viewFactory_ContentRecordEditComponent19);
        this._NgFor_138_6 = new import37.Wrapper_NgFor(this._appEl_138.vcRef, this._TemplateRef_138_5, this.parent.parentInjector.get(import39.IterableDiffers), this.parent.ref);
        this._text_139 = this.renderer.createText(this._el_136, ' \n          ', null);
        this._anchor_140 = this.renderer.createTemplateAnchor(this._el_136, null);
        this._appEl_140 = new import3.AppElement(140, 136, this, this._anchor_140);
        this._TemplateRef_140_5 = new import25.TemplateRef_(this._appEl_140, viewFactory_ContentRecordEditComponent21);
        this._NgIf_140_6 = new import23.Wrapper_NgIf(this._appEl_140.vcRef, this._TemplateRef_140_5);
        this._text_141 = this.renderer.createText(this._el_136, '\n			  ', null);
        this._text_142 = this.renderer.createText(this._el_134, '\n      ', null);
        this._text_143 = this.renderer.createText(this._el_2, ' \n\n			', null);
        this._el_144 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_145 = this.renderer.createText(this._el_144, '\n				', null);
        this._el_146 = import5.createRenderElement(this.renderer, this._el_144, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_147 = this.renderer.createText(this._el_146, ' \n					', null);
        this._el_148 = import5.createRenderElement(this.renderer, this._el_146, 'div', new import5.InlineArray2(2, 'class', 'input-group col-lg-3 col-md-4 col-sm-5 pull-right'), null);
        this._text_149 = this.renderer.createText(this._el_148, '\n						', null);
        this._el_150 = import5.createRenderElement(this.renderer, this._el_148, 'input', new import5.InlineArray8(6, 'class', 'btn btn-info', 'type', 'submit', 'value', 'Enregistrer le nouveau disque'), null);
        this._text_151 = this.renderer.createText(this._el_148, ' \n					', null);
        this._text_152 = this.renderer.createText(this._el_146, '  \n				', null);
        this._text_153 = this.renderer.createText(this._el_144, '\n			', null);
        this._text_154 = this.renderer.createText(this._el_2, '\n\n      ', null);
        this._text_155 = this.renderer.createText(this._el_0, '\n    ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_11, 'change', this.eventHandler(this._handle_change_11_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_11, 'blur', this.eventHandler(this._handle_blur_11_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_18, 'input', this.eventHandler(this._handle_input_18_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_18, 'blur', this.eventHandler(this._handle_blur_18_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_47, 'change', this.eventHandler(this._handle_change_47_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_47, 'blur', this.eventHandler(this._handle_blur_47_1.bind(this)));
        var disposable_9 = this.renderer.listen(this._el_62, 'input', this.eventHandler(this._handle_input_62_0.bind(this)));
        var disposable_10 = this.renderer.listen(this._el_62, 'blur', this.eventHandler(this._handle_blur_62_1.bind(this)));
        var disposable_11 = this.renderer.listen(this._el_70, 'input', this.eventHandler(this._handle_input_70_0.bind(this)));
        var disposable_12 = this.renderer.listen(this._el_70, 'blur', this.eventHandler(this._handle_blur_70_1.bind(this)));
        var disposable_13 = this.renderer.listen(this._el_81, 'input', this.eventHandler(this._handle_input_81_0.bind(this)));
        var disposable_14 = this.renderer.listen(this._el_81, 'blur', this.eventHandler(this._handle_blur_81_1.bind(this)));
        var disposable_15 = this.renderer.listen(this._el_89, 'input', this.eventHandler(this._handle_input_89_0.bind(this)));
        var disposable_16 = this.renderer.listen(this._el_89, 'blur', this.eventHandler(this._handle_blur_89_1.bind(this)));
        var disposable_17 = this.renderer.listen(this._el_94, 'click', this.eventHandler(this._handle_click_94_0.bind(this)));
        var disposable_18 = this.renderer.listen(this._el_97, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_97_0.bind(this)));
        var disposable_19 = this.renderer.listen(this._el_97, 'input', this.eventHandler(this._handle_input_97_1.bind(this)));
        var disposable_20 = this.renderer.listen(this._el_97, 'blur', this.eventHandler(this._handle_blur_97_2.bind(this)));
        var subscription_1 = this._FormControlName_97_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_97_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._anchor_21,
            this._text_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._el_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._el_41,
            this._text_42,
            this._el_43,
            this._text_44,
            this._el_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._text_51,
            this._el_52,
            this._text_53,
            this._text_54,
            this._text_55,
            this._text_56,
            this._el_57,
            this._text_58,
            this._el_59,
            this._el_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._text_64,
            this._el_65,
            this._text_66,
            this._el_67,
            this._el_68,
            this._text_69,
            this._el_70,
            this._text_71,
            this._text_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._el_76,
            this._text_77,
            this._el_78,
            this._el_79,
            this._text_80,
            this._el_81,
            this._text_82,
            this._text_83,
            this._el_84,
            this._text_85,
            this._el_86,
            this._el_87,
            this._text_88,
            this._el_89,
            this._text_90,
            this._text_91,
            this._el_92,
            this._text_93,
            this._el_94,
            this._el_95,
            this._text_96,
            this._el_97,
            this._text_98,
            this._text_99,
            this._text_100,
            this._el_101,
            this._text_102,
            this._anchor_103,
            this._text_104,
            this._text_105,
            this._anchor_106,
            this._text_107,
            this._text_108,
            this._text_109,
            this._el_110,
            this._text_111,
            this._text_112,
            this._el_113,
            this._text_114,
            this._anchor_115,
            this._text_116,
            this._anchor_117,
            this._text_118,
            this._text_119,
            this._el_120,
            this._text_121,
            this._text_122,
            this._el_123,
            this._text_124,
            this._el_125,
            this._text_126,
            this._anchor_127,
            this._text_128,
            this._text_129,
            this._text_130,
            this._el_131,
            this._text_132,
            this._text_133,
            this._el_134,
            this._text_135,
            this._el_136,
            this._text_137,
            this._anchor_138,
            this._text_139,
            this._anchor_140,
            this._text_141,
            this._text_142,
            this._text_143,
            this._el_144,
            this._text_145,
            this._el_146,
            this._text_147,
            this._el_148,
            this._text_149,
            this._el_150,
            this._text_151,
            this._text_152,
            this._text_153,
            this._text_154,
            this._text_155
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8,
            disposable_9,
            disposable_10,
            disposable_11,
            disposable_12,
            disposable_13,
            disposable_14,
            disposable_15,
            disposable_16,
            disposable_17,
            disposable_18,
            disposable_19,
            disposable_20
        ], [
            subscription_0,
            subscription_1
        ]);
        return null;
    };
    _View_ContentRecordEditComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.CheckboxControlValueAccessor) && (11 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_11_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (11 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_11_4;
        }
        if (((token === import42.FormControlName) && (11 === requestNodeIndex))) {
            return this._FormControlName_11_5.context;
        }
        if (((token === import43.NgControl) && (11 === requestNodeIndex))) {
            return this._NgControl_11_6;
        }
        if (((token === import44.NgControlStatus) && (11 === requestNodeIndex))) {
            return this._NgControlStatus_11_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (18 === requestNodeIndex))) {
            return this._DefaultValueAccessor_18_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (18 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_18_4;
        }
        if (((token === import42.FormControlName) && (18 === requestNodeIndex))) {
            return this._FormControlName_18_5.context;
        }
        if (((token === import43.NgControl) && (18 === requestNodeIndex))) {
            return this._NgControl_18_6;
        }
        if (((token === import44.NgControlStatus) && (18 === requestNodeIndex))) {
            return this._NgControlStatus_18_7.context;
        }
        if (((token === import25.TemplateRef) && (21 === requestNodeIndex))) {
            return this._TemplateRef_21_5;
        }
        if (((token === import27.NgIf) && (21 === requestNodeIndex))) {
            return this._NgIf_21_6.context;
        }
        if (((token === import46.ImageUploadComponent) && ((31 <= requestNodeIndex) && (requestNodeIndex <= 32)))) {
            return this._ImageUploadComponent_31_4.context;
        }
        if (((token === import47.FormGroupName) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) {
            return this._FormGroupName_29_3.context;
        }
        if (((token === import48.ControlContainer) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) {
            return this._ControlContainer_29_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 33)))) {
            return this._NgControlStatusGroup_29_5.context;
        }
        if (((token === import49.NgSelectOption) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 50)))) {
            return this._NgSelectOption_49_3.context;
        }
        if (((token === import50.NgSelectMultipleOption) && ((49 <= requestNodeIndex) && (requestNodeIndex <= 50)))) {
            return this._NgSelectMultipleOption_49_4.context;
        }
        if (((token === import49.NgSelectOption) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 53)))) {
            return this._NgSelectOption_52_3.context;
        }
        if (((token === import50.NgSelectMultipleOption) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 53)))) {
            return this._NgSelectMultipleOption_52_4.context;
        }
        if (((token === import49.SelectControlValueAccessor) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._SelectControlValueAccessor_47_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._NG_VALUE_ACCESSOR_47_4;
        }
        if (((token === import42.FormControlName) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._FormControlName_47_5.context;
        }
        if (((token === import43.NgControl) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._NgControl_47_6;
        }
        if (((token === import44.NgControlStatus) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._NgControlStatus_47_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (62 === requestNodeIndex))) {
            return this._DefaultValueAccessor_62_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (62 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_62_4;
        }
        if (((token === import42.FormControlName) && (62 === requestNodeIndex))) {
            return this._FormControlName_62_5.context;
        }
        if (((token === import43.NgControl) && (62 === requestNodeIndex))) {
            return this._NgControl_62_6;
        }
        if (((token === import44.NgControlStatus) && (62 === requestNodeIndex))) {
            return this._NgControlStatus_62_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (70 === requestNodeIndex))) {
            return this._DefaultValueAccessor_70_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (70 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_70_4;
        }
        if (((token === import42.FormControlName) && (70 === requestNodeIndex))) {
            return this._FormControlName_70_5.context;
        }
        if (((token === import43.NgControl) && (70 === requestNodeIndex))) {
            return this._NgControl_70_6;
        }
        if (((token === import44.NgControlStatus) && (70 === requestNodeIndex))) {
            return this._NgControlStatus_70_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (81 === requestNodeIndex))) {
            return this._DefaultValueAccessor_81_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (81 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_81_4;
        }
        if (((token === import42.FormControlName) && (81 === requestNodeIndex))) {
            return this._FormControlName_81_5.context;
        }
        if (((token === import43.NgControl) && (81 === requestNodeIndex))) {
            return this._NgControl_81_6;
        }
        if (((token === import44.NgControlStatus) && (81 === requestNodeIndex))) {
            return this._NgControlStatus_81_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (89 === requestNodeIndex))) {
            return this._DefaultValueAccessor_89_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (89 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_89_4;
        }
        if (((token === import42.FormControlName) && (89 === requestNodeIndex))) {
            return this._FormControlName_89_5.context;
        }
        if (((token === import43.NgControl) && (89 === requestNodeIndex))) {
            return this._NgControl_89_6;
        }
        if (((token === import44.NgControlStatus) && (89 === requestNodeIndex))) {
            return this._NgControlStatus_89_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (97 === requestNodeIndex))) {
            return this._DefaultValueAccessor_97_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (97 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_97_4;
        }
        if (((token === import42.FormControlName) && (97 === requestNodeIndex))) {
            return this._FormControlName_97_5.context;
        }
        if (((token === import43.NgControl) && (97 === requestNodeIndex))) {
            return this._NgControl_97_6;
        }
        if (((token === import44.NgControlStatus) && (97 === requestNodeIndex))) {
            return this._NgControlStatus_97_7.context;
        }
        if (((token === import25.TemplateRef) && (103 === requestNodeIndex))) {
            return this._TemplateRef_103_5;
        }
        if (((token === import51.NgFor) && (103 === requestNodeIndex))) {
            return this._NgFor_103_6.context;
        }
        if (((token === import25.TemplateRef) && (106 === requestNodeIndex))) {
            return this._TemplateRef_106_5;
        }
        if (((token === import27.NgIf) && (106 === requestNodeIndex))) {
            return this._NgIf_106_6.context;
        }
        if (((token === import25.TemplateRef) && (115 === requestNodeIndex))) {
            return this._TemplateRef_115_5;
        }
        if (((token === import51.NgFor) && (115 === requestNodeIndex))) {
            return this._NgFor_115_6.context;
        }
        if (((token === import25.TemplateRef) && (117 === requestNodeIndex))) {
            return this._TemplateRef_117_5;
        }
        if (((token === import27.NgIf) && (117 === requestNodeIndex))) {
            return this._NgIf_117_6.context;
        }
        if (((token === import47.FormArrayName) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) {
            return this._FormArrayName_113_3.context;
        }
        if (((token === import48.ControlContainer) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) {
            return this._ControlContainer_113_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((113 <= requestNodeIndex) && (requestNodeIndex <= 118)))) {
            return this._NgControlStatusGroup_113_5.context;
        }
        if (((token === import25.TemplateRef) && (127 === requestNodeIndex))) {
            return this._TemplateRef_127_5;
        }
        if (((token === import51.NgFor) && (127 === requestNodeIndex))) {
            return this._NgFor_127_6.context;
        }
        if (((token === import47.FormGroupName) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) {
            return this._FormGroupName_125_3.context;
        }
        if (((token === import48.ControlContainer) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) {
            return this._ControlContainer_125_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((125 <= requestNodeIndex) && (requestNodeIndex <= 128)))) {
            return this._NgControlStatusGroup_125_5.context;
        }
        if (((token === import25.TemplateRef) && (138 === requestNodeIndex))) {
            return this._TemplateRef_138_5;
        }
        if (((token === import51.NgFor) && (138 === requestNodeIndex))) {
            return this._NgFor_138_6.context;
        }
        if (((token === import25.TemplateRef) && (140 === requestNodeIndex))) {
            return this._TemplateRef_140_5;
        }
        if (((token === import27.NgIf) && (140 === requestNodeIndex))) {
            return this._NgIf_140_6.context;
        }
        if (((token === import47.FormArrayName) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) {
            return this._FormArrayName_134_3.context;
        }
        if (((token === import48.ControlContainer) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) {
            return this._ControlContainer_134_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((134 <= requestNodeIndex) && (requestNodeIndex <= 142)))) {
            return this._NgControlStatusGroup_134_5.context;
        }
        if (((token === import52.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) {
            return this._FormGroupDirective_0_3.context;
        }
        if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 155)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.recordForm;
        this._FormGroupDirective_0_3.check_form(currVal_0_0_0, throwOnChange, false);
        this._FormGroupDirective_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_11_3.detectChangesInInputProps(this, this._el_11, throwOnChange);
        var currVal_11_1_0 = 'active';
        this._FormControlName_11_5.check_name(currVal_11_1_0, throwOnChange, false);
        this._FormControlName_11_5.detectChangesInInputProps(this, this._el_11, throwOnChange);
        this._NgControlStatus_11_7.detectChangesInInputProps(this, this._el_11, throwOnChange);
        this._DefaultValueAccessor_18_3.detectChangesInInputProps(this, this._el_18, throwOnChange);
        var currVal_18_1_0 = 'title';
        this._FormControlName_18_5.check_name(currVal_18_1_0, throwOnChange, false);
        this._FormControlName_18_5.detectChangesInInputProps(this, this._el_18, throwOnChange);
        this._NgControlStatus_18_7.detectChangesInInputProps(this, this._el_18, throwOnChange);
        var currVal_21_0_0 = (this.parent.context.action == 'update');
        this._NgIf_21_6.check_ngIf(currVal_21_0_0, throwOnChange, false);
        this._NgIf_21_6.detectChangesInInputProps(this, this._anchor_21, throwOnChange);
        var currVal_29_0_0 = 'cover';
        this._FormGroupName_29_3.check_name(currVal_29_0_0, throwOnChange, false);
        this._FormGroupName_29_3.detectChangesInInputProps(this, this._el_29, throwOnChange);
        this._NgControlStatusGroup_29_5.detectChangesInInputProps(this, this._el_29, throwOnChange);
        var currVal_31_0_0 = this.parent.context.recordForm;
        this._ImageUploadComponent_31_4.check_form(currVal_31_0_0, throwOnChange, false);
        var currVal_31_0_1 = 'cover';
        this._ImageUploadComponent_31_4.check_groupName(currVal_31_0_1, throwOnChange, false);
        var currVal_31_0_2 = '/data/covers/';
        this._ImageUploadComponent_31_4.check_imagePath(currVal_31_0_2, throwOnChange, false);
        var currVal_31_0_3 = '/api/data/covers/add';
        this._ImageUploadComponent_31_4.check_addApi(currVal_31_0_3, throwOnChange, false);
        var currVal_31_0_4 = '/api/data/covers/delete/';
        this._ImageUploadComponent_31_4.check_deleteApi(currVal_31_0_4, throwOnChange, false);
        var currVal_31_0_5 = 'covers';
        this._ImageUploadComponent_31_4.check_deleteDir(currVal_31_0_5, throwOnChange, false);
        var currVal_31_0_6 = 300;
        this._ImageUploadComponent_31_4.check_thumbSize(currVal_31_0_6, throwOnChange, false);
        this._ImageUploadComponent_31_4.detectChangesInInputProps(this, this._el_31, throwOnChange);
        this._SelectControlValueAccessor_47_3.detectChangesInInputProps(this, this._el_47, throwOnChange);
        var currVal_47_1_0 = 'type';
        this._FormControlName_47_5.check_name(currVal_47_1_0, throwOnChange, false);
        this._FormControlName_47_5.detectChangesInInputProps(this, this._el_47, throwOnChange);
        this._NgControlStatus_47_7.detectChangesInInputProps(this, this._el_47, throwOnChange);
        var currVal_49_0_0 = 'reissue';
        this._NgSelectOption_49_3.check_value(currVal_49_0_0, throwOnChange, false);
        this._NgSelectOption_49_3.detectChangesInInputProps(this, this._el_49, throwOnChange);
        var currVal_49_1_0 = 'reissue';
        this._NgSelectMultipleOption_49_4.check_value(currVal_49_1_0, throwOnChange, false);
        this._NgSelectMultipleOption_49_4.detectChangesInInputProps(this, this._el_49, throwOnChange);
        var currVal_52_0_0 = 'production';
        this._NgSelectOption_52_3.check_value(currVal_52_0_0, throwOnChange, false);
        this._NgSelectOption_52_3.detectChangesInInputProps(this, this._el_52, throwOnChange);
        var currVal_52_1_0 = 'production';
        this._NgSelectMultipleOption_52_4.check_value(currVal_52_1_0, throwOnChange, false);
        this._NgSelectMultipleOption_52_4.detectChangesInInputProps(this, this._el_52, throwOnChange);
        this._DefaultValueAccessor_62_3.detectChangesInInputProps(this, this._el_62, throwOnChange);
        var currVal_62_1_0 = 'reference';
        this._FormControlName_62_5.check_name(currVal_62_1_0, throwOnChange, false);
        this._FormControlName_62_5.detectChangesInInputProps(this, this._el_62, throwOnChange);
        this._NgControlStatus_62_7.detectChangesInInputProps(this, this._el_62, throwOnChange);
        this._DefaultValueAccessor_70_3.detectChangesInInputProps(this, this._el_70, throwOnChange);
        var currVal_70_1_0 = 'date';
        this._FormControlName_70_5.check_name(currVal_70_1_0, throwOnChange, false);
        this._FormControlName_70_5.detectChangesInInputProps(this, this._el_70, throwOnChange);
        this._NgControlStatus_70_7.detectChangesInInputProps(this, this._el_70, throwOnChange);
        this._DefaultValueAccessor_81_3.detectChangesInInputProps(this, this._el_81, throwOnChange);
        var currVal_81_1_0 = 'price';
        this._FormControlName_81_5.check_name(currVal_81_1_0, throwOnChange, false);
        this._FormControlName_81_5.detectChangesInInputProps(this, this._el_81, throwOnChange);
        this._NgControlStatus_81_7.detectChangesInInputProps(this, this._el_81, throwOnChange);
        this._DefaultValueAccessor_89_3.detectChangesInInputProps(this, this._el_89, throwOnChange);
        var currVal_89_1_0 = 'length';
        this._FormControlName_89_5.check_name(currVal_89_1_0, throwOnChange, false);
        this._FormControlName_89_5.detectChangesInInputProps(this, this._el_89, throwOnChange);
        this._NgControlStatus_89_7.detectChangesInInputProps(this, this._el_89, throwOnChange);
        this._DefaultValueAccessor_97_3.detectChangesInInputProps(this, this._el_97, throwOnChange);
        var currVal_97_1_0 = 'url';
        this._FormControlName_97_5.check_name(currVal_97_1_0, throwOnChange, false);
        var currVal_97_1_1 = this.parent.context.url;
        this._FormControlName_97_5.check_model(currVal_97_1_1, throwOnChange, false);
        this._FormControlName_97_5.detectChangesInInputProps(this, this._el_97, throwOnChange);
        this._NgControlStatus_97_7.detectChangesInInputProps(this, this._el_97, throwOnChange);
        var currVal_103_0_0 = this.parent.context.recordForm.controls.original_references.controls;
        this._NgFor_103_6.check_ngForOf(currVal_103_0_0, throwOnChange, false);
        this._NgFor_103_6.detectChangesInInputProps(this, this._anchor_103, throwOnChange);
        var currVal_106_0_0 = (this.parent.context.recordForm.controls.original_references.controls.length == 0);
        this._NgIf_106_6.check_ngIf(currVal_106_0_0, throwOnChange, false);
        this._NgIf_106_6.detectChangesInInputProps(this, this._anchor_106, throwOnChange);
        var currVal_113_0_0 = 'music_pieces';
        this._FormArrayName_113_3.check_name(currVal_113_0_0, throwOnChange, false);
        this._FormArrayName_113_3.detectChangesInInputProps(this, this._el_113, throwOnChange);
        this._NgControlStatusGroup_113_5.detectChangesInInputProps(this, this._el_113, throwOnChange);
        var currVal_115_0_0 = this.parent.context.recordForm.get('music_pieces').controls;
        this._NgFor_115_6.check_ngForOf(currVal_115_0_0, throwOnChange, false);
        this._NgFor_115_6.detectChangesInInputProps(this, this._anchor_115, throwOnChange);
        var currVal_117_0_0 = (this.parent.context.recordForm.get('music_pieces').controls.length == 0);
        this._NgIf_117_6.check_ngIf(currVal_117_0_0, throwOnChange, false);
        this._NgIf_117_6.detectChangesInInputProps(this, this._anchor_117, throwOnChange);
        var currVal_125_0_0 = 'description';
        this._FormGroupName_125_3.check_name(currVal_125_0_0, throwOnChange, false);
        this._FormGroupName_125_3.detectChangesInInputProps(this, this._el_125, throwOnChange);
        this._NgControlStatusGroup_125_5.detectChangesInInputProps(this, this._el_125, throwOnChange);
        var currVal_127_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_127_6.check_ngForOf(currVal_127_0_0, throwOnChange, false);
        this._NgFor_127_6.detectChangesInInputProps(this, this._anchor_127, throwOnChange);
        var currVal_134_0_0 = 'tags';
        this._FormArrayName_134_3.check_name(currVal_134_0_0, throwOnChange, false);
        this._FormArrayName_134_3.detectChangesInInputProps(this, this._el_134, throwOnChange);
        this._NgControlStatusGroup_134_5.detectChangesInInputProps(this, this._el_134, throwOnChange);
        var currVal_138_0_0 = this.parent.context.recordForm.controls.tags.controls;
        this._NgFor_138_6.check_ngForOf(currVal_138_0_0, throwOnChange, false);
        this._NgFor_138_6.detectChangesInInputProps(this, this._anchor_138, throwOnChange);
        var currVal_140_0_0 = (this.parent.context.recordForm.controls.tags.controls.length == 0);
        this._NgIf_140_6.check_ngIf(currVal_140_0_0, throwOnChange, false);
        this._NgIf_140_6.detectChangesInInputProps(this, this._anchor_140, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupDirective_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_11_3.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._FormControlName_11_5.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._NgControlStatus_11_7.detectChangesInHostProps(this, this._el_11, throwOnChange);
        this._DefaultValueAccessor_18_3.detectChangesInHostProps(this, this._el_18, throwOnChange);
        this._FormControlName_18_5.detectChangesInHostProps(this, this._el_18, throwOnChange);
        this._NgControlStatus_18_7.detectChangesInHostProps(this, this._el_18, throwOnChange);
        this._FormGroupName_29_3.detectChangesInHostProps(this, this._el_29, throwOnChange);
        this._NgControlStatusGroup_29_5.detectChangesInHostProps(this, this._el_29, throwOnChange);
        this._ImageUploadComponent_31_4.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._SelectControlValueAccessor_47_3.detectChangesInHostProps(this, this._el_47, throwOnChange);
        this._FormControlName_47_5.detectChangesInHostProps(this, this._el_47, throwOnChange);
        this._NgControlStatus_47_7.detectChangesInHostProps(this, this._el_47, throwOnChange);
        this._NgSelectOption_49_3.detectChangesInHostProps(this, this._el_49, throwOnChange);
        this._NgSelectMultipleOption_49_4.detectChangesInHostProps(this, this._el_49, throwOnChange);
        this._NgSelectOption_52_3.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._NgSelectMultipleOption_52_4.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._DefaultValueAccessor_62_3.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._FormControlName_62_5.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._NgControlStatus_62_7.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._DefaultValueAccessor_70_3.detectChangesInHostProps(this, this._el_70, throwOnChange);
        this._FormControlName_70_5.detectChangesInHostProps(this, this._el_70, throwOnChange);
        this._NgControlStatus_70_7.detectChangesInHostProps(this, this._el_70, throwOnChange);
        this._DefaultValueAccessor_81_3.detectChangesInHostProps(this, this._el_81, throwOnChange);
        this._FormControlName_81_5.detectChangesInHostProps(this, this._el_81, throwOnChange);
        this._NgControlStatus_81_7.detectChangesInHostProps(this, this._el_81, throwOnChange);
        this._DefaultValueAccessor_89_3.detectChangesInHostProps(this, this._el_89, throwOnChange);
        this._FormControlName_89_5.detectChangesInHostProps(this, this._el_89, throwOnChange);
        this._NgControlStatus_89_7.detectChangesInHostProps(this, this._el_89, throwOnChange);
        this._DefaultValueAccessor_97_3.detectChangesInHostProps(this, this._el_97, throwOnChange);
        this._FormControlName_97_5.detectChangesInHostProps(this, this._el_97, throwOnChange);
        this._NgControlStatus_97_7.detectChangesInHostProps(this, this._el_97, throwOnChange);
        this._FormArrayName_113_3.detectChangesInHostProps(this, this._el_113, throwOnChange);
        this._NgControlStatusGroup_113_5.detectChangesInHostProps(this, this._el_113, throwOnChange);
        this._FormGroupName_125_3.detectChangesInHostProps(this, this._el_125, throwOnChange);
        this._NgControlStatusGroup_125_5.detectChangesInHostProps(this, this._el_125, throwOnChange);
        this._FormArrayName_134_3.detectChangesInHostProps(this, this._el_134, throwOnChange);
        this._NgControlStatusGroup_134_5.detectChangesInHostProps(this, this._el_134, throwOnChange);
        var currVal_241 = this.parent.context.recordForm.invalid;
        if (import5.checkBinding(throwOnChange, this._expr_241, currVal_241)) {
            this.renderer.setElementProperty(this._el_150, 'disabled', currVal_241);
            this._expr_241 = currVal_241;
        }
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._ImageUploadComponent_31_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentRecordEditComponent5.prototype.destroyInternal = function () {
        this._FormControlName_11_5.context.ngOnDestroy();
        this._FormControlName_18_5.context.ngOnDestroy();
        this._NgSelectOption_49_3.context.ngOnDestroy();
        this._NgSelectMultipleOption_49_4.context.ngOnDestroy();
        this._NgSelectOption_52_3.context.ngOnDestroy();
        this._NgSelectMultipleOption_52_4.context.ngOnDestroy();
        this._FormControlName_47_5.context.ngOnDestroy();
        this._FormControlName_62_5.context.ngOnDestroy();
        this._FormControlName_70_5.context.ngOnDestroy();
        this._FormControlName_81_5.context.ngOnDestroy();
        this._FormControlName_89_5.context.ngOnDestroy();
        this._FormControlName_97_5.context.ngOnDestroy();
        this._FormArrayName_113_3.context.ngOnDestroy();
        this._FormArrayName_134_3.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent5.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_0_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_change_11_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = (this._CheckboxControlValueAccessor_11_3.context.onChange($event.target.checked) !== false);
        return (true && pd_11_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_11_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = (this._CheckboxControlValueAccessor_11_3.context.onTouched() !== false);
        return (true && pd_11_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_18_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_18_0 = (this._DefaultValueAccessor_18_3.context.onChange($event.target.value) !== false);
        return (true && pd_18_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_18_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_18_0 = (this._DefaultValueAccessor_18_3.context.onTouched() !== false);
        return (true && pd_18_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_change_47_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_47_0 = (this._SelectControlValueAccessor_47_3.context.onChange($event.target.value) !== false);
        return (true && pd_47_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_47_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_47_0 = (this._SelectControlValueAccessor_47_3.context.onTouched() !== false);
        return (true && pd_47_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_62_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_62_0 = (this._DefaultValueAccessor_62_3.context.onChange($event.target.value) !== false);
        return (true && pd_62_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_62_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_62_0 = (this._DefaultValueAccessor_62_3.context.onTouched() !== false);
        return (true && pd_62_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_70_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_70_0 = (this._DefaultValueAccessor_70_3.context.onChange($event.target.value) !== false);
        return (true && pd_70_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_70_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_70_0 = (this._DefaultValueAccessor_70_3.context.onTouched() !== false);
        return (true && pd_70_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_81_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_81_0 = (this._DefaultValueAccessor_81_3.context.onChange($event.target.value) !== false);
        return (true && pd_81_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_81_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_81_0 = (this._DefaultValueAccessor_81_3.context.onTouched() !== false);
        return (true && pd_81_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_89_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_89_0 = (this._DefaultValueAccessor_89_3.context.onChange($event.target.value) !== false);
        return (true && pd_89_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_89_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_89_0 = (this._DefaultValueAccessor_89_3.context.onTouched() !== false);
        return (true && pd_89_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_click_94_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_94_0 = (this.parent.context.buildUrl() !== false);
        return (true && pd_94_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_ngModelChange_97_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_97_0 = ((this.parent.context.url = $event) !== false);
        return (true && pd_97_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_input_97_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_97_0 = (this._DefaultValueAccessor_97_3.context.onChange($event.target.value) !== false);
        return (true && pd_97_0);
    };
    _View_ContentRecordEditComponent5.prototype._handle_blur_97_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_97_0 = (this._DefaultValueAccessor_97_3.context.onTouched() !== false);
        return (true && pd_97_0);
    };
    return _View_ContentRecordEditComponent5;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent6 = (function (_super) {
    __extends(_View_ContentRecordEditComponent6, _super);
    function _View_ContentRecordEditComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent6, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_3 = new import3.AppElement(3, 0, this, this._anchor_3);
        this._TemplateRef_3_5 = new import25.TemplateRef_(this._appEl_3, viewFactory_ContentRecordEditComponent7);
        this._NgIf_3_6 = new import23.Wrapper_NgIf(this._appEl_3.vcRef, this._TemplateRef_3_5);
        this._text_4 = this.renderer.createText(this._el_0, '\n          ', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_6 = new import3.AppElement(6, 0, this, this._anchor_6);
        this._TemplateRef_6_5 = new import25.TemplateRef_(this._appEl_6, viewFactory_ContentRecordEditComponent8);
        this._NgIf_6_6 = new import23.Wrapper_NgIf(this._appEl_6.vcRef, this._TemplateRef_6_5);
        this._text_7 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._anchor_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7
        ], [], []);
        return null;
    };
    _View_ContentRecordEditComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import27.NgIf) && (3 === requestNodeIndex))) {
            return this._NgIf_3_6.context;
        }
        if (((token === import25.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import27.NgIf) && (6 === requestNodeIndex))) {
            return this._NgIf_6_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = !this.parent.parent.context.special;
        this._NgIf_3_6.check_ngIf(currVal_3_0_0, throwOnChange, false);
        this._NgIf_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        var currVal_6_0_0 = this.parent.parent.context.special;
        this._NgIf_6_6.check_ngIf(currVal_6_0_0, throwOnChange, false);
        this._NgIf_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordEditComponent6;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent7 = (function (_super) {
    __extends(_View_ContentRecordEditComponent7, _super);
    function _View_ContentRecordEditComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent7, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-xs-1 pointer switch'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'i', new import5.InlineArray8(6, 'class', 'glyphicon glyphicon-star-empty', 'style', 'font-size:14pt', 'title', 'special'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent7.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.parent.context.utils.lNavigate('admin/special/edit/0', this.parent.parent.parent.context.currentLanguage, null, { queryParams: { recordUrl: this.parent.parent.parent.context.content.url } }) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent7;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent8 = (function (_super) {
    __extends(_View_ContentRecordEditComponent8, _super);
    function _View_ContentRecordEditComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent8, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-xs-1 pointer switch'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'i', new import5.InlineArray8(6, 'class', 'glyphicon glyphicon-star', 'style', 'font-size:14pt', 'title', 'special'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent8.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.parent.context.utils.lNavigate(('admin/special/edit/' + this.parent.parent.parent.context.special._id), this.parent.parent.parent.context.currentLanguage, null) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent8;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent9 = (function (_super) {
    __extends(_View_ContentRecordEditComponent9, _super);
    function _View_ContentRecordEditComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent9, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray8(6, 'class', 'input-group col-md-4', 'formArrayName', 'original_references', 'style', 'padding-right: 4px'), null);
        this._FormArrayName_0_3 = new import33.Wrapper_FormArrayName(this.parent._ControlContainer_0_4, null, null);
        this._ControlContainer_0_4 = this._FormArrayName_0_3.context;
        this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n              ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_3 = import5.createRenderElement(this.renderer, this._el_2, 'i', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-education'), null);
        this._text_4 = this.renderer.createText(this._el_0, '\n              ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import29.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n              ', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_7, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-remove lLink'), null);
        this._text_9 = this.renderer.createText(this._el_0, '\n              ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_10 = new import3.AppElement(10, 0, this, this._anchor_10);
        this._TemplateRef_10_5 = new import25.TemplateRef_(this._appEl_10, viewFactory_ContentRecordEditComponent10);
        this._NgIf_10_6 = new import23.Wrapper_NgIf(this._appEl_10.vcRef, this._TemplateRef_10_5);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_8, 'click', this.eventHandler(this._handle_click_8_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._el_8,
            this._text_9,
            this._anchor_10,
            this._text_11
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentRecordEditComponent9.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import45.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import42.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import43.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import44.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        if (((token === import25.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import27.NgIf) && (10 === requestNodeIndex))) {
            return this._NgIf_10_6.context;
        }
        if (((token === import47.FormArrayName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._FormArrayName_0_3.context;
        }
        if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent9.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'original_references';
        this._FormArrayName_0_3.check_name(currVal_0_0_0, throwOnChange, false);
        this._FormArrayName_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.index;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_10_0_0 = (this.parent.parent.context.recordForm.controls.original_references.controls.length == (this.context.index + 1));
        this._NgIf_10_6.check_ngIf(currVal_10_0_0, throwOnChange, false);
        this._NgIf_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormArrayName_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordEditComponent9.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
        this._FormArrayName_0_3.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent9.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentRecordEditComponent9.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    _View_ContentRecordEditComponent9.prototype._handle_click_8_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_8_0 = (this.parent.parent.context.onRemoveOriginalReference(this.context.index) !== false);
        return (true && pd_8_0);
    };
    return _View_ContentRecordEditComponent9;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent9(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent10 = (function (_super) {
    __extends(_View_ContentRecordEditComponent10, _super);
    function _View_ContentRecordEditComponent10(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent10, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent10.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_1, 'click', this.eventHandler(this._handle_click_1_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent10.prototype._handle_click_1_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_1_0 = (this.parent.parent.parent.context.onAddOriginalReference() !== false);
        return (true && pd_1_0);
    };
    return _View_ContentRecordEditComponent10;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent10(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent10(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent11 = (function (_super) {
    __extends(_View_ContentRecordEditComponent11, _super);
    function _View_ContentRecordEditComponent11(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent11, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent11.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [this._el_0], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent11.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.onAddOriginalReference() !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent11;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent11(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent11(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent12 = (function (_super) {
    __extends(_View_ContentRecordEditComponent12, _super);
    function _View_ContentRecordEditComponent12(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent12, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_113 = import8.UNINITIALIZED;
        this._expr_114 = import8.UNINITIALIZED;
        this._expr_115 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent12.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group'), null);
        this._FormGroupName_0_3 = new import33.Wrapper_FormGroupName(this.parent._ControlContainer_113_4, null, null);
        this._ControlContainer_0_4 = this._FormGroupName_0_3.context;
        this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'block'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'collapse input-group col-xs-12'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'input', new import5.InlineArray8(8, 'class', 'form-control', 'formControlName', 'title', 'style', 'font-weight:bold', 'type', 'text'), null);
        this._DefaultValueAccessor_6_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_6));
        this._NG_VALUE_ACCESSOR_6_4 = [this._DefaultValueAccessor_6_3.context];
        this._FormControlName_6_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_6_4);
        this._NgControl_6_6 = this._FormControlName_6_5.context;
        this._NgControlStatus_6_7 = new import29.Wrapper_NgControlStatus(this._NgControl_6_6);
        this._text_7 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_4, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_8, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-remove lLink'), null);
        this._text_10 = this.renderer.createText(this._el_4, '\n                ', null);
        this._anchor_11 = this.renderer.createTemplateAnchor(this._el_4, null);
        this._appEl_11 = new import3.AppElement(11, 4, this, this._anchor_11);
        this._TemplateRef_11_5 = new import25.TemplateRef_(this._appEl_11, viewFactory_ContentRecordEditComponent13);
        this._NgIf_11_6 = new import23.Wrapper_NgIf(this._appEl_11.vcRef, this._TemplateRef_11_5);
        this._text_12 = this.renderer.createText(this._el_4, '\n              ', null);
        this._text_13 = this.renderer.createText(this._el_2, '\n          ', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'block form-inline'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n              ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-3'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n                ', null);
        this._el_19 = import5.createRenderElement(this.renderer, this._el_17, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_19, 'i', new import5.InlineArray2(2, 'class', 'fa fa-calendar'), null);
        this._text_21 = this.renderer.createText(this._el_17, '\n                ', null);
        this._el_22 = import5.createRenderElement(this.renderer, this._el_17, 'input', new import5.InlineArray8(6, 'class', 'form-control date-mask', 'formControlName', 'date', 'type', 'text'), null);
        this._DefaultValueAccessor_22_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_22));
        this._NG_VALUE_ACCESSOR_22_4 = [this._DefaultValueAccessor_22_3.context];
        this._FormControlName_22_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_22_4);
        this._NgControl_22_6 = this._FormControlName_22_5.context;
        this._NgControlStatus_22_7 = new import29.Wrapper_NgControlStatus(this._NgControl_22_6);
        this._text_23 = this.renderer.createText(this._el_17, '\n              ', null);
        this._text_24 = this.renderer.createText(this._el_15, '\n              ', null);
        this._el_25 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                ', null);
        this._el_27 = import5.createRenderElement(this.renderer, this._el_25, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_28 = this.renderer.createText(this._el_27, 'C', null);
        this._text_29 = this.renderer.createText(this._el_25, '\n                ', null);
        this._text_30 = this.renderer.createText(this._el_25, '\n                ', null);
        this._el_31 = import5.createRenderElement(this.renderer, this._el_25, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'composer', 'type', 'text'), null);
        this._DefaultValueAccessor_31_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_31));
        this._NG_VALUE_ACCESSOR_31_4 = [this._DefaultValueAccessor_31_3.context];
        this._FormControlName_31_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_31_4);
        this._NgControl_31_6 = this._FormControlName_31_5.context;
        this._NgControlStatus_31_7 = new import29.Wrapper_NgControlStatus(this._NgControl_31_6);
        this._text_32 = this.renderer.createText(this._el_25, '\n                 ', null);
        this._el_33 = import5.createRenderElement(this.renderer, this._el_25, 'search-autocomplete', new import5.InlineArray2(2, 'esType', 'composer'), null);
        this._appEl_33 = new import3.AppElement(33, 25, this, this._el_33);
        var compView_33 = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(33), this._appEl_33);
        this._SearchAutocompleteComponent_33_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_33), this.parent.parent.parentInjector.get(import14.SearchService), this.parent.parent.parentInjector.get(import15.UtilsService));
        this._appEl_33.initComponent(this._SearchAutocompleteComponent_33_4.context, [], compView_33);
        this._text_34 = this.renderer.createText(null, '\n                ', null);
        compView_33.create(this._SearchAutocompleteComponent_33_4.context, [], null);
        this._text_35 = this.renderer.createText(this._el_25, ' \n              ', null);
        this._text_36 = this.renderer.createText(this._el_15, '\n              ', null);
        this._el_37 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-4'), null);
        this._text_38 = this.renderer.createText(this._el_37, '\n                ', null);
        this._el_39 = import5.createRenderElement(this.renderer, this._el_37, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_40 = this.renderer.createText(this._el_39, 'C.O', null);
        this._text_41 = this.renderer.createText(this._el_37, '\n                ', null);
        this._el_42 = import5.createRenderElement(this.renderer, this._el_37, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'conductor', 'type', 'text'), null);
        this._DefaultValueAccessor_42_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_42));
        this._NG_VALUE_ACCESSOR_42_4 = [this._DefaultValueAccessor_42_3.context];
        this._FormControlName_42_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_42_4);
        this._NgControl_42_6 = this._FormControlName_42_5.context;
        this._NgControlStatus_42_7 = new import29.Wrapper_NgControlStatus(this._NgControl_42_6);
        this._text_43 = this.renderer.createText(this._el_37, '\n                 ', null);
        this._el_44 = import5.createRenderElement(this.renderer, this._el_37, 'search-autocomplete', new import5.InlineArray2(2, 'esType', 'conductor'), null);
        this._appEl_44 = new import3.AppElement(44, 37, this, this._el_44);
        var compView_44 = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(44), this._appEl_44);
        this._SearchAutocompleteComponent_44_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_44), this.parent.parent.parentInjector.get(import14.SearchService), this.parent.parent.parentInjector.get(import15.UtilsService));
        this._appEl_44.initComponent(this._SearchAutocompleteComponent_44_4.context, [], compView_44);
        this._text_45 = this.renderer.createText(null, '\n                ', null);
        compView_44.create(this._SearchAutocompleteComponent_44_4.context, [], null);
        this._text_46 = this.renderer.createText(this._el_37, ' \n              ', null);
        this._text_47 = this.renderer.createText(this._el_15, '\n          ', null);
        this._text_48 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_50 = this.renderer.createText(this._el_49, '\n              ', null);
        this._el_51 = import5.createRenderElement(this.renderer, this._el_49, 'div', new import5.InlineArray4(4, 'class', 'col-md-6 input-group', 'style', 'padding-right: 3px'), null);
        this._text_52 = this.renderer.createText(this._el_51, '\n                ', null);
        this._el_53 = import5.createRenderElement(this.renderer, this._el_51, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_54 = this.renderer.createText(this._el_53, 'O', null);
        this._text_55 = this.renderer.createText(this._el_51, '\n                ', null);
        this._el_56 = import5.createRenderElement(this.renderer, this._el_51, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'orchestra', 'type', 'text'), null);
        this._DefaultValueAccessor_56_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_56));
        this._NG_VALUE_ACCESSOR_56_4 = [this._DefaultValueAccessor_56_3.context];
        this._FormControlName_56_5 = new import31.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_56_4);
        this._NgControl_56_6 = this._FormControlName_56_5.context;
        this._NgControlStatus_56_7 = new import29.Wrapper_NgControlStatus(this._NgControl_56_6);
        this._text_57 = this.renderer.createText(this._el_51, '\n                 ', null);
        this._el_58 = import5.createRenderElement(this.renderer, this._el_51, 'search-autocomplete', new import5.InlineArray2(2, 'esType', 'orchestra'), null);
        this._appEl_58 = new import3.AppElement(58, 51, this, this._el_58);
        var compView_58 = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(58), this._appEl_58);
        this._SearchAutocompleteComponent_58_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_58), this.parent.parent.parentInjector.get(import14.SearchService), this.parent.parent.parentInjector.get(import15.UtilsService));
        this._appEl_58.initComponent(this._SearchAutocompleteComponent_58_4.context, [], compView_58);
        this._text_59 = this.renderer.createText(null, '\n                ', null);
        compView_58.create(this._SearchAutocompleteComponent_58_4.context, [], null);
        this._text_60 = this.renderer.createText(this._el_51, ' \n              ', null);
        this._text_61 = this.renderer.createText(this._el_49, '\n          ', null);
        this._text_62 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_63 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_64 = this.renderer.createText(this._el_63, '\n              ', null);
        this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63, null);
        this._appEl_65 = new import3.AppElement(65, 63, this, this._anchor_65);
        this._TemplateRef_65_5 = new import25.TemplateRef_(this._appEl_65, viewFactory_ContentRecordEditComponent14);
        this._NgFor_65_6 = new import37.Wrapper_NgFor(this._appEl_65.vcRef, this._TemplateRef_65_5, this.parent.parent.parentInjector.get(import39.IterableDiffers), this.parent.parent.ref);
        this._text_66 = this.renderer.createText(this._el_63, '\n              ', null);
        this._anchor_67 = this.renderer.createTemplateAnchor(this._el_63, null);
        this._appEl_67 = new import3.AppElement(67, 63, this, this._anchor_67);
        this._TemplateRef_67_5 = new import25.TemplateRef_(this._appEl_67, viewFactory_ContentRecordEditComponent16);
        this._NgIf_67_6 = new import23.Wrapper_NgIf(this._appEl_67.vcRef, this._TemplateRef_67_5);
        this._text_68 = this.renderer.createText(this._el_63, '\n          ', null);
        this._text_69 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'input', this.eventHandler(this._handle_input_6_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_6, 'blur', this.eventHandler(this._handle_blur_6_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_9, 'click', this.eventHandler(this._handle_click_9_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_22, 'input', this.eventHandler(this._handle_input_22_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_22, 'blur', this.eventHandler(this._handle_blur_22_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_31, 'keyup', this.eventHandler(this._handle_keyup_31_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_31, 'input', this.eventHandler(this._handle_input_31_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_31, 'blur', this.eventHandler(this._handle_blur_31_2.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_42, 'keyup', this.eventHandler(this._handle_keyup_42_0.bind(this)));
        var disposable_9 = this.renderer.listen(this._el_42, 'input', this.eventHandler(this._handle_input_42_1.bind(this)));
        var disposable_10 = this.renderer.listen(this._el_42, 'blur', this.eventHandler(this._handle_blur_42_2.bind(this)));
        var disposable_11 = this.renderer.listen(this._el_56, 'keyup', this.eventHandler(this._handle_keyup_56_0.bind(this)));
        var disposable_12 = this.renderer.listen(this._el_56, 'input', this.eventHandler(this._handle_input_56_1.bind(this)));
        var disposable_13 = this.renderer.listen(this._el_56, 'blur', this.eventHandler(this._handle_blur_56_2.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._el_9,
            this._text_10,
            this._anchor_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._el_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._el_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._text_41,
            this._el_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._text_46,
            this._text_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._el_51,
            this._text_52,
            this._el_53,
            this._text_54,
            this._text_55,
            this._el_56,
            this._text_57,
            this._el_58,
            this._text_59,
            this._text_60,
            this._text_61,
            this._text_62,
            this._el_63,
            this._text_64,
            this._anchor_65,
            this._text_66,
            this._anchor_67,
            this._text_68,
            this._text_69
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8,
            disposable_9,
            disposable_10,
            disposable_11,
            disposable_12,
            disposable_13
        ], []);
        return null;
    };
    _View_ContentRecordEditComponent12.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import45.DefaultValueAccessor) && (6 === requestNodeIndex))) {
            return this._DefaultValueAccessor_6_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_6_4;
        }
        if (((token === import42.FormControlName) && (6 === requestNodeIndex))) {
            return this._FormControlName_6_5.context;
        }
        if (((token === import43.NgControl) && (6 === requestNodeIndex))) {
            return this._NgControl_6_6;
        }
        if (((token === import44.NgControlStatus) && (6 === requestNodeIndex))) {
            return this._NgControlStatus_6_7.context;
        }
        if (((token === import25.TemplateRef) && (11 === requestNodeIndex))) {
            return this._TemplateRef_11_5;
        }
        if (((token === import27.NgIf) && (11 === requestNodeIndex))) {
            return this._NgIf_11_6.context;
        }
        if (((token === import45.DefaultValueAccessor) && (22 === requestNodeIndex))) {
            return this._DefaultValueAccessor_22_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (22 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_22_4;
        }
        if (((token === import42.FormControlName) && (22 === requestNodeIndex))) {
            return this._FormControlName_22_5.context;
        }
        if (((token === import43.NgControl) && (22 === requestNodeIndex))) {
            return this._NgControl_22_6;
        }
        if (((token === import44.NgControlStatus) && (22 === requestNodeIndex))) {
            return this._NgControlStatus_22_7.context;
        }
        if (((token === import45.DefaultValueAccessor) && (31 === requestNodeIndex))) {
            return this._DefaultValueAccessor_31_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (31 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_31_4;
        }
        if (((token === import42.FormControlName) && (31 === requestNodeIndex))) {
            return this._FormControlName_31_5.context;
        }
        if (((token === import43.NgControl) && (31 === requestNodeIndex))) {
            return this._NgControl_31_6;
        }
        if (((token === import44.NgControlStatus) && (31 === requestNodeIndex))) {
            return this._NgControlStatus_31_7.context;
        }
        if (((token === import54.SearchAutocompleteComponent) && ((33 <= requestNodeIndex) && (requestNodeIndex <= 34)))) {
            return this._SearchAutocompleteComponent_33_4.context;
        }
        if (((token === import45.DefaultValueAccessor) && (42 === requestNodeIndex))) {
            return this._DefaultValueAccessor_42_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (42 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_42_4;
        }
        if (((token === import42.FormControlName) && (42 === requestNodeIndex))) {
            return this._FormControlName_42_5.context;
        }
        if (((token === import43.NgControl) && (42 === requestNodeIndex))) {
            return this._NgControl_42_6;
        }
        if (((token === import44.NgControlStatus) && (42 === requestNodeIndex))) {
            return this._NgControlStatus_42_7.context;
        }
        if (((token === import54.SearchAutocompleteComponent) && ((44 <= requestNodeIndex) && (requestNodeIndex <= 45)))) {
            return this._SearchAutocompleteComponent_44_4.context;
        }
        if (((token === import45.DefaultValueAccessor) && (56 === requestNodeIndex))) {
            return this._DefaultValueAccessor_56_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (56 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_56_4;
        }
        if (((token === import42.FormControlName) && (56 === requestNodeIndex))) {
            return this._FormControlName_56_5.context;
        }
        if (((token === import43.NgControl) && (56 === requestNodeIndex))) {
            return this._NgControl_56_6;
        }
        if (((token === import44.NgControlStatus) && (56 === requestNodeIndex))) {
            return this._NgControlStatus_56_7.context;
        }
        if (((token === import54.SearchAutocompleteComponent) && ((58 <= requestNodeIndex) && (requestNodeIndex <= 59)))) {
            return this._SearchAutocompleteComponent_58_4.context;
        }
        if (((token === import25.TemplateRef) && (65 === requestNodeIndex))) {
            return this._TemplateRef_65_5;
        }
        if (((token === import51.NgFor) && (65 === requestNodeIndex))) {
            return this._NgFor_65_6.context;
        }
        if (((token === import25.TemplateRef) && (67 === requestNodeIndex))) {
            return this._TemplateRef_67_5;
        }
        if (((token === import27.NgIf) && (67 === requestNodeIndex))) {
            return this._NgIf_67_6.context;
        }
        if (((token === import47.FormGroupName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._FormGroupName_0_3.context;
        }
        if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 69)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent12.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.index;
        this._FormGroupName_0_3.check_name(currVal_0_0_0, throwOnChange, false);
        this._FormGroupName_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_6_1_0 = 'title';
        this._FormControlName_6_5.check_name(currVal_6_1_0, throwOnChange, false);
        this._FormControlName_6_5.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_11_0_0 = (this.parent.parent.context.recordForm.get('music_pieces').controls.length == (this.context.index + 1));
        this._NgIf_11_6.check_ngIf(currVal_11_0_0, throwOnChange, false);
        this._NgIf_11_6.detectChangesInInputProps(this, this._anchor_11, throwOnChange);
        this._DefaultValueAccessor_22_3.detectChangesInInputProps(this, this._el_22, throwOnChange);
        var currVal_22_1_0 = 'date';
        this._FormControlName_22_5.check_name(currVal_22_1_0, throwOnChange, false);
        this._FormControlName_22_5.detectChangesInInputProps(this, this._el_22, throwOnChange);
        this._NgControlStatus_22_7.detectChangesInInputProps(this, this._el_22, throwOnChange);
        this._DefaultValueAccessor_31_3.detectChangesInInputProps(this, this._el_31, throwOnChange);
        var currVal_31_1_0 = 'composer';
        this._FormControlName_31_5.check_name(currVal_31_1_0, throwOnChange, false);
        this._FormControlName_31_5.detectChangesInInputProps(this, this._el_31, throwOnChange);
        this._NgControlStatus_31_7.detectChangesInInputProps(this, this._el_31, throwOnChange);
        var currVal_33_0_0 = this.parent.parent.context.recordForm;
        this._SearchAutocompleteComponent_33_4.check_form(currVal_33_0_0, throwOnChange, false);
        var currVal_33_0_1 = import5.interpolate(1, 'music_pieces.', this.context.index, '.composer');
        this._SearchAutocompleteComponent_33_4.check_formPath(currVal_33_0_1, throwOnChange, false);
        var currVal_33_0_2 = import5.interpolate(1, 'composer', this.context.index, '');
        this._SearchAutocompleteComponent_33_4.check_target(currVal_33_0_2, throwOnChange, false);
        var currVal_33_0_3 = this.parent.parent.context.inputFocus;
        this._SearchAutocompleteComponent_33_4.check_input(currVal_33_0_3, throwOnChange, false);
        var currVal_33_0_4 = 'composer';
        this._SearchAutocompleteComponent_33_4.check_esType(currVal_33_0_4, throwOnChange, false);
        this._SearchAutocompleteComponent_33_4.detectChangesInInputProps(this, this._el_33, throwOnChange);
        this._DefaultValueAccessor_42_3.detectChangesInInputProps(this, this._el_42, throwOnChange);
        var currVal_42_1_0 = 'conductor';
        this._FormControlName_42_5.check_name(currVal_42_1_0, throwOnChange, false);
        this._FormControlName_42_5.detectChangesInInputProps(this, this._el_42, throwOnChange);
        this._NgControlStatus_42_7.detectChangesInInputProps(this, this._el_42, throwOnChange);
        var currVal_44_0_0 = this.parent.parent.context.recordForm;
        this._SearchAutocompleteComponent_44_4.check_form(currVal_44_0_0, throwOnChange, false);
        var currVal_44_0_1 = import5.interpolate(1, 'music_pieces.', this.context.index, '.conductor');
        this._SearchAutocompleteComponent_44_4.check_formPath(currVal_44_0_1, throwOnChange, false);
        var currVal_44_0_2 = import5.interpolate(1, 'conductor', this.context.index, '');
        this._SearchAutocompleteComponent_44_4.check_target(currVal_44_0_2, throwOnChange, false);
        var currVal_44_0_3 = this.parent.parent.context.inputFocus;
        this._SearchAutocompleteComponent_44_4.check_input(currVal_44_0_3, throwOnChange, false);
        var currVal_44_0_4 = 'conductor';
        this._SearchAutocompleteComponent_44_4.check_esType(currVal_44_0_4, throwOnChange, false);
        this._SearchAutocompleteComponent_44_4.detectChangesInInputProps(this, this._el_44, throwOnChange);
        this._DefaultValueAccessor_56_3.detectChangesInInputProps(this, this._el_56, throwOnChange);
        var currVal_56_1_0 = 'orchestra';
        this._FormControlName_56_5.check_name(currVal_56_1_0, throwOnChange, false);
        this._FormControlName_56_5.detectChangesInInputProps(this, this._el_56, throwOnChange);
        this._NgControlStatus_56_7.detectChangesInInputProps(this, this._el_56, throwOnChange);
        var currVal_58_0_0 = this.parent.parent.context.recordForm;
        this._SearchAutocompleteComponent_58_4.check_form(currVal_58_0_0, throwOnChange, false);
        var currVal_58_0_1 = import5.interpolate(1, 'music_pieces.', this.context.index, '.orchestra');
        this._SearchAutocompleteComponent_58_4.check_formPath(currVal_58_0_1, throwOnChange, false);
        var currVal_58_0_2 = import5.interpolate(1, 'orchestra', this.context.index, '');
        this._SearchAutocompleteComponent_58_4.check_target(currVal_58_0_2, throwOnChange, false);
        var currVal_58_0_3 = this.parent.parent.context.inputFocus;
        this._SearchAutocompleteComponent_58_4.check_input(currVal_58_0_3, throwOnChange, false);
        var currVal_58_0_4 = 'orchestra';
        this._SearchAutocompleteComponent_58_4.check_esType(currVal_58_0_4, throwOnChange, false);
        this._SearchAutocompleteComponent_58_4.detectChangesInInputProps(this, this._el_58, throwOnChange);
        var currVal_65_0_0 = this.parent.parent.context.recordForm.get('music_pieces').at(this.context.index).get('soloists').controls;
        this._NgFor_65_6.check_ngForOf(currVal_65_0_0, throwOnChange, false);
        this._NgFor_65_6.detectChangesInInputProps(this, this._anchor_65, throwOnChange);
        var currVal_67_0_0 = (this.parent.parent.context.recordForm.get('music_pieces').at(this.context.index).get('soloists').controls == 0);
        this._NgIf_67_6.check_ngIf(currVal_67_0_0, throwOnChange, false);
        this._NgIf_67_6.detectChangesInInputProps(this, this._anchor_67, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupName_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._FormControlName_6_5.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._DefaultValueAccessor_22_3.detectChangesInHostProps(this, this._el_22, throwOnChange);
        this._FormControlName_22_5.detectChangesInHostProps(this, this._el_22, throwOnChange);
        this._NgControlStatus_22_7.detectChangesInHostProps(this, this._el_22, throwOnChange);
        var currVal_113 = import5.interpolate(1, 'composer', this.context.index, '');
        if (import5.checkBinding(throwOnChange, this._expr_113, currVal_113)) {
            this.renderer.setElementProperty(this._el_31, 'id', currVal_113);
            this._expr_113 = currVal_113;
        }
        this._DefaultValueAccessor_31_3.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._FormControlName_31_5.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._NgControlStatus_31_7.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._SearchAutocompleteComponent_33_4.detectChangesInHostProps(this, this._el_33, throwOnChange);
        var currVal_114 = import5.interpolate(1, 'conductor', this.context.index, '');
        if (import5.checkBinding(throwOnChange, this._expr_114, currVal_114)) {
            this.renderer.setElementProperty(this._el_42, 'id', currVal_114);
            this._expr_114 = currVal_114;
        }
        this._DefaultValueAccessor_42_3.detectChangesInHostProps(this, this._el_42, throwOnChange);
        this._FormControlName_42_5.detectChangesInHostProps(this, this._el_42, throwOnChange);
        this._NgControlStatus_42_7.detectChangesInHostProps(this, this._el_42, throwOnChange);
        this._SearchAutocompleteComponent_44_4.detectChangesInHostProps(this, this._el_44, throwOnChange);
        var currVal_115 = import5.interpolate(1, 'orchestra', this.context.index, '');
        if (import5.checkBinding(throwOnChange, this._expr_115, currVal_115)) {
            this.renderer.setElementProperty(this._el_56, 'id', currVal_115);
            this._expr_115 = currVal_115;
        }
        this._DefaultValueAccessor_56_3.detectChangesInHostProps(this, this._el_56, throwOnChange);
        this._FormControlName_56_5.detectChangesInHostProps(this, this._el_56, throwOnChange);
        this._NgControlStatus_56_7.detectChangesInHostProps(this, this._el_56, throwOnChange);
        this._SearchAutocompleteComponent_58_4.detectChangesInHostProps(this, this._el_58, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordEditComponent12.prototype.destroyInternal = function () {
        this._FormControlName_6_5.context.ngOnDestroy();
        this._FormControlName_22_5.context.ngOnDestroy();
        this._FormControlName_31_5.context.ngOnDestroy();
        this._FormControlName_42_5.context.ngOnDestroy();
        this._FormControlName_56_5.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent12.prototype._handle_input_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._DefaultValueAccessor_6_3.context.onChange($event.target.value) !== false);
        return (true && pd_6_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_blur_6_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._DefaultValueAccessor_6_3.context.onTouched() !== false);
        return (true && pd_6_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_click_9_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_9_0 = (this.parent.parent.context.onRemoveMusicPiece(this.context.index) !== false);
        return (true && pd_9_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_input_22_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_22_0 = (this._DefaultValueAccessor_22_3.context.onChange($event.target.value) !== false);
        return (true && pd_22_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_blur_22_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_22_0 = (this._DefaultValueAccessor_22_3.context.onTouched() !== false);
        return (true && pd_22_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_keyup_31_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = (this.parent.parent.context.onInputChange('composer', $event) !== false);
        return (true && pd_31_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_input_31_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = (this._DefaultValueAccessor_31_3.context.onChange($event.target.value) !== false);
        return (true && pd_31_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_blur_31_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = (this._DefaultValueAccessor_31_3.context.onTouched() !== false);
        return (true && pd_31_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_keyup_42_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_42_0 = (this.parent.parent.context.onInputChange('conductor', $event) !== false);
        return (true && pd_42_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_input_42_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_42_0 = (this._DefaultValueAccessor_42_3.context.onChange($event.target.value) !== false);
        return (true && pd_42_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_blur_42_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_42_0 = (this._DefaultValueAccessor_42_3.context.onTouched() !== false);
        return (true && pd_42_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_keyup_56_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_56_0 = (this.parent.parent.context.onInputChange('orchestra', $event) !== false);
        return (true && pd_56_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_input_56_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_56_0 = (this._DefaultValueAccessor_56_3.context.onChange($event.target.value) !== false);
        return (true && pd_56_0);
    };
    _View_ContentRecordEditComponent12.prototype._handle_blur_56_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_56_0 = (this._DefaultValueAccessor_56_3.context.onTouched() !== false);
        return (true && pd_56_0);
    };
    return _View_ContentRecordEditComponent12;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent12(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent12(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent13 = (function (_super) {
    __extends(_View_ContentRecordEditComponent13, _super);
    function _View_ContentRecordEditComponent13(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent13, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent13.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_1, 'click', this.eventHandler(this._handle_click_1_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent13.prototype._handle_click_1_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_1_0 = (this.parent.parent.parent.context.onAddMusicPiece() !== false);
        return (true && pd_1_0);
    };
    return _View_ContentRecordEditComponent13;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent13(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent13(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent14 = (function (_super) {
    __extends(_View_ContentRecordEditComponent14, _super);
    function _View_ContentRecordEditComponent14(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent14, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_55 = import8.UNINITIALIZED;
        this._expr_56 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent14.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'formArrayName', 'soloists'), null);
        this._FormArrayName_0_3 = new import33.Wrapper_FormArrayName(this.parent._ControlContainer_0_4, null, null);
        this._ControlContainer_0_4 = this._FormArrayName_0_3.context;
        this._NgControlStatusGroup_0_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._FormGroupName_2_3 = new import33.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_2_4 = this._FormGroupName_2_3.context;
        this._NgControlStatusGroup_2_5 = new import29.Wrapper_NgControlStatusGroup(this._ControlContainer_2_4);
        this._text_3 = this.renderer.createText(this._el_2, '\n                  ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-5'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_7 = this.renderer.createText(this._el_6, 'S', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_4, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'name', 'type', 'text'), null);
        this._DefaultValueAccessor_9_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_9));
        this._NG_VALUE_ACCESSOR_9_4 = [this._DefaultValueAccessor_9_3.context];
        this._FormControlName_9_5 = new import31.Wrapper_FormControlName(this._ControlContainer_2_4, null, null, this._NG_VALUE_ACCESSOR_9_4);
        this._NgControl_9_6 = this._FormControlName_9_5.context;
        this._NgControlStatus_9_7 = new import29.Wrapper_NgControlStatus(this._NgControl_9_6);
        this._text_10 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_4, 'search-autocomplete', new import5.InlineArray2(2, 'esType', 'soloist'), null);
        this._appEl_11 = new import3.AppElement(11, 4, this, this._el_11);
        var compView_11 = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(11), this._appEl_11);
        this._SearchAutocompleteComponent_11_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_11), this.parent.parent.parent.parentInjector.get(import14.SearchService), this.parent.parent.parent.parentInjector.get(import15.UtilsService));
        this._appEl_11.initComponent(this._SearchAutocompleteComponent_11_4.context, [], compView_11);
        this._text_12 = this.renderer.createText(null, '\n                    ', null);
        compView_11.create(this._SearchAutocompleteComponent_11_4.context, [], null);
        this._text_13 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n                  ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'input-group col-md-6'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                    ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_18 = this.renderer.createText(this._el_17, 'I', null);
        this._text_19 = this.renderer.createText(this._el_15, '\n                    ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_15, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'instrument', 'type', 'text'), null);
        this._DefaultValueAccessor_20_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_20));
        this._NG_VALUE_ACCESSOR_20_4 = [this._DefaultValueAccessor_20_3.context];
        this._FormControlName_20_5 = new import31.Wrapper_FormControlName(this._ControlContainer_2_4, null, null, this._NG_VALUE_ACCESSOR_20_4);
        this._NgControl_20_6 = this._FormControlName_20_5.context;
        this._NgControlStatus_20_7 = new import29.Wrapper_NgControlStatus(this._NgControl_20_6);
        this._text_21 = this.renderer.createText(this._el_15, '\n                    ', null);
        this._el_22 = import5.createRenderElement(this.renderer, this._el_15, 'search-autocomplete', new import5.InlineArray2(2, 'esType', 'instrument'), null);
        this._appEl_22 = new import3.AppElement(22, 15, this, this._el_22);
        var compView_22 = import53.viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(22), this._appEl_22);
        this._SearchAutocompleteComponent_22_4 = new import53.Wrapper_SearchAutocompleteComponent(new import13.ElementRef(this._el_22), this.parent.parent.parent.parentInjector.get(import14.SearchService), this.parent.parent.parent.parentInjector.get(import15.UtilsService));
        this._appEl_22.initComponent(this._SearchAutocompleteComponent_22_4.context, [], compView_22);
        this._text_23 = this.renderer.createText(null, '\n                    ', null);
        compView_22.create(this._SearchAutocompleteComponent_22_4.context, [], null);
        this._text_24 = this.renderer.createText(this._el_15, '\n                    ', null);
        this._el_25 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_26 = import5.createRenderElement(this.renderer, this._el_25, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-remove lLink'), null);
        this._text_27 = this.renderer.createText(this._el_15, '\n                    ', null);
        this._anchor_28 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_28 = new import3.AppElement(28, 15, this, this._anchor_28);
        this._TemplateRef_28_5 = new import25.TemplateRef_(this._appEl_28, viewFactory_ContentRecordEditComponent15);
        this._NgIf_28_6 = new import23.Wrapper_NgIf(this._appEl_28.vcRef, this._TemplateRef_28_5);
        this._text_29 = this.renderer.createText(this._el_15, '\n                  ', null);
        this._text_30 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_31 = this.renderer.createText(this._el_0, '\n              ', null);
        var disposable_0 = this.renderer.listen(this._el_9, 'keyup', this.eventHandler(this._handle_keyup_9_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_9, 'input', this.eventHandler(this._handle_input_9_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_9, 'blur', this.eventHandler(this._handle_blur_9_2.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_20, 'keyup', this.eventHandler(this._handle_keyup_20_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_20, 'input', this.eventHandler(this._handle_input_20_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_20, 'blur', this.eventHandler(this._handle_blur_20_2.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_26, 'click', this.eventHandler(this._handle_click_26_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._el_26,
            this._text_27,
            this._anchor_28,
            this._text_29,
            this._text_30,
            this._text_31
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6
        ], []);
        return null;
    };
    _View_ContentRecordEditComponent14.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import45.DefaultValueAccessor) && (9 === requestNodeIndex))) {
            return this._DefaultValueAccessor_9_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (9 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_9_4;
        }
        if (((token === import42.FormControlName) && (9 === requestNodeIndex))) {
            return this._FormControlName_9_5.context;
        }
        if (((token === import43.NgControl) && (9 === requestNodeIndex))) {
            return this._NgControl_9_6;
        }
        if (((token === import44.NgControlStatus) && (9 === requestNodeIndex))) {
            return this._NgControlStatus_9_7.context;
        }
        if (((token === import54.SearchAutocompleteComponent) && ((11 <= requestNodeIndex) && (requestNodeIndex <= 12)))) {
            return this._SearchAutocompleteComponent_11_4.context;
        }
        if (((token === import45.DefaultValueAccessor) && (20 === requestNodeIndex))) {
            return this._DefaultValueAccessor_20_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (20 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_20_4;
        }
        if (((token === import42.FormControlName) && (20 === requestNodeIndex))) {
            return this._FormControlName_20_5.context;
        }
        if (((token === import43.NgControl) && (20 === requestNodeIndex))) {
            return this._NgControl_20_6;
        }
        if (((token === import44.NgControlStatus) && (20 === requestNodeIndex))) {
            return this._NgControlStatus_20_7.context;
        }
        if (((token === import54.SearchAutocompleteComponent) && ((22 <= requestNodeIndex) && (requestNodeIndex <= 23)))) {
            return this._SearchAutocompleteComponent_22_4.context;
        }
        if (((token === import25.TemplateRef) && (28 === requestNodeIndex))) {
            return this._TemplateRef_28_5;
        }
        if (((token === import27.NgIf) && (28 === requestNodeIndex))) {
            return this._NgIf_28_6.context;
        }
        if (((token === import47.FormGroupName) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._FormGroupName_2_3.context;
        }
        if (((token === import48.ControlContainer) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._ControlContainer_2_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._NgControlStatusGroup_2_5.context;
        }
        if (((token === import47.FormArrayName) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) {
            return this._FormArrayName_0_3.context;
        }
        if (((token === import48.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import44.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 31)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent14.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'soloists';
        this._FormArrayName_0_3.check_name(currVal_0_0_0, throwOnChange, false);
        this._FormArrayName_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = this.context.index;
        this._FormGroupName_2_3.check_name(currVal_2_0_0, throwOnChange, false);
        this._FormGroupName_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this._NgControlStatusGroup_2_5.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this._DefaultValueAccessor_9_3.detectChangesInInputProps(this, this._el_9, throwOnChange);
        var currVal_9_1_0 = 'name';
        this._FormControlName_9_5.check_name(currVal_9_1_0, throwOnChange, false);
        this._FormControlName_9_5.detectChangesInInputProps(this, this._el_9, throwOnChange);
        this._NgControlStatus_9_7.detectChangesInInputProps(this, this._el_9, throwOnChange);
        var currVal_11_0_0 = this.parent.parent.parent.context.recordForm;
        this._SearchAutocompleteComponent_11_4.check_form(currVal_11_0_0, throwOnChange, false);
        var currVal_11_0_1 = import5.interpolate(2, 'music_pieces.', this.parent.context.index, '.soloists.', this.context.index, '.name');
        this._SearchAutocompleteComponent_11_4.check_formPath(currVal_11_0_1, throwOnChange, false);
        var currVal_11_0_2 = import5.interpolate(2, 'soloist', this.parent.context.index, '', this.context.index, '');
        this._SearchAutocompleteComponent_11_4.check_target(currVal_11_0_2, throwOnChange, false);
        var currVal_11_0_3 = this.parent.parent.parent.context.inputFocus;
        this._SearchAutocompleteComponent_11_4.check_input(currVal_11_0_3, throwOnChange, false);
        var currVal_11_0_4 = 'soloist';
        this._SearchAutocompleteComponent_11_4.check_esType(currVal_11_0_4, throwOnChange, false);
        this._SearchAutocompleteComponent_11_4.detectChangesInInputProps(this, this._el_11, throwOnChange);
        this._DefaultValueAccessor_20_3.detectChangesInInputProps(this, this._el_20, throwOnChange);
        var currVal_20_1_0 = 'instrument';
        this._FormControlName_20_5.check_name(currVal_20_1_0, throwOnChange, false);
        this._FormControlName_20_5.detectChangesInInputProps(this, this._el_20, throwOnChange);
        this._NgControlStatus_20_7.detectChangesInInputProps(this, this._el_20, throwOnChange);
        var currVal_22_0_0 = this.parent.parent.parent.context.recordForm;
        this._SearchAutocompleteComponent_22_4.check_form(currVal_22_0_0, throwOnChange, false);
        var currVal_22_0_1 = import5.interpolate(2, 'music_pieces.', this.parent.context.index, '.soloists.', this.context.index, '.instrument');
        this._SearchAutocompleteComponent_22_4.check_formPath(currVal_22_0_1, throwOnChange, false);
        var currVal_22_0_2 = import5.interpolate(2, 'instrument', this.parent.context.index, '', this.context.index, '');
        this._SearchAutocompleteComponent_22_4.check_target(currVal_22_0_2, throwOnChange, false);
        var currVal_22_0_3 = this.parent.parent.parent.context.inputFocus;
        this._SearchAutocompleteComponent_22_4.check_input(currVal_22_0_3, throwOnChange, false);
        var currVal_22_0_4 = 'instrument';
        this._SearchAutocompleteComponent_22_4.check_esType(currVal_22_0_4, throwOnChange, false);
        this._SearchAutocompleteComponent_22_4.detectChangesInInputProps(this, this._el_22, throwOnChange);
        var currVal_28_0_0 = (this.context.index == (this.parent.parent.parent.context.recordForm.get('music_pieces').at(this.parent.context.index).get('soloists').controls.length - 1));
        this._NgIf_28_6.check_ngIf(currVal_28_0_0, throwOnChange, false);
        this._NgIf_28_6.detectChangesInInputProps(this, this._anchor_28, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormArrayName_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._FormGroupName_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgControlStatusGroup_2_5.detectChangesInHostProps(this, this._el_2, throwOnChange);
        var currVal_55 = import5.interpolate(2, 'soloist', this.parent.context.index, '', this.context.index, '');
        if (import5.checkBinding(throwOnChange, this._expr_55, currVal_55)) {
            this.renderer.setElementProperty(this._el_9, 'id', currVal_55);
            this._expr_55 = currVal_55;
        }
        this._DefaultValueAccessor_9_3.detectChangesInHostProps(this, this._el_9, throwOnChange);
        this._FormControlName_9_5.detectChangesInHostProps(this, this._el_9, throwOnChange);
        this._NgControlStatus_9_7.detectChangesInHostProps(this, this._el_9, throwOnChange);
        this._SearchAutocompleteComponent_11_4.detectChangesInHostProps(this, this._el_11, throwOnChange);
        var currVal_56 = import5.interpolate(2, 'instrument', this.parent.context.index, '', this.context.index, '');
        if (import5.checkBinding(throwOnChange, this._expr_56, currVal_56)) {
            this.renderer.setElementProperty(this._el_20, 'id', currVal_56);
            this._expr_56 = currVal_56;
        }
        this._DefaultValueAccessor_20_3.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._FormControlName_20_5.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._NgControlStatus_20_7.detectChangesInHostProps(this, this._el_20, throwOnChange);
        this._SearchAutocompleteComponent_22_4.detectChangesInHostProps(this, this._el_22, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordEditComponent14.prototype.destroyInternal = function () {
        this._FormControlName_9_5.context.ngOnDestroy();
        this._FormControlName_20_5.context.ngOnDestroy();
        this._FormArrayName_0_3.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent14.prototype._handle_keyup_9_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_9_0 = (this.parent.parent.parent.context.onInputChange('soloist', $event) !== false);
        return (true && pd_9_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_input_9_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_9_0 = (this._DefaultValueAccessor_9_3.context.onChange($event.target.value) !== false);
        return (true && pd_9_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_blur_9_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_9_0 = (this._DefaultValueAccessor_9_3.context.onTouched() !== false);
        return (true && pd_9_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_keyup_20_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this.parent.parent.parent.context.onInputChange('instrument', $event) !== false);
        return (true && pd_20_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_input_20_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this._DefaultValueAccessor_20_3.context.onChange($event.target.value) !== false);
        return (true && pd_20_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_blur_20_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this._DefaultValueAccessor_20_3.context.onTouched() !== false);
        return (true && pd_20_0);
    };
    _View_ContentRecordEditComponent14.prototype._handle_click_26_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_26_0 = (this.parent.parent.parent.context.onRemoveSoloist(this.parent.context.index, this.context.index) !== false);
        return (true && pd_26_0);
    };
    return _View_ContentRecordEditComponent14;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent14(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent14(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent15 = (function (_super) {
    __extends(_View_ContentRecordEditComponent15, _super);
    function _View_ContentRecordEditComponent15(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent15, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent15.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_1, 'click', this.eventHandler(this._handle_click_1_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent15.prototype._handle_click_1_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_1_0 = (this.parent.parent.parent.parent.context.onAddSoloist(this.parent.parent.context.index) !== false);
        return (true && pd_1_0);
    };
    return _View_ContentRecordEditComponent15;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent15(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent15(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent16 = (function (_super) {
    __extends(_View_ContentRecordEditComponent16, _super);
    function _View_ContentRecordEditComponent16(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent16, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent16.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._text_3 = this.renderer.createText(this._el_2, 'S', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_5, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        this._text_7 = this.renderer.createText(this._el_0, '\n              ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._el_6,
            this._text_7
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent16.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.parent.parent.context.onAddSoloist(this.parent.context.index) !== false);
        return (true && pd_6_0);
    };
    return _View_ContentRecordEditComponent16;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent16(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent16(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent17 = (function (_super) {
    __extends(_View_ContentRecordEditComponent17, _super);
    function _View_ContentRecordEditComponent17(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent17, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent17.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [this._el_0], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent17.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.onAddMusicPiece() !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent17;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent17(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent17(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent18 = (function (_super) {
    __extends(_View_ContentRecordEditComponent18, _super);
    function _View_ContentRecordEditComponent18(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent18, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import8.UNINITIALIZED;
    }
    _View_ContentRecordEditComponent18.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, ' \n          ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'html-editor', import5.EMPTY_INLINE_ARRAY, null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._el_5);
        var compView_5 = import55.viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._HtmlEditorComponent_5_4 = new import55.Wrapper_HtmlEditorComponent();
        this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context, [], compView_5);
        this._text_6 = this.renderer.createText(null, '\n          ', null);
        compView_5.create(this._HtmlEditorComponent_5_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_0, '\n        ', null);
        this._pipe_uppercase_1_0 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'onEditorKeyup', this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        var subscription_0 = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentRecordEditComponent18.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import56.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._HtmlEditorComponent_5_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent18.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_5_0_0 = ('editor-description-' + this.context.$implicit);
        this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = (this.parent.parent.context.content ? this.parent.parent.context.content.description[this.context.$implicit] : '');
        this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1, throwOnChange, false);
        var currVal_5_0_2 = 5;
        this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2, throwOnChange, false);
        this._HtmlEditorComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_10 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_10, currVal_10))) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this._HtmlEditorComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentRecordEditComponent18.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_5_4.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent18.prototype._handle_onEditorKeyup_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.keyupEditorHandlerFunction([
            'description',
            this.context.$implicit
        ], $event) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentRecordEditComponent18;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent18(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent18(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent19 = (function (_super) {
    __extends(_View_ContentRecordEditComponent19, _super);
    function _View_ContentRecordEditComponent19(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent19, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent19.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray4(4, 'class', 'input-group col-lg-3 col-md-4 col-sm-5', 'style', 'padding: 0px 3px 3px 0px; max-width: 200px'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_2_3 = new import32.Wrapper_DefaultValueAccessor(this.renderer, new import13.ElementRef(this._el_2));
        this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
        this._FormControlName_2_5 = new import31.Wrapper_FormControlName(this.parent._ControlContainer_134_4, null, null, this._NG_VALUE_ACCESSOR_2_4);
        this._NgControl_2_6 = this._FormControlName_2_5.context;
        this._NgControlStatus_2_7 = new import29.Wrapper_NgControlStatus(this._NgControl_2_6);
        this._text_3 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_4, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-remove lLink'), null);
        this._text_6 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_7 = new import3.AppElement(7, 0, this, this._anchor_7);
        this._TemplateRef_7_5 = new import25.TemplateRef_(this._appEl_7, viewFactory_ContentRecordEditComponent20);
        this._NgIf_7_6 = new import23.Wrapper_NgIf(this._appEl_7.vcRef, this._TemplateRef_7_5);
        this._text_8 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'input', this.eventHandler(this._handle_input_2_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_2, 'blur', this.eventHandler(this._handle_blur_2_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._el_5,
            this._text_6,
            this._anchor_7,
            this._text_8
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentRecordEditComponent19.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import45.DefaultValueAccessor) && (2 === requestNodeIndex))) {
            return this._DefaultValueAccessor_2_3.context;
        }
        if (((token === import41.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_2_4;
        }
        if (((token === import42.FormControlName) && (2 === requestNodeIndex))) {
            return this._FormControlName_2_5.context;
        }
        if (((token === import43.NgControl) && (2 === requestNodeIndex))) {
            return this._NgControl_2_6;
        }
        if (((token === import44.NgControlStatus) && (2 === requestNodeIndex))) {
            return this._NgControlStatus_2_7.context;
        }
        if (((token === import25.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import27.NgIf) && (7 === requestNodeIndex))) {
            return this._NgIf_7_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordEditComponent19.prototype.detectChangesInternal = function (throwOnChange) {
        this._DefaultValueAccessor_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_2_1_0 = import5.interpolate(1, '', this.context.index, '');
        this._FormControlName_2_5.check_name(currVal_2_1_0, throwOnChange, false);
        this._FormControlName_2_5.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_7_0_0 = (this.parent.parent.context.recordForm.controls.tags.controls.length == (this.context.index + 1));
        this._NgIf_7_6.check_ngIf(currVal_7_0_0, throwOnChange, false);
        this._NgIf_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._DefaultValueAccessor_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._FormControlName_2_5.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordEditComponent19.prototype.destroyInternal = function () {
        this._FormControlName_2_5.context.ngOnDestroy();
    };
    _View_ContentRecordEditComponent19.prototype._handle_input_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onChange($event.target.value) !== false);
        return (true && pd_2_0);
    };
    _View_ContentRecordEditComponent19.prototype._handle_blur_2_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onTouched() !== false);
        return (true && pd_2_0);
    };
    _View_ContentRecordEditComponent19.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.onRemoveTag(this.context.index) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentRecordEditComponent19;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent19(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent19(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent20 = (function (_super) {
    __extends(_View_ContentRecordEditComponent20, _super);
    function _View_ContentRecordEditComponent20(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent20, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent20.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_1, 'click', this.eventHandler(this._handle_click_1_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent20.prototype._handle_click_1_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_1_0 = (this.parent.parent.parent.context.onAddTag() !== false);
        return (true && pd_1_0);
    };
    return _View_ContentRecordEditComponent20;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent20(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent20(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordEditComponent21 = (function (_super) {
    __extends(_View_ContentRecordEditComponent21, _super);
    function _View_ContentRecordEditComponent21(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordEditComponent21, renderType_ContentRecordEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordEditComponent21.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus lLink'), null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [this._el_0], [disposable_0], []);
        return null;
    };
    _View_ContentRecordEditComponent21.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.onAddTag() !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordEditComponent21;
}(import1.AppView));
function viewFactory_ContentRecordEditComponent21(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordEditComponent21(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(157);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(2);
var import10 = __webpack_require__(9);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(32);
var import13 = __webpack_require__(15);
var import14 = __webpack_require__(11);
var import15 = __webpack_require__(10);
var import16 = __webpack_require__(56);
var import17 = __webpack_require__(178);
var import18 = __webpack_require__(30);
var import19 = __webpack_require__(29);
var import20 = __webpack_require__(14);
var import21 = __webpack_require__(39);
var import22 = __webpack_require__(97);
var import23 = __webpack_require__(65);
var import24 = __webpack_require__(44);
var import25 = __webpack_require__(237);
var import26 = __webpack_require__(436);
var import27 = __webpack_require__(119);
var import28 = __webpack_require__(226);
var Wrapper_ContentRecordsComponent = (function () {
    function Wrapper_ContentRecordsComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.ContentRecordsComponent(p0, p1, p2, p3, p4, p5);
    }
    Wrapper_ContentRecordsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentRecordsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentRecordsComponent;
}());
exports.Wrapper_ContentRecordsComponent = Wrapper_ContentRecordsComponent;
var renderType_ContentRecordsComponent_Host = null;
var _View_ContentRecordsComponent_Host0 = (function (_super) {
    __extends(_View_ContentRecordsComponent_Host0, _super);
    function _View_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent_Host0, renderType_ContentRecordsComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentRecordsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentRecordsComponent_0_4 = new Wrapper_ContentRecordsComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.UtilsService), this.parentInjector.get(import10.ContentService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Location), this.parentInjector.get(import13.Router));
        this._appEl_0.initComponent(this._ContentRecordsComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentRecordsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentRecordsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentRecordsComponent) && (0 === requestNodeIndex))) {
            return this._ContentRecordsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentRecordsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentRecordsComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentRecordsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent_Host0;
}(import1.AppView));
function viewFactory_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordsComponent_Host === null)) {
        (renderType_ContentRecordsComponent_Host = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentRecordsComponentNgFactory = new import15.ComponentFactory('ng-component', viewFactory_ContentRecordsComponent_Host0, import0.ContentRecordsComponent);
var styles_ContentRecordsComponent = [];
var renderType_ContentRecordsComponent = null;
var _View_ContentRecordsComponent0 = (function (_super) {
    __extends(_View_ContentRecordsComponent0, _super);
    function _View_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent0, renderType_ContentRecordsComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Catalogue\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'lLink'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n      ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_7 = this.renderer.createText(this._el_6, 'Nouveau', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n    ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n', null);
        this._text_11 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_12 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray8(6, 'class', 'container-fluid', 'context', 'record', 'searchable-contents', ''), null);
        this._NgSwitch_12_3 = new import16.Wrapper_NgSwitch();
        this._SearchableContentsComponent_12_4 = new import17.Wrapper_SearchableContentsComponent(this.parentInjector.get(import10.ContentService), this.parentInjector.get(import18.SearchService), this.parentInjector.get(import9.UtilsService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import13.Router), this.parentInjector.get(import19.ElasticSearchService));
        this._text_13 = this.renderer.createText(this._el_12, '\n\n  ', null);
        this._text_14 = this.renderer.createText(this._el_12, '\n	', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_15 = new import3.AppElement(15, 12, this, this._anchor_15);
        this._TemplateRef_15_5 = new import20.TemplateRef_(this._appEl_15, viewFactory_ContentRecordsComponent1);
        this._NgSwitchCase_15_6 = new import16.Wrapper_NgSwitchCase(this._appEl_15.vcRef, this._TemplateRef_15_5, this._NgSwitch_12_3.context);
        this._text_16 = this.renderer.createText(this._el_12, '\n\n  ', null);
        this._text_17 = this.renderer.createText(this._el_12, '\n  ', null);
        this._anchor_18 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_18 = new import3.AppElement(18, 12, this, this._anchor_18);
        this._TemplateRef_18_5 = new import20.TemplateRef_(this._appEl_18, viewFactory_ContentRecordsComponent2);
        this._NgSwitchCase_18_6 = new import16.Wrapper_NgSwitchCase(this._appEl_18.vcRef, this._TemplateRef_18_5, this._NgSwitch_12_3.context);
        this._text_19 = this.renderer.createText(this._el_12, '\n\n', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._text_17,
            this._anchor_18,
            this._text_19
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import20.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import21.NgSwitchCase) && (15 === requestNodeIndex))) {
            return this._NgSwitchCase_15_6.context;
        }
        if (((token === import20.TemplateRef) && (18 === requestNodeIndex))) {
            return this._TemplateRef_18_5;
        }
        if (((token === import21.NgSwitchCase) && (18 === requestNodeIndex))) {
            return this._NgSwitchCase_18_6.context;
        }
        if (((token === import21.NgSwitch) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 19)))) {
            return this._NgSwitch_12_3.context;
        }
        if (((token === import22.SearchableContentsComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 19)))) {
            return this._SearchableContentsComponent_12_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_12_0_0 = this._SearchableContentsComponent_12_4.context.loading;
        this._NgSwitch_12_3.check_ngSwitch(currVal_12_0_0, throwOnChange, false);
        this._NgSwitch_12_3.detectChangesInInputProps(this, this._el_12, throwOnChange);
        var currVal_12_1_0 = 'record';
        this._SearchableContentsComponent_12_4.check_context(currVal_12_1_0, throwOnChange, false);
        var currVal_12_1_1 = this.context.pageSize;
        this._SearchableContentsComponent_12_4.check_pageSize(currVal_12_1_1, throwOnChange, false);
        var currVal_12_1_2 = true;
        this._SearchableContentsComponent_12_4.check_noCache(currVal_12_1_2, throwOnChange, false);
        this._SearchableContentsComponent_12_4.detectChangesInInputProps(this, this._el_12, throwOnChange);
        var currVal_15_0_0 = true;
        this._NgSwitchCase_15_6.check_ngSwitchCase(currVal_15_0_0, throwOnChange, false);
        this._NgSwitchCase_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        var currVal_18_0_0 = false;
        this._NgSwitchCase_18_6.check_ngSwitchCase(currVal_18_0_0, throwOnChange, false);
        this._NgSwitchCase_18_6.detectChangesInInputProps(this, this._anchor_18, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_12_3.detectChangesInHostProps(this, this._el_12, throwOnChange);
        this._SearchableContentsComponent_12_4.detectChangesInHostProps(this, this._el_12, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.context.utils.lLink('admin/record/edit/0', this.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    return _View_ContentRecordsComponent0;
}(import1.AppView));
function viewFactory_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordsComponent === null)) {
        (renderType_ContentRecordsComponent = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, styles_ContentRecordsComponent, {}));
    }
    return new _View_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentRecordsComponent0 = viewFactory_ContentRecordsComponent0;
var _View_ContentRecordsComponent1 = (function (_super) {
    __extends(_View_ContentRecordsComponent1, _super);
    function _View_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent1, renderType_ContentRecordsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n	  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'loading-indicator', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._el_2);
        var compView_2 = import23.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(2), this._appEl_2);
        this._LoadingIndicator_2_4 = new import23.Wrapper_LoadingIndicator();
        this._appEl_2.initComponent(this._LoadingIndicator_2_4.context, [], compView_2);
        compView_2.create(this._LoadingIndicator_2_4.context, [], null);
        this._text_3 = this.renderer.createText(this._el_0, '\n	', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.LoadingIndicator) && (2 === requestNodeIndex))) {
            return this._LoadingIndicator_2_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        this._LoadingIndicator_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent1;
}(import1.AppView));
function viewFactory_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent2 = (function (_super) {
    __extends(_View_ContentRecordsComponent2, _super);
    function _View_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent2, renderType_ContentRecordsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._text_3 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n      \n      ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'search-filters', new import4.InlineArray2(2, 'title', 'Recherche'), null);
        this._appEl_6 = new import3.AppElement(6, 4, this, this._el_6);
        var compView_6 = import25.viewFactory_SearchFilterComponent0(this.viewUtils, this.injector(6), this._appEl_6);
        this._SearchFilterComponent_6_4 = new import25.Wrapper_SearchFilterComponent(this.parent.parentInjector.get(import9.UtilsService), this.parent.parentInjector.get(import13.Router), this.parent.parentInjector.get(import11.ActivatedRoute), this.parent.parentInjector.get(import19.ElasticSearchService));
        this._appEl_6.initComponent(this._SearchFilterComponent_6_4.context, [], compView_6);
        this._text_7 = this.renderer.createText(null, '\n      ', null);
        compView_6.create(this._SearchFilterComponent_6_4.context, [], null);
        this._text_8 = this.renderer.createText(this._el_4, '\n\n      ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_4, 'admin-search-results', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_9 = new import3.AppElement(9, 4, this, this._el_9);
        var compView_9 = import26.viewFactory_SearchResultsComponent0(this.viewUtils, this.injector(9), this._appEl_9);
        this._SearchResultsComponent_9_4 = new import26.Wrapper_SearchResultsComponent(this.parent.parentInjector.get(import8.ConfigService), this.parent.parentInjector.get(import10.ContentService), this.parent.parentInjector.get(import9.UtilsService), this.parent.parentInjector.get(import13.Router), this.parent.parentInjector.get(import11.ActivatedRoute));
        this._appEl_9.initComponent(this._SearchResultsComponent_9_4.context, [], compView_9);
        this._text_10 = this.renderer.createText(null, '\n      ', null);
        compView_9.create(this._SearchResultsComponent_9_4.context, [], null);
        this._text_11 = this.renderer.createText(this._el_4, '\n\n    ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._text_13 = this.renderer.createText(this._el_0, '\n\n  ', null);
        var disposable_0 = this.renderer.listen(this._el_9, 'onSearch', this.eventHandler(this._handle_onSearch_9_0.bind(this)));
        var subscription_0 = this._SearchResultsComponent_9_4.context.onSearch.subscribe(this.eventHandler(this._handle_onSearch_9_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._text_13
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentRecordsComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.SearchFilterComponent) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 7)))) {
            return this._SearchFilterComponent_6_4.context;
        }
        if (((token === import28.SearchResultsComponent) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._SearchResultsComponent_9_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_6_0_0 = this.parent._SearchableContentsComponent_12_4.context.esQuery;
        this._SearchFilterComponent_6_4.check_esQuery(currVal_6_0_0, throwOnChange, false);
        var currVal_6_0_1 = this.parent._SearchableContentsComponent_12_4.context.esFilters;
        this._SearchFilterComponent_6_4.check_esFilters(currVal_6_0_1, throwOnChange, false);
        var currVal_6_0_2 = 'Recherche';
        this._SearchFilterComponent_6_4.check_title(currVal_6_0_2, throwOnChange, false);
        this._SearchFilterComponent_6_4.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_9_0_0 = this.parent._SearchableContentsComponent_12_4.context.esContents;
        this._SearchResultsComponent_9_4.check_esContents(currVal_9_0_0, throwOnChange, false);
        var currVal_9_0_1 = this.parent._SearchableContentsComponent_12_4.context.dbContents;
        this._SearchResultsComponent_9_4.check_dbContents(currVal_9_0_1, throwOnChange, false);
        var currVal_9_0_2 = this.parent._SearchableContentsComponent_12_4.context.pageSize;
        this._SearchResultsComponent_9_4.check_pageSize(currVal_9_0_2, throwOnChange, false);
        this._SearchResultsComponent_9_4.detectChangesInInputProps(this, this._el_9, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._SearchResultsComponent_9_4.context.ngAfterContentChecked();
        }
        this._SearchFilterComponent_6_4.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._SearchResultsComponent_9_4.detectChangesInHostProps(this, this._el_9, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent2.prototype._handle_onSearch_9_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_9_0 = (this.parent._SearchableContentsComponent_12_4.context.searchCallBack($event) !== false);
        return (true && pd_9_0);
    };
    return _View_ContentRecordsComponent2;
}(import1.AppView));
function viewFactory_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(158);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(46);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(38);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(17);
var import12 = __webpack_require__(45);
var import13 = __webpack_require__(25);
var import14 = __webpack_require__(2);
var import15 = __webpack_require__(73);
var import16 = __webpack_require__(15);
var import17 = __webpack_require__(9);
var import18 = __webpack_require__(16);
var import19 = __webpack_require__(11);
var import20 = __webpack_require__(10);
var import21 = __webpack_require__(56);
var import22 = __webpack_require__(22);
var import23 = __webpack_require__(82);
var import24 = __webpack_require__(14);
var import25 = __webpack_require__(39);
var import26 = __webpack_require__(19);
var import27 = __webpack_require__(114);
var import28 = __webpack_require__(43);
var import29 = __webpack_require__(64);
var import30 = __webpack_require__(113);
var import31 = __webpack_require__(85);
var import32 = __webpack_require__(115);
var import33 = __webpack_require__(24);
var import34 = __webpack_require__(18);
var import35 = __webpack_require__(20);
var import36 = __webpack_require__(41);
var import37 = __webpack_require__(26);
var import38 = __webpack_require__(61);
var import39 = __webpack_require__(28);
var import40 = __webpack_require__(33);
var import41 = __webpack_require__(47);
var import42 = __webpack_require__(21);
var import43 = __webpack_require__(54);
var import44 = __webpack_require__(37);
var import45 = __webpack_require__(53);
var import46 = __webpack_require__(31);
var Wrapper_ContentSpecialEditComponent = (function () {
    function Wrapper_ContentSpecialEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
        this.changed = false;
        this.context = new import0.ContentSpecialEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
    }
    Wrapper_ContentSpecialEditComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentSpecialEditComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentSpecialEditComponent;
}());
exports.Wrapper_ContentSpecialEditComponent = Wrapper_ContentSpecialEditComponent;
var renderType_ContentSpecialEditComponent_Host = null;
var _View_ContentSpecialEditComponent_Host0 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent_Host0, _super);
    function _View_ContentSpecialEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent_Host0, renderType_ContentSpecialEditComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentSpecialEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentSpecialEditComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._ContentSpecialEditComponent_0_5 = new Wrapper_ContentSpecialEditComponent(this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.IntlService), this._DatePipe_0_4, this.parentInjector.get(import12.NotificationService), this.parentInjector.get(import13.MetaService), this.parentInjector.get(import14.UtilsService), this.parentInjector.get(import15.FormBuilder), this.parentInjector.get(import16.Router), this.parentInjector.get(import17.ContentService), this.parentInjector.get(import18.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentSpecialEditComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentSpecialEditComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentSpecialEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.DatePipe) && (0 === requestNodeIndex))) {
            return this._DatePipe_0_4;
        }
        if (((token === import0.ContentSpecialEditComponent) && (0 === requestNodeIndex))) {
            return this._ContentSpecialEditComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentSpecialEditComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentSpecialEditComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialEditComponent_Host0;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentSpecialEditComponent_Host === null)) {
        (renderType_ContentSpecialEditComponent_Host = viewUtils.createRenderComponentType('', 0, import19.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentSpecialEditComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentSpecialEditComponentNgFactory = new import20.ComponentFactory('ng-component', viewFactory_ContentSpecialEditComponent_Host0, import0.ContentSpecialEditComponent);
var styles_ContentSpecialEditComponent = [];
var renderType_ContentSpecialEditComponent = null;
var _View_ContentSpecialEditComponent0 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent0, _super);
    function _View_ContentSpecialEditComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent0, renderType_ContentSpecialEditComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentSpecialEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'h1', import5.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_2_3 = new import21.Wrapper_NgSwitch();
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_4 = new import3.AppElement(4, 2, this, this._anchor_4);
        this._TemplateRef_4_5 = new import24.TemplateRef_(this._appEl_4, viewFactory_ContentSpecialEditComponent1);
        this._NgSwitchCase_4_6 = new import21.Wrapper_NgSwitchCase(this._appEl_4.vcRef, this._TemplateRef_4_5, this._NgSwitch_2_3.context);
        this._text_5 = this.renderer.createText(this._el_2, '\n        ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_6 = new import3.AppElement(6, 2, this, this._anchor_6);
        this._TemplateRef_6_5 = new import24.TemplateRef_(this._appEl_6, viewFactory_ContentSpecialEditComponent2);
        this._NgSwitchCase_6_6 = new import21.Wrapper_NgSwitchCase(this._appEl_6.vcRef, this._TemplateRef_6_5, this._NgSwitch_2_3.context);
        this._text_7 = this.renderer.createText(this._el_2, '\n        ', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_8 = new import3.AppElement(8, 2, this, this._anchor_8);
        this._TemplateRef_8_5 = new import24.TemplateRef_(this._appEl_8, viewFactory_ContentSpecialEditComponent3);
        this._NgIf_8_6 = new import22.Wrapper_NgIf(this._appEl_8.vcRef, this._TemplateRef_8_5);
        this._text_9 = this.renderer.createText(this._el_2, '\n        ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_2, null);
        this._appEl_10 = new import3.AppElement(10, 2, this, this._anchor_10);
        this._TemplateRef_10_5 = new import24.TemplateRef_(this._appEl_10, viewFactory_ContentSpecialEditComponent4);
        this._NgSwitchCase_10_6 = new import21.Wrapper_NgSwitchCase(this._appEl_10.vcRef, this._TemplateRef_10_5, this._NgSwitch_2_3.context);
        this._text_11 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n  ', null);
        this._text_13 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_14 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n  ', null);
        this._el_16 = import5.createRenderElement(this.renderer, this._el_14, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n    ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n      ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_18, 'div', new import5.InlineArray2(2, 'class', 'box'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n        ', null);
        this._el_22 = import5.createRenderElement(this.renderer, this._el_20, 'div', new import5.InlineArray2(2, 'class', 'box-body'), null);
        this._text_23 = this.renderer.createText(this._el_22, '\n\n          ', null);
        this._anchor_24 = this.renderer.createTemplateAnchor(this._el_22, null);
        this._appEl_24 = new import3.AppElement(24, 22, this, this._anchor_24);
        this._TemplateRef_24_5 = new import24.TemplateRef_(this._appEl_24, viewFactory_ContentSpecialEditComponent5);
        this._NgIf_24_6 = new import22.Wrapper_NgIf(this._appEl_24.vcRef, this._TemplateRef_24_5);
        this._text_25 = this.renderer.createText(this._el_22, '\n\n\n        ', null);
        this._text_26 = this.renderer.createText(this._el_20, '\n        ', null);
        this._text_27 = this.renderer.createText(this._el_20, '\n      ', null);
        this._text_28 = this.renderer.createText(this._el_18, '\n    ', null);
        this._text_29 = this.renderer.createText(this._el_16, '\n  ', null);
        this._text_30 = this.renderer.createText(this._el_14, '\n', null);
        this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._pipe_uppercase_1 = new import23.UpperCasePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._anchor_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._anchor_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30
        ], [], []);
        return null;
    };
    _View_ContentSpecialEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import25.NgSwitchCase) && (4 === requestNodeIndex))) {
            return this._NgSwitchCase_4_6.context;
        }
        if (((token === import24.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import25.NgSwitchCase) && (6 === requestNodeIndex))) {
            return this._NgSwitchCase_6_6.context;
        }
        if (((token === import24.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import26.NgIf) && (8 === requestNodeIndex))) {
            return this._NgIf_8_6.context;
        }
        if (((token === import24.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import25.NgSwitchCase) && (10 === requestNodeIndex))) {
            return this._NgSwitchCase_10_6.context;
        }
        if (((token === import25.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._NgSwitch_2_3.context;
        }
        if (((token === import24.TemplateRef) && (24 === requestNodeIndex))) {
            return this._TemplateRef_24_5;
        }
        if (((token === import26.NgIf) && (24 === requestNodeIndex))) {
            return this._NgIf_24_6.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.context.action;
        this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0, throwOnChange, false);
        this._NgSwitch_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_4_0_0 = 'add';
        this._NgSwitchCase_4_6.check_ngSwitchCase(currVal_4_0_0, throwOnChange, false);
        this._NgSwitchCase_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        var currVal_6_0_0 = 'update';
        this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0, throwOnChange, false);
        this._NgSwitchCase_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_8_0_0 = (this.context.content && (this.context.action == 'update'));
        this._NgIf_8_6.check_ngIf(currVal_8_0_0, throwOnChange, false);
        this._NgIf_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        var currVal_10_0_0 = 'update';
        this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0, throwOnChange, false);
        this._NgSwitchCase_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        var currVal_24_0_0 = (this.context.content || (this.context.action == 'add'));
        this._NgIf_24_6.check_ngIf(currVal_24_0_0, throwOnChange, false);
        this._NgIf_24_6.detectChangesInInputProps(this, this._anchor_24, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialEditComponent0;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentSpecialEditComponent === null)) {
        (renderType_ContentSpecialEditComponent = viewUtils.createRenderComponentType('', 0, import19.ViewEncapsulation.None, styles_ContentSpecialEditComponent, {}));
    }
    return new _View_ContentSpecialEditComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentSpecialEditComponent0 = viewFactory_ContentSpecialEditComponent0;
var _View_ContentSpecialEditComponent1 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent1, _super);
    function _View_ContentSpecialEditComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent1, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentSpecialEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Parmi les interprètes d\'ajourd\'hui (nouveau)', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentSpecialEditComponent1;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent2 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent2, _super);
    function _View_ContentSpecialEditComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent2, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Parmi les interprètes d\'ajourd\'hui ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentSpecialEditComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_4 = import5.interpolate(1, '', ((this.parent.context.content == null) ? null : this.parent.context.content.cid), '');
        if (import5.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialEditComponent2;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent3 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent3, _super);
    function _View_ContentSpecialEditComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent3, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentSpecialEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'lLink'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_3 = this.renderer.createText(this._el_2, 'Supprimer', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_ContentSpecialEditComponent3.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.deleteContent('special', this.parent.context.content._id) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentSpecialEditComponent3;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent4 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent4, _super);
    function _View_ContentSpecialEditComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent4, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ' ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_date_0_0 = import5.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentSpecialEditComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import5.interpolate(1, '(modifié: ', valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(((this.parent.context.content == null) ? null : this.parent.context.content.update_date), 'dd MMM yyyy')), ')');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialEditComponent4;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent5 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent5, _super);
    function _View_ContentSpecialEditComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent5, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_120 = import8.UNINITIALIZED;
        this._expr_121 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'form', import5.EMPTY_INLINE_ARRAY, null);
        this._FormGroupDirective_0_3 = new import27.Wrapper_FormGroupDirective(null, null);
        this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
        this._NgControlStatusGroup_0_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'panel panel-default'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Métadonnées', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_7, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'col-md-1 col-sm-1 input-group switch material-switch'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'input', new import5.InlineArray8(8, 'formControlName', 'active', 'id', 'act', 'name', 'act', 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_13_3 = new import29.Wrapper_CheckboxControlValueAccessor(this.renderer, new import34.ElementRef(this._el_13));
        this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
        this._FormControlName_13_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_13_4);
        this._NgControl_13_6 = this._FormControlName_13_5.context;
        this._NgControlStatus_13_7 = new import28.Wrapper_NgControlStatus(this._NgControl_13_6);
        this._text_14 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_11, 'label', new import5.InlineArray4(4, 'class', 'label-primary', 'for', 'act'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                  ', null);
        this._text_17 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray4(4, 'class', 'input-group col-lg-3 col-md-4 col-sm-5', 'style', 'max-width: 200px'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_18, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_20, 'i', new import5.InlineArray2(2, 'class', 'fa fa-calendar'), null);
        this._text_22 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._text_23 = this.renderer.createText(this._el_18, '\n                    ', null);
        this._el_24 = import5.createRenderElement(this.renderer, this._el_18, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'date', 'type', 'text'), null);
        this._DefaultValueAccessor_24_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer, new import34.ElementRef(this._el_24));
        this._NG_VALUE_ACCESSOR_24_4 = [this._DefaultValueAccessor_24_3.context];
        this._FormControlName_24_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_24_4);
        this._NgControl_24_6 = this._FormControlName_24_5.context;
        this._NgControlStatus_24_7 = new import28.Wrapper_NgControlStatus(this._NgControl_24_6);
        this._text_25 = this.renderer.createText(this._el_18, '\n                  ', null);
        this._text_26 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._el_27 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'input-group col-lg-7 col-md-7 col-sm-10'), null);
        this._text_28 = this.renderer.createText(this._el_27, '\n                      ', null);
        this._el_29 = import5.createRenderElement(this.renderer, this._el_27, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_30 = import5.createRenderElement(this.renderer, this._el_29, 'i', new import5.InlineArray2(2, 'class', 'fa fa-external-link'), null);
        this._text_31 = this.renderer.createText(this._el_27, '\n                      ', null);
        this._el_32 = import5.createRenderElement(this.renderer, this._el_27, 'input', new import5.InlineArray8(8, 'class', 'form-control', 'formControlName', 'url', 'readonly', '', 'type', 'text'), null);
        this._DefaultValueAccessor_32_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer, new import34.ElementRef(this._el_32));
        this._NG_VALUE_ACCESSOR_32_4 = [this._DefaultValueAccessor_32_3.context];
        this._FormControlName_32_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_32_4);
        this._NgControl_32_6 = this._FormControlName_32_5.context;
        this._NgControlStatus_32_7 = new import28.Wrapper_NgControlStatus(this._NgControl_32_6);
        this._text_33 = this.renderer.createText(this._el_27, '\n                    ', null);
        this._text_34 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._text_35 = this.renderer.createText(this._el_9, '\n                ', null);
        this._text_36 = this.renderer.createText(this._el_7, '\n              ', null);
        this._text_37 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_38 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_39 = this.renderer.createText(this._el_38, 'Image', null);
        this._text_40 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_41 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_42 = this.renderer.createText(this._el_41, '\n                  ', null);
        this._text_43 = this.renderer.createText(this._el_41, '\n                  ', null);
        this._el_44 = import5.createRenderElement(this.renderer, this._el_41, 'img', new import5.InlineArray2(2, 'width', '350px'), null);
        this._text_45 = this.renderer.createText(this._el_41, '\n              ', null);
        this._text_46 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_47 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_48 = this.renderer.createText(this._el_47, 'Titre', null);
        this._text_49 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_50 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_51 = this.renderer.createText(this._el_50, '\n                ', null);
        this._el_52 = import5.createRenderElement(this.renderer, this._el_50, 'div', new import5.InlineArray4(4, 'class', 'form-inline', 'formGroupName', 'title'), null);
        this._FormGroupName_52_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_52_4 = this._FormGroupName_52_3.context;
        this._NgControlStatusGroup_52_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_52_4);
        this._text_53 = this.renderer.createText(this._el_52, '\n                  ', null);
        this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52, null);
        this._appEl_54 = new import3.AppElement(54, 52, this, this._anchor_54);
        this._TemplateRef_54_5 = new import24.TemplateRef_(this._appEl_54, viewFactory_ContentSpecialEditComponent6);
        this._NgFor_54_6 = new import33.Wrapper_NgFor(this._appEl_54.vcRef, this._TemplateRef_54_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_55 = this.renderer.createText(this._el_52, '\n                ', null);
        this._text_56 = this.renderer.createText(this._el_50, '\n              ', null);
        this._text_57 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_58 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_59 = this.renderer.createText(this._el_58, 'Sous-titre', null);
        this._text_60 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_61 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_62 = this.renderer.createText(this._el_61, '\n                ', null);
        this._el_63 = import5.createRenderElement(this.renderer, this._el_61, 'div', new import5.InlineArray4(4, 'class', 'form-inline', 'formGroupName', 'subtitle'), null);
        this._FormGroupName_63_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_63_4 = this._FormGroupName_63_3.context;
        this._NgControlStatusGroup_63_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_63_4);
        this._text_64 = this.renderer.createText(this._el_63, '\n                  ', null);
        this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63, null);
        this._appEl_65 = new import3.AppElement(65, 63, this, this._anchor_65);
        this._TemplateRef_65_5 = new import24.TemplateRef_(this._appEl_65, viewFactory_ContentSpecialEditComponent7);
        this._NgFor_65_6 = new import33.Wrapper_NgFor(this._appEl_65.vcRef, this._TemplateRef_65_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_66 = this.renderer.createText(this._el_63, '\n                ', null);
        this._text_67 = this.renderer.createText(this._el_61, '\n              ', null);
        this._text_68 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_69 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_70 = this.renderer.createText(this._el_69, 'Contenu', null);
        this._text_71 = this.renderer.createText(this._el_2, '\n              ', null);
        this._el_72 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_73 = this.renderer.createText(this._el_72, '\n                ', null);
        this._el_74 = import5.createRenderElement(this.renderer, this._el_72, 'div', new import5.InlineArray2(2, 'formGroupName', 'content'), null);
        this._FormGroupName_74_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_74_4 = this._FormGroupName_74_3.context;
        this._NgControlStatusGroup_74_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_74_4);
        this._text_75 = this.renderer.createText(this._el_74, '\n                  ', null);
        this._anchor_76 = this.renderer.createTemplateAnchor(this._el_74, null);
        this._appEl_76 = new import3.AppElement(76, 74, this, this._anchor_76);
        this._TemplateRef_76_5 = new import24.TemplateRef_(this._appEl_76, viewFactory_ContentSpecialEditComponent8);
        this._NgFor_76_6 = new import33.Wrapper_NgFor(this._appEl_76.vcRef, this._TemplateRef_76_5, this.parent.parentInjector.get(import35.IterableDiffers), this.parent.ref);
        this._text_77 = this.renderer.createText(this._el_74, '\n                ', null);
        this._text_78 = this.renderer.createText(this._el_72, '\n              ', null);
        this._text_79 = this.renderer.createText(this._el_2, '\n\n              ', null);
        this._el_80 = import5.createRenderElement(this.renderer, this._el_2, 'button', new import5.InlineArray4(4, 'class', 'btn btn-info pull-right', 'type', 'submit'), null);
        this._text_81 = this.renderer.createText(this._el_80, '\n        Sauvegarder\n      ', null);
        this._text_82 = this.renderer.createText(this._el_2, '\n\n            ', null);
        this._text_83 = this.renderer.createText(this._el_0, '\n\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_13, 'change', this.eventHandler(this._handle_change_13_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_13, 'blur', this.eventHandler(this._handle_blur_13_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_24, 'input', this.eventHandler(this._handle_input_24_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_24, 'blur', this.eventHandler(this._handle_blur_24_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_32, 'input', this.eventHandler(this._handle_input_32_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_32, 'blur', this.eventHandler(this._handle_blur_32_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._el_21,
            this._text_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._el_29,
            this._el_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._text_40,
            this._el_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._text_49,
            this._el_50,
            this._text_51,
            this._el_52,
            this._text_53,
            this._anchor_54,
            this._text_55,
            this._text_56,
            this._text_57,
            this._el_58,
            this._text_59,
            this._text_60,
            this._el_61,
            this._text_62,
            this._el_63,
            this._text_64,
            this._anchor_65,
            this._text_66,
            this._text_67,
            this._text_68,
            this._el_69,
            this._text_70,
            this._text_71,
            this._el_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._anchor_76,
            this._text_77,
            this._text_78,
            this._text_79,
            this._el_80,
            this._text_81,
            this._text_82,
            this._text_83
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], [subscription_0]);
        return null;
    };
    _View_ContentSpecialEditComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import36.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_13_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_13_4;
        }
        if (((token === import38.FormControlName) && (13 === requestNodeIndex))) {
            return this._FormControlName_13_5.context;
        }
        if (((token === import39.NgControl) && (13 === requestNodeIndex))) {
            return this._NgControl_13_6;
        }
        if (((token === import40.NgControlStatus) && (13 === requestNodeIndex))) {
            return this._NgControlStatus_13_7.context;
        }
        if (((token === import41.DefaultValueAccessor) && (24 === requestNodeIndex))) {
            return this._DefaultValueAccessor_24_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (24 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_24_4;
        }
        if (((token === import38.FormControlName) && (24 === requestNodeIndex))) {
            return this._FormControlName_24_5.context;
        }
        if (((token === import39.NgControl) && (24 === requestNodeIndex))) {
            return this._NgControl_24_6;
        }
        if (((token === import40.NgControlStatus) && (24 === requestNodeIndex))) {
            return this._NgControlStatus_24_7.context;
        }
        if (((token === import41.DefaultValueAccessor) && (32 === requestNodeIndex))) {
            return this._DefaultValueAccessor_32_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (32 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_32_4;
        }
        if (((token === import38.FormControlName) && (32 === requestNodeIndex))) {
            return this._FormControlName_32_5.context;
        }
        if (((token === import39.NgControl) && (32 === requestNodeIndex))) {
            return this._NgControl_32_6;
        }
        if (((token === import40.NgControlStatus) && (32 === requestNodeIndex))) {
            return this._NgControlStatus_32_7.context;
        }
        if (((token === import24.TemplateRef) && (54 === requestNodeIndex))) {
            return this._TemplateRef_54_5;
        }
        if (((token === import42.NgFor) && (54 === requestNodeIndex))) {
            return this._NgFor_54_6.context;
        }
        if (((token === import43.FormGroupName) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._FormGroupName_52_3.context;
        }
        if (((token === import44.ControlContainer) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._ControlContainer_52_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._NgControlStatusGroup_52_5.context;
        }
        if (((token === import24.TemplateRef) && (65 === requestNodeIndex))) {
            return this._TemplateRef_65_5;
        }
        if (((token === import42.NgFor) && (65 === requestNodeIndex))) {
            return this._NgFor_65_6.context;
        }
        if (((token === import43.FormGroupName) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) {
            return this._FormGroupName_63_3.context;
        }
        if (((token === import44.ControlContainer) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) {
            return this._ControlContainer_63_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) {
            return this._NgControlStatusGroup_63_5.context;
        }
        if (((token === import24.TemplateRef) && (76 === requestNodeIndex))) {
            return this._TemplateRef_76_5;
        }
        if (((token === import42.NgFor) && (76 === requestNodeIndex))) {
            return this._NgFor_76_6.context;
        }
        if (((token === import43.FormGroupName) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._FormGroupName_74_3.context;
        }
        if (((token === import44.ControlContainer) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._ControlContainer_74_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._NgControlStatusGroup_74_5.context;
        }
        if (((token === import45.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) {
            return this._FormGroupDirective_0_3.context;
        }
        if (((token === import44.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import40.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.specialForm;
        this._FormGroupDirective_0_3.check_form(currVal_0_0_0, throwOnChange, false);
        this._FormGroupDirective_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this, this._el_13, throwOnChange);
        var currVal_13_1_0 = 'active';
        this._FormControlName_13_5.check_name(currVal_13_1_0, throwOnChange, false);
        this._FormControlName_13_5.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_24_3.detectChangesInInputProps(this, this._el_24, throwOnChange);
        var currVal_24_1_0 = 'date';
        this._FormControlName_24_5.check_name(currVal_24_1_0, throwOnChange, false);
        this._FormControlName_24_5.detectChangesInInputProps(this, this._el_24, throwOnChange);
        this._NgControlStatus_24_7.detectChangesInInputProps(this, this._el_24, throwOnChange);
        this._DefaultValueAccessor_32_3.detectChangesInInputProps(this, this._el_32, throwOnChange);
        var currVal_32_1_0 = 'url';
        this._FormControlName_32_5.check_name(currVal_32_1_0, throwOnChange, false);
        this._FormControlName_32_5.detectChangesInInputProps(this, this._el_32, throwOnChange);
        this._NgControlStatus_32_7.detectChangesInInputProps(this, this._el_32, throwOnChange);
        var currVal_52_0_0 = 'title';
        this._FormGroupName_52_3.check_name(currVal_52_0_0, throwOnChange, false);
        this._FormGroupName_52_3.detectChangesInInputProps(this, this._el_52, throwOnChange);
        this._NgControlStatusGroup_52_5.detectChangesInInputProps(this, this._el_52, throwOnChange);
        var currVal_54_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_54_6.check_ngForOf(currVal_54_0_0, throwOnChange, false);
        this._NgFor_54_6.detectChangesInInputProps(this, this._anchor_54, throwOnChange);
        var currVal_63_0_0 = 'subtitle';
        this._FormGroupName_63_3.check_name(currVal_63_0_0, throwOnChange, false);
        this._FormGroupName_63_3.detectChangesInInputProps(this, this._el_63, throwOnChange);
        this._NgControlStatusGroup_63_5.detectChangesInInputProps(this, this._el_63, throwOnChange);
        var currVal_65_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_65_6.check_ngForOf(currVal_65_0_0, throwOnChange, false);
        this._NgFor_65_6.detectChangesInInputProps(this, this._anchor_65, throwOnChange);
        var currVal_74_0_0 = 'content';
        this._FormGroupName_74_3.check_name(currVal_74_0_0, throwOnChange, false);
        this._FormGroupName_74_3.detectChangesInInputProps(this, this._el_74, throwOnChange);
        this._NgControlStatusGroup_74_5.detectChangesInInputProps(this, this._el_74, throwOnChange);
        var currVal_76_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_76_6.check_ngForOf(currVal_76_0_0, throwOnChange, false);
        this._NgFor_76_6.detectChangesInInputProps(this, this._anchor_76, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupDirective_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._FormControlName_13_5.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_24_3.detectChangesInHostProps(this, this._el_24, throwOnChange);
        this._FormControlName_24_5.detectChangesInHostProps(this, this._el_24, throwOnChange);
        this._NgControlStatus_24_7.detectChangesInHostProps(this, this._el_24, throwOnChange);
        this._DefaultValueAccessor_32_3.detectChangesInHostProps(this, this._el_32, throwOnChange);
        this._FormControlName_32_5.detectChangesInHostProps(this, this._el_32, throwOnChange);
        this._NgControlStatus_32_7.detectChangesInHostProps(this, this._el_32, throwOnChange);
        var currVal_120 = this.parent.context.image;
        if (import5.checkBinding(throwOnChange, this._expr_120, currVal_120)) {
            this.renderer.setElementProperty(this._el_44, 'src', this.viewUtils.sanitizer.sanitize(import46.SecurityContext.URL, currVal_120));
            this._expr_120 = currVal_120;
        }
        this._FormGroupName_52_3.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._NgControlStatusGroup_52_5.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._FormGroupName_63_3.detectChangesInHostProps(this, this._el_63, throwOnChange);
        this._NgControlStatusGroup_63_5.detectChangesInHostProps(this, this._el_63, throwOnChange);
        this._FormGroupName_74_3.detectChangesInHostProps(this, this._el_74, throwOnChange);
        this._NgControlStatusGroup_74_5.detectChangesInHostProps(this, this._el_74, throwOnChange);
        var currVal_121 = !this.parent.context.specialForm.valid;
        if (import5.checkBinding(throwOnChange, this._expr_121, currVal_121)) {
            this.renderer.setElementProperty(this._el_80, 'disabled', currVal_121);
            this._expr_121 = currVal_121;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentSpecialEditComponent5.prototype.destroyInternal = function () {
        this._FormControlName_13_5.context.ngOnDestroy();
        this._FormControlName_24_5.context.ngOnDestroy();
        this._FormControlName_32_5.context.ngOnDestroy();
    };
    _View_ContentSpecialEditComponent5.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_0_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_change_13_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked) !== false);
        return (true && pd_13_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_blur_13_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onTouched() !== false);
        return (true && pd_13_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_input_24_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_24_0 = (this._DefaultValueAccessor_24_3.context.onChange($event.target.value) !== false);
        return (true && pd_24_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_blur_24_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_24_0 = (this._DefaultValueAccessor_24_3.context.onTouched() !== false);
        return (true && pd_24_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_input_32_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_32_0 = (this._DefaultValueAccessor_32_3.context.onChange($event.target.value) !== false);
        return (true && pd_32_0);
    };
    _View_ContentSpecialEditComponent5.prototype._handle_blur_32_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_32_0 = (this._DefaultValueAccessor_32_3.context.onTouched() !== false);
        return (true && pd_32_0);
    };
    return _View_ContentSpecialEditComponent5;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent6 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent6, _super);
    function _View_ContentSpecialEditComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent6, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon max-width-20'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer, new import34.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import30.Wrapper_FormControlName(this.parent._ControlContainer_52_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_0 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentSpecialEditComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import38.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import39.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentSpecialEditComponent6.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentSpecialEditComponent6.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentSpecialEditComponent6.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentSpecialEditComponent6;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent7 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent7, _super);
    function _View_ContentSpecialEditComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent7, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon max-width-20'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer, new import34.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import30.Wrapper_FormControlName(this.parent._ControlContainer_63_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_1 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentSpecialEditComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import38.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import39.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentSpecialEditComponent7.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentSpecialEditComponent7.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentSpecialEditComponent7.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentSpecialEditComponent7;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentSpecialEditComponent8 = (function (_super) {
    __extends(_View_ContentSpecialEditComponent8, _super);
    function _View_ContentSpecialEditComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialEditComponent8, renderType_ContentSpecialEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentSpecialEditComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer, new import34.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import30.Wrapper_FormControlName(this.parent._ControlContainer_74_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                  ', null);
        this._pipe_uppercase_1_2 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentSpecialEditComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import38.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import39.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialEditComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentSpecialEditComponent8.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentSpecialEditComponent8.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentSpecialEditComponent8.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentSpecialEditComponent8;
}(import1.AppView));
function viewFactory_ContentSpecialEditComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialEditComponent8(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(159);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(45);
var import10 = __webpack_require__(2);
var import11 = __webpack_require__(9);
var import12 = __webpack_require__(16);
var import13 = __webpack_require__(32);
var import14 = __webpack_require__(15);
var import15 = __webpack_require__(11);
var import16 = __webpack_require__(10);
var import17 = __webpack_require__(24);
var import18 = __webpack_require__(46);
var import19 = __webpack_require__(14);
var import20 = __webpack_require__(20);
var import21 = __webpack_require__(38);
var import22 = __webpack_require__(21);
var import23 = __webpack_require__(64);
var import24 = __webpack_require__(79);
var import25 = __webpack_require__(43);
var import26 = __webpack_require__(18);
var import27 = __webpack_require__(41);
var import28 = __webpack_require__(26);
var import29 = __webpack_require__(48);
var import30 = __webpack_require__(28);
var import31 = __webpack_require__(33);
var Wrapper_ContentSpecialsComponent = (function () {
    function Wrapper_ContentSpecialsComponent(p0, p1, p2, p3, p4, p5, p6) {
        this.changed = false;
        this.context = new import0.ContentSpecialsComponent(p0, p1, p2, p3, p4, p5, p6);
    }
    Wrapper_ContentSpecialsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentSpecialsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentSpecialsComponent;
}());
exports.Wrapper_ContentSpecialsComponent = Wrapper_ContentSpecialsComponent;
var renderType_ContentSpecialsComponent_Host = null;
var _View_ContentSpecialsComponent_Host0 = (function (_super) {
    __extends(_View_ContentSpecialsComponent_Host0, _super);
    function _View_ContentSpecialsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialsComponent_Host0, renderType_ContentSpecialsComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentSpecialsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentSpecialsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentSpecialsComponent_0_4 = new Wrapper_ContentSpecialsComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.NotificationService), this.parentInjector.get(import10.UtilsService), this.parentInjector.get(import11.ContentService), this.parentInjector.get(import12.ActivatedRoute), this.parentInjector.get(import13.Location), this.parentInjector.get(import14.Router));
        this._appEl_0.initComponent(this._ContentSpecialsComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentSpecialsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentSpecialsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentSpecialsComponent) && (0 === requestNodeIndex))) {
            return this._ContentSpecialsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentSpecialsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentSpecialsComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentSpecialsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialsComponent_Host0;
}(import1.AppView));
function viewFactory_ContentSpecialsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentSpecialsComponent_Host === null)) {
        (renderType_ContentSpecialsComponent_Host = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentSpecialsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentSpecialsComponentNgFactory = new import16.ComponentFactory('ng-component', viewFactory_ContentSpecialsComponent_Host0, import0.ContentSpecialsComponent);
var styles_ContentSpecialsComponent = [];
var renderType_ContentSpecialsComponent = null;
var _View_ContentSpecialsComponent0 = (function (_super) {
    __extends(_View_ContentSpecialsComponent0, _super);
    function _View_ContentSpecialsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialsComponent0, renderType_ContentSpecialsComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_52 = import7.UNINITIALIZED;
        this._expr_53 = import7.UNINITIALIZED;
    }
    _View_ContentSpecialsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Parmi les interprètes d\'aujourd\'hui\n    ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_5 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_7 = this.renderer.createText(this._el_0, ' \n', null);
        this._text_8 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_9 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n  ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n\n  ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n  ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_13, 'div', new import4.InlineArray2(2, 'class', 'box'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n    ', null);
        this._el_17 = import4.createRenderElement(this.renderer, this._el_15, 'div', new import4.InlineArray2(2, 'class', 'box-body'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n\n      ', null);
        this._el_19 = import4.createRenderElement(this.renderer, this._el_17, 'table', new import4.InlineArray2(2, 'class', 'table table-striped table-hover'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n        ', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_19, 'thead', import4.EMPTY_INLINE_ARRAY, null);
        this._text_22 = this.renderer.createText(this._el_21, '\n          ', null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_21, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_24 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_25 = import4.createRenderElement(this.renderer, this._el_23, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_26 = this.renderer.createText(this._el_25, 'Statut', null);
        this._text_27 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_23, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_29 = this.renderer.createText(this._el_28, 'Date', null);
        this._text_30 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_31 = import4.createRenderElement(this.renderer, this._el_23, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_32 = this.renderer.createText(this._el_31, '', null);
        this._text_33 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_34 = import4.createRenderElement(this.renderer, this._el_23, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_35 = this.renderer.createText(this._el_34, '', null);
        this._text_36 = this.renderer.createText(this._el_23, '\n          ', null);
        this._text_37 = this.renderer.createText(this._el_21, '\n        ', null);
        this._text_38 = this.renderer.createText(this._el_19, '\n        ', null);
        this._el_39 = import4.createRenderElement(this.renderer, this._el_19, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_40 = this.renderer.createText(this._el_39, '\n          ', null);
        this._anchor_41 = this.renderer.createTemplateAnchor(this._el_39, null);
        this._appEl_41 = new import3.AppElement(41, 39, this, this._anchor_41);
        this._TemplateRef_41_5 = new import19.TemplateRef_(this._appEl_41, viewFactory_ContentSpecialsComponent1);
        this._NgFor_41_6 = new import17.Wrapper_NgFor(this._appEl_41.vcRef, this._TemplateRef_41_5, this.parentInjector.get(import20.IterableDiffers), this.ref);
        this._text_42 = this.renderer.createText(this._el_39, '\n        ', null);
        this._text_43 = this.renderer.createText(this._el_19, '\n      ', null);
        this._text_44 = this.renderer.createText(this._el_17, '\n\n\n    ', null);
        this._text_45 = this.renderer.createText(this._el_15, '\n  ', null);
        this._text_46 = this.renderer.createText(this._el_13, '\n  ', null);
        this._text_47 = this.renderer.createText(this._el_11, '\n  ', null);
        this._text_48 = this.renderer.createText(this._el_9, '\n', null);
        this._pipe_date_0 = new import18.DatePipe(this.parentInjector.get(import21.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._anchor_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._text_46,
            this._text_47,
            this._text_48
        ], [], []);
        return null;
    };
    _View_ContentSpecialsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import19.TemplateRef) && (41 === requestNodeIndex))) {
            return this._TemplateRef_41_5;
        }
        if (((token === import22.NgFor) && (41 === requestNodeIndex))) {
            return this._NgFor_41_6.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_41_0_0 = this.context.contents;
        this._NgFor_41_6.check_ngForOf(currVal_41_0_0, throwOnChange, false);
        this._NgFor_41_6.detectChangesInInputProps(this, this._anchor_41, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_52 = import4.interpolate(1, 'Titre (', this.context.currentLanguage, ')');
        if (import4.checkBinding(throwOnChange, this._expr_52, currVal_52)) {
            this.renderer.setText(this._text_32, currVal_52);
            this._expr_52 = currVal_52;
        }
        var currVal_53 = import4.interpolate(1, 'Sous-titre (', this.context.currentLanguage, ')');
        if (import4.checkBinding(throwOnChange, this._expr_53, currVal_53)) {
            this.renderer.setText(this._text_35, currVal_53);
            this._expr_53 = currVal_53;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentSpecialsComponent0;
}(import1.AppView));
function viewFactory_ContentSpecialsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentSpecialsComponent === null)) {
        (renderType_ContentSpecialsComponent = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, styles_ContentSpecialsComponent, {}));
    }
    return new _View_ContentSpecialsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentSpecialsComponent0 = viewFactory_ContentSpecialsComponent0;
var _View_ContentSpecialsComponent1 = (function (_super) {
    __extends(_View_ContentSpecialsComponent1, _super);
    function _View_ContentSpecialsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentSpecialsComponent1, renderType_ContentSpecialsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_26 = import7.UNINITIALIZED;
        this._expr_27 = import7.UNINITIALIZED;
        this._expr_28 = import7.UNINITIALIZED;
        this._expr_30 = import7.UNINITIALIZED;
        this._expr_31 = import7.UNINITIALIZED;
    }
    _View_ContentSpecialsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'switch material-switch'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'input', new import4.InlineArray2(2, 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_6_3 = new import23.Wrapper_CheckboxControlValueAccessor(this.renderer, new import26.ElementRef(this._el_6));
        this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
        this._NgModel_6_5 = new import24.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_6_4);
        this._NgControl_6_6 = this._NgModel_6_5.context;
        this._NgControlStatus_6_7 = new import25.Wrapper_NgControlStatus(this._NgControl_6_6);
        this._text_7 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_4, 'label', new import4.InlineArray2(2, 'class', 'label-primary'), null);
        this._text_9 = this.renderer.createText(this._el_4, '\n                ', null);
        this._text_10 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_19 = this.renderer.createText(this._el_18, '', null);
        this._text_20 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_6, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_6, 'change', this.eventHandler(this._handle_change_6_2.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_6, 'blur', this.eventHandler(this._handle_blur_6_3.bind(this)));
        var subscription_0 = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        this._pipe_date_0_0 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        var disposable_4 = this.renderer.listen(this._el_15, 'click', this.eventHandler(this._handle_click_15_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ], [subscription_0]);
        return null;
    };
    _View_ContentSpecialsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_6_3.context;
        }
        if (((token === import28.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_6_4;
        }
        if (((token === import29.NgModel) && (6 === requestNodeIndex))) {
            return this._NgModel_6_5.context;
        }
        if (((token === import30.NgControl) && (6 === requestNodeIndex))) {
            return this._NgControl_6_6;
        }
        if (((token === import31.NgControlStatus) && (6 === requestNodeIndex))) {
            return this._NgControlStatus_6_7.context;
        }
        return notFoundResult;
    };
    _View_ContentSpecialsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_6_1_0 = import4.interpolate(1, '', this.context.$implicit._id, '');
        this._NgModel_6_5.check_name(currVal_6_1_0, throwOnChange, false);
        var currVal_6_1_1 = this.context.$implicit.active;
        this._NgModel_6_5.check_model(currVal_6_1_1, throwOnChange, false);
        this._NgModel_6_5.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_26 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_26, currVal_26)) {
            this.renderer.setElementProperty(this._el_6, 'id', currVal_26);
            this._expr_26 = currVal_26;
        }
        this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgModel_6_5.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInHostProps(this, this._el_6, throwOnChange);
        var currVal_27 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_27, currVal_27)) {
            this.renderer.setElementAttribute(this._el_8, 'for', ((currVal_27 == null) ? null : currVal_27.toString()));
            this._expr_27 = currVal_27;
        }
        valUnwrapper.reset();
        var currVal_28 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(this.context.$implicit.date, 'MMM dd yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_13, currVal_28);
            this._expr_28 = currVal_28;
        }
        var currVal_30 = import4.interpolate(1, '\n            ', (this.context.$implicit.title ? this.context.$implicit.title[this.parent.context.currentLanguage] : '-'), '');
        if (import4.checkBinding(throwOnChange, this._expr_30, currVal_30)) {
            this.renderer.setText(this._text_16, currVal_30);
            this._expr_30 = currVal_30;
        }
        var currVal_31 = import4.interpolate(1, '', (this.context.$implicit.subtitle ? this.context.$implicit.subtitle[this.parent.context.currentLanguage] : '-'), '');
        if (import4.checkBinding(throwOnChange, this._expr_31, currVal_31)) {
            this.renderer.setText(this._text_19, currVal_31);
            this._expr_31 = currVal_31;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentSpecialsComponent1.prototype.destroyInternal = function () {
        this._NgModel_6_5.context.ngOnDestroy();
    };
    _View_ContentSpecialsComponent1.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.context.onStatusChange(!this.context.$implicit.active, this.context.$implicit) !== false);
        return (true && pd_6_0);
    };
    _View_ContentSpecialsComponent1.prototype._handle_ngModelChange_6_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = ((this.context.$implicit.active = $event) !== false);
        return (true && pd_6_0);
    };
    _View_ContentSpecialsComponent1.prototype._handle_change_6_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked) !== false);
        return (true && pd_6_0);
    };
    _View_ContentSpecialsComponent1.prototype._handle_blur_6_3 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onTouched() !== false);
        return (true && pd_6_0);
    };
    _View_ContentSpecialsComponent1.prototype._handle_click_15_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_15_0 = (this.parent.context.router.navigate([('special/edit/' + this.context.$implicit._id)], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_15_0);
    };
    return _View_ContentSpecialsComponent1;
}(import1.AppView));
function viewFactory_ContentSpecialsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentSpecialsComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(160);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(46);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(38);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(17);
var import12 = __webpack_require__(25);
var import13 = __webpack_require__(2);
var import14 = __webpack_require__(73);
var import15 = __webpack_require__(15);
var import16 = __webpack_require__(9);
var import17 = __webpack_require__(16);
var import18 = __webpack_require__(11);
var import19 = __webpack_require__(10);
var import20 = __webpack_require__(56);
var import21 = __webpack_require__(22);
var import22 = __webpack_require__(82);
var import23 = __webpack_require__(14);
var import24 = __webpack_require__(39);
var import25 = __webpack_require__(19);
var import26 = __webpack_require__(114);
var import27 = __webpack_require__(43);
var import28 = __webpack_require__(64);
var import29 = __webpack_require__(113);
var import30 = __webpack_require__(85);
var import31 = __webpack_require__(115);
var import32 = __webpack_require__(24);
var import33 = __webpack_require__(18);
var import34 = __webpack_require__(20);
var import35 = __webpack_require__(41);
var import36 = __webpack_require__(26);
var import37 = __webpack_require__(61);
var import38 = __webpack_require__(28);
var import39 = __webpack_require__(33);
var import40 = __webpack_require__(47);
var import41 = __webpack_require__(21);
var import42 = __webpack_require__(54);
var import43 = __webpack_require__(37);
var import44 = __webpack_require__(53);
var import45 = __webpack_require__(162);
var import46 = __webpack_require__(96);
var Wrapper_ContentWritingEditComponent = (function () {
    function Wrapper_ContentWritingEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8) {
        this.changed = false;
        this.context = new import0.ContentWritingEditComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8);
    }
    Wrapper_ContentWritingEditComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentWritingEditComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentWritingEditComponent;
}());
exports.Wrapper_ContentWritingEditComponent = Wrapper_ContentWritingEditComponent;
var renderType_ContentWritingEditComponent_Host = null;
var _View_ContentWritingEditComponent_Host0 = (function (_super) {
    __extends(_View_ContentWritingEditComponent_Host0, _super);
    function _View_ContentWritingEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent_Host0, renderType_ContentWritingEditComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentWritingEditComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._ContentWritingEditComponent_0_5 = new Wrapper_ContentWritingEditComponent(this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.IntlService), this.parentInjector.get(import12.MetaService), this.parentInjector.get(import13.UtilsService), this._DatePipe_0_4, this.parentInjector.get(import14.FormBuilder), this.parentInjector.get(import15.Router), this.parentInjector.get(import16.ContentService), this.parentInjector.get(import17.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentWritingEditComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentWritingEditComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentWritingEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.DatePipe) && (0 === requestNodeIndex))) {
            return this._DatePipe_0_4;
        }
        if (((token === import0.ContentWritingEditComponent) && (0 === requestNodeIndex))) {
            return this._ContentWritingEditComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentWritingEditComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentWritingEditComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingEditComponent_Host0;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingEditComponent_Host === null)) {
        (renderType_ContentWritingEditComponent_Host = viewUtils.createRenderComponentType('', 0, import18.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentWritingEditComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentWritingEditComponentNgFactory = new import19.ComponentFactory('ng-component', viewFactory_ContentWritingEditComponent_Host0, import0.ContentWritingEditComponent);
var styles_ContentWritingEditComponent = [];
var renderType_ContentWritingEditComponent = null;
var _View_ContentWritingEditComponent0 = (function (_super) {
    __extends(_View_ContentWritingEditComponent0, _super);
    function _View_ContentWritingEditComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent0, renderType_ContentWritingEditComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '      ', null);
        this._el_1 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content-header'), null);
        this._text_2 = this.renderer.createText(this._el_1, '\n          ', null);
        this._el_3 = import5.createRenderElement(this.renderer, this._el_1, 'h1', import5.EMPTY_INLINE_ARRAY, null);
        this._NgSwitch_3_3 = new import20.Wrapper_NgSwitch();
        this._text_4 = this.renderer.createText(this._el_3, '\n              ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_5 = new import3.AppElement(5, 3, this, this._anchor_5);
        this._TemplateRef_5_5 = new import23.TemplateRef_(this._appEl_5, viewFactory_ContentWritingEditComponent1);
        this._NgSwitchCase_5_6 = new import20.Wrapper_NgSwitchCase(this._appEl_5.vcRef, this._TemplateRef_5_5, this._NgSwitch_3_3.context);
        this._text_6 = this.renderer.createText(this._el_3, '\n              ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_7 = new import3.AppElement(7, 3, this, this._anchor_7);
        this._TemplateRef_7_5 = new import23.TemplateRef_(this._appEl_7, viewFactory_ContentWritingEditComponent2);
        this._NgSwitchCase_7_6 = new import20.Wrapper_NgSwitchCase(this._appEl_7.vcRef, this._TemplateRef_7_5, this._NgSwitch_3_3.context);
        this._text_8 = this.renderer.createText(this._el_3, '\n              ', null);
        this._anchor_9 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_9 = new import3.AppElement(9, 3, this, this._anchor_9);
        this._TemplateRef_9_5 = new import23.TemplateRef_(this._appEl_9, viewFactory_ContentWritingEditComponent3);
        this._NgIf_9_6 = new import21.Wrapper_NgIf(this._appEl_9.vcRef, this._TemplateRef_9_5);
        this._text_10 = this.renderer.createText(this._el_3, '\n              ', null);
        this._anchor_11 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_11 = new import3.AppElement(11, 3, this, this._anchor_11);
        this._TemplateRef_11_5 = new import23.TemplateRef_(this._appEl_11, viewFactory_ContentWritingEditComponent4);
        this._NgSwitchCase_11_6 = new import20.Wrapper_NgSwitchCase(this._appEl_11.vcRef, this._TemplateRef_11_5, this._NgSwitch_3_3.context);
        this._text_12 = this.renderer.createText(this._el_3, '\n          ', null);
        this._text_13 = this.renderer.createText(this._el_1, '\n        ', null);
        this._text_14 = this.renderer.createText(parentRenderNode, '\n\n      ', null);
        this._el_15 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'content'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n        ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_15, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n          ', null);
        this._el_19 = import5.createRenderElement(this.renderer, this._el_17, 'div', new import5.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n            ', null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_19, 'div', new import5.InlineArray2(2, 'class', 'box'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n              ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_21, 'div', new import5.InlineArray2(2, 'class', 'box-body'), null);
        this._text_24 = this.renderer.createText(this._el_23, '\n      \n                ', null);
        this._anchor_25 = this.renderer.createTemplateAnchor(this._el_23, null);
        this._appEl_25 = new import3.AppElement(25, 23, this, this._anchor_25);
        this._TemplateRef_25_5 = new import23.TemplateRef_(this._appEl_25, viewFactory_ContentWritingEditComponent5);
        this._NgIf_25_6 = new import21.Wrapper_NgIf(this._appEl_25.vcRef, this._TemplateRef_25_5);
        this._text_26 = this.renderer.createText(this._el_23, '\n      \n      \n              ', null);
        this._text_27 = this.renderer.createText(this._el_21, '\n              ', null);
        this._text_28 = this.renderer.createText(this._el_21, '\n            ', null);
        this._text_29 = this.renderer.createText(this._el_19, '\n          ', null);
        this._text_30 = this.renderer.createText(this._el_17, '\n        ', null);
        this._text_31 = this.renderer.createText(this._el_15, '\n      ', null);
        this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
        this._pipe_uppercase_1 = new import22.UpperCasePipe();
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._anchor_9,
            this._text_10,
            this._anchor_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._anchor_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._text_31
        ], [], []);
        return null;
    };
    _View_ContentWritingEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import24.NgSwitchCase) && (5 === requestNodeIndex))) {
            return this._NgSwitchCase_5_6.context;
        }
        if (((token === import23.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import24.NgSwitchCase) && (7 === requestNodeIndex))) {
            return this._NgSwitchCase_7_6.context;
        }
        if (((token === import23.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import25.NgIf) && (9 === requestNodeIndex))) {
            return this._NgIf_9_6.context;
        }
        if (((token === import23.TemplateRef) && (11 === requestNodeIndex))) {
            return this._TemplateRef_11_5;
        }
        if (((token === import24.NgSwitchCase) && (11 === requestNodeIndex))) {
            return this._NgSwitchCase_11_6.context;
        }
        if (((token === import24.NgSwitch) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 12)))) {
            return this._NgSwitch_3_3.context;
        }
        if (((token === import23.TemplateRef) && (25 === requestNodeIndex))) {
            return this._TemplateRef_25_5;
        }
        if (((token === import25.NgIf) && (25 === requestNodeIndex))) {
            return this._NgIf_25_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = this.context.action;
        this._NgSwitch_3_3.check_ngSwitch(currVal_3_0_0, throwOnChange, false);
        this._NgSwitch_3_3.detectChangesInInputProps(this, this._el_3, throwOnChange);
        var currVal_5_0_0 = 'add';
        this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0, throwOnChange, false);
        this._NgSwitchCase_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = 'update';
        this._NgSwitchCase_7_6.check_ngSwitchCase(currVal_7_0_0, throwOnChange, false);
        this._NgSwitchCase_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        var currVal_9_0_0 = (this.context.content && (this.context.action == 'update'));
        this._NgIf_9_6.check_ngIf(currVal_9_0_0, throwOnChange, false);
        this._NgIf_9_6.detectChangesInInputProps(this, this._anchor_9, throwOnChange);
        var currVal_11_0_0 = 'update';
        this._NgSwitchCase_11_6.check_ngSwitchCase(currVal_11_0_0, throwOnChange, false);
        this._NgSwitchCase_11_6.detectChangesInInputProps(this, this._anchor_11, throwOnChange);
        var currVal_25_0_0 = (this.context.content || (this.context.action == 'add'));
        this._NgIf_25_6.check_ngIf(currVal_25_0_0, throwOnChange, false);
        this._NgIf_25_6.detectChangesInInputProps(this, this._anchor_25, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_3_3.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingEditComponent0;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingEditComponent === null)) {
        (renderType_ContentWritingEditComponent = viewUtils.createRenderComponentType('', 0, import18.ViewEncapsulation.None, styles_ContentWritingEditComponent, {}));
    }
    return new _View_ContentWritingEditComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentWritingEditComponent0 = viewFactory_ContentWritingEditComponent0;
var _View_ContentWritingEditComponent1 = (function (_super) {
    __extends(_View_ContentWritingEditComponent1, _super);
    function _View_ContentWritingEditComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent1, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Nouvel écrit', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentWritingEditComponent1;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent2 = (function (_super) {
    __extends(_View_ContentWritingEditComponent2, _super);
    function _View_ContentWritingEditComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent2, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, 'Edition ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentWritingEditComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_4 = import5.interpolate(1, '', ((this.parent.context.content == null) ? null : this.parent.context.content.cid), '');
        if (import5.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingEditComponent2;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent3 = (function (_super) {
    __extends(_View_ContentWritingEditComponent3, _super);
    function _View_ContentWritingEditComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent3, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'lLink'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_3 = this.renderer.createText(this._el_2, 'Supprimer', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n              ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingEditComponent3.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.deleteContent('writing', this.parent.context.content._id) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentWritingEditComponent3;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent4 = (function (_super) {
    __extends(_View_ContentWritingEditComponent4, _super);
    function _View_ContentWritingEditComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent4, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ' ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_date_0_0 = import5.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentWritingEditComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import5.interpolate(1, '(modifié: ', valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(((this.parent.context.content == null) ? null : this.parent.context.content.update_date), 'dd MMM yyyy')), ')');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingEditComponent4;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent5 = (function (_super) {
    __extends(_View_ContentWritingEditComponent5, _super);
    function _View_ContentWritingEditComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent5, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_145 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'form', import5.EMPTY_INLINE_ARRAY, null);
        this._FormGroupDirective_0_3 = new import26.Wrapper_FormGroupDirective(null, null);
        this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
        this._NgControlStatusGroup_0_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n      \n                  ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'panel panel-default'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n      \n                    ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Métadonnées', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_7 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                      ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_7, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'col-md-1 col-sm-1 input-group switch material-switch'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                              ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'input', new import5.InlineArray8(8, 'formControlName', 'active', 'id', 'act', 'name', 'act', 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_13_3 = new import28.Wrapper_CheckboxControlValueAccessor(this.renderer, new import33.ElementRef(this._el_13));
        this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
        this._FormControlName_13_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_13_4);
        this._NgControl_13_6 = this._FormControlName_13_5.context;
        this._NgControlStatus_13_7 = new import27.Wrapper_NgControlStatus(this._NgControl_13_6);
        this._text_14 = this.renderer.createText(this._el_11, '\n                              ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_11, 'label', new import5.InlineArray4(4, 'class', 'label-primary', 'for', 'act'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._text_17 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._el_18 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'input-group col-lg-3 col-md-3 col-sm-4'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                            ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_18, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_20, 'i', new import5.InlineArray2(2, 'class', 'fa fa-user'), null);
        this._text_22 = this.renderer.createText(this._el_18, '\n                            ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_18, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'author', 'type', 'text'), null);
        this._DefaultValueAccessor_23_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_23));
        this._NG_VALUE_ACCESSOR_23_4 = [this._DefaultValueAccessor_23_3.context];
        this._FormControlName_23_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_23_4);
        this._NgControl_23_6 = this._FormControlName_23_5.context;
        this._NgControlStatus_23_7 = new import27.Wrapper_NgControlStatus(this._NgControl_23_6);
        this._text_24 = this.renderer.createText(this._el_18, '\n                        ', null);
        this._text_25 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._el_26 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'input-group col-lg-5 col-md-5 col-sm-5'), null);
        this._text_27 = this.renderer.createText(this._el_26, '\n                            ', null);
        this._el_28 = import5.createRenderElement(this.renderer, this._el_26, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon addon-width'), null);
        this._el_29 = import5.createRenderElement(this.renderer, this._el_28, 'i', new import5.InlineArray2(2, 'class', 'fa fa-external-link'), null);
        this._text_30 = this.renderer.createText(this._el_26, '\n                            ', null);
        this._el_31 = import5.createRenderElement(this.renderer, this._el_26, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'url', 'type', 'text'), null);
        this._DefaultValueAccessor_31_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_31));
        this._NG_VALUE_ACCESSOR_31_4 = [this._DefaultValueAccessor_31_3.context];
        this._FormControlName_31_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_31_4);
        this._NgControl_31_6 = this._FormControlName_31_5.context;
        this._NgControlStatus_31_7 = new import27.Wrapper_NgControlStatus(this._NgControl_31_6);
        this._text_32 = this.renderer.createText(this._el_26, '\n                        ', null);
        this._text_33 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._el_34 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray4(4, 'class', 'input-group col-lg-2 col-md-2 col-sm-5', 'style', 'max-width: 200px'), null);
        this._text_35 = this.renderer.createText(this._el_34, '\n                          ', null);
        this._el_36 = import5.createRenderElement(this.renderer, this._el_34, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_37 = import5.createRenderElement(this.renderer, this._el_36, 'i', new import5.InlineArray2(2, 'class', 'fa fa-calendar'), null);
        this._text_38 = this.renderer.createText(this._el_34, '\n                          ', null);
        this._text_39 = this.renderer.createText(this._el_34, '\n                          ', null);
        this._el_40 = import5.createRenderElement(this.renderer, this._el_34, 'input', new import5.InlineArray8(6, 'class', 'form-control', 'formControlName', 'date', 'type', 'text'), null);
        this._DefaultValueAccessor_40_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_40));
        this._NG_VALUE_ACCESSOR_40_4 = [this._DefaultValueAccessor_40_3.context];
        this._FormControlName_40_5 = new import29.Wrapper_FormControlName(this._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_40_4);
        this._NgControl_40_6 = this._FormControlName_40_5.context;
        this._NgControlStatus_40_7 = new import27.Wrapper_NgControlStatus(this._NgControl_40_6);
        this._text_41 = this.renderer.createText(this._el_34, '\n                        ', null);
        this._text_42 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._text_43 = this.renderer.createText(this._el_9, '\n                      ', null);
        this._text_44 = this.renderer.createText(this._el_7, '\n                    ', null);
        this._text_45 = this.renderer.createText(this._el_2, '\n      \n                    ', null);
        this._el_46 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_47 = this.renderer.createText(this._el_46, 'Titre', null);
        this._text_48 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_50 = this.renderer.createText(this._el_49, '\n                      ', null);
        this._el_51 = import5.createRenderElement(this.renderer, this._el_49, 'div', new import5.InlineArray2(2, 'formGroupName', 'title'), null);
        this._FormGroupName_51_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_51_4 = this._FormGroupName_51_3.context;
        this._NgControlStatusGroup_51_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_51_4);
        this._text_52 = this.renderer.createText(this._el_51, '\n                        ', null);
        this._anchor_53 = this.renderer.createTemplateAnchor(this._el_51, null);
        this._appEl_53 = new import3.AppElement(53, 51, this, this._anchor_53);
        this._TemplateRef_53_5 = new import23.TemplateRef_(this._appEl_53, viewFactory_ContentWritingEditComponent6);
        this._NgFor_53_6 = new import32.Wrapper_NgFor(this._appEl_53.vcRef, this._TemplateRef_53_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_54 = this.renderer.createText(this._el_51, '\n                      ', null);
        this._text_55 = this.renderer.createText(this._el_49, '\n                    ', null);
        this._text_56 = this.renderer.createText(this._el_2, '\n\n                    ', null);
        this._el_57 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_58 = this.renderer.createText(this._el_57, 'Résumé', null);
        this._text_59 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_60 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_61 = this.renderer.createText(this._el_60, '\n                      ', null);
        this._el_62 = import5.createRenderElement(this.renderer, this._el_60, 'div', new import5.InlineArray2(2, 'formGroupName', 'summary'), null);
        this._FormGroupName_62_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_62_4 = this._FormGroupName_62_3.context;
        this._NgControlStatusGroup_62_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_62_4);
        this._text_63 = this.renderer.createText(this._el_62, '\n                        ', null);
        this._anchor_64 = this.renderer.createTemplateAnchor(this._el_62, null);
        this._appEl_64 = new import3.AppElement(64, 62, this, this._anchor_64);
        this._TemplateRef_64_5 = new import23.TemplateRef_(this._appEl_64, viewFactory_ContentWritingEditComponent7);
        this._NgFor_64_6 = new import32.Wrapper_NgFor(this._appEl_64.vcRef, this._TemplateRef_64_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_65 = this.renderer.createText(this._el_62, '\n                      ', null);
        this._text_66 = this.renderer.createText(this._el_60, '\n                    ', null);
        this._text_67 = this.renderer.createText(this._el_2, '\n', null);
        this._text_68 = this.renderer.createText(this._el_2, '\n\n                    ', null);
        this._el_69 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_70 = this.renderer.createText(this._el_69, 'Contenu', null);
        this._text_71 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_72 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-body'), null);
        this._text_73 = this.renderer.createText(this._el_72, '\n                      ', null);
        this._el_74 = import5.createRenderElement(this.renderer, this._el_72, 'div', new import5.InlineArray2(2, 'formGroupName', 'content'), null);
        this._FormGroupName_74_3 = new import31.Wrapper_FormGroupName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_74_4 = this._FormGroupName_74_3.context;
        this._NgControlStatusGroup_74_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_74_4);
        this._text_75 = this.renderer.createText(this._el_74, '\n                        ', null);
        this._anchor_76 = this.renderer.createTemplateAnchor(this._el_74, null);
        this._appEl_76 = new import3.AppElement(76, 74, this, this._anchor_76);
        this._TemplateRef_76_5 = new import23.TemplateRef_(this._appEl_76, viewFactory_ContentWritingEditComponent8);
        this._NgFor_76_6 = new import32.Wrapper_NgFor(this._appEl_76.vcRef, this._TemplateRef_76_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_77 = this.renderer.createText(this._el_74, '\n                      ', null);
        this._text_78 = this.renderer.createText(this._el_72, '\n                    ', null);
        this._text_79 = this.renderer.createText(this._el_2, '\n      \n                    ', null);
        this._el_80 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'panel-heading'), null);
        this._text_81 = this.renderer.createText(this._el_80, 'Tags', null);
        this._text_82 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_83 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray4(4, 'class', 'panel-body', 'formArrayName', 'tags'), null);
        this._FormArrayName_83_3 = new import31.Wrapper_FormArrayName(this._ControlContainer_0_4, null, null);
        this._ControlContainer_83_4 = this._FormArrayName_83_3.context;
        this._NgControlStatusGroup_83_5 = new import27.Wrapper_NgControlStatusGroup(this._ControlContainer_83_4);
        this._text_84 = this.renderer.createText(this._el_83, '\n                      ', null);
        this._el_85 = import5.createRenderElement(this.renderer, this._el_83, 'div', new import5.InlineArray2(2, 'class', 'form-inline'), null);
        this._text_86 = this.renderer.createText(this._el_85, '\n                        ', null);
        this._anchor_87 = this.renderer.createTemplateAnchor(this._el_85, null);
        this._appEl_87 = new import3.AppElement(87, 85, this, this._anchor_87);
        this._TemplateRef_87_5 = new import23.TemplateRef_(this._appEl_87, viewFactory_ContentWritingEditComponent9);
        this._NgFor_87_6 = new import32.Wrapper_NgFor(this._appEl_87.vcRef, this._TemplateRef_87_5, this.parent.parentInjector.get(import34.IterableDiffers), this.parent.ref);
        this._text_88 = this.renderer.createText(this._el_85, '\n                        ', null);
        this._el_89 = import5.createRenderElement(this.renderer, this._el_85, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-plus clickLink'), null);
        this._text_90 = this.renderer.createText(this._el_89, ' ', null);
        this._text_91 = this.renderer.createText(this._el_85, '\n                      ', null);
        this._text_92 = this.renderer.createText(this._el_83, '\n                    ', null);
        this._text_93 = this.renderer.createText(this._el_2, '\n      \n                    ', null);
        this._el_94 = import5.createRenderElement(this.renderer, this._el_2, 'button', new import5.InlineArray4(4, 'class', 'btn btn-info pull-right', 'type', 'submit'), null);
        this._text_95 = this.renderer.createText(this._el_94, '\n              Sauvegarder\n            ', null);
        this._text_96 = this.renderer.createText(this._el_2, '\n      \n                  ', null);
        this._text_97 = this.renderer.createText(this._el_0, '\n      \n                ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'ngSubmit', this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_0, 'submit', this.eventHandler(this._handle_submit_0_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_0, 'reset', this.eventHandler(this._handle_reset_0_2.bind(this)));
        var subscription_0 = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_13, 'change', this.eventHandler(this._handle_change_13_0.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_13, 'blur', this.eventHandler(this._handle_blur_13_1.bind(this)));
        var disposable_5 = this.renderer.listen(this._el_23, 'input', this.eventHandler(this._handle_input_23_0.bind(this)));
        var disposable_6 = this.renderer.listen(this._el_23, 'blur', this.eventHandler(this._handle_blur_23_1.bind(this)));
        var disposable_7 = this.renderer.listen(this._el_31, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_31_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_31, 'input', this.eventHandler(this._handle_input_31_1.bind(this)));
        var disposable_9 = this.renderer.listen(this._el_31, 'blur', this.eventHandler(this._handle_blur_31_2.bind(this)));
        var subscription_1 = this._FormControlName_31_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_31_0.bind(this)));
        var disposable_10 = this.renderer.listen(this._el_40, 'input', this.eventHandler(this._handle_input_40_0.bind(this)));
        var disposable_11 = this.renderer.listen(this._el_40, 'blur', this.eventHandler(this._handle_blur_40_1.bind(this)));
        var disposable_12 = this.renderer.listen(this._el_89, 'click', this.eventHandler(this._handle_click_89_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._el_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._el_36,
            this._el_37,
            this._text_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._el_46,
            this._text_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._el_51,
            this._text_52,
            this._anchor_53,
            this._text_54,
            this._text_55,
            this._text_56,
            this._el_57,
            this._text_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._anchor_64,
            this._text_65,
            this._text_66,
            this._text_67,
            this._text_68,
            this._el_69,
            this._text_70,
            this._text_71,
            this._el_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._anchor_76,
            this._text_77,
            this._text_78,
            this._text_79,
            this._el_80,
            this._text_81,
            this._text_82,
            this._el_83,
            this._text_84,
            this._el_85,
            this._text_86,
            this._anchor_87,
            this._text_88,
            this._el_89,
            this._text_90,
            this._text_91,
            this._text_92,
            this._text_93,
            this._el_94,
            this._text_95,
            this._text_96,
            this._text_97
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8,
            disposable_9,
            disposable_10,
            disposable_11,
            disposable_12
        ], [
            subscription_0,
            subscription_1
        ]);
        return null;
    };
    _View_ContentWritingEditComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import35.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_13_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_13_4;
        }
        if (((token === import37.FormControlName) && (13 === requestNodeIndex))) {
            return this._FormControlName_13_5.context;
        }
        if (((token === import38.NgControl) && (13 === requestNodeIndex))) {
            return this._NgControl_13_6;
        }
        if (((token === import39.NgControlStatus) && (13 === requestNodeIndex))) {
            return this._NgControlStatus_13_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (23 === requestNodeIndex))) {
            return this._DefaultValueAccessor_23_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (23 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_23_4;
        }
        if (((token === import37.FormControlName) && (23 === requestNodeIndex))) {
            return this._FormControlName_23_5.context;
        }
        if (((token === import38.NgControl) && (23 === requestNodeIndex))) {
            return this._NgControl_23_6;
        }
        if (((token === import39.NgControlStatus) && (23 === requestNodeIndex))) {
            return this._NgControlStatus_23_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (31 === requestNodeIndex))) {
            return this._DefaultValueAccessor_31_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (31 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_31_4;
        }
        if (((token === import37.FormControlName) && (31 === requestNodeIndex))) {
            return this._FormControlName_31_5.context;
        }
        if (((token === import38.NgControl) && (31 === requestNodeIndex))) {
            return this._NgControl_31_6;
        }
        if (((token === import39.NgControlStatus) && (31 === requestNodeIndex))) {
            return this._NgControlStatus_31_7.context;
        }
        if (((token === import40.DefaultValueAccessor) && (40 === requestNodeIndex))) {
            return this._DefaultValueAccessor_40_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (40 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_40_4;
        }
        if (((token === import37.FormControlName) && (40 === requestNodeIndex))) {
            return this._FormControlName_40_5.context;
        }
        if (((token === import38.NgControl) && (40 === requestNodeIndex))) {
            return this._NgControl_40_6;
        }
        if (((token === import39.NgControlStatus) && (40 === requestNodeIndex))) {
            return this._NgControlStatus_40_7.context;
        }
        if (((token === import23.TemplateRef) && (53 === requestNodeIndex))) {
            return this._TemplateRef_53_5;
        }
        if (((token === import41.NgFor) && (53 === requestNodeIndex))) {
            return this._NgFor_53_6.context;
        }
        if (((token === import42.FormGroupName) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._FormGroupName_51_3.context;
        }
        if (((token === import43.ControlContainer) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._ControlContainer_51_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((51 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._NgControlStatusGroup_51_5.context;
        }
        if (((token === import23.TemplateRef) && (64 === requestNodeIndex))) {
            return this._TemplateRef_64_5;
        }
        if (((token === import41.NgFor) && (64 === requestNodeIndex))) {
            return this._NgFor_64_6.context;
        }
        if (((token === import42.FormGroupName) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._FormGroupName_62_3.context;
        }
        if (((token === import43.ControlContainer) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._ControlContainer_62_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((62 <= requestNodeIndex) && (requestNodeIndex <= 65)))) {
            return this._NgControlStatusGroup_62_5.context;
        }
        if (((token === import23.TemplateRef) && (76 === requestNodeIndex))) {
            return this._TemplateRef_76_5;
        }
        if (((token === import41.NgFor) && (76 === requestNodeIndex))) {
            return this._NgFor_76_6.context;
        }
        if (((token === import42.FormGroupName) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._FormGroupName_74_3.context;
        }
        if (((token === import43.ControlContainer) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._ControlContainer_74_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) {
            return this._NgControlStatusGroup_74_5.context;
        }
        if (((token === import23.TemplateRef) && (87 === requestNodeIndex))) {
            return this._TemplateRef_87_5;
        }
        if (((token === import41.NgFor) && (87 === requestNodeIndex))) {
            return this._NgFor_87_6.context;
        }
        if (((token === import42.FormArrayName) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) {
            return this._FormArrayName_83_3.context;
        }
        if (((token === import43.ControlContainer) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) {
            return this._ControlContainer_83_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((83 <= requestNodeIndex) && (requestNodeIndex <= 92)))) {
            return this._NgControlStatusGroup_83_5.context;
        }
        if (((token === import44.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) {
            return this._FormGroupDirective_0_3.context;
        }
        if (((token === import43.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import39.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 97)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.context.writingForm;
        this._FormGroupDirective_0_3.check_form(currVal_0_0_0, throwOnChange, false);
        this._FormGroupDirective_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this, this._el_13, throwOnChange);
        var currVal_13_1_0 = 'active';
        this._FormControlName_13_5.check_name(currVal_13_1_0, throwOnChange, false);
        this._FormControlName_13_5.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInInputProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_23_3.detectChangesInInputProps(this, this._el_23, throwOnChange);
        var currVal_23_1_0 = 'author';
        this._FormControlName_23_5.check_name(currVal_23_1_0, throwOnChange, false);
        this._FormControlName_23_5.detectChangesInInputProps(this, this._el_23, throwOnChange);
        this._NgControlStatus_23_7.detectChangesInInputProps(this, this._el_23, throwOnChange);
        this._DefaultValueAccessor_31_3.detectChangesInInputProps(this, this._el_31, throwOnChange);
        var currVal_31_1_0 = 'url';
        this._FormControlName_31_5.check_name(currVal_31_1_0, throwOnChange, false);
        var currVal_31_1_1 = this.parent.context.url;
        this._FormControlName_31_5.check_model(currVal_31_1_1, throwOnChange, false);
        this._FormControlName_31_5.detectChangesInInputProps(this, this._el_31, throwOnChange);
        this._NgControlStatus_31_7.detectChangesInInputProps(this, this._el_31, throwOnChange);
        this._DefaultValueAccessor_40_3.detectChangesInInputProps(this, this._el_40, throwOnChange);
        var currVal_40_1_0 = 'date';
        this._FormControlName_40_5.check_name(currVal_40_1_0, throwOnChange, false);
        this._FormControlName_40_5.detectChangesInInputProps(this, this._el_40, throwOnChange);
        this._NgControlStatus_40_7.detectChangesInInputProps(this, this._el_40, throwOnChange);
        var currVal_51_0_0 = 'title';
        this._FormGroupName_51_3.check_name(currVal_51_0_0, throwOnChange, false);
        this._FormGroupName_51_3.detectChangesInInputProps(this, this._el_51, throwOnChange);
        this._NgControlStatusGroup_51_5.detectChangesInInputProps(this, this._el_51, throwOnChange);
        var currVal_53_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_53_6.check_ngForOf(currVal_53_0_0, throwOnChange, false);
        this._NgFor_53_6.detectChangesInInputProps(this, this._anchor_53, throwOnChange);
        var currVal_62_0_0 = 'summary';
        this._FormGroupName_62_3.check_name(currVal_62_0_0, throwOnChange, false);
        this._FormGroupName_62_3.detectChangesInInputProps(this, this._el_62, throwOnChange);
        this._NgControlStatusGroup_62_5.detectChangesInInputProps(this, this._el_62, throwOnChange);
        var currVal_64_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_64_6.check_ngForOf(currVal_64_0_0, throwOnChange, false);
        this._NgFor_64_6.detectChangesInInputProps(this, this._anchor_64, throwOnChange);
        var currVal_74_0_0 = 'content';
        this._FormGroupName_74_3.check_name(currVal_74_0_0, throwOnChange, false);
        this._FormGroupName_74_3.detectChangesInInputProps(this, this._el_74, throwOnChange);
        this._NgControlStatusGroup_74_5.detectChangesInInputProps(this, this._el_74, throwOnChange);
        var currVal_76_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_76_6.check_ngForOf(currVal_76_0_0, throwOnChange, false);
        this._NgFor_76_6.detectChangesInInputProps(this, this._anchor_76, throwOnChange);
        var currVal_83_0_0 = 'tags';
        this._FormArrayName_83_3.check_name(currVal_83_0_0, throwOnChange, false);
        this._FormArrayName_83_3.detectChangesInInputProps(this, this._el_83, throwOnChange);
        this._NgControlStatusGroup_83_5.detectChangesInInputProps(this, this._el_83, throwOnChange);
        var currVal_87_0_0 = this.parent.context.writingForm.controls.tags.controls;
        this._NgFor_87_6.check_ngForOf(currVal_87_0_0, throwOnChange, false);
        this._NgFor_87_6.detectChangesInInputProps(this, this._anchor_87, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FormGroupDirective_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._FormControlName_13_5.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._NgControlStatus_13_7.detectChangesInHostProps(this, this._el_13, throwOnChange);
        this._DefaultValueAccessor_23_3.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._FormControlName_23_5.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._NgControlStatus_23_7.detectChangesInHostProps(this, this._el_23, throwOnChange);
        this._DefaultValueAccessor_31_3.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._FormControlName_31_5.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._NgControlStatus_31_7.detectChangesInHostProps(this, this._el_31, throwOnChange);
        this._DefaultValueAccessor_40_3.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._FormControlName_40_5.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._NgControlStatus_40_7.detectChangesInHostProps(this, this._el_40, throwOnChange);
        this._FormGroupName_51_3.detectChangesInHostProps(this, this._el_51, throwOnChange);
        this._NgControlStatusGroup_51_5.detectChangesInHostProps(this, this._el_51, throwOnChange);
        this._FormGroupName_62_3.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._NgControlStatusGroup_62_5.detectChangesInHostProps(this, this._el_62, throwOnChange);
        this._FormGroupName_74_3.detectChangesInHostProps(this, this._el_74, throwOnChange);
        this._NgControlStatusGroup_74_5.detectChangesInHostProps(this, this._el_74, throwOnChange);
        this._FormArrayName_83_3.detectChangesInHostProps(this, this._el_83, throwOnChange);
        this._NgControlStatusGroup_83_5.detectChangesInHostProps(this, this._el_83, throwOnChange);
        var currVal_145 = !this.parent.context.writingForm.valid;
        if (import5.checkBinding(throwOnChange, this._expr_145, currVal_145)) {
            this.renderer.setElementProperty(this._el_94, 'disabled', currVal_145);
            this._expr_145 = currVal_145;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingEditComponent5.prototype.destroyInternal = function () {
        this._FormControlName_13_5.context.ngOnDestroy();
        this._FormControlName_23_5.context.ngOnDestroy();
        this._FormControlName_31_5.context.ngOnDestroy();
        this._FormControlName_40_5.context.ngOnDestroy();
        this._FormArrayName_83_3.context.ngOnDestroy();
    };
    _View_ContentWritingEditComponent5.prototype._handle_ngSubmit_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onSubmit() !== false);
        return (true && pd_0_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_submit_0_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onSubmit($event) !== false);
        return (true && pd_0_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_reset_0_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this._FormGroupDirective_0_3.context.onReset() !== false);
        return (true && pd_0_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_change_13_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked) !== false);
        return (true && pd_13_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_blur_13_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_13_0 = (this._CheckboxControlValueAccessor_13_3.context.onTouched() !== false);
        return (true && pd_13_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_input_23_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this._DefaultValueAccessor_23_3.context.onChange($event.target.value) !== false);
        return (true && pd_23_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_blur_23_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this._DefaultValueAccessor_23_3.context.onTouched() !== false);
        return (true && pd_23_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_ngModelChange_31_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = ((this.parent.context.url = $event) !== false);
        return (true && pd_31_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_input_31_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = (this._DefaultValueAccessor_31_3.context.onChange($event.target.value) !== false);
        return (true && pd_31_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_blur_31_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_31_0 = (this._DefaultValueAccessor_31_3.context.onTouched() !== false);
        return (true && pd_31_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_input_40_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_40_0 = (this._DefaultValueAccessor_40_3.context.onChange($event.target.value) !== false);
        return (true && pd_40_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_blur_40_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_40_0 = (this._DefaultValueAccessor_40_3.context.onTouched() !== false);
        return (true && pd_40_0);
    };
    _View_ContentWritingEditComponent5.prototype._handle_click_89_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_89_0 = (this.parent.context.onAddTag() !== false);
        return (true && pd_89_0);
    };
    return _View_ContentWritingEditComponent5;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent6 = (function (_super) {
    __extends(_View_ContentWritingEditComponent6, _super);
    function _View_ContentWritingEditComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent6, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import29.Wrapper_FormControlName(this.parent._ControlContainer_51_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._pipe_uppercase_1_0 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentWritingEditComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import37.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import38.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingEditComponent6.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentWritingEditComponent6.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentWritingEditComponent6.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentWritingEditComponent6;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent7 = (function (_super) {
    __extends(_View_ContentWritingEditComponent7, _super);
    function _View_ContentWritingEditComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent7, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group input-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'textarea', new import5.InlineArray8(6, 'class', 'form-control', 'rows', '3', 'type', 'text'), null);
        this._DefaultValueAccessor_5_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_5));
        this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
        this._FormControlName_5_5 = new import29.Wrapper_FormControlName(this.parent._ControlContainer_62_4, null, null, this._NG_VALUE_ACCESSOR_5_4);
        this._NgControl_5_6 = this._FormControlName_5_5.context;
        this._NgControlStatus_5_7 = new import27.Wrapper_NgControlStatus(this._NgControl_5_6);
        this._text_6 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._pipe_uppercase_1_1 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'input', this.eventHandler(this._handle_input_5_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'blur', this.eventHandler(this._handle_blur_5_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentWritingEditComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.DefaultValueAccessor) && (5 === requestNodeIndex))) {
            return this._DefaultValueAccessor_5_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_5_4;
        }
        if (((token === import37.FormControlName) && (5 === requestNodeIndex))) {
            return this._FormControlName_5_5.context;
        }
        if (((token === import38.NgControl) && (5 === requestNodeIndex))) {
            return this._NgControl_5_6;
        }
        if (((token === import39.NgControlStatus) && (5 === requestNodeIndex))) {
            return this._NgControlStatus_5_7.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._DefaultValueAccessor_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_5_1_0 = this.context.$implicit;
        this._FormControlName_5_5.check_name(currVal_5_1_0, throwOnChange, false);
        this._FormControlName_5_5.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_3, currVal_12);
            this._expr_12 = currVal_12;
        }
        this._DefaultValueAccessor_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._FormControlName_5_5.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._NgControlStatus_5_7.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingEditComponent7.prototype.destroyInternal = function () {
        this._FormControlName_5_5.context.ngOnDestroy();
    };
    _View_ContentWritingEditComponent7.prototype._handle_input_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onChange($event.target.value) !== false);
        return (true && pd_5_0);
    };
    _View_ContentWritingEditComponent7.prototype._handle_blur_5_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this._DefaultValueAccessor_5_3.context.onTouched() !== false);
        return (true && pd_5_0);
    };
    return _View_ContentWritingEditComponent7;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent8 = (function (_super) {
    __extends(_View_ContentWritingEditComponent8, _super);
    function _View_ContentWritingEditComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent8, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_10 = import8.UNINITIALIZED;
    }
    _View_ContentWritingEditComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'form-group'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_0, 'html-editor', new import5.InlineArray2(2, 'height', '50'), null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._el_5);
        var compView_5 = import45.viewFactory_HtmlEditorComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._HtmlEditorComponent_5_4 = new import45.Wrapper_HtmlEditorComponent();
        this._appEl_5.initComponent(this._HtmlEditorComponent_5_4.context, [], compView_5);
        this._text_6 = this.renderer.createText(null, '\n                          ', null);
        compView_5.create(this._HtmlEditorComponent_5_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._pipe_uppercase_1_2 = import5.pureProxy1(this.parent.parent._pipe_uppercase_1.transform.bind(this.parent.parent._pipe_uppercase_1));
        var disposable_0 = this.renderer.listen(this._el_5, 'onEditorKeyup', this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        var subscription_0 = this._HtmlEditorComponent_5_4.context.onEditorKeyup.subscribe(this.eventHandler(this._handle_onEditorKeyup_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentWritingEditComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import46.HtmlEditorComponent) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 6)))) {
            return this._HtmlEditorComponent_5_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_5_0_0 = ('editor-content-' + this.context.$implicit);
        this._HtmlEditorComponent_5_4.check_elementId(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = (this.parent.parent.context.content ? this.parent.parent.context.content.content[this.context.$implicit] : '');
        this._HtmlEditorComponent_5_4.check_initText(currVal_5_0_1, throwOnChange, false);
        var currVal_5_0_2 = '50';
        this._HtmlEditorComponent_5_4.check_height(currVal_5_0_2, throwOnChange, false);
        this._HtmlEditorComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_10 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2, this.parent.parent._pipe_uppercase_1.transform)(this.context.$implicit)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_10, currVal_10))) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
        this._HtmlEditorComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HtmlEditorComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_ContentWritingEditComponent8.prototype.destroyInternal = function () {
        this._HtmlEditorComponent_5_4.context.ngOnDestroy();
    };
    _View_ContentWritingEditComponent8.prototype._handle_onEditorKeyup_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.keyupEditorHandlerFunction([
            'content',
            this.context.$implicit
        ], $event) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentWritingEditComponent8;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingEditComponent9 = (function (_super) {
    __extends(_View_ContentWritingEditComponent9, _super);
    function _View_ContentWritingEditComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingEditComponent9, renderType_ContentWritingEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingEditComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray4(4, 'class', 'input-group col-lg-3 col-md-4 col-sm-5', 'style', 'padding: 0px 3px 3px 0px; max-width: 200px'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'input', new import5.InlineArray4(4, 'class', 'form-control', 'type', 'text'), null);
        this._DefaultValueAccessor_2_3 = new import30.Wrapper_DefaultValueAccessor(this.renderer, new import33.ElementRef(this._el_2));
        this._NG_VALUE_ACCESSOR_2_4 = [this._DefaultValueAccessor_2_3.context];
        this._FormControlName_2_5 = new import29.Wrapper_FormControlName(this.parent._ControlContainer_83_4, null, null, this._NG_VALUE_ACCESSOR_2_4);
        this._NgControl_2_6 = this._FormControlName_2_5.context;
        this._NgControlStatus_2_7 = new import27.Wrapper_NgControlStatus(this._NgControl_2_6);
        this._text_3 = this.renderer.createText(this._el_0, '\n                          ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'input-group-addon'), null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_4, 'a', new import5.InlineArray2(2, 'class', 'glyphicon glyphicon-remove clickLink'), null);
        this._text_6 = this.renderer.createText(this._el_0, '\n                        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'input', this.eventHandler(this._handle_input_2_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_2, 'blur', this.eventHandler(this._handle_blur_2_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._el_5,
            this._text_6
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentWritingEditComponent9.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.DefaultValueAccessor) && (2 === requestNodeIndex))) {
            return this._DefaultValueAccessor_2_3.context;
        }
        if (((token === import36.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_2_4;
        }
        if (((token === import37.FormControlName) && (2 === requestNodeIndex))) {
            return this._FormControlName_2_5.context;
        }
        if (((token === import38.NgControl) && (2 === requestNodeIndex))) {
            return this._NgControl_2_6;
        }
        if (((token === import39.NgControlStatus) && (2 === requestNodeIndex))) {
            return this._NgControlStatus_2_7.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingEditComponent9.prototype.detectChangesInternal = function (throwOnChange) {
        this._DefaultValueAccessor_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_2_1_0 = import5.interpolate(1, '', this.context.index, '');
        this._FormControlName_2_5.check_name(currVal_2_1_0, throwOnChange, false);
        this._FormControlName_2_5.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._DefaultValueAccessor_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._FormControlName_2_5.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_7.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingEditComponent9.prototype.destroyInternal = function () {
        this._FormControlName_2_5.context.ngOnDestroy();
    };
    _View_ContentWritingEditComponent9.prototype._handle_input_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onChange($event.target.value) !== false);
        return (true && pd_2_0);
    };
    _View_ContentWritingEditComponent9.prototype._handle_blur_2_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this._DefaultValueAccessor_2_3.context.onTouched() !== false);
        return (true && pd_2_0);
    };
    _View_ContentWritingEditComponent9.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.context.onRemoveTag(this.context.index) !== false);
        return (true && pd_5_0);
    };
    return _View_ContentWritingEditComponent9;
}(import1.AppView));
function viewFactory_ContentWritingEditComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingEditComponent9(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(161);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(2);
var import10 = __webpack_require__(9);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(32);
var import13 = __webpack_require__(15);
var import14 = __webpack_require__(11);
var import15 = __webpack_require__(10);
var import16 = __webpack_require__(24);
var import17 = __webpack_require__(46);
var import18 = __webpack_require__(14);
var import19 = __webpack_require__(20);
var import20 = __webpack_require__(38);
var import21 = __webpack_require__(21);
var import22 = __webpack_require__(64);
var import23 = __webpack_require__(79);
var import24 = __webpack_require__(43);
var import25 = __webpack_require__(18);
var import26 = __webpack_require__(41);
var import27 = __webpack_require__(26);
var import28 = __webpack_require__(48);
var import29 = __webpack_require__(28);
var import30 = __webpack_require__(33);
var Wrapper_ContentWritingsComponent = (function () {
    function Wrapper_ContentWritingsComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.ContentWritingsComponent(p0, p1, p2, p3, p4, p5);
    }
    Wrapper_ContentWritingsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentWritingsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentWritingsComponent;
}());
exports.Wrapper_ContentWritingsComponent = Wrapper_ContentWritingsComponent;
var renderType_ContentWritingsComponent_Host = null;
var _View_ContentWritingsComponent_Host0 = (function (_super) {
    __extends(_View_ContentWritingsComponent_Host0, _super);
    function _View_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent_Host0, renderType_ContentWritingsComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentWritingsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentWritingsComponent_0_4 = new Wrapper_ContentWritingsComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.UtilsService), this.parentInjector.get(import10.ContentService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Location), this.parentInjector.get(import13.Router));
        this._appEl_0.initComponent(this._ContentWritingsComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentWritingsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentWritingsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentWritingsComponent) && (0 === requestNodeIndex))) {
            return this._ContentWritingsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentWritingsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentWritingsComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentWritingsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent_Host0;
}(import1.AppView));
function viewFactory_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingsComponent_Host === null)) {
        (renderType_ContentWritingsComponent_Host = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentWritingsComponentNgFactory = new import15.ComponentFactory('ng-component', viewFactory_ContentWritingsComponent_Host0, import0.ContentWritingsComponent);
var styles_ContentWritingsComponent = [];
var renderType_ContentWritingsComponent = null;
var _View_ContentWritingsComponent0 = (function (_super) {
    __extends(_View_ContentWritingsComponent0, _super);
    function _View_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent0, renderType_ContentWritingsComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_60 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-header'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n  ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'h1', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Ecrits\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'lLink'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n      ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'btn btn-default btn-sm'), null);
        this._text_7 = this.renderer.createText(this._el_6, 'Nouveau', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n    ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n  ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n', null);
        this._text_11 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_12 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n  ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n  ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_14, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n  ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_16, 'div', new import4.InlineArray2(2, 'class', 'box'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n    ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'div', new import4.InlineArray2(2, 'class', 'box-body'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n\n      ', null);
        this._el_22 = import4.createRenderElement(this.renderer, this._el_20, 'table', new import4.InlineArray2(2, 'class', 'table table-striped table-hover'), null);
        this._text_23 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_24 = import4.createRenderElement(this.renderer, this._el_22, 'thead', import4.EMPTY_INLINE_ARRAY, null);
        this._text_25 = this.renderer.createText(this._el_24, '\n          ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_24, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_27 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_29 = this.renderer.createText(this._el_28, 'Statut', null);
        this._text_30 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_31 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_32 = this.renderer.createText(this._el_31, 'Auteur', null);
        this._text_33 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_34 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_35 = this.renderer.createText(this._el_34, 'Titre ', null);
        this._el_36 = import4.createRenderElement(this.renderer, this._el_34, 'small', new import4.InlineArray2(2, 'class', 'table-language'), null);
        this._text_37 = this.renderer.createText(this._el_36, '', null);
        this._text_38 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_39 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_40 = this.renderer.createText(this._el_39, 'Date', null);
        this._text_41 = this.renderer.createText(this._el_26, '\n            ', null);
        this._el_42 = import4.createRenderElement(this.renderer, this._el_26, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_43 = this.renderer.createText(this._el_42, 'Modifié', null);
        this._text_44 = this.renderer.createText(this._el_26, '\n          ', null);
        this._text_45 = this.renderer.createText(this._el_24, '\n        ', null);
        this._text_46 = this.renderer.createText(this._el_22, '\n        ', null);
        this._el_47 = import4.createRenderElement(this.renderer, this._el_22, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_48 = this.renderer.createText(this._el_47, '\n          ', null);
        this._anchor_49 = this.renderer.createTemplateAnchor(this._el_47, null);
        this._appEl_49 = new import3.AppElement(49, 47, this, this._anchor_49);
        this._TemplateRef_49_5 = new import18.TemplateRef_(this._appEl_49, viewFactory_ContentWritingsComponent1);
        this._NgFor_49_6 = new import16.Wrapper_NgFor(this._appEl_49.vcRef, this._TemplateRef_49_5, this.parentInjector.get(import19.IterableDiffers), this.ref);
        this._text_50 = this.renderer.createText(this._el_47, '\n        ', null);
        this._text_51 = this.renderer.createText(this._el_22, '\n      ', null);
        this._text_52 = this.renderer.createText(this._el_20, '\n\n\n    ', null);
        this._text_53 = this.renderer.createText(this._el_18, '\n  ', null);
        this._text_54 = this.renderer.createText(this._el_16, '\n  ', null);
        this._text_55 = this.renderer.createText(this._el_14, '\n  ', null);
        this._text_56 = this.renderer.createText(this._el_12, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this._pipe_date_0 = new import17.DatePipe(this.parentInjector.get(import20.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._el_31,
            this._text_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._text_41,
            this._el_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._anchor_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._text_53,
            this._text_54,
            this._text_55,
            this._text_56
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import18.TemplateRef) && (49 === requestNodeIndex))) {
            return this._TemplateRef_49_5;
        }
        if (((token === import21.NgFor) && (49 === requestNodeIndex))) {
            return this._NgFor_49_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_49_0_0 = this.context.contents;
        this._NgFor_49_6.check_ngForOf(currVal_49_0_0, throwOnChange, false);
        this._NgFor_49_6.detectChangesInInputProps(this, this._anchor_49, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_60 = import4.interpolate(1, '', this.context.currentLanguage, '');
        if (import4.checkBinding(throwOnChange, this._expr_60, currVal_60)) {
            this.renderer.setText(this._text_37, currVal_60);
            this._expr_60 = currVal_60;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent0.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.context.utils.lLink('admin/writing/edit/0', this.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    return _View_ContentWritingsComponent0;
}(import1.AppView));
function viewFactory_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingsComponent === null)) {
        (renderType_ContentWritingsComponent = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, styles_ContentWritingsComponent, {}));
    }
    return new _View_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentWritingsComponent0 = viewFactory_ContentWritingsComponent0;
var _View_ContentWritingsComponent1 = (function (_super) {
    __extends(_View_ContentWritingsComponent1, _super);
    function _View_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent1, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_29 = import7.UNINITIALIZED;
        this._expr_30 = import7.UNINITIALIZED;
        this._expr_31 = import7.UNINITIALIZED;
        this._expr_32 = import7.UNINITIALIZED;
        this._expr_33 = import7.UNINITIALIZED;
        this._expr_35 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'switch material-switch'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'input', new import4.InlineArray2(2, 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_6_3 = new import22.Wrapper_CheckboxControlValueAccessor(this.renderer, new import25.ElementRef(this._el_6));
        this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
        this._NgModel_6_5 = new import23.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_6_4);
        this._NgControl_6_6 = this._NgModel_6_5.context;
        this._NgControlStatus_6_7 = new import24.Wrapper_NgControlStatus(this._NgControl_6_6);
        this._text_7 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_4, 'label', new import4.InlineArray2(2, 'class', 'label-primary'), null);
        this._text_9 = this.renderer.createText(this._el_4, '\n                ', null);
        this._text_10 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_19 = this.renderer.createText(this._el_18, '', null);
        this._text_20 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_0, 'td', import4.EMPTY_INLINE_ARRAY, null);
        this._text_22 = this.renderer.createText(this._el_21, '', null);
        this._text_23 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_6, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_6, 'change', this.eventHandler(this._handle_change_6_2.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_6, 'blur', this.eventHandler(this._handle_blur_6_3.bind(this)));
        var subscription_0 = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_15, 'click', this.eventHandler(this._handle_click_15_0.bind(this)));
        this._pipe_date_0_0 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this._pipe_date_0_1 = import4.pureProxy2(this.parent._pipe_date_0.transform.bind(this.parent._pipe_date_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._text_23
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ], [subscription_0]);
        return null;
    };
    _View_ContentWritingsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_6_3.context;
        }
        if (((token === import27.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_6_4;
        }
        if (((token === import28.NgModel) && (6 === requestNodeIndex))) {
            return this._NgModel_6_5.context;
        }
        if (((token === import29.NgControl) && (6 === requestNodeIndex))) {
            return this._NgControl_6_6;
        }
        if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) {
            return this._NgControlStatus_6_7.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_6_1_0 = import4.interpolate(1, '', this.context.$implicit._id, '');
        this._NgModel_6_5.check_name(currVal_6_1_0, throwOnChange, false);
        var currVal_6_1_1 = this.context.$implicit.active;
        this._NgModel_6_5.check_model(currVal_6_1_1, throwOnChange, false);
        this._NgModel_6_5.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_29 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_29, currVal_29)) {
            this.renderer.setElementProperty(this._el_6, 'id', currVal_29);
            this._expr_29 = currVal_29;
        }
        this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgModel_6_5.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInHostProps(this, this._el_6, throwOnChange);
        var currVal_30 = import4.interpolate(1, '', this.context.$implicit._id, '');
        if (import4.checkBinding(throwOnChange, this._expr_30, currVal_30)) {
            this.renderer.setElementAttribute(this._el_8, 'for', ((currVal_30 == null) ? null : currVal_30.toString()));
            this._expr_30 = currVal_30;
        }
        var currVal_31 = import4.interpolate(1, '', this.context.$implicit.author, '');
        if (import4.checkBinding(throwOnChange, this._expr_31, currVal_31)) {
            this.renderer.setText(this._text_13, currVal_31);
            this._expr_31 = currVal_31;
        }
        var currVal_32 = import4.interpolate(1, '', (this.context.$implicit.title ? this.context.$implicit.title[this.parent.context.currentLanguage] : '-'), '');
        if (import4.checkBinding(throwOnChange, this._expr_32, currVal_32)) {
            this.renderer.setText(this._text_16, currVal_32);
            this._expr_32 = currVal_32;
        }
        valUnwrapper.reset();
        var currVal_33 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0, this.parent._pipe_date_0.transform)(this.context.$implicit.date, 'MMM yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_33, currVal_33))) {
            this.renderer.setText(this._text_19, currVal_33);
            this._expr_33 = currVal_33;
        }
        valUnwrapper.reset();
        var currVal_35 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_1, this.parent._pipe_date_0.transform)(this.context.$implicit.update_date, 'MMM dd yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_35, currVal_35))) {
            this.renderer.setText(this._text_22, currVal_35);
            this._expr_35 = currVal_35;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent1.prototype.destroyInternal = function () {
        this._NgModel_6_5.context.ngOnDestroy();
    };
    _View_ContentWritingsComponent1.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.context.onStatusChange(!this.context.$implicit.active, this.context.$implicit) !== false);
        return (true && pd_6_0);
    };
    _View_ContentWritingsComponent1.prototype._handle_ngModelChange_6_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = ((this.context.$implicit.active = $event) !== false);
        return (true && pd_6_0);
    };
    _View_ContentWritingsComponent1.prototype._handle_change_6_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked) !== false);
        return (true && pd_6_0);
    };
    _View_ContentWritingsComponent1.prototype._handle_blur_6_3 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onTouched() !== false);
        return (true && pd_6_0);
    };
    _View_ContentWritingsComponent1.prototype._handle_click_15_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_15_0 = (this.parent.context.router.navigate([('writing/edit/' + this.context.$implicit._id)], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_15_0);
    };
    return _View_ContentWritingsComponent1;
}(import1.AppView));
function viewFactory_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(224);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(116);
var import9 = __webpack_require__(11);
var import10 = __webpack_require__(10);
var import11 = __webpack_require__(24);
var import12 = __webpack_require__(14);
var import13 = __webpack_require__(20);
var import14 = __webpack_require__(21);
var import15 = __webpack_require__(216);
var import16 = __webpack_require__(416);
var import17 = __webpack_require__(22);
var import18 = __webpack_require__(40);
var import19 = __webpack_require__(18);
var import20 = __webpack_require__(181);
var import21 = __webpack_require__(19);
var import22 = __webpack_require__(102);
var import23 = __webpack_require__(31);
var Wrapper_ImageUploadComponent = (function () {
    function Wrapper_ImageUploadComponent(p0) {
        this.changed = false;
        this.context = new import0.ImageUploadComponent(p0);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
        this._expr_7 = import1.UNINITIALIZED;
    }
    Wrapper_ImageUploadComponent.prototype.check_form = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.form = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_groupName = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.groupName = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_imagePath = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.imagePath = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_addApi = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.addApi = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_deleteApi = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.deleteApi = currValue;
            this._expr_4 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_deleteDir = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.deleteDir = currValue;
            this._expr_5 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_images = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_6, currValue))) {
            this.changed = true;
            this.context.images = currValue;
            this._expr_6 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.check_thumbSize = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_7, currValue))) {
            this.changed = true;
            this.context.thumbSize = currValue;
            this._expr_7 = currValue;
        }
    };
    Wrapper_ImageUploadComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_ImageUploadComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ImageUploadComponent;
}());
exports.Wrapper_ImageUploadComponent = Wrapper_ImageUploadComponent;
var renderType_ImageUploadComponent_Host = null;
var _View_ImageUploadComponent_Host0 = (function (_super) {
    __extends(_View_ImageUploadComponent_Host0, _super);
    function _View_ImageUploadComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent_Host0, renderType_ImageUploadComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_ImageUploadComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'image-uploads', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ImageUploadComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ImageUploadComponent_0_4 = new Wrapper_ImageUploadComponent(this.parentInjector.get(import8.DataService));
        this._appEl_0.initComponent(this._ImageUploadComponent_0_4.context, [], compView_0);
        compView_0.create(this._ImageUploadComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ImageUploadComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ImageUploadComponent) && (0 === requestNodeIndex))) {
            return this._ImageUploadComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ImageUploadComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ImageUploadComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ImageUploadComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._ImageUploadComponent_0_4.context.ngAfterViewInit();
            }
        }
    };
    return _View_ImageUploadComponent_Host0;
}(import3.AppView));
function viewFactory_ImageUploadComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ImageUploadComponent_Host === null)) {
        (renderType_ImageUploadComponent_Host = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.None, [], {}));
    }
    return new _View_ImageUploadComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ImageUploadComponentNgFactory = new import10.ComponentFactory('image-uploads', viewFactory_ImageUploadComponent_Host0, import0.ImageUploadComponent);
var styles_ImageUploadComponent = [
    '.upload-tool[_ngcontent-%COMP%] {height: 20px; margin-top: -5px}',
    '.progress-cover[_ngcontent-%COMP%] {margin-right: 5px; float: left}',
    '.uploader[_ngcontent-%COMP%] {margin: 15px 10px 0px 0px}',
    '.clickLink[_ngcontent-%COMP%] {cursor: pointer}'
];
var renderType_ImageUploadComponent = null;
var _View_ImageUploadComponent0 = (function (_super) {
    __extends(_View_ImageUploadComponent0, _super);
    function _View_ImageUploadComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent0, renderType_ImageUploadComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_ImageUploadComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n          ', null);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_1 = new import5.AppElement(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import12.TemplateRef_(this._appEl_1, viewFactory_ImageUploadComponent1);
        this._NgFor_1_6 = new import11.Wrapper_NgFor(this._appEl_1.vcRef, this._TemplateRef_1_5, this.parentInjector.get(import13.IterableDiffers), this.ref);
        this._text_2 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this.init([], [
            this._text_0,
            this._anchor_1,
            this._text_2
        ], [], []);
        return null;
    };
    _View_ImageUploadComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import12.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import14.NgFor) && (1 === requestNodeIndex))) {
            return this._NgFor_1_6.context;
        }
        return notFoundResult;
    };
    _View_ImageUploadComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = this.context.uploaders;
        this._NgFor_1_6.check_ngForOf(currVal_1_0_0, throwOnChange, false);
        this._NgFor_1_6.detectChangesInInputProps(this, this._anchor_1, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ImageUploadComponent0;
}(import3.AppView));
function viewFactory_ImageUploadComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ImageUploadComponent === null)) {
        (renderType_ImageUploadComponent = viewUtils.createRenderComponentType('', 0, import9.ViewEncapsulation.Emulated, styles_ImageUploadComponent, {}));
    }
    return new _View_ImageUploadComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ImageUploadComponent0 = viewFactory_ImageUploadComponent0;
var _View_ImageUploadComponent1 = (function (_super) {
    __extends(_View_ImageUploadComponent1, _super);
    function _View_ImageUploadComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent1, renderType_ImageUploadComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_18 = import2.pureProxy1(function (p0) {
            return { width: p0 };
        });
    }
    _View_ImageUploadComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'uploader col-md-5'), null);
        this._NgStyle_0_3 = new import15.Wrapper_NgStyle(this.parentInjector.get(import18.KeyValueDiffers), new import19.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'input', new import2.InlineArray8(6, 'class', 'hidden', 'ng2FileSelect', '', 'type', 'file'), null);
        this._FileSelectDirective_2_3 = new import16.Wrapper_FileSelectDirective(new import19.ElementRef(this._el_2));
        this._text_3 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_5 = new import5.AppElement(5, 0, this, this._anchor_5);
        this._TemplateRef_5_5 = new import12.TemplateRef_(this._appEl_5, viewFactory_ImageUploadComponent2);
        this._NgIf_5_6 = new import17.Wrapper_NgIf(this._appEl_5.vcRef, this._TemplateRef_5_5);
        this._text_6 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_7 = new import5.AppElement(7, 0, this, this._anchor_7);
        this._TemplateRef_7_5 = new import12.TemplateRef_(this._appEl_7, viewFactory_ImageUploadComponent3);
        this._NgFor_7_6 = new import11.Wrapper_NgFor(this._appEl_7.vcRef, this._TemplateRef_7_5, this.parentInjector.get(import13.IterableDiffers), this.parent.ref);
        this._text_8 = this.renderer.createText(this._el_0, ' ', null);
        this._text_9 = this.renderer.createText(this._el_0, '\n            \n          ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'change', this.eventHandler(this._handle_change_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._text_9
        ], [disposable_0], []);
        return null;
    };
    _View_ImageUploadComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import20.FileSelectDirective) && (2 === requestNodeIndex))) {
            return this._FileSelectDirective_2_3.context;
        }
        if (((token === import12.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import21.NgIf) && (5 === requestNodeIndex))) {
            return this._NgIf_5_6.context;
        }
        if (((token === import12.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import14.NgFor) && (7 === requestNodeIndex))) {
            return this._NgFor_7_6.context;
        }
        if (((token === import22.NgStyle) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 9)))) {
            return this._NgStyle_0_3.context;
        }
        return notFoundResult;
    };
    _View_ImageUploadComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._map_18((this.parent.context.thumbSize + 20));
        this._NgStyle_0_3.check_ngStyle(currVal_0_0_0, throwOnChange, false);
        this._NgStyle_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = this.context.$implicit;
        this._FileSelectDirective_2_3.check_uploader(currVal_2_0_0, throwOnChange, false);
        this._FileSelectDirective_2_3.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_5_0_0 = (this.context.$implicit.queue.length == 0);
        this._NgIf_5_6.check_ngIf(currVal_5_0_0, throwOnChange, false);
        this._NgIf_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = this.context.$implicit.queue;
        this._NgFor_7_6.check_ngForOf(currVal_7_0_0, throwOnChange, false);
        this._NgFor_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgStyle_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._FileSelectDirective_2_3.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ImageUploadComponent1.prototype._handle_change_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.onChangeImageHandler(this.context.$implicit.options.itemAlias, $event) !== false);
        var pd_2_1 = (this._FileSelectDirective_2_3.context.onChange() !== false);
        return ((true && pd_2_0) && pd_2_1);
    };
    return _View_ImageUploadComponent1;
}(import3.AppView));
function viewFactory_ImageUploadComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ImageUploadComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ImageUploadComponent2 = (function (_super) {
    __extends(_View_ImageUploadComponent2, _super);
    function _View_ImageUploadComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent2, renderType_ImageUploadComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
    }
    _View_ImageUploadComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'img', new import2.InlineArray4(4, 'class', 'clickLink', 'style', 'margin-top: 10px'), null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [this._el_0], [disposable_0], []);
        return null;
    };
    _View_ImageUploadComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_1 = import2.interpolate(1, '', this.parent.context.$implicit.options.itemAlias, '');
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            this.renderer.setElementProperty(this._el_0, 'title', currVal_1);
            this._expr_1 = currVal_1;
        }
        var currVal_2 = (this.parent.parent.context.form.controls[this.parent.parent.context.groupName].controls[this.parent.context.$implicit.options.itemAlias].value ? (this.parent.parent.context.imagePath + this.parent.parent.context.form.controls[this.parent.parent.context.groupName].controls[this.parent.context.$implicit.options.itemAlias].value) : (this.parent.parent.context.imagePath + this.parent.parent.context.defaultImage));
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'src', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL, currVal_2));
            this._expr_2 = currVal_2;
        }
        var currVal_3 = import2.interpolate(1, '', this.parent.parent.context.thumbSize, '');
        if (import2.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            this.renderer.setElementProperty(this._el_0, 'width', currVal_3);
            this._expr_3 = currVal_3;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ImageUploadComponent2.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent._el_2.click() !== false);
        return (true && pd_0_0);
    };
    return _View_ImageUploadComponent2;
}(import3.AppView));
function viewFactory_ImageUploadComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ImageUploadComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ImageUploadComponent3 = (function (_super) {
    __extends(_View_ImageUploadComponent3, _super);
    function _View_ImageUploadComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent3, renderType_ImageUploadComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_40 = import2.pureProxy1(function (p0) {
            return { width: p0 };
        });
        this._map_41 = import2.pureProxy1(function (p0) {
            return { width: p0 };
        });
        this._expr_42 = import1.UNINITIALIZED;
        this._expr_43 = import1.UNINITIALIZED;
        this._expr_44 = import1.UNINITIALIZED;
    }
    _View_ImageUploadComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'style', 'margin-top: 10px'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n              ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import12.TemplateRef_(this._appEl_2, viewFactory_ImageUploadComponent4);
        this._NgIf_2_6 = new import17.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n\n              ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'style', 'width: 100%; margin-top: 5px'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_4, 'div', new import2.InlineArray2(2, 'class', 'progress progress-cover'), null);
        this._NgStyle_6_3 = new import15.Wrapper_NgStyle(this.parent.parentInjector.get(import18.KeyValueDiffers), new import19.ElementRef(this._el_6), this.renderer);
        this._text_7 = this.renderer.createText(this._el_6, '\n                  ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_6, 'div', new import2.InlineArray4(4, 'class', 'progress-bar', 'role', 'progressbar'), null);
        this._NgStyle_8_3 = new import15.Wrapper_NgStyle(this.parent.parentInjector.get(import18.KeyValueDiffers), new import19.ElementRef(this._el_8), this.renderer);
        this._text_9 = this.renderer.createText(this._el_8, '\n                    ', null);
        this._el_10 = import2.createRenderElement(this.renderer, this._el_8, 'span', new import2.InlineArray2(2, 'style', 'padding: 0px 3px'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_8, '\n                  ', null);
        this._text_13 = this.renderer.createText(this._el_6, '\n                ', null);
        this._text_14 = this.renderer.createText(this._el_4, '\n                ', null);
        this._el_15 = import2.createRenderElement(this.renderer, this._el_4, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                  ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_15, 'button', new import2.InlineArray4(4, 'class', 'upload-tool btn btn-danger btn-xs', 'type', 'button'), null);
        this._text_18 = this.renderer.createText(this._el_17, ' ', null);
        this._text_19 = this.renderer.createText(this._el_17, '\n                    ', null);
        this._el_20 = import2.createRenderElement(this.renderer, this._el_17, 'span', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-trash'), null);
        this._text_21 = this.renderer.createText(this._el_17, '\n                  ', null);
        this._text_22 = this.renderer.createText(this._el_15, '\n                  ', null);
        this._el_23 = import2.createRenderElement(this.renderer, this._el_15, 'button', new import2.InlineArray4(4, 'class', 'upload-tool btn btn-warning btn-xs', 'type', 'button'), null);
        this._text_24 = this.renderer.createText(this._el_23, '\n                    ', null);
        this._el_25 = import2.createRenderElement(this.renderer, this._el_23, 'span', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-ban-circle'), null);
        this._text_26 = this.renderer.createText(this._el_23, '\n                  ', null);
        this._text_27 = this.renderer.createText(this._el_15, '				                \n                  ', null);
        this._el_28 = import2.createRenderElement(this.renderer, this._el_15, 'button', new import2.InlineArray4(4, 'class', 'upload-tool btn btn-success btn-xs', 'type', 'button'), null);
        this._text_29 = this.renderer.createText(this._el_28, '\n                    ', null);
        this._el_30 = import2.createRenderElement(this.renderer, this._el_28, 'span', new import2.InlineArray2(2, 'class', 'glyphicon glyphicon-upload'), null);
        this._text_31 = this.renderer.createText(this._el_28, '\n                  ', null);
        this._text_32 = this.renderer.createText(this._el_15, ' \n                ', null);
        this._text_33 = this.renderer.createText(this._el_4, '\n              ', null);
        this._text_34 = this.renderer.createText(this._el_0, '\n\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_17, 'click', this.eventHandler(this._handle_click_17_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_23, 'click', this.eventHandler(this._handle_click_23_0.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_28, 'click', this.eventHandler(this._handle_click_28_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._text_34
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ImageUploadComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import12.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import21.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        if (((token === import22.NgStyle) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 12)))) {
            return this._NgStyle_8_3.context;
        }
        if (((token === import22.NgStyle) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 13)))) {
            return this._NgStyle_6_3.context;
        }
        return notFoundResult;
    };
    _View_ImageUploadComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parent.parent.context.tempData[this.parent.context.$implicit.options.itemAlias];
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        var currVal_6_0_0 = this._map_40((this.parent.parent.context.thumbSize - 100));
        this._NgStyle_6_3.check_ngStyle(currVal_6_0_0, throwOnChange, false);
        this._NgStyle_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_8_0_0 = this._map_41((this.context.$implicit.progress + '%'));
        this._NgStyle_8_3.check_ngStyle(currVal_8_0_0, throwOnChange, false);
        this._NgStyle_8_3.detectChangesInInputProps(this, this._el_8, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgStyle_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgStyle_8_3.detectChangesInHostProps(this, this._el_8, throwOnChange);
        var currVal_42 = import2.interpolate(1, '', this.context.$implicit.progress, '%');
        if (import2.checkBinding(throwOnChange, this._expr_42, currVal_42)) {
            this.renderer.setText(this._text_11, currVal_42);
            this._expr_42 = currVal_42;
        }
        var currVal_43 = !this.context.$implicit.isUploading;
        if (import2.checkBinding(throwOnChange, this._expr_43, currVal_43)) {
            this.renderer.setElementProperty(this._el_23, 'disabled', currVal_43);
            this._expr_43 = currVal_43;
        }
        var currVal_44 = ((this.context.$implicit.isReady || this.context.$implicit.isUploading) || this.context.$implicit.isSuccess);
        if (import2.checkBinding(throwOnChange, this._expr_44, currVal_44)) {
            this.renderer.setElementProperty(this._el_28, 'disabled', currVal_44);
            this._expr_44 = currVal_44;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ImageUploadComponent3.prototype._handle_click_17_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_17_0 = (this.parent.parent.context.onRemoveImage(this.context.$implicit) !== false);
        return (true && pd_17_0);
    };
    _View_ImageUploadComponent3.prototype._handle_click_23_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this.context.$implicit.cancel() !== false);
        return (true && pd_23_0);
    };
    _View_ImageUploadComponent3.prototype._handle_click_28_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this.context.$implicit.upload() !== false);
        return (true && pd_28_0);
    };
    return _View_ImageUploadComponent3;
}(import3.AppView));
function viewFactory_ImageUploadComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ImageUploadComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ImageUploadComponent4 = (function (_super) {
    __extends(_View_ImageUploadComponent4, _super);
    function _View_ImageUploadComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ImageUploadComponent4, renderType_ImageUploadComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_ImageUploadComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'img', new import2.InlineArray2(2, 'class', 'clickLink'), null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [this._el_0], [disposable_0], []);
        return null;
    };
    _View_ImageUploadComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_1 = this.parent.parent.parent.context.tempData[this.parent.parent.context.$implicit.options.itemAlias];
        if (import2.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            this.renderer.setElementProperty(this._el_0, 'src', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL, currVal_1));
            this._expr_1 = currVal_1;
        }
        var currVal_2 = import2.interpolate(1, '', this.parent.parent.parent.context.thumbSize, '');
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'height', currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ImageUploadComponent4.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent._el_2.click() !== false);
        return (true && pd_0_0);
    };
    return _View_ImageUploadComponent4;
}(import3.AppView));
function viewFactory_ImageUploadComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ImageUploadComponent4(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var mask_service_1 = __webpack_require__(225);
var MaskDirective = (function () {
    function MaskDirective(el, zone, control, maskService) {
        this.el = el;
        this.zone = zone;
        this.control = control;
        this.maskService = maskService;
        this.options = {};
        $.jMaskGlobals = {
            translation: {
                '0': { pattern: /\d/ },
                '9': { pattern: /\d/, optional: true },
                '#': { pattern: /\d/, recursive: true },
                'A': { pattern: /[a-zA-Z0-9]/ },
                'S': { pattern: /[a-zA-Z]/ },
                'Y': { pattern: /[0-9]/ }
            }
        };
    }
    MaskDirective.prototype.ngOnInit = function () { };
    MaskDirective.prototype.getPattern = function (pattern) {
        var rule = this.toCamelCase('get ' + this.pattern);
        if (rule in this.maskService) {
            pattern = this.maskService[rule]();
        }
        return pattern;
    };
    MaskDirective.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.zone.run(function () {
            $(_this.el.nativeElement).mask(_this.getPattern(_this.pattern), _this.options);
            if (_this.control.control) {
                _this.control.control.setValue(_this.el.nativeElement.value);
            }
        });
    };
    MaskDirective.prototype.ngOnDestroy = function () {
        $(this.el.nativeElement).unmask();
    };
    MaskDirective.prototype.ngOnChanges = function (changes) {
        if (typeof (changes.pattern.previousValue) === 'string') {
            $(this.el.nativeElement).mask(this.getPattern(changes.pattern.currentValue), this.options);
        }
    };
    MaskDirective.prototype.onBlur = function () {
        var _this = this;
        this.zone.run(function () {
            if (_this.control.control) {
                _this.control.control.setValue(_this.el.nativeElement.value);
            }
        });
    };
    MaskDirective.prototype.toCamelCase = function (text) {
        return text.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
            if (p2)
                return p2.toUpperCase();
            return p1.toLowerCase();
        });
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], MaskDirective.prototype, "options", void 0);
    __decorate([
        core_1.Input('mask'), 
        __metadata('design:type', String)
    ], MaskDirective.prototype, "pattern", void 0);
    MaskDirective = __decorate([
        core_1.Directive({
            selector: '[mask]',
            host: {
                "(blur)": "onBlur()"
            }
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object, (typeof (_b = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _b) || Object, (typeof (_c = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _c) || Object, (typeof (_d = typeof mask_service_1.MaskService !== 'undefined' && mask_service_1.MaskService) === 'function' && _d) || Object])
    ], MaskDirective);
    return MaskDirective;
    var _a, _b, _c, _d;
}());
exports.MaskDirective = MaskDirective;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(226);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(9);
var import10 = __webpack_require__(2);
var import11 = __webpack_require__(15);
var import12 = __webpack_require__(16);
var import13 = __webpack_require__(11);
var import14 = __webpack_require__(10);
var import15 = __webpack_require__(22);
var import16 = __webpack_require__(98);
var import17 = __webpack_require__(14);
var import18 = __webpack_require__(19);
var import19 = __webpack_require__(24);
var import20 = __webpack_require__(20);
var import21 = __webpack_require__(21);
var import22 = __webpack_require__(64);
var import23 = __webpack_require__(79);
var import24 = __webpack_require__(43);
var import25 = __webpack_require__(18);
var import26 = __webpack_require__(41);
var import27 = __webpack_require__(26);
var import28 = __webpack_require__(48);
var import29 = __webpack_require__(28);
var import30 = __webpack_require__(33);
var import31 = __webpack_require__(31);
var import32 = __webpack_require__(220);
var import33 = __webpack_require__(95);
var Wrapper_SearchResultsComponent = (function () {
    function Wrapper_SearchResultsComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.SearchResultsComponent(p0, p1, p2, p3, p4);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
    }
    Wrapper_SearchResultsComponent.prototype.check_esContents = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.esContents = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchResultsComponent.prototype.check_dbContents = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.dbContents = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchResultsComponent.prototype.check_pageSize = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.pageSize = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchResultsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchResultsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchResultsComponent;
}());
exports.Wrapper_SearchResultsComponent = Wrapper_SearchResultsComponent;
var renderType_SearchResultsComponent_Host = null;
var _View_SearchResultsComponent_Host0 = (function (_super) {
    __extends(_View_SearchResultsComponent_Host0, _super);
    function _View_SearchResultsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent_Host0, renderType_SearchResultsComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchResultsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'admin-search-results', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchResultsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchResultsComponent_0_4 = new Wrapper_SearchResultsComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.ContentService), this.parentInjector.get(import10.UtilsService), this.parentInjector.get(import11.Router), this.parentInjector.get(import12.ActivatedRoute));
        this._appEl_0.initComponent(this._SearchResultsComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchResultsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchResultsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchResultsComponent) && (0 === requestNodeIndex))) {
            return this._SearchResultsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchResultsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._SearchResultsComponent_0_4.context.ngAfterContentChecked();
        }
        this._SearchResultsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchResultsComponent_Host0;
}(import3.AppView));
function viewFactory_SearchResultsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchResultsComponent_Host === null)) {
        (renderType_SearchResultsComponent_Host = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchResultsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchResultsComponentNgFactory = new import14.ComponentFactory('admin-search-results', viewFactory_SearchResultsComponent_Host0, import0.SearchResultsComponent);
var styles_SearchResultsComponent = [];
var renderType_SearchResultsComponent = null;
var _View_SearchResultsComponent0 = (function (_super) {
    __extends(_View_SearchResultsComponent0, _super);
    function _View_SearchResultsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent0, renderType_SearchResultsComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchResultsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '  ', null);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_1 = new import5.AppElement(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import17.TemplateRef_(this._appEl_1, viewFactory_SearchResultsComponent1);
        this._NgIf_1_6 = new import15.Wrapper_NgIf(this._appEl_1.vcRef, this._TemplateRef_1_5);
        this._text_2 = this.renderer.createText(parentRenderNode, '\n  ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_3 = new import5.AppElement(3, null, this, this._anchor_3);
        this._TemplateRef_3_5 = new import17.TemplateRef_(this._appEl_3, viewFactory_SearchResultsComponent5);
        this._NgIf_3_6 = new import15.Wrapper_NgIf(this._appEl_3.vcRef, this._TemplateRef_3_5);
        this._pipe_truncate_0 = new import16.TruncatePipe();
        this.init([], [
            this._text_0,
            this._anchor_1,
            this._text_2,
            this._anchor_3
        ], [], []);
        return null;
    };
    _View_SearchResultsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import18.NgIf) && (1 === requestNodeIndex))) {
            return this._NgIf_1_6.context;
        }
        if (((token === import17.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import18.NgIf) && (3 === requestNodeIndex))) {
            return this._NgIf_3_6.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = this.context.dbContents;
        this._NgIf_1_6.check_ngIf(currVal_1_0_0, throwOnChange, false);
        this._NgIf_1_6.detectChangesInInputProps(this, this._anchor_1, throwOnChange);
        var currVal_3_0_0 = this.context.dbContents;
        this._NgIf_3_6.check_ngIf(currVal_3_0_0, throwOnChange, false);
        this._NgIf_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchResultsComponent0;
}(import3.AppView));
function viewFactory_SearchResultsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchResultsComponent === null)) {
        (renderType_SearchResultsComponent = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, styles_SearchResultsComponent, {}));
    }
    return new _View_SearchResultsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchResultsComponent0 = viewFactory_SearchResultsComponent0;
var _View_SearchResultsComponent1 = (function (_super) {
    __extends(_View_SearchResultsComponent1, _super);
    function _View_SearchResultsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent1, renderType_SearchResultsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchResultsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'row row-eq-height'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import17.TemplateRef_(this._appEl_2, viewFactory_SearchResultsComponent2);
        this._NgFor_2_6 = new import19.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parentInjector.get(import20.IterableDiffers), this.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n  ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_SearchResultsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import21.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parent.context.dbContents;
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchResultsComponent1;
}(import3.AppView));
function viewFactory_SearchResultsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchResultsComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchResultsComponent2 = (function (_super) {
    __extends(_View_SearchResultsComponent2, _super);
    function _View_SearchResultsComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent2, renderType_SearchResultsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchResultsComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'col-sm-6 col-md-4 col-lg-3'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_3 = new import5.AppElement(3, 0, this, this._anchor_3);
        this._TemplateRef_3_5 = new import17.TemplateRef_(this._appEl_3, viewFactory_SearchResultsComponent3);
        this._NgIf_3_6 = new import15.Wrapper_NgIf(this._appEl_3.vcRef, this._TemplateRef_3_5);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_5 = new import5.AppElement(5, 0, this, this._anchor_5);
        this._TemplateRef_5_5 = new import17.TemplateRef_(this._appEl_5, viewFactory_SearchResultsComponent4);
        this._NgIf_5_6 = new import15.Wrapper_NgIf(this._appEl_5.vcRef, this._TemplateRef_5_5);
        this._text_6 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n    ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._anchor_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._text_7
        ], [], []);
        return null;
    };
    _View_SearchResultsComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import18.NgIf) && (3 === requestNodeIndex))) {
            return this._NgIf_3_6.context;
        }
        if (((token === import17.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import18.NgIf) && (5 === requestNodeIndex))) {
            return this._NgIf_5_6.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = this.context.$implicit;
        this._NgIf_3_6.check_ngIf(currVal_3_0_0, throwOnChange, false);
        this._NgIf_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        var currVal_5_0_0 = this.context.$implicit;
        this._NgIf_5_6.check_ngIf(currVal_5_0_0, throwOnChange, false);
        this._NgIf_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchResultsComponent2;
}(import3.AppView));
function viewFactory_SearchResultsComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchResultsComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_SearchResultsComponent3 = (function (_super) {
    __extends(_View_SearchResultsComponent3, _super);
    function _View_SearchResultsComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent3, renderType_SearchResultsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_16 = import1.UNINITIALIZED;
        this._expr_17 = import1.UNINITIALIZED;
        this._expr_18 = import1.UNINITIALIZED;
        this._expr_19 = import1.UNINITIALIZED;
    }
    _View_SearchResultsComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'img', new import2.InlineArray2(2, 'class', 'fa fa-edit img-responsive'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_0, 'span', new import2.InlineArray2(2, 'class', 'image-tag switch material-switch'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n              ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_4, 'input', new import2.InlineArray2(2, 'type', 'checkbox'), null);
        this._CheckboxControlValueAccessor_6_3 = new import22.Wrapper_CheckboxControlValueAccessor(this.renderer, new import25.ElementRef(this._el_6));
        this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
        this._NgModel_6_5 = new import23.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_6_4);
        this._NgControl_6_6 = this._NgModel_6_5.context;
        this._NgControlStatus_6_7 = new import24.Wrapper_NgControlStatus(this._NgControl_6_6);
        this._text_7 = this.renderer.createText(this._el_4, '\n              ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_4, 'label', new import2.InlineArray2(2, 'class', 'label-primary'), null);
        this._text_9 = this.renderer.createText(this._el_4, '\n          ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_6, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_6, 'change', this.eventHandler(this._handle_change_6_2.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_6, 'blur', this.eventHandler(this._handle_blur_6_3.bind(this)));
        var subscription_0 = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3
        ], [subscription_0]);
        return null;
    };
    _View_SearchResultsComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) {
            return this._CheckboxControlValueAccessor_6_3.context;
        }
        if (((token === import27.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_6_4;
        }
        if (((token === import28.NgModel) && (6 === requestNodeIndex))) {
            return this._NgModel_6_5.context;
        }
        if (((token === import29.NgControl) && (6 === requestNodeIndex))) {
            return this._NgControl_6_6;
        }
        if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) {
            return this._NgControlStatus_6_7.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this, this._el_6, throwOnChange);
        var currVal_6_1_0 = import2.interpolate(1, '', this.parent.context.$implicit._id, '');
        this._NgModel_6_5.check_name(currVal_6_1_0, throwOnChange, false);
        var currVal_6_1_1 = this.parent.context.$implicit.active;
        this._NgModel_6_5.check_model(currVal_6_1_1, throwOnChange, false);
        this._NgModel_6_5.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_16 = import2.interpolate(1, '/data/covers/thumbs/', this.parent.context.$implicit.cover.front, '');
        if (import2.checkBinding(throwOnChange, this._expr_16, currVal_16)) {
            this.renderer.setElementProperty(this._el_2, 'src', this.viewUtils.sanitizer.sanitize(import31.SecurityContext.URL, currVal_16));
            this._expr_16 = currVal_16;
        }
        var currVal_17 = import2.interpolate(1, '', this.parent.context.$implicit.cover.front, '');
        if (import2.checkBinding(throwOnChange, this._expr_17, currVal_17)) {
            this.renderer.setElementProperty(this._el_2, 'alt', currVal_17);
            this._expr_17 = currVal_17;
        }
        var currVal_18 = import2.interpolate(1, '', this.parent.context.$implicit._id, '');
        if (import2.checkBinding(throwOnChange, this._expr_18, currVal_18)) {
            this.renderer.setElementProperty(this._el_6, 'id', currVal_18);
            this._expr_18 = currVal_18;
        }
        this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgModel_6_5.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this._NgControlStatus_6_7.detectChangesInHostProps(this, this._el_6, throwOnChange);
        var currVal_19 = import2.interpolate(1, '', this.parent.context.$implicit._id, '');
        if (import2.checkBinding(throwOnChange, this._expr_19, currVal_19)) {
            this.renderer.setElementAttribute(this._el_8, 'for', ((currVal_19 == null) ? null : currVal_19.toString()));
            this._expr_19 = currVal_19;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchResultsComponent3.prototype.destroyInternal = function () {
        this._NgModel_6_5.context.ngOnDestroy();
    };
    _View_SearchResultsComponent3.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.parent.parent.context.onStatusChange(!this.parent.context.$implicit.active, this.parent.context.$implicit) !== false);
        return (true && pd_6_0);
    };
    _View_SearchResultsComponent3.prototype._handle_ngModelChange_6_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = ((this.parent.context.$implicit.active = $event) !== false);
        return (true && pd_6_0);
    };
    _View_SearchResultsComponent3.prototype._handle_change_6_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked) !== false);
        return (true && pd_6_0);
    };
    _View_SearchResultsComponent3.prototype._handle_blur_6_3 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this._CheckboxControlValueAccessor_6_3.context.onTouched() !== false);
        return (true && pd_6_0);
    };
    return _View_SearchResultsComponent3;
}(import3.AppView));
function viewFactory_SearchResultsComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchResultsComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_SearchResultsComponent4 = (function (_super) {
    __extends(_View_SearchResultsComponent4, _super);
    function _View_SearchResultsComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent4, renderType_SearchResultsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
    }
    _View_SearchResultsComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'lLink thumb-title'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this._pipe_truncate_0_0 = import2.pureProxy2(this.parent.parent.parent._pipe_truncate_0.transform.bind(this.parent.parent.parent._pipe_truncate_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_SearchResultsComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_0, this.parent.parent.parent._pipe_truncate_0.transform)(this.parent.context.$implicit.title, '80')), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_3, currVal_5);
            this._expr_5 = currVal_5;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchResultsComponent4.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.context.router.navigate([('record/edit/' + this.parent.context.$implicit._id)], { relativeTo: this.parent.parent.parent.context.route.parent }) !== false);
        return (true && pd_2_0);
    };
    return _View_SearchResultsComponent4;
}(import3.AppView));
function viewFactory_SearchResultsComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchResultsComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_SearchResultsComponent5 = (function (_super) {
    __extends(_View_SearchResultsComponent5, _super);
    function _View_SearchResultsComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchResultsComponent5, renderType_SearchResultsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchResultsComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'style', 'text-align: center'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'ng-pagination', new import2.InlineArray16(10, 'first-text', 'First', 'last-text', 'Last', 'next-text', '›', 'previous-text', '‹', 'style', 'cursor: pointer'), null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._el_2);
        var compView_2 = import32.viewFactory_PaginationComponent0(this.viewUtils, this.injector(2), this._appEl_2);
        this._PaginationComponent_2_4 = new import32.Wrapper_PaginationComponent();
        this._appEl_2.initComponent(this._PaginationComponent_2_4.context, [], compView_2);
        this._text_3 = this.renderer.createText(null, '\n    ', null);
        compView_2.create(this._PaginationComponent_2_4.context, [], null);
        this._text_4 = this.renderer.createText(this._el_0, '\n  ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'pageChange', this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        var subscription_0 = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_SearchResultsComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import33.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._PaginationComponent_2_4.context;
        }
        return notFoundResult;
    };
    _View_SearchResultsComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = '‹';
        this._PaginationComponent_2_4.check_previousText(currVal_2_0_0, throwOnChange, false);
        var currVal_2_0_1 = '›';
        this._PaginationComponent_2_4.check_nextText(currVal_2_0_1, throwOnChange, false);
        var currVal_2_0_2 = 'First';
        this._PaginationComponent_2_4.check_firstText(currVal_2_0_2, throwOnChange, false);
        var currVal_2_0_3 = 'Last';
        this._PaginationComponent_2_4.check_lastText(currVal_2_0_3, throwOnChange, false);
        var currVal_2_0_4 = this.parent.context.esContents.total;
        this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4, throwOnChange, false);
        var currVal_2_0_5 = this.parent.context.currentPage;
        this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5, throwOnChange, false);
        var currVal_2_0_6 = this.parent.context.pageSize;
        this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6, throwOnChange, false);
        this._PaginationComponent_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._PaginationComponent_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchResultsComponent5.prototype._handle_pageChange_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.onPageChange($event) !== false);
        return (true && pd_2_0);
    };
    return _View_SearchResultsComponent5;
}(import3.AppView));
function viewFactory_SearchResultsComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchResultsComponent5(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(227);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(11);
var import9 = __webpack_require__(10);
var import10 = __webpack_require__(219);
var import11 = __webpack_require__(75);
var import12 = __webpack_require__(83);
var import13 = __webpack_require__(93);
var Wrapper_AppComponent = (function () {
    function Wrapper_AppComponent() {
        this.changed = false;
        this.context = new import0.AppComponent();
    }
    Wrapper_AppComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        return changed;
    };
    Wrapper_AppComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_AppComponent;
}());
exports.Wrapper_AppComponent = Wrapper_AppComponent;
var renderType_AppComponent_Host = null;
var _View_AppComponent_Host0 = (function (_super) {
    __extends(_View_AppComponent_Host0, _super);
    function _View_AppComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AppComponent_Host0, renderType_AppComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AppComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'guern-cms', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_AppComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._AppComponent_0_4 = new Wrapper_AppComponent();
        this._appEl_0.initComponent(this._AppComponent_0_4.context, [], compView_0);
        compView_0.create(this._AppComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_AppComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.AppComponent) && (0 === requestNodeIndex))) {
            return this._AppComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_AppComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._AppComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._AppComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_AppComponent_Host0;
}(import1.AppView));
function viewFactory_AppComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AppComponent_Host === null)) {
        (renderType_AppComponent_Host = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, [], {}));
    }
    return new _View_AppComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.AppComponentNgFactory = new import9.ComponentFactory('guern-cms', viewFactory_AppComponent_Host0, import0.AppComponent);
var styles_AppComponent = [];
var renderType_AppComponent = null;
var _View_AppComponent0 = (function (_super) {
    __extends(_View_AppComponent0, _super);
    function _View_AppComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_AppComponent0, renderType_AppComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_AppComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'router-outlet', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        this._RouterOutlet_0_5 = new import10.Wrapper_RouterOutlet(this.parentInjector.get(import11.RouterOutletMap), this._appEl_0.vcRef, this.parentInjector.get(import12.ComponentFactoryResolver), null);
        this._text_1 = this.renderer.createText(parentRenderNode, ' ', null);
        this.init([], [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_AppComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import13.RouterOutlet) && (0 === requestNodeIndex))) {
            return this._RouterOutlet_0_5.context;
        }
        return notFoundResult;
    };
    _View_AppComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        this._RouterOutlet_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._RouterOutlet_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_AppComponent0.prototype.destroyInternal = function () {
        this._RouterOutlet_0_5.context.ngOnDestroy();
    };
    return _View_AppComponent0;
}(import1.AppView));
function viewFactory_AppComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_AppComponent === null)) {
        (renderType_AppComponent = viewUtils.createRenderComponentType('', 0, import8.ViewEncapsulation.None, styles_AppComponent, {}));
    }
    return new _View_AppComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_AppComponent0 = viewFactory_AppComponent0;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var sample_service_1 = __webpack_require__(454);
var BrowserComponent = (function () {
    function BrowserComponent(service) {
        this.service = service;
        this.test = 'Rendered by the browser';
        this.text = service.go();
    }
    BrowserComponent = __decorate([
        core_1.Component({
            template: "\n    <section>\n    <div class=\"container\">\n      <div class=\"row\">\n        <h4>{{test}}</h4>\n        <p>{{text}}</p> \n      </div> \n    </div>\n    </section>\n  ",
            providers: [sample_service_1.SampleService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof sample_service_1.SampleService !== 'undefined' && sample_service_1.SampleService) === 'function' && _a) || Object])
    ], BrowserComponent);
    return BrowserComponent;
    var _a;
}());
exports.BrowserComponent = BrowserComponent;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(228);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import6 = __webpack_require__(45);
var import8 = __webpack_require__(6);
var import9 = __webpack_require__(18);
var import10 = __webpack_require__(17);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(49);
var import13 = __webpack_require__(16);
var import14 = __webpack_require__(15);
var import15 = __webpack_require__(11);
var import16 = __webpack_require__(10);
var import17 = __webpack_require__(78);
var import18 = __webpack_require__(24);
var import19 = __webpack_require__(22);
var import20 = __webpack_require__(176);
var import21 = __webpack_require__(50);
var import22 = __webpack_require__(20);
var import23 = __webpack_require__(40);
var import24 = __webpack_require__(14);
var import25 = __webpack_require__(57);
var import26 = __webpack_require__(21);
var import27 = __webpack_require__(19);
var import28 = __webpack_require__(31);
var Wrapper_CartWidgetComponent = (function () {
    function Wrapper_CartWidgetComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.CartWidgetComponent(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_CartWidgetComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_CartWidgetComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_CartWidgetComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_CartWidgetComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_CartWidgetComponent;
}());
exports.Wrapper_CartWidgetComponent = Wrapper_CartWidgetComponent;
var renderType_CartWidgetComponent_Host = null;
var _View_CartWidgetComponent_Host0 = (function (_super) {
    __extends(_View_CartWidgetComponent_Host0, _super);
    function _View_CartWidgetComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent_Host0, renderType_CartWidgetComponent_Host, import8.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_CartWidgetComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'cart-widget', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_CartWidgetComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._NotificationService_0_4 = new import6.NotificationService(new import9.ElementRef(this._el_0), this.renderer);
        this._CartWidgetComponent_0_5 = new Wrapper_CartWidgetComponent(this._NotificationService_0_4, this.parentInjector.get(import10.IntlService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.CartService), this.parentInjector.get(import13.ActivatedRoute), this.parentInjector.get(import14.Router));
        this._appEl_0.initComponent(this._CartWidgetComponent_0_5.context, [], compView_0);
        compView_0.create(this._CartWidgetComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_CartWidgetComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import6.NotificationService) && (0 === requestNodeIndex))) {
            return this._NotificationService_0_4;
        }
        if (((token === import0.CartWidgetComponent) && (0 === requestNodeIndex))) {
            return this._CartWidgetComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_CartWidgetComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._CartWidgetComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._CartWidgetComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartWidgetComponent_Host0;
}(import3.AppView));
function viewFactory_CartWidgetComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CartWidgetComponent_Host === null)) {
        (renderType_CartWidgetComponent_Host = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, [], {}));
    }
    return new _View_CartWidgetComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.CartWidgetComponentNgFactory = new import16.ComponentFactory('cart-widget', viewFactory_CartWidgetComponent_Host0, import0.CartWidgetComponent);
var styles_CartWidgetComponent = [];
var renderType_CartWidgetComponent = null;
var _View_CartWidgetComponent0 = (function (_super) {
    __extends(_View_CartWidgetComponent0, _super);
    function _View_CartWidgetComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent0, renderType_CartWidgetComponent, import8.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_48 = import2.pureProxy1(function (p0) {
            return { 'cart-empty': p0 };
        });
        this._expr_49 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', new import2.InlineArray2(2, 'id', 'snackbar'), null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_2 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', new import2.InlineArray2(2, 'class', 'top-cart'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n    ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_2, 'a', new import2.InlineArray4(4, 'class', 'shopping-cart', 'href', '#'), null);
        this._NgClass_5_3 = new import17.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers), this.parentInjector.get(import23.KeyValueDiffers), new import9.ElementRef(this._el_5), this.renderer);
        this._text_6 = this.renderer.createText(this._el_5, ' \n        ', null);
        this._el_7 = import2.createRenderElement(this.renderer, this._el_5, 'i', new import2.InlineArray2(2, 'class', 'pointer fa fa-shopping-cart'), null);
        this._text_8 = this.renderer.createText(this._el_5, '\n        ', null);
        this._el_9 = import2.createRenderElement(this.renderer, this._el_5, 'div', new import2.InlineArray2(2, 'class', 'subtitle'), null);
        this._text_10 = this.renderer.createText(this._el_9, '', null);
        this._text_11 = this.renderer.createText(this._el_5, '\n    ', null);
        this._text_12 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_13 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n    ', null);
        this._el_15 = import2.createRenderElement(this.renderer, this._el_2, 'div', new import2.InlineArray2(2, 'class', 'cart-content'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n        ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_15, 'ul', new import2.InlineArray2(2, 'class', 'cart-list'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n            ', null);
        this._anchor_19 = this.renderer.createTemplateAnchor(this._el_17, null);
        this._appEl_19 = new import5.AppElement(19, 17, this, this._anchor_19);
        this._TemplateRef_19_5 = new import24.TemplateRef_(this._appEl_19, viewFactory_CartWidgetComponent1);
        this._NgFor_19_6 = new import18.Wrapper_NgFor(this._appEl_19.vcRef, this._TemplateRef_19_5, this.parentInjector.get(import22.IterableDiffers), this.ref);
        this._text_20 = this.renderer.createText(this._el_17, '\n        ', null);
        this._text_21 = this.renderer.createText(this._el_15, '\n        ', null);
        this._anchor_22 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_22 = new import5.AppElement(22, 15, this, this._anchor_22);
        this._TemplateRef_22_5 = new import24.TemplateRef_(this._appEl_22, viewFactory_CartWidgetComponent2);
        this._NgIf_22_6 = new import19.Wrapper_NgIf(this._appEl_22.vcRef, this._TemplateRef_22_5);
        this._text_23 = this.renderer.createText(this._el_15, '\n        ', null);
        this._anchor_24 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_24 = new import5.AppElement(24, 15, this, this._anchor_24);
        this._TemplateRef_24_5 = new import24.TemplateRef_(this._appEl_24, viewFactory_CartWidgetComponent3);
        this._NgIf_24_6 = new import19.Wrapper_NgIf(this._appEl_24.vcRef, this._TemplateRef_24_5);
        this._text_25 = this.renderer.createText(this._el_15, '\n        ', null);
        this._anchor_26 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_26 = new import5.AppElement(26, 15, this, this._anchor_26);
        this._TemplateRef_26_5 = new import24.TemplateRef_(this._appEl_26, viewFactory_CartWidgetComponent4);
        this._NgIf_26_6 = new import19.Wrapper_NgIf(this._appEl_26.vcRef, this._TemplateRef_26_5);
        this._text_27 = this.renderer.createText(this._el_15, '\n        ', null);
        this._anchor_28 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_28 = new import5.AppElement(28, 15, this, this._anchor_28);
        this._TemplateRef_28_5 = new import24.TemplateRef_(this._appEl_28, viewFactory_CartWidgetComponent5);
        this._NgIf_28_6 = new import19.Wrapper_NgIf(this._appEl_28.vcRef, this._TemplateRef_28_5);
        this._text_29 = this.renderer.createText(this._el_15, '\n    ', null);
        this._text_30 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_31 = this.renderer.createText(this._el_2, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_7, 'click', this.eventHandler(this._handle_click_7_0.bind(this)));
        this._pipe_numberFormat_0 = new import20.NumberFormat();
        this._pipe_intl_1 = new import21.IntlPipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._anchor_19,
            this._text_20,
            this._text_21,
            this._anchor_22,
            this._text_23,
            this._anchor_24,
            this._text_25,
            this._anchor_26,
            this._text_27,
            this._anchor_28,
            this._text_29,
            this._text_30,
            this._text_31
        ], [disposable_0], []);
        return null;
    };
    _View_CartWidgetComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import25.NgClass) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._NgClass_5_3.context;
        }
        if (((token === import24.TemplateRef) && (19 === requestNodeIndex))) {
            return this._TemplateRef_19_5;
        }
        if (((token === import26.NgFor) && (19 === requestNodeIndex))) {
            return this._NgFor_19_6.context;
        }
        if (((token === import24.TemplateRef) && (22 === requestNodeIndex))) {
            return this._TemplateRef_22_5;
        }
        if (((token === import27.NgIf) && (22 === requestNodeIndex))) {
            return this._NgIf_22_6.context;
        }
        if (((token === import24.TemplateRef) && (24 === requestNodeIndex))) {
            return this._TemplateRef_24_5;
        }
        if (((token === import27.NgIf) && (24 === requestNodeIndex))) {
            return this._NgIf_24_6.context;
        }
        if (((token === import24.TemplateRef) && (26 === requestNodeIndex))) {
            return this._TemplateRef_26_5;
        }
        if (((token === import27.NgIf) && (26 === requestNodeIndex))) {
            return this._NgIf_26_6.context;
        }
        if (((token === import24.TemplateRef) && (28 === requestNodeIndex))) {
            return this._TemplateRef_28_5;
        }
        if (((token === import27.NgIf) && (28 === requestNodeIndex))) {
            return this._NgIf_28_6.context;
        }
        return notFoundResult;
    };
    _View_CartWidgetComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_5_0_0 = 'shopping-cart';
        this._NgClass_5_3.check_klass(currVal_5_0_0, throwOnChange, false);
        var currVal_5_0_1 = this._map_48((this.context.cartService.count() == 0));
        this._NgClass_5_3.check_ngClass(currVal_5_0_1, throwOnChange, false);
        this._NgClass_5_3.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_19_0_0 = this.context.cartService.itemsLimited();
        this._NgFor_19_6.check_ngForOf(currVal_19_0_0, throwOnChange, false);
        this._NgFor_19_6.detectChangesInInputProps(this, this._anchor_19, throwOnChange);
        var currVal_22_0_0 = (this.context.cartService.count() > this.context.cartService.limit);
        this._NgIf_22_6.check_ngIf(currVal_22_0_0, throwOnChange, false);
        this._NgIf_22_6.detectChangesInInputProps(this, this._anchor_22, throwOnChange);
        var currVal_24_0_0 = (this.context.cartService.count() > 0);
        this._NgIf_24_6.check_ngIf(currVal_24_0_0, throwOnChange, false);
        this._NgIf_24_6.detectChangesInInputProps(this, this._anchor_24, throwOnChange);
        var currVal_26_0_0 = (this.context.cartService.count() == 0);
        this._NgIf_26_6.check_ngIf(currVal_26_0_0, throwOnChange, false);
        this._NgIf_26_6.detectChangesInInputProps(this, this._anchor_26, throwOnChange);
        var currVal_28_0_0 = (this.context.cartService.count() > 0);
        this._NgIf_28_6.check_ngIf(currVal_28_0_0, throwOnChange, false);
        this._NgIf_28_6.detectChangesInInputProps(this, this._anchor_28, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_5_3.detectChangesInHostProps(this, this._el_5, throwOnChange);
        var currVal_49 = import2.interpolate(1, '(', this.context.cartService.count(), ')');
        if (import2.checkBinding(throwOnChange, this._expr_49, currVal_49)) {
            this.renderer.setText(this._text_10, currVal_49);
            this._expr_49 = currVal_49;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartWidgetComponent0.prototype._handle_click_7_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_7_0 = (this.context.utils.lLink('cart', this.context.language) !== false);
        return (true && pd_7_0);
    };
    return _View_CartWidgetComponent0;
}(import3.AppView));
function viewFactory_CartWidgetComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CartWidgetComponent === null)) {
        (renderType_CartWidgetComponent = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, styles_CartWidgetComponent, {}));
    }
    return new _View_CartWidgetComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_CartWidgetComponent0 = viewFactory_CartWidgetComponent0;
var _View_CartWidgetComponent1 = (function (_super) {
    __extends(_View_CartWidgetComponent1, _super);
    function _View_CartWidgetComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent1, renderType_CartWidgetComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_17 = import1.UNINITIALIZED;
        this._expr_18 = import1.UNINITIALIZED;
        this._expr_19 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray4(4, 'class', 'remove pointer', 'title', 'Remove item'), null);
        this._text_3 = this.renderer.createText(this._el_2, '×', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'class', 'pointer'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n                    ', null);
        this._el_7 = import2.createRenderElement(this.renderer, this._el_5, 'img', new import2.InlineArray8(6, 'alt', '', 'height', '90', 'width', '90'), null);
        this._text_8 = this.renderer.createText(this._el_5, '\n                    ', null);
        this._text_9 = this.renderer.createText(this._el_5, '\n                ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_11 = import2.createRenderElement(this.renderer, this._el_0, 'span', new import2.InlineArray2(2, 'class', 'quantity'), null);
        this._text_12 = this.renderer.createText(this._el_11, '', null);
        this._el_13 = import2.createRenderElement(this.renderer, this._el_11, 'span', new import2.InlineArray2(2, 'class', 'amount'), null);
        this._text_14 = this.renderer.createText(this._el_13, '', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n                ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this._pipe_numberFormat_0_0 = import2.pureProxy2(this.parent._pipe_numberFormat_0.transform.bind(this.parent._pipe_numberFormat_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15,
            this._text_16
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_CartWidgetComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_17 = import2.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.content.cover.front, '');
        if (import2.checkBinding(throwOnChange, this._expr_17, currVal_17)) {
            this.renderer.setElementProperty(this._el_7, 'src', this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL, currVal_17));
            this._expr_17 = currVal_17;
        }
        var currVal_18 = import2.interpolate(1, '', this.context.$implicit.qty, ' × ');
        if (import2.checkBinding(throwOnChange, this._expr_18, currVal_18)) {
            this.renderer.setText(this._text_12, currVal_18);
            this._expr_18 = currVal_18;
        }
        valUnwrapper.reset();
        var currVal_19 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_numberFormat_0_0, this.parent._pipe_numberFormat_0.transform)(this.context.$implicit.content.price, 2)), '€');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_19, currVal_19))) {
            this.renderer.setText(this._text_14, currVal_19);
            this._expr_19 = currVal_19;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartWidgetComponent1.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.removeFromCart(this.context.$implicit.content._id) !== false);
        return (true && pd_2_0);
    };
    _View_CartWidgetComponent1.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.context.utils.lLink(this.context.$implicit.content.url, this.parent.context.language) !== false);
        return (true && pd_5_0);
    };
    return _View_CartWidgetComponent1;
}(import3.AppView));
function viewFactory_CartWidgetComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_CartWidgetComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_CartWidgetComponent2 = (function (_super) {
    __extends(_View_CartWidgetComponent2, _super);
    function _View_CartWidgetComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent2, renderType_CartWidgetComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'p', new import2.InlineArray2(2, 'class', 'text-center'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'class', 'pointer gray-text'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this._pipe_intl_1_0 = import2.pureProxy2(this.parent._pipe_intl_1.transform.bind(this.parent._pipe_intl_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_CartWidgetComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import2.interpolate(2, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_0, this.parent._pipe_intl_1.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.SHOW_ALL), this.parent.context.language)), ' (', this.parent.context.cartService.count(), ')');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_3, currVal_5);
            this._expr_5 = currVal_5;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartWidgetComponent2.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.utils.lLink('cart', this.parent.context.language) !== false);
        return (true && pd_2_0);
    };
    return _View_CartWidgetComponent2;
}(import3.AppView));
function viewFactory_CartWidgetComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_CartWidgetComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_CartWidgetComponent3 = (function (_super) {
    __extends(_View_CartWidgetComponent3, _super);
    function _View_CartWidgetComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent3, renderType_CartWidgetComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'p', new import2.InlineArray2(2, 'class', 'total'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'span', new import2.InlineArray2(2, 'class', 'amount'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_intl_1_1 = import2.pureProxy2(this.parent._pipe_intl_1.transform.bind(this.parent._pipe_intl_1));
        this._pipe_numberFormat_0_1 = import2.pureProxy2(this.parent._pipe_numberFormat_0.transform.bind(this.parent._pipe_numberFormat_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_CartWidgetComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_1, this.parent._pipe_intl_1.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.PROPERTY.SUBTOTAL), this.parent.context.language)), ': ');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
        valUnwrapper.reset();
        var currVal_6 = import2.interpolate(1, '\n        ', valUnwrapper.unwrap(import2.castByValue(this._pipe_numberFormat_0_1, this.parent._pipe_numberFormat_0.transform)(this.parent.context.cartService.subtotal(), 2)), '€');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_6, currVal_6))) {
            this.renderer.setText(this._text_3, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartWidgetComponent3;
}(import3.AppView));
function viewFactory_CartWidgetComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_CartWidgetComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_CartWidgetComponent4 = (function (_super) {
    __extends(_View_CartWidgetComponent4, _super);
    function _View_CartWidgetComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent4, renderType_CartWidgetComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'p', new import2.InlineArray2(2, 'class', 'total'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._pipe_intl_1_2 = import2.pureProxy2(this.parent._pipe_intl_1.transform.bind(this.parent._pipe_intl_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_CartWidgetComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_2 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_2, this.parent._pipe_intl_1.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.EMPTY), this.parent.context.language)), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_2, currVal_2))) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartWidgetComponent4;
}(import3.AppView));
function viewFactory_CartWidgetComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_CartWidgetComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_CartWidgetComponent5 = (function (_super) {
    __extends(_View_CartWidgetComponent5, _super);
    function _View_CartWidgetComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartWidgetComponent5, renderType_CartWidgetComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_6 = import1.UNINITIALIZED;
    }
    _View_CartWidgetComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'p', new import2.InlineArray2(2, 'class', 'buttons text-center'), null);
        this._text_1 = this.renderer.createText(this._el_0, ' \n            ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'class', 'pointer btn btn-very-small-white no-margin-bottom margin-seven no-margin-lr'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n            ', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this._pipe_intl_1_3 = import2.pureProxy2(this.parent._pipe_intl_1.transform.bind(this.parent._pipe_intl_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5
        ], [disposable_0], []);
        return null;
    };
    _View_CartWidgetComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_6 = import2.interpolate(1, '\n                    ', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_3, this.parent._pipe_intl_1.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.GO), this.parent.context.language)), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_6, currVal_6))) {
            this.renderer.setText(this._text_3, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartWidgetComponent5.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.context.utils.lLink('cart', this.parent.context.language) !== false);
        return (true && pd_2_0);
    };
    return _View_CartWidgetComponent5;
}(import3.AppView));
function viewFactory_CartWidgetComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_CartWidgetComponent5(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(163);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(17);
var import9 = __webpack_require__(5);
var import10 = __webpack_require__(9);
var import11 = __webpack_require__(18);
var import12 = __webpack_require__(2);
var import13 = __webpack_require__(49);
var import14 = __webpack_require__(16);
var import15 = __webpack_require__(15);
var import16 = __webpack_require__(11);
var import17 = __webpack_require__(10);
var import18 = __webpack_require__(22);
var import19 = __webpack_require__(50);
var import20 = __webpack_require__(176);
var import21 = __webpack_require__(14);
var import22 = __webpack_require__(19);
var import23 = __webpack_require__(31);
var import24 = __webpack_require__(24);
var import25 = __webpack_require__(20);
var import26 = __webpack_require__(21);
var import27 = __webpack_require__(217);
var import28 = __webpack_require__(79);
var import29 = __webpack_require__(43);
var import30 = __webpack_require__(70);
var import31 = __webpack_require__(26);
var import32 = __webpack_require__(48);
var import33 = __webpack_require__(28);
var import34 = __webpack_require__(33);
var import35 = __webpack_require__(218);
var import36 = __webpack_require__(71);
var import37 = __webpack_require__(449);
var import38 = __webpack_require__(230);
var Wrapper_CartComponent = (function () {
    function Wrapper_CartComponent(p0, p1, p2, p3, p4, p5, p6, p7) {
        this.changed = false;
        this.context = new import0.CartComponent(p0, p1, p2, p3, p4, p5, p6, p7);
    }
    Wrapper_CartComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_CartComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_CartComponent;
}());
exports.Wrapper_CartComponent = Wrapper_CartComponent;
var renderType_CartComponent_Host = null;
var _View_CartComponent_Host0 = (function (_super) {
    __extends(_View_CartComponent_Host0, _super);
    function _View_CartComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent_Host0, renderType_CartComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_CartComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_CartComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._CartComponent_0_4 = new Wrapper_CartComponent(this.parentInjector.get(import8.IntlService), this.parentInjector.get(import9.ConfigService), this.parentInjector.get(import10.ContentService), new import11.ElementRef(this._el_0), this.parentInjector.get(import12.UtilsService), this.parentInjector.get(import13.CartService), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router));
        this._appEl_0.initComponent(this._CartComponent_0_4.context, [], compView_0);
        compView_0.create(this._CartComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_CartComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.CartComponent) && (0 === requestNodeIndex))) {
            return this._CartComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_CartComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._CartComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._CartComponent_0_4.context.ngAfterContentInit();
            }
            this._CartComponent_0_4.context.ngAfterContentChecked();
        }
        this._CartComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent_Host0;
}(import1.AppView));
function viewFactory_CartComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CartComponent_Host === null)) {
        (renderType_CartComponent_Host = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, [], {}));
    }
    return new _View_CartComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.CartComponentNgFactory = new import17.ComponentFactory('ng-component', viewFactory_CartComponent_Host0, import0.CartComponent);
var styles_CartComponent = [];
var renderType_CartComponent = null;
var _View_CartComponent0 = (function (_super) {
    __extends(_View_CartComponent0, _super);
    function _View_CartComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent0, renderType_CartComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_CartComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_5 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_6 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'page-title page-title-small bg-gray'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n    ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n        ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_8, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'div', new import4.InlineArray2(2, 'class', 'col-md-8 col-sm-12'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                ', null);
        this._text_14 = this.renderer.createText(this._el_12, '\n                ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_15 = new import3.AppElement(15, 12, this, this._anchor_15);
        this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15, viewFactory_CartComponent1);
        this._NgIf_15_6 = new import18.Wrapper_NgIf(this._appEl_15.vcRef, this._TemplateRef_15_5);
        this._text_16 = this.renderer.createText(this._el_12, '\n                ', null);
        this._anchor_17 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_17 = new import3.AppElement(17, 12, this, this._anchor_17);
        this._TemplateRef_17_5 = new import21.TemplateRef_(this._appEl_17, viewFactory_CartComponent2);
        this._NgIf_17_6 = new import18.Wrapper_NgIf(this._appEl_17.vcRef, this._TemplateRef_17_5);
        this._text_18 = this.renderer.createText(this._el_12, '\n                ', null);
        this._text_19 = this.renderer.createText(this._el_12, '\n            ', null);
        this._text_20 = this.renderer.createText(this._el_10, '\n        ', null);
        this._text_21 = this.renderer.createText(this._el_8, '\n    ', null);
        this._text_22 = this.renderer.createText(this._el_6, '\n', null);
        this._text_23 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_24 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_25 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-section section-pull-up-less'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n    ', null);
        this._el_27 = import4.createRenderElement(this.renderer, this._el_25, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_28 = this.renderer.createText(this._el_27, '\n\n        ', null);
        this._text_29 = this.renderer.createText(this._el_27, '\n        ', null);
        this._anchor_30 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_30 = new import3.AppElement(30, 27, this, this._anchor_30);
        this._TemplateRef_30_5 = new import21.TemplateRef_(this._appEl_30, viewFactory_CartComponent3);
        this._NgIf_30_6 = new import18.Wrapper_NgIf(this._appEl_30.vcRef, this._TemplateRef_30_5);
        this._text_31 = this.renderer.createText(this._el_27, '\n        ', null);
        this._anchor_32 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_32 = new import3.AppElement(32, 27, this, this._anchor_32);
        this._TemplateRef_32_5 = new import21.TemplateRef_(this._appEl_32, viewFactory_CartComponent4);
        this._NgIf_32_6 = new import18.Wrapper_NgIf(this._appEl_32.vcRef, this._TemplateRef_32_5);
        this._text_33 = this.renderer.createText(this._el_27, '\n\n        ', null);
        this._text_34 = this.renderer.createText(this._el_27, '\n        ', null);
        this._anchor_35 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_35 = new import3.AppElement(35, 27, this, this._anchor_35);
        this._TemplateRef_35_5 = new import21.TemplateRef_(this._appEl_35, viewFactory_CartComponent5);
        this._NgIf_35_6 = new import18.Wrapper_NgIf(this._appEl_35.vcRef, this._TemplateRef_35_5);
        this._text_36 = this.renderer.createText(this._el_27, '\n\n    ', null);
        this._text_37 = this.renderer.createText(this._el_25, '\n\n', null);
        this._text_38 = this.renderer.createText(parentRenderNode, '\n', null);
        this._pipe_intl_0 = new import19.IntlPipe();
        this._pipe_numberFormat_1 = new import20.NumberFormat();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._anchor_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._text_29,
            this._anchor_30,
            this._text_31,
            this._anchor_32,
            this._text_33,
            this._text_34,
            this._anchor_35,
            this._text_36,
            this._text_37,
            this._text_38
        ], [], []);
        return null;
    };
    _View_CartComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import22.NgIf) && (15 === requestNodeIndex))) {
            return this._NgIf_15_6.context;
        }
        if (((token === import21.TemplateRef) && (17 === requestNodeIndex))) {
            return this._TemplateRef_17_5;
        }
        if (((token === import22.NgIf) && (17 === requestNodeIndex))) {
            return this._NgIf_17_6.context;
        }
        if (((token === import21.TemplateRef) && (30 === requestNodeIndex))) {
            return this._TemplateRef_30_5;
        }
        if (((token === import22.NgIf) && (30 === requestNodeIndex))) {
            return this._NgIf_30_6.context;
        }
        if (((token === import21.TemplateRef) && (32 === requestNodeIndex))) {
            return this._TemplateRef_32_5;
        }
        if (((token === import22.NgIf) && (32 === requestNodeIndex))) {
            return this._NgIf_32_6.context;
        }
        if (((token === import21.TemplateRef) && (35 === requestNodeIndex))) {
            return this._TemplateRef_35_5;
        }
        if (((token === import22.NgIf) && (35 === requestNodeIndex))) {
            return this._NgIf_35_6.context;
        }
        return notFoundResult;
    };
    _View_CartComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_15_0_0 = !((this.context.cartService.paymentData == null) ? null : this.context.cartService.paymentData.paymentID);
        this._NgIf_15_6.check_ngIf(currVal_15_0_0, throwOnChange, false);
        this._NgIf_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        var currVal_17_0_0 = ((this.context.cartService.paymentData == null) ? null : this.context.cartService.paymentData.paymentID);
        this._NgIf_17_6.check_ngIf(currVal_17_0_0, throwOnChange, false);
        this._NgIf_17_6.detectChangesInInputProps(this, this._anchor_17, throwOnChange);
        var currVal_30_0_0 = ((this.context.cartService.paymentData == null) ? null : this.context.cartService.paymentData.paymentID);
        this._NgIf_30_6.check_ngIf(currVal_30_0_0, throwOnChange, false);
        this._NgIf_30_6.detectChangesInInputProps(this, this._anchor_30, throwOnChange);
        var currVal_32_0_0 = ((this.context.cartService.paymentData == null) ? null : this.context.cartService.paymentData.paymentID);
        this._NgIf_32_6.check_ngIf(currVal_32_0_0, throwOnChange, false);
        this._NgIf_32_6.detectChangesInInputProps(this, this._anchor_32, throwOnChange);
        var currVal_35_0_0 = !((this.context.cartService.paymentData == null) ? null : this.context.cartService.paymentData.paymentID);
        this._NgIf_35_6.check_ngIf(currVal_35_0_0, throwOnChange, false);
        this._NgIf_35_6.detectChangesInInputProps(this, this._anchor_35, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent0;
}(import1.AppView));
function viewFactory_CartComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CartComponent === null)) {
        (renderType_CartComponent = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, styles_CartComponent, {}));
    }
    return new _View_CartComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_CartComponent0 = viewFactory_CartComponent0;
var _View_CartComponent1 = (function (_super) {
    __extends(_View_CartComponent1, _super);
    function _View_CartComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent1, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import7.UNINITIALIZED;
    }
    _View_CartComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'h1', new import4.InlineArray2(2, 'class', 'black-text'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._pipe_intl_0_0 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_CartComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_2 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.TITLE), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_2, currVal_2))) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent1;
}(import1.AppView));
function viewFactory_CartComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent2 = (function (_super) {
    __extends(_View_CartComponent2, _super);
    function _View_CartComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent2, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import7.UNINITIALIZED;
    }
    _View_CartComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'h1', new import4.InlineArray2(2, 'class', 'black-text'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._pipe_intl_0_1 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_CartComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_2 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.ORDER.TITLE), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_2, currVal_2))) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent2;
}(import1.AppView));
function viewFactory_CartComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent3 = (function (_super) {
    __extends(_View_CartComponent3, _super);
    function _View_CartComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent3, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_26 = import7.UNINITIALIZED;
        this._expr_28 = import7.UNINITIALIZED;
        this._expr_30 = import7.UNINITIALIZED;
        this._expr_32 = import7.UNINITIALIZED;
        this._expr_33 = import7.UNINITIALIZED;
    }
    _View_CartComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'col-md-6 col-sm-6 xs-margin-bottom-five'), null);
        this._text_3 = this.renderer.createText(this._el_2, ' \n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'p', new import4.InlineArray2(2, 'class', 'text-med'), null);
        this._text_5 = this.renderer.createText(this._el_4, '', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_2, 'p', new import4.InlineArray2(2, 'class', 'text-med'), null);
        this._text_8 = this.renderer.createText(this._el_7, '', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_7, 'a', new import4.InlineArray2(2, 'href', 'mailto:order@forgottenrecords.com'), null);
        this._text_10 = this.renderer.createText(this._el_9, 'order@forgottenrecords.com', null);
        this._text_11 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'col-md-6 col-sm-6'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n                ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_13, 'p', new import4.InlineArray2(2, 'class', 'text-large font-weight-600 text-black margin-three no-margin-top'), null);
        this._text_16 = this.renderer.createText(this._el_15, ' ', null);
        this._text_17 = this.renderer.createText(this._el_13, '\n                ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_13, 'p', new import4.InlineArray2(2, 'class', 'text-med no-margin'), null);
        this._text_19 = this.renderer.createText(this._el_18, '', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'code', import4.EMPTY_INLINE_ARRAY, null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_20, 'a', new import4.InlineArray2(2, 'target', '_blank'), null);
        this._text_22 = this.renderer.createText(this._el_21, '', null);
        this._text_23 = this.renderer.createText(this._el_18, '\n                ', null);
        this._text_24 = this.renderer.createText(this._el_13, '\n            ', null);
        this._text_25 = this.renderer.createText(this._el_0, '\n        ', null);
        this._pipe_intl_0_2 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_intl_0_3 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_intl_0_4 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._el_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._text_25
        ], [], []);
        return null;
    };
    _View_CartComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_26 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.ORDER.MESSAGE), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_26, currVal_26))) {
            this.renderer.setText(this._text_5, currVal_26);
            this._expr_26 = currVal_26;
        }
        valUnwrapper.reset();
        var currVal_28 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.ORDER.QUESTION), this.parent.context.currentLanguage)), ' ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_8, currVal_28);
            this._expr_28 = currVal_28;
        }
        valUnwrapper.reset();
        var currVal_30 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.ORDER.PAYMENT_ID), this.parent.context.currentLanguage)), ': \n                    ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_30, currVal_30))) {
            this.renderer.setText(this._text_19, currVal_30);
            this._expr_30 = currVal_30;
        }
        var currVal_32 = import4.interpolate(1, '', this.parent.context.cartService.paymentData.returnUrl, '');
        if (import4.checkBinding(throwOnChange, this._expr_32, currVal_32)) {
            this.renderer.setElementProperty(this._el_21, 'href', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL, currVal_32));
            this._expr_32 = currVal_32;
        }
        var currVal_33 = import4.interpolate(1, '', this.parent.context.cartService.paymentData.paymentID, '');
        if (import4.checkBinding(throwOnChange, this._expr_33, currVal_33)) {
            this.renderer.setText(this._text_22, currVal_33);
            this._expr_33 = currVal_33;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent3;
}(import1.AppView));
function viewFactory_CartComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent4 = (function (_super) {
    __extends(_View_CartComponent4, _super);
    function _View_CartComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent4, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_CartComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'learn-more row col-md-12 col-sm-12 center-col text-center'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-medium button xs-margin-bottom-five'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'Revenir au catalogue', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7
        ], [disposable_0], []);
        return null;
    };
    _View_CartComponent4.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.context.router.navigate(['catalogue'], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_4_0);
    };
    return _View_CartComponent4;
}(import1.AppView));
function viewFactory_CartComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent5 = (function (_super) {
    __extends(_View_CartComponent5, _super);
    function _View_CartComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent5, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_29 = import7.UNINITIALIZED;
    }
    _View_CartComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import21.TemplateRef_(this._appEl_2, viewFactory_CartComponent6);
        this._NgIf_2_6 = new import18.Wrapper_NgIf(this._appEl_2.vcRef, this._TemplateRef_2_5);
        this._text_3 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_4 = new import3.AppElement(4, 0, this, this._anchor_4);
        this._TemplateRef_4_5 = new import21.TemplateRef_(this._appEl_4, viewFactory_CartComponent9);
        this._NgIf_4_6 = new import18.Wrapper_NgIf(this._appEl_4.vcRef, this._TemplateRef_4_5);
        this._text_5 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'col-sm-12 cupon padding-five border-top border-bottom'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                ', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6, null);
        this._appEl_8 = new import3.AppElement(8, 6, this, this._anchor_8);
        this._TemplateRef_8_5 = new import21.TemplateRef_(this._appEl_8, viewFactory_CartComponent10);
        this._NgIf_8_6 = new import18.Wrapper_NgIf(this._appEl_8.vcRef, this._TemplateRef_8_5);
        this._text_9 = this.renderer.createText(this._el_6, '\n                ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_6, 'button', new import4.InlineArray2(2, 'class', 'highlight-button btn btn-very-small no-margin pull-right continue-shopping'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_6, '\n                ', null);
        this._text_13 = this.renderer.createText(this._el_6, '\n            ', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_15 = new import3.AppElement(15, 0, this, this._anchor_15);
        this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15, viewFactory_CartComponent11);
        this._NgIf_15_6 = new import18.Wrapper_NgIf(this._appEl_15.vcRef, this._TemplateRef_15_5);
        this._text_16 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_10, 'click', this.eventHandler(this._handle_click_10_0.bind(this)));
        this._pipe_intl_0_10 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3,
            this._anchor_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16
        ], [disposable_0], []);
        return null;
    };
    _View_CartComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import22.NgIf) && (2 === requestNodeIndex))) {
            return this._NgIf_2_6.context;
        }
        if (((token === import21.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import22.NgIf) && (4 === requestNodeIndex))) {
            return this._NgIf_4_6.context;
        }
        if (((token === import21.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import22.NgIf) && (8 === requestNodeIndex))) {
            return this._NgIf_8_6.context;
        }
        if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import22.NgIf) && (15 === requestNodeIndex))) {
            return this._NgIf_15_6.context;
        }
        return notFoundResult;
    };
    _View_CartComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_2_0_0 = (this.parent.context.cartService.count() > 0);
        this._NgIf_2_6.check_ngIf(currVal_2_0_0, throwOnChange, false);
        this._NgIf_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        var currVal_4_0_0 = (this.parent.context.cartService.count() == 0);
        this._NgIf_4_6.check_ngIf(currVal_4_0_0, throwOnChange, false);
        this._NgIf_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        var currVal_8_0_0 = (this.parent.context.cartService.count() > 0);
        this._NgIf_8_6.check_ngIf(currVal_8_0_0, throwOnChange, false);
        this._NgIf_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        var currVal_15_0_0 = (this.parent.context.cartService.count() > 0);
        this._NgIf_15_6.check_ngIf(currVal_15_0_0, throwOnChange, false);
        this._NgIf_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_29 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_10, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CART.BACK), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_29, currVal_29))) {
            this.renderer.setText(this._text_11, currVal_29);
            this._expr_29 = currVal_29;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartComponent5.prototype._handle_click_10_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_10_0 = (this.parent.context.router.navigate(['catalogue'], { relativeTo: this.parent.context.route.parent }) !== false);
        return (true && pd_10_0);
    };
    return _View_CartComponent5;
}(import1.AppView));
function viewFactory_CartComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent6 = (function (_super) {
    __extends(_View_CartComponent6, _super);
    function _View_CartComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent6, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_34 = import7.UNINITIALIZED;
        this._expr_36 = import7.UNINITIALIZED;
        this._expr_38 = import7.UNINITIALIZED;
    }
    _View_CartComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-sm-12 shop-cart-table'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'table', new import4.InlineArray2(2, 'class', 'table shop-cart text-center'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'thead', import4.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                        ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'th', new import4.InlineArray2(2, 'class', 'first'), null);
        this._text_9 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_6, 'th', new import4.InlineArray2(2, 'class', 'text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'), null);
        this._text_11 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_6, 'th', new import4.InlineArray2(2, 'class', 'text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_6, 'th', new import4.InlineArray2(2, 'class', 'text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_6, 'th', new import4.InlineArray2(2, 'class', 'text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text'), null);
        this._text_19 = this.renderer.createText(this._el_18, '', null);
        this._text_20 = this.renderer.createText(this._el_6, '\n                            ', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_6, 'th', import4.EMPTY_INLINE_ARRAY, null);
        this._text_22 = this.renderer.createText(this._el_6, '\n                        ', null);
        this._text_23 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_24 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_25 = import4.createRenderElement(this.renderer, this._el_2, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                        ', null);
        this._anchor_27 = this.renderer.createTemplateAnchor(this._el_25, null);
        this._appEl_27 = new import3.AppElement(27, 25, this, this._anchor_27);
        this._TemplateRef_27_5 = new import21.TemplateRef_(this._appEl_27, viewFactory_CartComponent7);
        this._NgFor_27_6 = new import24.Wrapper_NgFor(this._appEl_27.vcRef, this._TemplateRef_27_5, this.parent.parent.parentInjector.get(import25.IterableDiffers), this.parent.parent.ref);
        this._text_28 = this.renderer.createText(this._el_25, '\n                    ', null);
        this._text_29 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_30 = this.renderer.createText(this._el_0, '\n            ', null);
        this._pipe_intl_0_5 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_intl_0_6 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_intl_0_7 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._anchor_27,
            this._text_28,
            this._text_29,
            this._text_30
        ], [], []);
        return null;
    };
    _View_CartComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (27 === requestNodeIndex))) {
            return this._TemplateRef_27_5;
        }
        if (((token === import26.NgFor) && (27 === requestNodeIndex))) {
            return this._NgFor_27_6.context;
        }
        return notFoundResult;
    };
    _View_CartComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_27_0_0 = this.parent.parent.context.cartService.items;
        this._NgFor_27_6.check_ngForOf(currVal_27_0_0, throwOnChange, false);
        this._NgFor_27_6.detectChangesInInputProps(this, this._anchor_27, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_34 = import4.interpolate(1, '\n                                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_5, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.PRICE), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_34, currVal_34))) {
            this.renderer.setText(this._text_13, currVal_34);
            this._expr_34 = currVal_34;
        }
        valUnwrapper.reset();
        var currVal_36 = import4.interpolate(1, '\n                                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_6, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.QUANTITY), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_36, currVal_36))) {
            this.renderer.setText(this._text_16, currVal_36);
            this._expr_36 = currVal_36;
        }
        valUnwrapper.reset();
        var currVal_38 = import4.interpolate(1, '\n                                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_7, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.SUBTOTAL), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_38, currVal_38))) {
            this.renderer.setText(this._text_19, currVal_38);
            this._expr_38 = currVal_38;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent6;
}(import1.AppView));
function viewFactory_CartComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent7 = (function (_super) {
    __extends(_View_CartComponent7, _super);
    function _View_CartComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent7, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_51 = import7.UNINITIALIZED;
        this._expr_52 = import7.UNINITIALIZED;
        this._expr_53 = import7.UNINITIALIZED;
        this._expr_54 = import7.UNINITIALIZED;
        this._arr_56 = import4.pureProxy10(function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
            return [
                p0,
                p1,
                p2,
                p3,
                p4,
                p5,
                p6,
                p7,
                p8,
                p9
            ];
        });
        this._expr_57 = import7.UNINITIALIZED;
    }
    _View_CartComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'product-thumbnail text-left'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                                    ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'img', new import4.InlineArray2(2, 'alt', ''), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                                ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n                            ', null);
        this._text_9 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'text-left'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n                                ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_10, '\n                                ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_10, 'span', new import4.InlineArray2(2, 'class', 'text-uppercase display-block text-small margin-two'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_10, '\n                                ', null);
        this._text_18 = this.renderer.createText(this._el_10, '\n                            ', null);
        this._text_19 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'text-left'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'product-quantity'), null);
        this._text_24 = this.renderer.createText(this._el_23, '\n                                ', null);
        this._el_25 = import4.createRenderElement(this.renderer, this._el_23, 'div', new import4.InlineArray2(2, 'class', 'select-style med-input shop-shorting shop-shorting-cart no-border-round'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                                    ', null);
        this._el_27 = import4.createRenderElement(this.renderer, this._el_25, 'select', import4.EMPTY_INLINE_ARRAY, null);
        this._SelectControlValueAccessor_27_3 = new import27.Wrapper_SelectControlValueAccessor(this.renderer, new import11.ElementRef(this._el_27));
        this._NG_VALUE_ACCESSOR_27_4 = [this._SelectControlValueAccessor_27_3.context];
        this._NgModel_27_5 = new import28.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_27_4);
        this._NgControl_27_6 = this._NgModel_27_5.context;
        this._NgControlStatus_27_7 = new import29.Wrapper_NgControlStatus(this._NgControl_27_6);
        this._text_28 = this.renderer.createText(this._el_27, '\n                                        ', null);
        this._anchor_29 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_29 = new import3.AppElement(29, 27, this, this._anchor_29);
        this._TemplateRef_29_5 = new import21.TemplateRef_(this._appEl_29, viewFactory_CartComponent8);
        this._NgFor_29_6 = new import24.Wrapper_NgFor(this._appEl_29.vcRef, this._TemplateRef_29_5, this.parent.parent.parent.parentInjector.get(import25.IterableDiffers), this.parent.parent.parent.ref);
        this._text_30 = this.renderer.createText(this._el_27, '\n                                    ', null);
        this._text_31 = this.renderer.createText(this._el_25, '\n                                ', null);
        this._text_32 = this.renderer.createText(this._el_23, '\n                            ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_34 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'product-subtotal text-left'), null);
        this._text_35 = this.renderer.createText(this._el_34, '', null);
        this._text_36 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._el_37 = import4.createRenderElement(this.renderer, this._el_0, 'td', new import4.InlineArray2(2, 'class', 'product-remove text-center'), null);
        this._text_38 = this.renderer.createText(this._el_37, '\n                                ', null);
        this._el_39 = import4.createRenderElement(this.renderer, this._el_37, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._el_40 = import4.createRenderElement(this.renderer, this._el_39, 'i', new import4.InlineArray2(2, 'class', 'fa fa-times'), null);
        this._text_41 = this.renderer.createText(this._el_37, '\n                            ', null);
        this._text_42 = this.renderer.createText(this._el_0, '\n                        ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_12, 'click', this.eventHandler(this._handle_click_12_0.bind(this)));
        this._pipe_numberFormat_1_0 = import4.pureProxy2(this.parent.parent.parent._pipe_numberFormat_1.transform.bind(this.parent.parent.parent._pipe_numberFormat_1));
        var disposable_2 = this.renderer.listen(this._el_27, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_27_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_27, 'change', this.eventHandler(this._handle_change_27_1.bind(this)));
        var disposable_4 = this.renderer.listen(this._el_27, 'blur', this.eventHandler(this._handle_blur_27_2.bind(this)));
        var subscription_0 = this._NgModel_27_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_27_0.bind(this)));
        this._pipe_numberFormat_1_1 = import4.pureProxy2(this.parent.parent.parent._pipe_numberFormat_1.transform.bind(this.parent.parent.parent._pipe_numberFormat_1));
        var disposable_5 = this.renderer.listen(this._el_39, 'click', this.eventHandler(this._handle_click_39_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._anchor_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._text_36,
            this._el_37,
            this._text_38,
            this._el_39,
            this._el_40,
            this._text_41,
            this._text_42
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5
        ], [subscription_0]);
        return null;
    };
    _View_CartComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (29 === requestNodeIndex))) {
            return this._TemplateRef_29_5;
        }
        if (((token === import26.NgFor) && (29 === requestNodeIndex))) {
            return this._NgFor_29_6.context;
        }
        if (((token === import30.SelectControlValueAccessor) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._SelectControlValueAccessor_27_3.context;
        }
        if (((token === import31.NG_VALUE_ACCESSOR) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._NG_VALUE_ACCESSOR_27_4;
        }
        if (((token === import32.NgModel) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._NgModel_27_5.context;
        }
        if (((token === import33.NgControl) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._NgControl_27_6;
        }
        if (((token === import34.NgControlStatus) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 30)))) {
            return this._NgControlStatus_27_7.context;
        }
        return notFoundResult;
    };
    _View_CartComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._SelectControlValueAccessor_27_3.detectChangesInInputProps(this, this._el_27, throwOnChange);
        var currVal_27_1_0 = this.context.$implicit.qty;
        this._NgModel_27_5.check_model(currVal_27_1_0, throwOnChange, false);
        this._NgModel_27_5.detectChangesInInputProps(this, this._el_27, throwOnChange);
        this._NgControlStatus_27_7.detectChangesInInputProps(this, this._el_27, throwOnChange);
        var currVal_29_0_0 = this._arr_56(1, 2, 3, 4, 5, 6, 7, 8, 9, 10);
        this._NgFor_29_6.check_ngForOf(currVal_29_0_0, throwOnChange, false);
        this._NgFor_29_6.detectChangesInInputProps(this, this._anchor_29, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_51 = import4.interpolate(1, '/data/covers/', this.context.$implicit.content.cover.front, '');
        if (import4.checkBinding(throwOnChange, this._expr_51, currVal_51)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL, currVal_51));
            this._expr_51 = currVal_51;
        }
        var currVal_52 = import4.interpolate(1, '', this.context.$implicit.content.title, '');
        if (import4.checkBinding(throwOnChange, this._expr_52, currVal_52)) {
            this.renderer.setText(this._text_13, currVal_52);
            this._expr_52 = currVal_52;
        }
        var currVal_53 = import4.interpolate(1, 'Ref: ', this.context.$implicit.content.reference, '');
        if (import4.checkBinding(throwOnChange, this._expr_53, currVal_53)) {
            this.renderer.setText(this._text_16, currVal_53);
            this._expr_53 = currVal_53;
        }
        valUnwrapper.reset();
        var currVal_54 = import4.interpolate(1, '\n                                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_0, this.parent.parent.parent._pipe_numberFormat_1.transform)(this.context.$implicit.content.price, 2)), '€\n                            ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_54, currVal_54))) {
            this.renderer.setText(this._text_21, currVal_54);
            this._expr_54 = currVal_54;
        }
        this._SelectControlValueAccessor_27_3.detectChangesInHostProps(this, this._el_27, throwOnChange);
        this._NgModel_27_5.detectChangesInHostProps(this, this._el_27, throwOnChange);
        this._NgControlStatus_27_7.detectChangesInHostProps(this, this._el_27, throwOnChange);
        valUnwrapper.reset();
        var currVal_57 = import4.interpolate(1, '\n                                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_1, this.parent.parent.parent._pipe_numberFormat_1.transform)((this.context.$implicit.qty * this.context.$implicit.content.price), 2)), '€');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_57, currVal_57))) {
            this.renderer.setText(this._text_35, currVal_57);
            this._expr_57 = currVal_57;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartComponent7.prototype.destroyInternal = function () {
        this._NgModel_27_5.context.ngOnDestroy();
    };
    _View_CartComponent7.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.parent.parent.context.router.navigate([this.context.$implicit.content.url], { relativeTo: this.parent.parent.parent.context.route.parent }) !== false);
        return (true && pd_4_0);
    };
    _View_CartComponent7.prototype._handle_click_12_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_12_0 = (this.parent.parent.parent.context.router.navigate([this.context.$implicit.content.url], { relativeTo: this.parent.parent.parent.context.route.parent }) !== false);
        return (true && pd_12_0);
    };
    _View_CartComponent7.prototype._handle_ngModelChange_27_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_27_0 = ((this.context.$implicit.qty = $event) !== false);
        return (true && pd_27_0);
    };
    _View_CartComponent7.prototype._handle_change_27_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_27_0 = (this.parent.parent.parent.context.cartService.update(this.context.$implicit.content, $event.target.value) !== false);
        var pd_27_1 = (this._SelectControlValueAccessor_27_3.context.onChange($event.target.value) !== false);
        return ((true && pd_27_0) && pd_27_1);
    };
    _View_CartComponent7.prototype._handle_blur_27_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_27_0 = (this._SelectControlValueAccessor_27_3.context.onTouched() !== false);
        return (true && pd_27_0);
    };
    _View_CartComponent7.prototype._handle_click_39_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_39_0 = (this.parent.parent.parent.context.cartService.remove(this.context.$implicit.content._id) !== false);
        return (true && pd_39_0);
    };
    return _View_CartComponent7;
}(import1.AppView));
function viewFactory_CartComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent8 = (function (_super) {
    __extends(_View_CartComponent8, _super);
    function _View_CartComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent8, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import7.UNINITIALIZED;
    }
    _View_CartComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'option', import4.EMPTY_INLINE_ARRAY, null);
        this._NgSelectOption_0_3 = new import27.Wrapper_NgSelectOption(new import11.ElementRef(this._el_0), this.renderer, this.parent._SelectControlValueAccessor_27_3.context);
        this._NgSelectMultipleOption_0_4 = new import35.Wrapper_NgSelectMultipleOption(new import11.ElementRef(this._el_0), this.renderer, null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_CartComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import30.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgSelectOption_0_3.context;
        }
        if (((token === import36.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgSelectMultipleOption_0_4.context;
        }
        return notFoundResult;
    };
    _View_CartComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.$implicit;
        this._NgSelectOption_0_3.check_value(currVal_0_0_0, throwOnChange, false);
        this._NgSelectOption_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_0_1_0 = this.context.$implicit;
        this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0, throwOnChange, false);
        this._NgSelectMultipleOption_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSelectOption_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgSelectMultipleOption_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_4 = import4.interpolate(1, '', this.context.$implicit, '');
        if (import4.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartComponent8.prototype.destroyInternal = function () {
        this._NgSelectOption_0_3.context.ngOnDestroy();
        this._NgSelectMultipleOption_0_4.context.ngOnDestroy();
    };
    return _View_CartComponent8;
}(import1.AppView));
function viewFactory_CartComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent9 = (function (_super) {
    __extends(_View_CartComponent9, _super);
    function _View_CartComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent9, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import7.UNINITIALIZED;
    }
    _View_CartComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-sm-12 shop-cart-table'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'p', import4.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n            ', null);
        this._pipe_intl_0_8 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [], []);
        return null;
    };
    _View_CartComponent9.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_8, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.EMPTY), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_3, currVal_5);
            this._expr_5 = currVal_5;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent9;
}(import1.AppView));
function viewFactory_CartComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent9(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent10 = (function (_super) {
    __extends(_View_CartComponent10, _super);
    function _View_CartComponent10(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent10, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import7.UNINITIALIZED;
    }
    _View_CartComponent10.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'button', new import4.InlineArray2(2, 'class', 'highlight-button btn btn-very-small no-margin pull-left'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this._pipe_intl_0_9 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_CartComponent10.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_2 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_9, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.DO_EMPTY), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_2, currVal_2))) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CartComponent10.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.cartService.clear() !== false);
        return (true && pd_0_0);
    };
    return _View_CartComponent10;
}(import1.AppView));
function viewFactory_CartComponent10(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent10(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent11 = (function (_super) {
    __extends(_View_CartComponent11, _super);
    function _View_CartComponent11(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent11, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_75 = import7.UNINITIALIZED;
        this._expr_77 = import7.UNINITIALIZED;
        this._expr_79 = import7.UNINITIALIZED;
        this._expr_81 = import7.UNINITIALIZED;
        this._expr_83 = import7.UNINITIALIZED;
        this._expr_85 = import7.UNINITIALIZED;
        this._expr_87 = import7.UNINITIALIZED;
        this._expr_89 = import7.UNINITIALIZED;
    }
    _View_CartComponent11.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-sm-12 padding-five no-padding-bottom'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n                ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'col-md-11 no-padding-right xs-no-padding'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_3, 'table', new import4.InlineArray2(2, 'class', 'table cart-total'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n                        ', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_5, 'tbody', import4.EMPTY_INLINE_ARRAY, null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                            ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_7, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                                ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'th', new import4.InlineArray2(2, 'class', 'padding-two text-right no-padding-right text-uppercase font-weight-600 letter-spacing-2 text-small xs-no-padding'), null);
        this._text_12 = this.renderer.createText(this._el_11, '', null);
        this._text_13 = this.renderer.createText(this._el_9, '\n                                ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_9, 'td', new import4.InlineArray2(2, 'class', 'padding-two text-uppercase text-right no-padding-right font-weight-600 black-text xs-no-padding'), null);
        this._text_15 = this.renderer.createText(this._el_14, '', null);
        this._text_16 = this.renderer.createText(this._el_9, '\n                            ', null);
        this._text_17 = this.renderer.createText(this._el_7, '\n                            ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_7, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                                ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'th', new import4.InlineArray2(2, 'class', 'padding-two text-right no-padding-right text-small xs-no-padding'), null);
        this._text_21 = this.renderer.createText(this._el_20, '\n                                    ', null);
        this._el_22 = import4.createRenderElement(this.renderer, this._el_20, 'span', new import4.InlineArray2(2, 'class', 'text-uppercase font-weight-600 letter-spacing-2'), null);
        this._text_23 = this.renderer.createText(this._el_22, '', null);
        this._el_24 = import4.createRenderElement(this.renderer, this._el_20, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_25 = this.renderer.createText(this._el_20, '\n                                    ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_20, 'p', new import4.InlineArray2(2, 'class', 'font-weight-100'), null);
        this._text_27 = this.renderer.createText(this._el_26, '', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_26, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_29 = this.renderer.createText(this._el_26, '', null);
        this._text_30 = this.renderer.createText(this._el_20, '\n                                ', null);
        this._text_31 = this.renderer.createText(this._el_18, '\n                                ', null);
        this._el_32 = import4.createRenderElement(this.renderer, this._el_18, 'td', new import4.InlineArray2(2, 'class', 'padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-small xs-no-padding'), null);
        this._text_33 = this.renderer.createText(this._el_32, '', null);
        this._text_34 = this.renderer.createText(this._el_18, '\n                            ', null);
        this._text_35 = this.renderer.createText(this._el_7, '\n                            ', null);
        this._el_36 = import4.createRenderElement(this.renderer, this._el_7, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_37 = this.renderer.createText(this._el_36, '\n                                ', null);
        this._el_38 = import4.createRenderElement(this.renderer, this._el_36, 'td', new import4.InlineArray4(4, 'class', 'padding-one no-padding-right xs-no-padding', 'colspan', '2'), null);
        this._text_39 = this.renderer.createText(this._el_38, '\n                                    ', null);
        this._el_40 = import4.createRenderElement(this.renderer, this._el_38, 'hr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_41 = this.renderer.createText(this._el_38, '\n                                ', null);
        this._text_42 = this.renderer.createText(this._el_36, '\n                            ', null);
        this._text_43 = this.renderer.createText(this._el_7, '\n                            ', null);
        this._el_44 = import4.createRenderElement(this.renderer, this._el_7, 'tr', new import4.InlineArray2(2, 'class', 'total'), null);
        this._text_45 = this.renderer.createText(this._el_44, '\n                                ', null);
        this._el_46 = import4.createRenderElement(this.renderer, this._el_44, 'th', new import4.InlineArray2(2, 'class', 'padding-two text-uppercase text-right no-padding-right font-weight-600 text-large xs-no-padding'), null);
        this._text_47 = this.renderer.createText(this._el_46, '', null);
        this._text_48 = this.renderer.createText(this._el_44, '\n                                ', null);
        this._el_49 = import4.createRenderElement(this.renderer, this._el_44, 'td', new import4.InlineArray2(2, 'class', 'padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-large no-letter-spacing xs-no-padding'), null);
        this._text_50 = this.renderer.createText(this._el_49, '', null);
        this._text_51 = this.renderer.createText(this._el_44, '\n                            ', null);
        this._text_52 = this.renderer.createText(this._el_7, '\n                            ', null);
        this._el_53 = import4.createRenderElement(this.renderer, this._el_7, 'tr', import4.EMPTY_INLINE_ARRAY, null);
        this._text_54 = this.renderer.createText(this._el_53, '\n                                ', null);
        this._el_55 = import4.createRenderElement(this.renderer, this._el_53, 'td', new import4.InlineArray4(4, 'class', 'padding-one no-padding-right xs-no-padding', 'colspan', '2'), null);
        this._text_56 = this.renderer.createText(this._el_55, '\n                                    ', null);
        this._el_57 = import4.createRenderElement(this.renderer, this._el_55, 'hr', new import4.InlineArray2(2, 'class', 'no-margin-bottom'), null);
        this._text_58 = this.renderer.createText(this._el_55, '\n                                ', null);
        this._text_59 = this.renderer.createText(this._el_53, '\n                            ', null);
        this._text_60 = this.renderer.createText(this._el_7, '\n                        ', null);
        this._text_61 = this.renderer.createText(this._el_5, '\n                    ', null);
        this._text_62 = this.renderer.createText(this._el_3, '\n                    ', null);
        this._text_63 = this.renderer.createText(this._el_3, '\n\n                ', null);
        this._text_64 = this.renderer.createText(this._el_0, '\n\n                ', null);
        this._anchor_65 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_65 = new import3.AppElement(65, 0, this, this._anchor_65);
        this._TemplateRef_65_5 = new import21.TemplateRef_(this._appEl_65, viewFactory_CartComponent12);
        this._NgIf_65_6 = new import18.Wrapper_NgIf(this._appEl_65.vcRef, this._TemplateRef_65_5);
        this._text_66 = this.renderer.createText(this._el_0, '\n\n                ', null);
        this._el_67 = import4.createRenderElement(this.renderer, this._el_0, 'payment-paypal-express-checkout', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_67 = new import3.AppElement(67, 0, this, this._el_67);
        var compView_67 = import37.viewFactory_PaymentPayPalExpressCheckoutComponent0(this.viewUtils, this.injector(67), this._appEl_67);
        this._PaymentPayPalExpressCheckoutComponent_67_4 = new import37.Wrapper_PaymentPayPalExpressCheckoutComponent(this.parent.parent.parentInjector.get(import13.CartService), this.parent.parent.parentInjector.get(import12.UtilsService), this.parent.parent.parentInjector.get(import9.ConfigService));
        this._appEl_67.initComponent(this._PaymentPayPalExpressCheckoutComponent_67_4.context, [], compView_67);
        compView_67.create(this._PaymentPayPalExpressCheckoutComponent_67_4.context, [], null);
        this._text_68 = this.renderer.createText(this._el_0, '\n                ', null);
        this._text_69 = this.renderer.createText(this._el_0, '\n            ', null);
        this._pipe_intl_0_11 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_numberFormat_1_2 = import4.pureProxy2(this.parent.parent._pipe_numberFormat_1.transform.bind(this.parent.parent._pipe_numberFormat_1));
        this._pipe_intl_0_12 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_intl_0_13 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_intl_0_14 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_numberFormat_1_3 = import4.pureProxy2(this.parent.parent._pipe_numberFormat_1.transform.bind(this.parent.parent._pipe_numberFormat_1));
        this._pipe_intl_0_15 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_numberFormat_1_4 = import4.pureProxy2(this.parent.parent._pipe_numberFormat_1.transform.bind(this.parent.parent._pipe_numberFormat_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._text_23,
            this._el_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._el_46,
            this._text_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._el_53,
            this._text_54,
            this._el_55,
            this._text_56,
            this._el_57,
            this._text_58,
            this._text_59,
            this._text_60,
            this._text_61,
            this._text_62,
            this._text_63,
            this._text_64,
            this._anchor_65,
            this._text_66,
            this._el_67,
            this._text_68,
            this._text_69
        ], [], []);
        return null;
    };
    _View_CartComponent11.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (65 === requestNodeIndex))) {
            return this._TemplateRef_65_5;
        }
        if (((token === import22.NgIf) && (65 === requestNodeIndex))) {
            return this._NgIf_65_6.context;
        }
        if (((token === import38.PaymentPayPalExpressCheckoutComponent) && (67 === requestNodeIndex))) {
            return this._PaymentPayPalExpressCheckoutComponent_67_4.context;
        }
        return notFoundResult;
    };
    _View_CartComponent11.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_65_0_0 = (this.parent.parent.context.awayMessage && this.parent.parent.context.awayMessage.active);
        this._NgIf_65_6.check_ngIf(currVal_65_0_0, throwOnChange, false);
        this._NgIf_65_6.detectChangesInInputProps(this, this._anchor_65, throwOnChange);
        var currVal_67_0_0 = this.parent.parent.context.currentLanguage;
        this._PaymentPayPalExpressCheckoutComponent_67_4.check_language(currVal_67_0_0, throwOnChange, false);
        this._PaymentPayPalExpressCheckoutComponent_67_4.detectChangesInInputProps(this, this._el_67, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_75 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_11, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.SUBTOTAL), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_75, currVal_75))) {
            this.renderer.setText(this._text_12, currVal_75);
            this._expr_75 = currVal_75;
        }
        valUnwrapper.reset();
        var currVal_77 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_2, this.parent.parent._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.subtotal(), 2)), ' €');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_77, currVal_77))) {
            this.renderer.setText(this._text_15, currVal_77);
            this._expr_77 = currVal_77;
        }
        valUnwrapper.reset();
        var currVal_79 = import4.interpolate(1, '\n                                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_12, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.TITLE), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_79, currVal_79))) {
            this.renderer.setText(this._text_23, currVal_79);
            this._expr_79 = currVal_79;
        }
        valUnwrapper.reset();
        var currVal_81 = import4.interpolate(1, '\n                                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_13, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.ONE), this.parent.parent.context.currentLanguage)), ': 9.70 €');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_81, currVal_81))) {
            this.renderer.setText(this._text_27, currVal_81);
            this._expr_81 = currVal_81;
        }
        valUnwrapper.reset();
        var currVal_83 = import4.interpolate(1, '\n                                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_14, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.SHIPPING.OTHERS), this.parent.parent.context.currentLanguage)), ': 3.00 €');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_83, currVal_83))) {
            this.renderer.setText(this._text_29, currVal_83);
            this._expr_83 = currVal_83;
        }
        valUnwrapper.reset();
        var currVal_85 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_3, this.parent.parent._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.shipping(), 2)), ' €');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_85, currVal_85))) {
            this.renderer.setText(this._text_33, currVal_85);
            this._expr_85 = currVal_85;
        }
        valUnwrapper.reset();
        var currVal_87 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_15, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.PROPERTY.TOTAL), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_87, currVal_87))) {
            this.renderer.setText(this._text_47, currVal_87);
            this._expr_87 = currVal_87;
        }
        valUnwrapper.reset();
        var currVal_89 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_numberFormat_1_4, this.parent.parent._pipe_numberFormat_1.transform)(this.parent.parent.context.cartService.total(), 2)), ' €');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_89, currVal_89))) {
            this.renderer.setText(this._text_50, currVal_89);
            this._expr_89 = currVal_89;
        }
        this._PaymentPayPalExpressCheckoutComponent_67_4.detectChangesInHostProps(this, this._el_67, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent11;
}(import1.AppView));
function viewFactory_CartComponent11(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent11(viewUtils, parentInjector, declarationEl);
}
var _View_CartComponent12 = (function (_super) {
    __extends(_View_CartComponent12, _super);
    function _View_CartComponent12(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CartComponent12, renderType_CartComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_7 = import7.UNINITIALIZED;
        this._expr_8 = import7.UNINITIALIZED;
    }
    _View_CartComponent12.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'text-center col-md-12 block message-away'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'message-away-title'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, ' \n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'message-away-content'), null);
        this._text_6 = this.renderer.createText(this._el_0, '\n                ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6
        ], [], []);
        return null;
    };
    _View_CartComponent12.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_7 = import4.interpolate(1, '', this.parent.parent.parent.context.awayMessage.title[this.parent.parent.parent.context.currentLanguage], ':');
        if (import4.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setText(this._text_3, currVal_7);
            this._expr_7 = currVal_7;
        }
        var currVal_8 = this.parent.parent.parent.context.awayMessage.content[this.parent.parent.parent.context.currentLanguage];
        if (import4.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setElementProperty(this._el_5, 'innerHTML', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.HTML, currVal_8));
            this._expr_8 = currVal_8;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CartComponent12;
}(import1.AppView));
function viewFactory_CartComponent12(viewUtils, parentInjector, declarationEl) {
    return new _View_CartComponent12(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(164);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(25);
var import5 = __webpack_require__(9);
var import6 = __webpack_require__(3);
var import8 = __webpack_require__(6);
var import9 = __webpack_require__(4);
var import10 = __webpack_require__(149);
var import11 = __webpack_require__(143);
var import12 = __webpack_require__(15);
var import13 = __webpack_require__(5);
var import14 = __webpack_require__(17);
var import15 = __webpack_require__(2);
var import16 = __webpack_require__(16);
var import17 = __webpack_require__(11);
var import18 = __webpack_require__(10);
var import19 = __webpack_require__(22);
var import20 = __webpack_require__(50);
var import21 = __webpack_require__(14);
var import22 = __webpack_require__(19);
var import23 = __webpack_require__(65);
var import24 = __webpack_require__(44);
var import25 = __webpack_require__(31);
var Wrapper_ContentPageComponent = (function () {
    function Wrapper_ContentPageComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.ContentPageComponent(p0, p1, p2, p3, p4, p5);
    }
    Wrapper_ContentPageComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentPageComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentPageComponent;
}());
exports.Wrapper_ContentPageComponent = Wrapper_ContentPageComponent;
var renderType_ContentPageComponent_Host = null;
var _View_ContentPageComponent_Host0 = (function (_super) {
    __extends(_View_ContentPageComponent_Host0, _super);
    function _View_ContentPageComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent_Host0, renderType_ContentPageComponent_Host, import8.ViewType.HOST, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import6.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentPageComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._MetaService_0_4 = new import4.MetaService(this.parentInjector.get(import10.Meta));
        this._ContentService_0_5 = new import5.ContentService(this.parentInjector.get(import11.Http), this.parentInjector.get(import12.Router));
        this._ContentPageComponent_0_6 = new Wrapper_ContentPageComponent(this.parentInjector.get(import13.ConfigService), this.parentInjector.get(import14.IntlService), this.parentInjector.get(import15.UtilsService), this._MetaService_0_4, this._ContentService_0_5, this.parentInjector.get(import16.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentPageComponent_0_6.context, [], compView_0);
        compView_0.create(this._ContentPageComponent_0_6.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentPageComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.MetaService) && (0 === requestNodeIndex))) {
            return this._MetaService_0_4;
        }
        if (((token === import5.ContentService) && (0 === requestNodeIndex))) {
            return this._ContentService_0_5;
        }
        if (((token === import0.ContentPageComponent) && (0 === requestNodeIndex))) {
            return this._ContentPageComponent_0_6.context;
        }
        return notFoundResult;
    };
    _View_ContentPageComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentPageComponent_0_6.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentPageComponent_0_6.context.ngAfterContentChecked();
        }
        this._ContentPageComponent_0_6.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageComponent_Host0;
}(import1.AppView));
function viewFactory_ContentPageComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPageComponent_Host === null)) {
        (renderType_ContentPageComponent_Host = viewUtils.createRenderComponentType('', 0, import17.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentPageComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentPageComponentNgFactory = new import18.ComponentFactory('ng-component', viewFactory_ContentPageComponent_Host0, import0.ContentPageComponent);
var styles_ContentPageComponent = [];
var renderType_ContentPageComponent = null;
var _View_ContentPageComponent0 = (function (_super) {
    __extends(_View_ContentPageComponent0, _super);
    function _View_ContentPageComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent0, renderType_ContentPageComponent, import8.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import6.createRenderElement(this.renderer, parentRenderNode, 'section', new import6.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import6.createRenderElement(this.renderer, this._el_0, 'div', new import6.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_5 = this.renderer.createText(parentRenderNode, '\n', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_6 = new import3.AppElement(6, null, this, this._anchor_6);
        this._TemplateRef_6_5 = new import21.TemplateRef_(this._appEl_6, viewFactory_ContentPageComponent1);
        this._NgIf_6_6 = new import19.Wrapper_NgIf(this._appEl_6.vcRef, this._TemplateRef_6_5);
        this._text_7 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_8 = this.renderer.createText(parentRenderNode, '\n', null);
        this._anchor_9 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_9 = new import3.AppElement(9, null, this, this._anchor_9);
        this._TemplateRef_9_5 = new import21.TemplateRef_(this._appEl_9, viewFactory_ContentPageComponent3);
        this._NgIf_9_6 = new import19.Wrapper_NgIf(this._appEl_9.vcRef, this._TemplateRef_9_5);
        this._text_10 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_11 = this.renderer.createText(parentRenderNode, '\n', null);
        this._anchor_12 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_12 = new import3.AppElement(12, null, this, this._anchor_12);
        this._TemplateRef_12_5 = new import21.TemplateRef_(this._appEl_12, viewFactory_ContentPageComponent4);
        this._NgIf_12_6 = new import19.Wrapper_NgIf(this._appEl_12.vcRef, this._TemplateRef_12_5);
        this._pipe_intl_0 = new import20.IntlPipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._text_8,
            this._anchor_9,
            this._text_10,
            this._text_11,
            this._anchor_12
        ], [], []);
        return null;
    };
    _View_ContentPageComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import22.NgIf) && (6 === requestNodeIndex))) {
            return this._NgIf_6_6.context;
        }
        if (((token === import21.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import22.NgIf) && (9 === requestNodeIndex))) {
            return this._NgIf_9_6.context;
        }
        if (((token === import21.TemplateRef) && (12 === requestNodeIndex))) {
            return this._TemplateRef_12_5;
        }
        if (((token === import22.NgIf) && (12 === requestNodeIndex))) {
            return this._NgIf_12_6.context;
        }
        return notFoundResult;
    };
    _View_ContentPageComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_6_0_0 = (this.context.content && this.context.currentLanguage);
        this._NgIf_6_6.check_ngIf(currVal_6_0_0, throwOnChange, false);
        this._NgIf_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_9_0_0 = this.context.loading;
        this._NgIf_9_6.check_ngIf(currVal_9_0_0, throwOnChange, false);
        this._NgIf_9_6.detectChangesInInputProps(this, this._anchor_9, throwOnChange);
        var currVal_12_0_0 = (this.context.content && this.context.currentLanguage);
        this._NgIf_12_6.check_ngIf(currVal_12_0_0, throwOnChange, false);
        this._NgIf_12_6.detectChangesInInputProps(this, this._anchor_12, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageComponent0;
}(import1.AppView));
function viewFactory_ContentPageComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentPageComponent === null)) {
        (renderType_ContentPageComponent = viewUtils.createRenderComponentType('', 0, import17.ViewEncapsulation.None, styles_ContentPageComponent, {}));
    }
    return new _View_ContentPageComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentPageComponent0 = viewFactory_ContentPageComponent0;
var _View_ContentPageComponent1 = (function (_super) {
    __extends(_View_ContentPageComponent1, _super);
    function _View_ContentPageComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent1, renderType_ContentPageComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
        this._expr_22 = import9.UNINITIALIZED;
    }
    _View_ContentPageComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.createRenderElement(this.renderer, null, 'section', new import6.InlineArray2(2, 'class', 'page-title page-title-small bg-gray'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import6.createRenderElement(this.renderer, this._el_0, 'div', new import6.InlineArray2(2, 'class', 'container'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import6.createRenderElement(this.renderer, this._el_2, 'div', new import6.InlineArray2(2, 'class', 'row'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n            ', null);
        this._el_6 = import6.createRenderElement(this.renderer, this._el_4, 'div', new import6.InlineArray2(2, 'class', 'col-md-4 col-sm-12'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                ', null);
        this._text_8 = this.renderer.createText(this._el_6, '\n                ', null);
        this._el_9 = import6.createRenderElement(this.renderer, this._el_6, 'h1', new import6.InlineArray2(2, 'class', 'black-text'), null);
        this._text_10 = this.renderer.createText(this._el_9, '', null);
        this._text_11 = this.renderer.createText(this._el_6, '\n                ', null);
        this._text_12 = this.renderer.createText(this._el_6, '\n            ', null);
        this._text_13 = this.renderer.createText(this._el_4, '\n            ', null);
        this._text_14 = this.renderer.createText(this._el_4, '\n            ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_4, null);
        this._appEl_15 = new import3.AppElement(15, 4, this, this._anchor_15);
        this._TemplateRef_15_5 = new import21.TemplateRef_(this._appEl_15, viewFactory_ContentPageComponent2);
        this._NgIf_15_6 = new import19.Wrapper_NgIf(this._appEl_15.vcRef, this._TemplateRef_15_5);
        this._text_16 = this.renderer.createText(this._el_4, '\n        ', null);
        this._text_17 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_18 = this.renderer.createText(this._el_0, '\n', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._text_17,
            this._text_18
        ], [], []);
        return null;
    };
    _View_ContentPageComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import21.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import22.NgIf) && (15 === requestNodeIndex))) {
            return this._NgIf_15_6.context;
        }
        return notFoundResult;
    };
    _View_ContentPageComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_15_0_0 = (this.parent.context.content.url == 'about');
        this._NgIf_15_6.check_ngIf(currVal_15_0_0, throwOnChange, false);
        this._NgIf_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_22 = import6.interpolate(1, '', this.parent.context.content.title[this.parent.context.currentLanguage], '');
        if (import6.checkBinding(throwOnChange, this._expr_22, currVal_22)) {
            this.renderer.setText(this._text_10, currVal_22);
            this._expr_22 = currVal_22;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageComponent1;
}(import1.AppView));
function viewFactory_ContentPageComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageComponent2 = (function (_super) {
    __extends(_View_ContentPageComponent2, _super);
    function _View_ContentPageComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent2, renderType_ContentPageComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
        this._expr_22 = import9.UNINITIALIZED;
        this._expr_24 = import9.UNINITIALIZED;
        this._expr_26 = import9.UNINITIALIZED;
        this._expr_28 = import9.UNINITIALIZED;
    }
    _View_ContentPageComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.createRenderElement(this.renderer, null, 'div', new import6.InlineArray2(2, 'class', 'col-md-8 col-sm-12 breadcrumb text-uppercase'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_3 = import6.createRenderElement(this.renderer, this._el_0, 'ul', new import6.InlineArray2(2, 'class', 'breadcrumb-sub'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n                        ', null);
        this._el_5 = import6.createRenderElement(this.renderer, this._el_3, 'li', import6.EMPTY_INLINE_ARRAY, null);
        this._el_6 = import6.createRenderElement(this.renderer, this._el_5, 'a', new import6.InlineArray2(2, 'class', 'breadcrumb-active'), null);
        this._text_7 = this.renderer.createText(this._el_6, '', null);
        this._text_8 = this.renderer.createText(this._el_3, '\n                        ', null);
        this._el_9 = import6.createRenderElement(this.renderer, this._el_3, 'li', import6.EMPTY_INLINE_ARRAY, null);
        this._el_10 = import6.createRenderElement(this.renderer, this._el_9, 'a', new import6.InlineArray2(2, 'class', 'pointer'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_3, '\n                        ', null);
        this._el_13 = import6.createRenderElement(this.renderer, this._el_3, 'li', import6.EMPTY_INLINE_ARRAY, null);
        this._el_14 = import6.createRenderElement(this.renderer, this._el_13, 'a', new import6.InlineArray2(2, 'class', 'pointer'), null);
        this._text_15 = this.renderer.createText(this._el_14, '', null);
        this._text_16 = this.renderer.createText(this._el_3, '\n                            ', null);
        this._el_17 = import6.createRenderElement(this.renderer, this._el_3, 'li', import6.EMPTY_INLINE_ARRAY, null);
        this._el_18 = import6.createRenderElement(this.renderer, this._el_17, 'a', new import6.InlineArray2(2, 'class', 'pointer'), null);
        this._text_19 = this.renderer.createText(this._el_18, '', null);
        this._text_20 = this.renderer.createText(this._el_3, '\n                    ', null);
        this._text_21 = this.renderer.createText(this._el_0, '\n\n                ', null);
        this._pipe_intl_0_0 = import6.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        var disposable_0 = this.renderer.listen(this._el_10, 'click', this.eventHandler(this._handle_click_10_0.bind(this)));
        this._pipe_intl_0_1 = import6.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        var disposable_1 = this.renderer.listen(this._el_14, 'click', this.eventHandler(this._handle_click_14_0.bind(this)));
        this._pipe_intl_0_2 = import6.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        var disposable_2 = this.renderer.listen(this._el_18, 'click', this.eventHandler(this._handle_click_18_0.bind(this)));
        this._pipe_intl_0_3 = import6.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._text_21
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentPageComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import9.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_22 = import6.interpolate(1, '\n                            ', valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_0, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PRESENTATION), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange, this._expr_22, currVal_22))) {
            this.renderer.setText(this._text_7, currVal_22);
            this._expr_22 = currVal_22;
        }
        valUnwrapper.reset();
        var currVal_24 = import6.interpolate(1, '\n                            ', valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_1, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PRESS), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange, this._expr_24, currVal_24))) {
            this.renderer.setText(this._text_11, currVal_24);
            this._expr_24 = currVal_24;
        }
        valUnwrapper.reset();
        var currVal_26 = import6.interpolate(1, '\n                            ', valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_2, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.PARTNERS), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange, this._expr_26, currVal_26))) {
            this.renderer.setText(this._text_15, currVal_26);
            this._expr_26 = currVal_26;
        }
        valUnwrapper.reset();
        var currVal_28 = import6.interpolate(1, '\n                            ', valUnwrapper.unwrap(import6.castByValue(this._pipe_intl_0_3, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.MENU.ABOUT.CONTACT), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import6.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_19, currVal_28);
            this._expr_28 = currVal_28;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentPageComponent2.prototype._handle_click_10_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_10_0 = (this.parent.parent.context.utils.scrollToClass('press', (0 - 100)) !== false);
        return (true && pd_10_0);
    };
    _View_ContentPageComponent2.prototype._handle_click_14_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_14_0 = (this.parent.parent.context.utils.scrollToClass('partners', 0) !== false);
        return (true && pd_14_0);
    };
    _View_ContentPageComponent2.prototype._handle_click_18_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_18_0 = (this.parent.parent.context.utils.scrollToClass('contact', 0) !== false);
        return (true && pd_18_0);
    };
    return _View_ContentPageComponent2;
}(import1.AppView));
function viewFactory_ContentPageComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageComponent3 = (function (_super) {
    __extends(_View_ContentPageComponent3, _super);
    function _View_ContentPageComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent3, renderType_ContentPageComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentPageComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.createRenderElement(this.renderer, null, 'section', import6.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import6.createRenderElement(this.renderer, this._el_0, 'div', new import6.InlineArray2(2, 'class', 'container'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import6.createRenderElement(this.renderer, this._el_2, 'div', new import6.InlineArray2(2, 'class', 'row'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n            ', null);
        this._el_6 = import6.createRenderElement(this.renderer, this._el_4, 'loading-indicator', new import6.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_6 = new import3.AppElement(6, 4, this, this._el_6);
        var compView_6 = import23.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(6), this._appEl_6);
        this._LoadingIndicator_6_4 = new import23.Wrapper_LoadingIndicator();
        this._appEl_6.initComponent(this._LoadingIndicator_6_4.context, [], compView_6);
        compView_6.create(this._LoadingIndicator_6_4.context, [], null);
        this._text_7 = this.renderer.createText(this._el_4, '  \n        ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_9 = this.renderer.createText(this._el_0, '\n', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9
        ], [], []);
        return null;
    };
    _View_ContentPageComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.LoadingIndicator) && (6 === requestNodeIndex))) {
            return this._LoadingIndicator_6_4.context;
        }
        return notFoundResult;
    };
    _View_ContentPageComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_6_0_0 = '#B6B6B6';
        this._LoadingIndicator_6_4.check_color(currVal_6_0_0, throwOnChange, false);
        this._LoadingIndicator_6_4.detectChangesInInputProps(this, this._el_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_6_4.detectChangesInHostProps(this, this._el_6, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageComponent3;
}(import1.AppView));
function viewFactory_ContentPageComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentPageComponent4 = (function (_super) {
    __extends(_View_ContentPageComponent4, _super);
    function _View_ContentPageComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentPageComponent4, renderType_ContentPageComponent, import8.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import9.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import9.UNINITIALIZED;
    }
    _View_ContentPageComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import6.createRenderElement(this.renderer, null, 'div', new import6.InlineArray2(2, 'class', 'page-content'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentPageComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.context.content.content[this.parent.context.currentLanguage];
        if (import6.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentPageComponent4;
}(import1.AppView));
function viewFactory_ContentPageComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentPageComponent4(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(165);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(45);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(18);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(32);
var import12 = __webpack_require__(17);
var import13 = __webpack_require__(49);
var import14 = __webpack_require__(30);
var import15 = __webpack_require__(2);
var import16 = __webpack_require__(25);
var import17 = __webpack_require__(9);
var import18 = __webpack_require__(16);
var import19 = __webpack_require__(15);
var import20 = __webpack_require__(11);
var import21 = __webpack_require__(10);
var import22 = __webpack_require__(56);
var import23 = __webpack_require__(22);
var import24 = __webpack_require__(50);
var import25 = __webpack_require__(312);
var import26 = __webpack_require__(176);
var import27 = __webpack_require__(118);
var import28 = __webpack_require__(307);
var import29 = __webpack_require__(308);
var import30 = __webpack_require__(98);
var import31 = __webpack_require__(14);
var import32 = __webpack_require__(39);
var import33 = __webpack_require__(19);
var import34 = __webpack_require__(65);
var import35 = __webpack_require__(44);
var import36 = __webpack_require__(217);
var import37 = __webpack_require__(79);
var import38 = __webpack_require__(43);
var import39 = __webpack_require__(24);
var import40 = __webpack_require__(20);
var import41 = __webpack_require__(21);
var import42 = __webpack_require__(70);
var import43 = __webpack_require__(26);
var import44 = __webpack_require__(48);
var import45 = __webpack_require__(28);
var import46 = __webpack_require__(33);
var import47 = __webpack_require__(31);
var import48 = __webpack_require__(218);
var import49 = __webpack_require__(71);
var Wrapper_ContentRecordComponent = (function () {
    function Wrapper_ContentRecordComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11) {
        this.changed = false;
        this.context = new import0.ContentRecordComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11);
    }
    Wrapper_ContentRecordComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentRecordComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentRecordComponent;
}());
exports.Wrapper_ContentRecordComponent = Wrapper_ContentRecordComponent;
var renderType_ContentRecordComponent_Host = null;
var _View_ContentRecordComponent_Host0 = (function (_super) {
    __extends(_View_ContentRecordComponent_Host0, _super);
    function _View_ContentRecordComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent_Host0, renderType_ContentRecordComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentRecordComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._NotificationService_0_4 = new import4.NotificationService(new import9.ElementRef(this._el_0), this.renderer);
        this._ContentRecordComponent_0_5 = new Wrapper_ContentRecordComponent(this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.Location), this.parentInjector.get(import12.IntlService), this._NotificationService_0_4, this.parentInjector.get(import13.CartService), this.parentInjector.get(import14.SearchService), new import9.ElementRef(this._el_0), this.parentInjector.get(import15.UtilsService), this.parentInjector.get(import16.MetaService), this.parentInjector.get(import17.ContentService), this.parentInjector.get(import18.ActivatedRoute), this.parentInjector.get(import19.Router));
        this._appEl_0.initComponent(this._ContentRecordComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentRecordComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentRecordComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.NotificationService) && (0 === requestNodeIndex))) {
            return this._NotificationService_0_4;
        }
        if (((token === import0.ContentRecordComponent) && (0 === requestNodeIndex))) {
            return this._ContentRecordComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentRecordComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentRecordComponent_0_5.context.ngAfterContentChecked();
        }
        this._ContentRecordComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent_Host0;
}(import1.AppView));
function viewFactory_ContentRecordComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordComponent_Host === null)) {
        (renderType_ContentRecordComponent_Host = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentRecordComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentRecordComponentNgFactory = new import21.ComponentFactory('ng-component', viewFactory_ContentRecordComponent_Host0, import0.ContentRecordComponent);
var styles_ContentRecordComponent = [];
var renderType_ContentRecordComponent = null;
var _View_ContentRecordComponent0 = (function (_super) {
    __extends(_View_ContentRecordComponent0, _super);
    function _View_ContentRecordComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent0, renderType_ContentRecordComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_39 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'id', 'snackbar'), null);
        this._text_5 = this.renderer.createText(this._el_0, '\n', null);
        this._text_6 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_7 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_8 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_9 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'section-record'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n    ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'container'), null);
        this._NgSwitch_11_3 = new import22.Wrapper_NgSwitch();
        this._text_12 = this.renderer.createText(this._el_11, '\n        ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'div', new import5.InlineArray2(2, 'class', 'row btn-back'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n            ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_13, 'button', new import5.InlineArray2(2, 'class', 'highlight-button btn btn-very-small no-margin continue-shopping-custom'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_13, '\n        ', null);
        this._text_18 = this.renderer.createText(this._el_11, '\n\n        ', null);
        this._text_19 = this.renderer.createText(this._el_11, '\n        ', null);
        this._anchor_20 = this.renderer.createTemplateAnchor(this._el_11, null);
        this._appEl_20 = new import3.AppElement(20, 11, this, this._anchor_20);
        this._TemplateRef_20_5 = new import31.TemplateRef_(this._appEl_20, viewFactory_ContentRecordComponent1);
        this._NgSwitchCase_20_6 = new import22.Wrapper_NgSwitchCase(this._appEl_20.vcRef, this._TemplateRef_20_5, this._NgSwitch_11_3.context);
        this._text_21 = this.renderer.createText(this._el_11, '\n        \n        ', null);
        this._text_22 = this.renderer.createText(this._el_11, '\n        ', null);
        this._anchor_23 = this.renderer.createTemplateAnchor(this._el_11, null);
        this._appEl_23 = new import3.AppElement(23, 11, this, this._anchor_23);
        this._TemplateRef_23_5 = new import31.TemplateRef_(this._appEl_23, viewFactory_ContentRecordComponent2);
        this._NgIf_23_6 = new import23.Wrapper_NgIf(this._appEl_23.vcRef, this._TemplateRef_23_5);
        this._text_24 = this.renderer.createText(this._el_11, '\n    ', null);
        this._text_25 = this.renderer.createText(this._el_9, '\n', null);
        this._text_26 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._anchor_27 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_27 = new import3.AppElement(27, null, this, this._anchor_27);
        this._TemplateRef_27_5 = new import31.TemplateRef_(this._appEl_27, viewFactory_ContentRecordComponent14);
        this._NgIf_27_6 = new import23.Wrapper_NgIf(this._appEl_27.vcRef, this._TemplateRef_27_5);
        this._text_28 = this.renderer.createText(parentRenderNode, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_15, 'click', this.eventHandler(this._handle_click_15_0.bind(this)));
        this._pipe_intl_0 = new import24.IntlPipe();
        this._pipe_intl_0_0 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_replace_1 = new import25.ReplacePipe();
        this._pipe_numberFormat_2 = new import26.NumberFormat();
        this._pipe_nameResolver_3 = new import27.NameResolverPipe();
        this._pipe_toYear_4 = new import28.Date2YearPipe();
        this._pipe_join_5 = new import29.JoinPipe();
        this._pipe_truncate_6 = new import30.TruncatePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._text_19,
            this._anchor_20,
            this._text_21,
            this._text_22,
            this._anchor_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._anchor_27,
            this._text_28
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (20 === requestNodeIndex))) {
            return this._TemplateRef_20_5;
        }
        if (((token === import32.NgSwitchCase) && (20 === requestNodeIndex))) {
            return this._NgSwitchCase_20_6.context;
        }
        if (((token === import31.TemplateRef) && (23 === requestNodeIndex))) {
            return this._TemplateRef_23_5;
        }
        if (((token === import33.NgIf) && (23 === requestNodeIndex))) {
            return this._NgIf_23_6.context;
        }
        if (((token === import32.NgSwitch) && ((11 <= requestNodeIndex) && (requestNodeIndex <= 24)))) {
            return this._NgSwitch_11_3.context;
        }
        if (((token === import31.TemplateRef) && (27 === requestNodeIndex))) {
            return this._TemplateRef_27_5;
        }
        if (((token === import33.NgIf) && (27 === requestNodeIndex))) {
            return this._NgIf_27_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_11_0_0 = this.context.loading;
        this._NgSwitch_11_3.check_ngSwitch(currVal_11_0_0, throwOnChange, false);
        this._NgSwitch_11_3.detectChangesInInputProps(this, this._el_11, throwOnChange);
        var currVal_20_0_0 = true;
        this._NgSwitchCase_20_6.check_ngSwitchCase(currVal_20_0_0, throwOnChange, false);
        this._NgSwitchCase_20_6.detectChangesInInputProps(this, this._anchor_20, throwOnChange);
        var currVal_23_0_0 = (this.context.content && this.context.currentLanguage);
        this._NgIf_23_6.check_ngIf(currVal_23_0_0, throwOnChange, false);
        this._NgIf_23_6.detectChangesInInputProps(this, this._anchor_23, throwOnChange);
        var currVal_27_0_0 = (this.context.mltContents.length > 0);
        this._NgIf_27_6.check_ngIf(currVal_27_0_0, throwOnChange, false);
        this._NgIf_27_6.detectChangesInInputProps(this, this._anchor_27, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSwitch_11_3.detectChangesInHostProps(this, this._el_11, throwOnChange);
        valUnwrapper.reset();
        var currVal_39 = import5.interpolate(1, '\n            ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_0, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.BACK), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_39, currVal_39))) {
            this.renderer.setText(this._text_16, currVal_39);
            this._expr_39 = currVal_39;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent0.prototype._handle_click_15_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_15_0 = (this.context.location.back() !== false);
        return (true && pd_15_0);
    };
    return _View_ContentRecordComponent0;
}(import1.AppView));
function viewFactory_ContentRecordComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordComponent === null)) {
        (renderType_ContentRecordComponent = viewUtils.createRenderComponentType('', 0, import20.ViewEncapsulation.None, styles_ContentRecordComponent, {}));
    }
    return new _View_ContentRecordComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentRecordComponent0 = viewFactory_ContentRecordComponent0;
var _View_ContentRecordComponent1 = (function (_super) {
    __extends(_View_ContentRecordComponent1, _super);
    function _View_ContentRecordComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent1, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'loading-indicator', new import5.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import34.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new import34.Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, [], null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_ContentRecordComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import35.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = '#B6B6B6';
        this._LoadingIndicator_0_4.check_color(currVal_0_0_0, throwOnChange, false);
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent1;
}(import1.AppView));
function viewFactory_ContentRecordComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent2 = (function (_super) {
    __extends(_View_ContentRecordComponent2, _super);
    function _View_ContentRecordComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent2, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_133 = import8.UNINITIALIZED;
        this._expr_134 = import8.UNINITIALIZED;
        this._expr_135 = import8.UNINITIALIZED;
        this._expr_136 = import8.UNINITIALIZED;
        this._expr_137 = import8.UNINITIALIZED;
        this._expr_138 = import8.UNINITIALIZED;
        this._expr_140 = import8.UNINITIALIZED;
        this._expr_141 = import8.UNINITIALIZED;
        this._arr_143 = import5.pureProxy10(function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
            return [
                p0,
                p1,
                p2,
                p3,
                p4,
                p5,
                p6,
                p7,
                p8,
                p9
            ];
        });
        this._expr_144 = import8.UNINITIALIZED;
        this._expr_146 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_1 = this.renderer.createText(this._el_0, ' \n            ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_3 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 col-sm-12 record-zoom-gallery product-image sm-margin-bottom-ten'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n                ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_3, 'a', import5.EMPTY_INLINE_ARRAY, null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_5, 'img', new import5.InlineArray4(4, 'alt', '', 'class', 'project-img-gallery'), null);
        this._text_7 = this.renderer.createText(this._el_3, '\n                ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_3, 'div', new import5.InlineArray2(2, 'class', ''), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                    ', null);
        this._el_10 = import5.createRenderElement(this.renderer, this._el_8, 'a', import5.EMPTY_INLINE_ARRAY, null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_10, 'img', new import5.InlineArray4(4, 'alt', '', 'class', 'project-img-gallery'), null);
        this._text_12 = this.renderer.createText(this._el_8, '\n                ', null);
        this._text_13 = this.renderer.createText(this._el_3, ' \n            ', null);
        this._text_14 = this.renderer.createText(this._el_0, '\n            \n            ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_16 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'col-md-5 col-sm-12 col-md-offset-1'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_18 = this.renderer.createText(this._el_16, '\n\n                ', null);
        this._el_19 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'rating margin-five'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n                    ', null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_19, 'span', new import5.InlineArray2(2, 'class', 'record-date rating-text text-uppercase'), null);
        this._text_22 = this.renderer.createText(this._el_21, 'Ref: ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_21, 'span', new import5.InlineArray2(2, 'class', 'black-text'), null);
        this._text_24 = this.renderer.createText(this._el_23, '', null);
        this._text_25 = this.renderer.createText(this._el_19, '\n                    ', null);
        this._el_26 = import5.createRenderElement(this.renderer, this._el_19, 'span', new import5.InlineArray2(2, 'class', 'rating-text text-uppercase pull-right'), null);
        this._text_27 = this.renderer.createText(this._el_26, '', null);
        this._text_28 = this.renderer.createText(this._el_19, '\n                ', null);
        this._text_29 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_30 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_31 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_32 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_33 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_34 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_35 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_36 = this.renderer.createText(this._el_16, '\n                ', null);
        this._el_37 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'separator-line bg-black no-margin-lr margin-five'), null);
        this._text_38 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_39 = this.renderer.createText(this._el_16, '\n                ', null);
        this._el_40 = import5.createRenderElement(this.renderer, this._el_16, 'p', new import5.InlineArray2(2, 'class', 'text-uppercase letter-spacing-2'), null);
        this._text_41 = this.renderer.createText(this._el_40, '', null);
        this._text_42 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_43 = this.renderer.createText(this._el_16, '\n                ', null);
        this._el_44 = import5.createRenderElement(this.renderer, this._el_16, 'span', new import5.InlineArray2(2, 'class', 'price black-text title-small'), null);
        this._text_45 = this.renderer.createText(this._el_44, '', null);
        this._text_46 = this.renderer.createText(this._el_16, '\n\n                ', null);
        this._el_47 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'col-md-3 col-sm-3 no-padding-left margin-five'), null);
        this._text_48 = this.renderer.createText(this._el_47, '\n                    ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_47, 'div', new import5.InlineArray2(2, 'class', 'select-style med-input xs-med-input shop-shorting-details no-border-round'), null);
        this._text_50 = this.renderer.createText(this._el_49, '\n                        ', null);
        this._text_51 = this.renderer.createText(this._el_49, '\n                        ', null);
        this._el_52 = import5.createRenderElement(this.renderer, this._el_49, 'select', import5.EMPTY_INLINE_ARRAY, null);
        this._SelectControlValueAccessor_52_3 = new import36.Wrapper_SelectControlValueAccessor(this.renderer, new import9.ElementRef(this._el_52));
        this._NG_VALUE_ACCESSOR_52_4 = [this._SelectControlValueAccessor_52_3.context];
        this._NgModel_52_5 = new import37.Wrapper_NgModel(null, null, null, this._NG_VALUE_ACCESSOR_52_4);
        this._NgControl_52_6 = this._NgModel_52_5.context;
        this._NgControlStatus_52_7 = new import38.Wrapper_NgControlStatus(this._NgControl_52_6);
        this._text_53 = this.renderer.createText(this._el_52, '\n                            ', null);
        this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52, null);
        this._appEl_54 = new import3.AppElement(54, 52, this, this._anchor_54);
        this._TemplateRef_54_5 = new import31.TemplateRef_(this._appEl_54, viewFactory_ContentRecordComponent3);
        this._NgFor_54_6 = new import39.Wrapper_NgFor(this._appEl_54.vcRef, this._TemplateRef_54_5, this.parent.parentInjector.get(import40.IterableDiffers), this.parent.ref);
        this._text_55 = this.renderer.createText(this._el_52, '\n                        ', null);
        this._text_56 = this.renderer.createText(this._el_49, '\n                        ', null);
        this._text_57 = this.renderer.createText(this._el_49, '\n                    ', null);
        this._text_58 = this.renderer.createText(this._el_47, '\n                ', null);
        this._text_59 = this.renderer.createText(this._el_16, '\n                ', null);
        this._el_60 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'col-md-9 col-sm-9 no-padding margin-five'), null);
        this._text_61 = this.renderer.createText(this._el_60, '\n                    ', null);
        this._text_62 = this.renderer.createText(this._el_60, '\n                    ', null);
        this._anchor_63 = this.renderer.createTemplateAnchor(this._el_60, null);
        this._appEl_63 = new import3.AppElement(63, 60, this, this._anchor_63);
        this._TemplateRef_63_5 = new import31.TemplateRef_(this._appEl_63, viewFactory_ContentRecordComponent4);
        this._NgIf_63_6 = new import23.Wrapper_NgIf(this._appEl_63.vcRef, this._TemplateRef_63_5);
        this._text_64 = this.renderer.createText(this._el_60, '\n                    ', null);
        this._anchor_65 = this.renderer.createTemplateAnchor(this._el_60, null);
        this._appEl_65 = new import3.AppElement(65, 60, this, this._anchor_65);
        this._TemplateRef_65_5 = new import31.TemplateRef_(this._appEl_65, viewFactory_ContentRecordComponent5);
        this._NgIf_65_6 = new import23.Wrapper_NgIf(this._appEl_65.vcRef, this._TemplateRef_65_5);
        this._text_66 = this.renderer.createText(this._el_60, '\n                    ', null);
        this._text_67 = this.renderer.createText(this._el_60, '\n                ', null);
        this._text_68 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_69 = this.renderer.createText(this._el_16, '\n\n            ', null);
        this._el_70 = import5.createRenderElement(this.renderer, this._el_16, 'div', new import5.InlineArray2(2, 'class', 'col-md-12 col-sm-12 no-padding-left margin-five'), null);
        this._text_71 = this.renderer.createText(this._el_70, '\n                ', null);
        this._text_72 = this.renderer.createText(this._el_70, '\n                ', null);
        this._el_73 = import5.createRenderElement(this.renderer, this._el_70, 'div', new import5.InlineArray2(2, 'class', 'tab-style1'), null);
        this._text_74 = this.renderer.createText(this._el_73, '\n                    ', null);
        this._text_75 = this.renderer.createText(this._el_73, '\n                    ', null);
        this._text_76 = this.renderer.createText(this._el_73, '\n                    ', null);
        this._el_77 = import5.createRenderElement(this.renderer, this._el_73, 'div', new import5.InlineArray2(2, 'class', 'tab-content'), null);
        this._text_78 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._text_79 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._el_80 = import5.createRenderElement(this.renderer, this._el_77, 'div', new import5.InlineArray4(4, 'class', 'tab-pane fade in active', 'id', 'tab_details'), null);
        this._text_81 = this.renderer.createText(this._el_80, '\n                            ', null);
        this._el_82 = import5.createRenderElement(this.renderer, this._el_80, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_83 = this.renderer.createText(this._el_82, '\n                                ', null);
        this._el_84 = import5.createRenderElement(this.renderer, this._el_82, 'div', new import5.InlineArray2(2, 'class', 'col-md-12 col-sm-12 review-main'), null);
        this._text_85 = this.renderer.createText(this._el_84, '\n                                    ', null);
        this._anchor_86 = this.renderer.createTemplateAnchor(this._el_84, null);
        this._appEl_86 = new import3.AppElement(86, 84, this, this._anchor_86);
        this._TemplateRef_86_5 = new import31.TemplateRef_(this._appEl_86, viewFactory_ContentRecordComponent6);
        this._NgFor_86_6 = new import39.Wrapper_NgFor(this._appEl_86.vcRef, this._TemplateRef_86_5, this.parent.parentInjector.get(import40.IterableDiffers), this.parent.ref);
        this._text_87 = this.renderer.createText(this._el_84, '\n                                ', null);
        this._text_88 = this.renderer.createText(this._el_82, '\n                            ', null);
        this._text_89 = this.renderer.createText(this._el_80, '\n                        ', null);
        this._text_90 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._text_91 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._text_92 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._text_93 = this.renderer.createText(this._el_77, '\n                        ', null);
        this._text_94 = this.renderer.createText(this._el_77, '\n                    ', null);
        this._text_95 = this.renderer.createText(this._el_73, '\n                    ', null);
        this._text_96 = this.renderer.createText(this._el_73, '\n                ', null);
        this._text_97 = this.renderer.createText(this._el_70, '\n                ', null);
        this._text_98 = this.renderer.createText(this._el_70, '\n            ', null);
        this._text_99 = this.renderer.createText(this._el_16, '  \n            \n            ', null);
        this._anchor_100 = this.renderer.createTemplateAnchor(this._el_16, null);
        this._appEl_100 = new import3.AppElement(100, 16, this, this._anchor_100);
        this._TemplateRef_100_5 = new import31.TemplateRef_(this._appEl_100, viewFactory_ContentRecordComponent12);
        this._NgIf_100_6 = new import23.Wrapper_NgIf(this._appEl_100.vcRef, this._TemplateRef_100_5);
        this._text_101 = this.renderer.createText(this._el_16, '\n  \n            ', null);
        this._anchor_102 = this.renderer.createTemplateAnchor(this._el_16, null);
        this._appEl_102 = new import3.AppElement(102, 16, this, this._anchor_102);
        this._TemplateRef_102_5 = new import31.TemplateRef_(this._appEl_102, viewFactory_ContentRecordComponent13);
        this._NgIf_102_6 = new import23.Wrapper_NgIf(this._appEl_102.vcRef, this._TemplateRef_102_5);
        this._text_103 = this.renderer.createText(this._el_16, '\n            ', null);
        this._el_104 = import5.createRenderElement(this.renderer, this._el_16, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._el_105 = import5.createRenderElement(this.renderer, this._el_104, 'b', import5.EMPTY_INLINE_ARRAY, null);
        this._text_106 = this.renderer.createText(this._el_105, '', null);
        this._text_107 = this.renderer.createText(this._el_104, '', null);
        this._text_108 = this.renderer.createText(this._el_16, '\n            \n            ', null);
        this._text_109 = this.renderer.createText(this._el_0, '\n\n\n\n        ', null);
        this._pipe_replace_1_0 = import5.pureProxy3(this.parent._pipe_replace_1.transform.bind(this.parent._pipe_replace_1));
        this._pipe_numberFormat_2_0 = import5.pureProxy2(this.parent._pipe_numberFormat_2.transform.bind(this.parent._pipe_numberFormat_2));
        var disposable_0 = this.renderer.listen(this._el_52, 'ngModelChange', this.eventHandler(this._handle_ngModelChange_52_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_52, 'change', this.eventHandler(this._handle_change_52_1.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_52, 'blur', this.eventHandler(this._handle_blur_52_2.bind(this)));
        var subscription_0 = this._NgModel_52_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_52_0.bind(this)));
        this._pipe_intl_0_5 = import5.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._el_37,
            this._text_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._text_51,
            this._el_52,
            this._text_53,
            this._anchor_54,
            this._text_55,
            this._text_56,
            this._text_57,
            this._text_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._text_62,
            this._anchor_63,
            this._text_64,
            this._anchor_65,
            this._text_66,
            this._text_67,
            this._text_68,
            this._text_69,
            this._el_70,
            this._text_71,
            this._text_72,
            this._el_73,
            this._text_74,
            this._text_75,
            this._text_76,
            this._el_77,
            this._text_78,
            this._text_79,
            this._el_80,
            this._text_81,
            this._el_82,
            this._text_83,
            this._el_84,
            this._text_85,
            this._anchor_86,
            this._text_87,
            this._text_88,
            this._text_89,
            this._text_90,
            this._text_91,
            this._text_92,
            this._text_93,
            this._text_94,
            this._text_95,
            this._text_96,
            this._text_97,
            this._text_98,
            this._text_99,
            this._anchor_100,
            this._text_101,
            this._anchor_102,
            this._text_103,
            this._el_104,
            this._el_105,
            this._text_106,
            this._text_107,
            this._text_108,
            this._text_109
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], [subscription_0]);
        return null;
    };
    _View_ContentRecordComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (54 === requestNodeIndex))) {
            return this._TemplateRef_54_5;
        }
        if (((token === import41.NgFor) && (54 === requestNodeIndex))) {
            return this._NgFor_54_6.context;
        }
        if (((token === import42.SelectControlValueAccessor) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._SelectControlValueAccessor_52_3.context;
        }
        if (((token === import43.NG_VALUE_ACCESSOR) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._NG_VALUE_ACCESSOR_52_4;
        }
        if (((token === import44.NgModel) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._NgModel_52_5.context;
        }
        if (((token === import45.NgControl) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._NgControl_52_6;
        }
        if (((token === import46.NgControlStatus) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) {
            return this._NgControlStatus_52_7.context;
        }
        if (((token === import31.TemplateRef) && (63 === requestNodeIndex))) {
            return this._TemplateRef_63_5;
        }
        if (((token === import33.NgIf) && (63 === requestNodeIndex))) {
            return this._NgIf_63_6.context;
        }
        if (((token === import31.TemplateRef) && (65 === requestNodeIndex))) {
            return this._TemplateRef_65_5;
        }
        if (((token === import33.NgIf) && (65 === requestNodeIndex))) {
            return this._NgIf_65_6.context;
        }
        if (((token === import31.TemplateRef) && (86 === requestNodeIndex))) {
            return this._TemplateRef_86_5;
        }
        if (((token === import41.NgFor) && (86 === requestNodeIndex))) {
            return this._NgFor_86_6.context;
        }
        if (((token === import31.TemplateRef) && (100 === requestNodeIndex))) {
            return this._TemplateRef_100_5;
        }
        if (((token === import33.NgIf) && (100 === requestNodeIndex))) {
            return this._NgIf_100_6.context;
        }
        if (((token === import31.TemplateRef) && (102 === requestNodeIndex))) {
            return this._TemplateRef_102_5;
        }
        if (((token === import33.NgIf) && (102 === requestNodeIndex))) {
            return this._NgIf_102_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this._SelectControlValueAccessor_52_3.detectChangesInInputProps(this, this._el_52, throwOnChange);
        var currVal_52_1_0 = this.parent.context.qty;
        this._NgModel_52_5.check_model(currVal_52_1_0, throwOnChange, false);
        this._NgModel_52_5.detectChangesInInputProps(this, this._el_52, throwOnChange);
        this._NgControlStatus_52_7.detectChangesInInputProps(this, this._el_52, throwOnChange);
        var currVal_54_0_0 = this._arr_143(1, 2, 3, 4, 5, 6, 7, 8, 9, 10);
        this._NgFor_54_6.check_ngForOf(currVal_54_0_0, throwOnChange, false);
        this._NgFor_54_6.detectChangesInInputProps(this, this._anchor_54, throwOnChange);
        var currVal_63_0_0 = !this.parent.context.cartService.isInCart(this.parent.context.content._id);
        this._NgIf_63_6.check_ngIf(currVal_63_0_0, throwOnChange, false);
        this._NgIf_63_6.detectChangesInInputProps(this, this._anchor_63, throwOnChange);
        var currVal_65_0_0 = this.parent.context.cartService.isInCart(this.parent.context.content._id);
        this._NgIf_65_6.check_ngIf(currVal_65_0_0, throwOnChange, false);
        this._NgIf_65_6.detectChangesInInputProps(this, this._anchor_65, throwOnChange);
        var currVal_86_0_0 = this.parent.context.content.music_pieces;
        this._NgFor_86_6.check_ngForOf(currVal_86_0_0, throwOnChange, false);
        this._NgFor_86_6.detectChangesInInputProps(this, this._anchor_86, throwOnChange);
        var currVal_100_0_0 = this.parent.context.content.description[this.parent.context.currentLanguage];
        this._NgIf_100_6.check_ngIf(currVal_100_0_0, throwOnChange, false);
        this._NgIf_100_6.detectChangesInInputProps(this, this._anchor_100, throwOnChange);
        var currVal_102_0_0 = ((this.parent.context.content.original_references && (this.parent.context.content.original_references.length > 0)) && (this.parent.context.content.original_references[0] != ''));
        this._NgIf_102_6.check_ngIf(currVal_102_0_0, throwOnChange, false);
        this._NgIf_102_6.detectChangesInInputProps(this, this._anchor_102, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_133 = import5.interpolate(1, '/data/covers/', this.parent.context.content.cover.front, '');
        if (import5.checkBinding(throwOnChange, this._expr_133, currVal_133)) {
            this.renderer.setElementProperty(this._el_5, 'href', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL, currVal_133));
            this._expr_133 = currVal_133;
        }
        var currVal_134 = import5.interpolate(1, '/data/covers/', this.parent.context.content.cover.front, '');
        if (import5.checkBinding(throwOnChange, this._expr_134, currVal_134)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL, currVal_134));
            this._expr_134 = currVal_134;
        }
        var currVal_135 = import5.interpolate(1, '/data/covers/', this.parent.context.content.cover.back, '');
        if (import5.checkBinding(throwOnChange, this._expr_135, currVal_135)) {
            this.renderer.setElementProperty(this._el_10, 'href', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL, currVal_135));
            this._expr_135 = currVal_135;
        }
        var currVal_136 = import5.interpolate(1, '/data/covers/', this.parent.context.content.cover.back, '');
        if (import5.checkBinding(throwOnChange, this._expr_136, currVal_136)) {
            this.renderer.setElementProperty(this._el_11, 'src', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL, currVal_136));
            this._expr_136 = currVal_136;
        }
        var currVal_137 = import5.interpolate(1, '', this.parent.context.content.reference, '');
        if (import5.checkBinding(throwOnChange, this._expr_137, currVal_137)) {
            this.renderer.setText(this._text_24, currVal_137);
            this._expr_137 = currVal_137;
        }
        valUnwrapper.reset();
        var currVal_138 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_replace_1_0, this.parent._pipe_replace_1.transform)(this.parent.context.content.date, 'T.+', '')), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_138, currVal_138))) {
            this.renderer.setText(this._text_27, currVal_138);
            this._expr_138 = currVal_138;
        }
        var currVal_140 = import5.interpolate(1, '', this.parent.context.content.title, '');
        if (import5.checkBinding(throwOnChange, this._expr_140, currVal_140)) {
            this.renderer.setText(this._text_41, currVal_140);
            this._expr_140 = currVal_140;
        }
        valUnwrapper.reset();
        var currVal_141 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_numberFormat_2_0, this.parent._pipe_numberFormat_2.transform)(this.parent.context.content.price, 2)), '€');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_141, currVal_141))) {
            this.renderer.setText(this._text_45, currVal_141);
            this._expr_141 = currVal_141;
        }
        this._SelectControlValueAccessor_52_3.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._NgModel_52_5.detectChangesInHostProps(this, this._el_52, throwOnChange);
        this._NgControlStatus_52_7.detectChangesInHostProps(this, this._el_52, throwOnChange);
        valUnwrapper.reset();
        var currVal_144 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_5, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.RECORD.LENGTH), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_144, currVal_144))) {
            this.renderer.setText(this._text_106, currVal_144);
            this._expr_144 = currVal_144;
        }
        var currVal_146 = import5.interpolate(1, ': ', this.parent.context.content.length, '');
        if (import5.checkBinding(throwOnChange, this._expr_146, currVal_146)) {
            this.renderer.setText(this._text_107, currVal_146);
            this._expr_146 = currVal_146;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent2.prototype.destroyInternal = function () {
        this._NgModel_52_5.context.ngOnDestroy();
    };
    _View_ContentRecordComponent2.prototype._handle_ngModelChange_52_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_52_0 = ((this.parent.context.qty = $event) !== false);
        return (true && pd_52_0);
    };
    _View_ContentRecordComponent2.prototype._handle_change_52_1 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_52_0 = (this._SelectControlValueAccessor_52_3.context.onChange($event.target.value) !== false);
        return (true && pd_52_0);
    };
    _View_ContentRecordComponent2.prototype._handle_blur_52_2 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_52_0 = (this._SelectControlValueAccessor_52_3.context.onTouched() !== false);
        return (true && pd_52_0);
    };
    return _View_ContentRecordComponent2;
}(import1.AppView));
function viewFactory_ContentRecordComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent3 = (function (_super) {
    __extends(_View_ContentRecordComponent3, _super);
    function _View_ContentRecordComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent3, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'option', import5.EMPTY_INLINE_ARRAY, null);
        this._NgSelectOption_0_3 = new import36.Wrapper_NgSelectOption(new import9.ElementRef(this._el_0), this.renderer, this.parent._SelectControlValueAccessor_52_3.context);
        this._NgSelectMultipleOption_0_4 = new import48.Wrapper_NgSelectMultipleOption(new import9.ElementRef(this._el_0), this.renderer, null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import42.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgSelectOption_0_3.context;
        }
        if (((token === import49.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._NgSelectMultipleOption_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.$implicit;
        this._NgSelectOption_0_3.check_value(currVal_0_0_0, throwOnChange, false);
        this._NgSelectOption_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_0_1_0 = this.context.$implicit;
        this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0, throwOnChange, false);
        this._NgSelectMultipleOption_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgSelectOption_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgSelectMultipleOption_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_4 = import5.interpolate(1, '', this.context.$implicit, '');
        if (import5.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            this.renderer.setText(this._text_1, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent3.prototype.destroyInternal = function () {
        this._NgSelectOption_0_3.context.ngOnDestroy();
        this._NgSelectMultipleOption_0_4.context.ngOnDestroy();
    };
    return _View_ContentRecordComponent3;
}(import1.AppView));
function viewFactory_ContentRecordComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent4 = (function (_super) {
    __extends(_View_ContentRecordComponent4, _super);
    function _View_ContentRecordComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent4, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_3 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'highlight-button-dark btn btn-medium button pointer'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'i', new import5.InlineArray2(2, 'class', 'icon-basket'), null);
        this._text_2 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this._pipe_intl_0_1 = import5.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1,
            this._text_2
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_3 = import5.interpolate(1, ' \n                        ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_1, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.ADD), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_3, currVal_3))) {
            this.renderer.setText(this._text_2, currVal_3);
            this._expr_3 = currVal_3;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent4.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.addToCart(this.parent.parent.context.content, this.parent.parent.context.qty) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordComponent4;
}(import1.AppView));
function viewFactory_ContentRecordComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent5 = (function (_super) {
    __extends(_View_ContentRecordComponent5, _super);
    function _View_ContentRecordComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent5, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_3 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'a', new import5.InlineArray2(2, 'class', 'btn btn-medium button pointer'), null);
        this._el_1 = import5.createRenderElement(this.renderer, this._el_0, 'i', new import5.InlineArray2(2, 'class', 'fa fa-remove'), null);
        this._text_2 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this._pipe_intl_0_2 = import5.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1,
            this._text_2
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_3 = import5.interpolate(1, ' \n                        ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_2, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CART.REMOVE), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_3, currVal_3))) {
            this.renderer.setText(this._text_2, currVal_3);
            this._expr_3 = currVal_3;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent5.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent.context.removeFromCart(this.parent.parent.context.content._id) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordComponent5;
}(import1.AppView));
function viewFactory_ContentRecordComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent6 = (function (_super) {
    __extends(_View_ContentRecordComponent6, _super);
    function _View_ContentRecordComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent6, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_22 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'review'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'p', new import5.InlineArray2(2, 'class', 'letter-spacing-2 text-uppercase review-name'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                                            ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'strong', import5.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, '', null);
        this._text_6 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_7 = new import3.AppElement(7, 0, this, this._anchor_7);
        this._TemplateRef_7_5 = new import31.TemplateRef_(this._appEl_7, viewFactory_ContentRecordComponent7);
        this._NgFor_7_6 = new import39.Wrapper_NgFor(this._appEl_7.vcRef, this._TemplateRef_7_5, this.parent.parent.parentInjector.get(import40.IterableDiffers), this.parent.parent.ref);
        this._text_8 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._anchor_9 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_9 = new import3.AppElement(9, 0, this, this._anchor_9);
        this._TemplateRef_9_5 = new import31.TemplateRef_(this._appEl_9, viewFactory_ContentRecordComponent10);
        this._NgIf_9_6 = new import23.Wrapper_NgIf(this._appEl_9.vcRef, this._TemplateRef_9_5);
        this._text_10 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_11 = new import3.AppElement(11, 0, this, this._anchor_11);
        this._TemplateRef_11_5 = new import31.TemplateRef_(this._appEl_11, viewFactory_ContentRecordComponent11);
        this._NgIf_11_6 = new import23.Wrapper_NgIf(this._appEl_11.vcRef, this._TemplateRef_11_5);
        this._text_12 = this.renderer.createText(this._el_0, '\n                                    ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._anchor_9,
            this._text_10,
            this._anchor_11,
            this._text_12
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import41.NgFor) && (7 === requestNodeIndex))) {
            return this._NgFor_7_6.context;
        }
        if (((token === import31.TemplateRef) && (9 === requestNodeIndex))) {
            return this._TemplateRef_9_5;
        }
        if (((token === import33.NgIf) && (9 === requestNodeIndex))) {
            return this._NgIf_9_6.context;
        }
        if (((token === import31.TemplateRef) && (11 === requestNodeIndex))) {
            return this._TemplateRef_11_5;
        }
        if (((token === import33.NgIf) && (11 === requestNodeIndex))) {
            return this._NgIf_11_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_7_0_0 = this.context.$implicit.soloists;
        this._NgFor_7_6.check_ngForOf(currVal_7_0_0, throwOnChange, false);
        this._NgFor_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        var currVal_9_0_0 = (this.context.$implicit.conductor && this.context.$implicit.orchestra);
        this._NgIf_9_6.check_ngIf(currVal_9_0_0, throwOnChange, false);
        this._NgIf_9_6.detectChangesInInputProps(this, this._anchor_9, throwOnChange);
        var currVal_11_0_0 = this.context.$implicit.date;
        this._NgIf_11_6.check_ngIf(currVal_11_0_0, throwOnChange, false);
        this._NgIf_11_6.detectChangesInInputProps(this, this._anchor_11, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_22 = import5.interpolate(2, '', this.context.$implicit.composer, ', ', this.context.$implicit.title, '');
        if (import5.checkBinding(throwOnChange, this._expr_22, currVal_22)) {
            this.renderer.setText(this._text_5, currVal_22);
            this._expr_22 = currVal_22;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent6;
}(import1.AppView));
function viewFactory_ContentRecordComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent7 = (function (_super) {
    __extends(_View_ContentRecordComponent7, _super);
    function _View_ContentRecordComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent7, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_15 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'reclink pointer'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, ' ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._anchor_5);
        this._TemplateRef_5_5 = new import31.TemplateRef_(this._appEl_5, viewFactory_ContentRecordComponent8);
        this._NgIf_5_6 = new import23.Wrapper_NgIf(this._appEl_5.vcRef, this._TemplateRef_5_5);
        this._text_6 = this.renderer.createText(this._el_0, '\n                                            ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_7 = new import3.AppElement(7, 0, this, this._anchor_7);
        this._TemplateRef_7_5 = new import31.TemplateRef_(this._appEl_7, viewFactory_ContentRecordComponent9);
        this._NgIf_7_6 = new import23.Wrapper_NgIf(this._appEl_7.vcRef, this._TemplateRef_7_5);
        this._text_8 = this.renderer.createText(this._el_0, '\n                                        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this._pipe_nameResolver_3_0 = import5.pureProxy1(this.parent.parent.parent._pipe_nameResolver_3.transform.bind(this.parent.parent.parent._pipe_nameResolver_3));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._anchor_7,
            this._text_8
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import33.NgIf) && (5 === requestNodeIndex))) {
            return this._NgIf_5_6.context;
        }
        if (((token === import31.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import33.NgIf) && (7 === requestNodeIndex))) {
            return this._NgIf_7_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_5_0_0 = this.context.$implicit.instrument;
        this._NgIf_5_6.check_ngIf(currVal_5_0_0, throwOnChange, false);
        this._NgIf_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_7_0_0 = (this.context.index < (this.parent.context.$implicit.soloists.length - 1));
        this._NgIf_7_6.check_ngIf(currVal_7_0_0, throwOnChange, false);
        this._NgIf_7_6.detectChangesInInputProps(this, this._anchor_7, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_15 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_nameResolver_3_0, this.parent.parent.parent._pipe_nameResolver_3.transform)(this.context.$implicit.name)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_15, currVal_15))) {
            this.renderer.setText(this._text_3, currVal_15);
            this._expr_15 = currVal_15;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent7.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.context.utils.lLink(('catalogue?f=soloist~' + this.context.$implicit.name), this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_2_0);
    };
    return _View_ContentRecordComponent7;
}(import1.AppView));
function viewFactory_ContentRecordComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent8 = (function (_super) {
    __extends(_View_ContentRecordComponent8, _super);
    function _View_ContentRecordComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent8, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = import5.interpolate(1, '(', this.parent.context.$implicit.instrument, ')');
        if (import5.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent8;
}(import1.AppView));
function viewFactory_ContentRecordComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent9 = (function (_super) {
    __extends(_View_ContentRecordComponent9, _super);
    function _View_ContentRecordComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent9, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'span', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ', ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentRecordComponent9;
}(import1.AppView));
function viewFactory_ContentRecordComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent9(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent10 = (function (_super) {
    __extends(_View_ContentRecordComponent10, _super);
    function _View_ContentRecordComponent10(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent10, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import8.UNINITIALIZED;
        this._expr_7 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent10.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', import5.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                            ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'a', new import5.InlineArray2(2, 'class', 'reclink pointer'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this._pipe_nameResolver_3_1 = import5.pureProxy1(this.parent.parent.parent._pipe_nameResolver_3.transform.bind(this.parent.parent.parent._pipe_nameResolver_3));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent10.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_5 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_nameResolver_3_1, this.parent.parent.parent._pipe_nameResolver_3.transform)(this.parent.context.$implicit.conductor)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_5, currVal_5))) {
            this.renderer.setText(this._text_3, currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_7 = import5.interpolate(1, ' / ', this.parent.context.$implicit.orchestra, '\n                                        ');
        if (import5.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setText(this._text_4, currVal_7);
            this._expr_7 = currVal_7;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent10.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.context.utils.lLink(('catalogue?f=conductor~' + this.parent.context.$implicit.conductor), this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_2_0);
    };
    return _View_ContentRecordComponent10;
}(import1.AppView));
function viewFactory_ContentRecordComponent10(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent10(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent11 = (function (_super) {
    __extends(_View_ContentRecordComponent11, _super);
    function _View_ContentRecordComponent11(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent11, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_4 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent11.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'black-text letter-spacing-2'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._pipe_intl_0_3 = import5.pureProxy2(this.parent.parent.parent._pipe_intl_0.transform.bind(this.parent.parent.parent._pipe_intl_0));
        this._pipe_toYear_4_0 = import5.pureProxy1(this.parent.parent.parent._pipe_toYear_4.transform.bind(this.parent.parent.parent._pipe_toYear_4));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent11.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_4 = import5.interpolate(2, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_3, this.parent.parent.parent._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.context.intl.data.RECORD.RECORDING), this.parent.parent.parent.context.currentLanguage)), ': ', valUnwrapper.unwrap(import5.castByValue(this._pipe_toYear_4_0, this.parent.parent.parent._pipe_toYear_4.transform)(this.parent.context.$implicit.date)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_4, currVal_4))) {
            this.renderer.setText(this._text_3, currVal_4);
            this._expr_4 = currVal_4;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent11;
}(import1.AppView));
function viewFactory_ContentRecordComponent11(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent11(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent12 = (function (_super) {
    __extends(_View_ContentRecordComponent12, _super);
    function _View_ContentRecordComponent12(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent12, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_8 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent12.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'record-description col-md-12'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                        ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n                        ', null);
        this._el_5 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'col-md-12 sm-margin-top-seven'), null);
        this._text_6 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent12.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_8 = this.parent.parent.context.utils.formatInHtml(this.parent.parent.context.content.description[this.parent.parent.context.currentLanguage], 'p');
        if (import5.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setElementProperty(this._el_5, 'innerHTML', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.HTML, currVal_8));
            this._expr_8 = currVal_8;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent12;
}(import1.AppView));
function viewFactory_ContentRecordComponent12(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent12(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent13 = (function (_super) {
    __extends(_View_ContentRecordComponent13, _super);
    function _View_ContentRecordComponent13(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent13, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_7 = import8.UNINITIALIZED;
        this._expr_9 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent13.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'record-original-references'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'small', import5.EMPTY_INLINE_ARRAY, null);
        this._el_3 = import5.createRenderElement(this.renderer, this._el_2, 'b', import5.EMPTY_INLINE_ARRAY, null);
        this._text_4 = this.renderer.createText(this._el_3, '', null);
        this._text_5 = this.renderer.createText(this._el_2, '', null);
        this._text_6 = this.renderer.createText(this._el_0, '\n            ', null);
        this._pipe_intl_0_4 = import5.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this._pipe_join_5_0 = import5.pureProxy2(this.parent.parent._pipe_join_5.transform.bind(this.parent.parent._pipe_join_5));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._el_3,
            this._text_4,
            this._text_5,
            this._text_6
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent13.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_7 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_4, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.RECORD.ORIGINAL_REFERENCES), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_7, currVal_7))) {
            this.renderer.setText(this._text_4, currVal_7);
            this._expr_7 = currVal_7;
        }
        valUnwrapper.reset();
        var currVal_9 = import5.interpolate(1, ': ', valUnwrapper.unwrap(import5.castByValue(this._pipe_join_5_0, this.parent.parent._pipe_join_5.transform)(this.parent.parent.context.content.original_references, ', ')), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_9, currVal_9))) {
            this.renderer.setText(this._text_5, currVal_9);
            this._expr_9 = currVal_9;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent13;
}(import1.AppView));
function viewFactory_ContentRecordComponent13(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent13(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent14 = (function (_super) {
    __extends(_View_ContentRecordComponent14, _super);
    function _View_ContentRecordComponent14(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent14, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_23 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent14.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'section', new import5.InlineArray2(2, 'class', 'border-top section-pull-up-less'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'container'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n            ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'div', new import5.InlineArray2(2, 'class', 'col-md-12 text-center'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_6, 'h3', new import5.InlineArray2(2, 'class', 'section-title'), null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_6, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_4, '\n        ', null);
        this._text_12 = this.renderer.createText(this._el_2, ' \n        ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'row record-listing-featured record-listing'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n          ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_13, null);
        this._appEl_15 = new import3.AppElement(15, 13, this, this._anchor_15);
        this._TemplateRef_15_5 = new import31.TemplateRef_(this._appEl_15, viewFactory_ContentRecordComponent15);
        this._NgFor_15_6 = new import39.Wrapper_NgFor(this._appEl_15.vcRef, this._TemplateRef_15_5, this.parentInjector.get(import40.IterableDiffers), this.parent.ref);
        this._text_16 = this.renderer.createText(this._el_13, '\n        ', null);
        this._text_17 = this.renderer.createText(this._el_2, '\n        ', null);
        this._text_18 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_19 = this.renderer.createText(this._el_0, '\n', null);
        this._pipe_intl_0_6 = import5.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._text_19
        ], [], []);
        return null;
    };
    _View_ContentRecordComponent14.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import41.NgFor) && (15 === requestNodeIndex))) {
            return this._NgFor_15_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordComponent14.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_15_0_0 = this.parent.context.mltContents;
        this._NgFor_15_6.check_ngForOf(currVal_15_0_0, throwOnChange, false);
        this._NgFor_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_23 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_6, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.RECORD.RECOMMENDATION), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_23, currVal_23))) {
            this.renderer.setText(this._text_9, currVal_23);
            this._expr_23 = currVal_23;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordComponent14;
}(import1.AppView));
function viewFactory_ContentRecordComponent14(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent14(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordComponent15 = (function (_super) {
    __extends(_View_ContentRecordComponent15, _super);
    function _View_ContentRecordComponent15(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordComponent15, renderType_ContentRecordComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_17 = import8.UNINITIALIZED;
        this._expr_18 = import8.UNINITIALIZED;
    }
    _View_ContentRecordComponent15.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-3 col-xs-6 record-item'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', ''), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                  ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'img', new import5.InlineArray2(2, 'alt', ''), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_8 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'record-desc'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                  ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'div', new import5.InlineArray2(2, 'class', 'catalogue-record-title gray-text text-uppercase letter-spacing-2'), null);
        this._text_14 = this.renderer.createText(this._el_13, '', null);
        this._text_15 = this.renderer.createText(this._el_11, '\n                ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this._pipe_truncate_6_0 = import5.pureProxy2(this.parent.parent._pipe_truncate_6.transform.bind(this.parent.parent._pipe_truncate_6));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15,
            this._text_16
        ], [disposable_0], []);
        return null;
    };
    _View_ContentRecordComponent15.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_17 = import5.interpolate(1, '/data/covers/', this.context.$implicit.cover.front, '');
        if (import5.checkBinding(throwOnChange, this._expr_17, currVal_17)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL, currVal_17));
            this._expr_17 = currVal_17;
        }
        valUnwrapper.reset();
        var currVal_18 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_6_0, this.parent.parent._pipe_truncate_6.transform)(this.context.$implicit.title, '75')), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_18, currVal_18))) {
            this.renderer.setText(this._text_14, currVal_18);
            this._expr_18 = currVal_18;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordComponent15.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.parent.context.router.navigate([this.context.$implicit.url], { relativeTo: this.parent.parent.context.route.parent }) !== false);
        return (true && pd_4_0);
    };
    return _View_ContentRecordComponent15;
}(import1.AppView));
function viewFactory_ContentRecordComponent15(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordComponent15(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(167);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(118);
var import5 = __webpack_require__(3);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(4);
var import9 = __webpack_require__(18);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(17);
var import13 = __webpack_require__(25);
var import14 = __webpack_require__(9);
var import15 = __webpack_require__(16);
var import16 = __webpack_require__(32);
var import17 = __webpack_require__(15);
var import18 = __webpack_require__(11);
var import19 = __webpack_require__(10);
var import20 = __webpack_require__(78);
var import21 = __webpack_require__(178);
var import22 = __webpack_require__(56);
var import23 = __webpack_require__(22);
var import24 = __webpack_require__(50);
var import25 = __webpack_require__(258);
var import26 = __webpack_require__(98);
var import27 = __webpack_require__(20);
var import28 = __webpack_require__(40);
var import29 = __webpack_require__(30);
var import30 = __webpack_require__(29);
var import31 = __webpack_require__(14);
var import32 = __webpack_require__(38);
var import33 = __webpack_require__(57);
var import34 = __webpack_require__(39);
var import35 = __webpack_require__(19);
var import36 = __webpack_require__(97);
var import37 = __webpack_require__(65);
var import38 = __webpack_require__(44);
var import39 = __webpack_require__(313);
var import40 = __webpack_require__(177);
var import41 = __webpack_require__(306);
var import42 = __webpack_require__(174);
var import43 = __webpack_require__(451);
var import44 = __webpack_require__(231);
var import45 = __webpack_require__(237);
var import46 = __webpack_require__(119);
var import47 = __webpack_require__(302);
var import48 = __webpack_require__(24);
var import49 = __webpack_require__(21);
var import50 = __webpack_require__(166);
var import51 = __webpack_require__(31);
var import52 = __webpack_require__(415);
var import53 = __webpack_require__(105);
var import54 = __webpack_require__(180);
var import55 = __webpack_require__(303);
var import56 = __webpack_require__(168);
var import57 = __webpack_require__(220);
var import58 = __webpack_require__(95);
var Wrapper_ContentRecordsComponent = (function () {
    function Wrapper_ContentRecordsComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
        this.changed = false;
        this.context = new import0.ContentRecordsComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
    }
    Wrapper_ContentRecordsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentRecordsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentRecordsComponent;
}());
exports.Wrapper_ContentRecordsComponent = Wrapper_ContentRecordsComponent;
var renderType_ContentRecordsComponent_Host = null;
var _View_ContentRecordsComponent_Host0 = (function (_super) {
    __extends(_View_ContentRecordsComponent_Host0, _super);
    function _View_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent_Host0, renderType_ContentRecordsComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import5.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentRecordsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._NameResolverPipe_0_4 = new import4.NameResolverPipe();
        this._ContentRecordsComponent_0_5 = new Wrapper_ContentRecordsComponent(this._NameResolverPipe_0_4, new import9.ElementRef(this._el_0), this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.IntlService), this.parentInjector.get(import13.MetaService), this.parentInjector.get(import14.ContentService), this.parentInjector.get(import15.ActivatedRoute), this.parentInjector.get(import16.Location), this.parentInjector.get(import17.Router));
        this._appEl_0.initComponent(this._ContentRecordsComponent_0_5.context, [], compView_0);
        compView_0.create(this._ContentRecordsComponent_0_5.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentRecordsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.NameResolverPipe) && (0 === requestNodeIndex))) {
            return this._NameResolverPipe_0_4;
        }
        if (((token === import0.ContentRecordsComponent) && (0 === requestNodeIndex))) {
            return this._ContentRecordsComponent_0_5.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentRecordsComponent_0_5.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentRecordsComponent_0_5.context.ngAfterContentChecked();
        }
        this._ContentRecordsComponent_0_5.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent_Host0;
}(import1.AppView));
function viewFactory_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordsComponent_Host === null)) {
        (renderType_ContentRecordsComponent_Host = viewUtils.createRenderComponentType('', 0, import18.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentRecordsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentRecordsComponentNgFactory = new import19.ComponentFactory('ng-component', viewFactory_ContentRecordsComponent_Host0, import0.ContentRecordsComponent);
var styles_ContentRecordsComponent = [];
var renderType_ContentRecordsComponent = null;
var _View_ContentRecordsComponent0 = (function (_super) {
    __extends(_View_ContentRecordsComponent0, _super);
    function _View_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent0, renderType_ContentRecordsComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_79 = import8.UNINITIALIZED;
        this._map_82 = import5.pureProxy1(function (p0) {
            return { 'breadcrumb-active': p0 };
        });
        this._expr_83 = import8.UNINITIALIZED;
        this._map_85 = import5.pureProxy1(function (p0) {
            return { 'breadcrumb-active': p0 };
        });
        this._expr_86 = import8.UNINITIALIZED;
        this._map_88 = import5.pureProxy1(function (p0) {
            return { 'breadcrumb-active': p0 };
        });
        this._expr_89 = import8.UNINITIALIZED;
        this._map_91 = import5.pureProxy1(function (p0) {
            return { 'breadcrumb-active': p0 };
        });
        this._expr_92 = import8.UNINITIALIZED;
    }
    _View_ContentRecordsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_5 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_6 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray2(2, 'class', 'page-title page-title-small bg-gray'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n    ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_6, 'div', new import5.InlineArray2(2, 'class', 'container'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n        ', null);
        this._el_10 = import5.createRenderElement(this.renderer, this._el_8, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_12 = import5.createRenderElement(this.renderer, this._el_10, 'div', new import5.InlineArray2(2, 'class', 'hidden-md hidden-sm hidden-xs col-md-2 col-sm-12'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                ', null);
        this._el_14 = import5.createRenderElement(this.renderer, this._el_12, 'h1', new import5.InlineArray2(2, 'class', 'black-text'), null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_14, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_12, '\n            ', null);
        this._text_18 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_19 = import5.createRenderElement(this.renderer, this._el_10, 'div', new import5.InlineArray2(2, 'class', 'col-md-10 col-sm-12 breadcrumb text-uppercase'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n                ', null);
        this._el_21 = import5.createRenderElement(this.renderer, this._el_19, 'ul', new import5.InlineArray2(2, 'class', 'breadcrumb-sub'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n                    ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_21, 'li', import5.EMPTY_INLINE_ARRAY, null);
        this._el_24 = import5.createRenderElement(this.renderer, this._el_23, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._NgClass_24_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers), this.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_24), this.renderer);
        this._text_25 = this.renderer.createText(this._el_24, '', null);
        this._text_26 = this.renderer.createText(this._el_21, '\n                    ', null);
        this._el_27 = import5.createRenderElement(this.renderer, this._el_21, 'li', import5.EMPTY_INLINE_ARRAY, null);
        this._el_28 = import5.createRenderElement(this.renderer, this._el_27, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._NgClass_28_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers), this.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_28), this.renderer);
        this._text_29 = this.renderer.createText(this._el_28, '', null);
        this._text_30 = this.renderer.createText(this._el_21, '\n                    ', null);
        this._el_31 = import5.createRenderElement(this.renderer, this._el_21, 'li', import5.EMPTY_INLINE_ARRAY, null);
        this._el_32 = import5.createRenderElement(this.renderer, this._el_31, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._NgClass_32_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers), this.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_32), this.renderer);
        this._text_33 = this.renderer.createText(this._el_32, '', null);
        this._text_34 = this.renderer.createText(this._el_21, '\n                    ', null);
        this._el_35 = import5.createRenderElement(this.renderer, this._el_21, 'li', import5.EMPTY_INLINE_ARRAY, null);
        this._el_36 = import5.createRenderElement(this.renderer, this._el_35, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._NgClass_36_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers), this.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_36), this.renderer);
        this._text_37 = this.renderer.createText(this._el_36, '', null);
        this._text_38 = this.renderer.createText(this._el_21, '\n                ', null);
        this._text_39 = this.renderer.createText(this._el_19, '\n            ', null);
        this._text_40 = this.renderer.createText(this._el_10, '\n        ', null);
        this._text_41 = this.renderer.createText(this._el_8, '\n    ', null);
        this._text_42 = this.renderer.createText(this._el_6, '\n', null);
        this._text_43 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_44 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_45 = import5.createRenderElement(this.renderer, parentRenderNode, 'section', new import5.InlineArray8(8, 'class', 'page-pull-top', 'context', 'record', 'id', 'content-start', 'searchable-contents', ''), null);
        this._SearchableContentsComponent_45_3 = new import21.Wrapper_SearchableContentsComponent(this.parentInjector.get(import14.ContentService), this.parentInjector.get(import29.SearchService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import15.ActivatedRoute), this.parentInjector.get(import17.Router), this.parentInjector.get(import30.ElasticSearchService));
        this._text_46 = this.renderer.createText(this._el_45, '\n\n  ', null);
        this._el_47 = import5.createRenderElement(this.renderer, this._el_45, 'div', new import5.InlineArray2(2, 'class', 'container'), null);
        this._NgSwitch_47_3 = new import22.Wrapper_NgSwitch();
        this._text_48 = this.renderer.createText(this._el_47, '\n    ', null);
        this._el_49 = import5.createRenderElement(this.renderer, this._el_47, 'div', new import5.InlineArray2(2, 'class', 'row'), null);
        this._text_50 = this.renderer.createText(this._el_49, '\n\n      ', null);
        this._text_51 = this.renderer.createText(this._el_49, '\n      ', null);
        this._anchor_52 = this.renderer.createTemplateAnchor(this._el_49, null);
        this._appEl_52 = new import3.AppElement(52, 49, this, this._anchor_52);
        this._TemplateRef_52_5 = new import31.TemplateRef_(this._appEl_52, viewFactory_ContentRecordsComponent1);
        this._NgSwitchCase_52_6 = new import22.Wrapper_NgSwitchCase(this._appEl_52.vcRef, this._TemplateRef_52_5, this._NgSwitch_47_3.context);
        this._text_53 = this.renderer.createText(this._el_49, '\n\n      ', null);
        this._text_54 = this.renderer.createText(this._el_49, '\n      ', null);
        this._anchor_55 = this.renderer.createTemplateAnchor(this._el_49, null);
        this._appEl_55 = new import3.AppElement(55, 49, this, this._anchor_55);
        this._TemplateRef_55_5 = new import31.TemplateRef_(this._appEl_55, viewFactory_ContentRecordsComponent2);
        this._NgIf_55_6 = new import23.Wrapper_NgIf(this._appEl_55.vcRef, this._TemplateRef_55_5);
        this._text_56 = this.renderer.createText(this._el_49, '\n      ', null);
        this._text_57 = this.renderer.createText(this._el_49, '\n\n      ', null);
        this._text_58 = this.renderer.createText(this._el_49, '\n      ', null);
        this._anchor_59 = this.renderer.createTemplateAnchor(this._el_49, null);
        this._appEl_59 = new import3.AppElement(59, 49, this, this._anchor_59);
        this._TemplateRef_59_5 = new import31.TemplateRef_(this._appEl_59, viewFactory_ContentRecordsComponent4);
        this._NgSwitchCase_59_6 = new import22.Wrapper_NgSwitchCase(this._appEl_59.vcRef, this._TemplateRef_59_5, this._NgSwitch_47_3.context);
        this._text_60 = this.renderer.createText(this._el_49, '\n    ', null);
        this._text_61 = this.renderer.createText(this._el_47, '\n  ', null);
        this._text_62 = this.renderer.createText(this._el_45, '\n', null);
        this._text_63 = this.renderer.createText(parentRenderNode, '\n', null);
        var disposable_0 = this.renderer.listen(this._el_15, 'click', this.eventHandler(this._handle_click_15_0.bind(this)));
        this._pipe_intl_0 = new import24.IntlPipe();
        this._pipe_intl_0_0 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_1 = this.renderer.listen(this._el_24, 'click', this.eventHandler(this._handle_click_24_0.bind(this)));
        this._pipe_intl_0_1 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_2 = this.renderer.listen(this._el_28, 'click', this.eventHandler(this._handle_click_28_0.bind(this)));
        this._pipe_intl_0_2 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_3 = this.renderer.listen(this._el_32, 'click', this.eventHandler(this._handle_click_32_0.bind(this)));
        this._pipe_intl_0_3 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_4 = this.renderer.listen(this._el_36, 'click', this.eventHandler(this._handle_click_36_0.bind(this)));
        this._pipe_intl_0_4 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_number_1 = new import25.DecimalPipe(this.parentInjector.get(import32.LOCALE_ID));
        this._pipe_truncate_2 = new import26.TruncatePipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._el_24,
            this._text_25,
            this._text_26,
            this._el_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._el_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._el_35,
            this._el_36,
            this._text_37,
            this._text_38,
            this._text_39,
            this._text_40,
            this._text_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._el_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._text_51,
            this._anchor_52,
            this._text_53,
            this._text_54,
            this._anchor_55,
            this._text_56,
            this._text_57,
            this._text_58,
            this._anchor_59,
            this._text_60,
            this._text_61,
            this._text_62,
            this._text_63
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ], []);
        return null;
    };
    _View_ContentRecordsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import33.NgClass) && ((24 <= requestNodeIndex) && (requestNodeIndex <= 25)))) {
            return this._NgClass_24_3.context;
        }
        if (((token === import33.NgClass) && ((28 <= requestNodeIndex) && (requestNodeIndex <= 29)))) {
            return this._NgClass_28_3.context;
        }
        if (((token === import33.NgClass) && ((32 <= requestNodeIndex) && (requestNodeIndex <= 33)))) {
            return this._NgClass_32_3.context;
        }
        if (((token === import33.NgClass) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 37)))) {
            return this._NgClass_36_3.context;
        }
        if (((token === import31.TemplateRef) && (52 === requestNodeIndex))) {
            return this._TemplateRef_52_5;
        }
        if (((token === import34.NgSwitchCase) && (52 === requestNodeIndex))) {
            return this._NgSwitchCase_52_6.context;
        }
        if (((token === import31.TemplateRef) && (55 === requestNodeIndex))) {
            return this._TemplateRef_55_5;
        }
        if (((token === import35.NgIf) && (55 === requestNodeIndex))) {
            return this._NgIf_55_6.context;
        }
        if (((token === import31.TemplateRef) && (59 === requestNodeIndex))) {
            return this._TemplateRef_59_5;
        }
        if (((token === import34.NgSwitchCase) && (59 === requestNodeIndex))) {
            return this._NgSwitchCase_59_6.context;
        }
        if (((token === import34.NgSwitch) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 61)))) {
            return this._NgSwitch_47_3.context;
        }
        if (((token === import36.SearchableContentsComponent) && ((45 <= requestNodeIndex) && (requestNodeIndex <= 62)))) {
            return this._SearchableContentsComponent_45_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_24_0_0 = 'pointer';
        this._NgClass_24_3.check_klass(currVal_24_0_0, throwOnChange, false);
        var currVal_24_0_1 = this._map_82((!this.context.entryType && !this.context.hasFilter));
        this._NgClass_24_3.check_ngClass(currVal_24_0_1, throwOnChange, false);
        this._NgClass_24_3.detectChangesInInputProps(this, this._el_24, throwOnChange);
        var currVal_28_0_0 = 'pointer';
        this._NgClass_28_3.check_klass(currVal_28_0_0, throwOnChange, false);
        var currVal_28_0_1 = this._map_85((this.context.entryType == 'reissue'));
        this._NgClass_28_3.check_ngClass(currVal_28_0_1, throwOnChange, false);
        this._NgClass_28_3.detectChangesInInputProps(this, this._el_28, throwOnChange);
        var currVal_32_0_0 = 'pointer';
        this._NgClass_32_3.check_klass(currVal_32_0_0, throwOnChange, false);
        var currVal_32_0_1 = this._map_88((this.context.entryType == 'production'));
        this._NgClass_32_3.check_ngClass(currVal_32_0_1, throwOnChange, false);
        this._NgClass_32_3.detectChangesInInputProps(this, this._el_32, throwOnChange);
        var currVal_36_0_0 = 'pointer';
        this._NgClass_36_3.check_klass(currVal_36_0_0, throwOnChange, false);
        var currVal_36_0_1 = this._map_91((this.context.entryType == 'special'));
        this._NgClass_36_3.check_ngClass(currVal_36_0_1, throwOnChange, false);
        this._NgClass_36_3.detectChangesInInputProps(this, this._el_36, throwOnChange);
        var currVal_45_0_0 = 'record';
        this._SearchableContentsComponent_45_3.check_context(currVal_45_0_0, throwOnChange, false);
        var currVal_45_0_1 = this.context.pageSize;
        this._SearchableContentsComponent_45_3.check_pageSize(currVal_45_0_1, throwOnChange, false);
        var currVal_45_0_2 = true;
        this._SearchableContentsComponent_45_3.check_active(currVal_45_0_2, throwOnChange, false);
        this._SearchableContentsComponent_45_3.detectChangesInInputProps(this, this._el_45, throwOnChange);
        var currVal_47_0_0 = this._SearchableContentsComponent_45_3.context.loading;
        this._NgSwitch_47_3.check_ngSwitch(currVal_47_0_0, throwOnChange, false);
        this._NgSwitch_47_3.detectChangesInInputProps(this, this._el_47, throwOnChange);
        var currVal_52_0_0 = true;
        this._NgSwitchCase_52_6.check_ngSwitchCase(currVal_52_0_0, throwOnChange, false);
        this._NgSwitchCase_52_6.detectChangesInInputProps(this, this._anchor_52, throwOnChange);
        var currVal_55_0_0 = this.context.hasFilter;
        this._NgIf_55_6.check_ngIf(currVal_55_0_0, throwOnChange, false);
        this._NgIf_55_6.detectChangesInInputProps(this, this._anchor_55, throwOnChange);
        var currVal_59_0_0 = false;
        this._NgSwitchCase_59_6.check_ngSwitchCase(currVal_59_0_0, throwOnChange, false);
        this._NgSwitchCase_59_6.detectChangesInInputProps(this, this._anchor_59, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_79 = import5.interpolate(1, '\n                ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_0, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_79, currVal_79))) {
            this.renderer.setText(this._text_16, currVal_79);
            this._expr_79 = currVal_79;
        }
        this._NgClass_24_3.detectChangesInHostProps(this, this._el_24, throwOnChange);
        valUnwrapper.reset();
        var currVal_83 = import5.interpolate(1, '\n                      ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_1, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE.ALL), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_83, currVal_83))) {
            this.renderer.setText(this._text_25, currVal_83);
            this._expr_83 = currVal_83;
        }
        this._NgClass_28_3.detectChangesInHostProps(this, this._el_28, throwOnChange);
        valUnwrapper.reset();
        var currVal_86 = import5.interpolate(1, '\n                      ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_2, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE.REISSUE), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_86, currVal_86))) {
            this.renderer.setText(this._text_29, currVal_86);
            this._expr_86 = currVal_86;
        }
        this._NgClass_32_3.detectChangesInHostProps(this, this._el_32, throwOnChange);
        valUnwrapper.reset();
        var currVal_89 = import5.interpolate(1, '\n                      ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_3, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE.PRODUCTION), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_89, currVal_89))) {
            this.renderer.setText(this._text_33, currVal_89);
            this._expr_89 = currVal_89;
        }
        this._NgClass_36_3.detectChangesInHostProps(this, this._el_36, throwOnChange);
        valUnwrapper.reset();
        var currVal_92 = import5.interpolate(1, '\n                      ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_4, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE.SPECIAL), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_92, currVal_92))) {
            this.renderer.setText(this._text_37, currVal_92);
            this._expr_92 = currVal_92;
        }
        this._SearchableContentsComponent_45_3.detectChangesInHostProps(this, this._el_45, throwOnChange);
        this._NgSwitch_47_3.detectChangesInHostProps(this, this._el_47, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_15_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_15_0 = (this.context.utils.lLink('catalogue', this.context.currentLanguage) !== false);
        return (true && pd_15_0);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_24_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_24_0 = (this.context.utils.lLink('catalogue', this.context.currentLanguage) !== false);
        return (true && pd_24_0);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_28_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this.context.utils.lLink('catalogue/reissue', this.context.currentLanguage) !== false);
        return (true && pd_28_0);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_32_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_32_0 = (this.context.utils.lLink('catalogue/production', this.context.currentLanguage) !== false);
        return (true && pd_32_0);
    };
    _View_ContentRecordsComponent0.prototype._handle_click_36_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_36_0 = (this.context.utils.lLink('catalogue/special', this.context.currentLanguage) !== false);
        return (true && pd_36_0);
    };
    return _View_ContentRecordsComponent0;
}(import1.AppView));
function viewFactory_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentRecordsComponent === null)) {
        (renderType_ContentRecordsComponent = viewUtils.createRenderComponentType('', 0, import18.ViewEncapsulation.None, styles_ContentRecordsComponent, {}));
    }
    return new _View_ContentRecordsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentRecordsComponent0 = viewFactory_ContentRecordsComponent0;
var _View_ContentRecordsComponent1 = (function (_super) {
    __extends(_View_ContentRecordsComponent1, _super);
    function _View_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent1, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'loading-indicator', new import5.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import37.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new import37.Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, [], null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_ContentRecordsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import38.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = '#B6B6B6';
        this._LoadingIndicator_0_4.check_color(currVal_0_0_0, throwOnChange, false);
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent1;
}(import1.AppView));
function viewFactory_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent2 = (function (_super) {
    __extends(_View_ContentRecordsComponent2, _super);
    function _View_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent2, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-3 col-sm-4 sidebar'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'search', new import5.InlineArray4(4, 'scrollOnClick', '#content-start', 'target', '/catalogue'), null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._el_2);
        var compView_2 = import39.viewFactory_SearchComponent0(this.viewUtils, this.injector(2), this._appEl_2);
        this._SearchComponent_2_4 = new import39.Wrapper_SearchComponent(this.parent.parentInjector.get(import11.UtilsService), this.parent.parentInjector.get(import29.SearchService), this.parent.parentInjector.get(import30.ElasticSearchService), this.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parentInjector.get(import17.Router));
        this._appEl_2.initComponent(this._SearchComponent_2_4.context, [], compView_2);
        this._text_3 = this.renderer.createText(null, '\n        ', null);
        compView_2.create(this._SearchComponent_2_4.context, [], null);
        this._text_4 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_5 = new import3.AppElement(5, 0, this, this._anchor_5);
        this._TemplateRef_5_5 = new import31.TemplateRef_(this._appEl_5, viewFactory_ContentRecordsComponent3);
        this._NgSwitchCase_5_6 = new import22.Wrapper_NgSwitchCase(this._appEl_5.vcRef, this._TemplateRef_5_5, this.parent._NgSwitch_47_3.context);
        this._text_6 = this.renderer.createText(this._el_0, '\n\n      ', null);
        this._pipe_intl_0_5 = import5.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.SearchComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._SearchComponent_2_4.context;
        }
        if (((token === import31.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import34.NgSwitchCase) && (5 === requestNodeIndex))) {
            return this._NgSwitchCase_5_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_2_0_0 = ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.CATALOGUE.SEARCH.SUGGESTIONS.ORDER);
        this._SearchComponent_2_4.check_order(currVal_2_0_0, throwOnChange, false);
        var currVal_2_0_1 = '#content-start';
        this._SearchComponent_2_4.check_scrollOnClick(currVal_2_0_1, throwOnChange, false);
        var currVal_2_0_2 = '/catalogue';
        this._SearchComponent_2_4.check_target(currVal_2_0_2, throwOnChange, false);
        valUnwrapper.reset();
        var currVal_2_0_3 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_5, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CATALOGUE.SEARCH), this.parent.context.currentLanguage)), '');
        this._SearchComponent_2_4.check_placeholder(currVal_2_0_3, throwOnChange, valUnwrapper.hasWrappedValue);
        var currVal_2_0_4 = this.parent.context.currentLanguage;
        this._SearchComponent_2_4.check_language(currVal_2_0_4, throwOnChange, false);
        var currVal_2_0_5 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchComponent_2_4.check_labels(currVal_2_0_5, throwOnChange, false);
        this._SearchComponent_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        var currVal_5_0_0 = false;
        this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0, throwOnChange, false);
        this._NgSwitchCase_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchComponent_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent2;
}(import1.AppView));
function viewFactory_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent3 = (function (_super) {
    __extends(_View_ContentRecordsComponent3, _super);
    function _View_ContentRecordsComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent3, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'search-facets', new import5.InlineArray4(4, 'class', 'hidden-xs', 'target', '/catalogue'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import41.viewFactory_SearchFacetsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchFacetsComponent_0_4 = new import41.Wrapper_SearchFacetsComponent(this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parent.parentInjector.get(import17.Router), this.parent.parent.parentInjector.get(import30.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n        ', null);
        compView_0.create(this._SearchFacetsComponent_0_4.context, [], null);
        var disposable_0 = this.renderer.listen(this._el_0, 'onFilter', this.eventHandler(this._handle_onFilter_0_0.bind(this)));
        var subscription_0 = this._SearchFacetsComponent_0_4.context.onFilter.subscribe(this.eventHandler(this._handle_onFilter_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentRecordsComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import42.SearchFacetsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._SearchFacetsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.parent._SearchableContentsComponent_45_3.context.esAggregations;
        this._SearchFacetsComponent_0_4.check_esAggregations(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent.parent._SearchableContentsComponent_45_3.context.aggFields.record;
        this._SearchFacetsComponent_0_4.check_fields(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = this.parent.parent._SearchableContentsComponent_45_3.context.esFilters;
        this._SearchFacetsComponent_0_4.check_esFilters(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchFacetsComponent_0_4.check_labels(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = this.parent.parent.context.currentLanguage;
        this._SearchFacetsComponent_0_4.check_language(currVal_0_0_4, throwOnChange, false);
        var currVal_0_0_5 = '/catalogue';
        this._SearchFacetsComponent_0_4.check_target(currVal_0_0_5, throwOnChange, false);
        this._SearchFacetsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFacetsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent3.prototype._handle_onFilter_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.parent._SearchableContentsComponent_45_3.context.searchCallBack($event) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentRecordsComponent3;
}(import1.AppView));
function viewFactory_ContentRecordsComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent4 = (function (_super) {
    __extends(_View_ContentRecordsComponent4, _super);
    function _View_ContentRecordsComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent4, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._map_72 = import5.pureProxy2(function (p0, p1) {
            return {
                'col-md-9 col-sm-8': p0,
                'col-md-12': p1
            };
        });
        this._map_73 = import5.pureProxy2(function (p0, p1) {
            return {
                'shorting-filter': p0,
                'shorting-nofilter': p1
            };
        });
        this._map_74 = import5.pureProxy1(function (p0) {
            return { 'col-lg-9 col-md-8 col-sm-7': p0 };
        });
        this._map_75 = import5.pureProxy1(function (p0) {
            return { 'search-az-nofilter': p0 };
        });
    }
    _View_ContentRecordsComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'catalogue-content col-md-offset-1'), null);
        this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers), this.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_3 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'shorting clearfix xs-no-margin col-xs-12'), null);
        this._NgClass_3_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers), this.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_3), this.renderer);
        this._text_4 = this.renderer.createText(this._el_3, '\n          \n          ', null);
        this._text_5 = this.renderer.createText(this._el_3, '\n          ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_6 = new import3.AppElement(6, 3, this, this._anchor_6);
        this._TemplateRef_6_5 = new import31.TemplateRef_(this._appEl_6, viewFactory_ContentRecordsComponent5);
        this._NgIf_6_6 = new import23.Wrapper_NgIf(this._appEl_6.vcRef, this._TemplateRef_6_5);
        this._text_7 = this.renderer.createText(this._el_3, '\n\n          ', null);
        this._text_8 = this.renderer.createText(this._el_3, ' \n          ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_3, 'div', new import5.InlineArray2(2, 'class', 'search-tools-container col-xs-12 grid-nav'), null);
        this._NgClass_9_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers), this.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_9), this.renderer);
        this._text_10 = this.renderer.createText(this._el_9, '\n\n            ', null);
        this._text_11 = this.renderer.createText(this._el_9, ' \n            ', null);
        this._el_12 = import5.createRenderElement(this.renderer, this._el_9, 'search-az', new import5.InlineArray4(4, 'class', 'search-az', 'target', '/catalogue'), null);
        this._appEl_12 = new import3.AppElement(12, 9, this, this._el_12);
        var compView_12 = import43.viewFactory_SearchAZComponent0(this.viewUtils, this.injector(12), this._appEl_12);
        this._NgClass_12_4 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers), this.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_12), this.renderer);
        this._SearchAZComponent_12_5 = new import43.Wrapper_SearchAZComponent(this.parent.parentInjector.get(import29.SearchService), new import9.ElementRef(this._el_12), this.parent.parentInjector.get(import11.UtilsService), this.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parentInjector.get(import17.Router), this.parent.parentInjector.get(import30.ElasticSearchService));
        this._appEl_12.initComponent(this._SearchAZComponent_12_5.context, [], compView_12);
        this._text_13 = this.renderer.createText(null, '\n            ', null);
        compView_12.create(this._SearchAZComponent_12_5.context, [], null);
        this._text_14 = this.renderer.createText(this._el_9, '\n\n            ', null);
        this._text_15 = this.renderer.createText(this._el_9, '\n            ', null);
        this._text_16 = this.renderer.createText(this._el_9, '\n            ', null);
        this._anchor_17 = this.renderer.createTemplateAnchor(this._el_9, null);
        this._appEl_17 = new import3.AppElement(17, 9, this, this._anchor_17);
        this._TemplateRef_17_5 = new import31.TemplateRef_(this._appEl_17, viewFactory_ContentRecordsComponent6);
        this._NgIf_17_6 = new import23.Wrapper_NgIf(this._appEl_17.vcRef, this._TemplateRef_17_5);
        this._text_18 = this.renderer.createText(this._el_9, '\n\n            ', null);
        this._anchor_19 = this.renderer.createTemplateAnchor(this._el_9, null);
        this._appEl_19 = new import3.AppElement(19, 9, this, this._anchor_19);
        this._TemplateRef_19_5 = new import31.TemplateRef_(this._appEl_19, viewFactory_ContentRecordsComponent7);
        this._NgIf_19_6 = new import23.Wrapper_NgIf(this._appEl_19.vcRef, this._TemplateRef_19_5);
        this._text_20 = this.renderer.createText(this._el_9, '\n\n            ', null);
        this._text_21 = this.renderer.createText(this._el_9, '\n            ', null);
        this._anchor_22 = this.renderer.createTemplateAnchor(this._el_9, null);
        this._appEl_22 = new import3.AppElement(22, 9, this, this._anchor_22);
        this._TemplateRef_22_5 = new import31.TemplateRef_(this._appEl_22, viewFactory_ContentRecordsComponent8);
        this._NgIf_22_6 = new import23.Wrapper_NgIf(this._appEl_22.vcRef, this._TemplateRef_22_5);
        this._text_23 = this.renderer.createText(this._el_9, '\n\n          ', null);
        this._text_24 = this.renderer.createText(this._el_3, '\n\n          ', null);
        this._text_25 = this.renderer.createText(this._el_3, '\n\n        ', null);
        this._text_26 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._text_27 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_28 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_28 = new import3.AppElement(28, 0, this, this._anchor_28);
        this._TemplateRef_28_5 = new import31.TemplateRef_(this._appEl_28, viewFactory_ContentRecordsComponent9);
        this._NgIf_28_6 = new import23.Wrapper_NgIf(this._appEl_28.vcRef, this._TemplateRef_28_5);
        this._text_29 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._text_30 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_31 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_31 = new import3.AppElement(31, 0, this, this._anchor_31);
        this._TemplateRef_31_5 = new import31.TemplateRef_(this._appEl_31, viewFactory_ContentRecordsComponent11);
        this._NgIf_31_6 = new import23.Wrapper_NgIf(this._appEl_31.vcRef, this._TemplateRef_31_5);
        this._text_32 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_34 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_34 = new import3.AppElement(34, 0, this, this._anchor_34);
        this._TemplateRef_34_5 = new import31.TemplateRef_(this._appEl_34, viewFactory_ContentRecordsComponent13);
        this._NgIf_34_6 = new import23.Wrapper_NgIf(this._appEl_34.vcRef, this._TemplateRef_34_5);
        this._text_35 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._text_36 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_37 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_37 = new import3.AppElement(37, 0, this, this._anchor_37);
        this._TemplateRef_37_5 = new import31.TemplateRef_(this._appEl_37, viewFactory_ContentRecordsComponent15);
        this._NgSwitchCase_37_6 = new import22.Wrapper_NgSwitchCase(this._appEl_37.vcRef, this._TemplateRef_37_5, this.parent._NgSwitch_47_3.context);
        this._text_38 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this._text_39 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_40 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_41 = this.renderer.createText(this._el_0, '\n      ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._anchor_17,
            this._text_18,
            this._anchor_19,
            this._text_20,
            this._text_21,
            this._anchor_22,
            this._text_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._anchor_28,
            this._text_29,
            this._text_30,
            this._anchor_31,
            this._text_32,
            this._text_33,
            this._anchor_34,
            this._text_35,
            this._text_36,
            this._anchor_37,
            this._text_38,
            this._text_39,
            this._text_40,
            this._text_41
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import35.NgIf) && (6 === requestNodeIndex))) {
            return this._NgIf_6_6.context;
        }
        if (((token === import33.NgClass) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) {
            return this._NgClass_12_4.context;
        }
        if (((token === import44.SearchAZComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) {
            return this._SearchAZComponent_12_5.context;
        }
        if (((token === import31.TemplateRef) && (17 === requestNodeIndex))) {
            return this._TemplateRef_17_5;
        }
        if (((token === import35.NgIf) && (17 === requestNodeIndex))) {
            return this._NgIf_17_6.context;
        }
        if (((token === import31.TemplateRef) && (19 === requestNodeIndex))) {
            return this._TemplateRef_19_5;
        }
        if (((token === import35.NgIf) && (19 === requestNodeIndex))) {
            return this._NgIf_19_6.context;
        }
        if (((token === import31.TemplateRef) && (22 === requestNodeIndex))) {
            return this._TemplateRef_22_5;
        }
        if (((token === import35.NgIf) && (22 === requestNodeIndex))) {
            return this._NgIf_22_6.context;
        }
        if (((token === import33.NgClass) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 23)))) {
            return this._NgClass_9_3.context;
        }
        if (((token === import33.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 25)))) {
            return this._NgClass_3_3.context;
        }
        if (((token === import31.TemplateRef) && (28 === requestNodeIndex))) {
            return this._TemplateRef_28_5;
        }
        if (((token === import35.NgIf) && (28 === requestNodeIndex))) {
            return this._NgIf_28_6.context;
        }
        if (((token === import31.TemplateRef) && (31 === requestNodeIndex))) {
            return this._TemplateRef_31_5;
        }
        if (((token === import35.NgIf) && (31 === requestNodeIndex))) {
            return this._NgIf_31_6.context;
        }
        if (((token === import31.TemplateRef) && (34 === requestNodeIndex))) {
            return this._TemplateRef_34_5;
        }
        if (((token === import35.NgIf) && (34 === requestNodeIndex))) {
            return this._NgIf_34_6.context;
        }
        if (((token === import31.TemplateRef) && (37 === requestNodeIndex))) {
            return this._TemplateRef_37_5;
        }
        if (((token === import34.NgSwitchCase) && (37 === requestNodeIndex))) {
            return this._NgSwitchCase_37_6.context;
        }
        if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 41)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'catalogue-content col-md-offset-1';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_72(this.parent.context.hasFilter, !this.parent.context.hasFilter);
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_3_0_0 = 'shorting clearfix xs-no-margin col-xs-12';
        this._NgClass_3_3.check_klass(currVal_3_0_0, throwOnChange, false);
        var currVal_3_0_1 = this._map_73(this.parent.context.hasFilter, !this.parent.context.hasFilter);
        this._NgClass_3_3.check_ngClass(currVal_3_0_1, throwOnChange, false);
        this._NgClass_3_3.detectChangesInInputProps(this, this._el_3, throwOnChange);
        var currVal_6_0_0 = !this.parent.context.hasFilter;
        this._NgIf_6_6.check_ngIf(currVal_6_0_0, throwOnChange, false);
        this._NgIf_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_9_0_0 = 'search-tools-container col-xs-12 grid-nav';
        this._NgClass_9_3.check_klass(currVal_9_0_0, throwOnChange, false);
        var currVal_9_0_1 = this._map_74(!this.parent.context.hasFilter);
        this._NgClass_9_3.check_ngClass(currVal_9_0_1, throwOnChange, false);
        this._NgClass_9_3.detectChangesInInputProps(this, this._el_9, throwOnChange);
        var currVal_12_0_0 = 'search-az';
        this._NgClass_12_4.check_klass(currVal_12_0_0, throwOnChange, false);
        var currVal_12_0_1 = this._map_75(!this.parent.context.hasFilter);
        this._NgClass_12_4.check_ngClass(currVal_12_0_1, throwOnChange, false);
        this._NgClass_12_4.detectChangesInInputProps(this, this._el_12, throwOnChange);
        var currVal_12_1_0 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchAZComponent_12_5.check_labels(currVal_12_1_0, throwOnChange, false);
        var currVal_12_1_1 = this.parent.context.currentLanguage;
        this._SearchAZComponent_12_5.check_language(currVal_12_1_1, throwOnChange, false);
        var currVal_12_1_2 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.CATALOGUE.NEW_SEARCH)[this.parent.context.currentLanguage];
        this._SearchAZComponent_12_5.check_title(currVal_12_1_2, throwOnChange, false);
        var currVal_12_1_3 = '/catalogue';
        this._SearchAZComponent_12_5.check_target(currVal_12_1_3, throwOnChange, false);
        this._SearchAZComponent_12_5.detectChangesInInputProps(this, this._el_12, throwOnChange);
        var currVal_17_0_0 = (this.parent.context.entryType != 'special');
        this._NgIf_17_6.check_ngIf(currVal_17_0_0, throwOnChange, false);
        this._NgIf_17_6.detectChangesInInputProps(this, this._anchor_17, throwOnChange);
        var currVal_19_0_0 = this.parent.context.hasFilter;
        this._NgIf_19_6.check_ngIf(currVal_19_0_0, throwOnChange, false);
        this._NgIf_19_6.detectChangesInInputProps(this, this._anchor_19, throwOnChange);
        var currVal_22_0_0 = this.parent.context.hasFilter;
        this._NgIf_22_6.check_ngIf(currVal_22_0_0, throwOnChange, false);
        this._NgIf_22_6.detectChangesInInputProps(this, this._anchor_22, throwOnChange);
        var currVal_28_0_0 = (((((this.parent.context.config.data == null) ? null : this.parent.context.config.data.CATALOGUE.FEATURED) && this.parent.context.isFirstPage) && !this.parent.context.entryType) && !this.parent.context.hasFilter);
        this._NgIf_28_6.check_ngIf(currVal_28_0_0, throwOnChange, false);
        this._NgIf_28_6.detectChangesInInputProps(this, this._anchor_28, throwOnChange);
        var currVal_31_0_0 = (this.parent.context.entryType != 'special');
        this._NgIf_31_6.check_ngIf(currVal_31_0_0, throwOnChange, false);
        this._NgIf_31_6.detectChangesInInputProps(this, this._anchor_31, throwOnChange);
        var currVal_34_0_0 = (this.parent.context.entryType == 'special');
        this._NgIf_34_6.check_ngIf(currVal_34_0_0, throwOnChange, false);
        this._NgIf_34_6.detectChangesInInputProps(this, this._anchor_34, throwOnChange);
        var currVal_37_0_0 = false;
        this._NgSwitchCase_37_6.check_ngSwitchCase(currVal_37_0_0, throwOnChange, false);
        this._NgSwitchCase_37_6.detectChangesInInputProps(this, this._anchor_37, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this._NgClass_3_3.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this._NgClass_9_3.detectChangesInHostProps(this, this._el_9, throwOnChange);
        this._NgClass_12_4.detectChangesInHostProps(this, this._el_12, throwOnChange);
        this._SearchAZComponent_12_5.detectChangesInHostProps(this, this._el_12, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent4;
}(import1.AppView));
function viewFactory_ContentRecordsComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent5 = (function (_super) {
    __extends(_View_ContentRecordsComponent5, _super);
    function _View_ContentRecordsComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent5, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'search', new import5.InlineArray8(6, 'class', 'search-nofilter col-lg-3 col-md-4 col-sm-5 col-xs-12', 'scrollOnClick', '#content-start', 'target', '/catalogue'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import39.viewFactory_SearchComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchComponent_0_4 = new import39.Wrapper_SearchComponent(this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import29.SearchService), this.parent.parent.parentInjector.get(import30.ElasticSearchService), this.parent.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parent.parentInjector.get(import17.Router));
        this._appEl_0.initComponent(this._SearchComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n          ', null);
        compView_0.create(this._SearchComponent_0_4.context, [], null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.SearchComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._SearchComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = ((this.parent.parent.context.config.data == null) ? null : this.parent.parent.context.config.data.CATALOGUE.SEARCH.SUGGESTIONS.ORDER);
        this._SearchComponent_0_4.check_order(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = '#content-start';
        this._SearchComponent_0_4.check_scrollOnClick(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = '/catalogue';
        this._SearchComponent_0_4.check_target(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CATALOGUE.SEARCH)[this.parent.parent.context.currentLanguage];
        this._SearchComponent_0_4.check_placeholder(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = this.parent.parent.context.currentLanguage;
        this._SearchComponent_0_4.check_language(currVal_0_0_4, throwOnChange, false);
        var currVal_0_0_5 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchComponent_0_4.check_labels(currVal_0_0_5, throwOnChange, false);
        var currVal_0_0_6 = true;
        this._SearchComponent_0_4.check_expand(currVal_0_0_6, throwOnChange, false);
        this._SearchComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent5;
}(import1.AppView));
function viewFactory_ContentRecordsComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent6 = (function (_super) {
    __extends(_View_ContentRecordsComponent6, _super);
    function _View_ContentRecordsComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent6, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_6 = import8.UNINITIALIZED;
    }
    _View_ContentRecordsComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'p', new import5.InlineArray2(2, 'class', 'page-status text-uppercase pull-right xs-display-none'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n              ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'span', new import5.InlineArray2(2, 'class', ''), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n              ', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n            ', null);
        this._pipe_number_1_0 = import5.pureProxy2(this.parent.parent._pipe_number_1.transform.bind(this.parent.parent._pipe_number_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_6 = import5.interpolate(4, '\n                ', ((this.parent.parent.context.pageSize <= this.parent.parent._SearchableContentsComponent_45_3.context.esContents['total']) ? this.parent.parent.context.pageSize : this.parent.parent._SearchableContentsComponent_45_3.context.esContents['total']), ' / ', this.parent.parent._SearchableContentsComponent_45_3.context.esContents['total'], ' | \n                Page ', this.parent.parent.context.currentPage, ' / ', valUnwrapper.unwrap(import5.castByValue(this._pipe_number_1_0, this.parent.parent._pipe_number_1.transform)((this.parent.parent._SearchableContentsComponent_45_3.context.esContents['total'] / this.parent.parent.context.pageSize), '1.0-0')), '\n              ');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_6, currVal_6))) {
            this.renderer.setText(this._text_3, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent6;
}(import1.AppView));
function viewFactory_ContentRecordsComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent7 = (function (_super) {
    __extends(_View_ContentRecordsComponent7, _super);
    function _View_ContentRecordsComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent7, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'br', import5.EMPTY_INLINE_ARRAY, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    return _View_ContentRecordsComponent7;
}(import1.AppView));
function viewFactory_ContentRecordsComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent8 = (function (_super) {
    __extends(_View_ContentRecordsComponent8, _super);
    function _View_ContentRecordsComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent8, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'search-filters', new import5.InlineArray4(4, 'class', 'search-filters', 'target', '/catalogue'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import45.viewFactory_SearchFilterComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchFilterComponent_0_4 = new import45.Wrapper_SearchFilterComponent(this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import17.Router), this.parent.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parent.parentInjector.get(import30.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchFilterComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n            ', null);
        compView_0.create(this._SearchFilterComponent_0_4.context, [], null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import46.SearchFilterComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._SearchFilterComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent.parent._SearchableContentsComponent_45_3.context.esQuery;
        this._SearchFilterComponent_0_4.check_esQuery(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent.parent._SearchableContentsComponent_45_3.context.esFilters;
        this._SearchFilterComponent_0_4.check_esFilters(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CATALOGUE.FILTERS)[this.parent.parent.context.currentLanguage];
        this._SearchFilterComponent_0_4.check_title(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = '/catalogue';
        this._SearchFilterComponent_0_4.check_target(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchFilterComponent_0_4.check_labels(currVal_0_0_4, throwOnChange, false);
        var currVal_0_0_5 = this.parent.parent.context.currentLanguage;
        this._SearchFilterComponent_0_4.check_language(currVal_0_0_5, throwOnChange, false);
        this._SearchFilterComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFilterComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent8;
}(import1.AppView));
function viewFactory_ContentRecordsComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent9 = (function (_super) {
    __extends(_View_ContentRecordsComponent9, _super);
    function _View_ContentRecordsComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent9, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray4(4, 'class', 'record-listing-featured record-listing', 'content-records-featured', ''), null);
        this._ContentRecordsFeaturedComponent_0_3 = new import47.Wrapper_ContentRecordsFeaturedComponent(this.parent.parent.parentInjector.get(import14.ContentService), this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parent.parentInjector.get(import17.Router), this.parent.parent.parentInjector.get(import30.ElasticSearchService));
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2, viewFactory_ContentRecordsComponent10);
        this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parent.parent.parentInjector.get(import27.IterableDiffers), this.parent.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent9.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import49.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        if (((token === import50.ContentRecordsFeaturedComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._ContentRecordsFeaturedComponent_0_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent9.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentRecordsFeaturedComponent_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = this._ContentRecordsFeaturedComponent_0_3.context.dbContentsLimited(4);
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentRecordsFeaturedComponent_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent9;
}(import1.AppView));
function viewFactory_ContentRecordsComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent9(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent10 = (function (_super) {
    __extends(_View_ContentRecordsComponent10, _super);
    function _View_ContentRecordsComponent10(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent10, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._map_22 = import5.pureProxy1(function (p0) {
            return { 'col-md-3 col-xs-6': p0 };
        });
        this._expr_23 = import8.UNINITIALIZED;
        this._expr_24 = import8.UNINITIALIZED;
        this._expr_26 = import8.UNINITIALIZED;
    }
    _View_ContentRecordsComponent10.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'record-item'), null);
        this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import27.IterableDiffers), this.parent.parent.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', ''), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                  ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'img', new import5.InlineArray2(2, 'alt', ''), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_4, 'span', new import5.InlineArray2(2, 'class', 'image-tag'), null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_4, '\n                  ', null);
        this._text_11 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'record-desc'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n                  ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_13, 'div', new import5.InlineArray2(2, 'class', 'catalogue-record-title gray-text text-uppercase letter-spacing-2'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                      ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_15, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._text_19 = this.renderer.createText(this._el_13, '\n                ', null);
        this._text_20 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        this._pipe_intl_0_6 = import5.pureProxy2(this.parent.parent.parent._pipe_intl_0.transform.bind(this.parent.parent.parent._pipe_intl_0));
        var disposable_1 = this.renderer.listen(this._el_17, 'click', this.eventHandler(this._handle_click_17_0.bind(this)));
        this._pipe_truncate_2_0 = import5.pureProxy2(this.parent.parent.parent._pipe_truncate_2.transform.bind(this.parent.parent.parent._pipe_truncate_2));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentRecordsComponent10.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 20)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent10.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_0_0_0 = 'record-item';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_22(!this.parent.parent.parent.context.hasFilter);
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_23 = import5.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.cover.front, '');
        if (import5.checkBinding(throwOnChange, this._expr_23, currVal_23)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL, currVal_23));
            this._expr_23 = currVal_23;
        }
        valUnwrapper.reset();
        var currVal_24 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_6, this.parent.parent.parent._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.context.intl.data.CATALOGUE.FEATURED), this.parent.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_24, currVal_24))) {
            this.renderer.setText(this._text_9, currVal_24);
            this._expr_24 = currVal_24;
        }
        valUnwrapper.reset();
        var currVal_26 = import5.interpolate(1, '\n                        ', valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_0, this.parent.parent.parent._pipe_truncate_2.transform)(this.context.$implicit.title, ((this.parent.parent.parent.context.config.data == null) ? null : this.parent.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_26, currVal_26))) {
            this.renderer.setText(this._text_18, currVal_26);
            this._expr_26 = currVal_26;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent10.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    _View_ContentRecordsComponent10.prototype._handle_click_17_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_17_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_17_0);
    };
    return _View_ContentRecordsComponent10;
}(import1.AppView));
function viewFactory_ContentRecordsComponent10(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent10(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent11 = (function (_super) {
    __extends(_View_ContentRecordsComponent11, _super);
    function _View_ContentRecordsComponent11(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent11, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent11.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'record-listing'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2, viewFactory_ContentRecordsComponent12);
        this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parent.parent.parentInjector.get(import27.IterableDiffers), this.parent.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent11.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import49.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent11.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parent.parent._SearchableContentsComponent_45_3.context.dbContents;
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent11;
}(import1.AppView));
function viewFactory_ContentRecordsComponent11(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent11(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent12 = (function (_super) {
    __extends(_View_ContentRecordsComponent12, _super);
    function _View_ContentRecordsComponent12(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent12, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._map_22 = import5.pureProxy2(function (p0, p1) {
            return {
                'col-md-4 col-sm-6 col-xs-5': p0,
                'col-md-3 col-sm-4 col-xs-6': p1
            };
        });
        this._expr_23 = import8.UNINITIALIZED;
        this._expr_24 = import8.UNINITIALIZED;
    }
    _View_ContentRecordsComponent12.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'record-item'), null);
        this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import27.IterableDiffers), this.parent.parent.parent.parentInjector.get(import28.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', import5.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                  ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_6 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._el_8 = import5.createRenderElement(this.renderer, this._el_4, 'img', new import5.InlineArray2(2, 'alt', ''), null);
        this._LazyLoadImageDirective_8_3 = new import52.Wrapper_LazyLoadImageDirective(new import9.ElementRef(this._el_8), this.parent.parent.parent.parentInjector.get(import53.NgZone));
        this._text_9 = this.renderer.createText(this._el_4, '\n\n                  ', null);
        this._text_10 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_12 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'record-desc'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                  ', null);
        this._el_14 = import5.createRenderElement(this.renderer, this._el_12, 'div', new import5.InlineArray2(2, 'class', 'catalogue-record-title gray-text text-uppercase letter-spacing-2'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n                      ', null);
        this._el_16 = import5.createRenderElement(this.renderer, this._el_14, 'a', new import5.InlineArray2(2, 'class', 'pointer'), null);
        this._text_17 = this.renderer.createText(this._el_16, '', null);
        this._text_18 = this.renderer.createText(this._el_12, '\n                ', null);
        this._text_19 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_16, 'click', this.eventHandler(this._handle_click_16_0.bind(this)));
        this._pipe_truncate_2_1 = import5.pureProxy2(this.parent.parent.parent._pipe_truncate_2.transform.bind(this.parent.parent.parent._pipe_truncate_2));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._text_19
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentRecordsComponent12.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import54.LazyLoadImageDirective) && (8 === requestNodeIndex))) {
            return this._LazyLoadImageDirective_8_3.context;
        }
        if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 19)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent12.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        var currVal_0_0_0 = 'record-item';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_22(this.parent.parent.parent.context.hasFilter, !this.parent.parent.parent.context.hasFilter);
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_8_0_0 = import5.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.cover.front, '');
        this._LazyLoadImageDirective_8_3.check_lazyImage(currVal_8_0_0, throwOnChange, false);
        var currVal_8_0_1 = import5.interpolate(1, '/data/covers/lazy/', this.context.$implicit.cover.front, '');
        this._LazyLoadImageDirective_8_3.check_defaultImage(currVal_8_0_1, throwOnChange, false);
        this._LazyLoadImageDirective_8_3.detectChangesInInputProps(this, this._el_8, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._LazyLoadImageDirective_8_3.context.ngAfterContentInit();
            }
        }
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_23 = import5.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.cover.front, '');
        if (import5.checkBinding(throwOnChange, this._expr_23, currVal_23)) {
            this.renderer.setElementProperty(this._el_8, 'src', this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL, currVal_23));
            this._expr_23 = currVal_23;
        }
        this._LazyLoadImageDirective_8_3.detectChangesInHostProps(this, this._el_8, throwOnChange);
        valUnwrapper.reset();
        var currVal_24 = import5.interpolate(1, '\n                        ', valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_1, this.parent.parent.parent._pipe_truncate_2.transform)(this.context.$implicit.title, ((this.parent.parent.parent.context.config.data == null) ? null : this.parent.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_24, currVal_24))) {
            this.renderer.setText(this._text_17, currVal_24);
            this._expr_24 = currVal_24;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent12.prototype.destroyInternal = function () {
        this._LazyLoadImageDirective_8_3.context.ngOnDestroy();
    };
    _View_ContentRecordsComponent12.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_4_0);
    };
    _View_ContentRecordsComponent12.prototype._handle_click_16_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_16_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_16_0);
    };
    return _View_ContentRecordsComponent12;
}(import1.AppView));
function viewFactory_ContentRecordsComponent12(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent12(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent13 = (function (_super) {
    __extends(_View_ContentRecordsComponent13, _super);
    function _View_ContentRecordsComponent13(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent13, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent13.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray4(4, 'class', 'record-listing', 'content-specials', ''), null);
        this._ContentSpecialsComponent_0_3 = new import55.Wrapper_ContentSpecialsComponent(this.parent.parent.parentInjector.get(import14.ContentService), this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import15.ActivatedRoute), this.parent.parent.parentInjector.get(import17.Router), this.parent.parent.parentInjector.get(import30.ElasticSearchService));
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2, viewFactory_ContentRecordsComponent14);
        this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parent.parent.parentInjector.get(import27.IterableDiffers), this.parent.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_ContentRecordsComponent13.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import49.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        if (((token === import56.ContentSpecialsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._ContentSpecialsComponent_0_3.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent13.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentSpecialsComponent_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = this._ContentSpecialsComponent_0_3.context.dbContents;
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentSpecialsComponent_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentRecordsComponent13;
}(import1.AppView));
function viewFactory_ContentRecordsComponent13(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent13(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent14 = (function (_super) {
    __extends(_View_ContentRecordsComponent14, _super);
    function _View_ContentRecordsComponent14(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent14, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_34 = import8.UNINITIALIZED;
        this._expr_35 = import8.UNINITIALIZED;
        this._expr_36 = import8.UNINITIALIZED;
        this._expr_37 = import8.UNINITIALIZED;
        this._expr_39 = import8.UNINITIALIZED;
    }
    _View_ContentRecordsComponent14.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 col-sm-6 xs-margin-bottom-ten'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'div', new import5.InlineArray2(2, 'class', 'model-details clearfix xs-no-margin'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_4 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'text-center col-md-6 no-padding'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                      ', null);
        this._el_6 = import5.createRenderElement(this.renderer, this._el_4, 'img', new import5.InlineArray4(4, 'alt', '', 'class', 'pointer'), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_9 = import5.createRenderElement(this.renderer, this._el_2, 'div', new import5.InlineArray2(2, 'class', 'col-md-6 no-padding'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                      ', null);
        this._el_11 = import5.createRenderElement(this.renderer, this._el_9, 'div', new import5.InlineArray2(2, 'class', 'special-text model-details-text'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_13 = import5.createRenderElement(this.renderer, this._el_11, 'div', new import5.InlineArray2(2, 'class', 'separator-line bg-black no-margin-lr margin-ten'), null);
        this._text_14 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_15 = import5.createRenderElement(this.renderer, this._el_11, 'span', new import5.InlineArray2(2, 'class', 'display-block clearfix xs-no-margin sm-display-none'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_17 = import5.createRenderElement(this.renderer, this._el_11, 'span', new import5.InlineArray2(2, 'class', 'text-uppercase font-weight-600 black-text letter-spacing-2'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._text_19 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_20 = import5.createRenderElement(this.renderer, this._el_11, 'span', new import5.InlineArray2(2, 'class', 'text-uppercase text-small letter-spacing-2 margin-two display-block'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_23 = import5.createRenderElement(this.renderer, this._el_11, 'p', new import5.InlineArray2(2, 'class', 'margin-ten xs-no-margin'), null);
        this._text_24 = this.renderer.createText(this._el_23, '', null);
        this._text_25 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_26 = import5.createRenderElement(this.renderer, this._el_11, 'span', new import5.InlineArray2(2, 'class', 'margin-five xs-no-margin display-block clearfix xs-no-margin'), null);
        this._text_27 = this.renderer.createText(this._el_11, '\n                          ', null);
        this._el_28 = import5.createRenderElement(this.renderer, this._el_11, 'a', new import5.InlineArray2(2, 'class', 'bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer'), null);
        this._text_29 = this.renderer.createText(this._el_28, '', null);
        this._text_30 = this.renderer.createText(this._el_11, '\n                      ', null);
        this._text_31 = this.renderer.createText(this._el_9, '\n                  ', null);
        this._text_32 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        this._pipe_truncate_2_2 = import5.pureProxy2(this.parent.parent.parent._pipe_truncate_2.transform.bind(this.parent.parent.parent._pipe_truncate_2));
        var disposable_1 = this.renderer.listen(this._el_28, 'click', this.eventHandler(this._handle_click_28_0.bind(this)));
        this._pipe_intl_0_7 = import5.pureProxy2(this.parent.parent.parent._pipe_intl_0.transform.bind(this.parent.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_ContentRecordsComponent14.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import8.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_34 = import5.interpolate(1, '', this.context.$implicit.image, '');
        if (import5.checkBinding(throwOnChange, this._expr_34, currVal_34)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL, currVal_34));
            this._expr_34 = currVal_34;
        }
        var currVal_35 = import5.interpolate(1, '', this.context.$implicit.title[this.parent.parent.parent.context.currentLanguage], '');
        if (import5.checkBinding(throwOnChange, this._expr_35, currVal_35)) {
            this.renderer.setText(this._text_18, currVal_35);
            this._expr_35 = currVal_35;
        }
        var currVal_36 = import5.interpolate(1, '', this.context.$implicit.subtitle[this.parent.parent.parent.context.currentLanguage], '');
        if (import5.checkBinding(throwOnChange, this._expr_36, currVal_36)) {
            this.renderer.setText(this._text_21, currVal_36);
            this._expr_36 = currVal_36;
        }
        valUnwrapper.reset();
        var currVal_37 = import5.interpolate(1, '', valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_2, this.parent.parent.parent._pipe_truncate_2.transform)(this.context.$implicit.content[this.parent.parent.parent.context.currentLanguage], ((this.parent.parent.parent.context.config.data == null) ? null : this.parent.parent.parent.context.config.data.SPECIAL.TITLE_TRUNCATE))), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_37, currVal_37))) {
            this.renderer.setText(this._text_24, currVal_37);
            this._expr_37 = currVal_37;
        }
        valUnwrapper.reset();
        var currVal_39 = import5.interpolate(1, '\n                            ', valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_7, this.parent.parent.parent._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.context.intl.data.COMMON.SEE_MORE), this.parent.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange, this._expr_39, currVal_39))) {
            this.renderer.setText(this._text_29, currVal_39);
            this._expr_39 = currVal_39;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent14.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_6_0);
    };
    _View_ContentRecordsComponent14.prototype._handle_click_28_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url, this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_28_0);
    };
    return _View_ContentRecordsComponent14;
}(import1.AppView));
function viewFactory_ContentRecordsComponent14(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent14(viewUtils, parentInjector, declarationEl);
}
var _View_ContentRecordsComponent15 = (function (_super) {
    __extends(_View_ContentRecordsComponent15, _super);
    function _View_ContentRecordsComponent15(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentRecordsComponent15, renderType_ContentRecordsComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import8.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentRecordsComponent15.prototype.createInternal = function (rootSelector) {
        this._el_0 = import5.createRenderElement(this.renderer, null, 'div', new import5.InlineArray2(2, 'class', 'pagination margin-two no-margin-bottom'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n          ', null);
        this._el_2 = import5.createRenderElement(this.renderer, this._el_0, 'ng-pagination', new import5.InlineArray16(10, 'first-text', '«', 'last-text', '»', 'next-text', '<img src=\'/data/images/arrow-next-small.png\'/>', 'previous-text', '<img src=\'/data/images/arrow-pre-small.png\'/>', 'style', 'cursor: pointer'), null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._el_2);
        var compView_2 = import57.viewFactory_PaginationComponent0(this.viewUtils, this.injector(2), this._appEl_2);
        this._PaginationComponent_2_4 = new import57.Wrapper_PaginationComponent();
        this._appEl_2.initComponent(this._PaginationComponent_2_4.context, [], compView_2);
        this._text_3 = this.renderer.createText(null, '\n          ', null);
        compView_2.create(this._PaginationComponent_2_4.context, [], null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'pageChange', this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        var subscription_0 = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentRecordsComponent15.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import58.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._PaginationComponent_2_4.context;
        }
        return notFoundResult;
    };
    _View_ContentRecordsComponent15.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = '<img src=\'/data/images/arrow-pre-small.png\'/>';
        this._PaginationComponent_2_4.check_previousText(currVal_2_0_0, throwOnChange, false);
        var currVal_2_0_1 = '<img src=\'/data/images/arrow-next-small.png\'/>';
        this._PaginationComponent_2_4.check_nextText(currVal_2_0_1, throwOnChange, false);
        var currVal_2_0_2 = '«';
        this._PaginationComponent_2_4.check_firstText(currVal_2_0_2, throwOnChange, false);
        var currVal_2_0_3 = '»';
        this._PaginationComponent_2_4.check_lastText(currVal_2_0_3, throwOnChange, false);
        var currVal_2_0_4 = this.parent.parent._SearchableContentsComponent_45_3.context.esContents['total'];
        this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4, throwOnChange, false);
        var currVal_2_0_5 = this.parent.parent.context.currentPage;
        this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5, throwOnChange, false);
        var currVal_2_0_6 = this.parent.parent.context.pageSize;
        this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6, throwOnChange, false);
        this._PaginationComponent_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._PaginationComponent_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentRecordsComponent15.prototype._handle_pageChange_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.context.onPageChange($event, 'catalogue') !== false);
        return (true && pd_2_0);
    };
    return _View_ContentRecordsComponent15;
}(import1.AppView));
function viewFactory_ContentRecordsComponent15(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentRecordsComponent15(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(169);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(18);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(25);
var import13 = __webpack_require__(9);
var import14 = __webpack_require__(16);
var import15 = __webpack_require__(11);
var import16 = __webpack_require__(10);
var import17 = __webpack_require__(22);
var import18 = __webpack_require__(50);
var import19 = __webpack_require__(46);
var import20 = __webpack_require__(14);
var import21 = __webpack_require__(38);
var import22 = __webpack_require__(19);
var import23 = __webpack_require__(65);
var import24 = __webpack_require__(44);
var import25 = __webpack_require__(31);
var Wrapper_ContentWritingComponent = (function () {
    function Wrapper_ContentWritingComponent(p0, p1, p2, p3, p4, p5, p6) {
        this.changed = false;
        this.context = new import0.ContentWritingComponent(p0, p1, p2, p3, p4, p5, p6);
    }
    Wrapper_ContentWritingComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentWritingComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentWritingComponent;
}());
exports.Wrapper_ContentWritingComponent = Wrapper_ContentWritingComponent;
var renderType_ContentWritingComponent_Host = null;
var _View_ContentWritingComponent_Host0 = (function (_super) {
    __extends(_View_ContentWritingComponent_Host0, _super);
    function _View_ContentWritingComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent_Host0, renderType_ContentWritingComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentWritingComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentWritingComponent_0_4 = new Wrapper_ContentWritingComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.IntlService), new import10.ElementRef(this._el_0), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.MetaService), this.parentInjector.get(import13.ContentService), this.parentInjector.get(import14.ActivatedRoute));
        this._appEl_0.initComponent(this._ContentWritingComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentWritingComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentWritingComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentWritingComponent) && (0 === requestNodeIndex))) {
            return this._ContentWritingComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentWritingComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentWritingComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentWritingComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingComponent_Host0;
}(import1.AppView));
function viewFactory_ContentWritingComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingComponent_Host === null)) {
        (renderType_ContentWritingComponent_Host = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentWritingComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentWritingComponentNgFactory = new import16.ComponentFactory('ng-component', viewFactory_ContentWritingComponent_Host0, import0.ContentWritingComponent);
var styles_ContentWritingComponent = [];
var renderType_ContentWritingComponent = null;
var _View_ContentWritingComponent0 = (function (_super) {
    __extends(_View_ContentWritingComponent0, _super);
    function _View_ContentWritingComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent0, renderType_ContentWritingComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_45 = import7.UNINITIALIZED;
        this._expr_48 = import7.UNINITIALIZED;
    }
    _View_ContentWritingComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_5 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_6 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'page-title page-title-small bg-gray'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n    ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n        ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_8, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'div', new import4.InlineArray2(2, 'class', 'col-lg-4 col-md-5 col-sm-12'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'h1', new import4.InlineArray2(2, 'class', 'black-text'), null);
        this._text_15 = this.renderer.createText(this._el_14, '', null);
        this._text_16 = this.renderer.createText(this._el_12, '\n            ', null);
        this._text_17 = this.renderer.createText(this._el_10, '\n            ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_10, 'div', new import4.InlineArray2(2, 'class', 'col-lg-8 col-md-7 col-sm-12 breadcrumb text-uppercase'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n                ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_18, 'ul', import4.EMPTY_INLINE_ARRAY, null);
        this._text_21 = this.renderer.createText(this._el_20, '\n                    ', null);
        this._el_22 = import4.createRenderElement(this.renderer, this._el_20, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_22, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_24 = this.renderer.createText(this._el_23, '', null);
        this._text_25 = this.renderer.createText(this._el_20, '\n                ', null);
        this._text_26 = this.renderer.createText(this._el_18, '\n            ', null);
        this._text_27 = this.renderer.createText(this._el_10, '\n        ', null);
        this._text_28 = this.renderer.createText(this._el_8, '\n    ', null);
        this._text_29 = this.renderer.createText(this._el_6, '\n', null);
        this._text_30 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_31 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_32 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'blog-single-full-width-text'), null);
        this._text_33 = this.renderer.createText(this._el_32, '\n    ', null);
        this._text_34 = this.renderer.createText(this._el_32, '\n    ', null);
        this._anchor_35 = this.renderer.createTemplateAnchor(this._el_32, null);
        this._appEl_35 = new import3.AppElement(35, 32, this, this._anchor_35);
        this._TemplateRef_35_5 = new import20.TemplateRef_(this._appEl_35, viewFactory_ContentWritingComponent1);
        this._NgIf_35_6 = new import17.Wrapper_NgIf(this._appEl_35.vcRef, this._TemplateRef_35_5);
        this._text_36 = this.renderer.createText(this._el_32, '\n    ', null);
        this._anchor_37 = this.renderer.createTemplateAnchor(this._el_32, null);
        this._appEl_37 = new import3.AppElement(37, 32, this, this._anchor_37);
        this._TemplateRef_37_5 = new import20.TemplateRef_(this._appEl_37, viewFactory_ContentWritingComponent2);
        this._NgIf_37_6 = new import17.Wrapper_NgIf(this._appEl_37.vcRef, this._TemplateRef_37_5);
        this._text_38 = this.renderer.createText(this._el_32, '\n', null);
        this._pipe_intl_0 = new import18.IntlPipe();
        this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_0 = this.renderer.listen(this._el_23, 'click', this.eventHandler(this._handle_click_23_0.bind(this)));
        this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_date_1 = new import19.DatePipe(this.parentInjector.get(import21.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._el_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._anchor_35,
            this._text_36,
            this._anchor_37,
            this._text_38
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import20.TemplateRef) && (35 === requestNodeIndex))) {
            return this._TemplateRef_35_5;
        }
        if (((token === import22.NgIf) && (35 === requestNodeIndex))) {
            return this._NgIf_35_6.context;
        }
        if (((token === import20.TemplateRef) && (37 === requestNodeIndex))) {
            return this._TemplateRef_37_5;
        }
        if (((token === import22.NgIf) && (37 === requestNodeIndex))) {
            return this._NgIf_37_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_35_0_0 = this.context.loading;
        this._NgIf_35_6.check_ngIf(currVal_35_0_0, throwOnChange, false);
        this._NgIf_35_6.detectChangesInInputProps(this, this._anchor_35, throwOnChange);
        var currVal_37_0_0 = (this.context.content && this.context.currentLanguage);
        this._NgIf_37_6.check_ngIf(currVal_37_0_0, throwOnChange, false);
        this._NgIf_37_6.detectChangesInInputProps(this, this._anchor_37, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_45 = import4.interpolate(1, '\n                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.WRITINGS.LONG), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_45, currVal_45))) {
            this.renderer.setText(this._text_15, currVal_45);
            this._expr_45 = currVal_45;
        }
        valUnwrapper.reset();
        var currVal_48 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.WRITINGS.ALL), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_48, currVal_48))) {
            this.renderer.setText(this._text_24, currVal_48);
            this._expr_48 = currVal_48;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingComponent0.prototype._handle_click_23_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_23_0 = (this.context.utils.lLink('writings', this.context.currentLanguage) !== false);
        return (true && pd_23_0);
    };
    return _View_ContentWritingComponent0;
}(import1.AppView));
function viewFactory_ContentWritingComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingComponent === null)) {
        (renderType_ContentWritingComponent = viewUtils.createRenderComponentType('', 0, import15.ViewEncapsulation.None, styles_ContentWritingComponent, {}));
    }
    return new _View_ContentWritingComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentWritingComponent0 = viewFactory_ContentWritingComponent0;
var _View_ContentWritingComponent1 = (function (_super) {
    __extends(_View_ContentWritingComponent1, _super);
    function _View_ContentWritingComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent1, renderType_ContentWritingComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n            ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'loading-indicator', new import4.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_4 = new import3.AppElement(4, 2, this, this._el_4);
        var compView_4 = import23.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(4), this._appEl_4);
        this._LoadingIndicator_4_4 = new import23.Wrapper_LoadingIndicator();
        this._appEl_4.initComponent(this._LoadingIndicator_4_4.context, [], compView_4);
        compView_4.create(this._LoadingIndicator_4_4.context, [], null);
        this._text_5 = this.renderer.createText(this._el_2, '  \n        ', null);
        this._text_6 = this.renderer.createText(this._el_0, '\n    ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6
        ], [], []);
        return null;
    };
    _View_ContentWritingComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.LoadingIndicator) && (4 === requestNodeIndex))) {
            return this._LoadingIndicator_4_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_4_0_0 = '#B6B6B6';
        this._LoadingIndicator_4_4.check_color(currVal_4_0_0, throwOnChange, false);
        this._LoadingIndicator_4_4.detectChangesInInputProps(this, this._el_4, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_4_4.detectChangesInHostProps(this, this._el_4, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingComponent1;
}(import1.AppView));
function viewFactory_ContentWritingComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingComponent2 = (function (_super) {
    __extends(_View_ContentWritingComponent2, _super);
    function _View_ContentWritingComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent2, renderType_ContentWritingComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_27 = import7.UNINITIALIZED;
        this._expr_28 = import7.UNINITIALIZED;
        this._expr_30 = import7.UNINITIALIZED;
        this._expr_31 = import7.UNINITIALIZED;
    }
    _View_ContentWritingComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'container writing-content'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'row writing-header col-md-10 col-sm-10 col-xs-11 text-center center-col'), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n            ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_3, 'h2', import4.EMPTY_INLINE_ARRAY, null);
        this._text_6 = this.renderer.createText(this._el_5, '', null);
        this._text_7 = this.renderer.createText(this._el_3, '\n            ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_3, 'h4', import4.EMPTY_INLINE_ARRAY, null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_8, 'small', import4.EMPTY_INLINE_ARRAY, null);
        this._text_10 = this.renderer.createText(this._el_9, '', null);
        this._text_11 = this.renderer.createText(this._el_8, '', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_8, 'small', import4.EMPTY_INLINE_ARRAY, null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_3, '\n        ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n        ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_17 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_17 = new import3.AppElement(17, 0, this, this._anchor_17);
        this._TemplateRef_17_5 = new import20.TemplateRef_(this._appEl_17, viewFactory_ContentWritingComponent3);
        this._NgIf_17_6 = new import17.Wrapper_NgIf(this._appEl_17.vcRef, this._TemplateRef_17_5);
        this._text_18 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_19 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_19 = new import3.AppElement(19, 0, this, this._anchor_19);
        this._TemplateRef_19_5 = new import20.TemplateRef_(this._appEl_19, viewFactory_ContentWritingComponent4);
        this._NgIf_19_6 = new import17.Wrapper_NgIf(this._appEl_19.vcRef, this._TemplateRef_19_5);
        this._text_20 = this.renderer.createText(this._el_0, '\n    ', null);
        this._pipe_intl_0_2 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_date_1_0 = import4.pureProxy2(this.parent._pipe_date_1.transform.bind(this.parent._pipe_date_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._anchor_17,
            this._text_18,
            this._anchor_19,
            this._text_20
        ], [], []);
        return null;
    };
    _View_ContentWritingComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import20.TemplateRef) && (17 === requestNodeIndex))) {
            return this._TemplateRef_17_5;
        }
        if (((token === import22.NgIf) && (17 === requestNodeIndex))) {
            return this._NgIf_17_6.context;
        }
        if (((token === import20.TemplateRef) && (19 === requestNodeIndex))) {
            return this._TemplateRef_19_5;
        }
        if (((token === import22.NgIf) && (19 === requestNodeIndex))) {
            return this._NgIf_19_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_17_0_0 = this.parent.context.content.content[this.parent.context.currentLanguage];
        this._NgIf_17_6.check_ngIf(currVal_17_0_0, throwOnChange, false);
        this._NgIf_17_6.detectChangesInInputProps(this, this._anchor_17, throwOnChange);
        var currVal_19_0_0 = !this.parent.context.content.content[this.parent.context.currentLanguage];
        this._NgIf_19_6.check_ngIf(currVal_19_0_0, throwOnChange, false);
        this._NgIf_19_6.detectChangesInInputProps(this, this._anchor_19, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_27 = import4.interpolate(1, '', this.parent.context.content.title[this.parent.context.currentLanguage], '');
        if (import4.checkBinding(throwOnChange, this._expr_27, currVal_27)) {
            this.renderer.setText(this._text_6, currVal_27);
            this._expr_27 = currVal_27;
        }
        valUnwrapper.reset();
        var currVal_28 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.WRITING.AUTHOR_BY), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_10, currVal_28);
            this._expr_28 = currVal_28;
        }
        var currVal_30 = import4.interpolate(1, ' ', this.parent.context.content.author, ', ');
        if (import4.checkBinding(throwOnChange, this._expr_30, currVal_30)) {
            this.renderer.setText(this._text_11, currVal_30);
            this._expr_30 = currVal_30;
        }
        valUnwrapper.reset();
        var currVal_31 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_1_0, this.parent._pipe_date_1.transform)(this.parent.context.content.date, 'yyyy')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_31, currVal_31))) {
            this.renderer.setText(this._text_13, currVal_31);
            this._expr_31 = currVal_31;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingComponent2;
}(import1.AppView));
function viewFactory_ContentWritingComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingComponent3 = (function (_super) {
    __extends(_View_ContentWritingComponent3, _super);
    function _View_ContentWritingComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent3, renderType_ContentWritingComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import7.UNINITIALIZED;
    }
    _View_ContentWritingComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'row col-md-10 col-sm-10 col-xs-11 center-col'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    _View_ContentWritingComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = this.parent.parent.context.content.content[this.parent.parent.context.currentLanguage];
        if (import4.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML, currVal_2));
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingComponent3;
}(import1.AppView));
function viewFactory_ContentWritingComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingComponent4 = (function (_super) {
    __extends(_View_ContentWritingComponent4, _super);
    function _View_ContentWritingComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingComponent4, renderType_ContentWritingComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_17 = import7.UNINITIALIZED;
        this._expr_18 = import7.UNINITIALIZED;
        this._expr_20 = import7.UNINITIALIZED;
    }
    _View_ContentWritingComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'writing-body'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'row col-md-10 col-sm-10 col-xs-11 center-col'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                ', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'writing-not-translated'), null);
        this._text_8 = this.renderer.createText(this._el_7, '', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'writing-read-preferred row col-md-12 col-sm-12 center-col text-center'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n                    ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-small button xs-margin-bottom-five'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_10, '\n                ', null);
        this._text_15 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n        ', null);
        this._pipe_intl_0_3 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        var disposable_0 = this.renderer.listen(this._el_12, 'click', this.eventHandler(this._handle_click_12_0.bind(this)));
        this._pipe_intl_0_4 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_17 = this.parent.parent.context.content.summary[this.parent.parent.context.currentLanguage];
        if (import4.checkBinding(throwOnChange, this._expr_17, currVal_17)) {
            this.renderer.setElementProperty(this._el_4, 'innerHTML', this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML, currVal_17));
            this._expr_17 = currVal_17;
        }
        valUnwrapper.reset();
        var currVal_18 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.WRITING.NOT_TRANSLATED), this.parent.parent.context.currentLanguage)), '\n                ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_18, currVal_18))) {
            this.renderer.setText(this._text_8, currVal_18);
            this._expr_18 = currVal_18;
        }
        valUnwrapper.reset();
        var currVal_20 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.WRITING.READ_IN_PREFERRED_LANGUAGE), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_20, currVal_20))) {
            this.renderer.setText(this._text_13, currVal_20);
            this._expr_20 = currVal_20;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingComponent4.prototype._handle_click_12_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_12_0 = (this.parent.parent.context.utils.lLink(((this.parent.parent.context.type + '/') + this.parent.parent.context.content.url), ((this.parent.parent.context.writingConfig.data == null) ? null : this.parent.parent.context.writingConfig.data.APP.LANGUAGES.PREFERRED)) !== false);
        return (true && pd_12_0);
    };
    return _View_ContentWritingComponent4;
}(import1.AppView));
function viewFactory_ContentWritingComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingComponent4(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(170);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(25);
var import11 = __webpack_require__(2);
var import12 = __webpack_require__(9);
var import13 = __webpack_require__(16);
var import14 = __webpack_require__(32);
var import15 = __webpack_require__(15);
var import16 = __webpack_require__(11);
var import17 = __webpack_require__(10);
var import18 = __webpack_require__(22);
var import19 = __webpack_require__(178);
var import20 = __webpack_require__(56);
var import21 = __webpack_require__(50);
var import22 = __webpack_require__(46);
var import23 = __webpack_require__(14);
var import24 = __webpack_require__(30);
var import25 = __webpack_require__(29);
var import26 = __webpack_require__(38);
var import27 = __webpack_require__(19);
var import28 = __webpack_require__(39);
var import29 = __webpack_require__(97);
var import30 = __webpack_require__(65);
var import31 = __webpack_require__(44);
var import32 = __webpack_require__(306);
var import33 = __webpack_require__(174);
var import34 = __webpack_require__(78);
var import35 = __webpack_require__(20);
var import36 = __webpack_require__(40);
var import37 = __webpack_require__(18);
var import38 = __webpack_require__(57);
var import39 = __webpack_require__(237);
var import40 = __webpack_require__(119);
var import41 = __webpack_require__(24);
var import42 = __webpack_require__(21);
var import43 = __webpack_require__(220);
var import44 = __webpack_require__(95);
var Wrapper_ContentWritingsComponent = (function () {
    function Wrapper_ContentWritingsComponent(p0, p1, p2, p3, p4, p5, p6, p7) {
        this.changed = false;
        this.context = new import0.ContentWritingsComponent(p0, p1, p2, p3, p4, p5, p6, p7);
    }
    Wrapper_ContentWritingsComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_ContentWritingsComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_ContentWritingsComponent;
}());
exports.Wrapper_ContentWritingsComponent = Wrapper_ContentWritingsComponent;
var renderType_ContentWritingsComponent_Host = null;
var _View_ContentWritingsComponent_Host0 = (function (_super) {
    __extends(_View_ContentWritingsComponent_Host0, _super);
    function _View_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent_Host0, renderType_ContentWritingsComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_ContentWritingsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._ContentWritingsComponent_0_4 = new Wrapper_ContentWritingsComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.IntlService), this.parentInjector.get(import10.MetaService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import12.ContentService), this.parentInjector.get(import13.ActivatedRoute), this.parentInjector.get(import14.Location), this.parentInjector.get(import15.Router));
        this._appEl_0.initComponent(this._ContentWritingsComponent_0_4.context, [], compView_0);
        compView_0.create(this._ContentWritingsComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_ContentWritingsComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ContentWritingsComponent) && (0 === requestNodeIndex))) {
            return this._ContentWritingsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ContentWritingsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._ContentWritingsComponent_0_4.context.ngAfterContentChecked();
        }
        this._ContentWritingsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent_Host0;
}(import1.AppView));
function viewFactory_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingsComponent_Host === null)) {
        (renderType_ContentWritingsComponent_Host = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, [], {}));
    }
    return new _View_ContentWritingsComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.ContentWritingsComponentNgFactory = new import17.ComponentFactory('ng-component', viewFactory_ContentWritingsComponent_Host0, import0.ContentWritingsComponent);
var styles_ContentWritingsComponent = [];
var renderType_ContentWritingsComponent = null;
var _View_ContentWritingsComponent0 = (function (_super) {
    __extends(_View_ContentWritingsComponent0, _super);
    function _View_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent0, renderType_ContentWritingsComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'page-title-pull-top page-title parallax3 parallax-fix'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n', null);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_5 = this.renderer.createText(parentRenderNode, '\n', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_6 = new import3.AppElement(6, null, this, this._anchor_6);
        this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6, viewFactory_ContentWritingsComponent1);
        this._NgIf_6_6 = new import18.Wrapper_NgIf(this._appEl_6.vcRef, this._TemplateRef_6_5);
        this._text_7 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_8 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray8(6, 'context', 'writing', 'id', 'content-start', 'searchable-contents', ''), null);
        this._SearchableContentsComponent_8_3 = new import19.Wrapper_SearchableContentsComponent(this.parentInjector.get(import12.ContentService), this.parentInjector.get(import24.SearchService), this.parentInjector.get(import11.UtilsService), this.parentInjector.get(import13.ActivatedRoute), this.parentInjector.get(import15.Router), this.parentInjector.get(import25.ElasticSearchService));
        this._text_9 = this.renderer.createText(this._el_8, '\n\n  ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_8, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._NgSwitch_10_3 = new import20.Wrapper_NgSwitch();
        this._text_11 = this.renderer.createText(this._el_10, '\n    ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n\n      ', null);
        this._text_14 = this.renderer.createText(this._el_12, '\n      ', null);
        this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_15 = new import3.AppElement(15, 12, this, this._anchor_15);
        this._TemplateRef_15_5 = new import23.TemplateRef_(this._appEl_15, viewFactory_ContentWritingsComponent3);
        this._NgSwitchCase_15_6 = new import20.Wrapper_NgSwitchCase(this._appEl_15.vcRef, this._TemplateRef_15_5, this._NgSwitch_10_3.context);
        this._text_16 = this.renderer.createText(this._el_12, '\n\n      ', null);
        this._text_17 = this.renderer.createText(this._el_12, '\n      ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_12, 'div', new import4.InlineArray2(2, 'class', 'col-md-3 col-sm-4 sidebar writings-sidebar'), null);
        this._text_19 = this.renderer.createText(this._el_18, '\n\n        ', null);
        this._anchor_20 = this.renderer.createTemplateAnchor(this._el_18, null);
        this._appEl_20 = new import3.AppElement(20, 18, this, this._anchor_20);
        this._TemplateRef_20_5 = new import23.TemplateRef_(this._appEl_20, viewFactory_ContentWritingsComponent4);
        this._NgSwitchCase_20_6 = new import20.Wrapper_NgSwitchCase(this._appEl_20.vcRef, this._TemplateRef_20_5, this._NgSwitch_10_3.context);
        this._text_21 = this.renderer.createText(this._el_18, '\n\n      ', null);
        this._text_22 = this.renderer.createText(this._el_12, '\n      ', null);
        this._text_23 = this.renderer.createText(this._el_12, '\n\n      ', null);
        this._text_24 = this.renderer.createText(this._el_12, '\n      ', null);
        this._anchor_25 = this.renderer.createTemplateAnchor(this._el_12, null);
        this._appEl_25 = new import3.AppElement(25, 12, this, this._anchor_25);
        this._TemplateRef_25_5 = new import23.TemplateRef_(this._appEl_25, viewFactory_ContentWritingsComponent5);
        this._NgSwitchCase_25_6 = new import20.Wrapper_NgSwitchCase(this._appEl_25.vcRef, this._TemplateRef_25_5, this._NgSwitch_10_3.context);
        this._text_26 = this.renderer.createText(this._el_12, '\n    ', null);
        this._text_27 = this.renderer.createText(this._el_10, '\n  ', null);
        this._text_28 = this.renderer.createText(this._el_8, '\n', null);
        this._text_29 = this.renderer.createText(parentRenderNode, '\n', null);
        this._pipe_intl_0 = new import21.IntlPipe();
        this._pipe_date_1 = new import22.DatePipe(this.parentInjector.get(import26.LOCALE_ID));
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._anchor_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._anchor_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._anchor_25,
            this._text_26,
            this._text_27,
            this._text_28,
            this._text_29
        ], [], []);
        return null;
    };
    _View_ContentWritingsComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import27.NgIf) && (6 === requestNodeIndex))) {
            return this._NgIf_6_6.context;
        }
        if (((token === import23.TemplateRef) && (15 === requestNodeIndex))) {
            return this._TemplateRef_15_5;
        }
        if (((token === import28.NgSwitchCase) && (15 === requestNodeIndex))) {
            return this._NgSwitchCase_15_6.context;
        }
        if (((token === import23.TemplateRef) && (20 === requestNodeIndex))) {
            return this._TemplateRef_20_5;
        }
        if (((token === import28.NgSwitchCase) && (20 === requestNodeIndex))) {
            return this._NgSwitchCase_20_6.context;
        }
        if (((token === import23.TemplateRef) && (25 === requestNodeIndex))) {
            return this._TemplateRef_25_5;
        }
        if (((token === import28.NgSwitchCase) && (25 === requestNodeIndex))) {
            return this._NgSwitchCase_25_6.context;
        }
        if (((token === import28.NgSwitch) && ((10 <= requestNodeIndex) && (requestNodeIndex <= 27)))) {
            return this._NgSwitch_10_3.context;
        }
        if (((token === import29.SearchableContentsComponent) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 28)))) {
            return this._SearchableContentsComponent_8_3.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_6_0_0 = this.context.currentLanguage;
        this._NgIf_6_6.check_ngIf(currVal_6_0_0, throwOnChange, false);
        this._NgIf_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_8_0_0 = 'writing';
        this._SearchableContentsComponent_8_3.check_context(currVal_8_0_0, throwOnChange, false);
        var currVal_8_0_1 = this.context.pageSize;
        this._SearchableContentsComponent_8_3.check_pageSize(currVal_8_0_1, throwOnChange, false);
        var currVal_8_0_2 = true;
        this._SearchableContentsComponent_8_3.check_active(currVal_8_0_2, throwOnChange, false);
        this._SearchableContentsComponent_8_3.detectChangesInInputProps(this, this._el_8, throwOnChange);
        var currVal_10_0_0 = this._SearchableContentsComponent_8_3.context.loading;
        this._NgSwitch_10_3.check_ngSwitch(currVal_10_0_0, throwOnChange, false);
        this._NgSwitch_10_3.detectChangesInInputProps(this, this._el_10, throwOnChange);
        var currVal_15_0_0 = true;
        this._NgSwitchCase_15_6.check_ngSwitchCase(currVal_15_0_0, throwOnChange, false);
        this._NgSwitchCase_15_6.detectChangesInInputProps(this, this._anchor_15, throwOnChange);
        var currVal_20_0_0 = false;
        this._NgSwitchCase_20_6.check_ngSwitchCase(currVal_20_0_0, throwOnChange, false);
        this._NgSwitchCase_20_6.detectChangesInInputProps(this, this._anchor_20, throwOnChange);
        var currVal_25_0_0 = false;
        this._NgSwitchCase_25_6.check_ngSwitchCase(currVal_25_0_0, throwOnChange, false);
        this._NgSwitchCase_25_6.detectChangesInInputProps(this, this._anchor_25, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchableContentsComponent_8_3.detectChangesInHostProps(this, this._el_8, throwOnChange);
        this._NgSwitch_10_3.detectChangesInHostProps(this, this._el_10, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent0;
}(import1.AppView));
function viewFactory_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_ContentWritingsComponent === null)) {
        (renderType_ContentWritingsComponent = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, styles_ContentWritingsComponent, {}));
    }
    return new _View_ContentWritingsComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_ContentWritingsComponent0 = viewFactory_ContentWritingsComponent0;
var _View_ContentWritingsComponent1 = (function (_super) {
    __extends(_View_ContentWritingsComponent1, _super);
    function _View_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent1, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_25 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'section', new import4.InlineArray2(2, 'class', 'page-title page-title-small bg-gray'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'col-md-5 col-xs-12'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'h1', new import4.InlineArray2(2, 'class', 'black-text'), null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_6, '\n            ', null);
        this._text_11 = this.renderer.createText(this._el_4, '\n            ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'col-md-7 col-xs-12 breadcrumb text-uppercase'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'ul', new import4.InlineArray2(2, 'class', 'breadcrumb-sub'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n                    ', null);
        this._anchor_16 = this.renderer.createTemplateAnchor(this._el_14, null);
        this._appEl_16 = new import3.AppElement(16, 14, this, this._anchor_16);
        this._TemplateRef_16_5 = new import23.TemplateRef_(this._appEl_16, viewFactory_ContentWritingsComponent2);
        this._NgIf_16_6 = new import18.Wrapper_NgIf(this._appEl_16.vcRef, this._TemplateRef_16_5);
        this._text_17 = this.renderer.createText(this._el_14, '\n                ', null);
        this._text_18 = this.renderer.createText(this._el_12, '\n            ', null);
        this._text_19 = this.renderer.createText(this._el_4, '\n        ', null);
        this._text_20 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_21 = this.renderer.createText(this._el_0, '\n', null);
        this._pipe_intl_0_0 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._anchor_16,
            this._text_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._text_21
        ], [], []);
        return null;
    };
    _View_ContentWritingsComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (16 === requestNodeIndex))) {
            return this._TemplateRef_16_5;
        }
        if (((token === import27.NgIf) && (16 === requestNodeIndex))) {
            return this._NgIf_16_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_16_0_0 = this.parent.context.hasFilter;
        this._NgIf_16_6.check_ngIf(currVal_16_0_0, throwOnChange, false);
        this._NgIf_16_6.detectChangesInInputProps(this, this._anchor_16, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_25 = import4.interpolate(1, '\n                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.MENU.WRITINGS.LONG), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_25, currVal_25))) {
            this.renderer.setText(this._text_9, currVal_25);
            this._expr_25 = currVal_25;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent1;
}(import1.AppView));
function viewFactory_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent2 = (function (_super) {
    __extends(_View_ContentWritingsComponent2, _super);
    function _View_ContentWritingsComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent2, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_3 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._el_1 = import4.createRenderElement(this.renderer, this._el_0, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_2 = this.renderer.createText(this._el_1, '', null);
        var disposable_0 = this.renderer.listen(this._el_1, 'click', this.eventHandler(this._handle_click_1_0.bind(this)));
        this._pipe_intl_0_1 = import4.pureProxy2(this.parent.parent._pipe_intl_0.transform.bind(this.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1,
            this._text_2
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingsComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_3 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this.parent.parent._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.MENU.WRITINGS.ALL), this.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_3, currVal_3))) {
            this.renderer.setText(this._text_2, currVal_3);
            this._expr_3 = currVal_3;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent2.prototype._handle_click_1_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_1_0 = (this.parent.parent.context.utils.lLink('writings', this.parent.parent.context.currentLanguage) !== false);
        return (true && pd_1_0);
    };
    return _View_ContentWritingsComponent2;
}(import1.AppView));
function viewFactory_ContentWritingsComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent3 = (function (_super) {
    __extends(_View_ContentWritingsComponent3, _super);
    function _View_ContentWritingsComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent3, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'loading-indicator', new import4.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import30.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new import30.Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, [], null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_ContentWritingsComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import31.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = '#B6B6B6';
        this._LoadingIndicator_0_4.check_color(currVal_0_0_0, throwOnChange, false);
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent3;
}(import1.AppView));
function viewFactory_ContentWritingsComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent4 = (function (_super) {
    __extends(_View_ContentWritingsComponent4, _super);
    function _View_ContentWritingsComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent4, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'search-facets', new import4.InlineArray4(4, 'class', 'hidden-xs', 'target', '/writings'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import32.viewFactory_SearchFacetsComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchFacetsComponent_0_4 = new import32.Wrapper_SearchFacetsComponent(this.parent.parentInjector.get(import11.UtilsService), this.parent.parentInjector.get(import13.ActivatedRoute), this.parent.parentInjector.get(import15.Router), this.parent.parentInjector.get(import25.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n        ', null);
        compView_0.create(this._SearchFacetsComponent_0_4.context, [], null);
        var disposable_0 = this.renderer.listen(this._el_0, 'onFilter', this.eventHandler(this._handle_onFilter_0_0.bind(this)));
        var subscription_0 = this._SearchFacetsComponent_0_4.context.onFilter.subscribe(this.eventHandler(this._handle_onFilter_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentWritingsComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import33.SearchFacetsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._SearchFacetsComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent._SearchableContentsComponent_8_3.context.esAggregations;
        this._SearchFacetsComponent_0_4.check_esAggregations(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent._SearchableContentsComponent_8_3.context.aggFields.writing;
        this._SearchFacetsComponent_0_4.check_fields(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = this.parent._SearchableContentsComponent_8_3.context.esFilters;
        this._SearchFacetsComponent_0_4.check_esFilters(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchFacetsComponent_0_4.check_labels(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = this.parent.context.currentLanguage;
        this._SearchFacetsComponent_0_4.check_language(currVal_0_0_4, throwOnChange, false);
        var currVal_0_0_5 = '/writings';
        this._SearchFacetsComponent_0_4.check_target(currVal_0_0_5, throwOnChange, false);
        this._SearchFacetsComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFacetsComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent4.prototype._handle_onFilter_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent._SearchableContentsComponent_8_3.context.searchCallBack($event) !== false);
        return (true && pd_0_0);
    };
    return _View_ContentWritingsComponent4;
}(import1.AppView));
function viewFactory_ContentWritingsComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent5 = (function (_super) {
    __extends(_View_ContentWritingsComponent5, _super);
    function _View_ContentWritingsComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent5, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._map_19 = import4.pureProxy2(function (p0, p1) {
            return {
                'shorting-filter': p0,
                'shorting-nofilter': p1
            };
        });
    }
    _View_ContentWritingsComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-md-9 col-sm-8 catalogue-content writings-content col-md-offset-1'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        \n        ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'shorting writings-shorting clearfix xs-no-margin col-xs-12'), null);
        this._NgClass_3_3 = new import34.Wrapper_NgClass(this.parent.parentInjector.get(import35.IterableDiffers), this.parent.parentInjector.get(import36.KeyValueDiffers), new import37.ElementRef(this._el_3), this.renderer);
        this._text_4 = this.renderer.createText(this._el_3, '\n\n          ', null);
        this._text_5 = this.renderer.createText(this._el_3, ' \n          ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_3, null);
        this._appEl_6 = new import3.AppElement(6, 3, this, this._anchor_6);
        this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6, viewFactory_ContentWritingsComponent6);
        this._NgIf_6_6 = new import18.Wrapper_NgIf(this._appEl_6.vcRef, this._TemplateRef_6_5);
        this._text_7 = this.renderer.createText(this._el_3, '\n\n        ', null);
        this._text_8 = this.renderer.createText(this._el_0, '\n        \n        ', null);
        this._text_9 = this.renderer.createText(this._el_0, '\n        ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_10 = new import3.AppElement(10, 0, this, this._anchor_10);
        this._TemplateRef_10_5 = new import23.TemplateRef_(this._appEl_10, viewFactory_ContentWritingsComponent7);
        this._NgSwitchCase_10_6 = new import20.Wrapper_NgSwitchCase(this._appEl_10.vcRef, this._TemplateRef_10_5, this.parent._NgSwitch_10_3.context);
        this._text_11 = this.renderer.createText(this._el_0, '\n      ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._anchor_10,
            this._text_11
        ], [], []);
        return null;
    };
    _View_ContentWritingsComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import27.NgIf) && (6 === requestNodeIndex))) {
            return this._NgIf_6_6.context;
        }
        if (((token === import38.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 7)))) {
            return this._NgClass_3_3.context;
        }
        if (((token === import23.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import28.NgSwitchCase) && (10 === requestNodeIndex))) {
            return this._NgSwitchCase_10_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = 'shorting writings-shorting clearfix xs-no-margin col-xs-12';
        this._NgClass_3_3.check_klass(currVal_3_0_0, throwOnChange, false);
        var currVal_3_0_1 = this._map_19(this.parent.context.hasFilter, !this.parent.context.hasFilter);
        this._NgClass_3_3.check_ngClass(currVal_3_0_1, throwOnChange, false);
        this._NgClass_3_3.detectChangesInInputProps(this, this._el_3, throwOnChange);
        var currVal_6_0_0 = this.parent.context.hasFilter;
        this._NgIf_6_6.check_ngIf(currVal_6_0_0, throwOnChange, false);
        this._NgIf_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        var currVal_10_0_0 = false;
        this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0, throwOnChange, false);
        this._NgSwitchCase_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_3_3.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent5;
}(import1.AppView));
function viewFactory_ContentWritingsComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent6 = (function (_super) {
    __extends(_View_ContentWritingsComponent6, _super);
    function _View_ContentWritingsComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent6, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-xs-12 grid-nav'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'search-filters', new import4.InlineArray2(2, 'class', 'search-filters'), null);
        this._appEl_3 = new import3.AppElement(3, 0, this, this._el_3);
        var compView_3 = import39.viewFactory_SearchFilterComponent0(this.viewUtils, this.injector(3), this._appEl_3);
        this._SearchFilterComponent_3_4 = new import39.Wrapper_SearchFilterComponent(this.parent.parent.parentInjector.get(import11.UtilsService), this.parent.parent.parentInjector.get(import15.Router), this.parent.parent.parentInjector.get(import13.ActivatedRoute), this.parent.parent.parentInjector.get(import25.ElasticSearchService));
        this._appEl_3.initComponent(this._SearchFilterComponent_3_4.context, [], compView_3);
        this._text_4 = this.renderer.createText(null, '\n            ', null);
        compView_3.create(this._SearchFilterComponent_3_4.context, [], null);
        this._text_5 = this.renderer.createText(this._el_0, '\n\n          ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._text_5
        ], [], []);
        return null;
    };
    _View_ContentWritingsComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import40.SearchFilterComponent) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 4)))) {
            return this._SearchFilterComponent_3_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = this.parent.parent._SearchableContentsComponent_8_3.context.esQuery;
        this._SearchFilterComponent_3_4.check_esQuery(currVal_3_0_0, throwOnChange, false);
        var currVal_3_0_1 = this.parent.parent._SearchableContentsComponent_8_3.context.esFilters;
        this._SearchFilterComponent_3_4.check_esFilters(currVal_3_0_1, throwOnChange, false);
        var currVal_3_0_2 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.CATALOGUE.FILTERS)[this.parent.parent.context.currentLanguage];
        this._SearchFilterComponent_3_4.check_title(currVal_3_0_2, throwOnChange, false);
        var currVal_3_0_3 = ((this.parent.parent.context.intl.data == null) ? null : this.parent.parent.context.intl.data.COMMON.TAXONOMY);
        this._SearchFilterComponent_3_4.check_labels(currVal_3_0_3, throwOnChange, false);
        var currVal_3_0_4 = this.parent.parent.context.currentLanguage;
        this._SearchFilterComponent_3_4.check_language(currVal_3_0_4, throwOnChange, false);
        this._SearchFilterComponent_3_4.detectChangesInInputProps(this, this._el_3, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchFilterComponent_3_4.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent6;
}(import1.AppView));
function viewFactory_ContentWritingsComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent7 = (function (_super) {
    __extends(_View_ContentWritingsComponent7, _super);
    function _View_ContentWritingsComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent7, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n          ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_3 = new import3.AppElement(3, 0, this, this._anchor_3);
        this._TemplateRef_3_5 = new import23.TemplateRef_(this._appEl_3, viewFactory_ContentWritingsComponent8);
        this._NgFor_3_6 = new import41.Wrapper_NgFor(this._appEl_3.vcRef, this._TemplateRef_3_5, this.parent.parent.parentInjector.get(import35.IterableDiffers), this.parent.parent.ref);
        this._text_4 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n          ', null);
        this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_6 = new import3.AppElement(6, 0, this, this._anchor_6);
        this._TemplateRef_6_5 = new import23.TemplateRef_(this._appEl_6, viewFactory_ContentWritingsComponent11);
        this._NgSwitchCase_6_6 = new import20.Wrapper_NgSwitchCase(this._appEl_6.vcRef, this._TemplateRef_6_5, this.parent.parent._NgSwitch_10_3.context);
        this._text_7 = this.renderer.createText(this._el_0, '\n\n        ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._anchor_3,
            this._text_4,
            this._text_5,
            this._anchor_6,
            this._text_7
        ], [], []);
        return null;
    };
    _View_ContentWritingsComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import42.NgFor) && (3 === requestNodeIndex))) {
            return this._NgFor_3_6.context;
        }
        if (((token === import23.TemplateRef) && (6 === requestNodeIndex))) {
            return this._TemplateRef_6_5;
        }
        if (((token === import28.NgSwitchCase) && (6 === requestNodeIndex))) {
            return this._NgSwitchCase_6_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = this.parent.parent._SearchableContentsComponent_8_3.context.dbContents;
        this._NgFor_3_6.check_ngForOf(currVal_3_0_0, throwOnChange, false);
        this._NgFor_3_6.detectChangesInInputProps(this, this._anchor_3, throwOnChange);
        var currVal_6_0_0 = false;
        this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0, throwOnChange, false);
        this._NgSwitchCase_6_6.detectChangesInInputProps(this, this._anchor_6, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_ContentWritingsComponent7;
}(import1.AppView));
function viewFactory_ContentWritingsComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent8 = (function (_super) {
    __extends(_View_ContentWritingsComponent8, _super);
    function _View_ContentWritingsComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent8, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_27 = import7.UNINITIALIZED;
        this._expr_28 = import7.UNINITIALIZED;
        this._expr_30 = import7.UNINITIALIZED;
        this._expr_31 = import7.UNINITIALIZED;
        this._expr_32 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-md-12 writing-listing blog-listing blog-listing-classic'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n\n            ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'blog-details writing-details'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'blog-date'), null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_4, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_6 = this.renderer.createText(this._el_5, '', null);
        this._text_7 = this.renderer.createText(this._el_4, '', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_4, null);
        this._appEl_8 = new import3.AppElement(8, 4, this, this._anchor_8);
        this._TemplateRef_8_5 = new import23.TemplateRef_(this._appEl_8, viewFactory_ContentWritingsComponent9);
        this._NgFor_8_6 = new import41.Wrapper_NgFor(this._appEl_8.vcRef, this._TemplateRef_8_5, this.parent.parent.parent.parentInjector.get(import35.IterableDiffers), this.parent.parent.parent.ref);
        this._text_9 = this.renderer.createText(this._el_4, '\n                ', null);
        this._text_10 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'blog-title'), null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_11, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'writing-summary'), null);
        this._text_16 = this.renderer.createText(this._el_15, '', null);
        this._text_17 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'separator-line bg-black no-margin-lr margin-two'), null);
        this._text_19 = this.renderer.createText(this._el_2, '\n                ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'writing-read-more pointer highlight-button btn btn-small xs-no-margin-bottom'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_2, '\n            ', null);
        this._text_23 = this.renderer.createText(this._el_0, '\n            \n          ', null);
        var disposable_0 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this._pipe_date_1_0 = import4.pureProxy2(this.parent.parent.parent._pipe_date_1.transform.bind(this.parent.parent.parent._pipe_date_1));
        var disposable_1 = this.renderer.listen(this._el_12, 'click', this.eventHandler(this._handle_click_12_0.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_20, 'click', this.eventHandler(this._handle_click_20_0.bind(this)));
        this._pipe_intl_0_2 = import4.pureProxy2(this.parent.parent.parent._pipe_intl_0.transform.bind(this.parent.parent.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._text_23
        ], [
            disposable_0,
            disposable_1,
            disposable_2
        ], []);
        return null;
    };
    _View_ContentWritingsComponent8.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import42.NgFor) && (8 === requestNodeIndex))) {
            return this._NgFor_8_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_8_0_0 = this.context.$implicit.tags;
        this._NgFor_8_6.check_ngForOf(currVal_8_0_0, throwOnChange, false);
        this._NgFor_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_27 = import4.interpolate(1, '\n                  ', this.context.$implicit.author, '');
        if (import4.checkBinding(throwOnChange, this._expr_27, currVal_27)) {
            this.renderer.setText(this._text_6, currVal_27);
            this._expr_27 = currVal_27;
        }
        valUnwrapper.reset();
        var currVal_28 = import4.interpolate(1, ' | ', valUnwrapper.unwrap(import4.castByValue(this._pipe_date_1_0, this.parent.parent.parent._pipe_date_1.transform)(this.context.$implicit.date, 'yyyy')), ' | \n                  ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_7, currVal_28);
            this._expr_28 = currVal_28;
        }
        var currVal_30 = import4.interpolate(1, '\n                ', this.context.$implicit.title[this.parent.parent.parent.context.currentLanguage], '');
        if (import4.checkBinding(throwOnChange, this._expr_30, currVal_30)) {
            this.renderer.setText(this._text_13, currVal_30);
            this._expr_30 = currVal_30;
        }
        var currVal_31 = import4.interpolate(1, '', this.context.$implicit.summary[this.parent.parent.parent.context.currentLanguage], '');
        if (import4.checkBinding(throwOnChange, this._expr_31, currVal_31)) {
            this.renderer.setText(this._text_16, currVal_31);
            this._expr_31 = currVal_31;
        }
        valUnwrapper.reset();
        var currVal_32 = import4.interpolate(1, '\n                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2, this.parent.parent.parent._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.context.intl.data.WRITING.FULL_TEXT_GO), this.parent.parent.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_32, currVal_32))) {
            this.renderer.setText(this._text_21, currVal_32);
            this._expr_32 = currVal_32;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent8.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.parent.parent.context.utils.lLink(('writings?f=author~' + this.context.$implicit.author), this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_5_0);
    };
    _View_ContentWritingsComponent8.prototype._handle_click_12_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_12_0 = (this.parent.parent.parent.context.utils.lLink(('writing/' + this.context.$implicit.url), this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_12_0);
    };
    _View_ContentWritingsComponent8.prototype._handle_click_20_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_20_0 = (this.parent.parent.parent.context.utils.lLink(('writing/' + this.context.$implicit.url), this.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_20_0);
    };
    return _View_ContentWritingsComponent8;
}(import1.AppView));
function viewFactory_ContentWritingsComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent8(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent9 = (function (_super) {
    __extends(_View_ContentWritingsComponent9, _super);
    function _View_ContentWritingsComponent9(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent9, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_9 = import7.UNINITIALIZED;
    }
    _View_ContentWritingsComponent9.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_4 = new import3.AppElement(4, 0, this, this._anchor_4);
        this._TemplateRef_4_5 = new import23.TemplateRef_(this._appEl_4, viewFactory_ContentWritingsComponent10);
        this._NgIf_4_6 = new import18.Wrapper_NgIf(this._appEl_4.vcRef, this._TemplateRef_4_5);
        this._text_5 = this.renderer.createText(this._el_0, '\n                  ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._anchor_4,
            this._text_5
        ], [disposable_0], []);
        return null;
    };
    _View_ContentWritingsComponent9.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import23.TemplateRef) && (4 === requestNodeIndex))) {
            return this._TemplateRef_4_5;
        }
        if (((token === import27.NgIf) && (4 === requestNodeIndex))) {
            return this._NgIf_4_6.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent9.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_4_0_0 = ((this.context.index + 1) < this.parent.context.$implicit.tags.length);
        this._NgIf_4_6.check_ngIf(currVal_4_0_0, throwOnChange, false);
        this._NgIf_4_6.detectChangesInInputProps(this, this._anchor_4, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_9 = import4.interpolate(1, '\n                    ', (((this.parent.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.parent.context.intl.data.COMMON.TAXONOMY.tag.VALUES)[this.context.$implicit] ? ((this.parent.parent.parent.parent.context.intl.data == null) ? null : this.parent.parent.parent.parent.context.intl.data.COMMON.TAXONOMY.tag.VALUES)[this.context.$implicit][this.parent.parent.parent.parent.context.currentLanguage] : this.context.$implicit), '');
        if (import4.checkBinding(throwOnChange, this._expr_9, currVal_9)) {
            this.renderer.setText(this._text_3, currVal_9);
            this._expr_9 = currVal_9;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent9.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.parent.context.utils.lLink(('writings?f=tag~' + this.context.$implicit), this.parent.parent.parent.parent.context.currentLanguage) !== false);
        return (true && pd_2_0);
    };
    return _View_ContentWritingsComponent9;
}(import1.AppView));
function viewFactory_ContentWritingsComponent9(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent9(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent10 = (function (_super) {
    __extends(_View_ContentWritingsComponent10, _super);
    function _View_ContentWritingsComponent10(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent10, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent10.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, ', ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [], []);
        return null;
    };
    return _View_ContentWritingsComponent10;
}(import1.AppView));
function viewFactory_ContentWritingsComponent10(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent10(viewUtils, parentInjector, declarationEl);
}
var _View_ContentWritingsComponent11 = (function (_super) {
    __extends(_View_ContentWritingsComponent11, _super);
    function _View_ContentWritingsComponent11(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_ContentWritingsComponent11, renderType_ContentWritingsComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_ContentWritingsComponent11.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'pagination margin-two no-margin-bottom'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'ng-pagination', new import4.InlineArray16(10, 'first-text', '«', 'last-text', '»', 'next-text', '<img src=\'/data/images/arrow-next-small.png\'/>', 'previous-text', '<img src=\'/data/images/arrow-pre-small.png\'/>', 'style', 'cursor: pointer'), null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._el_2);
        var compView_2 = import43.viewFactory_PaginationComponent0(this.viewUtils, this.injector(2), this._appEl_2);
        this._PaginationComponent_2_4 = new import43.Wrapper_PaginationComponent();
        this._appEl_2.initComponent(this._PaginationComponent_2_4.context, [], compView_2);
        this._text_3 = this.renderer.createText(null, '\n                ', null);
        compView_2.create(this._PaginationComponent_2_4.context, [], null);
        this._text_4 = this.renderer.createText(this._el_0, '\n          ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'pageChange', this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        var subscription_0 = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_ContentWritingsComponent11.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import44.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._PaginationComponent_2_4.context;
        }
        return notFoundResult;
    };
    _View_ContentWritingsComponent11.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = '<img src=\'/data/images/arrow-pre-small.png\'/>';
        this._PaginationComponent_2_4.check_previousText(currVal_2_0_0, throwOnChange, false);
        var currVal_2_0_1 = '<img src=\'/data/images/arrow-next-small.png\'/>';
        this._PaginationComponent_2_4.check_nextText(currVal_2_0_1, throwOnChange, false);
        var currVal_2_0_2 = '«';
        this._PaginationComponent_2_4.check_firstText(currVal_2_0_2, throwOnChange, false);
        var currVal_2_0_3 = '»';
        this._PaginationComponent_2_4.check_lastText(currVal_2_0_3, throwOnChange, false);
        var currVal_2_0_4 = this.parent.parent.parent._SearchableContentsComponent_8_3.context.esContents['total'];
        this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4, throwOnChange, false);
        var currVal_2_0_5 = this.parent.parent.parent.context.currentPage;
        this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5, throwOnChange, false);
        var currVal_2_0_6 = this.parent.parent.parent.context.pageSize;
        this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6, throwOnChange, false);
        this._PaginationComponent_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._PaginationComponent_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_ContentWritingsComponent11.prototype._handle_pageChange_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.context.onPageChange($event, 'writings') !== false);
        return (true && pd_2_0);
    };
    return _View_ContentWritingsComponent11;
}(import1.AppView));
function viewFactory_ContentWritingsComponent11(viewUtils, parentInjector, declarationEl) {
    return new _View_ContentWritingsComponent11(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(229);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(17);
var import9 = __webpack_require__(5);
var import10 = __webpack_require__(2);
var import11 = __webpack_require__(77);
var import12 = __webpack_require__(18);
var import13 = __webpack_require__(11);
var import14 = __webpack_require__(10);
var import15 = __webpack_require__(22);
var import16 = __webpack_require__(50);
var import17 = __webpack_require__(14);
var import18 = __webpack_require__(19);
var import19 = __webpack_require__(31);
var Wrapper_CookieConsentComponent = (function () {
    function Wrapper_CookieConsentComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.CookieConsentComponent(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_CookieConsentComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_CookieConsentComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_CookieConsentComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_CookieConsentComponent;
}());
exports.Wrapper_CookieConsentComponent = Wrapper_CookieConsentComponent;
var renderType_CookieConsentComponent_Host = null;
var _View_CookieConsentComponent_Host0 = (function (_super) {
    __extends(_View_CookieConsentComponent_Host0, _super);
    function _View_CookieConsentComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CookieConsentComponent_Host0, renderType_CookieConsentComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_CookieConsentComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'policy-checker', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_CookieConsentComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._CookieConsentComponent_0_4 = new Wrapper_CookieConsentComponent(this.parentInjector.get(import8.IntlService), this.parentInjector.get(import9.ConfigService), this.parentInjector.get(import10.UtilsService), this.parentInjector.get(import11.CookieService), this.renderer, new import12.ElementRef(this._el_0));
        this._appEl_0.initComponent(this._CookieConsentComponent_0_4.context, [], compView_0);
        compView_0.create(this._CookieConsentComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_CookieConsentComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.CookieConsentComponent) && (0 === requestNodeIndex))) {
            return this._CookieConsentComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_CookieConsentComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._CookieConsentComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._CookieConsentComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._CookieConsentComponent_0_4.context.ngAfterViewInit();
            }
        }
    };
    return _View_CookieConsentComponent_Host0;
}(import3.AppView));
function viewFactory_CookieConsentComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CookieConsentComponent_Host === null)) {
        (renderType_CookieConsentComponent_Host = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, [], {}));
    }
    return new _View_CookieConsentComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.CookieConsentComponentNgFactory = new import14.ComponentFactory('policy-checker', viewFactory_CookieConsentComponent_Host0, import0.CookieConsentComponent);
var styles_CookieConsentComponent = [];
var renderType_CookieConsentComponent = null;
var _View_CookieConsentComponent0 = (function (_super) {
    __extends(_View_CookieConsentComponent0, _super);
    function _View_CookieConsentComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CookieConsentComponent0, renderType_CookieConsentComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_CookieConsentComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._anchor_0);
        this._TemplateRef_0_5 = new import17.TemplateRef_(this._appEl_0, viewFactory_CookieConsentComponent1);
        this._NgIf_0_6 = new import15.Wrapper_NgIf(this._appEl_0.vcRef, this._TemplateRef_0_5);
        this._pipe_intl_0 = new import16.IntlPipe();
        this.init([], [this._anchor_0], [], []);
        return null;
    };
    _View_CookieConsentComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (0 === requestNodeIndex))) {
            return this._TemplateRef_0_5;
        }
        if (((token === import18.NgIf) && (0 === requestNodeIndex))) {
            return this._NgIf_0_6.context;
        }
        return notFoundResult;
    };
    _View_CookieConsentComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = !this.context.hasConsented;
        this._NgIf_0_6.check_ngIf(currVal_0_0_0, throwOnChange, false);
        this._NgIf_0_6.detectChangesInInputProps(this, this._anchor_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_CookieConsentComponent0;
}(import3.AppView));
function viewFactory_CookieConsentComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_CookieConsentComponent === null)) {
        (renderType_CookieConsentComponent = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, styles_CookieConsentComponent, {}));
    }
    return new _View_CookieConsentComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_CookieConsentComponent0 = viewFactory_CookieConsentComponent0;
var _View_CookieConsentComponent1 = (function (_super) {
    __extends(_View_CookieConsentComponent1, _super);
    function _View_CookieConsentComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_CookieConsentComponent1, renderType_CookieConsentComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_21 = import1.UNINITIALIZED;
        this._expr_23 = import1.UNINITIALIZED;
        this._expr_24 = import1.UNINITIALIZED;
        this._expr_26 = import1.UNINITIALIZED;
        this._expr_28 = import1.UNINITIALIZED;
    }
    _View_CookieConsentComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray4(4, 'class', 'cookie-consent pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main', 'id', 'cookie-consent'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'h4', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_2, 'small', import2.EMPTY_INLINE_ARRAY, null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_4, 'a', new import2.InlineArray2(2, 'target', '_blank'), null);
        this._text_6 = this.renderer.createText(this._el_5, '', null);
        this._text_7 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_8 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_9 = import2.createRenderElement(this.renderer, this._el_0, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_10 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_11 = import2.createRenderElement(this.renderer, this._el_9, 'a', new import2.InlineArray2(2, 'class', 'pointer btn button'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_13 = import2.createRenderElement(this.renderer, this._el_11, 'small', import2.EMPTY_INLINE_ARRAY, null);
        this._text_14 = this.renderer.createText(this._el_13, '', null);
        this._text_15 = this.renderer.createText(this._el_11, '\n        ', null);
        this._text_16 = this.renderer.createText(this._el_9, ' \n        ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_9, 'a', new import2.InlineArray2(2, 'class', 'pointer highlight-button btn'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._text_19 = this.renderer.createText(this._el_9, '\n    ', null);
        this._text_20 = this.renderer.createText(this._el_0, '\n', null);
        this._pipe_intl_0_0 = import2.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_intl_0_1 = import2.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        var disposable_0 = this.renderer.listen(this._el_11, 'click', this.eventHandler(this._handle_click_11_0.bind(this)));
        this._pipe_intl_0_2 = import2.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        var disposable_1 = this.renderer.listen(this._el_17, 'click', this.eventHandler(this._handle_click_17_0.bind(this)));
        this._pipe_intl_0_3 = import2.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_CookieConsentComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_21 = import2.interpolate(1, '\n        ', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_0, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.COOKIE_CONSENT), this.parent.context.language)), '\n        ');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_21, currVal_21))) {
            this.renderer.setText(this._text_3, currVal_21);
            this._expr_21 = currVal_21;
        }
        var currVal_23 = import2.interpolate(1, '', ((this.parent.context.language == 'en') ? 'http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm' : 'https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs'), '');
        if (import2.checkBinding(throwOnChange, this._expr_23, currVal_23)) {
            this.renderer.setElementProperty(this._el_5, 'href', this.viewUtils.sanitizer.sanitize(import19.SecurityContext.URL, currVal_23));
            this._expr_23 = currVal_23;
        }
        valUnwrapper.reset();
        var currVal_24 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_1, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.LEARN_MORE), this.parent.context.language)), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_24, currVal_24))) {
            this.renderer.setText(this._text_6, currVal_24);
            this._expr_24 = currVal_24;
        }
        valUnwrapper.reset();
        var currVal_26 = import2.interpolate(1, '', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_2, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.COOKIE_CONSENT_DISMISS), this.parent.context.language)), '');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_26, currVal_26))) {
            this.renderer.setText(this._text_14, currVal_26);
            this._expr_26 = currVal_26;
        }
        valUnwrapper.reset();
        var currVal_28 = import2.interpolate(1, '\n            ', valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_3, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.COOKIE_CONSENT_ACCEPT), this.parent.context.language)), ' \n        ');
        if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange, this._expr_28, currVal_28))) {
            this.renderer.setText(this._text_18, currVal_28);
            this._expr_28 = currVal_28;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_CookieConsentComponent1.prototype._handle_click_11_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_11_0 = (this.parent.context.onConsent(false) !== false);
        return (true && pd_11_0);
    };
    _View_CookieConsentComponent1.prototype._handle_click_17_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_17_0 = (this.parent.context.onConsent(true) !== false);
        return (true && pd_17_0);
    };
    return _View_CookieConsentComponent1;
}(import3.AppView));
function viewFactory_CookieConsentComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_CookieConsentComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(171);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(25);
var import11 = __webpack_require__(9);
var import12 = __webpack_require__(2);
var import13 = __webpack_require__(18);
var import14 = __webpack_require__(16);
var import15 = __webpack_require__(15);
var import16 = __webpack_require__(11);
var import17 = __webpack_require__(10);
var import18 = __webpack_require__(56);
var import19 = __webpack_require__(178);
var import20 = __webpack_require__(303);
var import21 = __webpack_require__(24);
var import22 = __webpack_require__(22);
var import23 = __webpack_require__(50);
var import24 = __webpack_require__(98);
var import25 = __webpack_require__(30);
var import26 = __webpack_require__(29);
var import27 = __webpack_require__(14);
var import28 = __webpack_require__(20);
var import29 = __webpack_require__(39);
var import30 = __webpack_require__(97);
var import31 = __webpack_require__(21);
var import32 = __webpack_require__(168);
var import33 = __webpack_require__(19);
var import34 = __webpack_require__(65);
var import35 = __webpack_require__(44);
var import36 = __webpack_require__(31);
var import37 = __webpack_require__(302);
var import38 = __webpack_require__(166);
var Wrapper_HomeComponent = (function () {
    function Wrapper_HomeComponent(p0, p1, p2, p3, p4, p5, p6, p7) {
        this.changed = false;
        this.context = new import0.HomeComponent(p0, p1, p2, p3, p4, p5, p6, p7);
    }
    Wrapper_HomeComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_HomeComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_HomeComponent;
}());
exports.Wrapper_HomeComponent = Wrapper_HomeComponent;
var renderType_HomeComponent_Host = null;
var _View_HomeComponent_Host0 = (function (_super) {
    __extends(_View_HomeComponent_Host0, _super);
    function _View_HomeComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent_Host0, renderType_HomeComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_HomeComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_HomeComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._HomeComponent_0_4 = new Wrapper_HomeComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.IntlService), this.parentInjector.get(import10.MetaService), this.parentInjector.get(import11.ContentService), this.parentInjector.get(import12.UtilsService), new import13.ElementRef(this._el_0), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router));
        this._appEl_0.initComponent(this._HomeComponent_0_4.context, [], compView_0);
        compView_0.create(this._HomeComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_HomeComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.HomeComponent) && (0 === requestNodeIndex))) {
            return this._HomeComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_HomeComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._HomeComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            this._HomeComponent_0_4.context.ngAfterContentChecked();
        }
        this._HomeComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._HomeComponent_0_4.context.ngAfterViewInit();
            }
        }
    };
    return _View_HomeComponent_Host0;
}(import1.AppView));
function viewFactory_HomeComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_HomeComponent_Host === null)) {
        (renderType_HomeComponent_Host = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, [], {}));
    }
    return new _View_HomeComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.HomeComponentNgFactory = new import17.ComponentFactory('ng-component', viewFactory_HomeComponent_Host0, import0.HomeComponent);
var styles_HomeComponent = [];
var renderType_HomeComponent = null;
var _View_HomeComponent0 = (function (_super) {
    __extends(_View_HomeComponent0, _super);
    function _View_HomeComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent0, renderType_HomeComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_141 = import7.UNINITIALIZED;
        this._expr_144 = import7.UNINITIALIZED;
        this._expr_146 = import7.UNINITIALIZED;
        this._expr_148 = import7.UNINITIALIZED;
        this._expr_150 = import7.UNINITIALIZED;
        this._expr_153 = import7.UNINITIALIZED;
        this._expr_155 = import7.UNINITIALIZED;
        this._expr_157 = import7.UNINITIALIZED;
        this._expr_159 = import7.UNINITIALIZED;
        this._expr_161 = import7.UNINITIALIZED;
    }
    _View_HomeComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_1 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray8(6, 'class', 'fill full-screen', 'id', 'full-screen-home', 'style', 'background-image:url(\'/data/images/platine-v2-home-web-clean.jpg\'); position: relative'), null);
        this._text_2 = this.renderer.createText(this._el_1, '\n    ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_1, 'div', new import4.InlineArray2(2, 'class', 'opacity-super-light bg-dark-gray'), null);
        this._text_4 = this.renderer.createText(this._el_1, '\n    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_1, 'div', new import4.InlineArray2(2, 'class', 'slider-typography text-center'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n        ', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_5, 'div', new import4.InlineArray2(2, 'class', 'slider-text-middle-main pull-left'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n            ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_7, 'div', new import4.InlineArray2(2, 'class', 'row slider-home slider-text-middle padding-left-right-px'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                ', null);
        this._text_11 = this.renderer.createText(this._el_9, '\n                ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'text-center col-sm-5 col-lg-4'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                    ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'a', new import4.InlineArray2(2, 'class', 'highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five'), null);
        this._text_15 = this.renderer.createText(this._el_14, '', null);
        this._text_16 = this.renderer.createText(this._el_12, '\n                    ', null);
        this._el_17 = import4.createRenderElement(this.renderer, this._el_12, 'h1', new import4.InlineArray2(2, 'class', 'white-text font-weight-100 letter-spacing-2'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._el_19 = import4.createRenderElement(this.renderer, this._el_17, 'br', new import4.InlineArray2(2, 'class', 'xs-display-none'), null);
        this._text_20 = this.renderer.createText(this._el_17, '', null);
        this._text_21 = this.renderer.createText(this._el_12, '\n                ', null);
        this._text_22 = this.renderer.createText(this._el_9, '\n            ', null);
        this._text_23 = this.renderer.createText(this._el_7, '\n        ', null);
        this._text_24 = this.renderer.createText(this._el_5, '\n    ', null);
        this._text_25 = this.renderer.createText(this._el_1, '\n    ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_1, 'div', new import4.InlineArray2(2, 'class', 'scroll-down'), null);
        this._el_27 = import4.createRenderElement(this.renderer, this._el_26, 'a', new import4.InlineArray2(2, 'class', 'pointer inner-link'), null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_27, 'i', new import4.InlineArray2(2, 'class', 'fa fa-angle-down'), null);
        this._text_29 = this.renderer.createText(this._el_1, '\n', null);
        this._text_30 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_31 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_32 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'content-section wow fadeIn'), null);
        this._text_33 = this.renderer.createText(this._el_32, '\n    ', null);
        this._el_34 = import4.createRenderElement(this.renderer, this._el_32, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_35 = this.renderer.createText(this._el_34, '\n\n        ', null);
        this._el_36 = import4.createRenderElement(this.renderer, this._el_34, 'div', new import4.InlineArray8(8, 'class', 'row col-md-12', 'context', 'record', 'pageSize', '12', 'searchable-contents', ''), null);
        this._NgSwitch_36_3 = new import18.Wrapper_NgSwitch();
        this._SearchableContentsComponent_36_4 = new import19.Wrapper_SearchableContentsComponent(this.parentInjector.get(import11.ContentService), this.parentInjector.get(import25.SearchService), this.parentInjector.get(import12.UtilsService), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router), this.parentInjector.get(import26.ElasticSearchService));
        this._text_37 = this.renderer.createText(this._el_36, '\n            ', null);
        this._el_38 = import4.createRenderElement(this.renderer, this._el_36, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_39 = this.renderer.createText(this._el_38, '\n                ', null);
        this._el_40 = import4.createRenderElement(this.renderer, this._el_38, 'div', new import4.InlineArray2(2, 'class', 'col-md-12 text-center'), null);
        this._text_41 = this.renderer.createText(this._el_40, '\n                    ', null);
        this._el_42 = import4.createRenderElement(this.renderer, this._el_40, 'h3', new import4.InlineArray2(2, 'class', 'section-title section-title-services no-padding-bottom'), null);
        this._text_43 = this.renderer.createText(this._el_42, '', null);
        this._text_44 = this.renderer.createText(this._el_40, '\n                ', null);
        this._text_45 = this.renderer.createText(this._el_38, '\n\n                ', null);
        this._el_46 = import4.createRenderElement(this.renderer, this._el_38, 'div', new import4.InlineArray2(2, 'class', 'col-md-5 col-sm-11 margin-five center-col text-center'), null);
        this._text_47 = this.renderer.createText(this._el_46, '\n                    ', null);
        this._el_48 = import4.createRenderElement(this.renderer, this._el_46, 'h4', new import4.InlineArray2(2, 'class', 'gray-text'), null);
        this._text_49 = this.renderer.createText(this._el_48, '', null);
        this._text_50 = this.renderer.createText(this._el_46, '\n                ', null);
        this._text_51 = this.renderer.createText(this._el_38, '\n            ', null);
        this._text_52 = this.renderer.createText(this._el_36, '\n\n            ', null);
        this._text_53 = this.renderer.createText(this._el_36, '\n            ', null);
        this._anchor_54 = this.renderer.createTemplateAnchor(this._el_36, null);
        this._appEl_54 = new import3.AppElement(54, 36, this, this._anchor_54);
        this._TemplateRef_54_5 = new import27.TemplateRef_(this._appEl_54, viewFactory_HomeComponent1);
        this._NgSwitchCase_54_6 = new import18.Wrapper_NgSwitchCase(this._appEl_54.vcRef, this._TemplateRef_54_5, this._NgSwitch_36_3.context);
        this._text_55 = this.renderer.createText(this._el_36, '\n\n            ', null);
        this._anchor_56 = this.renderer.createTemplateAnchor(this._el_36, null);
        this._appEl_56 = new import3.AppElement(56, 36, this, this._anchor_56);
        this._TemplateRef_56_5 = new import27.TemplateRef_(this._appEl_56, viewFactory_HomeComponent2);
        this._NgSwitchCase_56_6 = new import18.Wrapper_NgSwitchCase(this._appEl_56.vcRef, this._TemplateRef_56_5, this._NgSwitch_36_3.context);
        this._text_57 = this.renderer.createText(this._el_36, '\n\n        ', null);
        this._text_58 = this.renderer.createText(this._el_34, '\n\n    ', null);
        this._text_59 = this.renderer.createText(this._el_32, '\n\n    ', null);
        this._el_60 = import4.createRenderElement(this.renderer, this._el_32, 'div', new import4.InlineArray2(2, 'class', 'learn-more row col-md-12 col-sm-12 center-col text-center'), null);
        this._text_61 = this.renderer.createText(this._el_60, '\n        ', null);
        this._el_62 = import4.createRenderElement(this.renderer, this._el_60, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-medium button xs-margin-bottom-five'), null);
        this._text_63 = this.renderer.createText(this._el_62, '', null);
        this._text_64 = this.renderer.createText(this._el_60, '\n    ', null);
        this._text_65 = this.renderer.createText(this._el_32, '\n', null);
        this._text_66 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_67 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_68 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray4(4, 'class', 'bg-gray wow fadeIn', 'content-specials', ''), null);
        this._ContentSpecialsComponent_68_3 = new import20.Wrapper_ContentSpecialsComponent(this.parentInjector.get(import11.ContentService), this.parentInjector.get(import12.UtilsService), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router), this.parentInjector.get(import26.ElasticSearchService));
        this._text_69 = this.renderer.createText(this._el_68, '\n    ', null);
        this._el_70 = import4.createRenderElement(this.renderer, this._el_68, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_71 = this.renderer.createText(this._el_70, '\n\n        ', null);
        this._el_72 = import4.createRenderElement(this.renderer, this._el_70, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_73 = this.renderer.createText(this._el_72, '\n            ', null);
        this._el_74 = import4.createRenderElement(this.renderer, this._el_72, 'div', new import4.InlineArray2(2, 'class', 'col-md-12 text-center'), null);
        this._text_75 = this.renderer.createText(this._el_74, '\n                ', null);
        this._el_76 = import4.createRenderElement(this.renderer, this._el_74, 'h3', new import4.InlineArray2(2, 'class', 'section-title section-title-services no-padding-bottom'), null);
        this._text_77 = this.renderer.createText(this._el_76, '', null);
        this._text_78 = this.renderer.createText(this._el_74, '\n            ', null);
        this._text_79 = this.renderer.createText(this._el_72, '\n\n            ', null);
        this._el_80 = import4.createRenderElement(this.renderer, this._el_72, 'div', new import4.InlineArray2(2, 'class', 'col-md-5 col-sm-11 margin-five center-col text-center'), null);
        this._text_81 = this.renderer.createText(this._el_80, '\n                ', null);
        this._el_82 = import4.createRenderElement(this.renderer, this._el_80, 'h4', new import4.InlineArray2(2, 'class', 'gray-text'), null);
        this._text_83 = this.renderer.createText(this._el_82, '', null);
        this._text_84 = this.renderer.createText(this._el_80, '\n            ', null);
        this._text_85 = this.renderer.createText(this._el_72, '\n        ', null);
        this._text_86 = this.renderer.createText(this._el_70, '\n\n        ', null);
        this._el_87 = import4.createRenderElement(this.renderer, this._el_70, 'div', new import4.InlineArray2(2, 'class', 'row margin-five no-margin-bottom'), null);
        this._text_88 = this.renderer.createText(this._el_87, '\n            ', null);
        this._text_89 = this.renderer.createText(this._el_87, '\n            ', null);
        this._anchor_90 = this.renderer.createTemplateAnchor(this._el_87, null);
        this._appEl_90 = new import3.AppElement(90, 87, this, this._anchor_90);
        this._TemplateRef_90_5 = new import27.TemplateRef_(this._appEl_90, viewFactory_HomeComponent4);
        this._NgFor_90_6 = new import21.Wrapper_NgFor(this._appEl_90.vcRef, this._TemplateRef_90_5, this.parentInjector.get(import28.IterableDiffers), this.ref);
        this._text_91 = this.renderer.createText(this._el_87, '\n            ', null);
        this._text_92 = this.renderer.createText(this._el_87, '\n        ', null);
        this._text_93 = this.renderer.createText(this._el_70, '\n    ', null);
        this._text_94 = this.renderer.createText(this._el_68, '\n\n    ', null);
        this._el_95 = import4.createRenderElement(this.renderer, this._el_68, 'div', new import4.InlineArray2(2, 'class', 'learn-more col-md-12 col-sm-12 center-col text-center'), null);
        this._text_96 = this.renderer.createText(this._el_95, '\n        ', null);
        this._el_97 = import4.createRenderElement(this.renderer, this._el_95, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-medium button xs-margin-bottom-five'), null);
        this._text_98 = this.renderer.createText(this._el_97, '', null);
        this._text_99 = this.renderer.createText(this._el_95, '\n    ', null);
        this._text_100 = this.renderer.createText(this._el_68, '\n\n', null);
        this._text_101 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_102 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._anchor_103 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_103 = new import3.AppElement(103, null, this, this._anchor_103);
        this._TemplateRef_103_5 = new import27.TemplateRef_(this._appEl_103, viewFactory_HomeComponent5);
        this._NgIf_103_6 = new import22.Wrapper_NgIf(this._appEl_103.vcRef, this._TemplateRef_103_5);
        this._text_104 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_105 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._anchor_106 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_106 = new import3.AppElement(106, null, this, this._anchor_106);
        this._TemplateRef_106_5 = new import27.TemplateRef_(this._appEl_106, viewFactory_HomeComponent7);
        this._NgIf_106_6 = new import22.Wrapper_NgIf(this._appEl_106.vcRef, this._TemplateRef_106_5);
        this._text_107 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_108 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray2(2, 'class', 'section-pull-up'), null);
        this._text_109 = this.renderer.createText(this._el_108, '\n    ', null);
        this._el_110 = import4.createRenderElement(this.renderer, this._el_108, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_111 = this.renderer.createText(this._el_110, '\n        ', null);
        this._el_112 = import4.createRenderElement(this.renderer, this._el_110, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_113 = this.renderer.createText(this._el_112, '\n            ', null);
        this._el_114 = import4.createRenderElement(this.renderer, this._el_112, 'div', new import4.InlineArray2(2, 'class', 'col-md-12 col-sm-12 center-col text-center margin-three'), null);
        this._text_115 = this.renderer.createText(this._el_114, '\n                ', null);
        this._el_116 = import4.createRenderElement(this.renderer, this._el_114, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-medium button xs-margin-bottom-five'), null);
        this._text_117 = this.renderer.createText(this._el_116, '', null);
        this._text_118 = this.renderer.createText(this._el_114, '\n            ', null);
        this._text_119 = this.renderer.createText(this._el_112, '\n        ', null);
        this._text_120 = this.renderer.createText(this._el_110, '\n    ', null);
        this._text_121 = this.renderer.createText(this._el_108, '\n\n', null);
        this._text_122 = this.renderer.createText(parentRenderNode, '\n\n\n', null);
        var disposable_0 = this.renderer.listen(this._el_14, 'click', this.eventHandler(this._handle_click_14_0.bind(this)));
        this._pipe_intl_0 = new import23.IntlPipe();
        this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_intl_0_2 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_1 = this.renderer.listen(this._el_27, 'click', this.eventHandler(this._handle_click_27_0.bind(this)));
        this._pipe_intl_0_3 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_intl_0_4 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_truncate_1 = new import24.TruncatePipe();
        var disposable_2 = this.renderer.listen(this._el_62, 'click', this.eventHandler(this._handle_click_62_0.bind(this)));
        this._pipe_intl_0_5 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_intl_0_6 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this._pipe_intl_0_7 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_3 = this.renderer.listen(this._el_97, 'click', this.eventHandler(this._handle_click_97_0.bind(this)));
        this._pipe_intl_0_9 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_4 = this.renderer.listen(this._el_116, 'click', this.eventHandler(this._handle_click_116_0.bind(this)));
        this._pipe_intl_0_13 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._el_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._el_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._el_46,
            this._text_47,
            this._el_48,
            this._text_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._text_53,
            this._anchor_54,
            this._text_55,
            this._anchor_56,
            this._text_57,
            this._text_58,
            this._text_59,
            this._el_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._text_64,
            this._text_65,
            this._text_66,
            this._text_67,
            this._el_68,
            this._text_69,
            this._el_70,
            this._text_71,
            this._el_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._el_76,
            this._text_77,
            this._text_78,
            this._text_79,
            this._el_80,
            this._text_81,
            this._el_82,
            this._text_83,
            this._text_84,
            this._text_85,
            this._text_86,
            this._el_87,
            this._text_88,
            this._text_89,
            this._anchor_90,
            this._text_91,
            this._text_92,
            this._text_93,
            this._text_94,
            this._el_95,
            this._text_96,
            this._el_97,
            this._text_98,
            this._text_99,
            this._text_100,
            this._text_101,
            this._text_102,
            this._anchor_103,
            this._text_104,
            this._text_105,
            this._anchor_106,
            this._text_107,
            this._el_108,
            this._text_109,
            this._el_110,
            this._text_111,
            this._el_112,
            this._text_113,
            this._el_114,
            this._text_115,
            this._el_116,
            this._text_117,
            this._text_118,
            this._text_119,
            this._text_120,
            this._text_121,
            this._text_122
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ], []);
        return null;
    };
    _View_HomeComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.TemplateRef) && (54 === requestNodeIndex))) {
            return this._TemplateRef_54_5;
        }
        if (((token === import29.NgSwitchCase) && (54 === requestNodeIndex))) {
            return this._NgSwitchCase_54_6.context;
        }
        if (((token === import27.TemplateRef) && (56 === requestNodeIndex))) {
            return this._TemplateRef_56_5;
        }
        if (((token === import29.NgSwitchCase) && (56 === requestNodeIndex))) {
            return this._NgSwitchCase_56_6.context;
        }
        if (((token === import29.NgSwitch) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 57)))) {
            return this._NgSwitch_36_3.context;
        }
        if (((token === import30.SearchableContentsComponent) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 57)))) {
            return this._SearchableContentsComponent_36_4.context;
        }
        if (((token === import27.TemplateRef) && (90 === requestNodeIndex))) {
            return this._TemplateRef_90_5;
        }
        if (((token === import31.NgFor) && (90 === requestNodeIndex))) {
            return this._NgFor_90_6.context;
        }
        if (((token === import32.ContentSpecialsComponent) && ((68 <= requestNodeIndex) && (requestNodeIndex <= 100)))) {
            return this._ContentSpecialsComponent_68_3.context;
        }
        if (((token === import27.TemplateRef) && (103 === requestNodeIndex))) {
            return this._TemplateRef_103_5;
        }
        if (((token === import33.NgIf) && (103 === requestNodeIndex))) {
            return this._NgIf_103_6.context;
        }
        if (((token === import27.TemplateRef) && (106 === requestNodeIndex))) {
            return this._TemplateRef_106_5;
        }
        if (((token === import33.NgIf) && (106 === requestNodeIndex))) {
            return this._NgIf_106_6.context;
        }
        return notFoundResult;
    };
    _View_HomeComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        var currVal_36_0_0 = this._SearchableContentsComponent_36_4.context.loading;
        this._NgSwitch_36_3.check_ngSwitch(currVal_36_0_0, throwOnChange, false);
        this._NgSwitch_36_3.detectChangesInInputProps(this, this._el_36, throwOnChange);
        var currVal_36_1_0 = 'record';
        this._SearchableContentsComponent_36_4.check_context(currVal_36_1_0, throwOnChange, false);
        var currVal_36_1_1 = '12';
        this._SearchableContentsComponent_36_4.check_pageSize(currVal_36_1_1, throwOnChange, false);
        var currVal_36_1_2 = true;
        this._SearchableContentsComponent_36_4.check_active(currVal_36_1_2, throwOnChange, false);
        this._SearchableContentsComponent_36_4.detectChangesInInputProps(this, this._el_36, throwOnChange);
        var currVal_54_0_0 = true;
        this._NgSwitchCase_54_6.check_ngSwitchCase(currVal_54_0_0, throwOnChange, false);
        this._NgSwitchCase_54_6.detectChangesInInputProps(this, this._anchor_54, throwOnChange);
        var currVal_56_0_0 = false;
        this._NgSwitchCase_56_6.check_ngSwitchCase(currVal_56_0_0, throwOnChange, false);
        this._NgSwitchCase_56_6.detectChangesInInputProps(this, this._anchor_56, throwOnChange);
        this._ContentSpecialsComponent_68_3.detectChangesInInputProps(this, this._el_68, throwOnChange);
        var currVal_90_0_0 = this._ContentSpecialsComponent_68_3.context.dbContentsLimited(4);
        this._NgFor_90_6.check_ngForOf(currVal_90_0_0, throwOnChange, false);
        this._NgFor_90_6.detectChangesInInputProps(this, this._anchor_90, throwOnChange);
        var currVal_103_0_0 = ((this.context.config.data == null) ? null : this.context.config.data.HOME.FEATURED);
        this._NgIf_103_6.check_ngIf(currVal_103_0_0, throwOnChange, false);
        this._NgIf_103_6.detectChangesInInputProps(this, this._anchor_103, throwOnChange);
        var currVal_106_0_0 = (this.context.about && this.context.currentLanguage);
        this._NgIf_106_6.check_ngIf(currVal_106_0_0, throwOnChange, false);
        this._NgIf_106_6.detectChangesInInputProps(this, this._anchor_106, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_141 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.LATEST_RELEASES_GO), this.context.currentLanguage)), '\n                    ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_141, currVal_141))) {
            this.renderer.setText(this._text_15, currVal_141);
            this._expr_141 = currVal_141;
        }
        valUnwrapper.reset();
        var currVal_144 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.HEADLINE_1), this.context.currentLanguage)), '\n                        ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_144, currVal_144))) {
            this.renderer.setText(this._text_18, currVal_144);
            this._expr_144 = currVal_144;
        }
        valUnwrapper.reset();
        var currVal_146 = import4.interpolate(1, ' ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.HEADLINE_2), this.context.currentLanguage)), '\n                    ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_146, currVal_146))) {
            this.renderer.setText(this._text_20, currVal_146);
            this._expr_146 = currVal_146;
        }
        this._NgSwitch_36_3.detectChangesInHostProps(this, this._el_36, throwOnChange);
        this._SearchableContentsComponent_36_4.detectChangesInHostProps(this, this._el_36, throwOnChange);
        valUnwrapper.reset();
        var currVal_148 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.LATEST_RELEASES), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_148, currVal_148))) {
            this.renderer.setText(this._text_43, currVal_148);
            this._expr_148 = currVal_148;
        }
        valUnwrapper.reset();
        var currVal_150 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.LATEST_RELEASES_SUB), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_150, currVal_150))) {
            this.renderer.setText(this._text_49, currVal_150);
            this._expr_150 = currVal_150;
        }
        valUnwrapper.reset();
        var currVal_153 = import4.interpolate(1, '\n            ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_5, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.CATALOGUE_GO), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_153, currVal_153))) {
            this.renderer.setText(this._text_63, currVal_153);
            this._expr_153 = currVal_153;
        }
        this._ContentSpecialsComponent_68_3.detectChangesInHostProps(this, this._el_68, throwOnChange);
        valUnwrapper.reset();
        var currVal_155 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_6, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.SPECIALS), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_155, currVal_155))) {
            this.renderer.setText(this._text_77, currVal_155);
            this._expr_155 = currVal_155;
        }
        valUnwrapper.reset();
        var currVal_157 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_7, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.SPECIALS_SUB), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_157, currVal_157))) {
            this.renderer.setText(this._text_83, currVal_157);
            this._expr_157 = currVal_157;
        }
        valUnwrapper.reset();
        var currVal_159 = import4.interpolate(1, '\n            ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_9, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.HOME.SPECIALS_GO), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_159, currVal_159))) {
            this.renderer.setText(this._text_98, currVal_159);
            this._expr_159 = currVal_159;
        }
        valUnwrapper.reset();
        var currVal_161 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_13, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.LEARN_MORE), this.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_161, currVal_161))) {
            this.renderer.setText(this._text_117, currVal_161);
            this._expr_161 = currVal_161;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_HomeComponent0.prototype._handle_click_14_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_14_0 = (this.context.utils.scroll(this._el_32, 20) !== false);
        return (true && pd_14_0);
    };
    _View_HomeComponent0.prototype._handle_click_27_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_27_0 = (this.context.utils.scroll(this._el_32, 20) !== false);
        return (true && pd_27_0);
    };
    _View_HomeComponent0.prototype._handle_click_62_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_62_0 = (this.context.utils.lLink('catalogue', this.context.currentLanguage) !== false);
        return (true && pd_62_0);
    };
    _View_HomeComponent0.prototype._handle_click_97_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_97_0 = (this.context.utils.lLink('catalogue/special', this.context.currentLanguage) !== false);
        return (true && pd_97_0);
    };
    _View_HomeComponent0.prototype._handle_click_116_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_116_0 = (this.context.utils.lLink('page/about', this.context.currentLanguage) !== false);
        return (true && pd_116_0);
    };
    return _View_HomeComponent0;
}(import1.AppView));
function viewFactory_HomeComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_HomeComponent === null)) {
        (renderType_HomeComponent = viewUtils.createRenderComponentType('', 0, import16.ViewEncapsulation.None, styles_HomeComponent, {}));
    }
    return new _View_HomeComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_HomeComponent0 = viewFactory_HomeComponent0;
var _View_HomeComponent1 = (function (_super) {
    __extends(_View_HomeComponent1, _super);
    function _View_HomeComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent1, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_HomeComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', import4.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'loading-indicator', new import4.InlineArray2(2, 'color', '#B6B6B6'), null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._el_2);
        var compView_2 = import34.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(2), this._appEl_2);
        this._LoadingIndicator_2_4 = new import34.Wrapper_LoadingIndicator();
        this._appEl_2.initComponent(this._LoadingIndicator_2_4.context, [], compView_2);
        compView_2.create(this._LoadingIndicator_2_4.context, [], null);
        this._text_3 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_HomeComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import35.LoadingIndicator) && (2 === requestNodeIndex))) {
            return this._LoadingIndicator_2_4.context;
        }
        return notFoundResult;
    };
    _View_HomeComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = '#B6B6B6';
        this._LoadingIndicator_2_4.check_color(currVal_2_0_0, throwOnChange, false);
        this._LoadingIndicator_2_4.detectChangesInInputProps(this, this._el_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_2_4.detectChangesInHostProps(this, this._el_2, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_HomeComponent1;
}(import1.AppView));
function viewFactory_HomeComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent2 = (function (_super) {
    __extends(_View_HomeComponent2, _super);
    function _View_HomeComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent2, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_HomeComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'record-listing-home'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import3.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import27.TemplateRef_(this._appEl_2, viewFactory_HomeComponent3);
        this._NgFor_2_6 = new import21.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parent.parentInjector.get(import28.IterableDiffers), this.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [], []);
        return null;
    };
    _View_HomeComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import31.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        return notFoundResult;
    };
    _View_HomeComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parent._SearchableContentsComponent_36_4.context.dbContentsLimited(8);
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_HomeComponent2;
}(import1.AppView));
function viewFactory_HomeComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent3 = (function (_super) {
    __extends(_View_HomeComponent3, _super);
    function _View_HomeComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent3, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_14 = import7.UNINITIALIZED;
        this._expr_15 = import7.UNINITIALIZED;
    }
    _View_HomeComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'record-item col-md-3 col-xs-6'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', ''), null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_3, 'img', new import4.InlineArray2(2, 'alt', ''), null);
        this._text_5 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'record-desc'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                        ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'div', new import4.InlineArray2(2, 'class', 'catalogue-record-title gray-text text-uppercase letter-spacing-1'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                                ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_8, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_6, '\n                    ', null);
        this._text_13 = this.renderer.createText(this._el_0, '\n                ', null);
        var disposable_0 = this.renderer.listen(this._el_3, 'click', this.eventHandler(this._handle_click_3_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_10, 'click', this.eventHandler(this._handle_click_10_0.bind(this)));
        this._pipe_truncate_1_0 = import4.pureProxy2(this.parent.parent._pipe_truncate_1.transform.bind(this.parent.parent._pipe_truncate_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._el_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._text_13
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_HomeComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_14 = import4.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.cover.front, '');
        if (import4.checkBinding(throwOnChange, this._expr_14, currVal_14)) {
            this.renderer.setElementProperty(this._el_4, 'src', this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL, currVal_14));
            this._expr_14 = currVal_14;
        }
        valUnwrapper.reset();
        var currVal_15 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_0, this.parent.parent._pipe_truncate_1.transform)(this.context.$implicit.title, ((this.parent.parent.context.config.data == null) ? null : this.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_15, currVal_15))) {
            this.renderer.setText(this._text_11, currVal_15);
            this._expr_15 = currVal_15;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_HomeComponent3.prototype._handle_click_3_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_3_0 = (this.parent.parent.context.router.navigate([this.context.$implicit.url], { relativeTo: this.parent.parent.context.route.parent }) !== false);
        return (true && pd_3_0);
    };
    _View_HomeComponent3.prototype._handle_click_10_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_10_0 = (this.parent.parent.context.router.navigate([this.context.$implicit.url], { relativeTo: this.parent.parent.context.route.parent }) !== false);
        return (true && pd_10_0);
    };
    return _View_HomeComponent3;
}(import1.AppView));
function viewFactory_HomeComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent4 = (function (_super) {
    __extends(_View_HomeComponent4, _super);
    function _View_HomeComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent4, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_34 = import7.UNINITIALIZED;
        this._expr_35 = import7.UNINITIALIZED;
        this._expr_36 = import7.UNINITIALIZED;
        this._expr_37 = import7.UNINITIALIZED;
        this._expr_39 = import7.UNINITIALIZED;
    }
    _View_HomeComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'col-md-6 col-sm-6 xs-margin-bottom-ten'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'model-details clearfix xs-no-margin'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'text-center col-md-6 no-padding'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                        ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'img', new import4.InlineArray4(4, 'alt', '', 'class', 'pointer'), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                    ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray2(2, 'class', 'col-md-6 no-padding'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n                        ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'special-text model-details-text'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_13 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'separator-line bg-black no-margin-lr margin-ten'), null);
        this._text_14 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_15 = import4.createRenderElement(this.renderer, this._el_11, 'span', new import4.InlineArray2(2, 'class', 'display-block clearfix xs-no-margin sm-display-none'), null);
        this._text_16 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_17 = import4.createRenderElement(this.renderer, this._el_11, 'span', new import4.InlineArray2(2, 'class', 'text-uppercase font-weight-600 black-text letter-spacing-2'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._text_19 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_20 = import4.createRenderElement(this.renderer, this._el_11, 'span', new import4.InlineArray2(2, 'class', 'text-uppercase text-small letter-spacing-2 margin-two display-block'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_23 = import4.createRenderElement(this.renderer, this._el_11, 'p', new import4.InlineArray2(2, 'class', 'margin-ten xs-no-margin'), null);
        this._text_24 = this.renderer.createText(this._el_23, '', null);
        this._text_25 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_26 = import4.createRenderElement(this.renderer, this._el_11, 'span', new import4.InlineArray2(2, 'class', 'margin-five xs-no-margin display-block clearfix xs-no-margin'), null);
        this._text_27 = this.renderer.createText(this._el_11, '\n                            ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_11, 'a', new import4.InlineArray2(2, 'class', 'bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer'), null);
        this._text_29 = this.renderer.createText(this._el_28, '', null);
        this._text_30 = this.renderer.createText(this._el_11, '\n                        ', null);
        this._text_31 = this.renderer.createText(this._el_9, '\n                    ', null);
        this._text_32 = this.renderer.createText(this._el_2, '\n                ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_6, 'click', this.eventHandler(this._handle_click_6_0.bind(this)));
        this._pipe_truncate_1_1 = import4.pureProxy2(this.parent._pipe_truncate_1.transform.bind(this.parent._pipe_truncate_1));
        var disposable_1 = this.renderer.listen(this._el_28, 'click', this.eventHandler(this._handle_click_28_0.bind(this)));
        this._pipe_intl_0_8 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_HomeComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_34 = import4.interpolate(1, '', this.context.$implicit.image, '');
        if (import4.checkBinding(throwOnChange, this._expr_34, currVal_34)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL, currVal_34));
            this._expr_34 = currVal_34;
        }
        var currVal_35 = import4.interpolate(1, '', this.context.$implicit.title[this.parent.context.currentLanguage], '');
        if (import4.checkBinding(throwOnChange, this._expr_35, currVal_35)) {
            this.renderer.setText(this._text_18, currVal_35);
            this._expr_35 = currVal_35;
        }
        var currVal_36 = import4.interpolate(1, '', this.context.$implicit.subtitle[this.parent.context.currentLanguage], '');
        if (import4.checkBinding(throwOnChange, this._expr_36, currVal_36)) {
            this.renderer.setText(this._text_21, currVal_36);
            this._expr_36 = currVal_36;
        }
        valUnwrapper.reset();
        var currVal_37 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_1, this.parent._pipe_truncate_1.transform)(this.context.$implicit.content[this.parent.context.currentLanguage], ((this.parent.context.config.data == null) ? null : this.parent.context.config.data.SPECIAL.TITLE_TRUNCATE))), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_37, currVal_37))) {
            this.renderer.setText(this._text_24, currVal_37);
            this._expr_37 = currVal_37;
        }
        valUnwrapper.reset();
        var currVal_39 = import4.interpolate(1, '\n                            ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_8, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.SEE_MORE), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_39, currVal_39))) {
            this.renderer.setText(this._text_29, currVal_39);
            this._expr_39 = currVal_39;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_HomeComponent4.prototype._handle_click_6_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_6_0 = (this.parent.context.utils.lLink(this.context.$implicit.url, this.parent.context.currentLanguage) !== false);
        return (true && pd_6_0);
    };
    _View_HomeComponent4.prototype._handle_click_28_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_28_0 = (this.parent.context.utils.lLink(this.context.$implicit.url, this.parent.context.currentLanguage) !== false);
        return (true && pd_28_0);
    };
    return _View_HomeComponent4;
}(import1.AppView));
function viewFactory_HomeComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent5 = (function (_super) {
    __extends(_View_HomeComponent5, _super);
    function _View_HomeComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent5, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_38 = import7.UNINITIALIZED;
        this._expr_40 = import7.UNINITIALIZED;
        this._expr_42 = import7.UNINITIALIZED;
    }
    _View_HomeComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'section', new import4.InlineArray2(2, 'class', 'bg-gray content-section wow fadeIn '), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n\n        ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'div', new import4.InlineArray4(4, 'class', 'row col-md-12 ', 'content-records-featured', ''), null);
        this._ContentRecordsFeaturedComponent_4_3 = new import37.Wrapper_ContentRecordsFeaturedComponent(this.parentInjector.get(import11.ContentService), this.parentInjector.get(import12.UtilsService), this.parentInjector.get(import14.ActivatedRoute), this.parentInjector.get(import15.Router), this.parentInjector.get(import26.ElasticSearchService));
        this._text_5 = this.renderer.createText(this._el_4, '\n\n            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                ', null);
        this._el_8 = import4.createRenderElement(this.renderer, this._el_6, 'div', new import4.InlineArray2(2, 'class', 'col-md-12 text-center'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                    ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_8, 'h3', new import4.InlineArray2(2, 'class', 'section-title section-title-services no-padding-bottom'), null);
        this._text_11 = this.renderer.createText(this._el_10, '', null);
        this._text_12 = this.renderer.createText(this._el_8, '\n                ', null);
        this._text_13 = this.renderer.createText(this._el_6, '\n\n                ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_6, 'div', new import4.InlineArray2(2, 'class', 'col-md-5 col-sm-11 margin-five center-col text-center'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n                    ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_14, 'h4', new import4.InlineArray2(2, 'class', 'gray-text'), null);
        this._text_17 = this.renderer.createText(this._el_16, '', null);
        this._text_18 = this.renderer.createText(this._el_14, '\n                ', null);
        this._text_19 = this.renderer.createText(this._el_6, '\n            ', null);
        this._text_20 = this.renderer.createText(this._el_4, '\n\n\n            ', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'record-listing'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n                ', null);
        this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21, null);
        this._appEl_23 = new import3.AppElement(23, 21, this, this._anchor_23);
        this._TemplateRef_23_5 = new import27.TemplateRef_(this._appEl_23, viewFactory_HomeComponent6);
        this._NgFor_23_6 = new import21.Wrapper_NgFor(this._appEl_23.vcRef, this._TemplateRef_23_5, this.parentInjector.get(import28.IterableDiffers), this.parent.ref);
        this._text_24 = this.renderer.createText(this._el_21, '\n            ', null);
        this._text_25 = this.renderer.createText(this._el_4, '\n\n        ', null);
        this._text_26 = this.renderer.createText(this._el_2, '\n\n    ', null);
        this._text_27 = this.renderer.createText(this._el_0, '\n\n    ', null);
        this._el_28 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'learn-more row col-md-12 col-sm-12 center-col text-center'), null);
        this._text_29 = this.renderer.createText(this._el_28, '\n        ', null);
        this._el_30 = import4.createRenderElement(this.renderer, this._el_28, 'a', new import4.InlineArray2(2, 'class', 'pointer highlight-button btn btn-medium button xs-margin-bottom-five'), null);
        this._text_31 = this.renderer.createText(this._el_30, '', null);
        this._text_32 = this.renderer.createText(this._el_28, '\n    ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n', null);
        this._pipe_intl_0_10 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_intl_0_11 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        var disposable_0 = this.renderer.listen(this._el_30, 'click', this.eventHandler(this._handle_click_30_0.bind(this)));
        this._pipe_intl_0_12 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._anchor_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._text_27,
            this._el_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._text_33
        ], [disposable_0], []);
        return null;
    };
    _View_HomeComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.TemplateRef) && (23 === requestNodeIndex))) {
            return this._TemplateRef_23_5;
        }
        if (((token === import31.NgFor) && (23 === requestNodeIndex))) {
            return this._NgFor_23_6.context;
        }
        if (((token === import38.ContentRecordsFeaturedComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 25)))) {
            return this._ContentRecordsFeaturedComponent_4_3.context;
        }
        return notFoundResult;
    };
    _View_HomeComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._ContentRecordsFeaturedComponent_4_3.detectChangesInInputProps(this, this._el_4, throwOnChange);
        var currVal_23_0_0 = this._ContentRecordsFeaturedComponent_4_3.context.dbContentsLimited(4);
        this._NgFor_23_6.check_ngForOf(currVal_23_0_0, throwOnChange, false);
        this._NgFor_23_6.detectChangesInInputProps(this, this._anchor_23, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._ContentRecordsFeaturedComponent_4_3.detectChangesInHostProps(this, this._el_4, throwOnChange);
        valUnwrapper.reset();
        var currVal_38 = import4.interpolate(1, '\n                        ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_10, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.HOME.FEATURED), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_38, currVal_38))) {
            this.renderer.setText(this._text_11, currVal_38);
            this._expr_38 = currVal_38;
        }
        valUnwrapper.reset();
        var currVal_40 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_11, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.HOME.FEATURED_SUB), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_40, currVal_40))) {
            this.renderer.setText(this._text_17, currVal_40);
            this._expr_40 = currVal_40;
        }
        valUnwrapper.reset();
        var currVal_42 = import4.interpolate(1, '\n                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_12, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.HOME.CATALOGUE_GO), this.parent.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_42, currVal_42))) {
            this.renderer.setText(this._text_31, currVal_42);
            this._expr_42 = currVal_42;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_HomeComponent5.prototype._handle_click_30_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_30_0 = (this.parent.context.utils.lLink('catalogue', this.parent.context.currentLanguage) !== false);
        return (true && pd_30_0);
    };
    return _View_HomeComponent5;
}(import1.AppView));
function viewFactory_HomeComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent6 = (function (_super) {
    __extends(_View_HomeComponent6, _super);
    function _View_HomeComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent6, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_18 = import7.UNINITIALIZED;
        this._expr_19 = import7.UNINITIALIZED;
    }
    _View_HomeComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'record-item col-md-3 col-xs-6'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', ''), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                        ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_2, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                            ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'img', new import4.InlineArray2(2, 'alt', ''), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                        ', null);
        this._text_8 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._text_9 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_10 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'record-desc'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n                        ', null);
        this._el_12 = import4.createRenderElement(this.renderer, this._el_10, 'div', new import4.InlineArray2(2, 'class', 'catalogue-record-title gray-text text-uppercase letter-spacing-1'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                                ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_12, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_15 = this.renderer.createText(this._el_14, '', null);
        this._text_16 = this.renderer.createText(this._el_10, '\n                    ', null);
        this._text_17 = this.renderer.createText(this._el_0, '\n                ', null);
        var disposable_0 = this.renderer.listen(this._el_4, 'click', this.eventHandler(this._handle_click_4_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_14, 'click', this.eventHandler(this._handle_click_14_0.bind(this)));
        this._pipe_truncate_1_2 = import4.pureProxy2(this.parent.parent._pipe_truncate_1.transform.bind(this.parent.parent._pipe_truncate_1));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._text_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._text_17
        ], [
            disposable_0,
            disposable_1
        ], []);
        return null;
    };
    _View_HomeComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_18 = import4.interpolate(1, '/data/covers/thumbs/', this.context.$implicit.cover.front, '');
        if (import4.checkBinding(throwOnChange, this._expr_18, currVal_18)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL, currVal_18));
            this._expr_18 = currVal_18;
        }
        valUnwrapper.reset();
        var currVal_19 = import4.interpolate(1, '\n                                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_2, this.parent.parent._pipe_truncate_1.transform)(this.context.$implicit.title, '80')), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_19, currVal_19))) {
            this.renderer.setText(this._text_15, currVal_19);
            this._expr_19 = currVal_19;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_HomeComponent6.prototype._handle_click_4_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_4_0 = (this.parent.parent.context.router.navigate([this.context.$implicit.url], { relativeTo: this.parent.parent.context.route.parent }) !== false);
        return (true && pd_4_0);
    };
    _View_HomeComponent6.prototype._handle_click_14_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_14_0 = (this.parent.parent.context.router.navigate([this.context.$implicit.url], { relativeTo: this.parent.parent.context.route.parent }) !== false);
        return (true && pd_14_0);
    };
    return _View_HomeComponent6;
}(import1.AppView));
function viewFactory_HomeComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_HomeComponent7 = (function (_super) {
    __extends(_View_HomeComponent7, _super);
    function _View_HomeComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_HomeComponent7, renderType_HomeComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_1 = import7.UNINITIALIZED;
    }
    _View_HomeComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', import4.EMPTY_INLINE_ARRAY, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_HomeComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_1 = this.parent.context.about.summary[this.parent.context.currentLanguage];
        if (import4.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            this.renderer.setElementProperty(this._el_0, 'innerHTML', this.viewUtils.sanitizer.sanitize(import36.SecurityContext.HTML, currVal_1));
            this._expr_1 = currVal_1;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_HomeComponent7;
}(import1.AppView));
function viewFactory_HomeComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_HomeComponent7(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(172);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(2);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(15);
var import12 = __webpack_require__(16);
var import13 = __webpack_require__(11);
var import14 = __webpack_require__(10);
var import15 = __webpack_require__(22);
var import16 = __webpack_require__(50);
var import17 = __webpack_require__(14);
var import18 = __webpack_require__(19);
var Wrapper_PageNotFoundComponent = (function () {
    function Wrapper_PageNotFoundComponent(p0, p1, p2, p3, p4) {
        this.changed = false;
        this.context = new import0.PageNotFoundComponent(p0, p1, p2, p3, p4);
    }
    Wrapper_PageNotFoundComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_PageNotFoundComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_PageNotFoundComponent;
}());
exports.Wrapper_PageNotFoundComponent = Wrapper_PageNotFoundComponent;
var renderType_PageNotFoundComponent_Host = null;
var _View_PageNotFoundComponent_Host0 = (function (_super) {
    __extends(_View_PageNotFoundComponent_Host0, _super);
    function _View_PageNotFoundComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PageNotFoundComponent_Host0, renderType_PageNotFoundComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_PageNotFoundComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_PageNotFoundComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._PageNotFoundComponent_0_4 = new Wrapper_PageNotFoundComponent(this.parentInjector.get(import8.UtilsService), this.parentInjector.get(import9.IntlService), this.parentInjector.get(import10.ConfigService), this.parentInjector.get(import11.Router), this.parentInjector.get(import12.ActivatedRoute));
        this._appEl_0.initComponent(this._PageNotFoundComponent_0_4.context, [], compView_0);
        compView_0.create(this._PageNotFoundComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_PageNotFoundComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.PageNotFoundComponent) && (0 === requestNodeIndex))) {
            return this._PageNotFoundComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_PageNotFoundComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._PageNotFoundComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._PageNotFoundComponent_0_4.context.ngAfterContentInit();
            }
            this._PageNotFoundComponent_0_4.context.ngAfterContentChecked();
        }
        this._PageNotFoundComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PageNotFoundComponent_Host0;
}(import1.AppView));
function viewFactory_PageNotFoundComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PageNotFoundComponent_Host === null)) {
        (renderType_PageNotFoundComponent_Host = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, [], {}));
    }
    return new _View_PageNotFoundComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.PageNotFoundComponentNgFactory = new import14.ComponentFactory('ng-component', viewFactory_PageNotFoundComponent_Host0, import0.PageNotFoundComponent);
var styles_PageNotFoundComponent = [];
var renderType_PageNotFoundComponent = null;
var _View_PageNotFoundComponent0 = (function (_super) {
    __extends(_View_PageNotFoundComponent0, _super);
    function _View_PageNotFoundComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PageNotFoundComponent0, renderType_PageNotFoundComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_PageNotFoundComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import4.createRenderElement(this.renderer, parentRenderNode, 'section', new import4.InlineArray8(6, 'class', 'fill full-screen', 'id', 'full-screen-home', 'style', 'background-image:url(\'/data/images/platine-v2-home-web-clean.jpg\'); position: relative'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'opacity-light bg-dark-gray'), null);
        this._text_3 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_4 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', 'slider-typography text-center'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n        ', null);
        this._el_6 = import4.createRenderElement(this.renderer, this._el_4, 'div', new import4.InlineArray2(2, 'class', 'slider-text-middle-main pull-left'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n            ', null);
        this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6, null);
        this._appEl_8 = new import3.AppElement(8, 6, this, this._anchor_8);
        this._TemplateRef_8_5 = new import17.TemplateRef_(this._appEl_8, viewFactory_PageNotFoundComponent1);
        this._NgIf_8_6 = new import15.Wrapper_NgIf(this._appEl_8.vcRef, this._TemplateRef_8_5);
        this._text_9 = this.renderer.createText(this._el_6, '\n        ', null);
        this._text_10 = this.renderer.createText(this._el_4, '\n    ', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n', null);
        this._pipe_intl_0 = new import16.IntlPipe();
        this.init([], [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._anchor_8,
            this._text_9,
            this._text_10,
            this._text_11
        ], [], []);
        return null;
    };
    _View_PageNotFoundComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import17.TemplateRef) && (8 === requestNodeIndex))) {
            return this._TemplateRef_8_5;
        }
        if (((token === import18.NgIf) && (8 === requestNodeIndex))) {
            return this._NgIf_8_6.context;
        }
        return notFoundResult;
    };
    _View_PageNotFoundComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_8_0_0 = this.context.currentLanguage;
        this._NgIf_8_6.check_ngIf(currVal_8_0_0, throwOnChange, false);
        this._NgIf_8_6.detectChangesInInputProps(this, this._anchor_8, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PageNotFoundComponent0;
}(import1.AppView));
function viewFactory_PageNotFoundComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PageNotFoundComponent === null)) {
        (renderType_PageNotFoundComponent = viewUtils.createRenderComponentType('', 0, import13.ViewEncapsulation.None, styles_PageNotFoundComponent, {}));
    }
    return new _View_PageNotFoundComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_PageNotFoundComponent0 = viewFactory_PageNotFoundComponent0;
var _View_PageNotFoundComponent1 = (function (_super) {
    __extends(_View_PageNotFoundComponent1, _super);
    function _View_PageNotFoundComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PageNotFoundComponent1, renderType_PageNotFoundComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_12 = import7.UNINITIALIZED;
        this._expr_14 = import7.UNINITIALIZED;
    }
    _View_PageNotFoundComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'div', new import4.InlineArray2(2, 'class', 'slider-home slider-text-middle padding-left-right-px'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._text_2 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_3 = import4.createRenderElement(this.renderer, this._el_0, 'div', new import4.InlineArray2(2, 'class', ''), null);
        this._text_4 = this.renderer.createText(this._el_3, '\n                    ', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_3, 'a', new import4.InlineArray2(2, 'class', 'highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five'), null);
        this._text_6 = this.renderer.createText(this._el_5, '', null);
        this._text_7 = this.renderer.createText(this._el_3, '\n                ', null);
        this._text_8 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_0, 'h1', new import4.InlineArray2(2, 'class', 'white-text font-weight-100 letter-spacing-2'), null);
        this._text_10 = this.renderer.createText(this._el_9, '', null);
        this._text_11 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_5, 'click', this.eventHandler(this._handle_click_5_0.bind(this)));
        this._pipe_intl_0_0 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this._pipe_intl_0_1 = import4.pureProxy2(this.parent._pipe_intl_0.transform.bind(this.parent._pipe_intl_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11
        ], [disposable_0], []);
        return null;
    };
    _View_PageNotFoundComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this.detectContentChildrenChanges(throwOnChange);
        valUnwrapper.reset();
        var currVal_12 = import4.interpolate(1, '\n                    ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.HOME.CATALOGUE_GO), this.parent.context.currentLanguage)), '\n                    ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_12, currVal_12))) {
            this.renderer.setText(this._text_6, currVal_12);
            this._expr_12 = currVal_12;
        }
        valUnwrapper.reset();
        var currVal_14 = import4.interpolate(1, '\n                ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this.parent._pipe_intl_0.transform)(((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.PAGE_NOT_FOUND.TITLE), this.parent.context.currentLanguage)), '\n                ');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_14, currVal_14))) {
            this.renderer.setText(this._text_10, currVal_14);
            this._expr_14 = currVal_14;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_PageNotFoundComponent1.prototype._handle_click_5_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_5_0 = (this.parent.context.utils.lLink('catalogue', this.parent.context.currentLanguage) !== false);
        return (true && pd_5_0);
    };
    return _View_PageNotFoundComponent1;
}(import1.AppView));
function viewFactory_PageNotFoundComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_PageNotFoundComponent1(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(230);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(49);
var import9 = __webpack_require__(2);
var import10 = __webpack_require__(5);
var import11 = __webpack_require__(11);
var import12 = __webpack_require__(10);
var Wrapper_PaymentPayPalExpressCheckoutComponent = (function () {
    function Wrapper_PaymentPayPalExpressCheckoutComponent(p0, p1, p2) {
        this.changed = false;
        this.context = new import0.PaymentPayPalExpressCheckoutComponent(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_PaymentPayPalExpressCheckoutComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_PaymentPayPalExpressCheckoutComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_PaymentPayPalExpressCheckoutComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_PaymentPayPalExpressCheckoutComponent;
}());
exports.Wrapper_PaymentPayPalExpressCheckoutComponent = Wrapper_PaymentPayPalExpressCheckoutComponent;
var renderType_PaymentPayPalExpressCheckoutComponent_Host = null;
var _View_PaymentPayPalExpressCheckoutComponent_Host0 = (function (_super) {
    __extends(_View_PaymentPayPalExpressCheckoutComponent_Host0, _super);
    function _View_PaymentPayPalExpressCheckoutComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaymentPayPalExpressCheckoutComponent_Host0, renderType_PaymentPayPalExpressCheckoutComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_PaymentPayPalExpressCheckoutComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'payment-paypal-express-checkout', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_PaymentPayPalExpressCheckoutComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._PaymentPayPalExpressCheckoutComponent_0_4 = new Wrapper_PaymentPayPalExpressCheckoutComponent(this.parentInjector.get(import8.CartService), this.parentInjector.get(import9.UtilsService), this.parentInjector.get(import10.ConfigService));
        this._appEl_0.initComponent(this._PaymentPayPalExpressCheckoutComponent_0_4.context, [], compView_0);
        compView_0.create(this._PaymentPayPalExpressCheckoutComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_PaymentPayPalExpressCheckoutComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.PaymentPayPalExpressCheckoutComponent) && (0 === requestNodeIndex))) {
            return this._PaymentPayPalExpressCheckoutComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_PaymentPayPalExpressCheckoutComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._PaymentPayPalExpressCheckoutComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._PaymentPayPalExpressCheckoutComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_PaymentPayPalExpressCheckoutComponent_Host0;
}(import3.AppView));
function viewFactory_PaymentPayPalExpressCheckoutComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PaymentPayPalExpressCheckoutComponent_Host === null)) {
        (renderType_PaymentPayPalExpressCheckoutComponent_Host = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, [], {}));
    }
    return new _View_PaymentPayPalExpressCheckoutComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.PaymentPayPalExpressCheckoutComponentNgFactory = new import12.ComponentFactory('payment-paypal-express-checkout', viewFactory_PaymentPayPalExpressCheckoutComponent_Host0, import0.PaymentPayPalExpressCheckoutComponent);
var styles_PaymentPayPalExpressCheckoutComponent = [];
var renderType_PaymentPayPalExpressCheckoutComponent = null;
var _View_PaymentPayPalExpressCheckoutComponent0 = (function (_super) {
    __extends(_View_PaymentPayPalExpressCheckoutComponent0, _super);
    function _View_PaymentPayPalExpressCheckoutComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_PaymentPayPalExpressCheckoutComponent0, renderType_PaymentPayPalExpressCheckoutComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_PaymentPayPalExpressCheckoutComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._el_0 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', new import2.InlineArray4(4, 'class', 'text-right', 'id', 'paypal-button-container'), null);
        this.init([], [this._el_0], [], []);
        return null;
    };
    return _View_PaymentPayPalExpressCheckoutComponent0;
}(import3.AppView));
function viewFactory_PaymentPayPalExpressCheckoutComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_PaymentPayPalExpressCheckoutComponent === null)) {
        (renderType_PaymentPayPalExpressCheckoutComponent = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, styles_PaymentPayPalExpressCheckoutComponent, {}));
    }
    return new _View_PaymentPayPalExpressCheckoutComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_PaymentPayPalExpressCheckoutComponent0 = viewFactory_PaymentPayPalExpressCheckoutComponent0;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(173);
var import1 = __webpack_require__(12);
var import3 = __webpack_require__(7);
var import4 = __webpack_require__(3);
var import6 = __webpack_require__(6);
var import7 = __webpack_require__(4);
var import8 = __webpack_require__(5);
var import9 = __webpack_require__(17);
var import10 = __webpack_require__(77);
var import11 = __webpack_require__(49);
var import12 = __webpack_require__(32);
var import13 = __webpack_require__(16);
var import14 = __webpack_require__(15);
var import15 = __webpack_require__(18);
var import16 = __webpack_require__(2);
var import17 = __webpack_require__(11);
var import18 = __webpack_require__(10);
var import19 = __webpack_require__(309);
var import20 = __webpack_require__(446);
var import21 = __webpack_require__(22);
var import22 = __webpack_require__(45);
var import23 = __webpack_require__(439);
var import24 = __webpack_require__(24);
var import25 = __webpack_require__(78);
var import26 = __webpack_require__(219);
var import27 = __webpack_require__(50);
var import28 = __webpack_require__(14);
var import29 = __webpack_require__(20);
var import30 = __webpack_require__(40);
var import31 = __webpack_require__(75);
var import32 = __webpack_require__(83);
var import33 = __webpack_require__(229);
var import34 = __webpack_require__(19);
var import35 = __webpack_require__(228);
var import36 = __webpack_require__(21);
var import37 = __webpack_require__(57);
var import38 = __webpack_require__(93);
var import39 = __webpack_require__(117);
var import40 = __webpack_require__(65);
var import41 = __webpack_require__(44);
var import42 = __webpack_require__(310);
var import43 = __webpack_require__(175);
var Wrapper_FrontRootComponent = (function () {
    function Wrapper_FrontRootComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
        this.changed = false;
        this.context = new import0.FrontRootComponent(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
    }
    Wrapper_FrontRootComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_FrontRootComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_FrontRootComponent;
}());
exports.Wrapper_FrontRootComponent = Wrapper_FrontRootComponent;
var renderType_FrontRootComponent_Host = null;
var _View_FrontRootComponent_Host0 = (function (_super) {
    __extends(_View_FrontRootComponent_Host0, _super);
    function _View_FrontRootComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_FrontRootComponent_Host0, renderType_FrontRootComponent_Host, import6.ViewType.HOST, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_FrontRootComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import4.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_FrontRootComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._FrontRootComponent_0_4 = new Wrapper_FrontRootComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import9.IntlService), this.parentInjector.get(import10.CookieService), this.parentInjector.get(import11.CartService), this.parentInjector.get(import12.Location), this.parentInjector.get(import13.ActivatedRoute), this.parentInjector.get(import14.Router), new import15.ElementRef(this._el_0), this.renderer, this.parentInjector.get(import16.UtilsService));
        this._appEl_0.initComponent(this._FrontRootComponent_0_4.context, [], compView_0);
        compView_0.create(this._FrontRootComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_FrontRootComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.FrontRootComponent) && (0 === requestNodeIndex))) {
            return this._FrontRootComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_FrontRootComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._FrontRootComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._FrontRootComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._FrontRootComponent_0_4.context.ngAfterViewInit();
            }
        }
    };
    return _View_FrontRootComponent_Host0;
}(import1.AppView));
function viewFactory_FrontRootComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_FrontRootComponent_Host === null)) {
        (renderType_FrontRootComponent_Host = viewUtils.createRenderComponentType('', 0, import17.ViewEncapsulation.None, [], {}));
    }
    return new _View_FrontRootComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.FrontRootComponentNgFactory = new import18.ComponentFactory('ng-component', viewFactory_FrontRootComponent_Host0, import0.FrontRootComponent);
var styles_FrontRootComponent = [];
var renderType_FrontRootComponent = null;
var _View_FrontRootComponent0 = (function (_super) {
    __extends(_View_FrontRootComponent0, _super);
    function _View_FrontRootComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_FrontRootComponent0, renderType_FrontRootComponent, import6.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_225 = import7.UNINITIALIZED;
        this._map_228 = import4.pureProxy1(function (p0) {
            return { current: p0 };
        });
        this._expr_229 = import7.UNINITIALIZED;
        this._map_231 = import4.pureProxy1(function (p0) {
            return { current: p0 };
        });
        this._expr_232 = import7.UNINITIALIZED;
        this._map_234 = import4.pureProxy1(function (p0) {
            return { current: p0 };
        });
        this._expr_235 = import7.UNINITIALIZED;
        this._expr_237 = import7.UNINITIALIZED;
        this._expr_238 = import7.UNINITIALIZED;
    }
    _View_FrontRootComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._text_1 = this.renderer.createText(parentRenderNode, '\n', null);
        this._text_2 = this.renderer.createText(parentRenderNode, '\n\n', null);
        this._el_3 = import4.createRenderElement(this.renderer, parentRenderNode, 'span', new import4.InlineArray2(2, 'lg-routing', ''), null);
        this._LanguageRoutingComponent_3_3 = new import19.Wrapper_LanguageRoutingComponent(this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import12.Location), this.parentInjector.get(import14.Router), this.parentInjector.get(import16.UtilsService), this.parentInjector.get(import10.CookieService));
        this._text_4 = this.renderer.createText(this._el_3, '\n\n', null);
        this._el_5 = import4.createRenderElement(this.renderer, this._el_3, 'policy-checker', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_5 = new import3.AppElement(5, 3, this, this._el_5);
        var compView_5 = import20.viewFactory_CookieConsentComponent0(this.viewUtils, this.injector(5), this._appEl_5);
        this._CookieConsentComponent_5_4 = new import20.Wrapper_CookieConsentComponent(this.parentInjector.get(import9.IntlService), this.parentInjector.get(import8.ConfigService), this.parentInjector.get(import16.UtilsService), this.parentInjector.get(import10.CookieService), this.renderer, new import15.ElementRef(this._el_5));
        this._appEl_5.initComponent(this._CookieConsentComponent_5_4.context, [], compView_5);
        compView_5.create(this._CookieConsentComponent_5_4.context, [], null);
        this._text_6 = this.renderer.createText(this._el_3, '\n\n', null);
        this._el_7 = import4.createRenderElement(this.renderer, this._el_3, 'nav', new import4.InlineArray4(4, 'class', 'navbar navbar-default navbar-fixed-top nav-transparent overlay-nav sticky-nav nav-white nav-border-bottom', 'role', 'navigation'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n    ', null);
        this._el_9 = import4.createRenderElement(this.renderer, this._el_7, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_10 = this.renderer.createText(this._el_9, '\n        ', null);
        this._el_11 = import4.createRenderElement(this.renderer, this._el_9, 'div', new import4.InlineArray2(2, 'class', 'row'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_13 = this.renderer.createText(this._el_11, '   \n            ', null);
        this._el_14 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'col-md-1 pull-left'), null);
        this._text_15 = this.renderer.createText(this._el_14, '\n                ', null);
        this._el_16 = import4.createRenderElement(this.renderer, this._el_14, 'a', new import4.InlineArray2(2, 'class', 'pointer logo-light text-small font-weight-600 text-uppercase white-text letter-spacing-7'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n                    ', null);
        this._el_18 = import4.createRenderElement(this.renderer, this._el_16, 'span', new import4.InlineArray2(2, 'class', 'logo-first-letter'), null);
        this._text_19 = this.renderer.createText(this._el_18, 'F', null);
        this._text_20 = this.renderer.createText(this._el_16, 'orgotten', null);
        this._el_21 = import4.createRenderElement(this.renderer, this._el_16, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_22 = this.renderer.createText(this._el_16, ' Records\n                    ', null);
        this._text_23 = this.renderer.createText(this._el_16, '\n                ', null);
        this._text_24 = this.renderer.createText(this._el_14, '\n                ', null);
        this._el_25 = import4.createRenderElement(this.renderer, this._el_14, 'a', new import4.InlineArray2(2, 'class', 'logo-dark text-small font-weight-600 text-uppercase black-text letter-spacing-7'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                    ', null);
        this._el_27 = import4.createRenderElement(this.renderer, this._el_25, 'span', new import4.InlineArray2(2, 'class', 'logo-first-letter'), null);
        this._text_28 = this.renderer.createText(this._el_27, 'F', null);
        this._text_29 = this.renderer.createText(this._el_25, 'orgotten', null);
        this._el_30 = import4.createRenderElement(this.renderer, this._el_25, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_31 = this.renderer.createText(this._el_25, ' Records\n                    ', null);
        this._text_32 = this.renderer.createText(this._el_25, '\n                ', null);
        this._text_33 = this.renderer.createText(this._el_14, '\n                ', null);
        this._anchor_34 = this.renderer.createTemplateAnchor(this._el_14, null);
        this._appEl_34 = new import3.AppElement(34, 14, this, this._anchor_34);
        this._TemplateRef_34_5 = new import28.TemplateRef_(this._appEl_34, viewFactory_FrontRootComponent1);
        this._NgIf_34_6 = new import21.Wrapper_NgIf(this._appEl_34.vcRef, this._TemplateRef_34_5);
        this._text_35 = this.renderer.createText(this._el_14, '\n            ', null);
        this._text_36 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_37 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_38 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_39 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'col-md-3 no-padding-left search-cart-header pull-right'), null);
        this._text_40 = this.renderer.createText(this._el_39, '\n                ', null);
        this._el_41 = import4.createRenderElement(this.renderer, this._el_39, 'div', new import4.InlineArray2(2, 'id', 'top-search'), null);
        this._text_42 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._text_43 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._text_44 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._text_45 = this.renderer.createText(this._el_41, '\n                    ', null);
        this._el_46 = import4.createRenderElement(this.renderer, this._el_41, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._el_47 = import4.createRenderElement(this.renderer, this._el_46, 'i', new import4.InlineArray2(2, 'class', 'fa fa-search search-button'), null);
        this._text_48 = this.renderer.createText(this._el_41, '\n                ', null);
        this._text_49 = this.renderer.createText(this._el_39, '\n                ', null);
        this._text_50 = this.renderer.createText(this._el_39, '\n                ', null);
        this._text_51 = this.renderer.createText(this._el_39, '\n\n                ', null);
        this._text_52 = this.renderer.createText(this._el_39, '\n                ', null);
        this._el_53 = import4.createRenderElement(this.renderer, this._el_39, 'cart-widget', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_53 = new import3.AppElement(53, 39, this, this._el_53);
        var compView_53 = import23.viewFactory_CartWidgetComponent0(this.viewUtils, this.injector(53), this._appEl_53);
        this._NotificationService_53_4 = new import22.NotificationService(new import15.ElementRef(this._el_53), this.renderer);
        this._CartWidgetComponent_53_5 = new import23.Wrapper_CartWidgetComponent(this._NotificationService_53_4, this.parentInjector.get(import9.IntlService), this.parentInjector.get(import16.UtilsService), this.parentInjector.get(import11.CartService), this.parentInjector.get(import13.ActivatedRoute), this.parentInjector.get(import14.Router));
        this._appEl_53.initComponent(this._CartWidgetComponent_53_5.context, [], compView_53);
        this._text_54 = this.renderer.createText(null, '\n                ', null);
        compView_53.create(this._CartWidgetComponent_53_5.context, [], null);
        this._text_55 = this.renderer.createText(this._el_39, '\n\n                ', null);
        this._el_56 = import4.createRenderElement(this.renderer, this._el_39, 'div', new import4.InlineArray2(2, 'class', 'language-selector pull-right'), null);
        this._text_57 = this.renderer.createText(this._el_56, '\n                    ', null);
        this._el_58 = import4.createRenderElement(this.renderer, this._el_56, 'div', new import4.InlineArray2(2, 'class', 'logo-light'), null);
        this._text_59 = this.renderer.createText(this._el_58, '\n                        ', null);
        this._anchor_60 = this.renderer.createTemplateAnchor(this._el_58, null);
        this._appEl_60 = new import3.AppElement(60, 58, this, this._anchor_60);
        this._TemplateRef_60_5 = new import28.TemplateRef_(this._appEl_60, viewFactory_FrontRootComponent2);
        this._NgFor_60_6 = new import24.Wrapper_NgFor(this._appEl_60.vcRef, this._TemplateRef_60_5, this.parentInjector.get(import29.IterableDiffers), this.ref);
        this._text_61 = this.renderer.createText(this._el_58, '\n                    ', null);
        this._text_62 = this.renderer.createText(this._el_56, '\n                    ', null);
        this._el_63 = import4.createRenderElement(this.renderer, this._el_56, 'div', new import4.InlineArray2(2, 'class', 'logo-dark'), null);
        this._text_64 = this.renderer.createText(this._el_63, '\n                        ', null);
        this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63, null);
        this._appEl_65 = new import3.AppElement(65, 63, this, this._anchor_65);
        this._TemplateRef_65_5 = new import28.TemplateRef_(this._appEl_65, viewFactory_FrontRootComponent3);
        this._NgFor_65_6 = new import24.Wrapper_NgFor(this._appEl_65.vcRef, this._TemplateRef_65_5, this.parentInjector.get(import29.IterableDiffers), this.ref);
        this._text_66 = this.renderer.createText(this._el_63, '\n                    ', null);
        this._text_67 = this.renderer.createText(this._el_56, '\n                ', null);
        this._text_68 = this.renderer.createText(this._el_39, '\n\n            ', null);
        this._text_69 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_70 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_71 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_72 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'navbar-header col-xs-2 pull-right'), null);
        this._text_73 = this.renderer.createText(this._el_72, '\n                ', null);
        this._el_74 = import4.createRenderElement(this.renderer, this._el_72, 'button', new import4.InlineArray16(10, 'class', 'navbar-toggle', 'data-target', '.navbar-collapse', 'data-toggle', 'collapse', 'id', 'accordion-menu', 'type', 'button'), null);
        this._text_75 = this.renderer.createText(this._el_74, ' ', null);
        this._el_76 = import4.createRenderElement(this.renderer, this._el_74, 'span', new import4.InlineArray2(2, 'class', 'sr-only'), null);
        this._text_77 = this.renderer.createText(this._el_76, 'Toggle navigation', null);
        this._text_78 = this.renderer.createText(this._el_74, ' ', null);
        this._el_79 = import4.createRenderElement(this.renderer, this._el_74, 'span', new import4.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_80 = this.renderer.createText(this._el_74, ' ', null);
        this._el_81 = import4.createRenderElement(this.renderer, this._el_74, 'span', new import4.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_82 = this.renderer.createText(this._el_74, ' ', null);
        this._el_83 = import4.createRenderElement(this.renderer, this._el_74, 'span', new import4.InlineArray2(2, 'class', 'icon-bar'), null);
        this._text_84 = this.renderer.createText(this._el_74, ' ', null);
        this._text_85 = this.renderer.createText(this._el_72, '\n            ', null);
        this._text_86 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_87 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_88 = this.renderer.createText(this._el_11, '\n            ', null);
        this._el_89 = import4.createRenderElement(this.renderer, this._el_11, 'div', new import4.InlineArray2(2, 'class', 'col-md-8 no-padding-right accordion-menu text-right'), null);
        this._text_90 = this.renderer.createText(this._el_89, '\n                ', null);
        this._el_91 = import4.createRenderElement(this.renderer, this._el_89, 'div', new import4.InlineArray2(2, 'class', 'navbar-collapse collapse'), null);
        this._text_92 = this.renderer.createText(this._el_91, '\n                    ', null);
        this._el_93 = import4.createRenderElement(this.renderer, this._el_91, 'ul', new import4.InlineArray4(4, 'class', 'nav navbar-nav navbar-right panel-group', 'id', 'accordion'), null);
        this._text_94 = this.renderer.createText(this._el_93, '\n                        \n                        ', null);
        this._el_95 = import4.createRenderElement(this.renderer, this._el_93, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._text_96 = this.renderer.createText(this._el_95, '\n                            ', null);
        this._el_97 = import4.createRenderElement(this.renderer, this._el_95, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_98 = this.renderer.createText(this._el_97, '', null);
        this._text_99 = this.renderer.createText(this._el_95, '\n                        ', null);
        this._text_100 = this.renderer.createText(this._el_93, '\n\n                        ', null);
        this._text_101 = this.renderer.createText(this._el_93, '\n                        ', null);
        this._el_102 = import4.createRenderElement(this.renderer, this._el_93, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._NgClass_102_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers), this.parentInjector.get(import30.KeyValueDiffers), new import15.ElementRef(this._el_102), this.renderer);
        this._text_103 = this.renderer.createText(this._el_102, '\n                            ', null);
        this._el_104 = import4.createRenderElement(this.renderer, this._el_102, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_105 = this.renderer.createText(this._el_104, '', null);
        this._text_106 = this.renderer.createText(this._el_102, ' \n                            ', null);
        this._text_107 = this.renderer.createText(this._el_102, '\n                        ', null);
        this._text_108 = this.renderer.createText(this._el_93, '\n                        \n                        ', null);
        this._el_109 = import4.createRenderElement(this.renderer, this._el_93, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._NgClass_109_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers), this.parentInjector.get(import30.KeyValueDiffers), new import15.ElementRef(this._el_109), this.renderer);
        this._text_110 = this.renderer.createText(this._el_109, '\n                            ', null);
        this._el_111 = import4.createRenderElement(this.renderer, this._el_109, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_112 = this.renderer.createText(this._el_111, '', null);
        this._text_113 = this.renderer.createText(this._el_109, '                             \n                        ', null);
        this._text_114 = this.renderer.createText(this._el_93, '\n\n                        ', null);
        this._el_115 = import4.createRenderElement(this.renderer, this._el_93, 'li', import4.EMPTY_INLINE_ARRAY, null);
        this._NgClass_115_3 = new import25.Wrapper_NgClass(this.parentInjector.get(import29.IterableDiffers), this.parentInjector.get(import30.KeyValueDiffers), new import15.ElementRef(this._el_115), this.renderer);
        this._text_116 = this.renderer.createText(this._el_115, '\n                            ', null);
        this._el_117 = import4.createRenderElement(this.renderer, this._el_115, 'a', new import4.InlineArray2(2, 'class', 'pointer'), null);
        this._text_118 = this.renderer.createText(this._el_117, '', null);
        this._text_119 = this.renderer.createText(this._el_115, '                            \n                        ', null);
        this._text_120 = this.renderer.createText(this._el_93, '\n                        \n                    ', null);
        this._text_121 = this.renderer.createText(this._el_91, '\n                ', null);
        this._text_122 = this.renderer.createText(this._el_89, '\n            ', null);
        this._text_123 = this.renderer.createText(this._el_11, '\n            ', null);
        this._text_124 = this.renderer.createText(this._el_11, '\n        ', null);
        this._text_125 = this.renderer.createText(this._el_9, '\n    ', null);
        this._text_126 = this.renderer.createText(this._el_7, '\n', null);
        this._text_127 = this.renderer.createText(this._el_3, '\n', null);
        this._text_128 = this.renderer.createText(this._el_3, '\n\n', null);
        this._el_129 = import4.createRenderElement(this.renderer, this._el_3, 'router-outlet', import4.EMPTY_INLINE_ARRAY, null);
        this._appEl_129 = new import3.AppElement(129, 3, this, this._el_129);
        this._RouterOutlet_129_5 = new import26.Wrapper_RouterOutlet(this.parentInjector.get(import31.RouterOutletMap), this._appEl_129.vcRef, this.parentInjector.get(import32.ComponentFactoryResolver), null);
        this._text_130 = this.renderer.createText(this._el_3, '\n\n', null);
        this._text_131 = this.renderer.createText(this._el_3, '\n', null);
        this._el_132 = import4.createRenderElement(this.renderer, this._el_3, 'footer', import4.EMPTY_INLINE_ARRAY, null);
        this._text_133 = this.renderer.createText(this._el_132, '\n    ', null);
        this._el_134 = import4.createRenderElement(this.renderer, this._el_132, 'div', new import4.InlineArray2(2, 'class', 'bg-gray footer-top'), null);
        this._text_135 = this.renderer.createText(this._el_134, '\n        ', null);
        this._el_136 = import4.createRenderElement(this.renderer, this._el_134, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_137 = this.renderer.createText(this._el_136, '\n            ', null);
        this._el_138 = import4.createRenderElement(this.renderer, this._el_136, 'div', new import4.InlineArray2(2, 'class', 'row margin-four center-col text-center'), null);
        this._text_139 = this.renderer.createText(this._el_138, '\n\n                ', null);
        this._el_140 = import4.createRenderElement(this.renderer, this._el_138, 'div', new import4.InlineArray2(2, 'class', 'col-sm-4 text-center'), null);
        this._el_141 = import4.createRenderElement(this.renderer, this._el_140, 'i', new import4.InlineArray2(2, 'class', 'fa fa-facebook small-icon black-text'), null);
        this._text_142 = this.renderer.createText(this._el_140, '\n                    ', null);
        this._el_143 = import4.createRenderElement(this.renderer, this._el_140, 'h6', new import4.InlineArray2(2, 'class', 'margin-two no-margin-bottom'), null);
        this._el_144 = import4.createRenderElement(this.renderer, this._el_143, 'a', new import4.InlineArray8(6, 'class', 'black-text', 'href', 'http://facebook.com/forgottenrecords', 'target', '_blank'), null);
        this._text_145 = this.renderer.createText(this._el_144, 'fb.com/forgottenrecords', null);
        this._text_146 = this.renderer.createText(this._el_140, '\n                ', null);
        this._text_147 = this.renderer.createText(this._el_138, '\n\n                ', null);
        this._el_148 = import4.createRenderElement(this.renderer, this._el_138, 'div', new import4.InlineArray2(2, 'class', 'col-sm-4 text-center'), null);
        this._el_149 = import4.createRenderElement(this.renderer, this._el_148, 'i', new import4.InlineArray2(2, 'class', 'icon-envelope small-icon black-text'), null);
        this._text_150 = this.renderer.createText(this._el_148, '\n                    ', null);
        this._el_151 = import4.createRenderElement(this.renderer, this._el_148, 'h6', new import4.InlineArray2(2, 'class', 'margin-two no-margin-bottom contact'), null);
        this._el_152 = import4.createRenderElement(this.renderer, this._el_151, 'a', new import4.InlineArray4(4, 'class', 'black-text', 'href', 'mailto:contact@forgottenrecords.com'), null);
        this._text_153 = this.renderer.createText(this._el_152, 'contact@forgottenrecords.com', null);
        this._text_154 = this.renderer.createText(this._el_148, '\n                ', null);
        this._text_155 = this.renderer.createText(this._el_138, '\n\n                ', null);
        this._el_156 = import4.createRenderElement(this.renderer, this._el_138, 'div', new import4.InlineArray2(2, 'class', 'col-sm-4 text-center'), null);
        this._el_157 = import4.createRenderElement(this.renderer, this._el_156, 'i', new import4.InlineArray2(2, 'class', 'fa fa-instagram small-icon black-text'), null);
        this._text_158 = this.renderer.createText(this._el_156, '\n                    ', null);
        this._el_159 = import4.createRenderElement(this.renderer, this._el_156, 'h6', new import4.InlineArray2(2, 'class', 'black-text margin-two no-margin-bottom'), null);
        this._el_160 = import4.createRenderElement(this.renderer, this._el_159, 'a', new import4.InlineArray8(6, 'class', 'black-text', 'href', 'http://instagram.com/forgottenrecords', 'target', '_blank'), null);
        this._text_161 = this.renderer.createText(this._el_160, 'instagr.am/forgottenrecords', null);
        this._text_162 = this.renderer.createText(this._el_156, '\n                ', null);
        this._text_163 = this.renderer.createText(this._el_138, '\n            ', null);
        this._text_164 = this.renderer.createText(this._el_136, ' \n        ', null);
        this._text_165 = this.renderer.createText(this._el_134, '\n    ', null);
        this._text_166 = this.renderer.createText(this._el_132, '\n\n    ', null);
        this._el_167 = import4.createRenderElement(this.renderer, this._el_132, 'div', new import4.InlineArray2(2, 'class', 'container-fluid bg-dark-gray footer-bottom'), null);
        this._text_168 = this.renderer.createText(this._el_167, '\n        ', null);
        this._el_169 = import4.createRenderElement(this.renderer, this._el_167, 'div', new import4.InlineArray2(2, 'class', 'container'), null);
        this._text_170 = this.renderer.createText(this._el_169, '\n            ', null);
        this._el_171 = import4.createRenderElement(this.renderer, this._el_169, 'div', new import4.InlineArray2(2, 'class', 'row margin-three'), null);
        this._text_172 = this.renderer.createText(this._el_171, '\n                ', null);
        this._text_173 = this.renderer.createText(this._el_171, '\n                ', null);
        this._el_174 = import4.createRenderElement(this.renderer, this._el_171, 'div', new import4.InlineArray2(2, 'class', 'col-lg-8 col-sm-6 copyright text-left letter-spacing-1 xs-text-center xs-margin-bottom-one'), null);
        this._text_175 = this.renderer.createText(this._el_174, '', null);
        this._text_176 = this.renderer.createText(this._el_171, '\n                ', null);
        this._text_177 = this.renderer.createText(this._el_171, '\n                ', null);
        this._text_178 = this.renderer.createText(this._el_171, '\n                ', null);
        this._el_179 = import4.createRenderElement(this.renderer, this._el_171, 'div', new import4.InlineArray2(2, 'class', 'col-lg-4 col-sm-6 footer-logo deep-light-gray-text'), null);
        this._text_180 = this.renderer.createText(this._el_179, '\n                    4 allée du Clos Pilet, 35700 Rennes, France', null);
        this._el_181 = import4.createRenderElement(this.renderer, this._el_179, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_182 = this.renderer.createText(this._el_179, '\n                    ', null);
        this._el_183 = import4.createRenderElement(this.renderer, this._el_179, 'a', new import4.InlineArray4(4, 'class', 'light-gray-text', 'href', 'mailto:contact@forgottenrecords.com'), null);
        this._text_184 = this.renderer.createText(this._el_183, 'contact@forgottenrecords.com', null);
        this._text_185 = this.renderer.createText(this._el_179, ' | +33 2 99 36 26 72', null);
        this._el_186 = import4.createRenderElement(this.renderer, this._el_179, 'br', import4.EMPTY_INLINE_ARRAY, null);
        this._text_187 = this.renderer.createText(this._el_179, '\n                    SIRET: 50874189900019 | ', null);
        this._el_188 = import4.createRenderElement(this.renderer, this._el_179, 'a', new import4.InlineArray2(2, 'class', 'light-gray-text pointer'), null);
        this._text_189 = this.renderer.createText(this._el_188, '', null);
        this._text_190 = this.renderer.createText(this._el_179, '\n                    ', null);
        this._text_191 = this.renderer.createText(this._el_179, '\n                    ', null);
        this._text_192 = this.renderer.createText(this._el_179, '\n                ', null);
        this._text_193 = this.renderer.createText(this._el_171, '\n                ', null);
        this._text_194 = this.renderer.createText(this._el_171, '\n            ', null);
        this._text_195 = this.renderer.createText(this._el_169, '\n        ', null);
        this._text_196 = this.renderer.createText(this._el_167, '\n    ', null);
        this._text_197 = this.renderer.createText(this._el_132, '\n    ', null);
        this._text_198 = this.renderer.createText(this._el_132, '\n    ', null);
        this._el_199 = import4.createRenderElement(this.renderer, this._el_132, 'a', new import4.InlineArray4(4, 'class', 'scrollToTop', 'href', 'javascript:;'), null);
        this._el_200 = import4.createRenderElement(this.renderer, this._el_199, 'i', new import4.InlineArray2(2, 'class', 'fa fa-angle-up'), null);
        this._text_201 = this.renderer.createText(this._el_132, '\n    ', null);
        this._text_202 = this.renderer.createText(this._el_132, '\n', null);
        this._text_203 = this.renderer.createText(this._el_3, '\n', null);
        this._text_204 = this.renderer.createText(this._el_3, '\n\n', null);
        var disposable_0 = this.renderer.listen(this._el_16, 'click', this.eventHandler(this._handle_click_16_0.bind(this)));
        var disposable_1 = this.renderer.listen(this._el_25, 'click', this.eventHandler(this._handle_click_25_0.bind(this)));
        var disposable_2 = this.renderer.listen(this._el_46, 'click', this.eventHandler(this._handle_click_46_0.bind(this)));
        var disposable_3 = this.renderer.listen(this._el_97, 'click', this.eventHandler(this._handle_click_97_0.bind(this)));
        this._pipe_intl_0 = new import27.IntlPipe();
        this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_4 = this.renderer.listen(this._el_104, 'click', this.eventHandler(this._handle_click_104_0.bind(this)));
        this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_5 = this.renderer.listen(this._el_111, 'click', this.eventHandler(this._handle_click_111_0.bind(this)));
        this._pipe_intl_0_2 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_6 = this.renderer.listen(this._el_117, 'click', this.eventHandler(this._handle_click_117_0.bind(this)));
        this._pipe_intl_0_3 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        var disposable_7 = this.renderer.listen(this._el_129, 'activate', this.eventHandler(this._handle_activate_129_0.bind(this)));
        var subscription_0 = this._RouterOutlet_129_5.context.activateEvents.subscribe(this.eventHandler(this._handle_activate_129_0.bind(this)));
        var disposable_8 = this.renderer.listen(this._el_188, 'click', this.eventHandler(this._handle_click_188_0.bind(this)));
        this._pipe_intl_0_4 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
        this.init([], [
            this._text_0,
            this._text_1,
            this._text_2,
            this._el_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._anchor_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._el_41,
            this._text_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._el_46,
            this._el_47,
            this._text_48,
            this._text_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._el_53,
            this._text_54,
            this._text_55,
            this._el_56,
            this._text_57,
            this._el_58,
            this._text_59,
            this._anchor_60,
            this._text_61,
            this._text_62,
            this._el_63,
            this._text_64,
            this._anchor_65,
            this._text_66,
            this._text_67,
            this._text_68,
            this._text_69,
            this._text_70,
            this._text_71,
            this._el_72,
            this._text_73,
            this._el_74,
            this._text_75,
            this._el_76,
            this._text_77,
            this._text_78,
            this._el_79,
            this._text_80,
            this._el_81,
            this._text_82,
            this._el_83,
            this._text_84,
            this._text_85,
            this._text_86,
            this._text_87,
            this._text_88,
            this._el_89,
            this._text_90,
            this._el_91,
            this._text_92,
            this._el_93,
            this._text_94,
            this._el_95,
            this._text_96,
            this._el_97,
            this._text_98,
            this._text_99,
            this._text_100,
            this._text_101,
            this._el_102,
            this._text_103,
            this._el_104,
            this._text_105,
            this._text_106,
            this._text_107,
            this._text_108,
            this._el_109,
            this._text_110,
            this._el_111,
            this._text_112,
            this._text_113,
            this._text_114,
            this._el_115,
            this._text_116,
            this._el_117,
            this._text_118,
            this._text_119,
            this._text_120,
            this._text_121,
            this._text_122,
            this._text_123,
            this._text_124,
            this._text_125,
            this._text_126,
            this._text_127,
            this._text_128,
            this._el_129,
            this._text_130,
            this._text_131,
            this._el_132,
            this._text_133,
            this._el_134,
            this._text_135,
            this._el_136,
            this._text_137,
            this._el_138,
            this._text_139,
            this._el_140,
            this._el_141,
            this._text_142,
            this._el_143,
            this._el_144,
            this._text_145,
            this._text_146,
            this._text_147,
            this._el_148,
            this._el_149,
            this._text_150,
            this._el_151,
            this._el_152,
            this._text_153,
            this._text_154,
            this._text_155,
            this._el_156,
            this._el_157,
            this._text_158,
            this._el_159,
            this._el_160,
            this._text_161,
            this._text_162,
            this._text_163,
            this._text_164,
            this._text_165,
            this._text_166,
            this._el_167,
            this._text_168,
            this._el_169,
            this._text_170,
            this._el_171,
            this._text_172,
            this._text_173,
            this._el_174,
            this._text_175,
            this._text_176,
            this._text_177,
            this._text_178,
            this._el_179,
            this._text_180,
            this._el_181,
            this._text_182,
            this._el_183,
            this._text_184,
            this._text_185,
            this._el_186,
            this._text_187,
            this._el_188,
            this._text_189,
            this._text_190,
            this._text_191,
            this._text_192,
            this._text_193,
            this._text_194,
            this._text_195,
            this._text_196,
            this._text_197,
            this._text_198,
            this._el_199,
            this._el_200,
            this._text_201,
            this._text_202,
            this._text_203,
            this._text_204
        ], [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4,
            disposable_5,
            disposable_6,
            disposable_7,
            disposable_8
        ], [subscription_0]);
        return null;
    };
    _View_FrontRootComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import33.CookieConsentComponent) && (5 === requestNodeIndex))) {
            return this._CookieConsentComponent_5_4.context;
        }
        if (((token === import28.TemplateRef) && (34 === requestNodeIndex))) {
            return this._TemplateRef_34_5;
        }
        if (((token === import34.NgIf) && (34 === requestNodeIndex))) {
            return this._NgIf_34_6.context;
        }
        if (((token === import22.NotificationService) && ((53 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._NotificationService_53_4;
        }
        if (((token === import35.CartWidgetComponent) && ((53 <= requestNodeIndex) && (requestNodeIndex <= 54)))) {
            return this._CartWidgetComponent_53_5.context;
        }
        if (((token === import28.TemplateRef) && (60 === requestNodeIndex))) {
            return this._TemplateRef_60_5;
        }
        if (((token === import36.NgFor) && (60 === requestNodeIndex))) {
            return this._NgFor_60_6.context;
        }
        if (((token === import28.TemplateRef) && (65 === requestNodeIndex))) {
            return this._TemplateRef_65_5;
        }
        if (((token === import36.NgFor) && (65 === requestNodeIndex))) {
            return this._NgFor_65_6.context;
        }
        if (((token === import37.NgClass) && ((102 <= requestNodeIndex) && (requestNodeIndex <= 107)))) {
            return this._NgClass_102_3.context;
        }
        if (((token === import37.NgClass) && ((109 <= requestNodeIndex) && (requestNodeIndex <= 113)))) {
            return this._NgClass_109_3.context;
        }
        if (((token === import37.NgClass) && ((115 <= requestNodeIndex) && (requestNodeIndex <= 119)))) {
            return this._NgClass_115_3.context;
        }
        if (((token === import38.RouterOutlet) && (129 === requestNodeIndex))) {
            return this._RouterOutlet_129_5.context;
        }
        if (((token === import39.LanguageRoutingComponent) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 204)))) {
            return this._LanguageRoutingComponent_3_3.context;
        }
        return notFoundResult;
    };
    _View_FrontRootComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import7.ValueUnwrapper();
        this._LanguageRoutingComponent_3_3.detectChangesInInputProps(this, this._el_3, throwOnChange);
        var currVal_5_0_0 = this._LanguageRoutingComponent_3_3.context.currentLanguage;
        this._CookieConsentComponent_5_4.check_language(currVal_5_0_0, throwOnChange, false);
        this._CookieConsentComponent_5_4.detectChangesInInputProps(this, this._el_5, throwOnChange);
        var currVal_34_0_0 = this.context.nodeLoading;
        this._NgIf_34_6.check_ngIf(currVal_34_0_0, throwOnChange, false);
        this._NgIf_34_6.detectChangesInInputProps(this, this._anchor_34, throwOnChange);
        var currVal_53_0_0 = this._LanguageRoutingComponent_3_3.context.currentLanguage;
        this._CartWidgetComponent_53_5.check_language(currVal_53_0_0, throwOnChange, false);
        var currVal_53_0_1 = ((this.context.intl.data == null) ? null : this.context.intl.data.CART.WIDGET);
        this._CartWidgetComponent_53_5.check_labels(currVal_53_0_1, throwOnChange, false);
        this._CartWidgetComponent_53_5.detectChangesInInputProps(this, this._el_53, throwOnChange);
        var currVal_60_0_0 = ((this.context.config.data == null) ? null : this.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_60_6.check_ngForOf(currVal_60_0_0, throwOnChange, false);
        this._NgFor_60_6.detectChangesInInputProps(this, this._anchor_60, throwOnChange);
        var currVal_65_0_0 = ((this.context.config.data == null) ? null : this.context.config.data.APP.LANGUAGES.SUPPORTED);
        this._NgFor_65_6.check_ngForOf(currVal_65_0_0, throwOnChange, false);
        this._NgFor_65_6.detectChangesInInputProps(this, this._anchor_65, throwOnChange);
        var currVal_102_0_0 = this._map_228(this.context.isCurrent('/catalogue'));
        this._NgClass_102_3.check_ngClass(currVal_102_0_0, throwOnChange, false);
        this._NgClass_102_3.detectChangesInInputProps(this, this._el_102, throwOnChange);
        var currVal_109_0_0 = this._map_231(this.context.isCurrent('/writings'));
        this._NgClass_109_3.check_ngClass(currVal_109_0_0, throwOnChange, false);
        this._NgClass_109_3.detectChangesInInputProps(this, this._el_109, throwOnChange);
        var currVal_115_0_0 = this._map_234(this.context.isCurrent('/about'));
        this._NgClass_115_3.check_ngClass(currVal_115_0_0, throwOnChange, false);
        this._NgClass_115_3.detectChangesInInputProps(this, this._el_115, throwOnChange);
        this._RouterOutlet_129_5.detectChangesInInputProps(this, this._el_129, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageRoutingComponent_3_3.detectChangesInHostProps(this, this._el_3, throwOnChange);
        this._CookieConsentComponent_5_4.detectChangesInHostProps(this, this._el_5, throwOnChange);
        this._CartWidgetComponent_53_5.detectChangesInHostProps(this, this._el_53, throwOnChange);
        valUnwrapper.reset();
        var currVal_225 = import4.interpolate(1, '\n                            ', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.HOME), this._LanguageRoutingComponent_3_3.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_225, currVal_225))) {
            this.renderer.setText(this._text_98, currVal_225);
            this._expr_225 = currVal_225;
        }
        this._NgClass_102_3.detectChangesInHostProps(this, this._el_102, throwOnChange);
        valUnwrapper.reset();
        var currVal_229 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.CATALOGUE), this._LanguageRoutingComponent_3_3.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_229, currVal_229))) {
            this.renderer.setText(this._text_105, currVal_229);
            this._expr_229 = currVal_229;
        }
        this._NgClass_109_3.detectChangesInHostProps(this, this._el_109, throwOnChange);
        valUnwrapper.reset();
        var currVal_232 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.WRITINGS), this._LanguageRoutingComponent_3_3.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_232, currVal_232))) {
            this.renderer.setText(this._text_112, currVal_232);
            this._expr_232 = currVal_232;
        }
        this._NgClass_115_3.detectChangesInHostProps(this, this._el_115, throwOnChange);
        valUnwrapper.reset();
        var currVal_235 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.MENU.ABOUT), this._LanguageRoutingComponent_3_3.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_235, currVal_235))) {
            this.renderer.setText(this._text_118, currVal_235);
            this._expr_235 = currVal_235;
        }
        this._RouterOutlet_129_5.detectChangesInHostProps(this, this._el_129, throwOnChange);
        var currVal_237 = import4.interpolate(1, '\n                    © 2009-', this.context.currentYear, ' Forgotten Records.\n                ');
        if (import4.checkBinding(throwOnChange, this._expr_237, currVal_237)) {
            this.renderer.setText(this._text_175, currVal_237);
            this._expr_237 = currVal_237;
        }
        valUnwrapper.reset();
        var currVal_238 = import4.interpolate(1, '', valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4, this._pipe_intl_0.transform)(((this.context.intl.data == null) ? null : this.context.intl.data.COMMON.LEGAL_MENTIONS), this._LanguageRoutingComponent_3_3.context.currentLanguage)), '');
        if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange, this._expr_238, currVal_238))) {
            this.renderer.setText(this._text_189, currVal_238);
            this._expr_238 = currVal_238;
        }
        this.detectViewChildrenChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._CookieConsentComponent_5_4.context.ngAfterViewInit();
            }
        }
    };
    _View_FrontRootComponent0.prototype.destroyInternal = function () {
        this._RouterOutlet_129_5.context.ngOnDestroy();
    };
    _View_FrontRootComponent0.prototype._handle_click_16_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_16_0 = (this.context.utils.lLink('', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_16_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_25_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_25_0 = (this.context.utils.lLink('', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_25_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_46_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_46_0 = (this.context.onSearchClick('catalogue', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_46_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_97_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_97_0 = (this.context.onMenuClick('', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_97_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_104_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_104_0 = (this.context.onMenuClick('catalogue', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_104_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_111_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_111_0 = (this.context.onMenuClick('writings', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_111_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_117_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_117_0 = (this.context.onMenuClick('page/about', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_117_0);
    };
    _View_FrontRootComponent0.prototype._handle_activate_129_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_129_0 = (this.context.onActivate($event) !== false);
        return (true && pd_129_0);
    };
    _View_FrontRootComponent0.prototype._handle_click_188_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_188_0 = (this.context.utils.lLink('page/legal', this._LanguageRoutingComponent_3_3.context.currentLanguage) !== false);
        return (true && pd_188_0);
    };
    return _View_FrontRootComponent0;
}(import1.AppView));
function viewFactory_FrontRootComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_FrontRootComponent === null)) {
        (renderType_FrontRootComponent = viewUtils.createRenderComponentType('', 0, import17.ViewEncapsulation.None, styles_FrontRootComponent, {}));
    }
    return new _View_FrontRootComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_FrontRootComponent0 = viewFactory_FrontRootComponent0;
var _View_FrontRootComponent1 = (function (_super) {
    __extends(_View_FrontRootComponent1, _super);
    function _View_FrontRootComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_FrontRootComponent1, renderType_FrontRootComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_FrontRootComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'loading-indicator', new import4.InlineArray4(4, 'class', 'app-loading', 'color', '#8f2424'), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import40.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new import40.Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, [], null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_FrontRootComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import41.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_FrontRootComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = '#8f2424';
        this._LoadingIndicator_0_4.check_color(currVal_0_0_0, throwOnChange, false);
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_FrontRootComponent1;
}(import1.AppView));
function viewFactory_FrontRootComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_FrontRootComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_FrontRootComponent2 = (function (_super) {
    __extends(_View_FrontRootComponent2, _super);
    function _View_FrontRootComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_FrontRootComponent2, renderType_FrontRootComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_FrontRootComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', new import4.InlineArray4(4, 'class', 'language-select', 'language-selector', ''), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import42.viewFactory_LanguageSelectorComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LanguageSelectorComponent_0_4 = new import42.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService), this.parent.parentInjector.get(import12.Location), this.parent.parentInjector.get(import14.Router), this.parent.parentInjector.get(import16.UtilsService), this.parent.parentInjector.get(import10.CookieService));
        this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n                        ', null);
        compView_0.create(this._LanguageSelectorComponent_0_4.context, [], null);
        var disposable_0 = this.renderer.listen(this._el_0, 'onLanguageSelect', this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        var subscription_0 = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_FrontRootComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import43.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._LanguageSelectorComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_FrontRootComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent._LanguageRoutingComponent_3_3.context.resourcePath;
        this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent._LanguageRoutingComponent_3_3.context.currentLanguage;
        this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = false;
        this._LanguageSelectorComponent_0_4.check_displayCurrent(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = this.context.$implicit;
        this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.LANGUAGE_LOCALE);
        this._LanguageSelectorComponent_0_4.check_labels(currVal_0_0_4, throwOnChange, false);
        this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_FrontRootComponent2.prototype._handle_onLanguageSelect_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent._LanguageRoutingComponent_3_3.context.onSelect($event) !== false);
        return (true && pd_0_0);
    };
    return _View_FrontRootComponent2;
}(import1.AppView));
function viewFactory_FrontRootComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_FrontRootComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_FrontRootComponent3 = (function (_super) {
    __extends(_View_FrontRootComponent3, _super);
    function _View_FrontRootComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_FrontRootComponent3, renderType_FrontRootComponent, import6.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import7.ChangeDetectorStatus.CheckAlways);
    }
    _View_FrontRootComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import4.createRenderElement(this.renderer, null, 'span', new import4.InlineArray4(4, 'class', 'language-select', 'language-selector', ''), null);
        this._appEl_0 = new import3.AppElement(0, null, this, this._el_0);
        var compView_0 = import42.viewFactory_LanguageSelectorComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LanguageSelectorComponent_0_4 = new import42.Wrapper_LanguageSelectorComponent(this.parent.parentInjector.get(import8.ConfigService), this.parent.parentInjector.get(import12.Location), this.parent.parentInjector.get(import14.Router), this.parent.parentInjector.get(import16.UtilsService), this.parent.parentInjector.get(import10.CookieService));
        this._appEl_0.initComponent(this._LanguageSelectorComponent_0_4.context, [], compView_0);
        this._text_1 = this.renderer.createText(null, '\n                        ', null);
        compView_0.create(this._LanguageSelectorComponent_0_4.context, [], null);
        var disposable_0 = this.renderer.listen(this._el_0, 'onLanguageSelect', this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        var subscription_0 = this._LanguageSelectorComponent_0_4.context.onLanguageSelect.subscribe(this.eventHandler(this._handle_onLanguageSelect_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], [subscription_0]);
        return null;
    };
    _View_FrontRootComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import43.LanguageSelectorComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._LanguageSelectorComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_FrontRootComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parent._LanguageRoutingComponent_3_3.context.resourcePath;
        this._LanguageSelectorComponent_0_4.check_resourcePath(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parent._LanguageRoutingComponent_3_3.context.currentLanguage;
        this._LanguageSelectorComponent_0_4.check_currentLanguage(currVal_0_0_1, throwOnChange, false);
        var currVal_0_0_2 = false;
        this._LanguageSelectorComponent_0_4.check_displayCurrent(currVal_0_0_2, throwOnChange, false);
        var currVal_0_0_3 = this.context.$implicit;
        this._LanguageSelectorComponent_0_4.check_language(currVal_0_0_3, throwOnChange, false);
        var currVal_0_0_4 = ((this.parent.context.intl.data == null) ? null : this.parent.context.intl.data.COMMON.LANGUAGE_LOCALE);
        this._LanguageSelectorComponent_0_4.check_labels(currVal_0_0_4, throwOnChange, false);
        this._LanguageSelectorComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LanguageSelectorComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_FrontRootComponent3.prototype._handle_onLanguageSelect_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent._LanguageRoutingComponent_3_3.context.onSelect($event) !== false);
        return (true && pd_0_0);
    };
    return _View_FrontRootComponent3;
}(import1.AppView));
function viewFactory_FrontRootComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_FrontRootComponent3(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(231);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(30);
var import9 = __webpack_require__(18);
var import10 = __webpack_require__(2);
var import11 = __webpack_require__(16);
var import12 = __webpack_require__(15);
var import13 = __webpack_require__(29);
var import14 = __webpack_require__(11);
var import15 = __webpack_require__(10);
var import16 = __webpack_require__(24);
var import17 = __webpack_require__(22);
var import18 = __webpack_require__(235);
var import19 = __webpack_require__(14);
var import20 = __webpack_require__(20);
var import21 = __webpack_require__(21);
var import22 = __webpack_require__(19);
var import23 = __webpack_require__(65);
var import24 = __webpack_require__(44);
var import25 = __webpack_require__(78);
var import26 = __webpack_require__(40);
var import27 = __webpack_require__(57);
var import28 = __webpack_require__(31);
var Wrapper_SearchAZComponent = (function () {
    function Wrapper_SearchAZComponent(p0, p1, p2, p3, p4, p5) {
        this.changed = false;
        this.context = new import0.SearchAZComponent(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
    }
    Wrapper_SearchAZComponent.prototype.check_labels = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.labels = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchAZComponent.prototype.check_language = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.language = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchAZComponent.prototype.check_title = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.title = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchAZComponent.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchAZComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchAZComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchAZComponent;
}());
exports.Wrapper_SearchAZComponent = Wrapper_SearchAZComponent;
var renderType_SearchAZComponent_Host = null;
var _View_SearchAZComponent_Host0 = (function (_super) {
    __extends(_View_SearchAZComponent_Host0, _super);
    function _View_SearchAZComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent_Host0, renderType_SearchAZComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAZComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'search-az', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchAZComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchAZComponent_0_4 = new Wrapper_SearchAZComponent(this.parentInjector.get(import8.SearchService), new import9.ElementRef(this._el_0), this.parentInjector.get(import10.UtilsService), this.parentInjector.get(import11.ActivatedRoute), this.parentInjector.get(import12.Router), this.parentInjector.get(import13.ElasticSearchService));
        this._appEl_0.initComponent(this._SearchAZComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchAZComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchAZComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchAZComponent) && (0 === requestNodeIndex))) {
            return this._SearchAZComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchAZComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchAZComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent_Host0;
}(import3.AppView));
function viewFactory_SearchAZComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchAZComponent_Host === null)) {
        (renderType_SearchAZComponent_Host = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchAZComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchAZComponentNgFactory = new import15.ComponentFactory('search-az', viewFactory_SearchAZComponent_Host0, import0.SearchAZComponent);
var styles_SearchAZComponent = [];
var renderType_SearchAZComponent = null;
var _View_SearchAZComponent0 = (function (_super) {
    __extends(_View_SearchAZComponent0, _super);
    function _View_SearchAZComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent0, renderType_SearchAZComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_48 = import1.UNINITIALIZED;
    }
    _View_SearchAZComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_1 = import2.createRenderElement(this.renderer, parentRenderNode, 'p', import2.EMPTY_INLINE_ARRAY, null);
        this._text_2 = this.renderer.createText(this._el_1, '\n    ', null);
        this._text_3 = this.renderer.createText(this._el_1, '\n    ', null);
        this._text_4 = this.renderer.createText(this._el_1, '\n    ', null);
        this._anchor_5 = this.renderer.createTemplateAnchor(this._el_1, null);
        this._appEl_5 = new import5.AppElement(5, 1, this, this._anchor_5);
        this._TemplateRef_5_5 = new import19.TemplateRef_(this._appEl_5, viewFactory_SearchAZComponent1);
        this._NgFor_5_6 = new import16.Wrapper_NgFor(this._appEl_5.vcRef, this._TemplateRef_5_5, this.parentInjector.get(import20.IterableDiffers), this.ref);
        this._text_6 = this.renderer.createText(this._el_1, '\n\n    ', null);
        this._text_7 = this.renderer.createText(this._el_1, '\n    ', null);
        this._el_8 = import2.createRenderElement(this.renderer, parentRenderNode, 'div', new import2.InlineArray4(4, 'class', 'pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main', 'id', 'modal-popup'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n\n        ', null);
        this._el_10 = import2.createRenderElement(this.renderer, this._el_8, 'span', new import2.InlineArray2(2, 'class', 'slider-subtitle5 black-text no-margin-bottom'), null);
        this._text_11 = this.renderer.createText(this._el_10, 'A-Z', null);
        this._text_12 = this.renderer.createText(this._el_8, '\n\n        ', null);
        this._el_13 = import2.createRenderElement(this.renderer, this._el_8, 'div', import2.EMPTY_INLINE_ARRAY, null);
        this._text_14 = this.renderer.createText(this._el_13, '\n            ', null);
        this._el_15 = import2.createRenderElement(this.renderer, this._el_13, 'div', new import2.InlineArray2(2, 'class', 'row'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_15, 'div', new import2.InlineArray2(2, 'class', 'col-md-11 col-sm-10 center-col text-center margin-ten no-margin-top xs-margin-bottom-seven'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n                    ', null);
        this._el_19 = import2.createRenderElement(this.renderer, this._el_17, 'h6', new import2.InlineArray2(2, 'class', 'no-margin-top margin-ten xs-margin-bottom-seven'), null);
        this._el_20 = import2.createRenderElement(this.renderer, this._el_19, 'strong', new import2.InlineArray2(2, 'class', 'black-text'), null);
        this._text_21 = this.renderer.createText(this._el_20, '', null);
        this._text_22 = this.renderer.createText(this._el_17, '\n                ', null);
        this._text_23 = this.renderer.createText(this._el_15, '\n            ', null);
        this._text_24 = this.renderer.createText(this._el_13, '\n            ', null);
        this._el_25 = import2.createRenderElement(this.renderer, this._el_13, 'div', new import2.InlineArray2(2, 'class', 'row az-content center-col'), null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                ', null);
        this._el_27 = import2.createRenderElement(this.renderer, this._el_25, 'div', new import2.InlineArray2(2, 'class', 'col-md-12 col-sm-10 center-col'), null);
        this._text_28 = this.renderer.createText(this._el_27, '\n\n                    ', null);
        this._anchor_29 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_29 = new import5.AppElement(29, 27, this, this._anchor_29);
        this._TemplateRef_29_5 = new import19.TemplateRef_(this._appEl_29, viewFactory_SearchAZComponent2);
        this._NgIf_29_6 = new import17.Wrapper_NgIf(this._appEl_29.vcRef, this._TemplateRef_29_5);
        this._text_30 = this.renderer.createText(this._el_27, '\n\n                    ', null);
        this._text_31 = this.renderer.createText(this._el_27, '\n                    ', null);
        this._anchor_32 = this.renderer.createTemplateAnchor(this._el_27, null);
        this._appEl_32 = new import5.AppElement(32, 27, this, this._anchor_32);
        this._TemplateRef_32_5 = new import19.TemplateRef_(this._appEl_32, viewFactory_SearchAZComponent3);
        this._NgIf_32_6 = new import17.Wrapper_NgIf(this._appEl_32.vcRef, this._TemplateRef_32_5);
        this._text_33 = this.renderer.createText(this._el_27, '\n                    ', null);
        this._text_34 = this.renderer.createText(this._el_27, '\n                ', null);
        this._text_35 = this.renderer.createText(this._el_25, '\n            ', null);
        this._text_36 = this.renderer.createText(this._el_13, '\n        ', null);
        this._text_37 = this.renderer.createText(this._el_8, '\n\n    ', null);
        this._text_38 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this._pipe_mapToIterable_0 = new import18.MapToIterable();
        this.init([], [
            this._text_0,
            this._el_1,
            this._text_2,
            this._text_3,
            this._text_4,
            this._anchor_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._el_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._anchor_29,
            this._text_30,
            this._text_31,
            this._anchor_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._text_38
        ], [], []);
        return null;
    };
    _View_SearchAZComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import19.TemplateRef) && (5 === requestNodeIndex))) {
            return this._TemplateRef_5_5;
        }
        if (((token === import21.NgFor) && (5 === requestNodeIndex))) {
            return this._NgFor_5_6.context;
        }
        if (((token === import19.TemplateRef) && (29 === requestNodeIndex))) {
            return this._TemplateRef_29_5;
        }
        if (((token === import22.NgIf) && (29 === requestNodeIndex))) {
            return this._NgIf_29_6.context;
        }
        if (((token === import19.TemplateRef) && (32 === requestNodeIndex))) {
            return this._TemplateRef_32_5;
        }
        if (((token === import22.NgIf) && (32 === requestNodeIndex))) {
            return this._NgIf_32_6.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_5_0_0 = this.context.fields;
        this._NgFor_5_6.check_ngForOf(currVal_5_0_0, throwOnChange, false);
        this._NgFor_5_6.detectChangesInInputProps(this, this._anchor_5, throwOnChange);
        var currVal_29_0_0 = !this.context.ready;
        this._NgIf_29_6.check_ngIf(currVal_29_0_0, throwOnChange, false);
        this._NgIf_29_6.detectChangesInInputProps(this, this._anchor_29, throwOnChange);
        var currVal_32_0_0 = this.context.ready;
        this._NgIf_32_6.check_ngIf(currVal_32_0_0, throwOnChange, false);
        this._NgIf_32_6.detectChangesInInputProps(this, this._anchor_32, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_48 = import2.interpolate(1, '\n                        ', this.context.title, '');
        if (import2.checkBinding(throwOnChange, this._expr_48, currVal_48)) {
            this.renderer.setText(this._text_21, currVal_48);
            this._expr_48 = currVal_48;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent0;
}(import3.AppView));
function viewFactory_SearchAZComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchAZComponent === null)) {
        (renderType_SearchAZComponent = viewUtils.createRenderComponentType('', 0, import14.ViewEncapsulation.None, styles_SearchAZComponent, {}));
    }
    return new _View_SearchAZComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchAZComponent0 = viewFactory_SearchAZComponent0;
var _View_SearchAZComponent1 = (function (_super) {
    __extends(_View_SearchAZComponent1, _super);
    function _View_SearchAZComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent1, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_2 = import1.UNINITIALIZED;
    }
    _View_SearchAZComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'a', new import2.InlineArray4(4, 'class', 'az-btn highlight-button btn-az btn btn-small no-margin-top modal-popup no-margin-bottom', 'href', '#modal-popup'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'click', this.eventHandler(this._handle_click_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1
        ], [disposable_0], []);
        return null;
    };
    _View_SearchAZComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_2 = import2.interpolate(1, '\n        ', (this.parent.context.labels ? this.parent.context.labels[this.context.$implicit][this.parent.context.language] : this.context.$implicit), ' \n    ');
        if (import2.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchAZComponent1.prototype._handle_click_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onClickLoad(this.context.$implicit) !== false);
        return (true && pd_0_0);
    };
    return _View_SearchAZComponent1;
}(import3.AppView));
function viewFactory_SearchAZComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent2 = (function (_super) {
    __extends(_View_SearchAZComponent2, _super);
    function _View_SearchAZComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent2, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAZComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'loading-indicator', new import2.InlineArray4(4, 'class', 'tab-style1', 'color', '#B6B6B6'), null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = import23.viewFactory_LoadingIndicator0(this.viewUtils, this.injector(0), this._appEl_0);
        this._LoadingIndicator_0_4 = new import23.Wrapper_LoadingIndicator();
        this._appEl_0.initComponent(this._LoadingIndicator_0_4.context, [], compView_0);
        compView_0.create(this._LoadingIndicator_0_4.context, [], null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return null;
    };
    _View_SearchAZComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.LoadingIndicator) && (0 === requestNodeIndex))) {
            return this._LoadingIndicator_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = '#B6B6B6';
        this._LoadingIndicator_0_4.check_color(currVal_0_0_0, throwOnChange, false);
        this._LoadingIndicator_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._LoadingIndicator_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent2;
}(import3.AppView));
function viewFactory_SearchAZComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent2(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent3 = (function (_super) {
    __extends(_View_SearchAZComponent3, _super);
    function _View_SearchAZComponent3(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent3, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAZComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'tab-style1'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'row'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                            ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_2, 'div', new import2.InlineArray2(2, 'class', 'col-md-12 col-sm-12'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                                ', null);
        this._text_6 = this.renderer.createText(this._el_4, '\n                                ', null);
        this._el_7 = import2.createRenderElement(this.renderer, this._el_4, 'ul', new import2.InlineArray2(2, 'class', 'nav nav-tabs nav-tabs-light text-center'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n                                    ', null);
        this._text_9 = this.renderer.createText(this._el_7, '\n                                    ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_7, null);
        this._appEl_10 = new import5.AppElement(10, 7, this, this._anchor_10);
        this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10, viewFactory_SearchAZComponent4);
        this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef, this._TemplateRef_10_5, this.parent.parentInjector.get(import20.IterableDiffers), this.parent.ref);
        this._text_11 = this.renderer.createText(this._el_7, '\n                                ', null);
        this._text_12 = this.renderer.createText(this._el_4, '\n                                ', null);
        this._text_13 = this.renderer.createText(this._el_4, '\n                            ', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n                        ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'tab-content'), null);
        this._text_18 = this.renderer.createText(this._el_17, '\n\n                            ', null);
        this._text_19 = this.renderer.createText(this._el_17, '\n                            ', null);
        this._anchor_20 = this.renderer.createTemplateAnchor(this._el_17, null);
        this._appEl_20 = new import5.AppElement(20, 17, this, this._anchor_20);
        this._TemplateRef_20_5 = new import19.TemplateRef_(this._appEl_20, viewFactory_SearchAZComponent5);
        this._NgFor_20_6 = new import16.Wrapper_NgFor(this._appEl_20.vcRef, this._TemplateRef_20_5, this.parent.parentInjector.get(import20.IterableDiffers), this.parent.ref);
        this._text_21 = this.renderer.createText(this._el_17, '\n                            ', null);
        this._text_22 = this.renderer.createText(this._el_17, '\n\n                        ', null);
        this._text_23 = this.renderer.createText(this._el_0, '\n                        ', null);
        this._text_24 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._pipe_mapToIterable_0_0 = import2.pureProxy1(this.parent._pipe_mapToIterable_0.transform.bind(this.parent._pipe_mapToIterable_0));
        this._pipe_mapToIterable_0_1 = import2.pureProxy1(this.parent._pipe_mapToIterable_0.transform.bind(this.parent._pipe_mapToIterable_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._anchor_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24
        ], [], []);
        return null;
    };
    _View_SearchAZComponent3.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import21.NgFor) && (10 === requestNodeIndex))) {
            return this._NgFor_10_6.context;
        }
        if (((token === import19.TemplateRef) && (20 === requestNodeIndex))) {
            return this._TemplateRef_20_5;
        }
        if (((token === import21.NgFor) && (20 === requestNodeIndex))) {
            return this._NgFor_20_6.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        valUnwrapper.reset();
        var currVal_10_0_0 = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_0, this.parent._pipe_mapToIterable_0.transform)(this.parent.context.azData));
        this._NgFor_10_6.check_ngForOf(currVal_10_0_0, throwOnChange, valUnwrapper.hasWrappedValue);
        this._NgFor_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        valUnwrapper.reset();
        var currVal_20_0_0 = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_1, this.parent._pipe_mapToIterable_0.transform)(this.parent.context.azData));
        this._NgFor_20_6.check_ngForOf(currVal_20_0_0, throwOnChange, valUnwrapper.hasWrappedValue);
        this._NgFor_20_6.detectChangesInInputProps(this, this._anchor_20, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent3;
}(import3.AppView));
function viewFactory_SearchAZComponent3(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent3(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent4 = (function (_super) {
    __extends(_View_SearchAZComponent4, _super);
    function _View_SearchAZComponent4(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent4, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_6 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_7 = import1.UNINITIALIZED;
        this._expr_8 = import1.UNINITIALIZED;
    }
    _View_SearchAZComponent4.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.parentInjector.get(import26.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                        ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'data-toggle', 'tab'), null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n                                    ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [], []);
        return null;
    };
    _View_SearchAZComponent4.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 4)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent4.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this._map_6((this.context.$implicit.key == this.parent.parent.context.requestType));
        this._NgClass_0_3.check_ngClass(currVal_0_0_0, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_7 = import2.interpolate(1, '#tab-', this.context.$implicit.key, '');
        if (import2.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setElementProperty(this._el_2, 'href', this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL, currVal_7));
            this._expr_7 = currVal_7;
        }
        var currVal_8 = import2.interpolate(1, '\n                                                ', (this.parent.parent.context.labels ? this.parent.parent.context.labels[this.context.$implicit.key][this.parent.parent.context.language] : this.context.$implicit.key), '');
        if (import2.checkBinding(throwOnChange, this._expr_8, currVal_8)) {
            this.renderer.setText(this._text_3, currVal_8);
            this._expr_8 = currVal_8;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent4;
}(import3.AppView));
function viewFactory_SearchAZComponent4(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent4(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent5 = (function (_super) {
    __extends(_View_SearchAZComponent5, _super);
    function _View_SearchAZComponent5(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent5, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_33 = import1.UNINITIALIZED;
        this._map_34 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
    }
    _View_SearchAZComponent5.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'tab-pane med-text fade in'), null);
        this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.parentInjector.get(import26.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'row'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                                    ', null);
        this._text_4 = this.renderer.createText(this._el_2, '\n                                    ', null);
        this._el_5 = import2.createRenderElement(this.renderer, this._el_2, 'div', new import2.InlineArray4(4, 'class', 'col-md-12 col-sm-12 center-col text-center', 'id', 'animated-tab'), null);
        this._text_6 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._text_7 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_5, 'ul', new import2.InlineArray2(2, 'class', 'nav nav-tabs nav-tabs-light text-center'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                                            ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8, null);
        this._appEl_10 = new import5.AppElement(10, 8, this, this._anchor_10);
        this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10, viewFactory_SearchAZComponent6);
        this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef, this._TemplateRef_10_5, this.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.ref);
        this._text_11 = this.renderer.createText(this._el_8, '\n                                        ', null);
        this._text_12 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._text_13 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._text_14 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._el_15 = import2.createRenderElement(this.renderer, this._el_5, 'div', new import2.InlineArray2(2, 'class', 'tab-content tab-content-az-names'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                                            ', null);
        this._text_17 = this.renderer.createText(this._el_15, '\n                                            ', null);
        this._anchor_18 = this.renderer.createTemplateAnchor(this._el_15, null);
        this._appEl_18 = new import5.AppElement(18, 15, this, this._anchor_18);
        this._TemplateRef_18_5 = new import19.TemplateRef_(this._appEl_18, viewFactory_SearchAZComponent7);
        this._NgFor_18_6 = new import16.Wrapper_NgFor(this._appEl_18.vcRef, this._TemplateRef_18_5, this.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.ref);
        this._text_19 = this.renderer.createText(this._el_15, '\n                                            ', null);
        this._text_20 = this.renderer.createText(this._el_15, '\n\n\n                                        ', null);
        this._text_21 = this.renderer.createText(this._el_5, '\n                                        ', null);
        this._text_22 = this.renderer.createText(this._el_5, '\n                                    ', null);
        this._text_23 = this.renderer.createText(this._el_2, '\n                                    ', null);
        this._text_24 = this.renderer.createText(this._el_2, '\n                                ', null);
        this._text_25 = this.renderer.createText(this._el_0, '\n                            ', null);
        this._pipe_mapToIterable_0_2 = import2.pureProxy1(this.parent.parent._pipe_mapToIterable_0.transform.bind(this.parent.parent._pipe_mapToIterable_0));
        this._pipe_mapToIterable_0_3 = import2.pureProxy1(this.parent.parent._pipe_mapToIterable_0.transform.bind(this.parent.parent._pipe_mapToIterable_0));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._anchor_18,
            this._text_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._text_23,
            this._text_24,
            this._text_25
        ], [], []);
        return null;
    };
    _View_SearchAZComponent5.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import21.NgFor) && (10 === requestNodeIndex))) {
            return this._NgFor_10_6.context;
        }
        if (((token === import19.TemplateRef) && (18 === requestNodeIndex))) {
            return this._TemplateRef_18_5;
        }
        if (((token === import21.NgFor) && (18 === requestNodeIndex))) {
            return this._NgFor_18_6.context;
        }
        if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 25)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent5.prototype.detectChangesInternal = function (throwOnChange) {
        var valUnwrapper = new import1.ValueUnwrapper();
        var currVal_0_0_0 = 'tab-pane med-text fade in';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_34((this.context.$implicit.key == this.parent.parent.context.requestType));
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        valUnwrapper.reset();
        var currVal_10_0_0 = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_2, this.parent.parent._pipe_mapToIterable_0.transform)(this.context.$implicit.value));
        this._NgFor_10_6.check_ngForOf(currVal_10_0_0, throwOnChange, valUnwrapper.hasWrappedValue);
        this._NgFor_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        valUnwrapper.reset();
        var currVal_18_0_0 = valUnwrapper.unwrap(import2.castByValue(this._pipe_mapToIterable_0_3, this.parent.parent._pipe_mapToIterable_0.transform)(this.context.$implicit.value));
        this._NgFor_18_6.check_ngForOf(currVal_18_0_0, throwOnChange, valUnwrapper.hasWrappedValue);
        this._NgFor_18_6.detectChangesInInputProps(this, this._anchor_18, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_33 = import2.interpolate(1, 'tab-', this.context.$implicit.key, '');
        if (import2.checkBinding(throwOnChange, this._expr_33, currVal_33)) {
            this.renderer.setElementProperty(this._el_0, 'id', currVal_33);
            this._expr_33 = currVal_33;
        }
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent5;
}(import3.AppView));
function viewFactory_SearchAZComponent5(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent5(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent6 = (function (_super) {
    __extends(_View_SearchAZComponent6, _super);
    function _View_SearchAZComponent6(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent6, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._map_4 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_5 = import1.UNINITIALIZED;
        this._expr_6 = import1.UNINITIALIZED;
    }
    _View_SearchAZComponent6.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', new import2.InlineArray2(2, 'class', 'nav az-letter'), null);
        this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.parent.parentInjector.get(import26.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._el_1 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'data-toggle', 'tab'), null);
        this._text_2 = this.renderer.createText(this._el_1, '', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._el_1,
            this._text_2
        ], [], []);
        return null;
    };
    _View_SearchAZComponent6.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 2)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent6.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'nav az-letter';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_4((this.context.index == 0));
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        var currVal_5 = import2.interpolate(2, '#tab-', this.parent.context.$implicit.key, '-', this.context.$implicit.key, '');
        if (import2.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            this.renderer.setElementProperty(this._el_1, 'href', this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL, currVal_5));
            this._expr_5 = currVal_5;
        }
        var currVal_6 = import2.interpolate(1, '', this.context.$implicit.key, '');
        if (import2.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            this.renderer.setText(this._text_2, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent6;
}(import3.AppView));
function viewFactory_SearchAZComponent6(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent6(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent7 = (function (_super) {
    __extends(_View_SearchAZComponent7, _super);
    function _View_SearchAZComponent7(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent7, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_26 = import1.UNINITIALIZED;
        this._map_27 = import2.pureProxy1(function (p0) {
            return { active: p0 };
        });
    }
    _View_SearchAZComponent7.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'div', new import2.InlineArray2(2, 'class', 'col-md-9 col-sm-12 text-center center-col tab-pane fade in'), null);
        this._NgClass_0_3 = new import25.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.parent.parentInjector.get(import26.KeyValueDiffers), new import9.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'div', new import2.InlineArray2(2, 'class', 'tab-pane fade in'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n                                                    ', null);
        this._el_4 = import2.createRenderElement(this.renderer, this._el_2, 'div', new import2.InlineArray2(2, 'class', 'row'), null);
        this._text_5 = this.renderer.createText(this._el_4, '\n                                                        ', null);
        this._el_6 = import2.createRenderElement(this.renderer, this._el_4, 'div', new import2.InlineArray2(2, 'class', 'col-md-12 col-sm-12 gray-text'), null);
        this._text_7 = this.renderer.createText(this._el_6, '\n                                                            ', null);
        this._el_8 = import2.createRenderElement(this.renderer, this._el_6, 'ul', new import2.InlineArray2(2, 'class', 'az-list'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                                                                ', null);
        this._anchor_10 = this.renderer.createTemplateAnchor(this._el_8, null);
        this._appEl_10 = new import5.AppElement(10, 8, this, this._anchor_10);
        this._TemplateRef_10_5 = new import19.TemplateRef_(this._appEl_10, viewFactory_SearchAZComponent8);
        this._NgFor_10_6 = new import16.Wrapper_NgFor(this._appEl_10.vcRef, this._TemplateRef_10_5, this.parent.parent.parent.parentInjector.get(import20.IterableDiffers), this.parent.parent.parent.ref);
        this._text_11 = this.renderer.createText(this._el_8, '\n                                                            ', null);
        this._text_12 = this.renderer.createText(this._el_6, '\n                                                        ', null);
        this._text_13 = this.renderer.createText(this._el_4, '\n                                                    ', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n                                                    ', null);
        this._el_15 = import2.createRenderElement(this.renderer, this._el_2, 'div', new import2.InlineArray2(2, 'class', 'row'), null);
        this._text_16 = this.renderer.createText(this._el_15, '\n                                                        ', null);
        this._el_17 = import2.createRenderElement(this.renderer, this._el_15, 'div', new import2.InlineArray2(2, 'class', 'wide-separator-line'), null);
        this._text_18 = this.renderer.createText(this._el_15, '\n                                                    ', null);
        this._text_19 = this.renderer.createText(this._el_2, '\n                                                    ', null);
        this._text_20 = this.renderer.createText(this._el_2, '\n                                                ', null);
        this._text_21 = this.renderer.createText(this._el_0, '\n                                            ', null);
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._anchor_10,
            this._text_11,
            this._text_12,
            this._text_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._text_21
        ], [], []);
        return null;
    };
    _View_SearchAZComponent7.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import19.TemplateRef) && (10 === requestNodeIndex))) {
            return this._TemplateRef_10_5;
        }
        if (((token === import21.NgFor) && (10 === requestNodeIndex))) {
            return this._NgFor_10_6.context;
        }
        if (((token === import27.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 21)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    _View_SearchAZComponent7.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'col-md-9 col-sm-12 text-center center-col tab-pane fade in';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this._map_27((this.context.index == 0));
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.detectChangesInInputProps(this, this._el_0, throwOnChange);
        var currVal_10_0_0 = this.context.$implicit.value;
        this._NgFor_10_6.check_ngForOf(currVal_10_0_0, throwOnChange, false);
        this._NgFor_10_6.detectChangesInInputProps(this, this._anchor_10, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_26 = import2.interpolate(2, 'tab-', this.parent.context.$implicit.key, '-', this.context.$implicit.key, '');
        if (import2.checkBinding(throwOnChange, this._expr_26, currVal_26)) {
            this.renderer.setElementProperty(this._el_0, 'id', currVal_26);
            this._expr_26 = currVal_26;
        }
        this._NgClass_0_3.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAZComponent7;
}(import3.AppView));
function viewFactory_SearchAZComponent7(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent7(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAZComponent8 = (function (_super) {
    __extends(_View_SearchAZComponent8, _super);
    function _View_SearchAZComponent8(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAZComponent8, renderType_SearchAZComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_6 = import1.UNINITIALIZED;
    }
    _View_SearchAZComponent8.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                                                                    ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', new import2.InlineArray2(2, 'class', 'popup-modal-dismiss pointer'), null);
        this._el_3 = import2.createRenderElement(this.renderer, this._el_2, 'span', new import2.InlineArray2(2, 'class', 'label label-az-name'), null);
        this._text_4 = this.renderer.createText(this._el_3, '', null);
        this._text_5 = this.renderer.createText(this._el_0, '\n                                                                ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._el_3,
            this._text_4,
            this._text_5
        ], [disposable_0], []);
        return null;
    };
    _View_SearchAZComponent8.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_6 = import2.interpolate(1, '', this.context.$implicit, '');
        if (import2.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            this.renderer.setText(this._text_4, currVal_6);
            this._expr_6 = currVal_6;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchAZComponent8.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.parent.parent.context.onSelect(this.parent.parent.context.$implicit.key, this.context.$implicit) !== false);
        return (true && pd_2_0);
    };
    return _View_SearchAZComponent8;
}(import3.AppView));
function viewFactory_SearchAZComponent8(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAZComponent8(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 452 */
/***/ (function(module, exports) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
exports.styles = ['ul[_ngcontent-%COMP%] {\n    list-style-type: none;\n  }\n\n.suggestion-search-msg[_ngcontent-%COMP%] {\n    padding: 15px;\n}\n.suggestion-search-msg[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] {\n    color: #fff;\n}\n.suggestions[_ngcontent-%COMP%] {\n    z-index: 100;\n    background-color: #000;\n    float: right;\n    position: absolute;\n    padding: 10px;\n    opacity: 0.9\n}\n@media screen and (max-width: 9200px) {\n    .suggestions[_ngcontent-%COMP%] { width: 545px}\n}\n@media screen and (max-width: 576px) {\n    .suggestions[_ngcontent-%COMP%] { width: 250px}\n}\n.suggestions[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > ul[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] {\n    color: #ddd;\n}'];


/***/ }),
/* 453 */
/***/ (function(module, exports) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
exports.styles = ['.spinner[_ngcontent-%COMP%] {\n  margin: 0px auto;\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.spinner[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%] {\n  background-color: #B6B6B6;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n  \n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.spinner[_ngcontent-%COMP%]   .rect2[_ngcontent-%COMP%] {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.spinner[_ngcontent-%COMP%]   .rect3[_ngcontent-%COMP%] {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s;\n}\n\n.spinner[_ngcontent-%COMP%]   .rect4[_ngcontent-%COMP%] {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.spinner[_ngcontent-%COMP%]   .rect5[_ngcontent-%COMP%] {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \n  20% { -webkit-transform: scaleY(1.0) }\n}\n\n@keyframes sk-stretchdelay {\n  0%, 40%, 100% { \n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }  20% { \n    transform: scaleY(1.0);\n    -webkit-transform: scaleY(1.0);\n  }\n}'];


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var SampleService = (function () {
    function SampleService() {
    }
    SampleService.prototype.go = function () {
        return 'Hey HO!';
    };
    SampleService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], SampleService);
    return SampleService;
}());
exports.SampleService = SampleService;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
/* tslint:disable */
"use strict";
var import0 = __webpack_require__(236);
var import1 = __webpack_require__(4);
var import2 = __webpack_require__(3);
var import3 = __webpack_require__(12);
var import5 = __webpack_require__(7);
var import7 = __webpack_require__(6);
var import8 = __webpack_require__(18);
var import9 = __webpack_require__(30);
var import10 = __webpack_require__(2);
var import11 = __webpack_require__(11);
var import12 = __webpack_require__(10);
var import13 = __webpack_require__(22);
var import14 = __webpack_require__(14);
var import15 = __webpack_require__(19);
var import16 = __webpack_require__(24);
var import17 = __webpack_require__(20);
var import18 = __webpack_require__(21);
var Wrapper_SearchAutocompleteComponent = (function () {
    function Wrapper_SearchAutocompleteComponent(p0, p1, p2) {
        this.changed = false;
        this.changes = {};
        this.context = new import0.SearchAutocompleteComponent(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
        this._expr_2 = import1.UNINITIALIZED;
        this._expr_3 = import1.UNINITIALIZED;
        this._expr_4 = import1.UNINITIALIZED;
        this._expr_5 = import1.UNINITIALIZED;
    }
    Wrapper_SearchAutocompleteComponent.prototype.check_form = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this.changed = true;
            this.context.form = currValue;
            this.changes['form'] = new import1.SimpleChange(this._expr_0, currValue);
            this._expr_0 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.check_formPath = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this.changed = true;
            this.context.formPath = currValue;
            this.changes['formPath'] = new import1.SimpleChange(this._expr_1, currValue);
            this._expr_1 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.check_onSelectCallBack = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this.changed = true;
            this.context.onSelectCallBack = currValue;
            this.changes['onSelectCallBack'] = new import1.SimpleChange(this._expr_2, currValue);
            this._expr_2 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.check_target = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_3, currValue))) {
            this.changed = true;
            this.context.target = currValue;
            this.changes['target'] = new import1.SimpleChange(this._expr_3, currValue);
            this._expr_3 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.check_input = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_4, currValue))) {
            this.changed = true;
            this.context.input = currValue;
            this.changes['input'] = new import1.SimpleChange(this._expr_4, currValue);
            this._expr_4 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.check_esType = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import2.checkBinding(throwOnChange, this._expr_5, currValue))) {
            this.changed = true;
            this.context.esType = currValue;
            this.changes['esType'] = new import1.SimpleChange(this._expr_5, currValue);
            this._expr_5 = currValue;
        }
    };
    Wrapper_SearchAutocompleteComponent.prototype.detectChangesInInputProps = function (view, el, throwOnChange) {
        var changed = this.changed;
        this.changed = false;
        if (!throwOnChange) {
            if (changed) {
                this.context.ngOnChanges(this.changes);
                this.changes = {};
            }
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_SearchAutocompleteComponent.prototype.detectChangesInHostProps = function (view, el, throwOnChange) {
    };
    return Wrapper_SearchAutocompleteComponent;
}());
exports.Wrapper_SearchAutocompleteComponent = Wrapper_SearchAutocompleteComponent;
var renderType_SearchAutocompleteComponent_Host = null;
var _View_SearchAutocompleteComponent_Host0 = (function (_super) {
    __extends(_View_SearchAutocompleteComponent_Host0, _super);
    function _View_SearchAutocompleteComponent_Host0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAutocompleteComponent_Host0, renderType_SearchAutocompleteComponent_Host, import7.ViewType.HOST, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAutocompleteComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer, 'search-autocomplete', import2.EMPTY_INLINE_ARRAY, rootSelector, null);
        this._appEl_0 = new import5.AppElement(0, null, this, this._el_0);
        var compView_0 = viewFactory_SearchAutocompleteComponent0(this.viewUtils, this.injector(0), this._appEl_0);
        this._SearchAutocompleteComponent_0_4 = new Wrapper_SearchAutocompleteComponent(new import8.ElementRef(this._el_0), this.parentInjector.get(import9.SearchService), this.parentInjector.get(import10.UtilsService));
        this._appEl_0.initComponent(this._SearchAutocompleteComponent_0_4.context, [], compView_0);
        compView_0.create(this._SearchAutocompleteComponent_0_4.context, this.projectableNodes, null);
        this.init([].concat([this._el_0]), [this._el_0], [], []);
        return this._appEl_0;
    };
    _View_SearchAutocompleteComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SearchAutocompleteComponent) && (0 === requestNodeIndex))) {
            return this._SearchAutocompleteComponent_0_4.context;
        }
        return notFoundResult;
    };
    _View_SearchAutocompleteComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SearchAutocompleteComponent_0_4.detectChangesInInputProps(this, this._el_0, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this._SearchAutocompleteComponent_0_4.detectChangesInHostProps(this, this._el_0, throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAutocompleteComponent_Host0;
}(import3.AppView));
function viewFactory_SearchAutocompleteComponent_Host0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchAutocompleteComponent_Host === null)) {
        (renderType_SearchAutocompleteComponent_Host = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, [], {}));
    }
    return new _View_SearchAutocompleteComponent_Host0(viewUtils, parentInjector, declarationEl);
}
exports.SearchAutocompleteComponentNgFactory = new import12.ComponentFactory('search-autocomplete', viewFactory_SearchAutocompleteComponent_Host0, import0.SearchAutocompleteComponent);
var styles_SearchAutocompleteComponent = [];
var renderType_SearchAutocompleteComponent = null;
var _View_SearchAutocompleteComponent0 = (function (_super) {
    __extends(_View_SearchAutocompleteComponent0, _super);
    function _View_SearchAutocompleteComponent0(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAutocompleteComponent0, renderType_SearchAutocompleteComponent, import7.ViewType.COMPONENT, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAutocompleteComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n        ', null);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._appEl_1 = new import5.AppElement(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import14.TemplateRef_(this._appEl_1, viewFactory_SearchAutocompleteComponent1);
        this._NgIf_1_6 = new import13.Wrapper_NgIf(this._appEl_1.vcRef, this._TemplateRef_1_5);
        this._text_2 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this.init([], [
            this._text_0,
            this._anchor_1,
            this._text_2
        ], [], []);
        return null;
    };
    _View_SearchAutocompleteComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import14.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import15.NgIf) && (1 === requestNodeIndex))) {
            return this._NgIf_1_6.context;
        }
        return notFoundResult;
    };
    _View_SearchAutocompleteComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = (this.context.isOnFocus() && this.context.autocompleteContent);
        this._NgIf_1_6.check_ngIf(currVal_1_0_0, throwOnChange, false);
        this._NgIf_1_6.detectChangesInInputProps(this, this._anchor_1, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    return _View_SearchAutocompleteComponent0;
}(import3.AppView));
function viewFactory_SearchAutocompleteComponent0(viewUtils, parentInjector, declarationEl) {
    if ((renderType_SearchAutocompleteComponent === null)) {
        (renderType_SearchAutocompleteComponent = viewUtils.createRenderComponentType('', 0, import11.ViewEncapsulation.None, styles_SearchAutocompleteComponent, {}));
    }
    return new _View_SearchAutocompleteComponent0(viewUtils, parentInjector, declarationEl);
}
exports.viewFactory_SearchAutocompleteComponent0 = viewFactory_SearchAutocompleteComponent0;
var _View_SearchAutocompleteComponent1 = (function (_super) {
    __extends(_View_SearchAutocompleteComponent1, _super);
    function _View_SearchAutocompleteComponent1(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAutocompleteComponent1, renderType_SearchAutocompleteComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
    }
    _View_SearchAutocompleteComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'ul', new import2.InlineArray2(2, 'class', 'autocomplete'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n            ', null);
        this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._appEl_2 = new import5.AppElement(2, 0, this, this._anchor_2);
        this._TemplateRef_2_5 = new import14.TemplateRef_(this._appEl_2, viewFactory_SearchAutocompleteComponent2);
        this._NgFor_2_6 = new import16.Wrapper_NgFor(this._appEl_2.vcRef, this._TemplateRef_2_5, this.parentInjector.get(import17.IterableDiffers), this.parent.ref);
        this._text_3 = this.renderer.createText(this._el_0, '\n        ', null);
        var disposable_0 = this.renderer.listen(this._el_0, 'mouseleave', this.eventHandler(this._handle_mouseleave_0_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._anchor_2,
            this._text_3
        ], [disposable_0], []);
        return null;
    };
    _View_SearchAutocompleteComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import14.TemplateRef) && (2 === requestNodeIndex))) {
            return this._TemplateRef_2_5;
        }
        if (((token === import18.NgFor) && (2 === requestNodeIndex))) {
            return this._NgFor_2_6.context;
        }
        return notFoundResult;
    };
    _View_SearchAutocompleteComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2_0_0 = this.parent.context.autocompleteContent;
        this._NgFor_2_6.check_ngForOf(currVal_2_0_0, throwOnChange, false);
        this._NgFor_2_6.detectChangesInInputProps(this, this._anchor_2, throwOnChange);
        this.detectContentChildrenChanges(throwOnChange);
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchAutocompleteComponent1.prototype._handle_mouseleave_0_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_0_0 = (this.parent.context.onAutocompleteLeave() !== false);
        return (true && pd_0_0);
    };
    return _View_SearchAutocompleteComponent1;
}(import3.AppView));
function viewFactory_SearchAutocompleteComponent1(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAutocompleteComponent1(viewUtils, parentInjector, declarationEl);
}
var _View_SearchAutocompleteComponent2 = (function (_super) {
    __extends(_View_SearchAutocompleteComponent2, _super);
    function _View_SearchAutocompleteComponent2(viewUtils, parentInjector, declarationEl) {
        _super.call(this, _View_SearchAutocompleteComponent2, renderType_SearchAutocompleteComponent, import7.ViewType.EMBEDDED, viewUtils, parentInjector, declarationEl, import1.ChangeDetectorStatus.CheckAlways);
        this._expr_5 = import1.UNINITIALIZED;
    }
    _View_SearchAutocompleteComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import2.createRenderElement(this.renderer, null, 'li', import2.EMPTY_INLINE_ARRAY, null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import2.createRenderElement(this.renderer, this._el_0, 'a', import2.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, '', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n            ', null);
        var disposable_0 = this.renderer.listen(this._el_2, 'click', this.eventHandler(this._handle_click_2_0.bind(this)));
        this.init([].concat([this._el_0]), [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ], [disposable_0], []);
        return null;
    };
    _View_SearchAutocompleteComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this.detectContentChildrenChanges(throwOnChange);
        var currVal_5 = import2.interpolate(1, '', this.context.$implicit.name, '');
        if (import2.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            this.renderer.setText(this._text_3, currVal_5);
            this._expr_5 = currVal_5;
        }
        this.detectViewChildrenChanges(throwOnChange);
    };
    _View_SearchAutocompleteComponent2.prototype._handle_click_2_0 = function ($event) {
        this.markPathToRootAsCheckOnce();
        var pd_2_0 = (this.parent.parent.context.onSelect(this.context.$implicit.name) !== false);
        return (true && pd_2_0);
    };
    return _View_SearchAutocompleteComponent2;
}(import3.AppView));
function viewFactory_SearchAutocompleteComponent2(viewUtils, parentInjector, declarationEl) {
    return new _View_SearchAutocompleteComponent2(viewUtils, parentInjector, declarationEl);
}


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var TestComponent = (function () {
    function TestComponent() {
        this.test2 = '<b>This is shared</b>';
    }
    TestComponent = __decorate([
        core_1.Component({
            selector: 'test',
            template: __webpack_require__(505),
        }), 
        __metadata('design:paramtypes', [])
    ], TestComponent);
    return TestComponent;
}());
exports.TestComponent = TestComponent;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(52);
var router_1 = __webpack_require__(8);
var browser_1 = __webpack_require__(410); // for AoT we need to manually split universal packages
var idle_preload_1 = __webpack_require__(289);
var app_module_1 = __webpack_require__(301);
var cache_service_1 = __webpack_require__(234);
// Will be merged into @angular/platform-browser in a later release
// see https://github.com/angular/angular/pull/12322
var angular2_meta_1 = __webpack_require__(149);
// import * as LRU from 'modern-lru';
function getLRU(lru) {
    // use LRU for node
    // return lru || new LRU(10); 
    return lru || new Map();
}
exports.getLRU = getLRU;
function getRequest() {
    // the request object only lives on the server
    return { cookie: document.cookie };
}
exports.getRequest = getRequest;
function getResponse() {
    // the response object is sent as the index.html and lives on the server
    return {};
}
exports.getResponse = getResponse;
// TODO(gdi2290): refactor into Universal
exports.UNIVERSAL_KEY = 'UNIVERSAL_CACHE';
var MainModule = (function () {
    function MainModule(cache) {
        this.cache = cache;
        // TODO(gdi2290): refactor into a lifecycle hook
        this.doRehydrate();
    }
    MainModule.prototype.doRehydrate = function () {
        var defaultValue = {};
        var serverCache = this._getCacheValue(cache_service_1.CacheService.KEY, defaultValue);
        this.cache.rehydrate(serverCache);
    };
    MainModule.prototype._getCacheValue = function (key, defaultValue) {
        // browser
        var win = window;
        if (win[exports.UNIVERSAL_KEY] && win[exports.UNIVERSAL_KEY][key]) {
            var serverCache = defaultValue;
            try {
                serverCache = JSON.parse(win[exports.UNIVERSAL_KEY][key]);
                if (typeof serverCache !== typeof defaultValue) {
                    console.log('Angular Universal: The type of data from the server is different from the default value type');
                    serverCache = defaultValue;
                }
            }
            catch (e) {
                console.log('Angular Universal: There was a problem parsing the server data during rehydrate');
                serverCache = defaultValue;
            }
            return serverCache;
        }
        else {
            console.log('Angular Universal: UNIVERSAL_CACHE is missing');
        }
        return defaultValue;
    };
    MainModule = __decorate([
        core_1.NgModule({
            bootstrap: [app_module_1.AppComponent],
            imports: [
                // MaterialModule.forRoot() should be included first
                browser_1.UniversalModule,
                forms_1.FormsModule,
                router_1.RouterModule.forRoot([], { useHash: false, preloadingStrategy: idle_preload_1.IdlePreload }),
                idle_preload_1.IdlePreloadModule.forRoot(),
                app_module_1.AppModule,
            ],
            providers: [
                { provide: 'isBrowser', useValue: browser_1.isBrowser },
                { provide: 'isNode', useValue: browser_1.isNode },
                { provide: 'req', useFactory: getRequest },
                { provide: 'res', useFactory: getResponse },
                { provide: 'LRU', useFactory: getLRU, deps: [] },
                cache_service_1.CacheService,
                angular2_meta_1.Meta,
            ]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof cache_service_1.CacheService !== 'undefined' && cache_service_1.CacheService) === 'function' && _a) || Object])
    ], MainModule);
    return MainModule;
    var _a;
}());
exports.MainModule = MainModule;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   3.0.2
 */

(function() {
    "use strict";
    function lib$es6$promise$utils$$objectOrFunction(x) {
      return typeof x === 'function' || (typeof x === 'object' && x !== null);
    }

    function lib$es6$promise$utils$$isFunction(x) {
      return typeof x === 'function';
    }

    function lib$es6$promise$utils$$isMaybeThenable(x) {
      return typeof x === 'object' && x !== null;
    }

    var lib$es6$promise$utils$$_isArray;
    if (!Array.isArray) {
      lib$es6$promise$utils$$_isArray = function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      };
    } else {
      lib$es6$promise$utils$$_isArray = Array.isArray;
    }

    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
    var lib$es6$promise$asap$$len = 0;
    var lib$es6$promise$asap$$toString = {}.toString;
    var lib$es6$promise$asap$$vertxNext;
    var lib$es6$promise$asap$$customSchedulerFn;

    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
      lib$es6$promise$asap$$len += 2;
      if (lib$es6$promise$asap$$len === 2) {
        // If len is 2, that means that we need to schedule an async flush.
        // If additional callbacks are queued before the queue is flushed, they
        // will be processed by this flush that we are scheduling.
        if (lib$es6$promise$asap$$customSchedulerFn) {
          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
        } else {
          lib$es6$promise$asap$$scheduleFlush();
        }
      }
    }

    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
    }

    function lib$es6$promise$asap$$setAsap(asapFn) {
      lib$es6$promise$asap$$asap = asapFn;
    }

    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

    // test for web worker but not in IE10
    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
      typeof importScripts !== 'undefined' &&
      typeof MessageChannel !== 'undefined';

    // node
    function lib$es6$promise$asap$$useNextTick() {
      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
      // see https://github.com/cujojs/when/issues/410 for details
      return function() {
        process.nextTick(lib$es6$promise$asap$$flush);
      };
    }

    // vertx
    function lib$es6$promise$asap$$useVertxTimer() {
      return function() {
        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
      };
    }

    function lib$es6$promise$asap$$useMutationObserver() {
      var iterations = 0;
      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
      var node = document.createTextNode('');
      observer.observe(node, { characterData: true });

      return function() {
        node.data = (iterations = ++iterations % 2);
      };
    }

    // web worker
    function lib$es6$promise$asap$$useMessageChannel() {
      var channel = new MessageChannel();
      channel.port1.onmessage = lib$es6$promise$asap$$flush;
      return function () {
        channel.port2.postMessage(0);
      };
    }

    function lib$es6$promise$asap$$useSetTimeout() {
      return function() {
        setTimeout(lib$es6$promise$asap$$flush, 1);
      };
    }

    var lib$es6$promise$asap$$queue = new Array(1000);
    function lib$es6$promise$asap$$flush() {
      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
        var callback = lib$es6$promise$asap$$queue[i];
        var arg = lib$es6$promise$asap$$queue[i+1];

        callback(arg);

        lib$es6$promise$asap$$queue[i] = undefined;
        lib$es6$promise$asap$$queue[i+1] = undefined;
      }

      lib$es6$promise$asap$$len = 0;
    }

    function lib$es6$promise$asap$$attemptVertx() {
      try {
        var r = require;
        var vertx = __webpack_require__(549);
        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return lib$es6$promise$asap$$useVertxTimer();
      } catch(e) {
        return lib$es6$promise$asap$$useSetTimeout();
      }
    }

    var lib$es6$promise$asap$$scheduleFlush;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (lib$es6$promise$asap$$isNode) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
    } else if (lib$es6$promise$asap$$isWorker) {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
    } else {
      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
    }

    function lib$es6$promise$$internal$$noop() {}

    var lib$es6$promise$$internal$$PENDING   = void 0;
    var lib$es6$promise$$internal$$FULFILLED = 1;
    var lib$es6$promise$$internal$$REJECTED  = 2;

    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$selfFulfillment() {
      return new TypeError("You cannot resolve a promise with itself");
    }

    function lib$es6$promise$$internal$$cannotReturnOwn() {
      return new TypeError('A promises callback cannot return that same promise.');
    }

    function lib$es6$promise$$internal$$getThen(promise) {
      try {
        return promise.then;
      } catch(error) {
        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
        return lib$es6$promise$$internal$$GET_THEN_ERROR;
      }
    }

    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
      try {
        then.call(value, fulfillmentHandler, rejectionHandler);
      } catch(e) {
        return e;
      }
    }

    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
       lib$es6$promise$asap$$asap(function(promise) {
        var sealed = false;
        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
          if (sealed) { return; }
          sealed = true;
          if (thenable !== value) {
            lib$es6$promise$$internal$$resolve(promise, value);
          } else {
            lib$es6$promise$$internal$$fulfill(promise, value);
          }
        }, function(reason) {
          if (sealed) { return; }
          sealed = true;

          lib$es6$promise$$internal$$reject(promise, reason);
        }, 'Settle: ' + (promise._label || ' unknown promise'));

        if (!sealed && error) {
          sealed = true;
          lib$es6$promise$$internal$$reject(promise, error);
        }
      }, promise);
    }

    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, thenable._result);
      } else {
        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      }
    }

    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
      if (maybeThenable.constructor === promise.constructor) {
        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
      } else {
        var then = lib$es6$promise$$internal$$getThen(maybeThenable);

        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
        } else if (then === undefined) {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        } else if (lib$es6$promise$utils$$isFunction(then)) {
          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
        } else {
          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
        }
      }
    }

    function lib$es6$promise$$internal$$resolve(promise, value) {
      if (promise === value) {
        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
        lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
      } else {
        lib$es6$promise$$internal$$fulfill(promise, value);
      }
    }

    function lib$es6$promise$$internal$$publishRejection(promise) {
      if (promise._onerror) {
        promise._onerror(promise._result);
      }

      lib$es6$promise$$internal$$publish(promise);
    }

    function lib$es6$promise$$internal$$fulfill(promise, value) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }

      promise._result = value;
      promise._state = lib$es6$promise$$internal$$FULFILLED;

      if (promise._subscribers.length !== 0) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
      }
    }

    function lib$es6$promise$$internal$$reject(promise, reason) {
      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
      promise._state = lib$es6$promise$$internal$$REJECTED;
      promise._result = reason;

      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
    }

    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
      var subscribers = parent._subscribers;
      var length = subscribers.length;

      parent._onerror = null;

      subscribers[length] = child;
      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;

      if (length === 0 && parent._state) {
        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
      }
    }

    function lib$es6$promise$$internal$$publish(promise) {
      var subscribers = promise._subscribers;
      var settled = promise._state;

      if (subscribers.length === 0) { return; }

      var child, callback, detail = promise._result;

      for (var i = 0; i < subscribers.length; i += 3) {
        child = subscribers[i];
        callback = subscribers[i + settled];

        if (child) {
          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
        } else {
          callback(detail);
        }
      }

      promise._subscribers.length = 0;
    }

    function lib$es6$promise$$internal$$ErrorObject() {
      this.error = null;
    }

    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();

    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
      try {
        return callback(detail);
      } catch(e) {
        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
      }
    }

    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
          value, error, succeeded, failed;

      if (hasCallback) {
        value = lib$es6$promise$$internal$$tryCatch(callback, detail);

        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
          failed = true;
          error = value.error;
          value = null;
        } else {
          succeeded = true;
        }

        if (promise === value) {
          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
          return;
        }

      } else {
        value = detail;
        succeeded = true;
      }

      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
        // noop
      } else if (hasCallback && succeeded) {
        lib$es6$promise$$internal$$resolve(promise, value);
      } else if (failed) {
        lib$es6$promise$$internal$$reject(promise, error);
      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
        lib$es6$promise$$internal$$fulfill(promise, value);
      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
        lib$es6$promise$$internal$$reject(promise, value);
      }
    }

    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
      try {
        resolver(function resolvePromise(value){
          lib$es6$promise$$internal$$resolve(promise, value);
        }, function rejectPromise(reason) {
          lib$es6$promise$$internal$$reject(promise, reason);
        });
      } catch(e) {
        lib$es6$promise$$internal$$reject(promise, e);
      }
    }

    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
      var enumerator = this;

      enumerator._instanceConstructor = Constructor;
      enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);

      if (enumerator._validateInput(input)) {
        enumerator._input     = input;
        enumerator.length     = input.length;
        enumerator._remaining = input.length;

        enumerator._init();

        if (enumerator.length === 0) {
          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
        } else {
          enumerator.length = enumerator.length || 0;
          enumerator._enumerate();
          if (enumerator._remaining === 0) {
            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
          }
        }
      } else {
        lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
      }
    }

    lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function(input) {
      return lib$es6$promise$utils$$isArray(input);
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
      return new Error('Array Methods must be provided an Array');
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._init = function() {
      this._result = new Array(this.length);
    };

    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;

    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
      var enumerator = this;

      var length  = enumerator.length;
      var promise = enumerator.promise;
      var input   = enumerator._input;

      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
        enumerator._eachEntry(input[i], i);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
      var enumerator = this;
      var c = enumerator._instanceConstructor;

      if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
        if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
          entry._onerror = null;
          enumerator._settledAt(entry._state, i, entry._result);
        } else {
          enumerator._willSettleAt(c.resolve(entry), i);
        }
      } else {
        enumerator._remaining--;
        enumerator._result[i] = entry;
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
      var enumerator = this;
      var promise = enumerator.promise;

      if (promise._state === lib$es6$promise$$internal$$PENDING) {
        enumerator._remaining--;

        if (state === lib$es6$promise$$internal$$REJECTED) {
          lib$es6$promise$$internal$$reject(promise, value);
        } else {
          enumerator._result[i] = value;
        }
      }

      if (enumerator._remaining === 0) {
        lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
      }
    };

    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
      var enumerator = this;

      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
      }, function(reason) {
        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
      });
    };
    function lib$es6$promise$promise$all$$all(entries) {
      return new lib$es6$promise$enumerator$$default(this, entries).promise;
    }
    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
    function lib$es6$promise$promise$race$$race(entries) {
      /*jshint validthis:true */
      var Constructor = this;

      var promise = new Constructor(lib$es6$promise$$internal$$noop);

      if (!lib$es6$promise$utils$$isArray(entries)) {
        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
        return promise;
      }

      var length = entries.length;

      function onFulfillment(value) {
        lib$es6$promise$$internal$$resolve(promise, value);
      }

      function onRejection(reason) {
        lib$es6$promise$$internal$$reject(promise, reason);
      }

      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
      }

      return promise;
    }
    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
    function lib$es6$promise$promise$resolve$$resolve(object) {
      /*jshint validthis:true */
      var Constructor = this;

      if (object && typeof object === 'object' && object.constructor === Constructor) {
        return object;
      }

      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$resolve(promise, object);
      return promise;
    }
    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
    function lib$es6$promise$promise$reject$$reject(reason) {
      /*jshint validthis:true */
      var Constructor = this;
      var promise = new Constructor(lib$es6$promise$$internal$$noop);
      lib$es6$promise$$internal$$reject(promise, reason);
      return promise;
    }
    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;

    var lib$es6$promise$promise$$counter = 0;

    function lib$es6$promise$promise$$needsResolver() {
      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }

    function lib$es6$promise$promise$$needsNew() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }

    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
    /**
      Promise objects represent the eventual result of an asynchronous operation. The
      primary way of interacting with a promise is through its `then` method, which
      registers callbacks to receive either a promise's eventual value or the reason
      why the promise cannot be fulfilled.

      Terminology
      -----------

      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
      - `thenable` is an object or function that defines a `then` method.
      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
      - `exception` is a value that is thrown using the throw statement.
      - `reason` is a value that indicates why a promise was rejected.
      - `settled` the final resting state of a promise, fulfilled or rejected.

      A promise can be in one of three states: pending, fulfilled, or rejected.

      Promises that are fulfilled have a fulfillment value and are in the fulfilled
      state.  Promises that are rejected have a rejection reason and are in the
      rejected state.  A fulfillment value is never a thenable.

      Promises can also be said to *resolve* a value.  If this value is also a
      promise, then the original promise's settled state will match the value's
      settled state.  So a promise that *resolves* a promise that rejects will
      itself reject, and a promise that *resolves* a promise that fulfills will
      itself fulfill.


      Basic Usage:
      ------------

      ```js
      var promise = new Promise(function(resolve, reject) {
        // on success
        resolve(value);

        // on failure
        reject(reason);
      });

      promise.then(function(value) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Advanced Usage:
      ---------------

      Promises shine when abstracting away asynchronous interactions such as
      `XMLHttpRequest`s.

      ```js
      function getJSON(url) {
        return new Promise(function(resolve, reject){
          var xhr = new XMLHttpRequest();

          xhr.open('GET', url);
          xhr.onreadystatechange = handler;
          xhr.responseType = 'json';
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.send();

          function handler() {
            if (this.readyState === this.DONE) {
              if (this.status === 200) {
                resolve(this.response);
              } else {
                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
              }
            }
          };
        });
      }

      getJSON('/posts.json').then(function(json) {
        // on fulfillment
      }, function(reason) {
        // on rejection
      });
      ```

      Unlike callbacks, promises are great composable primitives.

      ```js
      Promise.all([
        getJSON('/posts'),
        getJSON('/comments')
      ]).then(function(values){
        values[0] // => postsJSON
        values[1] // => commentsJSON

        return values;
      });
      ```

      @class Promise
      @param {function} resolver
      Useful for tooling.
      @constructor
    */
    function lib$es6$promise$promise$$Promise(resolver) {
      this._id = lib$es6$promise$promise$$counter++;
      this._state = undefined;
      this._result = undefined;
      this._subscribers = [];

      if (lib$es6$promise$$internal$$noop !== resolver) {
        if (!lib$es6$promise$utils$$isFunction(resolver)) {
          lib$es6$promise$promise$$needsResolver();
        }

        if (!(this instanceof lib$es6$promise$promise$$Promise)) {
          lib$es6$promise$promise$$needsNew();
        }

        lib$es6$promise$$internal$$initializePromise(this, resolver);
      }
    }

    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;

    lib$es6$promise$promise$$Promise.prototype = {
      constructor: lib$es6$promise$promise$$Promise,

    /**
      The primary way of interacting with a promise is through its `then` method,
      which registers callbacks to receive either a promise's eventual value or the
      reason why the promise cannot be fulfilled.

      ```js
      findUser().then(function(user){
        // user is available
      }, function(reason){
        // user is unavailable, and you are given the reason why
      });
      ```

      Chaining
      --------

      The return value of `then` is itself a promise.  This second, 'downstream'
      promise is resolved with the return value of the first promise's fulfillment
      or rejection handler, or rejected if the handler throws an exception.

      ```js
      findUser().then(function (user) {
        return user.name;
      }, function (reason) {
        return 'default name';
      }).then(function (userName) {
        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
        // will be `'default name'`
      });

      findUser().then(function (user) {
        throw new Error('Found user, but still unhappy');
      }, function (reason) {
        throw new Error('`findUser` rejected and we're unhappy');
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
      });
      ```
      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

      ```js
      findUser().then(function (user) {
        throw new PedagogicalException('Upstream error');
      }).then(function (value) {
        // never reached
      }).then(function (value) {
        // never reached
      }, function (reason) {
        // The `PedgagocialException` is propagated all the way down to here
      });
      ```

      Assimilation
      ------------

      Sometimes the value you want to propagate to a downstream promise can only be
      retrieved asynchronously. This can be achieved by returning a promise in the
      fulfillment or rejection handler. The downstream promise will then be pending
      until the returned promise is settled. This is called *assimilation*.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // The user's comments are now available
      });
      ```

      If the assimliated promise rejects, then the downstream promise will also reject.

      ```js
      findUser().then(function (user) {
        return findCommentsByAuthor(user);
      }).then(function (comments) {
        // If `findCommentsByAuthor` fulfills, we'll have the value here
      }, function (reason) {
        // If `findCommentsByAuthor` rejects, we'll have the reason here
      });
      ```

      Simple Example
      --------------

      Synchronous Example

      ```javascript
      var result;

      try {
        result = findResult();
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js
      findResult(function(result, err){
        if (err) {
          // failure
        } else {
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findResult().then(function(result){
        // success
      }, function(reason){
        // failure
      });
      ```

      Advanced Example
      --------------

      Synchronous Example

      ```javascript
      var author, books;

      try {
        author = findAuthor();
        books  = findBooksByAuthor(author);
        // success
      } catch(reason) {
        // failure
      }
      ```

      Errback Example

      ```js

      function foundBooks(books) {

      }

      function failure(reason) {

      }

      findAuthor(function(author, err){
        if (err) {
          failure(err);
          // failure
        } else {
          try {
            findBoooksByAuthor(author, function(books, err) {
              if (err) {
                failure(err);
              } else {
                try {
                  foundBooks(books);
                } catch(reason) {
                  failure(reason);
                }
              }
            });
          } catch(error) {
            failure(err);
          }
          // success
        }
      });
      ```

      Promise Example;

      ```javascript
      findAuthor().
        then(findBooksByAuthor).
        then(function(books){
          // found books
      }).catch(function(reason){
        // something went wrong
      });
      ```

      @method then
      @param {Function} onFulfilled
      @param {Function} onRejected
      Useful for tooling.
      @return {Promise}
    */
      then: function(onFulfillment, onRejection) {
        var parent = this;
        var state = parent._state;

        if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
          return this;
        }

        var child = new this.constructor(lib$es6$promise$$internal$$noop);
        var result = parent._result;

        if (state) {
          var callback = arguments[state - 1];
          lib$es6$promise$asap$$asap(function(){
            lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
          });
        } else {
          lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
        }

        return child;
      },

    /**
      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
      as the catch block of a try/catch statement.

      ```js
      function findAuthor(){
        throw new Error('couldn't find that author');
      }

      // synchronous
      try {
        findAuthor();
      } catch(reason) {
        // something went wrong
      }

      // async with promises
      findAuthor().catch(function(reason){
        // something went wrong
      });
      ```

      @method catch
      @param {Function} onRejection
      Useful for tooling.
      @return {Promise}
    */
      'catch': function(onRejection) {
        return this.then(null, onRejection);
      }
    };
    function lib$es6$promise$polyfill$$polyfill() {
      var local;

      if (typeof global !== 'undefined') {
          local = global;
      } else if (typeof self !== 'undefined') {
          local = self;
      } else {
          try {
              local = Function('return this')();
          } catch (e) {
              throw new Error('polyfill failed because global object is unavailable in this environment');
          }
      }

      var P = local.Promise;

      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
        return;
      }

      local.Promise = lib$es6$promise$promise$$default;
    }
    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;

    var lib$es6$promise$umd$$ES6Promise = {
      'Promise': lib$es6$promise$promise$$default,
      'polyfill': lib$es6$promise$polyfill$$default
    };

    /* global define:true module:true window: true */
    if (true) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && module['exports']) {
      module['exports'] = lib$es6$promise$umd$$ES6Promise;
    } else if (typeof this !== 'undefined') {
      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
    }

    lib$es6$promise$polyfill$$default();
}).call(this);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(320), __webpack_require__(59)))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
  * https://github.com/paulmillr/es6-shim
  * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
  *   and contributors,  MIT License
  * es6-shim: v0.35.1
  * see https://github.com/paulmillr/es6-shim/blob/0.35.1/LICENSE
  * Details and documentation:
  * https://github.com/paulmillr/es6-shim/
  */

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
  /*global define, module, exports */
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(this, function () {
  'use strict';

  var _apply = Function.call.bind(Function.apply);
  var _call = Function.call.bind(Function.call);
  var isArray = Array.isArray;
  var keys = Object.keys;

  var not = function notThunker(func) {
    return function notThunk() {
      return !_apply(func, this, arguments);
    };
  };
  var throwsError = function (func) {
    try {
      func();
      return false;
    } catch (e) {
      return true;
    }
  };
  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
    try {
      return func();
    } catch (e) {
      return false;
    }
  };

  var isCallableWithoutNew = not(throwsError);
  var arePropertyDescriptorsSupported = function () {
    // if Object.defineProperty exists but throws, it's IE 8
    return !throwsError(function () {
      Object.defineProperty({}, 'x', { get: function () {} });
    });
  };
  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
  var functionsHaveNames = (function foo() {}).name === 'foo'; // eslint-disable-line no-extra-parens

  var _forEach = Function.call.bind(Array.prototype.forEach);
  var _reduce = Function.call.bind(Array.prototype.reduce);
  var _filter = Function.call.bind(Array.prototype.filter);
  var _some = Function.call.bind(Array.prototype.some);

  var defineProperty = function (object, name, value, force) {
    if (!force && name in object) { return; }
    if (supportsDescriptors) {
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  // Define configurable, writable and non-enumerable props
  // if they don’t exist.
  var defineProperties = function (object, map, forceOverride) {
    _forEach(keys(map), function (name) {
      var method = map[name];
      defineProperty(object, name, method, !!forceOverride);
    });
  };

  var _toString = Function.call.bind(Object.prototype.toString);
  var isCallable =  false ? function IsCallableSlow(x) {
    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
    return typeof x === 'function' && _toString(x) === '[object Function]';
  } : function IsCallableFast(x) { return typeof x === 'function'; };

  var Value = {
    getter: function (object, name, getter) {
      if (!supportsDescriptors) {
        throw new TypeError('getters require true ES5 support');
      }
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: false,
        get: getter
      });
    },
    proxy: function (originalObject, key, targetObject) {
      if (!supportsDescriptors) {
        throw new TypeError('getters require true ES5 support');
      }
      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
      Object.defineProperty(targetObject, key, {
        configurable: originalDescriptor.configurable,
        enumerable: originalDescriptor.enumerable,
        get: function getKey() { return originalObject[key]; },
        set: function setKey(value) { originalObject[key] = value; }
      });
    },
    redefine: function (object, property, newValue) {
      if (supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(object, property);
        descriptor.value = newValue;
        Object.defineProperty(object, property, descriptor);
      } else {
        object[property] = newValue;
      }
    },
    defineByDescriptor: function (object, property, descriptor) {
      if (supportsDescriptors) {
        Object.defineProperty(object, property, descriptor);
      } else if ('value' in descriptor) {
        object[property] = descriptor.value;
      }
    },
    preserveToString: function (target, source) {
      if (source && isCallable(source.toString)) {
        defineProperty(target, 'toString', source.toString.bind(source), true);
      }
    }
  };

  // Simple shim for Object.create on ES3 browsers
  // (unlike real shim, no attempt to support `prototype === null`)
  var create = Object.create || function (prototype, properties) {
    var Prototype = function Prototype() {};
    Prototype.prototype = prototype;
    var object = new Prototype();
    if (typeof properties !== 'undefined') {
      keys(properties).forEach(function (key) {
        Value.defineByDescriptor(object, key, properties[key]);
      });
    }
    return object;
  };

  var supportsSubclassing = function (C, f) {
    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
    return valueOrFalseIfThrows(function () {
      var Sub = function Subclass(arg) {
        var o = new C(arg);
        Object.setPrototypeOf(o, Subclass.prototype);
        return o;
      };
      Object.setPrototypeOf(Sub, C);
      Sub.prototype = create(C.prototype, {
        constructor: { value: Sub }
      });
      return f(Sub);
    });
  };

  var getGlobal = function () {
    /* global self, window, global */
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') { return self; }
    if (typeof window !== 'undefined') { return window; }
    if (typeof global !== 'undefined') { return global; }
    throw new Error('unable to locate global object');
  };

  var globals = getGlobal();
  var globalIsFinite = globals.isFinite;
  var _indexOf = Function.call.bind(String.prototype.indexOf);
  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
  var _concat = Function.call.bind(Array.prototype.concat);
  // var _sort = Function.call.bind(Array.prototype.sort);
  var _strSlice = Function.call.bind(String.prototype.slice);
  var _push = Function.call.bind(Array.prototype.push);
  var _pushApply = Function.apply.bind(Array.prototype.push);
  var _shift = Function.call.bind(Array.prototype.shift);
  var _max = Math.max;
  var _min = Math.min;
  var _floor = Math.floor;
  var _abs = Math.abs;
  var _exp = Math.exp;
  var _log = Math.log;
  var _sqrt = Math.sqrt;
  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
  var ArrayIterator; // make our implementation private
  var noop = function () {};

  var OrigMap = globals.Map;
  var origMapDelete = OrigMap && OrigMap.prototype['delete'];
  var origMapGet = OrigMap && OrigMap.prototype.get;
  var origMapHas = OrigMap && OrigMap.prototype.has;
  var origMapSet = OrigMap && OrigMap.prototype.set;

  var Symbol = globals.Symbol || {};
  var symbolSpecies = Symbol.species || '@@species';

  var numberIsNaN = Number.isNaN || function isNaN(value) {
    // NaN !== NaN, but they are identical.
    // NaNs are the only non-reflexive value, i.e., if x !== x,
    // then x is NaN.
    // isNaN is broken: it converts its argument to number, so
    // isNaN('foo') => true
    return value !== value;
  };
  var numberIsFinite = Number.isFinite || function isFinite(value) {
    return typeof value === 'number' && globalIsFinite(value);
  };
  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
    var number = Number(value);
    if (number === 0) { return number; }
    if (numberIsNaN(number)) { return number; }
    return number < 0 ? -1 : 1;
  };

  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
  // can be replaced with require('is-arguments') if we ever use a build process instead
  var isStandardArguments = function isArguments(value) {
    return _toString(value) === '[object Arguments]';
  };
  var isLegacyArguments = function isArguments(value) {
    return value !== null &&
      typeof value === 'object' &&
      typeof value.length === 'number' &&
      value.length >= 0 &&
      _toString(value) !== '[object Array]' &&
      _toString(value.callee) === '[object Function]';
  };
  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

  var Type = {
    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
    string: function (x) { return _toString(x) === '[object String]'; },
    regex: function (x) { return _toString(x) === '[object RegExp]'; },
    symbol: function (x) {
      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
    }
  };

  var overrideNative = function overrideNative(object, property, replacement) {
    var original = object[property];
    defineProperty(object, property, replacement, true);
    Value.preserveToString(object[property], original);
  };

  // eslint-disable-next-line no-restricted-properties
  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());

  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
  // we're going to use an arbitrary _-prefixed name to make our shims
  // work properly with each other, even though we don't have full Iterator
  // support.  That is, `Array.from(map.keys())` will work, but we don't
  // pretend to export a "real" Iterator interface.
  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
  // Firefox ships a partial implementation using the name @@iterator.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
  // So use that name if we detect it.
  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
    $iterator$ = '@@iterator';
  }

  // Reflect
  if (!globals.Reflect) {
    defineProperty(globals, 'Reflect', {}, true);
  }
  var Reflect = globals.Reflect;

  var $String = String;

  /* global document */
  var domAll = (typeof document === 'undefined' || !document) ? null : document.all;
  /* jshint eqnull:true */
  var isNullOrUndefined = domAll == null ? function isNullOrUndefined(x) {
    /* jshint eqnull:true */
    return x == null;
  } : function isNullOrUndefinedAndNotDocumentAll(x) {
    /* jshint eqnull:true */
    return x == null && x !== domAll;
  };

  var ES = {
    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
    Call: function Call(F, V) {
      var args = arguments.length > 2 ? arguments[2] : [];
      if (!ES.IsCallable(F)) {
        throw new TypeError(F + ' is not a function');
      }
      return _apply(F, V, args);
    },

    RequireObjectCoercible: function (x, optMessage) {
      if (isNullOrUndefined(x)) {
        throw new TypeError(optMessage || 'Cannot call method on ' + x);
      }
      return x;
    },

    // This might miss the "(non-standard exotic and does not implement
    // [[Call]])" case from
    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
    // but we can't find any evidence these objects exist in practice.
    // If we find some in the future, you could test `Object(x) === x`,
    // which is reliable according to
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
    // but is not well optimized by runtimes and creates an object
    // whenever it returns false, and thus is very slow.
    TypeIsObject: function (x) {
      if (x === void 0 || x === null || x === true || x === false) {
        return false;
      }
      return typeof x === 'function' || typeof x === 'object' || x === domAll;
    },

    ToObject: function (o, optMessage) {
      return Object(ES.RequireObjectCoercible(o, optMessage));
    },

    IsCallable: isCallable,

    IsConstructor: function (x) {
      // We can't tell callables from constructors in ES5
      return ES.IsCallable(x);
    },

    ToInt32: function (x) {
      return ES.ToNumber(x) >> 0;
    },

    ToUint32: function (x) {
      return ES.ToNumber(x) >>> 0;
    },

    ToNumber: function (value) {
      if (_toString(value) === '[object Symbol]') {
        throw new TypeError('Cannot convert a Symbol value to a number');
      }
      return +value;
    },

    ToInteger: function (value) {
      var number = ES.ToNumber(value);
      if (numberIsNaN(number)) { return 0; }
      if (number === 0 || !numberIsFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * _floor(_abs(number));
    },

    ToLength: function (value) {
      var len = ES.ToInteger(value);
      if (len <= 0) { return 0; } // includes converting -0 to +0
      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
      return len;
    },

    SameValue: function (a, b) {
      if (a === b) {
        // 0 === -0, but they are not identical.
        if (a === 0) { return 1 / a === 1 / b; }
        return true;
      }
      return numberIsNaN(a) && numberIsNaN(b);
    },

    SameValueZero: function (a, b) {
      // same as SameValue except for SameValueZero(+0, -0) == true
      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
    },

    IsIterable: function (o) {
      return ES.TypeIsObject(o) && (typeof o[$iterator$] !== 'undefined' || isArguments(o));
    },

    GetIterator: function (o) {
      if (isArguments(o)) {
        // special case support for `arguments`
        return new ArrayIterator(o, 'value');
      }
      var itFn = ES.GetMethod(o, $iterator$);
      if (!ES.IsCallable(itFn)) {
        // Better diagnostics if itFn is null or undefined
        throw new TypeError('value is not an iterable');
      }
      var it = ES.Call(itFn, o);
      if (!ES.TypeIsObject(it)) {
        throw new TypeError('bad iterator');
      }
      return it;
    },

    GetMethod: function (o, p) {
      var func = ES.ToObject(o)[p];
      if (isNullOrUndefined(func)) {
        return void 0;
      }
      if (!ES.IsCallable(func)) {
        throw new TypeError('Method not callable: ' + p);
      }
      return func;
    },

    IteratorComplete: function (iterResult) {
      return !!iterResult.done;
    },

    IteratorClose: function (iterator, completionIsThrow) {
      var returnMethod = ES.GetMethod(iterator, 'return');
      if (returnMethod === void 0) {
        return;
      }
      var innerResult, innerException;
      try {
        innerResult = ES.Call(returnMethod, iterator);
      } catch (e) {
        innerException = e;
      }
      if (completionIsThrow) {
        return;
      }
      if (innerException) {
        throw innerException;
      }
      if (!ES.TypeIsObject(innerResult)) {
        throw new TypeError("Iterator's return method returned a non-object.");
      }
    },

    IteratorNext: function (it) {
      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
      if (!ES.TypeIsObject(result)) {
        throw new TypeError('bad iterator');
      }
      return result;
    },

    IteratorStep: function (it) {
      var result = ES.IteratorNext(it);
      var done = ES.IteratorComplete(result);
      return done ? false : result;
    },

    Construct: function (C, args, newTarget, isES6internal) {
      var target = typeof newTarget === 'undefined' ? C : newTarget;

      if (!isES6internal && Reflect.construct) {
        // Try to use Reflect.construct if available
        return Reflect.construct(C, args, target);
      }
      // OK, we have to fake it.  This will only work if the
      // C.[[ConstructorKind]] == "base" -- but that's the only
      // kind we can make in ES5 code anyway.

      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
      var proto = target.prototype;
      if (!ES.TypeIsObject(proto)) {
        proto = Object.prototype;
      }
      var obj = create(proto);
      // Call the constructor.
      var result = ES.Call(C, obj, args);
      return ES.TypeIsObject(result) ? result : obj;
    },

    SpeciesConstructor: function (O, defaultConstructor) {
      var C = O.constructor;
      if (C === void 0) {
        return defaultConstructor;
      }
      if (!ES.TypeIsObject(C)) {
        throw new TypeError('Bad constructor');
      }
      var S = C[symbolSpecies];
      if (isNullOrUndefined(S)) {
        return defaultConstructor;
      }
      if (!ES.IsConstructor(S)) {
        throw new TypeError('Bad @@species');
      }
      return S;
    },

    CreateHTML: function (string, tag, attribute, value) {
      var S = ES.ToString(string);
      var p1 = '<' + tag;
      if (attribute !== '') {
        var V = ES.ToString(value);
        var escapedV = V.replace(/"/g, '&quot;');
        p1 += ' ' + attribute + '="' + escapedV + '"';
      }
      var p2 = p1 + '>';
      var p3 = p2 + S;
      return p3 + '</' + tag + '>';
    },

    IsRegExp: function IsRegExp(argument) {
      if (!ES.TypeIsObject(argument)) {
        return false;
      }
      var isRegExp = argument[Symbol.match];
      if (typeof isRegExp !== 'undefined') {
        return !!isRegExp;
      }
      return Type.regex(argument);
    },

    ToString: function ToString(string) {
      return $String(string);
    }
  };

  // Well-known Symbol shims
  if (supportsDescriptors && hasSymbols) {
    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
      if (Type.symbol(Symbol[name])) {
        return Symbol[name];
      }
      // eslint-disable-next-line no-restricted-properties
      var sym = Symbol['for']('Symbol.' + name);
      Object.defineProperty(Symbol, name, {
        configurable: false,
        enumerable: false,
        writable: false,
        value: sym
      });
      return sym;
    };
    if (!Type.symbol(Symbol.search)) {
      var symbolSearch = defineWellKnownSymbol('search');
      var originalSearch = String.prototype.search;
      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
        return ES.Call(originalSearch, string, [this]);
      });
      var searchShim = function search(regexp) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(regexp)) {
          var searcher = ES.GetMethod(regexp, symbolSearch);
          if (typeof searcher !== 'undefined') {
            return ES.Call(searcher, regexp, [O]);
          }
        }
        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
      };
      overrideNative(String.prototype, 'search', searchShim);
    }
    if (!Type.symbol(Symbol.replace)) {
      var symbolReplace = defineWellKnownSymbol('replace');
      var originalReplace = String.prototype.replace;
      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
        return ES.Call(originalReplace, string, [this, replaceValue]);
      });
      var replaceShim = function replace(searchValue, replaceValue) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(searchValue)) {
          var replacer = ES.GetMethod(searchValue, symbolReplace);
          if (typeof replacer !== 'undefined') {
            return ES.Call(replacer, searchValue, [O, replaceValue]);
          }
        }
        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
      };
      overrideNative(String.prototype, 'replace', replaceShim);
    }
    if (!Type.symbol(Symbol.split)) {
      var symbolSplit = defineWellKnownSymbol('split');
      var originalSplit = String.prototype.split;
      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
        return ES.Call(originalSplit, string, [this, limit]);
      });
      var splitShim = function split(separator, limit) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(separator)) {
          var splitter = ES.GetMethod(separator, symbolSplit);
          if (typeof splitter !== 'undefined') {
            return ES.Call(splitter, separator, [O, limit]);
          }
        }
        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
      };
      overrideNative(String.prototype, 'split', splitShim);
    }
    var symbolMatchExists = Type.symbol(Symbol.match);
    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
      // Firefox 40 and below have Symbol.match but String#match works fine.
      var o = {};
      o[Symbol.match] = function () { return 42; };
      return 'a'.match(o) !== 42;
    }());
    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
      var symbolMatch = defineWellKnownSymbol('match');

      var originalMatch = String.prototype.match;
      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
        return ES.Call(originalMatch, string, [this]);
      });

      var matchShim = function match(regexp) {
        var O = ES.RequireObjectCoercible(this);
        if (!isNullOrUndefined(regexp)) {
          var matcher = ES.GetMethod(regexp, symbolMatch);
          if (typeof matcher !== 'undefined') {
            return ES.Call(matcher, regexp, [O]);
          }
        }
        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
      };
      overrideNative(String.prototype, 'match', matchShim);
    }
  }

  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
    Value.preserveToString(replacement, original);
    if (Object.setPrototypeOf) {
      // sets up proper prototype chain where possible
      Object.setPrototypeOf(original, replacement);
    }
    if (supportsDescriptors) {
      _forEach(Object.getOwnPropertyNames(original), function (key) {
        if (key in noop || keysToSkip[key]) { return; }
        Value.proxy(original, key, replacement);
      });
    } else {
      _forEach(Object.keys(original), function (key) {
        if (key in noop || keysToSkip[key]) { return; }
        replacement[key] = original[key];
      });
    }
    replacement.prototype = original.prototype;
    Value.redefine(original.prototype, 'constructor', replacement);
  };

  var defaultSpeciesGetter = function () { return this; };
  var addDefaultSpecies = function (C) {
    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
    }
  };

  var addIterator = function (prototype, impl) {
    var implementation = impl || function iterator() { return this; };
    defineProperty(prototype, $iterator$, implementation);
    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
      // implementations are buggy when $iterator$ is a Symbol
      prototype[$iterator$] = implementation;
    }
  };

  var createDataProperty = function createDataProperty(object, name, value) {
    if (supportsDescriptors) {
      Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };
  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
    createDataProperty(object, name, value);
    if (!ES.SameValue(object[name], value)) {
      throw new TypeError('property is nonconfigurable');
    }
  };

  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
    // This is an es5 approximation to es6 construct semantics.  in es6,
    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
    // to Foo and then returns Foo().

    // Many ES6 object then have constructors of the form:
    // 1. If NewTarget is undefined, throw a TypeError exception
    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)

    // So we're going to emulate those first two steps.
    if (!ES.TypeIsObject(o)) {
      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
    }
    var proto = defaultNewTarget.prototype;
    if (!ES.TypeIsObject(proto)) {
      proto = defaultProto;
    }
    var obj = create(proto);
    for (var name in slots) {
      if (_hasOwnProperty(slots, name)) {
        var value = slots[name];
        defineProperty(obj, name, value, true);
      }
    }
    return obj;
  };

  // Firefox 31 reports this function's length as 0
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
    var originalFromCodePoint = String.fromCodePoint;
    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
      return ES.Call(originalFromCodePoint, this, arguments);
    });
  }

  var StringShims = {
    fromCodePoint: function fromCodePoint(codePoints) {
      var result = [];
      var next;
      for (var i = 0, length = arguments.length; i < length; i++) {
        next = Number(arguments[i]);
        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
          throw new RangeError('Invalid code point ' + next);
        }

        if (next < 0x10000) {
          _push(result, String.fromCharCode(next));
        } else {
          next -= 0x10000;
          _push(result, String.fromCharCode((next >> 10) + 0xD800));
          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
        }
      }
      return result.join('');
    },

    raw: function raw(callSite) {
      var cooked = ES.ToObject(callSite, 'bad callSite');
      var rawString = ES.ToObject(cooked.raw, 'bad raw value');
      var len = rawString.length;
      var literalsegments = ES.ToLength(len);
      if (literalsegments <= 0) {
        return '';
      }

      var stringElements = [];
      var nextIndex = 0;
      var nextKey, next, nextSeg, nextSub;
      while (nextIndex < literalsegments) {
        nextKey = ES.ToString(nextIndex);
        nextSeg = ES.ToString(rawString[nextKey]);
        _push(stringElements, nextSeg);
        if (nextIndex + 1 >= literalsegments) {
          break;
        }
        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
        nextSub = ES.ToString(next);
        _push(stringElements, nextSub);
        nextIndex += 1;
      }
      return stringElements.join('');
    }
  };
  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
    // IE 11 TP has a broken String.raw implementation
    overrideNative(String, 'raw', StringShims.raw);
  }
  defineProperties(String, StringShims);

  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
  // Perf: http://jsperf.com/string-repeat2/2
  var stringRepeat = function repeat(s, times) {
    if (times < 1) { return ''; }
    if (times % 2) { return repeat(s, times - 1) + s; }
    var half = repeat(s, times / 2);
    return half + half;
  };
  var stringMaxLength = Infinity;

  var StringPrototypeShims = {
    repeat: function repeat(times) {
      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
      var numTimes = ES.ToInteger(times);
      if (numTimes < 0 || numTimes >= stringMaxLength) {
        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
      }
      return stringRepeat(thisStr, numTimes);
    },

    startsWith: function startsWith(searchString) {
      var S = ES.ToString(ES.RequireObjectCoercible(this));
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('Cannot call method "startsWith" with a regex');
      }
      var searchStr = ES.ToString(searchString);
      var position;
      if (arguments.length > 1) {
        position = arguments[1];
      }
      var start = _max(ES.ToInteger(position), 0);
      return _strSlice(S, start, start + searchStr.length) === searchStr;
    },

    endsWith: function endsWith(searchString) {
      var S = ES.ToString(ES.RequireObjectCoercible(this));
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('Cannot call method "endsWith" with a regex');
      }
      var searchStr = ES.ToString(searchString);
      var len = S.length;
      var endPosition;
      if (arguments.length > 1) {
        endPosition = arguments[1];
      }
      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
      var end = _min(_max(pos, 0), len);
      return _strSlice(S, end - searchStr.length, end) === searchStr;
    },

    includes: function includes(searchString) {
      if (ES.IsRegExp(searchString)) {
        throw new TypeError('"includes" does not accept a RegExp');
      }
      var searchStr = ES.ToString(searchString);
      var position;
      if (arguments.length > 1) {
        position = arguments[1];
      }
      // Somehow this trick makes method 100% compat with the spec.
      return _indexOf(this, searchStr, position) !== -1;
    },

    codePointAt: function codePointAt(pos) {
      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
      var position = ES.ToInteger(pos);
      var length = thisStr.length;
      if (position >= 0 && position < length) {
        var first = thisStr.charCodeAt(position);
        var isEnd = position + 1 === length;
        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
        var second = thisStr.charCodeAt(position + 1);
        if (second < 0xDC00 || second > 0xDFFF) { return first; }
        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
      }
    }
  };
  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
  }

  if (String.prototype.startsWith && String.prototype.endsWith) {
    var startsWithRejectsRegex = throwsError(function () {
      /* throws if spec-compliant */
      '/a/'.startsWith(/a/);
    });
    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
      return 'abc'.startsWith('a', Infinity) === false;
    });
    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
    }
  }
  if (hasSymbols) {
    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.startsWith(re);
    });
    if (!startsWithSupportsSymbolMatch) {
      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
    }
    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.endsWith(re);
    });
    if (!endsWithSupportsSymbolMatch) {
      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
    }
    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
      var re = /a/;
      re[Symbol.match] = false;
      return '/a/'.includes(re);
    });
    if (!includesSupportsSymbolMatch) {
      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
    }
  }

  defineProperties(String.prototype, StringPrototypeShims);

  // whitespace from: http://es5.github.io/#x15.5.4.20
  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
  var ws = [
    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
    '\u2029\uFEFF'
  ].join('');
  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
  var trimShim = function trim() {
    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
  };
  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
  var isBadHexRegex = /^[-+]0x[0-9a-f]+$/i;
  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);

  // Given an argument x, it will return an IteratorResult object,
  // with value set to x and done to false.
  // Given no arguments, it will return an iterator completion object.
  var iteratorResult = function (x) {
    return { value: x, done: arguments.length === 0 };
  };

  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
  var StringIterator = function (s) {
    ES.RequireObjectCoercible(s);
    this._s = ES.ToString(s);
    this._i = 0;
  };
  StringIterator.prototype.next = function () {
    var s = this._s;
    var i = this._i;
    if (typeof s === 'undefined' || i >= s.length) {
      this._s = void 0;
      return iteratorResult();
    }
    var first = s.charCodeAt(i);
    var second, len;
    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
      len = 1;
    } else {
      second = s.charCodeAt(i + 1);
      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
    }
    this._i = i + len;
    return iteratorResult(s.substr(i, len));
  };
  addIterator(StringIterator.prototype);
  addIterator(String.prototype, function () {
    return new StringIterator(this);
  });

  var ArrayShims = {
    from: function from(items) {
      var C = this;
      var mapFn;
      if (arguments.length > 1) {
        mapFn = arguments[1];
      }
      var mapping, T;
      if (typeof mapFn === 'undefined') {
        mapping = false;
      } else {
        if (!ES.IsCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }
        if (arguments.length > 2) {
          T = arguments[2];
        }
        mapping = true;
      }

      // Note that that Arrays will use ArrayIterator:
      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';

      var length, result, i;
      if (usingIterator) {
        result = ES.IsConstructor(C) ? Object(new C()) : [];
        var iterator = ES.GetIterator(items);
        var next, nextValue;

        i = 0;
        while (true) {
          next = ES.IteratorStep(iterator);
          if (next === false) {
            break;
          }
          nextValue = next.value;
          try {
            if (mapping) {
              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
            }
            result[i] = nextValue;
          } catch (e) {
            ES.IteratorClose(iterator, true);
            throw e;
          }
          i += 1;
        }
        length = i;
      } else {
        var arrayLike = ES.ToObject(items);
        length = ES.ToLength(arrayLike.length);
        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
        var value;
        for (i = 0; i < length; ++i) {
          value = arrayLike[i];
          if (mapping) {
            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
          }
          createDataPropertyOrThrow(result, i, value);
        }
      }

      result.length = length;
      return result;
    },

    of: function of() {
      var len = arguments.length;
      var C = this;
      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
      for (var k = 0; k < len; ++k) {
        createDataPropertyOrThrow(A, k, arguments[k]);
      }
      A.length = len;
      return A;
    }
  };
  defineProperties(Array, ArrayShims);
  addDefaultSpecies(Array);

  // Our ArrayIterator is private; see
  // https://github.com/paulmillr/es6-shim/issues/252
  ArrayIterator = function (array, kind) {
    this.i = 0;
    this.array = array;
    this.kind = kind;
  };

  defineProperties(ArrayIterator.prototype, {
    next: function () {
      var i = this.i;
      var array = this.array;
      if (!(this instanceof ArrayIterator)) {
        throw new TypeError('Not an ArrayIterator');
      }
      if (typeof array !== 'undefined') {
        var len = ES.ToLength(array.length);
        for (; i < len; i++) {
          var kind = this.kind;
          var retval;
          if (kind === 'key') {
            retval = i;
          } else if (kind === 'value') {
            retval = array[i];
          } else if (kind === 'entry') {
            retval = [i, array[i]];
          }
          this.i = i + 1;
          return iteratorResult(retval);
        }
      }
      this.array = void 0;
      return iteratorResult();
    }
  });
  addIterator(ArrayIterator.prototype);

/*
  var orderKeys = function orderKeys(a, b) {
    var aNumeric = String(ES.ToInteger(a)) === a;
    var bNumeric = String(ES.ToInteger(b)) === b;
    if (aNumeric && bNumeric) {
      return b - a;
    } else if (aNumeric && !bNumeric) {
      return -1;
    } else if (!aNumeric && bNumeric) {
      return 1;
    } else {
      return a.localeCompare(b);
    }
  };

  var getAllKeys = function getAllKeys(object) {
    var ownKeys = [];
    var keys = [];

    for (var key in object) {
      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
    }
    _sort(ownKeys, orderKeys);
    _sort(keys, orderKeys);

    return _concat(ownKeys, keys);
  };
  */

  // note: this is positioned here because it depends on ArrayIterator
  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
    // Detects a bug in Webkit nightly r181886
    var Foo = function Foo(len) { this.length = len; };
    Foo.prototype = [];
    var fooArr = Array.of.apply(Foo, [1, 2]);
    return fooArr instanceof Foo && fooArr.length === 2;
  }());
  if (!arrayOfSupportsSubclassing) {
    overrideNative(Array, 'of', ArrayShims.of);
  }

  var ArrayPrototypeShims = {
    copyWithin: function copyWithin(target, start) {
      var o = ES.ToObject(this);
      var len = ES.ToLength(o.length);
      var relativeTarget = ES.ToInteger(target);
      var relativeStart = ES.ToInteger(start);
      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
      var end;
      if (arguments.length > 2) {
        end = arguments[2];
      }
      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
      var count = _min(finalItem - from, len - to);
      var direction = 1;
      if (from < to && to < (from + count)) {
        direction = -1;
        from += count - 1;
        to += count - 1;
      }
      while (count > 0) {
        if (from in o) {
          o[to] = o[from];
        } else {
          delete o[to];
        }
        from += direction;
        to += direction;
        count -= 1;
      }
      return o;
    },

    fill: function fill(value) {
      var start;
      if (arguments.length > 1) {
        start = arguments[1];
      }
      var end;
      if (arguments.length > 2) {
        end = arguments[2];
      }
      var O = ES.ToObject(this);
      var len = ES.ToLength(O.length);
      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
      end = ES.ToInteger(typeof end === 'undefined' ? len : end);

      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
      var relativeEnd = end < 0 ? len + end : end;

      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
        O[i] = value;
      }
      return O;
    },

    find: function find(predicate) {
      var list = ES.ToObject(this);
      var length = ES.ToLength(list.length);
      if (!ES.IsCallable(predicate)) {
        throw new TypeError('Array#find: predicate must be a function');
      }
      var thisArg = arguments.length > 1 ? arguments[1] : null;
      for (var i = 0, value; i < length; i++) {
        value = list[i];
        if (thisArg) {
          if (_call(predicate, thisArg, value, i, list)) {
            return value;
          }
        } else if (predicate(value, i, list)) {
          return value;
        }
      }
    },

    findIndex: function findIndex(predicate) {
      var list = ES.ToObject(this);
      var length = ES.ToLength(list.length);
      if (!ES.IsCallable(predicate)) {
        throw new TypeError('Array#findIndex: predicate must be a function');
      }
      var thisArg = arguments.length > 1 ? arguments[1] : null;
      for (var i = 0; i < length; i++) {
        if (thisArg) {
          if (_call(predicate, thisArg, list[i], i, list)) {
            return i;
          }
        } else if (predicate(list[i], i, list)) {
          return i;
        }
      }
      return -1;
    },

    keys: function keys() {
      return new ArrayIterator(this, 'key');
    },

    values: function values() {
      return new ArrayIterator(this, 'value');
    },

    entries: function entries() {
      return new ArrayIterator(this, 'entry');
    }
  };
  // Safari 7.1 defines Array#keys and Array#entries natively,
  // but the resulting ArrayIterator objects don't have a "next" method.
  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
    delete Array.prototype.keys;
  }
  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
    delete Array.prototype.entries;
  }

  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
    defineProperties(Array.prototype, {
      values: Array.prototype[$iterator$]
    });
    if (Type.symbol(Symbol.unscopables)) {
      Array.prototype[Symbol.unscopables].values = true;
    }
  }
  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
    var originalArrayPrototypeValues = Array.prototype.values;
    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
  }
  defineProperties(Array.prototype, ArrayPrototypeShims);

  if (1 / [true].indexOf(true, -0) < 0) {
    // indexOf when given a position arg of -0 should return +0.
    // https://github.com/tc39/ecma262/pull/316
    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
      var value = _arrayIndexOfApply(this, arguments);
      if (value === 0 && (1 / value) < 0) {
        return 0;
      }
      return value;
    }, true);
  }

  addIterator(Array.prototype, function () { return this.values(); });
  // Chrome defines keys/values/entries on Array, but doesn't give us
  // any way to identify its iterator.  So add our own shimmed field.
  if (Object.getPrototypeOf) {
    addIterator(Object.getPrototypeOf([].values()));
  }

  // note: this is positioned here because it relies on Array#entries
  var arrayFromSwallowsNegativeLengths = (function () {
    // Detects a Firefox bug in v32
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
    return valueOrFalseIfThrows(function () {
      return Array.from({ length: -1 }).length === 0;
    });
  }());
  var arrayFromHandlesIterables = (function () {
    // Detects a bug in Webkit nightly r181886
    var arr = Array.from([0].entries());
    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
  }());
  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
    overrideNative(Array, 'from', ArrayShims.from);
  }
  var arrayFromHandlesUndefinedMapFunction = (function () {
    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
    return valueOrFalseIfThrows(function () {
      return Array.from([0], void 0);
    });
  }());
  if (!arrayFromHandlesUndefinedMapFunction) {
    var origArrayFrom = Array.from;
    overrideNative(Array, 'from', function from(items) {
      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
        return ES.Call(origArrayFrom, this, arguments);
      } else {
        return _call(origArrayFrom, this, items);
      }
    });
  }

  var int32sAsOne = -(Math.pow(2, 32) - 1);
  var toLengthsCorrectly = function (method, reversed) {
    var obj = { length: int32sAsOne };
    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
    return valueOrFalseIfThrows(function () {
      _call(method, obj, function () {
        // note: in nonconforming browsers, this will be called
        // -1 >>> 0 times, which is 4294967295, so the throw matters.
        throw new RangeError('should not reach here');
      }, []);
      return true;
    });
  };
  if (!toLengthsCorrectly(Array.prototype.forEach)) {
    var originalForEach = Array.prototype.forEach;
    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.map)) {
    var originalMap = Array.prototype.map;
    overrideNative(Array.prototype, 'map', function map(callbackFn) {
      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.filter)) {
    var originalFilter = Array.prototype.filter;
    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.some)) {
    var originalSome = Array.prototype.some;
    overrideNative(Array.prototype, 'some', function some(callbackFn) {
      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.every)) {
    var originalEvery = Array.prototype.every;
    overrideNative(Array.prototype, 'every', function every(callbackFn) {
      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.reduce)) {
    var originalReduce = Array.prototype.reduce;
    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
    }, true);
  }
  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
    var originalReduceRight = Array.prototype.reduceRight;
    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
    }, true);
  }

  var lacksOctalSupport = Number('0o10') !== 8;
  var lacksBinarySupport = Number('0b10') !== 2;
  var trimsNonWhitespace = _some(nonWS, function (c) {
    return Number(c + 0 + c) === 0;
  });
  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
    var OrigNumber = Number;
    var binaryRegex = /^0b[01]+$/i;
    var octalRegex = /^0o[0-7]+$/i;
    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
    var isBinary = binaryRegex.test.bind(binaryRegex);
    var isOctal = octalRegex.test.bind(octalRegex);
    var toPrimitive = function (O) { // need to replace this with `es-to-primitive/es6`
      var result;
      if (typeof O.valueOf === 'function') {
        result = O.valueOf();
        if (Type.primitive(result)) {
          return result;
        }
      }
      if (typeof O.toString === 'function') {
        result = O.toString();
        if (Type.primitive(result)) {
          return result;
        }
      }
      throw new TypeError('No default value');
    };
    var hasNonWS = nonWSregex.test.bind(nonWSregex);
    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
    var NumberShim = (function () {
      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
      var NumberShim = function Number(value) {
        var primValue;
        if (arguments.length > 0) {
          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
        } else {
          primValue = 0;
        }
        if (typeof primValue === 'string') {
          primValue = ES.Call(trimShim, primValue);
          if (isBinary(primValue)) {
            primValue = parseInt(_strSlice(primValue, 2), 2);
          } else if (isOctal(primValue)) {
            primValue = parseInt(_strSlice(primValue, 2), 8);
          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
            primValue = NaN;
          }
        }
        var receiver = this;
        var valueOfSucceeds = valueOrFalseIfThrows(function () {
          OrigNumber.prototype.valueOf.call(receiver);
          return true;
        });
        if (receiver instanceof NumberShim && !valueOfSucceeds) {
          return new OrigNumber(primValue);
        }
        /* jshint newcap: false */
        return OrigNumber(primValue);
        /* jshint newcap: true */
      };
      return NumberShim;
    }());
    wrapConstructor(OrigNumber, NumberShim, {});
    // this is necessary for ES3 browsers, where these properties are non-enumerable.
    defineProperties(NumberShim, {
      NaN: OrigNumber.NaN,
      MAX_VALUE: OrigNumber.MAX_VALUE,
      MIN_VALUE: OrigNumber.MIN_VALUE,
      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
    });
    /* globals Number: true */
    /* eslint-disable no-undef, no-global-assign */
    /* jshint -W020 */
    Number = NumberShim;
    Value.redefine(globals, 'Number', NumberShim);
    /* jshint +W020 */
    /* eslint-enable no-undef, no-global-assign */
    /* globals Number: false */
  }

  var maxSafeInteger = Math.pow(2, 53) - 1;
  defineProperties(Number, {
    MAX_SAFE_INTEGER: maxSafeInteger,
    MIN_SAFE_INTEGER: -maxSafeInteger,
    EPSILON: 2.220446049250313e-16,

    parseInt: globals.parseInt,
    parseFloat: globals.parseFloat,

    isFinite: numberIsFinite,

    isInteger: function isInteger(value) {
      return numberIsFinite(value) && ES.ToInteger(value) === value;
    },

    isSafeInteger: function isSafeInteger(value) {
      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
    },

    isNaN: numberIsNaN
  });
  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);

  // Work around bugs in Array#find and Array#findIndex -- early
  // implementations skipped holes in sparse arrays. (Note that the
  // implementations of find/findIndex indirectly use shimmed
  // methods of Number, so this test has to happen down here.)
  /*jshint elision: true */
  /* eslint-disable no-sparse-arrays */
  if ([, 1].find(function () { return true; }) === 1) {
    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
  }
  if ([, 1].findIndex(function () { return true; }) !== 0) {
    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
  }
  /* eslint-enable no-sparse-arrays */
  /*jshint elision: false */

  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
  var ensureEnumerable = function ensureEnumerable(obj, prop) {
    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
      Object.defineProperty(obj, prop, { enumerable: false });
    }
  };
  var sliceArgs = function sliceArgs() {
    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
    var initial = Number(this);
    var len = arguments.length;
    var desiredArgCount = len - initial;
    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
    for (var i = initial; i < len; ++i) {
      args[i - initial] = arguments[i];
    }
    return args;
  };
  var assignTo = function assignTo(source) {
    return function assignToSource(target, key) {
      target[key] = source[key];
      return target;
    };
  };
  var assignReducer = function (target, source) {
    var sourceKeys = keys(Object(source));
    var symbols;
    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
    }
    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
  };

  var ObjectShims = {
    // 19.1.3.1
    assign: function (target, source) {
      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
    },

    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
    is: function is(a, b) {
      return ES.SameValue(a, b);
    }
  };
  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
    // which is 72% slower than our shim, and Firefox 40's native implementation.
    var thrower = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(thrower, 'xy');
    } catch (e) {
      return thrower[1] === 'y';
    }
  }());
  if (assignHasPendingExceptions) {
    overrideNative(Object, 'assign', ObjectShims.assign);
  }
  defineProperties(Object, ObjectShims);

  if (supportsDescriptors) {
    var ES5ObjectShims = {
      // 19.1.3.9
      // shim from https://gist.github.com/WebReflection/5593554
      setPrototypeOf: (function (Object, magic) {
        var set;

        var checkArgs = function (O, proto) {
          if (!ES.TypeIsObject(O)) {
            throw new TypeError('cannot set prototype on a non-object');
          }
          if (!(proto === null || ES.TypeIsObject(proto))) {
            throw new TypeError('can only set prototype to an object or null' + proto);
          }
        };

        var setPrototypeOf = function (O, proto) {
          checkArgs(O, proto);
          _call(set, O, proto);
          return O;
        };

        try {
          // this works already in Firefox and Safari
          set = Object.getOwnPropertyDescriptor(Object.prototype, magic).set;
          _call(set, {}, null);
        } catch (e) {
          if (Object.prototype !== {}[magic]) {
            // IE < 11 cannot be shimmed
            return;
          }
          // probably Chrome or some old Mobile stock browser
          set = function (proto) {
            this[magic] = proto;
          };
          // please note that this will **not** work
          // in those browsers that do not inherit
          // __proto__ by mistake from Object.prototype
          // in these cases we should probably throw an error
          // or at least be informed about the issue
          setPrototypeOf.polyfill = setPrototypeOf(
            setPrototypeOf({}, null),
            Object.prototype
          ) instanceof Object;
          // setPrototypeOf.polyfill === true means it works as meant
          // setPrototypeOf.polyfill === false means it's not 100% reliable
          // setPrototypeOf.polyfill === undefined
          // or
          // setPrototypeOf.polyfill ==  null means it's not a polyfill
          // which means it works as expected
          // we can even delete Object.prototype.__proto__;
        }
        return setPrototypeOf;
      }(Object, '__proto__'))
    };

    defineProperties(Object, ES5ObjectShims);
  }

  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
  // but Object.create(null) does.
  if (Object.setPrototypeOf && Object.getPrototypeOf &&
      Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null &&
      Object.getPrototypeOf(Object.create(null)) === null) {
    (function () {
      var FAKENULL = Object.create(null);
      var gpo = Object.getPrototypeOf;
      var spo = Object.setPrototypeOf;
      Object.getPrototypeOf = function (o) {
        var result = gpo(o);
        return result === FAKENULL ? null : result;
      };
      Object.setPrototypeOf = function (o, p) {
        var proto = p === null ? FAKENULL : p;
        return spo(o, proto);
      };
      Object.setPrototypeOf.polyfill = false;
    }());
  }

  var objectKeysAcceptsPrimitives = !throwsError(function () { Object.keys('foo'); });
  if (!objectKeysAcceptsPrimitives) {
    var originalObjectKeys = Object.keys;
    overrideNative(Object, 'keys', function keys(value) {
      return originalObjectKeys(ES.ToObject(value));
    });
    keys = Object.keys;
  }
  var objectKeysRejectsRegex = throwsError(function () { Object.keys(/a/g); });
  if (objectKeysRejectsRegex) {
    var regexRejectingObjectKeys = Object.keys;
    overrideNative(Object, 'keys', function keys(value) {
      if (Type.regex(value)) {
        var regexKeys = [];
        for (var k in value) {
          if (_hasOwnProperty(value, k)) {
            _push(regexKeys, k);
          }
        }
        return regexKeys;
      }
      return regexRejectingObjectKeys(value);
    });
    keys = Object.keys;
  }

  if (Object.getOwnPropertyNames) {
    var objectGOPNAcceptsPrimitives = !throwsError(function () { Object.getOwnPropertyNames('foo'); });
    if (!objectGOPNAcceptsPrimitives) {
      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
        var val = ES.ToObject(value);
        if (_toString(val) === '[object Window]') {
          try {
            return originalObjectGetOwnPropertyNames(val);
          } catch (e) {
            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
            return _concat([], cachedWindowNames);
          }
        }
        return originalObjectGetOwnPropertyNames(val);
      });
    }
  }
  if (Object.getOwnPropertyDescriptor) {
    var objectGOPDAcceptsPrimitives = !throwsError(function () { Object.getOwnPropertyDescriptor('foo', 'bar'); });
    if (!objectGOPDAcceptsPrimitives) {
      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
      });
    }
  }
  if (Object.seal) {
    var objectSealAcceptsPrimitives = !throwsError(function () { Object.seal('foo'); });
    if (!objectSealAcceptsPrimitives) {
      var originalObjectSeal = Object.seal;
      overrideNative(Object, 'seal', function seal(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectSeal(value);
      });
    }
  }
  if (Object.isSealed) {
    var objectIsSealedAcceptsPrimitives = !throwsError(function () { Object.isSealed('foo'); });
    if (!objectIsSealedAcceptsPrimitives) {
      var originalObjectIsSealed = Object.isSealed;
      overrideNative(Object, 'isSealed', function isSealed(value) {
        if (!ES.TypeIsObject(value)) { return true; }
        return originalObjectIsSealed(value);
      });
    }
  }
  if (Object.freeze) {
    var objectFreezeAcceptsPrimitives = !throwsError(function () { Object.freeze('foo'); });
    if (!objectFreezeAcceptsPrimitives) {
      var originalObjectFreeze = Object.freeze;
      overrideNative(Object, 'freeze', function freeze(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectFreeze(value);
      });
    }
  }
  if (Object.isFrozen) {
    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { Object.isFrozen('foo'); });
    if (!objectIsFrozenAcceptsPrimitives) {
      var originalObjectIsFrozen = Object.isFrozen;
      overrideNative(Object, 'isFrozen', function isFrozen(value) {
        if (!ES.TypeIsObject(value)) { return true; }
        return originalObjectIsFrozen(value);
      });
    }
  }
  if (Object.preventExtensions) {
    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { Object.preventExtensions('foo'); });
    if (!objectPreventExtensionsAcceptsPrimitives) {
      var originalObjectPreventExtensions = Object.preventExtensions;
      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
        if (!ES.TypeIsObject(value)) { return value; }
        return originalObjectPreventExtensions(value);
      });
    }
  }
  if (Object.isExtensible) {
    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { Object.isExtensible('foo'); });
    if (!objectIsExtensibleAcceptsPrimitives) {
      var originalObjectIsExtensible = Object.isExtensible;
      overrideNative(Object, 'isExtensible', function isExtensible(value) {
        if (!ES.TypeIsObject(value)) { return false; }
        return originalObjectIsExtensible(value);
      });
    }
  }
  if (Object.getPrototypeOf) {
    var objectGetProtoAcceptsPrimitives = !throwsError(function () { Object.getPrototypeOf('foo'); });
    if (!objectGetProtoAcceptsPrimitives) {
      var originalGetProto = Object.getPrototypeOf;
      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
        return originalGetProto(ES.ToObject(value));
      });
    }
  }

  var hasFlags = supportsDescriptors && (function () {
    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
    return desc && ES.IsCallable(desc.get);
  }());
  if (supportsDescriptors && !hasFlags) {
    var regExpFlagsGetter = function flags() {
      if (!ES.TypeIsObject(this)) {
        throw new TypeError('Method called on incompatible type: must be an object.');
      }
      var result = '';
      if (this.global) {
        result += 'g';
      }
      if (this.ignoreCase) {
        result += 'i';
      }
      if (this.multiline) {
        result += 'm';
      }
      if (this.unicode) {
        result += 'u';
      }
      if (this.sticky) {
        result += 'y';
      }
      return result;
    };

    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
  }

  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
    return String(new RegExp(/a/g, 'i')) === '/a/i';
  });
  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
    // Edge 0.12 supports flags fully, but does not support Symbol.match
    var regex = /./;
    regex[Symbol.match] = false;
    return RegExp(regex) === regex;
  }());

  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
  });
  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
  });
  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
    var origRegExpToString = RegExp.prototype.toString;
    defineProperty(RegExp.prototype, 'toString', function toString() {
      var R = ES.RequireObjectCoercible(this);
      if (Type.regex(R)) {
        return _call(origRegExpToString, R);
      }
      var pattern = $String(R.source);
      var flags = $String(R.flags);
      return '/' + pattern + '/' + flags;
    }, true);
    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
  }

  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
    var legacySourceGetter = function () {
      // prior to it being a getter, it's own + nonconfigurable
      return this.source;
    };
    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;

    var OrigRegExp = RegExp;
    var RegExpShim = (function () {
      return function RegExp(pattern, flags) {
        var patternIsRegExp = ES.IsRegExp(pattern);
        var calledWithNew = this instanceof RegExp;
        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
          return pattern;
        }

        var P = pattern;
        var F = flags;
        if (Type.regex(pattern)) {
          P = ES.Call(sourceGetter, pattern);
          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
          return new RegExp(P, F);
        } else if (patternIsRegExp) {
          P = pattern.source;
          F = typeof flags === 'undefined' ? pattern.flags : flags;
        }
        return new OrigRegExp(pattern, flags);
      };
    }());
    wrapConstructor(OrigRegExp, RegExpShim, {
      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
    });
    /* globals RegExp: true */
    /* eslint-disable no-undef, no-global-assign */
    /* jshint -W020 */
    RegExp = RegExpShim;
    Value.redefine(globals, 'RegExp', RegExpShim);
    /* jshint +W020 */
    /* eslint-enable no-undef, no-global-assign */
    /* globals RegExp: false */
  }

  if (supportsDescriptors) {
    var regexGlobals = {
      input: '$_',
      lastMatch: '$&',
      lastParen: '$+',
      leftContext: '$`',
      rightContext: '$\''
    };
    _forEach(keys(regexGlobals), function (prop) {
      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
        Value.getter(RegExp, regexGlobals[prop], function get() {
          return RegExp[prop];
        });
      }
    });
  }
  addDefaultSpecies(RegExp);

  var inverseEpsilon = 1 / Number.EPSILON;
  var roundTiesToEven = function roundTiesToEven(n) {
    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
    return (n + inverseEpsilon) - inverseEpsilon;
  };
  var BINARY_32_EPSILON = Math.pow(2, -23);
  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
  var E = Math.E;
  var LOG2E = Math.LOG2E;
  var LOG10E = Math.LOG10E;
  var numberCLZ = Number.prototype.clz;
  delete Number.prototype.clz; // Safari 8 has Number#clz

  var MathShims = {
    acosh: function acosh(value) {
      var x = Number(value);
      if (numberIsNaN(x) || value < 1) { return NaN; }
      if (x === 1) { return 0; }
      if (x === Infinity) { return x; }
      return _log((x / E) + (_sqrt(x + 1) * _sqrt(x - 1) / E)) + 1;
    },

    asinh: function asinh(value) {
      var x = Number(value);
      if (x === 0 || !globalIsFinite(x)) {
        return x;
      }
      return x < 0 ? -asinh(-x) : _log(x + _sqrt((x * x) + 1));
    },

    atanh: function atanh(value) {
      var x = Number(value);
      if (numberIsNaN(x) || x < -1 || x > 1) {
        return NaN;
      }
      if (x === -1) { return -Infinity; }
      if (x === 1) { return Infinity; }
      if (x === 0) { return x; }
      return 0.5 * _log((1 + x) / (1 - x));
    },

    cbrt: function cbrt(value) {
      var x = Number(value);
      if (x === 0) { return x; }
      var negate = x < 0;
      var result;
      if (negate) { x = -x; }
      if (x === Infinity) {
        result = Infinity;
      } else {
        result = _exp(_log(x) / 3);
        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = ((x / (result * result)) + (2 * result)) / 3;
      }
      return negate ? -result : result;
    },

    clz32: function clz32(value) {
      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
      var x = Number(value);
      var number = ES.ToUint32(x);
      if (number === 0) {
        return 32;
      }
      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
    },

    cosh: function cosh(value) {
      var x = Number(value);
      if (x === 0) { return 1; } // +0 or -0
      if (numberIsNaN(x)) { return NaN; }
      if (!globalIsFinite(x)) { return Infinity; }
      if (x < 0) { x = -x; }
      if (x > 21) { return _exp(x) / 2; }
      return (_exp(x) + _exp(-x)) / 2;
    },

    expm1: function expm1(value) {
      var x = Number(value);
      if (x === -Infinity) { return -1; }
      if (!globalIsFinite(x) || x === 0) { return x; }
      if (_abs(x) > 0.5) {
        return _exp(x) - 1;
      }
      // A more precise approximation using Taylor series expansion
      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
      var t = x;
      var sum = 0;
      var n = 1;
      while (sum + t !== sum) {
        sum += t;
        n += 1;
        t *= x / n;
      }
      return sum;
    },

    hypot: function hypot(x, y) {
      var result = 0;
      var largest = 0;
      for (var i = 0; i < arguments.length; ++i) {
        var value = _abs(Number(arguments[i]));
        if (largest < value) {
          result *= (largest / value) * (largest / value);
          result += 1;
          largest = value;
        } else {
          result += value > 0 ? (value / largest) * (value / largest) : value;
        }
      }
      return largest === Infinity ? Infinity : largest * _sqrt(result);
    },

    log2: function log2(value) {
      return _log(value) * LOG2E;
    },

    log10: function log10(value) {
      return _log(value) * LOG10E;
    },

    log1p: function log1p(value) {
      var x = Number(value);
      if (x < -1 || numberIsNaN(x)) { return NaN; }
      if (x === 0 || x === Infinity) { return x; }
      if (x === -1) { return -Infinity; }

      return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
    },

    sign: _sign,

    sinh: function sinh(value) {
      var x = Number(value);
      if (!globalIsFinite(x) || x === 0) { return x; }

      if (_abs(x) < 1) {
        return (Math.expm1(x) - Math.expm1(-x)) / 2;
      }
      return (_exp(x - 1) - _exp(-x - 1)) * E / 2;
    },

    tanh: function tanh(value) {
      var x = Number(value);
      if (numberIsNaN(x) || x === 0) { return x; }
      // can exit early at +-20 as JS loses precision for true value at this integer
      if (x >= 20) { return 1; }
      if (x <= -20) { return -1; }

      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
    },

    trunc: function trunc(value) {
      var x = Number(value);
      return x < 0 ? -_floor(-x) : _floor(x);
    },

    imul: function imul(x, y) {
      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
      var a = ES.ToUint32(x);
      var b = ES.ToUint32(y);
      var ah = (a >>> 16) & 0xffff;
      var al = a & 0xffff;
      var bh = (b >>> 16) & 0xffff;
      var bl = b & 0xffff;
      // the shift by 0 fixes the sign on the high part
      // the final |0 converts the unsigned value into a signed value
      return (al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0) | 0;
    },

    fround: function fround(x) {
      var v = Number(x);
      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
        return v;
      }
      var sign = _sign(v);
      var abs = _abs(v);
      if (abs < BINARY_32_MIN_VALUE) {
        return sign * roundTiesToEven(
          abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON
        ) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
      }
      // Veltkamp's splitting (?)
      var a = (1 + (BINARY_32_EPSILON / Number.EPSILON)) * abs;
      var result = a - (a - abs);
      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
        return sign * Infinity;
      }
      return sign * result;
    }
  };
  defineProperties(Math, MathShims);
  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
  // Chrome 40 has an imprecise Math.tanh with very small numbers
  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
  // Chrome 40 loses Math.acosh precision with high numbers
  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
  // Firefox 38 on Windows
  defineProperty(Math, 'cbrt', MathShims.cbrt, Math.abs(1 - (Math.cbrt(1e-300) / 1e-100)) / Number.EPSILON > 8);
  // node 0.11 has an imprecise Math.sinh with very small numbers
  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
  var expm1OfTen = Math.expm1(10);
  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);

  var origMathRound = Math.round;
  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
  var roundHandlesBoundaryConditions = Math.round(0.5 - (Number.EPSILON / 4)) === 0 &&
    Math.round(-0.5 + (Number.EPSILON / 3.99)) === 1;

  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
  // This behavior should be governed by "round to nearest, ties to even mode"
  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
  // These are the boundary cases where it breaks.
  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
  var largestPositiveNumberWhereRoundBreaks = (2 * inverseEpsilon) - 1;
  var roundDoesNotIncreaseIntegers = [
    smallestPositiveNumberWhereRoundBreaks,
    largestPositiveNumberWhereRoundBreaks
  ].every(function (num) {
    return Math.round(num) === num;
  });
  defineProperty(Math, 'round', function round(x) {
    var floor = _floor(x);
    var ceil = floor === -1 ? -0 : floor + 1;
    return x - floor < 0.5 ? floor : ceil;
  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
  Value.preserveToString(Math.round, origMathRound);

  var origImul = Math.imul;
  if (Math.imul(0xffffffff, 5) !== -5) {
    // Safari 6.1, at least, reports "0" for this value
    Math.imul = MathShims.imul;
    Value.preserveToString(Math.imul, origImul);
  }
  if (Math.imul.length !== 2) {
    // Safari 8.0.4 has a length of 1
    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
    overrideNative(Math, 'imul', function imul(x, y) {
      return ES.Call(origImul, Math, arguments);
    });
  }

  // Promises
  // Simplest possible implementation; use a 3rd-party library if you
  // want the best possible speed and/or long stack traces.
  var PromiseShim = (function () {
    var setTimeout = globals.setTimeout;
    // some environments don't have setTimeout - no way to shim here.
    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }

    ES.IsPromise = function (promise) {
      if (!ES.TypeIsObject(promise)) {
        return false;
      }
      if (typeof promise._promise === 'undefined') {
        return false; // uninitialized, or missing our hidden field.
      }
      return true;
    };

    // "PromiseCapability" in the spec is what most promise implementations
    // call a "deferred".
    var PromiseCapability = function (C) {
      if (!ES.IsConstructor(C)) {
        throw new TypeError('Bad promise constructor');
      }
      var capability = this;
      var resolver = function (resolve, reject) {
        if (capability.resolve !== void 0 || capability.reject !== void 0) {
          throw new TypeError('Bad Promise implementation!');
        }
        capability.resolve = resolve;
        capability.reject = reject;
      };
      // Initialize fields to inform optimizers about the object shape.
      capability.resolve = void 0;
      capability.reject = void 0;
      capability.promise = new C(resolver);
      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
        throw new TypeError('Bad promise constructor');
      }
    };

    // find an appropriate setImmediate-alike
    var makeZeroTimeout;
    /*global window */
    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
      makeZeroTimeout = function () {
        // from http://dbaron.org/log/20100309-faster-timeouts
        var timeouts = [];
        var messageName = 'zero-timeout-message';
        var setZeroTimeout = function (fn) {
          _push(timeouts, fn);
          window.postMessage(messageName, '*');
        };
        var handleMessage = function (event) {
          if (event.source === window && event.data === messageName) {
            event.stopPropagation();
            if (timeouts.length === 0) { return; }
            var fn = _shift(timeouts);
            fn();
          }
        };
        window.addEventListener('message', handleMessage, true);
        return setZeroTimeout;
      };
    }
    var makePromiseAsap = function () {
      // An efficient task-scheduler based on a pre-existing Promise
      // implementation, which we can use even if we override the
      // global Promise below (in order to workaround bugs)
      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
      var P = globals.Promise;
      var pr = P && P.resolve && P.resolve();
      return pr && function (task) {
        return pr.then(task);
      };
    };
    /*global process */
    /* jscs:disable disallowMultiLineTernary */
    var enqueue = ES.IsCallable(globals.setImmediate) ?
      globals.setImmediate :
      typeof process === 'object' && process.nextTick ? process.nextTick :
      makePromiseAsap() ||
      (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() :
      function (task) { setTimeout(task, 0); }); // fallback
    /* jscs:enable disallowMultiLineTernary */

    // Constants for Promise implementation
    var PROMISE_IDENTITY = function (x) { return x; };
    var PROMISE_THROWER = function (e) { throw e; };
    var PROMISE_PENDING = 0;
    var PROMISE_FULFILLED = 1;
    var PROMISE_REJECTED = 2;
    // We store fulfill/reject handlers and capabilities in a single array.
    var PROMISE_FULFILL_OFFSET = 0;
    var PROMISE_REJECT_OFFSET = 1;
    var PROMISE_CAPABILITY_OFFSET = 2;
    // This is used in an optimization for chaining promises via then.
    var PROMISE_FAKE_CAPABILITY = {};

    var enqueuePromiseReactionJob = function (handler, capability, argument) {
      enqueue(function () {
        promiseReactionJob(handler, capability, argument);
      });
    };

    var promiseReactionJob = function (handler, promiseCapability, argument) {
      var handlerResult, f;
      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
        // Fast case, when we don't actually need to chain through to a
        // (real) promiseCapability.
        return handler(argument);
      }
      try {
        handlerResult = handler(argument);
        f = promiseCapability.resolve;
      } catch (e) {
        handlerResult = e;
        f = promiseCapability.reject;
      }
      f(handlerResult);
    };

    var fulfillPromise = function (promise, value) {
      var _promise = promise._promise;
      var length = _promise.reactionLength;
      if (length > 0) {
        enqueuePromiseReactionJob(
          _promise.fulfillReactionHandler0,
          _promise.reactionCapability0,
          value
        );
        _promise.fulfillReactionHandler0 = void 0;
        _promise.rejectReactions0 = void 0;
        _promise.reactionCapability0 = void 0;
        if (length > 1) {
          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
            enqueuePromiseReactionJob(
              _promise[idx + PROMISE_FULFILL_OFFSET],
              _promise[idx + PROMISE_CAPABILITY_OFFSET],
              value
            );
            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
          }
        }
      }
      _promise.result = value;
      _promise.state = PROMISE_FULFILLED;
      _promise.reactionLength = 0;
    };

    var rejectPromise = function (promise, reason) {
      var _promise = promise._promise;
      var length = _promise.reactionLength;
      if (length > 0) {
        enqueuePromiseReactionJob(
          _promise.rejectReactionHandler0,
          _promise.reactionCapability0,
          reason
        );
        _promise.fulfillReactionHandler0 = void 0;
        _promise.rejectReactions0 = void 0;
        _promise.reactionCapability0 = void 0;
        if (length > 1) {
          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
            enqueuePromiseReactionJob(
              _promise[idx + PROMISE_REJECT_OFFSET],
              _promise[idx + PROMISE_CAPABILITY_OFFSET],
              reason
            );
            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
          }
        }
      }
      _promise.result = reason;
      _promise.state = PROMISE_REJECTED;
      _promise.reactionLength = 0;
    };

    var createResolvingFunctions = function (promise) {
      var alreadyResolved = false;
      var resolve = function (resolution) {
        var then;
        if (alreadyResolved) { return; }
        alreadyResolved = true;
        if (resolution === promise) {
          return rejectPromise(promise, new TypeError('Self resolution'));
        }
        if (!ES.TypeIsObject(resolution)) {
          return fulfillPromise(promise, resolution);
        }
        try {
          then = resolution.then;
        } catch (e) {
          return rejectPromise(promise, e);
        }
        if (!ES.IsCallable(then)) {
          return fulfillPromise(promise, resolution);
        }
        enqueue(function () {
          promiseResolveThenableJob(promise, resolution, then);
        });
      };
      var reject = function (reason) {
        if (alreadyResolved) { return; }
        alreadyResolved = true;
        return rejectPromise(promise, reason);
      };
      return { resolve: resolve, reject: reject };
    };

    var optimizedThen = function (then, thenable, resolve, reject) {
      // Optimization: since we discard the result, we can pass our
      // own then implementation a special hint to let it know it
      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
      // object is local to this implementation and unforgeable outside.)
      if (then === Promise$prototype$then) {
        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
      } else {
        _call(then, thenable, resolve, reject);
      }
    };
    var promiseResolveThenableJob = function (promise, thenable, then) {
      var resolvingFunctions = createResolvingFunctions(promise);
      var resolve = resolvingFunctions.resolve;
      var reject = resolvingFunctions.reject;
      try {
        optimizedThen(then, thenable, resolve, reject);
      } catch (e) {
        reject(e);
      }
    };

    var Promise$prototype, Promise$prototype$then;
    var Promise = (function () {
      var PromiseShim = function Promise(resolver) {
        if (!(this instanceof PromiseShim)) {
          throw new TypeError('Constructor Promise requires "new"');
        }
        if (this && this._promise) {
          throw new TypeError('Bad construction');
        }
        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
        if (!ES.IsCallable(resolver)) {
          throw new TypeError('not a valid resolver');
        }
        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
          _promise: {
            result: void 0,
            state: PROMISE_PENDING,
            // The first member of the "reactions" array is inlined here,
            // since most promises only have one reaction.
            // We've also exploded the 'reaction' object to inline the
            // "handler" and "capability" fields, since both fulfill and
            // reject reactions share the same capability.
            reactionLength: 0,
            fulfillReactionHandler0: void 0,
            rejectReactionHandler0: void 0,
            reactionCapability0: void 0
          }
        });
        var resolvingFunctions = createResolvingFunctions(promise);
        var reject = resolvingFunctions.reject;
        try {
          resolver(resolvingFunctions.resolve, reject);
        } catch (e) {
          reject(e);
        }
        return promise;
      };
      return PromiseShim;
    }());
    Promise$prototype = Promise.prototype;

    var _promiseAllResolver = function (index, values, capability, remaining) {
      var alreadyCalled = false;
      return function (x) {
        if (alreadyCalled) { return; }
        alreadyCalled = true;
        values[index] = x;
        if ((--remaining.count) === 0) {
          var resolve = capability.resolve;
          resolve(values); // call w/ this===undefined
        }
      };
    };

    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
      var it = iteratorRecord.iterator;
      var values = [];
      var remaining = { count: 1 };
      var next, nextValue;
      var index = 0;
      while (true) {
        try {
          next = ES.IteratorStep(it);
          if (next === false) {
            iteratorRecord.done = true;
            break;
          }
          nextValue = next.value;
        } catch (e) {
          iteratorRecord.done = true;
          throw e;
        }
        values[index] = void 0;
        var nextPromise = C.resolve(nextValue);
        var resolveElement = _promiseAllResolver(
          index, values, resultCapability, remaining
        );
        remaining.count += 1;
        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
        index += 1;
      }
      if ((--remaining.count) === 0) {
        var resolve = resultCapability.resolve;
        resolve(values); // call w/ this===undefined
      }
      return resultCapability.promise;
    };

    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
      var it = iteratorRecord.iterator;
      var next, nextValue, nextPromise;
      while (true) {
        try {
          next = ES.IteratorStep(it);
          if (next === false) {
            // NOTE: If iterable has no items, resulting promise will never
            // resolve; see:
            // https://github.com/domenic/promises-unwrapping/issues/75
            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
            iteratorRecord.done = true;
            break;
          }
          nextValue = next.value;
        } catch (e) {
          iteratorRecord.done = true;
          throw e;
        }
        nextPromise = C.resolve(nextValue);
        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
      }
      return resultCapability.promise;
    };

    defineProperties(Promise, {
      all: function all(iterable) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Promise is not object');
        }
        var capability = new PromiseCapability(C);
        var iterator, iteratorRecord;
        try {
          iterator = ES.GetIterator(iterable);
          iteratorRecord = { iterator: iterator, done: false };
          return performPromiseAll(iteratorRecord, C, capability);
        } catch (e) {
          var exception = e;
          if (iteratorRecord && !iteratorRecord.done) {
            try {
              ES.IteratorClose(iterator, true);
            } catch (ee) {
              exception = ee;
            }
          }
          var reject = capability.reject;
          reject(exception);
          return capability.promise;
        }
      },

      race: function race(iterable) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Promise is not object');
        }
        var capability = new PromiseCapability(C);
        var iterator, iteratorRecord;
        try {
          iterator = ES.GetIterator(iterable);
          iteratorRecord = { iterator: iterator, done: false };
          return performPromiseRace(iteratorRecord, C, capability);
        } catch (e) {
          var exception = e;
          if (iteratorRecord && !iteratorRecord.done) {
            try {
              ES.IteratorClose(iterator, true);
            } catch (ee) {
              exception = ee;
            }
          }
          var reject = capability.reject;
          reject(exception);
          return capability.promise;
        }
      },

      reject: function reject(reason) {
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Bad promise constructor');
        }
        var capability = new PromiseCapability(C);
        var rejectFunc = capability.reject;
        rejectFunc(reason); // call with this===undefined
        return capability.promise;
      },

      resolve: function resolve(v) {
        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
        var C = this;
        if (!ES.TypeIsObject(C)) {
          throw new TypeError('Bad promise constructor');
        }
        if (ES.IsPromise(v)) {
          var constructor = v.constructor;
          if (constructor === C) {
            return v;
          }
        }
        var capability = new PromiseCapability(C);
        var resolveFunc = capability.resolve;
        resolveFunc(v); // call with this===undefined
        return capability.promise;
      }
    });

    defineProperties(Promise$prototype, {
      'catch': function (onRejected) {
        return this.then(null, onRejected);
      },

      then: function then(onFulfilled, onRejected) {
        var promise = this;
        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
        var C = ES.SpeciesConstructor(promise, Promise);
        var resultCapability;
        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
        if (returnValueIsIgnored && C === Promise) {
          resultCapability = PROMISE_FAKE_CAPABILITY;
        } else {
          resultCapability = new PromiseCapability(C);
        }
        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
        // Note that we've split the 'reaction' object into its two
        // components, "capabilities" and "handler"
        // "capabilities" is always equal to `resultCapability`
        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
        var _promise = promise._promise;
        var value;
        if (_promise.state === PROMISE_PENDING) {
          if (_promise.reactionLength === 0) {
            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
            _promise.rejectReactionHandler0 = rejectReactionHandler;
            _promise.reactionCapability0 = resultCapability;
          } else {
            var idx = 3 * (_promise.reactionLength - 1);
            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
          }
          _promise.reactionLength += 1;
        } else if (_promise.state === PROMISE_FULFILLED) {
          value = _promise.result;
          enqueuePromiseReactionJob(
            fulfillReactionHandler, resultCapability, value
          );
        } else if (_promise.state === PROMISE_REJECTED) {
          value = _promise.result;
          enqueuePromiseReactionJob(
            rejectReactionHandler, resultCapability, value
          );
        } else {
          throw new TypeError('unexpected Promise state');
        }
        return resultCapability.promise;
      }
    });
    // This helps the optimizer by ensuring that methods which take
    // capabilities aren't polymorphic.
    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
    Promise$prototype$then = Promise$prototype.then;

    return Promise;
  }());

  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
  if (globals.Promise) {
    delete globals.Promise.accept;
    delete globals.Promise.defer;
    delete globals.Promise.prototype.chain;
  }

  if (typeof PromiseShim === 'function') {
    // export the Promise constructor.
    defineProperties(globals, { Promise: PromiseShim });
    // In Chrome 33 (and thereabouts) Promise is defined, but the
    // implementation is buggy in a number of ways.  Let's check subclassing
    // support to see if we have a buggy implementation.
    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
      return S.resolve(42).then(function () {}) instanceof S;
    });
    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () {
      globals.Promise.reject(42).then(null, 5).then(null, noop);
    });
    var promiseRequiresObjectContext = throwsError(function () { globals.Promise.call(3, noop); });
    // Promise.resolve() was errata'ed late in the ES6 process.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
    //      https://code.google.com/p/v8/issues/detail?id=4161
    // It serves as a proxy for a number of other bugs in early Promise
    // implementations.
    var promiseResolveBroken = (function (Promise) {
      var p = Promise.resolve(5);
      p.constructor = {};
      var p2 = Promise.resolve(p);
      try {
        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
      } catch (e) {
        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
      }
      return p === p2; // This *should* be false!
    }(globals.Promise));

    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
    var getsThenSynchronously = supportsDescriptors && (function () {
      var count = 0;
      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
      Promise.resolve(thenable);
      return count === 1;
    }());

    var BadResolverPromise = function BadResolverPromise(executor) {
      var p = new Promise(executor);
      executor(3, function () {});
      this.then = p.then;
      this.constructor = BadResolverPromise;
    };
    BadResolverPromise.prototype = Promise.prototype;
    BadResolverPromise.all = Promise.all;
    // Chrome Canary 49 (probably older too) has some implementation bugs
    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
      return !!BadResolverPromise.all([1, 2]);
    });

    if (!promiseSupportsSubclassing || !promiseIgnoresNonFunctionThenCallbacks ||
        !promiseRequiresObjectContext || promiseResolveBroken ||
        !getsThenSynchronously || hasBadResolverPromise) {
      /* globals Promise: true */
      /* eslint-disable no-undef, no-global-assign */
      /* jshint -W020 */
      Promise = PromiseShim;
      /* jshint +W020 */
      /* eslint-enable no-undef, no-global-assign */
      /* globals Promise: false */
      overrideNative(globals, 'Promise', PromiseShim);
    }
    if (Promise.all.length !== 1) {
      var origAll = Promise.all;
      overrideNative(Promise, 'all', function all(iterable) {
        return ES.Call(origAll, this, arguments);
      });
    }
    if (Promise.race.length !== 1) {
      var origRace = Promise.race;
      overrideNative(Promise, 'race', function race(iterable) {
        return ES.Call(origRace, this, arguments);
      });
    }
    if (Promise.resolve.length !== 1) {
      var origResolve = Promise.resolve;
      overrideNative(Promise, 'resolve', function resolve(x) {
        return ES.Call(origResolve, this, arguments);
      });
    }
    if (Promise.reject.length !== 1) {
      var origReject = Promise.reject;
      overrideNative(Promise, 'reject', function reject(r) {
        return ES.Call(origReject, this, arguments);
      });
    }
    ensureEnumerable(Promise, 'all');
    ensureEnumerable(Promise, 'race');
    ensureEnumerable(Promise, 'resolve');
    ensureEnumerable(Promise, 'reject');
    addDefaultSpecies(Promise);
  }

  // Map and Set require a true ES5 environment
  // Their fast path also requires that the environment preserve
  // property insertion order, which is not guaranteed by the spec.
  var testOrder = function (a) {
    var b = keys(_reduce(a, function (o, k) {
      o[k] = true;
      return o;
    }, {}));
    return a.join(':') === b.join(':');
  };
  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
  // some engines (eg, Chrome) only preserve insertion order for string keys
  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);

  if (supportsDescriptors) {

    var fastkey = function fastkey(key, skipInsertionOrderCheck) {
      if (!skipInsertionOrderCheck && !preservesInsertionOrder) {
        return null;
      }
      if (isNullOrUndefined(key)) {
        return '^' + ES.ToString(key);
      } else if (typeof key === 'string') {
        return '$' + key;
      } else if (typeof key === 'number') {
        // note that -0 will get coerced to "0" when used as a property key
        if (!preservesNumericInsertionOrder) {
          return 'n' + key;
        }
        return key;
      } else if (typeof key === 'boolean') {
        return 'b' + key;
      }
      return null;
    };

    var emptyObject = function emptyObject() {
      // accomodate some older not-quite-ES5 browsers
      return Object.create ? Object.create(null) : {};
    };

    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
      if (isArray(iterable) || Type.string(iterable)) {
        _forEach(iterable, function (entry) {
          if (!ES.TypeIsObject(entry)) {
            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
          }
          map.set(entry[0], entry[1]);
        });
      } else if (iterable instanceof MapConstructor) {
        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
          map.set(key, value);
        });
      } else {
        var iter, adder;
        if (!isNullOrUndefined(iterable)) {
          adder = map.set;
          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
          iter = ES.GetIterator(iterable);
        }
        if (typeof iter !== 'undefined') {
          while (true) {
            var next = ES.IteratorStep(iter);
            if (next === false) { break; }
            var nextItem = next.value;
            try {
              if (!ES.TypeIsObject(nextItem)) {
                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
              }
              _call(adder, map, nextItem[0], nextItem[1]);
            } catch (e) {
              ES.IteratorClose(iter, true);
              throw e;
            }
          }
        }
      }
    };
    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
      if (isArray(iterable) || Type.string(iterable)) {
        _forEach(iterable, function (value) {
          set.add(value);
        });
      } else if (iterable instanceof SetConstructor) {
        _call(SetConstructor.prototype.forEach, iterable, function (value) {
          set.add(value);
        });
      } else {
        var iter, adder;
        if (!isNullOrUndefined(iterable)) {
          adder = set.add;
          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
          iter = ES.GetIterator(iterable);
        }
        if (typeof iter !== 'undefined') {
          while (true) {
            var next = ES.IteratorStep(iter);
            if (next === false) { break; }
            var nextValue = next.value;
            try {
              _call(adder, set, nextValue);
            } catch (e) {
              ES.IteratorClose(iter, true);
              throw e;
            }
          }
        }
      }
    };

    var collectionShims = {
      Map: (function () {

        var empty = {};

        var MapEntry = function MapEntry(key, value) {
          this.key = key;
          this.value = value;
          this.next = null;
          this.prev = null;
        };

        MapEntry.prototype.isRemoved = function isRemoved() {
          return this.key === empty;
        };

        var isMap = function isMap(map) {
          return !!map._es6map;
        };

        var requireMapSlot = function requireMapSlot(map, method) {
          if (!ES.TypeIsObject(map) || !isMap(map)) {
            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
          }
        };

        var MapIterator = function MapIterator(map, kind) {
          requireMapSlot(map, '[[MapIterator]]');
          this.head = map._head;
          this.i = this.head;
          this.kind = kind;
        };

        MapIterator.prototype = {
          next: function next() {
            var i = this.i;
            var kind = this.kind;
            var head = this.head;
            if (typeof this.i === 'undefined') {
              return iteratorResult();
            }
            while (i.isRemoved() && i !== head) {
              // back up off of removed entries
              i = i.prev;
            }
            // advance to next unreturned element.
            var result;
            while (i.next !== head) {
              i = i.next;
              if (!i.isRemoved()) {
                if (kind === 'key') {
                  result = i.key;
                } else if (kind === 'value') {
                  result = i.value;
                } else {
                  result = [i.key, i.value];
                }
                this.i = i;
                return iteratorResult(result);
              }
            }
            // once the iterator is done, it is done forever.
            this.i = void 0;
            return iteratorResult();
          }
        };
        addIterator(MapIterator.prototype);

        var Map$prototype;
        var MapShim = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          if (this && this._es6map) {
            throw new TypeError('Bad construction');
          }
          var map = emulateES6construct(this, Map, Map$prototype, {
            _es6map: true,
            _head: null,
            _map: OrigMap ? new OrigMap() : null,
            _size: 0,
            _storage: emptyObject()
          });

          var head = new MapEntry(null, null);
          // circular doubly-linked list.
          /* eslint no-multi-assign: 1 */
          head.next = head.prev = head;
          map._head = head;

          // Optionally initialize map from iterable
          if (arguments.length > 0) {
            addIterableToMap(Map, map, arguments[0]);
          }
          return map;
        };
        Map$prototype = MapShim.prototype;

        Value.getter(Map$prototype, 'size', function () {
          if (typeof this._size === 'undefined') {
            throw new TypeError('size method called on incompatible Map');
          }
          return this._size;
        });

        defineProperties(Map$prototype, {
          get: function get(key) {
            requireMapSlot(this, 'get');
            var entry;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              entry = this._storage[fkey];
              if (entry) {
                return entry.value;
              } else {
                return;
              }
            }
            if (this._map) {
              // fast object key path
              entry = origMapGet.call(this._map, key);
              if (entry) {
                return entry.value;
              } else {
                return;
              }
            }
            var head = this._head;
            var i = head;
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                return i.value;
              }
            }
          },

          has: function has(key) {
            requireMapSlot(this, 'has');
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              return typeof this._storage[fkey] !== 'undefined';
            }
            if (this._map) {
              // fast object key path
              return origMapHas.call(this._map, key);
            }
            var head = this._head;
            var i = head;
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                return true;
              }
            }
            return false;
          },

          set: function set(key, value) {
            requireMapSlot(this, 'set');
            var head = this._head;
            var i = head;
            var entry;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              if (typeof this._storage[fkey] !== 'undefined') {
                this._storage[fkey].value = value;
                return this;
              } else {
                entry = this._storage[fkey] = new MapEntry(key, value); /* eslint no-multi-assign: 1 */
                i = head.prev;
                // fall through
              }
            } else if (this._map) {
              // fast object key path
              if (origMapHas.call(this._map, key)) {
                origMapGet.call(this._map, key).value = value;
              } else {
                entry = new MapEntry(key, value);
                origMapSet.call(this._map, key, entry);
                i = head.prev;
                // fall through
              }
            }
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                i.value = value;
                return this;
              }
            }
            entry = entry || new MapEntry(key, value);
            if (ES.SameValue(-0, key)) {
              entry.key = +0; // coerce -0 to +0 in entry
            }
            entry.next = this._head;
            entry.prev = this._head.prev;
            entry.prev.next = entry;
            entry.next.prev = entry;
            this._size += 1;
            return this;
          },

          'delete': function (key) {
            requireMapSlot(this, 'delete');
            var head = this._head;
            var i = head;
            var fkey = fastkey(key, true);
            if (fkey !== null) {
              // fast O(1) path
              if (typeof this._storage[fkey] === 'undefined') {
                return false;
              }
              i = this._storage[fkey].prev;
              delete this._storage[fkey];
              // fall through
            } else if (this._map) {
              // fast object key path
              if (!origMapHas.call(this._map, key)) {
                return false;
              }
              i = origMapGet.call(this._map, key).prev;
              origMapDelete.call(this._map, key);
              // fall through
            }
            while ((i = i.next) !== head) {
              if (ES.SameValueZero(i.key, key)) {
                i.key = empty;
                i.value = empty;
                i.prev.next = i.next;
                i.next.prev = i.prev;
                this._size -= 1;
                return true;
              }
            }
            return false;
          },

          clear: function clear() {
             /* eslint no-multi-assign: 1 */
            requireMapSlot(this, 'clear');
            this._map = OrigMap ? new OrigMap() : null;
            this._size = 0;
            this._storage = emptyObject();
            var head = this._head;
            var i = head;
            var p = i.next;
            while ((i = p) !== head) {
              i.key = empty;
              i.value = empty;
              p = i.next;
              i.next = i.prev = head;
            }
            head.next = head.prev = head;
          },

          keys: function keys() {
            requireMapSlot(this, 'keys');
            return new MapIterator(this, 'key');
          },

          values: function values() {
            requireMapSlot(this, 'values');
            return new MapIterator(this, 'value');
          },

          entries: function entries() {
            requireMapSlot(this, 'entries');
            return new MapIterator(this, 'key+value');
          },

          forEach: function forEach(callback) {
            requireMapSlot(this, 'forEach');
            var context = arguments.length > 1 ? arguments[1] : null;
            var it = this.entries();
            for (var entry = it.next(); !entry.done; entry = it.next()) {
              if (context) {
                _call(callback, context, entry.value[1], entry.value[0], this);
              } else {
                callback(entry.value[1], entry.value[0], this);
              }
            }
          }
        });
        addIterator(Map$prototype, Map$prototype.entries);

        return MapShim;
      }()),

      Set: (function () {
        var isSet = function isSet(set) {
          return set._es6set && typeof set._storage !== 'undefined';
        };
        var requireSetSlot = function requireSetSlot(set, method) {
          if (!ES.TypeIsObject(set) || !isSet(set)) {
            // https://github.com/paulmillr/es6-shim/issues/176
            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
          }
        };

        // Creating a Map is expensive.  To speed up the common case of
        // Sets containing only string or numeric keys, we use an object
        // as backing storage and lazily create a full Map only when
        // required.
        var Set$prototype;
        var SetShim = function Set() {
          if (!(this instanceof Set)) {
            throw new TypeError('Constructor Set requires "new"');
          }
          if (this && this._es6set) {
            throw new TypeError('Bad construction');
          }
          var set = emulateES6construct(this, Set, Set$prototype, {
            _es6set: true,
            '[[SetData]]': null,
            _storage: emptyObject()
          });
          if (!set._es6set) {
            throw new TypeError('bad set');
          }

          // Optionally initialize Set from iterable
          if (arguments.length > 0) {
            addIterableToSet(Set, set, arguments[0]);
          }
          return set;
        };
        Set$prototype = SetShim.prototype;

        var decodeKey = function (key) {
          var k = key;
          if (k === '^null') {
            return null;
          } else if (k === '^undefined') {
            return void 0;
          } else {
            var first = k.charAt(0);
            if (first === '$') {
              return _strSlice(k, 1);
            } else if (first === 'n') {
              return +_strSlice(k, 1);
            } else if (first === 'b') {
              return k === 'btrue';
            }
          }
          return +k;
        };
        // Switch from the object backing storage to a full Map.
        var ensureMap = function ensureMap(set) {
          if (!set['[[SetData]]']) {
            var m = new collectionShims.Map();
            set['[[SetData]]'] = m;
            _forEach(keys(set._storage), function (key) {
              var k = decodeKey(key);
              m.set(k, k);
            });
            set['[[SetData]]'] = m;
          }
          set._storage = null; // free old backing storage
        };

        Value.getter(SetShim.prototype, 'size', function () {
          requireSetSlot(this, 'size');
          if (this._storage) {
            return keys(this._storage).length;
          }
          ensureMap(this);
          return this['[[SetData]]'].size;
        });

        defineProperties(SetShim.prototype, {
          has: function has(key) {
            requireSetSlot(this, 'has');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              return !!this._storage[fkey];
            }
            ensureMap(this);
            return this['[[SetData]]'].has(key);
          },

          add: function add(key) {
            requireSetSlot(this, 'add');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              this._storage[fkey] = true;
              return this;
            }
            ensureMap(this);
            this['[[SetData]]'].set(key, key);
            return this;
          },

          'delete': function (key) {
            requireSetSlot(this, 'delete');
            var fkey;
            if (this._storage && (fkey = fastkey(key)) !== null) {
              var hasFKey = _hasOwnProperty(this._storage, fkey);
              return (delete this._storage[fkey]) && hasFKey;
            }
            ensureMap(this);
            return this['[[SetData]]']['delete'](key);
          },

          clear: function clear() {
            requireSetSlot(this, 'clear');
            if (this._storage) {
              this._storage = emptyObject();
            }
            if (this['[[SetData]]']) {
              this['[[SetData]]'].clear();
            }
          },

          values: function values() {
            requireSetSlot(this, 'values');
            ensureMap(this);
            return this['[[SetData]]'].values();
          },

          entries: function entries() {
            requireSetSlot(this, 'entries');
            ensureMap(this);
            return this['[[SetData]]'].entries();
          },

          forEach: function forEach(callback) {
            requireSetSlot(this, 'forEach');
            var context = arguments.length > 1 ? arguments[1] : null;
            var entireSet = this;
            ensureMap(entireSet);
            this['[[SetData]]'].forEach(function (value, key) {
              if (context) {
                _call(callback, context, key, key, entireSet);
              } else {
                callback(key, key, entireSet);
              }
            });
          }
        });
        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
        addIterator(SetShim.prototype, SetShim.prototype.values);

        return SetShim;
      }())
    };

    if (globals.Map || globals.Set) {
      // Safari 8, for example, doesn't accept an iterable.
      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
      if (!mapAcceptsArguments) {
        globals.Map = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          var m = new OrigMap();
          if (arguments.length > 0) {
            addIterableToMap(Map, m, arguments[0]);
          }
          delete m.constructor;
          Object.setPrototypeOf(m, globals.Map.prototype);
          return m;
        };
        globals.Map.prototype = create(OrigMap.prototype);
        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
        Value.preserveToString(globals.Map, OrigMap);
      }
      var testMap = new Map();
      var mapUsesSameValueZero = (function () {
        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
        m.set(-0, m);
        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
      }());
      var mapSupportsChaining = testMap.set(1, 2) === testMap;
      if (!mapUsesSameValueZero || !mapSupportsChaining) {
        overrideNative(Map.prototype, 'set', function set(k, v) {
          _call(origMapSet, this, k === 0 ? 0 : k, v);
          return this;
        });
      }
      if (!mapUsesSameValueZero) {
        defineProperties(Map.prototype, {
          get: function get(k) {
            return _call(origMapGet, this, k === 0 ? 0 : k);
          },
          has: function has(k) {
            return _call(origMapHas, this, k === 0 ? 0 : k);
          }
        }, true);
        Value.preserveToString(Map.prototype.get, origMapGet);
        Value.preserveToString(Map.prototype.has, origMapHas);
      }
      var testSet = new Set();
      var setUsesSameValueZero = (function (s) {
        s['delete'](0);
        s.add(-0);
        return !s.has(0);
      }(testSet));
      var setSupportsChaining = testSet.add(1) === testSet;
      if (!setUsesSameValueZero || !setSupportsChaining) {
        var origSetAdd = Set.prototype.add;
        Set.prototype.add = function add(v) {
          _call(origSetAdd, this, v === 0 ? 0 : v);
          return this;
        };
        Value.preserveToString(Set.prototype.add, origSetAdd);
      }
      if (!setUsesSameValueZero) {
        var origSetHas = Set.prototype.has;
        Set.prototype.has = function has(v) {
          return _call(origSetHas, this, v === 0 ? 0 : v);
        };
        Value.preserveToString(Set.prototype.has, origSetHas);
        var origSetDel = Set.prototype['delete'];
        Set.prototype['delete'] = function SetDelete(v) {
          return _call(origSetDel, this, v === 0 ? 0 : v);
        };
        Value.preserveToString(Set.prototype['delete'], origSetDel);
      }
      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
        var m = new M([]);
        // Firefox 32 is ok with the instantiating the subclass but will
        // throw when the map is used.
        m.set(42, 42);
        return m instanceof M;
      });
      // without Object.setPrototypeOf, subclassing is not possible
      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing;
      var mapRequiresNew = (function () {
        try {
          return !(globals.Map() instanceof globals.Map);
        } catch (e) {
          return e instanceof TypeError;
        }
      }());
      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
        globals.Map = function Map() {
          if (!(this instanceof Map)) {
            throw new TypeError('Constructor Map requires "new"');
          }
          var m = new OrigMap();
          if (arguments.length > 0) {
            addIterableToMap(Map, m, arguments[0]);
          }
          delete m.constructor;
          Object.setPrototypeOf(m, Map.prototype);
          return m;
        };
        globals.Map.prototype = OrigMap.prototype;
        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
        Value.preserveToString(globals.Map, OrigMap);
      }
      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
        var s = new S([]);
        s.add(42, 42);
        return s instanceof S;
      });
      // without Object.setPrototypeOf, subclassing is not possible
      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing;
      var setRequiresNew = (function () {
        try {
          return !(globals.Set() instanceof globals.Set);
        } catch (e) {
          return e instanceof TypeError;
        }
      }());
      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
        var OrigSet = globals.Set;
        globals.Set = function Set() {
          if (!(this instanceof Set)) {
            throw new TypeError('Constructor Set requires "new"');
          }
          var s = new OrigSet();
          if (arguments.length > 0) {
            addIterableToSet(Set, s, arguments[0]);
          }
          delete s.constructor;
          Object.setPrototypeOf(s, Set.prototype);
          return s;
        };
        globals.Set.prototype = OrigSet.prototype;
        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
        Value.preserveToString(globals.Set, OrigSet);
      }
      var newMap = new globals.Map();
      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
        return newMap.keys().next().done;
      });
      /*
        - In Firefox < 23, Map#size is a function.
        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
        - In Firefox 24, Map and Set do not implement forEach
        - In Firefox 25 at least, Map and Set are callable without "new"
      */
      if (
        typeof globals.Map.prototype.clear !== 'function' ||
        new globals.Set().size !== 0 ||
        newMap.size !== 0 ||
        typeof globals.Map.prototype.keys !== 'function' ||
        typeof globals.Set.prototype.keys !== 'function' ||
        typeof globals.Map.prototype.forEach !== 'function' ||
        typeof globals.Set.prototype.forEach !== 'function' ||
        isCallableWithoutNew(globals.Map) ||
        isCallableWithoutNew(globals.Set) ||
        typeof newMap.keys().next !== 'function' || // Safari 8
        mapIterationThrowsStopIterator || // Firefox 25
        !mapSupportsSubclassing
      ) {
        defineProperties(globals, {
          Map: collectionShims.Map,
          Set: collectionShims.Set
        }, true);
      }

      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
      }

      // Shim incomplete iterator implementations.
      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));

      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
        var anonymousSetHas = globals.Set.prototype.has;
        overrideNative(globals.Set.prototype, 'has', function has(key) {
          return _call(anonymousSetHas, this, key);
        });
      }
    }
    defineProperties(globals, collectionShims);
    addDefaultSpecies(globals.Map);
    addDefaultSpecies(globals.Set);
  }

  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
    if (!ES.TypeIsObject(target)) {
      throw new TypeError('target must be an object');
    }
  };

  // Some Reflect methods are basically the same as
  // those on the Object global, except that a TypeError is thrown if
  // target isn't an object. As well as returning a boolean indicating
  // the success of the operation.
  var ReflectShims = {
    // Apply method in a functional form.
    apply: function apply() {
      return ES.Call(ES.Call, null, arguments);
    },

    // New operator in a functional form.
    construct: function construct(constructor, args) {
      if (!ES.IsConstructor(constructor)) {
        throw new TypeError('First argument must be a constructor.');
      }
      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
      if (!ES.IsConstructor(newTarget)) {
        throw new TypeError('new.target must be a constructor.');
      }
      return ES.Construct(constructor, args, newTarget, 'internal');
    },

    // When deleting a non-existent or configurable property,
    // true is returned.
    // When attempting to delete a non-configurable property,
    // it will return false.
    deleteProperty: function deleteProperty(target, key) {
      throwUnlessTargetIsObject(target);
      if (supportsDescriptors) {
        var desc = Object.getOwnPropertyDescriptor(target, key);

        if (desc && !desc.configurable) {
          return false;
        }
      }

      // Will return true.
      return delete target[key];
    },

    has: function has(target, key) {
      throwUnlessTargetIsObject(target);
      return key in target;
    }
  };

  if (Object.getOwnPropertyNames) {
    Object.assign(ReflectShims, {
      // Basically the result of calling the internal [[OwnPropertyKeys]].
      // Concatenating propertyNames and propertySymbols should do the trick.
      // This should continue to work together with a Symbol shim
      // which overrides Object.getOwnPropertyNames and implements
      // Object.getOwnPropertySymbols.
      ownKeys: function ownKeys(target) {
        throwUnlessTargetIsObject(target);
        var keys = Object.getOwnPropertyNames(target);

        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
          _pushApply(keys, Object.getOwnPropertySymbols(target));
        }

        return keys;
      }
    });
  }

  var callAndCatchException = function ConvertExceptionToBoolean(func) {
    return !throwsError(func);
  };

  if (Object.preventExtensions) {
    Object.assign(ReflectShims, {
      isExtensible: function isExtensible(target) {
        throwUnlessTargetIsObject(target);
        return Object.isExtensible(target);
      },
      preventExtensions: function preventExtensions(target) {
        throwUnlessTargetIsObject(target);
        return callAndCatchException(function () {
          Object.preventExtensions(target);
        });
      }
    });
  }

  if (supportsDescriptors) {
    var internalGet = function get(target, key, receiver) {
      var desc = Object.getOwnPropertyDescriptor(target, key);

      if (!desc) {
        var parent = Object.getPrototypeOf(target);

        if (parent === null) {
          return void 0;
        }

        return internalGet(parent, key, receiver);
      }

      if ('value' in desc) {
        return desc.value;
      }

      if (desc.get) {
        return ES.Call(desc.get, receiver);
      }

      return void 0;
    };

    var internalSet = function set(target, key, value, receiver) {
      var desc = Object.getOwnPropertyDescriptor(target, key);

      if (!desc) {
        var parent = Object.getPrototypeOf(target);

        if (parent !== null) {
          return internalSet(parent, key, value, receiver);
        }

        desc = {
          value: void 0,
          writable: true,
          enumerable: true,
          configurable: true
        };
      }

      if ('value' in desc) {
        if (!desc.writable) {
          return false;
        }

        if (!ES.TypeIsObject(receiver)) {
          return false;
        }

        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);

        if (existingDesc) {
          return Reflect.defineProperty(receiver, key, {
            value: value
          });
        } else {
          return Reflect.defineProperty(receiver, key, {
            value: value,
            writable: true,
            enumerable: true,
            configurable: true
          });
        }
      }

      if (desc.set) {
        _call(desc.set, receiver, value);
        return true;
      }

      return false;
    };

    Object.assign(ReflectShims, {
      defineProperty: function defineProperty(target, propertyKey, attributes) {
        throwUnlessTargetIsObject(target);
        return callAndCatchException(function () {
          Object.defineProperty(target, propertyKey, attributes);
        });
      },

      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        throwUnlessTargetIsObject(target);
        return Object.getOwnPropertyDescriptor(target, propertyKey);
      },

      // Syntax in a functional form.
      get: function get(target, key) {
        throwUnlessTargetIsObject(target);
        var receiver = arguments.length > 2 ? arguments[2] : target;

        return internalGet(target, key, receiver);
      },

      set: function set(target, key, value) {
        throwUnlessTargetIsObject(target);
        var receiver = arguments.length > 3 ? arguments[3] : target;

        return internalSet(target, key, value, receiver);
      }
    });
  }

  if (Object.getPrototypeOf) {
    var objectDotGetPrototypeOf = Object.getPrototypeOf;
    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
      throwUnlessTargetIsObject(target);
      return objectDotGetPrototypeOf(target);
    };
  }

  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
    var willCreateCircularPrototype = function (object, lastProto) {
      var proto = lastProto;
      while (proto) {
        if (object === proto) {
          return true;
        }
        proto = ReflectShims.getPrototypeOf(proto);
      }
      return false;
    };

    Object.assign(ReflectShims, {
      // Sets the prototype of the given object.
      // Returns true on success, otherwise false.
      setPrototypeOf: function setPrototypeOf(object, proto) {
        throwUnlessTargetIsObject(object);
        if (proto !== null && !ES.TypeIsObject(proto)) {
          throw new TypeError('proto must be an object or null');
        }

        // If they already are the same, we're done.
        if (proto === Reflect.getPrototypeOf(object)) {
          return true;
        }

        // Cannot alter prototype if object not extensible.
        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
          return false;
        }

        // Ensure that we do not create a circular prototype chain.
        if (willCreateCircularPrototype(object, proto)) {
          return false;
        }

        Object.setPrototypeOf(object, proto);

        return true;
      }
    });
  }
  var defineOrOverrideReflectProperty = function (key, shim) {
    if (!ES.IsCallable(globals.Reflect[key])) {
      defineProperty(globals.Reflect, key, shim);
    } else {
      var acceptsPrimitives = valueOrFalseIfThrows(function () {
        globals.Reflect[key](1);
        globals.Reflect[key](NaN);
        globals.Reflect[key](true);
        return true;
      });
      if (acceptsPrimitives) {
        overrideNative(globals.Reflect, key, shim);
      }
    }
  };
  Object.keys(ReflectShims).forEach(function (key) {
    defineOrOverrideReflectProperty(key, ReflectShims[key]);
  });
  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
      return _call(originalReflectGetProto, globals.Reflect, target);
    });
  }
  if (globals.Reflect.setPrototypeOf) {
    if (valueOrFalseIfThrows(function () {
      globals.Reflect.setPrototypeOf(1, {});
      return true;
    })) {
      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
    }
  }
  if (globals.Reflect.defineProperty) {
    if (!valueOrFalseIfThrows(function () {
      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
      // "extensible" fails on Edge 0.12
      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
      return basic && extensible;
    })) {
      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
    }
  }
  if (globals.Reflect.construct) {
    if (!valueOrFalseIfThrows(function () {
      var F = function F() {};
      return globals.Reflect.construct(function () {}, [], F) instanceof F;
    })) {
      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
    }
  }

  if (String(new Date(NaN)) !== 'Invalid Date') {
    var dateToString = Date.prototype.toString;
    var shimmedDateToString = function toString() {
      var valueOf = +this;
      if (valueOf !== valueOf) {
        return 'Invalid Date';
      }
      return ES.Call(dateToString, this);
    };
    overrideNative(Date.prototype, 'toString', shimmedDateToString);
  }

  // Annex B HTML methods
  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
  var stringHTMLshims = {
    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
  };
  _forEach(Object.keys(stringHTMLshims), function (key) {
    var method = String.prototype[key];
    var shouldOverwrite = false;
    if (ES.IsCallable(method)) {
      var output = _call(method, '', ' " ');
      var quotesCount = _concat([], output.match(/"/g)).length;
      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
    } else {
      shouldOverwrite = true;
    }
    if (shouldOverwrite) {
      overrideNative(String.prototype, key, stringHTMLshims[key]);
    }
  });

  var JSONstringifiesSymbols = (function () {
    // Microsoft Edge v0.12 stringifies Symbols incorrectly
    if (!hasSymbols) { return false; } // Symbols are not supported
    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
    if (!stringify) { return false; } // JSON.stringify is not supported
    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
    var obj = { a: Symbol() };
    obj[Symbol()] = true;
    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
    return false;
  }());
  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
    // Chrome 45 throws on stringifying object symbols
    if (!hasSymbols) { return true; } // Symbols are not supported
    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
  });
  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
    var origStringify = JSON.stringify;
    overrideNative(JSON, 'stringify', function stringify(value) {
      if (typeof value === 'symbol') { return; }
      var replacer;
      if (arguments.length > 1) {
        replacer = arguments[1];
      }
      var args = [value];
      if (!isArray(replacer)) {
        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
        var wrappedReplacer = function (key, val) {
          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
          if (typeof parsedValue !== 'symbol') {
            if (Type.symbol(parsedValue)) {
              return assignTo({})(parsedValue);
            } else {
              return parsedValue;
            }
          }
        };
        args.push(wrappedReplacer);
      } else {
        // create wrapped replacer that handles an array replacer?
        args.push(replacer);
      }
      if (arguments.length > 2) {
        args.push(arguments[2]);
      }
      return origStringify.apply(this, args);
    });
  }

  return globals;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(320)))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	// function.name (all IE)
	/*! @source http://stackoverflow.com/questions/6903762/function-name-not-supported-in-ie*/
	if (!Object.hasOwnProperty('name')) {
	  Object.defineProperty(Function.prototype, 'name', {
	    get: function() {
	      var matches = this.toString().match(/^\s*function\s*(\S*)\s*\(/);
	      var name = matches && matches.length > 1 ? matches[1] : "";
	      // For better performance only parse once, and then cache the
	      // result through a new accessor for repeated access.
	      Object.defineProperty(this, 'name', {value: name});
	      return name;
	    }
	  });
	}
	
	// URL polyfill for SystemJS (all IE)
	/*! @source https://github.com/ModuleLoader/es6-module-loader/blob/master/src/url-polyfill.js*/
	// from https://gist.github.com/Yaffle/1088850
	(function(global) {
	  function URLPolyfill(url, baseURL) {
	    if (typeof url != 'string') {
	      throw new TypeError('URL must be a string');
	    }
	    var m = String(url).replace(/^\s+|\s+$/g, "").match(/^([^:\/?#]+:)?(?:\/\/(?:([^:@\/?#]*)(?::([^:@\/?#]*))?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
	    if (!m) {
	      throw new RangeError();
	    }
	    var protocol = m[1] || "";
	    var username = m[2] || "";
	    var password = m[3] || "";
	    var host = m[4] || "";
	    var hostname = m[5] || "";
	    var port = m[6] || "";
	    var pathname = m[7] || "";
	    var search = m[8] || "";
	    var hash = m[9] || "";
	    if (baseURL !== undefined) {
	      var base = baseURL instanceof URLPolyfill ? baseURL : new URLPolyfill(baseURL);
	      var flag = protocol === "" && host === "" && username === "";
	      if (flag && pathname === "" && search === "") {
	        search = base.search;
	      }
	      if (flag && pathname.charAt(0) !== "/") {
	        pathname = (pathname !== "" ? (((base.host !== "" || base.username !== "") && base.pathname === "" ? "/" : "") + base.pathname.slice(0, base.pathname.lastIndexOf("/") + 1) + pathname) : base.pathname);
	      }
	      // dot segments removal
	      var output = [];
	      pathname.replace(/^(\.\.?(\/|$))+/, "")
	        .replace(/\/(\.(\/|$))+/g, "/")
	        .replace(/\/\.\.$/, "/../")
	        .replace(/\/?[^\/]*/g, function (p) {
	          if (p === "/..") {
	            output.pop();
	          } else {
	            output.push(p);
	          }
	        });
	      pathname = output.join("").replace(/^\//, pathname.charAt(0) === "/" ? "/" : "");
	      if (flag) {
	        port = base.port;
	        hostname = base.hostname;
	        host = base.host;
	        password = base.password;
	        username = base.username;
	      }
	      if (protocol === "") {
	        protocol = base.protocol;
	      }
	    }
	
	    // convert windows file URLs to use /
	    if (protocol == 'file:')
	      pathname = pathname.replace(/\\/g, '/');
	
	    this.origin = protocol + (protocol !== "" || host !== "" ? "//" : "") + host;
	    this.href = protocol + (protocol !== "" || host !== "" ? "//" : "") + (username !== "" ? username + (password !== "" ? ":" + password : "") + "@" : "") + host + pathname + search + hash;
	    this.protocol = protocol;
	    this.username = username;
	    this.password = password;
	    this.host = host;
	    this.hostname = hostname;
	    this.port = port;
	    this.pathname = pathname;
	    this.search = search;
	    this.hash = hash;
	  }
	global.URLPolyfill = URLPolyfill;
	})(typeof self != 'undefined' ? self : global);
	
	//classList (IE9)
	/*! @license please refer to http://unlicense.org/ */
	/*! @author Eli Grey */
	/*! @source https://github.com/eligrey/classList.js */
	;if("document" in self&&!("classList" in document.createElement("_"))){(function(j){"use strict";if(!("Element" in j)){return}var a="classList",f="prototype",m=j.Element[f],b=Object,k=String[f].trim||function(){return this.replace(/^\s+|\s+$/g,"")},c=Array[f].indexOf||function(q){var p=0,o=this.length;for(;p<o;p++){if(p in this&&this[p]===q){return p}}return -1},n=function(o,p){this.name=o;this.code=DOMException[o];this.message=p},g=function(p,o){if(o===""){throw new n("SYNTAX_ERR","An invalid or illegal string was specified")}if(/\s/.test(o)){throw new n("INVALID_CHARACTER_ERR","String contains an invalid character")}return c.call(p,o)},d=function(s){var r=k.call(s.getAttribute("class")||""),q=r?r.split(/\s+/):[],p=0,o=q.length;for(;p<o;p++){this.push(q[p])}this._updateClassName=function(){s.setAttribute("class",this.toString())}},e=d[f]=[],i=function(){return new d(this)};n[f]=Error[f];e.item=function(o){return this[o]||null};e.contains=function(o){o+="";return g(this,o)!==-1};e.add=function(){var s=arguments,r=0,p=s.length,q,o=false;do{q=s[r]+"";if(g(this,q)===-1){this.push(q);o=true}}while(++r<p);if(o){this._updateClassName()}};e.remove=function(){var t=arguments,s=0,p=t.length,r,o=false;do{r=t[s]+"";var q=g(this,r);if(q!==-1){this.splice(q,1);o=true}}while(++s<p);if(o){this._updateClassName()}};e.toggle=function(p,q){p+="";var o=this.contains(p),r=o?q!==true&&"remove":q!==false&&"add";if(r){this[r](p)}return !o};e.toString=function(){return this.join(" ")};if(b.defineProperty){var l={get:i,enumerable:true,configurable:true};try{b.defineProperty(m,a,l)}catch(h){if(h.number===-2146823252){l.enumerable=false;b.defineProperty(m,a,l)}}}else{if(b[f].__defineGetter__){m.__defineGetter__(a,i)}}}(self))};
	
	//console mock (IE9)
	if (!window.console) window.console = {};
	if (!window.console.log) window.console.log = function () { };
	if (!window.console.error) window.console.error = function () { };
	if (!window.console.warn) window.console.warn = function () { };
	if (!window.console.assert) window.console.assert = function () { };
	
	//RequestAnimationFrame (IE9, Android 4.1, 4.2, 4.3)
	/*! @author Paul Irish */
	/*! @source https://gist.github.com/paulirish/1579671 */
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	
	// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
	
	// MIT license
	
	(function() {
	    var lastTime = 0;
	
	    if (!window.requestAnimationFrame)
	        window.requestAnimationFrame = function(callback, element) {
	            var currTime = Date.now();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
	              timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	
	    if (!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function(id) {
	            clearTimeout(id);
	        };
	}());


/***/ }
/******/ ]);
//# sourceMappingURL=browser.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {
	"APP": {
		"URL": "http://85.215.150.174:3001",
		"ADMIN": {
			"TITLE": "GuernCMS",
			"TITLE_MINI": "GC"
		},
		"FRONT": {
			"TITLE": "Forgotten Records"
		},
		"LANGUAGES": {
			"SUPPORTED": [
				"fr",
				"en"
			],
			"PREFERRED": "en",
			"SQUASH": false,
			"COOKIE_DAY_AGE": 730
		}
	},
	"STORE": {
		"DB": {
			"HOST": "mongodb://admin:YgXrK5WMB3Bh@85.215.150.174:27028/forgottenrecords_1?authSource=admin"
		},
		"ELASTICSEARCH": {
			"HOST": "http://85.215.150.174:9211/",
			"INDEX": {
				"record": "forgottenrecords_record",
				"writing": "forgottenrecords_writing"
			}
		}
	},
	"DATA": {
		"covers": "data/covers",
		"images": "data/images"
	},
	"CART": {
		"PAYPAL": {
			"ENV": "production"
		},
		"SHIPPING_FIRST": 9.7,
		"SHIPPING_OTHER": 3,
		"COOKIE_DAY_AGE": 30
	},
	"CATALOGUE": {
		"FEATURED": false,
		"SEARCH": {
			"SUGGESTIONS": {
				"ORDER": [
					"composer",
					"soloist",
					"conductor"
				]
			}
		},
		"THUMB": {
			"CACHE": true,
			"RESIZE_ALGO": "RESIZE_BICUBIC",
			"HEIGHT": 350,
			"RECOMPRESS": true,
			"RECOMPRESS_TARGET": 0.85,
			"RECOMPRESS_MIN": 85,
			"RECOMPRESS_TARGET_LAZY": 0.02,
			"RECOMPRESS_MIN_LAZY": 2
		},
		"RECORD_TITLE_TRUNCATE": "75"
	},
	"SPECIAL": {
		"TITLE_TRUNCATE": "70"
	},
	"HOME": {
		"FEATURED": false
	},
	"PAGE_NOT_FOUND": {
		"TIMEOUT": 5000
	}
};

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = {
	"COMMON": {
		"LEGAL_MENTIONS": {
			"fr": "Mentions légales",
			"en": "Legal mentions"
		},
		"COOKIE_CONSENT": {
			"fr": "Nous utilisons des cookies pour une meilleure expérience utilisateur.",
			"en": "We use cookies for better user experience."
		},
		"COOKIE_CONSENT_ACCEPT": {
			"fr": "Accepter",
			"en": "Accept"
		},
		"COOKIE_CONSENT_DISMISS": {
			"fr": "Fermer",
			"en": "Dismiss"
		},
		"COOKIE_CONSENT_DISMISS_MORE": {
			"fr": "Désactive les cookies",
			"en": "Cookies will be disabled"
		},
		"HEADLINE": {
			"fr": "Interprètes d'hier et d'aujourd'hui",
			"en": "Interpretations, past and present"
		},
		"HEADLINE_1": {
			"fr": "Interprètes d'hier",
			"en": "Interpretations,"
		},
		"HEADLINE_2": {
			"fr": "et d'aujourd'hui",
			"en": "past and present"
		},
		"SUMMARY": {
			"fr": "Forgotten Records est un label français de musique classique. Il est né d’une passion de la musique et de son interprétation.",
			"en": "Forgotten Records is a French label specialised in classical music. We are driven by our passion for music and interpretation."
		},
		"KEYWORDS": {
			"fr": "musique clasique re-edition reedition rare historique enregistrement",
			"en": "classical music reissue rare historical recording"
		},
		"LANGUAGE_LOCALE": {
			"fr": "français",
			"en": "english"
		},
		"LANGUAGE": {
			"fr": {
				"fr": "français",
				"en": "anglais"
			},
			"en": {
				"fr": "french",
				"en": "english"
			}
		},
		"SEE_MORE": {
			"fr": "Voir",
			"en": "See more"
		},
		"BACK": {
			"fr": "Retour",
			"en": "Back"
		},
		"LEARN_MORE": {
			"fr": "En savoir davantage",
			"en": "Learn more"
		},
		"MENU": {
			"HOME": {
				"fr": "Accueil",
				"en": "Home"
			},
			"CATALOGUE": {
				"fr": "Catalogue",
				"en": "Catalogue",
				"ALL": {
					"fr": "tout le catalogue",
					"en": "full catalogue"
				},
				"REISSUE": {
					"fr": "Interprètes d'hier",
					"en": "Historical recordings"
				},
				"PRODUCTION": {
					"fr": "Interprètes d'aujourd'hui",
					"en": "Contemporary artists"
				},
				"SPECIAL": {
					"fr": "Parmi les interprètes d'aujourd'hui",
					"en": "Special releases"
				}
			},
			"WRITINGS": {
				"fr": "Ecrits",
				"en": "Writings",
				"LONG": {
					"fr": "Ecrits sur la musique",
					"en": "Writings about music"
				},
				"ALL": {
					"fr": "Tous les écrits",
					"en": "All the writings"
				}
			},
			"ABOUT": {
				"fr": "Qui sommes-nous",
				"en": "About us",
				"PRESENTATION": {
					"fr": "Présentation",
					"en": "Presentation"
				},
				"PRESS": {
					"fr": "Dans la presse",
					"en": "In the press"
				},
				"PARTNERS": {
					"fr": "Partenaires",
					"en": "Partners"
				},
				"CONTACT": {
					"fr": "Contact",
					"en": "Contact"
				}
			}
		},
		"TAXONOMY": {
			"active": {
				"fr": "publié",
				"en": "published"
			},
			"type": {
				"fr": "types",
				"en": "types",
				"VALUES": {
					"reissue": {
						"fr": "Interprètes d'hier",
						"en": "Historical recording"
					},
					"production": {
						"fr": "Interprètes d'aujourd'hui",
						"en": "Contemporary artists"
					},
					"special": {
						"fr": "Parmi les interprètes d'aujourd'hui",
						"en": "Special releases"
					}
				}
			},
			"tag": {
				"fr": "thématiques",
				"en": "subjects",
				"VALUES": {
					"philosophy": {
						"fr": "Philosophie et musique",
						"en": "Philosophy and music"
					},
					"composers": {
						"fr": "Les compositeurs et leurs oeuvres",
						"en": "Composers and their work"
					},
					"artists": {
						"fr": "Les interprètes",
						"en": "Artists"
					},
					"miscellaneous": {
						"fr": "Varia",
						"en": "Miscellaneous"
					}
				}
			},
			"language": {
				"fr": "langue",
				"en": "language",
				"VALUES": {
					"fr": {
						"fr": "français",
						"en": "French"
					},
					"en": {
						"fr": "anglais",
						"en": "English"
					}
				}
			},
			"author": {
				"fr": "auteurs",
				"en": "authors"
			},
			"composer": {
				"fr": "compositeurs",
				"en": "composers"
			},
			"soloist": {
				"fr": "solistes",
				"en": "artists"
			},
			"conductor": {
				"fr": "chefs d'orchestre",
				"en": "conductors"
			},
			"instrument": {
				"fr": "instruments",
				"en": "instruments"
			}
		},
		"PAGE_NOT_FOUND": {
			"TITLE": {
				"fr": "Cette page n'existe pas",
				"en": "Page not found"
			},
			"CONTENT": {
				"fr": "",
				"en": ""
			}
		}
	},
	"HOME": {
		"CATALOGUE_GO": {
			"fr": "Voir le catalogue",
			"en": "Go to the catalogue"
		},
		"LATEST_RELEASES": {
			"fr": "Dernières publications",
			"en": "Latest releases"
		},
		"LATEST_RELEASES_SUB": {
			"fr": "Les derniers disques au catalogue",
			"en": "The latest in our catalogue"
		},
		"LATEST_RELEASES_GO": {
			"fr": "Voir les dernières publications",
			"en": "See the latest releases"
		},
		"SPECIALS": {
			"fr": "Forgotten Records présente",
			"en": "Forgotten Records presents"
		},
		"SPECIALS_SUB": {
			"fr": "Parmi les interprètes d'aujourd'hui",
			"en": "Some of our special releases"
		},
		"SPECIALS_GO": {
			"fr": "Voir davantage",
			"en": "See all the special releases"
		},
		"FEATURED": {
			"fr": "coup de cœur",
			"en": "featured"
		},
		"FEATURED_SUB": {
			"fr": "Nos recommandations du moment",
			"en": "What we are loving at the moment"
		}
	},
	"CATALOGUE": {
		"META": {
			"TITLE": {
				"fr": "Interprètes d'hier et d'aujourd'hui | Catalogue",
				"en": "Interpretations, past and present | Catalogue"
			}
		},
		"SEARCH": {
			"fr": "Rechercher",
			"en": "Search"
		},
		"NEW_SEARCH": {
			"fr": "Nouvelle recherche",
			"en": "New search"
		},
		"FILTERS": {
			"fr": "Filtres",
			"en": "Filters"
		},
		"FEATURED": {
			"fr": "Coup de coeur",
			"en": "Featured"
		}
	},
	"RECORD": {
		"ORIGINAL_REFERENCES": {
			"fr": "Edition originale",
			"en": "Original edition"
		},
		"LENGTH": {
			"fr": "Durée",
			"en": "Length"
		},
		"RECORDING": {
			"fr": "Enregistrement",
			"en": "Recording"
		},
		"DETAILS": {
			"fr": "Détails",
			"en": "Details"
		},
		"DESCRIPTION": {
			"fr": "Description",
			"en": "Description"
		},
		"RECOMMENDATION": {
			"fr": "Egalement par les mêmes interprètes",
			"en": "Featuring the same artists"
		}
	},
	"WRITING": {
		"FULL_TEXT_GO": {
			"fr": "Lire  le texte complet",
			"en": "Read the full text"
		},
		"AUTHOR_BY": {
			"fr": "par",
			"en": "by"
		},
		"NOT_TRANSLATED": {
			"fr": null,
			"en": "The full text has not been translated in English."
		},
		"READ_IN_PREFERRED_LANGUAGE": {
			"fr": "Lire en Français",
			"en": "Read in French"
		}
	},
	"CART": {
		"TITLE": {
			"fr": "Votre panier",
			"en": "Your cart"
		},
		"SHOW_ALL": {
			"fr": "Voir tout le panier",
			"en": "Show all items"
		},
		"GO": {
			"fr": "Accéder au panier",
			"en": "Go to your cart"
		},
		"EMPTY": {
			"fr": "Le panier est vide.",
			"en": "Your cart is currently empty."
		},
		"PROPERTY": {
			"PRICE": {
				"fr": "prix",
				"en": "price"
			},
			"QUANTITY": {
				"fr": "quantité",
				"en": "quantity"
			},
			"SUBTOTAL": {
				"fr": "sous-total",
				"en": "sub-total"
			},
			"TOTAL": {
				"fr": "total de la commande",
				"en": "total"
			},
			"SHIPPING": {
				"TITLE": {
					"fr": "Frais de livraison",
					"en": "Worldwide shipping"
				},
				"ONE": {
					"fr": "Premier disque",
					"en": "First item"
				},
				"OTHERS": {
					"fr": "Chaque disque supplémentaire",
					"en": "Each additional item"
				}
			}
		},
		"BACK": {
			"fr": "Revenir au catalogue",
			"en": "Back to catalogue"
		},
		"ADD": {
			"fr": "Ajouter au panier",
			"en": "Add to cart"
		},
		"DO_EMPTY": {
			"fr": "Vider le panier",
			"en": "Empty the cart"
		},
		"REMOVE": {
			"fr": "Retirer du panier",
			"en": "Remove from cart"
		},
		"WIDGET": {
			"NOTIFICATION": {
				"fr": "Le panier a été mis à jour",
				"en": "Your cart has been updated"
			}
		},
		"ORDER": {
			"TITLE": {
				"fr": "Confirmation de la commande",
				"en": "Order confirmation"
			},
			"MESSAGE": {
				"fr": "Vous recevrez d'ici peu un email de la part de notre partenaire.",
				"en": "You will receive a confirmation email very shortly."
			},
			"QUESTION": {
				"fr": "Pour toute question relative à cette commande, contactez-nous via",
				"en": "For any question about your order, feel free to contact us at"
			},
			"PAYMENT_ID": {
				"fr": "Identifiant du paiement",
				"en": "Payment ID"
			}
		}
	}
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lazyload_image_directive_1 = __webpack_require__(180);
exports.LazyLoadImageDirective = lazyload_image_directive_1.LazyLoadImageDirective;
var lazyload_image_module_1 = __webpack_require__(314);
exports.LazyLoadImageModule = lazyload_image_module_1.LazyLoadImageModule;
exports.default = lazyload_image_module_1.LazyLoadImageModule;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(513);
__webpack_require__(324);
__webpack_require__(518);
__webpack_require__(241);
__webpack_require__(515);
__webpack_require__(120);
__webpack_require__(100);
var Observable_1 = __webpack_require__(13);
function isVisible(element, threshold, _window) {
    if (threshold === void 0) { threshold = 0; }
    if (_window === void 0) { _window = window; }
    var _a = element.getBoundingClientRect(), top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    var height = _window.innerHeight;
    var width = _window.innerWidth;
    var elementLargerThenViewport = top <= -threshold && bottom >= (height + threshold) && left <= -threshold && right >= (width + threshold);
    var topInsideViewport = top <= (height + threshold) && top >= -threshold;
    var bottomInsideViewport = bottom >= -threshold && bottom <= (height + threshold);
    var rightsideInViewport = right >= -threshold && right <= (width + threshold);
    var leftsideInViewport = left <= (width + threshold) && left >= -threshold;
    return (elementLargerThenViewport ||
        ((topInsideViewport || bottomInsideViewport) &&
            (rightsideInViewport || leftsideInViewport)));
}
exports.isVisible = isVisible;
function loadImage(imagePath) {
    return Observable_1.Observable
        .create(function (observer) {
        var img = new Image();
        img.src = imagePath;
        img.onload = function () {
            observer.next(imagePath);
            observer.complete();
        };
        img.onerror = function (err) {
            observer.error(null);
        };
    });
}
function setImage(element, imagePath) {
    var isImgNode = element.nodeName.toLowerCase() === 'img';
    if (isImgNode) {
        element.src = imagePath;
    }
    else {
        element.style.backgroundImage = "url('" + imagePath + "')";
    }
    return element;
}
function setLoadedStyle(element) {
    var styles = element.className
        .split(' ')
        .filter(function (s) { return !!s; })
        .filter(function (s) { return s !== 'ng-lazyloading'; });
    styles.push('ng-lazyloaded');
    element.className = styles.join(' ');
    return element;
}
function lazyLoadImage(image, imagePath, defaultImagePath, errorImgPath, offset) {
    if (defaultImagePath) {
        setImage(image, defaultImagePath);
    }
    return function (scrollObservable) {
        return scrollObservable
            .filter(function () { return isVisible(image, offset); })
            .take(1)
            .mergeMap(function () { return loadImage(imagePath); })
            .do(function () { return setImage(image, imagePath); })
            .map(function () { return true; })
            .catch(function () {
            if (errorImgPath) {
                setImage(image, errorImgPath);
            }
            image.className += ' ng-failed-lazyloaded';
            return Observable_1.Observable.of(false);
        })
            .do(function () { return setLoadedStyle(image); });
    };
}
exports.lazyLoadImage = lazyLoadImage;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(517);
__webpack_require__(516);
__webpack_require__(325);
__webpack_require__(511);
var Observable_1 = __webpack_require__(13);
var scrollListeners = new WeakMap();
function sampleObservable(obs, scheduler) {
    return obs
        .sampleTime(100, scheduler)
        .share()
        .startWith('');
}
exports.sampleObservable = sampleObservable;
exports.getScrollListener = function (scrollTarget) {
    if (!scrollTarget || typeof scrollTarget.addEventListener !== 'function') {
        if (typeof window !== 'undefined') {
            console.warn('`addEventListener` on ' + scrollTarget + ' (scrollTarget) is not a function. Skipping this target');
        }
        return Observable_1.Observable.empty();
    }
    if (scrollListeners.has(scrollTarget)) {
        return scrollListeners.get(scrollTarget);
    }
    var srollEvent = Observable_1.Observable.create(function (observer) {
        var eventName = 'scroll';
        var handler = function (event) { return observer.next(event); };
        var options = { passive: true, capture: false };
        scrollTarget.addEventListener(eventName, handler, options);
        return function () { return scrollTarget.removeEventListener(eventName, handler, options); };
    });
    var listener = sampleObservable(srollEvent);
    scrollListeners.set(scrollTarget, listener);
    return listener;
};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

"use strict";
"use strict";
var FileType = (function () {
    function FileType() {
    }
    FileType.getMimeClass = function (file) {
        var mimeClass = 'application';
        if (this.mime_psd.indexOf(file.type) !== -1) {
            mimeClass = 'image';
        }
        else if (file.type.match('image.*')) {
            mimeClass = 'image';
        }
        else if (file.type.match('video.*')) {
            mimeClass = 'video';
        }
        else if (file.type.match('audio.*')) {
            mimeClass = 'audio';
        }
        else if (file.type === 'application/pdf') {
            mimeClass = 'pdf';
        }
        else if (this.mime_compress.indexOf(file.type) !== -1) {
            mimeClass = 'compress';
        }
        else if (this.mime_doc.indexOf(file.type) !== -1) {
            mimeClass = 'doc';
        }
        else if (this.mime_xsl.indexOf(file.type) !== -1) {
            mimeClass = 'xls';
        }
        else if (this.mime_ppt.indexOf(file.type) !== -1) {
            mimeClass = 'ppt';
        }
        if (mimeClass === 'application') {
            mimeClass = this.fileTypeDetection(file.name);
        }
        return mimeClass;
    };
    FileType.fileTypeDetection = function (inputFilename) {
        var types = {
            'jpg': 'image',
            'jpeg': 'image',
            'tif': 'image',
            'psd': 'image',
            'bmp': 'image',
            'png': 'image',
            'nef': 'image',
            'tiff': 'image',
            'cr2': 'image',
            'dwg': 'image',
            'cdr': 'image',
            'ai': 'image',
            'indd': 'image',
            'pin': 'image',
            'cdp': 'image',
            'skp': 'image',
            'stp': 'image',
            '3dm': 'image',
            'mp3': 'audio',
            'wav': 'audio',
            'wma': 'audio',
            'mod': 'audio',
            'm4a': 'audio',
            'compress': 'compress',
            'rar': 'compress',
            '7z': 'compress',
            'lz': 'compress',
            'z01': 'compress',
            'pdf': 'pdf',
            'xls': 'xls',
            'xlsx': 'xls',
            'ods': 'xls',
            'mp4': 'video',
            'avi': 'video',
            'wmv': 'video',
            'mpg': 'video',
            'mts': 'video',
            'flv': 'video',
            '3gp': 'video',
            'vob': 'video',
            'm4v': 'video',
            'mpeg': 'video',
            'm2ts': 'video',
            'mov': 'video',
            'doc': 'doc',
            'docx': 'doc',
            'eps': 'doc',
            'txt': 'doc',
            'odt': 'doc',
            'rtf': 'doc',
            'ppt': 'ppt',
            'pptx': 'ppt',
            'pps': 'ppt',
            'ppsx': 'ppt',
            'odp': 'ppt'
        };
        var chunks = inputFilename.split('.');
        if (chunks.length < 2) {
            return 'application';
        }
        var extension = chunks[chunks.length - 1].toLowerCase();
        if (types[extension] === undefined) {
            return 'application';
        }
        else {
            return types[extension];
        }
    };
    return FileType;
}());
/*  MS office  */
FileType.mime_doc = [
    'application/msword',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12'
];
FileType.mime_xsl = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
];
FileType.mime_ppt = [
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
/* PSD */
FileType.mime_psd = [
    'image/photoshop',
    'image/x-photoshop',
    'image/psd',
    'application/photoshop',
    'application/psd',
    'zz-application/zz-winassoc-psd'
];
/* Compressed files */
FileType.mime_compress = [
    'application/x-gtar',
    'application/x-gcompress',
    'application/compress',
    'application/x-tar',
    'application/x-rar-compressed',
    'application/octet-stream'
];
exports.FileType = FileType;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

"use strict";
/**
 * This is the entry point for the client side preboot library. At a high level, this library
 * is used to facilitate the switch from the server view to the client view. Specifically that
 * means:
 *
 *    1. Replay stored server view events on client view
 *    2. Switch buffer from server view to client view
 *    3. Reset focus on client view
 */
"use strict";
// the idea here is that preboot is a global value on the window that is used by the client
var preboot = prebootClient();
// wrapper function used to contain all the preboot client functionality
function prebootClient() {
    // used to cache map from server node key to associated client node
    var clientNodeCache = {};
    /**
     * External code call this to kick off the switch from server to client
     */
    function complete(opts) {
        opts = opts || {};
        var theWindow = (opts.window || window);
        var prebootData = theWindow.prebootData || {};
        var apps = prebootData.apps || [];
        // loop through each of the preboot apps
        apps.forEach(function (appData) { return completeApp(opts, appData); });
        // once all events have been replayed and buffers switched, then we cleanup preboot
        if (!opts.noCleanup) {
            cleanup(theWindow, prebootData);
        }
    }
    /**
     * Complete a particular app
     * @param opts
     * @param appData
     */
    function completeApp(opts, appData) {
        opts = opts || {};
        appData = (appData || {});
        var theWindow = (opts.window || window);
        var root = (appData.root || {});
        var events = appData.events || [];
        // if a specific app root set and it doesn't equal the server selector, then don't do anything
        if (opts.appRoot && opts.appRoot !== root.serverSelector) {
            return;
        }
        // some client side frameworks (like Angular 1 w UI Router) will replace
        // elements, so we need to re-get client root just to be safe
        root.clientNode = theWindow.document.querySelector(root.clientSelector);
        // replay all the events from the server view onto the client view
        events.forEach(function (event) { return replayEvent(appData, event); });
        // if we are buffering, switch the buffers
        switchBuffer(theWindow, appData);
    }
    /**
     * Replay a particular event. The trick here is finding the appropriate client
     * node where the event is to be dispatched that matches up with the server node
     * where the event came from originally.
     */
    function replayEvent(appData, prebootEvent) {
        appData = (appData || {});
        prebootEvent = (prebootEvent || {});
        var event = prebootEvent.event;
        var serverNode = prebootEvent.node || {};
        var nodeKey = prebootEvent.nodeKey;
        var clientNode = findClientNode({
            root: appData.root,
            node: serverNode,
            nodeKey: nodeKey
        });
        // if client node can't be found, log a warning
        if (!clientNode) {
            console.warn('Trying to dispatch event ' + event.type +
                ' to node ' + nodeKey + ' but could not find client node. ' +
                'Server node is: ');
            console.log(serverNode);
            return;
        }
        // now dispatch events and whatnot to the client node
        clientNode.checked = serverNode.checked ? true : undefined;
        clientNode.selected = serverNode.selected ? true : undefined;
        clientNode.value = serverNode.value;
        clientNode.dispatchEvent(event);
    }
    /**
     * Hide the server buffer and show the client buffer
     */
    function switchBuffer(window, appData) {
        appData = (appData || {});
        var root = (appData.root || {});
        var serverView = root.serverNode;
        var clientView = root.clientNode;
        // if no client view or the server view is the body or client
        // and server view are the same, then don't do anything and return
        if (!clientView || !serverView || serverView === clientView || serverView.nodeName === 'BODY') {
            return;
        }
        // do a try-catch for case where serverView is an object but NOT of type Element
        try {
            // get the server view display mode
            var display = window
                .getComputedStyle(serverView)
                .getPropertyValue('display') || 'block';
            // first remove the server view
            serverView.remove ?
                serverView.remove() :
                serverView.style.display = 'none';
            // now add the client view
            clientView.style.display = display;
        }
        catch (ex) {
            console.error(ex);
        }
    }
    /**
     * This function does three things to cleanup preboot:
     *    1. Set focus (and selection if a text box/text area) within a form element
     *    2. Remove existing event listeners
     *    3. Delete data from memory
     */
    function cleanup(window, prebootData) {
        prebootData = prebootData || {};
        var listeners = prebootData.listeners || [];
        // set focus on the active node AFTER a small delay to ensure buffer switched
        setTimeout(function () {
            setFocus(prebootData.activeNode);
        }, 1);
        // remove all event listeners
        for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
            var listener = listeners_1[_i];
            listener.node.removeEventListener(listener.eventName, listener.handler);
        }
        // remove the freeze overlay if it exists
        removeOverlay(window);
        // finally clear out the data stored for each app
        prebootData.apps = [];
        clientNodeCache = {};
    }
    /**
     * Remove the overlay if it exists
     */
    function removeOverlay(window) {
        var prebootOverlay = window.document.body.querySelector('#prebootOverlay');
        if (prebootOverlay) {
            prebootOverlay.style.display = 'none';
        }
    }
    /**
     * Set focus on a given active node element
     */
    function setFocus(activeNode) {
        // only do something if there is an active node
        if (!activeNode || !activeNode.node || !activeNode.nodeKey) {
            return;
        }
        // find the client node in the new client view
        var clientNode = findClientNode(activeNode);
        if (clientNode) {
            // set focus on the client node
            clientNode.focus();
            // set selection if a modern browser (i.e. IE9+, etc.)
            var selection = activeNode.selection;
            if (clientNode.setSelectionRange && selection) {
                clientNode.setSelectionRange(selection.start, selection.end, selection.direction);
            }
        }
    }
    /**
     * Given a node from the server rendered view, find the equivalent
     * node in the client rendered view. We do this by the following approach:
     *      1. take the name of the server node tag (ex. div or h1 or input)
     *      2. add either id (ex. div#myid) or class names (ex. div.class1.class2)
     *      3. use that value as a selector to get all the matching client nodes
     *      4. loop through all client nodes found and for each generate a key value
     *      5. compare the client key to the server key; once there is a match, we have our client node
     *
     * NOTE: this only works when the client view is almost exactly the same as the server
     * view. we will need an improvement here in the future to account for situations
     * where the client view is different in structure from the server view
     */
    function findClientNode(serverNodeContext) {
        serverNodeContext = (serverNodeContext || {});
        var serverNode = serverNodeContext.node;
        var root = serverNodeContext.root;
        // if no server or client root, don't do anything
        if (!root || !root.serverNode || !root.clientNode) {
            return null;
        }
        // we use the string of the node to compare to the client node & as key in cache
        var serverNodeKey = serverNodeContext.nodeKey || getNodeKey(serverNodeContext);
        // if client node already in cache, return it
        if (clientNodeCache[serverNodeKey]) {
            return clientNodeCache[serverNodeKey];
        }
        // get the selector for client nodes
        var className = (serverNode.className || '').replace('ng-binding', '').trim();
        var selector = serverNode.tagName;
        if (serverNode.id) {
            selector += '#' + serverNode.id;
        }
        else if (className) {
            selector += '.' + className.replace(/ /g, '.');
        }
        // select all possible client nodes and look through them to try and find a match
        var rootClientNode = root.clientNode;
        var clientNodes = rootClientNode.querySelectorAll(selector) || [];
        // if nothing found, then just try the tag name as a final option
        if (!clientNodes.length) {
            clientNodes = rootClientNode.querySelectorAll(serverNode.tagName) || [];
        }
        for (var _i = 0, clientNodes_1 = clientNodes; _i < clientNodes_1.length; _i++) {
            var clientNode = clientNodes_1[_i];
            // get the key for the client node
            var clientNodeKey = getNodeKey({ root: root, node: clientNode });
            // if the client node key is exact match for the server node key, then we found the client node
            if (clientNodeKey === serverNodeKey) {
                clientNodeCache[serverNodeKey] = clientNode;
                return clientNode;
            }
        }
        // if we get here and there is one clientNode, use it as a fallback
        if (clientNodes.length === 1) {
            clientNodeCache[serverNodeKey] = clientNodes[0];
            return clientNodes[0];
        }
        // if we get here it means we couldn't find the client node so give the user a warning
        console.warn('No matching client node found for ' + serverNodeKey +
            '. You can fix this by assigning this element a unique id attribute.');
        return null;
    }
    /**
     * Attempt to generate key from node position in the DOM
     *
     * NOTE: this function is duplicated in preboot_inline.ts and must be
     * kept in sync. It is duplicated for right now since we are trying
     * to keep all inline code separated and distinct (i.e. without imports)
     */
    function getNodeKey(nodeContext) {
        var ancestors = [];
        var root = nodeContext.root;
        var node = nodeContext.node;
        var temp = node;
        // walk up the tree from the target node up to the root
        while (temp && temp !== root.serverNode && temp !== root.clientNode) {
            ancestors.push(temp);
            temp = temp.parentNode;
        }
        // note: if temp doesn't exist here it means root node wasn't found
        if (temp) {
            ancestors.push(temp);
        }
        // now go backwards starting from the root, appending the appName to unique identify the node later..
        var name = node.nodeName || 'unknown';
        var key = name + '_' + root.serverSelector;
        var len = ancestors.length;
        for (var i = (len - 1); i >= 0; i--) {
            temp = ancestors[i];
            if (temp.childNodes && i > 0) {
                for (var j = 0; j < temp.childNodes.length; j++) {
                    if (temp.childNodes[j] === ancestors[i - 1]) {
                        key += '_s' + (j + 1);
                        break;
                    }
                }
            }
        }
        return key;
    }
    return {
        complete: complete,
        completeApp: completeApp,
        replayEvent: replayEvent,
        switchBuffer: switchBuffer,
        removeOverlay: removeOverlay,
        cleanup: cleanup,
        setFocus: setFocus,
        findClientNode: findClientNode,
        getNodeKey: getNodeKey
    };
}
exports.prebootClient = prebootClient;


/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic);/*!\n *   AdminLTE v2.3.8\n *   Author: Almsaeed Studio\n *\t Website: Almsaeed Studio <http://almsaeedstudio.com>\n *   License: Open source - MIT\n *           Please visit http://opensource.org/licenses/MIT for more information\n!*/html,body{height:100%}.layout-boxed html,.layout-boxed body{height:100%}body{font-family:'Source Sans Pro','Helvetica Neue',Helvetica,Arial,sans-serif;font-weight:400;overflow-x:hidden;overflow-y:auto}.wrapper{height:100%;position:relative;overflow-x:hidden;overflow-y:auto}.wrapper:before,.wrapper:after{content:\" \";display:table}.wrapper:after{clear:both}.layout-boxed .wrapper{max-width:1250px;margin:0 auto;min-height:100%;box-shadow:0 0 8px rgba(0,0,0,0.5);position:relative}.layout-boxed{background:url('../img/boxed-bg.jpg') repeat fixed}.content-wrapper,.right-side,.main-footer{-webkit-transition:-webkit-transform .3s ease-in-out,margin .3s ease-in-out;-moz-transition:-moz-transform .3s ease-in-out,margin .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out,margin .3s ease-in-out;transition:transform .3s ease-in-out,margin .3s ease-in-out;margin-left:230px;z-index:820}.layout-top-nav .content-wrapper,.layout-top-nav .right-side,.layout-top-nav .main-footer{margin-left:0}@media (max-width:767px){.content-wrapper,.right-side,.main-footer{margin-left:0}}@media (min-width:768px){.sidebar-collapse .content-wrapper,.sidebar-collapse .right-side,.sidebar-collapse .main-footer{margin-left:0}}@media (max-width:767px){.sidebar-open .content-wrapper,.sidebar-open .right-side,.sidebar-open .main-footer{-webkit-transform:translate(230px, 0);-ms-transform:translate(230px, 0);-o-transform:translate(230px, 0);transform:translate(230px, 0)}}.content-wrapper,.right-side{min-height:100%;background-color:#ecf0f5;z-index:800}.main-footer{background:#fff;padding:15px;color:#444;border-top:1px solid #d2d6de}.fixed .main-header,.fixed .main-sidebar,.fixed .left-side{position:fixed}.fixed .main-header{top:0;right:0;left:0}.fixed .content-wrapper,.fixed .right-side{padding-top:50px}@media (max-width:767px){.fixed .content-wrapper,.fixed .right-side{padding-top:100px}}.fixed.layout-boxed .wrapper{max-width:100%}body.hold-transition .content-wrapper,body.hold-transition .right-side,body.hold-transition .main-footer,body.hold-transition .main-sidebar,body.hold-transition .left-side,body.hold-transition .main-header .navbar,body.hold-transition .main-header .logo{-webkit-transition:none;-o-transition:none;transition:none}.content{min-height:250px;padding:15px;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6{font-family:'Source Sans Pro',sans-serif}a{color:#3c8dbc}a:hover,a:active,a:focus{outline:none;text-decoration:none;color:#72afd2}.page-header{margin:10px 0 20px 0;font-size:22px}.page-header>small{color:#666;display:block;margin-top:5px}.main-header{position:relative;max-height:100px;z-index:1030}.main-header .navbar{-webkit-transition:margin-left .3s ease-in-out;-o-transition:margin-left .3s ease-in-out;transition:margin-left .3s ease-in-out;margin-bottom:0;margin-left:230px;border:none;min-height:50px;border-radius:0}.layout-top-nav .main-header .navbar{margin-left:0}.main-header #navbar-search-input.form-control{background:rgba(255,255,255,0.2);border-color:transparent}.main-header #navbar-search-input.form-control:focus,.main-header #navbar-search-input.form-control:active{border-color:rgba(0,0,0,0.1);background:rgba(255,255,255,0.9)}.main-header #navbar-search-input.form-control::-moz-placeholder{color:#ccc;opacity:1}.main-header #navbar-search-input.form-control:-ms-input-placeholder{color:#ccc}.main-header #navbar-search-input.form-control::-webkit-input-placeholder{color:#ccc}.main-header .navbar-custom-menu,.main-header .navbar-right{float:right}@media (max-width:991px){.main-header .navbar-custom-menu a,.main-header .navbar-right a{color:inherit;background:transparent}}@media (max-width:767px){.main-header .navbar-right{float:none}.navbar-collapse .main-header .navbar-right{margin:7.5px -15px}.main-header .navbar-right>li{color:inherit;border:0}}.main-header .sidebar-toggle{float:left;background-color:transparent;background-image:none;padding:15px 15px;font-family:fontAwesome}.main-header .sidebar-toggle:before{content:\"\\f0c9\"}.main-header .sidebar-toggle:hover{color:#fff}.main-header .sidebar-toggle:focus,.main-header .sidebar-toggle:active{background:transparent}.main-header .sidebar-toggle .icon-bar{display:none}.main-header .navbar .nav>li.user>a>.fa,.main-header .navbar .nav>li.user>a>.glyphicon,.main-header .navbar .nav>li.user>a>.ion{margin-right:5px}.main-header .navbar .nav>li>a>.label{position:absolute;top:9px;right:7px;text-align:center;font-size:9px;padding:2px 3px;line-height:.9}.main-header .logo{-webkit-transition:width .3s ease-in-out;-o-transition:width .3s ease-in-out;transition:width .3s ease-in-out;display:block;float:left;height:50px;font-size:20px;line-height:50px;text-align:center;width:230px;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;padding:0 15px;font-weight:300;overflow:hidden}.main-header .logo .logo-lg{display:block}.main-header .logo .logo-mini{display:none}.main-header .navbar-brand{color:#fff}.content-header{position:relative;padding:15px 15px 0 15px}.content-header>h1{margin:0;font-size:24px}.content-header>h1>small{font-size:15px;display:inline-block;padding-left:4px;font-weight:300}.content-header>.breadcrumb{float:right;background:transparent;margin-top:0;margin-bottom:0;font-size:12px;padding:7px 5px;position:absolute;top:15px;right:10px;border-radius:2px}.content-header>.breadcrumb>li>a{color:#444;text-decoration:none;display:inline-block}.content-header>.breadcrumb>li>a>.fa,.content-header>.breadcrumb>li>a>.glyphicon,.content-header>.breadcrumb>li>a>.ion{margin-right:5px}.content-header>.breadcrumb>li+li:before{content:'>\\00a0'}@media (max-width:991px){.content-header>.breadcrumb{position:relative;margin-top:5px;top:0;right:0;float:none;background:#d2d6de;padding-left:10px}.content-header>.breadcrumb li:before{color:#97a0b3}}.navbar-toggle{color:#fff;border:0;margin:0;padding:15px 15px}@media (max-width:991px){.navbar-custom-menu .navbar-nav>li{float:left}.navbar-custom-menu .navbar-nav{margin:0;float:left}.navbar-custom-menu .navbar-nav>li>a{padding-top:15px;padding-bottom:15px;line-height:20px}}@media (max-width:767px){.main-header{position:relative}.main-header .logo,.main-header .navbar{width:100%;float:none}.main-header .navbar{margin:0}.main-header .navbar-custom-menu{float:right}}@media (max-width:991px){.navbar-collapse.pull-left{float:none !important}.navbar-collapse.pull-left+.navbar-custom-menu{display:block;position:absolute;top:0;right:40px}}.main-sidebar,.left-side{position:absolute;top:0;left:0;padding-top:50px;min-height:100%;width:230px;z-index:810;-webkit-transition:-webkit-transform .3s ease-in-out,width .3s ease-in-out;-moz-transition:-moz-transform .3s ease-in-out,width .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out,width .3s ease-in-out;transition:transform .3s ease-in-out,width .3s ease-in-out}@media (max-width:767px){.main-sidebar,.left-side{padding-top:100px}}@media (max-width:767px){.main-sidebar,.left-side{-webkit-transform:translate(-230px, 0);-ms-transform:translate(-230px, 0);-o-transform:translate(-230px, 0);transform:translate(-230px, 0)}}@media (min-width:768px){.sidebar-collapse .main-sidebar,.sidebar-collapse .left-side{-webkit-transform:translate(-230px, 0);-ms-transform:translate(-230px, 0);-o-transform:translate(-230px, 0);transform:translate(-230px, 0)}}@media (max-width:767px){.sidebar-open .main-sidebar,.sidebar-open .left-side{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}}.sidebar{padding-bottom:10px}.sidebar-form input:focus{border-color:transparent}.user-panel{position:relative;width:100%;padding:10px;overflow:hidden}.user-panel:before,.user-panel:after{content:\" \";display:table}.user-panel:after{clear:both}.user-panel>.image>img{width:100%;max-width:45px;height:auto}.user-panel>.info{padding:5px 5px 5px 15px;line-height:1;position:absolute;left:55px}.user-panel>.info>p{font-weight:600;margin-bottom:9px}.user-panel>.info>a{text-decoration:none;padding-right:5px;margin-top:3px;font-size:11px}.user-panel>.info>a>.fa,.user-panel>.info>a>.ion,.user-panel>.info>a>.glyphicon{margin-right:3px}.sidebar-menu{list-style:none;margin:0;padding:0}.sidebar-menu>li{position:relative;margin:0;padding:0}.sidebar-menu>li>a{padding:12px 5px 12px 15px;display:block}.sidebar-menu>li>a>.fa,.sidebar-menu>li>a>.glyphicon,.sidebar-menu>li>a>.ion{width:20px}.sidebar-menu>li .label,.sidebar-menu>li .badge{margin-right:5px}.sidebar-menu>li .badge{margin-top:3px}.sidebar-menu li.header{padding:10px 25px 10px 15px;font-size:12px}.sidebar-menu li>a>.fa-angle-left,.sidebar-menu li>a>.pull-right-container>.fa-angle-left{width:auto;height:auto;padding:0;margin-right:10px}.sidebar-menu li>a>.fa-angle-left{position:absolute;top:50%;right:10px;margin-top:-8px}.sidebar-menu li.active>a>.fa-angle-left,.sidebar-menu li.active>a>.pull-right-container>.fa-angle-left{-webkit-transform:rotate(-90deg);-ms-transform:rotate(-90deg);-o-transform:rotate(-90deg);transform:rotate(-90deg)}.sidebar-menu li.active>.treeview-menu{display:block}.sidebar-menu .treeview-menu{display:none;list-style:none;padding:0;margin:0;padding-left:5px}.sidebar-menu .treeview-menu .treeview-menu{padding-left:20px}.sidebar-menu .treeview-menu>li{margin:0}.sidebar-menu .treeview-menu>li>a{padding:5px 5px 5px 15px;display:block;font-size:14px}.sidebar-menu .treeview-menu>li>a>.fa,.sidebar-menu .treeview-menu>li>a>.glyphicon,.sidebar-menu .treeview-menu>li>a>.ion{width:20px}.sidebar-menu .treeview-menu>li>a>.pull-right-container>.fa-angle-left,.sidebar-menu .treeview-menu>li>a>.pull-right-container>.fa-angle-down,.sidebar-menu .treeview-menu>li>a>.fa-angle-left,.sidebar-menu .treeview-menu>li>a>.fa-angle-down{width:auto}@media (min-width:768px){.sidebar-mini.sidebar-collapse .content-wrapper,.sidebar-mini.sidebar-collapse .right-side,.sidebar-mini.sidebar-collapse .main-footer{margin-left:50px !important;z-index:840}.sidebar-mini.sidebar-collapse .main-sidebar{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0);width:50px !important;z-index:850}.sidebar-mini.sidebar-collapse .sidebar-menu>li{position:relative}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a{margin-right:0}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span{border-top-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:not(.treeview)>a>span{border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu{padding-top:5px;padding-bottom:5px;border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span:not(.pull-right),.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{display:block !important;position:absolute;width:180px;left:50px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span{top:0;margin-left:-3px;padding:12px 5px 12px 20px;background-color:inherit}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>.pull-right-container{position:relative!important;float:right;width:auto!important;left:180px !important;top:-22px !important;z-index:900}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>.pull-right-container>.label:not(:first-of-type){display:none}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{top:44px;margin-left:0}.sidebar-mini.sidebar-collapse .main-sidebar .user-panel>.info,.sidebar-mini.sidebar-collapse .sidebar-form,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span,.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>.pull-right,.sidebar-mini.sidebar-collapse .sidebar-menu li.header{display:none !important;-webkit-transform:translateZ(0)}.sidebar-mini.sidebar-collapse .main-header .logo{width:50px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-mini{display:block;margin-left:-15px;margin-right:-15px;font-size:18px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-lg{display:none}.sidebar-mini.sidebar-collapse .main-header .navbar{margin-left:50px}}.sidebar-menu,.main-sidebar .user-panel,.sidebar-menu>li.header{white-space:nowrap;overflow:hidden}.sidebar-menu:hover{overflow:visible}.sidebar-form,.sidebar-menu>li.header{overflow:hidden;text-overflow:clip}.sidebar-menu li>a{position:relative}.sidebar-menu li>a>.pull-right-container{position:absolute;right:10px;top:50%;margin-top:-7px}.control-sidebar-bg{position:fixed;z-index:1000;bottom:0}.control-sidebar-bg,.control-sidebar{top:0;right:-230px;width:230px;-webkit-transition:right .3s ease-in-out;-o-transition:right .3s ease-in-out;transition:right .3s ease-in-out}.control-sidebar{position:absolute;padding-top:50px;z-index:1010}@media (max-width:768px){.control-sidebar{padding-top:100px}}.control-sidebar>.tab-content{padding:10px 15px}.control-sidebar.control-sidebar-open,.control-sidebar.control-sidebar-open+.control-sidebar-bg{right:0}.control-sidebar-open .control-sidebar-bg,.control-sidebar-open .control-sidebar{right:0}@media (min-width:768px){.control-sidebar-open .content-wrapper,.control-sidebar-open .right-side,.control-sidebar-open .main-footer{margin-right:230px}}.nav-tabs.control-sidebar-tabs>li:first-of-type>a,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:hover,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:focus{border-left-width:0}.nav-tabs.control-sidebar-tabs>li>a{border-radius:0}.nav-tabs.control-sidebar-tabs>li>a,.nav-tabs.control-sidebar-tabs>li>a:hover{border-top:none;border-right:none;border-left:1px solid transparent;border-bottom:1px solid transparent}.nav-tabs.control-sidebar-tabs>li>a .icon{font-size:16px}.nav-tabs.control-sidebar-tabs>li.active>a,.nav-tabs.control-sidebar-tabs>li.active>a:hover,.nav-tabs.control-sidebar-tabs>li.active>a:focus,.nav-tabs.control-sidebar-tabs>li.active>a:active{border-top:none;border-right:none;border-bottom:none}@media (max-width:768px){.nav-tabs.control-sidebar-tabs{display:table}.nav-tabs.control-sidebar-tabs>li{display:table-cell}}.control-sidebar-heading{font-weight:400;font-size:16px;padding:10px 0;margin-bottom:10px}.control-sidebar-subheading{display:block;font-weight:400;font-size:14px}.control-sidebar-menu{list-style:none;padding:0;margin:0 -15px}.control-sidebar-menu>li>a{display:block;padding:10px 15px}.control-sidebar-menu>li>a:before,.control-sidebar-menu>li>a:after{content:\" \";display:table}.control-sidebar-menu>li>a:after{clear:both}.control-sidebar-menu>li>a>.control-sidebar-subheading{margin-top:0}.control-sidebar-menu .menu-icon{float:left;width:35px;height:35px;border-radius:50%;text-align:center;line-height:35px}.control-sidebar-menu .menu-info{margin-left:45px;margin-top:3px}.control-sidebar-menu .menu-info>.control-sidebar-subheading{margin:0}.control-sidebar-menu .menu-info>p{margin:0;font-size:11px}.control-sidebar-menu .progress{margin:0}.control-sidebar-dark{color:#b8c7ce}.control-sidebar-dark,.control-sidebar-dark+.control-sidebar-bg{background:#222d32}.control-sidebar-dark .nav-tabs.control-sidebar-tabs{border-bottom:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a{background:#181f23;color:#b8c7ce}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus{border-left-color:#141a1d;border-bottom-color:#141a1d}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:active{background:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{color:#fff}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:active{background:#222d32;color:#fff}.control-sidebar-dark .control-sidebar-heading,.control-sidebar-dark .control-sidebar-subheading{color:#fff}.control-sidebar-dark .control-sidebar-menu>li>a:hover{background:#1e282c}.control-sidebar-dark .control-sidebar-menu>li>a .menu-info>p{color:#b8c7ce}.control-sidebar-light{color:#5e5e5e}.control-sidebar-light,.control-sidebar-light+.control-sidebar-bg{background:#f9fafc;border-left:1px solid #d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs{border-bottom:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a{background:#e8ecf4;color:#444}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus{border-left-color:#d2d6de;border-bottom-color:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:active{background:#eff1f7}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:active{background:#f9fafc;color:#111}.control-sidebar-light .control-sidebar-heading,.control-sidebar-light .control-sidebar-subheading{color:#111}.control-sidebar-light .control-sidebar-menu{margin-left:-14px}.control-sidebar-light .control-sidebar-menu>li>a:hover{background:#f4f4f5}.control-sidebar-light .control-sidebar-menu>li>a .menu-info>p{color:#5e5e5e}.dropdown-menu{box-shadow:none;border-color:#eee}.dropdown-menu>li>a{color:#777}.dropdown-menu>li>a>.glyphicon,.dropdown-menu>li>a>.fa,.dropdown-menu>li>a>.ion{margin-right:10px}.dropdown-menu>li>a:hover{background-color:#e1e3e9;color:#333}.dropdown-menu>.divider{background-color:#eee}.navbar-nav>.notifications-menu>.dropdown-menu,.navbar-nav>.messages-menu>.dropdown-menu,.navbar-nav>.tasks-menu>.dropdown-menu{width:280px;padding:0 0 0 0;margin:0;top:100%}.navbar-nav>.notifications-menu>.dropdown-menu>li,.navbar-nav>.messages-menu>.dropdown-menu>li,.navbar-nav>.tasks-menu>.dropdown-menu>li{position:relative}.navbar-nav>.notifications-menu>.dropdown-menu>li.header,.navbar-nav>.messages-menu>.dropdown-menu>li.header,.navbar-nav>.tasks-menu>.dropdown-menu>li.header{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0;background-color:#ffffff;padding:7px 10px;border-bottom:1px solid #f4f4f4;color:#444444;font-size:14px}.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px;font-size:12px;background-color:#fff;padding:7px 10px;border-bottom:1px solid #eeeeee;color:#444 !important;text-align:center}@media (max-width:991px){.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{background:#fff !important;color:#444 !important}}.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a:hover{text-decoration:none;font-weight:normal}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu,.navbar-nav>.messages-menu>.dropdown-menu>li .menu,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu{max-height:200px;margin:0;padding:0;list-style:none;overflow-x:hidden}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{display:block;white-space:nowrap;border-bottom:1px solid #f4f4f4}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background:#f4f4f4;text-decoration:none}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a{color:#444444;overflow:hidden;text-overflow:ellipsis;padding:10px}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.glyphicon,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.fa,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.ion{width:20px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a{margin:0;padding:10px 10px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>div>img{margin:auto 10px auto auto;width:40px;height:40px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4{padding:0;margin:0 0 0 45px;color:#444444;font-size:15px;position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4>small{color:#999999;font-size:10px;position:absolute;top:0;right:0}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>p{margin:0 0 0 45px;font-size:12px;color:#888888}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:before,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{content:\" \";display:table}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{clear:both}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{padding:10px}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px 0;color:#666666}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>.progress{padding:0;margin:0}.navbar-nav>.user-menu>.dropdown-menu{border-top-right-radius:0;border-top-left-radius:0;padding:1px 0 0 0;border-top-width:0;width:280px}.navbar-nav>.user-menu>.dropdown-menu,.navbar-nav>.user-menu>.dropdown-menu>.user-body{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header{height:175px;padding:10px;text-align:center}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>img{z-index:5;height:90px;width:90px;border:3px solid;border-color:transparent;border-color:rgba(255,255,255,0.2)}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p{z-index:5;color:#fff;color:rgba(255,255,255,0.8);font-size:17px;margin-top:10px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p>small{display:block;font-size:12px}.navbar-nav>.user-menu>.dropdown-menu>.user-body{padding:15px;border-bottom:1px solid #f4f4f4;border-top:1px solid #dddddd}.navbar-nav>.user-menu>.dropdown-menu>.user-body:before,.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{content:\" \";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-body a{color:#444 !important}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-body a{background:#fff !important;color:#444 !important}}.navbar-nav>.user-menu>.dropdown-menu>.user-footer{background-color:#f9f9f9;padding:10px}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:before,.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{content:\" \";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default{color:#666666}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default:hover{background-color:#f9f9f9}}.navbar-nav>.user-menu .user-image{float:left;width:25px;height:25px;border-radius:50%;margin-right:10px;margin-top:-2px}@media (max-width:767px){.navbar-nav>.user-menu .user-image{float:none;margin-right:0;margin-top:-8px;line-height:10px}}.open:not(.dropup)>.animated-dropdown-menu{backface-visibility:visible !important;-webkit-animation:flipInX .7s both;-o-animation:flipInX .7s both;animation:flipInX .7s both}@keyframes flipInX{0%{transform:perspective(400px) rotate3d(1, 0, 0, 90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(1, 0, 0, -20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}100%{transform:perspective(400px)}}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 90deg);-webkit-transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -20deg);-webkit-transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, 10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotate3d(1, 0, 0, -5deg)}100%{-webkit-transform:perspective(400px)}}.navbar-custom-menu>.navbar-nav>li{position:relative}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:0;left:auto}@media (max-width:991px){.navbar-custom-menu>.navbar-nav{float:right}.navbar-custom-menu>.navbar-nav>li{position:static}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:5%;left:auto;border:1px solid #ddd;background:#fff}}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}.form-control:focus{border-color:#3c8dbc;box-shadow:none}.form-control::-moz-placeholder,.form-control:-ms-input-placeholder,.form-control::-webkit-input-placeholder{color:#bbb;opacity:1}.form-control:not(select){-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-group.has-success label{color:#00a65a}.form-group.has-success .form-control,.form-group.has-success .input-group-addon{border-color:#00a65a;box-shadow:none}.form-group.has-success .help-block{color:#00a65a}.form-group.has-warning label{color:#f39c12}.form-group.has-warning .form-control,.form-group.has-warning .input-group-addon{border-color:#f39c12;box-shadow:none}.form-group.has-warning .help-block{color:#f39c12}.form-group.has-error label{color:#dd4b39}.form-group.has-error .form-control,.form-group.has-error .input-group-addon{border-color:#dd4b39;box-shadow:none}.form-group.has-error .help-block{color:#dd4b39}.input-group .input-group-addon{border-radius:0;border-color:#d2d6de;background-color:#fff}.btn-group-vertical .btn.btn-flat:first-of-type,.btn-group-vertical .btn.btn-flat:last-of-type{border-radius:0}.icheck>label{padding-left:0}.form-control-feedback.fa{line-height:34px}.input-lg+.form-control-feedback.fa,.input-group-lg+.form-control-feedback.fa,.form-group-lg .form-control+.form-control-feedback.fa{line-height:46px}.input-sm+.form-control-feedback.fa,.input-group-sm+.form-control-feedback.fa,.form-group-sm .form-control+.form-control-feedback.fa{line-height:30px}.progress,.progress>.progress-bar{-webkit-box-shadow:none;box-shadow:none}.progress,.progress>.progress-bar,.progress .progress-bar,.progress>.progress-bar .progress-bar{border-radius:1px}.progress.sm,.progress-sm{height:10px}.progress.sm,.progress-sm,.progress.sm .progress-bar,.progress-sm .progress-bar{border-radius:1px}.progress.xs,.progress-xs{height:7px}.progress.xs,.progress-xs,.progress.xs .progress-bar,.progress-xs .progress-bar{border-radius:1px}.progress.xxs,.progress-xxs{height:3px}.progress.xxs,.progress-xxs,.progress.xxs .progress-bar,.progress-xxs .progress-bar{border-radius:1px}.progress.vertical{position:relative;width:30px;height:200px;display:inline-block;margin-right:10px}.progress.vertical>.progress-bar{width:100%;position:absolute;bottom:0}.progress.vertical.sm,.progress.vertical.progress-sm{width:20px}.progress.vertical.xs,.progress.vertical.progress-xs{width:10px}.progress.vertical.xxs,.progress.vertical.progress-xxs{width:3px}.progress-group .progress-text{font-weight:600}.progress-group .progress-number{float:right}.table tr>td .progress{margin:0}.progress-bar-light-blue,.progress-bar-primary{background-color:#3c8dbc}.progress-striped .progress-bar-light-blue,.progress-striped .progress-bar-primary{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-green,.progress-bar-success{background-color:#00a65a}.progress-striped .progress-bar-green,.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-aqua,.progress-bar-info{background-color:#00c0ef}.progress-striped .progress-bar-aqua,.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-yellow,.progress-bar-warning{background-color:#f39c12}.progress-striped .progress-bar-yellow,.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.progress-bar-red,.progress-bar-danger{background-color:#dd4b39}.progress-striped .progress-bar-red,.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)}.small-box{border-radius:2px;position:relative;display:block;margin-bottom:20px;box-shadow:0 1px 1px rgba(0,0,0,0.1)}.small-box>.inner{padding:10px}.small-box>.small-box-footer{position:relative;text-align:center;padding:3px 0;color:#fff;color:rgba(255,255,255,0.8);display:block;z-index:10;background:rgba(0,0,0,0.1);text-decoration:none}.small-box>.small-box-footer:hover{color:#fff;background:rgba(0,0,0,0.15)}.small-box h3{font-size:38px;font-weight:bold;margin:0 0 10px 0;white-space:nowrap;padding:0}.small-box p{font-size:15px}.small-box p>small{display:block;color:#f9f9f9;font-size:13px;margin-top:5px}.small-box h3,.small-box p{z-index:5}.small-box .icon{-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear;position:absolute;top:-10px;right:10px;z-index:0;font-size:90px;color:rgba(0,0,0,0.15)}.small-box:hover{text-decoration:none;color:#f9f9f9}.small-box:hover .icon{font-size:95px}@media (max-width:767px){.small-box{text-align:center}.small-box .icon{display:none}.small-box p{font-size:12px}}.box{position:relative;border-radius:3px;background:#ffffff;border-top:3px solid #d2d6de;margin-bottom:20px;width:100%;box-shadow:0 1px 1px rgba(0,0,0,0.1)}.box.box-primary{border-top-color:#3c8dbc}.box.box-info{border-top-color:#00c0ef}.box.box-danger{border-top-color:#dd4b39}.box.box-warning{border-top-color:#f39c12}.box.box-success{border-top-color:#00a65a}.box.box-default{border-top-color:#d2d6de}.box.collapsed-box .box-body,.box.collapsed-box .box-footer{display:none}.box .nav-stacked>li{border-bottom:1px solid #f4f4f4;margin:0}.box .nav-stacked>li:last-of-type{border-bottom:none}.box.height-control .box-body{max-height:300px;overflow:auto}.box .border-right{border-right:1px solid #f4f4f4}.box .border-left{border-left:1px solid #f4f4f4}.box.box-solid{border-top:0}.box.box-solid>.box-header .btn.btn-default{background:transparent}.box.box-solid>.box-header .btn:hover,.box.box-solid>.box-header a:hover{background:rgba(0,0,0,0.1)}.box.box-solid.box-default{border:1px solid #d2d6de}.box.box-solid.box-default>.box-header{color:#444;background:#d2d6de;background-color:#d2d6de}.box.box-solid.box-default>.box-header a,.box.box-solid.box-default>.box-header .btn{color:#444}.box.box-solid.box-primary{border:1px solid #3c8dbc}.box.box-solid.box-primary>.box-header{color:#fff;background:#3c8dbc;background-color:#3c8dbc}.box.box-solid.box-primary>.box-header a,.box.box-solid.box-primary>.box-header .btn{color:#fff}.box.box-solid.box-info{border:1px solid #00c0ef}.box.box-solid.box-info>.box-header{color:#fff;background:#00c0ef;background-color:#00c0ef}.box.box-solid.box-info>.box-header a,.box.box-solid.box-info>.box-header .btn{color:#fff}.box.box-solid.box-danger{border:1px solid #dd4b39}.box.box-solid.box-danger>.box-header{color:#fff;background:#dd4b39;background-color:#dd4b39}.box.box-solid.box-danger>.box-header a,.box.box-solid.box-danger>.box-header .btn{color:#fff}.box.box-solid.box-warning{border:1px solid #f39c12}.box.box-solid.box-warning>.box-header{color:#fff;background:#f39c12;background-color:#f39c12}.box.box-solid.box-warning>.box-header a,.box.box-solid.box-warning>.box-header .btn{color:#fff}.box.box-solid.box-success{border:1px solid #00a65a}.box.box-solid.box-success>.box-header{color:#fff;background:#00a65a;background-color:#00a65a}.box.box-solid.box-success>.box-header a,.box.box-solid.box-success>.box-header .btn{color:#fff}.box.box-solid>.box-header>.box-tools .btn{border:0;box-shadow:none}.box.box-solid[class*='bg']>.box-header{color:#fff}.box .box-group>.box{margin-bottom:5px}.box .knob-label{text-align:center;color:#333;font-weight:100;font-size:12px;margin-bottom:0.3em}.box>.overlay,.overlay-wrapper>.overlay,.box>.loading-img,.overlay-wrapper>.loading-img{position:absolute;top:0;left:0;width:100%;height:100%}.box .overlay,.overlay-wrapper .overlay{z-index:50;background:rgba(255,255,255,0.7);border-radius:3px}.box .overlay>.fa,.overlay-wrapper .overlay>.fa{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.box .overlay.dark,.overlay-wrapper .overlay.dark{background:rgba(0,0,0,0.5)}.box-header:before,.box-body:before,.box-footer:before,.box-header:after,.box-body:after,.box-footer:after{content:\" \";display:table}.box-header:after,.box-body:after,.box-footer:after{clear:both}.box-header{color:#444;display:block;padding:10px;position:relative}.box-header.with-border{border-bottom:1px solid #f4f4f4}.collapsed-box .box-header.with-border{border-bottom:none}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion,.box-header .box-title{display:inline-block;font-size:18px;margin:0;line-height:1}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{margin-right:5px}.box-header>.box-tools{position:absolute;right:10px;top:5px}.box-header>.box-tools [data-toggle=\"tooltip\"]{position:relative}.box-header>.box-tools.pull-right .dropdown-menu{right:0;left:auto}.box-header>.box-tools .dropdown-menu>li>a{color:#444!important}.btn-box-tool{padding:5px;font-size:12px;background:transparent;color:#97a0b3}.open .btn-box-tool,.btn-box-tool:hover{color:#606c84}.btn-box-tool.btn:active{box-shadow:none}.box-body{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;padding:10px}.no-header .box-body{border-top-right-radius:3px;border-top-left-radius:3px}.box-body>.table{margin-bottom:0}.box-body .fc{margin-top:5px}.box-body .full-width-chart{margin:-19px}.box-body.no-padding .full-width-chart{margin:-9px}.box-body .box-pane{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:3px}.box-body .box-pane-right{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:0}.box-footer{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;border-top:1px solid #f4f4f4;padding:10px;background-color:#fff}.chart-legend{margin:10px 0}@media (max-width:991px){.chart-legend>li{float:left;margin-right:10px}}.box-comments{background:#f7f7f7}.box-comments .box-comment{padding:8px 0;border-bottom:1px solid #eee}.box-comments .box-comment:before,.box-comments .box-comment:after{content:\" \";display:table}.box-comments .box-comment:after{clear:both}.box-comments .box-comment:last-of-type{border-bottom:0}.box-comments .box-comment:first-of-type{padding-top:0}.box-comments .box-comment img{float:left}.box-comments .comment-text{margin-left:40px;color:#555}.box-comments .username{color:#444;display:block;font-weight:600}.box-comments .text-muted{font-weight:400;font-size:12px}.todo-list{margin:0;padding:0;list-style:none;overflow:auto}.todo-list>li{border-radius:2px;padding:10px;background:#f4f4f4;margin-bottom:2px;border-left:2px solid #e6e7e8;color:#444}.todo-list>li:last-of-type{margin-bottom:0}.todo-list>li>input[type='checkbox']{margin:0 10px 0 5px}.todo-list>li .text{display:inline-block;margin-left:5px;font-weight:600}.todo-list>li .label{margin-left:10px;font-size:9px}.todo-list>li .tools{display:none;float:right;color:#dd4b39}.todo-list>li .tools>.fa,.todo-list>li .tools>.glyphicon,.todo-list>li .tools>.ion{margin-right:5px;cursor:pointer}.todo-list>li:hover .tools{display:inline-block}.todo-list>li.done{color:#999}.todo-list>li.done .text{text-decoration:line-through;font-weight:500}.todo-list>li.done .label{background:#d2d6de !important}.todo-list .danger{border-left-color:#dd4b39}.todo-list .warning{border-left-color:#f39c12}.todo-list .info{border-left-color:#00c0ef}.todo-list .success{border-left-color:#00a65a}.todo-list .primary{border-left-color:#3c8dbc}.todo-list .handle{display:inline-block;cursor:move;margin:0 5px}.chat{padding:5px 20px 5px 10px}.chat .item{margin-bottom:10px}.chat .item:before,.chat .item:after{content:\" \";display:table}.chat .item:after{clear:both}.chat .item>img{width:40px;height:40px;border:2px solid transparent;border-radius:50%}.chat .item>.online{border:2px solid #00a65a}.chat .item>.offline{border:2px solid #dd4b39}.chat .item>.message{margin-left:55px;margin-top:-40px}.chat .item>.message>.name{display:block;font-weight:600}.chat .item>.attachment{border-radius:3px;background:#f4f4f4;margin-left:65px;margin-right:15px;padding:10px}.chat .item>.attachment>h4{margin:0 0 5px 0;font-weight:600;font-size:14px}.chat .item>.attachment>p,.chat .item>.attachment>.filename{font-weight:600;font-size:13px;font-style:italic;margin:0}.chat .item>.attachment:before,.chat .item>.attachment:after{content:\" \";display:table}.chat .item>.attachment:after{clear:both}.box-input{max-width:200px}.modal .panel-body{color:#444}.info-box{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:2px;margin-bottom:15px}.info-box small{font-size:14px}.info-box .progress{background:rgba(0,0,0,0.2);margin:5px -10px 5px -10px;height:2px}.info-box .progress,.info-box .progress .progress-bar{border-radius:0}.info-box .progress .progress-bar{background:#fff}.info-box-icon{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;height:90px;width:90px;text-align:center;font-size:45px;line-height:90px;background:rgba(0,0,0,0.2)}.info-box-icon>img{max-width:100%}.info-box-content{padding:5px 10px;margin-left:90px}.info-box-number{display:block;font-weight:bold;font-size:18px}.progress-description,.info-box-text{display:block;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info-box-text{text-transform:uppercase}.info-box-more{display:block}.progress-description{margin:0}.timeline{position:relative;margin:0 0 30px 0;padding:0;list-style:none}.timeline:before{content:'';position:absolute;top:0;bottom:0;width:4px;background:#ddd;left:31px;margin:0;border-radius:2px}.timeline>li{position:relative;margin-right:10px;margin-bottom:15px}.timeline>li:before,.timeline>li:after{content:\" \";display:table}.timeline>li:after{clear:both}.timeline>li>.timeline-item{-webkit-box-shadow:0 1px 1px rgba(0,0,0,0.1);box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px;margin-top:0;background:#fff;color:#444;margin-left:60px;margin-right:15px;padding:0;position:relative}.timeline>li>.timeline-item>.time{color:#999;float:right;padding:10px;font-size:12px}.timeline>li>.timeline-item>.timeline-header{margin:0;color:#555;border-bottom:1px solid #f4f4f4;padding:10px;font-size:16px;line-height:1.1}.timeline>li>.timeline-item>.timeline-header>a{font-weight:600}.timeline>li>.timeline-item>.timeline-body,.timeline>li>.timeline-item>.timeline-footer{padding:10px}.timeline>li>.fa,.timeline>li>.glyphicon,.timeline>li>.ion{width:30px;height:30px;font-size:15px;line-height:30px;position:absolute;color:#666;background:#d2d6de;border-radius:50%;text-align:center;left:18px;top:0}.timeline>.time-label>span{font-weight:600;padding:5px;display:inline-block;background-color:#fff;border-radius:4px}.timeline-inverse>li>.timeline-item{background:#f0f0f0;border:1px solid #ddd;-webkit-box-shadow:none;box-shadow:none}.timeline-inverse>li>.timeline-item>.timeline-header{border-bottom-color:#ddd}.btn{border-radius:3px;-webkit-box-shadow:none;box-shadow:none;border:1px solid transparent}.btn.uppercase{text-transform:uppercase}.btn.btn-flat{border-radius:0;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;border-width:1px}.btn:active{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);box-shadow:inset 0 3px 5px rgba(0,0,0,0.125)}.btn:focus{outline:none}.btn.btn-file{position:relative;overflow:hidden}.btn.btn-file>input[type='file']{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;opacity:0;filter:alpha(opacity=0);outline:none;background:white;cursor:inherit;display:block}.btn-default{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-default:hover,.btn-default:active,.btn-default.hover{background-color:#e7e7e7}.btn-primary{background-color:#3c8dbc;border-color:#367fa9}.btn-primary:hover,.btn-primary:active,.btn-primary.hover{background-color:#367fa9}.btn-success{background-color:#00a65a;border-color:#008d4c}.btn-success:hover,.btn-success:active,.btn-success.hover{background-color:#008d4c}.btn-info{background-color:#00c0ef;border-color:#00acd6}.btn-info:hover,.btn-info:active,.btn-info.hover{background-color:#00acd6}.btn-danger{background-color:#dd4b39;border-color:#d73925}.btn-danger:hover,.btn-danger:active,.btn-danger.hover{background-color:#d73925}.btn-warning{background-color:#f39c12;border-color:#e08e0b}.btn-warning:hover,.btn-warning:active,.btn-warning.hover{background-color:#e08e0b}.btn-outline{border:1px solid #fff;background:transparent;color:#fff}.btn-outline:hover,.btn-outline:focus,.btn-outline:active{color:rgba(255,255,255,0.7);border-color:rgba(255,255,255,0.7)}.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn[class*='bg-']:hover{-webkit-box-shadow:inset 0 0 100px rgba(0,0,0,0.2);box-shadow:inset 0 0 100px rgba(0,0,0,0.2)}.btn-app{border-radius:3px;position:relative;padding:15px 5px;margin:0 0 10px 10px;min-width:80px;height:60px;text-align:center;color:#666;border:1px solid #ddd;background-color:#f4f4f4;font-size:12px}.btn-app>.fa,.btn-app>.glyphicon,.btn-app>.ion{font-size:20px;display:block}.btn-app:hover{background:#f4f4f4;color:#444;border-color:#aaa}.btn-app:active,.btn-app:focus{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);-moz-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);box-shadow:inset 0 3px 5px rgba(0,0,0,0.125)}.btn-app>.badge{position:absolute;top:-3px;right:-10px;font-size:10px;font-weight:400}.callout{border-radius:3px;margin:0 0 20px 0;padding:15px 30px 15px 15px;border-left:5px solid #eee}.callout a{color:#fff;text-decoration:underline}.callout a:hover{color:#eee}.callout h4{margin-top:0;font-weight:600}.callout p:last-child{margin-bottom:0}.callout code,.callout .highlight{background-color:#fff}.callout.callout-danger{border-color:#c23321}.callout.callout-warning{border-color:#c87f0a}.callout.callout-info{border-color:#0097bc}.callout.callout-success{border-color:#00733e}.alert{border-radius:3px}.alert h4{font-weight:600}.alert .icon{margin-right:10px}.alert .close{color:#000;opacity:.2;filter:alpha(opacity=20)}.alert .close:hover{opacity:.5;filter:alpha(opacity=50)}.alert a{color:#fff;text-decoration:underline}.alert-success{border-color:#008d4c}.alert-danger,.alert-error{border-color:#d73925}.alert-warning{border-color:#e08e0b}.alert-info{border-color:#00acd6}.nav>li>a:hover,.nav>li>a:active,.nav>li>a:focus{color:#444;background:#f7f7f7}.nav-pills>li>a{border-radius:0;border-top:3px solid transparent;color:#444}.nav-pills>li>a>.fa,.nav-pills>li>a>.glyphicon,.nav-pills>li>a>.ion{margin-right:5px}.nav-pills>li.active>a,.nav-pills>li.active>a:hover,.nav-pills>li.active>a:focus{border-top-color:#3c8dbc}.nav-pills>li.active>a{font-weight:600}.nav-stacked>li>a{border-radius:0;border-top:0;border-left:3px solid transparent;color:#444}.nav-stacked>li.active>a,.nav-stacked>li.active>a:hover{background:transparent;color:#444;border-top:0;border-left-color:#3c8dbc}.nav-stacked>li.header{border-bottom:1px solid #ddd;color:#777;margin-bottom:10px;padding:5px 10px;text-transform:uppercase}.nav-tabs-custom{margin-bottom:20px;background:#fff;box-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px}.nav-tabs-custom>.nav-tabs{margin:0;border-bottom-color:#f4f4f4;border-top-right-radius:3px;border-top-left-radius:3px}.nav-tabs-custom>.nav-tabs>li{border-top:3px solid transparent;margin-bottom:-2px;margin-right:5px}.nav-tabs-custom>.nav-tabs>li>a{color:#444;border-radius:0}.nav-tabs-custom>.nav-tabs>li>a.text-muted{color:#999}.nav-tabs-custom>.nav-tabs>li>a,.nav-tabs-custom>.nav-tabs>li>a:hover{background:transparent;margin:0}.nav-tabs-custom>.nav-tabs>li>a:hover{color:#999}.nav-tabs-custom>.nav-tabs>li:not(.active)>a:hover,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:focus,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:active{border-color:transparent}.nav-tabs-custom>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom>.nav-tabs>li.active>a,.nav-tabs-custom>.nav-tabs>li.active:hover>a{background-color:#fff;color:#444}.nav-tabs-custom>.nav-tabs>li.active>a{border-top-color:transparent;border-left-color:#f4f4f4;border-right-color:#f4f4f4}.nav-tabs-custom>.nav-tabs>li:first-of-type{margin-left:0}.nav-tabs-custom>.nav-tabs>li:first-of-type.active>a{border-left-color:transparent}.nav-tabs-custom>.nav-tabs.pull-right{float:none !important}.nav-tabs-custom>.nav-tabs.pull-right>li{float:right}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type{margin-right:0}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type>a{border-left-width:1px}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type.active>a{border-left-color:#f4f4f4;border-right-color:transparent}.nav-tabs-custom>.nav-tabs>li.header{line-height:35px;padding:0 10px;font-size:20px;color:#444}.nav-tabs-custom>.nav-tabs>li.header>.fa,.nav-tabs-custom>.nav-tabs>li.header>.glyphicon,.nav-tabs-custom>.nav-tabs>li.header>.ion{margin-right:5px}.nav-tabs-custom>.tab-content{background:#fff;padding:10px;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.nav-tabs-custom .dropdown.open>a:active,.nav-tabs-custom .dropdown.open>a:focus{background:transparent;color:#999}.nav-tabs-custom.tab-primary>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom.tab-info>.nav-tabs>li.active{border-top-color:#00c0ef}.nav-tabs-custom.tab-danger>.nav-tabs>li.active{border-top-color:#dd4b39}.nav-tabs-custom.tab-warning>.nav-tabs>li.active{border-top-color:#f39c12}.nav-tabs-custom.tab-success>.nav-tabs>li.active{border-top-color:#00a65a}.nav-tabs-custom.tab-default>.nav-tabs>li.active{border-top-color:#d2d6de}.pagination>li>a{background:#fafafa;color:#666}.pagination.pagination-flat>li>a{border-radius:0 !important}.products-list{list-style:none;margin:0;padding:0}.products-list>.item{border-radius:3px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,0.1);box-shadow:0 1px 1px rgba(0,0,0,0.1);padding:10px 0;background:#fff}.products-list>.item:before,.products-list>.item:after{content:\" \";display:table}.products-list>.item:after{clear:both}.products-list .product-img{float:left}.products-list .product-img img{width:50px;height:50px}.products-list .product-info{margin-left:60px}.products-list .product-title{font-weight:600}.products-list .product-description{display:block;color:#999;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.product-list-in-box>.item{-webkit-box-shadow:none;box-shadow:none;border-radius:0;border-bottom:1px solid #f4f4f4}.product-list-in-box>.item:last-of-type{border-bottom-width:0}.table>thead>tr>th,.table>tbody>tr>th,.table>tfoot>tr>th,.table>thead>tr>td,.table>tbody>tr>td,.table>tfoot>tr>td{border-top:1px solid #f4f4f4}.table>thead>tr>th{border-bottom:2px solid #f4f4f4}.table tr td .progress{margin-top:5px}.table-bordered{border:1px solid #f4f4f4}.table-bordered>thead>tr>th,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>tbody>tr>td,.table-bordered>tfoot>tr>td{border:1px solid #f4f4f4}.table-bordered>thead>tr>th,.table-bordered>thead>tr>td{border-bottom-width:2px}.table.no-border,.table.no-border td,.table.no-border th{border:0}table.text-center,table.text-center td,table.text-center th{text-align:center}.table.align th{text-align:left}.table.align td{text-align:right}.label-default{background-color:#d2d6de;color:#444}.direct-chat .box-body{border-bottom-right-radius:0;border-bottom-left-radius:0;position:relative;overflow-x:hidden;padding:0}.direct-chat.chat-pane-open .direct-chat-contacts{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}.direct-chat-messages{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0);padding:10px;height:250px;overflow:auto}.direct-chat-msg,.direct-chat-text{display:block}.direct-chat-msg{margin-bottom:10px}.direct-chat-msg:before,.direct-chat-msg:after{content:\" \";display:table}.direct-chat-msg:after{clear:both}.direct-chat-messages,.direct-chat-contacts{-webkit-transition:-webkit-transform .5s ease-in-out;-moz-transition:-moz-transform .5s ease-in-out;-o-transition:-o-transform .5s ease-in-out;transition:transform .5s ease-in-out}.direct-chat-text{border-radius:5px;position:relative;padding:5px 10px;background:#d2d6de;border:1px solid #d2d6de;margin:5px 0 0 50px;color:#444}.direct-chat-text:after,.direct-chat-text:before{position:absolute;right:100%;top:15px;border:solid transparent;border-right-color:#d2d6de;content:' ';height:0;width:0;pointer-events:none}.direct-chat-text:after{border-width:5px;margin-top:-5px}.direct-chat-text:before{border-width:6px;margin-top:-6px}.right .direct-chat-text{margin-right:50px;margin-left:0}.right .direct-chat-text:after,.right .direct-chat-text:before{right:auto;left:100%;border-right-color:transparent;border-left-color:#d2d6de}.direct-chat-img{border-radius:50%;float:left;width:40px;height:40px}.right .direct-chat-img{float:right}.direct-chat-info{display:block;margin-bottom:2px;font-size:12px}.direct-chat-name{font-weight:600}.direct-chat-timestamp{color:#999}.direct-chat-contacts-open .direct-chat-contacts{-webkit-transform:translate(0, 0);-ms-transform:translate(0, 0);-o-transform:translate(0, 0);transform:translate(0, 0)}.direct-chat-contacts{-webkit-transform:translate(101%, 0);-ms-transform:translate(101%, 0);-o-transform:translate(101%, 0);transform:translate(101%, 0);position:absolute;top:0;bottom:0;height:250px;width:100%;background:#222d32;color:#fff;overflow:auto}.contacts-list>li{border-bottom:1px solid rgba(0,0,0,0.2);padding:10px;margin:0}.contacts-list>li:before,.contacts-list>li:after{content:\" \";display:table}.contacts-list>li:after{clear:both}.contacts-list>li:last-of-type{border-bottom:none}.contacts-list-img{border-radius:50%;width:40px;float:left}.contacts-list-info{margin-left:45px;color:#fff}.contacts-list-name,.contacts-list-status{display:block}.contacts-list-name{font-weight:600}.contacts-list-status{font-size:12px}.contacts-list-date{color:#aaa;font-weight:normal}.contacts-list-msg{color:#999}.direct-chat-danger .right>.direct-chat-text{background:#dd4b39;border-color:#dd4b39;color:#fff}.direct-chat-danger .right>.direct-chat-text:after,.direct-chat-danger .right>.direct-chat-text:before{border-left-color:#dd4b39}.direct-chat-primary .right>.direct-chat-text{background:#3c8dbc;border-color:#3c8dbc;color:#fff}.direct-chat-primary .right>.direct-chat-text:after,.direct-chat-primary .right>.direct-chat-text:before{border-left-color:#3c8dbc}.direct-chat-warning .right>.direct-chat-text{background:#f39c12;border-color:#f39c12;color:#fff}.direct-chat-warning .right>.direct-chat-text:after,.direct-chat-warning .right>.direct-chat-text:before{border-left-color:#f39c12}.direct-chat-info .right>.direct-chat-text{background:#00c0ef;border-color:#00c0ef;color:#fff}.direct-chat-info .right>.direct-chat-text:after,.direct-chat-info .right>.direct-chat-text:before{border-left-color:#00c0ef}.direct-chat-success .right>.direct-chat-text{background:#00a65a;border-color:#00a65a;color:#fff}.direct-chat-success .right>.direct-chat-text:after,.direct-chat-success .right>.direct-chat-text:before{border-left-color:#00a65a}.users-list>li{width:25%;float:left;padding:10px;text-align:center}.users-list>li img{border-radius:50%;max-width:100%;height:auto}.users-list>li>a:hover,.users-list>li>a:hover .users-list-name{color:#999}.users-list-name,.users-list-date{display:block}.users-list-name{font-weight:600;color:#444;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.users-list-date{color:#999;font-size:12px}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.modal{background:rgba(0,0,0,0.3)}.modal-content{border-radius:0;-webkit-box-shadow:0 2px 3px rgba(0,0,0,0.125);box-shadow:0 2px 3px rgba(0,0,0,0.125);border:0}@media (min-width:768px){.modal-content{-webkit-box-shadow:0 2px 3px rgba(0,0,0,0.125);box-shadow:0 2px 3px rgba(0,0,0,0.125)}}.modal-header{border-bottom-color:#f4f4f4}.modal-footer{border-top-color:#f4f4f4}.modal-primary .modal-header,.modal-primary .modal-footer{border-color:#307095}.modal-warning .modal-header,.modal-warning .modal-footer{border-color:#c87f0a}.modal-info .modal-header,.modal-info .modal-footer{border-color:#0097bc}.modal-success .modal-header,.modal-success .modal-footer{border-color:#00733e}.modal-danger .modal-header,.modal-danger .modal-footer{border-color:#c23321}.box-widget{border:none;position:relative}.widget-user .widget-user-header{padding:20px;height:120px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user .widget-user-username{margin-top:0;margin-bottom:5px;font-size:25px;font-weight:300;text-shadow:0 1px 1px rgba(0,0,0,0.2)}.widget-user .widget-user-desc{margin-top:0}.widget-user .widget-user-image{position:absolute;top:65px;left:50%;margin-left:-45px}.widget-user .widget-user-image>img{width:90px;height:auto;border:3px solid #fff}.widget-user .box-footer{padding-top:30px}.widget-user-2 .widget-user-header{padding:20px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user-2 .widget-user-username{margin-top:5px;margin-bottom:5px;font-size:25px;font-weight:300}.widget-user-2 .widget-user-desc{margin-top:0}.widget-user-2 .widget-user-username,.widget-user-2 .widget-user-desc{margin-left:75px}.widget-user-2 .widget-user-image>img{width:65px;height:auto;float:left}.mailbox-messages>.table{margin:0}.mailbox-controls{padding:5px}.mailbox-controls.with-border{border-bottom:1px solid #f4f4f4}.mailbox-read-info{border-bottom:1px solid #f4f4f4;padding:10px}.mailbox-read-info h3{font-size:20px;margin:0}.mailbox-read-info h5{margin:0;padding:5px 0 0 0}.mailbox-read-time{color:#999;font-size:13px}.mailbox-read-message{padding:10px}.mailbox-attachments li{float:left;width:200px;border:1px solid #eee;margin-bottom:10px;margin-right:10px}.mailbox-attachment-name{font-weight:bold;color:#666}.mailbox-attachment-icon,.mailbox-attachment-info,.mailbox-attachment-size{display:block}.mailbox-attachment-info{padding:10px;background:#f4f4f4}.mailbox-attachment-size{color:#999;font-size:12px}.mailbox-attachment-icon{text-align:center;font-size:65px;color:#666;padding:20px 10px}.mailbox-attachment-icon.has-img{padding:0}.mailbox-attachment-icon.has-img>img{max-width:100%;height:auto}.lockscreen{background:#d2d6de}.lockscreen-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.lockscreen-logo a{color:#444}.lockscreen-wrapper{max-width:400px;margin:0 auto;margin-top:10%}.lockscreen .lockscreen-name{text-align:center;font-weight:600}.lockscreen-item{border-radius:4px;padding:0;background:#fff;position:relative;margin:10px auto 30px auto;width:290px}.lockscreen-image{border-radius:50%;position:absolute;left:-10px;top:-25px;background:#fff;padding:5px;z-index:10}.lockscreen-image>img{border-radius:50%;width:70px;height:70px}.lockscreen-credentials{margin-left:70px}.lockscreen-credentials .form-control{border:0}.lockscreen-credentials .btn{background-color:#fff;border:0;padding:0 10px}.lockscreen-footer{margin-top:10px}.login-logo,.register-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.login-logo a,.register-logo a{color:#444}.login-page,.register-page{background:#d2d6de}.login-box,.register-box{width:360px;margin:7% auto}@media (max-width:768px){.login-box,.register-box{width:90%;margin-top:20px}}.login-box-body,.register-box-body{background:#fff;padding:20px;border-top:0;color:#666}.login-box-body .form-control-feedback,.register-box-body .form-control-feedback{color:#777}.login-box-msg,.register-box-msg{margin:0;text-align:center;padding:0 20px 20px 20px}.social-auth-links{margin:10px 0}.error-page{width:600px;margin:20px auto 0 auto}@media (max-width:991px){.error-page{width:100%}}.error-page>.headline{float:left;font-size:100px;font-weight:300}@media (max-width:991px){.error-page>.headline{float:none;text-align:center}}.error-page>.error-content{margin-left:190px;display:block}@media (max-width:991px){.error-page>.error-content{margin-left:0}}.error-page>.error-content>h3{font-weight:300;font-size:25px}@media (max-width:991px){.error-page>.error-content>h3{text-align:center}}.invoice{position:relative;background:#fff;border:1px solid #f4f4f4;padding:20px;margin:10px 25px}.invoice-title{margin-top:0}.profile-user-img{margin:0 auto;width:100px;padding:3px;border:3px solid #d2d6de}.profile-username{font-size:21px;margin-top:5px}.post{border-bottom:1px solid #d2d6de;margin-bottom:15px;padding-bottom:15px;color:#666}.post:last-of-type{border-bottom:0;margin-bottom:0;padding-bottom:0}.post .user-block{margin-bottom:15px}.btn-social{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn-social>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,0.2)}.btn-social.btn-lg{padding-left:61px}.btn-social.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social.btn-sm{padding-left:38px}.btn-social.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social.btn-xs{padding-left:30px}.btn-social.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:34px;width:34px;padding:0}.btn-social-icon>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,0.2)}.btn-social-icon.btn-lg{padding-left:61px}.btn-social-icon.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social-icon.btn-sm{padding-left:38px}.btn-social-icon.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social-icon.btn-xs{padding-left:30px}.btn-social-icon.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon>:first-child{border:none;text-align:center;width:100%}.btn-social-icon.btn-lg{height:45px;width:45px;padding-left:0;padding-right:0}.btn-social-icon.btn-sm{height:30px;width:30px;padding-left:0;padding-right:0}.btn-social-icon.btn-xs{height:22px;width:22px;padding-left:0;padding-right:0}.btn-adn{color:#fff;background-color:#d87a68;border-color:rgba(0,0,0,0.2)}.btn-adn:focus,.btn-adn.focus{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn:hover{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn:active,.btn-adn.active,.open>.dropdown-toggle.btn-adn{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,0.2)}.btn-adn:active,.btn-adn.active,.open>.dropdown-toggle.btn-adn{background-image:none}.btn-adn .badge{color:#d87a68;background-color:#fff}.btn-bitbucket{color:#fff;background-color:#205081;border-color:rgba(0,0,0,0.2)}.btn-bitbucket:focus,.btn-bitbucket.focus{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket:hover{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket:active,.btn-bitbucket.active,.open>.dropdown-toggle.btn-bitbucket{color:#fff;background-color:#163758;border-color:rgba(0,0,0,0.2)}.btn-bitbucket:active,.btn-bitbucket.active,.open>.dropdown-toggle.btn-bitbucket{background-image:none}.btn-bitbucket .badge{color:#205081;background-color:#fff}.btn-dropbox{color:#fff;background-color:#1087dd;border-color:rgba(0,0,0,0.2)}.btn-dropbox:focus,.btn-dropbox.focus{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox:hover{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox:active,.btn-dropbox.active,.open>.dropdown-toggle.btn-dropbox{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,0.2)}.btn-dropbox:active,.btn-dropbox.active,.open>.dropdown-toggle.btn-dropbox{background-image:none}.btn-dropbox .badge{color:#1087dd;background-color:#fff}.btn-facebook{color:#fff;background-color:#3b5998;border-color:rgba(0,0,0,0.2)}.btn-facebook:focus,.btn-facebook.focus{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook:hover{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook:active,.btn-facebook.active,.open>.dropdown-toggle.btn-facebook{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,0.2)}.btn-facebook:active,.btn-facebook.active,.open>.dropdown-toggle.btn-facebook{background-image:none}.btn-facebook .badge{color:#3b5998;background-color:#fff}.btn-flickr{color:#fff;background-color:#ff0084;border-color:rgba(0,0,0,0.2)}.btn-flickr:focus,.btn-flickr.focus{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr:hover{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr:active,.btn-flickr.active,.open>.dropdown-toggle.btn-flickr{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,0.2)}.btn-flickr:active,.btn-flickr.active,.open>.dropdown-toggle.btn-flickr{background-image:none}.btn-flickr .badge{color:#ff0084;background-color:#fff}.btn-foursquare{color:#fff;background-color:#f94877;border-color:rgba(0,0,0,0.2)}.btn-foursquare:focus,.btn-foursquare.focus{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare:hover{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare:active,.btn-foursquare.active,.open>.dropdown-toggle.btn-foursquare{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,0.2)}.btn-foursquare:active,.btn-foursquare.active,.open>.dropdown-toggle.btn-foursquare{background-image:none}.btn-foursquare .badge{color:#f94877;background-color:#fff}.btn-github{color:#fff;background-color:#444;border-color:rgba(0,0,0,0.2)}.btn-github:focus,.btn-github.focus{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github:hover{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github:active,.btn-github.active,.open>.dropdown-toggle.btn-github{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,0.2)}.btn-github:active,.btn-github.active,.open>.dropdown-toggle.btn-github{background-image:none}.btn-github .badge{color:#444;background-color:#fff}.btn-google{color:#fff;background-color:#dd4b39;border-color:rgba(0,0,0,0.2)}.btn-google:focus,.btn-google.focus{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google:hover{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google:active,.btn-google.active,.open>.dropdown-toggle.btn-google{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,0.2)}.btn-google:active,.btn-google.active,.open>.dropdown-toggle.btn-google{background-image:none}.btn-google .badge{color:#dd4b39;background-color:#fff}.btn-instagram{color:#fff;background-color:#3f729b;border-color:rgba(0,0,0,0.2)}.btn-instagram:focus,.btn-instagram.focus{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram:hover{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram:active,.btn-instagram.active,.open>.dropdown-toggle.btn-instagram{color:#fff;background-color:#305777;border-color:rgba(0,0,0,0.2)}.btn-instagram:active,.btn-instagram.active,.open>.dropdown-toggle.btn-instagram{background-image:none}.btn-instagram .badge{color:#3f729b;background-color:#fff}.btn-linkedin{color:#fff;background-color:#007bb6;border-color:rgba(0,0,0,0.2)}.btn-linkedin:focus,.btn-linkedin.focus{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin:hover{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin:active,.btn-linkedin.active,.open>.dropdown-toggle.btn-linkedin{color:#fff;background-color:#005983;border-color:rgba(0,0,0,0.2)}.btn-linkedin:active,.btn-linkedin.active,.open>.dropdown-toggle.btn-linkedin{background-image:none}.btn-linkedin .badge{color:#007bb6;background-color:#fff}.btn-microsoft{color:#fff;background-color:#2672ec;border-color:rgba(0,0,0,0.2)}.btn-microsoft:focus,.btn-microsoft.focus{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft:hover{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft:active,.btn-microsoft.active,.open>.dropdown-toggle.btn-microsoft{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,0.2)}.btn-microsoft:active,.btn-microsoft.active,.open>.dropdown-toggle.btn-microsoft{background-image:none}.btn-microsoft .badge{color:#2672ec;background-color:#fff}.btn-openid{color:#fff;background-color:#f7931e;border-color:rgba(0,0,0,0.2)}.btn-openid:focus,.btn-openid.focus{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid:hover{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid:active,.btn-openid.active,.open>.dropdown-toggle.btn-openid{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,0.2)}.btn-openid:active,.btn-openid.active,.open>.dropdown-toggle.btn-openid{background-image:none}.btn-openid .badge{color:#f7931e;background-color:#fff}.btn-pinterest{color:#fff;background-color:#cb2027;border-color:rgba(0,0,0,0.2)}.btn-pinterest:focus,.btn-pinterest.focus{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest:hover{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest:active,.btn-pinterest.active,.open>.dropdown-toggle.btn-pinterest{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,0.2)}.btn-pinterest:active,.btn-pinterest.active,.open>.dropdown-toggle.btn-pinterest{background-image:none}.btn-pinterest .badge{color:#cb2027;background-color:#fff}.btn-reddit{color:#000;background-color:#eff7ff;border-color:rgba(0,0,0,0.2)}.btn-reddit:focus,.btn-reddit.focus{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit:hover{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit:active,.btn-reddit.active,.open>.dropdown-toggle.btn-reddit{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,0.2)}.btn-reddit:active,.btn-reddit.active,.open>.dropdown-toggle.btn-reddit{background-image:none}.btn-reddit .badge{color:#eff7ff;background-color:#000}.btn-soundcloud{color:#fff;background-color:#f50;border-color:rgba(0,0,0,0.2)}.btn-soundcloud:focus,.btn-soundcloud.focus{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud:hover{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud:active,.btn-soundcloud.active,.open>.dropdown-toggle.btn-soundcloud{color:#fff;background-color:#c40;border-color:rgba(0,0,0,0.2)}.btn-soundcloud:active,.btn-soundcloud.active,.open>.dropdown-toggle.btn-soundcloud{background-image:none}.btn-soundcloud .badge{color:#f50;background-color:#fff}.btn-tumblr{color:#fff;background-color:#2c4762;border-color:rgba(0,0,0,0.2)}.btn-tumblr:focus,.btn-tumblr.focus{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr:hover{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr:active,.btn-tumblr.active,.open>.dropdown-toggle.btn-tumblr{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,0.2)}.btn-tumblr:active,.btn-tumblr.active,.open>.dropdown-toggle.btn-tumblr{background-image:none}.btn-tumblr .badge{color:#2c4762;background-color:#fff}.btn-twitter{color:#fff;background-color:#55acee;border-color:rgba(0,0,0,0.2)}.btn-twitter:focus,.btn-twitter.focus{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter:hover{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter:active,.btn-twitter.active,.open>.dropdown-toggle.btn-twitter{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,0.2)}.btn-twitter:active,.btn-twitter.active,.open>.dropdown-toggle.btn-twitter{background-image:none}.btn-twitter .badge{color:#55acee;background-color:#fff}.btn-vimeo{color:#fff;background-color:#1ab7ea;border-color:rgba(0,0,0,0.2)}.btn-vimeo:focus,.btn-vimeo.focus{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo:hover{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo:active,.btn-vimeo.active,.open>.dropdown-toggle.btn-vimeo{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,0.2)}.btn-vimeo:active,.btn-vimeo.active,.open>.dropdown-toggle.btn-vimeo{background-image:none}.btn-vimeo .badge{color:#1ab7ea;background-color:#fff}.btn-vk{color:#fff;background-color:#587ea3;border-color:rgba(0,0,0,0.2)}.btn-vk:focus,.btn-vk.focus{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk:hover{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk:active,.btn-vk.active,.open>.dropdown-toggle.btn-vk{color:#fff;background-color:#466482;border-color:rgba(0,0,0,0.2)}.btn-vk:active,.btn-vk.active,.open>.dropdown-toggle.btn-vk{background-image:none}.btn-vk .badge{color:#587ea3;background-color:#fff}.btn-yahoo{color:#fff;background-color:#720e9e;border-color:rgba(0,0,0,0.2)}.btn-yahoo:focus,.btn-yahoo.focus{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo:hover{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo:active,.btn-yahoo.active,.open>.dropdown-toggle.btn-yahoo{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,0.2)}.btn-yahoo:active,.btn-yahoo.active,.open>.dropdown-toggle.btn-yahoo{background-image:none}.btn-yahoo .badge{color:#720e9e;background-color:#fff}.fc-button{background:#f4f4f4;background-image:none;color:#444;border-color:#ddd;border-bottom-color:#ddd}.fc-button:hover,.fc-button:active,.fc-button.hover{background-color:#e9e9e9}.fc-header-title h2{font-size:15px;line-height:1.6em;color:#666;margin-left:10px}.fc-header-right{padding-right:10px}.fc-header-left{padding-left:10px}.fc-widget-header{background:#fafafa}.fc-grid{width:100%;border:0}.fc-widget-header:first-of-type,.fc-widget-content:first-of-type{border-left:0;border-right:0}.fc-widget-header:last-of-type,.fc-widget-content:last-of-type{border-right:0}.fc-toolbar{padding:10px;margin:0}.fc-day-number{font-size:20px;font-weight:300;padding-right:10px}.fc-color-picker{list-style:none;margin:0;padding:0}.fc-color-picker>li{float:left;font-size:30px;margin-right:5px;line-height:30px}.fc-color-picker>li .fa{-webkit-transition:-webkit-transform linear .3s;-moz-transition:-moz-transform linear .3s;-o-transition:-o-transform linear .3s;transition:transform linear .3s}.fc-color-picker>li .fa:hover{-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);-o-transform:rotate(30deg);transform:rotate(30deg)}#add-new-event{-webkit-transition:all linear .3s;-o-transition:all linear .3s;transition:all linear .3s}.external-event{padding:5px 10px;font-weight:bold;margin-bottom:4px;box-shadow:0 1px 1px rgba(0,0,0,0.1);text-shadow:0 1px 1px rgba(0,0,0,0.1);border-radius:3px;cursor:move}.external-event:hover{box-shadow:inset 0 0 90px rgba(0,0,0,0.2)}.select2-container--default.select2-container--focus,.select2-selection.select2-container--focus,.select2-container--default:focus,.select2-selection:focus,.select2-container--default:active,.select2-selection:active{outline:none}.select2-container--default .select2-selection--single,.select2-selection .select2-selection--single{border:1px solid #d2d6de;border-radius:0;padding:6px 12px;height:34px}.select2-container--default.select2-container--open{border-color:#3c8dbc}.select2-dropdown{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#3c8dbc;color:white}.select2-results__option{padding:6px 12px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{padding-left:0;padding-right:0;height:auto;margin-top:-4px}.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered{padding-right:6px;padding-left:20px}.select2-container--default .select2-selection--single .select2-selection__arrow{height:28px;right:3px}.select2-container--default .select2-selection--single .select2-selection__arrow b{margin-top:0}.select2-dropdown .select2-search__field,.select2-search--inline .select2-search__field{border:1px solid #d2d6de}.select2-dropdown .select2-search__field:focus,.select2-search--inline .select2-search__field:focus{outline:none;border:1px solid #3c8dbc}.select2-container--default .select2-results__option[aria-disabled=true]{color:#999}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ddd}.select2-container--default .select2-results__option[aria-selected=true],.select2-container--default .select2-results__option[aria-selected=true]:hover{color:#444}.select2-container--default .select2-selection--multiple{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-selection--multiple:focus{border-color:#3c8dbc}.select2-container--default.select2-container--focus .select2-selection--multiple{border-color:#d2d6de}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#3c8dbc;border-color:#367fa9;padding:1px 10px;color:#fff}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{margin-right:5px;color:rgba(255,255,255,0.7)}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#fff}.select2-container .select2-selection--single .select2-selection__rendered{padding-right:10px}.pad{padding:10px}.margin{margin:10px}.margin-bottom{margin-bottom:20px}.margin-bottom-none{margin-bottom:0}.margin-r-5{margin-right:5px}.inline{display:inline}.description-block{display:block;margin:10px 0;text-align:center}.description-block.margin-bottom{margin-bottom:25px}.description-block>.description-header{margin:0;padding:0;font-weight:600;font-size:16px}.description-block>.description-text{text-transform:uppercase}.bg-red,.bg-yellow,.bg-aqua,.bg-blue,.bg-light-blue,.bg-green,.bg-navy,.bg-teal,.bg-olive,.bg-lime,.bg-orange,.bg-fuchsia,.bg-purple,.bg-maroon,.bg-black,.bg-red-active,.bg-yellow-active,.bg-aqua-active,.bg-blue-active,.bg-light-blue-active,.bg-green-active,.bg-navy-active,.bg-teal-active,.bg-olive-active,.bg-lime-active,.bg-orange-active,.bg-fuchsia-active,.bg-purple-active,.bg-maroon-active,.bg-black-active,.callout.callout-danger,.callout.callout-warning,.callout.callout-info,.callout.callout-success,.alert-success,.alert-danger,.alert-error,.alert-warning,.alert-info,.label-danger,.label-info,.label-warning,.label-primary,.label-success,.modal-primary .modal-body,.modal-primary .modal-header,.modal-primary .modal-footer,.modal-warning .modal-body,.modal-warning .modal-header,.modal-warning .modal-footer,.modal-info .modal-body,.modal-info .modal-header,.modal-info .modal-footer,.modal-success .modal-body,.modal-success .modal-header,.modal-success .modal-footer,.modal-danger .modal-body,.modal-danger .modal-header,.modal-danger .modal-footer{color:#fff !important}.bg-gray{color:#000;background-color:#d2d6de !important}.bg-gray-light{background-color:#f7f7f7}.bg-black{background-color:#111 !important}.bg-red,.callout.callout-danger,.alert-danger,.alert-error,.label-danger,.modal-danger .modal-body{background-color:#dd4b39 !important}.bg-yellow,.callout.callout-warning,.alert-warning,.label-warning,.modal-warning .modal-body{background-color:#f39c12 !important}.bg-aqua,.callout.callout-info,.alert-info,.label-info,.modal-info .modal-body{background-color:#00c0ef !important}.bg-blue{background-color:#0073b7 !important}.bg-light-blue,.label-primary,.modal-primary .modal-body{background-color:#3c8dbc !important}.bg-green,.callout.callout-success,.alert-success,.label-success,.modal-success .modal-body{background-color:#00a65a !important}.bg-navy{background-color:#001f3f !important}.bg-teal{background-color:#39cccc !important}.bg-olive{background-color:#3d9970 !important}.bg-lime{background-color:#01ff70 !important}.bg-orange{background-color:#ff851b !important}.bg-fuchsia{background-color:#f012be !important}.bg-purple{background-color:#605ca8 !important}.bg-maroon{background-color:#d81b60 !important}.bg-gray-active{color:#000;background-color:#b5bbc8 !important}.bg-black-active{background-color:#000 !important}.bg-red-active,.modal-danger .modal-header,.modal-danger .modal-footer{background-color:#d33724 !important}.bg-yellow-active,.modal-warning .modal-header,.modal-warning .modal-footer{background-color:#db8b0b !important}.bg-aqua-active,.modal-info .modal-header,.modal-info .modal-footer{background-color:#00a7d0 !important}.bg-blue-active{background-color:#005384 !important}.bg-light-blue-active,.modal-primary .modal-header,.modal-primary .modal-footer{background-color:#357ca5 !important}.bg-green-active,.modal-success .modal-header,.modal-success .modal-footer{background-color:#008d4c !important}.bg-navy-active{background-color:#001a35 !important}.bg-teal-active{background-color:#30bbbb !important}.bg-olive-active{background-color:#368763 !important}.bg-lime-active{background-color:#00e765 !important}.bg-orange-active{background-color:#ff7701 !important}.bg-fuchsia-active{background-color:#db0ead !important}.bg-purple-active{background-color:#555299 !important}.bg-maroon-active{background-color:#ca195a !important}[class^=\"bg-\"].disabled{opacity:.65;filter:alpha(opacity=65)}.text-red{color:#dd4b39 !important}.text-yellow{color:#f39c12 !important}.text-aqua{color:#00c0ef !important}.text-blue{color:#0073b7 !important}.text-black{color:#111 !important}.text-light-blue{color:#3c8dbc !important}.text-green{color:#00a65a !important}.text-gray{color:#d2d6de !important}.text-navy{color:#001f3f !important}.text-teal{color:#39cccc !important}.text-olive{color:#3d9970 !important}.text-lime{color:#01ff70 !important}.text-orange{color:#ff851b !important}.text-fuchsia{color:#f012be !important}.text-purple{color:#605ca8 !important}.text-maroon{color:#d81b60 !important}.link-muted{color:#7a869d}.link-muted:hover,.link-muted:focus{color:#606c84}.link-black{color:#666}.link-black:hover,.link-black:focus{color:#999}.hide{display:none !important}.no-border{border:0 !important}.no-padding{padding:0 !important}.no-margin{margin:0 !important}.no-shadow{box-shadow:none !important}.list-unstyled,.chart-legend,.contacts-list,.users-list,.mailbox-attachments{list-style:none;margin:0;padding:0}.list-group-unbordered>.list-group-item{border-left:0;border-right:0;border-radius:0;padding-left:0;padding-right:0}.flat{border-radius:0 !important}.text-bold,.text-bold.table td,.text-bold.table th{font-weight:700}.text-sm{font-size:12px}.jqstooltip{padding:5px !important;width:auto !important;height:auto !important}.bg-teal-gradient{background:#39cccc !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #39cccc), color-stop(1, #7adddd)) !important;background:-ms-linear-gradient(bottom, #39cccc, #7adddd) !important;background:-moz-linear-gradient(center bottom, #39cccc 0, #7adddd 100%) !important;background:-o-linear-gradient(#7adddd, #39cccc) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#7adddd', endColorstr='#39cccc', GradientType=0) !important;color:#fff}.bg-light-blue-gradient{background:#3c8dbc !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #3c8dbc), color-stop(1, #67a8ce)) !important;background:-ms-linear-gradient(bottom, #3c8dbc, #67a8ce) !important;background:-moz-linear-gradient(center bottom, #3c8dbc 0, #67a8ce 100%) !important;background:-o-linear-gradient(#67a8ce, #3c8dbc) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#67a8ce', endColorstr='#3c8dbc', GradientType=0) !important;color:#fff}.bg-blue-gradient{background:#0073b7 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #0073b7), color-stop(1, #0089db)) !important;background:-ms-linear-gradient(bottom, #0073b7, #0089db) !important;background:-moz-linear-gradient(center bottom, #0073b7 0, #0089db 100%) !important;background:-o-linear-gradient(#0089db, #0073b7) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#0089db', endColorstr='#0073b7', GradientType=0) !important;color:#fff}.bg-aqua-gradient{background:#00c0ef !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #00c0ef), color-stop(1, #14d1ff)) !important;background:-ms-linear-gradient(bottom, #00c0ef, #14d1ff) !important;background:-moz-linear-gradient(center bottom, #00c0ef 0, #14d1ff 100%) !important;background:-o-linear-gradient(#14d1ff, #00c0ef) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#14d1ff', endColorstr='#00c0ef', GradientType=0) !important;color:#fff}.bg-yellow-gradient{background:#f39c12 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #f39c12), color-stop(1, #f7bc60)) !important;background:-ms-linear-gradient(bottom, #f39c12, #f7bc60) !important;background:-moz-linear-gradient(center bottom, #f39c12 0, #f7bc60 100%) !important;background:-o-linear-gradient(#f7bc60, #f39c12) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7bc60', endColorstr='#f39c12', GradientType=0) !important;color:#fff}.bg-purple-gradient{background:#605ca8 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #605ca8), color-stop(1, #9491c4)) !important;background:-ms-linear-gradient(bottom, #605ca8, #9491c4) !important;background:-moz-linear-gradient(center bottom, #605ca8 0, #9491c4 100%) !important;background:-o-linear-gradient(#9491c4, #605ca8) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#9491c4', endColorstr='#605ca8', GradientType=0) !important;color:#fff}.bg-green-gradient{background:#00a65a !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #00a65a), color-stop(1, #00ca6d)) !important;background:-ms-linear-gradient(bottom, #00a65a, #00ca6d) !important;background:-moz-linear-gradient(center bottom, #00a65a 0, #00ca6d 100%) !important;background:-o-linear-gradient(#00ca6d, #00a65a) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ca6d', endColorstr='#00a65a', GradientType=0) !important;color:#fff}.bg-red-gradient{background:#dd4b39 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #dd4b39), color-stop(1, #e47365)) !important;background:-ms-linear-gradient(bottom, #dd4b39, #e47365) !important;background:-moz-linear-gradient(center bottom, #dd4b39 0, #e47365 100%) !important;background:-o-linear-gradient(#e47365, #dd4b39) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e47365', endColorstr='#dd4b39', GradientType=0) !important;color:#fff}.bg-black-gradient{background:#111 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #111), color-stop(1, #2b2b2b)) !important;background:-ms-linear-gradient(bottom, #111, #2b2b2b) !important;background:-moz-linear-gradient(center bottom, #111 0, #2b2b2b 100%) !important;background:-o-linear-gradient(#2b2b2b, #111) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#2b2b2b', endColorstr='#111111', GradientType=0) !important;color:#fff}.bg-maroon-gradient{background:#d81b60 !important;background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #d81b60), color-stop(1, #e73f7c)) !important;background:-ms-linear-gradient(bottom, #d81b60, #e73f7c) !important;background:-moz-linear-gradient(center bottom, #d81b60 0, #e73f7c 100%) !important;background:-o-linear-gradient(#e73f7c, #d81b60) !important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e73f7c', endColorstr='#d81b60', GradientType=0) !important;color:#fff}.description-block .description-icon{font-size:16px}.no-pad-top{padding-top:0}.position-static{position:static !important}.list-header{font-size:15px;padding:10px 4px;font-weight:bold;color:#666}.list-seperator{height:1px;background:#f4f4f4;margin:15px 0 9px 0}.list-link>a{padding:4px;color:#777}.list-link>a:hover{color:#222}.font-light{font-weight:300}.user-block:before,.user-block:after{content:\" \";display:table}.user-block:after{clear:both}.user-block img{width:40px;height:40px;float:left}.user-block .username,.user-block .description,.user-block .comment{display:block;margin-left:50px}.user-block .username{font-size:16px;font-weight:600}.user-block .description{color:#999;font-size:13px}.user-block.user-block-sm .username,.user-block.user-block-sm .description,.user-block.user-block-sm .comment{margin-left:40px}.user-block.user-block-sm .username{font-size:14px}.img-sm,.img-md,.img-lg,.box-comments .box-comment img,.user-block.user-block-sm img{float:left}.img-sm,.box-comments .box-comment img,.user-block.user-block-sm img{width:30px !important;height:30px !important}.img-sm+.img-push{margin-left:40px}.img-md{width:60px;height:60px}.img-md+.img-push{margin-left:70px}.img-lg{width:100px;height:100px}.img-lg+.img-push{margin-left:110px}.img-bordered{border:3px solid #d2d6de;padding:3px}.img-bordered-sm{border:2px solid #d2d6de;padding:2px}.attachment-block{border:1px solid #f4f4f4;padding:5px;margin-bottom:10px;background:#f7f7f7}.attachment-block .attachment-img{max-width:100px;max-height:100px;height:auto;float:left}.attachment-block .attachment-pushed{margin-left:110px}.attachment-block .attachment-heading{margin:0}.attachment-block .attachment-text{color:#555}.connectedSortable{min-height:100px}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sort-highlight{background:#f4f4f4;border:1px dashed #ddd;margin-bottom:10px}.full-opacity-hover{opacity:.65;filter:alpha(opacity=65)}.full-opacity-hover:hover{opacity:1;filter:alpha(opacity=100)}.chart{position:relative;overflow:hidden;width:100%}.chart svg,.chart canvas{width:100% !important}@media print{.no-print,.main-sidebar,.left-side,.main-header,.content-header{display:none !important}.content-wrapper,.right-side,.main-footer{margin-left:0 !important;min-height:0 !important;-webkit-transform:translate(0, 0) !important;-ms-transform:translate(0, 0) !important;-o-transform:translate(0, 0) !important;transform:translate(0, 0) !important}.fixed .content-wrapper,.fixed .right-side{padding-top:0 !important}.invoice{width:100%;border:0;margin:0;padding:0}.invoice-col{float:left;width:33.3333333%}.table-responsive{overflow:auto}.table-responsive>.table tr th,.table-responsive>.table tr td{white-space:normal !important}}"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"totalSize > 1\" class=\"pagination\">\n\n    <a *ngIf=\"previousItemValid && firstText\" (click)=\"firstPage()\" [innerHTML]=\"firstText\">First</a>\n\n    <a *ngIf=\"previousItemValid\" (click)=\"previousPage(nextItem)\" [innerHTML]=\"previousText\">&laquo;</a>\n\n    <a *ngFor=\"let pageNo of pageList\" [ngClass]=\"{'active':selectedPageNo == pageNo}\" (click)=\"setCurrentPage(pageNo)\">{{pageNo}}</a>\n    \n    <a *ngIf=\"nextItemValid\" (click)=\"nextPage(nextItem)\" [innerHTML]=\"nextText\">&raquo;</a>\n    \n    <a *ngIf=\"nextItemValid && lastText\" (click)=\"lastPage()\" [innerHTML]=\"lastText\">Last</a>\n \n</div>\n"

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "      <!-- Main Footer -->\n      <footer class=\"main-footer\">\n        <!-- To the right -->\n        <div class=\"pull-right hidden-xs\">\n        </div>\n        <!-- Default to the left -->\n        &copy; 2017 <a href=\"http://www.forgottenrecords.com\" target=\"_blank\">Forgotten Records</a>. Tous droits réservés.\n      </footer>"

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "       <!-- Main Header -->\n        <header class=\"main-header\">\n\n          <!-- Logo -->\n          <a href=\"#\" class=\"logo\">\n            <!-- mini logo for sidebar mini 50x50 pixels -->\n            <span class=\"logo-mini logo-custum\">{{config.data?.APP.ADMIN.TITLE_MINI}}</span>\n            <!-- logo for regular state and mobile devices -->\n            <span class=\"logo-lg logo-custum\">{{config.data?.APP.ADMIN.TITLE}}</span>\n          </a>\n\n          <!-- Header Navbar -->\n          <nav class=\"navbar navbar-static-top\" role=\"navigation\">\n            <!-- Sidebar toggle button-->\n            <a href=\"#\" class=\"sidebar-toggle\" data-toggle=\"offcanvas\" role=\"button\">\n              <span class=\"sr-only\">toggle</span>\n            </a>\n            <!--<div class=\"pull-left\">\n              <form (ngSubmit)=\"this.utils.onGo(currentLanguage)\">\n                <input type=\"text\" style=\"margin: 10px 0px 0px 10px\" >\n                <button type=\"submit\" class=\"btn btn-default btn-custom-new\">Go</button>\n              </form>\n            </div>-->\n            <!-- Navbar Right Menu -->\n            <div class=\"navbar-custom-menu\">\n              <ul class=\"nav navbar-nav\">\n                <!-- Language selection -->\n                <li language-selector \n                      *ngFor=\"let lang of config.data?.APP.LANGUAGES.SUPPORTED\"\n                          [language]=\"lang\" \n                          [resourcePath]=\"lgRouting.resourcePath\" \n                          [currentLanguage]=\"lgRouting.currentLanguage\"\n                          (onLanguageSelect)=\"lgRouting.onSelect($event)\">\n                </li>\n                <!-- Notifications Menu -->\n                <!--<li class=\"dropdown notifications-menu\">\n                  <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n                    <i class=\"fa fa-tag\"></i>\n                    <span class=\"label label-success\">2</span>\n                  </a>\n                  <ul class=\"dropdown-menu\">\n                    <li class=\"header\">2 nouvelles commandes</li>\n                    <li class=\"footer\"><a href=\"#\">Voir les nouvelles commandes</a></li>\n                  </ul>\n                </li>-->\n                <!-- User Account Menu -->\n                <li class=\"dropdown user user-menu\">\n                  <!-- Menu Toggle Button -->\n                  <a href=\"#\" [routerLink]=\"['/admin/login']\">\n                    <!-- The user image in the navbar-->\n                    <div class=\"glyphicon glyphicon-off\"></div>\n                    <!-- hidden-xs hides the username on small devices so only the image appears. -->\n                    <span class=\"hidden-xs\" *ngIf=\"loggedInUser\">{{loggedInUser}}</span>\n                    <span class=\"hidden-xs\" *ngIf=\"!loggedInUser\">-</span>\n                  </a>\n                </li>\n                <!-- Control Sidebar Toggle Button -->\n                 <!--<li>\n                  <a href=\"#\" data-toggle=\"control-sidebar\"><i class=\"fa fa-gears\"></i></a>\n                </li> -->\n              </ul>\n            </div>\n          </nav>\n        </header>"

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "<!-- Messaging -->\n<!--<div message-flash type=\"info\"></div> -->\n\n<div class=\"login-box\" ng-controller=\"AdminLoginCtrl\">\n  <div class=\"login-logo logo-custum \">\n    GuernCMS\n  </div>\n  <!--TODO: remove this: {{credentials?.username}}-->\n  <!-- /.login-logo -->\n  <div class=\"login-box-body\">\n    <p class=\"login-box-msg\">Connexion à l'administration</p>\n\n        <!-- <a (click)=\"router.navigateByUrl('admin/record/edit/598afb40e57bc2230019b17d')\">test</a> -->\n\n      <form #f=\"ngForm\" (ngSubmit)=\"login(credentials)\" *ngIf=\"credentials\">\n\n        <div class=\"form-group has-feedback\">\n            <input [(ngModel)]=\"credentials.username\" required name=\"username\" type=\"text\" class=\"form-control\" placeholder=\"Utilisateur\">\n            <span class=\"glyphicon glyphicon-user form-control-feedback\"></span>\n        </div>\n\n        <div class=\"form-group has-feedback\">\n            <input [(ngModel)]=\"credentials.password\" required name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Mot de passe\">\n            <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span>\n        </div>\n        <div class=\"row\">\n            <!--\n            <div class=\"col-xs-8\">\n            <div class=\"checkbox icheck\">\n                <label>\n                <input type=\"checkbox\"> Mémoriser\n                </label>\n            </div>\n            </div>\n            -->\n            <!-- /.col -->\n            <div class=\"col-xs-4 pull-right\">\n            <!--[disabled]=\"!f.valid\" -->\n            <button type=\"submit\" class=\"btn btn-primary btn-block btn-flat btn-custom\">Valider</button>\n            </div>\n            <!-- /.col -->\n        </div>\n    </form>\n\n  </div>\n  <!-- /.login-box-body -->\n</div>\n<!-- /.login-box -->"

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "      <!-- Left side column. contains the logo and sidebar -->\n      <aside class=\"main-sidebar\">\n\n        <!-- sidebar: style can be found in sidebar.less -->\n        <section class=\"sidebar\"> \n\n          <search \n            [order]=\"['composer','soloist','conductor']\"\n            placeholder=\"Rechercher\"\n            [language]=\"currentLanguage\"\n            target=\"admin/records\">\n          </search>\n\n          <!-- Sidebar Menu --> \n          <ul class=\"sidebar-menu\">\n            <!--<li class=\"header\">Actions</li>-->\n            <li class=\"treeview\">\n                <a (click)=\"utils.lLink('admin/record/edit/0',currentLanguage)\" class=\"lLink\"><i class=\"glyphicon glyphicon-cd\"></i>\n                  <span>Nouveau disque</span>\n                </a>\n            </li>\n            <li class=\"treeview\">\n                <a href=\"#\"><!-- (click)=\"utils.lLink('admin/records',currentLanguage)\" -->\n                  <i class=\"glyphicon glyphicon-list\"></i>\n                  <span>Catalogue</span>\n                  <span class=\"pull-right-container\">\n                    <i class=\"fa fa-angle-left pull-right\"></i>\n                  </span>\n                </a>\n                <ul class=\"treeview-menu\">\n                  <li><a (click)=\"utils.lLink('admin/records',currentLanguage)\" class=\"lLink\"><i class=\"fa fa-circle-o\"></i> Tout le catalogue</a></li>\n                  <li><a (click)=\"utils.lLink('admin/records?f=type~reissue',currentLanguage)\" class=\"lLink\"><i class=\"fa fa-circle-o\"></i> Interprètes d'hier</a></li>\n                  <li><a (click)=\"utils.lLink('admin/records?f=type~production',currentLanguage)\" class=\"lLink\"><i class=\"fa fa-circle-o\"></i> Interprètes d'aujourd'hui</a></li>\n                  <li><a (click)=\"utils.lLink('admin/records/active/false',currentLanguage)\" class=\"lLink\"><i class=\"fa fa-circle-o\"></i> Non-publié</a></li>\n                </ul>\n              </li>\n            <li class=\"treeview\">\n              <a (click)=\"utils.lLink('admin/specials',currentLanguage)\" class=\"lLink\"><i class=\"glyphicon glyphicon-star\"></i>\n                <span>Parmi les interprètes</span>\n              </a>\n            </li>\n            <li class=\"treeview\">\n                <a (click)=\"utils.lLink('admin/writings',currentLanguage)\" class=\"lLink\"><i class=\"glyphicon glyphicon-text-size\"></i>\n                  <span>Ecrits</span>\n                </a>\n            </li>\n            <li class=\"treeview\">\n                <a (click)=\"utils.lLink('admin/messages',currentLanguage)\" class=\"lLink\"><i class=\"glyphicon glyphicon-paperclip\"></i>\n                  <span>Messages</span>\n                </a>\n            </li>\n            <li class=\"treeview\">\n                <a (click)=\"utils.lLink('admin/pages',currentLanguage)\" class=\"lLink\"><i class=\"glyphicon glyphicon-file\"></i>\n                  <span>Pages</span>\n                </a>\n              </li>\n          </ul>\n          <!-- /.sidebar-menu -->\n        </section>\n        <!-- /.sidebar -->\n      </aside>"

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"wrapper\" lg-routing #lgRouting=\"lgRouting\">\n\n        <!-- lgRouting used for currentLanguage, resourcePath and language switch call back-->\n        <admin-header \n            [loggedInUser]=\"loggedInUser\" \n            [lgRouting]=\"lgRouting\">\n        </admin-header>\n        \n        <admin-menu \n            [currentLanguage]=\"lgRouting.currentLanguage\">\n        </admin-menu>\n\n        <div class=\"content-wrapper white-bg\">\n            <!-- <ng2-toasty></ng2-toasty>         -->\n            <div id=\"snackbar\"></div>\n\n            <router-outlet></router-outlet>\n        </div>\n\n        <admin-footer></admin-footer>\n      \n    </div>"

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1 [ngSwitch]=\"action\">\n    <!--<small>{{currentLanguage | uppercase}}</small> -->\n    <span *ngSwitchCase=\"'add'\">Nouveau contenu</span>\n    <span *ngSwitchCase=\"'update'\">Edition</span>\n    <span *ngSwitchCase=\"'update'\"> <small>(modifié: {{content?.update_date | date:'dd MM yyyy'}})</small></span>\n  </h1>\n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"box\">\n        <div class=\"box-body\">\n\n          <form *ngIf=\"content || action=='add'\" [formGroup]=\"messageForm\" (ngSubmit)=\"onSubmit()\">\n\n            <div class=\"panel panel-default\">\n\n              <div class=\"panel-heading\">Métadonnées</div>\n              <div class=\"panel-body\">\n                <div class=\"form-inline\">\n                  <div class=\"col-md-1 col-sm-1 input-group switch material-switch\">\n                    <input formControlName=\"active\" id=\"act\" name=\"act\" type=\"checkbox\"/>\n                    <label for=\"act\" class=\"label-primary\"></label>\n                  </div>\n                  <div class=\"input-group col-md-4 col-sm-5\">\n                    <input type=\"text\" class=\"form-control\" formControlName=\"label\"/>\n                  </div>\n                  <div class=\"input-group col-md-6 col-sm-5\">\n                      <div class=\"input-group-addon\"><i class=\"fa fa-external-link\"></i></div>\n                      <input type=\"text\" class=\"form-control\" formControlName=\"url\" />\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Titre</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"title\" class=\"form-inline\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"col-md-6 input-group\">\n                    <div class=\"input-group-addon max-width-20\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Sous-titre</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"subtitle\" class=\"form-inline\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"col-md-6 input-group\">\n                    <div class=\"input-group-addon max-width-20\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Contenu</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"content\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n                    <small>{{lg | uppercase}}</small>\n                    <html-editor [initText]=\"content? content.content[lg] : ''\" [elementId]=\"'editor-content-'+lg\" (onEditorKeyup)=\"keyupEditorHandlerFunction(['content',lg], $event)\"\n                      height=\"3\">\n                    </html-editor>\n                  </div>\n                </div>\n              </div>\n\n              <button type=\"submit\" [disabled]=\"!messageForm.valid\" class=\"btn btn-info pull-right\">\n        Sauvegarder\n      </button>\n\n            </div>\n\n          </form>\n\n\n        </div>\n        <!-- /.box-body -->\n      </div>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1>Messages\n    <a (click)=\"this.utils.lLink('admin/special/edit/0',currentLanguage)\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Nouveau</div>\n    </a>\n  </h1> \n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n\n  <div class=\"col-xs-12\">\n  <div class=\"box\">\n    <div class=\"box-body\">\n\n      <table class=\"table table-striped table-hover\">\n        <thead>\n          <tr>\n            <th>Statut</th>\n            <th>Object</th>\n            <th>Mise à jour</th>\n          </tr> \n        </thead>\n        <tbody>\n          <tr *ngFor=\"let item of contents\">\n            <td>\n              <div class=\"switch material-switch\">\n                <input (click)=\"onStatusChange(!item.active,item)\" [(ngModel)]=\"item.active\" id=\"{{item._id}}\" name=\"{{item._id}}\" type=\"checkbox\"/>\n                <label attr.for=\"{{item._id}}\" class=\"label-primary\"></label>\n              </div>\n            </td>\n            <td (click)=\"router.navigate(['message/edit/'+item._id], {relativeTo: route.parent})\" class=\"lLink\">{{item.title ? item.label : '-'}}</td>\n            <td>{{item.update_date | date:'MMM dd yyyy'}}</td>\n          </tr>\n        </tbody>\n      </table>\n\n\n    </div><!-- /.box-body -->\n  </div>\n  </div>\n  </div>\n</section>"

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1 [ngSwitch]=\"action\">\n    <!--<small>{{currentLanguage | uppercase}}</small> -->\n    <span *ngSwitchCase=\"'add'\">Nouvelle page</span>\n    <span *ngSwitchCase=\"'update'\">Edition</span>\n    <span *ngSwitchCase=\"'update'\"> <small>(modifié: {{content?.update_date | date:'dd MM yyyy'}})</small></span>\n  </h1>\n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"box\">\n        <div class=\"box-body\">\n\n          <form *ngIf=\"content || action=='add'\" [formGroup]=\"pageForm\" (ngSubmit)=\"onSubmit()\">\n\n            <div class=\"panel panel-default\">\n\n              <div class=\"panel-heading\">Métadonnées</div>\n              <div class=\"panel-body\">\n                <div class=\"form-inline\">\n                  <div class=\"col-md-1 col-sm-1 input-group switch material-switch\">\n                        <input formControlName=\"active\" id=\"act\" name=\"act\" type=\"checkbox\"/>\n                        <label for=\"act\" class=\"label-primary\"></label>\n                  </div>\n                  <div class=\"input-group col-lg-3 col-md-4 col-sm-5\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-external-link\"></i></div>\n                    <input type=\"text\" class=\"form-control\" formControlName=\"url\" />\n                  </div>\n                  <div class=\"input-group col-lg-3 col-md-4 col-sm-5\" style=\"max-width: 200px\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></div>\n                    <!--[mask]=\"'brDate'\" -->\n                    <input type=\"text\" class=\"form-control\" formControlName=\"date\" readonly>\n                  </div>\n                  <div class=\"input-group col-lg-3 col-md-4 col-sm-5\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-id-card-o\"></i></div>\n                    <input type=\"text\" class=\"form-control\" formControlName=\"_id\" readonly/>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Titre</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"title\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group input-group\">\n                    <div class=\"input-group-addon\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <!--<div class=\"panel-heading\">Image</div>\n              <div class=\"panel-body panel-body-edit-image\">\n                <div formGroupName=\"image\">\n                  <image-uploads [reactiveForm]=\"pageForm\" groupName=\"image\" addApi=\"/api/data/uploads/add\" deleteApi=\"/api/data/uploads/delete/\"\n                    imagePath=\"data/uploads/\" [thumbSize]=\"300\">\n                  </image-uploads>\n                </div>\n              </div>-->\n\n              <div class=\"panel-heading\">Contenu</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"content\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n                    <small>{{lg | uppercase}}</small>\n                    <html-editor [initText]=\"content? content.content[lg] : ''\" [elementId]=\"'editor-content-'+lg\" (onEditorKeyup)=\"keyupEditorHandlerFunction(['content',lg], $event)\"\n                      height=\"50\">\n                    </html-editor>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Résumé</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"content\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n                    <small>{{lg | uppercase}}</small>\n                    <html-editor [initText]=\"content? content.summary[lg] : ''\" [elementId]=\"'editor-summary-'+lg\" (onEditorKeyup)=\"keyupEditorHandlerFunction(['summary',lg], $event)\"\n                      height=\"10\">\n                    </html-editor>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Tags</div>\n              <div class=\"panel-body\" formArrayName=\"tags\">\n                <div class=\"form-inline\">\n                  <div *ngFor=\"let item of pageForm.controls.tags.controls; let i = index\" class=\"input-group col-lg-3 col-md-4 col-sm-5\" style=\"padding: 0px 3px 3px 0px; max-width: 200px\">\n                    <input type=\"text\" class=\"form-control\" formControlName=\"{{i}}\">\n                    <div class=\"input-group-addon\"><a (click)=\"onRemoveTag(i)\" class=\"glyphicon glyphicon-remove clickLink\"></a></div>\n                  </div>\n                  <a (click)=\"onAddTag()\" class=\"glyphicon glyphicon-plus clickLink\"> </a>\n                </div>\n              </div>\n\n              <button type=\"submit\" [disabled]=\"!pageForm.valid\" class=\"btn btn-info pull-right\">\n        Sauvegarder\n      </button>\n\n            </div>\n\n          </form>\n\n\n        </div>\n        <!-- /.box-body -->\n      </div>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1>Pages\n    <a (click)=\"this.utils.lLink('admin/page/edit/0',currentLanguage)\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Nouveau</div>\n    </a>\n  </h1>\n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n  <div class=\"col-xs-12\">\n  <div class=\"box\">\n    <div class=\"box-body\">\n\n      <table class=\"table table-striped table-hover\">\n        <thead>\n          <tr>\n            <!-- <th>Statut</th> -->\n            <th>Date</th>\n            <th>Titre ({{currentLanguage}})</th>\n            <th>URL</th>\n            <th>Modifié</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let page of contents\">\n            <!-- <td>\n                <div class=\"switch material-switch\">\n                  <input (click)=\"onStatusChange(!page.active,page)\" [(ngModel)]=\"page.active\" id=\"{{page._id}}\" name=\"{{page._id}}\" type=\"checkbox\"/>\n                  <label attr.for=\"{{page._id}}\" class=\"label-primary\"></label>\n                </div>\n            </td> -->\n            <td>{{page.date | date:'MMM dd yyyy'}}</td>\n            <td (click)=\"router.navigate(['page/edit/'+page._id], {relativeTo: route.parent})\" class=\"pointer\">{{page.title ? page.title[currentLanguage] : '-'}}</td>\n            <td><a href=\"page/{{page.url}}\" target=\"_blank\" class=\"pointer\">{{page.url}}</a></td>\n            <td>{{page.update_date | date:'MMM dd yyyy'}}</td>\n          </tr>\n        </tbody>\n      </table>\n\n\n    </div><!-- /.box-body -->\n  </div>\n  </div>\n  </div>\n</section>"

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n\t<h1 [ngSwitch]=\"action\">\n  \t\t<span *ngSwitchCase=\"'add'\">Nouveau disque</span>\n      <span *ngSwitchCase=\"'update'\">Edition <small>{{content?.cid}}</small></span>\n      <a *ngIf=\"content && action=='update'\" (click)=\"deleteContent('record',content._id)\" class=\"lLink\">\n        <div class=\"btn btn-default btn-sm\">Supprimer</div>\n      </a>\n      <span *ngSwitchCase=\"'update'\"> <small>(modifié: {{content?.update_date | date:'dd MM yyyy'}})</small></span>\n  </h1>\n</section>\n\n<section class=\"content\">\n  \n  <div class=\"row\"><div class=\"col-xs-12\"><div class=\"box\">\n    <div class=\"box-body\">\n\n    <form *ngIf=\"content || action=='add'\" [formGroup]=\"recordForm\" (ngSubmit)=\"onSubmit()\" autocomplete=\"off\">\n\n      <div class=\"panel panel-default\">\n\n\t\t\t<div class=\"panel-heading\">Titre</div>\n\t\t\t<div class=\"panel-body\">\n        <div class=\"col-xs-1 switch material-switch\">\n          <input formControlName=\"active\" id=\"act\" name=\"act\" type=\"checkbox\"/>\n          <label for=\"act\" class=\"label-primary\"></label>\n        </div>\n        <div class=\"col-xs-9\">\n          <input formControlName=\"title\" type=\"text\" class=\"form-control\" style=\"font-weight:bold\" />\n        </div> \n        <div *ngIf=\"action=='update'\">\n          <!-- not special -->\n          <div *ngIf=\"!special\" (click)=\"utils.lNavigate('admin/special/edit/0', currentLanguage, null, {queryParams: {recordUrl: content.url}})\" class=\"col-xs-1 pointer switch\">\n            <i style=\"font-size:14pt\" title=\"special\" class=\"glyphicon glyphicon-star-empty\"></i>\n          </div>\n          <!-- special -->\n          <div *ngIf=\"special\" (click)=\"utils.lNavigate('admin/special/edit/'+special._id, currentLanguage, null)\" class=\"col-xs-1 pointer switch\">\n            <i style=\"font-size:14pt\" title=\"special\" class=\"glyphicon glyphicon-star\"></i>\n          </div>\n        </div>\n      </div>\n\n\t\t\t <div class=\"panel-heading\">Pochette</div>\n\t\t\t<div class=\"panel-body panel-body-edit-image\">\n        <div formGroupName=\"cover\">\n          <image-uploads \n                [reactiveForm]=\"recordForm\"\n                groupName=\"cover\"\n                addApi=\"/api/data/covers/add\"\n                deleteApi=\"/api/data/covers/delete/\"\n                deleteDir=\"covers\"\n                imagePath=\"/data/covers/\"\n                [thumbSize]=\"300\">\n          </image-uploads>\n        </div>\n      </div> \n\n\t\t\t<div class=\"panel-heading\">Métadonnées</div>\n\t\t\t<div class=\"panel-body\">\n        <div class=\"form-group\">\n          <div class=\"block form-inline\">\n            <div class=\"input-group col-md-3\">\n              <select formControlName=\"type\" class=\"form-control\">\n                <option value=\"reissue\">Ré-édition</option>\n                <option value=\"production\">Production</option>\n              </select>\n            </div>\n            <div class=\"input-group col-md-4\">\n              <div class=\"input-group-addon addon-width\"><i class=\"glyphicon glyphicon-cd\"></i></div>\n              <input formControlName=\"reference\" class=\"form-control\" type=\"text\"/>\n            </div> \n             <div class=\"input-group col-md-4\">\n              <div class=\"input-group-addon addon-width\" ><i class=\"fa fa-calendar\"></i></div>\n              <input formControlName=\"date\" type=\"text\" class=\"date-mask form-control\">\n            </div>   \n          </div> \n          <div class=\"block form-inline\">\n            <div class=\"input-group col-md-3\">\n              <span class=\"input-group-addon addon-width\"><i class=\"glyphicon glyphicon-euro\"></i></span>\n              <input formControlName=\"price\" type=\"text\" class=\"price-mask form-control\">\n            </div>\n            <div class=\"input-group col-md-4\">\n              <div class=\"input-group-addon addon-width\"><i class=\"glyphicon glyphicon-time\"></i></div>\n              <input formControlName=\"length\" type=\"text\" class=\"length-mask form-control\">\n            </div> \n            <div class=\"input-group col-md-4\">\n              <div (click)=\"buildUrl()\" class=\"input-group-addon addon-width\"><i class=\"fa fa-external-link\"></i></div>\n              <input [(ngModel)]=\"url\" formControlName=\"url\" class=\"form-control\" type=\"text\" readonly>\n            </div>   \n          </div>\n           <div class=\"block form-inline\">\n            <div class=\"input-group col-md-4\" formArrayName=\"original_references\" *ngFor=\"let item of recordForm.controls.original_references.controls; let i = index\" style=\"padding-right: 4px\">\n              <div class=\"input-group-addon addon-width\"><i class=\"glyphicon glyphicon-education\"></i></div>\n              <input type=\"text\" class=\"form-control\" [formControlName]=\"i\">\n              <div class=\"input-group-addon addon-width\"><a (click)=\"onRemoveOriginalReference(i)\" class=\"glyphicon glyphicon-remove lLink\"></a></div>\n              <div *ngIf=\"recordForm.controls.original_references.controls.length==i+1\" class=\"input-group-addon addon-width\"><a (click)=\"onAddOriginalReference()\" class=\"glyphicon glyphicon-plus lLink\"></a></div>\n            </div> \n          </div> \n          <a *ngIf=\"recordForm.controls.original_references.controls.length==0\" (click)=\"onAddOriginalReference()\" class=\"glyphicon glyphicon-plus lLink\"></a>   \n        </div>\n\t\t\t</div>\n\n\t\t\t <div class=\"panel-heading\" style=\"margin-bottom: 15px\">Œuvres</div>\n\t\t\t<div ngclass=\"panel-body\" formArrayName=\"music_pieces\">\n        <div class=\"form-group\" [formGroupName]=\"i\" *ngFor=\"let mp of recordForm.get('music_pieces').controls; let i = index\">\n          <div class=\"block\">\n              <div class=\"collapse input-group col-xs-12\">\n                <input style=\"font-weight:bold\" type=\"text\" class=\"form-control\" formControlName=\"title\"/>\n                <div class=\"input-group-addon\"><a (click)=\"onRemoveMusicPiece(i)\" class=\"glyphicon glyphicon-remove lLink\"></a></div>\n                <div *ngIf=\"recordForm.get('music_pieces').controls.length==i+1\" class=\"input-group-addon\"><a (click)=\"onAddMusicPiece()\" class=\"glyphicon glyphicon-plus lLink\"></a></div>\n              </div>\n          </div>\n          <div class=\"block form-inline\">\n              <div class=\"input-group col-md-3\">\n                <div class=\"input-group-addon addon-width\"><i class=\"fa fa-calendar\"></i></div>\n                <input type=\"text\" class=\"form-control date-mask\" formControlName=\"date\"/>\n              </div>\n              <div class=\"input-group col-md-4\">\n                <div class=\"input-group-addon addon-width\">C</div><!-- <i class=\"fa fa-pencil\"></i> -->\n                <!-- Outputs inputFocus property -->\n                <input (keyup)=\"onInputChange('composer',$event)\" id=\"composer{{i}}\" type=\"text\" class=\"form-control\" formControlName=\"composer\"/>\n                 <search-autocomplete\n                  [form]=\"recordForm\"\n                  formPath=\"music_pieces.{{i}}.composer\"\n                  target=\"composer{{i}}\"\n                  esType=\"composer\"\n                  [input]=\"inputFocus\">\n                </search-autocomplete> \n              </div>\n              <div class=\"input-group col-md-4\">\n                <div class=\"input-group-addon addon-width\">C.O</div><!-- <img src=\"data/images/icons/conductor.png\" class=\"input-group-addon-img\"/> -->\n                <input (keyup)=\"onInputChange('conductor',$event)\" id=\"conductor{{i}}\" type=\"text\" class=\"form-control\" formControlName=\"conductor\"/>\n                 <search-autocomplete\n                  [form]=\"recordForm\"\n                  formPath=\"music_pieces.{{i}}.conductor\"\n                  target=\"conductor{{i}}\"\n                  esType=\"conductor\"\n                  [input]=\"inputFocus\">\n                </search-autocomplete> \n              </div>\n          </div>\n          <div class=\"form-inline\">\n              <div style=\"padding-right: 3px\" class=\"col-md-6 input-group\">\n                <div class=\"input-group-addon addon-width\">O</div>\n                <input (keyup)=\"onInputChange('orchestra',$event)\" id=\"orchestra{{i}}\" type=\"text\" class=\"form-control\" formControlName=\"orchestra\"/>\n                 <search-autocomplete\n                  [form]=\"recordForm\"\n                  formPath=\"music_pieces.{{i}}.orchestra\"\n                  target=\"orchestra{{i}}\"\n                  esType=\"orchestra\"\n                  [input]=\"inputFocus\">\n                </search-autocomplete> \n              </div>\n          </div>\n          <div class=\"form-inline\">\n              <div formArrayName=\"soloists\" *ngFor=\"let s of recordForm.get('music_pieces').at(i).get('soloists').controls; let j = index\">\n                <div [formGroupName]=\"j\" class=\"form-inline\">\n                  <div class=\"input-group col-md-5\">\n                    <div class=\"input-group-addon addon-width\">S</div><!-- <img src=\"data/images/icons/soloist.png\" class=\"input-group-addon-img\"/> -->\n                    <input (keyup)=\"onInputChange('soloist',$event)\" id=\"soloist{{i}}{{j}}\" type=\"text\" class=\"form-control\" formControlName=\"name\"/>\n                    <search-autocomplete\n                      [form]=\"recordForm\"\n                      formPath=\"music_pieces.{{i}}.soloists.{{j}}.name\"\n                      target=\"soloist{{i}}{{j}}\"\n                      esType=\"soloist\"\n                      [input]=\"inputFocus\">\n                    </search-autocomplete>\n                  </div>\n                  <div class=\"input-group col-md-6\">\n                    <div class=\"input-group-addon addon-width\">I</div><!-- <img src=\"data/images/icons/instrument.png\" class=\"input-group-addon-img\"/> -->\n                    <input (keyup)=\"onInputChange('instrument',$event)\" id=\"instrument{{i}}{{j}}\" type=\"text\" class=\"form-control\" formControlName=\"instrument\"/>\n                    <search-autocomplete\n                      [form]=\"recordForm\"\n                      formPath=\"music_pieces.{{i}}.soloists.{{j}}.instrument\"\n                      target=\"instrument{{i}}{{j}}\"\n                      esType=\"instrument\"\n                      [input]=\"inputFocus\">\n                    </search-autocomplete>\n                    <div class=\"input-group-addon addon-width\"><a (click)=\"onRemoveSoloist(i,j)\" class=\"glyphicon glyphicon-remove lLink\"></a></div>\n                    <div class=\"input-group-addon addon-width\" *ngIf=\"j==recordForm.get('music_pieces').at(i).get('soloists').controls.length-1\"><a (click)=\"onAddSoloist(i)\" class=\"glyphicon glyphicon-plus lLink\"></a></div>\n                  </div>\n                </div>\n              </div>\n              <div *ngIf=\"recordForm.get('music_pieces').at(i).get('soloists').controls==0\" class=\"input-group\">\n                <div class=\"input-group-addon addon-width\">S</div>\n                <div class=\"input-group-addon addon-width\"><a (click)=\"onAddSoloist(i)\" class=\"glyphicon glyphicon-plus lLink\"></a></div>\n              </div>\n          </div>\n        </div>\n        <a *ngIf=\"recordForm.get('music_pieces').controls.length==0\" (click)=\"onAddMusicPiece()\" class=\"glyphicon glyphicon-plus lLink\"></a>\n      </div> \n\n\t\t\t <div class=\"panel-heading\">Description</div>\n\t\t\t<div class=\"panel-body\">\n      <div formGroupName=\"description\">\n        <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n          <small>{{lg | uppercase}}</small> \n          <html-editor\n              [initText]=\"content? content.description[lg] : ''\"\n              [elementId]=\"'editor-description-'+lg\"\n              [height]=\"5\"\n              (onEditorKeyup)=\"keyupEditorHandlerFunction(['description',lg], $event)\">\n          </html-editor>\n        </div>\n      </div>\n      </div> \n\n\t\t\t <div class=\"panel-heading\">Tags</div>\n\t\t\t<div class=\"panel-body\" formArrayName=\"tags\">\n        <div class=\"form-inline\">\n          <div *ngFor=\"let item of recordForm.controls.tags.controls; let i = index\" class=\"input-group col-lg-3 col-md-4 col-sm-5\" style=\"padding: 0px 3px 3px 0px; max-width: 200px\">\n            <input type=\"text\" class=\"form-control\" formControlName=\"{{i}}\">\n            <div class=\"input-group-addon\"><a (click)=\"onRemoveTag(i)\" class=\"glyphicon glyphicon-remove lLink\"></a></div>\n            <div *ngIf=\"recordForm.controls.tags.controls.length==i+1\" class=\"input-group-addon\"><a (click)=\"onAddTag()\" class=\"glyphicon glyphicon-plus lLink\"></a></div>\n          </div> \n          <a *ngIf=\"recordForm.controls.tags.controls.length==0\" (click)=\"onAddTag()\" class=\"glyphicon glyphicon-plus lLink\"></a>\n\t\t\t  </div>\n      </div> \n\n\t\t\t<div class=\"panel-body\">\n\t\t\t\t<div class=\"form-inline\"> \n\t\t\t\t\t<div class=\"input-group col-lg-3 col-md-4 col-sm-5 pull-right\">\n\t\t\t\t\t\t<input [disabled]=\"recordForm.invalid\" type=\"submit\" class=\"btn btn-info\" value=\"Enregistrer le nouveau disque\"> \n\t\t\t\t\t</div>  \n\t\t\t\t</div>\n\t\t\t</div>\n\n      </div>\n    </form>  \n\n\n    </div>\n  </div></div></div>\n</section>"

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1>Catalogue\n    <a (click)=\"utils.lLink('admin/record/edit/0',currentLanguage)\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Nouveau</div>\n    </a>\n  </h1>\n</section>\n\n<section searchable-contents [noCache]=\"true\" context=\"record\" [pageSize]=\"pageSize\" #sc=\"sc\" [ngSwitch]=\"sc.loading\" class=\"container-fluid\">\n\n  <!-- Loader -->\n\t<div *ngSwitchCase=\"true\">\n\t  <loading-indicator></loading-indicator>\n\t</div>\n\n  <!-- Data is ready -->\n  <div *ngSwitchCase=\"false\" class=\"row\">\n  <!--{{ sc?.esQuery | json }}-->\n\n    <!-- <div class=\"content col-sm-9 col-md-10\"> -->\n    <div class=\"content\">\n      \n      <search-filters \n        title=\"Recherche\"\n        [esQuery]=\"sc.esQuery\"\n        [esFilters]=\"sc.esFilters\">\n      </search-filters>\n\n      <admin-search-results \n        [esContents]=\"sc.esContents\"\n        [dbContents]=\"sc.dbContents\"\n        [pageSize]=\"sc.pageSize\"\n        (onSearch)=\"sc.searchCallBack($event)\">\n      </admin-search-results>\n\n    </div>\n\n    <!-- <div class=\"facets col-sm-3 col-md-2\">\n      <admin-search-facets \n        [fields]=\"['type']\"\n        [esAggregations]=\"sc.esAggregations\"\n        [esFilters]=\"sc.esFilters\"\n        (onFilter)=\"sc.searchCallBack($event)\">\n      </admin-search-facets>\n    </div> -->\n\n  </div>\n\n</section>"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n    <h1 [ngSwitch]=\"action\">\n        <span *ngSwitchCase=\"'add'\">Parmi les interprètes d'ajourd'hui (nouveau)</span>\n        <span *ngSwitchCase=\"'update'\">Parmi les interprètes d'ajourd'hui <small>{{content?.cid}}</small></span>\n        <a *ngIf=\"content && action=='update'\" (click)=\"deleteContent('special',content._id)\" class=\"lLink\">\n          <div class=\"btn btn-default btn-sm\">Supprimer</div>\n        </a>\n        <span *ngSwitchCase=\"'update'\"> <small>(modifié: {{content?.update_date | date:'dd MMM yyyy'}})</small></span>\n    </h1>\n  </section>\n\n<section class=\"content\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"box\">\n        <div class=\"box-body\">\n\n          <form *ngIf=\"content || action=='add'\" [formGroup]=\"specialForm\" (ngSubmit)=\"onSubmit()\">\n\n            <div class=\"panel panel-default\">\n\n              <div class=\"panel-heading\">Métadonnées</div>\n              <div class=\"panel-body\">\n                <div class=\"form-inline\">\n                  <div class=\"col-md-1 col-sm-1 input-group switch material-switch\">\n                        <input formControlName=\"active\" id=\"act\" name=\"act\" type=\"checkbox\"/>\n                        <label for=\"act\" class=\"label-primary\"></label>\n                  </div>\n                  <div class=\"input-group col-lg-3 col-md-4 col-sm-5\" style=\"max-width: 200px\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></div>\n                    <!--[mask]=\"'brDate'\" -->\n                    <input type=\"text\" class=\"form-control\" formControlName=\"date\">\n                  </div>\n                  <div class=\"input-group col-lg-7 col-md-7 col-sm-10\">\n                      <div class=\"input-group-addon\"><i class=\"fa fa-external-link\"></i></div>\n                      <input type=\"text\" class=\"form-control\" formControlName=\"url\" readonly/>\n                    </div>\n                  <!-- <div class=\"input-group col-lg-3 col-md-4 col-sm-5\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-id-card-o\"></i></div>\n                    <input type=\"text\" class=\"form-control\" formControlName=\"_id\" readonly/>\n                  </div> -->\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Image</div>\n              <div class=\"panel-body\">\n                  <!-- <div class=\"input-group\">\n                    <div class=\"input-group-addon\"><i class=\"fa fa-id-card-o\"></i></div>\n                    <input type=\"text\" class=\"form-control\" formControlName=\"image\"/>\n                  </div> -->\n                  <img width=\"350px\" [src]=\"image\" />\n              </div>\n\n              <div class=\"panel-heading\">Titre</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"title\" class=\"form-inline\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"col-md-6 input-group\">\n                    <div class=\"input-group-addon max-width-20\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Sous-titre</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"subtitle\" class=\"form-inline\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"col-md-6 input-group\">\n                    <div class=\"input-group-addon max-width-20\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"panel-heading\">Contenu</div>\n              <div class=\"panel-body\">\n                <div formGroupName=\"content\">\n                  <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"input-group\">\n                    <div class=\"input-group-addon\">{{lg | uppercase}}</div>\n                    <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                  </div>\n                </div>\n              </div>\n\n              <button type=\"submit\" [disabled]=\"!specialForm.valid\" class=\"btn btn-info pull-right\">\n        Sauvegarder\n      </button>\n\n            </div>\n\n          </form>\n\n\n        </div>\n        <!-- /.box-body -->\n      </div>\n    </div>\n  </div>\n</section>"

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1>Parmi les interprètes d'aujourd'hui\n    <!-- <a (click)=\"this.utils.lLink('admin/special/edit/0',currentLanguage)\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Nouveau</div>\n    </a> -->\n    <!-- <a (click)=\"notify()\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Notification</div>\n    </a>   -->\n    <!--<small>({{contents?.length}})</small>-->\n  </h1> \n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n\n  <div class=\"col-xs-12\">\n  <div class=\"box\">\n    <div class=\"box-body\">\n\n      <table class=\"table table-striped table-hover\">\n        <thead>\n          <tr>\n            <th>Statut</th>\n            <th>Date</th>\n            <th>Titre ({{currentLanguage}})</th>\n            <th>Sous-titre ({{currentLanguage}})</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let item of contents\">\n            <td>\n                <div class=\"switch material-switch\">\n                  <input (click)=\"onStatusChange(!item.active,item)\" [(ngModel)]=\"item.active\" id=\"{{item._id}}\" name=\"{{item._id}}\" type=\"checkbox\"/>\n                  <label attr.for=\"{{item._id}}\" class=\"label-primary\"></label>\n                </div>\n            </td>\n            <td>{{item.date | date:'MMM dd yyyy'}}</td>\n            <td (click)=\"router.navigate(['special/edit/'+item._id], {relativeTo: route.parent})\" class=\"pointer\">\n            {{item.title ? item.title[currentLanguage] : '-'}}</td>\n            <td>{{item.subtitle ? item.subtitle[currentLanguage] : '-'}}</td>\n          </tr>\n        </tbody>\n      </table>\n\n\n    </div><!-- /.box-body -->\n  </div>\n  </div>\n  </div>\n</section>"

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "      <section class=\"content-header\">\n          <h1 [ngSwitch]=\"action\">\n              <span *ngSwitchCase=\"'add'\">Nouvel écrit</span>\n              <span *ngSwitchCase=\"'update'\">Edition <small>{{content?.cid}}</small></span>\n              <a *ngIf=\"content && action=='update'\" (click)=\"deleteContent('writing',content._id)\" class=\"lLink\">\n                <div class=\"btn btn-default btn-sm\">Supprimer</div>\n              </a>\n              <span *ngSwitchCase=\"'update'\"> <small>(modifié: {{content?.update_date | date:'dd MMM yyyy'}})</small></span>\n          </h1>\n        </section>\n\n      <section class=\"content\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <div class=\"box\">\n              <div class=\"box-body\">\n      \n                <form *ngIf=\"content || action=='add'\" [formGroup]=\"writingForm\" (ngSubmit)=\"onSubmit()\">\n      \n                  <div class=\"panel panel-default\">\n      \n                    <div class=\"panel-heading\">Métadonnées</div>\n                    <div class=\"panel-body\">\n                      <div class=\"form-inline\">\n                        <div class=\"col-md-1 col-sm-1 input-group switch material-switch\">\n                              <input formControlName=\"active\" id=\"act\" name=\"act\" type=\"checkbox\"/>\n                              <label for=\"act\" class=\"label-primary\"></label>\n                        </div>\n                        <div class=\"input-group col-lg-3 col-md-3 col-sm-4\">\n                            <div class=\"input-group-addon\"><i class=\"fa fa-user\"></i></div>\n                            <input type=\"text\" class=\"form-control\" formControlName=\"author\" />\n                        </div>\n                        <div class=\"input-group col-lg-5 col-md-5 col-sm-5\">\n                            <div class=\"input-group-addon addon-width\"><i class=\"fa fa-external-link\"></i></div>\n                            <input [(ngModel)]=\"url\" formControlName=\"url\" class=\"form-control\" type=\"text\">\n                        </div>\n                        <div class=\"input-group col-lg-2 col-md-2 col-sm-5\" style=\"max-width: 200px\">\n                          <div class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></div>\n                          <!--[mask]=\"'brDate'\" -->\n                          <input type=\"text\" class=\"form-control\" formControlName=\"date\">\n                        </div>\n                        <!-- <div class=\"input-group col-lg-3 col-md-4 col-sm-5\">\n                          <div class=\"input-group-addon\"><i class=\"fa fa-id-card-o\"></i></div>\n                          <input type=\"text\" class=\"form-control\" formControlName=\"_id\" readonly/>\n                        </div> -->\n                      </div>\n                    </div>\n      \n                    <div class=\"panel-heading\">Titre</div>\n                    <div class=\"panel-body\">\n                      <div formGroupName=\"title\">\n                        <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group input-group\">\n                          <div class=\"input-group-addon\">{{lg | uppercase}}</div>\n                          <input type=\"text\" class=\"form-control\" [formControlName]=\"lg\" />\n                        </div>\n                      </div>\n                    </div>\n\n                    <div class=\"panel-heading\">Résumé</div>\n                    <div class=\"panel-body\">\n                      <div formGroupName=\"summary\">\n                        <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group input-group\">\n                          <div class=\"input-group-addon\">{{lg | uppercase}}</div>\n                          <textarea rows=\"3\" type=\"text\" class=\"form-control\" [formControlName]=\"lg\"></textarea>\n                        </div>\n                      </div>\n                    </div>\n<!-- \n                    <div class=\"panel-heading\">Résumé</div>\n                    <div class=\"panel-body\">\n                      <div formGroupName=\"content\">\n                        <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n                          <small>{{lg | uppercase}}</small>\n                          <html-editor [initText]=\"content? content.summary[lg] : ''\" [elementId]=\"'editor-summary-'+lg\" (onEditorKeyup)=\"keyupEditorHandlerFunction(['summary',lg], $event)\"\n                            height=\"5\">\n                          </html-editor>\n                        </div>\n                      </div>\n                    </div> -->\n\n                    <div class=\"panel-heading\">Contenu</div>\n                    <div class=\"panel-body\">\n                      <div formGroupName=\"content\">\n                        <div *ngFor=\"let lg of config.data?.APP.LANGUAGES.SUPPORTED\" class=\"form-group\">\n                          <small>{{lg | uppercase}}</small>\n                          <html-editor [initText]=\"content? content.content[lg] : ''\" [elementId]=\"'editor-content-'+lg\" (onEditorKeyup)=\"keyupEditorHandlerFunction(['content',lg], $event)\"\n                            height=\"50\">\n                          </html-editor>\n                        </div>\n                      </div>\n                    </div>\n      \n                    <div class=\"panel-heading\">Tags</div>\n                    <div class=\"panel-body\" formArrayName=\"tags\">\n                      <div class=\"form-inline\">\n                        <div *ngFor=\"let item of writingForm.controls.tags.controls; let i = index\" class=\"input-group col-lg-3 col-md-4 col-sm-5\" style=\"padding: 0px 3px 3px 0px; max-width: 200px\">\n                          <input type=\"text\" class=\"form-control\" formControlName=\"{{i}}\">\n                          <div class=\"input-group-addon\"><a (click)=\"onRemoveTag(i)\" class=\"glyphicon glyphicon-remove clickLink\"></a></div>\n                        </div>\n                        <a (click)=\"onAddTag()\" class=\"glyphicon glyphicon-plus clickLink\"> </a>\n                      </div>\n                    </div>\n      \n                    <button type=\"submit\" [disabled]=\"!writingForm.valid\" class=\"btn btn-info pull-right\">\n              Sauvegarder\n            </button>\n      \n                  </div>\n      \n                </form>\n      \n      \n              </div>\n              <!-- /.box-body -->\n            </div>\n          </div>\n        </div>\n      </section>"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "<section class=\"content-header\">\n  <h1>Ecrits\n    <a (click)=\"this.utils.lLink('admin/writing/edit/0',currentLanguage)\" class=\"lLink\">\n      <div class=\"btn btn-default btn-sm\">Nouveau</div>\n    </a>\n  </h1>\n</section>\n\n<section class=\"content\">\n  <div class=\"row\">\n  <div class=\"col-xs-12\">\n  <div class=\"box\">\n    <div class=\"box-body\">\n\n      <table class=\"table table-striped table-hover\">\n        <thead>\n          <tr>\n            <th>Statut</th>\n            <th>Auteur</th>\n            <th>Titre <small class=\"table-language\">{{currentLanguage}}</small></th>\n            <th>Date</th>\n            <th>Modifié</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let writing of contents\">\n            <td>\n                <div class=\"switch material-switch\">\n                  <input (click)=\"onStatusChange(!writing.active,writing)\" [(ngModel)]=\"writing.active\" id=\"{{writing._id}}\" name=\"{{writing._id}}\" type=\"checkbox\"/>\n                  <label attr.for=\"{{writing._id}}\" class=\"label-primary\"></label>\n                </div>\n            </td>\n            <td>{{writing.author}}</td>\n            <td (click)=\"router.navigate(['writing/edit/'+writing._id], {relativeTo: route.parent})\" class=\"pointer\">{{writing.title ? writing.title[currentLanguage] : '-'}}</td>\n            <td>{{writing.date | date:'MMM yyyy'}}</td>\n            <td>{{writing.update_date | date:'MMM dd yyyy'}}</td>\n          </tr>\n        </tbody>\n      </table>\n\n\n    </div><!-- /.box-body -->\n  </div>\n  </div>\n  </div>\n</section>"

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = "\n          <div *ngFor=\"let uploader of uploaders\" [ngStyle]=\"{'width': thumbSize+20}\" class=\"uploader col-md-5\">\n\n            <input class=\"hidden\" #fileSelect ng2FileSelect [uploader]=\"uploader\" (change)=\"onChangeImageHandler(uploader.options.itemAlias, $event)\" type=\"file\" />\n\n            <!-- existing or default image -->\n            <img *ngIf=\"uploader.queue.length==0\"\n                title=\"{{uploader.options.itemAlias}}\"\n                (click)=\"fileSelect.click()\" \n                [src]=\"form.controls[groupName].controls[uploader.options.itemAlias].value ? imagePath+form.controls[groupName].controls[uploader.options.itemAlias].value : imagePath+defaultImage\"\n                class=\"clickLink\" style=\"margin-top: 10px\" width=\"{{thumbSize}}\" />\n\n            <div *ngFor=\"let item of uploader.queue\" style=\"margin-top: 10px\">\n\n              <img (click)=\"fileSelect.click()\" *ngIf=\"tempData[uploader.options.itemAlias]\" [src]=\"tempData[uploader.options.itemAlias]\" class=\"clickLink\" height=\"{{thumbSize}}\" />\n\n              <div style=\"width: 100%; margin-top: 5px\">\n                <div class=\"progress progress-cover\" [ngStyle]=\"{'width': thumbSize-100}\">\n                  <div class=\"progress-bar\" role=\"progressbar\" [ngStyle]=\"{ 'width': item.progress + '%' }\">\n                    <span style=\"padding: 0px 3px\">{{item.progress}}%</span>\n                  </div>\n                </div>\n                <div>\n                  <button (click)=\"onRemoveImage(item)\" type=\"button\" class=\"upload-tool btn btn-danger btn-xs\"> <!-- (click)=\"removeCover(item)\"-->\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                  <button (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\" type=\"button\" class=\"upload-tool btn btn-warning btn-xs\">\n                    <span class=\"glyphicon glyphicon-ban-circle\"></span>\n                  </button>\t\t\t\t                \n                  <button (click)=\"item.upload()\" [disabled]=\"item.isReady || item.isUploading || item.isSuccess\" type=\"button\" class=\"upload-tool btn btn-success btn-xs\">\n                    <span class=\"glyphicon glyphicon-upload\"></span>\n                  </button> \n                </div>\n              </div>\n\n            </div> <!-- end repeat queue -->\n            \n          </div>\n\n"

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngFor=\"let field of fields\" class=\"box box-default\">\n    <div class=\"box-header with-border\">\n        <h3 class=\"box-title\">{{field}}</h3>\n        <div class=\"box-tools pull-right\">\n            <button type=\"button\" class=\"btn btn-box-tool\" data-widget=\"collapse\"><i class=\"fa fa-minus\"></i></button>\n        </div>\n    </div>\n    <!-- /.box-header -->\n    <div class=\"box-body\" style=\"padding-left: 20px\">\n        <div class=\"row\">\n            <ul class=\"list-unstyled\">\n                <li *ngFor=\"let term of esAggregations[field].buckets\">\n                    <span *ngIf=\"!utils.isInFilters(esFilters, field, term.key)\">\n                        <a (click)=\"onSelect(field, term.key)\" style=\"cursor: pointer\">\n                            {{ term.key | truncate:'20' }}\n                        </a> \n                        <small>({{term.doc_count}})</small>\n                    </span>\n                    <span *ngIf=\"utils.isInFilters(esFilters, field, term.key)\">\n                        {{term.key}} <small>({{term.doc_count}})</small>\n                    </span>\n                </li>\n            </ul>\n        </div>\n        <!-- /.row -->\n    </div>\n    <!-- /.footer -->\n</div>\n<!-- /.box -->"

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "  <div *ngIf=\"dbContents\" class=\"row row-eq-height\">\n    <div *ngFor=\"let content of dbContents\" class=\"col-sm-6 col-md-4 col-lg-3\">\n        <!-- need to test if content is null for some reason  -->\n        <div *ngIf=\"content\">\n          <img src=\"/data/covers/thumbs/{{content.cover.front}}\" class=\"fa fa-edit img-responsive\" alt=\"{{content.cover.front}}\">\n          <span class=\"image-tag switch material-switch\">\n              <input (click)=\"onStatusChange(!content.active,content)\" [(ngModel)]=\"content.active\" id=\"{{content._id}}\" name=\"{{content._id}}\" type=\"checkbox\"/>\n              <label attr.for=\"{{content._id}}\" class=\"label-primary\"></label>\n          </span>\n        </div>\n        <div *ngIf=\"content\" class=\"lLink thumb-title\">\n          <a (click)=\"router.navigate(['record/edit/'+content._id], {relativeTo: route.parent})\">{{ content.title | truncate:'80' }}</a>\n        </div>\n        <!--{{content._id}}-->\n    </div>\n  </div>\n  <div *ngIf=\"dbContents\" style=\"text-align: center\">\n    <ng-pagination [totalItems]=\"esContents.total\"\n                    [currentPage]=\"currentPage\"\n                    [pageSize]=\"pageSize\"\n                    (pageChange)=\"onPageChange($event)\"\n                    previous-text=\"&lsaquo;\"\n                    next-text=\"&rsaquo;\"\n                    first-text=\"First\"\n                    last-text=\"Last\" style=\"cursor: pointer\">\n    </ng-pagination>\n  </div>"

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "<div id=\"snackbar\"></div>\n<div class=\"top-cart\">\n    <!-- nav shopping bag -->\n    <a href=\"#\" [ngClass]=\"{'cart-empty' : cartService.count()==0}\" class=\"shopping-cart\"> \n        <i (click)=\"utils.lLink('cart',language)\" class=\"pointer fa fa-shopping-cart\"></i>\n        <div class=\"subtitle\">({{cartService.count()}})</div>\n    </a>\n    <!-- end nav shopping bag -->\n    <!-- shopping bag content -->\n    <div class=\"cart-content\">\n        <ul class=\"cart-list\">\n            <li *ngFor=\"let item of cartService.itemsLimited()\">\n                <a title=\"Remove item\" class=\"remove pointer\" (click)=\"removeFromCart(item.content._id)\">×</a>\n                <a (click)=\"utils.lLink(item.content.url,language)\" class=\"pointer\">\n                    <img width=\"90\" height=\"90\" alt=\"\" src=\"/data/covers/thumbs/{{item.content.cover.front}}\">\n                    <!--{{item.content._id}}-->\n                </a>\n                <span  class=\"quantity\">{{item.qty}} × <span class=\"amount\">{{item.content.price | numberFormat:2}}€</span></span>\n                <!--<a [routerLink]=\"[item.content.url]\" class=\"pointer\">Modifier</a>-->\n            </li>\n        </ul>\n        <p *ngIf=\"cartService.count()>cartService.limit\" class=\"text-center\">\n            <a (click)=\"utils.lLink('cart',language)\" class=\"pointer gray-text\">{{intl.data?.CART.SHOW_ALL | intl:language}} ({{cartService.count()}})</a>\n        </p>\n        <p *ngIf=\"cartService.count()>0\" class=\"total\">{{intl.data?.CART.PROPERTY.SUBTOTAL | intl:language}}: <span class=\"amount\">\n        {{cartService.subtotal() | numberFormat:2}}€</span></p>\n        <p *ngIf=\"cartService.count()==0\" class=\"total\">{{intl.data?.CART.EMPTY | intl:language}}</p>\n        <p *ngIf=\"cartService.count()>0\" class=\"buttons text-center\"> \n            <a (click)=\"utils.lLink('cart',language)\" class=\"pointer btn btn-very-small-white no-margin-bottom margin-seven no-margin-lr\">\n                    {{intl.data?.CART.GO | intl:language}}</a>\n            <!--<a href=\"xxx\" class=\"btn btn-very-small-white no-margin-bottom margin-seven no-margin-right pull-right\">Commander</a>-->\n        </p>\n    </div>\n    <!-- end shopping bag content -->\n</div>"

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n</section>\n\n<!-- head section -->\n<section class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-8 col-sm-12\">\n                <!-- page title -->\n                <h1 *ngIf=\"!cartService.paymentData?.paymentID\" class=\"black-text\">{{intl.data?.CART.TITLE | intl:currentLanguage}}</h1>\n                <h1 *ngIf=\"cartService.paymentData?.paymentID\" class=\"black-text\">{{intl.data?.CART.ORDER.TITLE | intl:currentLanguage}}</h1>\n                <!-- end page title -->\n            </div>\n        </div>\n    </div>\n</section>\n\n<!-- content section -->\n<section class=\"content-section section-pull-up-less\">\n    <div class=\"container\">\n\n        <!-- Payment received -->\n        <div *ngIf=\"cartService.paymentData?.paymentID\" class=\"row\">\n            <div class=\"col-md-6 col-sm-6 xs-margin-bottom-five\"> \n                <p class=\"text-med\">{{intl.data?.CART.ORDER.MESSAGE | intl:currentLanguage}}</p>\n                <p class=\"text-med\">{{intl.data?.CART.ORDER.QUESTION | intl:currentLanguage}} <a href=\"mailto:order@forgottenrecords.com\">order@forgottenrecords.com</a></p>\n            </div>\n            <div class=\"col-md-6 col-sm-6\">\n                <p class=\"text-large font-weight-600 text-black margin-three no-margin-top\">&nbsp;</p>\n                <p class=\"text-med no-margin\">{{intl.data?.CART.ORDER.PAYMENT_ID | intl:currentLanguage}}: \n                    <code><a target=\"_blank\" href=\"{{cartService.paymentData.returnUrl}}\">{{cartService.paymentData.paymentID}}</a></code>\n                </p>\n            </div>\n        </div>\n        <div *ngIf=\"cartService.paymentData?.paymentID\" class=\"row\">\n            <div class=\"learn-more row col-md-12 col-sm-12 center-col text-center\">\n                <a (click)=\"router.navigate(['catalogue'], {relativeTo: route.parent})\" class=\"pointer highlight-button btn btn-medium button xs-margin-bottom-five\">Revenir au catalogue</a>\n            </div>\n        </div>\n\n        <!-- Cart to be processed -->\n        <div *ngIf=\"!cartService.paymentData?.paymentID\" class=\"row\">\n            <div *ngIf=\"cartService.count()>0\" class=\"col-sm-12 shop-cart-table\">\n                <table class=\"table shop-cart text-center\">\n                    <thead>\n                        <tr>\n                            <th class=\"first\"></th>\n                            <th class=\"text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text\"></th>\n                            <th class=\"text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text\">\n                                {{intl.data?.CART.PROPERTY.PRICE | intl:currentLanguage}}</th>\n                            <th class=\"text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text\">\n                                {{intl.data?.CART.PROPERTY.QUANTITY | intl:currentLanguage}}</th>\n                            <th class=\"text-left text-uppercase font-weight-600 letter-spacing-2 text-small black-text\">\n                                {{intl.data?.CART.PROPERTY.SUBTOTAL | intl:currentLanguage}}</th>\n                            <th></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr *ngFor=\"let item of cartService.items\">\n                            <td class=\"product-thumbnail text-left\">\n                                <a (click)=\"router.navigate([item.content.url], {relativeTo: route.parent})\" class=\"pointer\">\n                                    <img src=\"/data/covers/{{item.content.cover.front}}\" alt=\"\" >\n                                </a>\n                            </td>\n                            <td class=\"text-left\">\n                                <a (click)=\"router.navigate([item.content.url], {relativeTo: route.parent})\" class=\"pointer\">{{item.content.title}}</a>\n                                <span class=\"text-uppercase display-block text-small margin-two\">Ref: {{item.content.reference}}</span>\n                                <!--<a [routerLink]=\"[item.content.url]\" class=\"text-small\"><i class=\"fa fa-edit black-text\"></i> Modifier</a>-->\n                            </td>\n                            <td class=\"text-left\">\n                                {{item.content.price | numberFormat:2}}€\n                            </td>\n                            <td class=\"product-quantity\">\n                                <div class=\"select-style med-input shop-shorting shop-shorting-cart no-border-round\">\n                                    <select [(ngModel)]=\"item.qty\" (change)=\"cartService.update(item.content, $event.target.value)\">\n                                        <option *ngFor=\"let j of [1,2,3,4,5,6,7,8,9,10]\" [value]=\"j\">{{j}}</option>\n                                    </select>\n                                </div>\n                            </td>\n                            <td class=\"product-subtotal text-left\">\n                                {{item.qty * item.content.price  | numberFormat:2}}€</td>\n                            <td class=\"product-remove text-center\">\n                                <a (click)=\"cartService.remove(item.content._id)\" class=\"pointer\"><i class=\"fa fa-times\"></i></a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div *ngIf=\"cartService.count()==0\" class=\"col-sm-12 shop-cart-table\">\n                <p>{{intl.data?.CART.EMPTY | intl:currentLanguage}}</p>\n            </div>\n            <div class=\"col-sm-12 cupon padding-five border-top border-bottom\">\n                <button *ngIf=\"cartService.count()>0\" (click)=\"cartService.clear()\" class=\"highlight-button btn btn-very-small no-margin pull-left\">\n                    {{intl.data?.CART.DO_EMPTY | intl:currentLanguage}}</button>\n                <button (click)=\"router.navigate(['catalogue'], {relativeTo: route.parent})\" class=\"highlight-button btn btn-very-small no-margin pull-right continue-shopping\">\n                    {{intl.data?.CART.BACK | intl:currentLanguage}}</button>\n                <!--<button class=\"highlight-button btn btn-very-small no-margin pull-right\">Update Shopping Cart</button>-->\n            </div>\n            <div *ngIf=\"cartService.count()>0\" class=\"col-sm-12 padding-five no-padding-bottom\">\n\n                <!-- col-md-6 col-sm-7 col-md-offset-1 -->\n                <div class=\"col-md-11 no-padding-right xs-no-padding\">\n                    <table class=\"table cart-total\">\n                        <tbody>\n                            <tr>\n                                <th class=\"padding-two text-right no-padding-right text-uppercase font-weight-600 letter-spacing-2 text-small xs-no-padding\">\n                                    {{intl.data?.CART.PROPERTY.SUBTOTAL | intl:currentLanguage}}</th>\n                                <td class=\"padding-two text-uppercase text-right no-padding-right font-weight-600 black-text xs-no-padding\">\n                                    {{cartService.subtotal() | numberFormat:2}} €</td>\n                            </tr>\n                            <tr>\n                                <th class=\"padding-two text-right no-padding-right text-small xs-no-padding\">\n                                    <span class=\"text-uppercase font-weight-600 letter-spacing-2\">\n                                        {{intl.data?.CART.PROPERTY.SHIPPING.TITLE | intl:currentLanguage}}</span><br>\n                                    <p class=\"font-weight-100\">\n                                        {{intl.data?.CART.PROPERTY.SHIPPING.ONE | intl:currentLanguage}}: 9.70 €<br>\n                                        {{intl.data?.CART.PROPERTY.SHIPPING.OTHERS | intl:currentLanguage}}: 3.00 €</p>\n                                </th>\n                                <td class=\"padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-small xs-no-padding\">\n                                    {{cartService.shipping() | numberFormat:2}} €</td>\n                            </tr>\n                            <tr>\n                                <td class=\"padding-one no-padding-right xs-no-padding\" colspan=\"2\">\n                                    <hr>\n                                </td>\n                            </tr>\n                            <tr class=\"total\">\n                                <th class=\"padding-two text-uppercase text-right no-padding-right font-weight-600 text-large xs-no-padding\">\n                                    {{intl.data?.CART.PROPERTY.TOTAL | intl:currentLanguage}}</th>\n                                <td class=\"padding-two text-uppercase text-right no-padding-right font-weight-600 black-text text-large no-letter-spacing xs-no-padding\">\n                                    {{cartService.total() | numberFormat:2}} €</td>\n                            </tr>\n                            <tr>\n                                <td class=\"padding-one no-padding-right xs-no-padding\" colspan=\"2\">\n                                    <hr class=\"no-margin-bottom\">\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <!--<a class=\"highlight-button-black-background btn no-margin pull-right checkout-btn\" href=\"#\">Procéder au règlement</a>-->\n\n                </div>\n\n                <div *ngIf=\"awayMessage && awayMessage.active\" class=\"text-center col-md-12 block message-away\">\n                    <div class=\"message-away-title\">{{awayMessage.title[currentLanguage]}}:</div> \n                    <div class=\"message-away-content\" [innerHTML]=\"awayMessage.content[currentLanguage]\"></div>\n                </div>\n\n                <payment-paypal-express-checkout [language]=\"currentLanguage\"></payment-paypal-express-checkout>\n                <!-- Braintree\n                <div class=\"text-center col-md-6 col-md-offset-3\">\n                    <div id=\"dropin-container\"></div>\n                    <button id=\"submit-button\">Valider la commande</button>\n                </div>-->\n            </div>\n        </div>\n\n    </div>\n\n</section>\n<!-- end content section -->"

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n</section>\n\n<!-- head section -->\n<section *ngIf=\"content&&currentLanguage\" class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-4 col-sm-12\">\n                <!-- page title -->\n                <h1 class=\"black-text\">{{content.title[currentLanguage]}}</h1>\n                <!-- end page title -->\n            </div>\n            <!-- Only for about page -->\n            <div *ngIf=\"content.url=='about'\" class=\"col-md-8 col-sm-12 breadcrumb text-uppercase\">\n                    <!-- breadcrumb -->\n                    <ul class=\"breadcrumb-sub\">\n                        <li><a class=\"breadcrumb-active\">\n                            {{intl.data?.COMMON.MENU.ABOUT.PRESENTATION | intl:currentLanguage}}</a></li>\n                        <li><a (click)=\"utils.scrollToClass('press',-100)\" class=\"pointer\">\n                            {{intl.data?.COMMON.MENU.ABOUT.PRESS | intl:currentLanguage}}</a></li>\n                        <li><a (click)=\"utils.scrollToClass('partners',0)\" class=\"pointer\">\n                            {{intl.data?.COMMON.MENU.ABOUT.PARTNERS | intl:currentLanguage}}</a></li>\n                            <li><a (click)=\"utils.scrollToClass('contact',0)\" class=\"pointer\">\n                            {{intl.data?.COMMON.MENU.ABOUT.CONTACT | intl:currentLanguage}}</a></li>\n                    </ul>\n\n                </div>\n        </div>\n    </div>\n</section>\n\n<!-- loader -->\n<section *ngIf=\"loading\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <loading-indicator color=\"#B6B6B6\"></loading-indicator>  \n        </div>\n    </div>\n</section>\n\n<!-- content -->\n<div class=\"page-content\" *ngIf=\"content&&currentLanguage\" [innerHTML]=\"content.content[currentLanguage]\">\n</div>"

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n    <div id=\"snackbar\"></div>\n</section>\n\n<!--<section *ngIf=\"content&&currentLanguage\" class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-10 col-sm-12\">\n                <h1 class=\"black-text\">{{highlights.list[0]}} / {{highlights.list[1]}}</h1>\n            </div>\n        </div>\n    </div>\n</section>-->\n\n<!-- content section -->\n<section class=\"section-record\">\n    <div class=\"container\" [ngSwitch]=\"loading\">\n        <div class=\"row btn-back\">\n            <button (click)=\"location.back()\" class=\"highlight-button btn btn-very-small no-margin continue-shopping-custom\">\n            {{ intl.data?.COMMON.BACK | intl:currentLanguage }}</button>\n        </div>\n\n        <!-- loader -->\n        <loading-indicator color=\"#B6B6B6\" *ngSwitchCase=\"true\"></loading-indicator>\n        \n        <!-- allow content once retrieved -->\n        <div *ngIf=\"content&&currentLanguage\" class=\"row\"> \n            <!-- product images -->\n            <div class=\"col-md-6 col-sm-12 record-zoom-gallery product-image sm-margin-bottom-ten\">\n                <a href=\"/data/covers/{{content.cover.front}}\"><img src=\"/data/covers/{{content.cover.front}}\" class=\"project-img-gallery\" alt=\"\"/></a>\n                <div class=\"\">\n                    <a href=\"/data/covers/{{content.cover.back}}\"><img src=\"/data/covers/{{content.cover.back}}\" class=\"project-img-gallery\" alt=\"\"/></a>\n                </div> \n            </div>\n            \n            <!-- end product images -->\n            <div class=\"col-md-5 col-sm-12 col-md-offset-1\">\n                <!-- product rating -->\n\n                <div class=\"rating margin-five\">\n                    <span class=\"record-date rating-text text-uppercase\">Ref: <span class=\"black-text\">{{content.reference}}</span></span>\n                    <span class=\"rating-text text-uppercase pull-right\">{{content.date | replace: 'T.+':''}}</span>\n                </div>\n                <!-- end product rating -->\n                <!-- product name -->\n                <!--<span class=\"product-name-details text-uppercase font-weight-600 letter-spacing-2 black-text\">&lt;Highlight level 1&gt;</span>-->\n                <!-- end product name -->\n                <!-- product stock -->\n                <!--<p class=\"text-uppercase letter-spacing-2 margin-two\">&lt;Highlight level 2&gt;</p>-->\n                <!-- end product stock -->\n                <div class=\"separator-line bg-black no-margin-lr margin-five\"></div>\n                <!-- product short description -->\n                <p class=\"text-uppercase letter-spacing-2\">{{content.title}}</p>\n                <!-- end product short description -->\n                <span class=\"price black-text title-small\">{{content.price | numberFormat:2}}€</span>\n\n                <div class=\"col-md-3 col-sm-3 no-padding-left margin-five\">\n                    <div class=\"select-style med-input xs-med-input shop-shorting-details no-border-round\">\n                        <!-- product qty -->\n                        <select [(ngModel)]=\"qty\">\n                            <option *ngFor=\"let j of [1,2,3,4,5,6,7,8,9,10]\" [value]=\"j\">{{j}}</option>\n                        </select>\n                        <!-- end product qty -->\n                    </div>\n                </div>\n                <div class=\"col-md-9 col-sm-9 no-padding margin-five\">\n                    <!-- add to bag button -->\n                    <a *ngIf=\"!cartService.isInCart(content._id)\"\n                        (click)=\"addToCart(content, qty)\" class=\"highlight-button-dark btn btn-medium button pointer\"><i class=\"icon-basket\"></i> \n                        {{ intl.data?.CART.ADD | intl:currentLanguage }}</a>\n                    <a *ngIf=\"cartService.isInCart(content._id)\" \n                        (click)=\"removeFromCart(content._id)\" class=\"btn btn-medium button pointer\"><i class=\"fa fa-remove\"></i> \n                        {{ intl.data?.CART.REMOVE | intl:currentLanguage }}</a>\n                    <!-- end add to bag button -->\n                </div>\n                <!--<div class=\"col-lg-4 col-md-5 col-sm-3 no-padding-left\">\n                    <a title=\"Add to Wishlist\" href=\"#\" class=\"text-uppercase text-small vertical-align-middle\"><i class=\"fa fa-heart-o black-text\"></i> Add to wishlist</a>\n                </div>\n                <div class=\"col-md-8 col-sm-9 product-details-social no-padding\">\n                    <span class=\"black-text text-uppercase text-small vertical-align-middle margin-right-five\">Share on</span>\n                    <a href=\"https://www.facebook.com/\" target=\"_blank\"><i class=\"fa fa-facebook\"></i></a>\n                    <a href=\"https://twitter.com/\" target=\"_blank\"><i class=\"fa fa-twitter\"></i></a>\n                    <a href=\"https://plus.google.com\" target=\"_blank\"><i class=\"fa fa-google-plus\"></i></a>\n                    <a href=\"https://www.linkedin.com/\" target=\"_blank\"><i class=\"fa fa-linkedin\"></i></a>\n                </div>-->\n\n            <div class=\"col-md-12 col-sm-12 no-padding-left margin-five\">\n                <!-- tab -->\n                <div class=\"tab-style1\">\n                    <!-- <div *ngIf=\"content.description[currentLanguage]\" class=\"col-md-12 col-sm-12 no-padding\">\n                        <ul class=\"nav nav-tabs nav-tabs-light text-left\">\n                            <li class=\"active\"><a href=\"#tab_details\" data-toggle=\"tab\">\n                                {{ intl.data?.RECORD.DETAILS | intl:currentLanguage }}</a></li>\n                            <li><a href=\"#tab_description\" data-toggle=\"tab\">\n                                {{ intl.data?.RECORD.DESCRIPTION | intl:currentLanguage }}</a></li>\n                        </ul>\n                    </div> -->\n                    <!-- tab content section -->\n                    <div class=\"tab-content\">\n                        <!-- tab content -->\n                        <div class=\"tab-pane fade in active\" id=\"tab_details\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12 col-sm-12 review-main\">\n                                    <div *ngFor=\"let mp of content.music_pieces\" class=\"review\">\n                                        <p class=\"letter-spacing-2 text-uppercase review-name\">\n                                            <strong>{{mp.composer}}, {{mp.title}}</strong></p>\n                                        <span *ngFor=\"let s of mp.soloists; let i=index\">\n                                            <a (click)=\"utils.lLink('catalogue?f=soloist~'+s.name,currentLanguage)\" class=\"reclink pointer\">{{s.name | nameResolver}}</a> <span *ngIf=\"s.instrument\">({{s.instrument}})</span>\n                                            <span *ngIf=\"i<mp.soloists.length-1\">, </span>\n                                        </span>\n                                        <div *ngIf=\"mp.conductor && mp.orchestra\">\n                                            <a (click)=\"utils.lLink('catalogue?f=conductor~'+mp.conductor,currentLanguage)\" class=\"reclink pointer\">{{mp.conductor | nameResolver}}</a> / {{mp.orchestra}}\n                                        </div>\n                                        <div *ngIf=\"mp.date\" class=\"black-text letter-spacing-2\">\n                                        <small>{{ intl.data?.RECORD.RECORDING | intl:currentLanguage }}: {{mp.date | toYear}}</small></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <!-- end tab content -->\n                        <!-- tab content -->\n                        <!-- <div *ngIf=\"content.description[currentLanguage]\" class=\"tab-pane fade in\" id=\"tab_description\">\n                            <div class=\"row\">\n                                <div [innerHTML]=\"content.description[currentLanguage]\" class=\"col-md-12 sm-margin-top-seven\"></div>\n                            </div>\n                        </div> -->\n                        <!-- end tab content -->\n                    </div>\n                    <!-- end tab content section -->\n                </div>\n                <!-- end tab -->\n            </div>  \n            \n            <div *ngIf=\"content.description[currentLanguage]\" class=\"record-description col-md-12\">\n                    <div class=\"row\">\n                        <!-- format if no html tags found (legacy content) -->\n                        <div [innerHTML]=\"utils.formatInHtml(content.description[currentLanguage], 'p')\" class=\"col-md-12 sm-margin-top-seven\"></div>\n                    </div>\n            </div>\n  \n            <div class=\"record-original-references\" *ngIf=\"content.original_references && content.original_references.length>0 && content.original_references[0]!=''\">\n                <small><b>{{ intl.data?.RECORD.ORIGINAL_REFERENCES | intl:currentLanguage }}</b>: {{content.original_references | join:', '}}</small>\n            </div>\n            <small><b>{{ intl.data?.RECORD.LENGTH | intl:currentLanguage }}</b>: {{content.length}}</small>\n            \n            </div>\n\n\n\n        </div>\n    </div>\n</section>\n\n<section *ngIf=\"mltContents.length>0\"class=\"border-top section-pull-up-less\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-12 text-center\">\n                <h3 class=\"section-title\">{{ intl.data?.RECORD.RECOMMENDATION | intl:currentLanguage }}</h3>\n            </div>\n        </div> \n        <div class=\"row record-listing-featured record-listing\">\n          <div *ngFor=\"let content of mltContents\" class=\"col-md-3 col-xs-6 record-item\">\n                <div class=\"\">\n                  <a (click)=\"router.navigate([content.url], {relativeTo: route.parent})\" class=\"pointer\">\n                    <img src=\"/data/covers/{{content.cover.front}}\" alt=\"\"/>\n                    <!--<span class=\"image-tag\">featured</span>-->\n                  </a>\n                </div>\n                <div class=\"record-desc\">\n                  <div class=\"catalogue-record-title gray-text text-uppercase letter-spacing-2\">{{content.title | truncate:'75'}}</div>\n                </div>\n          </div>\n        </div>\n        <!--<div class=\"row\">\n            <div id=\"shop-products\" class=\"owl-carousel owl-theme dark-pagination owl-no-pagination owl-prev-next-simple\">\n                <div *ngFor=\"let simRec of mltContents\" class=\"item\">\n                    <div class=\"home-product text-center position-relative overflow-hidden\">\n                        <a (click)=\"router.navigate([simRec.url], {relativeTo: route.parent})\" class=\"pointer\">\n                            <img src=\"/data/covers/{{simRec.cover.front}}\" alt=\"\"/>\n                        </a>\n                        <span class=\"product-name text-uppercase\"><a href=\"shop-single-product.html\">Richard Nicoll</a></span>\n                        <span class=\"price black-text\">$680</span>\n                        <div class=\"quick-buy\">\n                            <div class=\"product-share\">\n                                <a href=\"#\" class=\"highlight-button-dark btn btn-small no-margin-right quick-buy-btn\" title=\"Add to Wishlist\"><i class=\"fa fa-heart-o\"></i></a>\n                                <a href=\"#\" class=\"highlight-button-dark btn btn-small no-margin-right quick-buy-btn\" title=\"Add to Compare\"><i class=\"fa fa-refresh\"></i></a>\n                                <a href=\"shop-cart.html\" class=\"highlight-button-dark btn btn-small no-margin-right quick-buy-btn\" title=\"Add to Cart\"><i class=\"fa fa-shopping-cart\"></i></a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>-->\n    </div>\n</section>\n<!-- end content section -->"

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n</section>\n\n<!-- head section -->\n<section class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"hidden-md hidden-sm hidden-xs col-md-2 col-sm-12\">\n                <h1 class=\"black-text\"><a (click)=\"utils.lLink('catalogue',currentLanguage)\" class=\"pointer\">\n                {{intl.data?.COMMON.MENU.CATALOGUE | intl:currentLanguage}}</a></h1>\n            </div>\n            <div class=\"col-md-10 col-sm-12 breadcrumb text-uppercase\">\n                <ul class=\"breadcrumb-sub\">\n                    <li><a [ngClass]=\"{'breadcrumb-active' : !entryType && !hasFilter}\" (click)=\"utils.lLink('catalogue',currentLanguage)\" class=\"pointer\">\n                      {{intl.data?.COMMON.MENU.CATALOGUE.ALL | intl:currentLanguage}}</a></li>\n                    <li><a [ngClass]=\"{'breadcrumb-active' : entryType=='reissue'}\" (click)=\"utils.lLink('catalogue/reissue',currentLanguage)\" class=\"pointer\">\n                      {{intl.data?.COMMON.MENU.CATALOGUE.REISSUE | intl:currentLanguage}}</a></li>\n                    <li><a [ngClass]=\"{'breadcrumb-active' : entryType=='production'}\" (click)=\"utils.lLink('catalogue/production',currentLanguage)\" class=\"pointer\">\n                      {{intl.data?.COMMON.MENU.CATALOGUE.PRODUCTION | intl:currentLanguage}}</a></li>\n                    <li><a [ngClass]=\"{'breadcrumb-active' : entryType=='special'}\" (click)=\"utils.lLink('catalogue/special',currentLanguage)\" class=\"pointer\">\n                      {{intl.data?.COMMON.MENU.CATALOGUE.SPECIAL | intl:currentLanguage}}</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</section>\n\n<!--<section class=\"page-platine page-title parallax3 parallax-fix page-title-large page-title-shop\">\n  <div class=\"opacity-light bg-dark-gray\"></div>\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-12 col-sm-12 wow fadeIn\">\n        <h1 class=\"white-text\">Catalogue</h1>\n      </div>\n      <div class=\"col-md-12 col-sm-12 breadcrumb text-uppercase margin-three no-margin-bottom wow fadeIn\">\n        <ul>\n          <li class=\"white-text\"><a class=\"white-text\" href=\"#\">Reissues</a></li>\n          <li class=\"white-text\"><a class=\"white-text\" href=\"#\">Production</a></li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</section>-->\n\n<section id=\"content-start\" class=\"page-pull-top\" searchable-contents [pageSize]=\"pageSize\" context=\"record\" [active]=\"true\" #sc=\"sc\">\n\n  <div [ngSwitch]=\"sc.loading\" class=\"container\">\n    <div class=\"row\">\n\n      <!-- loader -->\n      <loading-indicator color=\"#B6B6B6\" *ngSwitchCase=\"true\"></loading-indicator>\n\n      <!-- sidebar  -->\n      <div *ngIf=\"hasFilter\" class=\"col-md-3 col-sm-4 sidebar\">\n        <search\n          target=\"/catalogue\"\n          [order]=\"config.data?.CATALOGUE.SEARCH.SUGGESTIONS.ORDER\"\n          scrollOnClick=\"#content-start\"\n          placeholder=\"{{intl.data?.CATALOGUE.SEARCH | intl:currentLanguage}}\"\n          [language]=\"currentLanguage\"\n          [labels]=\"intl.data?.COMMON.TAXONOMY\">\n        </search>\n\n        <search-facets *ngSwitchCase=\"false\" class=\"hidden-xs\"\n          target=\"/catalogue\"\n          [esAggregations]=\"sc.esAggregations\" \n          [fields]=\"sc.aggFields.record\" \n          [language]=\"currentLanguage\"\n          [labels]=\"intl.data?.COMMON.TAXONOMY\"\n          [esFilters]=\"sc.esFilters\" \n          (onFilter)=\"sc.searchCallBack($event)\">\n        </search-facets>\n\n      </div>\n      <!-- end sidebar  -->\n\n      <!-- content -->\n      <div *ngSwitchCase=\"false\" [ngClass]=\"{'col-md-9 col-sm-8' : hasFilter, 'col-md-12' : !hasFilter}\" class=\"catalogue-content col-md-offset-1\">\n        <!-- search result head -->\n        <div class=\"shorting clearfix xs-no-margin col-xs-12\" [ngClass]=\"{'shorting-filter' : hasFilter, 'shorting-nofilter' : !hasFilter}\">\n          \n          <!-- search box when no filters -->\n          <search *ngIf=\"!hasFilter\" class=\"search-nofilter col-lg-3 col-md-4 col-sm-5 col-xs-12\"\n            target=\"/catalogue\"\n            [order]=\"config.data?.CATALOGUE.SEARCH.SUGGESTIONS.ORDER\"\n            scrollOnClick=\"#content-start\"\n            [placeholder]=\"intl.data?.CATALOGUE.SEARCH[currentLanguage]\"\n            [language]=\"currentLanguage\"\n            [labels]=\"intl.data?.COMMON.TAXONOMY\"\n            [expand]=\"true\">\n          </search>\n\n          <!-- search tools --> \n          <div [ngClass]=\"{'col-lg-9 col-md-8 col-sm-7' : !hasFilter}\" class=\"search-tools-container col-xs-12 grid-nav\">\n\n            <!-- search az --> \n            <search-az class=\"search-az\" [ngClass]=\"{'search-az-nofilter' : !hasFilter}\"\n              target=\"/catalogue\"\n              [title]=\"intl.data?.CATALOGUE.NEW_SEARCH[currentLanguage]\"\n              [labels]=\"intl.data?.COMMON.TAXONOMY\"\n              [language]=\"currentLanguage\">\n            </search-az>\n\n            <!--<a href=\"shop-with-sidebar-list.html\"><i class=\"fa fa-bars\"></i></a>-->\n            <!--<span><i class=\"fa fa-th\"></i></span>-->\n            <p *ngIf=\"entryType!='special'\" class=\"page-status text-uppercase pull-right xs-display-none\">\n              <span class=\"\">\n                {{pageSize<=sc.esContents['total'] ? pageSize : sc.esContents['total']}} / {{sc.esContents['total']}} | \n                Page {{currentPage}} / {{sc.esContents['total'] / pageSize  | number : '1.0-0'}}\n              </span>\n              <!--<span class=\"hidden-lg hidden-md\">\n                {{sc.esContents['total']}} disques\n              </span>-->\n            </p>\n\n            <br *ngIf=\"hasFilter\">\n\n            <!-- search filters -->\n            <search-filters *ngIf=\"hasFilter\" class=\"search-filters\" \n              [esQuery]=\"sc.esQuery\" \n              [esFilters]=\"sc.esFilters\"\n              [labels]=\"intl.data?.COMMON.TAXONOMY\"\n              [title]=\"intl.data?.CATALOGUE.FILTERS[currentLanguage]\"\n              [language]=\"currentLanguage\"\n              target=\"/catalogue\">\n            </search-filters>\n\n          </div>\n\n          <!--<div class=\"col-md-3 pull-right sm-display-none\">\n            <div class=\"select-style input-round med-input shop-shorting no-border\">\n              <select>\n                <option value=\"\">Sort by</option>\n                <option value=\"\">By relevance</option>\n              </select>\n            </div>\n          </div>-->\n\n        </div>\n\n        <!-- featured -->\n        <div *ngIf=\"config.data?.CATALOGUE.FEATURED && isFirstPage && !entryType && !hasFilter\" content-records-featured #featured=\"featured\" class=\"record-listing-featured record-listing\">\n          <div [ngClass]=\"{'col-md-3 col-xs-6' : !hasFilter}\"\n              *ngFor=\"let content of featured.dbContentsLimited(4)\" class=\"record-item\">\n                <div class=\"\">\n                  <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\">\n                    <img src=\"/data/covers/thumbs/{{content.cover.front}}\" alt=\"\"/>\n                    <span class=\"image-tag\">{{ intl.data?.CATALOGUE.FEATURED | intl:currentLanguage }}</span>\n                  </a>\n                </div>\n                <div class=\"record-desc\">\n                  <div class=\"catalogue-record-title gray-text text-uppercase letter-spacing-2\">\n                      <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\">\n                        {{content.title | truncate: config.data?.CATALOGUE.RECORD_TITLE_TRUNCATE}}</a></div>\n                </div>\n          </div>\n        </div>\n\n        <!-- search results -->\n        <div *ngIf=\"entryType!='special'\" class=\"record-listing\">\n          <div [ngClass]=\"{'col-md-4 col-sm-6 col-xs-5' : hasFilter, 'col-md-3 col-sm-4 col-xs-6' : !hasFilter}\"\n              *ngFor=\"let content of sc.dbContents\" class=\"record-item\">\n                <div>\n                  <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\">\n                    <!-- Server: no lazy load with the src att -->\n                    <!-- Client: lazy load with ng-lazyload-image -->\n                    <img src=\"/data/covers/thumbs/{{content.cover.front}}\" defaultImage=\"/data/covers/lazy/{{content.cover.front}}\" lazyLoad=\"/data/covers/thumbs/{{content.cover.front}}\" alt=\"\"/>\n\n                  </a>\n                </div>\n                <div class=\"record-desc\">\n                  <div class=\"catalogue-record-title gray-text text-uppercase letter-spacing-2\">\n                      <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\">\n                        {{content.title | truncate: config.data?.CATALOGUE.RECORD_TITLE_TRUNCATE}}</a></div>\n                </div>\n          </div>\n        </div>\n\n        <!-- specials -->\n        <div content-specials #specials=\"specials\" *ngIf=\"entryType=='special'\" class=\"record-listing\">\n            <div *ngFor=\"let content of specials.dbContents\" class=\"col-md-6 col-sm-6 xs-margin-bottom-ten\">\n                <div class=\"model-details clearfix xs-no-margin\">\n                    <div class=\"text-center col-md-6 no-padding\">\n                      <img src=\"{{content.image}}\" (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\" alt=\"\" />\n                    </div>\n                    <div class=\"col-md-6 no-padding\">\n                      <div class=\"special-text model-details-text\">\n                          <div class=\"separator-line bg-black no-margin-lr margin-ten\"></div>\n                          <span class=\"display-block clearfix xs-no-margin sm-display-none\"></span>\n                          <span class=\"text-uppercase font-weight-600 black-text letter-spacing-2\">{{content.title[currentLanguage]}}</span>\n                          <span class=\"text-uppercase text-small letter-spacing-2 margin-two display-block\">{{content.subtitle[currentLanguage]}}</span>\n                          <p class=\"margin-ten xs-no-margin\">{{content.content[currentLanguage] | truncate:config.data?.SPECIAL.TITLE_TRUNCATE}}</p>\n                          <span class=\"margin-five xs-no-margin display-block clearfix xs-no-margin\"></span>\n                          <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer\">\n                            {{intl.data?.COMMON.SEE_MORE | intl:currentLanguage}}</a>\n                      </div>\n                  </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- pagination -->\n        <div *ngSwitchCase=\"false\" class=\"pagination margin-two no-margin-bottom\">\n          <ng-pagination [totalItems]=\"sc.esContents['total']\"\n                        [currentPage]=\"currentPage\"\n                        [pageSize]=\"pageSize\"\n                        (pageChange)=\"onPageChange($event, 'catalogue')\" \n                        previous-text=\"<img src='/data/images/arrow-pre-small.png'/>\"\n                        next-text=\"<img src='/data/images/arrow-next-small.png'/>\"\n                        first-text=\"&laquo;\"\n                        last-text=\"&raquo;\" \n                        style=\"cursor: pointer\">\n          </ng-pagination>\n        </div>\n\n        <!-- pagination -->\n        <!--<div class=\"pagination margin-ten no-margin-bottom\">\n          <a href=\"#\"><img src=\"images/arrow-pre-small.png\" alt=\"\"/></a>\n          <a href=\"#\">1</a>\n          <a href=\"#\">2</a>\n          <a href=\"#\" class=\"active\">3</a>\n          <a href=\"#\">4</a>\n          <a href=\"#\">5</a>\n          <a href=\"#\"><img src=\"images/arrow-next-small.png\" alt=\"\"/></a>\n        </div>-->\n        <!-- end pagination -->\n      </div>\n    </div>\n  </div>\n</section>\n<!-- end content section -->"

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n</section>\n\n<!-- head section -->\n<section class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-4 col-md-5 col-sm-12\">\n                <h1 class=\"black-text\">\n                {{intl.data?.COMMON.MENU.WRITINGS.LONG | intl:currentLanguage}}</h1>\n            </div>\n            <div class=\"col-lg-8 col-md-7 col-sm-12 breadcrumb text-uppercase\">\n                <ul>\n                    <li><a (click)=\"utils.lLink('writings',currentLanguage)\" class=\"pointer\">\n                    {{intl.data?.COMMON.MENU.WRITINGS.ALL | intl:currentLanguage}}</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</section>\n\n<!-- content section -->\n<section class=\"blog-single-full-width-text\">\n    <!-- loader -->\n    <div *ngIf=\"loading\" class=\"container\">\n        <div class=\"row\">\n            <loading-indicator color=\"#B6B6B6\"></loading-indicator>  \n        </div>\n    </div>\n    <div *ngIf=\"content&&currentLanguage\" class=\"container writing-content\">\n        <!-- heading -->\n        <div class=\"row writing-header col-md-10 col-sm-10 col-xs-11 text-center center-col\">\n            <h2>{{content.title[currentLanguage]}}</h2>\n            <h4><small>{{intl.data?.WRITING.AUTHOR_BY | intl:currentLanguage}}</small> {{content.author}}, <small>{{content.date | date:'yyyy'}}</small></h4>\n        </div>\n        <!-- content -->\n        <div *ngIf=\"content.content[currentLanguage]\" class=\"row col-md-10 col-sm-10 col-xs-11 center-col\" [innerHTML]=\"content.content[currentLanguage]\">\n        </div>\n        <div *ngIf=\"!content.content[currentLanguage]\">\n            <div class=\"writing-body\">\n                <div class=\"row col-md-10 col-sm-10 col-xs-11 center-col\" [innerHTML]=\"content.summary[currentLanguage]\">\n                </div>\n                <div class=\"writing-not-translated\">\n                    {{intl.data?.WRITING.NOT_TRANSLATED | intl:currentLanguage}}\n                </div>\n                <div class=\"writing-read-preferred row col-md-12 col-sm-12 center-col text-center\">\n                    <a (click)=\"utils.lLink(type+'/'+content.url, writingConfig.data?.APP.LANGUAGES.PREFERRED)\" class=\"pointer highlight-button btn btn-small button xs-margin-bottom-five\">\n                    {{intl.data?.WRITING.READ_IN_PREFERRED_LANGUAGE | intl:currentLanguage}}</a>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-title-pull-top page-title parallax3 parallax-fix\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n</section>\n\n<!-- head section -->\n<section *ngIf=\"currentLanguage\" class=\"page-title page-title-small bg-gray\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-5 col-xs-12\">\n                <h1 class=\"black-text\">\n                {{intl.data?.COMMON.MENU.WRITINGS.LONG | intl:currentLanguage}}</h1>\n            </div>\n            <div class=\"col-md-7 col-xs-12 breadcrumb text-uppercase\">\n                <ul class=\"breadcrumb-sub\">\n                    <li *ngIf=\"hasFilter\"><a class=\"pointer\" (click)=\"utils.lLink('writings',currentLanguage)\">\n                        {{intl.data?.COMMON.MENU.WRITINGS.ALL | intl:currentLanguage}}</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</section>\n\n<section id=\"content-start\" searchable-contents [pageSize]=\"pageSize\" [active]=\"true\" context=\"writing\" #sc=\"sc\">\n\n  <div [ngSwitch]=\"sc.loading\" class=\"container\">\n    <div class=\"row\">\n\n      <!-- loader -->\n      <loading-indicator color=\"#B6B6B6\" *ngSwitchCase=\"true\"></loading-indicator>\n\n      <!-- sidebar  -->\n      <div class=\"col-md-3 col-sm-4 sidebar writings-sidebar\">\n\n        <search-facets *ngSwitchCase=\"false\" class=\"hidden-xs\"\n          target=\"/writings\"\n          [esAggregations]=\"sc.esAggregations\" \n          [fields]=\"sc.aggFields.writing\"\n          [language]=\"currentLanguage\"\n          [labels]=\"intl.data?.COMMON.TAXONOMY\"\n          [esFilters]=\"sc.esFilters\" \n          (onFilter)=\"sc.searchCallBack($event)\">\n        </search-facets>\n\n      </div>\n      <!-- end sidebar  -->\n\n      <!-- content -->\n      <div *ngSwitchCase=\"false\" class=\"col-md-9 col-sm-8 catalogue-content writings-content col-md-offset-1\">\n        \n        <!-- search result head -->\n        <div class=\"shorting writings-shorting clearfix xs-no-margin col-xs-12\" [ngClass]=\"{'shorting-filter' : hasFilter, 'shorting-nofilter' : !hasFilter}\">\n\n          <!-- search tools --> \n          <div *ngIf=\"hasFilter\" class=\"col-xs-12 grid-nav\">\n\n            <!-- search filters -->\n            <search-filters class=\"search-filters\" \n              [labels]=\"intl.data?.COMMON.TAXONOMY\"\n              [title]=\"intl.data?.CATALOGUE.FILTERS[currentLanguage]\"\n              [language]=\"currentLanguage\"\n              [esQuery]=\"sc.esQuery\" \n              [esFilters]=\"sc.esFilters\">\n            </search-filters>\n\n          </div>\n\n        </div>\n        \n        <!-- content -->\n        <div *ngSwitchCase=\"false\">\n\n          <!-- items -->\n          <div *ngFor=\"let content of sc.dbContents\" class=\"col-md-12 writing-listing blog-listing blog-listing-classic\">\n\n            <div class=\"blog-details writing-details\">\n                <div class=\"blog-date\"><a (click)=\"utils.lLink('writings?f=author~'+content.author,currentLanguage)\" class=\"pointer\">\n                  {{content.author}}</a> | {{content.date | date:'yyyy'}} | \n                  <span *ngFor=\"let tag of content.tags; let i=index\" >\n                    <a (click)=\"utils.lLink('writings?f=tag~'+tag,currentLanguage)\" class=\"pointer\">\n                    {{intl.data?.COMMON.TAXONOMY.tag.VALUES[tag] ? intl.data?.COMMON.TAXONOMY.tag.VALUES[tag][currentLanguage] : tag}}</a><span *ngIf=\"i+1<content.tags.length\">, </span>\n                  </span>\n                </div>\n                <div class=\"blog-title\"><a (click)=\"utils.lLink('writing/'+content.url,currentLanguage)\" class=\"pointer\">\n                {{content.title[currentLanguage]}}</a></div>\n                <div class=\"writing-summary\">{{content.summary[currentLanguage]}}</div>\n                <div class=\"separator-line bg-black no-margin-lr margin-two\"></div>\n                <a (click)=\"utils.lLink('writing/'+content.url,currentLanguage)\" class=\"writing-read-more pointer highlight-button btn btn-small xs-no-margin-bottom\">\n                {{intl.data?.WRITING.FULL_TEXT_GO | intl:currentLanguage}}</a>\n            </div>\n            \n          </div>\n\n            <!-- pagination -->\n          <div *ngSwitchCase=\"false\" class=\"pagination margin-two no-margin-bottom\">\n                <ng-pagination [totalItems]=\"sc.esContents['total']\"\n                              [currentPage]=\"currentPage\"\n                              [pageSize]=\"pageSize\"\n                              (pageChange)=\"onPageChange($event, 'writings')\" \n                              previous-text=\"<img src='/data/images/arrow-pre-small.png'/>\"\n                              next-text=\"<img src='/data/images/arrow-next-small.png'/>\"\n                              first-text=\"&laquo;\"\n                              last-text=\"&raquo;\" \n                              style=\"cursor: pointer\">\n                </ng-pagination>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n<!-- end content section -->"

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"!hasConsented\" id=\"cookie-consent\" class=\"cookie-consent pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main\">\n    <h4>\n        {{intl.data?.COMMON.COOKIE_CONSENT | intl:language}}\n        <small><a href=\"{{ language=='en' ? 'http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm' : 'https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs' }}\" target=\"_blank\">{{intl.data?.COMMON.LEARN_MORE | intl:language}}</a></small>\n    </h4>\n    <div>\n        <a (click)=\"onConsent(false)\" class=\"pointer btn button\">\n            <small>{{intl.data?.COMMON.COOKIE_CONSENT_DISMISS | intl:language}}</small>\n        </a> \n        <a (click)=\"onConsent(true)\" class=\"pointer highlight-button btn\">\n            {{intl.data?.COMMON.COOKIE_CONSENT_ACCEPT | intl:language}} \n        </a>\n    </div>\n</div>"

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "<!--\n=====================================\nHome cover\n===================================== -->\n\n<section class=\"fill full-screen\" id=\"full-screen-home\" style=\"background-image:url('/data/images/platine-v2-home-web-clean.jpg'); position: relative\">\n    <div class=\"opacity-super-light bg-dark-gray\"></div>\n    <div class=\"slider-typography text-center\">\n        <div class=\"slider-text-middle-main pull-left\">\n            <div class=\"row slider-home slider-text-middle padding-left-right-px\">\n                <!-- <p class=\"text-center text-small font-weight-600 text-uppercase white-text letter-spacing-7 margin-three no-margin-top bg-deep-red highlight-link-text xs-line-height-18\">\n                    Forgotten Records\n                </p> -->\n                <div class=\"text-center col-sm-5 col-lg-4\">\n                    <a (click)=\"utils.scroll(contentstart, 20)\" class=\"highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five\">\n                        {{intl.data?.HOME.LATEST_RELEASES_GO | intl:currentLanguage}}\n                    </a>\n                    <h1 class=\"white-text font-weight-100 letter-spacing-2\">\n                        {{intl.data?.COMMON.HEADLINE_1 | intl:currentLanguage}}\n                        <br class=\"xs-display-none\"> {{intl.data?.COMMON.HEADLINE_2 | intl:currentLanguage}}\n                    </h1>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"scroll-down\"><a (click)=\"utils.scroll(contentstart, 20)\" class=\"pointer inner-link\"><i class=\"fa fa-angle-down\"></i></a></div>\n</section>\n\n<!--\n=====================================\nLatest releases\n=====================================-->\n\n<section #contentstart class=\"content-section wow fadeIn\">\n    <div class=\"container\">\n\n        <div class=\"row col-md-12\" searchable-contents pageSize=\"12\" context=\"record\" [active]=\"true\" #sc=\"sc\" [ngSwitch]=\"sc.loading\">\n            <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                    <h3 class=\"section-title section-title-services no-padding-bottom\">\n                        {{intl.data?.HOME.LATEST_RELEASES | intl:currentLanguage}}</h3>\n                </div>\n\n                <div class=\"col-md-5 col-sm-11 margin-five center-col text-center\">\n                    <h4 class=\"gray-text\">\n                        {{intl.data?.HOME.LATEST_RELEASES_SUB | intl:currentLanguage}}</h4>\n                </div>\n            </div>\n\n            <!-- loader -->\n            <div *ngSwitchCase=\"true\">\n                <loading-indicator color=\"#B6B6B6\"></loading-indicator>\n            </div>\n\n            <div *ngSwitchCase=\"false\" class=\"record-listing-home\">\n                <div *ngFor=\"let content of sc.dbContentsLimited(8)\" class=\"record-item col-md-3 col-xs-6\">\n                    <div class=\"\"><a (click)=\"router.navigate([content.url], {relativeTo: route.parent})\" class=\"pointer\"><img src=\"/data/covers/thumbs/{{content.cover.front}}\" alt=\"\"/></a></div>\n                    <div class=\"record-desc\">\n                        <div class=\"catalogue-record-title gray-text text-uppercase letter-spacing-1\">\n                                <a (click)=\"router.navigate([content.url], {relativeTo: route.parent})\" class=\"pointer\">\n                                    {{content.title | truncate:config.data?.CATALOGUE.RECORD_TITLE_TRUNCATE}}</a></div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n\n    <div class=\"learn-more row col-md-12 col-sm-12 center-col text-center\">\n        <a (click)=\"utils.lLink('catalogue', currentLanguage)\" class=\"pointer highlight-button btn btn-medium button xs-margin-bottom-five\">\n            {{intl.data?.HOME.CATALOGUE_GO | intl:currentLanguage}}</a>\n    </div>\n</section>\n\n<!--\n=====================================\nSpecials\n=====================================-->\n\n<section content-specials #specials=\"specials\" class=\"bg-gray wow fadeIn\">\n    <div class=\"container\">\n\n        <div class=\"row\">\n            <div class=\"col-md-12 text-center\">\n                <h3 class=\"section-title section-title-services no-padding-bottom\">{{intl.data?.HOME.SPECIALS | intl:currentLanguage}}</h3>\n            </div>\n\n            <div class=\"col-md-5 col-sm-11 margin-five center-col text-center\">\n                <h4 class=\"gray-text\">{{intl.data?.HOME.SPECIALS_SUB | intl:currentLanguage}}</h4>\n            </div>\n        </div>\n\n        <div class=\"row margin-five no-margin-bottom\">\n            <!-- model -->\n            <div *ngFor=\"let content of specials.dbContentsLimited(4)\" class=\"col-md-6 col-sm-6 xs-margin-bottom-ten\">\n                <div class=\"model-details clearfix xs-no-margin\">\n                    <div class=\"text-center col-md-6 no-padding\">\n                        <img src=\"{{content.image}}\" (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"pointer\" alt=\"\" />\n                    </div>\n                    <div class=\"col-md-6 no-padding\">\n                        <div class=\"special-text model-details-text\">\n                            <div class=\"separator-line bg-black no-margin-lr margin-ten\"></div>\n                            <span class=\"display-block clearfix xs-no-margin sm-display-none\"></span>\n                            <span class=\"text-uppercase font-weight-600 black-text letter-spacing-2\">{{content.title[currentLanguage]}}</span>\n                            <span class=\"text-uppercase text-small letter-spacing-2 margin-two display-block\">{{content.subtitle[currentLanguage]}}</span>\n                            <p class=\"margin-ten xs-no-margin\">{{content.content[currentLanguage] | truncate:config.data?.SPECIAL.TITLE_TRUNCATE}}</p>\n                            <span class=\"margin-five xs-no-margin display-block clearfix xs-no-margin\"></span>\n                            <a (click)=\"utils.lLink(content.url,currentLanguage)\" class=\"bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer\">\n                            {{intl.data?.COMMON.SEE_MORE | intl:currentLanguage}}</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <!-- end model -->\n        </div>\n    </div>\n\n    <div class=\"learn-more col-md-12 col-sm-12 center-col text-center\">\n        <a (click)=\"utils.lLink('catalogue/special', currentLanguage)\" class=\"pointer highlight-button btn btn-medium button xs-margin-bottom-five\">\n            {{intl.data?.HOME.SPECIALS_GO | intl:currentLanguage}}</a>\n    </div>\n\n</section>\n\n<!--\n=====================================\nFeatured\n===================================== -->\n\n<section *ngIf=\"config.data?.HOME.FEATURED\" class=\"bg-gray content-section wow fadeIn \">\n    <div class=\"container\">\n\n        <div class=\"row col-md-12 \" content-records-featured #featured=\"featured\">\n\n            <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                    <h3 class=\"section-title section-title-services no-padding-bottom\">\n                        {{intl.data?.HOME.FEATURED | intl:currentLanguage}}</h3>\n                </div>\n\n                <div class=\"col-md-5 col-sm-11 margin-five center-col text-center\">\n                    <h4 class=\"gray-text\">{{intl.data?.HOME.FEATURED_SUB | intl:currentLanguage}}</h4>\n                </div>\n            </div>\n\n\n            <div class=\"record-listing\">\n                <div *ngFor=\"let content of featured.dbContentsLimited(4)\" class=\"record-item col-md-3 col-xs-6\">\n                    <div class=\"\">\n                        <a (click)=\"router.navigate([content.url], {relativeTo: route.parent})\" class=\"pointer\">\n                            <img src=\"/data/covers/thumbs/{{content.cover.front}}\" alt=\"\"/>\n                        </a>\n                    </div>\n                    <div class=\"record-desc\">\n                        <div class=\"catalogue-record-title gray-text text-uppercase letter-spacing-1\">\n                                <a (click)=\"router.navigate([content.url], {relativeTo: route.parent})\" class=\"pointer\">\n                                    {{content.title | truncate:'80'}}</a></div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n\n    <div class=\"learn-more row col-md-12 col-sm-12 center-col text-center\">\n        <a (click)=\"utils.lLink('catalogue', currentLanguage)\" class=\"pointer highlight-button btn btn-medium button xs-margin-bottom-five\">\n                {{intl.data?.HOME.CATALOGUE_GO | intl:currentLanguage}}</a>\n    </div>\n</section>\n\n<!--\n=====================================\nAbout\n===================================== -->\n\n<span *ngIf=\"about && currentLanguage\" [innerHTML]=\"about.summary[currentLanguage]\"></span>\n\n<section class=\"section-pull-up\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-12 col-sm-12 center-col text-center margin-three\">\n                <a (click)=\"utils.lLink('page/about', currentLanguage)\" class=\"pointer highlight-button btn btn-medium button xs-margin-bottom-five\">\n                    {{intl.data?.COMMON.LEARN_MORE | intl:currentLanguage}}</a>\n            </div>\n        </div>\n    </div>\n\n</section>\n\n\n<!--<div class=\"wide-separator-line no-margin-lr\">&nbsp;</div>-->"

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "<section class=\"fill full-screen\" id=\"full-screen-home\" style=\"background-image:url('/data/images/platine-v2-home-web-clean.jpg'); position: relative\">\n    <div class=\"opacity-light bg-dark-gray\"></div>\n    <div class=\"slider-typography text-center\">\n        <div class=\"slider-text-middle-main pull-left\">\n            <div *ngIf=\"currentLanguage\" class=\"slider-home slider-text-middle padding-left-right-px\">\n                <!-- <p class=\"text-center text-small font-weight-600 text-uppercase white-text letter-spacing-7 margin-three no-margin-top bg-deep-red highlight-link-text xs-line-height-18\">\n                    Forgotten Records\n                </p> -->\n                <div class=\"\">\n                    <a (click)=\"utils.lLink('catalogue',currentLanguage)\" class=\"highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five\">\n                    {{intl.data?.HOME.CATALOGUE_GO | intl:currentLanguage}}\n                    </a>\n                </div>\n                <h1 class=\"white-text font-weight-100 letter-spacing-2\">\n                {{intl.data?.COMMON.PAGE_NOT_FOUND.TITLE | intl:currentLanguage}}\n                </h1>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "<!-- navigation panel -->\n\n<!-- STICKY-->\n<!--\n<nav class=\"navbar navbar-default navbar-fixed-top nav-transparent overlay-nav sticky-nav bg-white nav-border-bottom static-sticky\" role=\"navigation\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-2 pull-left\">\n                <a class=\"logo-light logo-dark text-small font-weight-600 text-uppercase black-text letter-spacing-7\" routerLink=\"/\" href=\"/\">Forgotten Records</a>\n            </div>   \n-->\n\n<span lg-routing #lgRouting=\"lgRouting\">\n\n<policy-checker [language]=\"lgRouting.currentLanguage\"></policy-checker>\n\n<nav class=\"navbar navbar-default navbar-fixed-top nav-transparent overlay-nav sticky-nav nav-white nav-border-bottom\" role=\"navigation\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <!-- logo (text) -->   \n            <div class=\"col-md-1 pull-left\">\n                <a (click)=\"utils.lLink('', lgRouting.currentLanguage)\" class=\"pointer logo-light text-small font-weight-600 text-uppercase white-text letter-spacing-7\">\n                    <span class=\"logo-first-letter\">F</span>orgotten<br> Records\n                    <!-- <span class=\"first-letter-logo\">F</span>orgotten<br class=\"xs-display\"> Records -->\n                </a>\n                <a (click)=\"utils.lLink('', lgRouting.currentLanguage)\" class=\"logo-dark text-small font-weight-600 text-uppercase black-text letter-spacing-7\">\n                    <span class=\"logo-first-letter\">F</span>orgotten<br> Records\n                    <!-- <span class=\"first-letter-logo\">F</span>orgotten<br class=\"xs-display\"> Records -->\n                </a>\n                <loading-indicator color=\"#8f2424\" *ngIf=\"nodeLoading\" class=\"app-loading\"></loading-indicator>\n            </div>\n            <!-- end logo -->\n            <!-- search and cart  -->\n            <div class=\"col-md-3 no-padding-left search-cart-header pull-right\">\n                <div id=\"top-search\">\n                    <!-- nav search -->\n                    <!--<a href=\"#search-header\" class=\"header-search-form\"><i class=\"fa fa-search search-button\"></i></a>-->\n                    <!-- end nav search -->\n                    <a (click)=\"onSearchClick('catalogue', lgRouting.currentLanguage)\" class=\"pointer\"><i class=\"fa fa-search search-button\"></i></a>\n                </div>\n                <!-- search input-->\n                <!--<form id=\"search-header\" method=\"post\" action=\"#\" name=\"search-header\" class=\"mfp-hide search-form-result\">\n                    <div class=\"search-form position-relative\">\n                        <button type=\"submit\" class=\"fa fa-search close-search search-button\"></button>\n                        <input type=\"text\" name=\"search\" class=\"search-input\" placeholder=\"Enter your keywords...\" autocomplete=\"off\">\n                    </div>\n                </form>-->\n\n                <!-- end search input -->\n                <cart-widget \n                    [language]=\"lgRouting.currentLanguage\"\n                    [labels]=\"intl.data?.CART.WIDGET\" >\n                </cart-widget>\n\n                <div class=\"language-selector pull-right\">\n                    <div class=\"logo-light\">\n                        <span language-selector class=\"language-select\"\n                            *ngFor=\"let lang of config.data?.APP.LANGUAGES.SUPPORTED\"\n                                [language]=\"lang\" \n                                [labels]=\"intl.data?.COMMON.LANGUAGE_LOCALE\" \n                                [resourcePath]=\"lgRouting.resourcePath\" \n                                [displayCurrent]=\"false\"\n                                [currentLanguage]=\"lgRouting.currentLanguage\"\n                                (onLanguageSelect)=\"lgRouting.onSelect($event)\">\n                        </span>\n                    </div>\n                    <div class=\"logo-dark\">\n                        <span language-selector class=\"language-select\"\n                            *ngFor=\"let lang of config.data?.APP.LANGUAGES.SUPPORTED\"\n                                [language]=\"lang\" \n                                [labels]=\"intl.data?.COMMON.LANGUAGE_LOCALE\" \n                                [resourcePath]=\"lgRouting.resourcePath\" \n                                [displayCurrent]=\"false\"\n                                [currentLanguage]=\"lgRouting.currentLanguage\"\n                                (onLanguageSelect)=\"lgRouting.onSelect($event)\">\n                        </span>\n                    </div>\n                </div>\n\n            </div>\n            <!-- end search and cart  -->\n            <!-- toggle navigation -->\n            <div class=\"navbar-header col-xs-2 pull-right\">\n                <button id=\"accordion-menu\" type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"> <span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> </button>\n            </div>\n            <!-- toggle navigation end -->\n            <!-- main menu -->\n            <div class=\"col-md-8 no-padding-right accordion-menu text-right\">\n                <div class=\"navbar-collapse collapse\">\n                    <ul class=\"nav navbar-nav navbar-right panel-group\" id=\"accordion\">\n                        \n                        <li>\n                            <a (click)=\"onMenuClick('', lgRouting.currentLanguage)\" class=\"pointer\">\n                            {{intl.data?.COMMON.MENU.HOME | intl:lgRouting.currentLanguage}}</a>\n                        </li>\n\n                        <!-- class=\"dropdown panel\" -->\n                        <li [ngClass]=\"{'current': isCurrent('/catalogue')}\">\n                            <a (click)=\"onMenuClick('catalogue', lgRouting.currentLanguage)\" class=\"pointer\">{{intl.data?.COMMON.MENU.CATALOGUE | intl:lgRouting.currentLanguage}}</a> \n                            <!--<a (click)=\"onMenuClick('catalogue', lgRouting.currentLanguage)\" class=\"pointer dropdown-toggle collapsed\" data-parent=\"#accordion\" data-hover=\"dropdown\">Catalogue <i class=\"fa fa-angle-down\"></i></a>\n                            <ul id=\"collapse2\" class=\"dropdown-menu mega-menu panel-collapse collapse mega-menu-full\">\n                                <li class=\"mega-menu-column col-sm-3\">\n                                    <ul>\n                                        <li class=\"dropdown-header\">Sections</li>\n                                        <li><a href=\"#\">Full catalogue</a></li>\n                                        <li><a href=\"#\">Reissues</a></li>\n                                        <li><a href=\"#\">Production</a></li>\n                                    </ul>\n                                </li>\n                                <li class=\"mega-menu-column col-sm-3\">\n                                    <ul>\n                                        <li class=\"dropdown-header\">Latest releases</li>\n                                        <li><a href=\"#\"><img alt=\"\" src=\"/data/covers/ALBENIZ DE FALLA SEBASTIAN MARTINON.front.jpg\"></a></li>\n                                    </ul>\n                                </li>\n                                <li class=\"mega-menu-column col-sm-3\">\n                                    <ul>\n                                        <li class=\"dropdown-header\">&nbsp;</li>\n                                        <li><a href=\"#\"><img alt=\"\" src=\"/data/covers/ALBENIZ FALLA TOLDRA DEL PUEYO MARTINON.front.jpg\"></a></li>\n                                    </ul>\n                                </li>\n                                <li class=\"mega-menu-column col-sm-3\">\n                                    <ul>\n                                        <li class=\"dropdown-header\">&nbsp;</li>\n                                        <li><a href=\"#\"><img alt=\"\" src=\"/data/covers/BACH CANTATES MAGNIFICAT GRISCHKAT.front.jpg\"></a></li>\n                                    </ul>\n                                </li>\n                            </ul>-->\n                        </li>\n                        \n                        <li [ngClass]=\"{'current': isCurrent('/writings')}\">\n                            <a (click)=\"onMenuClick('writings', lgRouting.currentLanguage)\" class=\"pointer\">{{intl.data?.COMMON.MENU.WRITINGS | intl:lgRouting.currentLanguage}}</a>                             \n                        </li>\n\n                        <li [ngClass]=\"{'current': isCurrent('/about')}\">\n                            <a (click)=\"onMenuClick('page/about', lgRouting.currentLanguage)\" class=\"pointer\">{{intl.data?.COMMON.MENU.ABOUT | intl:lgRouting.currentLanguage}}</a>                            \n                        </li>\n                        \n                    </ul>\n                </div>\n            </div>\n            <!-- end main menu -->\n        </div>\n    </div>\n</nav>\n<!-- end navigation panel -->\n\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n\n<!-- footer -->\n<footer>\n    <div class=\"bg-gray footer-top\">\n        <div class=\"container\">\n            <div class=\"row margin-four center-col text-center\">\n\n                <div class=\"col-sm-4 text-center\"><i class=\"fa fa-facebook small-icon black-text\"></i>\n                    <h6 class=\"margin-two no-margin-bottom\"><a class=\"black-text\" href=\"http://facebook.com/forgottenrecords\" target=\"_blank\">fb.com/forgottenrecords</a></h6>\n                </div>\n\n                <div class=\"col-sm-4 text-center\"><i class=\"icon-envelope small-icon black-text\"></i>\n                    <h6 class=\"margin-two no-margin-bottom contact\"><a class=\"black-text\" href=\"mailto:contact@forgottenrecords.com\">contact@forgottenrecords.com</a></h6>\n                </div>\n\n                <div class=\"col-sm-4 text-center\"><i class=\"fa fa-instagram small-icon black-text\"></i>\n                    <h6 class=\"black-text margin-two no-margin-bottom\"><a class=\"black-text\" href=\"http://instagram.com/forgottenrecords\" target=\"_blank\">instagr.am/forgottenrecords</a></h6>\n                </div>\n            </div> \n        </div>\n    </div>\n\n    <div class=\"container-fluid bg-dark-gray footer-bottom\">\n        <div class=\"container\">\n            <div class=\"row margin-three\">\n                <!-- copyright -->\n                <div class=\"col-lg-8 col-sm-6 copyright text-left letter-spacing-1 xs-text-center xs-margin-bottom-one\">\n                    &copy; 2009-{{currentYear}} Forgotten Records.\n                </div>\n                <!-- end copyright -->\n                <!-- logo -->\n                <div class=\"col-lg-4 col-sm-6 footer-logo deep-light-gray-text\">\n                    4 allée du Clos Pilet, 35700 Rennes, France<br>\n                    <a class=\"light-gray-text\" href=\"mailto:contact@forgottenrecords.com\">contact@forgottenrecords.com</a> | +33 2 99 36 26 72<br>\n                    SIRET: 50874189900019 | <a class=\"light-gray-text pointer\" (click)=\"utils.lLink('page/legal', lgRouting.currentLanguage)\">{{intl.data?.COMMON.LEGAL_MENTIONS | intl:lgRouting.currentLanguage}}</a>\n                    <!--<img src=\"/resources_front/assets/images/logo-light-gray.png\" alt=\"\"/>-->\n                    <!--<a href=\"index.html\">Forgotten Records</a>-->\n                </div>\n                <!-- end logo -->\n            </div>\n        </div>\n    </div>\n    <!-- scroll to top -->\n    <a href=\"javascript:;\" class=\"scrollToTop\"><i class=\"fa fa-angle-up\"></i></a>\n    <!-- scroll to top End... -->\n</footer>\n<!-- end footer -->\n\n</span>"

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "<!-- modal popup #1 -->\n<p>\n    <!-- xs-->\n    <!--<a (click)=\"onClickLoad('composer')\" href=\"#modal-popup\" class=\"hidden-lg hidden-md hidden-sm az-btn highlight-button btn-az btn btn-small no-margin-right no-margin-top modal-popup no-margin-bottom\">\n        A-Z \n    </a>-->\n    <a *ngFor=\"let field of fields\" (click)=\"onClickLoad(field)\" href=\"#modal-popup\" class=\"az-btn highlight-button btn-az btn btn-small no-margin-top modal-popup no-margin-bottom\">\n        {{labels? labels[field][language] : field}} \n    </a>\n\n    <!-- modal popup -->\n    <div id=\"modal-popup\" class=\"pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main\">\n\n        <span class=\"slider-subtitle5 black-text no-margin-bottom\">A-Z</span>\n\n        <div>\n            <div class=\"row\">\n                <div class=\"col-md-11 col-sm-10 center-col text-center margin-ten no-margin-top xs-margin-bottom-seven\">\n                    <h6 class=\"no-margin-top margin-ten xs-margin-bottom-seven\"><strong class=\"black-text\">\n                        {{title}}</strong></h6>\n                </div>\n            </div>\n            <div class=\"row az-content center-col\">\n                <div class=\"col-md-12 col-sm-10 center-col\">\n\n                    <loading-indicator color=\"#B6B6B6\" *ngIf=\"!ready\" class=\"tab-style1\"></loading-indicator>\n\n                    <!-- tab -->\n                    <div *ngIf=\"ready\" class=\"tab-style1\">\n                        <div class=\"row\">\n                            <div class=\"col-md-12 col-sm-12\">\n                                <!-- tab navigation -->\n                                <ul class=\"nav nav-tabs nav-tabs-light text-center\">\n                                    <!-- class=\"active\" -->\n                                    <li *ngFor=\"let type of azData | mapToIterable; let i=index\" [ngClass]=\"{'active': type.key==requestType}\">\n                                        <a href=\"#tab-{{type.key}}\" data-toggle=\"tab\">\n                                                {{labels? labels[type.key][language] : type.key}}</a>\n                                    </li>\n                                </ul>\n                                <!-- tab end navigation -->\n                            </div>\n                        </div>\n                        <!-- tab content section -->\n                        <div class=\"tab-content\">\n\n                            <!-- tab content -->\n                            <div *ngFor=\"let type of azData | mapToIterable; let j=index\" [ngClass]=\"{'active': type.key==requestType}\" class=\"tab-pane med-text fade in\" id=\"tab-{{type.key}}\">\n                                <div class=\"row\">\n                                    <!-- tab -->\n                                    <div class=\"col-md-12 col-sm-12 center-col text-center\" id=\"animated-tab\">\n                                        <!-- tab navigation -->\n                                        <ul class=\"nav nav-tabs nav-tabs-light text-center\">\n                                            <li *ngFor=\"let az of type.value | mapToIterable; let k=index\" [ngClass]=\"{'active': k==0}\" class=\"nav az-letter\"><a href=\"#tab-{{type.key}}-{{az.key}}\" data-toggle=\"tab\">{{az.key}}</a></li>\n                                        </ul>\n                                        <!-- end tab navigation -->\n                                        <!-- tab content section -->\n                                        <div class=\"tab-content tab-content-az-names\">\n                                            <!-- tab content -->\n                                            <div *ngFor=\"let az of type.value | mapToIterable; let k=index\" id=\"tab-{{type.key}}-{{az.key}}\" [ngClass]=\"{'active': k==0}\" class=\"col-md-9 col-sm-12 text-center center-col tab-pane fade in\">\n                                                <div class=\"tab-pane fade in\">\n                                                    <div class=\"row\">\n                                                        <div class=\"col-md-12 col-sm-12 gray-text\">\n                                                            <ul class=\"az-list\">\n                                                                <li *ngFor=\"let name of az.value\">\n                                                                    <a (click)=\"onSelect(type.key, name)\" class=\"popup-modal-dismiss pointer\"><span class=\"label label-az-name\">{{name}}</span></a>\n                                                                </li>\n                                                            </ul>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"row\">\n                                                        <div class=\"wide-separator-line\"></div>\n                                                    </div>\n                                                    <!-- <div class=\"row\">\n                                                        <div class=\"col-md-12 col-sm-12 text-center service-year black-text\">\n                                                            <strong>Est. 2009</strong>Forgotten Records\n                                                        </div>\n                                                    </div> -->\n                                                </div>\n                                            </div>\n                                            <!-- end tab content -->\n\n\n                                        </div>\n                                        <!-- end tab content section -->\n                                    </div>\n                                    <!-- end tab -->\n                                </div>\n                            </div>\n                            <!-- end tab content -->\n\n                        </div>\n                        <!-- end tab content section -->\n                    </div>\n                    <!-- end tab -->\n                </div>\n            </div>\n        </div>\n\n    </div>\n    <!-- end modal popup -->"

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "<!--<div *ngFor=\"let agg of esAggregations | mapToIterable\" class=\"facet widget\">-->\n<div *ngFor=\"let type of fields\" class=\"facet widget\">\n    <div *ngIf=\"esAggregations && esAggregations[type].buckets.length > 0\">\n        <h5 *ngIf=\"type!='type'\" class=\"widget-title font-alt\">{{labels && labels[type] ? labels[type][language] : type}}</h5>\n        <div *ngIf=\"type!='type'\" class=\"thin-separator-line bg-dark-gray no-margin-lr margin-ten\"></div>\n        <div class=\"widget-body\">\n            <ul class=\"category-list\">\n                <li *ngFor=\"let term of esAggregations[type].buckets\" class=\"facet-element\">\n                    <a *ngIf=\"!utils.isInFilters(esFilters, type, term.key)\" (click)=\"onSelect(type, term.key)\" style=\"cursor: pointer\">\n                    {{ (labels && labels[type].VALUES && labels[type].VALUES[term.key] ? labels[type].VALUES[term.key][language] : term.key) | truncate:'20' }}<span>{{term.doc_count}}</span>\n                    </a>\n                    <a *ngIf=\"utils.isInFilters(esFilters, type, term.key)\" class=\"facet-active\">\n                    {{ (labels && labels[type].VALUES && labels[type].VALUES[term.key] ? labels[type].VALUES[term.key][language] : term.key) | truncate:'20' }}<span>{{term.doc_count}}</span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "ul {\n    list-style-type: none;\n  }\n\n.suggestion-search-msg {\n    padding: 15px;\n}\n.suggestion-search-msg>a {\n    color: #fff;\n}\n.suggestions {\n    z-index: 100;\n    background-color: #000;\n    float: right;\n    position: absolute;\n    padding: 10px;\n    opacity: 0.9\n}\n@media screen and (max-width: 9200px) {\n    .suggestions { width: 545px}\n}\n@media screen and (max-width: 576px) {\n    .suggestions { width: 250px}\n}\n.suggestions>div>ul>li>a {\n    color: #ddd;\n}"

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = ".spinner {\n  margin: 0px auto;\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.spinner > div {\n  background-color: #B6B6B6;\n  height: 100%;\n  width: 6px;\n  display: inline-block;\n  \n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.spinner .rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.spinner .rect3 {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s;\n}\n\n.spinner .rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.spinner .rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  \n  20% { -webkit-transform: scaleY(1.0) }\n}\n\n@keyframes sk-stretchdelay {\n  0%, 40%, 100% { \n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }  20% { \n    transform: scaleY(1.0);\n    -webkit-transform: scaleY(1.0);\n  }\n}\n\n"

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "<div (mouseout)=\"onSearchLeave()\" (mouseover)=\"onSearchOver()\" class=\"search-c widget\">\n\n    <!-- LOCAL -->\n    <form (submit)=\"onSubmit()\" [ngClass]=\"{'hide' : type=='global'}\" autocomplete=\"off\" class=\"sidebar-form\">\n        <div class=\"input-group\">\n            <input #searchInput id=\"search-box\" type=\"text\" name=\"search\" class=\"form-control search-input\" placeholder=\"{{placeholder}}...\"\n                [ngClass]=\"{'search-box' : !expand,'search-box-expand' : expand}\" (click)=\"onInputClick(searchInput.value,$event)\" (keyup)=\"onInputChange(searchInput.value,$event)\"\n                [(ngModel)]=\"formQuery\">\n            <button name=\"search\" type=\"submit\" class=\"search-button\">\n                <i class=\"fa fa-search search-icon\"></i>\n            </button>\n        </div>\n    </form>\n\n    <!--GLOBAL \n    <form [ngClass]=\"{'hide' : type=='local'}\" id=\"search-header\" class=\"mfp-hide search-form-result\">\n        <div class=\"search-form position-relative\">\n            <button type=\"submit\" class=\"fa fa-search close-search search-button\"></button>\n            <input #searchInput type=\"text\" name=\"search\" class=\"search-input\"\n                placeholder=\"Rechercher...\"\n                [ngClass]=\"{'search-box-expand' : expand}\"\n                (click)=\"onInputClick(searchInput.value,$event)\"\n                (keyup)=\"onInputChange(searchInput.value,$event)\"\n                [(ngModel)]=\"formQuery\">\n        </div>\n    </form>-->\n\n    <div *ngIf=\"suggestions\" class=\"suggestions\">\n        <div class=\"suggestion-search-msg\">\n            <!--<span *ngIf=\"searchInput.value.length < suggestionTriggerThreshold\">\n                Start searching across the catalogue\n            </span>-->\n            <a (click)=\"onSubmit()\" style=\"cursor: pointer\">\n                <span *ngIf=\"searchInput.value.length >= suggestionTriggerThreshold\">\n                    {{placeholder}} <i>\"{{searchInput.value}}\"</i>\n                </span>\n            </a>\n        </div>\n        <div *ngFor=\"let type of order\">\n            <ul *ngIf=\"suggestions[type].length>0\" class=\"col-sm-4\">\n                <li class=\"dropdown-header text-uppercase\">{{ labels ? labels[type][language] : type }}</li>\n                <li *ngFor=\"let s of suggestions[type]\">\n                    <a (click)=\"onSuggestSelect(type, s.name)\" class=\"pointer\">\n                        {{s.name }} <small>({{s.freq}})</small>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n</div>"

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = "<p>{{test2}}</p>"

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    "use strict";
    var hasOwn = Object.prototype.hasOwnProperty;
    // feature test for Object.create support
    var supportsCreate = typeof Object.create === "function";
    // feature test for __proto__ support
    var supportsProto = (function () {
        var sentinel = {};
        function __() { }
        __.prototype = sentinel;
        var instance = new __();
        return instance.__proto__ === sentinel;
    })();
    // create an object in dictionary mode (a.k.a. "slow" mode in v8)
    var createDictionary = supportsCreate ? function () { return MakeDictionary(Object.create(null)); } :
        supportsProto ? function () { return MakeDictionary({ __proto__: null }); } :
            function () { return MakeDictionary({}); };
    var HashMap;
    (function (HashMap) {
        var downLevel = !supportsCreate && !supportsProto;
        HashMap.has = downLevel
            ? function (map, key) { return hasOwn.call(map, key); }
            : function (map, key) { return key in map; };
        HashMap.get = downLevel
            ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
            : function (map, key) { return map[key]; };
    })(HashMap || (HashMap = {}));
    // Load global or shim versions of Map, Set, and WeakMap
    var functionPrototype = Object.getPrototypeOf(Function);
    var _Map = typeof Map === "function" ? Map : CreateMapPolyfill();
    var _Set = typeof Set === "function" ? Set : CreateSetPolyfill();
    var _WeakMap = typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
    // [[Metadata]] internal slot
    var Metadata = new _WeakMap();
    /**
      * Applies a set of decorators to a property of a target object.
      * @param decorators An array of decorators.
      * @param target The target object.
      * @param targetKey (Optional) The property key to decorate.
      * @param targetDescriptor (Optional) The property descriptor for the target key
      * @remarks Decorators are applied in reverse order.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Example = Reflect.decorate(decoratorsArray, Example);
      *
      *     // property (on constructor)
      *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Object.defineProperty(Example, "staticMethod",
      *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
      *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
      *
      *     // method (on prototype)
      *     Object.defineProperty(Example.prototype, "method",
      *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
      *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
      *
      */
    function decorate(decorators, target, targetKey, targetDescriptor) {
        if (!IsUndefined(targetDescriptor)) {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsObject(target))
                throw new TypeError();
            if (IsUndefined(targetKey))
                throw new TypeError();
            if (!IsObject(targetDescriptor))
                throw new TypeError();
            targetKey = ToPropertyKey(targetKey);
            return DecoratePropertyWithDescriptor(decorators, target, targetKey, targetDescriptor);
        }
        else if (!IsUndefined(targetKey)) {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsObject(target))
                throw new TypeError();
            targetKey = ToPropertyKey(targetKey);
            return DecoratePropertyWithoutDescriptor(decorators, target, targetKey);
        }
        else {
            if (!IsArray(decorators))
                throw new TypeError();
            if (!IsConstructor(target))
                throw new TypeError();
            return DecorateConstructor(decorators, target);
        }
    }
    Reflect.decorate = decorate;
    /**
      * A default metadata decorator factory that can be used on a class, class member, or parameter.
      * @param metadataKey The key for the metadata entry.
      * @param metadataValue The value for the metadata entry.
      * @returns A decorator function.
      * @remarks
      * If `metadataKey` is already defined for the target and target key, the
      * metadataValue for that key will be overwritten.
      * @example
      *
      *     // constructor
      *     @Reflect.metadata(key, value)
      *     class Example {
      *     }
      *
      *     // property (on constructor, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticProperty;
      *     }
      *
      *     // property (on prototype, TypeScript only)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         property;
      *     }
      *
      *     // method (on constructor)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         static staticMethod() { }
      *     }
      *
      *     // method (on prototype)
      *     class Example {
      *         @Reflect.metadata(key, value)
      *         method() { }
      *     }
      *
      */
    function metadata(metadataKey, metadataValue) {
        function decorator(target, targetKey) {
            if (!IsUndefined(targetKey)) {
                if (!IsObject(target))
                    throw new TypeError();
                targetKey = ToPropertyKey(targetKey);
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, targetKey);
            }
            else {
                if (!IsConstructor(target))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, /*targetKey*/ undefined);
            }
        }
        return decorator;
    }
    Reflect.metadata = metadata;
    /**
      * Define a unique metadata entry on the target.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param metadataValue A value that contains attached metadata.
      * @param target The target object on which to define metadata.
      * @param targetKey (Optional) The property key for the target.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     Reflect.defineMetadata("custom:annotation", options, Example);
      *
      *     // property (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
      *
      *     // property (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
      *
      *     // method (on constructor)
      *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
      *
      *     // method (on prototype)
      *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
      *
      *     // decorator factory as metadata-producing annotation.
      *     function MyAnnotation(options): Decorator {
      *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
      *     }
      *
      */
    function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, targetKey);
    }
    Reflect.defineMetadata = defineMetadata;
    /**
      * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasMetadata(metadataKey, target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryHasMetadata(metadataKey, target, targetKey);
    }
    Reflect.hasMetadata = hasMetadata;
    /**
      * Gets a value indicating whether the target object has the provided metadata key defined.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function hasOwnMetadata(metadataKey, target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryHasOwnMetadata(metadataKey, target, targetKey);
    }
    Reflect.hasOwnMetadata = hasOwnMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getMetadata(metadataKey, target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryGetMetadata(metadataKey, target, targetKey);
    }
    Reflect.getMetadata = getMetadata;
    /**
      * Gets the metadata value for the provided metadata key on the target object.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function getOwnMetadata(metadataKey, target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryGetOwnMetadata(metadataKey, target, targetKey);
    }
    Reflect.getOwnMetadata = getOwnMetadata;
    /**
      * Gets the metadata keys defined on the target object or its prototype chain.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getMetadataKeys(Example.prototype, "method");
      *
      */
    function getMetadataKeys(target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryMetadataKeys(target, targetKey);
    }
    Reflect.getMetadataKeys = getMetadataKeys;
    /**
      * Gets the unique metadata keys defined on the target object.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns An array of unique metadata keys.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.getOwnMetadataKeys(Example);
      *
      *     // property (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
      *
      */
    function getOwnMetadataKeys(target, targetKey) {
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        return OrdinaryOwnMetadataKeys(target, targetKey);
    }
    Reflect.getOwnMetadataKeys = getOwnMetadataKeys;
    /**
      * Deletes the metadata entry from the target object with the provided key.
      * @param metadataKey A key used to store and retrieve metadata.
      * @param target The target object on which the metadata is defined.
      * @param targetKey (Optional) The property key for the target.
      * @returns `true` if the metadata entry was found and deleted; otherwise, false.
      * @example
      *
      *     class Example {
      *         // property declarations are not part of ES6, though they are valid in TypeScript:
      *         // static staticProperty;
      *         // property;
      *
      *         constructor(p) { }
      *         static staticMethod(p) { }
      *         method(p) { }
      *     }
      *
      *     // constructor
      *     result = Reflect.deleteMetadata("custom:annotation", Example);
      *
      *     // property (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
      *
      *     // property (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
      *
      *     // method (on constructor)
      *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
      *
      *     // method (on prototype)
      *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
      *
      */
    function deleteMetadata(metadataKey, target, targetKey) {
        // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#deletemetadata-metadatakey-p-
        if (!IsObject(target))
            throw new TypeError();
        if (!IsUndefined(targetKey))
            targetKey = ToPropertyKey(targetKey);
        var metadataMap = GetOrCreateMetadataMap(target, targetKey, /*create*/ false);
        if (IsUndefined(metadataMap))
            return false;
        if (!metadataMap.delete(metadataKey))
            return false;
        if (metadataMap.size > 0)
            return true;
        var targetMetadata = Metadata.get(target);
        targetMetadata.delete(targetKey);
        if (targetMetadata.size > 0)
            return true;
        Metadata.delete(target);
        return true;
    }
    Reflect.deleteMetadata = deleteMetadata;
    function DecorateConstructor(decorators, target) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target);
            if (!IsUndefined(decorated)) {
                if (!IsConstructor(decorated))
                    throw new TypeError();
                target = decorated;
            }
        }
        return target;
    }
    function DecoratePropertyWithDescriptor(decorators, target, propertyKey, descriptor) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            var decorated = decorator(target, propertyKey, descriptor);
            if (!IsUndefined(decorated)) {
                if (!IsObject(decorated))
                    throw new TypeError();
                descriptor = decorated;
            }
        }
        return descriptor;
    }
    function DecoratePropertyWithoutDescriptor(decorators, target, propertyKey) {
        for (var i = decorators.length - 1; i >= 0; --i) {
            var decorator = decorators[i];
            decorator(target, propertyKey);
        }
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#getorcreatemetadatamap--o-p-create-
    function GetOrCreateMetadataMap(target, targetKey, create) {
        var targetMetadata = Metadata.get(target);
        if (!targetMetadata) {
            if (!create)
                return undefined;
            targetMetadata = new _Map();
            Metadata.set(target, targetMetadata);
        }
        var keyMetadata = targetMetadata.get(targetKey);
        if (!keyMetadata) {
            if (!create)
                return undefined;
            keyMetadata = new _Map();
            targetMetadata.set(targetKey, keyMetadata);
        }
        return keyMetadata;
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinaryhasmetadata--metadatakey-o-p-
    function OrdinaryHasMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return true;
        var parent = GetPrototypeOf(O);
        return parent !== null ? OrdinaryHasMetadata(MetadataKey, parent, P) : false;
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinaryhasownmetadata--metadatakey-o-p-
    function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*create*/ false);
        return metadataMap !== undefined && Boolean(metadataMap.has(MetadataKey));
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinarygetmetadata--metadatakey-o-p-
    function OrdinaryGetMetadata(MetadataKey, O, P) {
        var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
        if (hasOwn)
            return OrdinaryGetOwnMetadata(MetadataKey, O, P);
        var parent = GetPrototypeOf(O);
        return parent !== null ? OrdinaryGetMetadata(MetadataKey, parent, P) : undefined;
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinarygetownmetadata--metadatakey-o-p-
    function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*create*/ false);
        return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinarydefineownmetadata--metadatakey-metadatavalue-o-p-
    function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
        var metadataMap = GetOrCreateMetadataMap(O, P, /*create*/ true);
        metadataMap.set(MetadataKey, MetadataValue);
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinarymetadatakeys--o-p-
    function OrdinaryMetadataKeys(O, P) {
        var ownKeys = OrdinaryOwnMetadataKeys(O, P);
        var parent = GetPrototypeOf(O);
        if (parent === null)
            return ownKeys;
        var parentKeys = OrdinaryMetadataKeys(parent, P);
        if (parentKeys.length <= 0)
            return ownKeys;
        if (ownKeys.length <= 0)
            return parentKeys;
        var keys = new _Set();
        for (var _i = 0; _i < ownKeys.length; _i++) {
            var key = ownKeys[_i];
            keys.add(key);
        }
        for (var _a = 0; _a < parentKeys.length; _a++) {
            var key = parentKeys[_a];
            keys.add(key);
        }
        return getKeys(keys);
    }
    // https://github.com/rbuckton/ReflectDecorators/blob/master/spec/metadata.md#ordinaryownmetadatakeys--o-p-
    function OrdinaryOwnMetadataKeys(target, targetKey) {
        var metadataMap = GetOrCreateMetadataMap(target, targetKey, /*create*/ false);
        var keys = [];
        if (metadataMap)
            forEach(metadataMap, function (_, key) { return keys.push(key); });
        return keys;
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-language-types-undefined-type
    function IsUndefined(x) {
        return x === undefined;
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
    function IsArray(x) {
        return Array.isArray ? Array.isArray(x) : x instanceof Array || Object.prototype.toString.call(x) === "[object Array]";
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object-type
    function IsObject(x) {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
    function IsConstructor(x) {
        return typeof x === "function";
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-language-types-symbol-type
    function IsSymbol(x) {
        return typeof x === "symbol";
    }
    // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
    function ToPropertyKey(value) {
        return IsSymbol(value) ? value : String(value);
    }
    function GetPrototypeOf(O) {
        var proto = Object.getPrototypeOf(O);
        if (typeof O !== "function" || O === functionPrototype)
            return proto;
        // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
        // Try to determine the superclass Exampleonstructor. Compatible implementations
        // must either set __proto__ on a subclass Exampleonstructor to the superclass Exampleonstructor,
        // or ensure each class has a valid `constructor` property on its prototype that
        // points back to the constructor.
        // If this is not the same as Function.[[Prototype]], then this is definately inherited.
        // This is the case when in ES6 or when using __proto__ in a compatible browser.
        if (proto !== functionPrototype)
            return proto;
        // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
        var prototype = O.prototype;
        var prototypeProto = prototype && Object.getPrototypeOf(prototype);
        if (prototypeProto == null || prototypeProto === Object.prototype)
            return proto;
        // If the constructor was not a function, then we cannot determine the heritage.
        var constructor = prototypeProto.constructor;
        if (typeof constructor !== "function")
            return proto;
        // If we have some kind of self-reference, then we cannot determine the heritage.
        if (constructor === O)
            return proto;
        // we have a pretty good guess at the heritage.
        return constructor;
    }
    function IteratorStep(iterator) {
        var result = iterator.next();
        return result.done ? undefined : result;
    }
    function IteratorClose(iterator) {
        var f = iterator["return"];
        if (f)
            f.call(iterator);
    }
    function forEach(source, callback, thisArg) {
        var entries = source.entries;
        if (typeof entries === "function") {
            var iterator = entries.call(source);
            var result;
            try {
                while (result = IteratorStep(iterator)) {
                    var _a = result.value, key = _a[0], value = _a[1];
                    callback.call(thisArg, value, key, source);
                }
            }
            finally {
                if (result)
                    IteratorClose(iterator);
            }
        }
        else {
            var forEach_1 = source.forEach;
            if (typeof forEach_1 === "function") {
                forEach_1.call(source, callback, thisArg);
            }
        }
    }
    function getKeys(source) {
        var keys = [];
        forEach(source, function (_, key) { keys.push(key); });
        return keys;
    }
    // naive MapIterator shim
    function CreateMapIterator(keys, values, kind) {
        var index = 0;
        return {
            next: function () {
                if ((keys || values) && index < (keys || values).length) {
                    var current = index++;
                    switch (kind) {
                        case "key": return { value: keys[current], done: false };
                        case "value": return { value: values[current], done: false };
                        case "key+value": return { value: [keys[current], values[current]], done: false };
                    }
                }
                keys = undefined;
                values = undefined;
                return { value: undefined, done: true };
            },
            "throw": function (error) {
                if (keys || values) {
                    keys = undefined;
                    values = undefined;
                }
                throw error;
            },
            "return": function (value) {
                if (keys || values) {
                    keys = undefined;
                    values = undefined;
                }
                return { value: value, done: true };
            }
        };
    }
    // naive Map shim
    function CreateMapPolyfill() {
        var cacheSentinel = {};
        return (function () {
            function Map() {
                this._keys = [];
                this._values = [];
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            }
            Object.defineProperty(Map.prototype, "size", {
                get: function () { return this._keys.length; },
                enumerable: true,
                configurable: true
            });
            Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
            Map.prototype.get = function (key) {
                var index = this._find(key, /*insert*/ false);
                return index >= 0 ? this._values[index] : undefined;
            };
            Map.prototype.set = function (key, value) {
                var index = this._find(key, /*insert*/ true);
                this._values[index] = value;
                return this;
            };
            Map.prototype.delete = function (key) {
                var index = this._find(key, /*insert*/ false);
                if (index >= 0) {
                    var size = this._keys.length;
                    for (var i = index + 1; i < size; i++) {
                        this._keys[i - 1] = this._keys[i];
                        this._values[i - 1] = this._values[i];
                    }
                    this._keys.length--;
                    this._values.length--;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                    return true;
                }
                return false;
            };
            Map.prototype.clear = function () {
                this._keys.length = 0;
                this._values.length = 0;
                this._cacheKey = cacheSentinel;
                this._cacheIndex = -2;
            };
            Map.prototype.keys = function () { return CreateMapIterator(this._keys, /*values*/ undefined, "key"); };
            Map.prototype.values = function () { return CreateMapIterator(/*keys*/ undefined, this._values, "value"); };
            Map.prototype.entries = function () { return CreateMapIterator(this._keys, this._values, "key+value"); };
            Map.prototype._find = function (key, insert) {
                if (this._cacheKey === key)
                    return this._cacheIndex;
                var index = this._keys.indexOf(key);
                if (index < 0 && insert) {
                    index = this._keys.length;
                    this._keys.push(key);
                    this._values.push(undefined);
                }
                return this._cacheKey = key, this._cacheIndex = index;
            };
            return Map;
        })();
    }
    // naive Set shim
    function CreateSetPolyfill() {
        return (function () {
            function Set() {
                this._map = new _Map();
            }
            Object.defineProperty(Set.prototype, "size", {
                get: function () { return this._map.size; },
                enumerable: true,
                configurable: true
            });
            Set.prototype.has = function (value) { return this._map.has(value); };
            Set.prototype.add = function (value) { return this._map.set(value, value), this; };
            Set.prototype.delete = function (value) { return this._map.delete(value); };
            Set.prototype.clear = function () { this._map.clear(); };
            Set.prototype.keys = function () { return this._map.keys(); };
            Set.prototype.values = function () { return this._map.values(); };
            Set.prototype.entries = function () { return this._map.entries(); };
            return Set;
        })();
    }
    // naive WeakMap shim
    function CreateWeakMapPolyfill() {
        var UUID_SIZE = 16;
        var keys = createDictionary();
        var rootKey = CreateUniqueKey();
        return (function () {
            function WeakMap() {
                this._key = CreateUniqueKey();
            }
            WeakMap.prototype.has = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.has(table, this._key) : false;
            };
            WeakMap.prototype.get = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? HashMap.get(table, this._key) : undefined;
            };
            WeakMap.prototype.set = function (target, value) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                table[this._key] = value;
                return this;
            };
            WeakMap.prototype.delete = function (target) {
                var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                return table !== undefined ? delete table[this._key] : false;
            };
            WeakMap.prototype.clear = function () {
                // NOTE: not a real clear, just makes the previous data unreachable
                this._key = CreateUniqueKey();
            };
            return WeakMap;
        })();
        function FillRandomBytes(buffer, size) {
            for (var i = 0; i < size; ++i)
                buffer[i] = Math.random() * 0xff | 0;
            return buffer;
        }
        function GenRandomBytes(size) {
            if (typeof Uint8Array === "function") {
                if (typeof crypto !== "undefined")
                    return crypto.getRandomValues(new Uint8Array(size));
                if (typeof msCrypto !== "undefined")
                    return msCrypto.getRandomValues(new Uint8Array(size));
                return FillRandomBytes(new Uint8Array(size), size);
            }
            return FillRandomBytes(new Array(size), size);
        }
        function CreateUUID() {
            var data = GenRandomBytes(UUID_SIZE);
            // mark as random - RFC 4122 § 4.4
            data[6] = data[6] & 0x4f | 0x40;
            data[8] = data[8] & 0xbf | 0x80;
            var result = "";
            for (var offset = 0; offset < UUID_SIZE; ++offset) {
                var byte = data[offset];
                if (offset === 4 || offset === 6 || offset === 8)
                    result += "-";
                if (byte < 16)
                    result += "0";
                result += byte.toString(16).toLowerCase();
            }
            return result;
        }
        function CreateUniqueKey() {
            var key;
            do
                key = "@@WeakMap@@" + CreateUUID();
            while (HashMap.has(keys, key));
            keys[key] = true;
            return key;
        }
        function GetOrCreateWeakMapTable(target, create) {
            if (!hasOwn.call(target, rootKey)) {
                if (!create)
                    return undefined;
                Object.defineProperty(target, rootKey, { value: createDictionary() });
            }
            return target[rootKey];
        }
    }
    // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
    function MakeDictionary(obj) {
        obj.__DICTIONARY_MODE__ = 1;
        delete obj.____DICTIONARY_MODE__;
        return obj;
    }
    // patch global Reflect
    (function (__global) {
        if (typeof __global.Reflect !== "undefined") {
            if (__global.Reflect !== Reflect) {
                for (var p in Reflect) {
                    if (hasOwn.call(Reflect, p)) {
                        __global.Reflect[p] = Reflect[p];
                    }
                }
            }
        }
        else {
            __global.Reflect = Reflect;
        }
    })(typeof window !== "undefined" ? window :
        typeof WorkerGlobalScope !== "undefined" ? self :
            typeof global !== "undefined" ? global :
                Function("return this;")());
})(Reflect || (Reflect = {}));
//# sourceMappingURL=Reflect.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return this.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return this.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(66);
var queue_1 = __webpack_require__(543);
var Subscription_1 = __webpack_require__(99);
var observeOn_1 = __webpack_require__(331);
var ObjectUnsubscribedError_1 = __webpack_require__(250);
var SubjectSubscription_1 = __webpack_require__(323);
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports) {

"use strict";
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var empty_1 = __webpack_require__(524);
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var throw_1 = __webpack_require__(525);
Observable_1.Observable.throw = throw_1._throw;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var filter_1 = __webpack_require__(330);
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var let_1 = __webpack_require__(532);
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var mergeMap_1 = __webpack_require__(101);
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var sampleTime_1 = __webpack_require__(535);
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var startWith_1 = __webpack_require__(537);
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Observable_1 = __webpack_require__(13);
var take_1 = __webpack_require__(539);
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
var ScalarObservable_1 = __webpack_require__(242);
var EmptyObservable_1 = __webpack_require__(123);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(66);
var Observable_1 = __webpack_require__(13);
var Subscriber_1 = __webpack_require__(35);
var Subscription_1 = __webpack_require__(99);
/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        this._refCount = 0;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new Subscription_1.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return this.lift(new RefCountOperator(this));
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
exports.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subscribe: { value: ConnectableObservable.prototype._subscribe },
    getSubject: { value: ConnectableObservable.prototype.getSubject },
    connect: { value: ConnectableObservable.prototype.connect },
    refCount: { value: ConnectableObservable.prototype.refCount }
};
var ConnectableSubscriber = (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(Subject_1.SubjectSubscriber));
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(13);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ErrorObservable = (function (_super) {
    __extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flattens numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link Scheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */
    ErrorObservable.create = function (error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function (arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    ErrorObservable.prototype._subscribe = function (subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ErrorObservable.dispatch, 0, {
                error: error, subscriber: subscriber
            });
        }
        else {
            subscriber.error(error);
        }
    };
    return ErrorObservable;
}(Observable_1.Observable));
exports.ErrorObservable = ErrorObservable;
//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(252);
var isPromise_1 = __webpack_require__(338);
var PromiseObservable_1 = __webpack_require__(326);
var IteratorObservable_1 = __webpack_require__(523);
var ArrayObservable_1 = __webpack_require__(184);
var ArrayLikeObservable_1 = __webpack_require__(519);
var iterator_1 = __webpack_require__(246);
var Observable_1 = __webpack_require__(13);
var observeOn_1 = __webpack_require__(331);
var observable_1 = __webpack_require__(247);
var isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.$$observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.$$iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.$$observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.$$observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(67);
var Observable_1 = __webpack_require__(13);
var iterator_1 = __webpack_require__(246);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.$$iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.$$iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.$$iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.$$iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var EmptyObservable_1 = __webpack_require__(123);
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var ErrorObservable_1 = __webpack_require__(521);
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var isScheduler_1 = __webpack_require__(253);
var ArrayObservable_1 = __webpack_require__(184);
var mergeAll_1 = __webpack_require__(125);
/* tslint:disable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {Observable} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional Scheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(concatStatic.apply(void 0, [this].concat(observables)));
}
exports.concat = concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins multiple Observables together by subscribing to them one at a time and
 * merging their results into the output Observable. Will wait for each
 * Observable to complete before moving on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat(timer1, timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {Observable} input1 An input Observable to concatenate with others.
 * @param {Observable} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional Scheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concatStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var scheduler = null;
    var args = observables;
    if (isScheduler_1.isScheduler(args[observables.length - 1])) {
        scheduler = args.pop();
    }
    if (scheduler === null && observables.length === 1) {
        return observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(1));
}
exports.concatStatic = concatStatic;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var async_1 = __webpack_require__(335);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link Scheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new DebounceTimeOperator(dueTime, scheduler));
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var tryCatch_1 = __webpack_require__(339);
var errorObject_1 = __webpack_require__(251);
/* tslint:disable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 * If a comparator function is not provided, an equality check is used by default.
 * @param {function} [compare] optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} an Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return this.lift(new DistinctUntilChangedOperator(compare, keySelector));
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/* tslint:disable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return this.lift(new DoOperator(nextOrObserver, error, complete));
}
exports._do = _do;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=do.js.map

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var EmptyError_1 = __webpack_require__(249);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} an Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return this.lift(new FirstOperator(predicate, resultSelector, defaultValue, this));
}
exports.first = first;
var FirstOperator = (function () {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FirstSubscriber = (function (_super) {
    __extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._emit = function (value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function (value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        }
        else if (!this.hasCompleted) {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return FirstSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=first.js.map

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var EmptyError_1 = __webpack_require__(249);
/* tslint:disable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - the condition any source emitted item has to satisfy.
 * @return {Observable} an Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return this.lift(new LastOperator(predicate, resultSelector, defaultValue, this));
}
exports.last = last;
var LastOperator = (function () {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function (observer, source) {
        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var LastSubscriber = (function (_super) {
    __extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return LastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=last.js.map

/***/ }),
/* 532 */
/***/ (function(module, exports) {

"use strict";
"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var ConnectableObservable_1 = __webpack_require__(520);
/* tslint:disable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} an Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory;
    if (typeof subjectOrSubjectFactory === 'function') {
        subjectFactory = subjectOrSubjectFactory;
    }
    else {
        subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
    }
    if (typeof selector === 'function') {
        return this.lift(new MulticastOperator(subjectFactory, selector));
    }
    var connectable = Object.create(this, ConnectableObservable_1.connectableObservableDescriptor);
    connectable.source = this;
    connectable.subjectFactory = subjectFactory;
    return connectable;
}
exports.multicast = multicast;
var MulticastOperator = (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());
exports.MulticastOperator = MulticastOperator;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
/* tslint:disable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return this.lift(new ReduceOperator(accumulator, seed, hasSeed));
}
exports.reduce = reduce;
var ReduceOperator = (function () {
    function ReduceOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ReduceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ReduceSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ReduceOperator;
}());
exports.ReduceOperator = ReduceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ReduceSubscriber = (function (_super) {
    __extends(ReduceSubscriber, _super);
    function ReduceSubscriber(destination, accumulator, seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.hasSeed = hasSeed;
        this.hasValue = false;
        this.acc = seed;
    }
    ReduceSubscriber.prototype._next = function (value) {
        if (this.hasValue || (this.hasValue = this.hasSeed)) {
            this._tryReduce(value);
        }
        else {
            this.acc = value;
            this.hasValue = true;
        }
    };
    ReduceSubscriber.prototype._tryReduce = function (value) {
        var result;
        try {
            result = this.accumulator(this.acc, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.acc = result;
    };
    ReduceSubscriber.prototype._complete = function () {
        if (this.hasValue || this.hasSeed) {
            this.destination.next(this.acc);
        }
        this.destination.complete();
    };
    return ReduceSubscriber;
}(Subscriber_1.Subscriber));
exports.ReduceSubscriber = ReduceSubscriber;
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var async_1 = __webpack_require__(335);
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link Scheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new SampleTimeOperator(period, scheduler));
}
exports.sampleTime = sampleTime;
var SampleTimeOperator = (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleTimeSubscriber = (function (_super) {
    __extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var multicast_1 = __webpack_require__(533);
var Subject_1 = __webpack_require__(66);
function shareSubjectFactory() {
    return new Subject_1.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .publish().refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} an Observable that upon connection causes the source Observable to emit items to its Observers
 * @method share
 * @owner Observable
 */
function share() {
    return multicast_1.multicast.call(this, shareSubjectFactory).refCount();
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var ArrayObservable_1 = __webpack_require__(184);
var ScalarObservable_1 = __webpack_require__(242);
var EmptyObservable_1 = __webpack_require__(123);
var concat_1 = __webpack_require__(526);
var isScheduler_1 = __webpack_require__(253);
/* tslint:disable:max-line-length */
/**
 * Returns an Observable that emits the items in a specified Iterable before it begins to emit items emitted by the
 * source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {Values} an Iterable that contains the items you want the modified Observable to emit first.
 * @return {Observable} an Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (isScheduler_1.isScheduler(scheduler)) {
        array.pop();
    }
    else {
        scheduler = null;
    }
    var len = array.length;
    if (len === 1) {
        return concat_1.concatStatic(new ScalarObservable_1.ScalarObservable(array[0], scheduler), this);
    }
    else if (len > 1) {
        return concat_1.concatStatic(new ArrayObservable_1.ArrayObservable(array, scheduler), this);
    }
    else {
        return concat_1.concatStatic(new EmptyObservable_1.EmptyObservable(scheduler), this);
    }
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(182);
var subscribeToResult_1 = __webpack_require__(185);
/* tslint:disable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): Observable} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return this.lift(new SwitchMapOperator(project, resultSelector));
}
exports.switchMap = switchMap;
var SwitchMapOperator = (function () {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapSubscriber = (function (_super) {
    __extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(35);
var ArgumentOutOfRangeError_1 = __webpack_require__(544);
var EmptyObservable_1 = __webpack_require__(123);
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else {
        return this.lift(new TakeOperator(count));
    }
}
exports.take = take;
var TakeOperator = (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeSubscriber = (function (_super) {
    __extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=take.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(99);
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(333);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(334);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var QueueAction_1 = __webpack_require__(541);
var QueueScheduler_1 = __webpack_require__(542);
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),
/* 544 */
/***/ (function(module, exports) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = (function (_super) {
    __extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error));
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports) {

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var Subscriber_1 = __webpack_require__(35);
var rxSubscriber_1 = __webpack_require__(248);
var Observer_1 = __webpack_require__(322);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.$$rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.$$rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

/**
* @license
* Copyright Google Inc. All Rights Reserved.
*
* Use of this source code is governed by an MIT-style license that can be
* found in the LICENSE file at https://angular.io/license
*/
(function (global, factory) {
	 true ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview
 * @suppress {globalThis}
 */
var NEWLINE = '\n';
var IGNORE_FRAMES = {};
var creationTrace = '__creationTrace__';
var ERROR_TAG = 'STACKTRACE TRACKING';
var SEP_TAG = '__SEP_TAG__';
var sepTemplate = SEP_TAG + '@[native]';
var LongStackTrace = (function () {
    function LongStackTrace() {
        this.error = getStacktrace();
        this.timestamp = new Date();
    }
    return LongStackTrace;
}());
function getStacktraceWithUncaughtError() {
    return new Error(ERROR_TAG);
}
function getStacktraceWithCaughtError() {
    try {
        throw getStacktraceWithUncaughtError();
    }
    catch (err) {
        return err;
    }
}
// Some implementations of exception handling don't create a stack trace if the exception
// isn't thrown, however it's faster not to actually throw the exception.
var error = getStacktraceWithUncaughtError();
var caughtError = getStacktraceWithCaughtError();
var getStacktrace = error.stack ?
    getStacktraceWithUncaughtError :
    (caughtError.stack ? getStacktraceWithCaughtError : getStacktraceWithUncaughtError);
function getFrames(error) {
    return error.stack ? error.stack.split(NEWLINE) : [];
}
function addErrorStack(lines, error) {
    var trace = getFrames(error);
    for (var i = 0; i < trace.length; i++) {
        var frame = trace[i];
        // Filter out the Frames which are part of stack capturing.
        if (!IGNORE_FRAMES.hasOwnProperty(frame)) {
            lines.push(trace[i]);
        }
    }
}
function renderLongStackTrace(frames, stack) {
    var longTrace = [stack ? stack.trim() : ''];
    if (frames) {
        var timestamp = new Date().getTime();
        for (var i = 0; i < frames.length; i++) {
            var traceFrames = frames[i];
            var lastTime = traceFrames.timestamp;
            var separator = "____________________Elapsed " + (timestamp - lastTime.getTime()) + " ms; At: " + lastTime;
            separator = separator.replace(/[^\w\d]/g, '_');
            longTrace.push(sepTemplate.replace(SEP_TAG, separator));
            addErrorStack(longTrace, traceFrames.error);
            timestamp = lastTime.getTime();
        }
    }
    return longTrace.join(NEWLINE);
}
Zone['longStackTraceZoneSpec'] = {
    name: 'long-stack-trace',
    longStackTraceLimit: 10,
    // add a getLongStackTrace method in spec to
    // handle handled reject promise error.
    getLongStackTrace: function (error) {
        if (!error) {
            return undefined;
        }
        var task = error[Zone.__symbol__('currentTask')];
        var trace = task && task.data && task.data[creationTrace];
        if (!trace) {
            return error.stack;
        }
        return renderLongStackTrace(trace, error.stack);
    },
    onScheduleTask: function (parentZoneDelegate, currentZone, targetZone, task) {
        if (Error.stackTraceLimit > 0) {
            // if Error.stackTraceLimit is 0, means stack trace
            // is disabled, so we don't need to generate long stack trace
            // this will improve performance in some test(some test will
            // set stackTraceLimit to 0, https://github.com/angular/zone.js/issues/698
            var currentTask = Zone.currentTask;
            var trace = currentTask && currentTask.data && currentTask.data[creationTrace] || [];
            trace = [new LongStackTrace()].concat(trace);
            if (trace.length > this.longStackTraceLimit) {
                trace.length = this.longStackTraceLimit;
            }
            if (!task.data)
                task.data = {};
            task.data[creationTrace] = trace;
        }
        return parentZoneDelegate.scheduleTask(targetZone, task);
    },
    onHandleError: function (parentZoneDelegate, currentZone, targetZone, error) {
        if (Error.stackTraceLimit > 0) {
            // if Error.stackTraceLimit is 0, means stack trace
            // is disabled, so we don't need to generate long stack trace
            // this will improve performance in some test(some test will
            // set stackTraceLimit to 0, https://github.com/angular/zone.js/issues/698
            var parentTask = Zone.currentTask || error.task;
            if (error instanceof Error && parentTask) {
                var longStack = renderLongStackTrace(parentTask.data && parentTask.data[creationTrace], error.stack);
                try {
                    error.stack = error.longStack = longStack;
                }
                catch (err) {
                }
            }
        }
        return parentZoneDelegate.handleError(targetZone, error);
    }
};
function captureStackTraces(stackTraces, count) {
    if (count > 0) {
        stackTraces.push(getFrames((new LongStackTrace()).error));
        captureStackTraces(stackTraces, count - 1);
    }
}
function computeIgnoreFrames() {
    if (Error.stackTraceLimit <= 0) {
        return;
    }
    var frames = [];
    captureStackTraces(frames, 2);
    var frames1 = frames[0];
    var frames2 = frames[1];
    for (var i = 0; i < frames1.length; i++) {
        var frame1 = frames1[i];
        if (frame1.indexOf(ERROR_TAG) == -1) {
            var match = frame1.match(/^\s*at\s+/);
            if (match) {
                sepTemplate = match[0] + SEP_TAG + ' (http://localhost)';
                break;
            }
        }
    }
    for (var i = 0; i < frames1.length; i++) {
        var frame1 = frames1[i];
        var frame2 = frames2[i];
        if (frame1 === frame2) {
            IGNORE_FRAMES[frame1] = true;
        }
        else {
            break;
        }
    }
}
computeIgnoreFrames();

})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
* @license
* Copyright Google Inc. All Rights Reserved.
*
* Use of this source code is governed by an MIT-style license that can be
* found in the LICENSE file at https://angular.io/license
*/
(function (global, factory) {
	 true ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Zone$1 = (function (global) {
    var FUNCTION = 'function';
    var performance = global['performance'];
    function mark(name) {
        performance && performance['mark'] && performance['mark'](name);
    }
    function performanceMeasure(name, label) {
        performance && performance['measure'] && performance['measure'](name, label);
    }
    mark('Zone');
    if (global['Zone']) {
        throw new Error('Zone already loaded.');
    }
    var Zone = (function () {
        function Zone(parent, zoneSpec) {
            this._properties = null;
            this._parent = parent;
            this._name = zoneSpec ? zoneSpec.name || 'unnamed' : '<root>';
            this._properties = zoneSpec && zoneSpec.properties || {};
            this._zoneDelegate =
                new ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
        }
        Zone.assertZonePatched = function () {
            if (global['Promise'] !== patches['ZoneAwarePromise']) {
                throw new Error('Zone.js has detected that ZoneAwarePromise `(window|global).Promise` ' +
                    'has been overwritten.\n' +
                    'Most likely cause is that a Promise polyfill has been loaded ' +
                    'after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. ' +
                    'If you must load one, do so before loading zone.js.)');
            }
        };
        Object.defineProperty(Zone, "root", {
            get: function () {
                var zone = Zone.current;
                while (zone.parent) {
                    zone = zone.parent;
                }
                return zone;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Zone, "current", {
            get: function () {
                return _currentZoneFrame.zone;
            },
            enumerable: true,
            configurable: true
        });
        
        Object.defineProperty(Zone, "currentTask", {
            get: function () {
                return _currentTask;
            },
            enumerable: true,
            configurable: true
        });
        
        Zone.__load_patch = function (name, fn) {
            if (patches.hasOwnProperty(name)) {
                throw Error('Already loaded patch: ' + name);
            }
            else if (!global['__Zone_disable_' + name]) {
                var perfName = 'Zone:' + name;
                mark(perfName);
                patches[name] = fn(global, Zone, _api);
                performanceMeasure(perfName, perfName);
            }
        };
        Object.defineProperty(Zone.prototype, "parent", {
            get: function () {
                return this._parent;
            },
            enumerable: true,
            configurable: true
        });
        
        Object.defineProperty(Zone.prototype, "name", {
            get: function () {
                return this._name;
            },
            enumerable: true,
            configurable: true
        });
        
        Zone.prototype.get = function (key) {
            var zone = this.getZoneWith(key);
            if (zone)
                return zone._properties[key];
        };
        Zone.prototype.getZoneWith = function (key) {
            var current = this;
            while (current) {
                if (current._properties.hasOwnProperty(key)) {
                    return current;
                }
                current = current._parent;
            }
            return null;
        };
        Zone.prototype.fork = function (zoneSpec) {
            if (!zoneSpec)
                throw new Error('ZoneSpec required!');
            return this._zoneDelegate.fork(this, zoneSpec);
        };
        Zone.prototype.wrap = function (callback, source) {
            if (typeof callback !== FUNCTION) {
                throw new Error('Expecting function got: ' + callback);
            }
            var _callback = this._zoneDelegate.intercept(this, callback, source);
            var zone = this;
            return function () {
                return zone.runGuarded(_callback, this, arguments, source);
            };
        };
        Zone.prototype.run = function (callback, applyThis, applyArgs, source) {
            if (applyThis === void 0) { applyThis = undefined; }
            if (applyArgs === void 0) { applyArgs = null; }
            if (source === void 0) { source = null; }
            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
            try {
                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
            }
            finally {
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        };
        Zone.prototype.runGuarded = function (callback, applyThis, applyArgs, source) {
            if (applyThis === void 0) { applyThis = null; }
            if (applyArgs === void 0) { applyArgs = null; }
            if (source === void 0) { source = null; }
            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
            try {
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                }
                catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) {
                        throw error;
                    }
                }
            }
            finally {
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        };
        Zone.prototype.runTask = function (task, applyThis, applyArgs) {
            if (task.zone != this) {
                throw new Error('A task can only be run in the zone of creation! (Creation: ' +
                    (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            }
            // https://github.com/angular/zone.js/issues/778, sometimes eventTask
            // will run in notScheduled(canceled) state, we should not try to
            // run such kind of task but just return
            // we have to define an variable here, if not
            // typescript compiler will complain below
            var isNotScheduled = task.state === notScheduled;
            if (isNotScheduled && task.type === eventTask) {
                return;
            }
            var reEntryGuard = task.state != running;
            reEntryGuard && task._transitionTo(running, scheduled);
            task.runCount++;
            var previousTask = _currentTask;
            _currentTask = task;
            _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
            try {
                if (task.type == macroTask && task.data && !task.data.isPeriodic) {
                    task.cancelFn = null;
                }
                try {
                    return this._zoneDelegate.invokeTask(this, task, applyThis, applyArgs);
                }
                catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) {
                        throw error;
                    }
                }
            }
            finally {
                // if the task's state is notScheduled or unknown, then it has already been cancelled
                // we should not reset the state to scheduled
                if (task.state !== notScheduled && task.state !== unknown) {
                    if (task.type == eventTask || (task.data && task.data.isPeriodic)) {
                        reEntryGuard && task._transitionTo(scheduled, running);
                    }
                    else {
                        task.runCount = 0;
                        this._updateTaskCount(task, -1);
                        reEntryGuard &&
                            task._transitionTo(notScheduled, running, notScheduled);
                    }
                }
                _currentZoneFrame = _currentZoneFrame.parent;
                _currentTask = previousTask;
            }
        };
        Zone.prototype.scheduleTask = function (task) {
            if (task.zone && task.zone !== this) {
                // check if the task was rescheduled, the newZone
                // should not be the children of the original zone
                var newZone = this;
                while (newZone) {
                    if (newZone === task.zone) {
                        throw Error("can not reschedule task to " + this
                            .name + " which is descendants of the original zone " + task.zone.name);
                    }
                    newZone = newZone.parent;
                }
            }
            task._transitionTo(scheduling, notScheduled);
            var zoneDelegates = [];
            task._zoneDelegates = zoneDelegates;
            task._zone = this;
            try {
                task = this._zoneDelegate.scheduleTask(this, task);
            }
            catch (err) {
                // should set task's state to unknown when scheduleTask throw error
                // because the err may from reschedule, so the fromState maybe notScheduled
                task._transitionTo(unknown, scheduling, notScheduled);
                // TODO: @JiaLiPassion, should we check the result from handleError?
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            if (task._zoneDelegates === zoneDelegates) {
                // we have to check because internally the delegate can reschedule the task.
                this._updateTaskCount(task, 1);
            }
            if (task.state == scheduling) {
                task._transitionTo(scheduled, scheduling);
            }
            return task;
        };
        Zone.prototype.scheduleMicroTask = function (source, callback, data, customSchedule) {
            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, null));
        };
        Zone.prototype.scheduleMacroTask = function (source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
        };
        Zone.prototype.scheduleEventTask = function (source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
        };
        Zone.prototype.cancelTask = function (task) {
            if (task.zone != this)
                throw new Error('A task can only be cancelled in the zone of creation! (Creation: ' +
                    (task.zone || NO_ZONE).name + '; Execution: ' + this.name + ')');
            task._transitionTo(canceling, scheduled, running);
            try {
                this._zoneDelegate.cancelTask(this, task);
            }
            catch (err) {
                // if error occurs when cancelTask, transit the state to unknown
                task._transitionTo(unknown, canceling);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            this._updateTaskCount(task, -1);
            task._transitionTo(notScheduled, canceling);
            task.runCount = 0;
            return task;
        };
        Zone.prototype._updateTaskCount = function (task, count) {
            var zoneDelegates = task._zoneDelegates;
            if (count == -1) {
                task._zoneDelegates = null;
            }
            for (var i = 0; i < zoneDelegates.length; i++) {
                zoneDelegates[i]._updateTaskCount(task.type, count);
            }
        };
        return Zone;
    }());
    Zone.__symbol__ = __symbol__;
    var DELEGATE_ZS = {
        name: '',
        onHasTask: function (delegate, _, target, hasTaskState) {
            return delegate.hasTask(target, hasTaskState);
        },
        onScheduleTask: function (delegate, _, target, task) {
            return delegate.scheduleTask(target, task);
        },
        onInvokeTask: function (delegate, _, target, task, applyThis, applyArgs) { return delegate.invokeTask(target, task, applyThis, applyArgs); },
        onCancelTask: function (delegate, _, target, task) {
            return delegate.cancelTask(target, task);
        }
    };
    var ZoneDelegate = (function () {
        function ZoneDelegate(zone, parentDelegate, zoneSpec) {
            this._taskCounts = { 'microTask': 0, 'macroTask': 0, 'eventTask': 0 };
            this.zone = zone;
            this._parentDelegate = parentDelegate;
            this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
            this._forkCurrZone = zoneSpec && (zoneSpec.onFork ? this.zone : parentDelegate.zone);
            this._interceptZS =
                zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
            this._interceptDlgt =
                zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
            this._interceptCurrZone =
                zoneSpec && (zoneSpec.onIntercept ? this.zone : parentDelegate.zone);
            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
            this._invokeDlgt =
                zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
            this._invokeCurrZone = zoneSpec && (zoneSpec.onInvoke ? this.zone : parentDelegate.zone);
            this._handleErrorZS =
                zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
            this._handleErrorDlgt =
                zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
            this._handleErrorCurrZone =
                zoneSpec && (zoneSpec.onHandleError ? this.zone : parentDelegate.zone);
            this._scheduleTaskZS =
                zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
            this._scheduleTaskDlgt =
                zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
            this._scheduleTaskCurrZone =
                zoneSpec && (zoneSpec.onScheduleTask ? this.zone : parentDelegate.zone);
            this._invokeTaskZS =
                zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
            this._invokeTaskDlgt =
                zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
            this._invokeTaskCurrZone =
                zoneSpec && (zoneSpec.onInvokeTask ? this.zone : parentDelegate.zone);
            this._cancelTaskZS =
                zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
            this._cancelTaskDlgt =
                zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
            this._cancelTaskCurrZone =
                zoneSpec && (zoneSpec.onCancelTask ? this.zone : parentDelegate.zone);
            this._hasTaskZS = null;
            this._hasTaskDlgt = null;
            this._hasTaskDlgtOwner = null;
            this._hasTaskCurrZone = null;
            var zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
            var parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
            if (zoneSpecHasTask || parentHasTask) {
                // If we need to report hasTask, than this ZS needs to do ref counting on tasks. In such
                // a case all task related interceptors must go through this ZD. We can't short circuit it.
                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                this._hasTaskDlgt = parentDelegate;
                this._hasTaskDlgtOwner = this;
                this._hasTaskCurrZone = zone;
                if (!zoneSpec.onScheduleTask) {
                    this._scheduleTaskZS = DELEGATE_ZS;
                    this._scheduleTaskDlgt = parentDelegate;
                    this._scheduleTaskCurrZone = this.zone;
                }
                if (!zoneSpec.onInvokeTask) {
                    this._invokeTaskZS = DELEGATE_ZS;
                    this._invokeTaskDlgt = parentDelegate;
                    this._invokeTaskCurrZone = this.zone;
                }
                if (!zoneSpec.onCancelTask) {
                    this._cancelTaskZS = DELEGATE_ZS;
                    this._cancelTaskDlgt = parentDelegate;
                    this._cancelTaskCurrZone = this.zone;
                }
            }
        }
        ZoneDelegate.prototype.fork = function (targetZone, zoneSpec) {
            return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) :
                new Zone(targetZone, zoneSpec);
        };
        ZoneDelegate.prototype.intercept = function (targetZone, callback, source) {
            return this._interceptZS ?
                this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) :
                callback;
        };
        ZoneDelegate.prototype.invoke = function (targetZone, callback, applyThis, applyArgs, source) {
            return this._invokeZS ?
                this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) :
                callback.apply(applyThis, applyArgs);
        };
        ZoneDelegate.prototype.handleError = function (targetZone, error) {
            return this._handleErrorZS ?
                this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) :
                true;
        };
        ZoneDelegate.prototype.scheduleTask = function (targetZone, task) {
            var returnTask = task;
            if (this._scheduleTaskZS) {
                if (this._hasTaskZS) {
                    returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                }
                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                if (!returnTask)
                    returnTask = task;
            }
            else {
                if (task.scheduleFn) {
                    task.scheduleFn(task);
                }
                else if (task.type == microTask) {
                    scheduleMicroTask(task);
                }
                else {
                    throw new Error('Task is missing scheduleFn.');
                }
            }
            return returnTask;
        };
        ZoneDelegate.prototype.invokeTask = function (targetZone, task, applyThis, applyArgs) {
            return this._invokeTaskZS ?
                this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) :
                task.callback.apply(applyThis, applyArgs);
        };
        ZoneDelegate.prototype.cancelTask = function (targetZone, task) {
            var value;
            if (this._cancelTaskZS) {
                value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
            }
            else {
                if (!task.cancelFn) {
                    throw Error('Task is not cancelable');
                }
                value = task.cancelFn(task);
            }
            return value;
        };
        ZoneDelegate.prototype.hasTask = function (targetZone, isEmpty) {
            // hasTask should not throw error so other ZoneDelegate
            // can still trigger hasTask callback
            try {
                return this._hasTaskZS &&
                    this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
            }
            catch (err) {
                this.handleError(targetZone, err);
            }
        };
        ZoneDelegate.prototype._updateTaskCount = function (type, count) {
            var counts = this._taskCounts;
            var prev = counts[type];
            var next = counts[type] = prev + count;
            if (next < 0) {
                throw new Error('More tasks executed then were scheduled.');
            }
            if (prev == 0 || next == 0) {
                var isEmpty = {
                    microTask: counts['microTask'] > 0,
                    macroTask: counts['macroTask'] > 0,
                    eventTask: counts['eventTask'] > 0,
                    change: type
                };
                this.hasTask(this.zone, isEmpty);
            }
        };
        return ZoneDelegate;
    }());
    var ZoneTask = (function () {
        function ZoneTask(type, source, callback, options, scheduleFn, cancelFn) {
            this._zone = null;
            this.runCount = 0;
            this._zoneDelegates = null;
            this._state = 'notScheduled';
            this.type = type;
            this.source = source;
            this.data = options;
            this.scheduleFn = scheduleFn;
            this.cancelFn = cancelFn;
            this.callback = callback;
            var self = this;
            if (type === eventTask && options && options.isUsingGlobalCallback) {
                this.invoke = ZoneTask.invokeTask;
            }
            else {
                this.invoke = function () {
                    return ZoneTask.invokeTask.apply(global, [self, this, arguments]);
                };
            }
        }
        ZoneTask.invokeTask = function (task, target, args) {
            if (!task) {
                task = this;
            }
            _numberOfNestedTaskFrames++;
            try {
                task.runCount++;
                return task.zone.runTask(task, target, args);
            }
            finally {
                if (_numberOfNestedTaskFrames == 1) {
                    drainMicroTaskQueue();
                }
                _numberOfNestedTaskFrames--;
            }
        };
        Object.defineProperty(ZoneTask.prototype, "zone", {
            get: function () {
                return this._zone;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ZoneTask.prototype, "state", {
            get: function () {
                return this._state;
            },
            enumerable: true,
            configurable: true
        });
        ZoneTask.prototype.cancelScheduleRequest = function () {
            this._transitionTo(notScheduled, scheduling);
        };
        ZoneTask.prototype._transitionTo = function (toState, fromState1, fromState2) {
            if (this._state === fromState1 || this._state === fromState2) {
                this._state = toState;
                if (toState == notScheduled) {
                    this._zoneDelegates = null;
                }
            }
            else {
                throw new Error(this.type + " '" + this.source + "': can not transition to '" + toState + "', expecting state '" + fromState1 + "'" + (fromState2 ?
                    ' or \'' + fromState2 + '\'' :
                    '') + ", was '" + this._state + "'.");
            }
        };
        ZoneTask.prototype.toString = function () {
            if (this.data && typeof this.data.handleId !== 'undefined') {
                return this.data.handleId;
            }
            else {
                return Object.prototype.toString.call(this);
            }
        };
        // add toJSON method to prevent cyclic error when
        // call JSON.stringify(zoneTask)
        ZoneTask.prototype.toJSON = function () {
            return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                invoke: this.invoke,
                scheduleFn: this.scheduleFn,
                cancelFn: this.cancelFn,
                runCount: this.runCount,
                callback: this.callback
            };
        };
        return ZoneTask;
    }());
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  MICROTASK QUEUE
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    var symbolSetTimeout = __symbol__('setTimeout');
    var symbolPromise = __symbol__('Promise');
    var symbolThen = __symbol__('then');
    var _microTaskQueue = [];
    var _isDrainingMicrotaskQueue = false;
    var nativeMicroTaskQueuePromise;
    function scheduleMicroTask(task) {
        // if we are not running in any task, and there has not been anything scheduled
        // we must bootstrap the initial task creation by manually scheduling the drain
        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) {
            // We are not running in Task, so we need to kickstart the microtask queue.
            if (!nativeMicroTaskQueuePromise) {
                if (global[symbolPromise]) {
                    nativeMicroTaskQueuePromise = global[symbolPromise].resolve(0);
                }
            }
            if (nativeMicroTaskQueuePromise) {
                nativeMicroTaskQueuePromise[symbolThen](drainMicroTaskQueue);
            }
            else {
                global[symbolSetTimeout](drainMicroTaskQueue, 0);
            }
        }
        task && _microTaskQueue.push(task);
    }
    function drainMicroTaskQueue() {
        if (!_isDrainingMicrotaskQueue) {
            _isDrainingMicrotaskQueue = true;
            while (_microTaskQueue.length) {
                var queue = _microTaskQueue;
                _microTaskQueue = [];
                for (var i = 0; i < queue.length; i++) {
                    var task = queue[i];
                    try {
                        task.zone.runTask(task, null, null);
                    }
                    catch (error) {
                        _api.onUnhandledError(error);
                    }
                }
            }
            var showError = !Zone[__symbol__('ignoreConsoleErrorUncaughtError')];
            _api.microtaskDrainDone();
            _isDrainingMicrotaskQueue = false;
        }
    }
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    ///  BOOTSTRAP
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    var NO_ZONE = { name: 'NO ZONE' };
    var notScheduled = 'notScheduled', scheduling = 'scheduling', scheduled = 'scheduled', running = 'running', canceling = 'canceling', unknown = 'unknown';
    var microTask = 'microTask', macroTask = 'macroTask', eventTask = 'eventTask';
    var patches = {};
    var _api = {
        symbol: __symbol__,
        currentZoneFrame: function () { return _currentZoneFrame; },
        onUnhandledError: noop,
        microtaskDrainDone: noop,
        scheduleMicroTask: scheduleMicroTask,
        showUncaughtError: function () { return !Zone[__symbol__('ignoreConsoleErrorUncaughtError')]; },
        patchEventTarget: function () { return []; },
        patchOnProperties: noop,
        patchMethod: function () { return noop; },
    };
    var _currentZoneFrame = { parent: null, zone: new Zone(null, null) };
    var _currentTask = null;
    var _numberOfNestedTaskFrames = 0;
    function noop() { }
    function __symbol__(name) {
        return '__zone_symbol__' + name;
    }
    performanceMeasure('Zone', 'Zone');
    return global['Zone'] = Zone;
})(typeof window !== 'undefined' && window || typeof self !== 'undefined' && self || global);

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
Zone.__load_patch('ZoneAwarePromise', function (global, Zone, api) {
    var __symbol__ = api.symbol;
    var _uncaughtPromiseErrors = [];
    var symbolPromise = __symbol__('Promise');
    var symbolThen = __symbol__('then');
    api.onUnhandledError = function (e) {
        if (api.showUncaughtError()) {
            var rejection = e && e.rejection;
            if (rejection) {
                console.error('Unhandled Promise rejection:', rejection instanceof Error ? rejection.message : rejection, '; Zone:', e.zone.name, '; Task:', e.task && e.task.source, '; Value:', rejection, rejection instanceof Error ? rejection.stack : undefined);
            }
            else {
                console.error(e);
            }
        }
    };
    api.microtaskDrainDone = function () {
        while (_uncaughtPromiseErrors.length) {
            var _loop_1 = function () {
                var uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                try {
                    uncaughtPromiseError.zone.runGuarded(function () {
                        throw uncaughtPromiseError;
                    });
                }
                catch (error) {
                    handleUnhandledRejection(error);
                }
            };
            while (_uncaughtPromiseErrors.length) {
                _loop_1();
            }
        }
    };
    var UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__('unhandledPromiseRejectionHandler');
    function handleUnhandledRejection(e) {
        api.onUnhandledError(e);
        try {
            var handler = Zone[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
            if (handler && typeof handler === 'function') {
                handler.apply(this, [e]);
            }
        }
        catch (err) {
        }
    }
    function isThenable(value) {
        return value && value.then;
    }
    function forwardResolution(value) {
        return value;
    }
    function forwardRejection(rejection) {
        return ZoneAwarePromise.reject(rejection);
    }
    var symbolState = __symbol__('state');
    var symbolValue = __symbol__('value');
    var source = 'Promise.then';
    var UNRESOLVED = null;
    var RESOLVED = true;
    var REJECTED = false;
    var REJECTED_NO_CATCH = 0;
    function makeResolver(promise, state) {
        return function (v) {
            try {
                resolvePromise(promise, state, v);
            }
            catch (err) {
                resolvePromise(promise, false, err);
            }
            // Do not return value or you will break the Promise spec.
        };
    }
    var once = function () {
        var wasCalled = false;
        return function wrapper(wrappedFunction) {
            return function () {
                if (wasCalled) {
                    return;
                }
                wasCalled = true;
                wrappedFunction.apply(null, arguments);
            };
        };
    };
    var TYPE_ERROR = 'Promise resolved with itself';
    var OBJECT = 'object';
    var FUNCTION = 'function';
    var CURRENT_TASK_SYMBOL = __symbol__('currentTask');
    // Promise Resolution
    function resolvePromise(promise, state, value) {
        var onceWrapper = once();
        if (promise === value) {
            throw new TypeError(TYPE_ERROR);
        }
        if (promise[symbolState] === UNRESOLVED) {
            // should only get value.then once based on promise spec.
            var then = null;
            try {
                if (typeof value === OBJECT || typeof value === FUNCTION) {
                    then = value && value.then;
                }
            }
            catch (err) {
                onceWrapper(function () {
                    resolvePromise(promise, false, err);
                })();
                return promise;
            }
            // if (value instanceof ZoneAwarePromise) {
            if (state !== REJECTED && value instanceof ZoneAwarePromise &&
                value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) &&
                value[symbolState] !== UNRESOLVED) {
                clearRejectedNoCatch(value);
                resolvePromise(promise, value[symbolState], value[symbolValue]);
            }
            else if (state !== REJECTED && typeof then === FUNCTION) {
                try {
                    then.apply(value, [
                        onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false))
                    ]);
                }
                catch (err) {
                    onceWrapper(function () {
                        resolvePromise(promise, false, err);
                    })();
                }
            }
            else {
                promise[symbolState] = state;
                var queue = promise[symbolValue];
                promise[symbolValue] = value;
                // record task information in value when error occurs, so we can
                // do some additional work such as render longStackTrace
                if (state === REJECTED && value instanceof Error) {
                    value[CURRENT_TASK_SYMBOL] = Zone.currentTask;
                }
                for (var i = 0; i < queue.length;) {
                    scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                }
                if (queue.length == 0 && state == REJECTED) {
                    promise[symbolState] = REJECTED_NO_CATCH;
                    try {
                        throw new Error('Uncaught (in promise): ' + value +
                            (value && value.stack ? '\n' + value.stack : ''));
                    }
                    catch (err) {
                        var error_1 = err;
                        error_1.rejection = value;
                        error_1.promise = promise;
                        error_1.zone = Zone.current;
                        error_1.task = Zone.currentTask;
                        _uncaughtPromiseErrors.push(error_1);
                        api.scheduleMicroTask(); // to make sure that it is running
                    }
                }
            }
        }
        // Resolving an already resolved promise is a noop.
        return promise;
    }
    var REJECTION_HANDLED_HANDLER = __symbol__('rejectionHandledHandler');
    function clearRejectedNoCatch(promise) {
        if (promise[symbolState] === REJECTED_NO_CATCH) {
            // if the promise is rejected no catch status
            // and queue.length > 0, means there is a error handler
            // here to handle the rejected promise, we should trigger
            // windows.rejectionhandled eventHandler or nodejs rejectionHandled
            // eventHandler
            try {
                var handler = Zone[REJECTION_HANDLED_HANDLER];
                if (handler && typeof handler === FUNCTION) {
                    handler.apply(this, [{ rejection: promise[symbolValue], promise: promise }]);
                }
            }
            catch (err) {
            }
            promise[symbolState] = REJECTED;
            for (var i = 0; i < _uncaughtPromiseErrors.length; i++) {
                if (promise === _uncaughtPromiseErrors[i].promise) {
                    _uncaughtPromiseErrors.splice(i, 1);
                }
            }
        }
    }
    function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
        clearRejectedNoCatch(promise);
        var delegate = promise[symbolState] ?
            (typeof onFulfilled === FUNCTION) ? onFulfilled : forwardResolution :
            (typeof onRejected === FUNCTION) ? onRejected : forwardRejection;
        zone.scheduleMicroTask(source, function () {
            try {
                resolvePromise(chainPromise, true, zone.run(delegate, undefined, [promise[symbolValue]]));
            }
            catch (error) {
                resolvePromise(chainPromise, false, error);
            }
        });
    }
    var ZONE_AWARE_PROMISE_TO_STRING = 'function ZoneAwarePromise() { [native code] }';
    var ZoneAwarePromise = (function () {
        function ZoneAwarePromise(executor) {
            var promise = this;
            if (!(promise instanceof ZoneAwarePromise)) {
                throw new Error('Must be an instanceof Promise.');
            }
            promise[symbolState] = UNRESOLVED;
            promise[symbolValue] = []; // queue;
            try {
                executor && executor(makeResolver(promise, RESOLVED), makeResolver(promise, REJECTED));
            }
            catch (error) {
                resolvePromise(promise, false, error);
            }
        }
        ZoneAwarePromise.toString = function () {
            return ZONE_AWARE_PROMISE_TO_STRING;
        };
        ZoneAwarePromise.resolve = function (value) {
            return resolvePromise(new this(null), RESOLVED, value);
        };
        ZoneAwarePromise.reject = function (error) {
            return resolvePromise(new this(null), REJECTED, error);
        };
        ZoneAwarePromise.race = function (values) {
            var resolve;
            var reject;
            var promise = new this(function (res, rej) {
                _a = [res, rej], resolve = _a[0], reject = _a[1];
                var _a;
            });
            function onResolve(value) {
                promise && (promise = null || resolve(value));
            }
            function onReject(error) {
                promise && (promise = null || reject(error));
            }
            for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                var value = values_1[_i];
                if (!isThenable(value)) {
                    value = this.resolve(value);
                }
                value.then(onResolve, onReject);
            }
            return promise;
        };
        ZoneAwarePromise.all = function (values) {
            var resolve;
            var reject;
            var promise = new this(function (res, rej) {
                resolve = res;
                reject = rej;
            });
            var count = 0;
            var resolvedValues = [];
            for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
                var value = values_2[_i];
                if (!isThenable(value)) {
                    value = this.resolve(value);
                }
                value.then((function (index) { return function (value) {
                    resolvedValues[index] = value;
                    count--;
                    if (!count) {
                        resolve(resolvedValues);
                    }
                }; })(count), reject);
                count++;
            }
            if (!count)
                resolve(resolvedValues);
            return promise;
        };
        ZoneAwarePromise.prototype.then = function (onFulfilled, onRejected) {
            var chainPromise = new this.constructor(null);
            var zone = Zone.current;
            if (this[symbolState] == UNRESOLVED) {
                this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
            }
            else {
                scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
            }
            return chainPromise;
        };
        ZoneAwarePromise.prototype.catch = function (onRejected) {
            return this.then(null, onRejected);
        };
        return ZoneAwarePromise;
    }());
    // Protect against aggressive optimizers dropping seemingly unused properties.
    // E.g. Closure Compiler in advanced mode.
    ZoneAwarePromise['resolve'] = ZoneAwarePromise.resolve;
    ZoneAwarePromise['reject'] = ZoneAwarePromise.reject;
    ZoneAwarePromise['race'] = ZoneAwarePromise.race;
    ZoneAwarePromise['all'] = ZoneAwarePromise.all;
    var NativePromise = global[symbolPromise] = global['Promise'];
    global['Promise'] = ZoneAwarePromise;
    var symbolThenPatched = __symbol__('thenPatched');
    function patchThen(Ctor) {
        var proto = Ctor.prototype;
        var originalThen = proto.then;
        // Keep a reference to the original method.
        proto[symbolThen] = originalThen;
        // check Ctor.prototype.then propertyDescritor is writable or not
        // in meteor env, writable is false, we have to make it to be true.
        var prop = Object.getOwnPropertyDescriptor(Ctor.prototype, 'then');
        if (prop && prop.writable === false && prop.configurable) {
            Object.defineProperty(Ctor.prototype, 'then', { writable: true });
        }
        Ctor.prototype.then = function (onResolve, onReject) {
            var _this = this;
            var wrapped = new ZoneAwarePromise(function (resolve, reject) {
                originalThen.call(_this, resolve, reject);
            });
            return wrapped.then(onResolve, onReject);
        };
        Ctor[symbolThenPatched] = true;
    }
    function zoneify(fn) {
        return function () {
            var resultPromise = fn.apply(this, arguments);
            if (resultPromise instanceof ZoneAwarePromise) {
                return resultPromise;
            }
            var ctor = resultPromise.constructor;
            if (!ctor[symbolThenPatched]) {
                patchThen(ctor);
            }
            return resultPromise;
        };
    }
    if (NativePromise) {
        patchThen(NativePromise);
        var fetch_1 = global['fetch'];
        if (typeof fetch_1 == FUNCTION) {
            global['fetch'] = zoneify(fetch_1);
        }
    }
    // This is not part of public API, but it is useful for tests, so we expose it.
    Promise[Zone.__symbol__('uncaughtPromiseErrors')] = _uncaughtPromiseErrors;
    return ZoneAwarePromise;
});

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Suppress closure compiler errors about unknown 'Zone' variable
 * @fileoverview
 * @suppress {undefinedVars,globalThis,missingRequire}
 */
var zoneSymbol = Zone.__symbol__;
var _global = typeof window === 'object' && window || typeof self === 'object' && self || global;
var FUNCTION = 'function';
var UNDEFINED = 'undefined';
var REMOVE_ATTRIBUTE = 'removeAttribute';
function bindArguments(args, source) {
    for (var i = args.length - 1; i >= 0; i--) {
        if (typeof args[i] === FUNCTION) {
            args[i] = Zone.current.wrap(args[i], source + '_' + i);
        }
    }
    return args;
}
function patchPrototype(prototype, fnNames) {
    var source = prototype.constructor['name'];
    var _loop_1 = function (i) {
        var name_1 = fnNames[i];
        var delegate = prototype[name_1];
        if (delegate) {
            var prototypeDesc = Object.getOwnPropertyDescriptor(prototype, name_1);
            if (!isPropertyWritable(prototypeDesc)) {
                return "continue";
            }
            prototype[name_1] = (function (delegate) {
                var patched = function () {
                    return delegate.apply(this, bindArguments(arguments, source + '.' + name_1));
                };
                attachOriginToPatched(patched, delegate);
                return patched;
            })(delegate);
        }
    };
    for (var i = 0; i < fnNames.length; i++) {
        _loop_1(i);
    }
}
function isPropertyWritable(propertyDesc) {
    if (!propertyDesc) {
        return true;
    }
    if (propertyDesc.writable === false) {
        return false;
    }
    if (typeof propertyDesc.get === FUNCTION && typeof propertyDesc.set === UNDEFINED) {
        return false;
    }
    return true;
}
var isWebWorker = (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope);
// Make sure to access `process` through `_global` so that WebPack does not accidently browserify
// this code.
var isNode = (!('nw' in _global) && typeof _global.process !== 'undefined' &&
    {}.toString.call(_global.process) === '[object process]');
var isBrowser = !isNode && !isWebWorker && !!(typeof window !== 'undefined' && window['HTMLElement']);
// we are in electron of nw, so we are both browser and nodejs
// Make sure to access `process` through `_global` so that WebPack does not accidently browserify
// this code.
var isMix = typeof _global.process !== 'undefined' &&
    {}.toString.call(_global.process) === '[object process]' && !isWebWorker &&
    !!(typeof window !== 'undefined' && window['HTMLElement']);
var ON_PROPERTY_HANDLER_SYMBOL = zoneSymbol('onPropertyHandler');
var zoneSymbolEventNames = {};
var wrapFn = function (event) {
    var eventNameSymbol = zoneSymbolEventNames[event.type];
    if (!eventNameSymbol) {
        eventNameSymbol = zoneSymbolEventNames[event.type] = zoneSymbol('ON_PROPERTY' + event.type);
    }
    var listener = this[eventNameSymbol];
    var result = listener && listener.apply(this, arguments);
    if (result != undefined && !result) {
        event.preventDefault();
    }
    return result;
};
function patchProperty(obj, prop, prototype) {
    var desc = Object.getOwnPropertyDescriptor(obj, prop);
    if (!desc && prototype) {
        // when patch window object, use prototype to check prop exist or not
        var prototypeDesc = Object.getOwnPropertyDescriptor(prototype, prop);
        if (prototypeDesc) {
            desc = { enumerable: true, configurable: true };
        }
    }
    // if the descriptor not exists or is not configurable
    // just return
    if (!desc || !desc.configurable) {
        return;
    }
    // A property descriptor cannot have getter/setter and be writable
    // deleting the writable and value properties avoids this error:
    //
    // TypeError: property descriptors must not specify a value or be writable when a
    // getter or setter has been specified
    delete desc.writable;
    delete desc.value;
    var originalDescGet = desc.get;
    // substr(2) cuz 'onclick' -> 'click', etc
    var eventName = prop.substr(2);
    var eventNameSymbol = zoneSymbolEventNames[eventName];
    if (!eventNameSymbol) {
        eventNameSymbol = zoneSymbolEventNames[eventName] = zoneSymbol('ON_PROPERTY' + eventName);
    }
    desc.set = function (newValue) {
        // in some of windows's onproperty callback, this is undefined
        // so we need to check it
        var target = this;
        if (!target && obj === _global) {
            target = _global;
        }
        if (!target) {
            return;
        }
        var previousValue = target[eventNameSymbol];
        if (previousValue) {
            target.removeEventListener(eventName, wrapFn);
        }
        if (typeof newValue === 'function') {
            target[eventNameSymbol] = newValue;
            target.addEventListener(eventName, wrapFn, false);
        }
        else {
            target[eventNameSymbol] = null;
        }
    };
    // The getter would return undefined for unassigned properties but the default value of an
    // unassigned property is null
    desc.get = function () {
        // in some of windows's onproperty callback, this is undefined
        // so we need to check it
        var target = this;
        if (!target && obj === _global) {
            target = _global;
        }
        if (!target) {
            return null;
        }
        if (target[eventNameSymbol]) {
            return wrapFn;
        }
        else if (originalDescGet) {
            // result will be null when use inline event attribute,
            // such as <button onclick="func();">OK</button>
            // because the onclick function is internal raw uncompiled handler
            // the onclick will be evaluated when first time event was triggered or
            // the property is accessed, https://github.com/angular/zone.js/issues/525
            // so we should use original native get to retrieve the handler
            var value = originalDescGet && originalDescGet.apply(this);
            if (value) {
                desc.set.apply(this, [value]);
                if (typeof target[REMOVE_ATTRIBUTE] === FUNCTION) {
                    target.removeAttribute(prop);
                }
                return value;
            }
        }
        return null;
    };
    Object.defineProperty(obj, prop, desc);
}
function patchOnProperties(obj, properties, prototype) {
    if (properties) {
        for (var i = 0; i < properties.length; i++) {
            patchProperty(obj, 'on' + properties[i], prototype);
        }
    }
    else {
        var onProperties = [];
        for (var prop in obj) {
            if (prop.substr(0, 2) == 'on') {
                onProperties.push(prop);
            }
        }
        for (var j = 0; j < onProperties.length; j++) {
            patchProperty(obj, onProperties[j], prototype);
        }
    }
}
var originalInstanceKey = zoneSymbol('originalInstance');
// wrap some native API on `window`
function patchClass(className) {
    var OriginalClass = _global[className];
    if (!OriginalClass)
        return;
    // keep original class in global
    _global[zoneSymbol(className)] = OriginalClass;
    _global[className] = function () {
        var a = bindArguments(arguments, className);
        switch (a.length) {
            case 0:
                this[originalInstanceKey] = new OriginalClass();
                break;
            case 1:
                this[originalInstanceKey] = new OriginalClass(a[0]);
                break;
            case 2:
                this[originalInstanceKey] = new OriginalClass(a[0], a[1]);
                break;
            case 3:
                this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                break;
            case 4:
                this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                break;
            default:
                throw new Error('Arg list too long.');
        }
    };
    // attach original delegate to patched function
    attachOriginToPatched(_global[className], OriginalClass);
    var instance = new OriginalClass(function () { });
    var prop;
    for (prop in instance) {
        // https://bugs.webkit.org/show_bug.cgi?id=44721
        if (className === 'XMLHttpRequest' && prop === 'responseBlob')
            continue;
        (function (prop) {
            if (typeof instance[prop] === 'function') {
                _global[className].prototype[prop] = function () {
                    return this[originalInstanceKey][prop].apply(this[originalInstanceKey], arguments);
                };
            }
            else {
                Object.defineProperty(_global[className].prototype, prop, {
                    set: function (fn) {
                        if (typeof fn === 'function') {
                            this[originalInstanceKey][prop] = Zone.current.wrap(fn, className + '.' + prop);
                            // keep callback in wrapped function so we can
                            // use it in Function.prototype.toString to return
                            // the native one.
                            attachOriginToPatched(this[originalInstanceKey][prop], fn);
                        }
                        else {
                            this[originalInstanceKey][prop] = fn;
                        }
                    },
                    get: function () {
                        return this[originalInstanceKey][prop];
                    }
                });
            }
        }(prop));
    }
    for (prop in OriginalClass) {
        if (prop !== 'prototype' && OriginalClass.hasOwnProperty(prop)) {
            _global[className][prop] = OriginalClass[prop];
        }
    }
}
function patchMethod(target, name, patchFn) {
    var proto = target;
    while (proto && !proto.hasOwnProperty(name)) {
        proto = Object.getPrototypeOf(proto);
    }
    if (!proto && target[name]) {
        // somehow we did not find it, but we can see it. This happens on IE for Window properties.
        proto = target;
    }
    var delegateName = zoneSymbol(name);
    var delegate;
    if (proto && !(delegate = proto[delegateName])) {
        delegate = proto[delegateName] = proto[name];
        // check whether proto[name] is writable
        // some property is readonly in safari, such as HtmlCanvasElement.prototype.toBlob
        var desc = proto && Object.getOwnPropertyDescriptor(proto, name);
        if (isPropertyWritable(desc)) {
            var patchDelegate_1 = patchFn(delegate, delegateName, name);
            proto[name] = function () {
                return patchDelegate_1(this, arguments);
            };
            attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
// TODO: @JiaLiPassion, support cancel task later if necessary
function patchMacroTask(obj, funcName, metaCreator) {
    var setNative = null;
    function scheduleTask(task) {
        var data = task.data;
        data.args[data.callbackIndex] = function () {
            task.invoke.apply(this, arguments);
        };
        setNative.apply(data.target, data.args);
        return task;
    }
    setNative = patchMethod(obj, funcName, function (delegate) { return function (self, args) {
        var meta = metaCreator(self, args);
        if (meta.callbackIndex >= 0 && typeof args[meta.callbackIndex] === 'function') {
            var task = Zone.current.scheduleMacroTask(meta.name, args[meta.callbackIndex], meta, scheduleTask, null);
            return task;
        }
        else {
            // cause an error by calling it directly.
            return delegate.apply(self, args);
        }
    }; });
}

function attachOriginToPatched(patched, original) {
    patched[zoneSymbol('OriginalDelegate')] = original;
}
var isDetectedIEOrEdge = false;
var ieOrEdge = false;
function isIEOrEdge() {
    if (isDetectedIEOrEdge) {
        return ieOrEdge;
    }
    isDetectedIEOrEdge = true;
    try {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1 || ua.indexOf('Edge/') !== -1) {
            ieOrEdge = true;
        }
        return ieOrEdge;
    }
    catch (error) {
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// override Function.prototype.toString to make zone.js patched function
// look like native function
Zone.__load_patch('toString', function (global, Zone, api) {
    // patch Func.prototype.toString to let them look like native
    var originalFunctionToString = Zone['__zone_symbol__originalToString'] =
        Function.prototype.toString;
    var FUNCTION = 'function';
    var ORIGINAL_DELEGATE_SYMBOL = zoneSymbol('OriginalDelegate');
    var PROMISE_SYMBOL = zoneSymbol('Promise');
    var ERROR_SYMBOL = zoneSymbol('Error');
    Function.prototype.toString = function () {
        if (typeof this === FUNCTION) {
            var originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
            if (originalDelegate) {
                if (typeof originalDelegate === FUNCTION) {
                    return originalFunctionToString.apply(this[ORIGINAL_DELEGATE_SYMBOL], arguments);
                }
                else {
                    return Object.prototype.toString.call(originalDelegate);
                }
            }
            if (this === Promise) {
                var nativePromise = global[PROMISE_SYMBOL];
                if (nativePromise) {
                    return originalFunctionToString.apply(nativePromise, arguments);
                }
            }
            if (this === Error) {
                var nativeError = global[ERROR_SYMBOL];
                if (nativeError) {
                    return originalFunctionToString.apply(nativeError, arguments);
                }
            }
        }
        return originalFunctionToString.apply(this, arguments);
    };
    // patch Object.prototype.toString to let them look like native
    var originalObjectToString = Object.prototype.toString;
    var PROMISE_OBJECT_TO_STRING = '[object Promise]';
    Object.prototype.toString = function () {
        if (this instanceof Promise) {
            return PROMISE_OBJECT_TO_STRING;
        }
        return originalObjectToString.apply(this, arguments);
    };
});

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview
 * @suppress {missingRequire}
 */
var TRUE_STR = 'true';
var FALSE_STR = 'false';
// an identifier to tell ZoneTask do not create a new invoke closure
var OPTIMIZED_ZONE_EVENT_TASK_DATA = {
    isUsingGlobalCallback: true
};
var zoneSymbolEventNames$1 = {};
var globalSources = {};
var CONSTRUCTOR_NAME = 'name';
var FUNCTION_TYPE = 'function';
var OBJECT_TYPE = 'object';
var ZONE_SYMBOL_PREFIX = '__zone_symbol__';
var EVENT_NAME_SYMBOL_REGX = /^__zone_symbol__(\w+)(true|false)$/;
function patchEventTarget(_global, apis, patchOptions) {
    var ADD_EVENT_LISTENER = (patchOptions && patchOptions.addEventListenerFnName) || 'addEventListener';
    var REMOVE_EVENT_LISTENER = (patchOptions && patchOptions.removeEventListenerFnName) || 'removeEventListener';
    var LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.listenersFnName) || 'eventListeners';
    var REMOVE_ALL_LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.removeAllFnName) || 'removeAllListeners';
    var zoneSymbolAddEventListener = zoneSymbol(ADD_EVENT_LISTENER);
    var ADD_EVENT_LISTENER_SOURCE = '.' + ADD_EVENT_LISTENER + ':';
    var PREPEND_EVENT_LISTENER = 'prependListener';
    var PREPEND_EVENT_LISTENER_SOURCE = '.' + PREPEND_EVENT_LISTENER + ':';
    var invokeTask = function (task, target, event) {
        // for better performance, check isRemoved which is set
        // by removeEventListener
        if (task.isRemoved) {
            return;
        }
        var delegate = task.callback;
        if (typeof delegate === OBJECT_TYPE && delegate.handleEvent) {
            // create the bind version of handleEvent when invoke
            task.callback = function (event) { return delegate.handleEvent(event); };
            task.originalDelegate = delegate;
        }
        // invoke static task.invoke
        task.invoke(task, target, [event]);
        var options = task.options;
        if (options && typeof options === 'object' && options.once) {
            // if options.once is true, after invoke once remove listener here
            // only browser need to do this, nodejs eventEmitter will cal removeListener
            // inside EventEmitter.once
            var delegate_1 = task.originalDelegate ? task.originalDelegate : task.callback;
            target[REMOVE_EVENT_LISTENER].apply(target, [event.type, delegate_1, options]);
        }
    };
    // global shared zoneAwareCallback to handle all event callback with capture = false
    var globalZoneAwareCallback = function (event) {
        var target = this || _global;
        var tasks = target[zoneSymbolEventNames$1[event.type][FALSE_STR]];
        if (tasks) {
            // invoke all tasks which attached to current target with given event.type and capture = false
            // for performance concern, if task.length === 1, just invoke
            if (tasks.length === 1) {
                invokeTask(tasks[0], target, event);
            }
            else {
                // https://github.com/angular/zone.js/issues/836
                // copy the tasks array before invoke, to avoid
                // the callback will remove itself or other listener
                var copyTasks = tasks.slice();
                for (var i = 0; i < copyTasks.length; i++) {
                    invokeTask(copyTasks[i], target, event);
                }
            }
        }
    };
    // global shared zoneAwareCallback to handle all event callback with capture = true
    var globalZoneAwareCaptureCallback = function (event) {
        var target = this || _global;
        var tasks = target[zoneSymbolEventNames$1[event.type][TRUE_STR]];
        if (tasks) {
            // invoke all tasks which attached to current target with given event.type and capture = false
            // for performance concern, if task.length === 1, just invoke
            if (tasks.length === 1) {
                invokeTask(tasks[0], target, event);
            }
            else {
                // https://github.com/angular/zone.js/issues/836
                // copy the tasks array before invoke, to avoid
                // the callback will remove itself or other listener
                var copyTasks = tasks.slice();
                for (var i = 0; i < copyTasks.length; i++) {
                    invokeTask(copyTasks[i], target, event);
                }
            }
        }
    };
    function patchEventTargetMethods(obj, patchOptions) {
        if (!obj) {
            return false;
        }
        var useGlobalCallback = true;
        if (patchOptions && patchOptions.useGlobalCallback !== undefined) {
            useGlobalCallback = patchOptions.useGlobalCallback;
        }
        var validateHandler = patchOptions && patchOptions.validateHandler;
        var checkDuplicate = true;
        if (patchOptions && patchOptions.checkDuplicate !== undefined) {
            checkDuplicate = patchOptions.checkDuplicate;
        }
        var returnTarget = false;
        if (patchOptions && patchOptions.returnTarget !== undefined) {
            returnTarget = patchOptions.returnTarget;
        }
        var proto = obj;
        while (proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER)) {
            proto = Object.getPrototypeOf(proto);
        }
        if (!proto && obj[ADD_EVENT_LISTENER]) {
            // somehow we did not find it, but we can see it. This happens on IE for Window properties.
            proto = obj;
        }
        if (!proto) {
            return false;
        }
        if (proto[zoneSymbolAddEventListener]) {
            return false;
        }
        // a shared global taskData to pass data for scheduleEventTask
        // so we do not need to create a new object just for pass some data
        var taskData = {};
        var nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
        var nativeRemoveEventListener = proto[zoneSymbol(REMOVE_EVENT_LISTENER)] =
            proto[REMOVE_EVENT_LISTENER];
        var nativeListeners = proto[zoneSymbol(LISTENERS_EVENT_LISTENER)] =
            proto[LISTENERS_EVENT_LISTENER];
        var nativeRemoveAllListeners = proto[zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] =
            proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
        var nativePrependEventListener;
        if (patchOptions && patchOptions.prependEventListenerFnName) {
            nativePrependEventListener = proto[zoneSymbol(patchOptions.prependEventListenerFnName)] =
                proto[patchOptions.prependEventListenerFnName];
        }
        var customScheduleGlobal = function (task) {
            // if there is already a task for the eventName + capture,
            // just return, because we use the shared globalZoneAwareCallback here.
            if (taskData.isExisting) {
                return;
            }
            return nativeAddEventListener.apply(taskData.target, [
                taskData.eventName,
                taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback,
                taskData.options
            ]);
        };
        var customCancelGlobal = function (task) {
            // if task is not marked as isRemoved, this call is directly
            // from Zone.prototype.cancelTask, we should remove the task
            // from tasksList of target first
            if (!task.isRemoved) {
                var symbolEventNames = zoneSymbolEventNames$1[task.eventName];
                var symbolEventName = void 0;
                if (symbolEventNames) {
                    symbolEventName = symbolEventNames[task.capture ? TRUE_STR : FALSE_STR];
                }
                var existingTasks = symbolEventName && task.target[symbolEventName];
                if (existingTasks) {
                    for (var i = 0; i < existingTasks.length; i++) {
                        var existingTask = existingTasks[i];
                        if (existingTask === task) {
                            existingTasks.splice(i, 1);
                            // set isRemoved to data for faster invokeTask check
                            task.isRemoved = true;
                            if (existingTasks.length === 0) {
                                // all tasks for the eventName + capture have gone,
                                // remove globalZoneAwareCallback and remove the task cache from target
                                task.allRemoved = true;
                                task.target[symbolEventName] = null;
                            }
                            break;
                        }
                    }
                }
            }
            // if all tasks for the eventName + capture have gone,
            // we will really remove the global event callback,
            // if not, return
            if (!task.allRemoved) {
                return;
            }
            return nativeRemoveEventListener.apply(task.target, [
                task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback,
                task.options
            ]);
        };
        var customScheduleNonGlobal = function (task) {
            return nativeAddEventListener.apply(taskData.target, [taskData.eventName, task.invoke, taskData.options]);
        };
        var customSchedulePrepend = function (task) {
            return nativePrependEventListener.apply(taskData.target, [taskData.eventName, task.invoke, taskData.options]);
        };
        var customCancelNonGlobal = function (task) {
            return nativeRemoveEventListener.apply(task.target, [task.eventName, task.invoke, task.options]);
        };
        var customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
        var customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
        var compareTaskCallbackVsDelegate = function (task, delegate) {
            var typeOfDelegate = typeof delegate;
            if ((typeOfDelegate === FUNCTION_TYPE && task.callback === delegate) ||
                (typeOfDelegate === OBJECT_TYPE && task.originalDelegate === delegate)) {
                // same callback, same capture, same event name, just return
                return true;
            }
            return false;
        };
        var compare = (patchOptions && patchOptions.compareTaskCallbackVsDelegate) ?
            patchOptions.compareTaskCallbackVsDelegate :
            compareTaskCallbackVsDelegate;
        var makeAddListener = function (nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget, prepend) {
            if (returnTarget === void 0) { returnTarget = false; }
            if (prepend === void 0) { prepend = false; }
            return function () {
                var target = this || _global;
                var targetZone = Zone.current;
                var delegate = arguments[1];
                if (!delegate) {
                    return nativeListener.apply(this, arguments);
                }
                // don't create the bind delegate function for handleEvent
                // case here to improve addEventListener performance
                // we will create the bind delegate when invoke
                var isHandleEvent = false;
                if (typeof delegate !== FUNCTION_TYPE) {
                    if (!delegate.handleEvent) {
                        return nativeListener.apply(this, arguments);
                    }
                    isHandleEvent = true;
                }
                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) {
                    return;
                }
                var eventName = arguments[0];
                var options = arguments[2];
                var capture;
                var once = false;
                if (options === undefined) {
                    capture = false;
                }
                else if (options === true) {
                    capture = true;
                }
                else if (options === false) {
                    capture = false;
                }
                else {
                    capture = options ? !!options.capture : false;
                    once = options ? !!options.once : false;
                }
                var zone = Zone.current;
                var symbolEventNames = zoneSymbolEventNames$1[eventName];
                var symbolEventName;
                if (!symbolEventNames) {
                    // the code is duplicate, but I just want to get some better performance
                    var falseEventName = eventName + FALSE_STR;
                    var trueEventName = eventName + TRUE_STR;
                    var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
                    var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
                    zoneSymbolEventNames$1[eventName] = {};
                    zoneSymbolEventNames$1[eventName][FALSE_STR] = symbol;
                    zoneSymbolEventNames$1[eventName][TRUE_STR] = symbolCapture;
                    symbolEventName = capture ? symbolCapture : symbol;
                }
                else {
                    symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
                }
                var existingTasks = target[symbolEventName];
                var isExisting = false;
                if (existingTasks) {
                    // already have task registered
                    isExisting = true;
                    if (checkDuplicate) {
                        for (var i = 0; i < existingTasks.length; i++) {
                            if (compare(existingTasks[i], delegate)) {
                                // same callback, same capture, same event name, just return
                                return;
                            }
                        }
                    }
                }
                else {
                    existingTasks = target[symbolEventName] = [];
                }
                var source;
                var constructorName = target.constructor[CONSTRUCTOR_NAME];
                var targetSource = globalSources[constructorName];
                if (targetSource) {
                    source = targetSource[eventName];
                }
                if (!source) {
                    source = constructorName + addSource + eventName;
                }
                // do not create a new object as task.data to pass those things
                // just use the global shared one
                taskData.options = options;
                if (once) {
                    // if addEventListener with once options, we don't pass it to
                    // native addEventListener, instead we keep the once setting
                    // and handle ourselves.
                    taskData.options.once = false;
                }
                taskData.target = target;
                taskData.capture = capture;
                taskData.eventName = eventName;
                taskData.isExisting = isExisting;
                var data = useGlobalCallback ? OPTIMIZED_ZONE_EVENT_TASK_DATA : null;
                var task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                // have to save those information to task in case
                // application may call task.zone.cancelTask() directly
                if (once) {
                    options.once = true;
                }
                task.options = options;
                task.target = target;
                task.capture = capture;
                task.eventName = eventName;
                if (isHandleEvent) {
                    // save original delegate for compare to check duplicate
                    task.originalDelegate = delegate;
                }
                if (!prepend) {
                    existingTasks.push(task);
                }
                else {
                    existingTasks.unshift(task);
                }
                if (returnTarget) {
                    return target;
                }
            };
        };
        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
        if (nativePrependEventListener) {
            proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
        }
        proto[REMOVE_EVENT_LISTENER] = function () {
            var target = this || _global;
            var eventName = arguments[0];
            var options = arguments[2];
            var capture;
            if (options === undefined) {
                capture = false;
            }
            else if (options === true) {
                capture = true;
            }
            else if (options === false) {
                capture = false;
            }
            else {
                capture = options ? !!options.capture : false;
            }
            var delegate = arguments[1];
            if (!delegate) {
                return nativeRemoveEventListener.apply(this, arguments);
            }
            if (validateHandler &&
                !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) {
                return;
            }
            var symbolEventNames = zoneSymbolEventNames$1[eventName];
            var symbolEventName;
            if (symbolEventNames) {
                symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
            }
            var existingTasks = symbolEventName && target[symbolEventName];
            if (existingTasks) {
                for (var i = 0; i < existingTasks.length; i++) {
                    var existingTask = existingTasks[i];
                    var typeOfDelegate = typeof delegate;
                    if (compare(existingTask, delegate)) {
                        existingTasks.splice(i, 1);
                        // set isRemoved to data for faster invokeTask check
                        existingTask.isRemoved = true;
                        if (existingTasks.length === 0) {
                            // all tasks for the eventName + capture have gone,
                            // remove globalZoneAwareCallback and remove the task cache from target
                            existingTask.allRemoved = true;
                            target[symbolEventName] = null;
                        }
                        existingTask.zone.cancelTask(existingTask);
                        return;
                    }
                }
            }
        };
        proto[LISTENERS_EVENT_LISTENER] = function () {
            var target = this || _global;
            var eventName = arguments[0];
            var listeners = [];
            var tasks = findEventTasks(target, eventName);
            for (var i = 0; i < tasks.length; i++) {
                var task = tasks[i];
                var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                listeners.push(delegate);
            }
            return listeners;
        };
        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function () {
            var target = this || _global;
            var eventName = arguments[0];
            if (!eventName) {
                var keys = Object.keys(target);
                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
                    var evtName = match && match[1];
                    // in nodejs EventEmitter, removeListener event is
                    // used for monitoring the removeListener call,
                    // so just keep removeListener eventListener until
                    // all other eventListeners are removed
                    if (evtName && evtName !== 'removeListener') {
                        this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].apply(this, [evtName]);
                    }
                }
                // remove removeListener listener finally
                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].apply(this, ['removeListener']);
            }
            else {
                var symbolEventNames = zoneSymbolEventNames$1[eventName];
                if (symbolEventNames) {
                    var symbolEventName = symbolEventNames[FALSE_STR];
                    var symbolCaptureEventName = symbolEventNames[TRUE_STR];
                    var tasks = target[symbolEventName];
                    var captureTasks = target[symbolCaptureEventName];
                    if (tasks) {
                        var removeTasks = tasks.slice();
                        for (var i = 0; i < removeTasks.length; i++) {
                            var task = removeTasks[i];
                            var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].apply(this, [eventName, delegate, task.options]);
                        }
                    }
                    if (captureTasks) {
                        var removeTasks = captureTasks.slice();
                        for (var i = 0; i < removeTasks.length; i++) {
                            var task = removeTasks[i];
                            var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].apply(this, [eventName, delegate, task.options]);
                        }
                    }
                }
            }
        };
        // for native toString patch
        attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
        attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
        if (nativeRemoveAllListeners) {
            attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
        }
        if (nativeListeners) {
            attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
        }
        return true;
    }
    var results = [];
    for (var i = 0; i < apis.length; i++) {
        results[i] = patchEventTargetMethods(apis[i], patchOptions);
    }
    return results;
}
function findEventTasks(target, eventName) {
    var foundTasks = [];
    for (var prop in target) {
        var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
        var evtName = match && match[1];
        if (evtName && (!eventName || evtName === eventName)) {
            var tasks = target[prop];
            if (tasks) {
                for (var i = 0; i < tasks.length; i++) {
                    foundTasks.push(tasks[i]);
                }
            }
        }
    }
    return foundTasks;
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview
 * @suppress {missingRequire}
 */
function patchTimer(window, setName, cancelName, nameSuffix) {
    var setNative = null;
    var clearNative = null;
    setName += nameSuffix;
    cancelName += nameSuffix;
    var tasksByHandleId = {};
    var NUMBER = 'number';
    var STRING = 'string';
    var FUNCTION = 'function';
    var INTERVAL = 'Interval';
    var TIMEOUT = 'Timeout';
    var NOT_SCHEDULED = 'notScheduled';
    function scheduleTask(task) {
        var data = task.data;
        function timer() {
            try {
                task.invoke.apply(this, arguments);
            }
            finally {
                if (typeof data.handleId === NUMBER) {
                    // Node returns complex objects as handleIds
                    delete tasksByHandleId[data.handleId];
                }
            }
        }
        data.args[0] = timer;
        data.handleId = setNative.apply(window, data.args);
        if (typeof data.handleId === NUMBER) {
            // Node returns complex objects as handleIds -> no need to keep them around. Additionally,
            // this throws an
            // exception in older node versions and has no effect there, because of the stringified key.
            tasksByHandleId[data.handleId] = task;
        }
        return task;
    }
    function clearTask(task) {
        if (typeof task.data.handleId === NUMBER) {
            // Node returns complex objects as handleIds
            delete tasksByHandleId[task.data.handleId];
        }
        return clearNative(task.data.handleId);
    }
    setNative =
        patchMethod(window, setName, function (delegate) { return function (self, args) {
            if (typeof args[0] === FUNCTION) {
                var zone = Zone.current;
                var options = {
                    handleId: null,
                    isPeriodic: nameSuffix === INTERVAL,
                    delay: (nameSuffix === TIMEOUT || nameSuffix === INTERVAL) ? args[1] || 0 : null,
                    args: args
                };
                var task = zone.scheduleMacroTask(setName, args[0], options, scheduleTask, clearTask);
                if (!task) {
                    return task;
                }
                // Node.js must additionally support the ref and unref functions.
                var handle = task.data.handleId;
                // check whether handle is null, because some polyfill or browser
                // may return undefined from setTimeout/setInterval/setImmediate/requestAnimationFrame
                if (handle && handle.ref && handle.unref && typeof handle.ref === FUNCTION &&
                    typeof handle.unref === FUNCTION) {
                    task.ref = handle.ref.bind(handle);
                    task.unref = handle.unref.bind(handle);
                }
                return task;
            }
            else {
                // cause an error by calling it directly.
                return delegate.apply(window, args);
            }
        }; });
    clearNative =
        patchMethod(window, cancelName, function (delegate) { return function (self, args) {
            var task = typeof args[0] === NUMBER ? tasksByHandleId[args[0]] : args[0];
            if (task && typeof task.type === STRING) {
                if (task.state !== NOT_SCHEDULED &&
                    (task.cancelFn && task.data.isPeriodic || task.runCount === 0)) {
                    // Do not cancel already canceled functions
                    task.zone.cancelTask(task);
                }
            }
            else {
                // cause an error by calling it directly.
                delegate.apply(window, args);
            }
        }; });
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/*
 * This is necessary for Chrome and Chrome mobile, to enable
 * things like redefining `createdCallback` on an element.
 */
var _defineProperty = Object[zoneSymbol('defineProperty')] = Object.defineProperty;
var _getOwnPropertyDescriptor = Object[zoneSymbol('getOwnPropertyDescriptor')] =
    Object.getOwnPropertyDescriptor;
var _create = Object.create;
var unconfigurablesKey = zoneSymbol('unconfigurables');
var PROTOTYPE = 'prototype';
var OBJECT = 'object';
var UNDEFINED$1 = 'undefined';
function propertyPatch() {
    Object.defineProperty = function (obj, prop, desc) {
        if (isUnconfigurable(obj, prop)) {
            throw new TypeError('Cannot assign to read only property \'' + prop + '\' of ' + obj);
        }
        var originalConfigurableFlag = desc.configurable;
        if (prop !== PROTOTYPE) {
            desc = rewriteDescriptor(obj, prop, desc);
        }
        return _tryDefineProperty(obj, prop, desc, originalConfigurableFlag);
    };
    Object.defineProperties = function (obj, props) {
        Object.keys(props).forEach(function (prop) {
            Object.defineProperty(obj, prop, props[prop]);
        });
        return obj;
    };
    Object.create = function (obj, proto) {
        if (typeof proto === OBJECT && !Object.isFrozen(proto)) {
            Object.keys(proto).forEach(function (prop) {
                proto[prop] = rewriteDescriptor(obj, prop, proto[prop]);
            });
        }
        return _create(obj, proto);
    };
    Object.getOwnPropertyDescriptor = function (obj, prop) {
        var desc = _getOwnPropertyDescriptor(obj, prop);
        if (isUnconfigurable(obj, prop)) {
            desc.configurable = false;
        }
        return desc;
    };
}
function _redefineProperty(obj, prop, desc) {
    var originalConfigurableFlag = desc.configurable;
    desc = rewriteDescriptor(obj, prop, desc);
    return _tryDefineProperty(obj, prop, desc, originalConfigurableFlag);
}
function isUnconfigurable(obj, prop) {
    return obj && obj[unconfigurablesKey] && obj[unconfigurablesKey][prop];
}
function rewriteDescriptor(obj, prop, desc) {
    desc.configurable = true;
    if (!desc.configurable) {
        if (!obj[unconfigurablesKey]) {
            _defineProperty(obj, unconfigurablesKey, { writable: true, value: {} });
        }
        obj[unconfigurablesKey][prop] = true;
    }
    return desc;
}
function _tryDefineProperty(obj, prop, desc, originalConfigurableFlag) {
    try {
        return _defineProperty(obj, prop, desc);
    }
    catch (error) {
        if (desc.configurable) {
            // In case of errors, when the configurable flag was likely set by rewriteDescriptor(), let's
            // retry with the original flag value
            if (typeof originalConfigurableFlag == UNDEFINED$1) {
                delete desc.configurable;
            }
            else {
                desc.configurable = originalConfigurableFlag;
            }
            try {
                return _defineProperty(obj, prop, desc);
            }
            catch (error) {
                var descJson = null;
                try {
                    descJson = JSON.stringify(desc);
                }
                catch (error) {
                    descJson = descJson.toString();
                }
                console.log("Attempting to configure '" + prop + "' with descriptor '" + descJson + "' on object '" + obj + "' and got error, giving up: " + error);
            }
        }
        else {
            throw error;
        }
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// we have to patch the instance since the proto is non-configurable
function apply(api, _global) {
    var WS = _global.WebSocket;
    // On Safari window.EventTarget doesn't exist so need to patch WS add/removeEventListener
    // On older Chrome, no need since EventTarget was already patched
    if (!_global.EventTarget) {
        patchEventTarget(_global, [WS.prototype]);
    }
    _global.WebSocket = function (a, b) {
        var socket = arguments.length > 1 ? new WS(a, b) : new WS(a);
        var proxySocket;
        var proxySocketProto;
        // Safari 7.0 has non-configurable own 'onmessage' and friends properties on the socket instance
        var onmessageDesc = Object.getOwnPropertyDescriptor(socket, 'onmessage');
        if (onmessageDesc && onmessageDesc.configurable === false) {
            proxySocket = Object.create(socket);
            // socket have own property descriptor 'onopen', 'onmessage', 'onclose', 'onerror'
            // but proxySocket not, so we will keep socket as prototype and pass it to
            // patchOnProperties method
            proxySocketProto = socket;
            ['addEventListener', 'removeEventListener', 'send', 'close'].forEach(function (propName) {
                proxySocket[propName] = function () {
                    var args = Array.prototype.slice.call(arguments);
                    if (propName === 'addEventListener' || propName === 'removeEventListener') {
                        var eventName = args.length > 0 ? args[0] : undefined;
                        if (eventName) {
                            var propertySymbol = Zone.__symbol__('ON_PROPERTY' + eventName);
                            socket[propertySymbol] = proxySocket[propertySymbol];
                        }
                    }
                    return socket[propName].apply(socket, args);
                };
            });
        }
        else {
            // we can patch the real socket
            proxySocket = socket;
        }
        patchOnProperties(proxySocket, ['close', 'error', 'message', 'open'], proxySocketProto);
        return proxySocket;
    };
    var globalWebSocket = _global['WebSocket'];
    for (var prop in WS) {
        globalWebSocket[prop] = WS[prop];
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview
 * @suppress {globalThis}
 */
var globalEventHandlersEventNames = [
    'abort',
    'animationcancel',
    'animationend',
    'animationiteration',
    'auxclick',
    'beforeinput',
    'blur',
    'cancel',
    'canplay',
    'canplaythrough',
    'change',
    'compositionstart',
    'compositionupdate',
    'compositionend',
    'cuechange',
    'click',
    'close',
    'contextmenu',
    'curechange',
    'dblclick',
    'drag',
    'dragend',
    'dragenter',
    'dragexit',
    'dragleave',
    'dragover',
    'drop',
    'durationchange',
    'emptied',
    'ended',
    'error',
    'focus',
    'focusin',
    'focusout',
    'gotpointercapture',
    'input',
    'invalid',
    'keydown',
    'keypress',
    'keyup',
    'load',
    'loadstart',
    'loadeddata',
    'loadedmetadata',
    'lostpointercapture',
    'mousedown',
    'mouseenter',
    'mouseleave',
    'mousemove',
    'mouseout',
    'mouseover',
    'mouseup',
    'mousewheel',
    'pause',
    'play',
    'playing',
    'pointercancel',
    'pointerdown',
    'pointerenter',
    'pointerleave',
    'pointerlockchange',
    'mozpointerlockchange',
    'webkitpointerlockerchange',
    'pointerlockerror',
    'mozpointerlockerror',
    'webkitpointerlockerror',
    'pointermove',
    'pointout',
    'pointerover',
    'pointerup',
    'progress',
    'ratechange',
    'reset',
    'resize',
    'scroll',
    'seeked',
    'seeking',
    'select',
    'selectionchange',
    'selectstart',
    'show',
    'sort',
    'stalled',
    'submit',
    'suspend',
    'timeupdate',
    'volumechange',
    'touchcancel',
    'touchmove',
    'touchstart',
    'transitioncancel',
    'transitionend',
    'waiting',
    'wheel'
];
var documentEventNames = [
    'afterscriptexecute', 'beforescriptexecute', 'DOMContentLoaded', 'fullscreenchange',
    'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange', 'fullscreenerror',
    'mozfullscreenerror', 'webkitfullscreenerror', 'msfullscreenerror', 'readystatechange'
];
var windowEventNames = [
    'absolutedeviceorientation',
    'afterinput',
    'afterprint',
    'appinstalled',
    'beforeinstallprompt',
    'beforeprint',
    'beforeunload',
    'devicelight',
    'devicemotion',
    'deviceorientation',
    'deviceorientationabsolute',
    'deviceproximity',
    'hashchange',
    'languagechange',
    'message',
    'mozbeforepaint',
    'offline',
    'online',
    'paint',
    'pageshow',
    'pagehide',
    'popstate',
    'rejectionhandled',
    'storage',
    'unhandledrejection',
    'unload',
    'userproximity',
    'vrdisplyconnected',
    'vrdisplaydisconnected',
    'vrdisplaypresentchange'
];
var htmlElementEventNames = [
    'beforecopy', 'beforecut', 'beforepaste', 'copy', 'cut', 'paste', 'dragstart', 'loadend',
    'animationstart', 'search', 'transitionrun', 'transitionstart', 'webkitanimationend',
    'webkitanimationiteration', 'webkitanimationstart', 'webkittransitionend'
];
var mediaElementEventNames = ['encrypted', 'waitingforkey', 'msneedkey', 'mozinterruptbegin', 'mozinterruptend'];
var ieElementEventNames = [
    'activate',
    'afterupdate',
    'ariarequest',
    'beforeactivate',
    'beforedeactivate',
    'beforeeditfocus',
    'beforeupdate',
    'cellchange',
    'controlselect',
    'dataavailable',
    'datasetchanged',
    'datasetcomplete',
    'errorupdate',
    'filterchange',
    'layoutcomplete',
    'losecapture',
    'move',
    'moveend',
    'movestart',
    'propertychange',
    'resizeend',
    'resizestart',
    'rowenter',
    'rowexit',
    'rowsdelete',
    'rowsinserted',
    'command',
    'compassneedscalibration',
    'deactivate',
    'help',
    'mscontentzoom',
    'msmanipulationstatechanged',
    'msgesturechange',
    'msgesturedoubletap',
    'msgestureend',
    'msgesturehold',
    'msgesturestart',
    'msgesturetap',
    'msgotpointercapture',
    'msinertiastart',
    'mslostpointercapture',
    'mspointercancel',
    'mspointerdown',
    'mspointerenter',
    'mspointerhover',
    'mspointerleave',
    'mspointermove',
    'mspointerout',
    'mspointerover',
    'mspointerup',
    'pointerout',
    'mssitemodejumplistitemremoved',
    'msthumbnailclick',
    'stop',
    'storagecommit'
];
var webglEventNames = ['webglcontextrestored', 'webglcontextlost', 'webglcontextcreationerror'];
var formEventNames = ['autocomplete', 'autocompleteerror'];
var detailEventNames = ['toggle'];
var frameEventNames = ['load'];
var frameSetEventNames = ['blur', 'error', 'focus', 'load', 'resize', 'scroll', 'messageerror'];
var marqueeEventNames = ['bounce', 'finish', 'start'];
var XMLHttpRequestEventNames = [
    'loadstart', 'progress', 'abort', 'error', 'load', 'progress', 'timeout', 'loadend',
    'readystatechange'
];
var IDBIndexEventNames = ['upgradeneeded', 'complete', 'abort', 'success', 'error', 'blocked', 'versionchange', 'close'];
var websocketEventNames = ['close', 'error', 'open', 'message'];
var eventNames = globalEventHandlersEventNames.concat(webglEventNames, formEventNames, detailEventNames, documentEventNames, windowEventNames, htmlElementEventNames, ieElementEventNames);
function filterProperties(target, onProperties, ignoreProperties) {
    if (!ignoreProperties) {
        return onProperties;
    }
    var tip = ignoreProperties.filter(function (ip) { return ip.target === target; });
    if (!tip || tip.length === 0) {
        return onProperties;
    }
    var targetIgnoreProperties = tip[0].ignoreProperties;
    return onProperties.filter(function (op) { return targetIgnoreProperties.indexOf(op) === -1; });
}
function patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
    var filteredProperties = filterProperties(target, onProperties, ignoreProperties);
    patchOnProperties(target, filteredProperties, prototype);
}
function propertyDescriptorPatch(api, _global) {
    if (isNode && !isMix) {
        return;
    }
    var supportsWebSocket = typeof WebSocket !== 'undefined';
    if (canPatchViaPropertyDescriptor()) {
        var ignoreProperties = _global.__Zone_ignore_on_properties;
        // for browsers that we can patch the descriptor:  Chrome & Firefox
        if (isBrowser) {
            // in IE/Edge, onProp not exist in window object, but in WindowPrototype
            // so we need to pass WindowPrototype to check onProp exist or not
            patchFilteredProperties(window, eventNames.concat(['messageerror']), ignoreProperties, Object.getPrototypeOf(window));
            patchFilteredProperties(Document.prototype, eventNames, ignoreProperties);
            if (typeof window['SVGElement'] !== 'undefined') {
                patchFilteredProperties(window['SVGElement'].prototype, eventNames, ignoreProperties);
            }
            patchFilteredProperties(Element.prototype, eventNames, ignoreProperties);
            patchFilteredProperties(HTMLElement.prototype, eventNames, ignoreProperties);
            patchFilteredProperties(HTMLMediaElement.prototype, mediaElementEventNames, ignoreProperties);
            patchFilteredProperties(HTMLFrameSetElement.prototype, windowEventNames.concat(frameSetEventNames), ignoreProperties);
            patchFilteredProperties(HTMLBodyElement.prototype, windowEventNames.concat(frameSetEventNames), ignoreProperties);
            patchFilteredProperties(HTMLFrameElement.prototype, frameEventNames, ignoreProperties);
            patchFilteredProperties(HTMLIFrameElement.prototype, frameEventNames, ignoreProperties);
            var HTMLMarqueeElement_1 = window['HTMLMarqueeElement'];
            if (HTMLMarqueeElement_1) {
                patchFilteredProperties(HTMLMarqueeElement_1.prototype, marqueeEventNames, ignoreProperties);
            }
        }
        patchFilteredProperties(XMLHttpRequest.prototype, XMLHttpRequestEventNames, ignoreProperties);
        var XMLHttpRequestEventTarget = _global['XMLHttpRequestEventTarget'];
        if (XMLHttpRequestEventTarget) {
            patchFilteredProperties(XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype, XMLHttpRequestEventNames, ignoreProperties);
        }
        if (typeof IDBIndex !== 'undefined') {
            patchFilteredProperties(IDBIndex.prototype, IDBIndexEventNames, ignoreProperties);
            patchFilteredProperties(IDBRequest.prototype, IDBIndexEventNames, ignoreProperties);
            patchFilteredProperties(IDBOpenDBRequest.prototype, IDBIndexEventNames, ignoreProperties);
            patchFilteredProperties(IDBDatabase.prototype, IDBIndexEventNames, ignoreProperties);
            patchFilteredProperties(IDBTransaction.prototype, IDBIndexEventNames, ignoreProperties);
            patchFilteredProperties(IDBCursor.prototype, IDBIndexEventNames, ignoreProperties);
        }
        if (supportsWebSocket) {
            patchFilteredProperties(WebSocket.prototype, websocketEventNames, ignoreProperties);
        }
    }
    else {
        // Safari, Android browsers (Jelly Bean)
        patchViaCapturingAllTheEvents();
        patchClass('XMLHttpRequest');
        if (supportsWebSocket) {
            apply(api, _global);
        }
    }
}
function canPatchViaPropertyDescriptor() {
    if ((isBrowser || isMix) && !Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'onclick') &&
        typeof Element !== 'undefined') {
        // WebKit https://bugs.webkit.org/show_bug.cgi?id=134364
        // IDL interface attributes are not configurable
        var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'onclick');
        if (desc && !desc.configurable)
            return false;
    }
    var xhrDesc = Object.getOwnPropertyDescriptor(XMLHttpRequest.prototype, 'onreadystatechange');
    // add enumerable and configurable here because in opera
    // by default XMLHttpRequest.prototype.onreadystatechange is undefined
    // without adding enumerable and configurable will cause onreadystatechange
    // non-configurable
    // and if XMLHttpRequest.prototype.onreadystatechange is undefined,
    // we should set a real desc instead a fake one
    if (xhrDesc) {
        Object.defineProperty(XMLHttpRequest.prototype, 'onreadystatechange', {
            enumerable: true,
            configurable: true,
            get: function () {
                return true;
            }
        });
        var req = new XMLHttpRequest();
        var result = !!req.onreadystatechange;
        // restore original desc
        Object.defineProperty(XMLHttpRequest.prototype, 'onreadystatechange', xhrDesc || {});
        return result;
    }
    else {
        var SYMBOL_FAKE_ONREADYSTATECHANGE_1 = zoneSymbol('fakeonreadystatechange');
        Object.defineProperty(XMLHttpRequest.prototype, 'onreadystatechange', {
            enumerable: true,
            configurable: true,
            get: function () {
                return this[SYMBOL_FAKE_ONREADYSTATECHANGE_1];
            },
            set: function (value) {
                this[SYMBOL_FAKE_ONREADYSTATECHANGE_1] = value;
            }
        });
        var req = new XMLHttpRequest();
        var detectFunc = function () { };
        req.onreadystatechange = detectFunc;
        var result = req[SYMBOL_FAKE_ONREADYSTATECHANGE_1] === detectFunc;
        req.onreadystatechange = null;
        return result;
    }
}

var unboundKey = zoneSymbol('unbound');
// Whenever any eventListener fires, we check the eventListener target and all parents
// for `onwhatever` properties and replace them with zone-bound functions
// - Chrome (for now)
function patchViaCapturingAllTheEvents() {
    var _loop_1 = function (i) {
        var property = eventNames[i];
        var onproperty = 'on' + property;
        self.addEventListener(property, function (event) {
            var elt = event.target, bound, source;
            if (elt) {
                source = elt.constructor['name'] + '.' + onproperty;
            }
            else {
                source = 'unknown.' + onproperty;
            }
            while (elt) {
                if (elt[onproperty] && !elt[onproperty][unboundKey]) {
                    bound = Zone.current.wrap(elt[onproperty], source);
                    bound[unboundKey] = elt[onproperty];
                    elt[onproperty] = bound;
                }
                elt = elt.parentElement;
            }
        }, true);
    };
    for (var i = 0; i < eventNames.length; i++) {
        _loop_1(i);
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function eventTargetPatch(_global, api) {
    var WTF_ISSUE_555 = 'Anchor,Area,Audio,BR,Base,BaseFont,Body,Button,Canvas,Content,DList,Directory,Div,Embed,FieldSet,Font,Form,Frame,FrameSet,HR,Head,Heading,Html,IFrame,Image,Input,Keygen,LI,Label,Legend,Link,Map,Marquee,Media,Menu,Meta,Meter,Mod,OList,Object,OptGroup,Option,Output,Paragraph,Pre,Progress,Quote,Script,Select,Source,Span,Style,TableCaption,TableCell,TableCol,Table,TableRow,TableSection,TextArea,Title,Track,UList,Unknown,Video';
    var NO_EVENT_TARGET = 'ApplicationCache,EventSource,FileReader,InputMethodContext,MediaController,MessagePort,Node,Performance,SVGElementInstance,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebKitNamedFlow,Window,Worker,WorkerGlobalScope,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload,IDBRequest,IDBOpenDBRequest,IDBDatabase,IDBTransaction,IDBCursor,DBIndex,WebSocket'
        .split(',');
    var EVENT_TARGET = 'EventTarget';
    var apis = [];
    var isWtf = _global['wtf'];
    var WTF_ISSUE_555_ARRAY = WTF_ISSUE_555.split(',');
    if (isWtf) {
        // Workaround for: https://github.com/google/tracing-framework/issues/555
        apis = WTF_ISSUE_555_ARRAY.map(function (v) { return 'HTML' + v + 'Element'; }).concat(NO_EVENT_TARGET);
    }
    else if (_global[EVENT_TARGET]) {
        apis.push(EVENT_TARGET);
    }
    else {
        // Note: EventTarget is not available in all browsers,
        // if it's not available, we instead patch the APIs in the IDL that inherit from EventTarget
        apis = NO_EVENT_TARGET;
    }
    var isDisableIECheck = _global['__Zone_disable_IE_check'] || false;
    var isEnableCrossContextCheck = _global['__Zone_enable_cross_context_check'] || false;
    var ieOrEdge = isIEOrEdge();
    var ADD_EVENT_LISTENER_SOURCE = '.addEventListener:';
    var FUNCTION_WRAPPER = '[object FunctionWrapper]';
    var BROWSER_TOOLS = 'function __BROWSERTOOLS_CONSOLE_SAFEFUNC() { [native code] }';
    //  predefine all __zone_symbol__ + eventName + true/false string
    for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        var falseEventName = eventName + FALSE_STR;
        var trueEventName = eventName + TRUE_STR;
        var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
        var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
        zoneSymbolEventNames$1[eventName] = {};
        zoneSymbolEventNames$1[eventName][FALSE_STR] = symbol;
        zoneSymbolEventNames$1[eventName][TRUE_STR] = symbolCapture;
    }
    //  predefine all task.source string
    for (var i = 0; i < WTF_ISSUE_555.length; i++) {
        var target = WTF_ISSUE_555_ARRAY[i];
        var targets = globalSources[target] = {};
        for (var j = 0; j < eventNames.length; j++) {
            var eventName = eventNames[j];
            targets[eventName] = target + ADD_EVENT_LISTENER_SOURCE + eventName;
        }
    }
    var checkIEAndCrossContext = function (nativeDelegate, delegate, target, args) {
        if (!isDisableIECheck && ieOrEdge) {
            if (isEnableCrossContextCheck) {
                try {
                    var testString = delegate.toString();
                    if ((testString === FUNCTION_WRAPPER || testString == BROWSER_TOOLS)) {
                        nativeDelegate.apply(target, args);
                        return false;
                    }
                }
                catch (error) {
                    nativeDelegate.apply(target, args);
                    return false;
                }
            }
            else {
                var testString = delegate.toString();
                if ((testString === FUNCTION_WRAPPER || testString == BROWSER_TOOLS)) {
                    nativeDelegate.apply(target, args);
                    return false;
                }
            }
        }
        else if (isEnableCrossContextCheck) {
            try {
                delegate.toString();
            }
            catch (error) {
                nativeDelegate.apply(target, args);
                return false;
            }
        }
        return true;
    };
    var apiTypes = [];
    for (var i = 0; i < apis.length; i++) {
        var type = _global[apis[i]];
        apiTypes.push(type && type.prototype);
    }
    patchEventTarget(_global, apiTypes, { validateHandler: checkIEAndCrossContext });
    api.patchEventTarget = patchEventTarget;
    return true;
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function registerElementPatch(_global) {
    if ((!isBrowser && !isMix) || !('registerElement' in _global.document)) {
        return;
    }
    var _registerElement = document.registerElement;
    var callbacks = ['createdCallback', 'attachedCallback', 'detachedCallback', 'attributeChangedCallback'];
    document.registerElement = function (name, opts) {
        if (opts && opts.prototype) {
            callbacks.forEach(function (callback) {
                var source = 'Document.registerElement::' + callback;
                if (opts.prototype.hasOwnProperty(callback)) {
                    var descriptor = Object.getOwnPropertyDescriptor(opts.prototype, callback);
                    if (descriptor && descriptor.value) {
                        descriptor.value = Zone.current.wrap(descriptor.value, source);
                        _redefineProperty(opts.prototype, callback, descriptor);
                    }
                    else {
                        opts.prototype[callback] = Zone.current.wrap(opts.prototype[callback], source);
                    }
                }
                else if (opts.prototype[callback]) {
                    opts.prototype[callback] = Zone.current.wrap(opts.prototype[callback], source);
                }
            });
        }
        return _registerElement.apply(document, [name, opts]);
    };
    attachOriginToPatched(document.registerElement, _registerElement);
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview
 * @suppress {missingRequire}
 */
Zone.__load_patch('timers', function (global, Zone, api) {
    var set = 'set';
    var clear = 'clear';
    patchTimer(global, set, clear, 'Timeout');
    patchTimer(global, set, clear, 'Interval');
    patchTimer(global, set, clear, 'Immediate');
});
Zone.__load_patch('requestAnimationFrame', function (global, Zone, api) {
    patchTimer(global, 'request', 'cancel', 'AnimationFrame');
    patchTimer(global, 'mozRequest', 'mozCancel', 'AnimationFrame');
    patchTimer(global, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
});
Zone.__load_patch('blocking', function (global, Zone, api) {
    var blockingMethods = ['alert', 'prompt', 'confirm'];
    for (var i = 0; i < blockingMethods.length; i++) {
        var name_1 = blockingMethods[i];
        patchMethod(global, name_1, function (delegate, symbol, name) {
            return function (s, args) {
                return Zone.current.run(delegate, global, args, name);
            };
        });
    }
});
Zone.__load_patch('EventTarget', function (global, Zone, api) {
    eventTargetPatch(global, api);
    // patch XMLHttpRequestEventTarget's addEventListener/removeEventListener
    var XMLHttpRequestEventTarget = global['XMLHttpRequestEventTarget'];
    if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) {
        api.patchEventTarget(global, [XMLHttpRequestEventTarget.prototype]);
    }
    patchClass('MutationObserver');
    patchClass('WebKitMutationObserver');
    patchClass('IntersectionObserver');
    patchClass('FileReader');
});
Zone.__load_patch('on_property', function (global, Zone, api) {
    propertyDescriptorPatch(api, global);
    propertyPatch();
    registerElementPatch(global);
});
Zone.__load_patch('canvas', function (global, Zone, api) {
    var HTMLCanvasElement = global['HTMLCanvasElement'];
    if (typeof HTMLCanvasElement !== 'undefined' && HTMLCanvasElement.prototype &&
        HTMLCanvasElement.prototype.toBlob) {
        patchMacroTask(HTMLCanvasElement.prototype, 'toBlob', function (self, args) {
            return { name: 'HTMLCanvasElement.toBlob', target: self, callbackIndex: 0, args: args };
        });
    }
});
Zone.__load_patch('XHR', function (global, Zone, api) {
    // Treat XMLHTTPRequest as a macrotask.
    patchXHR(global);
    var XHR_TASK = zoneSymbol('xhrTask');
    var XHR_SYNC = zoneSymbol('xhrSync');
    var XHR_LISTENER = zoneSymbol('xhrListener');
    var XHR_SCHEDULED = zoneSymbol('xhrScheduled');
    function patchXHR(window) {
        function findPendingTask(target) {
            var pendingTask = target[XHR_TASK];
            return pendingTask;
        }
        var SYMBOL_ADDEVENTLISTENER = zoneSymbol('addEventListener');
        var SYMBOL_REMOVEEVENTLISTENER = zoneSymbol('removeEventListener');
        var oriAddListener = XMLHttpRequest.prototype[SYMBOL_ADDEVENTLISTENER];
        var oriRemoveListener = XMLHttpRequest.prototype[SYMBOL_REMOVEEVENTLISTENER];
        if (!oriAddListener) {
            var XMLHttpRequestEventTarget = window['XMLHttpRequestEventTarget'];
            if (XMLHttpRequestEventTarget) {
                oriAddListener = XMLHttpRequestEventTarget.prototype[SYMBOL_ADDEVENTLISTENER];
                oriRemoveListener = XMLHttpRequestEventTarget.prototype[SYMBOL_REMOVEEVENTLISTENER];
            }
        }
        var READY_STATE_CHANGE = 'readystatechange';
        var SCHEDULED = 'scheduled';
        function scheduleTask(task) {
            XMLHttpRequest[XHR_SCHEDULED] = false;
            var data = task.data;
            var target = data.target;
            // remove existing event listener
            var listener = target[XHR_LISTENER];
            if (!oriAddListener) {
                oriAddListener = target[SYMBOL_ADDEVENTLISTENER];
                oriRemoveListener = target[SYMBOL_REMOVEEVENTLISTENER];
            }
            if (listener) {
                oriRemoveListener.apply(target, [READY_STATE_CHANGE, listener]);
            }
            var newListener = target[XHR_LISTENER] = function () {
                if (target.readyState === target.DONE) {
                    // sometimes on some browsers XMLHttpRequest will fire onreadystatechange with
                    // readyState=4 multiple times, so we need to check task state here
                    if (!data.aborted && XMLHttpRequest[XHR_SCHEDULED] && task.state === SCHEDULED) {
                        task.invoke();
                    }
                }
            };
            oriAddListener.apply(target, [READY_STATE_CHANGE, newListener]);
            var storedTask = target[XHR_TASK];
            if (!storedTask) {
                target[XHR_TASK] = task;
            }
            sendNative.apply(target, data.args);
            XMLHttpRequest[XHR_SCHEDULED] = true;
            return task;
        }
        function placeholderCallback() { }
        function clearTask(task) {
            var data = task.data;
            // Note - ideally, we would call data.target.removeEventListener here, but it's too late
            // to prevent it from firing. So instead, we store info for the event listener.
            data.aborted = true;
            return abortNative.apply(data.target, data.args);
        }
        var openNative = patchMethod(window.XMLHttpRequest.prototype, 'open', function () { return function (self, args) {
            self[XHR_SYNC] = args[2] == false;
            return openNative.apply(self, args);
        }; });
        var XMLHTTPREQUEST_SOURCE = 'XMLHttpRequest.send';
        var sendNative = patchMethod(window.XMLHttpRequest.prototype, 'send', function () { return function (self, args) {
            var zone = Zone.current;
            if (self[XHR_SYNC]) {
                // if the XHR is sync there is no task to schedule, just execute the code.
                return sendNative.apply(self, args);
            }
            else {
                var options = { target: self, isPeriodic: false, delay: null, args: args, aborted: false };
                return zone.scheduleMacroTask(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
            }
        }; });
        var STRING_TYPE = 'string';
        var abortNative = patchMethod(window.XMLHttpRequest.prototype, 'abort', function (delegate) { return function (self, args) {
            var task = findPendingTask(self);
            if (task && typeof task.type == STRING_TYPE) {
                // If the XHR has already completed, do nothing.
                // If the XHR has already been aborted, do nothing.
                // Fix #569, call abort multiple times before done will cause
                // macroTask task count be negative number
                if (task.cancelFn == null || (task.data && task.data.aborted)) {
                    return;
                }
                task.zone.cancelTask(task);
            }
            // Otherwise, we are trying to abort an XHR which has not yet been sent, so there is no
            // task
            // to cancel. Do nothing.
        }; });
    }
});
Zone.__load_patch('geolocation', function (global, Zone, api) {
    /// GEO_LOCATION
    if (global['navigator'] && global['navigator'].geolocation) {
        patchPrototype(global['navigator'].geolocation, ['getCurrentPosition', 'watchPosition']);
    }
});
Zone.__load_patch('PromiseRejectionEvent', function (global, Zone, api) {
    // handle unhandled promise rejection
    function findPromiseRejectionHandler(evtName) {
        return function (e) {
            var eventTasks = findEventTasks(global, evtName);
            eventTasks.forEach(function (eventTask) {
                // windows has added unhandledrejection event listener
                // trigger the event listener
                var PromiseRejectionEvent = global['PromiseRejectionEvent'];
                if (PromiseRejectionEvent) {
                    var evt = new PromiseRejectionEvent(evtName, { promise: e.promise, reason: e.rejection });
                    eventTask.invoke(evt);
                }
            });
        };
    }
    if (global['PromiseRejectionEvent']) {
        Zone[zoneSymbol('unhandledPromiseRejectionHandler')] =
            findPromiseRejectionHandler('unhandledrejection');
        Zone[zoneSymbol('rejectionHandledHandler')] =
            findPromiseRejectionHandler('rejectionhandled');
    }
});
Zone.__load_patch('util', function (global, Zone, api) {
    api.patchOnProperties = patchOnProperties;
    api.patchMethod = patchMethod;
});

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 549 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 550 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";
// the polyfills must be the first thing imported
__webpack_require__(342);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(343); // temporary until 2.1.1 things are patched in Core
// Angular 2
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(126);
var bootloader_1 = __webpack_require__(341);
// for AoT use platformBrowser
// import { platformUniversalDynamic } from 'angular2-universal/browser';
var webfontloader_1 = __webpack_require__(348);
// enable prod for faster renders
core_1.enableProdMode();
var browser_module_ngfactory_1 = __webpack_require__(344); // Generated at compilation
exports.platformRef = platform_browser_1.platformBrowser();
// on document ready bootstrap Angular 2
function main() {
    // Load fonts async
    // https://github.com/typekit/webfontloader#configuration
    webfontloader_1.load({
        google: {
            families: ['Droid Sans']
        }
    });
    return exports.platformRef.bootstrapModuleFactory(browser_module_ngfactory_1.MainModuleNgFactory); // Generated at compilation
}
exports.main = main;
// support async tag or hmr
bootloader_1.bootloader(main);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.js